import DOMPurify from 'isomorphic-dompurify';
import debounce from 'lodash.debounce';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React, { forwardRef, createContext, createElement, Component, Fragment, useState, useRef, useContext, useEffect, useCallback, Children, useReducer } from 'react';
import set from 'lodash.set';
import unset from 'lodash.unset';
import merge$1 from 'lodash.merge';
import createContainer from 'constate';
import isEmpty$1 from 'lodash.isempty';
import { CSSTransition } from 'react-transition-group';
import ReactDom, { createPortal } from 'react-dom';
import { CmrPuntosMenuMobile, CmrPuntosCategoryItem, useCmrPoints } from '@digital-retail/falabella-cmr-components';
import { logout, agentLogout } from '@digital-retail/fa-auth-sdk';
import { LoginWizard } from '@digital-retail/falabella-unified-login';
import Quagga from 'quagga';
import { useLoadScript, Marker, GoogleMap } from '@react-google-maps/api';
import { stringify } from 'query-string';
import LazyLoad from 'react-lazyload';

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var styles = {"rebranding":"FooterList-module_rebranding__27dmv","titleContainer":"FooterList-module_titleContainer__2HaWT","titleButtonContainer":"FooterList-module_titleButtonContainer__3Kxsb","titleLine":"FooterList-module_titleLine__JXxV-","footerList":"FooterList-module_footerList__3Xg9W","minimizeUl":"FooterList-module_minimizeUl__3cTBU","expandUl":"FooterList-module_expandUl__3N9TI","minimizeUlRebranded":"FooterList-module_minimizeUlRebranded__3UjOr","expandUlRebranded":"FooterList-module_expandUlRebranded__31Ezo"};

var countriesCode = {
  FACL: 'cl',
  FAAR: 'ar',
  FACO: 'co',
  FAPE: 'pe',
  CORP: 'corp'
};
var bottomNavLinksByCountries = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, countriesCode.FACL, [{
  title: 'HORARIO DE TIENDAS',
  url: 'https://www.falabella.com/falabella-cl/page/Horarios-especiales?sid=HO_HH_APE_27&amp;staticPageId=38100001&amp;uxref=horarios'
}, {
  title: 'MARKETPLACE',
  url: 'https://www.falabella.com/falabella-cl/page/Market-Place?staticPageId=42100009&amp;uxref=marketplace'
}, {
  title: 'FALABELLA SOSTENIBLE',
  url: 'https://www.falabella.com/falabella-cl/page/Falabella-Sostenible?staticPageId=22500003&amp;uxref=sostenible'
}, {
  title: 'CLUB BEBÉ',
  url: 'https://www.celebracionesfalabella.com/bebe/?uxref=bebe'
}, {
  title: 'NOVIOS',
  url: 'https://www.noviosfalabella.com/noviosclpr/public/inicio.do?uxref=novios'
}, {
  title: 'CMR PUNTOS',
  url: 'https://www.falabella.com/falabella-cl/page/Puntos-CMR?staticPageId=40200001&amp;uxref=cmrpuntos'
}]), countriesCode.FAAR, [{
  title: 'NUESTRAS TIENDAS',
  url: 'https://www.falabella.com.ar/falabella-ar/page/Nuestras-tiendas?staticPageId=10200005&amp;uxref=tiendas'
}, {
  title: 'EVENTOS ONLINE',
  url: 'https://falabellabeautyweeks.com.ar/?uxref=eventos'
}, {
  title: 'SERVICIO AL CLIENTE',
  url: 'https://www.falabella.com.ar/falabella-ar/page/Servicio-al-cliente?staticPageId=10200044&amp;uxref=sac'
}, {
  title: 'MARKETPLACE',
  url: 'https://www.falabella.com.ar/falabella-ar/page/Market-Place?staticPageId=11900001&amp;uxref=marketplace'
}, {
  title: 'NOVIOS',
  url: 'https://www.falabellanovios.com.ar/novios-ar/public/inicio.do?uxref=novios'
}, {
  title: 'CMR',
  url: 'https://www.cmrfalabella.com.ar/home?uxref=cmr'
}]), countriesCode.FAPE, [{
  title: 'NUESTRAS TIENDAS',
  url: 'https://www.falabella.com.pe/falabella-pe/category/cat50668/Hoy-en-tiendas'
}, {
  title: 'NOVIOS',
  url: 'https://www.noviosfalabella.com.pe/novios-pe/public/inicio.do'
}, {
  title: 'CMR PUNTOS',
  url: 'https://cmr-points-pe.azurewebsites.net/'
}, {
  title: 'PAGA TU CMR',
  url: 'https://pagorapido.bancofalabella.pe/?utm_source=falabella&amp;utm_medium=web&amp;utm_campaign=001cmr_pagorapidocmr_falabella_conversiones&amp;utm_term=pagorapidocmr_audienciaabierta&amp;utm_content=web_bannerpagorapidocmr'
}]), countriesCode.FACO, []);
var footerData = {
  linkStyles: {
    backgroundColor: '#1a1a1a',
    fontSize: 12,
    fontColor: '#bbb',
    textAlign: 'left'
  },
  countryStyles: {
    enabled: true,
    textAlign: 'center',
    fontSize: 13,
    fontColor: '#888'
  }
};
var analyticsInfo = {
  tagManager: {
    CL: {
      dev: 'https://assets.adobedtm.com/68ade2efaac6/05d444b949be/launch-1bb58d6e7e5d-staging.min.js',
      staging: 'https://assets.adobedtm.com/68ade2efaac6/05d444b949be/launch-1bb58d6e7e5d-staging.min.js',
      beta: 'https://assets.adobedtm.com/68ade2efaac6/05d444b949be/launch-e4e4d4b7b172.min.js',
      production: 'https://assets.adobedtm.com/68ade2efaac6/05d444b949be/launch-e4e4d4b7b172.min.js',
      sodimac: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/50ed25745533/launch-8ae7b195ca2b-development.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/50ed25745533/launch-19f3e45a2aa6-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/50ed25745533/launch-e75c8f9f59e6.min.js',
        production: 'https://assets.adobedtm.com/68ade2efaac6/50ed25745533/launch-e75c8f9f59e6.min.js'
      },
      tottus: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/04ae81e3c783/launch-b0e6a4c8ed33-staging.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/04ae81e3c783/launch-b0e6a4c8ed33-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/04ae81e3c783/launch-5782fcdb04f2-development.min.js',
        production: 'https://assets.adobedtm.com/68ade2efaac6/04ae81e3c783/launch-e9900040a231.min.js'
      }
    },
    CO: {
      dev: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-2d8fb54d95f7-staging.min.js',
      staging: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-2d8fb54d95f7-staging.min.js',
      beta: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-329acd7108ae.min.js',
      production: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-329acd7108ae.min.js',
      sodimac: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-2d8fb54d95f7-staging.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-2d8fb54d95f7-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-329acd7108ae.min.js',
        production: 'https://assets.adobedtm.com/68ade2efaac6/ec474569dc48/launch-329acd7108ae.min.js'
      }
    },
    PE: {
      dev: 'https://assets.adobedtm.com/68ade2efaac6/5617a0aafdc7/launch-029a964ec6d1-staging.min.js',
      staging: 'https://assets.adobedtm.com/68ade2efaac6/5617a0aafdc7/launch-029a964ec6d1-staging.min.js',
      beta: 'https://assets.adobedtm.com/68ade2efaac6/5617a0aafdc7/launch-d384ece6950a.min.js',
      production: 'https://assets.adobedtm.com/68ade2efaac6/5617a0aafdc7/launch-d384ece6950a.min.js',
      sodimac: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/9c1be53b5ebb/launch-7673274bc3ed-development.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/9c1be53b5ebb/launch-7c1626f7c981-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/9c1be53b5ebb/launch-495f63f5a78b.min.js',
        production: 'https://assets.adobedtm.com/68ade2efaac6/9c1be53b5ebb/launch-495f63f5a78b.min.js'
      },
      tottus: {
        dev: 'https://assets.adobedtm.com/68ade2efaac6/5503e49298c7/launch-af969c0b201a-staging.min.js',
        staging: 'https://assets.adobedtm.com/68ade2efaac6/5503e49298c7/launch-af969c0b201a-staging.min.js',
        beta: 'https://assets.adobedtm.com/68ade2efaac6/5503e49298c7/launch-b254bc97d74b-development.min.js',
        production: 'https://assets.adobedtm.com/68ade2efaac6/5503e49298c7/launch-20dd96aac0dc.min.js'
      }
    },
    AR: {
      dev: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
      staging: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
      beta: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
      production: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
      sodimac: {
        dev: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
        staging: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
        beta: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js',
        production: '//assets.adobedtm.com/launch-EN2c8098df45a14710b127b493f68a3987.min.js'
      }
    }
  },
  DIGITAL_DATA_STORAGE_NAME: 'analyticsInfo',
  searchTerm: 'Ntt',
  medallia: {
    falabella: {},
    sodimac: {},
    tottus: {
      CL: 'https://nebula-cdn.kampyle.com/us/wu/1335606/onsite/embed.js',
      PE: '',
      CO: ''
    }
  }
};
var footerLinks = {
  linkStyles: _objectSpread2({}, footerData.linkStyles),
  countryStyles: _objectSpread2({}, footerData.countryStyles)
};
var STORE_NAMES_REGEX = new RegExp(/(sodimac|linio|tottus|homecenter|so_com|to_com)/, 'g');
var STORE_MAP = {
  MARKETPLACE: 'falabella',
  cl: {
    sodimac: 'sodimac',
    so_com: 'sodimac',
    tottus: 'tottus',
    to_com: 'tottus',
    linio: 'linio',
    fa_america: 'americanino',
    fa_carters: 'carters',
    fa_aldo: 'aldo',
    fa_crabarr: 'crateandbarrel'
  },
  pe: {
    sodimac: 'sodimac',
    so_com: 'sodimac',
    tottus: 'tottus',
    to_com: 'tottus',
    linio: 'linio',
    fa_carters: 'carters',
    fa_aldo: 'aldo',
    fa_crabarr: 'crateandbarrel'
  },
  co: {
    homecenter: 'homecenter',
    sodimac: 'sodimac',
    so_com: 'sodimac',
    tottus: 'tottus',
    to_com: 'tottus',
    linio: 'linio',
    fa_crabarr: 'crateandbarrel'
  },
  ar: {}
};
var apiEndpoints = {
  getRegion: function getRegion(tenant) {
    var baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return "".concat(baseUrl, "/s/geo/v2/states/").concat(tenant);
  },
  getCitylist: function getCitylist(politicalId, tenant) {
    var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return "".concat(baseUrl, "/s/geo/v2/districts/").concat(tenant, "?statePoliticalId=").concat(politicalId);
  },
  getProvinceList: function getProvinceList(politicalId, tenant) {
    var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return "".concat(baseUrl, "/s/geo/v2/counties/").concat(tenant, "?statePoliticalId=").concat(politicalId);
  },
  getDistrictList: function getDistrictList(statePoliticalId, countyPoliticalId, tenant) {
    var baseUrl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    return "".concat(baseUrl, "/s/geo/v2/districts/").concat(tenant, "?statePoliticalId=").concat(statePoliticalId, "&countyPoliticalId=").concat(countyPoliticalId);
  },
  getComunaDetails: function getComunaDetails(politicalId) {
    var tenant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cl';
    var baseUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var store = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var url = "".concat(baseUrl, "/s/geo/v2/districts/").concat(tenant, "?politicalId=").concat(politicalId);
    if (store) {
      url += "&store=".concat(store);
    }
    return url;
  },
  getUserAddresses: function getUserAddresses(baseUrl) {
    return "".concat(baseUrl, "/s/account/v2/addresses");
  },
  saveUserAddresses: function saveUserAddresses(baseUrl) {
    return "".concat(baseUrl, "/s/account/v2/addresses");
  },
  deleteUserAddresses: function deleteUserAddresses(baseUrl, addressID) {
    return "".concat(baseUrl, "/s/account/v2/addresses/").concat(addressID);
  }
};
var deviceTypes = {
  DESKTOP: 'desktop',
  TABLET: 'tablet',
  MOBILE: 'mobile'
};
var platforms = {
  MOBILE: {
    IOS: 'mobile_ios',
    ANDROID: 'mobile_android'
  }
};
var ENVIRONMENT = {
  LOCAL: 'local',
  DEVELOPMEMT: 'dev',
  STAGING: 'staging',
  UAT: 'beta',
  PRODUCTION: 'www'
};
var ENV_SUBDOMAIN_MAPPING = {
  dev: {
    LINIO: 'dev-linio',
    TOTTUS: 'dev-tottus',
    SODIMAC: 'dev-sodimac',
    HOMECENTER: 'dev-homecenter',
    FALABELLA: 'dev',
    SO_COM: 'dev',
    TO_COM: 'dev',
    FA_AMERICA: 'dev'
  },
  staging: {
    LINIO: 'staging-linio',
    TOTTUS: 'staging-tottus',
    SODIMAC: 'staging-sodimac',
    HOMECENTER: 'staging-homecenter',
    FALABELLA: 'staging',
    SO_COM: 'staging',
    TO_COM: 'staging',
    FA_AMERICA: 'staging'
  },
  beta: {
    LINIO: 'beta-linio',
    TOTTUS: 'beta-tottus',
    SODIMAC: 'beta-sodimac',
    HOMECENTER: 'beta-homecenter',
    FALABELLA: 'beta',
    SO_COM: 'beta',
    TO_COM: 'beta',
    FA_AMERICA: 'beta'
  },
  production: {
    LINIO: 'linio',
    TOTTUS: 'tottus',
    SODIMAC: 'sodimac',
    HOMECENTER: 'homecenter',
    FALABELLA: 'www',
    SO_COM: 'www',
    TO_COM: 'www',
    FA_AMERICA: 'www'
  }
};
var STORES = {
  LINIO: 'linio',
  TOTTUS: 'tottus',
  SODIMAC: 'sodimac',
  HOMECENTER: 'homecenter',
  FALABELLA: 'falabella',
  SO_COM: 'so_com',
  TO_COM: 'to_com',
  FA_AMERICA: 'fa_america'
};
var STANDALONE_STORES = [STORES.SO_COM, STORES.TO_COM, STORES.FA_AMERICA];
var WHITELABEL_STORES = [STORES.FA_AMERICA];
var SIS_PAGE_FILTER = {
  LINIO: 'linio',
  TOTTUS: 'tottus',
  SODIMAC: 'sodimac',
  HOMECENTER: 'homecenter'
};
var SIS_STORE_MAP = {
  linio: 'Linio',
  tottus: 'Tottus',
  sodimac: 'Sodimac',
  homecenter: 'Homecenter',
  so_com: 'Sodimac',
  to_com: 'Tottus'
};
var HOME_ICON_WIDTH = '91.572';
var SIS_ICON_WIDTH = {
  LINIO: 48,
  TOTTUS: 75,
  SODIMAC: 80,
  HOMECENTER: 117
};
var NAVIGATION = 'NAVIGATION_TAGS';
var SIS_NAVIGATION = 'SIS_NAVIGATION_TAGS';
var HEADER = 'HEADER_TAGS';
var FOOTER = 'FOOTER_TAGS';
var DIGITALDATA_TAGS = {
  NAVIGATION_TAGS: {
    NESTED: 'tag.header.tlm_head'
  },
  SIS_NAVIGATION_TAGS: {
    PREFIX: 'MS-MenuSis_',
    NESTED: 'tag.TLMS.TlmsisTag'
  },
  HEADER_TAGS: {
    NESTED: 'tag.header.buttons'
  },
  FOOTER_TAGS: {
    NESTED: 'tag.FT.FooterTag'
  }
};
var DIGITALDATA_CMS_URL = {
  dev: 'https://assets-staging.falabella.com/v3/assets/blt07d653b53a07a055/blt09f2beda72d907db/cross-components.cjs',
  staging: 'https://assets-staging.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltac852fe85bca6e67/cross-components.cjs',
  beta: 'https://assets-uat.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3a018881108be146/cross-components.cjs',
  production: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc531eda557c63411/cross-components.cjs'
};
var defaultAnalyticsResponse = {
  analyticsInfo: {
    page: {},
    login: {}
  }
};
var PREPOSITIONS = {
  una: true,
  y: true,
  de: true,
  la: true,
  del: true,
  es: true
};
var SID_STATUS = {
  SOFTLOGIN: 'Soft',
  HARDLOGIN: 'Authenticated'
};
var ICONS = {
  F_LOGO: 'https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltabc2a9c42c4d5b36/falabella.com-256x256.png'
};
var gtmInfo = {
  FALABELLA: {
    CL: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-NJX6QWJ',
      production: 'GTM-NJX6QWJ'
    },
    PE: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-T29WRLG',
      production: 'GTM-T29WRLG'
    },
    CO: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-PQRB5NV',
      production: 'GTM-PQRB5NV'
    }
  },
  SODIMAC: {
    CL: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-WGGFJP',
      production: 'GTM-WGGFJP'
    },
    PE: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-5M8VN5',
      production: 'GTM-5M8VN5'
    },
    CO: {
      staging: '',
      beta: '',
      production: ''
    }
  },
  TOTTUS: {
    CL: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-MJQ3SH25',
      production: 'GTM-MJQ3SH25'
    },
    PE: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-W5DHXDR7',
      production: 'GTM-W5DHXDR7'
    }
  },
  WHITELABEL: {
    CL: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-NZJJ9R4',
      production: 'GTM-NZJJ9R4'
    },
    PE: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-T4MPK453',
      production: 'GTM-T4MPK453'
    },
    CO: {
      staging: 'GTM-NO-DATA',
      beta: 'GTM-M7VZ8LD7',
      production: 'GTM-M7VZ8LD7'
    }
  }
};
var metaTagsApp = {
  FALABELLA: [{
    property: 'al:ios:url',
    content: 'https://apps.apple.com/cl/app/falabella/id947145705'
  }, {
    property: 'al:ios:app_store_id',
    content: '947145705'
  }, {
    property: 'al:ios:app_name',
    content: 'Falabella'
  }, {
    property: 'al:android:url',
    content: 'https://play.google.com/store/apps/details?id=com.falabella.falabellaApp'
  }, {
    property: 'al:android:app_name',
    content: 'Falabella'
  }, {
    property: 'al:android:package',
    content: 'com.falabella.falabellaApp'
  }, {
    property: 'al:ios:package',
    content: 'com.falabella.app'
  }],
  SO_COM: [{
    property: 'al:ios:url',
    content: 'https://apps.apple.com/cl/app/sodimac-hogar-y-construcci%C3%B3n/id532353705'
  }, {
    property: 'al:ios:app_store_id',
    content: '532353705'
  }, {
    property: 'al:ios:app_name',
    content: 'Sodimac: Hogar y Construcción'
  }, {
    property: 'al:android:url',
    content: 'https://play.google.com/store/apps/details?id=com.falabella.falabellaApp'
  }, {
    property: 'al:android:app_name',
    content: 'Sodimac: Hogar y Construcción'
  }, {
    property: 'al:android:package',
    content: 'cl.sodimac'
  }, {
    property: 'al:ios:package',
    content: 'GerenciaSistemas.SubgerenciaIngenieriaSoftware.Francisco'
  }],
  TO_COM: [{
    property: 'al:ios:url',
    content: 'https://apps.apple.com/cl/app/tottus/id1476096203'
  }, {
    property: 'al:ios:app_store_id',
    content: '1476096203'
  }, {
    property: 'al:ios:app_name',
    content: 'Tottus'
  }, {
    property: 'al:android:url',
    content: 'https://play.google.com/store/apps/details?id=com.tottus'
  }, {
    property: 'al:android:app_name',
    content: 'Tottus'
  }, {
    property: 'al:android:package',
    content: 'com.tottus'
  }, {
    property: 'al:ios:package',
    content: 'com.tottus'
  }]
};
var WHITELABELS_SEARCH_PATH = {
  fa_america: 'search',
  fa_aldo: 'search',
  fa_crabarr: 'search',
  fa_carters: 'search'
};
var SEARCH_PATH = _objectSpread2({
  fa_com: 'search',
  so_com: 'buscar',
  to_com: 'buscar',
  sodimac: 'search',
  homecenter: 'search',
  tottus: 'search',
  linio: 'search'
}, WHITELABELS_SEARCH_PATH);
var HOME_URL = {
  '': 'https://www.falabella.com/falabella-cl',
  cl: 'https://www.falabella.com/falabella-cl',
  cl__sodimac: 'https://sodimac.falabella.com/sodimac-cl',
  cl__tottus: 'https://tottus.falabella.com/tottus-cl',
  cl__linio: 'https://linio.falabella.com/linio-cl',
  cl__so_com: 'https://www.sodimac.cl/sodimac-cl',
  cl__to_com: 'https://www.tottus.cl/tottus-cl',
  pe: 'https://www.falabella.com.pe/falabella-pe',
  pe__sodimac: 'https://sodimac.falabella.com.pe/sodimac-pe',
  pe__tottus: 'https://tottus.falabella.com.pe/tottus-pe',
  pe__linio: 'https://linio.falabella.com.pe/linio-pe',
  pe__so_com: 'https://www.sodimac.com.pe/sodimac-pe',
  pe__to_com: 'https://www.tottus.com.pe/tottus-pe',
  co: 'https://www.falabella.com.co/falabella-co',
  co__sodimac: 'https://sodimac.falabella.com.co/sodimac-co',
  co__tottus: 'https://tottus.falabella.com.co/tottus-co',
  co__linio: 'https://linio.falabella.com.co/linio-co',
  co__so_com: 'https://www.sodimac.com.co/sodimac-co',
  co__to_com: 'https://www.tottus.com.co/tottus-co'
};
var SCRIPT_URL = {
  falabella: {
    cl: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ae1beb67525ed26/vwo.js',
    pe: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf1762da3c97b64e4/vwo.js',
    co: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf0b1376d26dd28cc/vwo.js'
  },
  sodimac: {
    cl: 'https://assets.falabella.com/v3/assets/blt6a203fe6c6a9b6dd/blt705a6b1a4bf4cea6/vwo.js',
    pe: 'https://assets.falabella.com/v3/assets/blt6a82e9c0570891fd/blt1e8af8be1dce2321/vwo.js'
  },
  tottus: {
    cl: 'https://assets.falabella.com/v3/assets/blt72431f7a08fe765a/blt571db869516aebeb/vwo.js',
    pe: 'https://assets.falabella.com/v3/assets/blt422ac29cebae1d64/blt9b9f051e8c878b44/vwo.js'
  }
};
var WHITELABEL_SITES = new Set(['fa_aldo', 'fa_america', 'fa_carters', 'fa_crabarr']);
var USER_SEGMENT_COOKIE = 'userSegments';

var isWindow = function isWindow() {
  return process.browser;
};
var DEFAULT_COOKIE_DOMAIN = '.falabella.com';
var CookieSchema = {
  zoneData: {
    type: 'object',
    encoded: true
  },
  locationData: {
    type: 'object',
    encoded: true
  },
  customerData: {
    type: 'object',
    encoded: true
  },
  DYN_USER_ID: {
    type: 'string',
    encoded: false
  },
  DYNAMIC_DATA_COOKIE: {
    type: 'string',
    encoded: false
  },
  VENDOR_DATA: {
    type: 'string',
    encoded: false
  },
  AGENT_DATA: {
    type: 'string',
    encoded: false
  },
  CATALYST_DATA_COOKIE: {
    type: 'string',
    encoded: false
  },
  IS_PRESSURE_MODAL_INTERACTED: {
    type: 'string',
    encoded: false
  },
  IS_ZONE_SELECTED: {
    type: 'string',
    encoded: false
  },
  NAVIGATION_TAGS: {
    type: 'object',
    encoded: true
  },
  priceGroupId: {
    type: 'string',
    encoded: false
  },
  politicalId: {
    type: 'string',
    encoded: false
  },
  isPoliticalIdExists: {
    type: 'bool',
    encoded: false
  },
  SIS_NAVIGATION_TAGS: {
    type: 'object',
    encoded: true
  },
  HEADER_TAGS: {
    type: 'object',
    encoded: true
  },
  FOOTER_TAGS: {
    type: 'object',
    encoded: true
  },
  KIOSKO_STORE_ID: {
    type: 'string',
    encoded: false
  },
  KIOSKO_MODULO: {
    type: 'string',
    encoded: false
  },
  userSegments: {
    type: 'object',
    encoded: true
  }
};
var getTagFromCookie = function getTagFromCookie() {
  var cookies = document.cookie;
  var tagName = cookies.match(/(NAVIGATION_TAGS|SIS_NAVIGATION_TAGS|HEADER_TAGS|FOOTER_TAGS)/);
  return tagName && tagName[0] || '';
};
var isSodimacSite = function isSodimacSite() {
  return /sodimac\.(cl|com\.pe)/.test(window.location.origin);
};
var isTottusSite = function isTottusSite() {
  return /tottus\.(cl|com\.pe)/.test(window.location.origin);
};
var isWhitelabelSite = function isWhitelabelSite() {
  return /(americanino|carters|crateandbarrel|aldo|aldoshoes)\.(cl|com\.pe|com\.co)/.test(window.location.origin);
};
var getCookie = function getCookie(cookieName) {
  var result = document.cookie.match("(^|;)\\s*".concat(cookieName, "\\s*=\\s*([^;]+)"));
  return result ? result.pop() : '';
};
var isCatalyst = function isCatalyst() {
  var experience = getCookie('experience');
  return experience === 'CATALYST';
};
var encode = function encode(raw) {
  return isWindow() ? btoa(unescape(encodeURIComponent(raw))) : Buffer.from(raw).toString('base64');
};
function getWhitelabelCookieDomain() {
  var _window$location$host = window.location.hostname,
    hostname = _window$location$host === void 0 ? '' : _window$location$host;
  var prefixes = ['www.', 'beta.', 'staging.'];
  var cleanedHostname = prefixes.reduce(function (acc, prefix) {
    if (acc.startsWith(prefix)) {
      return acc.substring(prefix.length);
    }
    return acc;
  }, hostname);
  return ".".concat(cleanedHostname);
}
var getHost = function getHost(regionCode) {
  var sodimacHosts = {
    cl: '.sodimac.cl',
    pe: '.sodimac.com.pe'
  };
  var tottusHosts = {
    cl: '.tottus.cl',
    pe: '.tottus.com.pe'
  };
  if (isSodimacSite()) {
    return sodimacHosts[regionCode];
  }
  if (isTottusSite()) {
    return tottusHosts[regionCode];
  }
  if (isWhitelabelSite()) {
    return getWhitelabelCookieDomain();
  }
  var domain = DEFAULT_COOKIE_DOMAIN;
  var region = '';
  if (regionCode === 'cl' || !regionCode) {
    region = '';
  } else {
    region = ".".concat(regionCode);
  }
  return "".concat(domain).concat(region);
};
var setCookie = function setCookie(_ref) {
  var name = _ref.name,
    value = _ref.value,
    _ref$expiryDays = _ref.expiryDays,
    expiryDays = _ref$expiryDays === void 0 ? 1000 : _ref$expiryDays,
    domain = _ref.domain,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '/' : _ref$path,
    _ref$addQuotes = _ref.addQuotes,
    addQuotes = _ref$addQuotes === void 0 ? false : _ref$addQuotes,
    regionCode = _ref.regionCode,
    maxAge = _ref.maxAge;
  var cookie = value;
  var expiration = '';
  var domainStr = ";domain=".concat(domain || getHost(regionCode));
  var pathStr = ";path=".concat(path);
  var schema = CookieSchema[name];
  if (schema) {
    if (schema.type === 'object') {
      cookie = JSON.stringify(cookie);
    }
    cookie = schema.encoded ? encode(cookie) : cookie;
  }
  if (maxAge) {
    expiration = "; max-age=".concat(maxAge);
  } else {
    var date = new Date();
    var DAY = 24 * 60 * 60 * 1000;
    date.setTime(date.getTime() + expiryDays * DAY);
    expiration = "; expires=".concat(date.toGMTString());
  }
  var cookieStr = "".concat(name, "=").concat(cookie).concat(domainStr).concat(pathStr).concat(expiration, "; Priority=High");
  if (addQuotes) {
    cookieStr = "\"".concat(cookieStr, "\"");
  }
  if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
    document.cookie = cookieStr;
    return cookieStr;
  }
  return false;
};
var setHostOnlySessionCookie = function setHostOnlySessionCookie(_ref2) {
  var name = _ref2.name,
    value = _ref2.value,
    _ref2$path = _ref2.path,
    path = _ref2$path === void 0 ? '/' : _ref2$path;
  var cookie = value;
  var pathStr = ";path=".concat(path);
  var schema = CookieSchema[name];
  if (schema) {
    if (schema.type === 'object') {
      cookie = JSON.stringify(cookie);
    }
    cookie = schema.encoded ? encode(cookie) : cookie;
  }
  var cookieStr = "".concat(name, "=").concat(cookie).concat(pathStr);
  if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
    document.cookie = cookieStr;
    return cookieStr;
  }
  return false;
};
var setHostOnlyCookie = function setHostOnlyCookie(_ref3) {
  var name = _ref3.name,
    value = _ref3.value,
    _ref3$expiryDays = _ref3.expiryDays,
    expiryDays = _ref3$expiryDays === void 0 ? 1000 : _ref3$expiryDays,
    _ref3$path = _ref3.path,
    path = _ref3$path === void 0 ? '/' : _ref3$path;
  var cookie = value;
  var expiration = '';
  var pathStr = ";path=".concat(path);
  var schema = CookieSchema[name];
  if (schema) {
    if (schema.type === 'object') {
      cookie = JSON.stringify(cookie);
    }
    cookie = schema.encoded ? encode(cookie) : cookie;
  }
  if (expiryDays) {
    var date = new Date();
    var DAY = 24 * 60 * 60 * 1000;
    date.setTime(date.getTime() + expiryDays * DAY);
    expiration = "; expires=".concat(date.toGMTString());
  }
  var cookieStr = "".concat(name, "=").concat(cookie).concat(pathStr).concat(expiration);
  if (typeof document !== 'undefined' && typeof document.cookie !== 'undefined') {
    document.cookie = cookieStr;
    return cookieStr;
  }
  return false;
};
var removeCookie = function removeCookie(_ref4) {
  var name = _ref4.name;
  if (isWindow()) {
    document.cookie = "".concat(name, "= ; expires=Thu, 01 Jan 1970 00:00:01 GMT;");
  }
};
var removeCookieByDomain = function removeCookieByDomain(_ref5) {
  var name = _ref5.name,
    _ref5$domain = _ref5.domain,
    domain = _ref5$domain === void 0 ? DEFAULT_COOKIE_DOMAIN : _ref5$domain;
  if (typeof window !== 'undefined') {
    document.cookie = "".concat(name, "= ; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=").concat(domain, "; path=/;");
  }
};
var unescapeATGCookies = function unescapeATGCookies(str) {
  return decodeURIComponent(str).replace('+', ' ');
};
var escapeATGCookies = function escapeATGCookies(str) {
  return encodeURIComponent(str.replace('', '+'));
};
var getUserDataCookieName = function getUserDataCookieName() {
  return isCatalyst() ? 'CATALYST_DATA_COOKIE' : 'DYNAMIC_DATA_COOKIE';
};
var getAgentDataCookie = function getAgentDataCookie() {
  return isCatalyst() ? 'AGENT_INFO' : 'AGENT_DATA';
};
var getVendorDataCookie = function getVendorDataCookie() {
  return isCatalyst() ? 'KIOSKO_INFO' : 'VENDOR_DATA';
};
var decode = function decode(raw) {
  var regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
  try {
    if (regex.test(raw)) {
      return isWindow() ? decodeURIComponent(escape(window.atob(raw.replace(/"/g, '')))) : Buffer.from(raw, 'base64').toString();
    }
    return false;
  } catch (err) {
    return false;
  }
};
var parseCookieValue = function parseCookieValue(name, value) {
  if (!value) return undefined;
  var _ref6 = CookieSchema[name] || {},
    encoded = _ref6.encoded,
    type = _ref6.type;
  var decodedValue = encoded ? decode(value) : value;
  if (type === 'object') {
    try {
      return JSON.parse(decodedValue);
    } catch (e) {
      return undefined;
    }
  }
  return decodedValue;
};
var parseCookies = function parseCookies(str) {
  if (!str || str === '') {
    return {};
  }
  var cookies = {};
  str.split(';').forEach(function (cookie) {
    var c = cookie.split('=');
    var name = c[0].trim();
    var value = c[1];
    cookies[name] = parseCookieValue(name, value);
  });
  return cookies;
};
var getKioskoModuleCookieName = function getKioskoModuleCookieName() {
  return 'KIOSKO_MODULO';
};
var getKioskoStoreCookieName = function getKioskoStoreCookieName() {
  return 'KIOSKO_STORE_ID';
};
var CookieStorage = {
  setCookie: setCookie,
  getCookie: getCookie,
  removeCookie: removeCookie,
  removeCookieByDomain: removeCookieByDomain,
  unescapeATGCookies: unescapeATGCookies,
  escapeATGCookies: escapeATGCookies,
  getUserDataCookieName: getUserDataCookieName,
  parseCookies: parseCookies,
  getAgentDataCookie: getAgentDataCookie,
  isCatalyst: isCatalyst,
  setHostOnlyCookie: setHostOnlyCookie,
  setHostOnlySessionCookie: setHostOnlySessionCookie,
  getVendorDataCookie: getVendorDataCookie,
  parseCookieValue: parseCookieValue,
  getHost: getHost,
  isWindow: isWindow,
  encode: encode,
  decode: decode,
  getTagFromCookie: getTagFromCookie,
  getKioskoModuleCookieName: getKioskoModuleCookieName,
  getKioskoStoreCookieName: getKioskoStoreCookieName
};

var getItem = function getItem(_ref) {
  var name = _ref.name,
    fromPersistence = _ref.fromPersistence;
  return fromPersistence ? localStorage.getItem(name) : sessionStorage.getItem(name);
};
var setItem = function setItem(_ref2) {
  var name = _ref2.name,
    value = _ref2.value,
    shouldPersist = _ref2.shouldPersist;
  return shouldPersist ? localStorage.setItem(name, value) : sessionStorage.setItem(name, value);
};
var WebStorage = {
  getItem: getItem,
  setItem: setItem,
  removeItem: function removeItem(_ref3) {
    var name = _ref3.name,
      fromPersistence = _ref3.fromPersistence;
    return fromPersistence ? localStorage.removeItem(name) : sessionStorage.removeItem(name);
  },
  getItemWithTTL: function getItemWithTTL(_ref4) {
    var name = _ref4.name,
      fromPersistence = _ref4.fromPersistence;
    var data = getItem({
      name: name,
      fromPersistence: fromPersistence
    });
    if (data) {
      var _JSON$parse = JSON.parse(data),
        ttl = _JSON$parse.ttl,
        value = _JSON$parse.value;
      var now = new Date().getTime();
      if (ttl > now) {
        return value;
      }
    }
    return undefined;
  },
  setItemWithTTL: function setItemWithTTL(_ref5) {
    var name = _ref5.name,
      value = _ref5.value,
      fromPersistence = _ref5.fromPersistence,
      _ref5$ttl = _ref5.ttl,
      ttl = _ref5$ttl === void 0 ? 0 : _ref5$ttl;
    var now = new Date().getTime();
    var data = {
      ttl: now + ttl,
      value: value
    };
    setItem({
      name: name,
      value: JSON.stringify(data),
      fromPersistence: fromPersistence
    });
  }
};

var isEmpty = function isEmpty(obj) {
  if (!obj || Object.keys(obj).length === 0) {
    return true;
  }
  return false;
};
var fallbackForEmpty = function fallbackForEmpty(obj, path, defaultValue) {
  return get(obj, path) || defaultValue;
};
var isWindow$1 = function isWindow() {
  return process && process.browser;
};
var noop = function noop() {};
var formatPoints = function formatPoints() {
  var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var tenant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'cl';
  if (tenant === 'pe') {
    return points.toLocaleString('en');
  }
  return points.toLocaleString('en').replace(/,/g, '.');
};
var toggleBodyClass = function toggleBodyClass(condition, name) {
  condition ? document.body.classList.add("".concat(name)) : document.body.classList.remove("".concat(name));
};
var getParameterByName = function getParameterByName(key, url) {
  if (!url && isWindow$1()) {
    url = window.location.href;
  }
  var name = key.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp("[?&]".concat(name, "(=([^&#]*)|&|#|$)"));
  var results = regex.exec(url);
  if (!results || !results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
var getCurrentLocation = function getCurrentLocation() {
  if (!isWindow$1()) {
    return;
  }
  var cookies = CookieStorage.parseCookies(document.cookie);
  var zoneName = get(cookies, 'zoneData.zoneName', 'SELECCIONAR UBICACIÓN');
  return zoneName;
};
var svgToDataUri = function svgToDataUri(svgStr) {
  var encoded = encodeURIComponent(svgStr).replace(/'/g, '%27').replace(/"/g, '%22');
  var header = 'data:image/svg+xml;charset=utf8,';
  var dataUrl = header + encoded;
  return dataUrl;
};
var matchStoreName = function matchStoreName() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var result = text.match(STORE_NAMES_REGEX);
  return result ? result[0] : false;
};
var getSISPageName = function getSISPageName() {
  var baseUrl = '';
  if (typeof global.window !== 'undefined') {
    baseUrl = window.location.origin;
  }
  return matchStoreName(baseUrl);
};
var getEXPParam = function getEXPParam() {
  var queryParams = '';
  if (typeof global.window !== 'undefined') {
    queryParams = window.location.search.substring(1);
  }
  var params = new URLSearchParams(queryParams);
  if (params.get('exp')) {
    var exp = params.get('exp');
    return matchStoreName(exp);
  }
  return false;
};
var isPdpPage = function isPdpPage() {
  var pathUrl = '';
  if (typeof global.window !== 'undefined') {
    pathUrl = window.location.pathname;
  }
  return pathUrl.includes('/product/');
};
var isLandingPage = function isLandingPage() {
  var baseUrl = '';
  if (typeof global.window !== 'undefined') {
    baseUrl = window.location.pathname;
  }
  return baseUrl.includes('/page');
};
var isXLPPage = function isXLPPage() {
  var baseUrl = '';
  if (typeof global.window !== 'undefined') {
    baseUrl = window.location.pathname;
  }
  return baseUrl.includes('/search') || baseUrl.includes('/buscar') || baseUrl.includes('/category/') || baseUrl.includes('/lista/') || baseUrl.includes('/collection/') || baseUrl.includes('/seleccion/') || baseUrl.includes('/seller/') || baseUrl.includes('/vendedor/') || baseUrl.includes('/brand/') || baseUrl.includes('/marca/');
};
var filterStoresFromCurrentStore = function filterStoresFromCurrentStore() {
  var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentStoreName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return stores && stores.length > 0 && stores.filter(function (_ref) {
    var title = _ref.icon.title;
    return !title.includes(currentStoreName);
  });
};
var getStoreNameFromSisPage = function getStoreNameFromSisPage(stores, sisPageName) {
  if (stores) {
    var result;
    switch (sisPageName) {
      case 'sodimac':
        result = filterStoresFromCurrentStore(stores, SIS_PAGE_FILTER.SODIMAC);
        break;
      case 'homecenter':
        result = filterStoresFromCurrentStore(stores, SIS_PAGE_FILTER.HOMECENTER);
        break;
      case 'linio':
        result = filterStoresFromCurrentStore(stores, SIS_PAGE_FILTER.LINIO);
        break;
      case 'tottus':
        result = filterStoresFromCurrentStore(stores, SIS_PAGE_FILTER.TOTTUS);
        break;
      default:
        result = filterStoresFromCurrentStore(stores, 'main');
        break;
    }
    return {
      stores: result,
      title: ''
    };
  } else {
    return null;
  }
};
var getWidthForStoreIcon = function getWidthForStoreIcon() {
  var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (title.includes(SIS_PAGE_FILTER.SODIMAC)) {
    return SIS_ICON_WIDTH.SODIMAC;
  } else if (title.includes(SIS_PAGE_FILTER.HOMECENTER)) {
    return SIS_ICON_WIDTH.HOMECENTER;
  } else if (title.includes(SIS_PAGE_FILTER.TOTTUS)) {
    return SIS_ICON_WIDTH.TOTTUS;
  } else if (title.includes(SIS_PAGE_FILTER.LINIO)) {
    return SIS_ICON_WIDTH.LINIO;
  } else return HOME_ICON_WIDTH;
};
var isElementInViewport = function isElementInViewport(el) {
  if (!el) {
    return false;
  }
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};
var processSearchQuery = function processSearchQuery(searchQuery) {
  var isSearchSpecialCharactersEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var newSearchTerm;
  var specialChars = ['\\.', '\\,', '\\&', '\\"', '\\/'];
  var specialCharsRegex = specialChars.join('');
  if (isSearchSpecialCharactersEnabled) {
    newSearchTerm = searchQuery.trim().replace(/\s+/g, ' ').replace(new RegExp(
    "[^a-zA-Z0-9\xF1\xD1\xE1\xE9\xED\xF3\xFA\xC1\xC9\xCD\xD3\xDA\xFC\xDC\xC0\xC8\xCC\xD2\xD9\xE0\xE8\xEC\xF2\xF9\\s\\_\\-".concat(specialCharsRegex, "]"), 'g'), '').trim();
  } else {
    newSearchTerm = searchQuery.trim().replace(/\s+/g, ' ').replace(/&/g, ' ').replace(
    /[^a-zA-Z0-9\xf1\xd1\xe1\xe9\xed\xf3\xfa\xc1\xc9\xcd\xd3\xda\xfc\xdc\xc0\xc8\xcc\xd2\xd9\xe0\xe8\xec\xf2\xf9\s\_\-\/\"]/g, '').replace(/[/]+/g, ' ').trim();
  }
  return newSearchTerm;
};

var isClientSide = function isClientSide() {
  return typeof window !== 'undefined';
};
var getBusinessUnit = function getBusinessUnit() {
  var isSodimacStandAloneSite = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isTottusStandAloneSite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isSodimacStandAloneSite) return 'sodimac';
  if (isTottusStandAloneSite) return 'tottus';
  return 'falabella';
};
var buildContentStandaloneSiteUrl = function buildContentStandaloneSiteUrl(url, section, countryCode, version, store) {
  var sisMenuStore = STORE_MAP[countryCode][store];
  switch (section) {
    case 'header':
      return "".concat(url, "/s/content/").concat(version || 'v1', "/").concat(section, "/").concat(countryCode, "?site=").concat(store);
    case 'footer':
      return "".concat(url, "/s/content/").concat(version || 'v3', "/").concat(section, "/").concat(countryCode, "?site=").concat(store);
    case 'sisMenu':
      return "".concat(url, "/s/content/").concat(version || 'v1', "/").concat(section, "/").concat(countryCode, "/").concat(sisMenuStore, "?site=").concat(store);
    default:
      return "".concat(url, "/s/content/").concat(version || 'v1', "/").concat(section, "/").concat(countryCode);
  }
};
var buildWhitelabelContentUrl = function buildWhitelabelContentUrl(url, section, countryCode, version, store) {
  switch (section) {
    case 'header':
      return "".concat(url, "/s/content/").concat(version || 'v1', "/").concat(section, "/").concat(countryCode, "/whitelabel/").concat(store);
    case 'footer':
      return "".concat(url, "/s/content/").concat(version || 'v3', "/").concat(section, "/").concat(countryCode, "/whitelabel/").concat(store);
    case 'sisMenu':
      return "".concat(url, "/s/content/").concat(version || 'v1', "/menu/").concat(countryCode, "/whitelabel/").concat(store);
    default:
      return "".concat(url, "/s/content/").concat(version || 'v1', "/").concat(section, "/").concat(countryCode);
  }
};
var isSodimacStandalone = function isSodimacStandalone(store) {
  return store === STORES.SO_COM;
};
var isTottusStandalone = function isTottusStandalone(store) {
  return store === STORES.TO_COM;
};
var isWhitelabel = function isWhitelabel() {
  var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return WHITELABEL_SITES.has(store);
};
var getStandaloneSite = function getStandaloneSite() {
  var store = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var result = {
    isStandaloneSite: false,
    isSodimacStandalone: isSodimacStandalone(store),
    isTottusStandalone: isTottusStandalone(store),
    isWhitelabelSite: isWhitelabel(store)
  };
  if (result.isSodimacStandalone || result.isTottusStandalone) {
    result.isStandaloneSite = true;
  }
  return result;
};
var buildContentUrl = function buildContentUrl(url, section, countryCode, version, store) {
  if (isWhitelabel(store)) {
    return buildWhitelabelContentUrl(url, section, countryCode, version, store);
  }
  if (getStandaloneSite(store).isStandaloneSite) {
    return buildContentStandaloneSiteUrl(url, section, countryCode, version, store);
  }
  var storePath = store ? "/".concat(store) : '';
  return "".concat(url, "/s/content/").concat(version || 'v1', "/").concat(section, "/").concat(countryCode).concat(storePath);
};
var isValidTenant = function isValidTenant(tenant) {
  var tenantList = Object.values(countriesCode);
  return tenantList.includes(tenant);
};
var getCountry = function getCountry() {
  var pathName = window.location.pathname;
  var pathArray = pathName.split('/');
  var tenant = pathArray.length > 1 ? pathArray[1] : 'falabella-cl';
  var countryArray = tenant.split('-');
  var country = countryArray.length > 1 ? countryArray[1] : 'cl';
  return country.toUpperCase();
};
var getLocation = function getLocation(uri) {
  var regex = new RegExp(['^(https?:)//',
  '(([^:/?#]*)(?::([0-9]+))?)',
  '(/{0,1}[^?#]*)',
  '(\\?[^#]*|)',
  '(#.*|)$'
  ].join(''));
  var match = uri.match(regex);
  return match && {
    href: uri,
    protocol: match[1].replace(':', ''),
    host: match[2],
    hostname: match[3],
    port: match[4] || '80',
    pathname: match[5] || '/',
    search: match[6],
    hash: match[7]
  };
};
var getPage = function getPage(uri) {
  var errorPage = document.getElementsByClassName('error-page');
  if (errorPage.length > 0) {
    return 'error';
  }
  var path = getLocation(uri);
  var paths = path.pathname.split('/');
  return paths.length > 2 ? paths[2] : '';
};
var createScriptTag = function createScriptTag(_ref) {
  var src = _ref.src,
    _ref$async = _ref.async,
    async = _ref$async === void 0 ? false : _ref$async,
    _ref$defer = _ref.defer,
    defer = _ref$defer === void 0 ? false : _ref$defer,
    onLoad = _ref.onLoad,
    integrity = _ref.integrity,
    crossOrigin = _ref.crossOrigin,
    onError = _ref.onError;
  var script = document.createElement('script');
  script.type = 'text/javascript';
  if (src) {
    script.src = src;
  }
  script.defer = defer;
  script.async = async;
  script.onload = onLoad;
  script.onerror = onError;
  if (integrity) {
    script.integrity = integrity;
  }
  if (crossOrigin) {
    script.crossOrigin = crossOrigin;
  }
  return script;
};
var createLinkTag = function createLinkTag(_ref2) {
  var linkOptions = _ref2.linkOptions;
  var link = document.createElement('link');
  Object.keys(linkOptions).forEach(function (k) {
    link[k] = linkOptions[k];
  });
  return link;
};
var appendNodeToHead = function appendNodeToHead(script) {
  var _document = document,
    head = _document.head;
  var documentFragment = document.createDocumentFragment();
  documentFragment.appendChild(script);
  head.appendChild(documentFragment);
};
var getRegion = function getRegion(regionCode) {
  if (regionCode === 'cl' || !regionCode) {
    return '';
  }
  return ".".concat(regionCode);
};
var getHost$1 = function getHost(regionCode, store) {
  var env = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ENVIRONMENT.PRODUCTION;
  var region = getRegion(regionCode);
  var _getStandaloneSite = getStandaloneSite(store),
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite,
    isStandaloneSite = _getStandaloneSite.isStandaloneSite;
  if (isWhitelabelSite) {
    var tenantPrefix = regionCode === 'cl' ? 'cl' : "com".concat(region);
    var domain = STORE_MAP[regionCode][store];
    return "https://".concat(env, ".").concat(domain, ".").concat(tenantPrefix);
  }
  if (isStandaloneSite) {
    var _tenantPrefix = regionCode === 'cl' ? 'cl' : "com".concat(region);
    var _domain = STORE_MAP[regionCode][store];
    return "https://".concat(env, ".").concat(_domain, ".").concat(_tenantPrefix);
  }
  var host = "https://".concat(env, ".falabella.com").concat(region);
  if (store && store !== 'falabella') {
    return env !== ENVIRONMENT.PRODUCTION ? host.replace("".concat(env, "."), "".concat(env, "-").concat(store, ".")) : host.replace("".concat(env, "."), "".concat(store, "."));
  }
  return host;
};
var buildFooterData = function buildFooterData(footer) {
  var footerData = get(footer, 'entry', null);
  if (!footerData) {
    return footerData;
  }
  return {
    copyright: {
      title: get(footerData, 'copyright.title', ''),
      description: get(footerData, 'copyright.description', ''),
      textColor: get(footerData, 'copyright.text_color', '')
    },
    footerColumns: get(footerData, 'footer_columns', []),
    horizontalLinks: get(footerData, 'horizontal_links', []),
    security: {
      iconDesktopRebrandingOn: {
        filename: get(footerData, 'security.icon_desktop_rebranding_on.filename', ''),
        title: get(footerData, 'security.icon_desktop_rebranding_on.title', ''),
        tags: get(footerData, 'security.icon_desktop_rebranding_on.tags', []),
        url: get(footerData, 'security.icon_desktop_rebranding_on.url', '')
      },
      iconMobileRebrandingOn: {
        filename: get(footerData, 'security.icon_mobile_rebranding_on.filename', ''),
        title: get(footerData, 'security.icon_mobile_rebranding_on.title', ''),
        tags: get(footerData, 'security.icon_mobile_rebranding_on.tags', []),
        url: get(footerData, 'security.icon_mobile_rebranding_on.url', '')
      },
      iconRebrandingOff: {
        filename: get(footerData, 'security.icon_rebranding_off.filename', ''),
        title: get(footerData, 'security.icon_rebranding_off.title', ''),
        tags: get(footerData, 'security.icon_rebranding_off.tags', []),
        url: get(footerData, 'security.icon_rebranding_off.url', '')
      },
      text: get(footerData, 'security.text', ''),
      url: get(footerData, 'security.url', ''),
      isNewTab: get(footerData, 'security.is_new_tab', false)
    },
    socialIcons: get(footerData, 'social_icons', []),
    tags: get(footerData, 'security.tags', []),
    title: get(footerData, 'security.title', ''),
    bottom_banner: {
      enabled: get(footerData, 'bottom_banner.enabled', ''),
      banner: {
        content: get(footerData, 'bottom_banner.banner.content', ''),
        bgColor: get(footerData, 'bottom_banner.banner.background_color', ''),
        txtColor: get(footerData, 'bottom_banner.banner.text_color', '')
      },
      button: {
        title: get(footerData, 'bottom_banner.button.title', ''),
        txtColor: get(footerData, 'bottom_banner.button.text_color', ''),
        bgColor: get(footerData, 'bottom_banner.button.background_color', '')
      }
    },
    logo: get(footerData, 'footer_themes.footer_logo.url', ''),
    primaryBackgroundColor: get(footerData, 'footer_themes.footer_primary_background_color', ''),
    secondaryBackgroundColor: get(footerData, 'footer_themes.footer_secondary_background_color', ''),
    tertiaryBackgroundColor: get(footerData, 'footer_themes.footer_tertiary_background_color', ''),
    poweredBy: {
      icon: get(footerData, 'powered_by.icon', ''),
      label: get(footerData, 'powered_by.label', ''),
      labelColor: get(footerData, 'powered_by.label_color', '')
    }
  };
};
var getEnvironment = function getEnvironment() {
  if (!isClientSide()) return;
  var origin = window.location.origin;
  if (origin.includes('staging')) {
    return 'staging';
  } else if (origin.includes('beta') || origin.includes('local')) {
    return 'beta';
  } else if (origin.includes('dev')) {
    return 'dev';
  } else {
    return 'production';
  }
};
var getSubdomain = function getSubdomain() {
  var _window$location$host = window.location.hostname.split('.'),
    _window$location$host2 = _slicedToArray(_window$location$host, 2),
    hostname1 = _window$location$host2[0],
    hostname2 = _window$location$host2[1];
  var hostname = hostname1;
  var subdomain = null;
  if (hostname1 === 'www') {
    hostname = hostname2;
  }
  if (hostname.includes('linio')) {
    subdomain = 'linio';
  } else if (hostname.includes('sodimac')) {
    subdomain = 'sodimac';
  } else if (hostname.includes('tottus')) {
    subdomain = 'tottus';
  } else if (hostname.includes('homecenter')) {
    subdomain = 'homecenter';
  }
  return subdomain;
};
var getTenantTopLevelDomain = function getTenantTopLevelDomain() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  return tenant === 'cl' ? '' : ".".concat(tenant);
};
var getDomain = function getDomain(hostname) {
  return hostname && hostname.split('.').length > 1 ? hostname.split('.').slice(1, 3).join('.') : 'falabella.com';
};
var getEnvBaseUrl = function getEnvBaseUrl() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  var env = getEnvironment();
  var subdomain = env === 'production' ? 'www' : env;
  var tenantTLD = getTenantTopLevelDomain(tenant);
  var _ref3 = isWindow$1() ? window.location : {},
    _ref3$hostname = _ref3.hostname,
    hostname = _ref3$hostname === void 0 ? '' : _ref3$hostname;
  var domain = getDomain(hostname);
  return "https://".concat(subdomain, ".").concat(domain).concat(tenantTLD);
};
var getStoreBaseUrl = function getStoreBaseUrl() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  var rawStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'falabella';
  var store = rawStore || 'falabella';
  var env = getEnvironment();
  var subDomain = ENV_SUBDOMAIN_MAPPING[env][store.toUpperCase()];
  var tenantTLD = getTenantTopLevelDomain(tenant);
  return "https://".concat(subDomain, ".falabella.com").concat(tenantTLD);
};
var getStandaloneSiteBaseUrl = function getStandaloneSiteBaseUrl() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  var store = arguments.length > 1 ? arguments[1] : undefined;
  var env = getEnvironment();
  if (!env || !STANDALONE_STORES.includes(store)) {
    return;
  }
  var subDomain = ENV_SUBDOMAIN_MAPPING[env][store.toUpperCase()];
  var domain = STORE_MAP[tenant][store];
  var tenantTLD = tenant === 'cl' ? 'cl' : 'com.pe';
  return "https://".concat(subDomain, ".").concat(domain, ".").concat(tenantTLD);
};
var getWhitelabelSiteBaseUrl = function getWhitelabelSiteBaseUrl() {
  var tenant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cl';
  var store = arguments.length > 1 ? arguments[1] : undefined;
  var env = getEnvironment();
  if (!env || !WHITELABEL_STORES.includes(store)) {
    return;
  }
  var subDomain = ENV_SUBDOMAIN_MAPPING[env][store.toUpperCase()];
  var domain = STORE_MAP[tenant][store];
  var tenantTLD = tenant === 'cl' ? 'cl' : 'com.pe';
  return "https://".concat(subDomain, ".").concat(domain, ".").concat(tenantTLD);
};
var isLocalhost = function isLocalhost() {
  return isClientSide() ? window.location.origin.includes('localhost') : false;
};
var getAuthBaseUrl = function getAuthBaseUrl(endpoint, tenant) {
  var host = isLocalhost() ? 'https://dev.falabella.com' : getEnvBaseUrl(tenant);
  return "".concat(host, "/s/auth/v1/").concat(endpoint);
};
var toggleNotificationsPopUpVisibilty = function toggleNotificationsPopUpVisibilty() {
  var AirshipHtmlPromptShadow = document.querySelector('.airship-html-prompt-shadow');
  if (!AirshipHtmlPromptShadow) {
    return;
  }
  var AirshipPromptContainer = AirshipHtmlPromptShadow.shadowRoot.querySelector('.airship-prompt-container');
  if (!AirshipPromptContainer) {
    return;
  }
  if (AirshipPromptContainer.style.display !== 'none') {
    AirshipPromptContainer.style.display = 'none';
  } else {
    AirshipPromptContainer.style.display = 'block';
  }
};
var capitalizeSelectedOption = function capitalizeSelectedOption(option) {
  var name = get(option, 'name', '').split(' ');
  var mutatedWords = name.map(function (word, index) {
    var wordLowerCase = word.toLowerCase();
    if (wordLowerCase in PREPOSITIONS && index !== 0) {
      return wordLowerCase;
    }
    return wordLowerCase.charAt(0).toUpperCase() + wordLowerCase.substr(1).toLowerCase();
  });
  mutatedWords = mutatedWords.join(' ');
  set(option, 'name', mutatedWords);
  return option;
};
var capitalizeList = function capitalizeList(list) {
  return list.map(function (listElement) {
    return capitalizeSelectedOption(listElement);
  });
};
var capitalizeWord = function capitalizeWord(str) {
  if (typeof str !== 'string') {
    return '';
  }
  var trimmedStr = str.trim();
  if (trimmedStr.length === 0) {
    return '';
  }
  var words = trimmedStr.split(/\s+/);
  var capitalizedWords = words.map(function (word) {
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
  });
  return capitalizedWords.join(' ');
};
var getDomainName = function getDomainName(pageHostNameArray) {
  var homePageMapping = ['staging', 'beta', 'www'];
  var pageDomain = pageHostNameArray[0].includes('-') ? pageHostNameArray[0].split('-') : [homePageMapping.includes(pageHostNameArray[0]) ? pageHostNameArray[1] : pageHostNameArray[0]];
  return Array.isArray(pageDomain) && pageDomain.length === 2 ? pageDomain[1] : pageDomain[0];
};
var getPageTitle = function getPageTitle(href) {
  var pageHostNameArray = getLocation(href).hostname.split('.');
  var pageDomain = getDomainName(pageHostNameArray);
  return pageDomain;
};
var pageNameMapping = function pageNameMapping(page, href) {
  switch (page) {
    case 'noResult':
      return 'noSearchResult';
    case 'notFound':
      return 'notFound';
    case 'search':
    case 'buscar':
      return 'search';
    case 'category':
    case 'collection':
    case 'seller':
    case 'brand':
    case 'lista':
    case 'seleccion':
    case 'vendedor':
    case 'marca':
      return 'plp';
    case 'product':
    case 'articulo':
      return 'pdp';
    case 'page':
      return 'page';
    case 'myaccount':
      return 'myAccount';
    case 'myorders':
      return 'myOrders';
    default:
      {
        var pageHome = getPageTitle(href);
        return "".concat(pageHome, " home");
      }
  }
};
var getPageName = function getPageName() {
  var href = window.location.href;
  var page = getPage(href);
  var pageName = pageNameMapping(page, href);
  return pageName;
};
var SODIMAC_STANDALONE_DOMAIN_NAME = {
  pe: '.sodimac.com.pe',
  cl: '.sodimac.cl'
};
var TOTTUS_STANDALONE_DOMAIN_NAME = {
  pe: '.tottus.com.pe',
  cl: '.tottus.cl'
};
var MARKETPLACE_DOMAIN_NAME = {
  cl: '.falabella.com',
  pe: '.falabella.com.pe',
  co: '.falabella.com.co'
};
var getEcommerceName = function getEcommerceName(store, tenant) {
  var standaloneSite = getStandaloneSite(store);
  if (standaloneSite.isSodimacStandalone) {
    return "marketplacesodimac-".concat(tenant);
  }
  if (standaloneSite.isTottusStandalone) {
    return "marketplacetottus-".concat(tenant);
  }
  if (standaloneSite.isWhitelabelSite && STORE_MAP[tenant] && STORE_MAP[tenant][store]) {
    return "".concat(STORE_MAP[tenant][store], "-").concat(tenant);
  }
  return "marketplace-".concat(tenant);
};
var getWhitelabelSiteDomainName = function getWhitelabelSiteDomainName(tenant, store) {
  var siteName = STORE_MAP[tenant] ? STORE_MAP[tenant][store] : 'default';
  var region = tenant === 'cl' ? '.cl' : ".com.".concat(tenant);
  var domainName = siteName === 'default' ? MARKETPLACE_DOMAIN_NAME[tenant] : ".".concat(siteName).concat(region);
  return {
    siteName: siteName,
    domainName: domainName
  };
};
var generateWhiteLabelProps = function generateWhiteLabelProps(store, tenant) {
  var props = {
    enabled: true,
    siteName: 'default',
    ecommName: getEcommerceName(store, tenant),
    domainName: MARKETPLACE_DOMAIN_NAME[tenant],
    multiSite: true
  };
  var standaloneSite = getStandaloneSite(store);
  if (standaloneSite.isSodimacStandalone) {
    props.siteName = 'sodimac';
    props.domainName = SODIMAC_STANDALONE_DOMAIN_NAME[tenant];
    return props;
  }
  if (standaloneSite.isTottusStandalone) {
    props.siteName = 'tottus';
    props.domainName = TOTTUS_STANDALONE_DOMAIN_NAME[tenant];
    return props;
  }
  if (standaloneSite.isWhitelabelSite) {
    var _getWhitelabelSiteDom = getWhitelabelSiteDomainName(tenant, store),
      siteName = _getWhitelabelSiteDom.siteName,
      domainName = _getWhitelabelSiteDom.domainName;
    props.siteName = siteName;
    props.domainName = domainName;
    props.multiSite = false;
    return props;
  }
  return props;
};
var buildBaseUrlBetaEnv = function buildBaseUrlBetaEnv(baseHostUrl) {
  var env = getEnvironment();
  if (env === 'beta') {
    var _window$location$host3 = window.location.hostname.split('.'),
      _window$location$host4 = _slicedToArray(_window$location$host3, 2),
      hostname1 = _window$location$host4[0],
      hostname2 = _window$location$host4[1];
    return baseHostUrl.replace(/\/\/(.*?\.)?(sodimac|falabella)\.(cl|com(\.pe|\.co)?)/, "//".concat(hostname1, ".$2.$3"));
  }
  return baseHostUrl;
};
var isCurrentUrlSodimacStandAlone = function isCurrentUrlSodimacStandAlone() {
  if (isClientSide()) {
    var sodimacRegex = /https?:\/\/(?:[^.]+\.)?sodimac\.(cl|com\.pe)/;
    return sodimacRegex.test(window.location.origin);
  }
  return false;
};
var isCurrentUrlTottusStandAlone = function isCurrentUrlTottusStandAlone() {
  if (isClientSide()) {
    var tottusRegex = /https?:\/\/(?:[^.]+\.)?tottus\.(cl|com\.pe)/;
    return tottusRegex.test(window.location.origin);
  }
  return false;
};
var addMetaTag = function addMetaTag(property, content) {
  var head = document.getElementsByTagName('head')[0];
  var metaElement = document.createElement('meta');
  metaElement.setAttribute('property', property);
  metaElement.setAttribute('content', content);
  head.insertBefore(metaElement, head.firstChild);
};
var generateMetaTagsAPP = function generateMetaTagsAPP(isSodimacStandAlone, isTottusStandAloneSite) {
  var metaTags;
  if (isSodimacStandAlone) metaTags = metaTagsApp.SO_COM;else if (isTottusStandAloneSite) metaTags = metaTagsApp.TO_COM;else metaTags = metaTagsApp.FALABELLA;
  addMetaTag('al:web:url', window.location.href);
  metaTags.map(function (meta) {
    return addMetaTag(meta.property, meta.content);
  });
};
var getStoreName = function getStoreName() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var storeName = matchStoreName(text);
  if (isWhitelabel(text)) {
    return text;
  }
  if (storeName) {
    return storeName;
  }
  return STORE_MAP.MARKETPLACE;
};
var getTottusAddress = function getTottusAddress(address) {
  var _address$landmark;
  var isTottusStandAlone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!isTottusStandAlone) {
    return address.comuna;
  }
  var fields = ['landmark', 'addressLine1', 'addressLine2', 'comuna', 'region'];
  address.landmark = (_address$landmark = address.landmark) !== null && _address$landmark !== void 0 ? _address$landmark : address.departmentNumber;
  return fields.map(function (a, i) {
    var indent = i !== 0 ? ' ' : '';
    if (!address[a] || address[a] === 'undefined') return;
    var value = capitalizeWord(address[a]);
    return "".concat(indent).concat(value.replaceAll('#', '*'));
  }).filter(Boolean).join(',');
};
var getHeaderHeight = function getHeaderHeight(_ref4) {
  var isVendorLoggedIn = _ref4.isVendorLoggedIn,
    isAgentLoggedIn = _ref4.isAgentLoggedIn;
  var result = {
    totalVisibleHeight: 0,
    sisHeaderHeight: 0,
    searchHeaderHeight: 0,
    ternaryNavBarHeight: 0,
    transversalBannerHeight: 0,
    vendorHeaderHeight: 0,
    agentHeaderHeight: 0,
    crossBannerHeight: 0
  };
  if (!isClientSide()) {
    return result;
  }
  var agentHeader = document.getElementById('guided-selling-header-agent');
  result.agentHeaderHeight = agentHeader ? agentHeader.offsetHeight : 0;
  if (isAgentLoggedIn && result.agentHeaderHeight > 0 && isElementInViewport(agentHeader)) {
    result.totalVisibleHeight += result.agentHeaderHeight;
  }
  var vendorHeader = document.getElementById('guided-selling-header-vendor');
  result.vendorHeaderHeight = vendorHeader ? vendorHeader.offsetHeight : 0;
  if (isVendorLoggedIn && result.vendorHeaderHeight > 0 && isElementInViewport(vendorHeader)) {
    result.totalVisibleHeight += result.vendorHeaderHeight;
  }
  var searchHeader = document.getElementById('scrollable-content');
  result.searchHeaderHeight = searchHeader ? searchHeader.offsetHeight : 0;
  if (result.searchHeaderHeight > 0 && isElementInViewport(searchHeader)) {
    result.totalVisibleHeight += result.searchHeaderHeight;
  }
  var ternaryNavBar = document.getElementById('bottom-header');
  result.ternaryNavBarHeight = isElementInViewport(ternaryNavBar) ? ternaryNavBar.offsetHeight : 0;
  if (result.ternaryNavBarHeight > 0 && isElementInViewport(ternaryNavBar)) {
    result.totalVisibleHeight += result.ternaryNavBarHeight;
  }
  var sisHeader = document.getElementById('header-sis-links');
  result.sisHeaderHeight = sisHeader ? sisHeader.offsetHeight : 0;
  if (result.sisHeaderHeight > 0 && isElementInViewport(sisHeader)) {
    result.totalVisibleHeight += result.sisHeaderHeight;
  }
  var transversalBanner = document.getElementById('testId-transversalBanner');
  result.transversalBannerHeight = transversalBanner ? transversalBanner.offsetHeight : 0;
  if (result.transversalBannerHeight > 0 && isElementInViewport(transversalBanner)) {
    result.totalVisibleHeight += result.transversalBannerHeight;
  }
  var crossBanner = document.getElementById('cross-banner');
  result.crossBannerHeight = crossBanner ? crossBanner.offsetHeight : 0;
  if (result.crossBannerHeight > 0 && isElementInViewport(crossBanner)) {
    result.totalVisibleHeight += result.crossBannerHeight;
  }
  return result;
};
var getCategoryColor = function getCategoryColor(defaultCategoryColor, itemColor) {
  return itemColor || defaultCategoryColor;
};

var getDigitalDataFromStorage = function getDigitalDataFromStorage() {
  try {
    var data = JSON.parse(WebStorage.getItem({
      name: analyticsInfo.DIGITAL_DATA_STORAGE_NAME,
      fromPersistence: true
    }));
    return data;
  } catch (err) {
    return defaultAnalyticsResponse;
  }
};
var saveDigitalData = function saveDigitalData(digitalData) {
  WebStorage.setItem({
    name: analyticsInfo.DIGITAL_DATA_STORAGE_NAME,
    shouldPersist: true,
    value: JSON.stringify(digitalData)
  });
};
var saveTypeaheadMetrics = function saveTypeaheadMetrics(value) {
  set(window, 'digitalData.tag.XLP.busqueda_TA', value);
  var lsDigitalData = getDigitalDataFromStorage();
  var modifiedDigitalData = merge$1(lsDigitalData, {
    tag: {
      XLP: {
        busqueda_TA: value
      }
    }
  });
  saveDigitalData(modifiedDigitalData);
};
var saveDigitalDataCookies = function saveDigitalDataCookies() {
  var tagName = CookieStorage.getTagFromCookie();
  var _ref = tagName ? DIGITALDATA_TAGS[tagName] : {},
    _ref$NESTED = _ref.NESTED,
    NESTED = _ref$NESTED === void 0 ? '' : _ref$NESTED;
  var navigationTagData = tagName && CookieStorage.parseCookieValue(tagName, CookieStorage.getCookie(tagName));
  if (navigationTagData) {
    var countryCode = getCountry().toLowerCase();
    var domain = CookieStorage.getHost(countryCode);
    CookieStorage.removeCookieByDomain({
      name: tagName,
      domain: domain
    });
    var lsDigitalData = getDigitalDataFromStorage();
    var modifiedDigitalData = merge$1(lsDigitalData, navigationTagData);
    saveDigitalData(modifiedDigitalData);
    window.digitalData = merge$1(window.digitalData, modifiedDigitalData);
  } else {
    var _lsDigitalData = getDigitalDataFromStorage();
    if (get(_lsDigitalData, NESTED)) {
      unset(_lsDigitalData, NESTED);
      saveDigitalData(_lsDigitalData);
      window.digitalData = _objectSpread2({}, window.digitalData, {}, _lsDigitalData);
    }
  }
};
var updateDigitalDataCookies = function updateDigitalDataCookies(_ref2) {
  var _ref2$firstLevelItem = _ref2.firstLevelItem,
    firstLevelItem = _ref2$firstLevelItem === void 0 ? '' : _ref2$firstLevelItem,
    _ref2$secondLevelItem = _ref2.secondLevelItem,
    secondLevelItem = _ref2$secondLevelItem === void 0 ? '' : _ref2$secondLevelItem,
    _ref2$thirdLevelItem = _ref2.thirdLevelItem,
    thirdLevelItem = _ref2$thirdLevelItem === void 0 ? '' : _ref2$thirdLevelItem,
    _ref2$postionOne = _ref2.postionOne,
    postionOne = _ref2$postionOne === void 0 ? '' : _ref2$postionOne,
    _ref2$postionTwo = _ref2.postionTwo,
    postionTwo = _ref2$postionTwo === void 0 ? '' : _ref2$postionTwo,
    _ref2$postionThree = _ref2.postionThree,
    postionThree = _ref2$postionThree === void 0 ? '' : _ref2$postionThree,
    _ref2$tag = _ref2.tag,
    tag = _ref2$tag === void 0 ? '' : _ref2$tag,
    _ref2$dataWrapper = _ref2.dataWrapper,
    dataWrapper = _ref2$dataWrapper === void 0 ? '' : _ref2$dataWrapper;
  var existingTag = CookieStorage.getTagFromCookie();
  var countryCode = getCountry().toLowerCase();
  if (existingTag) {
    var domain = CookieStorage.getHost(countryCode);
    CookieStorage.removeCookieByDomain({
      name: existingTag,
      domain: domain
    });
  }
  var _get = get(DIGITALDATA_TAGS, tag, {}),
    _get$NESTED = _get.NESTED,
    NESTED = _get$NESTED === void 0 ? '' : _get$NESTED,
    _get$PREFIX = _get.PREFIX,
    PREFIX = _get$PREFIX === void 0 ? '' : _get$PREFIX;
  if (NESTED) {
    var tagObject = set({}, NESTED, [PREFIX + dataWrapper, firstLevelItem, secondLevelItem, thirdLevelItem, postionOne, postionTwo, postionThree].filter(function (e) {
      return e !== '';
    }).join('|'));
    CookieStorage.setCookie({
      name: tag,
      value: tagObject,
      regionCode: countryCode
    });
  }
};
var updateDigitalData = function updateDigitalData() {
  var update = get(window, 'digitalData.methods.update', noop);
  update();
};
var initDigitalData = function () {
  var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
    var initialize;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          initialize = get(window, 'digitalData.methods.init', noop);
          _context.next = 3;
          return initialize();
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function initDigitalData() {
    return _ref3.apply(this, arguments);
  };
}();
var sendSatelliteTrackEvent = function () {
  var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(eventName, payload) {
    var sendSateliteTrack;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          sendSateliteTrack = get(window, 'digitalData.methods.sateliteTrack', noop);
          _context2.next = 3;
          return sendSateliteTrack(eventName, payload);
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function sendSatelliteTrackEvent(_x, _x2) {
    return _ref4.apply(this, arguments);
  };
}();

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);
  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }
  tag.appendChild(document.createTextNode(''));
  return tag;
}
var StyleSheet =
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }
  var _proto = StyleSheet.prototype;
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);
      var before;
      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }
      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64;
        sheet.insertRule(rule,
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet;
}();

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f += e.charAt(l);
          }
          g = 59;
        }
        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;
            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;
                case 125:
                  k--;
                  break;
                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }
                          }
                        }
                        l = u;
                      }
                  }
                  break;
                case 91:
                  g++;
                case 40:
                  g++;
                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }
              }
              if (0 === k) break;
              l++;
            }
            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);
                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;
                  default:
                    r = O;
                }
                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);
                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;
                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;
                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;
              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }
            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;
          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;
              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }
              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }
      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;
        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }
        default:
          z++;
          y = e.charAt(l);
          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;
                default:
                  32 !== g && (y = ' ');
              }
              break;
            case 0:
              y = '\\0';
              break;
            case 12:
              y = '\\f';
              break;
            case 11:
              y = '\\v';
              break;
            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;
            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                case 8:
                  111 === K && (E = K);
              }
              break;
            case 58:
              0 === n + b + m && (u = l);
              break;
            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;
            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;
            case 91:
              0 === n + b + v && m++;
              break;
            case 93:
              0 === n + b + v && m--;
              break;
            case 41:
              0 === n + b + m && v--;
              break;
            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;
                  default:
                    q = 1;
                }
                v++;
              }
              break;
            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;
                    case 220:
                      t = l, b = 42;
                  }
                  break;
                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }
          0 === b && (f += y);
      }
      K = x;
      x = g;
      l++;
    }
    t = p.length;
    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';
      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);
        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;
          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }
        E = 0;
      }
    }
    return G + p + F;
  }
  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;
    switch (m) {
      case 0:
      case 1:
        var b = 0;
        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }
        break;
      default:
        var v = b = 0;
        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }
    }
    return c;
  }
  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));
    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());
      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());
      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }
    return d + c;
  }
  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;
    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }
    if (0 === w || 2 === w && !L(a, 1)) return a;
    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
      case 1009:
        if (100 !== a.charCodeAt(4)) break;
      case 969:
      case 942:
        return '-webkit-' + a + a;
      case 978:
        return '-webkit-' + a + '-moz-' + a + a;
      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;
      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;
      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;
      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;
        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;
          case 232:
            b = a.replace(G, 'tb-rl');
            break;
          case 220:
            b = a.replace(G, 'lr');
            break;
          default:
            return a;
        }
        return '-webkit-' + a + '-ms-' + b + a;
      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;
      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;
          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;
          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }
        return a + ';';
      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;
      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;
      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }
    return a;
  }
  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }
  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }
  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          x = w;
      }
    }
    if (x !== c) return x;
  }
  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;
      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }
    return T;
  }
  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }
  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];
    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }
    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }
  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      return cache.get(arg);
    }
    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var delimiter = '/*|*/';
var needle = delimiter + '}';
function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}
var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              Sheet.current.insert(content + ';');
              return '';
            }
          case 108:
            {
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }
        break;
      }
    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    case 3:
      {
        switch (ns) {
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }
          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }
    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};
var removeLabel = function removeLabel(context, content) {
  if (context === 1 &&
  content.charCodeAt(0) === 108 &&
  content.charCodeAt(2) === 98
  ) {
      return '';
    }
};
var isBrowser = typeof document !== 'undefined';
var rootServerStylisCache = {};
var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  var getCache = weakMemoize(function () {
    return {};
  });
  var prefixTrueCache = {};
  var prefixFalseCache = {};
  return function (prefix) {
    if (prefix === undefined || prefix === true) {
      return prefixTrueCache;
    }
    if (prefix === false) {
      return prefixFalseCache;
    }
    return getCache(prefix);
  };
});
var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;
  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }
  var stylis = new stylis_min(stylisOptions);
  var inserted = {};
  var container;
  if (isBrowser) {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key);
      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });
      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }
  var _insert;
  if (isBrowser) {
    stylis.use(options.stylisPlugins)(ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;
      stylis(selector, serialized.styles);
      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  } else {
    stylis.use(removeLabel);
    var serverStylisCache = rootServerStylisCache;
    if (options.stylisPlugins || options.prefix !== undefined) {
      stylis.use(options.stylisPlugins);
      serverStylisCache = getServerStylisCache(options.stylisPlugins || rootServerStylisCache)(options.prefix);
    }
    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;
      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = stylis(selector, serialized.styles);
      }
      return serverStylisCache[name];
    };
    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);
      if (cache.compat === undefined) {
        if (shouldCache) {
          cache.inserted[name] = true;
        }
        return rules;
      } else {
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }
  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if (
  (isStringTag === false ||
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;
    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }
      current = current.next;
    } while (current !== undefined);
    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

function murmur2(str) {
  var h = 0;
  var k,
      i = 0,
      len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    k >>> 24;
    h =
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  }
  h ^= h >>> 13;
  h =
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};
var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }
  return value;
};
function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }
  if (interpolation.__emotion_styles !== undefined) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }
    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }
        if (interpolation.styles !== undefined) {
          var next = interpolation.next;
          if (next !== undefined) {
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }
          var styles = interpolation.styles + ";";
          return styles;
        }
        return createStringFromObject(mergedProps, registered, interpolation);
      }
    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        }
        break;
      }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = '';
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }
        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);
          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }
            default:
              {
                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }
  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];
  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    styles += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
    if (stringMode) {
      styles += strings[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match;
  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' +
    match[1];
  }
  var name = murmur2(styles) + identifierName;
  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var isBrowser$2 = typeof document !== 'undefined';
var hasOwnProperty = Object.prototype.hasOwnProperty;
var EmotionCacheContext = createContext(
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext = createContext({});
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  };
  return forwardRef(render);
};
if (!isBrowser$2) {
  var BasicProvider = function (_React$Component) {
    _inheritsLoose(BasicProvider, _React$Component);
    function BasicProvider(props, context, updater) {
      var _this;
      _this = _React$Component.call(this, props, context, updater) || this;
      _this.state = {
        value: createCache()
      };
      return _this;
    }
    var _proto = BasicProvider.prototype;
    _proto.render = function render() {
      return createElement(EmotionCacheContext.Provider, this.state, this.props.children(this.state.value));
    };
    return BasicProvider;
  }(Component);
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      return createElement(EmotionCacheContext.Consumer, null, function (context) {
        if (context === null) {
          return createElement(BasicProvider, null, function (newContext) {
            return func(props, newContext);
          });
        } else {
          return func(props, context);
        }
      });
    };
  };
}
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }
  newProps[typePropName] = type;
  return newProps;
};
var Noop = function Noop() {
  return null;
};
var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme);
  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }
  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';
  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles);
  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ("production" === 'production' )) {
      newProps[key] = props[key];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  var ele = createElement(type, newProps);
  var possiblyStyleElement = createElement(Noop, null);
  if (!isBrowser$2 && rules !== undefined) {
    var _ref;
    var serializedNames = serialized.name;
    var next = serialized.next;
    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }
    possiblyStyleElement = createElement("style", (_ref = {}, _ref["data-emotion-" + cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  }
  return createElement(Fragment, null, possiblyStyleElement, ele);
};
var Emotion = withEmotionCache(function (props, cache, ref) {
  if (typeof props.css === 'function') {
    return createElement(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }
  return render(cache, props, null, ref);
});

var jsx = function jsx(type, props) {
  var args = arguments;
  if (props == null || !hasOwnProperty.call(props, 'css')) {
    return createElement.apply(undefined, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  createElementArgArray[1] = createEmotionProps(type, props);
  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }
  return createElement.apply(null, createElementArgArray);
};
var Global = withEmotionCache(function (props, cache) {
  var styles = props.styles;
  if (typeof styles === 'function') {
    return createElement(ThemeContext.Consumer, null, function (theme) {
      var serialized = serializeStyles([styles(theme)]);
      return createElement(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }
  var serialized = serializeStyles([styles]);
  return createElement(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});
var InnerGlobal = function (_React$Component) {
  _inheritsLoose(InnerGlobal, _React$Component);
  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }
  var _proto = InnerGlobal.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new StyleSheet({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    });
    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
    if (node !== null) {
      this.sheet.tags.push(node);
    }
    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }
    this.insertStyles();
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };
  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      insertStyles(this.props.cache, this.props.serialized.next, true);
    }
    if (this.sheet.tags.length) {
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }
    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };
  _proto.render = function render() {
    if (!isBrowser$2) {
      var serialized = this.props.serialized;
      var serializedNames = serialized.name;
      var serializedStyles = serialized.styles;
      var next = serialized.next;
      while (next !== undefined) {
        serializedNames += ' ' + next.name;
        serializedStyles += next.styles;
        next = next.next;
      }
      var shouldCache = this.props.cache.compat === true;
      var rules = this.props.cache.insert("", {
        name: serializedNames,
        styles: serializedStyles
      }, this.sheet, shouldCache);
      if (!shouldCache) {
        var _ref;
        return createElement("style", (_ref = {}, _ref["data-emotion-" + this.props.cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
          __html: rules
        }, _ref.nonce = this.props.cache.sheet.nonce, _ref));
      }
    }
    return null;
  };
  return InnerGlobal;
}(Component);
var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';
  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case 'boolean':
        break;
      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';
            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }
          break;
        }
      default:
        {
          toAdd = arg;
        }
    }
    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }
  return cls;
};
function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css(registeredStyles);
}
var Noop$1 = function Noop() {
  return null;
};
var ClassNames = withEmotionCache(function (props, context) {
  return createElement(ThemeContext.Consumer, null, function (theme) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;
    var css = function css() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('css can only be used during render');
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var serialized = serializeStyles(args, context.registered);
      if (isBrowser$2) {
        insertStyles(context, serialized, false);
      } else {
        var res = insertStyles(context, serialized, false);
        if (res !== undefined) {
          rules += res;
        }
      }
      if (!isBrowser$2) {
        serializedHashes += " " + serialized.name;
      }
      return context.key + "-" + serialized.name;
    };
    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('cx can only be used during render');
      }
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return merge(context.registered, css, classnames(args));
    };
    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;
    var possiblyStyleElement = createElement(Noop$1, null);
    if (!isBrowser$2 && rules.length !== 0) {
      var _ref;
      possiblyStyleElement = createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = context.sheet.nonce, _ref));
    }
    return createElement(Fragment, null, possiblyStyleElement, ele);
  });
});

var FooterList = function FooterList(_ref) {
  var listTitle = _ref.listTitle,
    items = _ref.items,
    itemIndex = _ref.index,
    deviceType = _ref.deviceType,
    platform = _ref.platform,
    isRebrandingEnabled = _ref.isRebrandingEnabled,
    textColor = _ref.textColor;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var ulRef = useRef(null);
  var indexByDevice = 0;
  var toggleIsOpen = function toggleIsOpen() {
    if (ulRef) {
      var minimizeClass = isRebrandingEnabled ? styles.minimizeUlRebranded : styles.minimizeUl;
      var expandClass = isRebrandingEnabled ? styles.expandUlRebranded : styles.expandUl;
      if (isOpen) {
        ulRef.current.classList.remove(expandClass);
        ulRef.current.classList.add(minimizeClass);
        setIsOpen(false);
      }
      if (!isOpen) {
        ulRef.current.classList.remove(minimizeClass);
        ulRef.current.classList.add(expandClass);
        setIsOpen(true);
      }
    }
  };
  var itemTextColor = textColor ? {
    color: textColor
  } : {};
  var titleLineStyles = textColor ? {
    backgroundColor: textColor,
    border: "1px solid ".concat(textColor)
  } : {};
  return jsx("nav", {
    className: isRebrandingEnabled ? "".concat(styles.footerList, " ").concat(styles.rebranding) : styles.footerList,
    id: "footer-top-column-".concat(itemIndex + 2, "-FooterList")
  }, jsx("input", {
    type: "checkbox",
    onClick: toggleIsOpen
  }), jsx("div", {
    className: styles.titleContainer
  }, jsx("h3", {
    style: itemTextColor
  }, listTitle), jsx("div", {
    className: styles.titleButtonContainer
  }, jsx("div", {
    className: styles.titleLine,
    style: titleLineStyles
  }), jsx("div", {
    className: styles.titleLine,
    style: titleLineStyles
  }))), jsx("ul", {
    ref: ulRef
  }, items.map(function (_ref2, index) {
    var url = _ref2.url,
      title = _ref2.title,
      image = _ref2.image,
      is_new_tab = _ref2.is_new_tab,
      icon_position = _ref2.icon_position,
      display_in = _ref2.display_in;
    if (!url) {
      return;
    }
    var shouldDisplay = function () {
      if (deviceType === deviceTypes.MOBILE && get(display_in, platform, false)) {
        return true;
      } else if (deviceType === deviceTypes.TABLET && get(display_in, "".concat(deviceType), false)) {
        return true;
      } else if (deviceType === deviceTypes.DESKTOP && get(display_in, "".concat(deviceType), false)) {
        return true;
      } else {
        return false;
      }
    }();
    if (!shouldDisplay) {
      return;
    }
    var imageUrl = image && image.url;
    var Image = function Image() {
      if (!imageUrl) {
        return;
      }
      return jsx("img", {
        className: styles['link-icon'],
        src: imageUrl,
        alt: title
      });
    };
    var Link = function Link(_ref3) {
      var children = _ref3.children;
      return jsx("a", {
        href: url,
        target: is_new_tab ? '_blank' : '_self',
        rel: "noopener noreferrer",
        style: itemTextColor
      }, children);
    };
    var iconPosition = icon_position ? icon_position.toLowerCase() : 'left';
    indexByDevice += 1;
    return imageUrl ? jsx("li", {
      id: "testId-footerList-".concat(listTitle.replace(/ /g, '-'), "-").concat(indexByDevice),
      key: title.replace(/ /g, '-'),
      "data-id": indexByDevice,
      onClick: function onClick(eventLink) {
        var currentIndex = eventLink.currentTarget.getAttribute('data-id');
        updateDigitalDataCookies({
          firstLevelItem: 'N1',
          secondLevelItem: itemIndex + 1,
          thirdLevelItem: currentIndex,
          postionOne: listTitle,
          postionTwo: title,
          postionThree: getPageName(),
          tag: FOOTER
        });
      }
    }, jsx(Link, null, iconPosition === 'left' ? jsx(Image, null) : jsx(React.Fragment, null), jsx("span", null, title), iconPosition === 'right' ? jsx(Image, null) : jsx(React.Fragment, null))) : jsx("li", {
      id: "testId-footerList-".concat(listTitle.replace(/ /g, '-'), "-").concat(indexByDevice),
      key: title.replace(/ /g, '-'),
      "data-id": indexByDevice,
      onClick: function onClick(eventLink) {
        var currentIndex = eventLink.currentTarget.getAttribute('data-id');
        updateDigitalDataCookies({
          firstLevelItem: 'N1',
          secondLevelItem: itemIndex + 1,
          thirdLevelItem: currentIndex,
          postionOne: listTitle,
          postionTwo: title,
          postionThree: getPageName(),
          tag: FOOTER
        });
      }
    }, jsx(Link, null, title));
  })));
};
FooterList.propTypes = process.env.NODE_ENV !== "production" ? {
  listTitle: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    is_new_tab: PropTypes.bool.isRequired,
    icon_position: PropTypes.string.isRequired,
    image: PropTypes.oneOfType([PropTypes.object, PropTypes.shape({
      filename: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      tag: PropTypes.arrayOf(PropTypes.string).isRequired,
      url: PropTypes.string.isRequired
    })]),
    display_in: PropTypes.shape({
      desktop: PropTypes.bool.isRequired,
      tablet: PropTypes.bool.isRequired,
      mobile_android: PropTypes.bool.isRequired,
      mobile_ios: PropTypes.bool.isRequired
    }).isRequired
  }).isRequired).isRequired,
  deviceType: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
  isRebrandingEnabled: PropTypes.bool.isRequired,
  textColor: PropTypes.string
} : {};

var styles$1 = {"rebranding":"SocialIcons-module_rebranding__3mwZd","icon":"SocialIcons-module_icon__2zAbQ","icon-facebook":"SocialIcons-module_icon-facebook__150yX","icon-twitter":"SocialIcons-module_icon-twitter__1HSaI","icon-instagram":"SocialIcons-module_icon-instagram__Oqgvr","icon-youtube":"SocialIcons-module_icon-youtube__2OWIu","socialIcons":"SocialIcons-module_socialIcons__2Fnye","icon-pinterest":"SocialIcons-module_icon-pinterest__3zTAg"};

var SocialIcons = function SocialIcons(_ref) {
  var icons = _ref.icons,
    isRebrandingEnabled = _ref.isRebrandingEnabled;
  return jsx("ul", {
    className: isRebrandingEnabled ? "".concat(styles$1.socialIcons, " ").concat(styles$1.rebranding) : styles$1.socialIcons,
    id: "footer-top-column-1-SocialIcons"
  }, icons.map(function (icon, index) {
    if (!icon.url) {
      return;
    }
    var socialMediaName = '';
    if (icon.url.includes('facebook')) {
      socialMediaName = 'facebook';
    } else if (icon.url.includes('instagram')) {
      socialMediaName = 'instagram';
    } else if (icon.url.includes('twitter')) {
      socialMediaName = 'twitter';
    } else if (icon.url.includes('youtube')) {
      socialMediaName = 'youtube';
    } else {
      return;
    }
    var iconBgColor = icon.icon_background_color || undefined;
    var iconHoverColor = icon.change_color_on_hover && icon.hover_color ? icon.hover_color : undefined;
    return jsx("li", {
      key: icon.url,
      id: "footer-top-column-1-SocialIcons"
    }, jsx("a", {
      href: icon.url,
      className: "".concat(styles$1.icon, "\n                ").concat(styles$1["icon-".concat(socialMediaName)]),
      target: icon.is_new_tab ? '_blank' : '_self',
      rel: "noreferrer noopener",
      onClick: function onClick() {
        updateDigitalDataCookies({
          firstLevelItem: 'N2',
          secondLevelItem: index + 1,
          thirdLevelItem: 'X',
          postionOne: "SI_".concat(capitalizeWord(socialMediaName)),
          postionTwo: 'X',
          postionThree: getPageName(),
          tag: FOOTER
        });
      },
      style: {
        '--icon-bg-color': iconBgColor,
        '--icon-hover-color': iconHoverColor
      }
    }, jsx("i", {
      className: styles$1["icon-".concat(socialMediaName)]
    })));
  }));
};
SocialIcons.propTypes = process.env.NODE_ENV !== "production" ? {
  icons: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
    is_new_tab: PropTypes.bool.isRequired,
    change_color_on_hover: PropTypes.bool.isRequired,
    hover_color: PropTypes.string.isRequired
  })).isRequired,
  isRebrandingEnabled: PropTypes.bool.isRequired
} : {};

var pattern = {
  ios: new RegExp(/iPad|iPhone|iPod/),
  android: new RegExp(/android/i),
  webview: new RegExp(/wv|Version\/4\.0|; wv/i)
};
var getPlatformType = function getPlatformType(userAgent) {
  if (pattern.ios.test(userAgent)) {
    return platforms.MOBILE.IOS;
  }
  if (pattern.android.test(userAgent)) {
    return platforms.MOBILE.ANDROID;
  }
  return 'unknown';
};
var isInWebView = function isInWebView() {
  var userAgent = window.navigator.userAgent || '';
  var isAndroidWebView = pattern.webview.test(userAgent);
  var isIOSWebView = pattern.ios.test(userAgent) && !/Safari/.test(userAgent);
  return isAndroidWebView || isIOSWebView;
};
var detectDeviceType = function detectDeviceType() {
  var userAgent = window.navigator.userAgent;
  var platform = getPlatformType(userAgent);
  if (isInWebView()) {
    return 'APP';
  }
  if (platform !== 'unknown') {
    return 'MOBILE';
  }
  return 'WEB';
};
var isWindow$2 = function isWindow() {
  return process.browser;
};
var compareViewPort = function compareViewPort(size) {
  return isWindow$2() && window.matchMedia && window.matchMedia("(max-width: ".concat(size, "px)")).matches;
};
var isMobile = function isMobile() {
  return compareViewPort('767');
};
var isIpadPotrait = function isIpadPotrait() {
  return compareViewPort('1024');
};

var onResize = function onResize(device, setDeviceType) {
  return function () {
    var newDeviceType = 'desktop';
    if (isMobile()) {
      newDeviceType = deviceTypes.MOBILE;
    } else if (isIpadPotrait()) {
      newDeviceType = deviceTypes.TABLET;
    } else {
      newDeviceType = deviceTypes.DESKTOP;
    }
    setDeviceType(newDeviceType);
  };
};
var attachResizeListener = function attachResizeListener(device, setDeviceType) {
  return function () {
    if (isWindow$2()) {
      onResize(device, setDeviceType)();
      window.onresize = onResize(device, setDeviceType);
      window.addEventListener('resize', onResize(device, setDeviceType));
    }
  };
};
function useDeviceContext(_ref) {
  var initialDeviceType = _ref.deviceType;
  var initDevice = initialDeviceType || deviceTypes.DESKTOP;
  var _useState = useState(initDevice),
    _useState2 = _slicedToArray(_useState, 2),
    deviceType = _useState2[0],
    setDeviceType = _useState2[1];
  return {
    deviceType: deviceType,
    setDeviceType: setDeviceType,
    attachResizeListener: attachResizeListener(deviceType, setDeviceType)
  };
}
var DeviceContext = createContainer(useDeviceContext);
var withDevice = function withDevice(WrappedComponent) {
  var getInitialProps = WrappedComponent.getInitialProps;
  var ComponentWithUser = function ComponentWithUser(props) {
    var deviceProps = useContext(DeviceContext.Context);
    return jsx(WrappedComponent, _extends({}, props, deviceProps));
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithUser.getInitialProps = getInitialProps;
  }
  return ComponentWithUser;
};

var entry = {
	compra_segura: [
		{
			tags: [
			],
			text: "<a href=\"https://www.falabella.com.ar/falabella-ar/page/Compra-100-segura?staticPageId=10200039\" target=\"_blank\"><img src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/bltaa8756ed2de224d0/5ebab239b5455801f1e0b3da/Norton.png\" alt=\"norton.png\" data-image=\"3smovebn8qco\">\n<strong>COMPRA 100% SEGURA</strong></a>\n\n<a href=\"http://qr.afip.gob.ar/?qr=O_jKcQ7qvy-FlkHq5zT2Yg,,\" target=\"_blank\"><img data-image=\"7qef523rlezr\" src=\"https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt06d98e082ba5dd9f/5f6d19e34a19ef4fa853fb14/Data-fiscal.jpg\" data-sys-asset-uid=\"blt06d98e082ba5dd9f\" alt=\"Data-fiscal.jpg\">\n<strong>DATA FISCAL</strong></a>",
			title: "NORTON COMPRA SEGURA FOOTER"
		}
	],
	derechos_reservados: [
		{
			tags: [
			],
			text: "<p><strong>© TODOS LOS DERECHOS RESERVADOS</strong><br>Falabella S.A. | Suipacha 1111 Piso 18, Ciudad Autónoma de Buenos Aires.<!--<br>Teléfono: 0810-333-7784.--></p>",
			title: "ESQUINA INFERIOR IZQUIERDA FOOTER"
		}
	],
	falabella_sostenible: [
	],
	footer_links: [
		{
			items: [
				{
					title: "Beneficios de comprar en Falabella.com",
					url: "https://www.falabella.com.ar/falabella-ar/page/Beneficios-de-Falabella?staticPageId=10200030",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Métodos y costos de envío",
					url: "https://www.falabella.com.ar/falabella-ar/page/Envio-a-domicilio?staticPageId=10200025",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Seguimiento de mi orden",
					url: "https://www.falabella.com.ar/falabella-ar/mi-cuenta/buscar-orden",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Cambios y devoluciones",
					url: "https://www.falabella.com.ar/falabella-ar/page/Politica-de-devolucion-cambios?staticPageId=10200016",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Términos y condiciones",
					url: "https://www.falabella.com.ar/falabella-ar/page/Terminos-y-condiciones?staticPageId=10200020",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Contratos de adhesión - Ley N° 24.240 de Defensa del Consumidor",
					url: "https://www.falabella.com.ar/falabella-ar/page/Contratos-de-adhesion?staticPageId=12900001",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Defensa de las y los Consumidores. Para reclamos. Ingrese aquí",
					url: "https://www.argentina.gob.ar/produccion/defensadelconsumidor/formulario",
					image: {
					},
					is_new_tab: false
				}
			],
			tags: [
			],
			title: "SERVICIO AL CLIENTE"
		},
		{
			items: [
				{
					title: "Nuestra empresa",
					url: "https://www.falabella.com.ar/falabella-ar/page/Nuestra-empresa?staticPageId=10300001",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Inversionistas",
					url: "https://investors.falabella.com/English/overview/default.aspx",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Venta Corporativa",
					url: "https://www.falabella.com.ar/falabella-ar/page/Gift-cards?staticPageId=13300001",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Trabajá con nosotros",
					url: "https://career4.successfactors.com/career?company=adessafalaP",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Programa JP/ Trainee y Pasantes",
					url: "https://www.grupociadetalentos.com/falabella/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Canal de Integridad",
					url: "https://canaldeintegridad.ines.cl/falabella/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Código de ética",
					url: "https://www.falabella.com.ar/static/staticContent/common/Codigo-de-etica/Codigo-de-etica-FalabellaArgentina.pdf",
					image: {
					},
					is_new_tab: false
				}
			],
			tags: [
			],
			title: "MAS FALABELLA"
		},
		{
			items: [
				{
					title: "CMR",
					url: "https://www.cmrfalabella.com/b2carpr/CMRCORP/logica/jsp/CMRCORPFFLogin.jsp?PAGINA=CMRLogOn&PAIS=AR",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Viajes Falabella",
					url: "http://www.viajesfalabella.com.ar/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Seguros Falabella",
					url: "https://web.segurosfalabella.com/ar/?utm_source=Footer&utm_medium=Falabella",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Sodimac",
					url: "https://www.sodimac.com.ar/sodimac-ar/",
					image: {
					},
					is_new_tab: true
				}
			],
			tags: [
			],
			title: "EMPRESAS FALABELLA"
		}
	],
	newsletter: [
		{
			tags: [
			],
			text: "<h3>SUSCRÍBETE A NUESTRO NEWSLETTER</h3>\n<p>Infórmate de lo último de Falabella. Nuestras ofertas y novedades directamente en tu e-mail.</p>",
			title: "TÍTULO NEWSLETTER FOOTER"
		}
	],
	social_icons: [
		{
			icons: [
				{
					title: "facebook",
					url: "https://www.facebook.com/FalabellaArgentina/"
				},
				{
					title: "twitter",
					url: "http://twitter.com/Falabella_ar"
				},
				{
					title: "instagram",
					url: "https://www.instagram.com/falabella_ar/"
				},
				{
					title: "pinterest",
					url: "https://ar.pinterest.com/falabellaarg/"
				},
				{
					title: "youtube",
					url: "https://www.youtube.com/user/FalabellaArgentina/"
				}
			],
			tags: [
			],
			title: "Iconos redes sociales footer"
		}
	],
	tags: [
	],
	title: "Footer FAAR"
};
var footerV2AR = {
	entry: entry
};

var entry$1 = {
	compra_segura: [
		{
			desktop: {
				text: "<p><a href=\"https://www.falabella.com/falabella-cl/category/cat20014/Compra-segura\" target=\"_blank\"><img src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/bltaa8756ed2de224d0/5ebab239b5455801f1e0b3da/Norton.png\" alt=\"norton.png\" data-image=\"3smovebn8qco\">\n<strong>COMPRA 100% SEGURA</strong></a></p>"
			},
			mobile: {
				text: "<p><a href=\"https://www.falabella.com/falabella-cl/category/cat20014/Compra-segura\" target=\"_blank\"><img src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/bltaa8756ed2de224d0/5ebab239b5455801f1e0b3da/Norton.png\" alt=\"norton.png\" data-image=\"3smovebn8qco\">\n<strong>COMPRA 100% SEGURA</strong></a></p>"
			},
			tags: [
				"norton",
				"compra segura",
				"footer"
			],
			text: "<p><a href=\"https://www.falabella.com/falabella-cl/category/cat20014/Compra-segura\" target=\"_blank\"><img src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/bltaa8756ed2de224d0/5ebab239b5455801f1e0b3da/Norton.png\" alt=\"norton.png\" data-image=\"3smovebn8qco\">\n<strong>COMPRA 100% SEGURA</strong></a></p>",
			title: "NORTON COMPRA SEGURA FOOTER"
		}
	],
	derechos_reservados: [
		{
			desktop: {
				text: "<p><strong>© TODOS LOS DERECHOS RESERVADOS</strong><br>Falabella Retail S. A. Manuel Rodrí­guez 730, Santiago de Chile.</p>"
			},
			mobile: {
				text: "<p><strong>© TODOS LOS DERECHOS RESERVADOS</strong><br>Falabella Retail S. A. Manuel Rodrí­guez 730, Santiago de Chile.</p>"
			},
			tags: [
				"derechos reservados",
				"direccion",
				"footer",
				"copyright"
			],
			text: "<strong>© TODOS LOS DERECHOS RESERVADOS</strong><br>Falabella Retail S. A. Manuel Rodrí­guez 730, Santiago de Chile.",
			title: "ESQUINA INFERIOR IZQUIERDA FOOTER"
		}
	],
	falabella_sostenible: [
		{
			desktop: {
				text: "<p><a target=\"_blank\" href=\"https://www.falabella.com/falabella-cl/page/Falabella-Sostenible?staticPageId=22500003\">\n<img alt=\"FalebellaSostenible.png\" data-sys-asset-uid=\"blt75c2d9666115f4ec\" src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/blt75c2d9666115f4ec/5eaff8f926a7212f2db1bfba/FalebellaSostenible.png\" data-image=\"7ylvycl9mm3i\">FALABELLA SOSTENIBLE</a></p>"
			},
			mobile: {
				text: "<p><a target=\"_blank\" href=\"https://www.falabella.com/falabella-cl/page/Falabella-Sostenible?staticPageId=22500003\">\n<img alt=\"FalebellaSostenible.png\" data-sys-asset-uid=\"blt75c2d9666115f4ec\" src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/blt75c2d9666115f4ec/5eaff8f926a7212f2db1bfba/FalebellaSostenible.png\" data-image=\"7ylvycl9mm3i\">FALABELLA SOSTENIBLE</a></p>"
			},
			tags: [
				"falabella sostenible",
				"footer"
			],
			text: "<p><a target=\"_blank\" href=\"https://www.falabella.com/falabella-cl/page/Falabella-Sostenible?staticPageId=22500003\">\n<img alt=\"FalebellaSostenible.png\" data-sys-asset-uid=\"blt75c2d9666115f4ec\" src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/blt75c2d9666115f4ec/5eaff8f926a7212f2db1bfba/FalebellaSostenible.png\" data-image=\"7ylvycl9mm3i\">FALABELLA SOSTENIBLE</a></p>",
			title: "FALABELLA SOSTENIBLE FOOTER"
		}
	],
	footer_links: [
		{
			items: [
				{
					title: "Contáctanos",
					url: "https://www.falabella.com/falabella-cl/page/contactanos?staticPageId=37900002&menu=contactanos&&sac",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "¿Por qué comprar en Falabella.com?",
					url: "https://www.falabella.com/falabella-cl/page/comprar-beneficios?staticPageId=37900003&menu=comprar&srv=c1",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Métodos y costos de envío",
					url: "https://www.falabella.com/falabella-cl/page/despachoretiro-domicilio?staticPageId=37900009&menu=despacho-retiro&srv=dr1",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Seguimiento de mi compra",
					url: "https://www.falabella.com/falabella-cl/mi-cuenta/buscar-orden?sid=webTrackingFooter",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Consultar por tus documentos electrónicos",
					url: "https://www.falabella.com/falabella-cl/page/postventa-copia-boleta-factura?staticPageId=40400016&menu=postventa&srv=p5",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Cambios y devoluciones",
					url: "https://www.falabella.com/falabella-cl/page/postventa-cambio-devoluciones?staticPageId=37900015&menu=postventa&srv=p1",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Términos y condiciones",
					url: "https://www.falabella.com/falabella-cl/page/comprar-terminos-condiciones?staticPageId=37900007&menu=comprar&srv=c5",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Política de privacidad",
					url: "https://www.falabella.com/falabella-cl/page/comprar-politica-privacidad?staticPageId=44100001&menu=comprar&srv=c7",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Política de cookies",
					url: "https://www.falabella.com/falabella-cl/page/comprar-politica-cookies?staticPageId=44100002&menu=comprar&srv=c8",
					image: {
					},
					is_new_tab: false
				}
			],
			tags: [
				"footer",
				"links",
				"servicio al cliente"
			],
			title: "SERVICIO AL CLIENTE"
		},
		{
			items: [
				{
					title: "¿Cómo vender en Falabella.com?",
					url: "https://www.falabella.com/falabella-cl/page/Vende-en-Falabella.com?mkid=LA_VI_VER_1000002626&staticPageId=42100010",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Nuestra empresa",
					url: "https://www.falabella.com/falabella-cl/category/cat40006/Nuestra-empresa",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Inversionistas",
					url: "https://investors.falabella.com/English/overview/default.aspx",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Proveedores",
					url: "https://www.falabella.com/falabella-cl/category/cat40007/Proveedores",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Fpay",
					url: "https://fpay.cl/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Venta empresa",
					url: "https://www.falabellaparaempresas.com/ventaemppr/public/inicio.do",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Trabaja con nosotros",
					url: "http://www.trabajos.falabella.cl/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Club Deco",
					url: "https://www.falabella.com/falabella-cl/static/staticContentMinisiteWithHeader.jsp?title=ClubDeco-Home",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Club Bebé",
					url: "https://www.celebracionesfalabella.com/bebe/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Novios Falabella",
					url: "https://www.noviosfalabella.com/noviosclpr/public/inicio.do",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Celebraciones",
					url: "https://www.celebracionesfalabella.com/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Canal de integridad",
					url: "https://canaldeintegridad.ines.cl/falabella",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Integrity Channel",
					url: "https://canaldeintegridad.ines.cl/falabella/eng/",
					image: {
					},
					is_new_tab: true
				}
			],
			tags: [
				"footer",
				"links",
				"más falabella"
			],
			title: "MÁS FALABELLA"
		},
		{
			items: [
				{
					title: "Falabella TV",
					url: "https://www.falabella.com/falabella-cl/category/cat9420008/Falabella-FTV",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "CMR Falabella",
					url: "https://www.bancofalabella.cl/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Banco Falabella",
					url: "https://www.bancofalabella.cl/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Viajes Falabella",
					url: "https://www.viajesfalabella.cl/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Seguros Falabella",
					url: "https://web.segurosfalabella.com/cl/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Sodimac",
					url: "https://www.sodimac.cl/sodimac-cl/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Fazil",
					url: "https://fazil-app.com/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Tottus",
					url: "https://www.tottus.cl/tottus/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Linio",
					url: "https://www.linio.cl/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Mallplaza",
					url: "https://www.mallplaza.cl/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Otras empresas Falabella",
					url: "https://www.falabella.com/falabella-cl/page/Indice-empresa?staticPageId=26400002",
					image: {
					},
					is_new_tab: false
				}
			],
			tags: [
				"footer",
				"empresas falabella",
				"links"
			],
			title: "EMPRESAS FALABELLA"
		}
	],
	newsletter: [
		{
			desktop: {
				text: "<h3><br></h3>\n<p></p>\n<p></p>"
			},
			mobile: {
				text: "<h3><br></h3>\n<p></p>\n<p></p>"
			},
			tags: [
				"newletter",
				"footer",
				"titulo"
			],
			text: "<p></p>\n<p></p>\n<p></p>\n<p></p>",
			title: "TÍTULO NEWSLETTER FOOTER"
		}
	],
	social_icons: [
		{
			icons: [
				{
					title: "facebook",
					url: "https://www.facebook.com/falabellachile"
				},
				{
					title: "twitter",
					url: "https://twitter.com/falabellaAyuda"
				},
				{
					title: "instagram",
					url: "https://www.instagram.com/falabella_cl"
				},
				{
					title: "youtube",
					url: "https://www.youtube.com/ComunidadFalabella"
				}
			],
			tags: [
				"redes sociales",
				"iconos",
				"twitter",
				"facebook",
				"instagram",
				"youtube",
				"footer"
			],
			title: "Iconos redes sociales"
		}
	],
	tags: [
	],
	title: "Footer FACL"
};
var footerV2CL = {
	entry: entry$1
};

var entry$2 = {
	compra_segura: [
		{
			tags: [
			],
			text: "<a href=\"\"><img src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/bltaa8756ed2de224d0/5ebab239b5455801f1e0b3da/Norton.png\" alt=\"norton.png\" data-image=\"3smovebn8qco\">\n<strong>COMPRA 100% SEGURA</strong></a>",
			title: "NORTON COMPRA SEGURA FOOTER"
		}
	],
	derechos_reservados: [
		{
			tags: [
			],
			text: "<p><strong>© TODOS LOS DERECHOS RESERVADOS<br></strong>Falabella de Colombia S.A. Calle 99 11A-32 Bogotá Colombia NIT: 900.017.447-8 Teléfono: Bogotá 5878002<br><a href=\"mailto:servicioalcliente@falabella.com.co\">Mail: servicioalcliente@falabella.com.co</a></p>",
			title: "ESQUINA INFERIOR IZQUIERDA FOOTER"
		}
	],
	falabella_sostenible: [
		{
			tags: [
			],
			text: "<h4><a>\n<img alt=\"FalebellaSostenible.png\" data-sys-asset-uid=\"blt75c2d9666115f4ec\" src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/blt75c2d9666115f4ec/5eaff8f926a7212f2db1bfba/FalebellaSostenible.png\" data-image=\"7ylvycl9mm3i\">FALABELLA SUSTENTABLE</a></h4>",
			title: "FALABELLA SUSTENTABLE FOOTER"
		}
	],
	footer_links: [
		{
			items: [
				{
					title: "Nuestra empresa",
					url: "https://www.falabella.com.co/falabella-co/page/Quienes-somos?staticPageId=16600002",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Proveedores",
					url: "https://www.falabella.com.co/falabella-co/page/mas-falabella?staticPageId=13000001#falabella-proveedores",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Ventas empresa",
					url: "https://www.falabella.com.co/falabella-co/page/mas-falabella?staticPageId=13000001#falabella-venta-empresa",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Inversionistas",
					url: "http://www.falabella.com/falabella-cl/static/staticContentMinisiteWithHeader.jsp?title=Inversionistas-Home",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Canal de integridad",
					url: "https://canaldeintegridad.ines.cl/falabella/",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Club Deco",
					url: "https://www.falabella.com.co/falabella-co/page/club-20deco?staticPageId=27800001",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Club Novios",
					url: "https://www.noviosfalabella.com.co/novios-co/public/inicio.do",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Club Bebés",
					url: "https://www.falabella.com.co/falabella-co/page/club-20bebes?staticPageId=27800002",
					image: {
					},
					is_new_tab: false
				}
			],
			tags: [
			],
			title: "MÁS FALABELLA"
		},
		{
			items: [
				{
					title: "Mi Cuenta",
					url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002#mi-cuenta",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Seguimiento de mi orden",
					url: "https://www.falabella.com.co/falabella-co/mi-cuenta/buscar-orden",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Nuestras Tiendas",
					url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002#nuestras-tiendas",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Medios de Pago",
					url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002#medios-pago",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Métodos de entrega",
					url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002#metodos-entrega",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Nuestros productos",
					url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002#nuestros-productos",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Preguntas Frecuentes",
					url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002#preguntas-frecuentes",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Términos y condiciones",
					url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002#terminos-condiciones",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Política de tratamiento de datos personales",
					url: "https://www.falabella.com.co/falabella-co/category/cat4840961/Politica-de-tratamiento-de-datos-personales",
					image: {
					},
					is_new_tab: false
				},
				{
					title: ".",
					url: "https://www.sic.gov.co/",
					image: {
						parent_uid: "bltbbfd5e44de659e94",
						filename: "Industria-y-comercio.png",
						title: "Industria-y-comercio.png",
						is_dir: false,
						tags: [
						],
						url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/bltcf341dd4dcc832bc/5f93268c545bdb56ce48fc30/Industria-y-comercio.png"
					},
					is_new_tab: true
				},
				{
					title: "Derecho de Retracto",
					url: "https://www.falabella.com.co/falabella-co/page/Derecho_de_retracto?staticPageId=9300001",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Comunicaciones Falabella",
					url: "https://www.falabella.com.co/falabella-co/page/comunicaciones-falabella?staticPageId=10000001",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Cambios y devoluciones",
					url: "https://www.falabella.com.co/falabella-co/page/Cambios-y-Devoluciones?staticPageId=20200002",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Reversión del pago",
					url: "https://www.falabella.com.co/falabella-co/page/Reversion-del-Pago?staticPageId=23000003",
					image: {
					},
					is_new_tab: false
				}
			],
			tags: [
			],
			title: "SERVICIO AL CLIENTE"
		},
		{
			items: [
				{
					title: "Banco Falabella",
					url: "http://www.bancofalabella.com.co/",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Seguros Falabella",
					url: "http://www.segurosfalabella.com.co/web/seguroscolombia/home",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Sodimac",
					url: "https://www.homecenter.com.co/homecenter-co/",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Linio",
					url: "https://www.linio.com.co/",
					image: {
					},
					is_new_tab: false
				}
			],
			tags: [
			],
			title: "EMPRESAS FALABELLA"
		}
	],
	newsletter: [
		{
			title: "Título Newsletter footer",
			text: "<h3>SUSCRÍBETE A NUESTRO NEWSLETTER</h3>\n<p>Infórmate de lo último de Falabella. Nuestras ofertas y novedades directamente en tu e-mail.</p>\n<p><a style=\"color: #add500;\" href=\"https://www.falabella.com.co/falabella-co/page/registros_2018?staticPageId=7100001\" class=\"link_form\"><u>Suscríbete y entérate primero de los mejores <br>productos y ofertas</u></a></p>",
			tags: [
			]
		}
	],
	social_icons: [
		{
			icons: [
				{
					title: "facebook",
					url: "https://www.facebook.com/FalabellaColombia/"
				},
				{
					title: "twitter",
					url: "https://twitter.com/Falabella_co"
				},
				{
					title: "instagram",
					url: "https://www.instagram.com/falabella_co/"
				}
			],
			tags: [
			],
			title: "Iconos redes sociales footer"
		}
	],
	tags: [
	],
	title: "Footer FACO"
};
var footerV2CO = {
	entry: entry$2
};

var entry$3 = {
	compra_segura: [
		{
			title: "NORTON COMPRA SEGURA FOOTER",
			text: "<p><a href=\"https://www.falabella.com.pe/falabella-pe/static/staticContent1.jsp?active=5&id=cat50618\" target=\"_blank\"><img src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/bltaa8756ed2de224d0/5ebab239b5455801f1e0b3da/Norton.png\" alt=\"norton.png\" data-image=\"3smovebn8qco\">\n<strong>COMPRA 100% SEGURA</strong></a></p>",
			tags: [
			],
			desktop: {
				text: "<p><a href=\"https://www.falabella.com.pe/falabella-pe/static/staticContent1.jsp?active=5&id=cat50618\" target=\"_blank\"><img src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/bltaa8756ed2de224d0/5ebab239b5455801f1e0b3da/Norton.png\" alt=\"norton.png\" data-image=\"3smovebn8qco\">\n<strong>COMPRA 100% SEGURA</strong></a></p>"
			},
			mobile: {
				text: "<p><a href=\"https://www.falabella.com.pe/falabella-pe/static/staticContent1.jsp?active=5&id=cat50618\" target=\"_blank\"><img src=\"https://images.contentstack.io/v3/assets/blt07d653b53a07a055/bltaa8756ed2de224d0/5ebab239b5455801f1e0b3da/Norton.png\" alt=\"norton.png\" data-image=\"3smovebn8qco\">\n<strong>COMPRA 100% SEGURA</strong></a></p>"
			}
		}
	],
	derechos_reservados: [
		{
			title: "ESQUINA INFERIOR IZQUIERDA FOOTER",
			text: "<p><strong>© TODOS LOS DERECHOS RESERVADOS</strong><br>Saga Falabella S.A. - Av. Paseo de la República 3220 - San Isidro - Lima</p>",
			tags: [
			],
			desktop: {
				text: "<p><strong>© TODOS LOS DERECHOS RESERVADOS</strong><br>Saga Falabella S.A. - Av. Paseo de la República 3220 - San Isidro - Lima</p>"
			},
			mobile: {
				text: "<p><strong>© TODOS LOS DERECHOS RESERVADOS</strong><br>Saga Falabella S.A. - Av. Paseo de la República 3220 - San Isidro - Lima</p>"
			}
		}
	],
	falabella_sostenible: [
	],
	footer_links: [
		{
			items: [
				{
					title: "Libro de Reclamaciones",
					url: "https://www.falabella.com.pe/falabella-pe/static/staticContent1.jsp?active=3&id=cat320489",
					image: {
						is_dir: false,
						description: "",
						filename: "libro-reclamacion.jpg",
						parent_uid: "bltde2c542bc5be2fca",
						tags: [
						],
						title: "libro-reclamacion.jpg",
						url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt69738c9cb2a93098/609418d7f07013101daf3a22/libro-reclamacion.jpg"
					},
					is_new_tab: true
				},
				{
					title: "Preguntas Frecuentes",
					url: "https://www.falabella.com.pe/falabella-pe/category/cat50608/Servicio-al-cliente",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Beneficios Falabella.com",
					url: "https://www.falabella.com.pe/falabella-pe/static/staticContent1.jsp?active=2&id=cat50630",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Tiempos y costos de envío",
					url: "https://www.falabella.com.pe/falabella-pe/static/staticContent1.jsp?active=11&id=cat510493",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Cambios y devoluciones",
					url: "https://www.falabella.com.pe/falabella-pe/static/staticContent1.jsp?active=1&id=cat50614",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Términos y condiciones",
					url: "https://www.falabella.com.pe/falabella-pe/static/staticContent1.jsp?active=10&id=cat200462",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Privacidad y Seguridad",
					url: "https://www.falabella.com.pe/falabella-pe/static/staticContent1.jsp?active=10&id=cat50618",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Mapa de sitio",
					url: "https://www.falabella.com.pe/falabella-pe/browse/siteMap.jsp",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Seguimiento de mi orden",
					url: "https://www.falabella.com.pe/falabella-pe/mi-cuenta/buscar-orden",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Comprobantes electrónicos",
					url: "http://bit.ly/Comprobante-Electronico",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Portal mis compras",
					url: "https://dte.falabella.com/portalmiscompras",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Textos legales",
					url: "https://www.falabella.com.pe/falabella-pe/page/Legales?staticPageId=26500001",
					image: {
					},
					is_new_tab: false
				}
			],
			tags: [
			],
			title: "SERVICIO AL CLIENTE"
		},
		{
			items: [
				{
					title: "Nuestra empresa",
					url: "https://www.falabella.com.pe/falabella-pe/category/cat50648/Nuestra-empresa",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Venta empresa",
					url: "https://www.falabella.com.pe/falabella-pe/category/cat111327/Venta-empresa",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Proveedores",
					url: "https://www.falabella.com.pe/falabella-pe/category/cat50652/Proveedores",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Declaración de ética",
					url: "https://www.falabella.com.pe/falabella-pe/page/Codigo-de-etica?staticPageId=19300001",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Inversionistas",
					url: "https://www.falabella.com.pe/static/staticContent/content/minisitios/Inversionistas/index.html",
					image: {
					},
					is_new_tab: false
				},
				{
					title: "Trabaja con nosotros",
					url: "https://bolsadetrabajo.laborum.pe/saga/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Novios Falabella",
					url: "https://www.noviosfalabella.com.pe/novios-pe/public/inicio.do",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Club Deco",
					url: "https://www.falabella.com.pe/falabella-pe/page/Club-Deco?staticPageId=21000001",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Canal de integridad",
					url: "https://canaldeintegridad.ines.cl/falabella",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Política de Prevención de Delitos",
					url: "https://bit.ly/3uqWUZm",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Cyber WOW",
					url: "https://www.falabella.com.pe/falabella-pe/page/Cyber-WOW?staticPageId=15000001",
					image: {
					},
					is_new_tab: false
				}
			],
			tags: [
			],
			title: "MÁS FALABELLA"
		},
		{
			items: [
				{
					title: "Banco Falabella",
					url: "http://www.bancofalabella.pe/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Viajes Falabella",
					url: "http://www.viajesfalabella.com.pe/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Seguros Falabella",
					url: "http://www.segurosfalabellacorredores.com.pe/web/agenciadeseguros/home",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Sodimac",
					url: "http://www.sodimac.com.pe/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Tottus",
					url: "http://www.tottus.com.pe/",
					image: {
					},
					is_new_tab: true
				},
				{
					title: "Linio",
					url: "https://www.linio.com.pe/",
					image: {
					},
					is_new_tab: true
				}
			],
			tags: [
			],
			title: "EMPRESAS FALABELLA"
		}
	],
	newsletter: [
	],
	social_icons: [
		{
			icons: [
				{
					title: "facebook",
					url: "https://www.facebook.com/sagafalabella"
				},
				{
					title: "twitter",
					url: "https://twitter.com/Falabella_pe"
				},
				{
					title: "instagram",
					url: "https://www.instagram.com/falabella_pe/"
				}
			],
			tags: [
			],
			title: "Iconos redes sociales"
		}
	],
	tags: [
	],
	title: "Footer FAPE"
};
var footerV2PE = {
	entry: entry$3
};

var footerFallback = {
  v2: {
    ar: footerV2AR,
    cl: footerV2CL,
    co: footerV2CO,
    pe: footerV2PE
  }
};

var HTTPError = function (_Error) {
  function HTTPError(statusCode) {
    var _this;
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    _classCallCheck(this, HTTPError);
    _this = _callSuper(this, HTTPError, [message]);
    _this.statusCode = statusCode;
    return _this;
  }
  _inherits(HTTPError, _Error);
  return _createClass(HTTPError, [{
    key: "getStatusCode",
    value: function getStatusCode() {
      return this.statusCode;
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      return this.message;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Error ".concat(this.statusCode, ": ").concat(this.message);
    }
  }]);
}( _wrapNativeSuper(Error));

var fetch = require('isomorphic-unfetch');
var handleFallback = function handleFallback(fallback, error) {
  if (fallback && fallback.data) {
    return fallback.data;
  }
  throw error;
};
var doFetch = function () {
  var _ref = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(url) {
    var options,
      fallbackOptions,
      fallback,
      response,
      data,
      error,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          fallbackOptions = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          fallback = _objectSpread2({
            triggerOnResponseError: false,
            triggerOnNetworkError: false
          }, fallbackOptions);
          _context.prev = 3;
          _context.next = 6;
          return fetch(url, options);
        case 6:
          response = _context.sent;
          _context.next = 9;
          return response.headers.get(['content-type']).includes('application/json') ? response.json() : response.text();
        case 9:
          data = _context.sent;
          if (!response.ok) {
            _context.next = 12;
            break;
          }
          return _context.abrupt("return", data);
        case 12:
          error = new HTTPError(response.headers.get(['status']), JSON.stringify(data));
          if (!fallback.triggerOnResponseError) {
            _context.next = 15;
            break;
          }
          return _context.abrupt("return", handleFallback(fallback, error));
        case 15:
          throw error;
        case 18:
          _context.prev = 18;
          _context.t0 = _context["catch"](3);
          if (!fallback.triggerOnNetworkError) {
            _context.next = 22;
            break;
          }
          return _context.abrupt("return", handleFallback(fallback, _context.t0));
        case 22:
          console.log("Error fetching: ".concat(JSON.stringify(url)));
          throw _context.t0;
        case 24:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 18]]);
  }));
  return function doFetch(_x) {
    return _ref.apply(this, arguments);
  };
}();
var doFetchResponse = function () {
  var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(url) {
    var options,
      fallbackOptions,
      fallback,
      response,
      data,
      error,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          fallbackOptions = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
          fallback = _objectSpread2({
            triggerOnResponseError: false,
            triggerOnNetworkError: false
          }, fallbackOptions);
          _context2.prev = 3;
          _context2.next = 6;
          return fetch(url, options);
        case 6:
          response = _context2.sent;
          _context2.next = 9;
          return response.headers.get(['content-type']).includes('application/json') ? response.json() : response.text();
        case 9:
          data = _context2.sent;
          if (!response.ok) {
            _context2.next = 12;
            break;
          }
          return _context2.abrupt("return", {
            headers: response.headers,
            data: data,
            error: false
          });
        case 12:
          error = new HTTPError(response.headers.get(['status']), JSON.stringify(data));
          return _context2.abrupt("return", {
            error: true,
            headers: response.headers,
            data: error
          });
        case 16:
          _context2.prev = 16;
          _context2.t0 = _context2["catch"](3);
          if (!fallback.triggerOnNetworkError) {
            _context2.next = 20;
            break;
          }
          return _context2.abrupt("return", handleFallback(fallback, _context2.t0));
        case 20:
          console.log("Error fetching: ".concat(JSON.stringify(url)));
          throw _context2.t0;
        case 22:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 16]]);
  }));
  return function doFetchResponse(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var doPost = function () {
  var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3(url, body, options) {
    var isTottusStandAlone,
      response,
      data,
      _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          isTottusStandAlone = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : false;
          _context3.prev = 1;
          _context3.next = 4;
          return fetch(url, _objectSpread2({
            method: 'post',
            body: JSON.stringify(body),
            headers: {
              'Content-Type': 'application/json'
            }
          }, options));
        case 4:
          response = _context3.sent;
          if (!(isTottusStandAlone && (response.ok || response.status === 204))) {
            _context3.next = 7;
            break;
          }
          return _context3.abrupt("return", true);
        case 7:
          _context3.next = 9;
          return response.headers.get(['content-type']).includes('application/json') ? response.json() : response.text();
        case 9:
          data = _context3.sent;
          if (!response.ok) {
            _context3.next = 13;
            break;
          }
          console.log('returning true');
          return _context3.abrupt("return", data);
        case 13:
          throw new HTTPError(response.headers.get(['status']), JSON.stringify(data));
        case 16:
          _context3.prev = 16;
          _context3.t0 = _context3["catch"](1);
          console.log("Error doing post to ".concat(JSON.stringify(url)));
          throw _context3.t0;
        case 20:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 16]]);
  }));
  return function doPost(_x3, _x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
var doDelete = function () {
  var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee4(url) {
    var options,
      isTottusStandAlone,
      response,
      data,
      _args4 = arguments;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
          isTottusStandAlone = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : false;
          _context4.prev = 2;
          _context4.next = 5;
          return fetch(url, _objectSpread2({
            method: 'delete',
            body: JSON.stringify({}),
            headers: {
              'Content-Type': 'application/json'
            }
          }, options));
        case 5:
          response = _context4.sent;
          if (!(isTottusStandAlone && (response.ok || response.status === 204))) {
            _context4.next = 8;
            break;
          }
          return _context4.abrupt("return", true);
        case 8:
          _context4.next = 10;
          return response.headers.get(['content-type']).includes('application/json') ? response.json() : response.text();
        case 10:
          data = _context4.sent;
          if (!response.ok) {
            _context4.next = 13;
            break;
          }
          return _context4.abrupt("return", data);
        case 13:
          throw new HTTPError(response.headers.get(['status']), JSON.stringify(data));
        case 16:
          _context4.prev = 16;
          _context4.t0 = _context4["catch"](2);
          console.log("Error doing delete to ".concat(JSON.stringify(url)));
          throw _context4.t0;
        case 20:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[2, 16]]);
  }));
  return function doDelete(_x6) {
    return _ref4.apply(this, arguments);
  };
}();

var validateSid = function () {
  var _ref = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(cookieSID, tenant, commerceOriginData) {
    var url, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = getAuthBaseUrl('validate', tenant);
          _context.next = 3;
          return doPost(url, {
            sessionId: cookieSID
          }, {
            headers: _objectSpread2({
              'x-channel-id': detectDeviceType(),
              'x-ecomm-name': "marketplace-".concat(tenant),
              'Content-Type': 'application/json',
              'x-commerce': 'FCM'
            }, commerceOriginData && commerceOriginData.name && {
              'x-origin-name': commerceOriginData.name
            }, {}, commerceOriginData && commerceOriginData.view && {
              'x-origin-view': commerceOriginData.view
            })
          });
        case 3:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function validateSid(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var getUserEmail = function () {
  var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(userId, tenant) {
    var url, response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = "".concat(getEnvBaseUrl(tenant), "/s/checkout/v1/users/").concat(userId, "/email");
          _context2.next = 3;
          return doFetch(url, {
            headers: {
              'x-channel-id': detectDeviceType(),
              'x-ecomm-name': "marketplace-".concat(tenant)
            }
          });
        case 3:
          response = _context2.sent;
          return _context2.abrupt("return", response.data.user);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getUserEmail(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
var softLogin = function () {
  var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3(emailId, tenant) {
    var url, response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          url = getAuthBaseUrl('soft/login', tenant);
          _context3.next = 3;
          return doPost(url, {
            emailAddress: emailId
          }, {
            headers: {
              'x-channel-id': detectDeviceType(),
              'x-ecomm-name': "marketplace-".concat(tenant),
              'Content-Type': 'application/json'
            }
          });
        case 3:
          response = _context3.sent;
          return _context3.abrupt("return", response);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function softLogin(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
var refreshUserSession = function () {
  var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee4(cookieSID, tenant, setUserLoggedIn, commerceOriginData) {
    var _yield$validateSid, active, status, remainingSessionTime, sidValue, userId, _yield$getUserEmail, emailId, _yield$softLogin, sessionId, expires;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (!cookieSID) {
            _context4.next = 26;
            break;
          }
          _context4.next = 3;
          return validateSid(cookieSID, tenant, commerceOriginData);
        case 3:
          _yield$validateSid = _context4.sent;
          active = _yield$validateSid.active;
          status = _yield$validateSid.status;
          remainingSessionTime = _yield$validateSid.remainingSessionTime;
          CookieStorage.setCookie({
            name: 'sidStatus',
            value: status || 'Soft',
            regionCode: tenant
          });
          if (remainingSessionTime) {
            sidValue = CookieStorage.getCookie('sid');
            CookieStorage.setCookie({
              name: 'sid',
              value: sidValue,
              regionCode: tenant,
              maxAge: remainingSessionTime,
              priority: 'High'
            });
          }
          if (active) {
            _context4.next = 26;
            break;
          }
          setUserLoggedIn(false);
          userId = CookieStorage.getCookie('USER_ID');
          if (userId) {
            _context4.next = 14;
            break;
          }
          throw new Error('User UserId not found cookies');
        case 14:
          CookieStorage.removeCookie({
            name: 'sid'
          });
          _context4.next = 17;
          return getUserEmail(userId, tenant);
        case 17:
          _yield$getUserEmail = _context4.sent;
          emailId = _yield$getUserEmail.emailId;
          _context4.next = 21;
          return softLogin(emailId, tenant);
        case 21:
          _yield$softLogin = _context4.sent;
          sessionId = _yield$softLogin.sessionId;
          expires = _yield$softLogin.expires;
          CookieStorage.setCookie({
            name: 'sid',
            value: sessionId,
            regionCode: tenant,
            expiryDays: expires,
            priority: 'High'
          });
          setUserLoggedIn(true);
        case 26:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function refreshUserSession(_x8, _x9, _x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();
var getUserAddressesCheckout = function () {
  var _ref5 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee5(newSessionId, tenant, store) {
    var CHECKOUT_URL, eCommerceName, response, dataSorted;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          CHECKOUT_URL = "".concat(getEnvBaseUrl(tenant), "/s/checkout/v1/users/addresses");
          eCommerceName = getEcommerceName(store, tenant);
          _context5.next = 4;
          return doFetch(CHECKOUT_URL, {
            headers: {
              'x-channel-id': detectDeviceType(),
              'x-ecomm-name': eCommerceName,
              Authorization: newSessionId
            }
          });
        case 4:
          response = _context5.sent;
          dataSorted = response.data.addresses.map(function (address) {
            var newStateCode = address.customInfo.find(function (item) {
              return item.name === 'stateCode';
            }).values[0];
            var newMunicipalCode = address.customInfo.find(function (item) {
              return item.name === 'municipalCode';
            }).values[0];
            var customInfo = [{
              name: 'department',
              value: ''
            }, {
              name: 'municipalCode',
              value: newMunicipalCode
            }, {
              name: 'stateCode',
              value: newStateCode
            }, {
              name: 'municipalPoliticalAreaId',
              value: address.municipalCode
            }, {
              name: 'statePoliticalAreaId',
              value: address.stateCode
            }];
            var mappedAddress = {
              id: address.id,
              addressName: '',
              isShippingAddress: false,
              isBillingAddress: false,
              isDefaultAddress: address.isDefaultAddress,
              addressLine1: address.addressLine2,
              addressLine2: address.addressLine1,
              addressLine3: address.addressLine3,
              municipal: address.municipalName,
              municipalCode: newMunicipalCode,
              departmentNumber: '',
              city: address.cityName,
              state: address.stateName,
              stateCode: newStateCode,
              country: address.countryName,
              postcode: '',
              latitude: address.latitude,
              longitude: address.longitude,
              customInfo: customInfo
            };
            if (tenant === 'pe') {
              var newCityCode = address.customInfo.find(function (item) {
                return item.name === 'cityCode';
              }).values[0];
              mappedAddress.cityCode = newCityCode;
              customInfo.push({
                name: 'cityPoliticalAreaId',
                value: address.cityCode
              });
              mappedAddress.customInfo = customInfo;
            }
            return mappedAddress;
          });
          return _context5.abrupt("return", {
            addresses: dataSorted
          });
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getUserAddressesCheckout(_x12, _x13, _x14) {
    return _ref5.apply(this, arguments);
  };
}();
var getUserAddresses = function () {
  var _ref6 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee6(cookieSID, tenant, store) {
    var baseUrl, eCommerceName, response;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          baseUrl = getEnvBaseUrl(tenant);
          eCommerceName = getEcommerceName(store, tenant);
          _context6.next = 5;
          return doFetch(apiEndpoints.getUserAddresses(baseUrl), {
            headers: {
              'x-channel-id': detectDeviceType(),
              'x-ecomm-name': eCommerceName,
              Authorization: cookieSID
            }
          });
        case 5:
          response = _context6.sent;
          return _context6.abrupt("return", response);
        case 9:
          _context6.prev = 9;
          _context6.t0 = _context6["catch"](0);
          return _context6.abrupt("return", JSON.parse(_context6.t0.message));
        case 12:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 9]]);
  }));
  return function getUserAddresses(_x15, _x16, _x17) {
    return _ref6.apply(this, arguments);
  };
}();
var saveUserAddresses = function () {
  var _ref7 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee7(cookieSID, tenant, store, data) {
    var baseUrl, eCommerceName, response;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          baseUrl = getEnvBaseUrl(tenant);
          eCommerceName = getEcommerceName(store, tenant);
          _context7.next = 5;
          return doPost(apiEndpoints.saveUserAddresses(baseUrl), data, {
            headers: {
              'Content-Type': 'application/json',
              'x-channel-id': detectDeviceType(),
              'x-ecomm-name': eCommerceName,
              Authorization: cookieSID
            }
          }, true);
        case 5:
          response = _context7.sent;
          return _context7.abrupt("return", response);
        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](0);
          return _context7.abrupt("return", JSON.parse(_context7.t0.message));
        case 12:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 9]]);
  }));
  return function saveUserAddresses(_x18, _x19, _x20, _x21) {
    return _ref7.apply(this, arguments);
  };
}();
var deleteUserAddresses = function () {
  var _ref8 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee8(cookieSID, tenant, store, addressID) {
    var baseUrl, eCommerceName, response;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          baseUrl = getEnvBaseUrl(tenant);
          eCommerceName = getEcommerceName(store, tenant);
          _context8.next = 5;
          return doDelete(apiEndpoints.deleteUserAddresses(baseUrl, addressID), {
            headers: {
              'Content-Type': 'application/json',
              'x-channel-id': detectDeviceType(),
              'x-ecomm-name': eCommerceName,
              Authorization: cookieSID
            }
          }, true);
        case 5:
          response = _context8.sent;
          return _context8.abrupt("return", response);
        case 9:
          _context8.prev = 9;
          _context8.t0 = _context8["catch"](0);
          return _context8.abrupt("return", JSON.parse(_context8.t0.message));
        case 12:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 9]]);
  }));
  return function deleteUserAddresses(_x22, _x23, _x24, _x25) {
    return _ref8.apply(this, arguments);
  };
}();

var AppContext = createContext(null);

function useUserContext() {
  var FIRST_NAME_POSITION = 0;
  var CART_COUNT_POSITION = 1;
  var LAST_NAME_POSITION = 2;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    firstName = _useState2[0],
    setFirstName = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    lastName = _useState4[0],
    setLastName = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isUserLoggedIn = _useState6[0],
    setUserLoggedIn = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    cartCount = _useState8[0],
    setCartCount = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isOverlayEnabled = _useState10[0],
    setOverlayEnabled = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isVendorLogin = _useState12[0],
    setIsVendorLoggedIn = _useState12[1];
  var _useState13 = useState({}),
    _useState14 = _slicedToArray(_useState13, 2),
    vendorData = _useState14[0],
    setVendorData = _useState14[1];
  var unescapeATGCookies = CookieStorage.unescapeATGCookies,
    getCookie = CookieStorage.getCookie,
    parseCookieValue = CookieStorage.parseCookieValue;
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    enableAnalytics = _useState16[0],
    setAnalyticsInfo = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    userSegments = _useState18[0],
    setUserSegments = _useState18[1];
  var _useContext = useContext(AppContext),
    tenant = _useContext.tenant,
    commerceOriginData = _useContext.commerceOriginData;
  var refreshUserData = function () {
    var _ref = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
      var userCookie, dynDataCookie, dynDataParts, cookieFirstName, cookieCartCount, cookieLastName, vendorDataCookie, _vendorDataCookie$spl, _vendorDataCookie$spl2, vendorId, storeName, storeId, vendorCode, cartProductsCount, cookieSID;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            userCookie = CookieStorage.getUserDataCookieName();
            dynDataCookie = unescapeATGCookies(getCookie(userCookie));
            dynDataParts = dynDataCookie.split('*');
            cookieFirstName = decodeURIComponent(dynDataParts[FIRST_NAME_POSITION]);
            cookieCartCount = dynDataParts[CART_COUNT_POSITION];
            cookieLastName = decodeURIComponent(dynDataParts[LAST_NAME_POSITION]);
            vendorDataCookie = unescapeATGCookies(getCookie('VENDOR_DATA'));
            if (!vendorDataCookie) {
              _context.next = 14;
              break;
            }
            vendorDataCookie = vendorDataCookie.replace(/"/g, '');
            _vendorDataCookie$spl = vendorDataCookie.split('*'), _vendorDataCookie$spl2 = _slicedToArray(_vendorDataCookie$spl, 4), vendorId = _vendorDataCookie$spl2[0], storeName = _vendorDataCookie$spl2[1], storeId = _vendorDataCookie$spl2[2], vendorCode = _vendorDataCookie$spl2[3];
            setIsVendorLoggedIn(true);
            if (!(!vendorId || !storeId || !vendorCode)) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return", null);
          case 13:
            setVendorData({
              vendorId: vendorId,
              storeName: storeName,
              storeId: storeId,
              vendorCode: vendorCode
            });
          case 14:
            cartProductsCount = !Number.isNaN(parseInt(cookieCartCount, 10)) ? cookieCartCount : '0';
            cookieSID = unescapeATGCookies(getCookie('sid'));
            _context.next = 18;
            return refreshUserSession(cookieSID, tenant, setUserLoggedIn, commerceOriginData);
          case 18:
            if (CookieStorage.isCatalyst()) {
              setUserLoggedIn(!!cookieFirstName && !!cookieSID);
            } else {
              setUserLoggedIn(!!cookieFirstName);
            }
            setFirstName(cookieFirstName);
            setCartCount(cartProductsCount);
            setLastName(cookieLastName);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function refreshUserData() {
      return _ref.apply(this, arguments);
    };
  }();
  var getUserSegments = function getUserSegments() {
    var userSegmentValue = getCookie(USER_SEGMENT_COOKIE);
    var cookieSegmentValue = decodeURIComponent(userSegmentValue);
    var userSegmentDecode = parseCookieValue(USER_SEGMENT_COOKIE, cookieSegmentValue);
    setUserSegments(userSegmentDecode);
  };
  useEffect(function () {
    refreshUserData();
  }, []);
  return {
    firstName: firstName || '',
    setFirstName: setFirstName,
    isUserLoggedIn: isUserLoggedIn,
    setUserLoggedIn: setUserLoggedIn,
    cartCount: cartCount,
    setCartCount: setCartCount,
    lastName: lastName,
    isVendorLogin: isVendorLogin,
    vendorData: vendorData,
    refreshUserData: refreshUserData,
    initDigitalData: initDigitalData,
    enableAnalytics: enableAnalytics,
    setAnalyticsInfo: setAnalyticsInfo,
    isOverlayEnabled: isOverlayEnabled,
    setOverlayEnabled: setOverlayEnabled,
    userSegments: userSegments,
    setUserSegments: setUserSegments,
    getUserSegments: getUserSegments
  };
}
var UserContext = createContainer(useUserContext);
var withUser = function withUser(WrappedComponent) {
  var getInitialProps = WrappedComponent.getInitialProps;
  var ComponentWithUser = function ComponentWithUser(props) {
    var user = useContext(UserContext.Context);
    return jsx(WrappedComponent, _extends({}, props, user));
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithUser.getInitialProps = getInitialProps;
  }
  return ComponentWithUser;
};

var setBusy = function setBusy(_ref) {
  var load = _ref.load,
    setLoad = _ref.setLoad;
  return function (busy) {
    var updatedBusy = busy ? load + 1 : load - 1;
    setLoad(updatedBusy > 0 ? updatedBusy : 0);
  };
};
function useLoaderContext() {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    load = _useState2[0],
    setLoad = _useState2[1];
  return {
    load: load,
    setBusy: setBusy({
      load: load,
      setLoad: setLoad
    })
  };
}
var LoaderContext = createContainer(useLoaderContext);
var withLoader = function withLoader(WrappedComponent) {
  var getInitialProps = WrappedComponent.getInitialProps;
  var ComponentWithLoader = function ComponentWithLoader(props) {
    var user = useContext(LoaderContext.Context);
    return jsx(WrappedComponent, _extends({}, props, user));
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithLoader.getInitialProps = getInitialProps;
  }
  return ComponentWithLoader;
};

function classNames() {
  var hasOwn = {}.hasOwnProperty;
  var classes = [];
  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i];
    if (!arg) continue;
    var argType = _typeof(arg);
    if (argType === 'string' || argType === 'number') {
      classes.push(arg);
    } else if (Array.isArray(arg)) {
      if (arg.length) {
        var inner = classNames.apply(null, arg);
        if (inner) {
          classes.push(inner);
        }
      }
    } else if (argType === 'object') {
      if (arg.toString === Object.prototype.toString) {
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes.push(key);
          }
        }
      } else {
        classes.push(arg.toString());
      }
    }
  }
  return classes.join(' ');
}

var styles$2 = {"spinner":"Spinner-module_spinner__1tiRz","rotate":"Spinner-module_rotate__cGc-R","medium":"Spinner-module_medium__31FhU","small":"Spinner-module_small__1hBjU","spinner__svg":"Spinner-module_spinner__svg__3A0EL","white":"Spinner-module_white__2JWy3","path_circle":"Spinner-module_path_circle__3wQ0t","spinner-ie":"Spinner-module_spinner-ie__30MR0","collapse":"Spinner-module_collapse__1d3LV","green":"Spinner-module_green__3jV6Q","orange":"Spinner-module_orange__a2AX2"};

var MarketplaceSpinner = function MarketplaceSpinner(_ref) {
  var size = _ref.size,
    color = _ref.color;
  return jsx("div", {
    className: classNames(styles$2.spinner, styles$2["".concat(size)], styles$2["".concat(color)])
  }, jsx("svg", {
    width: "49",
    height: "49",
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: styles$2.spinner__svg
  }, jsx("path", {
    d: "M24.4378 2C36.7207 2.05798 46.66 12.0332 46.66 24.33C46.66 36.6628 36.6628 46.66 24.33 46.66C12.039 46.66 2.0661 36.7265 2 24.4494",
    stroke: "#F0F0F0",
    strokeWidth: "3"
  }), jsx("path", {
    d: "M46.66 24.4378C46.602 36.7207 36.628 46.66 24.33 46.66C11.9972 46.66 2 36.6628 2 24.33C2 12.0378 11.9335 2.06494 24.2106 2",
    stroke: "#343E49",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
MarketplaceSpinner.propTypes = process.env.NODE_ENV !== "production" ? {
  size: PropTypes.oneOf(['medium', 'small']),
  color: PropTypes.oneOf(['orange', 'green'])
} : {};
MarketplaceSpinner.defaultProps = {
  size: 'medium',
  color: 'orange'
};

var RetailSpinner = function RetailSpinner(_ref) {
  var size = _ref.size,
    color = _ref.color;
  return jsx("div", {
    className: classNames(styles$2.spinner, styles$2["".concat(size)], styles$2["".concat(color)])
  }, jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: styles$2.spinner__svg,
    viewBox: "-2.5 -2.5 49 49"
  }, jsx("circle", {
    className: styles$2['spinner-ie'],
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4",
    cx: "22",
    cy: "22",
    r: "22"
  })));
};
RetailSpinner.propTypes = process.env.NODE_ENV !== "production" ? {
  size: PropTypes.oneOf(['medium', 'small']),
  color: PropTypes.oneOf(['white', 'green'])
} : {};
RetailSpinner.defaultProps = {
  size: 'medium',
  color: 'green'
};

var Spinner = function Spinner(props) {
  var _useContext = useContext(AppContext),
    isRebrandingEnabled = _useContext.isRebrandingEnabled;
  return jsx(React.Fragment, null, isRebrandingEnabled ? jsx(MarketplaceSpinner, null) : jsx(RetailSpinner, null));
};

var styles$3 = {"loader":"Loader-module_loader__kpm_V"};

var Loader = function Loader(_ref) {
  var load = _ref.load;
  return jsx(Fragment, null, load !== 0 && jsx("div", {
    className: styles$3.loader
  }, jsx(Spinner, null)));
};
Loader.propTypes = process.env.NODE_ENV !== "production" ? {
  load: PropTypes.number.isRequired
} : {};
var Loader$1 = withLoader(Loader);

var ContainerProvider = function ContainerProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, ["children"]);
  var tenant = props.tenant,
    deviceType = props.deviceType,
    commerceOriginData = props.commerceOriginData;
  var validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
  return jsx(AppContext.Provider, {
    value: _objectSpread2({}, props, {
      tenant: validTenant,
      commerceOriginData: commerceOriginData
    })
  }, jsx(DeviceContext.Provider, {
    deviceType: deviceType
  }, jsx(LoaderContext.Provider, null, jsx(Loader$1, null), jsx(UserContext.Provider, null, children))));
};
ContainerProvider.defaultProps = {
  deviceType: deviceTypes.DESKTOP,
  isRebrandingEnabled: true,
  isSodimacStandAloneSite: false,
  isTottusStandAloneSite: false
};
ContainerProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any.isRequired,
  tenant: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
  deviceType: PropTypes.string,
  isRebrandingEnabled: PropTypes.bool,
  commerceOriginData: PropTypes.object,
  isSodimacStandAloneSite: PropTypes.bool,
  isTottusStandAloneSite: PropTypes.bool
} : {};

var _ = {
  get: get,
  isEmpty: isEmpty$1
};

var useOnScroll = function useOnScroll(_ref) {
  var handler = _ref.handler,
    effectListener = _ref.effectListener;
  useEffect(function () {
    window.addEventListener('scroll', handler);
    return function () {
      window.removeEventListener('scroll', handler);
    };
  }, [effectListener]);
};

var footerLabels = {
  LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
  SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
  SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
  SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
  A11Y_BACKTOTOP: ''
};
var constants = {
  FACET_MOBILE_CONTAINER_HEIGHT: 50,
  isCookieLegalBannerSelected: 'isCookieLegalBannerSelected'
};
var footerEndpoints = {
  getEmailSubcriptionUrl: function getEmailSubcriptionUrl(baseUrl) {
    return "".concat(baseUrl, "/rest/model/falabella/rest/common/CommonActor/subscribe-to-newsletter");
  }
};
var DataFiscal = 'data:image/png;base64,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';
var footerConfig = {
  labels: footerLabels,
  endpoints: footerEndpoints,
  images: {
    DataFiscal: DataFiscal
  },
  constants: constants
};

var styles$4 = {"rebranding":"Footer-module_rebranding__32k0H","footer-secondary":"Footer-module_footer-secondary__1ojOU","footer-secondary-container":"Footer-module_footer-secondary-container__2PCoH","horizontal-links-container":"Footer-module_horizontal-links-container__2CadK","footer-tertiary":"Footer-module_footer-tertiary__2-DYf","footer-tertiary-container":"Footer-module_footer-tertiary-container__1q-au","copyright-container":"Footer-module_copyright-container__2gDiX","security-container":"Footer-module_security-container___VtDV","has-legal-banner":"Footer-module_has-legal-banner__1_wrC","hide-footer":"Footer-module_hide-footer__2hWE1","footerContainer":"Footer-module_footerContainer__FyULU","footer-bottom":"Footer-module_footer-bottom__1PSUN","close-legal-banner":"Footer-module_close-legal-banner__3LL88","footer-primary":"Footer-module_footer-primary__3F88d","footer-logo":"Footer-module_footer-logo__3Prh2","footer-primary-container":"Footer-module_footer-primary-container__2La_u","footer-links-column-container":"Footer-module_footer-links-column-container__1hvtp","social-media-container":"Footer-module_social-media-container__3AfWC","filler-container":"Footer-module_filler-container__LGeAU","copyright-title":"Footer-module_copyright-title__3btP8","copyright-description":"Footer-module_copyright-description__2mqao","security-icon":"Footer-module_security-icon__3WQRT","security-text":"Footer-module_security-text__28U7I","powered-by-container":"Footer-module_powered-by-container__2PRP-","powered-by-icon":"Footer-module_powered-by-icon__3uLRU"};

var Footer = function Footer(_ref) {
  var data = _ref.data,
    deviceType = _ref.deviceType,
    attachResizeListener = _ref.attachResizeListener,
    store = _ref.store;
  var _useContext = useContext(AppContext),
    tenant = _useContext.tenant,
    baseUrl = _useContext.baseUrl,
    isRebrandingEnabled = _useContext.isRebrandingEnabled,
    _useContext$MobileApp = _useContext.MobileAppWebView,
    MobileAppWebView = _useContext$MobileApp === void 0 ? false : _useContext$MobileApp;
  var constants = footerConfig.constants;
  var _useState = useState(buildFooterData(data)),
    _useState2 = _slicedToArray(_useState, 2),
    footer = _useState2[0],
    setFooter = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    platform = _useState4[0],
    setPlatform = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    legalBannerVisiblility = _useState6[0],
    setLegalBannerVisiblility = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    legalBannerCookie = _useState8[0],
    setLegalBannerCookie = _useState8[1];
  useEffect(function () {
    if (CookieStorage.getCookie(constants.isCookieLegalBannerSelected) !== 'true') {
      setLegalBannerVisiblility(true);
      setLegalBannerCookie(false);
    }
    if (!data || _.isEmpty(data)) {
      Footer.getFooterData({
        tenant: tenant,
        baseUrl: baseUrl,
        store: store
      }).then(function (d) {
        setFooter(buildFooterData(d));
      }).catch(function (e) {
        console.log('getFooterData error', e);
      });
    }
    attachResizeListener();
    if (window && window.navigator && window.navigator.userAgent) {
      setPlatform(getPlatformType(window.navigator.userAgent));
    }
    attachResizeListener();
  }, []);
  var footerRef = useRef();
  var handleWindowScroll = function handleWindowScroll() {
    if (deviceType === 'desktop') {
      return;
    }
    var topOffset = footerRef.current.getBoundingClientRect().top - constants.FACET_MOBILE_CONTAINER_HEIGHT;
    if (topOffset <= 0) {
      toggleBodyClass(true, 'footerVisible');
    } else {
      toggleBodyClass(false, 'footerVisible');
    }
  };
  useOnScroll({
    handler: debounce(handleWindowScroll, 10)
  });
  if (!footer || _.isEmpty(footer)) {
    return jsx(React.Fragment, null);
  }
  var securityIcon = function () {
    var key = '';
    if (isRebrandingEnabled) {
      key = deviceType === deviceTypes.MOBILE || deviceType === deviceTypes.TABLET ? 'security.iconMobileRebrandingOn' : 'security.iconDesktopRebrandingOn';
    } else {
      key = 'security.iconRebrandingOff';
    }
    return get(footer, key, {});
  }();
  var closeLegalBanner = function closeLegalBanner() {
    setLegalBannerVisiblility(false);
    CookieStorage.setCookie({
      name: constants.isCookieLegalBannerSelected,
      value: 'true',
      expiryDays: 30,
      regionCode: tenant
    });
  };
  var exitLegalBanner = function exitLegalBanner() {
    setLegalBannerVisiblility(false);
  };
  var primaryFooterStyles = isWhitelabel(store) ? {
    background: footer.primaryBackgroundColor
  } : undefined;
  var secondaryFooterStyles = isWhitelabel(store) ? {
    background: footer.secondaryBackgroundColor || footer.primaryBackgroundColor,
    borderBottom: '0px'
  } : undefined;
  var tertiaryFooterStyles = isWhitelabel(store) ? {
    background: footer.tertiaryBackgroundColor || footer.primaryBackgroundColor
  } : undefined;
  return footer.footerColumns.length > 0 && jsx(React.Fragment, null, jsx("footer", {
    className: "".concat(MobileAppWebView ? styles$4['hide-footer'] : '', " ").concat(isRebrandingEnabled ? "".concat(styles$4.footerContainer, " ").concat(styles$4.rebranding) : styles$4.footerContainer, " ").concat(legalBannerVisiblility && !legalBannerCookie && footer.bottom_banner.enabled ? styles$4['has-legal-banner'] : '', "             \n          "),
    style: primaryFooterStyles
  }, jsx("section", {
    className: styles$4['footer-primary'],
    ref: function ref(r) {
      footerRef.current = r;
    }
  }, footer.logo && deviceType === 'desktop' && jsx("div", {
    className: styles$4['footer-logo']
  }, jsx("a", {
    href: "/"
  }, jsx("img", {
    src: footer.logo,
    alt: "footer-logo"
  }))), jsx("div", {
    className: styles$4['footer-primary-container']
  }, footer.footerColumns.length > 0 && footer.footerColumns.map(function (fc, i) {
    return jsx("div", {
      key: "".concat(fc.title, "_footer_column"),
      className: styles$4['footer-links-column-container']
    }, jsx(FooterList, {
      listTitle: fc.title,
      items: fc.items,
      textColor: isWhitelabel(store) ? fc.text_color : '',
      index: i,
      deviceType: deviceType,
      platform: platform,
      isRebrandingEnabled: isRebrandingEnabled
    }));
  }))), jsx("section", {
    className: styles$4['footer-secondary'],
    style: secondaryFooterStyles
  }, jsx("div", {
    className: styles$4['footer-secondary-container']
  }, jsx("div", {
    className: styles$4['social-media-container']
  }, footer.socialIcons.length > 0 && jsx(SocialIcons, {
    icons: footer.socialIcons,
    isRebrandingEnabled: isRebrandingEnabled
  })), jsx("div", {
    className: styles$4['horizontal-links-container']
  }, footer.horizontalLinks.length > 0 && footer.horizontalLinks.map(function (hz, index) {
    return jsx("a", {
      href: hz.url,
      key: "".concat(hz.title, "_").concat(hz.url),
      className: styles$4['horizontal-link'],
      target: hz.is_new_tab ? '_blank' : '_self',
      rel: "noopener noreferrer",
      onClick: function onClick() {
        updateDigitalDataCookies({
          firstLevelItem: 'N2',
          secondLevelItem: "".concat(footer.socialIcons.length + index + 1),
          thirdLevelItem: 'X',
          postionOne: "HL_".concat(capitalizeWord(hz.title)),
          postionTwo: 'X',
          postionThree: getPageName(),
          tag: FOOTER
        });
      },
      style: isWhitelabel(store) ? {
        color: hz.text_color
      } : {}
    }, hz.title);
  })), jsx("div", {
    className: styles$4['filler-container']
  }))), jsx("section", {
    className: styles$4['footer-tertiary'],
    style: tertiaryFooterStyles
  }, jsx("div", {
    className: styles$4['footer-tertiary-container'],
    style: isWhitelabel(store) ? {
      color: footer.copyright.textColor
    } : {}
  }, jsx("div", {
    className: styles$4['copyright-container']
  }, jsx("span", {
    className: styles$4['copyright-title']
  }, footer.copyright.title), jsx("span", {
    className: styles$4['copyright-description']
  }, deviceType === 'mobile' ? jsx(React.Fragment, null, jsx("span", null, footer.copyright.description.substring(0, 22)), jsx("span", null, footer.copyright.description.substring(23))) : jsx("span", null, footer.copyright.description))), jsx("div", null, footer.poweredBy && jsx("span", {
    className: styles$4['powered-by-container']
  }, jsx("p", {
    style: {
      margin: '0'
    }
  }, footer.poweredBy.label), jsx("i", {
    className: styles$4['powered-by-icon'],
    style: {
      backgroundImage: "url(".concat(footer.poweredBy.icon.url, ")")
    }
  })), jsx("a", {
    className: styles$4['security-container'],
    href: footer.security.url,
    rel: "noopener noreferrer"
  }, jsx("img", {
    src: securityIcon.url,
    className: styles$4['security-icon'],
    alt: securityIcon.title
  }), jsx("span", {
    className: styles$4['security-text']
  }, footer.security.text))))), legalBannerVisiblility && !legalBannerCookie && footer.bottom_banner.enabled ? jsx("section", {
    className: styles$4['footer-bottom'],
    style: {
      backgroundColor: "".concat(footer.bottom_banner.banner.bgColor),
      color: "".concat(footer.bottom_banner.banner.txtColor)
    }
  }, jsx("span", {
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(footer.bottom_banner.banner.content)
    }
  }), jsx("button", {
    id: "testId-accept-cookies-btn",
    style: {
      backgroundColor: "".concat(footer.bottom_banner.button.bgColor),
      color: "".concat(footer.bottom_banner.button.txtColor)
    },
    type: "button",
    onClick: closeLegalBanner
  }, footer.bottom_banner.button.title), jsx("div", {
    id: "testId-close-cookies-btn",
    className: styles$4['close-legal-banner'],
    onClick: exitLegalBanner
  })) : jsx(React.Fragment, null)));
};
Footer.getFooterData = function (_ref2) {
  var tenant = _ref2.tenant,
    baseUrl = _ref2.baseUrl,
    store = _ref2.store;
  var validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
  return doFetch(buildContentUrl(baseUrl, 'footer', validTenant, 'v3', store), {}, {
    data: footerFallback.v2[validTenant],
    triggerOnResponseError: true,
    triggerOnNetworkError: true
  });
};
Footer.defaultProps = {
  deviceType: 'desktop',
  MobileAppWebView: false
};
Footer.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.any,
  deviceType: PropTypes.string,
  attachResizeListener: PropTypes.func.isRequired,
  store: PropTypes.string,
  MobileAppWebView: PropTypes.bool
} : {};
var Footer$1 = withDevice(Footer);

var styles$5 = {"errorDialog-container":"ErrorDialog-module_errorDialog-container__33DHX","header":"ErrorDialog-module_header__-0b9x","close":"ErrorDialog-module_close__3uOCn","title":"ErrorDialog-module_title__1CC_l","content":"ErrorDialog-module_content__1U6yy"};

var noop$1 = function noop() {};

var WithOutsideClick = function WithOutsideClick(_ref) {
  var children = _ref.children,
    onOutsideClick = _ref.onOutsideClick,
    className = _ref.className,
    styles = _ref.styles,
    id = _ref.id,
    style = _ref.style;
  var node = useRef();
  var handleClick = function handleClick(e) {
    if (!(node.current && node.current.contains(e.target))) {
      onOutsideClick(e);
    }
  };
  useEffect(function () {
    document.addEventListener('mousedown', handleClick, true);
    return function () {
      document.removeEventListener('mousedown', handleClick, true);
    };
  }, []);
  return jsx("div", {
    id: id,
    className: styles["".concat(className || 'doc-click-overlay')],
    ref: function ref(r) {
      node.current = r;
    },
    style: style
  }, children);
};
WithOutsideClick.defaultProps = {
  className: '',
  id: '',
  style: {}
};
WithOutsideClick.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any.isRequired,
  onOutsideClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  styles: PropTypes.object.isRequired,
  id: PropTypes.string,
  style: PropTypes.object
} : {};

var ErrorDialog = function ErrorDialog(_ref) {
  var title = _ref.title,
    message = _ref.message,
    onClose = _ref.onClose;
  useEffect(function () {
    toggleBodyClass(true, 'FacetMobilePanel--open');
    return function () {
      toggleBodyClass(false, 'FacetMobilePanel--open');
    };
  }, []);
  return jsx("div", {
    className: styles$5['errorDialog-container']
  }, jsx(WithOutsideClick, {
    className: styles$5.errorDialog,
    onOutsideClick: function onOutsideClick() {
      onClose();
    },
    styles: {}
  }, jsx("div", {
    className: styles$5.header
  }, jsx("h2", {
    className: styles$5.title
  }, title), jsx("button", {
    type: "button",
    onClick: onClose,
    className: styles$5.close
  }, ' ')), jsx("p", {
    className: styles$5.content
  }, message)));
};
ErrorDialog.defaultProps = {
  title: '',
  message: '',
  onClose: noop$1
};
ErrorDialog.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func
} : {};

var styles$6 = {"logo-main-wrapper":"Logo-module_logo-main-wrapper__3g-vZ","logo-wrapper":"Logo-module_logo-wrapper__2HDy0","logo":"Logo-module_logo__iW4zn","mobile-logo":"Logo-module_mobile-logo__2QggL","sis-logo-wrapper":"Logo-module_sis-logo-wrapper__1-Sun","sis-logo-wrapper--so_com":"Logo-module_sis-logo-wrapper--so_com__2TIWE","sis-logo-wrapper--to_com":"Logo-module_sis-logo-wrapper--to_com__2046H","sodimac":"Logo-module_sodimac__2lIk0","linio":"Logo-module_linio__1J0A5","tottus":"Logo-module_tottus__1fVr3","homecenter":"Logo-module_homecenter__gObZ6","so_com":"Logo-module_so_com__2nK5P","to_com":"Logo-module_to_com__1udRe","whitelabel":"Logo-module_whitelabel__2QUm9"};

var Logo = function Logo(_ref) {
  var path = _ref.path,
    logoIcon = _ref.logoIcon,
    isMobile = _ref.isMobile,
    store = _ref.store;
  var _getStandaloneSite = getStandaloneSite(store),
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  return jsx("div", {
    className: classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$6['logo-main-wrapper'], !store), styles$6['mobile-logo'], !store && isMobile), styles$6['sis-logo-wrapper'], Boolean(store)), styles$6['sis-logo-wrapper--so_com'], isSodimacStandalone), styles$6['sis-logo-wrapper--to_com'], isTottusStandalone))
  }, jsx("a", {
    id: "testId-logo-btn",
    href: path,
    name: "falabella-logo",
    className: classNames([styles$6['logo-wrapper']], styles$6[store], _defineProperty({}, styles$6.whitelabel, isWhitelabelSite)),
    onClick: function onClick() {
      return updateDigitalDataCookies({
        firstLevelItem: 'N1 - Home',
        tag: HEADER
      });
    }
  }, jsx("div", {
    style: {
      backgroundImage: "url(".concat(logoIcon, ")")
    },
    className: classNames(styles$6.logo)
  })));
};
Logo.propTypes = process.env.NODE_ENV !== "production" ? {
  path: PropTypes.string.isRequired,
  logoIcon: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  store: PropTypes.string
} : {};
Logo.defaultProps = {
  isMobile: false
};

var regexCollection = {
  pdp: /\/product|\/articulo/,
  xlp: /\/(search|buscar|collection|seleccion|category|lista)/,
  basket: /\/basket/,
  home: /^(?!.*(?:\/product|\/articulo\/search\/buscar|\/collection|\/seleccion\/category|\/lista\/basket)).*$/
};
var transversalBannerIsEnabled = function transversalBannerIsEnabled(locationPathname, transversalBannerConfig) {
  if (!transversalBannerConfig) {
    return true;
  }
  var pathname = isClientSide() ? window.location.pathname : locationPathname;
  for (var key in regexCollection) {
    if (regexCollection[key].test(pathname)) {
      return transversalBannerConfig[key];
    }
  }
  return true;
};

var styles$7 = {"transversalWrapper":"index-module_transversalWrapper__1wjsE"};

var TransversalBanner = function TransversalBanner(_ref) {
  var transversalBanner = _ref.transversalBanner,
    transversalBannerConfig = _ref.transversalBannerConfig,
    locationPathname = _ref.locationPathname;
  var isEnabled = transversalBannerIsEnabled(locationPathname, transversalBannerConfig);
  if (!transversalBanner || !isEnabled) {
    return jsx(React.Fragment, null);
  }
  return jsx("div", {
    className: styles$7.transversalWrapper,
    id: "testId-transversalBanner"
  }, jsx("div", {
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize("".concat(transversalBanner))
    }
  }), jsx("style", null, "\n          html body {\n            position: relative;\n          }\n        "));
};
TransversalBanner.propTypes = process.env.NODE_ENV !== "production" ? {
  transversalBanner: PropTypes.string.isRequired,
  locationPathname: PropTypes.string,
  transversalBannerConfig: PropTypes.shape({
    home: PropTypes.bool,
    pdp: PropTypes.bool,
    xlp: PropTypes.bool,
    basket: PropTypes.bool
  })
} : {};

var labels = {
  EMPTY_SEARCH_ERROR_TITLE: '',
  EMPTY_SEARCH_ERROR_MESSAGE: '',
  INCORRECT_SEARCH_ERROR_TITLE: '',
  INCORRECT_SEARCH_ERROR_MESSAGE: ''
};
var constants$1 = {
  MIN_SEARCH_TERM_LENGTH: '',
  ON_BOARDING_COOKIE: 'on_boarding',
  ORANGE_COLOR_AB: 'ORANGE_COLOR_AB'
};
var pageOffsetForAnimation = {
  desktop: 70,
  mobile: 96,
  tablet: 96
};
var configs = {
  labels: labels,
  constants: constants$1,
  pageOffsetForAnimation: pageOffsetForAnimation
};

var labels$1 = {
  MENU: 'Menu',
  CATEGORIES: 'Categorías',
  MARKETPLACE_CATEGORIES: 'Menú'
};
var agentHeaderHeights = {
  tablet: '73px',
  mobile: '116px'
};
var HamburgerConfig = {
  labels: labels$1,
  agentHeaderHeights: agentHeaderHeights
};

var styles$8 = {"fallback":"MediaComponent-module_fallback__3hWyv","mobile-only":"MediaComponent-module_mobile-only__NZuHI","tablet-only":"MediaComponent-module_tablet-only__17C6X","desktop-only":"MediaComponent-module_desktop-only__IpA31","mobile-tablet":"MediaComponent-module_mobile-tablet__8263L","mobile-desktop":"MediaComponent-module_mobile-desktop__2sgDU","tablet-desktop":"MediaComponent-module_tablet-desktop__3xCIl"};

var mediaConstants = {
  mobile: 'mobile',
  phablet: 'phablet',
  tablet: 'tablet',
  desktop: 'desktop'
};
var MediaComponent = function MediaComponent(_ref) {
  var from = _ref.from,
    to = _ref.to,
    children = _ref.children;
  var className;
  if (!to || from === to || from === mediaConstants.desktop) {
    className = "".concat(from, "-only");
  } else {
    className = "".concat(from, "-").concat(to);
  }
  className = from === mediaConstants.mobile ? classNames(styles$8.fallback, styles$8[className]) : styles$8[className];
  return jsx(Fragment, null, jsx("div", {
    className: className
  }, children));
};
MediaComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  from: PropTypes.string.isRequired,
  to: PropTypes.string,
  children: PropTypes.node
} : {};
MediaComponent.defaultProps = {
  children: null,
  to: null
};

var styles$9 = {"hamburgerBtn":"MarketplaceHamburgerBtn-module_hamburgerBtn__61t-r","active":"MarketplaceHamburgerBtn-module_active__1UL4T","openBtnStyle":"MarketplaceHamburgerBtn-module_openBtnStyle__I_oDJ","icon":"MarketplaceHamburgerBtn-module_icon__YC2PL","icon-container":"MarketplaceHamburgerBtn-module_icon-container__Bi8ju","line":"MarketplaceHamburgerBtn-module_line__1PMFs","icon-container-active":"MarketplaceHamburgerBtn-module_icon-container-active__3NNQW","title":"MarketplaceHamburgerBtn-module_title__2KG47","navigationOpen":"MarketplaceHamburgerBtn-module_navigationOpen__vDcoo"};

var HamburgerBtn = function HamburgerBtn(_ref) {
  var onNavBtnClick = _ref.onNavBtnClick,
    showTaxonomy = _ref.showTaxonomy,
    deviceType = _ref.deviceType;
  var labels = HamburgerConfig.labels;
  var categoriesLabel = labels.MARKETPLACE_CATEGORIES;
  useEffect(function () {
    toggleBodyClass(showTaxonomy, styles$9.navigationOpen);
  }, [showTaxonomy]);
  return jsx("button", {
    className: styles$9.hamburgerBtn,
    onClick: onNavBtnClick,
    type: "button",
    id: "testId-HamburgerBtn-toggle"
  }, jsx("div", {
    style: {
      paddingLeft: deviceType !== 'desktop' && showTaxonomy ? 0 : null
    },
    className: "".concat(styles$9.icon, " ").concat(showTaxonomy && deviceType === 'desktop' ? styles$9.openBtnStyle : '')
  }, showTaxonomy && jsx(MediaComponent, {
    from: "tablet",
    to: "desktop"
  }), jsx("div", {
    className: classNames(styles$9['icon-container'], _defineProperty({}, styles$9['icon-container-active'], showTaxonomy))
  }, jsx("span", {
    className: styles$9.line
  }))), jsx(MediaComponent, {
    from: "tablet",
    to: "desktop"
  }, jsx("span", {
    className: styles$9.title
  }, categoriesLabel)));
};
HamburgerBtn.defaultProps = {
  labels: {}
};
HamburgerBtn.propTypes = process.env.NODE_ENV !== "production" ? {
  onNavBtnClick: PropTypes.func.isRequired,
  showTaxonomy: PropTypes.bool.isRequired,
  deviceType: PropTypes.string.isRequired,
  labels: PropTypes.object
} : {};

var MatchMedia = function MatchMedia(_ref) {
  var content = _ref.content,
    deviceType = _ref.deviceType;
  return jsx(Fragment, null, content[deviceType] && content[deviceType]());
};
MatchMedia.defaultProps = {
  content: noop
};
MatchMedia.propTypes = process.env.NODE_ENV !== "production" ? {
  deviceType: PropTypes.string.isRequired,
  content: PropTypes.object
} : {};
var MatchMedia$1 = withDevice(MatchMedia);

var styles$a = {"categoryWrapper":"Categories-module_categoryWrapper__19-r8","categories":"Categories-module_categories__qRT0Y","verTodo":"Categories-module_verTodo__3J4C2","categoryTitle":"Categories-module_categoryTitle__3lTkT","seasonal":"Categories-module_seasonal__D6IFb","label":"Categories-module_label__3oIH2","chevronRightIcon":"Categories-module_chevronRightIcon__1r3nI"};

var Categories = function Categories(_ref) {
  var data = _ref.data,
    index = _ref.index,
    showMenu = _ref.showMenu,
    showMenuHover = _ref.showMenuHover,
    classes = _ref.classes,
    is_Seasonal_Flag = _ref.is_Seasonal_Flag,
    getCategoryDigitalData = _ref.getCategoryDigitalData,
    setGlobalPosition = _ref.setGlobalPosition,
    offset = _ref.offset;
  var item_name = data.item_name,
    subCategory = data.second_level_categories,
    third_level = data.third_level_categories,
    tag = data.tag,
    items = data.items,
    item_url = data.item_url,
    isVerTodo = data.is_ver_todo;
  var hasChildItems = Array.isArray(subCategory) && subCategory.length > 0 || Array.isArray(third_level) && third_level.length > 0 || Array.isArray(items) && items.length > 0;
  return jsx(Fragment, null, item_name && jsx("div", {
    className: styles$a.categoryWrapper,
    onClick: function onClick(e) {
      hasChildItems && showMenu(index, undefined, undefined);
      if (offset && hasChildItems) {
        setGlobalPosition(offset + index);
      }
    }
  }, hasChildItems ? jsx(Fragment, null, jsx("div", {
    className: classNames(styles$a.categories, classes, _defineProperty({}, styles$a.active, showMenuHover === index))
  }, jsx("div", {
    className: classNames(styles$a.categoryTitle, _defineProperty({}, styles$a.seasonal, is_Seasonal_Flag))
  }, item_name, !isEmpty$1(tag) && jsx("span", {
    className: styles$a.label
  }, tag)), jsx("div", {
    className: styles$a.chevronRightIcon
  }))) : jsx("a", {
    rel: "noreferrer noopener",
    target: "_self",
    className: classNames(styles$a.categories, classes, _defineProperty(_defineProperty({}, styles$a.active, showMenuHover === index), styles$a.verTodo, isVerTodo)),
    href: item_url,
    onClick: function onClick() {
      return offset ? getCategoryDigitalData(offset + index) : getCategoryDigitalData(index + 1);
    }
  }, jsx("div", {
    className: classNames(styles$a.categoryTitle, _defineProperty({}, styles$a.seasonal, is_Seasonal_Flag))
  }, item_name, !isEmpty$1(tag) && jsx("span", {
    className: styles$a.label
  }, tag)))));
};
Categories.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object,
  index: PropTypes.number,
  showMenu: PropTypes.func,
  showMenuHover: PropTypes.number,
  classes: PropTypes.string
} : {};
Categories.defaultProps = {
  data: {},
  classes: ''
};

var styles$b = {"TaxonomyMobile":"TaxonomyMobile-module_TaxonomyMobile__2jWVR","container":"TaxonomyMobile-module_container__8Vomc","scrollWrapper":"TaxonomyMobile-module_scrollWrapper__uDp0W","innerCategories":"TaxonomyMobile-module_innerCategories__3dHEQ","innerAccesses":"TaxonomyMobile-module_innerAccesses__3WSIo","wrapper":"TaxonomyMobile-module_wrapper__1x7X3","fastAccessesBox":"TaxonomyMobile-module_fastAccessesBox__2qDPH","categoryBox":"TaxonomyMobile-module_categoryBox__1BLEU","verTodoBox":"TaxonomyMobile-module_verTodoBox__3F_sB","verTodo":"TaxonomyMobile-module_verTodo__1WS0N","purchaseGuides":"TaxonomyMobile-module_purchaseGuides__P1Hh2","purchaseGuide":"TaxonomyMobile-module_purchaseGuide__yjU30","purchaseText":"TaxonomyMobile-module_purchaseText__X_mxC","purchaseImage":"TaxonomyMobile-module_purchaseImage__3A5pm","subCategories":"TaxonomyMobile-module_subCategories__1GMy4","brandLogo":"TaxonomyMobile-module_brandLogo__7WvBG","logoBox":"TaxonomyMobile-module_logoBox__3gsVU","subCategoryMainTitle":"TaxonomyMobile-module_subCategoryMainTitle__2xrcN","thirdCategoryTitle":"TaxonomyMobile-module_thirdCategoryTitle__1X7iw","iconWrapper":"TaxonomyMobile-module_iconWrapper__2YTKM","icon":"TaxonomyMobile-module_icon__1nMBh","overlay":"TaxonomyMobile-module_overlay__YfXgV","accesseswrapper":"TaxonomyMobile-module_accesseswrapper__2ezEI","accesses":"TaxonomyMobile-module_accesses__1lcBA","accessesTitleWrapper":"TaxonomyMobile-module_accessesTitleWrapper__14LVw","iconBox":"TaxonomyMobile-module_iconBox__2tAbs","accessesTitle":"TaxonomyMobile-module_accessesTitle__1ie5D"};

var styles$c = {"taxonomy__overlay":"TaxonomyOverlay-module_taxonomy__overlay__1PJnj","marketplace-overlay":"TaxonomyOverlay-module_marketplace-overlay__eBk5j","agent-loggedin":"TaxonomyOverlay-module_agent-loggedin___LQzg","vendor-loggedin":"TaxonomyOverlay-module_vendor-loggedin__3pCKS","agent-loggedin-mkp":"TaxonomyOverlay-module_agent-loggedin-mkp__2UEEO","vendor-loggedin-mkp":"TaxonomyOverlay-module_vendor-loggedin-mkp__zZXQu"};

var TaxonomyOverlay = function TaxonomyOverlay(_ref) {
  var hideMenu = _ref.hideMenu,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    isMarketPlace = _ref.isMarketPlace,
    _ref$backdropPosition = _ref.backdropPosition,
    backdropPosition = _ref$backdropPosition === void 0 ? null : _ref$backdropPosition,
    resetData = _ref.resetData,
    classes = _ref.classes;
  var overlayRef = useRef();
  var handleClick = function handleClick(e) {
    overlayRef.current.contains(e.target) && hideMenu();
    if (resetData) {
      resetData('categories');
      resetData('nextaccess');
    }
  };
  var vendorClass = isMarketPlace ? 'vendor-loggedin-mkp' : 'vendor-loggedin';
  var agentClass = isMarketPlace ? 'agent-loggedin-mkp' : 'agent-loggedin';
  return ReactDom.createPortal(jsx("div", {
    ref: overlayRef,
    onKeyDown: noop,
    tabIndex: "0",
    style: backdropPosition,
    role: "button",
    className: classNames(styles$c.taxonomy__overlay, styles$c["".concat(isAgentLoggedIn ? agentClass : '')], styles$c["".concat(isVendorLoggedIn ? vendorClass : '')], styles$c["".concat(isMarketPlace && 'marketplace-overlay')], classes),
    onClick: handleClick
  }), document.body);
};

var styles$d = {"categoryWrapper":"NextAccesses-module_categoryWrapper__3nyM4","nextCategoryMainTitle":"NextAccesses-module_nextCategoryMainTitle__3VJnn","categories":"NextAccesses-module_categories__2DfW7","iconBox":"NextAccesses-module_iconBox__26gjl","icon":"NextAccesses-module_icon__1fUQ8","active":"NextAccesses-module_active__g9VSs","categoryTitle":"NextAccesses-module_categoryTitle__1-Uq_","seasonal":"NextAccesses-module_seasonal__TrJU4","label":"NextAccesses-module_label__1v9p7","chevronRightIcon":"NextAccesses-module_chevronRightIcon__F-T6f","childItems":"NextAccesses-module_childItems__6HUy4","secondLevelAccess":"NextAccesses-module_secondLevelAccess__2gX_z"};

var NextAccesses = function NextAccesses(_ref) {
  var data = _ref.data,
    showMenu = _ref.showMenu,
    itemIndex = _ref.itemIndex,
    setGlobalPosition = _ref.setGlobalPosition,
    offset = _ref.offset;
  var item_name = data.item_name,
    items = data.items;
  var NextAccess = useRef(false);
  return jsx(Fragment, null, jsx("div", {
    className: styles$d.categoryWrapper
  }, item_name && jsx("div", {
    className: styles$d.nextCategoryMainTitle
  }, item_name), Array.isArray(items) && items.length > 0 && jsx(Fragment, null, items.map(function (item, index) {
    return item.second_level_access && item.second_level_access.length > 0 ? jsx(Fragment, {
      key: item.url
    }, jsx("div", {
      key: item.url,
      className: styles$d.categories,
      ref: NextAccess,
      onClick: function onClick() {
        showMenu(itemIndex, index, 'nextAccess');
        setGlobalPosition(offset + index);
      }
    }, jsx("div", {
      className: styles$d.categoryTitle
    }, item.icon && item.icon.url && jsx("div", {
      className: styles$d.iconBox
    }, jsx("img", {
      className: styles$d.icon,
      src: item.icon.url
    })), item.item_name), jsx("div", {
      className: styles$d.chevronRightIcon
    }))) : jsx("a", {
      key: item.url,
      rel: "noreferrer noopener",
      target: item.is_new_tab ? '_blank' : '_self',
      className: styles$d.categories,
      href: item.url,
      onClick: function onClick() {
        updateDigitalDataCookies({
          firstLevelItem: item.item_name,
          secondLevelItem: item.item_name,
          thirdLevelItem: item.item_name,
          postionOne: offset + index,
          postionTwo: 0,
          postionThree: 0,
          tag: NAVIGATION
        });
      }
    }, jsx("div", {
      className: styles$d.categoryTitle
    }, item.icon && item.icon.url && jsx("div", {
      className: styles$d.iconBox
    }, jsx("img", {
      className: styles$d.icon,
      src: item.icon.url
    })), item.item_name));
  }))));
};
NextAccesses.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object,
  showMenu: PropTypes.func,
  itemIndex: PropTypes.number
} : {};
NextAccesses.defaultProps = {
  data: {}
};

var styles$e = {"categoryWrapper":"FastAccesses-module_categoryWrapper__1sYn6","nextCategoryMainTitle":"FastAccesses-module_nextCategoryMainTitle___UTt0","categories":"FastAccesses-module_categories__1p2b1","iconBox":"FastAccesses-module_iconBox__3oyr7","icon":"FastAccesses-module_icon__2rgxn","active":"FastAccesses-module_active__BEqsZ","categoryTitle":"FastAccesses-module_categoryTitle__167Yx","seasonal":"FastAccesses-module_seasonal__3owrH","label":"FastAccesses-module_label__1hVu6","chevronRightIcon":"FastAccesses-module_chevronRightIcon__3Vx_g","childItems":"FastAccesses-module_childItems__qGcFY","secondLevelAccess":"FastAccesses-module_secondLevelAccess__3bFB8"};

var FastAccesses = function FastAccesses(_ref) {
  var data = _ref.data,
    showMenu = _ref.showMenu,
    isUserLoggedIn = _ref.isUserLoggedIn,
    isCmrPointsEnabled = _ref.isCmrPointsEnabled,
    tenant = _ref.tenant;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  useEffect(function () {
    isUserLoggedIn ? setItems(data.login_items) : setItems(data.not_logged_items);
  }, [isUserLoggedIn]);
  return jsx(Fragment, null, items && items.length > 0 && items.map(function (item, itemIndex) {
    return jsx(Fragment, {
      key: itemIndex
    }, jsx("div", {
      className: styles$e.categoryWrapper
    }, item.child_items && item.child_items.length > 0 ? jsx(Fragment, null, jsx("div", {
      className: styles$e.categories,
      onClick: function onClick() {
        return showMenu(itemIndex, false, 'fastAccess');
      }
    }, jsx("div", {
      className: styles$e.categoryTitle
    }, item.icon && item.icon.url && jsx("div", {
      className: styles$e.iconBox
    }, jsx("img", {
      className: styles$e.icon,
      src: item.icon.url
    })), !item.cmr_points_check_box && item.item_name, item.cmr_points_check_box && isCmrPointsEnabled && jsx(CmrPuntosMenuMobile, {
      cmrPuntosURL: item.url,
      cmrpuntosImageUrl: item.cmr_puntos_icon.url,
      cmrText: item.item_name,
      imageStyle: 'icon-cmr-icon',
      isCmrPointsEnabled: isCmrPointsEnabled,
      isLoggedIn: isUserLoggedIn,
      isNewTab: item.is_new_tab,
      tenantId: "falabella-".concat(tenant),
      isNavigationMobileMenu: true,
      isRebrandingEnabled: true,
      section: "menu"
    })), jsx("div", {
      className: styles$e.chevronRightIcon
    }))) : jsx("a", {
      rel: "noreferrer noopener",
      target: item.is_new_tab ? '_blank' : '_self',
      className: styles$e.categories,
      href: item.url,
      onClick: function onClick() {
        updateDigitalDataCookies({
          firstLevelItem: item.item_name,
          secondLevelItem: item.item_name,
          thirdLevelItem: item.item_name,
          postionOne: 0,
          postionTwo: 0,
          postionThree: 0,
          tag: NAVIGATION
        });
      }
    }, jsx("div", {
      className: styles$e.categoryTitle
    }, item.icon && item.icon.url && jsx("div", {
      className: styles$e.iconBox
    }, jsx("img", {
      className: styles$e.icon,
      src: item.icon.url
    })), !item.cmr_points_check_box && item.item_name, item.cmr_points_check_box && isCmrPointsEnabled && jsx(CmrPuntosMenuMobile, {
      cmrPuntosURL: item.url,
      cmrpuntosImageUrl: item.cmr_puntos_icon.url,
      cmrText: item.item_name,
      imageStyle: 'icon-cmr-icon',
      isCmrPointsEnabled: isCmrPointsEnabled,
      isLoggedIn: isUserLoggedIn,
      isNewTab: item.is_new_tab,
      isNavigationMobileMenu: true,
      tenantId: "falabella-".concat(tenant),
      isRebrandingEnabled: true,
      section: 'menu'
    })))));
  }));
};
FastAccesses.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object,
  showMenu: PropTypes.func,
  isUserLoggedIn: PropTypes.bool,
  isCmrPointsEnabled: PropTypes.bool
} : {};
FastAccesses.defaultProps = {
  data: {}
};

var styles$f = {"restAccesses":"RestAccesses-module_restAccesses__2PUV_","download":"RestAccesses-module_download__1ofVl","downloadIconBox":"RestAccesses-module_downloadIconBox__1uF2v","downloadIcon":"RestAccesses-module_downloadIcon__3vFpj","teleMarketingAndMonetizeBanner":"RestAccesses-module_teleMarketingAndMonetizeBanner__B8vf2","teleMarketingWrapper":"RestAccesses-module_teleMarketingWrapper__3zpn-","teleMarketingTitle":"RestAccesses-module_teleMarketingTitle__5YIB2","teleMarketingIconBox":"RestAccesses-module_teleMarketingIconBox__2FhkB","teleMarketingIcon":"RestAccesses-module_teleMarketingIcon__3abQK","teleMarketing":"RestAccesses-module_teleMarketing___vGtP","monetizeBanner":"RestAccesses-module_monetizeBanner__2-Exw","monetizeBannerImage":"RestAccesses-module_monetizeBannerImage__18H9f"};

var RestAccesses = function RestAccesses(_ref) {
  var downloadLink = _ref.downloadLink,
    telemarketing = _ref.telemarketing,
    banners = _ref.banners;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    platform = _useState2[0],
    setPlatform = _useState2[1];
  var item_name = downloadLink.item_name,
    icon = downloadLink.icon,
    url_ios = downloadLink.url_ios,
    url_android = downloadLink.url_android;
  var teleMarketingTitle = telemarketing.title,
    teleMarketingIcon = telemarketing.icon,
    number = telemarketing.number,
    teleMarketingLink = telemarketing.link;
  var isIOS = platform === 'mobile_ios';
  useEffect(function () {
    if (window && window.navigator && window.navigator.userAgent) {
      setPlatform(getPlatformType(window.navigator.userAgent));
    }
  }, []);
  return jsx("div", {
    className: styles$f.restAccesses
  }, downloadLink && jsx("a", {
    rel: "noreferrer noopener",
    href: isIOS ? url_ios : url_android,
    target: "_blank",
    className: styles$f.download,
    onClick: function onClick() {
      return updateDigitalDataCookies({
        firstLevelItem: item_name,
        secondLevelItem: item_name,
        thirdLevelItem: item_name,
        postionOne: 0,
        postionTwo: 0,
        postionThree: 0,
        tag: NAVIGATION
      });
    }
  }, icon && icon.url && jsx("div", {
    className: styles$f.downloadIconBox
  }, jsx("img", {
    className: styles$f.downloadIcon,
    src: icon.url
  })), item_name), jsx("div", {
    className: styles$f.teleMarketingAndMonetizeBanner
  }, telemarketing && jsx("div", {
    className: styles$f.teleMarketingWrapper
  }, jsx("div", {
    className: styles$f.teleMarketingTitle
  }, teleMarketingTitle), number && teleMarketingIcon && teleMarketingIcon.url && jsx("a", {
    onClick: function onClick() {
      return teleMarketingTitle && updateDigitalDataCookies({
        firstLevelItem: teleMarketingTitle,
        secondLevelItem: teleMarketingTitle,
        thirdLevelItem: teleMarketingTitle,
        postionOne: 0,
        postionTwo: 0,
        postionThree: 0,
        tag: NAVIGATION
      });
    },
    className: styles$f.teleMarketing,
    href: "tel:".concat(number)
  }, jsx("div", {
    className: styles$f.teleMarketingIconBox
  }, jsx("img", {
    className: styles$f.teleMarketingIcon,
    src: teleMarketingIcon.url,
    alt: "teleMarketingIcon"
  })), number)), banners && banners.length > 0 && banners.map(function (_ref2, index) {
    var image_mobile = _ref2.image_mobile,
      isnewtab = _ref2.isnewtab,
      url = _ref2.url;
    return image_mobile && image_mobile.url && jsx("a", {
      key: "".concat(index, "_").concat(url),
      href: url,
      rel: "noreferrer noopener",
      target: isnewtab ? '_blank' : '_self',
      className: styles$f.monetizeBanner,
      onClick: function onClick() {
        var name = image_mobile.filename && "M ".concat(image_mobile.filename.replace(/\..+$/, ''));
        updateDigitalDataCookies({
          firstLevelItem: name,
          secondLevelItem: name,
          thirdLevelItem: name,
          postionOne: index + 1,
          postionTwo: 0,
          postionThree: 0,
          tag: NAVIGATION
        });
      }
    }, jsx("img", {
      className: styles$f.monetizeBannerImage,
      src: image_mobile.url
    }));
  })));
};
RestAccesses.propTypes = process.env.NODE_ENV !== "production" ? {
  downloadLink: PropTypes.object,
  telemarketing: PropTypes.object,
  banners: PropTypes.array
} : {};
RestAccesses.defaultProps = {
  downloadLink: {},
  teleMarketing: {},
  banners: []
};

var styles$g = {"sideBarTitle":"SidebarTitle-module_sideBarTitle__WTNhT","text":"SidebarTitle-module_text__19dhv","lineClamp":"SidebarTitle-module_lineClamp__myiOy","userName":"SidebarTitle-module_userName__2XoN6","backTitle":"SidebarTitle-module_backTitle__18nyN","closeIcon":"SidebarTitle-module_closeIcon__e-7vr","leftIcon":"SidebarTitle-module_leftIcon__2GenD"};

var SidebarTitle = function SidebarTitle(_ref) {
  var isMainMenu = _ref.isMainMenu,
    targetMenu = _ref.targetMenu,
    setActiveMenu = _ref.setActiveMenu,
    isUserLoggedIn = _ref.isUserLoggedIn,
    name = _ref.name,
    resetData = _ref.resetData;
  return isMainMenu ? jsx("div", {
    className: styles$g.sideBarTitle
  }, jsx("div", {
    className: classNames(styles$g.text, styles$g.lineClamp)
  }, "\xA1Hola", isUserLoggedIn && jsx(Fragment, null, ',', jsx("span", {
    className: styles$g.userName
  }, name)), "!"), jsx("div", {
    className: styles$g.closeIcon,
    onClick: function onClick() {
      return resetData();
    }
  })) : jsx("div", {
    className: styles$g.sideBarTitle
  }, jsx("div", {
    onClick: function onClick() {
      return setActiveMenu(targetMenu);
    },
    className: classNames(styles$g.text, styles$g.backTitle)
  }, jsx("span", {
    className: styles$g.leftIcon
  }), "Volver al men\xFA principal"), jsx("div", {
    className: styles$g.closeIcon,
    onClick: function onClick() {
      return resetData();
    }
  }));
};
SidebarTitle.propTypes = process.env.NODE_ENV !== "production" ? {
  isMainMenu: PropTypes.bool,
  targetMenu: PropTypes.string,
  setActiveMenu: PropTypes.func.isRequired,
  isUserLoggedIn: PropTypes.bool,
  name: PropTypes.string,
  resetData: PropTypes.func.isRequired
} : {};

var NEXTACCESS = 'nextAccess';
var FASTACCESS = 'fastAccess';
var MAIN_MENU = 'first-level-menu';
var SECOND_LEVEL_MENU = 'second-level-menu';
var THIRD_LEVEL_MENU = 'third-level-menu';
var THIRD_LEVEL_ACCESS = 'third-level-access';
var THIRD_LEVEL_FAST_ACCESS = 'third-level-fast-access';
var NEXT = 'next';
var GOBACK = 'goback';

var hasTag = function hasTag(itemName, tag) {
  return !isEmpty$1(tag) ? "".concat(itemName, " - ").concat(tag) : itemName;
};

var TaxonomyMobile = function TaxonomyMobile(_ref) {
  var taxonomyData = _ref.taxonomyData,
    showTaxonomy = _ref.showTaxonomy,
    hideMenu = _ref.hideMenu,
    header = _ref.header,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    setMenuVisible = _ref.setMenuVisible,
    isUserLoggedIn = _ref.isUserLoggedIn,
    firstName = _ref.firstName,
    tenant = _ref.tenant;
  var entry = header.entry;
  var isCmrPointsEnabled = get(header, 'entry.header_configs[0].toggles.iscmrenabled', false);
  var _taxonomyData$all_acc = taxonomyData.all_accesses,
    accesses = _taxonomyData$all_acc.accesses,
    categories = _taxonomyData$all_acc.categories,
    position = _taxonomyData$all_acc.category_position,
    _taxonomyData$logo = taxonomyData.logo,
    mobileLogo = _taxonomyData$logo.imagemobile,
    mobileLogoURL = _taxonomyData$logo.url,
    banner = taxonomyData.monetization_banners.banner,
    telemarketing = taxonomyData.ventatelef_nica,
    downloadLink = taxonomyData.app_item,
    fast_accesses = taxonomyData.fast_accesses;
  var _useState = useState(MAIN_MENU),
    _useState2 = _slicedToArray(_useState, 2),
    activeMenu = _useState2[0],
    setActiveMenu = _useState2[1];
  var _useState3 = useState(NEXT),
    _useState4 = _slicedToArray(_useState3, 2),
    menuHistory = _useState4[0],
    setMenuHistory = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    categoriesData = _useState6[0],
    setCategoriesData = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedSecondaryCategory = _useState8[0],
    setSelectedSecondaryCategory = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedTertiaryCategory = _useState10[0],
    setSelectedTertiaryCategory = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    categoryNextIndex = _useState12[0],
    setCategoryNextIndex = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    categoryPrevIndex = _useState14[0],
    setCategoryPrevIndex = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedSecondaryAccess = _useState16[0],
    setSelectedSecondaryAccess = _useState16[1];
  var IS_SEASONAL_COUNT = 0;
  var purchaseGuides = selectedTertiaryCategory.gu_as_de_compra;
  var checkAccessORFastAccess = selectedSecondaryAccess.second_level_access || selectedSecondaryAccess.child_items;
  var data = [];
  var offset = 0;
  var accessesIndex = [];
  var categoryDigitalDataIndex = 0;
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    globalPosition = _useState18[0],
    setGlobalPosition = _useState18[1];
  var showMenu = function showMenu(index, childIndex, type) {
    if (activeMenu === MAIN_MENU && type === NEXTACCESS) {
      setSelectedSecondaryAccess(accesses[index].items[childIndex]);
      setMenuHistory(NEXT);
      setActiveMenu(THIRD_LEVEL_ACCESS);
    } else if (activeMenu === MAIN_MENU && type === FASTACCESS) {
      var isLogin = isUserLoggedIn ? 'login_items' : 'not_logged_items';
      setSelectedSecondaryAccess(fast_accesses[isLogin][index]);
      setMenuHistory(NEXT);
      setActiveMenu(THIRD_LEVEL_FAST_ACCESS);
    } else if (activeMenu === MAIN_MENU) {
      setCategoryPrevIndex(index);
      setSelectedSecondaryCategory(categories[index]);
      setMenuHistory(NEXT);
      setActiveMenu(SECOND_LEVEL_MENU);
    } else if (activeMenu === SECOND_LEVEL_MENU) {
      setCategoryNextIndex(index);
      setSelectedTertiaryCategory(selectedSecondaryCategory.second_level_categories[index]);
      setMenuHistory(GOBACK);
      setActiveMenu(THIRD_LEVEL_MENU);
    }
  };
  var resetData = function resetData() {
    setMenuVisible(false);
  };
  useEffect(function () {
    if (showTaxonomy) {
      setActiveMenu(MAIN_MENU);
    }
  }, [showTaxonomy]);
  var getCategoryDigitalData = function getCategoryDigitalData(index) {
    var isPurchaseGuide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (activeMenu === MAIN_MENU) {
      var indexOfMenu = index - categoryDigitalDataIndex;
      var name = hasTag(categories[indexOfMenu].item_name, categories[indexOfMenu].tag);
      updateDigitalDataCookies({
        firstLevelItem: name,
        secondLevelItem: name,
        thirdLevelItem: name,
        postionOne: index,
        postionTwo: 0,
        postionThree: 0,
        tag: NAVIGATION
      });
    }
    if (activeMenu === SECOND_LEVEL_MENU) {
      var _indexOfMenu = index - 1;
      var _name = selectedSecondaryCategory.second_level_categories[_indexOfMenu].item_name;
      updateDigitalDataCookies({
        firstLevelItem: categories[_indexOfMenu].item_name,
        secondLevelItem: _name,
        thirdLevelItem: _name,
        postionOne: globalPosition,
        postionTwo: index,
        postionThree: 0,
        tag: NAVIGATION
      });
    }
    if (activeMenu === THIRD_LEVEL_MENU) {
      var firstSelectedItem = hasTag(categories[categoryPrevIndex].item_name, categories[categoryPrevIndex].tag);
      var secondSelectedItem = selectedSecondaryCategory.second_level_categories[categoryNextIndex].item_name && selectedSecondaryCategory.second_level_categories[categoryNextIndex].item_name;
      var thirdSelectedItem;
      if (!isPurchaseGuide) {
        thirdSelectedItem = selectedTertiaryCategory && selectedTertiaryCategory.third_level_categories && selectedTertiaryCategory.third_level_categories.length > 0 && hasTag(selectedTertiaryCategory.third_level_categories[index - 1].item_name, selectedTertiaryCategory.third_level_categories[index - 1].tag);
      } else {
        thirdSelectedItem = 'Guía de compra';
      }
      var selondItemPosition = categoryNextIndex + 1;
      var thirdItemPosition = index;
      updateDigitalDataCookies({
        firstLevelItem: firstSelectedItem,
        secondLevelItem: secondSelectedItem,
        thirdLevelItem: thirdSelectedItem,
        postionOne: globalPosition,
        postionTwo: selondItemPosition,
        postionThree: thirdItemPosition,
        tag: NAVIGATION
      });
    }
  };
  useEffect(function () {
    accesses.forEach(function (element, index) {
      if (index === position - 1) {
        categoryDigitalDataIndex = offset + 1;
        offset += categories.length;
      }
      accessesIndex.push(offset + 1);
      offset += element.items.length;
    });
    if (position === 4) {
      categoryDigitalDataIndex = offset + 1;
    }
    var getCategoryData = function getCategoryData(accessIndex) {
      if (!categories || !categories.length) {
        return null;
      }
      return jsx("div", {
        className: styles$b.categoryBox,
        key: "accesses-insert-".concat(accessIndex)
      }, categories.map(function (y, index) {
        var is_Seasonal_Flag = false;
        if (y.is_seasonal) {
          IS_SEASONAL_COUNT += 1;
          is_Seasonal_Flag = IS_SEASONAL_COUNT <= 3;
        }
        return y && y.canal && y.canal.addmobile && jsx(Categories, {
          showMenu: showMenu,
          data: y,
          key: "category-".concat(index),
          index: index,
          is_Seasonal_Flag: is_Seasonal_Flag,
          getCategoryDigitalData: getCategoryDigitalData,
          setGlobalPosition: setGlobalPosition,
          offset: categoryDigitalDataIndex
        });
      }));
    };
    var nextAccesses = accesses.map(function (x, index) {
      return jsx("div", {
        className: styles$b.categoryBox,
        key: "accesses-".concat(index)
      }, jsx(NextAccesses, {
        showMenu: showMenu,
        data: x,
        itemIndex: index,
        setGlobalPosition: setGlobalPosition,
        offset: accessesIndex[index]
      }));
    });
    nextAccesses.splice(position - 1, 0, getCategoryData(position));
    var categoryLevel = selectedTertiaryCategory && selectedTertiaryCategory.third_level_categories && selectedTertiaryCategory.third_level_categories.length > 0 && activeMenu === THIRD_LEVEL_MENU ? selectedTertiaryCategory.third_level_categories : selectedSecondaryCategory.second_level_categories && selectedSecondaryCategory.second_level_categories;
    activeMenu !== MAIN_MENU ? categoryLevel && categoryLevel.length > 0 && categoryLevel.map(function (y, index) {
      return data.push(jsx(Categories, {
        showMenu: showMenu,
        data: y,
        key: "category-".concat(index, "-").concat(activeMenu),
        index: index,
        goToMenu: activeMenu,
        classes: styles$b.subCategories,
        getCategoryDigitalData: getCategoryDigitalData
      }));
    }) : [nextAccesses && data.push(nextAccesses)];
    setCategoriesData(data);
    return function () {
      setCategoriesData([]);
      data = [];
    };
  }, [activeMenu]);
  var getBrandLogo = function getBrandLogo() {
    return jsx("div", {
      className: styles$b.brandLogo
    }, mobileLogo && jsx("a", {
      target: "_self",
      className: styles$b.logoBox,
      href: mobileLogoURL
    }, jsx("img", {
      src: mobileLogo.url
    })));
  };
  var getSidebarTitle = function getSidebarTitle() {
    return jsx(SidebarTitle, {
      isMainMenu: activeMenu === MAIN_MENU,
      targetMenu: activeMenu === THIRD_LEVEL_MENU ? SECOND_LEVEL_MENU : MAIN_MENU,
      setActiveMenu: setActiveMenu,
      setMenuVisible: setMenuVisible,
      isUserLoggedIn: isUserLoggedIn,
      name: firstName,
      resetData: resetData
    });
  };
  return jsx(CSSTransition, {
    in: showTaxonomy,
    classNames: "container-open",
    appear: true,
    timeout: 0
  }, jsx(Fragment, null, jsx("div", {
    className: styles$b.TaxonomyMobile
  }, jsx(CSSTransition, {
    in: activeMenu === MAIN_MENU,
    classNames: "left",
    unmountOnExit: true,
    timeout: 0
  }, jsx("div", {
    className: styles$b.container
  }, getSidebarTitle(), jsx("div", {
    className: styles$b.scrollWrapper
  }, jsx("div", {
    className: styles$b.fastAccessesBox
  }, jsx(FastAccesses, {
    data: fast_accesses,
    showMenu: showMenu,
    isCmrPointsEnabled: isCmrPointsEnabled,
    isUserLoggedIn: isUserLoggedIn,
    tenant: tenant
  })), categoriesData && categoriesData, jsx(RestAccesses, {
    downloadLink: downloadLink,
    telemarketing: telemarketing,
    banners: banner
  }), getBrandLogo()))), jsx(CSSTransition, {
    in: activeMenu === SECOND_LEVEL_MENU,
    classNames: menuHistory === NEXT ? 'right' : 'left',
    unmountOnExit: true,
    timeout: 0
  }, jsx("div", {
    className: styles$b.container
  }, getSidebarTitle(), categories[categoryPrevIndex] && jsx("div", {
    className: styles$b.subCategoryMainTitle
  }, categories[categoryPrevIndex].item_url ? jsx("a", {
    href: categories[categoryPrevIndex].item_url,
    rel: "noreferrer noopener",
    target: "_self",
    onClick: function onClick() {
      var name = hasTag(categories[categoryPrevIndex].item_name, categories[categoryPrevIndex].tag);
      updateDigitalDataCookies({
        firstLevelItem: name,
        secondLevelItem: name,
        thirdLevelItem: name,
        postionOne: globalPosition,
        postionTwo: 0,
        postionThree: 0,
        tag: NAVIGATION
      });
    }
  }, jsx("div", {
    className: styles$b.iconWrapper
  }, categories[categoryPrevIndex].image_web && categories[categoryPrevIndex].image_web.url && jsx("img", {
    className: styles$b.icon,
    src: categories[categoryPrevIndex].image_web.url
  })), categories[categoryPrevIndex].item_name && categories[categoryPrevIndex].item_name) : jsx(Fragment, null, jsx("div", {
    className: styles$b.iconWrapper
  }, categories[categoryPrevIndex].image_web && categories[categoryPrevIndex].image_web.url && jsx("img", {
    className: styles$b.icon,
    src: categories[categoryPrevIndex].image_web.url
  })), categories[categoryPrevIndex].item_name && categories[categoryPrevIndex].item_name)), jsx("div", {
    className: classNames(styles$b.scrollWrapper, styles$b.innerCategories)
  }, jsx("div", {
    className: styles$b.Wrapper
  }, categories[categoryPrevIndex] && categories[categoryPrevIndex].ver_todo && categories[categoryPrevIndex].ver_todo.title && jsx("div", {
    className: styles$b.verTodoBox
  }, jsx("a", {
    rel: "noreferrer noopener",
    target: "_self",
    className: styles$b.verTodo,
    href: categories[categoryPrevIndex].ver_todo.href,
    onClick: function onClick() {
      updateDigitalDataCookies({
        firstLevelItem: categories[categoryPrevIndex].item_name,
        secondLevelItem: categories[categoryPrevIndex].ver_todo.title,
        thirdLevelItem: categories[categoryPrevIndex].ver_todo.title,
        postionOne: globalPosition,
        postionTwo: 0,
        postionThree: 0,
        tag: NAVIGATION
      });
    }
  }, categories[categoryPrevIndex].ver_todo.title)), categoriesData && categoriesData), jsx("div", {
    className: styles$b.Wrapper
  }, getBrandLogo())))), jsx(CSSTransition, {
    in: activeMenu === THIRD_LEVEL_MENU,
    classNames: "right",
    unmountOnExit: true,
    timeout: 0
  }, jsx("div", {
    className: styles$b.container
  }, getSidebarTitle(), jsx("div", {
    className: classNames(styles$b.subCategoryMainTitle, styles$b.thirdCategoryTitle)
  }, selectedSecondaryCategory && selectedSecondaryCategory.second_level_categories && selectedSecondaryCategory.second_level_categories[categoryNextIndex] && selectedSecondaryCategory.second_level_categories[categoryNextIndex].item_name && selectedSecondaryCategory.second_level_categories[categoryNextIndex].item_name), jsx("div", {
    className: classNames(styles$b.scrollWrapper, styles$b.innerCategories)
  }, jsx("div", {
    className: styles$b.Wrapper
  }, categoriesData && categoriesData), jsx("div", {
    className: styles$b.Wrapper
  }, purchaseGuides && purchaseGuides.length > 0 && jsx("div", {
    className: styles$b.purchaseGuides
  }, purchaseGuides.map(function (_ref2, index) {
    var url_mob = _ref2.url_mob,
      text_mobile = _ref2.text_mobile,
      image_mobile = _ref2.image_mobile;
    return jsx("a", {
      href: url_mob,
      rel: "noreferrer noopener",
      target: "_self",
      key: index,
      className: styles$b.purchaseGuide,
      onClick: function onClick() {
        getCategoryDigitalData(index + 1, true);
      }
    }, jsx("div", {
      className: styles$b.purchaseText
    }, text_mobile && text_mobile), jsx("img", {
      className: styles$b.purchaseImage,
      src: image_mobile && image_mobile.url
    }));
  })), getBrandLogo())))), jsx(CSSTransition, {
    in: activeMenu === THIRD_LEVEL_ACCESS || activeMenu === THIRD_LEVEL_FAST_ACCESS,
    classNames: "right",
    unmountOnExit: true,
    timeout: 0
  }, jsx("div", {
    className: styles$b.container
  }, getSidebarTitle(), jsx("div", {
    className: styles$b.accessesTitleWrapper
  }, jsx("div", {
    className: styles$b.accessesTitle
  }, selectedSecondaryAccess.icon && selectedSecondaryAccess.icon.url && jsx("div", {
    className: styles$b.iconBox
  }, jsx("img", {
    className: styles$b.icon,
    src: selectedSecondaryAccess.icon.url
  })), selectedSecondaryAccess.item_name)), jsx("div", {
    className: classNames(styles$b.scrollWrapper, styles$b.innerAccesses)
  }, jsx("div", {
    className: styles$b.Wrapper
  }, checkAccessORFastAccess && checkAccessORFastAccess.length > 0 && checkAccessORFastAccess.map(function (_ref3, index) {
    var child_name = _ref3.child_name,
      is_new_tab = _ref3.is_new_tab,
      url = _ref3.url;
    return jsx("div", {
      className: styles$b.accesseswrapper,
      key: index
    }, jsx("a", {
      rel: "noreferrer noopener",
      target: is_new_tab ? '_blank' : '_self',
      className: styles$b.accesses,
      href: url,
      onClick: function onClick() {
        updateDigitalDataCookies({
          firstLevelItem: selectedSecondaryAccess.item_name,
          secondLevelItem: child_name,
          thirdLevelItem: child_name,
          postionOne: globalPosition,
          postionTwo: index + 1,
          postionThree: 0,
          tag: NAVIGATION
        });
      }
    }, child_name));
  })), jsx("div", {
    className: styles$b.Wrapper
  }, getBrandLogo()))))), showTaxonomy && jsx(TaxonomyOverlay, {
    isMarketPlace: true,
    hideMenu: hideMenu,
    isAgentLoggedIn: isAgentLoggedIn,
    isVendorLoggedIn: isVendorLoggedIn,
    classes: styles$b.overlay,
    allowScroll: false
  })));
};
TaxonomyMobile.defaultProps = {
  showTaxonomy: false,
  taxonomyData: {
    all_accesses: {
      accesses: [],
      categories: [],
      category_position: 1
    },
    logo: {
      imagemobile: {
        url: ''
      },
      url: ''
    },
    monetization_banners: {},
    ventatelef_nica: {
      title: ''
    },
    app_item: {},
    fast_accesses: {}
  },
  header: {}
};
TaxonomyMobile.propTypes = process.env.NODE_ENV !== "production" ? {
  hideMenu: PropTypes.func.isRequired,
  showTaxonomy: PropTypes.bool,
  header: PropTypes.object,
  firstName: PropTypes.string
} : {};
var TaxonomyMobile$1 = withUser(TaxonomyMobile);

var styles$h = {"TaxonomyDesktop":"TaxonomyDesktop-module_TaxonomyDesktop__38GRl","sidebar":"TaxonomyDesktop-module_sidebar__37RX6","sideBarTitle":"TaxonomyDesktop-module_sideBarTitle__3b1gn","userName":"TaxonomyDesktop-module_userName__2u4_9","text":"TaxonomyDesktop-module_text__u1uBt","closeIcon":"TaxonomyDesktop-module_closeIcon__2X3P0","scrollWrapper":"TaxonomyDesktop-module_scrollWrapper__3Pu06","Box":"TaxonomyDesktop-module_Box__1zcT3","categoryWrapper":"TaxonomyDesktop-module_categoryWrapper__3YBaF","brandLogo":"TaxonomyDesktop-module_brandLogo__1bbD8","logo":"TaxonomyDesktop-module_logo__15yuB","overlay":"TaxonomyDesktop-module_overlay__zWBPM"};

var styles$i = {"categories":"FirstLevelCategories-module_categories__x82VK","active":"FirstLevelCategories-module_active__1Ry2f","categoryTitle":"FirstLevelCategories-module_categoryTitle__1PTiQ","seasonal":"FirstLevelCategories-module_seasonal__2DMzf","label":"FirstLevelCategories-module_label__uOWnb","chevronRightIcon":"FirstLevelCategories-module_chevronRightIcon__3qHuv"};

var NavigationRight = function NavigationRight(_ref) {
  var active = _ref.active;
  return jsx("svg", {
    width: "9",
    height: "16",
    viewBox: "0 0 9 16"
  }, jsx("path", {
    d: "M1 2.21355L1.88055 1.33301L8.54721 7.99967L1.88055 14.6663L1 13.7858L6.78612 7.99967L1 2.21355Z",
    fill: !active ? '#767676' : 'var(--primary-theme-color)',
    stroke: !active ? '#767676' : 'var(--primary-theme-color)',
    strokeWidth: "0.5"
  }));
};
NavigationRight.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool
} : {};
NavigationRight.defaultProps = {
  active: false
};

var FirstLevelCategories = function FirstLevelCategories(_ref) {
  var data = _ref.data,
    index = _ref.index,
    showMenuHover = _ref.showMenuHover,
    isSeasonalFlag = _ref.isSeasonalFlag,
    categoryDigitalDataIndex = _ref.categoryDigitalDataIndex;
  var itemName = data.item_name,
    secondLevelCategories = data.second_level_categories,
    tag = data.tag,
    itemUrl = data.item_url;
  var hasSubcategory = Array.isArray(secondLevelCategories) && secondLevelCategories.length > 0;
  return jsx(Fragment, null, hasSubcategory ? jsx(Fragment, null, itemName && jsx("div", {
    className: classNames(styles$i.categories, _defineProperty({}, styles$i.active, showMenuHover === index))
  }, jsx(Fragment, null, jsx("div", {
    className: classNames(styles$i.categoryTitle, _defineProperty({}, styles$i.seasonal, isSeasonalFlag))
  }, itemName, !isEmpty$1(tag) && jsx("span", {
    className: styles$i.label
  }, tag)), jsx("div", {
    className: styles$i.chevronRightIcon
  }, jsx(NavigationRight, {
    active: showMenuHover === index
  }))))) : jsx("a", {
    rel: "noreferrer noopener",
    target: "_self",
    className: classNames(styles$i.categories, _defineProperty({}, styles$i.active, showMenuHover === index)),
    href: itemUrl,
    onClick: function onClick() {
      return updateDigitalDataCookies({
        firstLevelItem: hasTag(itemName, tag),
        secondLevelItem: hasTag(itemName, tag),
        thirdLevelItem: hasTag(itemName, tag),
        postionOne: categoryDigitalDataIndex,
        postionTwo: 0,
        postionThree: 0,
        tag: NAVIGATION
      });
    }
  }, jsx("div", {
    className: classNames(styles$i.categoryTitle, _defineProperty({}, styles$i.seasonal, isSeasonalFlag))
  }, itemName, !isEmpty$1(tag) && jsx("span", {
    className: styles$i.label
  }, tag))));
};
FirstLevelCategories.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object,
  index: PropTypes.number,
  showMenuHover: PropTypes.number,
  isSeasonalFlag: PropTypes.bool
} : {};
FirstLevelCategories.defaultProps = {
  data: {}
};

var styles$j = {"monetizeWrapper":"GlobalMonetizationBanners-module_monetizeWrapper__Xeg6_","imageWrapper":"GlobalMonetizationBanners-module_imageWrapper__bSUro","image":"GlobalMonetizationBanners-module_image__1YrKB","medium":"GlobalMonetizationBanners-module_medium__3EyaU","small":"GlobalMonetizationBanners-module_small__3kqUX"};

var GlobalMonetizationBanners = function GlobalMonetizationBanners(_ref) {
  var monetizeBanners = _ref.monetizeBanners;
  var size = monetizeBanners.size,
    banner = monetizeBanners.banner;
  var count = size === 'small' ? 3 : [size === 'medium' ? 2 : 1];
  var banners = banner.slice(0, count);
  return jsx("div", {
    className: styles$j.monetizeWrapper
  }, banners.map(function (_ref2, index) {
    var image = _ref2.image_desktop,
      isnewtab = _ref2.isnewtab,
      url = _ref2.url;
    return jsx("a", {
      className: classNames(styles$j.imageWrapper, styles$j["".concat(size)]),
      href: url,
      target: isnewtab ? '_blank' : '_self',
      rel: "noreferrer",
      key: index,
      onClick: function onClick() {
        var name = image.filename && "M ".concat(image.filename.replace(/\..+$/, ''));
        updateDigitalDataCookies({
          firstLevelItem: name,
          secondLevelItem: name,
          thirdLevelItem: name,
          postionOne: index + 1,
          postionTwo: 0,
          postionThree: 0,
          tag: NAVIGATION
        });
      }
    }, jsx("img", {
      className: styles$j.image,
      src: image.url
    }));
  }));
};
GlobalMonetizationBanners.propTypes = process.env.NODE_ENV !== "production" ? {
  monetizeBanners: PropTypes.object
} : {};
GlobalMonetizationBanners.defaultProps = {
  monetizeBanners: {}
};

var styles$k = {"secondLevelMenuContainer":"SecondLevelCategories-module_secondLevelMenuContainer__3ZDAW","scrollContainer":"SecondLevelCategories-module_scrollContainer__2nHQf","subCategoryContent":"SecondLevelCategories-module_subCategoryContent__3L7Af","banners":"SecondLevelCategories-module_banners__pExml","purchaseGuide":"SecondLevelCategories-module_purchaseGuide__1CJb4","purchaseText":"SecondLevelCategories-module_purchaseText__2eIwX","purchaseImage":"SecondLevelCategories-module_purchaseImage__12erc","banner":"SecondLevelCategories-module_banner__2bGIB","small":"SecondLevelCategories-module_small__36Ntw","medium":"SecondLevelCategories-module_medium__3bVCU","large":"SecondLevelCategories-module_large__3xmIf","bannerImage":"SecondLevelCategories-module_bannerImage__2ljqw","BottomPosition":"SecondLevelCategories-module_BottomPosition__3L__n","bannerBox":"SecondLevelCategories-module_bannerBox__2MKR4","secondLevelMenuItemsBox":"SecondLevelCategories-module_secondLevelMenuItemsBox__2i00Y","secondLevelMenuContain":"SecondLevelCategories-module_secondLevelMenuContain__1b2Fs","secondLevelMenuItems":"SecondLevelCategories-module_secondLevelMenuItems__1_njT","secondLevelCategory":"SecondLevelCategories-module_secondLevelCategory__3SPXi","secondLevelCategoryTitle":"SecondLevelCategories-module_secondLevelCategoryTitle__13Ukq","link":"SecondLevelCategories-module_link__1WiMw","thirdLevelCategory":"SecondLevelCategories-module_thirdLevelCategory__2ZQFF","verTodo":"SecondLevelCategories-module_verTodo__-uHwY","label":"SecondLevelCategories-module_label__2qKBe","subCategoryMainTitleWrapper":"SecondLevelCategories-module_subCategoryMainTitleWrapper__2TL4V","vertodo":"SecondLevelCategories-module_vertodo__2_Cga","subCategoryMainTitle":"SecondLevelCategories-module_subCategoryMainTitle__Z7Sds","title":"SecondLevelCategories-module_title__14DJx","iconWrapper":"SecondLevelCategories-module_iconWrapper__1hhdw","icon":"SecondLevelCategories-module_icon__1Pyjz"};

var ThirdLevelCategories = function ThirdLevelCategories(_ref) {
  var thirdLevelCategories = _ref.thirdLevelCategories,
    FirstCategoryTitle = _ref.FirstCategoryTitle,
    SecondCategoryTitle = _ref.SecondCategoryTitle,
    categoryDigitalDataIndex = _ref.categoryDigitalDataIndex,
    secondCategoryDigitalDataIndex = _ref.secondCategoryDigitalDataIndex;
  return thirdLevelCategories && thirdLevelCategories.map(function (_ref2, index) {
    var name = _ref2.item_name,
      url = _ref2.item_url,
      isVerTodo = _ref2.is_ver_todo,
      tag = _ref2.tag;
    return jsx("li", {
      className: classNames(styles$k.thirdLevelCategory, _defineProperty({}, styles$k.verTodo, isVerTodo)),
      key: index
    }, jsx("a", {
      rel: "noreferrer noopener",
      target: "_self",
      href: url,
      onClick: function onClick() {
        updateDigitalDataCookies({
          firstLevelItem: FirstCategoryTitle,
          secondLevelItem: SecondCategoryTitle,
          thirdLevelItem: hasTag(name, tag),
          postionOne: categoryDigitalDataIndex,
          postionTwo: secondCategoryDigitalDataIndex,
          postionThree: index + 1,
          tag: NAVIGATION
        });
      }
    }, name, !isEmpty$1(tag) && jsx("span", {
      className: styles$k.label
    }, tag)));
  });
};

var SecondLevelCategories = function SecondLevelCategories(_ref) {
  var number = _ref.number,
    data = _ref.data,
    categoryDigitalDataIndex = _ref.categoryDigitalDataIndex;
  var FirstCategoryTitle = data.item_name,
    FirstCategoryURL = data.item_url,
    firstLevelTag = data.tag,
    verTodo = data.ver_todo,
    image = data.image_web,
    subMonetizeBanners = data.monetization_banner,
    monetizeBannerPosition = data.position_bottom,
    subCategory = data.second_level_categories,
    purchaseGuides = data.gu_as_de_compra;
  var itemBox = useRef(null);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    categoryWidth = _useState2[0],
    setCategoryWidth = _useState2[1];
  useEffect(function () {
    if (itemBox) {
      setCategoryWidth(itemBox.current.scrollWidth);
    }
    return function () {
      setCategoryWidth(0);
    };
  }, [number]);
  return jsx("div", {
    className: styles$k.secondLevelMenuContainer
  }, jsx("div", {
    className: styles$k.scrollContainer
  }, jsx("div", {
    className: styles$k.subCategoryMainTitleWrapper
  }, jsx("div", {
    className: styles$k.subCategoryMainTitle
  }, jsx("div", {
    className: styles$k.iconWrapper
  }, image.url && jsx("img", {
    className: styles$k.icon,
    src: image.url
  })), FirstCategoryURL ? jsx("a", {
    rel: "noreferrer noopener",
    target: "_self",
    className: styles$k.title,
    href: FirstCategoryURL,
    onClick: function onClick() {
      var name = hasTag(FirstCategoryTitle, firstLevelTag);
      updateDigitalDataCookies({
        firstLevelItem: name,
        secondLevelItem: name,
        thirdLevelItem: name,
        postionOne: categoryDigitalDataIndex,
        postionTwo: 0,
        postionThree: 0,
        tag: NAVIGATION
      });
    }
  }, FirstCategoryTitle) : jsx("div", {
    className: styles$k.title
  }, FirstCategoryTitle)), verTodo.title && verTodo.href && jsx("a", {
    target: "_self",
    href: verTodo.href,
    className: styles$k.vertodo,
    onClick: function onClick() {
      updateDigitalDataCookies({
        firstLevelItem: hasTag(FirstCategoryTitle, firstLevelTag),
        secondLevelItem: verTodo.title,
        thirdLevelItem: verTodo.title,
        postionOne: categoryDigitalDataIndex,
        postionTwo: 0,
        postionThree: 0,
        tag: NAVIGATION
      });
    }
  }, verTodo.title)), jsx("div", {
    className: classNames(styles$k.subCategoryContent, _defineProperty({}, styles$k.BottomPosition, monetizeBannerPosition))
  }, jsx("div", {
    ref: itemBox,
    style: {
      width: "".concat(categoryWidth + 32, "px")
    },
    className: classNames(styles$k.subCategoryInnerContent, styles$k.secondLevelMenuItemsBox)
  }, subCategory.map(function (_ref2, index) {
    var name = _ref2.item_name,
      url = _ref2.item_url,
      thirdLevelCategories = _ref2.third_level_categories;
    return jsx("ul", {
      className: styles$k.secondLevelCategory,
      key: index
    }, jsx("li", {
      className: styles$k.secondLevelCategoryTitle
    }, url ? jsx("a", {
      rel: "noreferrer noopener",
      target: "_self",
      className: styles$k.link,
      href: url,
      onClick: function onClick() {
        updateDigitalDataCookies({
          firstLevelItem: hasTag(FirstCategoryTitle, firstLevelTag),
          secondLevelItem: name,
          thirdLevelItem: name,
          postionOne: categoryDigitalDataIndex,
          postionTwo: index + 1,
          postionThree: 0,
          tag: NAVIGATION
        });
      }
    }, name) : name), jsx(ThirdLevelCategories, {
      key: index,
      thirdLevelCategories: thirdLevelCategories,
      FirstCategoryTitle: hasTag(FirstCategoryTitle, firstLevelTag),
      SecondCategoryTitle: name,
      categoryDigitalDataIndex: categoryDigitalDataIndex,
      secondCategoryDigitalDataIndex: index + 1
    }));
  })), (subMonetizeBanners && subMonetizeBanners.length > 0 || purchaseGuides && purchaseGuides.length > 0) && jsx("div", {
    className: styles$k.banners
  }, purchaseGuides && purchaseGuides.length > 0 && purchaseGuides.map(function (guide, index) {
    return jsx("a", {
      href: guide.url_desk,
      rel: "noreferrer noopener",
      target: "_self",
      key: index,
      className: styles$k.purchaseGuide,
      onClick: function onClick() {
        updateDigitalDataCookies({
          firstLevelItem: hasTag(FirstCategoryTitle, firstLevelTag),
          secondLevelItem: 'Guía de compra',
          thirdLevelItem: 'Guía de compra',
          postionOne: categoryDigitalDataIndex,
          postionTwo: 0,
          postionThree: 0,
          tag: NAVIGATION
        });
      }
    }, jsx("div", {
      className: styles$k.purchaseText
    }, guide.text_desktop && guide.text_desktop), jsx("img", {
      className: styles$k.purchaseImage,
      src: guide.image_desktop && guide.image_desktop.url
    }));
  }), subMonetizeBanners && subMonetizeBanners.length > 0 && jsx("div", {
    className: styles$k.bannerBox
  }, subMonetizeBanners.map(function (_ref3, index) {
    var url = _ref3.url,
      monetizeImage = _ref3.image,
      size = _ref3.size;
    return jsx("a", {
      key: index,
      href: url,
      target: "_self",
      className: classNames(styles$k.banner, styles$k["".concat(size)]),
      onClick: function onClick() {
        var name = monetizeImage.filename && "M ".concat(monetizeImage.filename.replace(/\..+$/, ''));
        updateDigitalDataCookies({
          firstLevelItem: hasTag(FirstCategoryTitle, firstLevelTag),
          secondLevelItem: name,
          thirdLevelItem: name,
          postionOne: categoryDigitalDataIndex,
          postionTwo: index + 1,
          postionThree: 0,
          tag: NAVIGATION
        });
      }
    }, jsx("img", {
      className: styles$k.bannerImage,
      src: monetizeImage.url,
      alt: monetizeImage.title
    }));
  }))))));
};
SecondLevelCategories.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object,
  number: PropTypes.number
} : {};
SecondLevelCategories.defaultProps = {
  data: {}
};

var styles$l = {"categoryWrapper":"NextAccesses-module_categoryWrapper__2HRxv","nextCategoryMainTitle":"NextAccesses-module_nextCategoryMainTitle__1E8W_","categories":"NextAccesses-module_categories__BPCVU","hasIcon":"NextAccesses-module_hasIcon__6qZif","iconBox":"NextAccesses-module_iconBox__1j22D","icon":"NextAccesses-module_icon__2j5DS","active":"NextAccesses-module_active__2B5Ns","categoryTitle":"NextAccesses-module_categoryTitle__1lWma","seasonal":"NextAccesses-module_seasonal__1cT_C","label":"NextAccesses-module_label__1fOoP","chevronRightIcon":"NextAccesses-module_chevronRightIcon__qtKkS","childItems":"NextAccesses-module_childItems__1IRH3","secondLevelAccess":"NextAccesses-module_secondLevelAccess__31Z-J"};

var NextAccesses$1 = function NextAccesses(_ref) {
  var data = _ref.data,
    showNextAccessMenu = _ref.showNextAccessMenu,
    parentIndex = _ref.parentIndex,
    showNextMenuHover = _ref.showNextMenuHover,
    nextDigitalDataIndex = _ref.nextDigitalDataIndex,
    globalIndexNext = _ref.globalIndexNext,
    globalNextParentName = _ref.globalNextParentName;
  var NextAccess = useRef(false);
  var parent = showNextMenuHover.parent,
    child = showNextMenuHover.child;
  var name = data.item_name,
    items = data.items;
  function checkNextAccessesPosition(index) {
    var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (NextAccess) {
      showNextAccessMenu(parentIndex, index, NextAccess.current.getBoundingClientRect().y, reset);
    }
  }
  return jsx(Fragment, null, jsx("div", {
    className: styles$l.categoryWrapper
  }, name && jsx("div", {
    className: styles$l.nextCategoryMainTitle
  }, name), Array.isArray(items) && items.length > 0 && jsx(Fragment, null, items.map(function (item, index) {
    return item.second_level_access && item.second_level_access.length > 0 ? jsx(Fragment, null, jsx("div", {
      className: classNames(styles$l.categories, _defineProperty(_defineProperty({}, styles$l.active, parent === parentIndex && child === index), styles$l.hasIcon, item.icon && item.icon.url)),
      ref: NextAccess,
      onMouseOver: function onMouseOver() {
        globalIndexNext(nextDigitalDataIndex + index);
        globalNextParentName(item.item_name);
        checkNextAccessesPosition(index);
      }
    }, jsx("div", {
      className: styles$l.categoryTitle
    }, item.icon && item.icon.url && jsx("div", {
      className: styles$l.iconBox
    }, jsx("img", {
      className: styles$l.icon,
      src: item.icon.url
    })), item.item_name), jsx("div", {
      className: styles$l.chevronRightIcon
    }, jsx(NavigationRight, {
      active: parent === parentIndex && child === index
    })))) : jsx("a", {
      rel: "noreferrer noopener",
      target: item.is_new_tab ? '_blank' : '_self',
      ref: NextAccess,
      className: classNames(styles$l.categories, _defineProperty(_defineProperty({}, styles$l.active, parent === parentIndex && child === index), styles$l.hasIcon, item.icon && item.icon.url)),
      href: item.url,
      onMouseOver: function onMouseOver() {
        globalIndexNext(nextDigitalDataIndex + index);
        globalNextParentName(item.item_name);
        checkNextAccessesPosition(index, true);
      },
      onClick: function onClick() {
        updateDigitalDataCookies({
          firstLevelItem: item.item_name,
          secondLevelItem: item.item_name,
          thirdLevelItem: item.item_name,
          postionOne: nextDigitalDataIndex + index,
          postionTwo: 0,
          postionThree: 0,
          tag: NAVIGATION
        });
      }
    }, jsx("div", {
      className: styles$l.categoryTitle
    }, item.icon && item.icon.url && jsx("div", {
      className: styles$l.iconBox
    }, jsx("img", {
      className: styles$l.icon,
      src: item.icon.url
    })), item.item_name));
  }))));
};
NextAccesses$1.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.object,
  showNextAccessMenu: PropTypes.func.isRequired,
  parentIndex: PropTypes.number,
  showNextMenuHover: PropTypes.object
} : {};
NextAccesses$1.defaultProps = {
  data: {}
};

var styles$m = {"popupWrapper":"NextAccessesPopup-module_popupWrapper__1eMvA","container":"NextAccessesPopup-module_container__Mxpz0","items":"NextAccessesPopup-module_items__L8Mo0"};

var NextAccessesPopup = function NextAccessesPopup(_ref) {
  var data = _ref.data,
    parentTopPosition = _ref.nextAccessTopPosition,
    hideMenuForSpecificArea = _ref.hideMenuForSpecificArea,
    globalNextParentName = _ref.globalNextParentName,
    nextDigitalDataIndex = _ref.nextDigitalDataIndex;
  var nextAccessHeight = useRef(null);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    popUpStyle = _useState2[0],
    setPopUpStyle = _useState2[1];
  useEffect(function () {
    var windowHeight = isWindow$1() ? window.innerHeight : {};
    var modifiedHeight = windowHeight - 59;
    var createPortion = windowHeight / 10;
    var topPortion = createPortion * 4;
    var middlePortion = topPortion + createPortion * 2;
    var parentMiddlePosition = parentTopPosition + 34;
    var subMenuHeight = nextAccessHeight && nextAccessHeight.current.scrollHeight;
    var halfOfSubMenuHeight = subMenuHeight / 2;
    if (parentMiddlePosition <= topPortion) {
      var space = parentTopPosition - 59 < halfOfSubMenuHeight;
      !space ? setPopUpStyle({
        top: "".concat(parentTopPosition - 64, "px"),
        transform: 'translateY(-30%)'
      }) : setPopUpStyle({
        top: '0px'
      });
    }
    if (parentMiddlePosition > topPortion && parentMiddlePosition <= middlePortion) {
      if (modifiedHeight < subMenuHeight) {
        setPopUpStyle({
          top: '0px'
        });
      } else {
        var _space = parentTopPosition > halfOfSubMenuHeight;
        var bottomPosition = Math.abs(modifiedHeight - parentTopPosition);
        _space ? setPopUpStyle({
          bottom: "".concat(bottomPosition, "px"),
          transform: 'translateY(50%)'
        }) : setPopUpStyle({
          top: '0px'
        });
      }
    }
    if (parentMiddlePosition > middlePortion) {
      if (subMenuHeight > modifiedHeight) {
        setPopUpStyle({
          top: '0px'
        });
      } else {
        var bottomSpaceCount = modifiedHeight - (parentTopPosition - 59);
        if (bottomSpaceCount <= 0) {
          setPopUpStyle({
            bottom: '0px'
          });
        } else {
          halfOfSubMenuHeight > bottomSpaceCount ? setPopUpStyle({
            bottom: "".concat(Math.abs(bottomSpaceCount), "px")
          }) : setPopUpStyle({
            bottom: "".concat(Math.abs(bottomSpaceCount), "px"),
            transform: 'translateY(50%)'
          });
        }
      }
    }
  }, [data, parentTopPosition]);
  return jsx("div", {
    className: classNames(styles$m.popupWrapper, 'popup-container'),
    onClick: function onClick(e) {
      return hideMenuForSpecificArea(e, 'popup-container');
    }
  }, jsx("div", {
    ref: nextAccessHeight,
    className: styles$m.container,
    style: popUpStyle
  }, data.map(function (_ref2, index) {
    var name = _ref2.child_name,
      isNewTab = _ref2.is_new_tab,
      url = _ref2.url;
    return jsx("a", {
      className: styles$m.items,
      href: url,
      rel: "noreferrer noopener",
      targer: isNewTab ? '_blank' : '_self',
      key: index,
      onClick: function onClick() {
        return updateDigitalDataCookies({
          firstLevelItem: globalNextParentName,
          secondLevelItem: name,
          thirdLevelItem: name,
          postionOne: nextDigitalDataIndex,
          postionTwo: index + 1,
          postionThree: 0,
          tag: NAVIGATION
        });
      }
    }, name);
  })));
};

var TaxonomyDesktop = function TaxonomyDesktop(_ref) {
  var taxonomyData = _ref.taxonomyData,
    showTaxonomy = _ref.showTaxonomy,
    hideMenu = _ref.hideMenu,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    setMenuVisible = _ref.setMenuVisible,
    isUserLoggedIn = _ref.isUserLoggedIn,
    firstName = _ref.firstName;
  var CATEGOROIES = 'categories';
  var NEXTACCESS = 'nextaccess';
  var _taxonomyData$all_acc = taxonomyData.all_accesses,
    accesses = _taxonomyData$all_acc.accesses,
    categories = _taxonomyData$all_acc.categories,
    position = _taxonomyData$all_acc.category_position,
    logo = taxonomyData.logo,
    monetizationBanners = taxonomyData.monetization_banners;
  var offset = 0;
  var accessesIndex = [];
  var categoryIndex = 0;
  accesses.forEach(function (element, index) {
    if (index === position - 1) {
      categoryIndex = offset + 1;
      offset += categories.length;
    }
    accessesIndex.push(offset + 1);
    offset += element.items.length;
  });
  if (position === 4) {
    categoryIndex = offset + 1;
  }
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    globalIndex = _useState2[0],
    setGlobalIndex = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    globalNextParentName = _useState4[0],
    setGlobalNextParentName = _useState4[1];
  var _useState5 = useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    showMenuHover = _useState6[0],
    setShowMenuHover = _useState6[1];
  var _useState7 = useState(-1),
    _useState8 = _slicedToArray(_useState7, 2),
    number = _useState8[0],
    setNumber = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedItem = _useState10[0],
    setSelectedItem = _useState10[1];
  var IS_SEASONAL_COUNT = 0;
  var _useState11 = useState({
      parent: -1,
      child: -1
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    showNextMenuHover = _useState12[0],
    setShowNextMenuHover = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedNextAccesses = _useState14[0],
    setSelectedNextAccesses = _useState14[1];
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    nextAccessPosition = _useState16[0],
    setNextAccessPosition = _useState16[1];
  var resetData = function resetData(type) {
    switch (type) {
      case CATEGOROIES:
        setSelectedItem({});
        setNumber(-1);
        break;
      case NEXTACCESS:
        setNextAccessPosition(0);
        setSelectedNextAccesses([]);
        break;
    }
  };
  var showCategoryMenu = function showCategoryMenu(menuNumber) {
    var hasChild = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    setShowNextMenuHover(-1);
    setShowMenuHover(menuNumber);
    resetData(NEXTACCESS);
    if (hasChild) {
      setSelectedItem(categories[menuNumber]);
      setNumber(menuNumber);
    } else {
      resetData(CATEGOROIES);
    }
  };
  var isArray = selectedItem && Array.isArray(selectedItem.second_level_categories);
  var subCategory = isArray && selectedItem.second_level_categories.length > 0 && selectedItem.second_level_categories;
  var notHaveNextAccesses = selectedNextAccesses && selectedNextAccesses.length === 0;
  var hasMonetizeBanner = monetizationBanners && monetizationBanners.banner && monetizationBanners.banner.length > 0;
  function showNextAccessMenu(parentIndex, index, topPosition) {
    var reset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    setShowMenuHover(-1);
    var hoverData = {
      parent: parentIndex,
      child: index
    };
    if (reset) {
      resetData(NEXTACCESS);
      setShowNextMenuHover(hoverData);
    }
    resetData(CATEGOROIES);
    setNextAccessPosition(topPosition);
    setSelectedNextAccesses(accesses[parentIndex].items[index].second_level_access);
    setShowNextMenuHover(hoverData);
  }
  var getCategory = function getCategory(category, index, isSeasonalFlag) {
    if (category && category.canal && category.canal.adddesktop) {
      var secondLevelCategories = category.second_level_categories;
      var hasSubcategory = Array.isArray(secondLevelCategories) && secondLevelCategories.length > 0;
      return jsx("div", {
        className: styles$h.categoryWrapper,
        onMouseOver: function onMouseOver() {
          setGlobalIndex(categoryIndex + index);
          showCategoryMenu(index, hasSubcategory);
        },
        key: "".concat(index, "_").concat(category.item_name)
      }, jsx(FirstLevelCategories, {
        showMenuHover: showMenuHover,
        data: category,
        key: "category-".concat(index),
        index: index,
        isSeasonalFlag: isSeasonalFlag,
        categoryDigitalDataIndex: globalIndex
      }));
    }
    return null;
  };
  var getCategoryData = function getCategoryData(accessIndex) {
    return jsx("div", {
      className: styles$h.Box,
      key: "accesses-insert-".concat(accessIndex)
    }, categories.map(function (category, index) {
      var isSeasonalFlag = false;
      if (category.is_seasonal) {
        IS_SEASONAL_COUNT += 1;
        isSeasonalFlag = IS_SEASONAL_COUNT <= 3;
      }
      return getCategory(category, index, isSeasonalFlag);
    }));
  };
  var nextAccesses = accesses.map(function (access, index) {
    return jsx("div", {
      className: styles$h.Box,
      key: "accesses-".concat(index)
    }, jsx(NextAccesses$1, {
      showNextMenuHover: showNextMenuHover,
      showNextAccessMenu: showNextAccessMenu,
      data: access,
      parentIndex: index,
      nextDigitalDataIndex: accessesIndex[index],
      globalIndexNext: setGlobalIndex,
      globalNextParentName: setGlobalNextParentName
    }));
  });
  nextAccesses.splice(position - 1, 0, getCategoryData(position));
  var hideMenuForSpecificArea = function hideMenuForSpecificArea(event, classes) {
    if (event.target.classList.contains(classes)) {
      setMenuVisible(false);
      setSelectedItem(undefined);
      setShowMenuHover(undefined);
      setSelectedNextAccesses([]);
    }
  };
  return jsx(Fragment, null, jsx(CSSTransition, {
    in: showTaxonomy,
    timeout: 600,
    classNames: "sidebar-open",
    unmountOnExit: true
  }, jsx("div", {
    className: styles$h.TaxonomyDesktop,
    onClick: function onClick(e) {
      return hideMenuForSpecificArea(e, 'sidebar-open-enter-done');
    }
  }, jsx("div", {
    className: styles$h.sidebar
  }, jsx("div", {
    className: styles$h.sideBarTitle
  }, jsx("div", {
    className: styles$h.text
  }, "\xA1Hola", isUserLoggedIn && jsx(Fragment, null, ',', jsx("span", {
    className: styles$h.userName
  }, firstName)), "!"), jsx("div", {
    className: styles$h.closeIcon,
    onClick: function onClick() {
      setMenuVisible(false);
      setSelectedItem(undefined);
      setShowMenuHover(undefined);
    }
  })), jsx("div", {
    className: styles$h.scrollWrapper
  }, nextAccesses, logo && logo.imagedesktop && (logo.url ? jsx("a", {
    rel: "noreferrer noopener",
    target: "_self",
    href: logo.url,
    className: styles$h.brandLogo
  }, jsx("img", {
    className: styles$h.logo,
    src: logo.imagedesktop.url,
    alt: "falabella"
  })) : jsx("div", {
    className: styles$h.brandLogo
  }, jsx("img", {
    className: styles$h.logo,
    src: logo.imagedesktop.url,
    alt: "falabella"
  }))))), !subCategory && notHaveNextAccesses && showTaxonomy && hasMonetizeBanner && jsx(GlobalMonetizationBanners, {
    monetizeBanners: monetizationBanners
  }), subCategory && jsx(SecondLevelCategories, {
    data: selectedItem,
    number: number,
    categoryDigitalDataIndex: globalIndex
  }), selectedNextAccesses && selectedNextAccesses.length > 0 && jsx(NextAccessesPopup, {
    data: selectedNextAccesses,
    nextAccessTopPosition: nextAccessPosition,
    hideMenuForSpecificArea: hideMenuForSpecificArea,
    globalNextParentName: globalNextParentName,
    nextDigitalDataIndex: globalIndex
  }))), showTaxonomy && jsx(TaxonomyOverlay, {
    isMarketPlace: true,
    hideMenu: hideMenu,
    isAgentLoggedIn: isAgentLoggedIn,
    isVendorLoggedIn: isVendorLoggedIn,
    classes: styles$h.overlay,
    resetData: resetData
  }));
};
TaxonomyDesktop.propTypes = process.env.NODE_ENV !== "production" ? {
  taxonomyData: PropTypes.object,
  showTaxonomy: PropTypes.bool,
  hideMenu: PropTypes.func.isRequired,
  isAgentLoggedIn: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  setMenuVisible: PropTypes.func,
  isUserLoggedIn: PropTypes.bool,
  firstName: PropTypes.string
} : {};
TaxonomyDesktop.defaultProps = {
  showTaxonomy: false,
  taxonomyData: {
    all_accesses: {
      accesses: [],
      categories: [],
      category_position: 1
    },
    logo: '',
    monetization_banners: {}
  }
};
var TaxonomyDesktop$1 = withUser(TaxonomyDesktop);

var styles$n = {"HamburgerBtnWrapper":"Taxonomy-module_HamburgerBtnWrapper__2pCOT"};

var state = {
	rootCategories: [
		{
			subCategories: [
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Smart TV",
							isHighlightLink: false,
							link: "/category/cat10180/Televisores?sortBy=derived.price.search%2Cdesc"
						},
						{
							link: "/category/cat10172/Computacion",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Computación"
						},
						{
							isHighlightLink: false,
							link: "/category/cat10164/Audio",
							label: "Audio",
							meatStickerOption: 0
						},
						{
							isHighlightLink: true,
							link: "/category/cat10010/Tecnologia",
							label: "Ver todo"
						}
					],
					link: "/category/cat10010/Tecnologia",
					verTodoActive: true,
					label: "Tecnología"
				},
				{
					leafCategories: [
						{
							link: "/category/cat1020002/Linea-blanca",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Línea blanca"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Electrodomésticos de cocina",
							link: "/category/cat2620005/Electrodomesticos-de-cocina"
						},
						{
							label: "Electrodomésticos del hogar",
							isHighlightLink: false,
							link: "/category/cat2620007/Electrodomesticos-del-hogar",
							meatStickerOption: 0
						},
						{
							link: "/category/cat10036/Cuidado-personal",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cuidado personal"
						},
						{
							label: "Ver todo",
							link: "/category/cat10008/Electrodomesticos",
							isHighlightLink: true
						}
					],
					verTodoActive: true,
					link: "/category/cat10008/Electrodomesticos",
					label: "Electrodomésticos"
				}
			],
			label: "Electro y tecnología",
			link: "/category/cat5630001/Electro-y-tecnologia"
		},
		{
			label: "Deco hogar",
			subCategories: [
				{
					verTodoActive: true,
					link: "/category/cat10014/Deco-hogar",
					label: "Casa",
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Bazar",
							link: "/category/cat4920017/Bazar-cocina-y-comedor",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat20655/Decoracion",
							label: "Decoración"
						},
						{
							label: "Baño",
							isHighlightLink: false,
							link: "/category/cat20663/Bano",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/collection/ropa-de-cama",
							label: "Ropa de cama",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat20649/Almohadones",
							label: "Almohadones",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat10016/Muebles",
							meatStickerOption: 0,
							label: "Muebles"
						},
						{
							meatStickerOption: 0,
							label: "Libros",
							link: "/category/cat5820067/Libros",
							isHighlightLink: false
						},
						{
							link: "/category/cat10014/Deco-hogar",
							isHighlightLink: true,
							label: "Ver todo"
						}
					]
				}
			],
			link: "cat10014"
		},
		{
			subCategories: [
				{
					link: "/category/cat20139/Ropa-de-mujer",
					leafCategories: [
						{
							link: "/collection/abrigos-mujer",
							label: "Abrigos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Jeans y pantalones",
							link: "/category/cat20197/Jeans-y-pantalones"
						},
						{
							link: "/category/cat1230110/Camisas-y-blusas",
							label: "Camisas y blusas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat1230106/Remeras",
							label: "Remeras"
						},
						{
							meatStickerOption: 0,
							label: "Ropa interior",
							isHighlightLink: false,
							link: "/category/cat1040008/Ropa-interior"
						},
						{
							isHighlightLink: false,
							link: "/category/cat20357/Ropa-deportiva-mujer",
							meatStickerOption: 0,
							label: "Ropa deportiva"
						},
						{
							isHighlightLink: false,
							link: "/category/cat20141/Zapatos-de-mujer",
							meatStickerOption: 0,
							label: "Zapatos de mujer"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Zapatillas deportivas",
							link: "/category/cat20420/Zapatillas"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Accesorios",
							link: "/collection/accesorios-mujer"
						},
						{
							meatStickerOption: 0,
							label: "Tapabocas",
							isHighlightLink: false,
							link: "/category/cat5920002/Salud--mascaras-y-alcohol-en-gel?f.product.attribute.Tipo=Tapabocas"
						},
						{
							link: "/category/cat20139/Moda-mujer",
							label: "Ver todo",
							isHighlightLink: true
						}
					],
					label: "Mujer"
				},
				{
					link: "/category/cat20301/Moda-hombre",
					verTodoActive: true,
					label: "Hombre",
					leafCategories: [
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/abrigos-hombre",
							label: "Abrigos"
						},
						{
							link: "/collection/pantalones-hombre",
							label: "Jeans y pantalones",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat20159/Camisas",
							label: "Camisas"
						},
						{
							label: "Remeras y chombas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat20147/Remeras-y-chombas"
						},
						{
							label: "Trajes y sacos de vestir",
							link: "/category/cat4850029/Trajes-y-sacos-de-vestir",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat1040012/Ropa-interior",
							label: "Ropa interior",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Ropa deportiva",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat20359/Ropa-deportiva-hombre"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Zapatos",
							link: "/category/cat20133/Zapatos-de-hombre"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat20420/Zapatillas",
							isHighlightLink: false,
							label: "Zapatillas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat20313/Accesorios-hombre",
							label: "Accesorios",
							meatStickerOption: 0
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat20301/Moda-hombre"
						}
					]
				},
				{
					link: "/category/cat20355/Ropa-infantil",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Niños",
							link: "/category/cat20369/Ropa-para-ninos",
							isHighlightLink: false
						},
						{
							label: "Niñas",
							isHighlightLink: false,
							link: "/category/cat20366/Ropa-para-ninas",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Mini",
							link: "/category/cat5890009/Mini"
						},
						{
							meatStickerOption: 0,
							label: "Bebé",
							link: "/category/cat30208/Ropa-de-bebe",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Calzado",
							link: "/category/cat20526/Calzado-infantil"
						},
						{
							label: "Ver todo",
							link: "/category/cat20355/Ropa-infantil",
							isHighlightLink: true
						}
					],
					label: "Ropa infantil"
				}
			],
			link: "cat10024",
			label: "Moda"
		},
		{
			subCategories: [
				{
					link: "/category/cat220002/Juegos-de-jardin",
					label: "Juegos y juguetes",
					leafCategories: [
						{
							label: "Juguetes",
							link: "/category/cat40044/Juguetes",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Piletas e inflables",
							isHighlightLink: false,
							link: "/category/cat40046/Piletas-e-inflables"
						},
						{
							link: "/category/cat40050/Juegos-al-aire-libre",
							isHighlightLink: false,
							label: "Juegos de exterior"
						},
						{
							label: "Camas elásticas",
							link: "/category/cat220008/Camas-elasticas",
							isHighlightLink: false
						},
						{
							label: "Mundo bebé",
							meatStickerOption: 0,
							link: "/category/cat20345/Mundo-bebe",
							isHighlightLink: false
						},
						{
							label: "Ver todo",
							link: "/category/cat220002/Juegos-de-jardin",
							isHighlightLink: true
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Uniformes escolares",
							link: "/category/cat350006/Indumentaria-escolar"
						},
						{
							label: "Zapatos escolares",
							link: "/category/cat350008/Calzado-escolar",
							isHighlightLink: false
						},
						{
							link: "/category/cat40084/Mochilas-y-luncheras",
							isHighlightLink: false,
							label: "Mochilas y luncheras"
						},
						{
							label: "Útiles y accesorios",
							link: "/category/cat40088/Utiles-y-accesorios",
							isHighlightLink: false
						},
						{
							label: "Ver todo",
							link: "/category/cat30146/Escolar",
							isHighlightLink: true
						}
					],
					label: "Escolar",
					link: "/category/cat30146/Escolar"
				},
				{
					label: "Ropa infantil",
					leafCategories: [
						{
							link: "/category/cat20366/Ropa-ninas",
							label: "Ropa para niñas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat20369/Ropa-ninos",
							label: "Ropa para niños"
						},
						{
							isHighlightLink: false,
							label: "Ropa de bebé",
							link: "/category/cat30208/Ropa-de-bebe"
						},
						{
							isHighlightLink: false,
							label: "Mini",
							link: "/category/cat5890009/Mini"
						},
						{
							isHighlightLink: false,
							link: "/category/cat20526/Calzado-infantil",
							meatStickerOption: 0,
							label: "Calzado infantil"
						},
						{
							isHighlightLink: true,
							link: "/category/cat20355/Ropa-infantil",
							label: "Ver todo"
						}
					],
					link: "/category/cat20355/Ropa-infantil"
				}
			],
			link: "cat10018",
			label: "Niños"
		},
		{
			label: "Deportes",
			subCategories: [
				{
					verTodoActive: true,
					link: "/collection/ropa-deportiva",
					label: "Ropa deportiva",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat20357/Ropa-deportiva-mujer",
							label: "Ropa deportiva mujer"
						},
						{
							label: "Ropa deportiva hombre",
							isHighlightLink: false,
							link: "/category/cat20359/Ropa-deportiva-hombre",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat20420/Zapatillas",
							label: "Zapatillas",
							meatStickerOption: 0
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/collection/ropa-deportiva"
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat20414/Mundo-fitness",
							label: "Fitness"
						},
						{
							link: "/category/cat5840001/Movilidad-electrica",
							isHighlightLink: false,
							label: "Movilidad eléctrica",
							meatStickerOption: 0
						},
						{
							link: "/category/cat220008/Camas-elasticas",
							isHighlightLink: false,
							label: "Camas elásticas"
						},
						{
							link: "/category/cat40046/Piletas-e-inflables",
							isHighlightLink: false,
							label: "Piletas e inflables"
						},
						{
							isHighlightLink: false,
							link: "/category/cat220002/Juegos-de-jardin",
							label: "Juegos de jardín"
						},
						{
							label: "Ver todo",
							link: "/category/cat20422/Tiempo-libre-y-camping",
							isHighlightLink: true
						}
					],
					label: "Tiempo libre",
					link: "/category/cat10020/Deportes"
				}
			],
			link: "cat10020"
		},
		{
			link: "cat10022",
			label: "Belleza",
			subCategories: [
				{
					label: "Perfumes",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Mujer",
							link: "/category/cat20072/Perfumes-de-mujer"
						},
						{
							link: "/category/cat2440002/Cofres-de-perfumes-mujer",
							isHighlightLink: false,
							label: "Sets mujer"
						},
						{
							link: "/category/cat20058/Perfumes-de-hombre",
							label: "Hombre",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							link: "/category/cat20056/Perfumes",
							label: "Ver todo"
						}
					],
					link: "/category/cat20056/Perfumes"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Ojos",
							link: "/category/cat20087/Maquillaje-de-ojos"
						},
						{
							label: "Labios",
							isHighlightLink: false,
							link: "/category/cat20091/Maquillaje-de-labios"
						},
						{
							label: "Rostro",
							link: "/category/cat20089/Maquillaje-de-rostro",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Uñas",
							link: "/category/cat20129/Esmaltes"
						},
						{
							link: "/category/cat2120001/Accesorios-de-maquillaje",
							isHighlightLink: false,
							label: "Accesorios"
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat20060/Maquillaje"
						}
					],
					label: "Maquillaje ",
					link: "/category/cat20060/Maquillaje"
				},
				{
					link: "/category/cat20064/Cuidado-del-rostro",
					leafCategories: [
						{
							label: "Limpieza facial",
							link: "/category/cat20115/Limpieza-facial",
							isHighlightLink: false
						},
						{
							label: "Tratamientos faciales",
							link: "/category/cat20109/Tratamientos-faciales",
							isHighlightLink: false
						},
						{
							label: "Tratamientos corporales",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat20117/Tratamientos-corporales"
						},
						{
							label: "Protección solar",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat740098/Cuidado-solar"
						},
						{
							label: "Productos para el cabello",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat3640001/Productos-para-el-cabello"
						},
						{
							label: "Ver todo",
							link: "/category/cat20064/Cuidado-del-rostro",
							isHighlightLink: true
						}
					],
					label: "Cuidado de la piel"
				}
			]
		}
	]
};
var taxonomyV1AR = {
	state: state
};

var state$1 = {
	rootCategories: [
		{
			subCategories: [
				{
					leafCategories: [
						{
							link: "/collection/ofertas-mujer-v2",
							label: "Ver todo",
							isHighlightLink: true
						},
						{
							label: "Ropa",
							isHighlightLink: false,
							link: "/collection/ofertas-mujer-ropa-v2",
							meatStickerOption: 0
						},
						{
							label: "Ropa deportiva",
							isHighlightLink: false,
							link: "/collection/ofertas-mujer-ropa-deportiva",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ropa interior y pijamas",
							link: "/collection/ofertas-mujer-ropa-interior-y-pijamas"
						},
						{
							meatStickerOption: 0,
							link: "/collection/ofertas-mujer-tallas-grandes",
							isHighlightLink: false,
							label: "Tallas grandes"
						},
						{
							link: "/collection/ofertas-mujer-zapatilla-v2",
							label: "Zapatillas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Zapatos",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/ofertas-mujer-zapatos"
						}
					],
					verTodoActive: true,
					label: "Ofertas mujer",
					link: "/collection/ofertas-mujer-v2"
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							link: "/collection/ofertas-hombre-v2",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							link: "/collection/ofertas-hombre-ropa",
							meatStickerOption: 0,
							label: "Ropa"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ropa deportiva",
							link: "/collection/ofertas-hombre-ropa-deportiva"
						},
						{
							meatStickerOption: 0,
							link: "/collection/ofertas-hombre-tallas-grandes",
							isHighlightLink: false,
							label: "Tallas grandes"
						},
						{
							isHighlightLink: false,
							link: "/collection/ofertas-hombre-zapatillas",
							label: "Zapatillas",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/collection/ofertas-hombre-zapatos",
							isHighlightLink: false,
							label: "Zapatos"
						}
					],
					label: "Ofertas hombre",
					link: "/collection/ofertas-hombre-v2",
					verTodoActive: true
				},
				{
					label: "Ofertas niños y bebés",
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/collection/ofertas-ninos-y-bebes-v2"
						},
						{
							label: "Coches",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/ofertas-ninos-y-bebes-coches"
						},
						{
							link: "/collection/ofertas-ninos-y-bebes-dormitorio-infantil",
							label: "Dormitorio infantil",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/ofertas-ninos-y-bebes-jugueteria",
							label: "Juguetería"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Mundo bebé",
							link: "/collection/ofertas-ninos-y-bebes-mundo-bebe"
						},
						{
							link: "/collection/ofertas-ninos-y-bebes-ropa-de-nina",
							label: "Ropa de niña",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Ropa de niño",
							isHighlightLink: false,
							link: "/collection/ofertas-ninos-y-bebes-ropa-de-nino"
						},
						{
							meatStickerOption: 0,
							link: "/collection/ofertas-ninos-y-bebes-zapatos-y-zapatillas",
							isHighlightLink: false,
							label: "Zapatos y zapatillas"
						}
					],
					link: "/collection/ofertas-ninos-y-bebes-v2"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/collection/ofertas-belleza-v2"
						},
						{
							isHighlightLink: false,
							link: "/collection/ofertas-belleza-cuidado-capilar",
							meatStickerOption: 0,
							label: "Cuidado capilar"
						},
						{
							link: "/collection/ofertas-belleza-cuidados-de-la-piel",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Cuidado de la piel"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Maquillaje",
							link: "/collection/ofertas-belleza-maquillaje"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Perfumes",
							link: "/collection/ofertas-belleza-perfumes"
						}
					],
					label: "Ofertas belleza",
					link: "/collection/ofertas-belleza-v2"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Electro y tecnología",
							meatStickerOption: 0,
							link: "/collection/outlet-electro-electro"
						},
						{
							isHighlightLink: false,
							label: "Videojuegos y accesorios",
							link: "/category/cat2023/Videojuegos?&facetSelected=true&f.range.derived.variant.discount_from=30%25+dcto+y+más",
							meatStickerOption: 0
						}
					],
					verTodoActive: true,
					link: "/collection/outlet-ver-todo-electro",
					label: "Ofertas electro/tecno"
				},
				{
					verTodoActive: true,
					label: "Ofertas accesorios",
					link: "/collection/ofertas-accesorios-v2",
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/collection/ofertas-accesorios-v2"
						},
						{
							label: "Accesorios hombre",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/ofertas-accesorios-hombre"
						},
						{
							isHighlightLink: false,
							link: "/collection/ofertas-accesorios-mujer",
							label: "Accesorios mujer",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/collection/ofertas-accesorios-carteras-y-mochilas",
							meatStickerOption: 0,
							label: "Carteras y mochilas"
						},
						{
							isHighlightLink: false,
							label: "Joyería",
							link: "/collection/ofertas-accesorios-joyeria",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/collection/ofertas-accesorios-lentes",
							label: "Lentes",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/collection/ofertas-accesorios-relojes",
							label: "Relojes",
							meatStickerOption: 0
						}
					]
				},
				{
					label: "Ofertas decohogar",
					link: "/collection/ofertas-hogar-2fmascotas-v2",
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/collection/ofertas-hogar-2fmascotas-v2",
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							link: "/collection/ofertas-hogar-2fmascotas-bano",
							isHighlightLink: false,
							label: "Baño"
						},
						{
							meatStickerOption: 0,
							label: "Decoración",
							link: "/collection/ofertas-hogar-2fmascotas-decoracion?facetSelected=true&f.product.attribute.Tipo=Cortinas+de+tela%3A%3AL%C3%A1mparas+de+colgar%3A%3AL%C3%A1mparas+de+mesa%3A%3AL%C3%A1mparas+de+pie%3A%3AL%C3%A1mparas+infantiles",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Menaje cocina",
							link: "/collection/ofertas-hogar-2fmascotas-menaje-cocina"
						},
						{
							isHighlightLink: false,
							label: "Menaje comedor",
							meatStickerOption: 0,
							link: "/collection/ofertas-hogar-2fmascotas-menaje-comedor"
						},
						{
							link: "/collection/ofertas-hogar-2fmascotas-muebles-2c-mesas-y-sillas",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Muebles, mesas y sillas"
						},
						{
							link: "/collection/ofertas-hogar-2fmascotas-ropa-de-cama",
							isHighlightLink: false,
							label: "Ropa de cama",
							meatStickerOption: 0
						}
					]
				}
			],
			label: "Ofertas",
			bannerLocation: "urlToImage",
			link: "cat13740006"
		},
		{
			subCategories: [
				{
					label: "Uniformes por talla",
					verTodoActive: true,
					link: "/category/cat1530007/Uniformes-Escolares",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Calcetines tallas 5 a 12",
							link: "/category/cat1530007/Uniformes-Escolares?facetSelected=true&f.product.attribute.Tipo=Calcetines"
						},
						{
							link: "/category/cat1530007/Uniformes-Escolares?facetSelected=true&f.variant.attribute.size=10%3A%3A4%3A%3A6%3A%3A8&facetSelected=true%2Ctrue%2Ctrue",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Tallas 4 a 10"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1530007/Uniformes-Escolares?facetSelected=true&f.variant.attribute.size=12%3A%3A14%3A%3A16&facetSelected=true%2Ctrue",
							label: "Talla 12 a 16"
						},
						{
							link: "/category/cat1530007/Uniformes-Escolares?facetSelected=true&f.variant.attribute.size=36%3A%3A40%3A%3A44%3A%3A48%3A%3A52&facetSelected=true%2Ctrue%2Ctrue%2Ctrue",
							meatStickerOption: 0,
							label: "Tallas 36 a 52",
							isHighlightLink: false
						},
						{
							label: "Tallas S-M-L-XL",
							meatStickerOption: 0,
							link: "/category/cat1530007/Uniformes-Escolares?facetSelected=true&f.variant.attribute.size=l%3A%3Am%3A%3As%3A%3Axl&facetSelected=true%2Ctrue%2Ctrue",
							isHighlightLink: false
						}
					]
				},
				{
					leafCategories: [
						{
							link: "/category/cat1550048/Uniformes-Escolares-Ninas",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							label: "Blazers",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat15510006/Blazers"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat15060005/Blusas",
							label: "Blusas"
						},
						{
							link: "/collection/uniformes-colegios-particulares?f.product.attribute.G%C3%A9nero=Ni%C3%B1a%3A%3AUnisex",
							label: "Busca tu colegio",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Calcetines y panties",
							link: "/category/cat15060009/Ropa-Interior"
						},
						{
							link: "/category/cat15060007/Delantales",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Delantales"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Jumpers y faldas",
							link: "/category/cat15060008/Jumpers-y-Faldas"
						},
						{
							label: "Pantalones",
							meatStickerOption: 0,
							link: "/category/cat15060006/Pantalones",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Parkas",
							link: "/category/cat15060004/Parkas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat15060003/Polerones-y-Sweaters",
							label: "Polerones y sweaters",
							meatStickerOption: 0
						}
					],
					link: "/category/cat1550048/Uniformes-Escolares-Ninas",
					verTodoActive: true,
					label: "Uniformes de niña"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat1550046/Uniformes-Escolares-Ninos"
						},
						{
							isHighlightLink: false,
							label: "Busca tu colegio",
							meatStickerOption: 0,
							link: "/collection/uniformes-colegios-particulares?f.product.attribute.G%C3%A9nero=Ni%C3%B1o%3A%3AUnisex"
						},
						{
							meatStickerOption: 0,
							label: "Calcetines",
							isHighlightLink: false,
							link: "/category/cat15060015/Ropa-Interior"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat15060012/Camisas",
							label: "Camisas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat15060014/Cotonas",
							meatStickerOption: 0,
							label: "Cotonas"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Pantalones",
							link: "/category/cat15060013/Pantalones"
						},
						{
							isHighlightLink: false,
							link: "/category/cat15060011/Parkas",
							label: "Parkas",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Polerones y sweaters",
							isHighlightLink: false,
							link: "/category/cat15060010/Polerones-y-Sweaters"
						},
						{
							label: "Vestones",
							link: "/category/cat15510007/Vestones",
							isHighlightLink: false,
							meatStickerOption: 0
						}
					],
					label: "Uniformes de niño",
					link: "/category/cat1550046/Uniformes-Escolares-Ninos",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					link: "/collection/zapatos-y-zapatillas-escolar-2021",
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/collection/zapatos-y-zapatillas-escolar-2021"
						},
						{
							link: "/collection/zapatos-y-zapatillas-escolar-2021?f.product.attribute.G%C3%A9nero=Ni%C3%B1a%3A%3AUnisex&f.product.attribute.Tipo=Zapatillas+deportivas%3A%3AZapatillas+urbanas",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Zapatillas niñas"
						},
						{
							link: "/collection/zapatos-y-zapatillas-escolar-2021?f.product.attribute.G%C3%A9nero=Ni%C3%B1o%3A%3AUnisex&f.product.attribute.Tipo=Zapatillas+deportivas%3A%3AZapatillas+urbanas",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Zapatillas niños"
						},
						{
							isHighlightLink: false,
							label: "Zapatos niñas",
							link: "/collection/zapatos-y-zapatillas-escolar-2021?f.product.attribute.G%C3%A9nero=Mujer%3A%3ANi%C3%B1a",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Zapatos niños",
							meatStickerOption: 0,
							link: "/collection/zapatos-y-zapatillas-escolar-2021?f.product.attribute.G%C3%A9nero=Hombre%3A%3ANi%C3%B1o"
						}
					],
					label: "Zapatos y zapatillas"
				},
				{
					link: "/category/cat11740007/Utiles-Escolares",
					label: "Librería y set de útiles",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat11740007/Utiles-Escolares",
							label: "Ver todo"
						},
						{
							label: "Calculadoras",
							isHighlightLink: false,
							link: "/search?Ntt=calculadoras",
							meatStickerOption: 0
						},
						{
							label: "Cuadernos",
							link: "/category/cat11740009/Cuadernos",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Lápices",
							link: "/collection/lapices---destacadores-y-marcadores",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat910002/Libros-Infantiles",
							isHighlightLink: false,
							label: "Libros infantiles",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Manualidades",
							link: "/collection/manualidades-escolar",
							meatStickerOption: 0
						},
						{
							label: "Pack útiles y aprendizaje",
							meatStickerOption: 0,
							link: "/collection/pack-utiles-y-aprendizaje",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Papelería y agendas",
							link: "/category/cat10981330/Papeleria-y-agendas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Textos escolares",
							link: "/category/cat6990144/Libros?facetSelected=true&f.product.attribute.G%C3%A9nero=Educaci%C3%B3n"
						},
						{
							isHighlightLink: false,
							link: "/category/cat11740007/Utiles-Escolares",
							meatStickerOption: 0,
							label: "Útiles"
						}
					],
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat1530005/Mochilas-Escolares",
							isHighlightLink: true
						},
						{
							meatStickerOption: 0,
							link: "/category/cat12060005/Estuches",
							isHighlightLink: false,
							label: "Estuches"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Loncheras",
							link: "/category/cat1540008/Loncheras"
						},
						{
							label: "Mochilas con ruedas",
							link: "/collection/mochilas-con-ruedas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Mochilas infantiles",
							meatStickerOption: 0,
							link: "/category/cat1530023/Mochilas-Infantiles",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Mochilas juveniles",
							link: "/category/cat1530024/Mochilas-Juveniles"
						},
						{
							meatStickerOption: 0,
							link: "/collection/pack-de-mochilas",
							label: "Pack de mochilas",
							isHighlightLink: false
						}
					],
					link: "/category/cat1530005/Mochilas-Escolares",
					verTodoActive: true,
					label: "Mochilas"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat40052/Computadores"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Accesorios computación",
							link: "/category/cat2001/Accesorios-Computacion"
						},
						{
							label: "Audífonos",
							meatStickerOption: 0,
							link: "/category/cat1640002/Audifonos",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Computadores all in one",
							isHighlightLink: false,
							link: "/category/cat40051/All-In-One"
						},
						{
							label: "Decoración muro",
							link: "/category/cat7280225/Decoracion-de-muro",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/collection/escritorios",
							meatStickerOption: 0,
							label: "Escritorios"
						},
						{
							isHighlightLink: false,
							label: "Estantes y repisas",
							meatStickerOption: 0,
							link: "/category/cat1810012/Estantes-y-Repisas"
						},
						{
							label: "Impresoras",
							link: "/category/cat2049/Impresoras",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Lámparas de escritorio",
							link: "/collection/lamparas-de-escritorio",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Licencias Office",
							link: "/category/cat2076/Softwares"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat70057/Notebooks",
							label: "Notebooks"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/home-office?facetSelected=true&f.product.attribute.Tipo=Sillas+de+oficina",
							label: "Sillas de escritorio"
						},
						{
							link: "/category/cat7230007/Tablets",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Tablets"
						}
					],
					link: "/category/cat40052/Computadores",
					label: "Clases online"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat5620004/Moda-infantil?f.product.attribute.Tipo=Buzos%3A%3APantalones%3A%3APolerones%3A%3AZapatillas+deportivas%3A%3AZapatillas+urbanas",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat5620004/Moda-infantil?f.product.attribute.Tipo=Buzos%3A%3AJoggings",
							isHighlightLink: false,
							label: "Buzos y joggers"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat5620004/Moda-infantil?f.product.attribute.Tipo=Calzas",
							label: "Calzas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat5620004/Moda-infantil?f.product.attribute.Tipo=Poleras",
							label: "Poleras"
						},
						{
							link: "/category/cat5620004/Moda-infantil?f.product.attribute.Tipo=Polerones",
							meatStickerOption: 0,
							label: "Polerones",
							isHighlightLink: false
						},
						{
							label: "Zapatillas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/Ver-Todo-Zapatillas-Ninos"
						}
					],
					label: "Cómodos en casa",
					link: "/category/cat5620004/Moda-infantil?f.product.attribute.Tipo=Buzos%3A%3APantalones%3A%3APolerones%3A%3AZapatillas+deportivas%3A%3AZapatillas+urbanas"
				}
			],
			label: "Escolares",
			bannerLocation: "urlToImage",
			link: "cat1530002"
		},
		{
			label: "Telefonía",
			subCategories: [
				{
					label: "Celulares y teléfonos",
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat2018/Celulares-y-Telefonos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1280018/Celulares-Basicos",
							label: "Celulares básicos"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/page/Planes?staticPageId=29400001",
							label: "Celulares con planes"
						},
						{
							isHighlightLink: false,
							link: "/category/cat720161/Smartphones",
							label: "Smartphones"
						}
					],
					link: "/category/cat2018/Celulares-y-Telefonos?isLanding=true"
				},
				{
					leafCategories: [
						{
							link: "/category/cat720161/Smartphones?f.product.brandName=huawei",
							label: "Celulares Huawei",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat720161/Smartphones?facetSelected=true&f.product.brandName=lg",
							meatStickerOption: 0,
							label: "Celulares LG"
						},
						{
							isHighlightLink: false,
							link: "/category/cat720161/Smartphones?f.product.brandName=motorola",
							label: "Celulares Motorola"
						},
						{
							isHighlightLink: false,
							label: "Celulares Samsung",
							link: "/category/cat720161/Smartphones?f.product.brandName=samsung"
						},
						{
							isHighlightLink: false,
							label: "Celulares Xiaomi",
							link: "/category/cat720161/Smartphones?f.product.brandName=xiaomi"
						},
						{
							link: "/category/cat720161/Smartphones?f.product.brandName=apple",
							isHighlightLink: false,
							label: "iPhone"
						}
					],
					label: "Marcas destacadas",
					link: "/category/cat720161/Smartphones"
				},
				{
					label: "Accesorios celulares",
					link: "/category/cat70014/Accesorios-Celulares",
					leafCategories: [
						{
							link: "/category/cat70014/Accesorios-Celulares",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							label: "Audífonos",
							isHighlightLink: false,
							link: "/category/cat1640002/Audifonos"
						},
						{
							label: "Baterias externas",
							link: "/category/cat7230057/Baterias-Externas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat1820030/Carcasas",
							label: "Carcasas"
						},
						{
							isHighlightLink: false,
							label: "Cargadores y cables",
							link: "/category/cat170030/Cargadores-y-cables"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13750040/Otros-Accesorios-Celulares",
							label: "Otros accesorios"
						},
						{
							label: "Protector de pantalla",
							link: "/category/cat1920016/Protector-de-Pantalla",
							isHighlightLink: false
						},
						{
							link: "/category/cat70037/Tarjetas-de-Memoria",
							isHighlightLink: false,
							label: "Tarjetas de memoria"
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat7190053/Wearables"
						},
						{
							label: "Smartband",
							link: "/category/cat4290064/Smartband",
							isHighlightLink: false
						},
						{
							label: "Smartwatches",
							isHighlightLink: false,
							link: "/category/cat4290063/SmartWatch"
						}
					],
					link: "/category/cat7190053/Wearables",
					label: "Wearables"
				},
				{
					link: "/page/Planes?staticPageId=29400001",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/page/Planes?staticPageId=29400001",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							label: "Planes Claro",
							link: "/collection/Planes-Claro"
						},
						{
							label: "Planes Entel",
							isHighlightLink: false,
							link: "/collection/Planes-Entel"
						},
						{
							link: "/collection/Planes-Movistar",
							label: "Planes Movistar",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Planes Wom",
							link: "/collection/Planes-WOM"
						}
					],
					label: "Celulares con planes"
				}
			],
			link: "cat16400010"
		},
		{
			subCategories: [
				{
					link: "/category/cat1012/TV?isLanding=true",
					label: "TV",
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat1012/TV",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							label: "Accesorios",
							isHighlightLink: false,
							link: "/category/cat70050/Accesorios-TV"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7190148/Televisores-LED",
							label: "LEDs y Smart TV",
							meatStickerOption: 0
						},
						{
							link: "/category/cat7190148/Televisores-LED?facetSelected=true&f.product.attribute.Tama%C3%B1o_de_la_pantalla=22+pulgadas%3A%3A24+pulgadas%3A%3A32+pulgadas%3A%3A40+pulgadas%3A%3A42+pulgadas%3A%3A43+pulgadas%3A%3A49+pulgadas",
							label: "LEDs menores a 50\"",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "LEDs entre 50\" - 55\"",
							isHighlightLink: false,
							link: "/category/cat7190148/Televisores-LED?facetSelected=true&f.product.attribute.Tama%C3%B1o_de_la_pantalla=50+pulgadas%3A%3A55+pulgadas"
						},
						{
							label: "LEDs sobre 55\"",
							link: "/category/cat7190148/Televisores-LED?facetSelected=true&f.product.attribute.Tama%C3%B1o_de_la_pantalla=58+pulgadas%3A%3A60+pulgadas%3A%3A65+pulgadas%3A%3A70+pulgadas%3A%3A75+pulgadas%3A%3A77+pulgadas%3A%3A82+pulgadas%3A%3A85+pulgadas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Proyectores",
							link: "/category/cat2070/Proyectores",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat70052/Soportes",
							label: "Soportes",
							isHighlightLink: false
						},
						{
							link: "/category/cat2045/Soundbar-y-Home-Theater",
							isHighlightLink: false,
							label: "Soundbar y Home Theater",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Streaming",
							link: "/category/cat6260040/Streaming",
							meatStickerOption: 0
						}
					]
				},
				{
					leafCategories: [
						{
							link: "/category/cat2005/Audio",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							label: "Audífonos",
							link: "/category/cat1640002/Audifonos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat590091/Audio-profesional-DJ",
							label: "Audio profesional - DJ",
							meatStickerOption: 0
						},
						{
							link: "/category/cat670008/Car-Audio",
							isHighlightLink: false,
							label: "Car Audio",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat3091/Equipos-de-Musica-y-Karaokes",
							label: "Equipos de música y karaokes",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Hi-Fi",
							isHighlightLink: false,
							link: "/category/cat3203/Hi-Fi"
						},
						{
							link: "/category/cat3117/Instrumentos-Musicales",
							label: "Instrumentos musicales",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Parlantes Bluetooth",
							link: "/category/cat3171/Parlantes-Bluetooth"
						},
						{
							meatStickerOption: 0,
							label: "Soundbar y Home Theater",
							link: "/category/cat2045/Soundbar-y-Home-Theater",
							isHighlightLink: false
						}
					],
					label: "Audio",
					link: "/category/cat2005/Audio"
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat40052/Computacion",
							meatStickerOption: 0,
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							link: "/category/cat2001/Accesorios-Computacion",
							label: "Accesorios"
						},
						{
							link: "/category/cat40051/All-In-One",
							label: "All In One",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Almacenamiento",
							link: "/category/cat2003/Almacenamiento"
						},
						{
							label: "Desktops",
							link: "/category/cat7350043/Desktops",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Impresión",
							link: "/category/cat2049/Impresion"
						},
						{
							link: "/category/cat7230007/Tablets?f.product.brandName=amazon%3A%3Akindle",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Kindle"
						},
						{
							label: "Monitores",
							isHighlightLink: false,
							link: "/category/cat2062/Monitores"
						},
						{
							label: "Notebooks",
							link: "/category/cat70057/Notebooks",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat2082/Routers-y-Conectividad",
							label: "Routers y conectividad",
							meatStickerOption: 0
						},
						{
							link: "/category/cat7230007/Tablets",
							isHighlightLink: false,
							label: "Tablets"
						},
						{
							label: "Tintas y toners",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat3246/Tintas-y-Toners"
						},
						{
							isHighlightLink: false,
							label: "Softwares",
							link: "/category/cat2076/Softwares"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat2380002/WebCams",
							label: "Web cam"
						}
					],
					link: "/category/cat40052/Computacion?isLanding=true",
					label: "Computación"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat4850013/Computacion-Gamer"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat13520029/Accesorios-Gamers",
							isHighlightLink: false,
							label: "Accesorios"
						},
						{
							isHighlightLink: false,
							label: "Audífonos",
							link: "/category/cat4930009/Audifonos-Gamers",
							meatStickerOption: 0
						},
						{
							link: "/category/cat10700011/Desktops-Gamers",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Desktops"
						},
						{
							link: "/category/cat2028/Notebooks-Gamers",
							label: "Notebooks",
							meatStickerOption: 0,
							isHighlightLink: false
						}
					],
					label: "Computación gamer",
					link: "/category/cat4850013/Computacion-Gamer",
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat2023/Videojuegos"
						},
						{
							link: "/category/cat3190/Accesorios-Videojuegos",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Accesorios"
						},
						{
							link: "/category/cat2023/Videojuegos?facetSelected=true&f.product.attribute.Tipo=3DS%3A%3ANES%3A%3ANintendo+3DS%3A%3ANintendo+Switch%3A%3AOtras+Consolas%3A%3APS3%3A%3APS4%3A%3AXbox+360%3A%3AXbox+One%3A%3APS5",
							label: "Consolas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Juegos",
							meatStickerOption: 0,
							link: "/category/cat2023/Videojuegos?facetSelected=true&f.product.attribute.Tipo=Videojuegos",
							isHighlightLink: false
						},
						{
							label: "Nintendo",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat70003/Nintendo"
						},
						{
							label: "PlayStation",
							link: "/category/cat4440005/PlayStation",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat12530007/Xbox-Live---Game-Pass",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Suscripciones y tarjetas"
						},
						{
							meatStickerOption: 0,
							label: "Xbox",
							isHighlightLink: false,
							link: "/category/cat4440004/Xbox"
						}
					],
					verTodoActive: true,
					label: "Videojuegos",
					link: "/category/cat2023/Videojuegos?isLanding=true"
				},
				{
					leafCategories: [
						{
							link: "/category/cat2038/Fotografia",
							label: "Ver todo",
							isHighlightLink: true
						},
						{
							label: "Accesorios",
							link: "/category/cat7190259/Accesorios-Fotografia",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Cámaras compactas",
							link: "/category/cat70028/Camaras-Compactas",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7230012/Camaras-Deportivas",
							label: "Cámaras deportivas"
						},
						{
							label: "Cámaras instantáneas",
							link: "/category/cat2038/Fotografia?facetSelected=true&f.product.attribute.Tipo=C%C3%A1maras+instant%C3%A1neas&isPLP=1",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Cámaras profesionales",
							meatStickerOption: 0,
							link: "/category/cat18230032/Camaras-Profesionales",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Cámaras semiprofesionales",
							link: "/category/cat7230011/Camaras-Semiprofesionales"
						},
						{
							label: "Cámaras de video",
							link: "/category/cat2014/Camaras-de-Video",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Drones",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7230062/Drones"
						},
						{
							label: "Lentes, filtros y flash",
							link: "/category/cat70040/Lentes--Filtros-y-Flash",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat70037/Tarjetas-de-Memoria",
							label: "Tarjetas de memoria"
						}
					],
					label: "Fotografía",
					link: "/category/cat2038/Fotografia?isLanding=true"
				},
				{
					label: "Smart Home",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat7190093/Smart-Home"
						},
						{
							isHighlightLink: false,
							label: "Asistentes de voz",
							link: "/category/cat13490034/Asistentes-por-Voz",
							meatStickerOption: 0
						},
						{
							label: "Aspiradoras robot",
							isHighlightLink: false,
							link: "/category/cat8600022/Aspiradoras-Robot"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7190100/Gadgets",
							meatStickerOption: 0,
							label: "Gadgets"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Iluminación inteligente",
							link: "/category/cat7190096/Iluminacion-inteligente"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat14710001/Proyectores",
							isHighlightLink: false,
							label: "Proyectores"
						},
						{
							label: "Seguridad y vigilancia",
							link: "/category/cat7190094/Camaras-de-Seguridad-y-Vigilancia",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Streaming",
							link: "/category/cat6260040/Streaming"
						}
					],
					link: "/category/cat7190093/Smart-Home?isLanding=true"
				},
				{
					link: "/category/cat2025/Cuidado-Personal?isLanding=true",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat2025/Cuidado-Personal",
							isHighlightLink: true
						},
						{
							link: "/category/cat8950035/Afeitadoras-y-Cortapelos",
							isHighlightLink: false,
							label: "Afeitadoras y cortapelos"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat3018/Alisadores-de-pelo",
							label: "Alisadores de pelo",
							isHighlightLink: false
						},
						{
							link: "/category/cat3085/Depiladoras",
							label: "Depiladoras",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Depiladoras IPL",
							link: "/category/cat10150027/Depiladoras-IPL",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Onduladores de pelo",
							link: "/category/cat3170/Onduladores-de-pelo"
						},
						{
							link: "/category/cat3218/Salud-y-Bienestar",
							isHighlightLink: false,
							label: "Salud y bienestar"
						},
						{
							label: "Secadores de pelo",
							isHighlightLink: false,
							link: "/category/cat3223/Secadores-de-pelo"
						},
						{
							isHighlightLink: false,
							label: "Tecnología para la belleza",
							link: "/category/cat7660011/Tecnologia-para-la-belleza"
						}
					],
					label: "Cuidado personal"
				}
			],
			label: "Tecnología",
			link: "cat7090034"
		},
		{
			subCategories: [
				{
					link: "/category/cat2034/Electrodomesticos-Cocina?isLanding=true",
					leafCategories: [
						{
							link: "/category/cat2034/Electrodomesticos-Cocina",
							isHighlightLink: true,
							label: "Ver todo "
						},
						{
							link: "/category/cat9890052/Batidoras",
							label: "Batidoras",
							isHighlightLink: false
						},
						{
							label: "Cafeteras eléctricas",
							link: "/category/cat3045/Cafeteras-electricas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Cocina entretenida",
							link: "/category/cat6740089/Cocina-Entretenida",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Freidoras",
							link: "/category/cat3099/Freidoras",
							meatStickerOption: 0
						},
						{
							label: "Hervidores",
							link: "/category/cat3110/Hervidores",
							isHighlightLink: false
						},
						{
							label: "Hornos eléctricos",
							link: "/category/cat3114/Hornos-Electricos",
							isHighlightLink: false
						},
						{
							link: "/category/cat3141/Licuadoras",
							isHighlightLink: false,
							label: "Licuadoras"
						},
						{
							label: "Microondas",
							isHighlightLink: false,
							link: "/category/cat3151/Microondas"
						},
						{
							link: "/category/cat7230035/Ollas-multiuso-y-arroceras",
							meatStickerOption: 0,
							label: "Ollas multifuncionales",
							isHighlightLink: false
						},
						{
							link: "/category/cat8410002/Robot-de-Cocina",
							label: "Robot de cocina",
							isHighlightLink: false
						}
					],
					label: "Electrodomésticos cocina"
				},
				{
					leafCategories: [
						{
							link: "/category/cat3205/Refrigeradores",
							isHighlightLink: true,
							label: "Ver todo",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat1840004/Cavas",
							meatStickerOption: 0,
							label: "Cavas"
						},
						{
							meatStickerOption: 0,
							label: "Convencionales",
							link: "/category/cat3205/Refrigeradores?f.product.attribute.Tipo=Bottom+freezer%3A%3AMonopuerta%3A%3ATop+mount&isPLP=1%2C1%2C1%2C1&isPLP=1",
							isHighlightLink: false
						},
						{
							label: "Freezers",
							isHighlightLink: false,
							link: "/category/cat4048/Freezers"
						},
						{
							isHighlightLink: false,
							link: "/category/cat4049/Frigobar",
							label: "Frigobar"
						},
						{
							label: "Side by Side",
							isHighlightLink: false,
							link: "/category/cat4091/Side-by-Side"
						}
					],
					label: "Refrigeradores",
					link: "/category/cat3205/Refrigeradores?isLanding=true"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat7190001/Aspirado-y-Limpieza"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8600020/Aspiradoras-de-Arrastre",
							label: "Aspiradoras de arrastre"
						},
						{
							link: "/category/cat8600026/Aspiradoras-Portatiles",
							isHighlightLink: false,
							label: "Aspiradoras portátiles"
						},
						{
							label: "Aspiradoras robot",
							link: "/category/cat8600022/Aspiradoras-Robot",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Purificadores",
							link: "/category/cat3197/Purificadores",
							meatStickerOption: 0
						}
					],
					link: "/category/cat7190001/Aspirado-y-Limpieza?isLanding=true",
					label: "Aspirado y limpieza"
				},
				{
					verTodoActive: true,
					label: "Máquinas de coser",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat2024/Maquinas-de-Coser",
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Accesorios y complementos",
							link: "/category/cat8540013/Accesorios-y-Complementos"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat8540011/Bordadoras",
							isHighlightLink: false,
							label: "Bordadoras"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Cortadoras",
							link: "/category/cat14790018/Cortadoras"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat2024/Maquinas-de-Coser",
							label: "Máquinas de coser"
						},
						{
							meatStickerOption: 0,
							label: "Overlock y quilting",
							link: "/category/cat13620018/Overlock-y-Quilting",
							isHighlightLink: false
						}
					],
					link: "/page/costuras?staticPageId=48700002"
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat3136/Lavado"
						},
						{
							isHighlightLink: false,
							link: "/category/cat4060/Lavadoras",
							label: "Lavadoras"
						},
						{
							label: "Lavadoras y secadoras",
							isHighlightLink: false,
							link: "/category/cat1700002/Lavadoras-Secadoras"
						},
						{
							isHighlightLink: false,
							link: "/category/cat4061/Lavavajillas",
							label: "Lavavajillas"
						},
						{
							label: "Planchas convencionales",
							isHighlightLink: false,
							link: "/category/cat8530004/Planchas-Convencionales"
						},
						{
							label: "Planchas verticales",
							isHighlightLink: false,
							link: "/category/cat8530006/Planchas-Verticales"
						},
						{
							isHighlightLink: false,
							label: "Secadoras",
							link: "/category/cat4088/Secadoras"
						}
					],
					label: "Lavado y planchado",
					link: "/category/cat3136/Lavado"
				},
				{
					label: "Cocina",
					link: "/category/cat3065/Cocina?isLanding=true",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat3065/Cocina",
							label: "Ver todo"
						},
						{
							isHighlightLink: false,
							label: "Calefont y termos",
							link: "/category/cat2013/Calefont-y-Termos"
						},
						{
							isHighlightLink: false,
							label: "Campanas",
							link: "/category/cat4026/Campanas"
						},
						{
							link: "/category/cat70012/Cocinas-a-gas",
							isHighlightLink: false,
							label: "Cocinas a gas"
						},
						{
							label: "Encimeras",
							link: "/category/cat4045/Encimeras",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat4054/Hornos-Empotrables",
							label: "Hornos empotrables"
						},
						{
							label: "Lavavajillas",
							link: "/category/cat4061/Lavavajillas",
							isHighlightLink: false
						}
					]
				},
				{
					link: "/category/cat7170003/Calefaccion?isLanding=true",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat7170003/Calefaccion",
							isHighlightLink: true
						},
						{
							link: "/category/cat7830014/Split",
							meatStickerOption: 0,
							label: "Aire acondicionado split",
							isHighlightLink: false
						},
						{
							link: "/category/cat2013/Calefont-y-Termos",
							isHighlightLink: false,
							label: "Calefonts y termos"
						},
						{
							link: "/category/cat3046/Calientacamas",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Calientacamas"
						},
						{
							label: "Estufas convector",
							link: "/category/cat9910031/Estufas-Convector",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat9910006/Estufas-Electricas",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Estufas eléctricas"
						},
						{
							meatStickerOption: 0,
							label: "Estufas gas",
							isHighlightLink: false,
							link: "/category/cat9910024/Estufas-Gas"
						},
						{
							isHighlightLink: false,
							label: "Estufas parafina láser",
							link: "/category/cat9900007/Estufas-Parafina-Laser",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat16160001/Estufas-Parafina-Mecha",
							label: "Estufas parafina mecha",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Estufas pellet y leña",
							link: "/category/cat9910027/Estufas-Pellet-y-Lena"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3197/Purificadores",
							meatStickerOption: 0,
							label: "Purificadores"
						}
					],
					label: "Climatización"
				},
				{
					leafCategories: [
						{
							label: "Ver todo ",
							isHighlightLink: true,
							link: "/category/cat19110021/Equipamiento-Industrial"
						},
						{
							isHighlightLink: false,
							link: "/category/cat10897314/Accesorios-Comerciales",
							label: "Accesorios comerciales"
						},
						{
							label: "Gastronomía",
							isHighlightLink: false,
							link: "/category/cat10897842/Gastronomia"
						},
						{
							isHighlightLink: false,
							label: "Mueblería y grifería",
							link: "/category/cat11264206/Muebleria-y-Griferia"
						},
						{
							label: "Panadería",
							link: "/category/cat10898763/Panaderia",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat10896522/Refrigeracion-Industrial",
							isHighlightLink: false,
							label: "Refrigeración industrial"
						},
						{
							label: "Visicoolers",
							isHighlightLink: false,
							link: "/category/cat10897149/Visicoolers"
						}
					],
					label: "Equipamiento industrial",
					link: "/category/cat19110021/Equipamiento-Industrial"
				}
			],
			label: "Electro",
			link: "cat16510006"
		},
		{
			label: "Decohogar",
			link: "cat8950017",
			subCategories: [
				{
					label: "Tendencias - Inspiración",
					link: "/page/Especial_Diseno?staticPageId=43300001",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat14009890/Piso-Diseno"
						},
						{
							label: "INSPÍRATE EN CASA F",
							link: "/page/casa-f?sid=HO_V2_TUC_1039&staticPageId=33400001",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/collection/deco-kids",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Deco kids"
						},
						{
							isHighlightLink: false,
							label: "Decoración",
							link: "/category/cat14010351/Decoracion-y-alfombras",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat14010411/Dormitorio",
							label: "Dormitorio",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Menaje",
							meatStickerOption: 0,
							link: "/category/cat14010376/Cocina-y-comedor"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Muebles",
							link: "/category/cat14010317/Muebles"
						},
						{
							label: "Ropa de baño y cama",
							isHighlightLink: false,
							link: "/category/cat14010391/Ropa-de-cama-y-bano",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Terraza",
							meatStickerOption: 0,
							link: "/page/casa-f?staticPageId=33400001&sred=casa+f"
						}
					],
					verTodoActive: true
				},
				{
					link: "/category/cat2026/Decoracion",
					leafCategories: [
						{
							link: "/category/cat2026/Decoracion",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							isHighlightLink: false,
							label: "MARCAS PREMIUM",
							link: "/category/cat2026/Decoracion-e-iluminacion?facetSelected=true&f.product.brandName=ameritex%3A%3Aanthropologie%3A%3Aanthropologie+home%3A%3Abasement+home%3A%3Acrate+%26+barrel%3A%3Aform+design%3A%3Ajohn+lewis%3A%3Arugs.cl%3A%3Asur+dise%C3%B1o%3A%3Atempora%3A%3Athe+candle+shop%3A%3Athe+candle+shop+chile&isPLP=1",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Adornos",
							link: "/category/cat7280221/Adornos"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat5540010/Cortinas",
							label: "Cortinas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Decoración de muro",
							link: "/category/cat7280225/Decoracion-de-muro",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14240003/Deco-Exterior",
							label: "Deco exterior"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3094/Espejos",
							meatStickerOption: 0,
							label: "Espejos"
						},
						{
							link: "/category/cat40064/Lamparas",
							isHighlightLink: false,
							label: "Lámparas"
						},
						{
							link: "/category/cat12640003/Muebles-Pequenos",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Muebles pequeños"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat10981330/Papeleria-Ver-Todo",
							isHighlightLink: false,
							label: "Organización/papelería"
						}
					],
					label: "Decoración"
				},
				{
					label: "Arte Falabella",
					link: "/page/Arte-Falabella?staticPageId=46500001",
					verTodoActive: true,
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat7280225/Decoracion-de-muro?facetSelected=true&f.product.brandName=alejandra+caro%3A%3Aalejandra+rivera%3A%3Aandrés+muñoz%3A%3Aandrés+parra+(nia+de+indias)%3A%3Abarbara+oettinger%3A%3Abernardita+bennet%3A%3Acarla+mc-kay%3A%3Acarla+yovane%3A%3Acarlos+silva%3A%3Acarola+sepulveda%3A%3Acarolina+agüero%3A%3Aconstanza+miranda%3A%3Acristian+ordoñez%3A%3Adiego+urbina%3A%3Afelipe+muñoz%3A%3Afrancisco+ibañez%3A%3Aisidora+correa%3A%3Ajorge+brantmayer%3A%3Ajorge+gronemeyer%3A%3Ajosefina+astorga%3A%3Aleonora+vicuña%3A%3Alucas+urenda%3A%3Amaite+zubizarreta%3A%3Amarize+parra%3A%3Amatthew+neary%3A%3Amauricio+soto%3A%3Amila+belén%3A%3Anicolás+piwonka%3A%3Apablo+izquierdo%3A%3Apía+vergara%3A%3Arosario+ateaga%3A%3Asebastián+leal%3A%3Asebastián+mejia%3A%3Atomás+verdejo%3A%3Atomás+westenenk%3A%3Avalentina+guerrero%3A%3Avalentina+osnovikoff%3A%3Averónica+garay&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue",
							isHighlightLink: true
						},
						{
							link: "/page/Arte-Artistas?staticPageId=46500003",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "ARTISTAS"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Arte en blanco y negro",
							link: "/collection/fotografias-bn"
						},
						{
							link: "/collection/fotografias-horizontal",
							isHighlightLink: false,
							label: "Impresión horizontal",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/collection/fotografias-vertical",
							isHighlightLink: false,
							label: "Impresión vertical"
						},
						{
							label: "Paisaje natural",
							isHighlightLink: false,
							link: "/collection/paisaje-natural",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/collection/paisaje-urbano",
							label: "Paisaje urbano",
							isHighlightLink: false
						},
						{
							link: "/collection/retrato",
							label: "Retratos",
							isHighlightLink: false,
							meatStickerOption: 0
						}
					]
				},
				{
					link: "/category/cat2060/Menaje-Cocina",
					label: "Menaje cocina",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat2060/Menaje-Cocina"
						},
						{
							label: "MARCAS PREMIUM",
							meatStickerOption: 0,
							link: "/category/cat2060/Menaje-Cocina?facetSelected=true&f.product.brandName=3+claveles%3A%3Aberlinger+haus%3A%3Acrate+%26+barrel%3A%3Ajohn+lewis%3A%3Ajoseph+joseph%3A%3Akorkmaz%3A%3Ale+creuset%3A%3Aoxo%3A%3Arachael+ray%3A%3Aswiss+nature+labs&isPLP=1",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat3034/Baterias-de-Cocina",
							label: "Baterías de cocina"
						},
						{
							link: "/category/cat7280093/Cuchillos-y-tablas",
							isHighlightLink: false,
							label: "Cuchillos y tablas"
						},
						{
							isHighlightLink: false,
							label: "Ollas",
							link: "/category/cat3169/Ollas"
						},
						{
							isHighlightLink: false,
							label: "Parrillas",
							link: "/category/cat2079/Parrillas"
						},
						{
							isHighlightLink: false,
							label: "Repostería",
							link: "/category/cat7280016/Reposteria"
						},
						{
							link: "/category/cat3220/Sartenes-y-Wok",
							isHighlightLink: false,
							label: "Sartenes y wok"
						},
						{
							isHighlightLink: false,
							label: "Termos y picnic",
							link: "/category/cat970004/Termos-y-Picnic"
						},
						{
							label: "Utensilios de cocina",
							link: "/category/cat3024/Utensilios-de-cocina",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/collection/ofertas-hogar-2fmascotas-menaje-cocina",
							label: "Ofertas",
							isHighlightLink: false
						}
					]
				},
				{
					label: "Menaje comedor",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat2061/Menaje-Comedor",
							isHighlightLink: true
						},
						{
							label: "MARCAS PREMIUM",
							link: "/category/cat2061/Menaje-Comedor?facetSelected=true&f.product.brandName=3+claveles%3A%3Aanthropologie+home%3A%3Abordallo%3A%3Acosta+nova%3A%3Acrate+%26+barrel%3A%3Adalper%3A%3Aidurgo%3A%3Ajohn+lewis%3A%3Ajoseph+joseph%3A%3Aoxo%3A%3Apip+studio%3A%3Aqdigital%3A%3Awmf%3A%3Awrzesniak&isPLP=1",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Accesorios de mesa",
							link: "/category/cat3012/Accesorios-de-mesa",
							isHighlightLink: false
						},
						{
							link: "/category/cat7280098/Aperitivo-y-bar",
							isHighlightLink: false,
							label: "Aperitivo y bar"
						},
						{
							link: "/category/cat3081/Cuchilleria",
							label: "Cuchillería",
							isHighlightLink: false
						},
						{
							link: "/category/cat3100/Fuentes-y-Bandejas",
							isHighlightLink: false,
							label: "Fuentes y bandejas"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat7280099/Manteleria",
							label: "Mantelería",
							isHighlightLink: false
						},
						{
							label: "Té y café",
							link: "/category/cat7280097/Te-y-cafe",
							isHighlightLink: false
						},
						{
							label: "Vajilla",
							link: "/category/cat7280100/Vajilla",
							isHighlightLink: false
						},
						{
							label: "Vasos y copas",
							isHighlightLink: false,
							link: "/category/cat6590032/Vasos-y-copas"
						},
						{
							link: "/collection/ofertas-hogar-2fmascotas-menaje-comedor",
							meatStickerOption: 0,
							label: "Ofertas",
							isHighlightLink: false
						}
					],
					link: "/category/cat2061/Menaje-Comedor"
				},
				{
					label: "Mundo parrilla y quincho",
					link: "/category/cat18560005/Mundo-Parrilla-y-Quincho",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat18560005/Mundo-Parrilla-y-Quincho",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							link: "/category/cat2450145/Accesorios-de-Parrillas",
							label: "Accesorios"
						},
						{
							meatStickerOption: 0,
							label: "Deco exterior",
							link: "/category/cat14240003/Deco-Exterior",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Iluminación exterior",
							isHighlightLink: false,
							link: "/category/cat14250003/Iluminacion-Exterior"
						},
						{
							isHighlightLink: false,
							link: "/category/cat14070032/Libros-de-Cocina",
							meatStickerOption: 0,
							label: "Libros de cocina"
						},
						{
							isHighlightLink: false,
							label: "Mundo Gourmet",
							link: "/category/cat14090010/Mundo-Gourmet"
						},
						{
							label: "Parrillas",
							link: "/category/cat2079/Parrillas",
							isHighlightLink: false
						}
					]
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat2002/Alfombras",
							label: "Ver todo",
							isHighlightLink: true
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Bajadas de cama",
							link: "/category/cat2002/Alfombras-y-cubrepisos?facetSelected=true&f.product.attribute.Tipo=Bajadas+de+cama"
						},
						{
							link: "/category/cat2002/Alfombras-y-cubrepisos?facetSelected=true&f.product.attribute.Tipo=Choapinos&isPLP=1",
							label: "Choapinos",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "De pasillo",
							link: "/category/cat2002/Alfombras?f.variant.attribute.size=060+x+120+cms%3A%3A060x120+cms%3A%3A060x140+cms%3A%3A060x200+cms%3A%3A060x213+cms%3A%3A070x230+cms%3A%3A070x240+cms%3A%3A080+x+230+cms%3A%3A080x230+cms%3A%3A080x240+cms%3A%3A080x280+cms%3A%3A080x300+cms%3A%3A80x230+cms"
						},
						{
							meatStickerOption: 0,
							label: "Grandes",
							link: "/category/cat2002/Alfombras?f.variant.attribute.size=170x230+cms%3A%3A170x240+cms%3A%3A170x290+cms%3A%3A180x240+cms%3A%3A180x270+cms%3A%3A183x274+cms%3A%3A190+x+290+cms%3A%3A190x290+cms%3A%3A190x300+cms%3A%3A196x294+cms%3A%3A200+x+290+cms%3A%3A200x220+cms%3A%3A200x280+cms%3A%3A200x285%3A%3A200x290+cms%3A%3A200x300+cms%3A%3A230x330%3A%3A230x330+cms%3A%3A240x305+cms%3A%3A240x330+cms%3A%3A244+x+305+cms%3A%3A244x292+cms%3A%3A244x305+cms%3A%3A244x310+cms%3A%3A245x305+cms%3A%3A280x200+cms%3A%3A300x400+cms",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat2002/Alfombras?f.variant.attribute.size=116x170+cms%3A%3A120x160+cms%3A%3A120x170+cms%3A%3A120x180+cms%3A%3A125+cms%3A%3A133x180+cms%3A%3A133x190+cms%3A%3A135x190+cms%3A%3A140x200+cms%3A%3A150x200+cms%3A%3A150x220+cms%3A%3A150x230+cms%3A%3A150x244+cms%3A%3A152x233+cms%3A%3A153x213+cms%3A%3A155x190+cms%3A%3A160x160+cms%3A%3A160x215+cms%3A%3A160x222+cms%3A%3A160x230+cms%3A%3A160x235%3A%3A160x235+cms%3A%3A160x240+cms",
							isHighlightLink: false,
							label: "Medianas"
						},
						{
							label: "Pequeñas",
							isHighlightLink: false,
							link: "/category/cat2002/Alfombras?facetSelected=true&f.product.attribute.Tamaño=Pequeña&f.product.attribute.Tipo=Alfombras&facetSelected=true",
							meatStickerOption: 0
						}
					],
					link: "/category/cat2002/Alfombras",
					label: "Alfombras"
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat2006/Bano"
						},
						{
							label: "Accesorios",
							isHighlightLink: false,
							link: "/category/cat3010/Accesorios-de-Bano"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3079/Cortinas-de-Bano",
							label: "Cortinas"
						},
						{
							isHighlightLink: false,
							label: "Muebles",
							link: "/category/cat6200001/Muebles-de-Bano"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat8950025/Organizacion-Bano",
							label: "Organización"
						},
						{
							link: "/category/cat670073/Toallas-de-Bano",
							label: "Toallas",
							isHighlightLink: false
						},
						{
							link: "/collection/ofertas-hogar-2fmascotas-bano",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ofertas"
						}
					],
					label: "Baño",
					link: "/category/cat2006/Bano"
				}
			]
		},
		{
			label: "Muebles",
			subCategories: [
				{
					link: "/category/cat1008/Muebles",
					leafCategories: [
						{
							link: "/category/cat1008/Muebles",
							label: "Ver todo",
							isHighlightLink: true
						},
						{
							label: "MARCAS PREMIUM",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat1008/Muebles-y-Organizacion?&facetSelected=true&f.product.brandName=amoble%3A%3Aanthropologie%3A%3Aanthropologie+home%3A%3Acrate+%26+barrel%3A%3Ajohn+lewis%3A%3Amilk%3A%3Asauder%3A%3Asur+dise%C3%B1o%3A%3Athe+popular+design&isPLP=1"
						},
						{
							isHighlightLink: false,
							label: "Bar y pisos de bar",
							link: "/category/cat3032/Bar",
							meatStickerOption: 0
						},
						{
							label: "Berger y reclinables",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat3036/Bergers-y-Reclinables"
						},
						{
							isHighlightLink: false,
							label: "Camas infantiles",
							link: "/category/cat3180021/Camas-infantiles",
							meatStickerOption: 0
						},
						{
							label: "Clóset",
							link: "/category/cat3063/Closet",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Cunas",
							link: "/category/cat10170015/Cunas-de-Madera"
						},
						{
							label: "Cómodas y cajoneras",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat3074/Comodas-y-Cajoneras"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat2046/Escritorio",
							label: "Escritorios y sillas"
						},
						{
							link: "/category/cat1810012/Estantes-y-Repisas",
							meatStickerOption: 0,
							label: "Estantes y repisas",
							isHighlightLink: false
						},
						{
							link: "/category/cat3123/Juegos-de-Comedor",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Juegos de comedor"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2940012/Mesas-Centro,-Laterales-y-Arrimos",
							label: "Mesas centro y arrimos",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat3149/Mesas-de-Comedor",
							label: "Mesas de comedor"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat5140014/Muebles-de-TV-y-Racks",
							label: "Muebles de TV y racks"
						},
						{
							link: "/category/cat5140004/Sillas",
							meatStickerOption: 0,
							label: "Sillas de comedor",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat8960005/Sofas-y-Sillones",
							meatStickerOption: 0,
							label: "Sofás y sillones"
						},
						{
							isHighlightLink: false,
							label: "Terrazas",
							link: "/category/cat1180024/Terrazas-SALE",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat840027/Vitrinas-y-Buffet",
							label: "Vitrinas y buffets",
							isHighlightLink: false
						},
						{
							label: "Ofertas",
							meatStickerOption: 0,
							link: "/collection/ofertas-hogar-2fmascotas-muebles-2c-mesas-y-sillas",
							isHighlightLink: false
						}
					],
					label: "Muebles por tipo"
				},
				{
					leafCategories: [
						{
							link: "/category/cat16610015/Living-Sala-de-Estar",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "MARCAS PREMIUM",
							link: "/category/cat1008/Muebles-y-Organizacion?&facetSelected=true&f.product.brandName=amoble%3A%3Aanthropologie%3A%3Aanthropologie+home%3A%3Acrate+%26+barrel%3A%3Ajohn+lewis%3A%3Amilk%3A%3Asauder%3A%3Asur+dise%C3%B1o%3A%3Athe+popular+design&isPLP=1"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3036/Bergers-y-Reclinables",
							meatStickerOption: 0,
							label: "Bergers y reclinables"
						},
						{
							meatStickerOption: 0,
							label: "Estantes y repisas",
							isHighlightLink: false,
							link: "/category/cat1810012/Estantes-y-Repisas"
						},
						{
							link: "/category/cat2940012/Mesas-Centro,-Laterales-y-Arrimos",
							isHighlightLink: false,
							label: "Mesas centro y arrimos",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Muebles de TV y racks",
							link: "/category/cat5140014/Muebles-de-TV-y-Racks"
						},
						{
							meatStickerOption: 0,
							label: "Sofás y sillones",
							link: "/category/cat8960005/Sofas-y-Sillones",
							isHighlightLink: false
						}
					],
					label: "Living y sala de estar",
					link: "/category/cat16610015/Living-Sala-de-Estar",
					verTodoActive: true
				},
				{
					label: "Comedor",
					link: "/category/cat2021/Comedor",
					leafCategories: [
						{
							link: "/category/cat2021/Comedor",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							isHighlightLink: false,
							label: "MARCAS PREMIUM",
							link: "/category/cat2021/Muebles-de-comedor?facetSelected=true&f.product.brandName=crate+%26+barrel%3A%3Ajohn+lewis%3A%3Amilk%3A%3Asauder%3A%3Asur+dise%C3%B1o%3A%3Athe+popular+design&isPLP=1",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Bar y pisos de bar",
							link: "/category/cat3032/Bar"
						},
						{
							isHighlightLink: false,
							label: "Juegos de comedor",
							link: "/category/cat3123/Juegos-de-Comedor"
						},
						{
							isHighlightLink: false,
							label: "Mesas de comedor",
							link: "/category/cat3149/Mesas-de-Comedor"
						},
						{
							label: "Sillas de comedor",
							link: "/category/cat5140004/Sillas",
							isHighlightLink: false
						},
						{
							link: "/category/cat840027/Vitrinas-y-Buffet",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Vitrinas y buffet"
						}
					]
				},
				{
					label: "Dormitorio",
					link: "/category/cat5870049/Muebles-de-Dormitorio",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat5870049/Muebles-de-Dormitorio",
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat3063/Closet",
							isHighlightLink: false,
							label: "Clóset"
						},
						{
							isHighlightLink: false,
							label: "Cómodas y cajoneras",
							link: "/category/cat3074/Comodas-y-Cajoneras"
						},
						{
							label: "Organización",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat8950028/Organizacion-Dormitorio"
						},
						{
							isHighlightLink: false,
							label: "Respaldos y veladores",
							link: "/category/cat3212/Respaldos-y-Veladores"
						}
					]
				},
				{
					link: "/category/cat3180022/Muebles-Infantiles",
					verTodoActive: true,
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat3180022/Muebles-Infantiles"
						},
						{
							isHighlightLink: false,
							label: "Camas infantiles",
							link: "/category/cat3180021/Camas-infantiles",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Cunas",
							meatStickerOption: 0,
							link: "/category/cat10170015/Cunas-de-Madera"
						},
						{
							label: "Mesas y sillas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat12830003/Sillas--Sofas-y-Mesas-infantiles"
						},
						{
							link: "/category/cat11668791/Comodas-y-Organizacion-Infantil",
							isHighlightLink: false,
							label: "Organización infantil",
							meatStickerOption: 0
						}
					],
					label: "Muebles para niños"
				},
				{
					label: "Home office",
					verTodoActive: true,
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat2046/Escritorio"
						},
						{
							meatStickerOption: 0,
							label: "Escritorios",
							link: "/category/cat3158/Escritorios",
							isHighlightLink: false
						},
						{
							label: "Estantes y repisas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1810012/Estantes-y-Repisas"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Lámparas",
							link: "/category/cat6570005/Lamparas-de-Mesa"
						},
						{
							label: "Sillas de escritorio",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat9130008/Sillas-de-Escritorio"
						}
					],
					link: "/category/cat2046/Escritorio"
				},
				{
					link: "/collection/ver-todo-crate-barrel",
					label: "Crate&Barrel",
					leafCategories: [
						{
							link: "/collection/ver-todo-crate-barrel",
							label: "Ver todo",
							isHighlightLink: true
						},
						{
							link: "/category/cat2021/Muebles-de-comedor?facetSelected=true&f.product.brandName=crate+%26+barrel&isPLP=1",
							isHighlightLink: false,
							label: "Comedor"
						},
						{
							link: "/collection/ver-todo-crate-barrel?facetSelected=true&f.product.attribute.Tipo=Arrimos%3A%3ABancos%3A%3ABanquetas%3A%3ABares%3A%3ACarros+de+bar%3A%3AEstantes%3A%3AJuegos+de+living+de+terraza%3A%3AMesas+auxiliares%3A%3AMesas+de+centro%3A%3AMesas+de+comedor%3A%3APoltronas%3A%3ARacks%3A%3ASillas+de+cocina%3A%3ASillas+de+comedor%3A%3ASillas+de+oficina%3A%3ASitiales%3A%3ASof%C3%A1s%3A%3AVeladores",
							label: "Muebles",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat8960005/Sofas-y-Sillones?&facetSelected=true&f.product.attribute.Tipo=Seccionales%3A%3ASof%C3%A1s&f.product.brandName=crate+%26+barrel",
							label: "Sofás y seccionales",
							isHighlightLink: false
						}
					]
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/page/Showroom?staticPageId=46600001",
							label: "Showroom digital",
							meatStickerOption: 0
						}
					],
					label: "Tienda virtual",
					link: "/page/Showroom?staticPageId=46600001"
				}
			],
			link: "cat16510005"
		},
		{
			link: "cat1005",
			label: "Dormitorio",
			subCategories: [
				{
					label: "Ropa de cama",
					link: "/category/cat2073/Ropa-de-Cama?isPLP=1",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat2073/Ropa-de-Cama?isPLP=1"
						},
						{
							link: "/category/cat13790009/Almohadas",
							label: "Almohadas",
							isHighlightLink: false
						},
						{
							link: "/category/cat3067/Cojines-y-Pieceras",
							isHighlightLink: false,
							label: "Cojines y pieceras"
						},
						{
							label: "Cubrecamas y quilts",
							isHighlightLink: false,
							link: "/category/cat3080/Cubrecamas-y-Quilts"
						},
						{
							meatStickerOption: 0,
							label: "Cubre colchón y toppers",
							isHighlightLink: false,
							link: "/category/cat16540008/Cubre-Colchon"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat2073/Ropa-de-Cama?facetSelected=true&f.product.attribute.Tipo=Faldones&isPLP=1",
							label: "Faldones"
						},
						{
							link: "/category/cat3098/Frazadas-y-Mantas",
							isHighlightLink: false,
							label: "Frazadas y mantas"
						},
						{
							label: "Fundas plumón",
							isHighlightLink: false,
							link: "/category/cat3104/Funda-plumon"
						},
						{
							label: "Sets ropa de cama",
							isHighlightLink: false,
							link: "/category/cat3122/Juegos-de-Cama"
						},
						{
							label: "Plumones",
							link: "/category/cat3185/Plumones",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/collection/ropa-de-cama-infantil",
							label: "Ropa de cama infantil"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3215/Sabanas",
							label: "Sábanas"
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat13720010/Camas",
							isHighlightLink: true
						},
						{
							label: "MARCAS PREMIUM",
							isHighlightLink: false,
							link: "/category/cat14010411/Dormitorio",
							meatStickerOption: 0
						},
						{
							link: "/category/cat13720010/Camas?f.product.attribute.Tama%C3%B1o=1+plaza&isPLP=1",
							isHighlightLink: false,
							label: "1 plaza"
						},
						{
							isHighlightLink: false,
							label: "1,5 plazas",
							link: "/category/cat13720010/Camas?&f.product.attribute.Tama%C3%B1o=1.5+plazas&isPLP=1"
						},
						{
							label: "2 plazas",
							link: "/category/cat13720010/Camas?&f.product.attribute.Tama%C3%B1o=2+plazas&isPLP=1",
							isHighlightLink: false
						},
						{
							link: "/category/cat13720010/Camas?f.product.attribute.Tama%C3%B1o=King&isPLP=1",
							label: "King",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Super king",
							link: "/category/cat13720010/Camas?f.product.attribute.Tama%C3%B1o=Super+King&isPLP=1"
						}
					],
					link: "/category/cat13720010/Camas",
					label: "Camas"
				},
				{
					verTodoActive: true,
					label: "Complementos cama",
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/collection/complementos-cama"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2073/Ropa-de-Cama?facetSelected=true&f.product.attribute.Tipo=Almohadas%3A%3AJuegos+de+almohadas&isPLP=1",
							label: "Almohadas",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cubre colchón y toppers",
							link: "/category/cat2073/Ropa-de-Cama?facetSelected=true&f.product.attribute.Tipo=Accesorios+de+dormitorio%3A%3ACubre+colchones&isPLP=1"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Faldones",
							link: "/category/cat2073/Ropa-de-Cama?facetSelected=true&f.product.attribute.Tipo=Faldones&isPLP=1"
						},
						{
							link: "/category/cat2073/Ropa-de-Cama?facetSelected=true&f.product.attribute.Tipo=Plumones+Sint%C3%A9ticos%3A%3APlumones+de+pluma&f.variant.attribute.colorGroup=Blanco&isPLP=1",
							isHighlightLink: false,
							label: "Plumones blancos",
							meatStickerOption: 0
						}
					],
					link: "/collection/complementos-cama"
				},
				{
					label: "Colchones",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat2020/Colchones",
							label: "Ver todo"
						},
						{
							label: "1 plaza",
							link: "/category/cat2020/Colchones?f.product.attribute.Tama%C3%B1o=1+plaza&isPLP=1",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "1,5 plazas",
							link: "/category/cat2020/Colchones?&f.product.attribute.Tama%C3%B1o=1.5+plazas&isPLP=1"
						},
						{
							link: "/category/cat2020/Colchones?&f.product.attribute.Tama%C3%B1o=2+plazas&isPLP=1",
							isHighlightLink: false,
							label: "2 plazas"
						},
						{
							label: "King",
							link: "/category/cat2020/Colchones?&f.product.attribute.Tama%C3%B1o=King&isPLP=1",
							isHighlightLink: false
						},
						{
							label: "Super king",
							isHighlightLink: false,
							link: "/category/cat2020/Colchones?f.product.attribute.Tama%C3%B1o=Super+King&isPLP=1"
						}
					],
					link: "/category/cat2020/Colchones"
				},
				{
					link: "/category/cat670091/Tipos-de-Cama",
					label: "Tipos de cama",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat670091/Tipos-de-Cama",
							isHighlightLink: true
						},
						{
							link: "/category/cat14010411/Dormitorio",
							label: "MARCAS PREMIUM",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Box Spring",
							link: "/category/cat13720010/Camas?f.product.attribute.Tipo_de_cama=Box+springs&isPLP=1"
						},
						{
							link: "/category/cat3049/Camarotes",
							isHighlightLink: false,
							label: "Camarotes"
						},
						{
							link: "/category/cat13720010/Camas?f.product.attribute.Tipo_de_cama=Camas+americanas&isPLP=1",
							label: "Camas americanas",
							isHighlightLink: false
						},
						{
							label: "Camas europeas",
							isHighlightLink: false,
							link: "/category/cat13720010/Camas?f.product.attribute.Tipo_de_cama=Camas+europeas&isPLP=1"
						},
						{
							label: "Camas nido",
							isHighlightLink: false,
							link: "/category/cat2029/Camas-Nido"
						},
						{
							isHighlightLink: false,
							label: "Marquesas y bases",
							link: "/category/cat8690021/Marquesas-y-Bases-de-Cama"
						}
					]
				},
				{
					label: "Muebles de dormitorio",
					link: "/category/cat5870049/Muebles-de-Dormitorio",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat5870049/Muebles-de-Dormitorio",
							isHighlightLink: true
						},
						{
							link: "/category/cat3063/Closet",
							label: "Clóset",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Cómodas y cajoneras",
							isHighlightLink: false,
							link: "/category/cat3074/Comodas-y-Cajoneras"
						},
						{
							label: "Organización dormitorio",
							link: "/category/cat8950028/Organizacion-Dormitorio",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat3212/Respaldos-y-Veladores",
							isHighlightLink: false,
							label: "Respaldos y veladores"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7180071/Tocadores",
							label: "Tocadores"
						},
						{
							isHighlightLink: false,
							label: "Zapateros",
							link: "/category/cat11640018/Zapateros",
							meatStickerOption: 0
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat3180019/Dormitorio-Infantil"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3180021/Camas-infantiles",
							label: "Camas infantiles"
						},
						{
							isHighlightLink: false,
							label: "Cómodas y mudadores",
							link: "/category/cat4034/Comodas-y-Mudadores"
						},
						{
							link: "/category/cat3159/Cunas-y-Colchones",
							isHighlightLink: false,
							label: "Cunas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3159/Cunas-y-Colchones",
							label: "Dormitorio bebé"
						},
						{
							isHighlightLink: false,
							label: "Ropa de cama",
							link: "/category/cat4210002/Ropa-de-cama-infantil"
						},
						{
							label: "Ropa de cuna ",
							isHighlightLink: false,
							link: "/category/cat4086/Ropa-de-cuna"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ofertas",
							link: "/collection/ofertas-ninos-y-bebes-dormitorio-infantil"
						}
					],
					link: "/category/cat3180019/Dormitorio-Infantil",
					label: "Dormitorio de niños"
				},
				{
					verTodoActive: true,
					link: "/category/cat10546441/Combos-de-Dormitorio",
					label: "Combos de dormitorio",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat10546441/Combos-de-Dormitorio"
						},
						{
							label: "1 plaza",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10546441/Combos-de-Dormitorio?f.product.attribute.Tama%C3%B1o=1+plaza"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "1,5 plazas",
							link: "/category/cat10546441/Combos-de-Dormitorio?f.product.attribute.Tama%C3%B1o=1.5+plazas"
						},
						{
							link: "/category/cat10546441/Combos-de-Dormitorio?f.product.attribute.Tama%C3%B1o=2+plazas",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "2 plazas"
						},
						{
							isHighlightLink: false,
							label: "King",
							meatStickerOption: 0,
							link: "/category/cat10546441/Combos-de-Dormitorio?f.product.attribute.Tama%C3%B1o=King"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat10546441/Combos-de-Dormitorio?f.product.attribute.Tama%C3%B1o=Super+King",
							label: "Super king"
						}
					]
				}
			]
		},
		{
			subCategories: [
				{
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat6930168/Ropa-Deportiva-Mujer",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							link: "/collection/Nueva-temporada-deportes-mujer",
							label: "NUEVA TEMPORADA",
							isHighlightLink: false
						},
						{
							label: "Calzas",
							isHighlightLink: false,
							link: "/category/cat6930190/Calzas",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Pantalones",
							link: "/category/cat12650001/Shorts-y-Pantalones?facetSelected=true&f.product.attribute.Tipo=Calzas%3A%3ACalzas+primera+capa%3A%3AJogger%3A%3APantalones%3A%3APantalones+de+buzo%3A%3APantalones+de+ski%3A%3APantalones+deportivos%3A%3APantalones+outdoor&f.range.derived.variant.discount_upto=Hasta+60%25+dcto&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Parkas y cortavientos",
							link: "/category/cat12650002/Parkas-y-Cortavientos-Mujer"
						},
						{
							isHighlightLink: false,
							link: "/category/cat6930191/Petos",
							label: "Petos",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat6930180/Poleras",
							label: "Poleras"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat6930181/Polerones-Mujer",
							label: "Polerones"
						},
						{
							label: "Shorts",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat12650001/Shorts-y-Pantalones?facetSelected=true&f.product.attribute.Tipo=Shorts&f.range.derived.variant.discount_upto=Hasta+60%25+dcto&facetSelected=true"
						},
						{
							isHighlightLink: false,
							label: "Ofertas",
							link: "/collection/ofertas-mujer-ropa-deportiva",
							meatStickerOption: 0
						}
					],
					label: "Ropa deportiva mujer",
					link: "/category/cat6930168/Ropa-Deportiva-Mujer"
				},
				{
					verTodoActive: true,
					label: "Ropa deportiva hombre",
					link: "/category/cat6930003/Ropa-Deportiva-Hombre",
					leafCategories: [
						{
							link: "/category/cat6930003/Ropa-Deportiva-Hombre",
							label: "Ver todo",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							label: "Camisetas de fútbol",
							link: "/category/cat190004/Camisetas-Oficiales",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat6930019/Pantalones-y-Joggers-deportivos",
							label: "Pantalones y joggers"
						},
						{
							link: "/category/cat12650004/Parkas-deportivas-y-cortavientos-Hombre",
							meatStickerOption: 0,
							label: "Parkas y cortavientos",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Poleras",
							link: "/category/cat6930011/Poleras-deportivas"
						},
						{
							link: "/category/cat6930014/Polerones-deportivos",
							isHighlightLink: false,
							label: "Polerones",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat6930018/Shorts-Deportivo",
							meatStickerOption: 0,
							label: "Shorts"
						},
						{
							meatStickerOption: 0,
							label: "Ofertas",
							isHighlightLink: false,
							link: "/collection/ofertas-hombre-ropa-deportiva"
						}
					]
				},
				{
					verTodoActive: true,
					link: "/collection/Accesorios-Deportivos ",
					leafCategories: [
						{
							link: "/collection/Accesorios-Deportivos ",
							label: "Ver todo",
							isHighlightLink: true
						},
						{
							label: "Bolsos y mochilas",
							link: "/collection/Accesorios-Deportivos?f.product.attribute.Tipo=Bolsos%3A%3ABolsos+deportivos%3A%3ABolsos+outdoor%3A%3AMochilas+de+hidrataci%C3%B3n%3A%3AMochilas+deportivas%3A%3AMochilas+outdoor",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Botellas e hidratación",
							meatStickerOption: 0,
							link: "/collection/Accesorios-Deportivos?f.product.attribute.Tipo=Accesorios+De+Hidrataci%C3%B3n%3A%3ABotellas+deportivas"
						},
						{
							meatStickerOption: 0,
							link: "/collection/Accesorios-Deportivos?f.product.attribute.Tipo=Calcetines+deportivos",
							label: "Calcetines",
							isHighlightLink: false
						},
						{
							link: "/collection/Accesorios-Deportivos?f.product.attribute.Tipo=Gorros%3A%3AJockeys",
							label: "Jockeys y gorros",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Pelotas",
							meatStickerOption: 0,
							link: "/category/cat11070034/Pelotas",
							isHighlightLink: false
						},
						{
							label: "Relojes",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat7480067/Relojes-deportivos"
						}
					],
					label: "Accesorios"
				},
				{
					label: "Mundo fitness",
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat2036/Mundo-Fitness"
						},
						{
							isHighlightLink: false,
							label: "Accesorios fitness",
							meatStickerOption: 0,
							link: "/category/cat6930440/Accesorios-Fitness"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Bicicletas estáticas",
							link: "/category/cat4046/Bicicletas-Estaticas"
						},
						{
							link: "/category/cat4044/Elipticas",
							meatStickerOption: 0,
							label: "Elípticas",
							isHighlightLink: false
						},
						{
							label: "Home gym",
							link: "/category/cat4053/Home-Gym",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Mancuernas y pesas",
							meatStickerOption: 0,
							link: "/category/cat6930442/Mancuernas-y-Pesas"
						},
						{
							link: "/category/cat90016/Maquinas-de-Abdominales",
							meatStickerOption: 0,
							label: "Máquinas de abdominales",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Spinning",
							link: "/category/cat4092/Spinning"
						},
						{
							isHighlightLink: false,
							label: "Trotadoras",
							meatStickerOption: 0,
							link: "/category/cat19170001/Trotadoras"
						}
					],
					link: "/category/cat2036/Mundo-Fitness"
				},
				{
					verTodoActive: true,
					link: "/category/cat70007/Bicicletas",
					label: "Bicicletas",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat70007/Bicicletas"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat6930367/Accesorios",
							label: "Accesorios"
						},
						{
							link: "/category/cat6930376/Cascos?facetSelected=true&f.product.attribute.Tipo=Cascos",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cascos"
						},
						{
							link: "/category/cat530006/Bicicletas-Electricas-y-Plegables",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Eléctricas y plegables"
						},
						{
							link: "/category/cat90099/Bicicletas-Infantiles",
							meatStickerOption: 0,
							label: "Infantiles",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Mountain bike",
							link: "/category/cat70008/Bicicletas-Mountain-Bike",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat6930366/Ropa-Ciclismo",
							meatStickerOption: 0,
							label: "Ropa ciclismo"
						},
						{
							link: "/category/cat190018/Bicicletas-Ruta-Pista",
							isHighlightLink: false,
							label: "Ruta pista",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Urbanas",
							link: "/category/cat70010/Bicicletas-Urbanas"
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/page/disciplinas-deporte?staticPageId=48400002"
						},
						{
							isHighlightLink: false,
							label: "Basquetbol",
							meatStickerOption: 0,
							link: "/category/cat90097/Basquetbol"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7190284/Boxeo-y-Artes-Marciales",
							meatStickerOption: 0,
							label: "Boxeo y artes marciales"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Fútbol",
							link: "/category/cat90089/Futbol"
						},
						{
							label: "Motociclismo",
							link: "/category/cat7190291/Motociclismo",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Natación",
							meatStickerOption: 0,
							link: "/category/cat7190282/Natacion"
						},
						{
							link: "/category/cat7190288/Pesca",
							label: "Pesca",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ping pong/Taca taca",
							link: "/category/cat6930454/Ping-pong--Taca-Taca-y-Pool"
						},
						{
							isHighlightLink: false,
							label: "Tenis y padel",
							link: "/category/cat90090/Tenis-y-Padel",
							meatStickerOption: 0
						}
					],
					label: "Disciplinas",
					verTodoActive: true,
					link: "/page/disciplinas-deporte?staticPageId=48400002"
				},
				{
					link: "/category/cat6930448/Camping",
					label: "Camping",
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat6930448/Camping"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Accesorios",
							link: "/category/cat90105/Accesorios-Outdoor"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Carpas",
							link: "/category/cat90101/Carpas"
						},
						{
							isHighlightLink: false,
							label: "Cocina",
							meatStickerOption: 0,
							link: "/category/cat14790011/Cocina-de-Camping"
						},
						{
							meatStickerOption: 0,
							label: "Colchones y colchonetas",
							isHighlightLink: false,
							link: "/category/cat90102/Colchones-y-Colchonetas"
						},
						{
							link: "/category/cat90104/Coolers",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Coolers"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat10692271/Equipamiento-Outdoor",
							isHighlightLink: false,
							label: "Equipamiento"
						},
						{
							isHighlightLink: false,
							link: "/category/cat6930080/Hidratacion",
							meatStickerOption: 0,
							label: "Hidratación"
						},
						{
							isHighlightLink: false,
							label: "Mochilas y bolsos",
							meatStickerOption: 0,
							link: "/category/cat90121/Mochilas-y-Bolsos-Outdoor"
						},
						{
							label: "Náuticos",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7190285/Nauticos"
						},
						{
							isHighlightLink: false,
							label: "Sacos de dormir",
							link: "/category/cat90103/Sacos-de-Dormir",
							meatStickerOption: 0
						}
					]
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat18260007/Electromovilidad",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							link: "/category/cat15810007/Bicicletas-Electricas",
							meatStickerOption: 0,
							label: "Bicicletas eléctricas"
						},
						{
							meatStickerOption: 0,
							label: "Cascos urbanos",
							isHighlightLink: false,
							link: "/category/cat5210012/Cascos-Urbanos"
						},
						{
							link: "/category/cat7280160/Hoverboard",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Hoverboard"
						},
						{
							label: "Monorueda, patín y skate",
							meatStickerOption: 0,
							link: "/category/cat18260008/Monorueda,-Patin-y-skate",
							isHighlightLink: false
						},
						{
							label: "Scooters eléctricos",
							link: "/category/cat8910010/Scooters-Electricos-Adultos",
							meatStickerOption: 0,
							isHighlightLink: false
						}
					],
					link: "/category/cat18260007/Electromovilidad",
					label: "Electromovilidad"
				}
			],
			link: "cat6930002",
			label: "Deportes",
			bannerLocation: "urlToImage"
		},
		{
			subCategories: [
				{
					label: "Tendencias - Inspiración",
					link: "/page/Moda-F?staticPageId=19100004",
					leafCategories: [
						{
							label: "MANGO",
							isHighlightLink: false,
							link: "/page/Mango?staticPageId=10700001",
							meatStickerOption: 0
						},
						{
							label: "INSPÍRATE EN MODA F",
							link: "/page/Moda-F?staticPageId=19100004",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/page/Marcas-Premium?staticPageId=48000001",
							meatStickerOption: 0,
							label: "MARCAS PREMIUM"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Cecilia Bolocco Apology",
							link: "/collection/coleccion-cecilia-bolocco-para-apology"
						},
						{
							meatStickerOption: 0,
							link: "/collection/regalables-dia-de-la-madre",
							isHighlightLink: false,
							label: "Regalos Día de la Madre"
						}
					],
					verTodoActive: true
				},
				{
					link: "/category/cat11670003/Especiales",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/collection/diseno-local",
							isHighlightLink: false,
							label: "Diseño local"
						},
						{
							isHighlightLink: false,
							label: "Mundo señora",
							meatStickerOption: 0,
							link: "/collection/mundo-senora"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/Mundo-Surf",
							label: "Mundo surf"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat17790018/Mujer-mas-sustentable",
							isHighlightLink: false,
							label: "Ropa + sustentable"
						},
						{
							isHighlightLink: false,
							link: "/category/cat14510010/Fiesta",
							label: "Ropa de fiesta",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Ropa maternal",
							isHighlightLink: false,
							link: "/category/cat7350021/Ropa-Maternal"
						},
						{
							isHighlightLink: false,
							link: "/collection/Tallas-Grandes-Mujer",
							meatStickerOption: 0,
							label: "Tallas grandes"
						}
					],
					label: "Segmentos y ocasiones"
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat12440001/Zapatos-Mujer",
							isHighlightLink: true
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "NUEVA TEMPORADA",
							link: "/collection/zapatos-mujer-nueva-temporada"
						},
						{
							isHighlightLink: false,
							link: "/category/cat12440001/Zapatos-Mujer?facetSelected=true&f.product.attribute.Tipo=Botas%3A%3ABotines",
							meatStickerOption: 0,
							label: "Botas y botines"
						},
						{
							link: "/category/cat16630007/Pantuflas",
							label: "Pantuflas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat850068/Zapatillas-Mujer",
							label: "Zapatillas"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat12440001/Zapatos-Mujer",
							label: "Zapatos"
						}
					],
					link: "/category/cat12440001/Zapatos-Mujer",
					verTodoActive: true,
					label: "Zapatos"
				},
				{
					link: "/category/cat20002/Moda-Mujer",
					verTodoActive: true,
					label: "Ropa",
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat20002/Moda-Mujer"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "NUEVA TEMPORADA",
							link: "/collection/Nueva-Temporada-Moda-Mujer"
						},
						{
							link: "/category/cat850030/Blusas-y-Poleras-Mujer",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Blusas y poleras"
						},
						{
							link: "/category/cat20002/Moda-Mujer?facetSelected=true&f.product.attribute.Tipo=Buzos%3A%3ACalzas&isPLP=1",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Buzos y calzas"
						},
						{
							label: "Chalecos y sweaters",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/sweaters-y-chalecos-mujer"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat850036/Abrigos-y-Chaquetas",
							label: "Chaquetas y parkas"
						},
						{
							label: "Faldas y shorts",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat20002/Moda-Mujer?facetSelected=true&f.product.attribute.Tipo=Faldas%3A%3AShorts&isPLP=1"
						},
						{
							isHighlightLink: false,
							label: "Jeans",
							meatStickerOption: 0,
							link: "/category/cat850038/Jeans"
						},
						{
							label: "Maternal",
							meatStickerOption: 0,
							link: "/category/cat7350021/Ropa-Maternal",
							isHighlightLink: false
						},
						{
							label: "Packs",
							link: "/collection/packs-mujer",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Pantalones",
							link: "/category/cat850040/Pantalones",
							isHighlightLink: false
						},
						{
							label: "Polerones y chiporros",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat20002/Moda-Mujer?facetSelected=true&f.product.attribute.Tipo=Chiporros%3A%3APolar%3A%3APolerones&isPLP=1"
						},
						{
							meatStickerOption: 0,
							link: "/collection/Tallas-Grandes-Mujer",
							isHighlightLink: false,
							label: "Tallas grandes"
						},
						{
							link: "/category/cat11610008/Trajes-de-Banos-y-Bikinis",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Trajes de baño"
						},
						{
							link: "/category/cat14330023/Vestidos-y-Enteritos",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Vestidos y enteritos"
						},
						{
							meatStickerOption: 0,
							label: "Ofertas",
							link: "/collection/ofertas-mujer-ropa-v2",
							isHighlightLink: false
						}
					]
				},
				{
					label: "Ropa interior y pijamas",
					leafCategories: [
						{
							link: "/category/cat13140017/Ropa-Interior-y-Pijamas",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "NUEVA TEMPORADA",
							link: "/collection/lo-nuevo-en-ropa-interior-mujer"
						},
						{
							link: "/category/cat7350018/Calzones",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Calzones"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7350012/Fajas-y-Modeladores",
							label: "Fajas y modeladores",
							meatStickerOption: 0
						},
						{
							link: "/category/cat13990009/Pack-Ropa-Interior",
							isHighlightLink: false,
							label: "Pack ropa interior",
							meatStickerOption: 0
						},
						{
							link: "/category/cat13140017/Ropa-Interior-y-Pijamas?facetSelected=true&f.product.attribute.Tipo=Accesorios%3A%3AAntifaz%3A%3ABatas%3A%3ABatas+de+ba%C3%B1o%3A%3APantuflas%3A%3APolerones+de+dormir",
							meatStickerOption: 0,
							label: "Pantuflas y accesorios",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Pantys y calcetines",
							link: "/category/cat7350013/Pantys-y-Calcetines"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat7350017/Pijamas-y-Camisas-de-dormir",
							isHighlightLink: false,
							label: "Pijamas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Sostenes",
							link: "/category/cat7350019/Sostenes"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/ofertas-mujer-ropa-interior-y-pijamas",
							label: "Ofertas"
						}
					],
					verTodoActive: true,
					link: "/category/cat13140017/Ropa-Interior-y-Pijamas"
				},
				{
					label: "Accesorios",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat2017/Accesorios-Mujer",
							label: "Ver todo"
						},
						{
							isHighlightLink: false,
							label: "NUEVA TEMPORADA",
							link: "/collection/lo-nuevo-en-accesorios-mujer",
							meatStickerOption: 0
						},
						{
							label: "Billeteras",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat3038/Billeteras"
						},
						{
							label: "Carteras y mochilas",
							isHighlightLink: false,
							link: "/category/cat7480104/Carteras-y-Mochilas",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat590028/Joyas",
							label: "Joyas"
						},
						{
							label: "Lentes",
							link: "/category/cat7480074/Anteojos?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex&facetSelected=true",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat14864567/Anteojos-Opticos?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex",
							label: "Lentes ópticos",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Mascarillas",
							link: "/collection/mascarillas-falabella",
							meatStickerOption: 0
						},
						{
							label: "Pañuelos",
							link: "/category/cat3088/Panuelos",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Relojes",
							link: "/category/cat12160001/Relojes-Mujer"
						}
					],
					link: "/category/cat2017/Accesorios-Mujer",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					link: "/page/marcas-a-z?staticPageId=47100001&v=2",
					label: "Marcas destacadas",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Marcas de la A a la Z",
							link: "/page/marcas-a-z?staticPageId=47100001&v=2"
						},
						{
							isHighlightLink: false,
							link: "/collection/Americanino-Mujer",
							label: "Americanino",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Basement",
							link: "https://www.falabella.com/falabella-cl/page/Basement?staticPageId=7600004"
						},
						{
							meatStickerOption: 0,
							label: "Calzedonia",
							link: "/category/cat7330051/Moda-Mujer?f.product.brandName=calzedonia",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Desigual",
							link: "/collection/desigual",
							meatStickerOption: 0
						},
						{
							link: "/collection/Doo-Australia-Mujer",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Doo Australia"
						},
						{
							meatStickerOption: 0,
							label: "ELLE",
							isHighlightLink: false,
							link: "/collection/Elle-mujer"
						},
						{
							label: "Esprit",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/Esprit-mujer"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Etam",
							link: "/category/cat7330051/Moda-Mujer?f.product.brandName=etam"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/Free-People",
							label: "Free People"
						},
						{
							link: "/collection/Gap-mujer",
							label: "GAP",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "iO",
							link: "/collection/Io-mujer",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/collection/Mango-Mujer",
							meatStickerOption: 0,
							label: "Mango",
							isHighlightLink: false
						},
						{
							label: "Mossimo",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/Mossimo-Mujer"
						},
						{
							link: "/collection/only",
							isHighlightLink: false,
							label: "Only",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/collection/Rapsodia-mujer",
							meatStickerOption: 0,
							label: "Rapsodia"
						},
						{
							isHighlightLink: false,
							link: "/collection/Saville-Row-Mujer",
							meatStickerOption: 0,
							label: "Saville Row"
						},
						{
							meatStickerOption: 0,
							link: "/collection/sybilla-moda-mujer",
							isHighlightLink: false,
							label: "Sybilla"
						},
						{
							link: "/collection/University-Club-mujer",
							label: "University Club",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/collection/vero-moda",
							label: "Vero Moda",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/collection/Violeta-by-Mango",
							meatStickerOption: 0,
							label: "Violeta by Mango"
						}
					]
				}
			],
			label: "Mujer",
			link: "cat7330051"
		},
		{
			label: "Hombre",
			link: "cat7450065",
			subCategories: [
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "INSPÍRATE EN MODA F",
							link: "/page/moda-hombre?staticPageId=48900002",
							isHighlightLink: false
						},
						{
							link: "/collection/urbano-hombre",
							label: "URBAN STORE",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/marcas-surferas",
							label: "MUNDO SURF"
						},
						{
							label: "Ropa cómoda",
							link: "/collection/comfort-everywhere",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ropa + sustentable",
							link: "/collection/COLECCIONMODAHOMBRESUSTENTABLE"
						},
						{
							link: "/category/cat1320008/Moda-Hombre?f.variant.attribute.size=xxl%3A%3Axxxl&isPLP=1",
							isHighlightLink: false,
							label: "Tallas grandes",
							meatStickerOption: 0
						}
					],
					label: "Tendencias - Inspiración",
					link: "/page/moda-hombre?staticPageId=48900002",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					label: "Zapatos",
					link: "/category/cat1720006/Zapatos-Hombre",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat1720006/Zapatos-Hombre",
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/zapatos-hombre-nueva-coleccion ",
							label: "NUEVA TEMPORADA"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1720008/Botines-Hombre?f.product.attribute.Tipo=Botas%3A%3ABotines",
							meatStickerOption: 0,
							label: "Botas y botines"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Zapatillas",
							link: "/category/cat850064/Zapatillas-Hombre"
						},
						{
							label: "Zapatos",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1720006/Zapatos-Hombre"
						}
					]
				},
				{
					link: "/category/cat5260002/Ropa-Interior",
					label: "Ropa interior y pijamas",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat5260002/Ropa-Interior",
							isHighlightLink: true
						},
						{
							link: "/category/cat7450083/Boxers",
							label: "Boxers y calzoncillos",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat5260002/Ropa-interior?f.product.attribute.Tipo=Calcetines%3A%3ACalcetines+de+vestir",
							label: "Calcetines",
							isHighlightLink: false
						},
						{
							label: "Pantuflas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7450089/Pantuflas-hombre"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7450086/Pijamas",
							label: "Pijamas y camisetas"
						}
					],
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat1320008/Moda-Hombre"
						},
						{
							meatStickerOption: 0,
							link: "/collection/Nueva-temporada-Moda-Hombre",
							isHighlightLink: false,
							label: "NUEVA TEMPORADA"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Camisas formales",
							link: "/category/cat7450067/Camisas-de-Vestir"
						},
						{
							label: "Camisas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat18380042/Camisas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1320012/Chalecos-y-Sweaters",
							label: "Chalecos y sweaters"
						},
						{
							isHighlightLink: false,
							link: "/category/cat16580002/Chaquetas-y-Abrigos",
							label: "Chaquetas y parkas",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Chiporros",
							link: "/category/cat16530002/Chiporros-Hombre"
						},
						{
							isHighlightLink: false,
							label: "Jeans",
							meatStickerOption: 0,
							link: "/category/cat7450073/Jeans-Hombre"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat17980009/Pantalones-Hombre",
							label: "Pantalones y buzos"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat1320010/Poleras",
							label: "Poleras"
						},
						{
							link: "/category/cat7500027/Polerones-y-Polar",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Polerones y polar"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13620025/Shorts-y-Bermudas",
							meatStickerOption: 0,
							label: "Shorts y bermudas"
						},
						{
							meatStickerOption: 0,
							label: "Trajes de baño",
							isHighlightLink: false,
							link: "/category/cat7450062/Trajes-de-Bano"
						},
						{
							meatStickerOption: 0,
							label: "Trajes formales",
							link: "/category/cat1640033/Trajes-Formales",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Ofertas",
							link: "/collection/ofertas-hombre-ropa",
							isHighlightLink: false
						}
					],
					link: "/category/cat1320008/Moda-Hombre",
					verTodoActive: true,
					label: "Ropa"
				},
				{
					link: "/category/cat7660002/Belleza?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre",
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/category/cat8950035/Afeitadoras-y-Cortapelos",
							isHighlightLink: false,
							label: "Afeitadoras y cortapelos"
						},
						{
							link: "/category/cat7660002/Belleza?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre&f.product.attribute.Tipo=Aceites+capilares%3A%3AAcondicionadores%3A%3AAftershave%3A%3AControl+ca%C3%ADda%3A%3ACremas+de+masaje+capilar%3A%3ACremas+para+peinar%3A%3AOtros+accesorios+de+belleza%3A%3APreparados+de+afeitar%3A%3ASet+de+tratamiento+capilar%3A%3AShampoos%3A%3ASprays+capilares%3A%3ATratamientos+capilares",
							meatStickerOption: 0,
							label: "Barbería y capilar",
							isHighlightLink: false
						},
						{
							link: "/category/cat3112/Perfumes-hombre",
							meatStickerOption: 0,
							label: "Perfumes de hombre",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Tratamiento e higiene",
							link: "/category/cat7660002/Belleza?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre&f.product.attribute.Tipo=Acondicionadores%3A%3ACepillos%3A%3AColoraci%C3%B3n%3A%3ADesodorantes%3A%3AHidratantes+corporales%3A%3AHidratantes+faciales%3A%3AJabones+corporales%3A%3AJabones+faciales%3A%3ALimpiadores%3A%3ASet+de+tratamientos+corporales%3A%3ASet+de+tratamientos+facial%3A%3AShampoos%3A%3AS%C3%A9rum%3A%3AS%C3%A9rums%3A%3ATratamientos+antiedad%3A%3ATratamientos+para+el+contorno+de+ojos"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/vitaminas-y-suplementos",
							label: "Vitaminas y suplementos"
						}
					],
					label: "Cuidado personal",
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							link: "/category/cat6930003/Ropa-Deportiva-Hombre",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							link: "/collection/Accesorios-Deportivos?f.product.attribute.G%C3%A9nero=Hombre%3A%3AUnisex",
							label: "Accesorios",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Bolsos deportivos",
							isHighlightLink: false,
							link: "/collection/Accesorios-Deportivos?f.product.attribute.Tipo=Bolsos%3A%3ABolsos+deportivos%3A%3ABolsos+outdoor%3A%3AMochilas+de+hidrataci%C3%B3n%3A%3AMochilas+deportivas%3A%3AMochilas+outdoor&f.product.attribute.G%C3%A9nero=Hombre%3A%3AUnisex"
						},
						{
							label: "Calcetines",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/Accesorios-Deportivos?f.product.attribute.Tipo=Calcetines+deportivos&f.product.attribute.G%C3%A9nero=Hombre%3A%3AUnisex"
						},
						{
							label: "Camisetas de fútbol",
							link: "/category/cat190004/Camisetas-Oficiales",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Pantalones y joggers",
							link: "/category/cat6930019/Pantalones-y-Joggers",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat12650004/Parkas-y-Cortavientos-Hombre",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Parkas y cortavientos"
						},
						{
							link: "/category/cat6930011/Poleras",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Poleras"
						},
						{
							link: "/category/cat6930014/Polerones",
							label: "Polerones",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat6930018/Shorts-Deportivo",
							isHighlightLink: false,
							label: "Shorts"
						},
						{
							label: "Ofertas",
							meatStickerOption: 0,
							link: "/collection/ofertas-hombre-ropa-deportiva",
							isHighlightLink: false
						}
					],
					verTodoActive: true,
					label: "Ropa deportiva",
					link: "/category/cat6930003/Ropa-Deportiva-Hombre"
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat6050003/Accesorios-Hombre",
							isHighlightLink: true
						},
						{
							meatStickerOption: 0,
							link: "/category/cat6050003/Accesorios-Hombre?f.product.attribute.Temporada=Otoño-Invierno",
							isHighlightLink: false,
							label: "NUEVA TEMPORADA"
						},
						{
							label: "Billeteras",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat6050006/Billeteras"
						},
						{
							isHighlightLink: false,
							link: "/category/cat6050005/Cinturones",
							meatStickerOption: 0,
							label: "Cinturones"
						},
						{
							link: "/category/cat1320018/Corbatas-y-Humitas",
							meatStickerOption: 0,
							label: "Corbatas y humitas",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Jockeys y gorros",
							link: "/category/cat6050008/Jockeys-y-Gorros"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7480074/Anteojos?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre%3A%3AUnisex&facetSelected=true%2Ctrue",
							meatStickerOption: 0,
							label: "Lentes"
						},
						{
							label: "Lentes ópticos",
							link: "/category/cat14864567/Anteojos-Opticos?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre%3A%3AUnisex",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat3207/Relojes-Hombre",
							meatStickerOption: 0,
							label: "Relojes",
							isHighlightLink: false
						}
					],
					label: "Accesorios",
					verTodoActive: true,
					link: "/category/cat6050003/Accesorios-Hombre"
				},
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Americanino",
							link: "/collection/Americanino-Hombre"
						},
						{
							link: "/category/cat1320008/Moda-Hombre?f.product.brandName=basement&isPLP=1",
							isHighlightLink: false,
							label: "Basement",
							meatStickerOption: 0
						},
						{
							link: "/category/cat1320008/Moda-Hombre?f.product.brandName=calvin+klein&isPLP=1",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Calvin Klein"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1320008/Moda-Hombre?facetSelected=true&f.product.brandName=cascais.",
							label: "Cascais"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1320008/Moda-Hombre?f.product.brandName=dockers&isPLP=1",
							meatStickerOption: 0,
							label: "Dockers"
						},
						{
							label: "GAP",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1320008/Moda-Hombre?f.product.brandName=gap&isPLP=1"
						},
						{
							link: "/category/cat1320008/Moda-Hombre?f.product.brandName=lacoste&isPLP=1",
							isHighlightLink: false,
							label: "Lacoste",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "La Martina",
							link: "/collection/la-martina",
							isHighlightLink: false
						},
						{
							label: "Levi's",
							link: "/category/cat1320008/Moda-Hombre?f.product.brandName=levis%3A%3Alevis+negocio+especial&isPLP=1",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Mango Man",
							link: "/collection/mango-man",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Mossimo",
							link: "/category/cat1320008/Moda-Hombre?f.product.brandName=mossimo&isPLP=1"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Tommy Hilfiger",
							link: "/category/cat1320008/Moda-Hombre?f.product.brandName=tommy+hilfiger&isPLP=1"
						},
						{
							link: "/page/wolf-hank?staticPageId=49400006",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Wolf&Hank"
						}
					],
					link: "/category/cat5420004/Marcas-Destacadas",
					verTodoActive: true,
					label: "Marcas destacadas"
				}
			]
		},
		{
			label: "Niños y juguetería",
			subCategories: [
				{
					link: "/collection/ver-todo-ropa-nina",
					verTodoActive: true,
					leafCategories: [
						{
							label: "0-24 meses",
							link: "/collection/ropa-bebe-nina-0-a-24",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "2-8 años",
							link: "/collection/ropa-nina-2-a-8",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "10-16 años",
							meatStickerOption: 0,
							link: "/collection/ropa-nina-8-a16"
						}
					],
					label: "Ropa de niñas por edad"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							label: "Ver todo",
							link: "/collection/ver-todo-ropa-nina",
							isHighlightLink: true
						},
						{
							link: "/page/mundo-infantil?staticPageId=48900003",
							isHighlightLink: false,
							label: "INSPÍRATE EN MODA F",
							meatStickerOption: 0
						},
						{
							link: "/collection/comodos-en-casa?facetSelected=true&f.product.attribute.Género=Niña%3A%3AUnisex",
							meatStickerOption: 0,
							label: "Básicos escenciales",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Calcetines y ropa interior",
							isHighlightLink: false,
							link: "/collection/ver-todo-pijamas-nina?facetSelected=true&f.product.attribute.Tipo=Calcetines%3A%3ACalcetines+de+vestir%3A%3ACalzones%3A%3ACamisetas%3A%3APack%3A%3APantys%3A%3APetos%3A%3ASostenes"
						},
						{
							isHighlightLink: false,
							link: "/category/cat14370004/Calzas",
							label: "Calzas y buzos",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Chaquetas y parkas",
							link: "/category/cat17010032/Chaquetas,-Parkas-y-Abrigos-Ninas",
							isHighlightLink: false
						},
						{
							link: "/category/cat16400014/Jeans-y-Pantalones-Ninas",
							meatStickerOption: 0,
							label: "Jeans y pantalones",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Pijamas y pantuflas",
							link: "/collection/ver-todo-pijamas-nina?facetSelected=true&f.product.attribute.Tipo=Pantuflas%3A%3APijamas",
							meatStickerOption: 0
						},
						{
							label: "Poleras y blusas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/ver-todo-ropa-nina?facetSelected=true&f.product.attribute.Tipo=Poleras"
						},
						{
							meatStickerOption: 0,
							label: "Polerones y chalecos",
							isHighlightLink: false,
							link: "/category/cat16400013/Sweaters-y-Polerones-Ninas"
						},
						{
							meatStickerOption: 0,
							link: "/collection/ver-todo-ropa-deportiva-nina",
							label: "Ropa deportiva",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Shorts y jardineras",
							link: "/category/cat19280007/Shorts-Ninas",
							meatStickerOption: 0
						},
						{
							link: "/category/cat19290017/Trajes-de-Bano-y-Bikinis-Ninas",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Trajes de baño y bikinis"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Vestidos y enteritos",
							link: "/category/cat16400015/Faldas-y-Vestidos-Ninas"
						}
					],
					link: "/collection/ver-todo-ropa-nina",
					label: "Ropa de niñas por tipo"
				},
				{
					label: "Ropa de niños por edad",
					verTodoActive: true,
					link: "/collection/ver-todo-ropa-nino",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/ropa-bebe-nino-0-a-24",
							label: "0-24 meses"
						},
						{
							link: "/collection/ropa-nino-2-a-8",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "2-8 años"
						},
						{
							isHighlightLink: false,
							link: "/collection/ropa-nino-8-a-16",
							label: "10-16 años",
							meatStickerOption: 0
						}
					]
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/collection/ver-todo-ropa-nino"
						},
						{
							label: "INSPÍRATE EN MODA F",
							isHighlightLink: false,
							link: "/page/mundo-infantil?staticPageId=48900003",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Buzos y conjuntos",
							link: "/category/cat16400020/Buzos-y-Conjuntos-Ninos"
						},
						{
							link: "/collection/ver-todo-ropa-interior-y-pijamas-nino?facetSelected=true&f.product.attribute.Tipo=Bodys%3A%3ABoxers%3A%3ACalcetines%3A%3ACalcetines+de+vestir%3A%3ACalcetines+deportivos%3A%3ACalzoncillos%3A%3ACamisetas%3A%3APack",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Calcetines y ropa interior"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Chaquetas y parkas",
							link: "/category/cat17010033/Chaquetas,-Parkas-y-Abrigos-Ninos"
						},
						{
							link: "/category/cat16400019/Jeans-y-Pantalones-Ninos",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Jeans y pantalones"
						},
						{
							isHighlightLink: false,
							link: "/collection/ver-todo-ropa-interior-y-pijamas-nino?facetSelected=true&f.product.attribute.Tipo=Pantuflas%3A%3APijamas",
							meatStickerOption: 0,
							label: "Pijamas y pantuflas"
						},
						{
							link: "/collection/ver-todo-ropa-nino?facetSelected=true&f.product.attribute.Tipo=Poleras",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Poleras y camisas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat16400018/Sweaters-y-Polerones-Ninos",
							meatStickerOption: 0,
							label: "Polerones y chalecos"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/ver-todo-ropa-deportiva-nino",
							label: "Ropa deportiva"
						},
						{
							link: "/category/cat19280010/Shorts-Ninos",
							label: "Shorts",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Trajes de baño",
							link: "/category/cat19290018/Trajes-de-Bano-Ninos",
							meatStickerOption: 0
						}
					],
					label: "Ropa de niños por tipo",
					link: "/collection/ver-todo-ropa-nino"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/collection/Ver-Todo-Zapatos-Ninos"
						},
						{
							meatStickerOption: 0,
							link: "/collection/zapatos-ninos-nueva-coleccion",
							isHighlightLink: false,
							label: "NUEVA TEMPORADA"
						},
						{
							label: "Botas y botines",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/Ver-Todo-Zapatos-Ninos?f.product.attribute.Tipo=Botas%3A%3ABotas+de+lluvia%3A%3ABotines"
						},
						{
							isHighlightLink: false,
							label: "Zapatillas",
							meatStickerOption: 0,
							link: "/collection/Ver-Todo-Zapatillas-Ninos"
						}
					],
					label: "Zapatos",
					verTodoActive: true,
					link: "/collection/Ver-Todo-Zapatos-Ninos"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/collection/coniglio",
							meatStickerOption: 0,
							label: "Coniglio"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ecko",
							link: "/collection/ecko"
						},
						{
							link: "/collection/eleven",
							label: "Eleven",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/collection/federation",
							label: "Federation",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Mango Kids",
							link: "/collection/mango-kids",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/collection/yamp",
							label: "Yamp",
							meatStickerOption: 0
						}
					],
					link: "/category/cat5620004/Moda-infantil",
					label: "Marcas destacadas"
				},
				{
					link: "/category/cat14680031/Juguetes",
					leafCategories: [
						{
							link: "/category/cat14680031/Juguetes",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							link: "/category/cat14680031/Juguetes?facetSelected=true&f.product.attribute.Edad_mínima_recomendada=3+meses%3A%3A6+meses%3A%3A9+meses%3A%3ARecién+nacido",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "0 a 1 año"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat14680031/Juguetes?f.product.attribute.Edad_mínima_recomendada=1+año%3A%3A12+meses%3A%3A2+años",
							label: "1 a 2 años",
							isHighlightLink: false
						},
						{
							label: "3 a 5 años",
							link: "/category/cat14680031/Juguetes?f.product.attribute.Edad_mínima_recomendada=3+años%3A%3A4+años%3A%3A5+años&isPLP=1%2C1%2C1%2C1&isPLP=1",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "6 a 8 años",
							meatStickerOption: 0,
							link: "/category/cat14680031/Juguetes?f.product.attribute.Edad_mínima_recomendada=6+años%3A%3A7+años%3A%3A8+años&isPLP=1%2C1%2C1%2C1%2C1&isPLP=1",
							isHighlightLink: false
						},
						{
							link: "/category/cat14680031/Juguetes?f.product.attribute.Edad_mínima_recomendada=10+años%3A%3A11+años%3A%3A12+años%3A%3A13+años%3A%3A14+años%3A%3A15+años%3A%3A9+años&isPLP=1%2C1%2C1%2C1%2C1%2C1%2C1%2C1&isPLP=1",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "9 años o más"
						}
					],
					label: "Juguetes por edad",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					label: "Juegos de exterior",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat690277/Juegos-de-Exterior-e-Interior"
						},
						{
							label: "Centros de juegos",
							link: "/collection/juegos-de-exterior",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Inflables",
							link: "/category/cat6930380/Inflables",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Juegos deportivos",
							link: "/category/cat12270023/Juegos-Deportivos",
							isHighlightLink: false
						},
						{
							link: "/category/cat6930454/Ping-pong,-Taca-Taca-y-Pool",
							label: "Ping pong, taca taca y pool",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Piscinas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/piscinas-y-accesorios"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Scooter, skate y patines",
							link: "/category/cat7280035/Scooter--Skate-y-Patines"
						},
						{
							label: "Triciclos y correpasillos",
							link: "/category/cat3078/Triciclos-y-Correpasillos",
							meatStickerOption: 0,
							isHighlightLink: false
						}
					],
					link: "/category/cat690277/Juegos-de-Exterior-e-Interior"
				},
				{
					verTodoActive: true,
					label: "Juguetería",
					link: "/category/cat14680031/Juguetes",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat14680031/Juguetes",
							isHighlightLink: true
						},
						{
							label: "Arte y manualidades",
							isHighlightLink: false,
							link: "/category/cat90073/Arte-y-Manualidades",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat17840007/Autos-y-Pistas",
							label: "Autos y pistas",
							meatStickerOption: 0
						},
						{
							link: "/category/cat210002/Disfraces",
							label: "Disfraces",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat690283/Radiocontrolados",
							isHighlightLink: false,
							label: "Drones y radiocontrolados",
							meatStickerOption: 0
						},
						{
							link: "/category/cat16760013/Figuras-Coleccionables",
							label: "Figuras coleccionables",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat690299/Figuras-de-Juguetes",
							isHighlightLink: false,
							label: "Figuras de juguetes"
						},
						{
							label: "Instrumentos musicales niños",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10260004/Instrumentos-Musicales-Ninos"
						},
						{
							link: "/category/cat3127/Juegos-de-Mesa",
							meatStickerOption: 0,
							label: "Juegos de mesa",
							isHighlightLink: false
						},
						{
							label: "Juegos de rol",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat6980031/Juegos-de-Rol"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Juguetes bebé",
							link: "/category/cat4059/Juguetes-Bebe"
						},
						{
							meatStickerOption: 0,
							label: "Juguetes didácticos",
							isHighlightLink: false,
							link: "/category/cat90080/Juguetes-Didacticos"
						},
						{
							label: "LEGO y armables",
							isHighlightLink: false,
							link: "/category/cat430005/Lego-y-Armables",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Libros infantiles",
							link: "/category/cat910002/Libros-Infantiles"
						},
						{
							isHighlightLink: false,
							label: "Muñecas y accesorios",
							link: "/category/cat90074/Munecas-y-Accesorios",
							meatStickerOption: 0
						},
						{
							link: "/category/cat90075/Peluches",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Peluches"
						},
						{
							label: "Pistolas de juguete",
							isHighlightLink: false,
							link: "/category/cat90083/Pistolas-de-Juguete",
							meatStickerOption: 0
						},
						{
							label: "Puzzles y rompecabezas",
							link: "/category/cat8860003/Puzzles-y-Rompecabezas",
							meatStickerOption: 0,
							isHighlightLink: false
						}
					]
				}
			],
			bannerLocation: "urlToImage",
			link: "cat7510001"
		},
		{
			link: "cat13550007",
			subCategories: [
				{
					verTodoActive: true,
					label: "Ropa bebé niña por edad",
					link: "/category/cat7280122/Ropa-de-bebe?f.product.attribute.Género=Niña%3A%3AUnisex",
					leafCategories: [
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "0-6 meses",
							link: "/category/cat7280122/Ropa-de-bebe?f.product.attribute.G%C3%A9nero=Ni%C3%B1a%3A%3AUnisex&f.variant.attribute.size=0+meses%3A%3A3+meses"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat7280122/Ropa-de-bebe?f.product.attribute.G%C3%A9nero=Ni%C3%B1a%3A%3AUnisex&f.variant.attribute.size=12+meses%3A%3A6+meses%3A%3A9+meses",
							label: "6-12 meses",
							isHighlightLink: false
						},
						{
							label: "12-24 meses",
							meatStickerOption: 0,
							link: "/category/cat7280122/Ropa-de-bebe?f.product.attribute.G%C3%A9nero=Ni%C3%B1a%3A%3AUnisex&f.variant.attribute.size=12+meses%3A%3A18+meses%3A%3A24+meses",
							isHighlightLink: false
						}
					]
				},
				{
					verTodoActive: true,
					link: "/category/cat13680004/Vestuario-Bebe-Nina",
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat13680004/Vestuario-Bebe-Nina"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Bodies y piluchos",
							link: "/category/cat15330009/Bodies-Ninas-Bebe"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Buzos y sets",
							link: "/category/cat15330007/Buzos-y-Conjuntos-Ninas-Bebe"
						},
						{
							isHighlightLink: false,
							link: "/category/cat15330010/Ropa-Interior-Ninas-Bebe",
							meatStickerOption: 0,
							label: "Calcetines, baberos y gorros"
						},
						{
							label: "Calzas, jeans y pantalones",
							link: "/category/cat15330005/Jeans-y-Pantalones-Ninas-Bebe",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Chaquetas y parkas",
							link: "/category/cat15330030/Chaquetas,-Parkas-y-Abrigos-Ninas-Bebe",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Ositos y enteritos",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat15330006/Ositos-y-Enteritos-Ninas-Bebe"
						},
						{
							label: "Patitas y pantys",
							link: "/category/cat13680004/Ropa-de-bebe-nina?f.product.attribute.Tipo=Pantys&isPLP=1%2C1&isPLP=1",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Pijamas",
							isHighlightLink: false,
							link: "/category/cat15330012/Pijamas-Ninas-Bebe"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat15330001/Poleras-y-Blusas-Ninas-Bebe",
							label: "Poleras, blusas y camisetas"
						},
						{
							isHighlightLink: false,
							label: "Polerones y chalecos",
							link: "/category/cat15330011/Sweaters-y-Polerones-Ninas-Bebe",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Trajes de baño",
							isHighlightLink: false,
							link: "/category/cat15330004/Trajes-de-Banos-y-Bikinis-Ninas-Bebe?&f.product.attribute.Género=Niña%3A%3AUnisex"
						},
						{
							label: "Vestidos y jardineras",
							meatStickerOption: 0,
							link: "/category/cat15330003/Faldas-y-Vestidos-Ninas-Bebe",
							isHighlightLink: false
						}
					],
					label: "Ropa bebé niña por tipo"
				},
				{
					label: "Ropa bebé niño por edad",
					leafCategories: [
						{
							label: "0-6 meses",
							link: "/category/cat7280122/Ropa-de-bebe?&f.product.attribute.G%C3%A9nero=Ni%C3%B1o%3A%3AUnisex&f.variant.attribute.size=0+meses%3A%3A3+meses",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat7280122/Ropa-de-bebe?f.product.attribute.G%C3%A9nero=Ni%C3%B1o%3A%3AUnisex&f.variant.attribute.size=12+meses%3A%3A6+meses%3A%3A9+meses",
							isHighlightLink: false,
							label: "6-12 meses"
						},
						{
							label: "12-24 meses",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7280122/Ropa-de-bebe?f.product.attribute.G%C3%A9nero=Ni%C3%B1o%3A%3AUnisex&f.variant.attribute.size=12+meses%3A%3A18+meses%3A%3A24+meses"
						}
					],
					verTodoActive: true,
					link: "/category/cat7280122/Ropa-de-bebe?&f.product.attribute.Género=Niño%3A%3AUnisex"
				},
				{
					label: "Ropa bebé niño por tipo",
					link: "/category/cat14730004/Vestuario-Bebe-Nino",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat14730004/Vestuario-Bebe-Nino",
							isHighlightLink: true
						},
						{
							label: "Bodies y piluchos",
							link: "/category/cat15330025/Bodies-Ninos-Bebe",
							isHighlightLink: false
						},
						{
							link: "/category/cat15330022/Buzos-y-Conjuntos-Ninos-Bebe",
							isHighlightLink: false,
							label: "Buzos y sets"
						},
						{
							isHighlightLink: false,
							label: "Calcetines, baberos y gorros",
							meatStickerOption: 0,
							link: "/category/cat15330026/Ropa-Interior-Ninos-Bebe"
						},
						{
							link: "/category/cat15330017/Chaquetas,-Parkas-y-Abrigos-Ninos-Bebe",
							isHighlightLink: false,
							label: "Chaquetas y parkas"
						},
						{
							link: "/category/cat15330021/Jeans-y-Pantalones-Ninos-Bebe",
							isHighlightLink: false,
							label: "Jeans y pantalones"
						},
						{
							isHighlightLink: false,
							label: "Ositos y enteritos",
							link: "/category/cat15330023/Ositos-y-Enteritos-Ninos-Bebe"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat15330029/Pijamas-Ninos-Bebe",
							isHighlightLink: false,
							label: "Pijamas"
						},
						{
							label: "Poleras, camisas y camisetas",
							link: "/category/cat15330018/Poleras-y-Camisas-Ninos-Bebe",
							isHighlightLink: false
						},
						{
							link: "/category/cat15330027/Sweaters-y-Polerones-Ninos-Bebe",
							isHighlightLink: false,
							label: "Polerones y chalecos"
						},
						{
							link: "/category/cat15330019/Shorts-Ninos-Bebe",
							isHighlightLink: false,
							label: "Shorts y jardineras"
						},
						{
							isHighlightLink: false,
							label: "Trajes de baño",
							meatStickerOption: 0,
							link: "/category/cat15330020/Trajes-de-Bano-Ninos-Bebe"
						}
					]
				},
				{
					link: "/category/cat2008/Mundo-Bebe?isLanding=true",
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat2008/Mundo-Bebe"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat3020/Andadores",
							label: "Andadores"
						},
						{
							label: "Baño bebé",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat210004/Bano-Bebe"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat550035/Bolsos-Maternales",
							label: "Bolsos maternales"
						},
						{
							link: "/category/cat10890020/Shampoos-y-jabones-bebe",
							isHighlightLink: false,
							label: "Crema, shampoo y jabón",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat2810080/Cuidados-Maternales",
							meatStickerOption: 0,
							label: "Cuidados maternales"
						},
						{
							label: "Cunas y colchones",
							isHighlightLink: false,
							link: "/category/cat3159/Dormitorio-Bebe",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat4051/Gimnasio-Bebe",
							meatStickerOption: 0,
							label: "Gimnasio y actividad"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Juguetes bebé",
							link: "/category/cat4059/Juguetes-Bebe"
						},
						{
							label: "Monitores y seguridad",
							link: "/category/cat70065/Seguridad-Infantil",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Pañales",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10540003/Panales"
						},
						{
							isHighlightLink: false,
							label: "Porta bebé",
							link: "/category/cat4022/Porta-Bebe",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat7280122/Vestuario-Bebe",
							label: "Ropa de bebé",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat3233/Sillas-Nido",
							label: "Sillas nido"
						},
						{
							link: "/category/cat13650010/Termometros",
							label: "Termómetros",
							meatStickerOption: 0,
							isHighlightLink: false
						}
					],
					verTodoActive: true,
					label: "Mundo bebé"
				},
				{
					verTodoActive: true,
					label: "Lactancia/alimentación",
					leafCategories: [
						{
							link: "/category/cat2670020/Extractores-de-Leche",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Extractores"
						},
						{
							label: "Leches y colados",
							meatStickerOption: 0,
							link: "/category/cat4010/Alimentacion-Infantil?f.product.attribute.Tipo=Bebestibles%3A%3AConservas%3A%3AC%C3%A1psulas%3A%3ADulces",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat2670018/Mamaderas",
							label: "Mamaderas",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Platos y contenedores",
							link: "/category/cat4010/Alimentacion-Infantil"
						},
						{
							isHighlightLink: false,
							label: "Sillas de comer",
							meatStickerOption: 0,
							link: "/category/cat3230/Sillas-de-Comer"
						}
					],
					link: "/category/cat10190016/Lactancia"
				},
				{
					link: "/category/cat3064/Coches",
					leafCategories: [
						{
							link: "/category/cat3064/Coches",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							isHighlightLink: false,
							link: "/category/cat10400099/Accesorios-Coches",
							label: "Accesorios coches y paseos",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat7510040/Coches-Cuna",
							isHighlightLink: false,
							label: "Coches cuna"
						},
						{
							link: "/category/cat7510042/Coches-Dobles",
							isHighlightLink: false,
							label: "Coches dobles",
							meatStickerOption: 0
						},
						{
							link: "/category/cat7510041/Coches-Jogger",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Coches Jogger"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Coches livianos y compactos",
							link: "/category/cat7510039/Coches-Livianos-y-Compactos"
						},
						{
							link: "/category/cat7510037/Coches-Travel-System",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Coches Travel System"
						},
						{
							link: "/collection/ofertas-ninos-y-bebes-coches",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ofertas"
						}
					],
					label: "Coches y paseos",
					verTodoActive: true
				},
				{
					label: "Sillas de auto",
					link: "/category/cat3228/Sillas-de-Auto",
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat3228/Sillas-de-Auto"
						},
						{
							label: "Accesorios silla de auto",
							isHighlightLink: false,
							link: "/category/cat10400098/Accesorios-Silla-de-Auto",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Alzadores",
							isHighlightLink: false,
							link: "/category/cat7510046/Alzadores"
						},
						{
							label: "Butacas",
							link: "/category/cat7510045/Butacas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat7510044/Convertibles",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Convertibles"
						},
						{
							meatStickerOption: 0,
							label: "Silla nido auto",
							isHighlightLink: false,
							link: "/category/cat9180001/Silla-Nido-Auto"
						}
					]
				}
			],
			label: "Bebés"
		},
		{
			link: "cat700256",
			subCategories: [
				{
					label: "Tendencias - Inspiración",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "SNEAKER CORNER",
							link: "/page/zapatillas?staticPageId=31100001"
						},
						{
							meatStickerOption: 0,
							link: "/page/zapatos?staticPageId=18100003",
							isHighlightLink: false,
							label: "INSPÍRATE EN MODA F"
						},
						{
							link: "/page/Marcas-Premium?staticPageId=48000001",
							label: "MARCAS PREMIUM",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/collection/zapatos-diseno-chileno",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Diseño Chileno"
						},
						{
							isHighlightLink: false,
							label: "Zapatos plataforma",
							meatStickerOption: 0,
							link: "/collection/Zapatos-Plataforma"
						}
					],
					link: "/page/zapatillas?staticPageId=31100001",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					label: "Mujer",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat12440001/Zapatos-Mujer"
						},
						{
							isHighlightLink: false,
							link: "/collection/zapatos-mujer-nueva-temporada",
							label: "NUEVA TEMPORADA",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Botas",
							isHighlightLink: false,
							link: "/category/cat690241/Botas"
						},
						{
							label: "Botines",
							meatStickerOption: 0,
							link: "/category/cat690245/Botines",
							isHighlightLink: false
						},
						{
							link: "/category/cat16630007/Pantuflas",
							isHighlightLink: false,
							label: "Pantuflas",
							meatStickerOption: 0
						},
						{
							link: "/category/cat690247/Sandalias-Mujer",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Sandalias"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat850068/Zapatillas-Mujer",
							label: "Zapatillas",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat7500147/Zapatillas-Outdoor",
							label: "Zapatillas outdoor",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Zapatillas running",
							link: "/category/cat7500146/Zapatillas-Running?facetSelected=true&f.product.attribute.Disciplina=Cross+training%3A%3ARunning&facetSelected=true",
							isHighlightLink: false
						},
						{
							label: "Zapatillas urbanas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat12440001/Zapatos?facetSelected=true&f.product.attribute.Tipo=Zapatillas+urbanas"
						},
						{
							isHighlightLink: false,
							label: "Zapatos",
							meatStickerOption: 0,
							link: "/category/cat12440001/Zapatos-Mujer?facetSelected=true&f.product.attribute.Tipo=Alpargatas%3A%3ABallerinas%3A%3AMocasines%3A%3AZapatos+casuales%3A%3AZapatos+formales&facetSelected=true%2Ctrue%2Ctrue%2Ctrue&isPLP=1"
						},
						{
							label: "Zapatos cómodos",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/zapatos-comodos-mujer"
						}
					],
					link: "/category/cat12440001/Zapatos-Mujer"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat1720006/Zapatos-Hombre",
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							label: "NUEVA TEMPORADA",
							link: "/collection/zapatos-hombre-nueva-coleccion",
							isHighlightLink: false
						},
						{
							link: "/category/cat1720008/Botines-Hombre?f.product.attribute.Tipo=Botas%3A%3ABotines",
							label: "Botines",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat1720006/Zapatos?facetSelected=true&f.product.attribute.Tipo=Mocasines&isPLP=1",
							label: "Mocasines",
							isHighlightLink: false
						},
						{
							link: "/category/cat1720006/Zapatos?facetSelected=true&f.product.attribute.Tipo=Pantuflas",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Pantuflas"
						},
						{
							label: "Sandalias",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1720006/Zapatos?facetSelected=true&f.product.attribute.Tipo=Sandalias"
						},
						{
							label: "Zapatillas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat850064/Zapatillas-Hombre"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Zapatillas de fútbol",
							link: "/category/cat6930355/Zapatillas-de-Running?facetSelected=true&f.product.attribute.Disciplina=Baby+fútbol%3A%3AFútbol&facetSelected=true"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat6930356/Zapatillas-de-Outdoor",
							label: "Zapatillas outdoor"
						},
						{
							link: "/category/cat6930355/Zapatillas-de-Running?f.product.attribute.Disciplina=Cross+training%3A%3ARunning&facetSelected=true&facetSelected=true",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Zapatillas running"
						},
						{
							meatStickerOption: 0,
							label: "Zapatillas urbanas",
							link: "/category/cat7500133/Zapatillas-Urbanas",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Zapatos casual",
							link: "/category/cat1720006/Zapatos-Hombre?f.product.attribute.Tipo=Mocasines%3A%3AZapatos+casuales"
						},
						{
							link: "/collection/zapatos-comodos?f.product.attribute.G%C3%A9nero=Hombre",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Zapatos cómodos"
						},
						{
							label: "Zapatos de seguridad",
							link: "/category/cat1720006/Zapatos?facetSelected=true&f.product.attribute.Tipo=Zapatos+de+seguridad",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat1720006/Zapatos?facetSelected=true&f.product.attribute.Tipo=Zapatos+formales",
							meatStickerOption: 0,
							label: "Zapatos formal",
							isHighlightLink: false
						}
					],
					label: "Hombre",
					link: "/category/cat1720006/Zapatos-Hombre",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/collection/Ver-Todo-Zapatos-Ninos",
							label: "Ver todo"
						},
						{
							link: "/collection/zapatos-ninos-nueva-coleccion",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "NUEVA TEMPORADA"
						},
						{
							isHighlightLink: false,
							label: "Botas y botines",
							link: "/collection/Ver-Todo-Zapatos-Ninos?f.product.attribute.Tipo=Botas%3A%3ABotas+de+lluvia%3A%3ABotines",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/collection/Ver-Todo-Zapatos-Ninos?f.product.attribute.Tipo=Sandalias",
							isHighlightLink: false,
							label: "Sandalias"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/Ver-Todo-Zapatillas-Ninos?f.product.attribute.G%C3%A9nero=Ni%C3%B1a%3A%3AUnisex",
							label: "Zapatillas niñas"
						},
						{
							label: "Zapatillas niños",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/Ver-Todo-Zapatillas-Ninos?f.product.attribute.G%C3%A9nero=Ni%C3%B1o%3A%3AUnisex"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Zapatos escolares",
							link: "/collection/zapatos-y-zapatillas-escolares"
						},
						{
							isHighlightLink: false,
							label: "Zapatos niñas",
							meatStickerOption: 0,
							link: "/collection/Ver-Todo-Zapatos-Nina"
						},
						{
							isHighlightLink: false,
							link: "/collection/Ver-Todo-Zapatos-Nino",
							meatStickerOption: 0,
							label: "Zapatos niños"
						}
					],
					label: "Niños",
					link: "/collection/Ver-Todo-Zapatos-Ninos"
				},
				{
					link: "/collection/ver-todo-zapatos",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/collection/Ver-Todo-Zapatillas?facetSelected=true&f.product.brandName=adidas%3A%3Aadidas+originals",
							label: "adidas",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/ver-todo-zapatos?f.product.brandName=aldo",
							label: "Aldo"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Americanino",
							link: "/collection/ver-todo-zapatos?f.product.brandName=americanino"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Basement",
							link: "/collection/ver-todo-zapatos?f.product.brandName=basement"
						},
						{
							link: "/collection/ver-todo-zapatos?f.product.brandName=call+it+spring",
							label: "Call it Spring",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Cat",
							link: "/collection/ver-todo-zapatos?f.product.brandName=cat",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/collection/ver-todo-zapatos?f.product.brandName=clarks",
							isHighlightLink: false,
							label: "Clarks",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/Ver-Todo-Zapatillas?facetSelected=true&f.product.brandName=converse",
							label: "Converse"
						},
						{
							label: "Dr Martens",
							link: "/collection/ver-todo-zapatos?f.product.brandName=dr+martens",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/collection/Ver-Todo-Zapatillas?facetSelected=true&f.product.brandName=fila",
							isHighlightLink: false,
							label: "Fila"
						},
						{
							isHighlightLink: false,
							label: "Hunter",
							link: "/collection/ver-todo-zapatos?f.product.brandName=hunter",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Lippi",
							link: "/category/cat2083/Zapatillas?f.product.brandName=lippi",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Merrel",
							meatStickerOption: 0,
							link: "/collection/Ver-Todo-Zapatillas?facetSelected=true&f.product.brandName=merrell"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat12440001/Zapatos?facetSelected=true&f.product.brandName=michael+kors&isPLP=1",
							label: "Michael Kors"
						},
						{
							isHighlightLink: false,
							link: "/collection/Ver-Todo-Zapatillas?facetSelected=true&f.product.brandName=new+balance",
							label: "New Balance",
							meatStickerOption: 0
						},
						{
							label: "Nike",
							meatStickerOption: 0,
							link: "/collection/Ver-Todo-Zapatillas?facetSelected=true&f.product.brandName=nike",
							isHighlightLink: false
						},
						{
							label: "Panamajack",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/ver-todo-zapatos?f.product.brandName=panamajack"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/Ver-Todo-Zapatillas?facetSelected=true&f.product.brandName=puma",
							label: "Puma"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Skechers",
							link: "/collection/ver-todo-zapatos?f.product.brandName=skechers"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Sybilla",
							link: "/category/cat12440001/Zapatos?facetSelected=true&f.product.brandName=sybilla&isPLP=1"
						},
						{
							link: "/collection/Ver-Todo-Zapatillas?facetSelected=true&f.product.brandName=vans",
							isHighlightLink: false,
							label: "Vans",
							meatStickerOption: 0
						}
					],
					label: "Marcas destacadas",
					verTodoActive: true
				}
			],
			label: "Zapatos",
			bannerLocation: "urlToImage"
		},
		{
			link: "cat7660002",
			subCategories: [
				{
					verTodoActive: true,
					label: "Belleza",
					link: "/page/belleza?staticPageId=44400001&sred=belleza",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "INSPÍRATE EN BELLEZA",
							link: "/page/belleza?staticPageId=44400001&sred=belleza"
						},
						{
							meatStickerOption: 0,
							label: "MARCAS PREMIUM",
							isHighlightLink: false,
							link: "/page/Marcas-Premium?staticPageId=48000001"
						},
						{
							isHighlightLink: false,
							label: "Belleza clean",
							meatStickerOption: 0,
							link: "/collection/clean-beauty"
						},
						{
							label: "Belleza: top ventas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/belleza-top-ventas"
						},
						{
							link: "/collection/Compra-y-prueba",
							label: "Compra y prueba",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cuidado capilar",
							link: "/category/cat9440008/Cuidado-Capilar"
						},
						{
							link: "/category/cat4960009/Cuidado-del-Cuerpo",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cuidado cuerpo"
						},
						{
							label: "Cuidado personal hombre",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/cuidado-personal-y-tratamiento-hombre"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cuidado rostro",
							link: "/category/cat3214/Cuidado-del-Rostro"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/dermocosmetica",
							label: "Dermocosmética"
						},
						{
							link: "/category/cat690199/Maquillaje",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Maquillaje"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/belleza-reviews",
							label: "Mejor evaluados"
						},
						{
							isHighlightLink: false,
							label: "Perfumes",
							link: "/category/cat2069/Perfumes",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat7660002/Belleza?facetSelected=true&f.product.attribute.Formato=Set",
							label: "Regalos"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/Wellness",
							label: "Suplementos y vitaminas"
						},
						{
							link: "/page/Make-Up-Tutoriales?staticPageId=38800001",
							meatStickerOption: 0,
							label: "Tutoriales y videos",
							isHighlightLink: false
						}
					]
				},
				{
					verTodoActive: true,
					link: "/category/cat2069/Perfumes",
					label: "Perfumes",
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat2069/Perfumes"
						},
						{
							link: "/collection/Compra-y-prueba",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Compra y prueba"
						},
						{
							isHighlightLink: false,
							label: "Hombre",
							meatStickerOption: 0,
							link: "/category/cat3112/Perfumes-hombre"
						},
						{
							isHighlightLink: false,
							label: "Mujer",
							link: "/category/cat3160/Perfumes-mujer",
							meatStickerOption: 0
						},
						{
							label: "Sets",
							link: "/category/cat4960008/Sets-de-Perfumes",
							isHighlightLink: false,
							meatStickerOption: 0
						}
					]
				},
				{
					leafCategories: [
						{
							link: "/category/cat3214/Cuidado-del-Rostro",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							link: "/category/cat3214/Cuidado-del-Rostro?facetSelected=true&f.product.attribute.Tipo=Ampollas%3A%3AContorno+de+ojos%3A%3APeeling%3A%3AS%C3%A9rum%3A%3ATratamientos+antiedad%3A%3ATratamientos+para+el+contorno+de+ojos&isPLP=1",
							isHighlightLink: false,
							label: "Antiedad y serums",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Barbería y tratamiento",
							link: "/collection/tratamiento-hombre-y-barberia",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Belleza Coreana",
							link: "/category/cat11150002/Belleza-Coreana"
						},
						{
							label: "Cremas mamás y bebés",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat3214/Cuidado-del-Rostro?facetSelected=true&f.product.attribute.Tipo=Aceites+beb%C3%A9%3A%3AAceites+mam%C3%A1%3A%3AHidratantes+corporales%3A%3ATratamientos+antiestr%C3%ADas"
						},
						{
							link: "/category/cat4960009/Cuidado-del-Cuerpo",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cuerpo"
						},
						{
							label: "Depiladoras",
							link: "/category/cat3085/Depiladoras",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Depiladoras IPL",
							link: "/category/cat10150027/Depiladoras-IPL"
						},
						{
							isHighlightLink: false,
							label: "Hidratantes/mascarillas",
							link: "/category/cat3214/Cuidado-del-Rostro?facetSelected=true&f.product.attribute.Tipo=Aguas+termales%3A%3AContorno+de+ojos%3A%3AHidratantes+faciales%3A%3AMascarillas%3A%3ASet+de+tratamientos+facial%3A%3ATratamientos+de+acn%C3%A9%3A%3ATratamientos+de+manchas%3A%3ATratamientos+para+el+contorno+de+ojos%3A%3ATratamientos+para+poros"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7660002/Belleza?facetSelected=true&f.product.attribute.Tipo=Acondicionadores%3A%3ACepillo+dental%3A%3ACepillos%3A%3AColoraci%C3%B3n%3A%3ADesodorantes%3A%3AJabones+corporales%3A%3AJabones+faciales%3A%3ASales+de+ba%C3%B1o%3A%3AShampoos",
							meatStickerOption: 0,
							label: "Higiene"
						},
						{
							link: "/category/cat3214/Cuidado-del-Rostro?facetSelected=true&f.product.attribute.Tipo=Cepillos%3A%3ADesmaquillantes%3A%3AExfoliantes%3A%3AJabones+faciales%3A%3ALimpiadores%3A%3AT%C3%B3nicos+Faciales&isPLP=1",
							label: "Limpiadores",
							isHighlightLink: false
						},
						{
							label: "Sets",
							isHighlightLink: false,
							link: "/category/cat3214/Cuidado-del-Rostro?facetSelected=true&f.product.attribute.Formato=Set"
						},
						{
							label: "Tecnología para la belleza",
							link: "/category/cat7660011/Tecnologia-para-la-belleza",
							isHighlightLink: false
						}
					],
					label: "Cuidado piel",
					link: "/category/cat3214/Cuidado-del-Rostro"
				},
				{
					verTodoActive: true,
					label: "Maquillaje",
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat690199/Maquillaje"
						},
						{
							label: "Brochas y accesorios",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat690203/Brochas-y-accesorios-de-maquillaje"
						},
						{
							isHighlightLink: false,
							link: "/category/cat690199/Maquillaje?facetSelected=true&f.product.attribute.Tipo=Cuidado+de+pesta%C3%B1as+y+cejas%3A%3ADelineadores+de+cejas%3A%3AMaquillajes+para+cejas&isPLP=1",
							meatStickerOption: 0,
							label: "Cejas"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Esmalte de uñas",
							link: "/category/cat690199/Maquillaje?facetSelected=true&f.product.attribute.Tipo=Esmaltes+de+u%C3%B1as%3A%3AEsmaltes+de+u%C3%B1as+permanentes%3A%3AEsmaltes+de+u%C3%B1as+semi-permanentes"
						},
						{
							isHighlightLink: false,
							label: "Labios",
							link: "/category/cat4720024/Maquillaje-de-labios",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat4720025/Maquillaje-de-ojos",
							label: "Ojos"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat4720026/Maquillaje-de-rostro",
							label: "Rostro",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Sets",
							link: "/category/cat4720028/Sets-de-Maquillaje"
						}
					],
					link: "/category/cat690199/Maquillaje"
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							link: "/collection/dermocosmetica",
							isHighlightLink: true
						},
						{
							link: "/category/cat13060003/Anti-Edad",
							isHighlightLink: false,
							label: "Antiedad"
						},
						{
							label: "Cuerpo",
							link: "/category/cat13060006/Cuerpo",
							isHighlightLink: false
						},
						{
							link: "/category/cat13060007/Hidratacion-y-Limpieza",
							isHighlightLink: false,
							label: "Hidratación y limpieza"
						},
						{
							link: "/category/cat690213/Bloqueadores-solares",
							isHighlightLink: false,
							label: "Protección solar"
						},
						{
							isHighlightLink: false,
							link: "/collection/sets-dermocosmetica",
							label: "Sets"
						}
					],
					label: "Dermocosmética",
					link: "/category/cat13080027/Dermocosmetica?isLanding=true"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat9440008/Cuidado-Capilar"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat8950035/Afeitadoras-y-Cortapelos",
							isHighlightLink: false,
							label: "Afeitadoras y cortapelos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3018/Alisadores-de-pelo",
							meatStickerOption: 0,
							label: "Alisadores de pelo"
						},
						{
							isHighlightLink: false,
							label: "Barbería y tratamiento",
							link: "/collection/tratamiento-hombre-y-barberia"
						},
						{
							isHighlightLink: false,
							label: "Marcas profesionales",
							link: "/category/cat7670019/Marcas-profesionales"
						},
						{
							isHighlightLink: false,
							label: "Mascarillas para pelo",
							meatStickerOption: 0,
							link: "/category/cat9440008/Cuidado-Capilar?facetSelected=true&f.product.attribute.Tipo=Cremas+de+masaje+capilar%3A%3AMascarillas+capilares%3A%3ATratamientos+capilares&facetSelected=true%2Ctrue&isPLP=1"
						},
						{
							link: "/category/cat3170/Onduladores-de-pelo",
							meatStickerOption: 0,
							label: "Onduladores de pelo",
							isHighlightLink: false
						},
						{
							label: "Secadores de pelo",
							isHighlightLink: false,
							link: "/category/cat3223/Secadores-de-pelo",
							meatStickerOption: 0
						},
						{
							link: "/category/cat5870075/Sets-Capilares",
							label: "Sets",
							isHighlightLink: false
						},
						{
							label: "Shampoo/acondicionador",
							isHighlightLink: false,
							link: "/category/cat90039/Shampoo-y-acondicionador"
						},
						{
							isHighlightLink: false,
							label: "Vitaminas para pelo",
							link: "/collection/nutricosmetica",
							meatStickerOption: 0
						},
						{
							label: "Ofertas",
							link: "/collection/ofertas-belleza-cuidado-capilar",
							meatStickerOption: 0,
							isHighlightLink: false
						}
					],
					label: "Cuidado capilar",
					link: "/category/cat9440008/Cuidado-Capilar?isLanding=true"
				},
				{
					link: "/page/belleza?staticPageId=44400001&sred=belleza",
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/page/anastasia?staticPageId=41400001&sred=anastasia",
							isHighlightLink: false,
							label: "Anastasia"
						},
						{
							link: "/page/Avene?staticPageId=48200002&sred",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Avene"
						},
						{
							label: "Bath & Body Works",
							isHighlightLink: false,
							link: "/page/bathbodyworks?staticPageId=44400002&sred=bath-and-body",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Benefit",
							link: "/page/Mundo-Benefit?staticPageId=8600001&sred=benefit",
							isHighlightLink: false
						},
						{
							label: "CHANEL",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/page/CHANEL?staticPageId=47200006"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "DIOR",
							link: "/page/Dior?staticPageId=47300001&sred=dior"
						},
						{
							isHighlightLink: false,
							label: "Foreo",
							link: "/page/foreo?staticPageId=39700006&sred=foreo"
						},
						{
							meatStickerOption: 0,
							link: "/page/it-cosmetics?&staticPageId=49000001",
							label: "IT Cosmetics",
							isHighlightLink: false
						},
						{
							label: "Kiehl's",
							link: "/page/Kiehls?staticPageId=19600001&sred=Kiehls",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/page/La-Mer?staticPageId=5500002&sred=La+Mer",
							label: "La Mer",
							meatStickerOption: 0
						},
						{
							label: "MAC",
							meatStickerOption: 0,
							link: "/page/mac-cosmetics?staticPageId=200002&sred=MAC+Cosmetics",
							isHighlightLink: false
						},
						{
							label: "The Body Shop",
							link: "/page/The-Body-Shop?staticPageId=10900002&sred=the+body+shop",
							isHighlightLink: false
						}
					],
					label: "Marcas destacadas"
				},
				{
					label: "Regalos",
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/collection/belleza-regalos?&f.range.derived.price.search=HASTA+%2410.000&facetSelected=true%2Ctrue",
							isHighlightLink: false,
							label: "Hasta $10.000"
						},
						{
							meatStickerOption: 0,
							label: "Hasta $20.000",
							link: "/collection/belleza-regalos?facetSelected=true&f.range.derived.price.search=%2410.000+-+%2420.000%3A%3AHASTA+%2410.000&facetSelected=true%2Ctrue",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Hasta $50.000",
							link: "/collection/belleza-regalos?facetSelected=true&f.range.derived.price.search=%2410.000+-+%2420.000%3A%3A%2420.000+-+%2450.000%3A%3AHASTA+%2410.000&facetSelected=true%2Ctrue%2Ctrue",
							isHighlightLink: false
						},
						{
							link: "/collection/belleza-regalos?facetSelected=true&f.range.derived.price.search=%2410.000+-+%2420.000%3A%3A%2420.000+-+%2450.000%3A%3A%2450.000+-+%24100.000%3A%3AHASTA+%2410.000&facetSelected=true%2Ctrue%2Ctrue%2Ctrue",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Hasta $100.000"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Para él",
							link: "/collection/sets-para-regalar-hombre"
						},
						{
							isHighlightLink: false,
							link: "/collection/sets-para-regalar-mujer",
							meatStickerOption: 0,
							label: "Para ella"
						},
						{
							link: "/collection/sets-para-regalar",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Sets para regalar"
						}
					],
					verTodoActive: true,
					link: "/category/cat7660002/Belleza?facetSelected=true&f.product.attribute.Formato=Set"
				}
			],
			label: "Belleza"
		},
		{
			bannerLocation: "urlToImage",
			subCategories: [
				{
					verTodoActive: true,
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat7480104/Carteras-y-Mochilas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "NUEVA TEMPORADA",
							link: "/collection/lo-nuevo-en-accesorios"
						},
						{
							link: "/category/cat1870002/Accesorios-de-Viaje",
							meatStickerOption: 0,
							label: "Accesorios de viaje",
							isHighlightLink: false
						},
						{
							link: "/category/cat11084981/Bananos",
							label: "Bananos",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat3038/Billeteras",
							label: "Billeteras",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Bolsos deportivos",
							link: "/category/cat6930147/Bolsos-deportivos",
							isHighlightLink: false
						},
						{
							link: "/category/cat17700022/Bolsos-y-Mochilas-de-Viaje",
							label: "Bolsos y mochilas de viaje",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat690235/Carteras",
							label: "Carteras"
						},
						{
							label: "Carteras de cuero",
							link: "/category/cat13700005/Carteras-de-Cuero",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat7490022/Carteras-de-fiesta",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Carteras de fiesta"
						},
						{
							label: "Maletas",
							link: "/category/cat3143/Maletas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat5880085/Mochilas",
							meatStickerOption: 0,
							label: "Mochilas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ofertas",
							link: "/collection/ofertas-accesorios-carteras-y-mochilas"
						}
					],
					label: "Carteras, mochilas y maletas",
					link: "/category/cat7480104/Carteras-y-Mochilas"
				},
				{
					verTodoActive: true,
					label: "Relojes hombre",
					link: "/category/cat3207/Relojes-Hombre",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat3207/Relojes-Hombre",
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Deportivos",
							link: "/category/cat7480061/Relojes-deportivos"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat7480059/Relojes-moda",
							label: "Moda"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Smartwatches",
							link: "/category/cat4290063/SmartWatch"
						},
						{
							meatStickerOption: 0,
							label: "Ofertas",
							link: "/collection/ofertas-accesorios-relojes?f.product.attribute.Género=Hombre",
							isHighlightLink: false
						}
					]
				},
				{
					link: "/category/cat3208/Relojes",
					label: "Relojes",
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat3208/Relojes"
						},
						{
							link: "/category/cat12200002/Correas-Relojes",
							isHighlightLink: false,
							label: "Correas",
							meatStickerOption: 0
						},
						{
							label: "Deportivos",
							link: "/category/cat7480067/Relojes-deportivos",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat3207/Relojes-Hombre",
							label: "Hombre",
							meatStickerOption: 0
						},
						{
							link: "/category/cat7480065/Relojes-moda",
							meatStickerOption: 0,
							label: "Moda",
							isHighlightLink: false
						},
						{
							label: "Mujer",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat12160001/Relojes-Mujer"
						},
						{
							isHighlightLink: false,
							label: "Niños y niñas",
							link: "/category/cat7480068/Relojes-ninos-y-ninas",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat4290063/SmartWatch",
							label: "Smartwatches",
							meatStickerOption: 0
						}
					]
				},
				{
					verTodoActive: true,
					link: "/category/cat6050003/Accesorios-Hombre",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat6050003/Accesorios-Hombre"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Audífonos",
							link: "/category/cat1640002/Audifonos"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Billeteras",
							link: "/category/cat6050006/Billeteras"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Bolsos y mochilas",
							link: "/category/cat6050007/Bolsos-y-Mochilas"
						},
						{
							meatStickerOption: 0,
							label: "Bufandas y pañuelos",
							link: "/category/cat6050009/Bufandas-y-Panuelos",
							isHighlightLink: false
						},
						{
							label: "Cinturones",
							link: "/category/cat6050005/Cinturones",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat1320018/Corbatas-y-Humitas",
							isHighlightLink: false,
							label: "Corbatas y humitas"
						},
						{
							link: "/category/cat6050008/Jockeys-y-Gorros",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Jockeys y gorros"
						},
						{
							label: "Lentes",
							link: "/category/cat6050011/Anteojos-de-hombre",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Relojes",
							meatStickerOption: 0,
							link: "/category/cat3207/Relojes-Hombre",
							isHighlightLink: false
						}
					],
					label: "Accesorios hombre"
				},
				{
					verTodoActive: true,
					label: "Joyas",
					link: "/category/cat590028/Joyas",
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat590028/Joyas"
						},
						{
							isHighlightLink: false,
							label: "Anillos",
							link: "/category/cat6220008/Anillos",
							meatStickerOption: 0
						},
						{
							link: "/category/cat6220009/Aros",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Aros"
						},
						{
							link: "/category/cat12200022/Bisuteria",
							label: "Bisuteria",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Collares",
							link: "/category/cat6220007/Collares",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat14720006/Charms",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Dijes"
						},
						{
							link: "/category/cat12200019/Joyeria",
							label: "Joyeria",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Pulseras",
							link: "/category/cat6220010/Pulseras",
							meatStickerOption: 0
						},
						{
							label: "Ofertas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/ofertas-accesorios-joyeria"
						}
					]
				},
				{
					link: "/category/cat7480074/Anteojos",
					label: "Lentes",
					leafCategories: [
						{
							link: "/category/cat7480074/Anteojos",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Hombre",
							link: "/category/cat6050011/Anteojos-de-hombre"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7480074/Anteojos?f.product.brandName=diesel%3A%3Adolce+%26+gabana%3A%3Afendi%3A%3Alongchamp%3A%3Amichael+kors%3A%3Aprada%3A%3Aversace&isPLP=1",
							label: "Lujo"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Mujer",
							link: "/category/cat7480074/Anteojos?f.product.attribute.Género=Mujer::Unisex"
						},
						{
							label: "Ópticos",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14864567/Anteojos-Opticos"
						},
						{
							link: "/category/cat11370068/Anteojos-de-Sol",
							meatStickerOption: 0,
							label: "Sol",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Unisex",
							isHighlightLink: false,
							link: "/category/cat7480076/Anteojos-unisex"
						},
						{
							isHighlightLink: false,
							link: "/collection/ofertas-accesorios-lentes",
							label: "Ofertas",
							meatStickerOption: 0
						}
					],
					verTodoActive: true
				},
				{
					label: "Accesorios mujer",
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat2017/Accesorios-Mujer"
						},
						{
							link: "/collection/lo-nuevo-en-accesorios-mujer",
							meatStickerOption: 0,
							label: "NUEVA TEMPORADA",
							isHighlightLink: false
						},
						{
							label: "MARCAS PREMIUM",
							link: "/page/Marcas-Premium?staticPageId=48000001",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Billeteras",
							isHighlightLink: false,
							link: "/category/cat3038/Billeteras"
						},
						{
							label: "Bisuteria",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat12200022/Bisuteria"
						},
						{
							label: "Cinturones",
							link: "/category/cat3062/Cinturones",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Mascarillas",
							link: "/collection/mascarillas-falabella"
						},
						{
							meatStickerOption: 0,
							label: "Otros",
							link: "/category/cat8320002/Otros-Accesorios-Mujer",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Pañuelos",
							link: "/category/cat3088/Panuelos"
						},
						{
							label: "Sombreros",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1090002/Sombreros"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ofertas",
							link: "/collection/ofertas-accesorios-mujer"
						}
					],
					link: "/category/cat2017/Accesorios-Mujer"
				},
				{
					verTodoActive: true,
					link: "/category/cat7480098/Boutique",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat7480098/Boutique",
							isHighlightLink: true
						},
						{
							label: "Furla",
							link: "/category/cat10636807/Furla",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Longchamp",
							link: "/category/cat7480104/Carteras-y-mochilas?facetSelected=true&f.product.brandName=longchamp",
							isHighlightLink: false
						},
						{
							link: "/category/cat8290115/Michael-Kors",
							isHighlightLink: false,
							label: "Michael Kors",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/collection/ver-todo-pandora",
							label: "Pandora",
							isHighlightLink: false
						},
						{
							label: "Tous",
							link: "/collection/tous",
							isHighlightLink: false,
							meatStickerOption: 0
						}
					],
					label: "Boutique"
				}
			],
			label: "Accesorios",
			link: "cat7480057"
		},
		{
			link: "cat14000011",
			subCategories: [
				{
					label: "Instrumentos musicales",
					verTodoActive: true,
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat3117/Instrumentos-Musicales",
							isHighlightLink: true
						},
						{
							meatStickerOption: 0,
							label: "Amplificación",
							isHighlightLink: false,
							link: "/category/cat2860024/Amplificacion-y-HI-FI"
						},
						{
							label: "Bajos",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat13900004/Bajos"
						},
						{
							meatStickerOption: 0,
							label: "Baterías y percusión",
							isHighlightLink: false,
							link: "/category/cat70023/Baterias-y-Percusion"
						},
						{
							isHighlightLink: false,
							link: "/category/cat590091/Audio-profesional---DJ",
							meatStickerOption: 0,
							label: "DJ y audio profesional"
						},
						{
							link: "/category/cat70021/Guitarras",
							meatStickerOption: 0,
							label: "Guitarras",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Instrumentos de viento",
							link: "/category/cat70022/Instrumentos-de-Viento",
							isHighlightLink: false
						},
						{
							link: "/category/cat11382365/Instrumentos-musicales-escolares",
							isHighlightLink: false,
							label: "Instrumentos escolares",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat70024/Teclados-y-Pianos",
							isHighlightLink: false,
							label: "Teclados y pianos"
						},
						{
							label: "Ukeleles",
							link: "/category/cat18210004/Ukeleles",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat10917725/Vinilos",
							meatStickerOption: 0,
							label: "Vinilos"
						}
					],
					link: "/category/cat3117/Instrumentos-Musicales?isLanding=true"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat14090010/Mundo-Gourmet"
						},
						{
							meatStickerOption: 0,
							label: "Aceites y condimentos",
							link: "/category/cat14090030/Aceites-y-Condimentos",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Café y té",
							link: "/category/cat14090029/Cafe-y-Te",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14090027/Cerveza-y-Espumante",
							label: "Cerveza y espumante"
						},
						{
							label: "Chocolates",
							link: "/category/cat12011175/Chocolates",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Conservas",
							link: "/category/cat14090031/Conservas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Destilados y licores",
							link: "/category/cat14090026/Destilados-y-Licores",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Juan Valdez",
							link: "/category/cat10370033/Juan-Valdez"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Vinos y accesorios",
							link: "/category/cat14090025/Vinos-y-accesorios"
						}
					],
					label: "Mundo Gourmet",
					link: "/category/cat14090010/Mundo-Gourmet"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat9360001/Mascotas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat9360005/Alimentos-y-snacks",
							label: "Alimentos y snacks",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Casas, camas y transporte",
							link: "/category/cat9360006/Casas-y-Camas"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat12562928/Collares--Correas-y-arneses",
							isHighlightLink: false,
							label: "Collares, correas y arneses"
						},
						{
							link: "/category/cat9360002/Higiene-y-Cuidados",
							isHighlightLink: false,
							label: "Higiene y cuidados",
							meatStickerOption: 0
						},
						{
							link: "/category/cat13660004/Juguetes-y-Entrenamiento",
							meatStickerOption: 0,
							label: "Juguetes y entrenamiento",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat13620011/Pet-Lovers",
							label: "Pet Lovers"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ropa y accesorios",
							link: "/category/cat9360004/Ropa-y-Accesorios"
						}
					],
					verTodoActive: true,
					label: "Mascotas",
					link: "/category/cat9360001/Mascotas"
				},
				{
					label: "Experiencias y servicios",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat10175896/Experiencias",
							label: "Ver todo"
						},
						{
							link: "/collection/tiempo-libre",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Actividades"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Belleza y salud",
							link: "/collection/salud-y-belleza"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Cursos online y hobbies",
							link: "/category/cat10175896/Experiencias?facetSelected=true&f.product.brandName=artebianca%3A%3Abepretty%3A%3Aclub+de+la+cocina%3A%3Acosturas+y+moda%3A%3Acursos+de+cocina%3A%3Aemporionatural%3A%3Aschool+of+rock%3A%3Athe+perfect+makeup%3A%3Atopclass&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue"
						},
						{
							isHighlightLink: false,
							label: "Impresión de fotos",
							meatStickerOption: 0,
							link: "/collection/fotografia-personalizadas"
						}
					],
					verTodoActive: true,
					link: "/category/cat10175896/Experiencias"
				},
				{
					label: "Herramientas y repuestos",
					verTodoActive: true,
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat8620074/Herramientas"
						},
						{
							label: "Eléctricas e inalámbricas",
							link: "/category/cat18320014/Herramientas-electricas-e-inalambricas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat18320015/Herramientas-de-jardin",
							meatStickerOption: 0,
							label: "Jardín"
						},
						{
							label: "Maquinarias y complementos",
							link: "/category/cat18320016/Maquinarias-y-complementos",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Repuestos para autos",
							link: "/category/cat15457083/Repuestos-y-accesorios"
						}
					],
					link: "/category/cat8620074/Herramientas"
				},
				{
					verTodoActive: true,
					label: "Productos + sustentables",
					leafCategories: [
						{
							link: "/category/cat16050015/Productos-Mas-Sustentables",
							label: "Ver todo",
							isHighlightLink: true
						},
						{
							meatStickerOption: 0,
							link: "/collection/Ver-todo-fundacion-Artesanias-de-Chile",
							isHighlightLink: false,
							label: "Artesanía"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat18830002/Cuidado-del-Cuerpo-Mas-Verde",
							label: "Belleza"
						},
						{
							link: "/category/cat17790022/Decoracion-Mas-Verde",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Decoración"
						},
						{
							link: "/category/cat12744145/Emporio",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Emporio y hogar"
						},
						{
							isHighlightLink: false,
							link: "/category/cat16050016/Mas-Reutilizacion",
							label: "Hombre",
							meatStickerOption: 0
						},
						{
							label: "Menaje",
							link: "/category/cat17790015/Menaje-Mas-Verde",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat11787126/Muebles-Mas-Sustentables",
							label: "Muebles",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Mujer",
							link: "/category/cat17790018/Joyas-Mas-Verde"
						},
						{
							meatStickerOption: 0,
							label: "Niños",
							isHighlightLink: false,
							link: "/category/cat18830005/Vestuario-Infantil-Mas-Verde"
						}
					],
					link: "/category/cat16050015/Productos-Mas-Sustentables"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat14090015/Salud",
							label: "Ver todo"
						},
						{
							label: "Accesorios médicos",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14090017/Accesorios-Medicos"
						},
						{
							meatStickerOption: 0,
							label: "Balanzas",
							isHighlightLink: false,
							link: "/category/cat14090016/Balanzas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat14090018/Masajeadores-y-almohadas",
							meatStickerOption: 0,
							label: "Masajeadores/almohadas"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Mobiliario médico",
							link: "/category/cat19190046/Camillas-y-Catres"
						},
						{
							meatStickerOption: 0,
							label: "Movilidad",
							link: "/category/cat19190043/Movilidad",
							isHighlightLink: false
						},
						{
							link: "/category/cat11868860/Ortopedia",
							label: "Ortopedia/protecciones",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Vitaminas y suplementos",
							meatStickerOption: 0,
							link: "/collection/Wellness",
							isHighlightLink: false
						}
					],
					label: "Salud e insumos médicos",
					link: "/category/cat14090015/Salud",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					label: "Libros",
					leafCategories: [
						{
							link: "/category/cat6990144/Libros",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							link: "/category/cat14660001/Best-Sellers",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Best sellers"
						},
						{
							label: "Bienestar",
							link: "/category/cat14660007/Autoayuda",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Cocina",
							link: "/category/cat14070032/Libros-de-Cocina"
						},
						{
							label: "Escolares",
							link: "/category/cat6990144/Libros?facetSelected=true&f.product.attribute.Género=Educación",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ficción",
							link: "/category/cat14660003/Literatura-y-Ficcion"
						},
						{
							label: "Historia",
							link: "/category/cat19370025/Historia---Politica",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Infantiles y comics",
							isHighlightLink: false,
							link: "/category/cat910002/Libros-Infantiles"
						},
						{
							link: "/category/cat14660002/Literatura-Juvenil",
							meatStickerOption: 0,
							label: "Literatura juvenil",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat12303907/Libros-de-Manualidades",
							label: "Manualidades"
						},
						{
							link: "/category/cat14070028/Novelas-y-Narrativa",
							label: "Novelas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat10981330/Papeleria-Ver-Todo",
							isHighlightLink: false,
							label: "Papelería y agendas"
						},
						{
							label: "Viajes y fotografía",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat12217197/TravelBooks"
						}
					],
					link: "/category/cat6990144/Libros"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							link: "/collection/manualidades",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/manualidades?facetSelected=true&f.product.attribute.Tipo=Accesorios+Para+Manualidades%3A%3AAgujas%3A%3AAlfileres%3A%3ACrochet%3A%3AOvillos%3A%3APalillos",
							label: "Accesorios"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Bordado",
							link: "/collection/manualidades?facetSelected=true&f.product.brandName=kit+%26+craft"
						},
						{
							meatStickerOption: 0,
							label: "Ovillos",
							link: "/collection/manualidades?facetSelected=true&f.product.attribute.Tipo=Ovillos",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Tejido",
							link: "/collection/manualidades?facetSelected=true&f.product.attribute.Tipo=Crochet%3A%3AOvillos%3A%3APalillos",
							isHighlightLink: false
						}
					],
					label: "Tejido y bordado",
					link: "/collection/manualidades"
				}
			],
			label: "Nuevas categorías"
		}
	]
};
var taxonomyV1CL = {
	state: state$1
};

var state$2 = {
	rootCategories: [
		{
			bannerLocation: "urlToImage",
			label: "Cyber Days",
			link: "cat123459",
			subCategories: [
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/page/Televisores?staticPageId=31000003",
							meatStickerOption: 0,
							label: "Televisores 40% Dcto"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Lo mejor en Smartwatch",
							link: "/collection/smartwatch"
						},
						{
							isHighlightLink: false,
							label: "Computadores precios cyber ",
							meatStickerOption: 0,
							link: "/category/cat1361001/Computadores--Portatiles-"
						}
					],
					verTodoActive: true,
					label: "Tecnología",
					link: "/page/Televisores?staticPageId=31000003"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat5420959/Freidoras",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Freidoras precios cyber"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Neveras precios cyber",
							link: "/category/cat1040986/Neveras-No-Frost"
						},
						{
							link: "/category/cat50496/Aspiradoras?facetSelected=true&f.product.attribute.Tipo=Aspiradoras+robots",
							meatStickerOption: 0,
							label: "Aspiradoras precios cyber",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat1041034/Lavadoras-Secadoras-",
							label: "Lavado y secado cyber"
						}
					],
					link: "/category/cat5420959/Freidoras",
					label: "Electrohogar"
				},
				{
					verTodoActive: true,
					link: "/collection/tenis-evento-179-990",
					label: "Calzado",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Tenis 179.990",
							link: "/collection/tenis-evento-179-990",
							meatStickerOption: 0
						},
						{
							label: "Tenis 30% Dcto",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10520949/TENIS"
						},
						{
							label: "Tenis deportivos 30%",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat10520949/TENIS"
						},
						{
							meatStickerOption: 0,
							label: "Tenis Fila $129.990",
							isHighlightLink: false,
							link: "/collection/tenis-fila-50-"
						},
						{
							meatStickerOption: 0,
							label: "Zapatos mujer $59.990",
							link: "/category/cat790973/Zapatos-Mujer",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat740959/Zapatos-Hombre",
							label: "Zapatos hombre $59.990"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Tenis infantiles 40%",
							link: "/collection/tenis-infantiles"
						},
						{
							label: "Aldo y Call it Spring 30%",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/aldo-y-call-it-spirng"
						},
						{
							link: "/collection/ultimas-tallas-zapatos",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Últimas tallas 60%"
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat1461053/Perfumes?f.product.attribute.G%C3%A9nero=Hombre%3A%3ANi%C3%B1o%3A%3AUnisex&isPLP=1%2C1",
							label: "50% Perfumes Hombre",
							meatStickerOption: 0
						},
						{
							link: "/category/cat1461053/Perfumes?f.product.attribute.G%C3%A9nero=Mujer%3A%3ANi%C3%B1a&isPLP=1%2C1",
							meatStickerOption: 0,
							label: "40% Perfumes Mujer",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "30% Sets de belleza",
							link: "/category/cat10820948/Regalo-perfecto"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "30% en Maquillaje",
							link: "/category/cat1131042/Maquillaje?isPLP=1&isPLP=1"
						},
						{
							isHighlightLink: false,
							link: "/category/cat10421009/Cuidado-Capilar?isPLP=1&isPLP=1",
							meatStickerOption: 0,
							label: "30% Cuidado Capilar"
						}
					],
					label: "Belleza",
					link: "/category/cat1461053/Perfumes?f.product.attribute.G%C3%A9nero=Hombre%3A%3ANi%C3%B1o%3A%3AUnisex&isPLP=1%2C1",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					label: "Mujer",
					link: "/collection/mujer-black-50",
					leafCategories: [
						{
							link: "/collection/mujer-black-50",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "50% Vestuario Mujer"
						},
						{
							meatStickerOption: 0,
							label: "Mejores marcas cyber",
							link: "/collection/marcas-premium-black-mujer",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/sacos-mujer-2x79990",
							label: "Sacos 2x$79.990"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Chaquetas $79.990",
							link: "/collection/chaquetas-mujer-79990"
						},
						{
							label: "Jeans $59.990",
							isHighlightLink: false,
							link: "/collection/jeans-mujer-59990",
							meatStickerOption: 0
						},
						{
							label: "Vestidos $79.990",
							isHighlightLink: false,
							link: "/collection/vestidos-mujer-79990",
							meatStickerOption: 0
						},
						{
							label: "Leggings Deportivos 2x$79.990",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/leggings-deportivos-2x79990"
						},
						{
							isHighlightLink: false,
							label: "30% Dcto Pijamas",
							meatStickerOption: 0,
							link: "/collection/pijamas-mujer-30"
						}
					]
				},
				{
					link: "/category/cat10320963/Marcas-Premium",
					label: "Hombre",
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat10320963/Marcas-Premium",
							label: "40% mejores marcas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "30% Levis",
							meatStickerOption: 0,
							link: "/category/cat4960965/Jeans-para-hombre?facetSelected=true&f.product.brandName=levis"
						},
						{
							isHighlightLink: false,
							link: "/category/cat4960962/Camisetas-para-hombre",
							meatStickerOption: 0,
							label: "Camisetas 30% "
						},
						{
							meatStickerOption: 0,
							label: "Calvin Klein 30%",
							link: "/category/cat5930952/Ropa-Interior-Masculina",
							isHighlightLink: false
						}
					]
				},
				{
					verTodoActive: true,
					label: "Infantil",
					link: "/category/cat4101180/Juguetes?isPLP=1&isPLP=1",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat4101180/Juguetes?isPLP=1&isPLP=1",
							meatStickerOption: 0,
							label: "60% juguetería"
						},
						{
							meatStickerOption: 0,
							label: "60% coches",
							link: "/category/cat50511/Mundo-Bebe?isPLP=1&isPLP=1",
							isHighlightLink: false
						},
						{
							label: "60% juegos exterior",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat9130961/Juegos-de-Exterior?isPLP=1&isPLP=1"
						},
						{
							isHighlightLink: false,
							label: "40% vestuario infantil",
							link: "/category/cat11630941/Vestuario-Infantil",
							meatStickerOption: 0
						},
						{
							link: "/category/cat10820943/Marcas-Premium",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "30% marcas premium"
						},
						{
							meatStickerOption: 0,
							label: "Pantalones y jeans",
							isHighlightLink: false,
							link: "/category/cat11630941/Vestuario-Infantil?facetSelected=true&f.product.attribute.Tipo=Jeans%3A%3APantalones"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3150971/Ropa-Bebe",
							meatStickerOption: 0,
							label: "Bebes 40% CMR"
						}
					]
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							label: "50% Dcto en relojes",
							link: "/category/cat6871001/Relojes",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "50% Dcto en gafas",
							link: "/category/cat1201309/Gafas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "50% Dcto Bolsos y Carteras",
							isHighlightLink: false,
							link: "/category/cat1660957/Bolsos-y-Carteras"
						},
						{
							meatStickerOption: 0,
							label: "Set relojes $99.990",
							link: "/collection/set-relojes",
							isHighlightLink: false
						},
						{
							link: "/collection/relojes-a-49-990",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Relojes a $49.990"
						}
					],
					label: "Accesorios Moda",
					link: "/category/cat6871001/Relojes"
				},
				{
					leafCategories: [
						{
							link: "/category/cat50516/Bicicletas?facetSelected=true&f.product.brandName=jeep&isPLP=1%2C1&isPLP=1",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Bicicletas Jeep $899.990"
						},
						{
							label: "30% Gimnasio en Casa",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat50620/Gimnasio-en-Casa?isPLP=1&isPLP=1"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Bicicletas Mountain Gear",
							link: "/category/cat50516/Bicicletas?facetSelected=true&f.product.brandName=mountain+gear&isPLP=1%2C1&isPLP=1"
						},
						{
							isHighlightLink: false,
							link: "/category/cat12801016/Ropa-Deportiva-Total?facetSelected=true&f.product.brandName=diadora",
							meatStickerOption: 0,
							label: "40% Ropa Deportiva Diadora"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat12801016/Ropa-Deportiva-Total?facetSelected=true&f.product.brandName=everlast%3A%3Afila%3A%3Apuma%3A%3Aunder+armour",
							label: "30% Mejores Marcas"
						}
					],
					link: "/category/cat50516/Bicicletas?facetSelected=true&f.product.brandName=jeep&isPLP=1%2C1&isPLP=1",
					label: "Deportes",
					verTodoActive: true
				},
				{
					link: "/category/cat10270963/Muebles?isPLP=1",
					label: "Decohogar",
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat10270963/Muebles?isPLP=1",
							isHighlightLink: false,
							label: "50% de dcto en muebles",
							meatStickerOption: 0
						},
						{
							label: "50% en Ropa de Cama",
							meatStickerOption: 0,
							link: "/category/cat50824/Ropa-de-cama?isPLP=1&isPLP=1",
							isHighlightLink: false
						},
						{
							label: "60% en Colchones",
							isHighlightLink: false,
							link: "/category/cat111333/Colchones?isPLP=1&isPLP=1",
							meatStickerOption: 0
						},
						{
							label: "35% Ollas y cuchillos",
							link: "/category/cat8610949/Ollas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "30% en Vajillas y cubiertos",
							meatStickerOption: 0,
							link: "/category/cat8630959/Vajillas-y-Cubiertos?isPLP=1&isPLP=1",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "30% Decoración",
							link: "/category/cat1051097/Decoracion?isPLP=1&isPLP=1",
							isHighlightLink: false
						}
					]
				}
			]
		},
		{
			label: "Celulares",
			subCategories: [
				{
					label: "Telefonía",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Celulares y Smartphones",
							link: "/category/cat1660941/Celulares-y-Smartphones"
						},
						{
							link: "/category/cat1660941/Celulares-y-Smartphones?facetSelected=true&f.product.brandName=nokia",
							meatStickerOption: 0,
							label: "Nokia",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat2840940/Celulares-Samsung",
							label: "Samsung"
						},
						{
							link: "/category/cat8650978/Celulares-Huawei",
							isHighlightLink: false,
							label: "Huawei"
						},
						{
							link: "/category/cat8650979/Celulares-Motorola",
							label: "Motorola",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Xiaomi",
							link: "/category/cat9710966/Celulares-Xiaomi"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1660941/Celulares-y-Smartphones?f.product.brandName=vivo",
							label: "Vivo",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Realme",
							link: "/category/cat1660941/Celulares-y-Smartphones?facetSelected=true&f.product.brandName=realme"
						},
						{
							isHighlightLink: false,
							label: "Teléfonos fijos",
							link: "/category/cat281021/Telefonos-fijos"
						},
						{
							label: "Entrega Rápida",
							link: "/collection/entrega24horasbogota?facetSelected=true&f.product.attribute.Tipo=Smartphones&isPLP=1",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "iPhone",
							link: "/category/cat3460941/iPhone"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Telefonía",
							link: "/category/cat910963/Telefonia?isPLP=1"
						}
					],
					link: "/page/Celulares?staticPageId=26800005?v=9876"
				},
				{
					link: "/category/cat10430953/Wearables",
					leafCategories: [
						{
							link: "/category/cat3050947/Smartwatch",
							label: "Smartwatch",
							isHighlightLink: false
						},
						{
							link: "/category/cat10430954/Smartbands",
							isHighlightLink: false,
							label: "Smartbands"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Wearables",
							link: "/category/cat10430953/Wearables?isPLP=1"
						}
					],
					label: "Wearables"
				},
				{
					link: "/category/cat10430955/Accesorios-Celulares",
					leafCategories: [
						{
							label: "Forros y Carcasas ",
							isHighlightLink: false,
							link: "/category/cat1031741/Forros-para-celulares"
						},
						{
							isHighlightLink: false,
							link: "/category/cat50670/Audifonos",
							label: "Audífonos"
						},
						{
							isHighlightLink: false,
							label: "Baterías externas",
							link: "/category/cat1031737/Baterias-externas"
						},
						{
							label: "Tarjetas Micro SD",
							link: "/category/cat760971/Tarjetas-Micro-SD",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Protectores de pantalla",
							link: "/category/cat10430956/Protectores-de-pantalla"
						},
						{
							isHighlightLink: false,
							label: "Cargadores y cables",
							link: "/category/cat1920951/Cargadores-y-cables"
						},
						{
							isHighlightLink: false,
							label: "Soporte para celulares",
							link: "/category/cat10430957/Soporte-para-celulares"
						},
						{
							label: "Otros Accesorios",
							isHighlightLink: false,
							link: "/category/cat10430958/Otros-Accesorios"
						},
						{
							label: "Ver todo Accesorios Celulares",
							link: "/category/cat10430955/Accesorios-Celulares?isPLP=1",
							isHighlightLink: true
						}
					],
					label: "Accesorios Celulares"
				}
			],
			link: "cat10430952"
		},
		{
			link: "cat50868",
			subCategories: [
				{
					label: "TV",
					link: "/page/Televisores?staticPageId=31000003",
					leafCategories: [
						{
							label: "Televisores",
							isHighlightLink: false,
							link: "/category/cat1360967/Televisores"
						},
						{
							label: "Streaming",
							isHighlightLink: false,
							link: "/category/cat7870947/Streaming"
						},
						{
							label: "Proyectores y Video Beams",
							link: "/category/cat1360969/Proyectores-y-Video-Beams",
							isHighlightLink: false
						},
						{
							label: "Soportes",
							link: "/category/cat160945/Soportes",
							isHighlightLink: false
						},
						{
							label: "Accesorios TV",
							link: "/category/cat5420975/Accesorios-TV",
							isHighlightLink: false
						},
						{
							link: "/category/cat2930962/Barras-de-Sonido",
							isHighlightLink: false,
							label: "Barras de Sonido"
						},
						{
							isHighlightLink: false,
							link: "/category/cat50867/Teatros-en-casa",
							label: "Teatros en casa"
						},
						{
							isHighlightLink: false,
							label: "Entrega Rápida",
							link: "/collection/entrega24horasbogota?facetSelected=true&f.product.attribute.Tipo=Televisores&isPLP=1",
							meatStickerOption: 0
						},
						{
							isHighlightLink: true,
							label: "Ver todo TV",
							link: "/category/cat1360963/TV?isPLP=1"
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Portátiles ",
							link: "/category/cat1361001/Computadores-Portatiles",
							isHighlightLink: false
						},
						{
							label: "2 en 1",
							link: "/category/cat10430998/Computadores-2-en-1",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat50611/Computadores-de-Mesa",
							label: "De Mesa"
						},
						{
							isHighlightLink: false,
							label: "Gaming",
							link: "/category/cat4920940/Computadores-Gaming"
						},
						{
							link: "/category/cat50666/Tablets",
							isHighlightLink: false,
							label: "Tablets "
						},
						{
							isHighlightLink: false,
							link: "/category/cat790955/Impresoras",
							label: "Impresoras "
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Tintas",
							link: "/category/cat50877/Tintas-para-Impresora"
						},
						{
							label: "Monitores",
							isHighlightLink: false,
							link: "/category/cat2571041/Monitores"
						},
						{
							isHighlightLink: false,
							label: "Software",
							link: "/category/cat10430999/Software"
						},
						{
							label: "Routers y Conectividad",
							link: "/category/cat1360965/Routers-y-Conectividad",
							isHighlightLink: false
						},
						{
							link: "/category/cat50475/Accesorios-Computacion",
							label: "Accesorios Computación",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo Computadores",
							link: "/category/cat171006/Computadores?isPLP=1"
						}
					],
					label: "Computadores",
					link: "/category/cat171006/Computadores?isLanding=true"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Consolas",
							link: "/category/cat1251018/Consolas-de-Videojuegos"
						},
						{
							label: "Videojuegos",
							isHighlightLink: false,
							link: "/category/cat2930986/Videojuegos"
						},
						{
							label: "Playstation",
							link: "/category/cat10431002/Playstation",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Xbox",
							link: "/category/cat2540956/Xbox"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2540955/Nintendo",
							label: "Nintendo"
						},
						{
							label: "Accesorios Videojuegos ",
							link: "/category/cat3000998/Accesorios-Videojuegos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Computadores gaming",
							link: "/category/cat4920940/Computadores-Gaming",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Audífonos Gaming",
							link: "/category/cat10440956/Audifonos-gaming"
						},
						{
							link: "/category/cat50590/Gaming?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Gaming"
						}
					],
					label: "Gaming",
					link: "/page/Videojuegos?staticPageId=26500002?vid=12345"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat10441102/Apple-Watch",
							label: "Apple Watch"
						},
						{
							link: "/category/cat10441103/Samsung-Watch",
							label: "Samsung Watch",
							isHighlightLink: false
						},
						{
							link: "/category/cat10441107/Huawei",
							isHighlightLink: false,
							label: "Huawei"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat3050947/Smartwatch?facetSelected=true&f.product.brandName=xiaomi&facetSelected=true%2Ctrue",
							label: "Xiaomi"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Smartwatch",
							link: "/category/cat3050947/Smartwatch?isPLP=1"
						}
					],
					label: "Smartwatch",
					link: "/category/cat3050947/Smartwatch"
				},
				{
					label: "Fotografía",
					link: "/category/cat311003/Fotografia?isLanding=true",
					leafCategories: [
						{
							label: "Cámaras Profesionales",
							link: "/category/cat1020959/Camaras-Profesionales",
							isHighlightLink: false
						},
						{
							link: "/category/cat1031408/Camaras-Semiprofesionales",
							isHighlightLink: false,
							label: "Cámaras Semiprofesionales "
						},
						{
							label: "Cámaras Digitales Compactas ",
							link: "/category/cat50535/Camaras-Digitales-Compactas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Cámaras Instantáneas",
							link: "/category/cat5430941/Camaras-Instantaneas"
						},
						{
							isHighlightLink: false,
							label: "Cámaras Deportivas",
							link: "/category/cat1451008/Camaras-Deportivas"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat2980941/Drones",
							label: "Drones",
							isHighlightLink: false
						},
						{
							label: "Cámaras de Video",
							link: "/category/cat50641/Camaras-de-Video",
							isHighlightLink: false
						},
						{
							label: "Accesorios Fotografía",
							link: "/category/cat50547/Accesorios-Fotografia",
							isHighlightLink: false
						},
						{
							label: "Impresoras de fotos",
							isHighlightLink: false,
							link: "/category/cat10431007/Impresoras-de-fotos"
						},
						{
							label: "Ver todo Fotografía",
							isHighlightLink: true,
							link: "/category/cat311003/Fotografia?isPLP=1"
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Bluetooth",
							isHighlightLink: false,
							link: "/category/cat10431028/Parlantes-Bluetooth"
						},
						{
							label: "Inteligentes",
							isHighlightLink: false,
							link: "/category/cat10431029/Parlantes-inteligentes"
						},
						{
							label: "de Fiesta",
							link: "/category/cat8611018/Parlantes-de-Fiesta",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat10431030/Parlantes-portatiles",
							label: "Portátiles"
						},
						{
							isHighlightLink: false,
							label: "Equipos de Sonido",
							link: "/category/cat50628/Equipos-de-Sonido"
						},
						{
							link: "/category/cat2930962/Barras-de-Sonido",
							label: "Barras de Sonido",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat50867/Teatros-en-casa",
							label: "Teatros en casa"
						},
						{
							link: "/category/cat8330945/Sonido-para-carros",
							isHighlightLink: false,
							label: "Sonido para carros"
						},
						{
							link: "/category/cat50907/Parlantes?isPLP=1",
							label: "Ver todo Parlantes",
							isHighlightLink: true
						}
					],
					link: "/page/Audio?staticPageId=29600004",
					label: "Parlantes"
				},
				{
					label: "Audífonos",
					link: "/page/Audio?staticPageId=29600004",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Bluetooth",
							link: "/category/cat10440953/Audifonos-Bluetooth"
						},
						{
							link: "/category/cat10440954/Audifonos-con-cable",
							label: "Con cable",
							isHighlightLink: false
						},
						{
							link: "/category/cat10440955/Audifonos-deportivos",
							isHighlightLink: false,
							label: "Deportivos"
						},
						{
							label: "Gaming",
							link: "/category/cat10440956/Audifonos-gaming",
							isHighlightLink: false
						},
						{
							label: "Ver todo Audífonos",
							isHighlightLink: true,
							link: "/category/cat50670/Audifonos?isPLP=1"
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat10441136/Camaras-inteligentes",
							label: "Cámaras inteligentes"
						},
						{
							isHighlightLink: false,
							link: "/category/cat10441137/Asistente-de-voz",
							label: "Asistente de voz"
						},
						{
							link: "/category/cat10441138/Iluminacion",
							isHighlightLink: false,
							label: "Iluminación"
						},
						{
							link: "/category/cat10441139/Switches-y-plugs",
							label: "Switches y plugs",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Electrodomésticos inteligentes",
							link: "/category/cat10441140/Electrodomesticos-inteligentes"
						},
						{
							link: "/category/cat10441141/Cerraduras",
							isHighlightLink: false,
							label: "Cerraduras"
						},
						{
							label: "Otros dispositivos",
							link: "/category/cat10441142/Otros-dispositivos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Drones",
							link: "/category/cat2980941/Drones"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1360965/Routers-y-Conectividad",
							label: "Routers y Conectividad"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Hogar Inteligente",
							link: "/category/cat10431000/Hogar-Inteligente?isPLP=1"
						}
					],
					label: "Hogar Inteligente",
					link: "/category/cat10431000/Hogar-Inteligente?isLanding=true"
				}
			],
			label: "Tecnología"
		},
		{
			link: "cat50623",
			label: "Electrodomésticos",
			subCategories: [
				{
					link: "/category/cat50564/Electro-Cocina?isLanding=true",
					leafCategories: [
						{
							label: "Batidoras",
							isHighlightLink: false,
							link: "/category/cat5430943/Batidoras"
						},
						{
							isHighlightLink: false,
							link: "/category/cat50526/Cafeteras",
							label: "Cafeteras "
						},
						{
							isHighlightLink: false,
							label: "Cocina Divertida",
							link: "/category/cat10430990/Cocina-Divertida"
						},
						{
							isHighlightLink: false,
							label: "Cocina Saludable ",
							link: "/category/cat7590943/Cocina-Saludable"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Dispensadores de Agua",
							link: "/category/cat2660958/Dispensadores-de-Agua"
						},
						{
							label: "Electro Especializados",
							link: "/category/cat5420956/Electro-Especializados",
							isHighlightLink: false
						},
						{
							label: "Exprimidores",
							isHighlightLink: false,
							link: "/category/cat50638/Exprimidores"
						},
						{
							isHighlightLink: false,
							label: "Extractores",
							link: "/category/cat10430988/Extractores"
						},
						{
							label: "Freidoras",
							link: "/category/cat5420959/Freidoras",
							isHighlightLink: false
						},
						{
							link: "/category/cat5420957/Hervidores-Electricos",
							isHighlightLink: false,
							label: "Hervidores Eléctricos"
						},
						{
							label: "Hornos Tostadores",
							link: "/category/cat50664/Hornos-Tostadores",
							isHighlightLink: false
						},
						{
							link: "/category/cat5430942/Licuadoras",
							isHighlightLink: false,
							label: "Licuadoras"
						},
						{
							label: "Microondas",
							isHighlightLink: false,
							link: "/category/cat50733/Microondas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat50642/Ollas-Arroceras",
							label: "Ollas Arroceras"
						},
						{
							label: "Ollas Eléctricas",
							link: "/category/cat10430989/Ollas-Electricas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat5430945/Parrillas-Electricas",
							label: "Parrillas Eléctricas"
						},
						{
							label: "Procesadores de Alimentos",
							isHighlightLink: false,
							link: "/category/cat50801/Procesadores-de-Alimentos"
						},
						{
							label: "Sanducheras",
							isHighlightLink: false,
							link: "/category/cat10430987/Sanducheras"
						},
						{
							label: "Tostadores Eléctricos",
							isHighlightLink: false,
							link: "/category/cat5440944/Tostadores-Electricos"
						},
						{
							label: "Wafleras",
							link: "/category/cat50831/Wafleras",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo Electro Cocina",
							link: "/category/cat50564/Electro-Cocina?isPLP=1"
						}
					],
					label: "Electro Cocina"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Planchas",
							link: "/category/cat50789/Planchas"
						},
						{
							label: "Aspiradoras",
							link: "/category/cat50496/Aspiradoras",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Hidrolavadoras",
							link: "/category/cat10430993/Hidrolavadoras"
						},
						{
							isHighlightLink: false,
							label: "Herramientas",
							link: "/category/cat10430995/Herramientas"
						},
						{
							isHighlightLink: false,
							label: "Máquinas de coser",
							link: "/category/cat731051/Maquinas-de-coser"
						},
						{
							label: "Limpiavidrios y Traperos",
							isHighlightLink: false,
							link: "/category/cat10440940/Limpiavidrios-y-Traperos"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Electro Hogar",
							link: "/category/cat10430980/Electro-Hogar?isPLP=1"
						}
					],
					link: "/category/cat10430980/Electro-Hogar?isLanding=true",
					label: "Electro Hogar"
				},
				{
					label: "Neveras",
					link: "/category/cat1040982/Neveras?isLanding=true",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Nevecones",
							link: "/category/cat1040992/Nevecones"
						},
						{
							link: "/category/cat1040986/Neveras-No-Frost",
							isHighlightLink: false,
							label: "Neveras No Frost"
						},
						{
							label: "Neveras Frost",
							isHighlightLink: false,
							link: "/category/cat8800940/Neveras-Frost"
						},
						{
							label: "Minibares",
							link: "/category/cat1040988/Minibares",
							isHighlightLink: false
						},
						{
							label: "Congeladores ",
							link: "/category/cat1040990/Congeladores",
							isHighlightLink: false
						},
						{
							link: "/category/cat1080967/Cavas-de-vino",
							isHighlightLink: false,
							label: "Cavas de vino"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8800944/Otros-Neveras",
							label: "Otros Neveras"
						},
						{
							link: "/category/cat1040982/Neveras?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Neveras"
						}
					]
				},
				{
					leafCategories: [
						{
							link: "/category/cat50702/Lavadoras-Carga-Frontal",
							isHighlightLink: false,
							label: "Lavadoras Carga Frontal "
						},
						{
							label: "Lavadoras Carga Superior ",
							isHighlightLink: false,
							link: "/category/cat1041032/Lavadoras-Carga-Superior"
						},
						{
							link: "/category/cat50834/Secadoras",
							label: "Secadoras",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Lavadoras Secadoras ",
							link: "/category/cat1041034/Lavadoras-Secadoras"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1041036/Lavadoras-y-Secadoras",
							label: "Lavadoras y Secadoras"
						},
						{
							label: "Lavavajillas",
							isHighlightLink: false,
							link: "/category/cat50703/Lavavajillas"
						},
						{
							link: "/category/cat7630942/Lavadoras-Doble-Carga",
							label: "Lavadoras Doble Carga",
							isHighlightLink: false
						},
						{
							link: "/category/cat50714/Lavadoras?isPLP=1",
							label: "Ver todo Lavadoras",
							isHighlightLink: true
						}
					],
					label: "Lavadoras",
					link: "/category/cat50714/Lavadoras?isLanding=true"
				},
				{
					link: "/category/cat2970970/Cocinas?isLanding=true",
					leafCategories: [
						{
							link: "/category/cat540953/Estufas-de-Piso",
							isHighlightLink: false,
							label: "Estufas de Piso"
						},
						{
							label: "Estufas Empotrables",
							link: "/category/cat540971/Estufas-Empotrables",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Hornos empotrables",
							link: "/category/cat6870993/Hornos-empotrables"
						},
						{
							isHighlightLink: false,
							label: "Extractores y Campanas ",
							link: "/category/cat540955/Extractores-y-Campanas"
						},
						{
							isHighlightLink: false,
							label: "Lavavajillas",
							link: "/category/cat50703/Lavavajillas"
						},
						{
							link: "/category/cat1091210/Asadores",
							isHighlightLink: false,
							label: "Asadores"
						},
						{
							isHighlightLink: true,
							link: "/category/cat2970970/Cocinas?isPLP=1",
							label: "Ver todo Cocinas"
						}
					],
					label: "Cocinas"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Aire acondicionados",
							link: "/category/cat50478/Aire-acondicionados"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7370942/Ventiladores",
							label: "Ventiladores"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Humidificadores",
							link: "/category/cat12241071/Humidificadores?isPLP=1&isPLP=1 "
						},
						{
							link: "/category/cat50530/Calefactores",
							isHighlightLink: false,
							label: "Calefactores"
						},
						{
							link: "/category/cat10430997/Calefactores-exterior",
							isHighlightLink: false,
							label: "Calefactores exterior"
						},
						{
							label: "Calentadores de Agua",
							link: "/category/cat561021/Calentadores-de-Agua",
							isHighlightLink: false
						},
						{
							label: "Ver todo Climatización",
							link: "/category/cat7150954/Climatizacion?isPLP=1",
							isHighlightLink: true
						}
					],
					label: "Climatización",
					link: "/category/cat7150954/Climatizacion"
				},
				{
					label: "Promociones Electro",
					link: "/category/cat10430982/Promociones-Electro",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat10431009/Amantes-de-la-Cocina",
							label: "Amantes de la Cocina"
						},
						{
							label: "Oportunidades Unicas",
							isHighlightLink: false,
							link: "/category/cat10431008/Oportunidades-Unicas"
						},
						{
							link: "/category/cat7870967/Ultimas-unidades",
							isHighlightLink: false,
							label: "Últimas unidades"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Promociones Electro",
							link: "/category/cat10430982/Promociones-Electro?isPLP=1"
						}
					]
				}
			]
		},
		{
			subCategories: [
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Bibliotecas y Repisas",
							link: "/category/cat5380964/Bibliotecas-y-Repisas"
						},
						{
							isHighlightLink: false,
							label: "Bifés y Consolas",
							link: "/category/cat2650940/Bifes-y-Consolas"
						},
						{
							isHighlightLink: false,
							label: "Closets y Zapateros",
							link: "/category/cat6370950/Closets,-Armarios-y-Zapateros"
						},
						{
							link: "/category/cat10980975/Comedores",
							isHighlightLink: false,
							label: "Comedores"
						},
						{
							label: "Cómodas y mesas de noche",
							link: "/category/cat1010977/Comodas-y-mesas-de-noche",
							isHighlightLink: false
						},
						{
							link: "/category/cat10130967/Camas-y-Cunas-Infantiles",
							label: "Cunas y Camas",
							isHighlightLink: false
						},
						{
							link: "/category/cat7590946/Escritorios",
							label: "Escritorios",
							isHighlightLink: false
						},
						{
							label: "Mesas de Centro y Auxiliares",
							isHighlightLink: false,
							link: "/category/cat50730/Mesas-de-Centro-y-Auxiliares"
						},
						{
							label: "Mesas de comedor",
							isHighlightLink: false,
							link: "/category/cat700993/Mesas-de-comedor"
						},
						{
							label: "Muebles de TV ",
							link: "/category/cat5380963/Muebles-de-TV",
							isHighlightLink: false
						},
						{
							link: "/category/cat50850/Puffs-y-Banquetas",
							label: "Puffs y Banquetas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat7881027/Sillas",
							label: "Sillas"
						},
						{
							link: "/category/cat4701002/Sillas-de-Bar",
							isHighlightLink: false,
							label: "Sillas de Bar"
						},
						{
							isHighlightLink: false,
							label: "Sillas de Oficina",
							link: "/category/cat2070965/Sillas-de-Oficina"
						},
						{
							label: "Sofás y Sillones",
							isHighlightLink: false,
							link: "/category/cat50853/Sofas-y-Sillones"
						},
						{
							meatStickerOption: 0,
							label: "Últimas Unidades SALE",
							link: "/category/cat7390943/Ultimas-Unidades-Muebles-",
							isHighlightLink: false
						},
						{
							link: "/category/cat10270963/Muebles",
							isHighlightLink: true,
							label: "Ver todo Muebles"
						}
					],
					label: "Muebles por Tipo",
					link: "/category/cat7830948/Muebles?isLanding=true"
				},
				{
					label: "Sala",
					link: "/category/cat50828/Muebles-de-Sala?isLanding=true",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Bibliotecas y Repisas",
							link: "/category/cat5380964/Bibliotecas-y-Repisas"
						},
						{
							label: "Juegos de Muebles",
							link: "/category/cat9830997/Juegos-de-Muebles",
							isHighlightLink: false
						},
						{
							label: "Mesas de Centro y Auxiliares",
							link: "/category/cat50730/Mesas-de-Centro-y-Auxiliares",
							isHighlightLink: false
						},
						{
							label: "Muebles de TV ",
							link: "/category/cat5380963/Muebles-de-TV",
							isHighlightLink: false
						},
						{
							label: "Poltronas",
							link: "/category/cat8760989/Poltronas",
							isHighlightLink: false
						},
						{
							link: "/category/cat50850/Puffs-y-Banquetas",
							isHighlightLink: false,
							label: "Puffs y Banquetas"
						},
						{
							label: "Sillones Reclinables",
							link: "/category/cat50503/Sillones-Reclinables",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat50650/Sofa-Camas-y-Futones",
							label: "Sofá Camas y Futones"
						},
						{
							link: "/category/cat1001066/Sofas-en-L",
							isHighlightLink: false,
							label: "Sofás en L"
						},
						{
							link: "/category/cat50853/Sofas-y-Sillones",
							label: "Sofás y Sillones",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo Sala",
							link: "/category/cat50828/Muebles-de-Sala?isPLP=1"
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Bifés y Consolas",
							link: "/category/cat2650940/Bifes-y-Consolas",
							isHighlightLink: false
						},
						{
							label: "Juegos de Comedor",
							link: "/category/cat50731/Juegos-de-comedor",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat700993/Mesas-de-comedor",
							label: "Mesas de comedor"
						},
						{
							isHighlightLink: false,
							label: "Muebles de Bar",
							link: "/category/cat8250947/Muebles-de-Bar"
						},
						{
							isHighlightLink: false,
							label: "Sillas de Bar",
							link: "/category/cat4701002/Sillas-de-Bar"
						},
						{
							label: "Sillas de Comedor  ",
							isHighlightLink: false,
							link: "/category/cat50847/Sillas-de-Comedor"
						},
						{
							link: "/category/cat50581/Muebles-de-Comedor?isPLP=1",
							label: "Ver todo Comedor",
							isHighlightLink: true
						}
					],
					label: "Comedor",
					link: "/category/cat50581/Muebles-de-Comedor?isLanding=true"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat5380964/Bibliotecas-y-Repisas",
							label: "Bibliotecas y Repisas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7590946/Escritorios",
							label: "Escritorios"
						},
						{
							isHighlightLink: false,
							label: "Sillas de Oficina",
							link: "/category/cat2070965/Sillas-de-Oficina"
						},
						{
							label: "Ver todo Estudio y Oficina",
							isHighlightLink: true,
							link: "/category/cat3021117/Muebles-de-Oficina?isPLP=1"
						}
					],
					label: "Estudio y Oficina",
					link: "/category/cat3021117/Muebles-de-Oficina"
				},
				{
					leafCategories: [
						{
							label: "Asoleadoras y Otros",
							isHighlightLink: false,
							link: "/category/cat5490974/Sillas-de-Terraza"
						},
						{
							link: "/category/cat1091134/Juegos-de-comedor-de-Terraza",
							label: "Comedores y Sillas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Parasoles",
							link: "/category/cat2650942/Parasoles-y-Complementos"
						},
						{
							isHighlightLink: false,
							label: "Salas",
							link: "/category/cat1091136/Salas-de-Terraza"
						},
						{
							link: "/category/cat50875/Muebles-de-Terraza?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Terraza"
						}
					],
					link: "/category/cat50875/Muebles-de-Terraza?isLanding=true",
					label: "Terraza"
				},
				{
					leafCategories: [
						{
							label: "Cabeceros",
							link: "/category/cat2930966/Cabeceros",
							isHighlightLink: false
						},
						{
							link: "/category/cat50527/Camas-y-Base-Camas",
							isHighlightLink: false,
							label: "Camas y Base Camas"
						},
						{
							label: "Closets y Zapateros",
							isHighlightLink: false,
							link: "/category/cat6370950/Closets,-Armarios-y-Zapateros"
						},
						{
							isHighlightLink: false,
							label: "Cómodas y Tocadores",
							link: "/category/cat5380962/Comodas-y-Tocadores"
						},
						{
							link: "/category/cat5851044/Mesas-de-Noche",
							label: "Mesas de Noche",
							isHighlightLink: false
						},
						{
							label: "Ver todo Dormitorio",
							isHighlightLink: true,
							link: "/category/cat1450949/Muebles-de-Dormitorio?isPLP=1"
						}
					],
					label: "Dormitorio",
					link: "/category/cat1450949/Muebles-de-Dormitorio"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat2930972/Camas-Infantiles",
							label: "Camas Infantiles"
						},
						{
							isHighlightLink: false,
							link: "/category/cat10230950/Organizacion-Infantil",
							label: "Closets y Cómodas"
						},
						{
							link: "/category/cat10130966/Cunas",
							label: "Cunas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Mecedoras y Sillones",
							link: "/category/cat12210979/Mecedoras",
							meatStickerOption: 0
						},
						{
							label: "Muebles Auxiliares",
							isHighlightLink: false,
							link: "/category/cat10230949/Muebles-Auxiliares"
						},
						{
							link: "/category/cat9650965/Muebles-para-Ninos?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Dormitorio Infantil"
						}
					],
					label: "Dormitorio Infantil",
					link: "/category/cat9650965/Muebles-para-Ninos?isLanding=true"
				},
				{
					link: "/category/cat12210975/Otros-Espacios",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat7180950/Muebles-de-Bano",
							meatStickerOption: 0,
							label: "Baño"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cocina",
							link: "/category/cat10130965/Muebles-de-Cocina"
						}
					],
					label: "Otros Espacios",
					verTodoActive: true
				},
				{
					label: "Crate&Barrel",
					verTodoActive: true,
					leafCategories: [
						{
							label: "Muebles",
							meatStickerOption: 0,
							link: "/category/cat7010950/Muebles-Crate-and-Barrel",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Terraza",
							link: "/category/cat7770942/Terraza-Crate-and-Barrel"
						},
						{
							link: "/category/cat6400952/Crate-Barrel?isLanding=true",
							isHighlightLink: true,
							label: "Ver todo Crate&Barrel"
						}
					],
					link: "/category/cat6400952/Crate-Barrel?isLanding=true"
				}
			],
			link: "cat10270963",
			label: "Muebles"
		},
		{
			label: "Dormitorio",
			link: "cat50480",
			subCategories: [
				{
					link: "/category/cat50824/Ropa-de-cama?isLanding=true",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat2140994/Edredones-y-cubrelechos",
							label: "Edredones y cubrelechos"
						},
						{
							link: "/category/cat50827/Sabanas",
							isHighlightLink: false,
							label: "Sábanas"
						},
						{
							isHighlightLink: false,
							label: "Fundas de duvet",
							link: "/category/cat731111/Funda-Duvet"
						},
						{
							link: "/category/cat50793/Plumones",
							isHighlightLink: false,
							label: "Plumones"
						},
						{
							link: "/category/cat50488/Almohadas-y-complementos",
							isHighlightLink: false,
							label: "Almohadas "
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Protectores",
							link: "/category/cat50804/Protectores"
						},
						{
							label: "Cobijas y mantas",
							isHighlightLink: false,
							link: "/category/cat50567/Cobijas-y-mantas"
						},
						{
							label: "Juegos de cama",
							isHighlightLink: false,
							link: "/category/cat7161017/Juegos-de-cama"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2701034/Cojines",
							label: "Cojines"
						},
						{
							link: "/category/cat13040956/Cojines",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Toppers"
						},
						{
							isHighlightLink: false,
							label: "Benetton NUEVO",
							meatStickerOption: 0,
							link: "/page/Benetton?staticPageId=26000001?vid=123456"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat50824/Ropa-de-cama?isPLP=1"
						}
					],
					label: "Ropa de cama"
				},
				{
					link: "/page/colchones?staticPageId=29400002",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Colchón King",
							link: "/category/cat50700/Colchon-King"
						},
						{
							isHighlightLink: false,
							label: "Colchón Queen",
							link: "/category/cat50809/Colchon-Queen"
						},
						{
							isHighlightLink: false,
							link: "/category/cat50617/Colchon-Doble",
							label: "Colchón Doble"
						},
						{
							label: "Colchón Semidoble",
							link: "/category/cat50837/Colchon-Semidoble",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat50669/Colchon-Sencillo",
							label: "Colchón Sencillo"
						},
						{
							link: "/category/cat111333/Colchones?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Colchones"
						}
					],
					label: "Colchones"
				},
				{
					label: "Camas",
					leafCategories: [
						{
							label: "Camas",
							isHighlightLink: false,
							link: "/category/cat360993/Camas"
						},
						{
							link: "/category/cat2930966/Cabeceros",
							isHighlightLink: false,
							label: "Cabeceros"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2930972/Camas-Infantiles",
							label: "Camas Infantiles"
						},
						{
							link: "/category/cat50527/Camas-y-Base-Camas",
							isHighlightLink: false,
							label: "Camas y Base Camas"
						},
						{
							label: "Camas nido",
							link: "/category/cat3030963/Camas-nido",
							isHighlightLink: false
						},
						{
							link: "/category/cat2930965/Camas?isPLP=1",
							label: "Ver todo Camas",
							isHighlightLink: true
						}
					],
					link: "/category/cat2930965/Camas"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Edredones y cubrelechos",
							link: "/category/cat2580995/Edredones-y-Cubrelechos-Infantiles"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2580951/Sabanas-Infantiles",
							meatStickerOption: 0,
							label: "Sábanas"
						},
						{
							link: "/category/cat11850941/Funda-Duvet-Infantil",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Fundas de duvet"
						},
						{
							link: "/category/cat50793/Plumones",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Plumones"
						},
						{
							isHighlightLink: false,
							label: "Cobijas y mantas",
							link: "/category/cat2580955/Cobijas-y-Mantas-Infantiles",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Juegos de cama",
							link: "/category/cat11850947/Juegos-de-Cama-Infantiles",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cojines",
							link: "/category/cat11850942/Cojines-Infantiles"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat2580950/Ropa-de-Cama-Infantiltil"
						}
					],
					label: "Ropa de Cama infantil",
					link: "/category/cat2580950/Ropa-de-Cama-Infantil"
				},
				{
					link: "/category/cat13320956/Ropa-de-cama-Juvenil",
					label: "Ropa de cama juvenil",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Edredones y cubrelechos",
							link: "/category/cat13320945/Edredones-y-Cubrelechos-Juvenil"
						},
						{
							label: "Sábanas",
							link: "/category/cat13320946/Sabanas-Juvenil",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Fundas de duvet",
							isHighlightLink: false,
							link: "/category/cat13320952/Funda-Duvet-Juvenil"
						},
						{
							link: "/category/cat13320953/Cobijas-y-Mantas-Juvenil",
							label: "Cobijas y mantas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat13320954/Juegos-de-Cama-Juvenil",
							label: "Juegos de cama"
						},
						{
							isHighlightLink: false,
							label: "Cojines",
							meatStickerOption: 0,
							link: "/category/cat13320957/Cojines-Juveniles"
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat13320956/Ropa-de-cama-Juvenil"
						}
					]
				},
				{
					link: "/category/cat1450949/Muebles-de-Dormitorio",
					leafCategories: [
						{
							label: "Mesas de Noche",
							link: "/category/cat5851044/Mesas-de-Noche",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Closets, Armarios y Zapateros",
							link: "/category/cat6370950/Closets,-Armarios-y-Zapateros"
						},
						{
							isHighlightLink: false,
							label: "Cabeceros",
							link: "/category/cat2930966/Cabeceros"
						},
						{
							label: "Camas y Base Camas",
							link: "/category/cat50527/Camas-y-Base-Camas",
							isHighlightLink: false
						},
						{
							link: "/category/cat5380962/Comodas-y-Tocadores",
							isHighlightLink: false,
							label: "Cómodas y Tocadores"
						},
						{
							label: "Ver todo Muebles de Dormitorio",
							isHighlightLink: true,
							link: "/category/cat1450949/Muebles-de-Dormitorio?isPLP=1"
						}
					],
					label: "Muebles"
				},
				{
					label: "Dormitorio Infantil",
					link: "/page/Deco-kids?staticPageId=31000004",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat2580950/Ropa-de-Cama-Infantil",
							label: "Ropa de cama"
						},
						{
							link: "/category/cat10130966/Cunas",
							isHighlightLink: false,
							label: "Cunas"
						},
						{
							link: "/category/cat2930972/Camas-Infantiles",
							label: "Camas",
							isHighlightLink: false
						},
						{
							label: "Colchones",
							isHighlightLink: false,
							link: "/category/cat2930974/Colchones-Infantiles",
							meatStickerOption: 0
						},
						{
							link: "/category/cat10230950/Organizacion-Infantil",
							isHighlightLink: false,
							label: "Organización"
						},
						{
							link: "/category/cat10230949/Muebles-Auxiliares",
							isHighlightLink: false,
							label: "Muebles auxiliares"
						},
						{
							link: "/category/cat11040941/Decoracion-Infantil",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Decoración"
						},
						{
							link: "/category/cat2930971/Dormitorio-infantil?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo"
						}
					]
				}
			]
		},
		{
			link: "cat50745",
			subCategories: [
				{
					label: "Tendencias-Inspiración",
					link: "/page/Deco-kids?staticPageId=31000004",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/page/Deco-kids?staticPageId=31000004",
							label: "Deco Kids NUEVO"
						},
						{
							isHighlightLink: false,
							label: "Contraste moderno",
							meatStickerOption: 0,
							link: "/falabella-co/page/Contraste-moderno?staticPageId=30500002"
						},
						{
							meatStickerOption: 0,
							link: "/page/Benetton?staticPageId=26000001?vid=123456",
							label: "Benetton",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Floreros y Materas",
							link: "/category/cat1331303/Flores-y-Macetas?facetSelected=true&f.product.attribute.Tipo=Floreros%3A%3AMaceteras",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat631494/Espejos-y-Relojes?facetSelected=true&f.product.attribute.Tipo=Espejos+de+mesa%3A%3AEspejos+de+pared%3A%3AEspejos+de+piso%3A%3AEspejos+joyeros",
							isHighlightLink: false,
							label: "Mundo Espejos"
						}
					]
				},
				{
					link: "/category/cat8610948/Cocina",
					label: "Cocina",
					leafCategories: [
						{
							label: "Ollas",
							link: "/category/cat8610949/Ollas",
							isHighlightLink: false
						},
						{
							label: "Libros de cocina",
							link: "/category/cat8410940/Libros-de-Cocina",
							isHighlightLink: false
						},
						{
							label: "Utensilios de cocina",
							link: "/category/cat8610960/Utensilios-para-Cocinar",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat8610951/Sartenes,-Woks-y-Parrillas",
							label: "Sartenes, woks y parrillas"
						},
						{
							isHighlightLink: false,
							label: "Cuchillos y tablas",
							link: "/category/cat8610952/Cuchillos-y-Tablas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8610953/Bowls-y-Refractarias",
							label: "Bowls y refractarias"
						},
						{
							isHighlightLink: false,
							label: "Recipientes y organización",
							link: "/category/cat8610962/Contenedores-y-Organizadores"
						},
						{
							isHighlightLink: false,
							link: "/category/cat12090977/Termos-y-Botellas-Personales",
							meatStickerOption: 0,
							label: "Termos y botellas"
						},
						{
							link: "/category/cat8610963/Panos-de-Cocina",
							isHighlightLink: false,
							label: "Paños y delantales"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8610955/Reposteria",
							label: "Repostería"
						},
						{
							label: "Asados",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1091210/Asadores"
						},
						{
							label: "Rebajas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat11091037/Rebajas-Cocina"
						},
						{
							link: "/category/cat8610948/Cocina?isPLP=1",
							label: "Ver todo",
							isHighlightLink: true
						}
					]
				},
				{
					link: "/category/cat8630959/Vajillas-y-Cubiertos",
					label: "Vajillas y cubiertos",
					leafCategories: [
						{
							label: "Vajillas",
							link: "/category/cat8630960/Vajillas",
							isHighlightLink: false
						},
						{
							label: "Cubiertos",
							link: "/category/cat8630964/Cubiertos",
							isHighlightLink: false
						},
						{
							link: "/category/cat8630968/Vasos-y-Copas",
							label: "Vasos y copas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Individuales y manteles",
							link: "/category/cat8630970/Individuales-y-Manteles"
						},
						{
							link: "/category/cat8640940/Accesorios-para-Servir",
							label: "Accesorios para servir",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Vino y bar",
							link: "/category/cat8640941/Vino-y-Bar"
						},
						{
							link: "/category/cat8640943/Te-y-Cafe",
							isHighlightLink: false,
							label: "Té y café"
						},
						{
							isHighlightLink: false,
							label: "Mesa infantil",
							link: "/category/cat10170940/Mesa-Infantil"
						},
						{
							isHighlightLink: false,
							label: "Rebajas",
							meatStickerOption: 0,
							link: "/category/cat11091038/Comedor-SALE"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat8630959/Vajillas-y-Cubiertos?isPLP=1"
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat50878/Toallas",
							label: "Toallas"
						},
						{
							isHighlightLink: false,
							label: "Tapetes",
							link: "/category/cat2580996/Tapetes"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7540942/Accesorios",
							label: "Accesorios"
						},
						{
							link: "/category/cat7180950/Muebles-de-Bano",
							label: "Muebles de Baño",
							isHighlightLink: false
						},
						{
							label: "Ver todo",
							link: "/category/cat50505/Bano?isPLP=1",
							isHighlightLink: true
						}
					],
					label: "Baño",
					link: "/category/cat50505/Bano"
				},
				{
					link: "/category/cat6400952/Crate-Barrel?isLanding=true",
					label: "Crate&Barrel",
					leafCategories: [
						{
							link: "/category/cat7010950/Muebles-Crate-and-Barrel",
							isHighlightLink: false,
							label: "Muebles"
						},
						{
							isHighlightLink: false,
							label: "Terraza",
							link: "/category/cat7770942/Terraza-Crate-and-Barrel"
						},
						{
							isHighlightLink: false,
							label: "Bar",
							meatStickerOption: 0,
							link: "/category/cat12220954/Bar-Crate-and-Barrel"
						},
						{
							isHighlightLink: false,
							label: "Comedor",
							link: "/category/cat6990949/Comedor-Bar-Crate-and-Barrel"
						},
						{
							isHighlightLink: false,
							link: "/category/cat6930951/Cocina-Crate-and-Barrel",
							label: "Cocina"
						},
						{
							link: "/category/cat6930958/Decoracion-Crate-and-Barrel",
							label: "Decoración",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat7060941/Bano-Crate-and-Barrel",
							label: "Baño"
						},
						{
							isHighlightLink: false,
							label: "Promociones",
							link: "/category/cat13231097/Promociones-Crate-and-Barrel-"
						},
						{
							label: "Ver todo",
							link: "/category/cat6400952/Crate-Barrel?isPLP=1",
							isHighlightLink: true
						}
					]
				},
				{
					verTodoActive: true,
					label: "Organización del Hogar",
					link: "/page/Muebles-de-organizacion?staticPageId=24700002",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat12130959/Organizacion-de-Cocina",
							meatStickerOption: 0,
							label: "Cocina"
						},
						{
							link: "/category/cat12130973/Organizacion-Dormitorio",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Dormitorio"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat12130972/Organizacion-de-Bano",
							label: "Baño"
						},
						{
							label: "Infantil",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10230950/Organizacion-Infantil"
						},
						{
							label: "Oficina",
							link: "/category/cat12130974/Organizacion-de-Oficina",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat12071084/Organizacion-de-Lavadero",
							isHighlightLink: false,
							label: "Cuarto de lavado"
						},
						{
							link: "/category/cat12071083/Organizacion-del-Hogar",
							label: "Ver todo",
							isHighlightLink: true
						}
					]
				},
				{
					link: "/category/cat1051097/Decoracion?isLanding=true",
					label: "Cojines y Decoración",
					leafCategories: [
						{
							link: "/category/cat2701034/Cojines",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Cojines"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1071174/Tapetes",
							label: "Tapetes"
						},
						{
							link: "/category/cat631504/Portaretratos",
							isHighlightLink: false,
							label: "Portarretratos"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat1331303/Flores-y-Macetas?f.product.attribute.Tipo=Floreros",
							label: "Floreros"
						},
						{
							label: "Flores y macetas",
							isHighlightLink: false,
							link: "/category/cat1331303/Flores-y-Jardineria"
						},
						{
							isHighlightLink: false,
							label: "Lámparas y bombillos",
							link: "/category/cat4000956/Lamparas-y-Bombillos"
						},
						{
							label: "Cuadros y arte de pared",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat3500949/Cuadros-y-Arte-de-Pared"
						},
						{
							label: "Relojes y espejos",
							isHighlightLink: false,
							link: "/category/cat631494/Espejos-y-Relojes"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1331299/Velas-y-Fragancias",
							label: "Velas y fragancias"
						},
						{
							label: "Faroles y candelabros",
							isHighlightLink: false,
							link: "/category/cat12360956/Faroles-y-Candelabros",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Canastos y cajas",
							link: "/category/cat7960979/Canastos-y-Organizacion"
						},
						{
							isHighlightLink: false,
							label: "Adornos",
							link: "/category/cat7960980/Adornos"
						},
						{
							label: "Mantas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat50567/Cobijas-y-mantas?f.product.attribute.Tipo=Mantas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat8680950/Decoracion-SALE",
							label: "Rebajas SALE"
						},
						{
							isHighlightLink: true,
							label: "Ver todo ",
							link: "/category/cat1051097/Decoracion?isPLP=1"
						}
					]
				}
			],
			label: "Decohogar"
		},
		{
			subCategories: [
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Tenis 179.990",
							meatStickerOption: 0,
							link: "/collection/tenis-evento-179-990"
						},
						{
							isHighlightLink: false,
							label: "Tenis Skechers 30%",
							link: "/collection/30skechers",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Tenis 30%",
							link: "/category/cat10520949/TENIS ",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Tenis Fila 129.990",
							meatStickerOption: 0,
							link: "/collection/tenis-fila-50-"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat4880942/Tenis-deportes",
							isHighlightLink: false,
							label: "Tenis deportivos 30%"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat740959/Zapatos-Hombre",
							label: "Zapatos hombre 59.990"
						},
						{
							isHighlightLink: false,
							label: "Zapatos mujer 59.990",
							meatStickerOption: 0,
							link: "/category/cat790973/Zapatos-Mujer"
						},
						{
							label: "Zapatos niños 59.990",
							isHighlightLink: false,
							link: "/category/cat10070940/Zapatos-Infantiles",
							meatStickerOption: 0
						},
						{
							label: "Aldo y Call it Spring 30%",
							link: "/collection/aldo-y-call-it-spirng",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/collection/ultimas-tallas-zapatos",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Últimas tallas 60%"
						}
					],
					verTodoActive: true,
					label: "Cyber Days",
					link: "/category/cat10520949/TENIS "
				},
				{
					label: "Día de la Madre",
					verTodoActive: true,
					leafCategories: [
						{
							label: "Especial Tenis Mujer",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/falabella-co/page/voycontenisypunto?staticPageId=2200001"
						},
						{
							label: "Tenis Mujer 30%",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1031787/Tenis-Mujer"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/30skechers?f.product.attribute.G%C3%A9nero=Mujer",
							label: "Tenis Skechers Mujer 30%"
						},
						{
							isHighlightLink: false,
							link: "/category/cat5481018/Tenis-Deportivos-Mujer",
							meatStickerOption: 0,
							label: "Tenis deportivos mujer 30%"
						},
						{
							label: "Tenis moda mujer 99.990",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/madres-tenis-99-990"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1181119/Botas-y-Botines",
							label: "Botas y botines 40%",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Sandalias 30%",
							link: "/category/cat2571199/Sandalias",
							meatStickerOption: 0
						}
					],
					link: "/page/Dia-de-la-madre?staticPageId=21900002"
				},
				{
					label: "Tenis Mujer",
					verTodoActive: true,
					link: "/category/cat1031787/Tenis-Mujer",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat10520949/TENIS?f.product.attribute.Género=Mujer&f.product.attribute.Tipo=Tenis+moda&facetSelected=true",
							label: "Tenis Moda Mujer",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat5481018/Tenis-Deportivos-Mujer",
							isHighlightLink: false,
							label: "Tenis Deportivos Mujer"
						},
						{
							link: "/collection/ultimas-tallas-calzado?facetSelected=true&f.product.attribute.Género=Mujer",
							label: "Últimas Tallas Mujer",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo Tenis Mujer",
							link: "/category/cat1031787/Tenis-Mujer"
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Tenis Moda Hombre",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10520949/TENIS?f.product.attribute.Género=Hombre&f.product.attribute.Tipo=Tenis+moda&facetSelected=true"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat5481019/Tenis-Deportivos-Hombre",
							label: "Tenis Deportivos Hombre"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Guayos",
							link: "/category/cat3030943/Guayos"
						},
						{
							meatStickerOption: 0,
							label: "Últimas Tallas Hombre",
							link: "/collection/ultimas-tallas-calzado?facetSelected=true&f.product.attribute.Género=Hombre",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							link: "/category/cat731023/Tenis-Hombre",
							label: "Ver todo Tenis Hombre"
						}
					],
					verTodoActive: true,
					link: "/category/cat731023/Tenis-Hombre",
					label: "Tenis Hombre"
				},
				{
					label: "Tenis Infantiles",
					link: "/collection/tenis-infantiles",
					leafCategories: [
						{
							link: "/collection/tenis-ninas",
							label: "Tenis Niñas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Tenis Niños",
							link: "/collection/tenis-ninos"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Últimas Tallas",
							link: "/collection/ultimas-tallas-calzado?facetSelected=true&f.product.attribute.Género=Niña%3A%3ANiño%3A%3AUnisex"
						},
						{
							label: "Ver Todo Tenis Infantiles",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/tenis-infantiles"
						}
					],
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1031787/Tenis-Mujer",
							label: "Tenis Mujer"
						},
						{
							meatStickerOption: 0,
							label: "Zápatos Cómodos",
							isHighlightLink: false,
							link: "/category/cat11411062/Comfort"
						},
						{
							isHighlightLink: false,
							label: "Botas y Botines",
							meatStickerOption: 0,
							link: "/category/cat1181119/Botas-y-Botines"
						},
						{
							meatStickerOption: 0,
							label: "Zapatos Casuales",
							link: "/category/cat10890960/Zapatos-Casuales",
							isHighlightLink: false
						},
						{
							label: "Sandalias",
							meatStickerOption: 0,
							link: "/category/cat2571199/Sandalias",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Tacones",
							isHighlightLink: false,
							link: "/category/cat1181121/Tacones"
						},
						{
							isHighlightLink: false,
							label: "Últimas Tallas Mujer",
							link: "/collection/ultimas-tallas-calzado?facetSelected=true&f.product.attribute.Género=Mujer",
							meatStickerOption: 0
						},
						{
							link: "/category/cat790973/Zapatos-Mujer?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Zapatos Mujer"
						}
					],
					label: "Zapatos Mujer",
					verTodoActive: true,
					link: "/category/cat790973/Zapatos-Mujer"
				},
				{
					leafCategories: [
						{
							label: "Tenis Hombre",
							isHighlightLink: false,
							link: "/category/cat731023/Tenis-Hombre"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat11411063/Comfort",
							label: "Zapatos Cómodos"
						},
						{
							isHighlightLink: false,
							label: "Zapatos Casuales",
							link: "/category/cat1831262/Zapatos-Casuales-Hombre"
						},
						{
							isHighlightLink: false,
							label: "Mocasines",
							link: "/category/cat1831254/Mocasines-Hombre"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2571201/Sandalias-Hombre",
							label: "Sandalias"
						},
						{
							isHighlightLink: false,
							label: "Botas",
							link: "/category/cat731013/Botas-Hombre"
						},
						{
							isHighlightLink: false,
							label: "Zapatos Formales",
							link: "/category/cat731011/Zapatos-Formales-Hombre"
						},
						{
							meatStickerOption: 0,
							label: "Últimas Tallas Hombre",
							link: "/collection/ultimas-tallas-calzado?facetSelected=true&f.product.attribute.Género=Hombre",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo Zapatos Hombre",
							link: "/category/cat740959/Zapatos-Hombre?isPLP=1"
						}
					],
					link: "/category/cat740959/Zapatos-Hombre",
					label: "Zapatos Hombre"
				},
				{
					link: "/category/cat8730964/Zapatos-Ninas",
					verTodoActive: true,
					label: "Zapatos Niñas",
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/collection/tenis-ninas",
							isHighlightLink: false,
							label: "Tenis Niñas"
						},
						{
							isHighlightLink: false,
							label: "Botas",
							meatStickerOption: 0,
							link: "/category/cat8730964/Zapatos-Ninas?facetSelected=true&f.product.attribute.Tipo=Botas%3A%3ABotas+de+lluvia%3A%3ABotines"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat8730964/Zapatos-Ninas?facetSelected=true&f.product.attribute.Tipo=Hawaianas%3A%3ASandalias",
							label: "Sandalias"
						},
						{
							label: "Baletas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat8730964/Zapatos-Ninas?facetSelected=true&f.product.attribute.Tipo=Baletas%3A%3AZapatos+casuales"
						},
						{
							label: "Calzado Escolar",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat8730964/Zapatos-Ninas?facetSelected=true&f.product.attribute.Tipo=Calzado+escolar"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/ultimas-tallas-calzado?&facetSelected=true&f.product.attribute.Género=Niña%3A%3AUnisex",
							label: "Últimas Tallas Niñas"
						},
						{
							link: "/category/cat8730964/Zapatos-Ninas",
							label: "Ver todo Zapatos Niñas",
							isHighlightLink: true
						}
					]
				},
				{
					verTodoActive: true,
					link: "/category/cat3020988/Zapatos-Ninos",
					label: "Zapatos Niños",
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Tenis Niños",
							link: "/collection/tenis-ninos",
							isHighlightLink: false
						},
						{
							link: "/category/cat3020988/Zapatos-Ninos?facetSelected=true&f.product.attribute.Tipo=Botas%3A%3ABotas+de+lluvia%3A%3ABotines",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Botas"
						},
						{
							label: "Sandalias ",
							link: "/category/cat3020988/Zapatos-Ninos?facetSelected=true&f.product.attribute.Tipo=Hawaianas%3A%3ASandalias",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Mocasines",
							link: "/category/cat3020988/Zapatos-Ninos?facetSelected=true&f.product.attribute.Tipo=Mocasines%3A%3AZapatos+casuales",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat3020988/Zapatos-Ninos?facetSelected=true&f.product.attribute.Tipo=Tenis+de+fútbol",
							meatStickerOption: 0,
							label: "Guayos"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Calzado Escolar",
							link: "/category/cat3020988/Zapatos-Ninos?facetSelected=true&f.product.attribute.Tipo=Calzado+escolar"
						},
						{
							label: "Últimas Tallas Niñas",
							meatStickerOption: 0,
							link: "/collection/ultimas-tallas-calzado?&facetSelected=true&f.product.attribute.Género=Niño%3A%3AUnisex",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo Zapatos Niños",
							link: "/category/cat3020988/Zapatos-Ninos"
						}
					]
				},
				{
					label: "Marcas Destacadas",
					link: "/category/cat10520949/TENIS?isPLP=1",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/collection/tenis-adidas",
							label: "Adidas",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Aldo",
							link: "/page/Aldo?staticPageId=25800001"
						},
						{
							meatStickerOption: 0,
							link: "/collection/tenis-asics",
							isHighlightLink: false,
							label: "Asics"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Call It Spring",
							link: "/page/call-it-spring?staticPageId=27400001&sred=call-it-spring"
						},
						{
							isHighlightLink: false,
							label: "Disney",
							link: "/category/cat10070940/Zapatos-Infantiles?facetSelected=true&f.product.brandName=disney&isPLP=1%3FisPLP%3D1&isPLP=1",
							meatStickerOption: 0
						},
						{
							label: "Fila",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/tenis-fila"
						},
						{
							isHighlightLink: false,
							label: "New Balance",
							link: "/collection/tenis-new-balance",
							meatStickerOption: 0
						},
						{
							label: "Nike",
							isHighlightLink: false,
							link: "/collection/tenis-nike",
							meatStickerOption: 0
						},
						{
							link: "/collection/tenis-puma",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Puma"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/tenis-reebok",
							label: "Reebok"
						},
						{
							label: "Skechers",
							meatStickerOption: 0,
							link: "/category/cat11230959/Skechers",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Under Armour",
							link: "/collection/tenis-under-armour",
							isHighlightLink: false
						}
					]
				}
			],
			label: "Zapatos",
			link: "cat260943"
		},
		{
			link: "cat2321031",
			label: "Mujer",
			subCategories: [
				{
					link: "/collection/mujer-black-50",
					label: "Cyber days",
					verTodoActive: true,
					leafCategories: [
						{
							link: "/collection/mujer-black-50",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "50% Vestuario Mujer "
						},
						{
							isHighlightLink: false,
							link: "/collection/sacos-mujer-2x79990",
							meatStickerOption: 0,
							label: "Sacos 2x$79.990"
						},
						{
							link: "/category/cat4670964/Ropa-Mujer?facetSelected=true&f.product.brandName=desigual%3A%3Amng&isPLP=1%2C1%2C1&isPLP=1",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Mejores Marcas Cyber "
						},
						{
							meatStickerOption: 0,
							label: "Ropa Cómoda $69.990",
							isHighlightLink: false,
							link: "/collection/ropa-comoda-black"
						},
						{
							link: "/collection/chaquetas-mujer-79990",
							meatStickerOption: 0,
							label: "Chaquetas $79.990",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Jeans $59.990",
							isHighlightLink: false,
							link: "/collection/jeans-mujer-59990"
						},
						{
							meatStickerOption: 0,
							label: "Vestidos $79.990",
							isHighlightLink: false,
							link: "/collection/vestidos-mujer-79990"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/leggings-deportivos-2x79990",
							label: "Leggings Deportivos 2x$79.990"
						},
						{
							link: "/collection/pijamas-mujer-30",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Pijamas Mujer 30% "
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Lobo Rosa by Falabella",
							link: "/collection/lobo-rosa"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Mamá e Hija Lobo Rosa By Falabella",
							link: "/collection/lobo-rosa-minime"
						}
					],
					label: "Lobo Rosa by Falabella",
					verTodoActive: true,
					link: "/collection/lobo-rosa"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ropa Cómoda",
							link: "/collection/comfy-mujer"
						},
						{
							label: "Colección Mickey",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/moda-mujer---closet-mickey"
						},
						{
							meatStickerOption: 0,
							link: "/collection/camisetas-licencias-mujer",
							isHighlightLink: false,
							label: "Camisetas Licencias"
						}
					],
					label: "Tendencias",
					link: "/category/cat4670964/Ropa-Mujer?isLanding=true"
				},
				{
					label: "Ropa Mujer",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat4670964/Ropa-Mujer?isPLP=1",
							label: "Ver todo Ropa Mujer"
						},
						{
							label: "Blusas y Camisas",
							link: "/category/cat9710983/Blusas-y-Camisetas",
							isHighlightLink: false
						},
						{
							link: "/category/cat11540942/Camisetas",
							meatStickerOption: 0,
							label: "Camisetas",
							isHighlightLink: false
						},
						{
							link: "/collection/packs-mujer-2021",
							label: "Packs x2",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Sacos",
							link: "/category/cat4960970/Sacos-y-sweaters"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ponchos",
							link: "/category/cat4960970/Sacos-y-Sweaters?f.product.attribute.Tipo=Ponchos"
						},
						{
							label: "Chaquetas y Abrigos",
							isHighlightLink: false,
							link: "/category/cat4960971/Chaquetas"
						},
						{
							link: "/category/cat4960969/Jeans",
							isHighlightLink: false,
							label: "Jeans"
						},
						{
							isHighlightLink: false,
							link: "/category/cat4960972/Pantalones",
							label: "Pantalones"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Joggers",
							link: "/category/cat4960972/Pantalones?f.product.attribute.Fit=Jogger"
						},
						{
							label: "Leggings",
							link: "/category/cat4960972/Pantalones?f.product.attribute.Tipo=Leggins",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat4960968/Vestidos",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Vestidos y Enterizos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat5521009/Faldas-y-Shorts?f.product.attribute.Tipo=Faldas%3A%3AJardineras",
							label: "Faldas "
						},
						{
							label: "Shorts",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat5521009/Faldas-y-Shorts?f.product.attribute.Tipo=Shorts"
						},
						{
							link: "/category/cat5810997/Vestidos-de-Bano",
							isHighlightLink: false,
							label: "Vestidos de Baño"
						},
						{
							meatStickerOption: 0,
							label: "Ropa Deportiva",
							isHighlightLink: false,
							link: "/category/cat10921002/Ropa-Deportiva"
						},
						{
							isHighlightLink: false,
							link: "/page/vestuario-mujer?staticPageId=30100002?v=488686",
							meatStickerOption: 0,
							label: "LIQUIDACIÓN"
						}
					],
					link: "/category/cat4670964/Ropa-Mujer?isLanding=true"
				},
				{
					leafCategories: [
						{
							label: "Ver todo Ropa Interior Femenina",
							isHighlightLink: true,
							link: "/category/cat6570940/Ropa-Interior-Femenina?isPLP=1"
						},
						{
							link: "/category/cat7100944/Pijamas",
							isHighlightLink: false,
							label: "Pijamas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat11390942/Arma-tu-Pijama-por--59-990",
							label: "Arma tu Pijama"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Batas",
							link: "/category/cat6570940/Ropa-Interior-Femenina?facetSelected=true&f.product.attribute.Tipo=Batas+de+ba%C3%B1o%3A%3ABatas+para+dormir&facetSelected=true&isPLP=1"
						},
						{
							link: "/category/cat7100945/Pantuflas",
							isHighlightLink: false,
							label: "Pantuflas y Accesorios"
						},
						{
							link: "/category/cat6570941/Brasieres",
							label: "Brasieres",
							isHighlightLink: false
						},
						{
							label: "Calzones",
							isHighlightLink: false,
							link: "/category/cat7400997/Tangas-y-Bragas"
						},
						{
							label: "Medias",
							link: "/category/cat7400998/Medias",
							isHighlightLink: false
						},
						{
							link: "/category/cat7400998/Medias-Mujer?f.product.attribute.Tipo=Medias+veladas",
							label: "Medias Veladas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Fajas",
							link: "/category/cat5100940/Fajas-y-Moldeadores",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Maternidad",
							link: "/collection/ropa-interior-maternidad/",
							isHighlightLink: false
						}
					],
					link: "/category/cat6570940/Ropa-Interior-Femenina",
					label: "Ropa Interior Femenina"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							link: "/page/Accesorios2020?staticPageId=26600001",
							isHighlightLink: true,
							label: "Ver todo Accesorios Mujer"
						}
					],
					label: "Accesorios Mujer",
					link: "/page/Accesorios2020?staticPageId=26600001"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Lobo Rosa by Falabella ",
							meatStickerOption: 0,
							link: "/collection/lobo-rosa"
						},
						{
							isHighlightLink: false,
							link: "/category/cat4670964/Ropa-Mujer?facetSelected=true&f.product.brandName=mng&isPLP=1%2C1&isPLP=1",
							label: "MNG"
						},
						{
							label: "Desigual",
							isHighlightLink: false,
							link: "/category/cat4670964/Ropa-Mujer?f.product.brandName=desigual&isPLP=1%2C1&isPLP=1"
						},
						{
							link: "/category/cat4670964/Ropa-Mujer?f.product.brandName=gap",
							isHighlightLink: false,
							label: "GAP"
						},
						{
							label: "Basement",
							link: "/category/cat4670964/Ropa-Mujer?f.product.brandName=basement&isPLP=1%2C1&isPLP=1",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Sybilla",
							link: "/category/cat4670964/Ropa-Mujer?facetSelected=true&f.product.brandName=sybilla&isPLP=1%2C1&isPLP=1"
						},
						{
							isHighlightLink: false,
							link: "/category/cat4670964/Ropa-Mujer?facetSelected=true&f.product.brandName=university+club",
							meatStickerOption: 0,
							label: "University Club"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat4670964/Ropa-Mujer?facetSelected=true&f.product.brandName=denimlab",
							label: "Denimlab"
						},
						{
							label: "Mossimo",
							link: "/category/cat4670964/Ropa-Mujer?facetSelected=true&f.product.brandName=mossimo",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Disney",
							link: "/category/cat6570940/Ropa-Interior-Femenina?facetSelected=true&f.product.brandName=disney&isPLP=1%2C1&isPLP=1",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat4670964/Ropa-Mujer?facetSelected=true&f.product.brandName=doo+australia&facetSelected=true",
							label: "Doo Australia"
						},
						{
							link: "/page/etam?staticPageId=28500001?v=1q2w",
							label: "ETAM",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat6570940/Ropa-Interior-Femenina?facetSelected=true&f.product.brandName=leonisa&isPLP=1%2C1&isPLP=1",
							label: "Leonisa"
						},
						{
							label: "Levis",
							isHighlightLink: false,
							link: "/category/cat4670964/Ropa-Mujer?f.product.brandName=levis"
						},
						{
							isHighlightLink: false,
							link: "/category/cat6570940/Ropa-Interior-Femenina?facetSelected=true&f.product.brandName=samsara&facetSelected=true%2Ctrue&isPLP=1%2C1%2C1%2C1&isPLP=1",
							label: "Samsara",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Touche",
							link: "/category/cat4670964/Ropa-Mujer?f.product.brandName=touche+balneaire%3A%3Atouche+lingerie&isPLP=1",
							isHighlightLink: false
						},
						{
							label: "Violeta by MNG ",
							link: "/category/cat4670964/Ropa-Mujer?f.product.brandName=violeta&isPLP=1%3FisPLP%3D1&isPLP=1",
							isHighlightLink: false
						},
						{
							link: "/category/cat2321046/Marcas-Destacadas?isPLP=1",
							label: "Ver todo Marcas Destacadas",
							isHighlightLink: true
						}
					],
					label: "Marcas Destacadas",
					link: "/category/cat2321046/Marcas-Destacadas"
				}
			]
		},
		{
			link: "cat900969",
			subCategories: [
				{
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat6871001/Relojes?isPLP=1",
							label: "Ver todo Relojes"
						},
						{
							label: "Mujer",
							link: "/category/cat1711094/Relojes-Mujer",
							isHighlightLink: false
						},
						{
							label: "Hombre",
							link: "/category/cat1711092/Relojes-Hombre",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Niños y Niñas",
							link: "/category/cat11381146/Relojes-Infantiles"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3050947/Smartwatch",
							label: "Smartwatch"
						}
					],
					label: "Relojes",
					link: "/category/cat6871001/Relojes"
				},
				{
					link: "/category/cat1660957/Carteras-y-Bolsos",
					leafCategories: [
						{
							label: "Ver todo Bolsos y Carteras",
							link: "/category/cat1660957/Carteras-y-Bolsos?isPLP=1",
							isHighlightLink: true
						},
						{
							link: "/category/cat5510962/Bolsos",
							isHighlightLink: false,
							label: "Bolsos y Carteras"
						},
						{
							isHighlightLink: false,
							label: "Morrales y Mochilas",
							link: "/category/cat10360978/Morrales"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat13320950/Rinoneras-y-Canguros",
							isHighlightLink: false,
							label: "Riñoneras y Canguros"
						},
						{
							link: "/category/cat11410954/Bolsos-de-Moda",
							isHighlightLink: false,
							label: "Nueva Temporada"
						}
					],
					label: "Bolsos y Carteras"
				},
				{
					label: "Billeteras y Monederos",
					verTodoActive: true,
					link: "/category/cat1091064/Billeteras-y-Monederos",
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Ver Todo",
							isHighlightLink: false,
							link: "/category/cat1091064/Billeteras-y-Monederos"
						},
						{
							label: "Mujer",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat1091064/Billeteras-y-Monederos?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex"
						},
						{
							label: "Hombre",
							link: "/category/cat1091064/Billeteras-y-Monederos?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre%3A%3AUnisex",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Tarjeteros y Portadocumentos",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1091064/Billeteras-y-Monederos?facetSelected=true&f.product.attribute.Tipo=Portadocumentos%3A%3ATarjetero"
						}
					]
				},
				{
					label: "Gafas",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat1201309/Gafas?isPLP=1&isPLP=1",
							label: "Ver todo Gafas"
						},
						{
							isHighlightLink: false,
							label: "Gafas de Sol",
							link: "/category/cat11381150/Gafas-de-Sol"
						},
						{
							label: "Monturas",
							link: "/category/cat11410950/Monturas-de-Gafas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat11520980/Gafas-de-Lectura",
							label: "Gafas para Leer",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Accesorios",
							meatStickerOption: 0,
							link: "/category/cat10360989/Accesorios-para-Gafas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Mujer",
							link: "/category/cat1201309/Gafas?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex&isPLP=1%2C1%2C1&isPLP=1"
						},
						{
							isHighlightLink: false,
							label: "Hombre",
							meatStickerOption: 0,
							link: "/category/cat1201309/Gafas?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre%3A%3AUnisex&isPLP=1%2C1%2C1%2C1&isPLP=1"
						},
						{
							label: "Niños y Niñas",
							link: "/category/cat11381150/Gafas-de-Sol?f.product.attribute.G%C3%A9nero=Ni%C3%B1a%3A%3ANi%C3%B1o",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat11381152/Gafas-Ray-Ban",
							label: "Gafas Ray-Ban",
							isHighlightLink: false
						},
						{
							label: "Gafas Oakley",
							isHighlightLink: false,
							link: "/category/cat11410955/Gafas-Oakley"
						}
					],
					link: "/category/cat1201309/Gafas"
				},
				{
					leafCategories: [
						{
							link: "/category/cat7530993/Accesorios-Mujer",
							label: "Ver todo Accesorios Mujer",
							isHighlightLink: true
						},
						{
							link: "/category/cat7530995/Cinturones",
							isHighlightLink: false,
							label: "Cinturones"
						},
						{
							link: "/category/cat7530996/Sombreros",
							isHighlightLink: false,
							label: "Sombreros y Gorras"
						},
						{
							link: "/category/cat7530997/Bufandas-y-Panuelos",
							isHighlightLink: false,
							label: "Bufandas y Pañuelos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat11671113/Tapabocas",
							meatStickerOption: 0,
							label: "Tapabocas"
						},
						{
							isHighlightLink: false,
							label: "Otros complementos",
							link: "/category/cat7531002/Otros-complementos"
						}
					],
					label: "Accesorios Mujer",
					link: "/category/cat900969/Accesorios"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo Bisutería y Joyería",
							link: "/category/cat1411008/Bisuteria-y-Joyeria?isPLP=1"
						},
						{
							label: "Collares ",
							link: "/category/cat5441004/Collares",
							isHighlightLink: false
						},
						{
							label: "Anillos",
							link: "/category/cat5441005/Anillos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat5441006/Aretes",
							label: "Aretes "
						},
						{
							label: "Pulseras",
							link: "/category/cat5510961/Pulseras",
							isHighlightLink: false
						},
						{
							label: "Dijes",
							isHighlightLink: false,
							link: "/category/cat1411008/Bisuteria-y-Joyeria?facetSelected=true&f.product.attribute.Tipo=Dijes&isPLP=1%2C1&isPLP=1",
							meatStickerOption: 0
						}
					],
					link: "/category/cat1411008/Bisuteria-y-Joyeria",
					label: "Bisutería y Joyería"
				},
				{
					link: "/category/cat10650948/Maletas-de-Viaje",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Maletas de Cabina",
							link: "/category/cat11261016/Maletas-de-Cabina"
						},
						{
							link: "/category/cat11261023/Maletas-Medianas",
							isHighlightLink: false,
							label: "Maletas Medianas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat11261028/Maletas-Grandes",
							label: "Maletas Grandes"
						},
						{
							label: "Sets de Maletas",
							isHighlightLink: false,
							link: "/category/cat11261030/Sets-de-Maletas"
						},
						{
							isHighlightLink: false,
							label: "Backpacks y Mochilas",
							link: "/category/cat670989/Backpacks-y-Mochilas"
						},
						{
							label: "Accesorios de Viaje",
							link: "/category/cat7930945/Accesorios-de-Viaje",
							isHighlightLink: false
						},
						{
							link: "/category/cat10650948/Maletas-de-Viaje?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Maletas de Viaje"
						}
					],
					label: "Maletas de Viaje"
				},
				{
					label: "Marcas Accesorios",
					link: "/category/cat4950948/Marcas-Accesorios",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat4950948/Marcas-Accesorios?isPLP=1",
							label: "Ver todo Marcas Accesorios"
						},
						{
							link: "/category/cat3891059/Casio",
							isHighlightLink: false,
							label: "Casio"
						},
						{
							isHighlightLink: false,
							link: "/category/cat5441018/Guess",
							label: "Guess"
						},
						{
							link: "/category/cat3990940/Rayban",
							label: "Ray-Ban",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat3831024/Michael-Kors",
							label: "Michael Kors"
						},
						{
							link: "/category/cat4080994/Fossil",
							label: "Fossil",
							isHighlightLink: false
						},
						{
							label: "Swatch",
							isHighlightLink: false,
							link: "/category/cat11020944/Swatch"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8760941/Tous",
							label: "Tous"
						},
						{
							link: "/category/cat11020940/Tissot",
							isHighlightLink: false,
							label: "Tissot"
						},
						{
							label: "Invicta",
							isHighlightLink: false,
							link: "/category/cat8070957/Invicta"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Sunglass Hut",
							link: "/collection/sunglass-hut"
						}
					]
				}
			],
			label: "Accesorios"
		},
		{
			label: "Belleza",
			subCategories: [
				{
					link: "/category/cat5440960/Belleza?isLanding=true",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat1461053/Perfumes?isPLP=1&isPLP=1",
							label: "Perfumes"
						},
						{
							isHighlightLink: false,
							label: "Maquillaje",
							link: "/category/cat1131042/Maquillaje?isPLP=1&isPLP=1"
						},
						{
							link: "/category/cat1461057/Cuidado-Facial?isPLP=1&isPLP=1",
							label: "Cuidado Facial",
							isHighlightLink: false
						},
						{
							label: "Cuidado Corporal",
							link: "/category/cat5440982/Cuidado-Corporal",
							isHighlightLink: false
						},
						{
							link: "/category/cat10421009/Cuidado-Capilar",
							isHighlightLink: false,
							label: "Cuidado Capilar"
						},
						{
							label: "Dermocosmetica",
							link: "/category/cat10651018/Dermocosmetica?isPLP=1&isPLP=1",
							isHighlightLink: false
						},
						{
							link: "/category/cat7580956/Aseo-Personal",
							isHighlightLink: false,
							label: "Aseo Personal"
						},
						{
							meatStickerOption: 0,
							link: "/collection/navidad-belleza?facetSelected=true&f.product.attribute.Género=Mujer%3A%3AUnisex&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue",
							isHighlightLink: false,
							label: "Regalos Para Ella"
						},
						{
							link: "/collection/navidad-belleza?facetSelected=true&f.product.attribute.Género=Hombre%3A%3AUnisex&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Regalos Para Él"
						},
						{
							label: "Sets Para Regalar",
							link: "/category/cat10820948/Regalo-perfecto",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/page/promociones-y-regalos?staticPageId=21200001",
							label: "Regalos Por Compra",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat5440960/Belleza",
							label: "Ver todo Belleza",
							isHighlightLink: true
						}
					],
					label: "Belleza"
				},
				{
					link: "/category/cat1461053/Perfumes?isLanding=true",
					label: "Perfumes",
					leafCategories: [
						{
							link: "/category/cat1461053/Perfumes?isPLP=1",
							label: "Ver todo Perfumes",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							link: "/category/cat2221019/Perfumes-Hombre",
							label: "Perfumes Hombre"
						},
						{
							link: "/category/cat2221021/Perfumes-Mujer",
							isHighlightLink: false,
							label: "Perfumes Mujer"
						},
						{
							isHighlightLink: false,
							label: "Sets de Perfumes",
							link: "/category/cat2540950/Sets-de-Perfumes"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1461053/Perfumes?facetSelected=true&f.range.derived.price.search=%2420.000+-+%2450.000%3A%3A%2450.000+-+%24100.000&isPLP=1%2C1%2C1&isPLP=1",
							label: "Perfumes a Menos De 99.990"
						},
						{
							link: "/category/cat10220969/PERFUMES-XXL",
							isHighlightLink: false,
							label: "Perfumes Extra Grandes",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Perfumes Tamaños Pequeños",
							link: "/collection/perfumes-tamanos-pequenos"
						}
					]
				},
				{
					link: "/category/cat1131042/Maquillaje?isLanding=true",
					label: "Maquillaje",
					leafCategories: [
						{
							link: "/category/cat1131042/Maquillaje?isPLP=1",
							label: "Ver todo Maquillaje",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							label: "Rostro",
							link: "/category/cat2930994/Rostro"
						},
						{
							isHighlightLink: false,
							label: "Ojos",
							link: "/category/cat2930995/Ojos"
						},
						{
							label: "Cejas",
							link: "/category/cat9820957/Cejas",
							isHighlightLink: false
						},
						{
							label: "Labios",
							isHighlightLink: false,
							link: "/category/cat3020944/Labios"
						},
						{
							isHighlightLink: false,
							label: "Uñas",
							link: "/category/cat10391014/Unas"
						},
						{
							label: "Sets de Maquillaje",
							link: "/category/cat7540940/Sets-de-Maquillaje",
							isHighlightLink: false
						},
						{
							label: "Accesorios",
							link: "/category/cat6370940/Accesorios",
							isHighlightLink: false
						}
					]
				},
				{
					link: "/page/CuidadoFacial?staticPageId=28900002?v=98",
					leafCategories: [
						{
							link: "/category/cat1461057/Cuidado-Facial?isPLP=1",
							label: "Ver todo Cuidado Facial",
							isHighlightLink: true
						},
						{
							link: "/category/cat5440970/Hidratantes-Faciales",
							isHighlightLink: false,
							label: "Hidratantes"
						},
						{
							isHighlightLink: false,
							label: "Limpieza",
							link: "/category/cat7580957/Limpieza-Facial"
						},
						{
							link: "/category/cat5440971/Tratamientos-Faciales",
							label: "Tratamientos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Set Cuidado",
							link: "/category/cat7490960/Set-Cuidado-Facial",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Protección Solar",
							link: "/category/cat7580958/Proteccion-Solar-Facial"
						},
						{
							isHighlightLink: false,
							label: "Accesorios",
							link: "/category/cat10651015/Accesorios-Cuidado-Facial"
						},
						{
							isHighlightLink: false,
							link: "/category/cat10651018/Dermocosmetica",
							label: "Dermocosmética"
						}
					],
					label: "Cuidado Facial"
				},
				{
					verTodoActive: true,
					label: "Cuidado Corporal",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat5440982/Cuidado-Corporal?isPLP=1",
							label: "Ver todo Cuidado Corporal"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Hidratantes",
							link: "/category/cat7580955/Hidratantes-Corporales"
						},
						{
							label: "Exfoliantes",
							link: "/category/cat11381061/Exfoliantes-Corporales",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Depilación",
							link: "/category/cat50608/Depilacion"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7580956/Aseo-Personal",
							label: "Aseo Personal",
							meatStickerOption: 0
						},
						{
							label: "Solares",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat10651037/Solares"
						},
						{
							link: "/category/cat350945/Accesorios-Corporales",
							meatStickerOption: 0,
							label: "Accesorios Corporales",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Nutrición y Suplementos",
							link: "/category/cat10780971/Nutricion-y-Suplementos"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Salud",
							link: "/category/cat10440978/Salud"
						}
					],
					link: "/category/cat5440982/Cuidado-Corporal"
				},
				{
					leafCategories: [
						{
							link: "/category/cat10421009/Cuidado-Capilar?isPLP=1",
							label: "Ver todo Cuidado Capilar",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							link: "/category/cat5510964/Shampoo-y-Acondicionadores",
							label: "Shampoo y Acondicionadores"
						},
						{
							isHighlightLink: false,
							label: "Tratamientos",
							link: "/category/cat10651016/Tratamientos-Capilares"
						},
						{
							link: "/category/cat11381082/Tintes-Capilares",
							meatStickerOption: 0,
							label: "Coloración",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Styling",
							link: "/category/cat10651040/Styling-de-Pelo"
						},
						{
							isHighlightLink: false,
							label: "Planchas",
							link: "/category/cat50485/Planchas-de-Pelo"
						},
						{
							link: "/category/cat50835/Secadores-de-Pelo",
							isHighlightLink: false,
							label: "Secadores"
						},
						{
							isHighlightLink: false,
							link: "/category/cat50767/Onduladores-de-Pelo",
							label: "Onduladores"
						},
						{
							isHighlightLink: false,
							link: "/category/cat10651017/Cepillos",
							label: "Cepillos y Accesorios"
						},
						{
							label: "Marcas Profesionales",
							link: "/category/cat10920994/Marcas-Profesionales",
							isHighlightLink: false
						}
					],
					label: "Cuidado Capilar",
					link: "/page/CuidadoCapilar?staticPageId=28900001"
				},
				{
					link: "/page/directorio-marcas-belleza?staticPageId=29300008",
					leafCategories: [
						{
							label: "Ver todo Marcas Belleza",
							link: "/category/cat3530950/Marcas-Belleza?isLanding=true",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							link: "/category/cat6510955/Carolina-Herrera",
							label: "Carolina Herrera"
						},
						{
							isHighlightLink: false,
							label: "Estée Lauder",
							link: "/category/cat6020964/Estee-Lauder?isLanding=true"
						},
						{
							link: "/page/Lancome?staticPageId=30500003",
							isHighlightLink: false,
							label: "Lancôme"
						},
						{
							link: "/category/cat6030962/Clinique",
							isHighlightLink: false,
							label: "Clinique"
						},
						{
							isHighlightLink: false,
							label: "Benefit",
							link: "/category/cat4070992/Benefit?isLanding=true"
						},
						{
							link: "/page/Kiehls?staticPageId=12200001",
							label: "Kiehl's",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "MAC Cosmetics",
							link: "/category/cat6030945/MAC-Cosmetics?isLanding=true"
						},
						{
							label: "Kérastase",
							isHighlightLink: false,
							link: "/category/cat10881031/Kerastase?isLanding=true"
						},
						{
							label: "Dior",
							link: "/category/cat11340944/Dior?isLanding=true",
							isHighlightLink: false
						}
					],
					label: "Marcas Belleza"
				},
				{
					link: "/category/cat10651018/Dermocosmetica?isLanding=true",
					leafCategories: [
						{
							label: "Ver todo Dermocosmetica",
							link: "/category/cat10651018/Dermocosmetica?isPLP=1",
							isHighlightLink: true
						},
						{
							link: "/category/cat10651019/Proteccion-Solar-Dermo",
							label: "Protección Solar",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Anti-Edad",
							link: "/category/cat10651020/Anti-Edad-Dermo"
						},
						{
							isHighlightLink: false,
							link: "/category/cat10651021/Cuidado-Capilar-Dermo",
							label: "Cuidado Capilar"
						},
						{
							isHighlightLink: false,
							label: "Cuidado Corporal",
							link: "/category/cat10651022/Cuidado-Corporal-Dermo"
						},
						{
							link: "/category/cat10651023/Ciudado-de-Rostro-Dermo",
							isHighlightLink: false,
							label: "Cudado de Rostro"
						},
						{
							link: "/category/cat10651024/Dermomaquillaje",
							label: "Dermomaquillaje",
							isHighlightLink: false
						}
					],
					label: "Dermocosmetica"
				}
			],
			link: "cat11340948"
		},
		{
			subCategories: [
				{
					link: "/category/cat4670965/Ropa-Hombre",
					label: "Ropa Hombre",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ropa Cómoda",
							link: "/collection/comfy-hombre"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Mundo Urbano",
							link: "/page/estilo-urbano?staticPageId=29300010"
						},
						{
							isHighlightLink: false,
							label: "Camisetas",
							link: "/category/cat4960962/Camisetas-para-hombre"
						},
						{
							isHighlightLink: false,
							link: "/category/cat4960962/Camisetas-para-hombre?facetSelected=true&f.product.attribute.Tipo=Camisetas+polo",
							label: "Camisetas Polo",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat5530965/Camisas-para-hombre",
							label: "Camisas Casuales"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat5530968/Camisas-formales",
							label: "Camisas Formales",
							isHighlightLink: false
						},
						{
							label: "Sacos y Sweaters",
							link: "/category/cat4960964/Sacos-y-Sweaters",
							isHighlightLink: false
						},
						{
							link: "/category/cat5530966/Chaquetas-para-hombre",
							isHighlightLink: false,
							label: "Chaquetas"
						},
						{
							label: "Blazer",
							link: "/category/cat7310956/Blazer-para-hombre",
							isHighlightLink: false
						},
						{
							link: "/category/cat4960965/Jeans-para-hombre",
							label: "Jeans",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat4960963/Pantalones-para-hombre",
							label: "Pantalones"
						},
						{
							label: "Pantalones de vestir",
							link: "/category/cat7310955/Pantalones-de-Vestir",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Joggers",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat4960963/Pantalones?f.product.attribute.Tipo=Jogger%3A%3AJoggers"
						},
						{
							link: "/category/cat8840945/Bermudas-y-Vestidos-de-Bano",
							label: "Bermudas y Vestidos de Baño",
							isHighlightLink: false
						},
						{
							label: "Ropa Deportiva",
							link: "/category/cat5390940/Ropa-Deportiva-Hombre?isPLP=1&isPLP=1",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Ver todo Ropa Hombre",
							isHighlightLink: true,
							link: "/category/cat4670965/Ropa-Hombre?isPLP=1"
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Calzoncillos y Boxers",
							link: "/category/cat7310960/Calzoncillos-y-Boxers"
						},
						{
							label: "Pijamas",
							isHighlightLink: false,
							link: "/category/cat7310959/Pijamas-para-hombre"
						},
						{
							isHighlightLink: false,
							label: "Medias",
							link: "/category/cat7310958/Medias-para-hombre"
						},
						{
							link: "/category/cat8750963/Camisetas",
							label: "Camisetas",
							isHighlightLink: false
						},
						{
							label: "Pantuflas",
							isHighlightLink: false,
							link: "/category/cat8820970/Pantuflas-hombre"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8820971/Packs",
							label: "Packs"
						},
						{
							isHighlightLink: false,
							label: "Ropa interior y Primeras Capas",
							link: "/category/cat8560966/Ropa-interior-y-Primeras-Capas"
						},
						{
							isHighlightLink: true,
							link: "/category/cat5930952/Ropa-Interior-masculina?isPLP=1",
							label: "Ver todo Ropa Interior"
						}
					],
					label: "Ropa Interior",
					link: "/category/cat5930952/Ropa-Interior-masculina"
				},
				{
					link: "/category/cat4960974/Accesorios-Hombre",
					label: "Accesorios",
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/collection/liquidacion-accesorios-hombre",
							isHighlightLink: false,
							label: "Liquidación Accesorios"
						},
						{
							label: "Perfumes",
							isHighlightLink: false,
							link: "/category/cat2221019/Perfumes-Hombre"
						},
						{
							isHighlightLink: false,
							label: "Relojes",
							link: "/category/cat1711092/Relojes-Hombre"
						},
						{
							label: "Billeteras y Maletas",
							link: "/category/cat8850957/Billeteras-y-Maletas",
							isHighlightLink: false
						},
						{
							label: "Cinturones",
							isHighlightLink: false,
							link: "/category/cat8790940/Cinturones-para-hombre"
						},
						{
							isHighlightLink: false,
							label: "Gorros y Sombreros",
							link: "/category/cat8820976/Gorros-y-Sombreros"
						},
						{
							link: "/category/cat8790941/Corbatas",
							isHighlightLink: false,
							label: "Corbatas"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Accesorios Hombre",
							link: "/category/cat4960974/Accesorios-Hombre?isPLP=1"
						}
					]
				},
				{
					label: "Marcas Destacadas",
					link: "/category/cat5530973/Marcas-Destacadas",
					leafCategories: [
						{
							link: "/page/LaMartina?staticPageId=29300009?v=ju",
							label: "La Martina",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat4670965/Ropa-Hombre?facetSelected=true&f.product.brandName=tommy+hilfiger&facetSelected=true&isPLP=1%2C1%2C1&isPLP=1",
							label: "Tommy Hilfiger",
							meatStickerOption: 0
						},
						{
							label: "Polo Ralph Lauren",
							isHighlightLink: false,
							link: "/category/cat4670965/Ropa-Hombre?facetSelected=true&f.product.brandName=polo+ralph+lauren&isPLP=1%2C1&isPLP=1"
						},
						{
							isHighlightLink: false,
							label: "GAP",
							link: "/category/cat11170941/GAP"
						},
						{
							link: "/category/cat4670965/Ropa-Hombre?facetSelected=true&f.product.brandName=levis&facetSelected=true%2Ctrue&isPLP=1%2C1%2C1%2C1&isPLP=1",
							label: "Levis",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Calvin Klein",
							meatStickerOption: 0,
							link: "/category/cat4670965/Ropa-Hombre?facetSelected=true&f.product.brandName=calvin+klein&isPLP=1%2C1%2C1%2C1&isPLP=1",
							isHighlightLink: false
						},
						{
							label: "MNG MAN",
							link: "/category/cat4670965/Ropa-Hombre?facetSelected=true&f.product.brandName=he%3A%3Amng+man&isPLP=1",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat11591021/FILA",
							label: "FILA"
						},
						{
							label: "French Connection",
							isHighlightLink: false,
							link: "/category/cat11060956/French-Connection"
						},
						{
							isHighlightLink: false,
							link: "/category/cat5530974/Pepe-Jeans",
							label: "Pepe Jeans"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat11630981/TM-Lewin",
							label: "TM Lewin"
						},
						{
							link: "/category/cat9270948/J.Crew",
							isHighlightLink: false,
							label: "J.Crew"
						},
						{
							label: "Ver todo Marcas Destacadas",
							link: "/category/cat5530973/Marcas-Destacadas?isPLP=1",
							isHighlightLink: true
						}
					]
				},
				{
					label: "Tapabocas",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Caretas",
							link: "/category/cat11671113/Tapabocas?sortBy=derived.price.search%2Casc&f.product.attribute.Tipo=Otros&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue"
						},
						{
							isHighlightLink: false,
							link: "/category/cat11671113/Tapabocas?facetSelected=true&f.product.brandName=looney+tunes",
							label: "Looney Toons",
							meatStickerOption: 0
						},
						{
							label: "Set Tapabocas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat11671113/Tapabocas?sortBy=derived.price.search%2Cdesc&f.product.brandName=bearcliff%3A%3Acolor+siete%3A%3Aeuro+care&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Tapabocas",
							link: "/category/cat11671113/Tapabocas?sortBy=derived.price.search%2Cdesc&f.product.brandName=bearcliff%3A%3Acolor+siete%3A%3Aeuro+care&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue"
						}
					],
					link: "/category/cat11671113/Tapabocas?sortBy=derived.price.search%2Cdesc&f.product.brandName=bearcliff%3A%3Acolor+siete%3A%3Aeuro+care&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue",
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat5810944/Medias-Basement-4-X--29-990",
							label: "Medias Basement 4 X $29.990"
						},
						{
							link: "/category/cat8700946/SALE",
							isHighlightLink: false,
							label: "Liquidación"
						},
						{
							label: "Ver todo Promociones",
							isHighlightLink: true,
							link: "/category/cat6250940/Promociones?isPLP=1"
						}
					],
					link: "/category/cat6250940/Promociones",
					label: "Promociones"
				},
				{
					link: "/category/cat740959/Zapatos-Hombre",
					label: "Zapatos Hombre",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat11840971/Liquidacion-Zapatos-Hombre",
							label: "LIQUIDACIÓN",
							meatStickerOption: 0
						},
						{
							label: "Tenis",
							isHighlightLink: false,
							link: "/category/cat731023/Tenis-Hombre"
						},
						{
							link: "/category/cat3030943/Guayos",
							isHighlightLink: false,
							label: "Guayos"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Comfort",
							link: "/category/cat11411063/Comfort"
						},
						{
							link: "/category/cat1831262/Zapatos-Casuales-Hombre",
							label: "Zapatos Casuales",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat1831254/Mocasines-Hombre",
							label: "Mocasines"
						},
						{
							label: "Sandalias",
							isHighlightLink: false,
							link: "/category/cat2571201/Sandalias-Hombre"
						},
						{
							label: "Botas",
							isHighlightLink: false,
							link: "/category/cat731013/Botas-Hombre"
						},
						{
							isHighlightLink: false,
							link: "/category/cat731011/Zapatos-Formales-Hombre",
							label: "Zapatos Formales"
						},
						{
							isHighlightLink: false,
							label: "Marcas Zapatos",
							link: "/category/cat5460956/Marcas-Zapatos-Hombre"
						},
						{
							link: "/category/cat740959/Zapatos-Hombre?isPLP=1",
							label: "Ver todo Zapatos Hombre",
							isHighlightLink: true
						}
					]
				},
				{
					label: "Cuidado personal hombre",
					link: "/category/cat8561003/Cuidado-personal-hombre",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Tratamientos Faciales",
							link: "/category/cat7580959/Tratamientos-Faciales-Hombre"
						},
						{
							link: "/category/cat50723/Afeitadoras-Hombre",
							isHighlightLink: false,
							label: "Afeitadoras"
						},
						{
							label: "Perfumes",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat2221019/Perfumes-Hombre"
						},
						{
							label: "Ver todo Cuidado personal hombre",
							link: "/category/cat8561003/Cuidado-personal-hombre?isPLP=1",
							isHighlightLink: true
						}
					]
				}
			],
			label: "Hombre",
			link: "cat5521012"
		},
		{
			label: "Deportes",
			link: "cat50609",
			subCategories: [
				{
					link: "/category/cat50610/Disciplinas-Deportivas",
					label: "Disciplinas Deportivas",
					leafCategories: [
						{
							link: "/category/cat10770991/Entrenamiento-Funcional",
							label: "Entrenamiento Funcional",
							isHighlightLink: false
						},
						{
							link: "/category/cat50620/Gimnasio-en-Casa?isLanding=true",
							isHighlightLink: false,
							label: "Gimnasio en Casa"
						},
						{
							label: "Camping",
							link: "/category/cat2950940/Camping",
							isHighlightLink: false
						},
						{
							label: "Tenis Deporte",
							link: "/category/cat1570943/Tenis-Deporte",
							isHighlightLink: false
						},
						{
							label: "Deportes Acuaticos",
							link: "/category/cat631784/Deportes-Acuaticos",
							isHighlightLink: false
						},
						{
							label: "Boxeo y Artes Marciales",
							link: "/category/cat3021212/Boxeo-y-Artes-Marciales",
							isHighlightLink: false
						},
						{
							link: "/category/cat50903/Yoga-y-Pilates",
							isHighlightLink: false,
							label: "Yoga y Pilates"
						},
						{
							label: "Ping Pong",
							isHighlightLink: false,
							link: "/category/cat631183/Ping-Pong"
						},
						{
							isHighlightLink: false,
							label: "Baloncesto",
							link: "/category/cat1520961/Baloncesto"
						},
						{
							isHighlightLink: false,
							link: "/category/cat490951/Futbol",
							label: "Fútbol"
						},
						{
							label: "Patinaje",
							link: "/category/cat13100946/Patinaje",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Ciclismo",
							link: "/category/cat10770997/Ciclismo"
						},
						{
							isHighlightLink: false,
							label: "Natacion",
							link: "/category/cat10780940/Natacion"
						},
						{
							link: "/category/cat50610/Disciplinas-Deportivas?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Disciplinas Deportivas"
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "LIQUIDACION",
							link: "/category/cat12981120/Liquidacion-Accesorios"
						},
						{
							label: "Morrales Maletines y Bolsos",
							link: "/falabella-co/category/cat10780954/Accesorios-Deportivos?f.product.attribute.Tipo=Bolsos+deportivos%3A%3ACanguros%3A%3AGym+sacks%3A%3AMaletas+deportivas%3A%3AMochilas+deportivas&isPLP=1",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat10780954/Accesorios-Deportivos?f.product.attribute.Tipo=Gorras",
							meatStickerOption: 0,
							label: "Gorras Deportivas"
						},
						{
							meatStickerOption: 0,
							label: "Botellas Deportivas",
							link: "/category/cat12090977/Termos-y-Botellas-Personales?facetSelected=true&f.product.attribute.Tipo=Botellas+deportivas%3A%3ABotellas+personales&facetSelected=true%2Ctrue%2Ctrue%2Ctrue",
							isHighlightLink: false
						},
						{
							link: "/category/cat10780954/Accesorios-Deportivos",
							isHighlightLink: true,
							label: "Ver todo Accesorios Deportivos"
						}
					],
					verTodoActive: true,
					label: "Accesorios Deportivos",
					link: "/category/cat10780954/Accesorios-Deportivos"
				},
				{
					link: "/category/cat50516/Bicicletas?isLanding=true",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Montaña",
							link: "/category/cat770967/Bicicletas-de-Montana"
						},
						{
							link: "/category/cat271051/Bicicletas-Infantiles",
							isHighlightLink: false,
							label: "Infantiles"
						},
						{
							isHighlightLink: false,
							label: "Urbanas",
							link: "/category/cat770969/Bicicletas-Urbanas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1071043/Bicicletas-Plegables",
							label: "Plegables"
						},
						{
							label: "Eléctricas",
							link: "/category/cat701459/Bicicletas-Electricas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Vestuario Ciclismo",
							link: "/category/cat1050969/Vestuario-Ciclismo",
							meatStickerOption: 0
						},
						{
							link: "/category/cat731045/Accesorios-Bicicletas",
							isHighlightLink: false,
							label: "Accesorios Bicicletas"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Bicicletas",
							link: "/category/cat50516/Bicicletas?isPLP=1"
						}
					],
					label: "Bicicletas"
				},
				{
					link: "/category/cat50620/Gimnasio-en-Casa?isLanding=true",
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat50888/Trotadoras-y-Caminadoras",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Trotadoras y Caminadoras"
						},
						{
							link: "/category/cat50624/Elipticas",
							meatStickerOption: 0,
							label: "Elípticas",
							isHighlightLink: false
						},
						{
							link: "/category/cat701571/Spinning",
							label: "Spinning",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Multigimnasio",
							link: "/category/cat50752/Multigimnasio",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat10780955/Estaticas",
							isHighlightLink: false,
							label: "Estaticas"
						},
						{
							link: "/category/cat731039/Accesorios-Fitness",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Accesorios Fitness"
						},
						{
							label: "Pesas y Mancuernas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat10780956/Pesas-y-mancuernas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Nutrición y suplementos",
							link: "/category/cat10780971/Nutricion-y-Suplementos"
						},
						{
							label: "Ver todo Gimnasio en Casa",
							link: "/category/cat50620/Gimnasio-en-Casa?isPLP=1",
							isHighlightLink: true
						}
					],
					label: "Gimnasio en Casa"
				},
				{
					link: "/category/cat2950940/Camping?isLanding=true",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Carpas",
							link: "/category/cat670983/Carpas"
						},
						{
							link: "/category/cat3970989/Sleeping-Bags-y-Colchones-Inflables",
							isHighlightLink: false,
							label: "Sleeping Bags y Colchones Inflables"
						},
						{
							label: "Backpacks y Mochilas",
							isHighlightLink: false,
							link: "/category/cat670989/Backpacks-y-Mochilas"
						},
						{
							isHighlightLink: false,
							label: "Accesorios Camping",
							link: "/category/cat670993/Accesorios-Camping"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Camping",
							link: "/category/cat2950940/Camping?isPLP=1"
						}
					],
					label: "Camping"
				},
				{
					link: "/category/cat10921002/Ropa-Deportiva-Mujer?isLanding=true",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "LIQUIDACION",
							meatStickerOption: 0,
							link: "/category/cat12981119/Liquidacion-Mujer"
						},
						{
							label: "Camisetas Deportivas",
							isHighlightLink: false,
							link: "/category/cat5390973/Camisetas-Deportivas-Mujer"
						},
						{
							isHighlightLink: false,
							label: "Leggins y Licras Deportivas",
							link: "/category/cat5390985/Leggins-y-Licras-Deportivas"
						},
						{
							isHighlightLink: false,
							label: "Sacos y Hoodies",
							link: "/category/cat5390977/Sacos-y-Hoodies"
						},
						{
							isHighlightLink: false,
							label: "Chaquetas y Cortavientos",
							link: "/category/cat5390981/Chaquetas-y-Cortavientos-Mujer"
						},
						{
							isHighlightLink: false,
							label: "Shorts y Faldas Deportivas",
							link: "/category/cat5390989/Shorts-y-Faldas-Deportivas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat5390990/Pantalones-y-Sudaderas-Mujer",
							label: "Pantalones y Sudaderas"
						},
						{
							link: "/category/cat8560959/Tops-Deportivos-y-Fajas",
							isHighlightLink: false,
							label: "Tops y Fajas"
						},
						{
							isHighlightLink: false,
							label: "Medias Deportivas",
							link: "/category/cat10780953/Medias-Deportivas"
						},
						{
							isHighlightLink: true,
							link: "/category/cat10921002/Ropa-Deportiva-Mujer?isPLP=1",
							label: "Ver todo Ropa Deportiva Mujer"
						}
					],
					label: "Ropa Deportiva Mujer"
				},
				{
					link: "/category/cat5390940/Ropa-Deportiva-Hombre",
					leafCategories: [
						{
							label: "LIQUIDACION",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat12981118/Liquidacion-Hombre"
						},
						{
							link: "/category/cat5390947/Camisetas-Deportivas",
							label: "Camisetas Deportivas",
							isHighlightLink: false
						},
						{
							label: "Sacos y Hoodies",
							isHighlightLink: false,
							link: "/category/cat5390953/Sacos-y-Hoodies-Hombre"
						},
						{
							label: "Chaquetas y Cortavientos",
							link: "/category/cat5390957/Chaquetas-y-Cortavientos-Hombre",
							isHighlightLink: false
						},
						{
							label: "Pantalonetas",
							link: "/category/cat7910940/Pantalonetas",
							isHighlightLink: false
						},
						{
							link: "/category/cat8560940/Pantalones-y-Sudaderas-Hombre",
							isHighlightLink: false,
							label: "Pantalones y Sudaderas"
						},
						{
							isHighlightLink: false,
							label: "Medias Deportivas",
							link: "/category/cat10780953/Medias-Deportivas"
						},
						{
							label: "Ver todo Ropa Deportiva Hombre",
							isHighlightLink: true,
							link: "/category/cat5390940/Ropa-Deportiva-Hombre?isPLP=1"
						}
					],
					label: "Ropa Deportiva Hombre"
				},
				{
					leafCategories: [
						{
							label: "Tenis Deportivos Mujer",
							link: "/category/cat5481018/Tenis-Deportivos-Mujer",
							isHighlightLink: false
						},
						{
							label: "Tenis Deportivos Hombre",
							link: "/category/cat5481019/Tenis-Deportivos-Hombre",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat4880942/Tenis-deportes?facetSelected=true&f.product.attribute.Disciplina=Running",
							label: "Para Trotar"
						},
						{
							meatStickerOption: 0,
							label: "Para Entrenar",
							isHighlightLink: false,
							link: "/category/cat4880942/Tenis-deportes?facetSelected=true&f.product.attribute.Disciplina=Cross+training"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat4880942/Tenis-deportes?facetSelected=true&f.product.attribute.Disciplina=Outdoor",
							label: "Para Senderismo"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat4880942/Tenis-deportes?facetSelected=true&f.product.attribute.Disciplina=Básquetbol",
							isHighlightLink: false,
							label: "Para Basketball"
						},
						{
							isHighlightLink: false,
							label: "Tenis Para Fútbol",
							link: "/category/cat4880942/Tenis-deportes?facetSelected=true&f.product.attribute.Disciplina=Fútbol",
							meatStickerOption: 0
						},
						{
							link: "/category/cat3030943/Guayos",
							isHighlightLink: false,
							label: "Guayos"
						},
						{
							label: "Ver todo Tenis Deportivos",
							isHighlightLink: true,
							link: "/category/cat4880942/Tenis-Deportivos?isPLP=1"
						}
					],
					link: "/category/cat4880942/Tenis-Deportivos",
					label: "Tenis Deportivos"
				}
			]
		},
		{
			label: "Vestuario Infantil",
			subCategories: [
				{
					label: "Ropa Bebé",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/category/cat8950941/Ropa-Bebe-Nina",
							isHighlightLink: false,
							label: "Ropa Bebé Niña"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ropa Bebé Niño",
							link: "/category/cat8950940/Ropa-Bebe-Nino"
						},
						{
							link: "/category/cat3150971/Ropa-Bebe?facetSelected=true&f.product.attribute.Tipo=Conjuntos",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Sets y Conjuntos"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Bodies",
							link: "/category/cat3150971/Ropa-Bebe?&f.product.attribute.Tipo=Bodies&facetSelected=true"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat3150971/Ropa-Bebe?facetSelected=true&f.product.attribute.Tipo=Blusas%3A%3ACamisas%3A%3ACamisetas",
							isHighlightLink: false,
							label: "Camisas y Camisetas"
						},
						{
							isHighlightLink: false,
							label: "Sacos y Chaquetas",
							link: "/category/cat3150971/Ropa-Bebe?facetSelected=true&f.product.attribute.Tipo=Chalecos%3A%3AChaquetas%3A%3ASacos",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Shorts, Pantalones y Leggins",
							link: "/category/cat3150971/Ropa-Bebe?facetSelected=true&f.product.attribute.Tipo=Bermudas%3A%3AFaldas%3A%3AJeans%3A%3ALeggins%3A%3APantalones%3A%3AShorts",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Ropa Interior y Pijamas",
							link: "/category/cat3150971/Ropa-Bebe?facetSelected=true&f.product.attribute.Tipo=Medias%3A%3APijamas",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat3150971/Ropa-Bebe?facetSelected=true&f.product.attribute.Tipo=Jardineras%3A%3AVestidos",
							label: "Vestidos y Jardineras"
						},
						{
							link: "/category/cat3150971/Ropa-Bebe?&f.product.attribute.Tipo=Ositos+y+enteritos&facetSelected=true",
							meatStickerOption: 0,
							label: "Ositos y Enteritos",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat3150971/Ropa-Bebe?&f.product.attribute.Tipo=Baberos%3A%3AGorros%3A%3AMantas%3A%3APantuflas&facetSelected=true",
							label: "Accesorios",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ver todo",
							link: "/category/cat3150971/Ropa-Bebe"
						}
					],
					link: "/category/cat3150971/Ropa-Bebe"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Camisetas y Blusas",
							link: "/category/cat8170942/Ropa-Ninas-2-8-anos?facetSelected=true&f.product.attribute.Tipo=Blusas%3A%3ACamisetas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8170942/Ropa-Ninas-2-8-anos?&f.product.attribute.Tipo=Sacos&facetSelected=true",
							meatStickerOption: 0,
							label: "Sacos y Conjuntos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8170942/Ropa-Ninas-2-8-anos?&f.product.attribute.Tipo=Jardineras%3A%3AVestidos&facetSelected=true",
							meatStickerOption: 0,
							label: "Vestidos y Jardineras"
						},
						{
							label: "Chaquetas y Chalecos",
							link: "/category/cat8170942/Ropa-Ninas-2-8-anos?&f.product.attribute.Tipo=Chalecos%3A%3AChaquetas&facetSelected=true",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Pantalones y Leggins",
							meatStickerOption: 0,
							link: "/category/cat8170942/Ropa-Ninas-2-8-anos?facetSelected=true&f.product.attribute.Tipo=Leggins%3A%3APantalones"
						},
						{
							label: "Shorts y Faldas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat8170942/Ropa-Ninas-2-8-anos?&f.product.attribute.Tipo=Faldas%3A%3AShorts&facetSelected=true"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8170942/Ropa-Ninas-2-8-anos?&f.product.attribute.Tipo=Jeans&facetSelected=true",
							label: "Jeans",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat10660942/Vestidos-de-Bano?facetSelected=true&f.product.attribute.Género=Niña%3A%3AUnisex&f.variant.attribute.size=2%3A%3A2t%3A%3A3%3A%3A4%3A%3A5%3A%3A6",
							label: "Vestidos de Baño",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat8600964/Ropa-Deportiva-Nina?facetSelected=true&f.variant.attribute.size=4%3A%3A6",
							label: "Ropa Deportiva",
							meatStickerOption: 0
						},
						{
							label: "Ropa Interior y Pijamas",
							meatStickerOption: 0,
							link: "/category/cat8990981/Ropa-Interior-y-Pijamas-Ninas?facetSelected=true&f.variant.attribute.size=1%3A%3A2%3A%3A22-24%3A%3A25-27%3A%3A28-30%3A%3A3%3A%3A31-33%3A%3A4%3A%3A5%3A%3A6%3A%3Aúnica",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Accesorios",
							link: "/category/cat8860942/Ropa-Ninas?&f.product.attribute.Tipo=Accesorios+de+cabello%3A%3ABolsos%3A%3AGorras%3A%3ATapabocas&facetSelected=true&isPLP=1%2C1%2C1%2C1%2C1%2C1%2C1"
						},
						{
							isHighlightLink: false,
							label: "Ver todo",
							link: "/category/cat8170942/Ropa-Ninas-2-8-anos",
							meatStickerOption: 0
						}
					],
					label: "Ropa Niñas 2-8 años",
					link: "/category/cat8170942/Ropa-Ninas-2-8-anos"
				},
				{
					label: "Juvenil Niña 8-16 años",
					link: "/category/cat8170944/Ropa-Ninas-8-16-anos",
					verTodoActive: true,
					leafCategories: [
						{
							label: "Camisetas y Blusas",
							link: "/category/cat8170944/Ropa-Ninas-8-16-anos?facetSelected=true&f.product.attribute.Tipo=Blusas%3A%3ACamisetas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat8170944/Ropa-Ninas-8-16-anos?&f.product.attribute.Tipo=Sacos&facetSelected=true",
							label: "Sacos",
							meatStickerOption: 0
						},
						{
							link: "/category/cat8170944/Ropa-Ninas-8-16-anos?&f.product.attribute.Tipo=Jardineras%3A%3AVestidos&facetSelected=true",
							label: "Vestidos y Jardineras",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat8170944/Ropa-Ninas-8-16-anos?&f.product.attribute.Tipo=Chalecos%3A%3AChaquetas&facetSelected=true",
							meatStickerOption: 0,
							label: "Chaquetas y Chalecos"
						},
						{
							link: "/category/cat8170944/Ropa-Ninas-8-16-anos?&f.product.attribute.Tipo=Jeans&facetSelected=true",
							isHighlightLink: false,
							label: "Jeans",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Pantalones y Leggins",
							link: "/category/cat8170944/Ropa-Ninas-8-16-anos?&f.product.attribute.Tipo=Leggins%3A%3APantalones&facetSelected=true",
							isHighlightLink: false
						},
						{
							label: "Shorts y Faldas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat8170944/Ropa-Ninas-8-16-anos?&f.product.attribute.Tipo=Faldas%3A%3AShorts&facetSelected=true"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ropa Deportiva",
							link: "/category/cat8600964/Ropa-Deportiva-Nina?facetSelected=true&f.variant.attribute.size=10%3A%3A12%3A%3A14%3A%3A16%3A%3A18%3A%3Al%3A%3Am%3A%3As%3A%3Axl%3A%3Axs"
						},
						{
							label: "Ropa Interior y Pijamas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat8990981/Ropa-Interior-y-Pijamas-Ninas?&f.variant.attribute.size=10%3A%3A12%3A%3A14%3A%3A16%3A%3A34-36%3A%3A37-39%3A%3Al%3A%3Am%3A%3As%3A%3Axl&facetSelected=true"
						},
						{
							label: "Vestidos de baño",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10660942/Vestidos-de-Bano?facetSelected=true&f.product.attribute.Género=Niña%3A%3AUnisex&f.variant.attribute.size=10%3A%3A12%3A%3A14%3A%3A16%3A%3Al%3A%3Am"
						},
						{
							label: "Accesorios",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat8860942/Ropa-Ninas?&f.product.attribute.Tipo=Accesorios+de+cabello%3A%3ABolsos%3A%3AGorras%3A%3ATapabocas&facetSelected=true&isPLP=1%2C1%2C1%2C1%2C1%2C1%2C1"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat8170944/Ropa-Ninas-8-16-anos",
							isHighlightLink: false,
							label: "Ver todo"
						}
					]
				},
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Camisetas y Camisas",
							link: "/category/cat5610954/Ropa-Ninos-2-8-anos?facetSelected=true&f.product.attribute.Tipo=Camisas%3A%3ACamisetas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Sacos y Conjuntos",
							link: "/category/cat5610954/Ropa-Ninos-2-8-anos?&f.product.attribute.Tipo=Conjuntos%3A%3ASacos&facetSelected=true"
						},
						{
							label: "Chaquetas y Chalecos",
							link: "/category/cat5610954/Ropa-Ninos-2-8-anos?&f.product.attribute.Tipo=Chalecos%3A%3AChaquetas&facetSelected=true",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat5610954/Ropa-Ninos-2-8-anos?&f.product.attribute.Tipo=Jardineras%3A%3AJeans&facetSelected=true",
							label: "Jeans",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat5610954/Ropa-Ninos-2-8-anos?&f.product.attribute.Tipo=Pantalones&facetSelected=true",
							label: "Pantalones"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Bermudas",
							link: "/category/cat5610954/Ropa-Ninos-2-8-anos?&f.product.attribute.Tipo=Bermudas&facetSelected=true"
						},
						{
							isHighlightLink: false,
							label: "Vestidos de baño",
							meatStickerOption: 0,
							link: "/category/cat10660942/Vestidos-de-Bano?facetSelected=true&f.product.attribute.G%C3%A9nero=Ni%C3%B1o%3A%3AUnisex&f.variant.attribute.size=2%3A%3A3%3A%3A4%3A%3A5%3A%3A6"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ropa Deportiva",
							link: "/category/cat5810942/Ropa-Deportiva-Nino?facetSelected=true&f.variant.attribute.size=1%3A%3A2%3A%3A3%3A%3A4%3A%3A6%3A%3A7"
						},
						{
							link: "/category/cat8990982/Ropa-Interior-y-Pijamas-Ninos?facetSelected=true&f.variant.attribute.size=1%3A%3A2%3A%3A22-24%3A%3A25-27%3A%3A28-30%3A%3A3%3A%3A31-33%3A%3A4%3A%3A5%3A%3A6%3A%3Aúnica",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ropa Interior y Pijamas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8860941/Ropa-Ninos?facetSelected=true&f.product.attribute.Tipo=Bolsos%3A%3ABufandas%3A%3AGorras%3A%3ATapabocas&isPLP=1%2C1%2C1%2C1%2C1&isPLP=1",
							label: "Accesorios",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat5610954/Ropa-Ninos-2-8-anos",
							isHighlightLink: false,
							label: "Ver todo"
						}
					],
					label: "Ropa Niños 2-8 años",
					link: "/category/cat5610954/Ropa-Ninos-2-8-anos",
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/category/cat8170941/Ropa-Ninos-8-16-anos?facetSelected=true&f.product.attribute.Tipo=Camisas%3A%3ACamisetas",
							isHighlightLink: false,
							label: "Camisetas y Camisas"
						},
						{
							link: "/category/cat8170941/Ropa-Ninos-8-16-anos?&f.product.attribute.Tipo=Sacos&facetSelected=true",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Sacos"
						},
						{
							meatStickerOption: 0,
							label: "Chaquetas y Chalecos",
							isHighlightLink: false,
							link: "/category/cat8170941/Ropa-Ninos-8-16-anos?&f.product.attribute.Tipo=Chaquetas&facetSelected=true"
						},
						{
							label: "Jeans",
							isHighlightLink: false,
							link: "/category/cat8170941/Ropa-Ninos-8-16-anos?&f.product.attribute.Tipo=Jeans&facetSelected=true",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Pantalones",
							meatStickerOption: 0,
							link: "/category/cat8170941/Ropa-Ninos-8-16-anos?&f.product.attribute.Tipo=Pantalones&facetSelected=true"
						},
						{
							meatStickerOption: 0,
							label: "Bermudas",
							isHighlightLink: false,
							link: "/category/cat8170941/Ropa-Ninos-8-16-anos?&f.product.attribute.Tipo=Bermudas&facetSelected=true"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ropa Deportiva",
							link: "/category/cat5810942/Ropa-Deportiva-Nino?facetSelected=true&f.variant.attribute.size=10%3A%3A12%3A%3A14%3A%3A16%3A%3A18%3A%3Al%3A%3Am%3A%3As%3A%3Axl%3A%3Axs"
						},
						{
							isHighlightLink: false,
							label: "Ropa interior y Pijamas",
							link: "/category/cat8990982/Ropa-Interior-y-Pijamas-Ninos?facetSelected=true&f.variant.attribute.size=10%3A%3A12%3A%3A14%3A%3A16%3A%3A34-36%3A%3A37-39%3A%3Al%3A%3Am%3A%3As%3A%3Axl%3A%3Axs%3A%3Aúnica",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Vestidos de baño",
							meatStickerOption: 0,
							link: "/category/cat10660942/Vestidos-de-Bano?facetSelected=true&f.product.attribute.Género=Niño%3A%3AUnisex&f.variant.attribute.size=10%3A%3A12%3A%3A14%3A%3A16%3A%3Al%3A%3Am%3A%3As"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat8860941/Ropa-Ninos?facetSelected=true&f.product.attribute.Tipo=Bolsos%3A%3ABufandas%3A%3AGorras%3A%3ATapabocas&isPLP=1%2C1%2C1%2C1%2C1&isPLP=1",
							isHighlightLink: false,
							label: "Accesorios"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat8170941/Ropa-Ninos-8-16-anos",
							isHighlightLink: false,
							label: "Ver todo"
						}
					],
					label: "Juvenil Niño 8-16 años",
					verTodoActive: true,
					link: "/category/cat8170941/Ropa-Ninos-8-16-anos"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat11110975/Liquidacion-Zapatos-Infantiles",
							meatStickerOption: 0,
							label: "Liquidación"
						},
						{
							meatStickerOption: 0,
							label: "Niños",
							link: "/category/cat3020988/Zapatos-Ninos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Niñas",
							link: "/category/cat8730964/Zapatos-Ninas",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat11201039/Marcas-Infantiles",
							isHighlightLink: false,
							label: "Marcas Infantiles"
						},
						{
							meatStickerOption: 0,
							label: "Ver todo",
							isHighlightLink: false,
							link: "/category/cat10070940/Zapatos-Infantiles?isPLP=1&isPLP=1"
						}
					],
					verTodoActive: true,
					label: "Zapatos Infantiles",
					link: "/category/cat10070940/Zapatos-Infantiles?isPLP=1&isPLP=1"
				},
				{
					label: "Otros",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/collection/lobo-rosa-infantil",
							label: "Lobo Rosa Infantil",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Packs",
							link: "/category/cat11991004/Packs",
							isHighlightLink: false
						},
						{
							label: "Lo Nuevo",
							isHighlightLink: false,
							link: "/category/cat11630941/Vestuario-Infantil",
							meatStickerOption: 0
						},
						{
							label: "Moda Infantil",
							link: "/falabella-co/page/Vestuario-Infantil?staticPageId=23400001",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat10820943/Marcas-Premium",
							isHighlightLink: false,
							label: "Marcas Premium"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Personajes",
							link: "/category/cat10720954/Personajes-Infantiles"
						},
						{
							isHighlightLink: false,
							label: "Disney",
							link: "/falabella-co/page/Pixar-?staticPageId=25700001?sred=disney",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Marvel",
							link: "/falabella-co/page/Encuentra%20tu%20poder?staticPageId=24100007?sred=marvel"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat11540985/Vestuario-Infantil-",
							label: "Liquidación",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat11671140/Ropa-Bebe",
							meatStickerOption: 0,
							label: "Liquidación Bebé"
						}
					],
					link: "/collection/lobo-rosa-infantil"
				}
			],
			bannerLocation: "urlToImage",
			link: "cat13260944"
		},
		{
			label: "Infantil",
			subCategories: [
				{
					leafCategories: [
						{
							link: "/falabella-co/category/cat11671140/Ropa-Bebe",
							isHighlightLink: false,
							label: "LIQUIDACIÓN",
							meatStickerOption: 0
						},
						{
							link: "/category/cat3150971/Ropa-Bebe",
							isHighlightLink: false,
							label: "Ropa Bebé"
						},
						{
							link: "/category/cat50568/Coches-Para-Bebes",
							label: "Coches Para Bebes",
							isHighlightLink: false
						},
						{
							link: "/category/cat770997/Cunas-y-Corrales",
							isHighlightLink: false,
							label: "Cunas y Corrales"
						},
						{
							isHighlightLink: false,
							label: "Sillas de Carro  ",
							link: "/category/cat50846/Sillas-de-Carro"
						},
						{
							isHighlightLink: false,
							link: "/category/cat771005/Sillas-de-comer",
							label: "Sillas de comer"
						},
						{
							link: "/category/cat9130958/Juguetes-de-Bebe",
							label: "Juguetes de Bebé",
							isHighlightLink: false
						},
						{
							label: "Lactancia y Alimentación",
							isHighlightLink: false,
							link: "/category/cat2571046/Lactancia-y-Alimentacion"
						},
						{
							link: "/category/cat5420945/Dormitorio-Bebe",
							label: "Dormitorio Bebé",
							isHighlightLink: false
						},
						{
							label: "Monitores y Seguridad Infantil",
							isHighlightLink: false,
							link: "/category/cat2571047/Monitores-y-Seguridad-Infantil"
						},
						{
							label: "Caminadores y Bouncers",
							isHighlightLink: false,
							link: "/category/cat50539/Caminadores-y-Bouncers"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat2571048/Cuidado-y-Salud-del-Bebe",
							label: "Salud y Cuidado del Bebé",
							isHighlightLink: false
						},
						{
							label: "Baberos",
							link: "/category/cat4320946/Baberos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Maternidad",
							link: "/category/cat7161061/Maternidad"
						},
						{
							link: "/category/cat580947/Gimnasio-Bebe",
							isHighlightLink: false,
							label: "Gimnasio Bebé"
						},
						{
							label: "Ropa de Cama Infantil",
							isHighlightLink: false,
							link: "/category/cat2580950/Ropa-de-Cama-Infantil"
						},
						{
							link: "/category/cat4330974/Moviles-Infantiles",
							isHighlightLink: false,
							label: "Móviles Infantiles"
						},
						{
							isHighlightLink: false,
							label: "Pañaleras y Fulares",
							link: "/category/cat5890970/Panaleras-y-Fulares"
						},
						{
							link: "/category/cat50511/Mundo-Bebe?isPLP=1",
							label: "Ver todo Mundo Bebé",
							isHighlightLink: true
						}
					],
					label: "Mundo Bebé",
					link: "/category/cat50511/Mundo-Bebe?isLanding=true"
				},
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "LIQUIDACIÓN",
							link: "/category/cat11540985/Vestuario-Infantil-?f.product.attribute.Género=Niña&sid=MULTICATPC181593824495",
							isHighlightLink: false
						},
						{
							label: "Bebé Niña",
							link: "/category/cat8950941/Ropa-Bebe-Nina",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Niñas 2-8 años",
							link: "/category/cat8170942/Ropa-Ninas-2-8-anos"
						},
						{
							isHighlightLink: false,
							label: "Niñas 8-16 años",
							link: "/category/cat8170944/Ropa-Ninas-8-16-anos"
						},
						{
							link: "/category/cat8600964/Ropa-Deportiva-Nina",
							isHighlightLink: false,
							label: "Ropa Deportiva "
						},
						{
							isHighlightLink: false,
							link: "/category/cat8990981/Ropa-Interior-y-Pijamas-Ninas",
							label: "Ropa Interior y Pijamas "
						},
						{
							link: "/category/cat10660942/Vestidos-de-Bano?f.product.attribute.Género=Niña%3A%3AUnisex",
							meatStickerOption: 0,
							label: "Vestidos de Baño",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat10770971/Disfraces-Ninas",
							label: "Disfraces"
						},
						{
							label: "Ver todo Ropa Niñas",
							isHighlightLink: true,
							link: "/category/cat8860942/Ropa-Ninas?isPLP=1"
						}
					],
					link: "/page/Vestuario-Infantil?staticPageId=23400001",
					label: "Ropa Niñas"
				},
				{
					leafCategories: [
						{
							link: "/category/cat1091150/Travel-System",
							label: "Travel System",
							isHighlightLink: false
						},
						{
							link: "/category/cat1091146/Coches-Estandar",
							label: "Estándar",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "De Tres Ruedas",
							link: "/category/cat3011048/Coche-De-Tres-Ruedas"
						},
						{
							isHighlightLink: false,
							label: "Compactos",
							link: "/category/cat10490962/Coches-Compactos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat10490961/Coches-Gemelares",
							label: "Gemelares"
						},
						{
							link: "/category/cat1091142/Coches-Paseadores",
							isHighlightLink: false,
							label: "Paseadores"
						},
						{
							isHighlightLink: false,
							label: "Accesorios ",
							link: "/category/cat4320943/Accesorios-Coches-y-Cunas"
						},
						{
							label: "Ver todo Coches",
							link: "/category/cat5420943/Coches?isPLP=1",
							isHighlightLink: true
						}
					],
					label: "Coches",
					link: "/category/cat5420943/Coches?isLanding=true"
				},
				{
					link: "/category/cat8860941/Ropa-Ninos",
					leafCategories: [
						{
							link: "/category/cat11540985/Vestuario-Infantil-?&f.product.attribute.Género=Niño&sid=MULTICATPC181593824495",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "LIQUIDACIÓN"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8950940/Ropa-Bebe-Nino",
							label: "Bebé Niño"
						},
						{
							label: "Niños 2-8 años",
							link: "/category/cat5610954/Ropa-Ninos-2-8-anos",
							isHighlightLink: false
						},
						{
							label: "Niños 8-16 años",
							link: "/category/cat8170941/Ropa-Ninos-8-16-anos",
							isHighlightLink: false
						},
						{
							link: "/category/cat5810942/Ropa-Deportiva-Nino",
							isHighlightLink: false,
							label: "Ropa Deportiva"
						},
						{
							link: "/category/cat8990982/Ropa-Interior-y-Pijamas-Ninos",
							isHighlightLink: false,
							label: "Ropa Interior y Pijamas"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Vestidos de Baño",
							link: "/category/cat10660942/Vestidos-de-Bano?f.product.attribute.Género=Niño%3A%3AUnisex"
						},
						{
							label: "Disfraces",
							meatStickerOption: 0,
							link: "/falabella-co/category/cat10770970/Disfraces-Ninos",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo Ropa Niños",
							link: "/category/cat8860941/Ropa-Ninos?isPLP=1"
						}
					],
					label: "Ropa Niños"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Niños",
							link: "/category/cat3020988/Zapatos-Ninos"
						},
						{
							link: "/category/cat8730964/Zapatos-Ninas",
							isHighlightLink: false,
							label: "Niñas"
						},
						{
							label: "Marcas Infantiles",
							link: "/category/cat11201039/Marcas-Infantiles",
							isHighlightLink: false
						},
						{
							link: "/category/cat10070940/Zapatos-Infantiles?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Zapatos Infantiles"
						}
					],
					label: "Zapatos Infantiles",
					link: "/collection/tenis-infantiles"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Maletas",
							link: "/category/cat7500954/Maletas-para-ninos"
						},
						{
							label: "Loncheras",
							isHighlightLink: false,
							link: "/category/cat7500953/Loncheras"
						},
						{
							link: "/category/cat591075/Utiles-Escolares",
							label: "Útiles Escolares",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat6340945/Libros-Infantiles",
							label: "Libros Infantiles"
						},
						{
							isHighlightLink: true,
							link: "/category/cat591073/Escolar?isPLP=1",
							label: "Ver todo Escolar"
						}
					],
					label: "Escolar",
					link: "/category/cat591073/Escolar"
				},
				{
					label: "Dormitorio Infantil",
					link: "/category/cat2930971/Dormitorio-infantil?isLanding=true",
					leafCategories: [
						{
							label: "Ropa de Cama",
							link: "/category/cat2580950/Ropa-de-Cama-Infantil",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Cunas",
							link: "/category/cat10130966/Cunas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Camas",
							link: "/category/cat2930972/Camas-Infantiles",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Organización",
							link: "/category/cat10230950/Organizacion-Infantil"
						},
						{
							meatStickerOption: 0,
							label: "Muebles Auxiliares",
							link: "/category/cat10230949/Muebles-Auxiliares",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat11040941/Decoracion-Infantil",
							label: "Decoración Infantil"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Dormitorio Infantil",
							link: "/category/cat2930971/Dormitorio-infantil?isPLP=1?isPLP=1"
						}
					],
					verTodoActive: true
				}
			],
			link: "cat50668"
		},
		{
			subCategories: [
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat9130959/Juegos-de-Mesa",
							label: "Juegos de Mesa"
						},
						{
							isHighlightLink: false,
							label: "Muñecas y Accesorios",
							link: "/category/cat11020948/Munecas-y-Accesorios"
						},
						{
							isHighlightLink: false,
							label: "Muñecos y Figuras de Acción",
							link: "/category/cat11020950/Munecos-y-Figuras-de-Accion"
						},
						{
							label: "Carros y Radiocontrolados",
							isHighlightLink: false,
							link: "/category/cat9130960/Carros-y-Radiocontrolados"
						},
						{
							isHighlightLink: false,
							label: "Mascotas Interactivas",
							link: "/category/cat1321023/Mascotas-Interactivas"
						},
						{
							link: "/category/cat9130956/Lego-y-Armables",
							isHighlightLink: false,
							label: "Lego y Armables"
						},
						{
							link: "/category/cat9130955/Juegos-Didacticos",
							label: "Juegos Didácticos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Coleccionables",
							link: "/category/cat8901029/Coleccionables"
						},
						{
							isHighlightLink: false,
							label: "Pistas de Carros",
							link: "/category/cat11010953/Pistas-de-Carros"
						},
						{
							isHighlightLink: false,
							link: "/category/cat9130957/Peluches",
							label: "Peluches"
						},
						{
							link: "/category/cat9130958/Juguetes-de-Bebe",
							isHighlightLink: false,
							label: "Juguetes de Bebé"
						},
						{
							label: "Juegos de Rol",
							isHighlightLink: false,
							link: "/category/cat12591023/Juegos-de-Rol",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Lanzadores",
							link: "/category/cat4330980/Lanzadores"
						},
						{
							link: "/category/cat9130954/Munecas-y-Munecos",
							isHighlightLink: false,
							label: "Muñecas y Muñecos"
						},
						{
							link: "/category/cat4101180/Juguetes?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Juguetes"
						}
					],
					label: "Juguetes",
					link: "/page/Juguetes?staticPageId=24200001"
				},
				{
					label: "Carros a Batería y Go Karts",
					leafCategories: [
						{
							label: "Carros Eléctricos",
							isHighlightLink: false,
							link: "/category/cat9130967/Carros-Electricos"
						},
						{
							label: "Triciclos y Correpasillos",
							link: "/category/cat1091156/Triciclos",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							link: "/category/cat960965/Carros-a-Bateria-y-Go-Karts?isPLP=1",
							label: "Ver todo Carros a Batería y Go Karts"
						}
					],
					link: "/category/cat960965/Carros-a-Bateria-y-Go-Karts"
				},
				{
					label: "Deportes y Aire Libre",
					link: "/category/cat10770948/Deportes-y-Aire-Libre",
					leafCategories: [
						{
							link: "/category/cat271051/Bicicletas-Infantiles",
							label: "Bicicletas Infantiles",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat561041/Patines,-Patinetas-y-Scooters",
							label: "Patines, Patinetas y Scooters"
						},
						{
							label: "Juegos y Deportes Infantiles",
							isHighlightLink: false,
							link: "/category/cat8610940/Juegos-y-Deportes-Infantiles"
						},
						{
							label: "Ver todo Deportes y Aire Libre",
							link: "/category/cat10770948/Deportes-y-Aire-Libre?isPLP=1",
							isHighlightLink: true
						}
					]
				},
				{
					label: "Juegos de Exterior",
					link: "/category/cat9130961/Juegos-de-Exterior",
					leafCategories: [
						{
							label: "Juegos de Jardín",
							isHighlightLink: false,
							link: "/category/cat9130962/Juegos-de-Jardin"
						},
						{
							link: "/category/cat670983/Carpas",
							label: "Carpas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat9130964/Juegos-Deportivos",
							label: "Juegos Deportivos"
						},
						{
							isHighlightLink: false,
							label: "Skates y Scooters",
							link: "/category/cat9130965/Skates-y-Scooters"
						},
						{
							isHighlightLink: false,
							label: "Carros a Batería y Go Karts",
							link: "/category/cat960965/Carros-a-Bateria-y-Go-Karts"
						},
						{
							link: "/category/cat2920955/Drones",
							label: "Drones",
							isHighlightLink: false
						},
						{
							label: "Trampolines e Inflables",
							link: "/category/cat2920957/Trampolines-e-Inflables",
							isHighlightLink: false
						},
						{
							label: "Casas y Juegos para el Jardín",
							link: "/category/cat1031781/Casas-y-Juegos-para-el-Jardin",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Inflables y Piscina",
							link: "/category/cat10650976/Inflables-y-Piscina"
						},
						{
							label: "Juegos y Deportes Infantiles",
							link: "/category/cat8610940/Juegos-y-Deportes-Infantiles",
							isHighlightLink: false
						},
						{
							link: "/category/cat3980982/Piscinas-y-Juegos-de-Agua",
							isHighlightLink: false,
							label: "Piscinas y Juegos de Agua"
						},
						{
							label: "Ver todo Juegos de Exterior",
							link: "/category/cat9130961/Juegos-de-Exterior?isPLP=1",
							isHighlightLink: true
						}
					]
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/falabella-co/category/cat10770971/Disfraces-Ninas",
							label: "Disfraces Niñas"
						},
						{
							label: "Disfraces Niños",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat10770970/Disfraces-Ninos"
						},
						{
							label: "Disfraces adulto",
							link: "/category/cat10770973/Disfraces-Adultos",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Disfraces Mascotas",
							link: "/category/cat10770972/Disfraces-Mascotas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Disfraces Animalitos",
							link: "/category/cat10781017/Disfraces-Animalitos",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Princesas y Superhéroes",
							link: "/category/cat10781018/Princesas-y-Superheroes"
						},
						{
							link: "/category/cat1220969/Disfraces",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ver todo Disfraces"
						}
					],
					label: "Disfraces",
					link: "/page/halloween-falabella?staticPageId=18400002?sred=halloween"
				},
				{
					link: "/category/cat7530989/Jugueteria-Mattel",
					label: "Tiendas Oficiales",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/page/boing-toys?staticPageId=28100001",
							meatStickerOption: 0,
							label: "Boing Toys"
						},
						{
							label: "Mattel",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/page/Mattel?staticPageId=28000003?v=1q"
						},
						{
							meatStickerOption: 0,
							link: "/page/Hasbro?staticPageId=26300002",
							label: "Hasbro",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/page/Pixar-?staticPageId=25700001?sred=disney",
							meatStickerOption: 0,
							label: "Disney"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Marvel",
							link: "/page/Encuentra%20tu%20poder?staticPageId=24100007"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/page/Distroller-lanzamiento?staticPageId=23100002&sred=ksimeritos",
							label: "Distroller"
						},
						{
							label: "Lego",
							link: "/page/Lego?staticPageId=23800001",
							isHighlightLink: false,
							meatStickerOption: 0
						}
					],
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat1251018/Consolas-de-Videojuegos",
							label: "Consolas de Videojuegos"
						},
						{
							link: "/category/cat2930986/Videojuegos",
							label: "Videojuegos",
							isHighlightLink: false
						},
						{
							label: "Playstation",
							link: "/category/cat10431002/Playstation",
							isHighlightLink: false
						},
						{
							label: "Xbox",
							isHighlightLink: false,
							link: "/category/cat2540956/Xbox"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2540955/Nintendo",
							label: "Nintendo"
						},
						{
							label: "Accesorios Videojuegos ",
							link: "/category/cat3000998/Accesorios-Videojuegos",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							link: "/category/cat50590/Gaming?isPLP=1",
							label: "Ver todo Gaming"
						}
					],
					link: "/category/cat50590/Gaming",
					label: "Gaming"
				}
			],
			link: "cat10770947",
			label: "Juguetería"
		},
		{
			label: "Crate&Barrel",
			link: "cat10890942",
			subCategories: [
				{
					link: "/category/cat6400952/Crate-Barrel?isLanding=true",
					leafCategories: [
						{
							link: "/category/cat7010950/Muebles-Crate-and-Barrel",
							label: "Muebles",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Muebles de terraza",
							link: "/category/cat7770942/Terraza-Crate-and-Barrel"
						},
						{
							link: "/category/cat6990949/Comedor-Bar-Crate-and-Barrel",
							label: "Comedor",
							isHighlightLink: false
						},
						{
							label: "Bar",
							isHighlightLink: false,
							link: "/category/cat12220954/Bar-Crate-and-Barrel",
							meatStickerOption: 0
						},
						{
							label: "Cocina",
							isHighlightLink: false,
							link: "/category/cat6930951/Cocina-Crate-and-Barrel"
						},
						{
							label: "Decoración",
							isHighlightLink: false,
							link: "/category/cat6930958/Decoracion-Crate-and-Barrel"
						},
						{
							label: "Baño",
							link: "/category/cat7060941/Bano-Crate-and-Barrel",
							isHighlightLink: false
						},
						{
							link: "/category/cat13231097/Promociones-Crate-and-Barrel-?page=1",
							label: "Promociones SALE",
							isHighlightLink: false
						},
						{
							label: "Ver todo Crate&Barrel",
							link: "/category/cat6400952/Crate-Barrel?isPLP=1",
							isHighlightLink: true
						}
					],
					label: "Crate&Barrel"
				},
				{
					label: "Muebles",
					leafCategories: [
						{
							link: "/category/cat6710945/Sofas-Poltronas-Crate-and-Barrel",
							isHighlightLink: false,
							label: "Sofás y poltronas"
						},
						{
							label: "Muebles de comedor",
							link: "/category/cat6710956/Muebles-de-Comedor-Crate-and-Barrel",
							isHighlightLink: false
						},
						{
							link: "/category/cat6710948/Consolas---Mesas-de-Centro",
							isHighlightLink: false,
							label: "Mesas de centro y auxiliares"
						},
						{
							label: "Muebles de bar",
							link: "/category/cat6710954/Muebles-de-Bar-Crate-and-Barrel",
							isHighlightLink: false
						},
						{
							label: "Bibliotecas y estantes",
							isHighlightLink: false,
							link: "/category/cat6710975/Bibliotecas-TV-Crate-and-Barrel"
						},
						{
							label: "Ver todo Muebles",
							isHighlightLink: true,
							link: "/category/cat7010950/Muebles-Crate-and-Barrel?isPLP=1"
						}
					],
					link: "/category/cat7010950/Muebles-Crate-and-Barrel"
				},
				{
					label: "Muebles de terraza",
					link: "/category/cat7770942/Terraza-Crate-and-Barrel",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Comedor de terraza",
							link: "/category/cat6710977/Muebles-de-Comedor-Crate-and-Barrel"
						},
						{
							label: "Sala de terraza",
							isHighlightLink: false,
							link: "/category/cat6710978/Muebles-de-Sala-Crate-and-Barrel"
						},
						{
							label: "Accesorios de terraza",
							link: "/category/cat8070961/Accesorios-de-Terraza-Crate-and-Barrel",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo Terraza",
							link: "/category/cat7770942/Terraza-Crate-and-Barrel?isPLP=1"
						}
					]
				},
				{
					link: "/page/Crate&Barrel-Bares?staticPageId=27600002",
					verTodoActive: true,
					label: "Bar",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Vasos",
							link: "/category/cat8670994/Vasos-Crate-and-Barrel"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat8670991/Copas-Crate-and-Barrel",
							label: "Copas "
						},
						{
							isHighlightLink: false,
							link: "/category/cat8681030/Accesorios-de-Bar-Coctel-Crate-and-Barrel",
							label: "Accesorios de bar y coctel",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat6710954/Muebles-de-Bar-Crate-and-Barrel",
							label: "Muebles de bar"
						},
						{
							isHighlightLink: true,
							link: "/category/cat12220954/Bar-Crate-and-Barrel",
							label: "Ver todo Bar"
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Vajillas",
							link: "/category/cat6990950/Vajillas-Crate-and-Barrel",
							isHighlightLink: false
						},
						{
							label: "Vasos y jarras",
							link: "/category/cat12370940/Vasos-Jarras-Crate-and-Barrel",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Cubiertos y piezas de servir",
							link: "/category/cat6990951/Cubiertos-Crate-and-Barrel"
						},
						{
							isHighlightLink: false,
							link: "/category/cat6930956/Cafe-Te-Crate-and-Barrel",
							label: "Café y té",
							meatStickerOption: 0
						},
						{
							label: "Accesorios para servir",
							link: "/category/cat6990953/Piezas-de-Servir-Crate-and-Barrel",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat6990954/Manteleria-Crate-and-Barrel",
							label: "Mantelería"
						},
						{
							label: "Ver todo Comedor",
							link: "/category/cat6990949/Comedor-Bar-Crate-and-Barrel?isPLP=1",
							isHighlightLink: true
						}
					],
					label: "Comedor",
					link: "/category/cat6990949/Comedor-Bar-Crate-and-Barrel"
				},
				{
					label: "Cocina",
					link: "/category/cat6930951/Cocina-Crate-and-Barrel",
					leafCategories: [
						{
							label: "Utensilios y gadgets",
							link: "/category/cat10440943/Utensilios-para-cocinar-Crate-and-Barrel",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat10440942/Reposteria-Crate-and-Barrel",
							label: "Repostería"
						},
						{
							isHighlightLink: false,
							label: "Contenedores y organización",
							link: "/category/cat10431035/Contenedores-Crate-and-Barrel"
						},
						{
							isHighlightLink: false,
							label: "Paños de Cocina",
							link: "/category/cat6930955/Panos-de-Cocina-Crate-and-Barrel"
						},
						{
							isHighlightLink: true,
							link: "/category/cat6930951/Cocina-Crate-and-Barrel?isPLP=1",
							label: "Ver todo Cocina"
						}
					]
				},
				{
					label: "Decoración",
					link: "/category/cat6930958/Decoracion-Crate-and-Barrel",
					leafCategories: [
						{
							label: "Floreros",
							isHighlightLink: false,
							link: "/category/cat6930960/Floreros-Crate-and-Barrel"
						},
						{
							link: "/category/cat8450952/Materas-Crate-and-Barrel",
							label: "Materas y plantas",
							isHighlightLink: false
						},
						{
							label: "Cojines y mantas",
							isHighlightLink: false,
							link: "/category/cat6930959/Cojines-Mantas-Crate-and-Barrel"
						},
						{
							link: "/category/cat8680964/Candelabros-Velas-Crate-and-Barrel",
							isHighlightLink: false,
							label: "Candelabros y velas",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat6930962/Canastos-Adornos-Crate-and-Barrel",
							label: "Canastos y adornos"
						},
						{
							isHighlightLink: false,
							label: "Espejos y arte de pared",
							link: "/category/cat6930961/Espejos-Cuadros-Crate-and-Barrel"
						},
						{
							isHighlightLink: false,
							label: "Alfombras",
							link: "/category/cat7500943/Alfombras-Crate-and-Barrel"
						},
						{
							link: "/category/cat6930958/Decoracion-Crate-and-Barrel?isPLP=1",
							label: "Ver todo Decoración",
							isHighlightLink: true
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Toallas y tapetes",
							link: "/category/cat7060942/Toallas-Tapetes-Crate-and-Barrel",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat10431036/Accesorios-de-bano-Crate-and-Barrel",
							label: "Accesorios de baño"
						},
						{
							label: "Ver todo Baño",
							link: "/category/cat7060941/Bano-Crate-and-Barrel?isPLP=1",
							isHighlightLink: true
						}
					],
					label: "Baño",
					link: "/category/cat7060941/Bano-Crate-and-Barrel"
				}
			]
		},
		{
			label: "Otras Categorías",
			subCategories: [
				{
					leafCategories: [
						{
							label: "Afeitadoras Hombre",
							link: "/category/cat50723/Afeitadoras-Hombre",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat50485/Planchas-de-Pelo",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Planchas de Pelo"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat50835/Secadores-de-Pelo",
							isHighlightLink: false,
							label: "Secadores de Pelo"
						},
						{
							label: "Depilación",
							link: "/category/cat50608/Depilacion",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Onduladores de Pelo",
							link: "/category/cat50767/Onduladores-de-Pelo"
						},
						{
							link: "/category/cat10651017/Cepillos",
							isHighlightLink: false,
							label: "Cepillos",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Salud",
							link: "/category/cat10440978/Salud"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Accesorios Corporales",
							link: "/category/cat350945/Accesorios-Corporales"
						},
						{
							label: "Aseo Personal",
							isHighlightLink: false,
							link: "/category/cat7580956/Aseo-Personal",
							meatStickerOption: 0
						},
						{
							label: "Ver todo Cuidado Personal",
							isHighlightLink: true,
							link: "/category/cat8231006/Cuidado-Personal"
						}
					],
					link: "/category/cat8231006/Cuidado-Personal",
					verTodoActive: true,
					label: "Cuidado Personal"
				},
				{
					link: "/category/cat10490958/Musica",
					leafCategories: [
						{
							link: "/category/cat10800949/CD's",
							label: "CD's",
							isHighlightLink: false
						},
						{
							link: "/category/cat10800951/DVD's",
							isHighlightLink: false,
							label: "DVD's"
						},
						{
							link: "/category/cat10800950/Vinilos",
							isHighlightLink: false,
							label: "Vinilos"
						},
						{
							link: "/category/cat10490958/Musica?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Música"
						}
					],
					label: "Música"
				},
				{
					link: "/category/cat591073/Escolar",
					label: "Escolar",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Utiles Escolares",
							link: "/falabella-co/category/cat591075/Utiles-Escolares"
						},
						{
							label: "Maletas",
							link: "/category/cat7500954/Maletas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/falabella-co/category/cat7500953/Loncheras",
							label: "Loncheras",
							meatStickerOption: 0
						},
						{
							link: "/falabella-co/category/cat6340945/Libros-Infantiles",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Libros Infantiles"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ver todo Escolar",
							link: "/category/cat591073/Escolar?isPLP=1"
						}
					]
				},
				{
					label: "Instrumentos musicales",
					link: "/category/cat6270994/Instrumentos-musicales?isLanding=true",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Acordeones",
							link: "/category/cat6870967/Acordeones"
						},
						{
							link: "/category/cat6270998/Teclados",
							isHighlightLink: false,
							label: "Teclados"
						},
						{
							link: "/category/cat6270995/Instrumentos-de-cuerda",
							isHighlightLink: false,
							label: "Instrumentos de cuerda"
						},
						{
							isHighlightLink: false,
							label: "Instrumentos de viento",
							link: "/category/cat6270997/Instrumentos-de-viento"
						},
						{
							label: "Accesorios musicales",
							isHighlightLink: false,
							link: "/category/cat6270999/Accesorios-musicales"
						},
						{
							link: "/category/cat6270994/Instrumentos-musicales",
							label: "Ver todo Instrumentos musicales",
							isHighlightLink: true
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Maletas de Cabina",
							isHighlightLink: false,
							link: "/category/cat11261016/Maletas-de-Cabina"
						},
						{
							link: "/category/cat11261023/Maletas-Medianas",
							isHighlightLink: false,
							label: "Maletas Medianas"
						},
						{
							link: "/category/cat11261028/Maletas-Grandes",
							isHighlightLink: false,
							label: "Maletas Grandes"
						},
						{
							link: "/category/cat11261030/Sets-de-Maletas",
							isHighlightLink: false,
							label: "Sets de Maletas"
						},
						{
							link: "/category/cat670989/Backpacks-y-Mochilas",
							isHighlightLink: false,
							label: "Backpacks y Mochilas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7930945/Accesorios-de-Viaje",
							label: "Accesorios de Viaje"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Maletas de Viaje",
							link: "/category/cat10650948/Maletas-de-Viaje?isPLP=1"
						}
					],
					link: "/category/cat10650948/Maletas-de-Viaje",
					label: "Maletas de Viaje"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat8220951/Scooters-Electricos",
							label: "Scooters Eléctricos"
						},
						{
							isHighlightLink: false,
							label: "Bicicletas Eléctricas",
							link: "/category/cat701459/Bicicletas-Electricas"
						},
						{
							label: "Otro Vehículos y Accesorios",
							isHighlightLink: false,
							link: "/category/cat10760947/Otro-Vehiculos-y-Accesorios"
						},
						{
							label: "Ver todo Movilidad",
							link: "/category/cat10780976/Movilidad?isPLP=1",
							isHighlightLink: true
						}
					],
					label: "Movilidad",
					link: "/category/cat10780976/Movilidad"
				},
				{
					label: "Gourmet",
					leafCategories: [
						{
							link: "/category/cat10781024/Comida",
							isHighlightLink: false,
							label: "Alimentos"
						},
						{
							label: "Licores",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat11020949/Licores"
						},
						{
							isHighlightLink: true,
							link: "/category/cat10781023/Gourmet?isPLP=1",
							label: "Ver todo Gourmet"
						}
					],
					link: "/category/cat10781023/Gourmet"
				},
				{
					label: "Libros",
					leafCategories: [
						{
							link: "/falabella-co/collection/j18-novedades",
							isHighlightLink: false,
							label: "Novedades NUEVO"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat8440961/Arte-&-Fotografía",
							label: "Arte y fotografía"
						},
						{
							label: "Autoayuda y bienestar",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat11570956/Autoayuda"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8410940/Libros--de--Cocina",
							label: "Cocina"
						},
						{
							meatStickerOption: 0,
							label: "Erótico y sexualidad ",
							link: "/category/cat11570976/Erotico",
							isHighlightLink: false
						},
						{
							label: "Historia y política",
							isHighlightLink: false,
							link: "/category/cat8440970/Historia-Politica"
						},
						{
							link: "/category/cat8440972/Juvenil",
							isHighlightLink: false,
							label: "Juvenil y comics "
						},
						{
							link: "/category/cat8440974/Libros-Infantiles",
							label: "Libros infantiles ",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Libros para colorear",
							isHighlightLink: false,
							link: "/category/cat13330956/Libros--para--colorear-?page=1"
						},
						{
							label: "Negocios y estrategia ",
							isHighlightLink: false,
							link: "/category/cat8440962/Negocios-Estrategia"
						},
						{
							label: "Novelas y literatura",
							isHighlightLink: false,
							link: "/category/cat8440969/Novelas"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Libros",
							link: "/category/cat8010964/Libros?isPLP=1"
						}
					],
					link: "/category/cat8010964/Libros?isLanding=true"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat8911019/Juguetes-y-Entrenamiento",
							meatStickerOption: 0,
							label: "Juguetes y Entrenamiento"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Comederos y Bebederos",
							link: "/category/cat11610941/Comederos-y-Bebederos"
						},
						{
							link: "/category/cat6890975/Mundo-mascotas?facetSelected=true&f.product.attribute.Tipo_de_mascota=Perros&isPLP=1",
							isHighlightLink: false,
							label: "Perros"
						},
						{
							label: "Gatos",
							link: "/category/cat6890975/Mundo-mascotas?facetSelected=true&f.product.attribute.Tipo_de_mascota=Gatos&facetSelected=true&isPLP=1",
							isHighlightLink: false
						},
						{
							label: "Alimentos y Snacks",
							isHighlightLink: false,
							link: "/category/cat8911017/Alimentos-y-Snacks"
						},
						{
							isHighlightLink: false,
							label: "Casas y camas",
							link: "/category/cat8911018/Casas-y-camas"
						},
						{
							label: "Ropa y accesorios",
							link: "/category/cat6890976/Ropa-y-accesorios",
							isHighlightLink: false
						},
						{
							label: "Higiene y Cuidados",
							isHighlightLink: false,
							link: "/category/cat6890977/Higiene-y-Cuidados"
						},
						{
							link: "/category/cat6890975/Mundo-mascotas?isPLP=1",
							isHighlightLink: true,
							label: "Ver todo Mundo mascotas"
						}
					],
					link: "/category/cat6890975/Mundo-mascotas?isLanding=true",
					label: "Mundo mascotas"
				}
			],
			link: "cat10490957"
		}
	]
};
var taxonomyV1CO = {
	state: state$2
};

var state$3 = {
	rootCategories: [
		{
			bannerLocation: "urlToImage",
			label: "Compra hoy Recibe hoy",
			subCategories: [
				{
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/collection/blusas-mujer-delivery-express",
							label: "Blusas",
							isHighlightLink: false
						},
						{
							link: "/collection/chompas-mujer-delivery-express",
							meatStickerOption: 0,
							label: "Chompas",
							isHighlightLink: false
						},
						{
							link: "/collection/casacas-mujer-delivery-express",
							meatStickerOption: 0,
							label: "Casacas",
							isHighlightLink: false
						},
						{
							label: "Jeans",
							meatStickerOption: 0,
							link: "/collection/jeans-mujer-delivery-express",
							isHighlightLink: false
						},
						{
							link: "/collection/polos-mujer-delivery-express",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Polos"
						},
						{
							link: "/collection/poleras-mujer-delivery-express",
							meatStickerOption: 0,
							label: "Poleras",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo Moda Mujer ",
							link: "/collection/recibe-hoy-vestuario-mujer"
						}
					],
					link: "/collection/recibe-hoy-vestuario-mujer",
					label: "Moda Mujer "
				},
				{
					link: "/collection/recibe-hoy-vestuario-hombre",
					leafCategories: [
						{
							label: "Chompas",
							link: "/collection/vestuario-hombre-chompas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Casacas",
							link: "/collection/vestuario-hombre-casacas",
							isHighlightLink: false
						},
						{
							link: "/collection/vestuario-hombre-joggers",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Joggers"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/vestuario-hombre-jeans",
							label: "Jeans"
						},
						{
							label: "Polos",
							link: "/collection/vestuario-hombre-polos",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/collection/vestuario-hombre-pijamas",
							meatStickerOption: 0,
							label: "Pijamas"
						},
						{
							meatStickerOption: 0,
							link: "/collection/vestuario-hombre-accesorios",
							label: "Accesorios",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							link: "/collection/recibe-hoy-vestuario-hombre",
							label: "Ver todo Moda Hombre"
						}
					],
					label: "Moda Hombre",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/collection/zapatos-mujer-recibe-hoy",
							isHighlightLink: false,
							label: "Calzado Mujer"
						},
						{
							link: "/collection/zapatos-hombre-recibe-hoy",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Calzado Hombre"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Calzado Infantil",
							link: "/collection/zapatos-ninos-recibe-hoy"
						},
						{
							isHighlightLink: true,
							link: "/collection/recibe-hoy-calzado",
							label: "Ver todo Calzado"
						}
					],
					label: "Calzado",
					link: "/collection/recibe-hoy-calzado"
				},
				{
					link: "/collection/recibe-hoy-deportes",
					leafCategories: [
						{
							link: "/collection/recibe-hoy-vestuario-deportivo-mujer",
							label: "Vestuario Deportivo Mujer",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Vestuario Deportivo Hombre",
							isHighlightLink: false,
							link: "/collection/recibe-hoy-vestuario-deportivo-hombre"
						},
						{
							link: "/collection/recibe-hoy-accesorios-deportivos",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Accesorios Deportivos"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Deportes",
							link: "/collection/recibe-hoy-deportes"
						}
					],
					verTodoActive: true,
					label: "Deportes"
				},
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Dermocosmética",
							isHighlightLink: false,
							link: "/collection/recibe-hoy-dermocosmetica"
						},
						{
							link: "/collection/recibe-hoy-capilar",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Capilar"
						},
						{
							isHighlightLink: false,
							link: "/collection/recibe-hoy-fragancias",
							meatStickerOption: 0,
							label: "Fragancias"
						},
						{
							meatStickerOption: 0,
							label: "Maquillaje",
							isHighlightLink: false,
							link: "/collection/recibe-hoy-maquillaje"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Tratamiento",
							link: "/collection/recibe-hoy-tratamiento"
						},
						{
							isHighlightLink: true,
							link: "/collection/recibe-hoy-belleza",
							label: "Ver todo Belleza"
						}
					],
					label: "Belleza",
					link: "/collection/recibe-hoy-belleza",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Vestuario Bebé",
							link: "/collection/recibe-hoy-vestuario-ninos-0-a-2",
							isHighlightLink: false
						},
						{
							link: "/collection/recibe-hoy-vestuario-ninos-2-a-8",
							meatStickerOption: 0,
							label: "Vestuario de 2 a 8",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Vestuario de 8 a 16 años",
							link: "/collection/recibe-hoy-vestuario-ninos-8-a-16"
						},
						{
							isHighlightLink: false,
							link: "/collection/recibe-hoy-pijamas-y-ropa-interior-ninos",
							label: "Pijamas y Ropa Interior",
							meatStickerOption: 0
						},
						{
							label: "Juguetería",
							meatStickerOption: 0,
							link: "/collection/recibe-hoy-juguetes",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							link: "/collection/recibe-hoy-infantil",
							label: "Ver todo Niños"
						}
					],
					label: "Niños",
					link: "/collection/recibe-hoy-infantil"
				},
				{
					verTodoActive: true,
					link: "/collection/recibe-hoy-deco",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/ropa-de-cama",
							label: "Ropa de Cama"
						},
						{
							link: "/collection/toallas",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Toallas"
						},
						{
							isHighlightLink: false,
							label: "Menaje Cocina",
							meatStickerOption: 0,
							link: "/collection/menaje-cocina"
						},
						{
							isHighlightLink: false,
							label: "Comedor",
							meatStickerOption: 0,
							link: "/collection/menaje-comedor"
						},
						{
							isHighlightLink: false,
							label: "Adornos",
							link: "/collection/decoracion-adornos",
							meatStickerOption: 0
						},
						{
							link: "/collection/regalables",
							meatStickerOption: 0,
							label: "Regalables",
							isHighlightLink: false
						},
						{
							link: "/collection/recibe-hoy-deco",
							label: "Ver todo Decoración",
							isHighlightLink: true
						}
					],
					label: "Decoración"
				}
			],
			link: "/collection/compra-hoy-recibe-hoy"
		},
		{
			label: "Tecnología",
			link: "cat40793",
			subCategories: [
				{
					leafCategories: [
						{
							label: "LED",
							link: "/category/cat6370551/Televisores-LED",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "OLED",
							link: "/category/cat6370553/Televisores-OLED"
						},
						{
							isHighlightLink: false,
							label: "QLED",
							link: "/category/cat7390472/Televisores-QLED"
						},
						{
							link: "/category/cat12930461/Televisores-NANOCELL",
							isHighlightLink: false,
							label: "NANOCELL"
						},
						{
							label: "Blu Ray Y DVD",
							link: "/category/cat210484/Blu-Ray-Y-DVD",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Streaming",
							link: "/category/cat11190475/Streaming"
						},
						{
							isHighlightLink: false,
							label: "Soundbars y Home Theaters",
							link: "/category/cat40622/Soundbars-y-Home-Theaters"
						},
						{
							isHighlightLink: false,
							label: "Racks",
							link: "/category/cat1450520/Racks"
						},
						{
							link: "/category/cat780520/Accesorios-TV",
							label: "Accesorios TV",
							isHighlightLink: false
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat210477/TV-Televisores"
						}
					],
					link: "/category/cat210477/TV-Televisores",
					label: "Televisores"
				},
				{
					leafCategories: [
						{
							link: "/category/cat760706/Celulares-y-Smartphones",
							isHighlightLink: false,
							label: "Celulares y Smartphones"
						},
						{
							isHighlightLink: false,
							label: "Smartwatch",
							link: "/category/cat1830468/Smartwatch"
						},
						{
							link: "/category/cat800582/Audifonos",
							label: "Audífonos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat800590/Cargadores-y-Cables",
							label: "Cargadores y Cables"
						},
						{
							isHighlightLink: false,
							label: "Baterías Externas",
							link: "/category/cat12950480/Baterias-Externas"
						},
						{
							link: "/category/cat760724/Carcasas-y-Laminas",
							isHighlightLink: false,
							label: "Carcasas y Láminas"
						},
						{
							label: "Parlantes",
							link: "/category/cat800584/Parlantes",
							isHighlightLink: false
						},
						{
							link: "/category/cat12030503/Tarjetas-de-Memoria",
							isHighlightLink: false,
							label: "Tarjetas de Memoria"
						},
						{
							isHighlightLink: false,
							label: "Accesorios Celulares",
							link: "/category/cat12020463/Accesorios-Celulares"
						},
						{
							label: "Ver todo",
							link: "/category/cat760702/Telefonos",
							isHighlightLink: true
						}
					],
					link: "/category/cat760702/Telefonos",
					label: "Teléfonos"
				},
				{
					leafCategories: [
						{
							label: "Laptops",
							link: "/category/cat40712/Laptops",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Laptops Gamer",
							link: "/category/cat6370538/Laptops-Gamer"
						},
						{
							label: "Laptops 2en1",
							isHighlightLink: false,
							link: "/category/cat3150461/Laptops-2en1"
						},
						{
							label: "Tablets",
							isHighlightLink: false,
							link: "/category/cat270476/Tablets"
						},
						{
							label: "Impresoras y Multifuncionales",
							link: "/category/cat3180533/Impresoras-y-Multifuncionales",
							isHighlightLink: false
						},
						{
							label: "Computadoras de Escritorio",
							link: "/category/cat1590484/All-In-One",
							isHighlightLink: false
						},
						{
							link: "/category/cat40695/Monitores",
							isHighlightLink: false,
							label: "Monitores"
						},
						{
							link: "/category/cat40480/Almacenamiento",
							isHighlightLink: false,
							label: "Almacenamiento"
						},
						{
							isHighlightLink: false,
							link: "/category/cat40509/Accesorios-Computacion",
							label: "Accesorios Computación"
						},
						{
							isHighlightLink: false,
							label: "Mundo Intel",
							link: "/page/Intel?tab=homepage&staticPageId=22200004",
							meatStickerOption: 0
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat50678/Computadoras"
						}
					],
					label: "Computadoras",
					link: "/category/cat50678/Computadoras?isPLP=1"
				},
				{
					link: "/category/cat40556/Videojuegos?isLanding=false",
					leafCategories: [
						{
							label: "Consolas",
							isHighlightLink: false,
							link: "/category/cat6370546/Consolas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1590516/PS4",
							label: "PS4"
						},
						{
							link: "/category/cat780466/Nintendo-Switch",
							label: "Nintendo Switch",
							isHighlightLink: false
						},
						{
							link: "/category/cat100466/Juegos",
							isHighlightLink: false,
							label: "Juegos"
						},
						{
							label: "Accesorios Videojuegos",
							link: "/category/cat100468/Accesorios-Videojuegos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Mandos",
							link: "/category/cat13340477/Mandos"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat40556/Videojuegos"
						}
					],
					label: "Videojuegos"
				},
				{
					link: "/category/cat11190471/Domotica-y-Smart-home",
					label: "Domótica y Smart home",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Asistente de Voz",
							link: "/category/cat12940611/Asistente-de-Voz"
						},
						{
							isHighlightLink: false,
							link: "/category/cat11190474/Routers-y-Conexion-Inalambrica",
							label: "Routers y Conexión Inalámbrica"
						},
						{
							link: "/category/cat13900478/Seguridad-Inteligente",
							isHighlightLink: false,
							label: "Seguridad Inteligente"
						},
						{
							label: "Iluminación Inteligente",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat12940612/Iluminacion-Inteligente"
						},
						{
							label: "Enchufes Inteligentes",
							isHighlightLink: false,
							link: "/category/cat13900483/Enchufes-Inteligentes"
						},
						{
							link: "/category/cat12820462/Aspiradoras-Robot",
							isHighlightLink: false,
							label: "Aspiradoras Robot"
						},
						{
							label: "Streaming",
							isHighlightLink: false,
							link: "/category/cat11190475/Streaming"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13570474/Mundo-Xiaomi",
							label: "Mundo Xiaomi"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13900484/Nuevo-en-Smart-Home",
							label: "Nuevo en Smart Home"
						},
						{
							link: "/category/cat11190471/Domotica-y-Smart-home",
							isHighlightLink: true,
							label: "Ver todo"
						}
					]
				},
				{
					label: "Audio",
					leafCategories: [
						{
							link: "/category/cat40464/Accesorios-Audio",
							label: "Accesorios Audio",
							isHighlightLink: false
						},
						{
							label: "Audífonos",
							link: "/category/cat800582/Audifonos",
							isHighlightLink: false
						},
						{
							label: "Audio Profesional",
							link: "/category/cat6370522/Audio-Profesional",
							isHighlightLink: false
						},
						{
							link: "/category/cat6370523/Autoradios",
							isHighlightLink: false,
							label: "Autoradios"
						},
						{
							isHighlightLink: false,
							label: "Equipos de Sonido",
							link: "/category/cat40590/Equipos-de-Sonido"
						},
						{
							isHighlightLink: false,
							label: "Karaoke",
							link: "/category/cat12940614/Karaoke"
						},
						{
							link: "/category/cat40630/Instrumentos-Musicales",
							isHighlightLink: false,
							label: "Instrumentos Musicales"
						},
						{
							link: "/category/cat800584/Parlantes",
							isHighlightLink: false,
							label: "Parlantes"
						},
						{
							isHighlightLink: false,
							label: "Soundbars y Home Theaters",
							link: "/category/cat40622/Soundbars-y-Home-Theaters"
						},
						{
							link: "/category/cat6370524/Torre-One-Box",
							isHighlightLink: false,
							label: "Torre One Box"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat40488/Audio"
						}
					],
					link: "/category/cat40488/Audio?isLanding=false"
				},
				{
					leafCategories: [
						{
							link: "/category/cat6370529/Camaras-Semiprofesionales",
							label: "Cámaras Semiprofesionales",
							isHighlightLink: false
						},
						{
							label: "Cámaras Instantaneas y Retro",
							link: "/category/cat6370534/Camaras-Instantaneas-y-Retro",
							isHighlightLink: false
						},
						{
							label: "Drones",
							link: "/category/cat2060478/Drones",
							isHighlightLink: false
						},
						{
							label: "Cámaras Compactas",
							link: "/category/cat40605/Camaras-Compactas",
							isHighlightLink: false
						},
						{
							link: "/category/cat270470/Camaras-de-Video",
							isHighlightLink: false,
							label: "Cámaras de Video"
						},
						{
							label: "Accesorios de Fotografía",
							link: "/category/cat830490/Accesorios-de-Fotografia",
							isHighlightLink: false
						},
						{
							link: "/category/cat12030503/Tarjetas-de-Memoria",
							isHighlightLink: false,
							label: "Tarjetas de Memoria"
						},
						{
							label: "Ver todo",
							link: "/category/cat40812/Fotografia",
							isHighlightLink: true
						}
					],
					label: "Fotografía",
					link: "/category/cat40812/Fotografia"
				},
				{
					link: "/category/cat13820487/PC-Gaming",
					label: "PC Gaming",
					leafCategories: [
						{
							link: "/category/cat6370538/Laptops-Gamer",
							isHighlightLink: false,
							label: "Laptops Gamer"
						},
						{
							label: "Monitores",
							link: "/category/cat40695/Monitores",
							isHighlightLink: false
						},
						{
							label: "Audífonos Gamer",
							isHighlightLink: false,
							link: "/category/cat12940610/Audifonos-Gamer"
						},
						{
							link: "/category/cat13820485/Componentes",
							isHighlightLink: false,
							label: "Componentes"
						},
						{
							link: "/category/cat13820484/Coolers",
							label: "Coolers",
							isHighlightLink: false
						},
						{
							link: "/category/cat13820482/Mouse-y-Mousepad-gamer",
							isHighlightLink: false,
							label: "Mouse y Mousepad gamer"
						},
						{
							label: "Otros accesorios PC Gamer",
							isHighlightLink: false,
							link: "/category/cat13000461/Otros-accesorios-PC-Gamer"
						},
						{
							label: "Sillas Gamer",
							link: "/category/cat13820483/Sillas-Gamer",
							isHighlightLink: false
						},
						{
							label: "Teclados Gamer",
							isHighlightLink: false,
							link: "/category/cat13820481/Teclados-Gamer"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13820486/Torres-y-Cases",
							label: "Torres y Cases"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat13820487/PC-Gaming"
						}
					]
				}
			]
		},
		{
			link: "cat40584",
			subCategories: [
				{
					label: "Refrigeración",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Refrigeradoras",
							link: "/category/cat780530/Refrigeradoras"
						},
						{
							label: "Side by Side",
							isHighlightLink: false,
							link: "/category/cat12940570/Side-by-Side"
						},
						{
							label: "Frenchdoor",
							link: "/category/cat12940575/Frenchdoor",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat12940573/Bottom-Freezer",
							label: "Bottom Freezer"
						},
						{
							link: "/category/cat12940576/Top-Mount",
							label: "Top Mount",
							isHighlightLink: false
						},
						{
							label: "Frigobares",
							isHighlightLink: false,
							link: "/category/cat6370589/Frigobares"
						},
						{
							isHighlightLink: false,
							label: "Cavas",
							link: "/category/cat6370588/Cavas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat780532/Congeladoras",
							label: "Congeladoras"
						},
						{
							isHighlightLink: false,
							link: "/category/cat12940577/Vitrinas-Verticales",
							label: "Vitrinas Verticales"
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat40754/Refrigeracion"
						}
					],
					link: "/category/cat40754/Refrigeracion"
				},
				{
					link: "/category/cat11170486/Climatizacion",
					leafCategories: [
						{
							label: "Ventiladores",
							isHighlightLink: false,
							link: "/category/cat40819/Ventiladores"
						},
						{
							isHighlightLink: false,
							label: "Aires Acondicionados",
							link: "/category/cat6370580/Aires-Acondicionados"
						},
						{
							link: "/category/cat12940598/Calefactores",
							isHighlightLink: false,
							label: "Calefactores"
						},
						{
							label: "Termoradiadores",
							link: "/category/cat12940604/Termoradiadores",
							isHighlightLink: false
						},
						{
							link: "/category/cat12940599/Deshumedecedores",
							label: "Deshumedecedores",
							isHighlightLink: false
						},
						{
							label: "Extractores de Aire",
							link: "/category/cat12990472/Extractores-de-Aire",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat12940605/Rapiduchas",
							label: "Rapiduchas"
						},
						{
							label: "Termas",
							isHighlightLink: false,
							link: "/category/cat40796/Termas"
						},
						{
							link: "/category/cat12990474/Duchas-Electricas",
							isHighlightLink: false,
							label: "Duchas Eléctricas"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat11170486/Climatizacion"
						}
					],
					label: "Climatización"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Lavadoras",
							link: "/category/cat780522/Lavadoras"
						},
						{
							link: "/category/cat780524/Secadoras",
							label: "Secadoras",
							isHighlightLink: false
						},
						{
							link: "/category/cat7180470/Lavasecas",
							label: "Lavasecas",
							isHighlightLink: false
						},
						{
							link: "/category/cat6420478/Centros-de-Lavado",
							isHighlightLink: false,
							label: "Centros de Lavado"
						},
						{
							link: "/category/cat40663/Lavavajillas",
							isHighlightLink: false,
							label: "Lavavajillas"
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat40662/Lavado"
						}
					],
					label: "Lavado",
					link: "/category/cat40662/Lavado"
				},
				{
					link: "/category/cat40567/Cuidado-Personal",
					label: "Cuidado Personal",
					leafCategories: [
						{
							link: "/category/cat40570/Depiladoras",
							isHighlightLink: false,
							label: "Depiladoras"
						},
						{
							link: "/category/cat40771/Secadoras-de-Cabello",
							isHighlightLink: false,
							label: "Secadoras de Cabello"
						},
						{
							link: "/category/cat40479/Alisadoras-y-Rizadores",
							isHighlightLink: false,
							label: "Alisadoras y Rizadores"
						},
						{
							link: "/category/cat40475/Maquinas-de-Afeitar",
							isHighlightLink: false,
							label: "Maquinas de Afeitar"
						},
						{
							link: "/category/cat12940566/Cortadoras-de-Cabello",
							label: "Cortadoras de Cabello",
							isHighlightLink: false
						},
						{
							link: "/category/cat12940567/Masajeadores",
							isHighlightLink: false,
							label: "Masajeadores"
						},
						{
							label: "Salud y Bienestar",
							link: "/category/cat40501/Salud-y-Bienestar",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Cuidado Facial",
							link: "/category/cat12940568/Cuidado-Facial"
						},
						{
							isHighlightLink: false,
							link: "/category/cat12940569/Combos",
							label: "Combos"
						},
						{
							link: "/category/cat40715/Rizadores",
							isHighlightLink: false,
							label: "Rizadores"
						},
						{
							link: "/category/cat13770465/Otros-Cuidado-Personal",
							isHighlightLink: false,
							label: "Otros Cuidado Personal"
						},
						{
							link: "/category/cat40567/Cuidado-Personal",
							isHighlightLink: true,
							label: "Ver todo"
						}
					]
				},
				{
					label: "Cocina",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Cocinas de Pie",
							link: "/category/cat840599/Cocinas-de-Pie"
						},
						{
							link: "/category/cat40586/Encimeras",
							label: "Encimeras",
							isHighlightLink: false
						},
						{
							label: "Hornos Empotrables",
							link: "/category/cat40624/Hornos-Empotrables",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat200466/Campanas",
							label: "Campanas"
						},
						{
							label: "Combos de Cocina",
							isHighlightLink: false,
							link: "/category/cat11200479/Combos-de-Cocina"
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat40538/Cocina"
						}
					],
					link: "/category/cat40538/Cocina"
				},
				{
					leafCategories: [
						{
							label: "Aspiradoras Robot",
							link: "/category/cat12940590/Aspiradoras-Robot",
							isHighlightLink: false
						},
						{
							label: "Aspiradoras de Arrastre",
							link: "/category/cat12940591/Aspiradoras-de-Arrastre",
							isHighlightLink: false
						},
						{
							label: "Aspiradoras Verticales",
							link: "/category/cat12940592/Aspiradoras-Verticales",
							isHighlightLink: false
						},
						{
							label: "Aspiradoras Tambor",
							link: "/category/cat12940593/Aspiradoras-Tambor",
							isHighlightLink: false
						},
						{
							link: "/category/cat12940594/Aspiradoras-Wet-Dry",
							label: "Aspiradoras Wet & Dry",
							isHighlightLink: false
						},
						{
							link: "/category/cat12940595/Aspiradoras-Portatiles",
							isHighlightLink: false,
							label: "Aspiradoras Portátiles"
						},
						{
							link: "/category/cat6370575/Lustradoras",
							isHighlightLink: false,
							label: "Lustradoras"
						},
						{
							isHighlightLink: false,
							label: "Hidrolavadoras",
							link: "/category/cat6370576/Hidrolavadoras"
						},
						{
							label: "Limpiadores a Vapor",
							link: "/category/cat6370577/Limpiadores-a-Vapor",
							isHighlightLink: false
						},
						{
							label: "Lavalfombra",
							link: "/category/cat13910462/Lavalfombra",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat40487/Limpieza-y-Aspirado"
						}
					],
					link: "/category/cat40487/Limpieza-y-Aspirado",
					label: "Limpieza y Aspirado"
				},
				{
					leafCategories: [
						{
							label: "Licuadoras",
							isHighlightLink: false,
							link: "/category/cat40674/Licuadoras"
						},
						{
							link: "/category/cat40713/Ollas-Arroceras",
							isHighlightLink: false,
							label: "Ollas Arroceras"
						},
						{
							link: "/category/cat40691/Microondas",
							isHighlightLink: false,
							label: "Microondas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat40508/Cafeteras",
							label: "Cafeteras"
						},
						{
							link: "/category/cat40619/Hervidores",
							label: "Hervidores",
							isHighlightLink: false
						},
						{
							link: "/category/cat7480478/Batidoras",
							isHighlightLink: false,
							label: "Batidoras"
						},
						{
							isHighlightLink: false,
							label: "Extractores",
							link: "/category/cat6370559/Extractores"
						},
						{
							label: "Sandwicheras/Wafleras",
							link: "/category/cat40767/Sandwicheras-Wafleras",
							isHighlightLink: false
						},
						{
							link: "/category/cat6370571/Combos",
							label: "Combos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Dispensador de Agua",
							link: "/category/cat6370572/Dispensador-de-Agua"
						},
						{
							link: "/category/cat40583/Electrodomesticos",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					label: "Electrodomésticos",
					link: "/category/cat40583/Electrodomesticos"
				},
				{
					link: "/category/cat8000471/Herramientas",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat3960464/Maquinas-de-Coser",
							label: "Maquinas de Coser"
						},
						{
							isHighlightLink: false,
							link: "/category/cat8390463/Taladros",
							label: "Taladros"
						},
						{
							isHighlightLink: false,
							label: "Esmeriles y Sierras",
							link: "/category/cat8390465/Esmeriles-y-Sierras"
						},
						{
							label: "Amoladoras",
							isHighlightLink: false,
							link: "/category/cat12940596/Amoladoras"
						},
						{
							isHighlightLink: false,
							label: "Jardinería y Pintado",
							link: "/category/cat8390466/Jardineria-y-Pintado"
						},
						{
							isHighlightLink: false,
							label: "Pulidoras y Lijadoras",
							link: "/category/cat8390464/Pulidoras-y-Lijadoras"
						},
						{
							isHighlightLink: false,
							label: "Accesorios",
							link: "/category/cat12940597/Accesorios"
						},
						{
							label: "Herramientas de Construcción",
							link: "/category/cat8390467/Herramientas-de-Construccion",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							link: "/category/cat8000471/Herramientas",
							label: "Ver todo"
						}
					],
					label: "Herramientas"
				}
			],
			label: "Electrohogar"
		},
		{
			subCategories: [
				{
					leafCategories: [
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat40700/Muebles"
						},
						{
							label: "Aparadores y vitrinas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat2180573/Aparadores-Vitrinas"
						},
						{
							isHighlightLink: false,
							label: "Banquetas y puffs",
							link: "/category/cat12630470/Banquetas-Puffs",
							meatStickerOption: 0
						},
						{
							label: "Bares",
							isHighlightLink: false,
							link: "/category/cat2180581/Bares"
						},
						{
							label: "Centros entretenimiento",
							link: "/category/cat7040487/Centros-de-Entretenimiento",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat12640465/Comodas-y-tocadores",
							label: "Cómodas y tocadores"
						},
						{
							isHighlightLink: false,
							link: "/category/cat12640469/Cunas-Camas-para-Ninos",
							label: "Cunas y camas infantiles"
						},
						{
							label: "Escritorios",
							isHighlightLink: false,
							link: "/category/cat2200542/Escritorios"
						},
						{
							isHighlightLink: false,
							label: "Estantes y libreros",
							link: "/category/cat560817/Estantes-Libreros"
						},
						{
							isHighlightLink: false,
							label: "Juegos de comedor",
							link: "/category/cat50590/Juegos-de-comedor"
						},
						{
							isHighlightLink: false,
							label: "Mesas",
							link: "/category/cat16230492/Mesas"
						},
						{
							link: "/category/cat40485/Roperos,-Comodas-Zapateras",
							label: "Roperos y zapateras",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Sillas",
							link: "/category/cat2180589/Sillas-Butacas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat11810489/Sofas-y-Seccionales",
							label: "Sofás y seccionales"
						},
						{
							link: "/category/cat2200546/Veladores-Cabeceras",
							isHighlightLink: false,
							label: "Veladores y cabeceras",
							meatStickerOption: 0
						},
						{
							label: "OUTLET",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat11860464/Outlet-Muebles"
						}
					],
					label: "Muebles por tipo",
					link: "/category/cat40700/Muebles"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat7040498/Escritorio",
							label: "Ver todo"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2200542/Escritorios",
							label: "Escritorios"
						},
						{
							isHighlightLink: false,
							link: "/category/cat560817/Estantes-Libreros",
							label: "Estantes y libreros"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat13940494/Archivadores-y-Repisas",
							label: "Repisas y archivadores",
							isHighlightLink: false
						},
						{
							link: "/category/cat2200540/Sillas-de-Escritorio",
							label: "Sillas de escritorio",
							isHighlightLink: false
						}
					],
					link: "/category/cat7040498/Escritorio",
					label: "Escritorio"
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat7040499/Sala",
							isHighlightLink: true
						},
						{
							link: "/category/cat12630470/Banquetas-Puffs",
							isHighlightLink: false,
							label: "Banquetas y puffs"
						},
						{
							label: "Butacas",
							isHighlightLink: false,
							link: "/category/cat11050489/Sillas-Butacas"
						},
						{
							label: "Centros entretenimiento",
							link: "/category/cat7040487/Centros-de-Entretenimiento",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Futones y sofá cama",
							link: "/category/cat560801/Futones-y-Sofa-Cama",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat50579/Juegos-de-Sala",
							label: "Juegos de sala"
						},
						{
							label: "Mesas centro y laterales ",
							isHighlightLink: false,
							link: "/category/cat50681/Mesas-de-Centro-Complementos"
						},
						{
							isHighlightLink: false,
							label: "Seccionales",
							link: "/category/cat560805/Seccionales"
						},
						{
							isHighlightLink: false,
							label: "Sofás",
							link: "/category/cat2180563/Sofas"
						},
						{
							meatStickerOption: 0,
							label: "Sofás reclinables",
							link: "/category/cat560803/Reclinables ",
							isHighlightLink: false
						}
					],
					link: "/category/cat7040499/Sala",
					label: "Sala"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat2200544/Muebles-de-Dormitorio"
						},
						{
							label: "Cómodas y tocadores",
							link: "/category/cat12640465/Comodas-y-tocadores",
							isHighlightLink: false
						},
						{
							label: "Roperos y zapateras",
							isHighlightLink: false,
							link: "/category/cat40485/Roperos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2200546/Veladores-Cabeceras",
							label: "Veladores y cabeceras"
						}
					],
					link: "/category/cat2200544/Muebles-de-Dormitorio",
					label: "Muebles de dormitorio"
				},
				{
					leafCategories: [
						{
							link: "/category/cat12420469/Muebles-Infantiles",
							label: "Ver todo",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							label: "Cómodas y cambiadores",
							link: "/category/cat800500/Comodas-Cambiadores"
						},
						{
							isHighlightLink: false,
							label: "Cunas y camas",
							link: "/category/cat12640469/Cunas-Camas-para-Ninos"
						},
						{
							label: "Roperos",
							link: "/category/cat12420473/Organizacion-Infantil",
							isHighlightLink: false
						},
						{
							link: "/category/cat12420475/Sillas-Mesas",
							label: "Sillas y mesas",
							isHighlightLink: false
						}
					],
					label: "Muebles infantiles",
					link: "/category/cat12420469/Muebles-Infantiles"
				},
				{
					label: "Comedor",
					leafCategories: [
						{
							link: "/category/cat40549/Comedor",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							label: "Aparadores y vitrinas",
							link: "/category/cat2180573/Aparadores-Vitrinas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Bancos de bar",
							link: "/category/cat2180585/Bancos-de-Bar"
						},
						{
							link: "/category/cat2180581/Bares",
							label: "Bares",
							isHighlightLink: false
						},
						{
							label: "Juegos de comedor",
							isHighlightLink: false,
							link: "/category/cat50590/Juegos-de-comedor"
						},
						{
							label: "Mesas de comedor",
							isHighlightLink: false,
							link: "/category/cat50592/Mesas-de-Comedor"
						},
						{
							label: "Sillas de comedor",
							link: "/category/cat50591/Sillas-de-Comedor",
							isHighlightLink: false
						}
					],
					link: "/category/cat7040492/Comedor"
				},
				{
					verTodoActive: true,
					link: "/category/cat14190469/Otros-Espacios",
					leafCategories: [
						{
							label: "Baño",
							link: "/category/cat7040490/Baño",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat13670461/Cocina-y-lavanderia",
							meatStickerOption: 0,
							label: "Cocina y lavandería",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat40798/Terrazas",
							label: "Terraza"
						}
					],
					label: "Otros espacios"
				},
				{
					label: "Marcas destacadas",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10240479/Crate-Barrel/?isLanding=true",
							label: "Crate & Barrel"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat40700/Muebles?facetSelected=true&f.product.brandName=bonno&isPLP=1",
							isHighlightLink: false,
							label: "Bonno"
						},
						{
							link: "/category/cat15140461/Natuzzi",
							label: "By NatuzziGroup",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat40700/Muebles?facetSelected=true&f.product.brandName=di+mobilia&isPLP=1",
							isHighlightLink: false,
							label: "Di Mobilia"
						},
						{
							link: "/category/cat40700/Muebles?facetSelected=true&f.product.brandName=pratelli&isPLP=1",
							meatStickerOption: 0,
							label: "Pratelli",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat11800461/Sauder",
							label: "Sauder"
						},
						{
							isHighlightLink: false,
							label: "Tuhome",
							meatStickerOption: 0,
							link: "/category/cat12840565/TUHOME"
						},
						{
							link: "/category/cat14190502/Tvilum",
							meatStickerOption: 0,
							label: "Tvilum",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Ziyaz",
							link: "/category/cat40700/Muebles?facetSelected=true&f.product.brandName=ziyaz&isPLP=1",
							isHighlightLink: false
						}
					],
					link: "/category/cat14360462/Marcas-Muebles"
				}
			],
			link: "cat7040484",
			label: "Muebles"
		},
		{
			subCategories: [
				{
					leafCategories: [
						{
							link: "/category/cat250473/Colchones",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							isHighlightLink: false,
							label: "Cuna",
							link: "/category/cat1260903/Colchon-de-Cuna"
						},
						{
							link: "/category/cat250479/Colchon-1-Plaza",
							isHighlightLink: false,
							label: "1 Plaza"
						},
						{
							isHighlightLink: false,
							link: "/category/cat250481/Colchon-1.5-Plazas",
							label: "1.5 Plazas"
						},
						{
							label: "2 Plazas ",
							isHighlightLink: false,
							link: "/category/cat250483/Colchon-2-Plazas"
						},
						{
							label: "Queen ",
							link: "/category/cat250485/Colchon-Queen",
							isHighlightLink: false
						},
						{
							link: "/category/cat250487/Colchon-King",
							isHighlightLink: false,
							label: "King"
						}
					],
					label: "Colchones",
					link: "/category/cat250473/Colchones/?isLanding=true"
				},
				{
					link: "/category/cat50588/Ropa-de-Cama",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat50588/Ropa-de-Cama",
							label: "Ver todo"
						},
						{
							isHighlightLink: false,
							label: "Sábanas",
							link: "/category/cat870508/Sabanas"
						},
						{
							isHighlightLink: false,
							label: "Edredones y Plumas",
							link: "/category/cat6880475/Edredones-y-Plumas"
						},
						{
							link: "/category/cat870522/Cubrecamas-y-Quilts",
							label: "Cubrecamas y Quilts",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat6880474/Frazadas-y-Mantas",
							label: "Frazadas y Mantas"
						},
						{
							isHighlightLink: false,
							label: "Fundas Plumón",
							link: "/category/cat870548/Fundas-Plumon"
						},
						{
							label: "Juegos de Cama",
							link: "/category/cat2660482/Juegos-de-Cama",
							isHighlightLink: false
						},
						{
							label: "Ropa de Cama Infantil",
							link: "/category/cat3760503/Ropa-de-Cama-Infantil",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Almohadas y Protectores",
							link: "/category/cat40481/Almohadas-y-Protectores"
						},
						{
							isHighlightLink: false,
							label: "Cojines y Accesorios",
							link: "/category/cat870538/Cojines-y-Accesorios"
						}
					],
					label: "Ropa de Cama"
				},
				{
					link: "/category/cat250477/Camas-Box-Tarima",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat250477/Camas-Box-Tarima"
						},
						{
							label: "1 Plaza ",
							link: "/category/cat250501/Camas-Box-Tarima-1-Plaza",
							isHighlightLink: false
						},
						{
							label: "1.5 Plazas",
							isHighlightLink: false,
							link: "/category/cat250503/Camas-Box-Tarima-1.5-Plazas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat250507/Camas-Box-Tarima-2-Plazas",
							label: "2 Plazas "
						},
						{
							isHighlightLink: false,
							link: "/category/cat250509/Camas-Box-Tarima-Queen",
							label: "Queen"
						},
						{
							link: "/category/cat250511/Camas-Box-Tarima-King",
							isHighlightLink: false,
							label: "King"
						}
					],
					label: "Camas Box Tarima"
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat800486/Dormitorio-Infantil",
							isHighlightLink: true
						},
						{
							label: "Alfombras infantiles",
							isHighlightLink: false,
							link: "/category/cat8490474/Alfombras-infantiles"
						},
						{
							label: "Cómodas y cambiadores",
							link: "/category/cat800500/Comodas-Cambiadores",
							isHighlightLink: false
						},
						{
							label: "Cunas y camas para niños",
							link: "/category/cat12640469/Cunas-Camas-para-Ninos",
							isHighlightLink: false
						},
						{
							link: "/category/cat12420483/Decoracion-Infantil",
							isHighlightLink: false,
							label: "Decoración infantil"
						},
						{
							link: "/category/cat800468/Dormitorio-Bebe",
							isHighlightLink: false,
							label: "Dormitorio bebé"
						},
						{
							label: "Libros infantiles",
							link: "/category/cat12090500/Libros-Infantiles",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat12420473/Organizacion-Infantil",
							label: "Organización infantil"
						},
						{
							isHighlightLink: false,
							label: "Ropa de cama infantil",
							link: "/category/cat3760503/Ropa-de-Cama-Infantil"
						},
						{
							label: "Sillas y mesas",
							link: "/category/cat12420475/Sillas-Mesas",
							isHighlightLink: false
						}
					],
					link: "/category/cat800486/Dormitorio-Infantil",
					label: "Dormitorio Infantil"
				},
				{
					label: "Juegos de Dormitorio",
					leafCategories: [
						{
							link: "/category/cat1270494/Juegos-de-Dormitorio",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							link: "/category/cat1270526/1-Plaza",
							isHighlightLink: false,
							label: "1 Plaza"
						},
						{
							link: "/category/cat1270528/1,5-Plazas",
							isHighlightLink: false,
							label: "1.5 Plazas"
						},
						{
							isHighlightLink: false,
							label: "2 Plazas",
							link: "/category/cat1270530/2-Plazas"
						},
						{
							label: "Queen",
							link: "/category/cat1270532/Queen",
							isHighlightLink: false
						},
						{
							label: "King",
							link: "/category/cat1270534/King",
							isHighlightLink: false
						}
					],
					link: "/category/cat1270494/Juegos-de-Dormitorio"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat2750541/Marcas-Destacadas"
						},
						{
							link: "/category/cat16230474/Drom",
							label: "DRÖM",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat11660462/BeautyRest-Simmons",
							meatStickerOption: 0,
							label: "Beautyrest Simmons"
						},
						{
							label: "Drimer",
							link: "/category/cat2850470/Drimer",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Forli",
							link: "/category/cat11510467/Forli"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Línea Exclusiva",
							link: "/category/cat12880519/Camas-y-Colchones-Linea-Exclusiva-Rosen"
						},
						{
							isHighlightLink: false,
							label: "Paraíso",
							link: "/category/cat2850468/Paraiso"
						},
						{
							label: "Rosen",
							link: "/category/cat2850467/Rosen",
							isHighlightLink: false
						}
					],
					link: "/category/cat2750541/Marcas-Destacadas",
					label: "Marcas Destacadas"
				},
				{
					link: "/category/cat2200544/Muebles-de-Dormitorio",
					label: "Muebles de Dormitorio",
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat2200544/Muebles-de-Dormitorio",
							isHighlightLink: true
						},
						{
							link: "/category/cat12640465/Comodas",
							isHighlightLink: false,
							label: "Cómodas"
						},
						{
							label: "Roperos",
							link: "/category/cat12640464/Roperos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat2200546/Veladores-Cabeceras",
							label: "Veladores y cabeceras"
						},
						{
							label: "Zapateras",
							link: "/category/cat12640466/Zapateras",
							isHighlightLink: false
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Ver todo",
							link: "/category/cat250475/Camas-Box-Spring",
							isHighlightLink: true
						},
						{
							isHighlightLink: false,
							label: "2 Plazas ",
							link: "/category/cat250493/Camas-Box-Spring-2-Plazas"
						},
						{
							isHighlightLink: false,
							label: "Queen ",
							link: "/category/cat250497/Camas-Box-Spring-Queen"
						},
						{
							label: "King",
							link: "/category/cat250499/Camas-Box-Spring-King",
							isHighlightLink: false
						}
					],
					link: "/category/cat250475/Camas-Box-Spring",
					label: "Camas Box Spring"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat11830507/Funcionales",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							meatStickerOption: 0,
							label: "Bases",
							link: "/category/cat2200550/Bases",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Boxets",
							link: "/category/cat2850463/Boxets",
							isHighlightLink: false
						},
						{
							label: "Camarotes",
							link: "/category/cat2850461/Camarotes",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Divanes",
							link: "/category/cat2850462/Divanes"
						}
					],
					label: "Camas Funcionales",
					link: "/category/cat11830507/Funcionales"
				}
			],
			label: "Dormitorio",
			link: "cat50684"
		},
		{
			link: "cat4220483",
			subCategories: [
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Juegos de Ollas",
							link: "/category/cat3160462/Juegos-de-Ollas"
						},
						{
							isHighlightLink: false,
							label: "Ollas",
							link: "/category/cat1450472/Ollas"
						},
						{
							link: "/category/cat3180508/Sartenes-y-Woks",
							isHighlightLink: false,
							label: "Sartenes y Woks"
						},
						{
							isHighlightLink: false,
							label: "Cuchillos de Cocina",
							link: "/category/cat3180462/Cuchillos-de-Cocina"
						},
						{
							link: "/category/cat1450474/Teteras,-Cafeteras-y-Termos",
							isHighlightLink: false,
							label: "Teteras, Cafeteras y Termos"
						},
						{
							label: "Organizadores y Contenedores",
							isHighlightLink: false,
							link: "/category/cat3180488/Organizadores-y-Contenedores"
						},
						{
							meatStickerOption: 0,
							label: "Repostería, fuentes y bowls",
							isHighlightLink: false,
							link: "/category/cat6880505/Repostería--fuentes-y-bowls"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3180500/Utensilios-de-Cocina",
							label: "Utensilios de Cocina"
						},
						{
							isHighlightLink: false,
							link: "/category/cat3180486/Escurridor-de-platos",
							label: "Escurridor de platos"
						},
						{
							label: "Lavaderos y Griferías ",
							isHighlightLink: false,
							link: "/category/cat13900482/Lavaderos-y-Griferias"
						},
						{
							isHighlightLink: true,
							link: "/category/cat40685/Menaje-Cocina",
							label: "Ver todo"
						}
					],
					label: "Menaje Cocina",
					link: "/category/cat40685/Menaje-Cocina?isLanding=true"
				},
				{
					link: "/page/Menaje?staticPageId=25400002",
					label: "Menaje Comedor",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Platos y Vajilla",
							link: "/category/cat7040472/Platos-y-Vajilla"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1450486/Cubiertos",
							label: "Cubiertos"
						},
						{
							isHighlightLink: false,
							label: "Vasos, Copas y Jarras",
							link: "/category/cat1450484/Vasos,-Copas-y-Jarras"
						},
						{
							link: "/category/cat11820463/Bar-y-Piqueos",
							isHighlightLink: false,
							label: "Bar y Piqueos"
						},
						{
							isHighlightLink: false,
							label: "Fuentes y Piezas de Servir",
							link: "/category/cat7040476/Fuentes-y-Piezas-de-Servir"
						},
						{
							label: "Te y Café",
							link: "/category/cat1450488/Te-y-Cafe",
							isHighlightLink: false
						},
						{
							label: "Manteles, Servilletas e Individuales",
							isHighlightLink: false,
							link: "/category/cat7040607/Manteles,-Servilletas-e-Individuales"
						},
						{
							label: "Accesorios de Mesa",
							isHighlightLink: false,
							link: "/category/cat7040474/Accesorios-de-Mesa"
						},
						{
							link: "/category/cat3180538/Acrilico-y-Melamina",
							isHighlightLink: false,
							label: "Acrílico y Melamina",
							meatStickerOption: 0
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat1450466/Menaje-Comedor"
						}
					]
				},
				{
					link: "/page/Decoracion?staticPageId=23700002",
					label: "Decoración",
					leafCategories: [
						{
							label: "Alfombras",
							isHighlightLink: false,
							link: "/category/cat40477/Alfombras"
						},
						{
							isHighlightLink: false,
							label: "Cortinas y Persianas",
							link: "/category/cat13080486/Cortinas-y-Persianas"
						},
						{
							label: "Decoración de Pared",
							isHighlightLink: false,
							link: "/category/cat6880481/Decoracion-de-Pared"
						},
						{
							label: "Plantas y Flores",
							link: "/category/cat6880480/Plantas-y-Flores",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Marcos de fotos",
							link: "/category/cat40681/Marcos-de-fotos"
						},
						{
							isHighlightLink: false,
							label: "Adornos",
							link: "/category/cat1190480/Adornos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat590485/Lamparas",
							label: "Lámparas"
						},
						{
							label: "Muebles Pequeños",
							link: "/category/cat2860464/Muebles-Pequenos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Velas, Difusores y Faroles",
							link: "/category/cat590493/Velas,-Difusores-y-Faroles"
						},
						{
							isHighlightLink: false,
							link: "/category/cat870538/Cojines-y-Accesorios",
							label: "Cojines y Accesorios"
						},
						{
							label: "Canastos",
							link: "/category/cat12770497/Canastos-y-Cajas",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							link: "/category/cat40474/Decoracion",
							label: "Ver todo"
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Muebles",
							isHighlightLink: false,
							link: "/category/cat12170479/Muebles"
						},
						{
							label: "Alfombras y Lámparas",
							isHighlightLink: false,
							link: "/category/cat12450507/Alfombras-Lamparas"
						},
						{
							label: "Decoración",
							link: "/category/cat10250467/Decoracion",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat10250466/Menaje-de-Cocina",
							label: "Menaje de Cocina"
						},
						{
							link: "/category/cat10250469/Menaje-de-Comedor",
							isHighlightLink: false,
							label: "Menaje de Comedor"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat10250471/Organización",
							label: "Organización",
							isHighlightLink: false
						},
						{
							label: "Terraza",
							link: "/category/cat10250472/Terraza",
							isHighlightLink: false
						},
						{
							label: "Dormitorio & Baño ",
							isHighlightLink: false,
							link: "/category/cat10250468/Dormitorio-Bano"
						},
						{
							link: "/category/cat10250473/Sale",
							label: "Sale",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Ver todo",
							link: "/category/cat10240479/Crate-Barrel",
							isHighlightLink: true
						}
					],
					label: "Crate&Barrel",
					link: "/category/cat10240479/Crate-Barrel/?isLanding=true"
				},
				{
					link: "/category/cat2660494/Parrillas,-Cajas-Chinas-y-mas",
					leafCategories: [
						{
							label: "Parrillas",
							link: "/category/cat2660495/Parrillas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Cajas Chinas",
							link: "/category/cat2660496/Cajas-Chinas"
						},
						{
							link: "/category/cat11510478/Kamados",
							label: "Kamados",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Cilindros",
							link: "/category/cat2660497/Cilindros"
						},
						{
							label: "Paelleras",
							isHighlightLink: false,
							link: "/category/cat7110601/Paelleras"
						},
						{
							label: "Accesorios y Utensilios",
							link: "/category/cat2660501/Accesorios-y-Utensilios",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat2660500/Rejillas-y-Asadores",
							label: "Rejillas y Asadores"
						},
						{
							label: "Parrillas Empotrables",
							link: "/category/cat7000466/Parrillas-Empotrables",
							isHighlightLink: false
						},
						{
							link: "/category/cat2660494/Parrillas,-Cajas-Chinas-y-mas",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					label: "Parrillas, Cajas Chinas y más"
				},
				{
					label: "Maletería y Viajes",
					link: "/category/cat950500/Maleteria-y-Viajes",
					leafCategories: [
						{
							link: "/category/cat950500/Maleteria-y-Viajes",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							label: "Accesorios de viaje",
							isHighlightLink: false,
							link: "/category/cat980618/Accesorios-de-Viaje"
						},
						{
							isHighlightLink: false,
							label: "Bolsos de viaje",
							link: "/category/cat6880496/Bolsos-de-Viaje"
						},
						{
							isHighlightLink: false,
							label: "Maletas de cabina",
							link: "/category/cat5790462/Maletas-de-Cabina"
						},
						{
							link: "/category/cat6880492/Maletas-de-Viaje",
							isHighlightLink: false,
							label: "Maletas de viaje"
						},
						{
							link: "/category/cat6880494/Mochilas-Outdoors",
							isHighlightLink: false,
							label: "Mochilas outdoors"
						},
						{
							label: "Mochilas para laptop",
							isHighlightLink: false,
							link: "/category/cat270485/Mochilas-para-Laptop"
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Toallas de Baño",
							isHighlightLink: false,
							link: "/category/cat2020470/Toallas-de-Bano"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat2020480/Toallas-de-Playa",
							label: "Toallas de Playa",
							isHighlightLink: false
						},
						{
							label: "Accesorios de Baño",
							link: "/category/cat2020476/Accesorios-de-Bano",
							isHighlightLink: false
						},
						{
							label: "Cortinas de baño",
							isHighlightLink: false,
							link: "/category/cat2020474/Cortinas-de-bano"
						},
						{
							isHighlightLink: false,
							label: "Pisos de Baño",
							link: "/category/cat12140479/Pisos-de-Bano"
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat2020468/Bano"
						}
					],
					link: "/category/cat2020468/Bano",
					label: "Baño"
				}
			],
			label: "Decohogar"
		},
		{
			label: "Crate&Barrel",
			subCategories: [
				{
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat12170479/Muebles",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							link: "/category/cat12180478/Estantes--Libreros---Gabinetes",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Aparadores y libreros"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat12180489/Muebles---Carritos-de-Bar",
							isHighlightLink: false,
							label: "Bares"
						},
						{
							isHighlightLink: false,
							label: "Butacas",
							meatStickerOption: 0,
							link: "/category/cat12180484"
						},
						{
							link: "/category/cat12180475/Camas---Cabeceras",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Camas y cabeceras"
						},
						{
							label: "Centros de entretenimiento",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat12180480/Centros-de-Entretenimiento---TV"
						},
						{
							link: "/category/cat12180477/Escritorios---Muebles-de-Oficina",
							meatStickerOption: 0,
							label: "Escritorios y muebles oficina",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat12180487/Otomanes---Puffs",
							isHighlightLink: false,
							label: "Otomanes y puffs"
						},
						{
							meatStickerOption: 0,
							label: "Mesas de centro y consolas",
							isHighlightLink: false,
							link: "/category/cat12180463/Mesas-de-Centro--Laterales---Consolas"
						},
						{
							isHighlightLink: false,
							label: "Mesas de comedor",
							meatStickerOption: 0,
							link: "/category/cat12180472/Mesas-de-Comedor"
						},
						{
							link: "/category/cat12180481",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Seccionales"
						},
						{
							label: "Sillas y bancos",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat12180473/Sillas-de-Comedor"
						},
						{
							link: "/category/cat12180485/Sofas---Futones",
							meatStickerOption: 0,
							label: "Sofás y futones",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Veladores y cómodas",
							link: "/category/cat10250513/Mesas-de-Noche",
							meatStickerOption: 0
						}
					],
					link: "/category/cat12170479/Muebles",
					label: "Muebles"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat13940486/Utensilios-de-Cocina",
							label: "Utensilios de Cocina"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Bowls & Contenedores de Alimentos",
							link: "/category/cat13940488/Bowls---Contenedores-de-Alimentos"
						},
						{
							label: "Utensilios para Hornear & Cocinar",
							link: "/category/cat10250477/Utensilios-para-hornear---Cocinar",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat13940485/Utensilios-de-Reposteria",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Utensilios de Repostería"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat14240461/Electrodomesticos",
							label: "Electrodomesticos",
							isHighlightLink: false
						},
						{
							label: "Café & Té ",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat10250475/Cafe---Te-"
						},
						{
							link: "/category/cat10250476/Cuchilleria",
							meatStickerOption: 0,
							label: "Cuchillos",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Basureros",
							isHighlightLink: false,
							link: "/category/cat13940487/Basureros"
						},
						{
							isHighlightLink: true,
							link: "/category/cat10250466/Menaje-de-Cocina",
							label: "Ver todo Menaje Cocina"
						}
					],
					link: "/category/cat10250466/Menaje-de-Cocina",
					label: "Menaje Cocina",
					verTodoActive: true
				},
				{
					link: "/category/cat10250469/Menaje-de-Comedor",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Bandejas y Accesorios",
							link: "/category/cat10250486/Bandejas---Accesorios"
						},
						{
							label: "Vajillas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat10250490/Vajillas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Vasos & Copas",
							link: "/category/cat10250491/Vasos---Copas"
						},
						{
							isHighlightLink: false,
							label: "Plásticos & Melamine",
							meatStickerOption: 0,
							link: "/category/cat10250489/Plasticos---Melamine"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat13940484/Accesorios-de-Bar",
							label: "Accesorios de Bar"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10250487/Cubiertos",
							label: "Cubiertos"
						},
						{
							link: "/category/cat10250488/Manteleria",
							label: "Mantelería",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat10250469/Menaje-de-Comedor",
							label: "Ver todo Menaje Comedor",
							isHighlightLink: true
						}
					],
					label: "Menaje Comedor"
				},
				{
					link: "/category/cat10250467/Decoracion",
					verTodoActive: true,
					leafCategories: [
						{
							label: "Arte de Pared",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat13940475/Arte-de-Pared"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat13940474/Cuadros",
							isHighlightLink: false,
							label: "Cuadros"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat13940473/Espejos",
							label: "Espejos"
						},
						{
							link: "/category/cat10250480/Candelabros---Floreros",
							meatStickerOption: 0,
							label: "Candelabros y Floreros",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cojines & Mantas",
							link: "/category/cat10250481/Cojines---Mantas"
						},
						{
							meatStickerOption: 0,
							label: "Accesorios de Decoración",
							link: "/category/cat12010488/Accesorios-de-Decoracion",
							isHighlightLink: false
						},
						{
							link: "/category/cat10250467/Decoracion",
							isHighlightLink: true,
							label: "Ver todo Decoración"
						}
					],
					label: "Decoración"
				},
				{
					label: "Alfombras y Lámparas",
					leafCategories: [
						{
							link: "/category/cat10240481/Alfombras",
							isHighlightLink: false,
							label: "Alfombras",
							meatStickerOption: 0
						},
						{
							label: "Lámparas de Mesa",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat13940478/Lamparas-de-Mesa"
						},
						{
							label: "Lámparas de Techo",
							link: "/category/cat13940480/Lamparas-de-Techo",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Ver todo Alfombras y Lámparas",
							link: "/category/cat12450507",
							isHighlightLink: true
						}
					],
					link: "/category/cat12450507",
					verTodoActive: true
				},
				{
					label: "Dormitorio y Baño",
					link: "/category/cat12450507",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Accesorios de baño",
							meatStickerOption: 0,
							link: "/category/cat12550473/Accesorios-de-bano"
						},
						{
							label: "Ropa de Baño",
							link: "/category/cat10250484/Ropa-de-Bano",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Ropa de Cama",
							link: "/category/cat10250485/Ropa-de-Cama",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: true,
							label: "Ver todo Dormitorio y Baño",
							link: "/category/cat12450507"
						}
					],
					verTodoActive: true
				},
				{
					link: "/category/cat10250472",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Comedor de Terraza",
							link: "/category/cat12180490/Comedor-de-Terraza"
						},
						{
							link: "/category/cat12180491/Sala-de-Terraza",
							label: "Sala de Terraza",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat10250509/Alfombras-de-Terraza",
							label: "Alfombras de Terraza"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat12180492/Sombrillas",
							label: "Sombrillas"
						},
						{
							link: "/category/cat10250512/Accesorios-de-Terraza",
							isHighlightLink: false,
							label: "Accesorios de Terraza",
							meatStickerOption: 0
						},
						{
							label: "Entretenimiento de Terraza",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10250515/Entretenimiento-de-Terraza"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Terrazas",
							link: "/category/cat10250472"
						}
					],
					verTodoActive: true,
					label: "Terrazas"
				}
			],
			link: "cat10240479",
			bannerLocation: "urlToImage"
		},
		{
			label: "Deportes",
			subCategories: [
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Trotadoras",
							link: "/category/cat520468/Trotadoras"
						},
						{
							label: "Elípticas",
							isHighlightLink: false,
							link: "/category/cat520466/Elipticas"
						},
						{
							isHighlightLink: false,
							label: "Mini Gimnasios",
							link: "/category/cat520472/Mini-Gimnasios"
						},
						{
							link: "/category/cat520470/Bicicletas-de-Spinning",
							label: "Bicicletas de Spinning",
							isHighlightLink: false
						},
						{
							label: "Bicicletas Estacionarias",
							link: "/category/cat4710461/Bicicletas-Estacionarias",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Máquina de Abdominales",
							link: "/category/cat520474/Maquina-de-Abdominales"
						},
						{
							isHighlightLink: false,
							link: "/category/cat14340461/Pesas-y-Mancuernas",
							label: "Pesas y Mancuernas",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat560922/Accesorios-Fitness",
							label: "Accesorios Fitness"
						},
						{
							link: "/category/cat6630620/Mundo-Fitness",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					label: "Mundo Fitness",
					link: "/category/cat6630620/Mundo-Fitness"
				},
				{
					label: "Bicicletas y Electromovilidad",
					leafCategories: [
						{
							label: "Bicicletas Montañeras",
							isHighlightLink: false,
							link: "/category/cat40710/Bicicletas-Montaneras"
						},
						{
							label: "Bicicletas Urbanas",
							link: "/category/cat50675/Bicicletas-Urbanas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Bicicletas Ruta Pista",
							link: "/category/cat6630567/Bicicletas-Ruta-Pista"
						},
						{
							isHighlightLink: false,
							link: "/category/cat50676/Bicicletas-Infantiles",
							label: "Bicicletas Infantiles"
						},
						{
							isHighlightLink: false,
							link: "/category/cat14400469/Bicicletas-Electricas",
							label: "Bicicletas Eléctricas "
						},
						{
							label: "Scooters Eléctricos",
							isHighlightLink: false,
							link: "/category/cat14400471/Scooter-electrico"
						},
						{
							label: "Hoverboard y Monopatines",
							link: "/category/cat14400470/Hoverboard",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat580482/Accesorios",
							label: "Accesorios"
						},
						{
							label: "Ver todo",
							link: "/category/cat40500/Bicicletas",
							isHighlightLink: true
						}
					],
					link: "/category/cat40500/Bicicletas"
				},
				{
					leafCategories: [
						{
							label: "Casacas, Parkas y Cortavientos",
							isHighlightLink: false,
							link: "/category/cat6630651/Casacas-y-Polerones"
						},
						{
							isHighlightLink: false,
							label: "Polares y Poleras",
							link: "/category/cat14410474/Polerones-y-polares"
						},
						{
							label: "Buzos Conjunto",
							link: "/category/cat6630647/Buzos-Conjunto-y-Pantalones",
							isHighlightLink: false
						},
						{
							link: "/category/cat6630649/Polos-deportivos-de-mujeres",
							label: "Polos deportivos",
							isHighlightLink: false
						},
						{
							label: "Tops deportivos",
							link: "/category/cat6630650/Tops-deportivos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Pantalones y Joggers",
							link: "/category/cat14410475/Pantalones-y-Joggers"
						},
						{
							label: "Mallas (leggings)",
							link: "/category/cat6630648/Mallas-(leggings)",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat6630652/Shorts",
							label: "Shorts"
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat6630630/Vestuario-Deportivo-Mujer"
						}
					],
					link: "/category/cat6630630/Vestuario-Deportivo-Mujer",
					label: "Ropa Deportiva Mujer"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat6630671/Casacas-y-Polerones",
							label: "Casacas, Parkas y Cortavientos"
						},
						{
							isHighlightLink: false,
							label: "Polares y Poleras",
							link: "/category/cat14410471/Polerones-y-polares"
						},
						{
							label: "Buzos Conjunto",
							link: "/category/cat6630670/Buzos-Conjunto-y-Pantalones",
							isHighlightLink: false
						},
						{
							link: "/category/cat6630672/Polos-deportivos-de-hombre",
							label: "Polos deportivos",
							isHighlightLink: false
						},
						{
							link: "/category/cat14410472/Pantalones-y-Joggers",
							label: "Pantalones y Joggers",
							isHighlightLink: false
						},
						{
							label: "Shorts",
							link: "/category/cat6630674/Shorts",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat6630655/Vestuario-Deportivo-Hombre"
						}
					],
					label: "Ropa Deportiva Hombre",
					link: "/category/cat6630655/Vestuario-Deportivo-Hombre"
				},
				{
					link: "/category/cat14410473/Mochilas-y-Bolsos",
					leafCategories: [
						{
							link: "/category/cat15840469/Mochilas-y-Bolsos",
							label: "Mochilas y Bolsos",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat11030464/Medias",
							label: "Medias "
						},
						{
							label: "Gorros y Viseras",
							isHighlightLink: false,
							link: "/category/cat15840462/Gorros-y-Viseras"
						},
						{
							label: "Botellas y Tomatodos",
							isHighlightLink: false,
							link: "/category/cat15840461/Botellas-y-Tomatodos"
						},
						{
							label: "Pelotas",
							link: "/category/cat15840463/Pelotas",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat1830468/Smartwatch",
							label: "Relojes",
							isHighlightLink: false
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat3930550/Electromovilidad"
						}
					],
					label: "Accesorios Deportivos"
				},
				{
					link: "/category/cat6630576/Tiempo-Libre-y-Camping",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Carpas",
							link: "/category/cat14370471/Carpas"
						},
						{
							link: "/category/cat14370472/Sacos-de-dormir",
							isHighlightLink: false,
							label: "Sacos de dormir"
						},
						{
							label: "Colchones Inflables",
							link: "/category/cat14370473/Colchones-Inflables",
							isHighlightLink: false
						},
						{
							label: "Coolers",
							link: "/category/cat550498/Coolers",
							isHighlightLink: false
						},
						{
							label: "Mochilas Outdoors",
							isHighlightLink: false,
							link: "/category/cat6880494/Mochilas-Outdoors"
						},
						{
							isHighlightLink: false,
							label: "Mesas multijuegos",
							link: "/category/cat11030466/Mesas-multijuegos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat6630596/Piscinas,-inflables-y-juegos-de-agua",
							label: "Piscinas, inflables y juegos de agua"
						},
						{
							isHighlightLink: false,
							label: "Kayaks, Canoas y Paddles",
							link: "/category/cat550500/Kayaks,-Canoas-y-Paddles"
						},
						{
							label: "Ver todo",
							link: "/category/cat6630576/Tiempo-Libre-y-Camping",
							isHighlightLink: true
						}
					],
					label: "Tiempo Libre y Camping"
				},
				{
					leafCategories: [
						{
							link: "/category/cat2870461/Adidas",
							label: "adidas",
							isHighlightLink: false
						},
						{
							link: "/category/cat2870470/Diadora",
							isHighlightLink: false,
							label: "Diadora"
						},
						{
							isHighlightLink: false,
							label: "Mountain Gear",
							link: "/category/cat2870500/Mountain-Gear"
						},
						{
							link: "/category/cat2870513/Puma",
							isHighlightLink: false,
							label: "Puma"
						},
						{
							link: "/category/cat2870504/Nike",
							label: "Nike",
							isHighlightLink: false
						},
						{
							link: "/category/cat2870515/Reebok",
							isHighlightLink: false,
							label: "Reebok"
						},
						{
							link: "/category/cat5400537/Under-Armour",
							isHighlightLink: false,
							label: "Under Armour"
						},
						{
							meatStickerOption: 0,
							label: "Mossimo",
							isHighlightLink: false,
							link: "/category/cat14280461/Mossimo"
						},
						{
							link: "/category/cat12240463/Umbro",
							label: "Umbro",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Fratta",
							link: "/category/cat2870475/Fratta"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat15760468/New-Balance",
							label: "New Balance",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "The North Face",
							meatStickerOption: 0,
							link: "/category/cat12280462/The-North-Face"
						},
						{
							isHighlightLink: false,
							link: "/category/cat15750480/Hoseg",
							label: "Hoseg",
							meatStickerOption: 0
						},
						{
							link: "/category/cat12240462/Everlast",
							label: "Everlast",
							isHighlightLink: false
						},
						{
							link: "/category/cat14280462/Bodytone",
							isHighlightLink: false,
							label: "Bodytone"
						},
						{
							label: "Monark",
							link: "/category/cat12470462/Monark",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat12540461/Muvo-by-Oxford",
							label: "Muvo "
						},
						{
							label: "Oxford",
							link: "/category/cat14280464/Oxford",
							isHighlightLink: false
						},
						{
							link: "/category/cat11030463/Marcas-Deportivas",
							label: "Ver todo",
							isHighlightLink: true
						}
					],
					label: "Marcas Deportivas",
					link: "/category/cat11030463/Marcas-Deportivas"
				},
				{
					label: "Zapatillas",
					link: "/category/cat1470548/Zapatillas",
					leafCategories: [
						{
							label: "Zapatillas Hombre",
							isHighlightLink: false,
							link: "/category/cat6630531/Zapatillas-Hombre"
						},
						{
							isHighlightLink: false,
							label: "Zapatillas Mujer",
							link: "/category/cat6630532/Zapatillas-Mujer"
						},
						{
							label: "Zapatillas Niños",
							isHighlightLink: false,
							link: "/category/cat4350537/Zapatillas-Ninos"
						},
						{
							label: "Zapatillas Urbanas",
							link: "/category/cat560495/Zapatillas-Urbanas",
							isHighlightLink: false
						},
						{
							label: "Zapatillas Running",
							link: "/category/cat560472/Zapatillas-Running",
							isHighlightLink: false
						},
						{
							link: "/category/cat560474/Zapatillas-Training",
							isHighlightLink: false,
							label: "Zapatillas Training"
						},
						{
							link: "/category/cat560476/Zapatillas-Futbol",
							label: "Zapatillas Fútbol",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat560478/Zapatillas-Outdoor",
							label: "Zapatillas Outdoor"
						},
						{
							label: "Zapatillas Basketball",
							link: "/category/cat4270474/Zapatillas-Basketball",
							isHighlightLink: false
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat1470548/Zapatillas"
						}
					]
				}
			],
			link: "cat40571"
		},
		{
			subCategories: [
				{
					link: "/category/cat11520463/Tendencias",
					label: "Tendencias",
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Sneaker Corner",
							isHighlightLink: false,
							link: "/page/Zapatillas?staticPageId=7100003"
						},
						{
							meatStickerOption: 0,
							label: "Zapatillas Blancas",
							link: "/collection/zapatillas-blancass",
							isHighlightLink: false
						},
						{
							label: "Calzado Comfy",
							link: "/collection/comfy1",
							meatStickerOption: 0,
							isHighlightLink: false
						}
					]
				},
				{
					link: "/category/cat1470548/Zapatillas",
					label: "Zapatillas",
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat1470548/Zapatillas",
							label: "Ver todo"
						},
						{
							label: "Zapatillas Deportivas",
							meatStickerOption: 0,
							link: "/category/cat7360593/Zapatillas-deportivas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Zapatillas Hombre",
							link: "/category/cat6630531/Zapatillas-Hombre"
						},
						{
							isHighlightLink: false,
							link: "/category/cat6630532/Zapatillas-Mujer",
							label: "Zapatillas Mujer"
						},
						{
							isHighlightLink: false,
							label: "Zapatillas Niños",
							link: "/category/cat4350537/Zapatillas-Ninos"
						},
						{
							label: "Zapatillas Urbanas",
							isHighlightLink: false,
							link: "/category/cat560495/Zapatillas-Urbanas"
						}
					]
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							link: "/category/cat1470526/Zapatos-Mujer",
							label: "Ver todo"
						},
						{
							label: "Zapatillas Urbanas Mujer",
							isHighlightLink: false,
							link: "/category/cat1470534/Zapatillas-Urbanas-Mujer"
						},
						{
							isHighlightLink: false,
							label: "Zapatos Casuales",
							link: "/category/cat6630526/Zapatos-Casuales"
						},
						{
							link: "/category/cat6630522/Zapatos-planos-y-ballerinas",
							label: "Zapatos planos y ballerinas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Sandalias",
							link: "/category/cat1470530/Sandalias"
						},
						{
							link: "/category/cat6630521/Zapatos-de-Taco",
							isHighlightLink: false,
							label: "Zapatos de Taco"
						},
						{
							meatStickerOption: 0,
							label: "Botines",
							link: "/category/cat6630524/Botines",
							isHighlightLink: false
						}
					],
					link: "/category/cat1470526/Zapatos-Mujer",
					label: "Zapatos Mujer"
				},
				{
					label: "Zapatos Hombre",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat1470538/Zapatos-Hombre"
						},
						{
							label: "Zapatillas Urbanas",
							link: "/category/cat1480500/Zapatillas-Urbanas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat1470540/Zapatos-Casuales",
							label: "Zapatos Casuales"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1470542/Zapatos-Formales",
							label: "Zapatos de Vestir"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat1470546/Botines",
							label: "Botines",
							isHighlightLink: false
						},
						{
							link: "/category/cat6630528/Mocasines",
							isHighlightLink: false,
							label: "Mocasines"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1600472/Sandalias",
							label: "Sandalias"
						},
						{
							isHighlightLink: false,
							link: "/category/cat11880472/Shoe-Care",
							label: "Shoe Care"
						}
					],
					link: "/category/cat1470538/Zapatos-Hombre"
				},
				{
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat6630519/Zapatos-Ninos"
						},
						{
							link: "/category/cat6630537/Zapatillas-Ninas",
							isHighlightLink: false,
							label: "Zapatillas Niñas"
						},
						{
							isHighlightLink: false,
							label: "Zapatillas Niños",
							link: "/category/cat6630536/Zapatillas-Ninos"
						},
						{
							label: "Botas y botines Niños",
							link: "/category/cat10600482/Botas-y-botines-Ninos",
							isHighlightLink: false
						},
						{
							label: "Zapatos Niñas",
							isHighlightLink: false,
							link: "/category/cat6630545/Zapatos-Ninas"
						},
						{
							link: "/category/cat6630546/Zapatos-Ninos",
							label: "Zapatos Niños",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Zapatos Bebés",
							link: "/category/cat6630547/Zapatos-Bebes"
						},
						{
							link: "/category/cat11170487/Sandalias-Ninos",
							label: "Sandalias Niños",
							isHighlightLink: false
						}
					],
					link: "/category/cat6630519/Zapatos-Ninos",
					label: "Zapatos Niños"
				},
				{
					link: "/category/cat6690540/Marcas-Destacadas",
					label: "Marcas Destacadas",
					leafCategories: [
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat6690540/Marcas-Destacadas"
						},
						{
							isHighlightLink: false,
							label: "adidas",
							link: "/category/cat1480518/Adidas"
						},
						{
							label: "Nike",
							link: "/category/cat1480522/Nike",
							isHighlightLink: false
						},
						{
							label: "Puma",
							link: "/category/cat7710496/Puma",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Reebok",
							link: "/category/cat1480524/Reebok"
						},
						{
							label: "New Balance",
							isHighlightLink: false,
							link: "/category/cat1600508/New-Balance"
						},
						{
							link: "/category/cat6370466/Converse",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Converse"
						},
						{
							label: "Skechers",
							link: "/category/cat4100461/Skechers",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Vans",
							meatStickerOption: 0,
							link: "/category/cat2680486/Vans",
							isHighlightLink: false
						},
						{
							label: "Aldo",
							link: "/category/cat1600470/Aldo",
							isHighlightLink: false
						},
						{
							label: "Call It Spring",
							link: "/category/cat1620466/Call-It-Spring",
							isHighlightLink: false
						},
						{
							link: "/category/cat3200473/Clarks",
							label: "Clarks",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Dr. Martens",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14070465/Dr-Martens"
						},
						{
							link: "/category/cat13800465/Crocs",
							label: "Crocs",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Basement",
							link: "/category/cat1590464/Basement"
						},
						{
							label: "Michael Kors",
							meatStickerOption: 0,
							link: "/category/cat7180485/Michael-Kors",
							isHighlightLink: false
						}
					]
				}
			],
			label: "Zapatos",
			link: "cat560468"
		},
		{
			link: "cat7720497",
			label: "Moda Mujer",
			subCategories: [
				{
					verTodoActive: true,
					label: "Comfy - Cómodo en casa",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/collection/sweaters-comfy",
							meatStickerOption: 0,
							label: "Sweaters"
						},
						{
							label: "Joggers",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/joggers-comfy"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Polos",
							link: "/collection/polos-comfy"
						},
						{
							label: "Vestidos",
							link: "/collection/vestidos-comfy",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Shorts y Faldas",
							meatStickerOption: 0,
							link: "/collection/shorts-y-faldas-comfy"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/collection/comfy-mujer"
						}
					],
					link: "/collection/comfy-mujer"
				},
				{
					leafCategories: [
						{
							label: "Nuevo moda mujer!",
							link: "/collection/lo-nuevo-i2021",
							isHighlightLink: false
						},
						{
							label: "Polos",
							link: "/category/cat4100465/Polos",
							isHighlightLink: false
						},
						{
							label: "Pantalones y joggers",
							link: "/collection/pantalones-y-joggers",
							isHighlightLink: false
						},
						{
							link: "/category/cat14030481/Poleras",
							label: "Polerones",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat4100472/Jeans",
							label: "Jeans"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Chompas y Sweaters",
							link: "/category/cat4100476/Chompas-y-sweaters"
						},
						{
							link: "/category/cat4100478/Casacas",
							label: "Casacas",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Abrigos",
							isHighlightLink: false,
							link: "/category/cat4100477/Abrigos"
						},
						{
							label: "Blusas",
							isHighlightLink: false,
							link: "/category/cat4100467/Blusas"
						},
						{
							isHighlightLink: false,
							label: "Vestidos y Enterizos",
							link: "/category/cat4100470/Vestidos-y-Enterizos"
						},
						{
							label: "Faldas",
							isHighlightLink: false,
							link: "/category/cat4100471/Faldas"
						},
						{
							link: "/collection/shorts-mujer",
							label: "Shorts",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat4100462/Moda-Mujer"
						}
					],
					link: "/category/cat4100462/Moda-Mujer",
					label: "Moda Mujer"
				},
				{
					link: "/category/cat7720498/Marcas-Especiales",
					leafCategories: [
						{
							link: "/collection/basement",
							label: "Basement",
							isHighlightLink: false
						},
						{
							label: "Mango",
							link: "/category/cat1220463/Mango",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Sybilla",
							link: "/category/cat7720508/Sybilla"
						},
						{
							isHighlightLink: false,
							label: "Denimlab",
							link: "/category/cat7720506/Denimlab"
						},
						{
							isHighlightLink: false,
							link: "/category/cat4400473/University-Club",
							label: "University Club"
						},
						{
							label: "Mossimo",
							isHighlightLink: false,
							link: "/category/cat7720509/Mossimo"
						},
						{
							isHighlightLink: false,
							label: "Doo Australia",
							link: "/category/cat7720507/Doo-Australia"
						},
						{
							meatStickerOption: 0,
							label: "American Abbey",
							link: "/category/cat15170477/American-Abbey",
							isHighlightLink: false
						},
						{
							label: "Vero Moda",
							link: "/collection/vero-moda",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Jacqueline De Yong",
							link: "/collection/jacqueline-de-yong"
						},
						{
							link: "/collection/only",
							isHighlightLink: false,
							label: "Only"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat13640465/Superdry",
							label: "Superdry"
						},
						{
							isHighlightLink: false,
							label: "Springfield",
							link: "/category/cat12710478/Springfield"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat12630462/Maison-1.2.3",
							label: "Maison 1.2.3",
							isHighlightLink: false
						},
						{
							label: "Cortefiel",
							meatStickerOption: 0,
							link: "/category/cat7720505/Cortefiel",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat15360476/Tommy-Hilfiger",
							isHighlightLink: false,
							label: "Tommy Hilfiger"
						},
						{
							meatStickerOption: 0,
							label: "Elle",
							isHighlightLink: false,
							link: "/category/cat7840494/Elle"
						},
						{
							label: "Violeta",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10470462/Violeta"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Apology",
							link: "/category/cat4480634/Apology"
						},
						{
							link: "/category/cat7840498/Newport",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Newport"
						},
						{
							label: "Stefano Cocci",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/stefano-cocci"
						},
						{
							link: "/collection/naf-naf",
							label: "Naf Naf",
							isHighlightLink: false
						}
					],
					label: "Marcas Especiales"
				},
				{
					label: "Solo Jeans",
					link: "/collection/solo-jeans",
					leafCategories: [
						{
							label: "Mom",
							link: "/collection/mom-fit",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Jogger",
							link: "/collection/jogger-fit"
						},
						{
							isHighlightLink: false,
							label: "High",
							link: "/collection/high-fit"
						},
						{
							label: "Skinny",
							link: "/collection/skinny-fit",
							isHighlightLink: false
						},
						{
							label: "Slouchy",
							link: "/collection/slouchy-fit",
							isHighlightLink: false
						},
						{
							link: "/collection/palazzo-fit",
							label: "Palazzo",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Casacas Jeans",
							link: "/collection/casacas-de-jeans"
						},
						{
							isHighlightLink: true,
							link: "/collection/solo-jeans",
							label: "Ver todo"
						}
					]
				},
				{
					link: "/category/cat7720500/Lenceria-y-Ropa-Interior",
					leafCategories: [
						{
							label: "Sostenes",
							link: "/category/cat7730462/Sostenes",
							isHighlightLink: false
						},
						{
							link: "/category/cat7730463/Calzones",
							label: "Calzones",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Pijamas Mujer",
							link: "/category/cat7730468/Pijamas-Mujer"
						},
						{
							isHighlightLink: false,
							label: "Arma tu Pijama S/.49.90",
							link: "/category/cat10760472/Arma-tu-Pijama-S-.49.90"
						},
						{
							isHighlightLink: false,
							label: "Batas",
							link: "/category/cat7730461/Batas"
						},
						{
							link: "/category/cat12980475/Camisetas-y-Fajas",
							label: "Camisetas y Fajas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Pantuflas Mujer",
							link: "/category/cat7730467/Pantuflas-Mujer"
						},
						{
							isHighlightLink: false,
							label: "Panties y Medias",
							link: "/category/cat7730466/Panties-y-Medias"
						},
						{
							link: "/category/cat12970481/Ropa-Interior-SALE",
							isHighlightLink: false,
							label: "Ropa Interior SALE"
						},
						{
							link: "/category/cat7720500/Lenceria-y-Ropa-Interior",
							label: "Ver todo",
							isHighlightLink: true
						}
					],
					label: "Lencería y Ropa Interior"
				},
				{
					leafCategories: [
						{
							link: "/collection/t-shop",
							meatStickerOption: 0,
							label: "T-shop",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Tus Personajes Favoritos",
							link: "/collection/licencias ",
							meatStickerOption: 0
						},
						{
							label: "Packs",
							isHighlightLink: false,
							link: "/collection/packs",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Denim a S/.69.00",
							meatStickerOption: 0,
							link: "/category/cat14050486/Denim"
						},
						{
							isHighlightLink: false,
							label: "Moda Sustentable",
							meatStickerOption: 0,
							link: "/collection/mujer-eco"
						},
						{
							link: "/collection/special-price-sybilla",
							isHighlightLink: false,
							label: "Special Price Sybilla"
						},
						{
							isHighlightLink: false,
							link: "/collection/jeans-a-49-90 ",
							meatStickerOption: 0,
							label: "Jeans Sybilla a 49.9"
						},
						{
							link: "/category/cat13960538/Moda-Señora",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Moda Señora"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/hecho-en-peru",
							label: "Hecho en Perú"
						},
						{
							label: "Ropa Maternal",
							isHighlightLink: false,
							link: "/category/cat9360472/Ropa-Maternal"
						},
						{
							link: "/collection/tallas-grandes",
							isHighlightLink: false,
							label: "Plus Size"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat11460481/Ropas-de-bano-bikini ",
							label: "Ropas de Baño",
							isHighlightLink: false
						},
						{
							label: "Ver todo",
							link: "/category/cat9360466/Especiales",
							isHighlightLink: true
						}
					],
					link: "/category/cat9360466/Especiales",
					label: "Especiales"
				}
			]
		},
		{
			link: "cat7720462",
			subCategories: [
				{
					link: "/collection/moda-adulto",
					leafCategories: [
						{
							link: "/collection/vestuario-adulto-polos",
							meatStickerOption: 0,
							label: "Polos Adulto",
							isHighlightLink: false
						},
						{
							link: "/collection/vestuario-hombre-polos-con-cuello",
							meatStickerOption: 0,
							label: "Polos con cuello",
							isHighlightLink: false
						},
						{
							label: "Shorts Adulto",
							link: "/collection/vestuario-adulto-shorts",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Camisas Manga Corta",
							link: "/collection/vestuario-adulto-camisas-manga-corta",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/collection/vestuario-adulto-camisas-manga-larga",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Camisas Manga Larga"
						},
						{
							label: "Poleras Adulto",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/vestuario-adulto-poleras"
						},
						{
							link: "/collection/vestuario-adulto-casacas",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Casacas Adulto"
						},
						{
							isHighlightLink: false,
							link: "/collection/vestuario-adulto-chalecos",
							label: "Chalecos Adulto",
							meatStickerOption: 0
						},
						{
							label: "Pantalones Adulto",
							isHighlightLink: false,
							link: "/collection/vestuario-hombre-pantalones",
							meatStickerOption: 0
						},
						{
							label: "Ver todo Moda Adulto",
							link: "collection/moda-adulto",
							isHighlightLink: true
						}
					],
					verTodoActive: true,
					label: "Moda Adulto"
				},
				{
					verTodoActive: true,
					link: "/collection/marcas-adulto",
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/category/cat7720468/Basement",
							label: "Basement",
							isHighlightLink: false
						},
						{
							label: "Newport",
							link: "/category/cat7840486/Newport",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7840490/University-Club",
							label: "University Club"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "La Martina",
							link: "/category/cat7720471/La-Martina"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Christian Lacroix",
							link: "/category/cat7840481/Christian-Lacroix"
						},
						{
							isHighlightLink: false,
							label: "Mango",
							meatStickerOption: 0,
							link: "/category/cat10290525/Mango"
						},
						{
							meatStickerOption: 0,
							label: "Polo Ralph Lauren",
							isHighlightLink: false,
							link: "/category/cat7720474/Polo-Ralph-Lauren"
						},
						{
							isHighlightLink: false,
							label: "Tommy Hilfiger",
							link: "/category/cat13300497/Tommy-Hilfiger",
							meatStickerOption: 0
						},
						{
							label: "Cortefiel",
							meatStickerOption: 0,
							link: "/category/cat9680463/Cortefiel",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat15340462/Wolf-Hank",
							label: "Wolf&Hank",
							isHighlightLink: false
						},
						{
							label: "Ver todo Marcas Adulto",
							isHighlightLink: true,
							link: "/collection/marcas-adulto"
						}
					],
					label: "Marcas Adulto"
				},
				{
					leafCategories: [
						{
							link: "/collection/vestuario-juvenil-polos",
							isHighlightLink: false,
							label: "Polos Juvenil",
							meatStickerOption: 0
						},
						{
							link: "/collection/vestuario-juvenil-polos-manga-larga",
							meatStickerOption: 0,
							label: "Polos Manga Larga",
							isHighlightLink: false
						},
						{
							label: "Shorts Juvenil",
							link: "/collection/vestuario-juvenil-shorts",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/collection/vestuario-juvenil-camisas-manga-corta",
							meatStickerOption: 0,
							label: "Camisas Manga Corta"
						},
						{
							label: "Camisas Manga Larga",
							meatStickerOption: 0,
							link: "/collection/vestuario-juvenil-camisas-manga-larga",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Poleras Juvenil",
							link: "/collection/vestuario-juvenil-poleras",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/vestuario-juvenil-casacas",
							label: "Casacas Juvenil"
						},
						{
							isHighlightLink: false,
							link: "/collection/vestuario-juvenil-pantalones",
							label: "Pantalones Juvenil",
							meatStickerOption: 0
						},
						{
							link: "/collection/vestuario-juvenil-joggers",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Joggers Juvenil"
						},
						{
							isHighlightLink: true,
							link: "/collection/moda-juvenil",
							label: "Ver todo Moda Juvenil"
						}
					],
					verTodoActive: true,
					label: "Moda Juvenil",
					link: "/collection/moda-juvenil"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Bearcliff",
							link: "/category/cat8320484/Bearcliff"
						},
						{
							isHighlightLink: false,
							label: "Doo Australia",
							meatStickerOption: 0,
							link: "/category/cat7720470/Doo-Australia"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Denimlab",
							link: "/category/cat7720469/Denimlab"
						},
						{
							label: "Mossimo",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat7720494/Mossimo"
						},
						{
							isHighlightLink: false,
							label: "Ecko",
							link: "/category/cat7840483/Ecko",
							meatStickerOption: 0
						},
						{
							label: "Springfield",
							isHighlightLink: false,
							link: "/category/cat7720475/Springfield",
							meatStickerOption: 0
						},
						{
							link: "/category/cat13640463/Superdry",
							isHighlightLink: false,
							label: "Superdry",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Champion",
							link: "/category/cat14360479/Champion",
							isHighlightLink: false
						},
						{
							link: "/category/cat7720492/Levis",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Levis"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7840484/Huntington",
							label: "Huntington"
						},
						{
							label: "Ver todo Marcas Juvenil",
							isHighlightLink: true,
							link: "/collection/marcas-juvenil"
						}
					],
					link: "/collection/marcas-juvenil",
					label: "Marcas Juvenil"
				},
				{
					label: "Ropa Interior",
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/collection/ropa-interior-pijamas-manga-corta",
							isHighlightLink: false,
							label: "Pijamas Manga Corta"
						},
						{
							link: "/collection/ropa-interior-pijamas-manga-larga",
							isHighlightLink: false,
							label: "Pijamas Manga Larga"
						},
						{
							label: "Boxers",
							isHighlightLink: false,
							link: "/collection/ropa-interior-boxers"
						},
						{
							label: "Pack Boxers",
							isHighlightLink: false,
							link: "/collection/ropa-interior-pack-boxers"
						},
						{
							isHighlightLink: false,
							label: "Calzoncillos",
							link: "/collection/ropa-interior-calzoncillos"
						},
						{
							isHighlightLink: false,
							link: "/collection/ropa-interior-medias",
							label: "Medias",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Pantuflas",
							link: "/collection/vestuario-hombre-pantuflas",
							meatStickerOption: 0
						},
						{
							link: "/collection/ropa-interior-camisetas",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Camisetas"
						},
						{
							link: "/category/cat4100491/Ropa-Interior",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					link: "/category/cat4100491/Ropa-Interior"
				},
				{
					label: "Especiales",
					leafCategories: [
						{
							label: "Mundo Urbano",
							isHighlightLink: false,
							link: "/collection/mundo-urbano",
							meatStickerOption: 0
						},
						{
							link: "/collection/mundo-organico",
							label: "Mundo Orgánico",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Mundo Surf",
							isHighlightLink: false,
							link: "/collection/mundo-surf",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Polos Licencias",
							isHighlightLink: false,
							link: "/collection/polos-licencias-hombre"
						},
						{
							link: "/category/cat7720465/fit-jeans",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Fit Jeans"
						},
						{
							isHighlightLink: false,
							label: "Liquidación Surf",
							link: "/collection/liquidacion-surf",
							meatStickerOption: 0
						},
						{
							label: "Ous Moda Hombre",
							isHighlightLink: false,
							link: "/collection/ous-moda-hombre",
							meatStickerOption: 0
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat13870473/Especiales"
						}
					],
					link: "/category/cat13870473/Tendencias"
				},
				{
					label: "Solo Jeans",
					verTodoActive: true,
					link: "/category/cat7720465/Jeans",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat10750469/Skinny",
							meatStickerOption: 0,
							label: "Skinny"
						},
						{
							meatStickerOption: 0,
							label: "Super Skinny",
							link: "/category/cat10750470/Super-skinny",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Slim",
							isHighlightLink: false,
							link: "/category/cat10750461/Slim"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Regular",
							link: "/category/cat11070524/Regular"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Jogger",
							link: "/category/cat11010507/Jogger"
						},
						{
							label: "Casacas",
							link: "/category/cat13000534/Casacas",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Ver todo Solo Jeans",
							isHighlightLink: true,
							link: "/category/cat7720465/Jeans"
						}
					]
				},
				{
					link: "/category/cat7230497/Accesorios",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Billeteras Juvenil",
							link: "/collection/accesorios-juvenil-billeteras"
						},
						{
							isHighlightLink: false,
							link: "/collection/accesorios-adulto-billeteras",
							label: "Billeteras Adulto"
						},
						{
							label: "Bolsos",
							isHighlightLink: false,
							link: "/collection/accesorios-hombre-bolsos"
						},
						{
							meatStickerOption: 0,
							link: "/collection/accesorios-hombre-maletines",
							label: "Maletines",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Mochilas",
							link: "/collection/accesorios-hombre-mochilas"
						},
						{
							link: "/collection/accesorios-hombre-correas",
							label: "Correas",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/accesorios-adulto-gorras",
							label: "Gorras Adulto"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Gorras Juvenil",
							link: "/collection/accesorios-juvenil-gorras"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/accesorios-hombre-lentes",
							label: "Lentes"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat7230497/Accesorios"
						}
					],
					label: "Accesorios"
				}
			],
			label: "Moda Hombre"
		},
		{
			link: "cat11510475",
			bannerLocation: "urlToImage",
			label: "Moda Infantil",
			subCategories: [
				{
					leafCategories: [
						{
							label: "Accesorios Niñas",
							isHighlightLink: false,
							link: "/category/cat11180470/Accesorios-Ninas-2-a-8",
							meatStickerOption: 0
						},
						{
							label: "Buzos y Conjuntos",
							link: "/category/cat14620479/Buzos-y-Conjuntos-2-a-8",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Casacas y Abrigos",
							link: "/category/cat7350592/Casacas-y-Abrigos-2-a-8"
						},
						{
							link: "/category/cat7350591/Chompas-y-Poleras-2-a-8",
							isHighlightLink: false,
							label: "Chompas y Poleras",
							meatStickerOption: 0
						},
						{
							label: "Pijamas y Ropa interior",
							isHighlightLink: false,
							link: "/category/cat7350593/Pijamas-y-Ropa-interior-2-a-8",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Polos y Blusas",
							link: "/category/cat7350588/Polos-y-Camisas-2-a-8",
							isHighlightLink: false
						},
						{
							link: "/category/cat7350594/Ropa-de-bano-2-a-8",
							meatStickerOption: 0,
							label: "Ropas de baño",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Shorts y Pantalones",
							link: "/category/cat7350590/Pantalones-y-Jeans-2-a-8",
							meatStickerOption: 0
						},
						{
							label: "Vestidos y Faldas",
							meatStickerOption: 0,
							link: "/category/cat7350589/Vestidos-y-Faldas-2-a-8",
							isHighlightLink: false
						},
						{
							link: "/category/cat7350564/Ninas-2-a-8-anos",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					verTodoActive: true,
					label: "Ropa Niñas 2-8",
					link: "/category/cat7350564/Ninas-2-a-8-anos"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Accesorios Niños",
							isHighlightLink: false,
							link: "/category/cat11180471/Accesorios-Ninos-2-a-8"
						},
						{
							isHighlightLink: false,
							link: "/category/cat14620478/Buzos-y-Conjuntos-2-a-8",
							meatStickerOption: 0,
							label: "Buzos y Conjuntos"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Casacas y Abrigos",
							link: "/category/cat7350570/Casacas-y-Abrigos-2-a-8"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7350569/Chompas-y-Poleras-2-a-8",
							label: "Chompas y Poleras"
						},
						{
							link: "/category/cat7350571/Pijamas-y-Ropa-interior-2-a-8",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Pijamas y Ropa interior"
						},
						{
							link: "/category/cat7350567/Polos-y-Camisas-2-a-8",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Polos y Camisas"
						},
						{
							link: "/category/cat7350572/Ropa-de-bano-2-a-8",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ropas de baño"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat7350568/Pantalones-y-Jeans-2-a-8",
							label: "Shorts y Pantalones"
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat7350562/Ninos-2-a-8-anos"
						}
					],
					label: "Ropa Niños 2-8",
					link: "/category/cat7350562/Ninos-2-a-8-anos"
				},
				{
					link: "/category/cat7350565/Ninas-8-a-16-anos",
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Buzos y Conjuntos",
							link: "/category/cat14620487/Buzos-y-Conjuntos-8-a-16",
							isHighlightLink: false
						},
						{
							link: "/category/cat7350585/Casacas-y-Abrigos-8-a-16",
							isHighlightLink: false,
							label: "Casacas y Abrigos",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat7350584/Chompas-y-Poleras-8-a-16",
							isHighlightLink: false,
							label: "Chompas y Poleras"
						},
						{
							label: "Pijamas y Ropa interior",
							meatStickerOption: 0,
							link: "/category/cat7350586/Pijamas-y-Ropa-interior-8-a-16",
							isHighlightLink: false
						},
						{
							label: "Polos y Blusas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7350580/Polos-y-Camisas-8-a-16"
						},
						{
							link: "/category/cat6630617/Ropa-deportiva-8-a-16",
							meatStickerOption: 0,
							label: "Ropa deportiva",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Ropas de baño",
							isHighlightLink: false,
							link: "/category/cat7350587/Ropa-de-bano-8-a-16"
						},
						{
							label: "Shorts y Pantalones",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14620485/Pantalones-y-Jeans-8-a-16"
						},
						{
							label: "Vestidos y Faldas",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat7350583/Vestidos-y-Faldas-8-a-16"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat7350565/Ninas-8-a-16-anos"
						}
					],
					label: "Teens Niñas 8 - 16"
				},
				{
					label: "Teens Niños 8 - 16",
					link: "/category/cat7350563/Ninos-8-a-16-anos",
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/category/cat14620482/Buzos-y-Conjuntos-8-a-16",
							isHighlightLink: false,
							label: "Buzos y Conjuntos"
						},
						{
							link: "/category/cat7350577/Casacas-Abrigos-y-Chalecos-8-a-16",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Casacas y Abrigos"
						},
						{
							label: "Chompas y Poleras",
							isHighlightLink: false,
							link: "/category/cat7350575/Chompas-y-Poleras-8-a-16",
							meatStickerOption: 0
						},
						{
							label: "Pijamas y Ropa interior",
							link: "/category/cat7350578/Polos-y-Camisas-8-a-16",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat7350573/Polos-y-Camisas-8-a-16",
							label: "Polos y Camisas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ropa deportiva",
							link: "/category/cat12570468/Ropa-deportiva-8-a-16"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat7350579/Ropa-de-bano-8-a-16",
							label: "Ropas de baño"
						},
						{
							link: "/category/cat14620481/Pantalones-y-Jeans-8-a-16",
							label: "Shorts y Pantalones",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							link: "/category/cat7350563/Ninos-8-a-16-anos",
							label: "Ver todo"
						}
					],
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Básicos para bebé",
							meatStickerOption: 0,
							link: "https://www.falabella.com.pe/falabella-pe/collection/basicos-de-bebe"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Accesorios",
							link: "/category/cat14190544/Accesorios-Bebe"
						},
						{
							isHighlightLink: false,
							label: "Bodys",
							link: "/category/cat14620473/Bodys-Bebe",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14620475/Enterizos-Bebe",
							label: "Enterizos"
						},
						{
							isHighlightLink: false,
							label: "Casacas y Abrigos",
							link: "/category/cat14190536/Casacas-Abrigos-y-Chalecos-Bebe",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat14190538/Chompas-y-Polerones-Bebe",
							meatStickerOption: 0,
							label: "Chompas y Polerones"
						},
						{
							isHighlightLink: false,
							label: "Pijamas y Ropa Interior",
							meatStickerOption: 0,
							link: "/category/cat14190543/Pijamas-y-Ropa-Interior-Bebe"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Polos Blusas y Camisas",
							link: "/category/cat14190540/Polos-Blusas-y-Camisas-Bebe"
						},
						{
							isHighlightLink: false,
							label: "Ropas de Baño",
							meatStickerOption: 0,
							link: "/category/cat14190545/Trajes-de-bano-Bebe"
						},
						{
							label: "Shorts y Pantalones",
							link: "/category/cat14190539/Pantalones-Jeans-y-Leggings-Bebe",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Vestidos y Faldas",
							link: "/category/cat14190542/Vestidos-y-Faldas-Bebe",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat7350561/Ropa-para-bebe",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					link: "/category/cat7350561/Ropa-para-bebe",
					verTodoActive: true,
					label: "Ropa para bebe"
				},
				{
					label: "Liquidación!",
					link: "https://www.falabella.com.pe/falabella-pe/collection/liquidacion-vestuario-infantil ",
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Ropa de 0 a 2 años",
							meatStickerOption: 0,
							link: "/collection/liquidacion-0-a-2-anos"
						},
						{
							link: "/collection/liquidacion-2-a-8-anos",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ropa de 2 a 8 años"
						},
						{
							meatStickerOption: 0,
							label: "Ropa de 8 a 16 años",
							link: "/collection/liquidacion-8-a-16-anos",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Ver todo",
							link: "/collection/liquidacion-vestuario-infantil",
							isHighlightLink: false
						}
					]
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Yamp",
							link: "/category/cat11160489/Yamp"
						},
						{
							label: "Eleven",
							link: "/category/cat11160491/Eleven",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Federation",
							link: "/category/cat11160494/Federation",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/collection/mango-kids",
							isHighlightLink: false,
							label: "Mango Kids"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13110486/Tus-Personajes-Favoritos",
							meatStickerOption: 0,
							label: "Personajes Favoritos"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat11990481/Barbie",
							label: "Barbie"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Coniglio",
							link: "/category/cat11160496/Coniglio"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat11160495/Doo-Australia",
							label: "Doo Australia",
							isHighlightLink: false
						},
						{
							link: "/category/cat13960523/Diadora",
							isHighlightLink: false,
							label: "Diadora",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Name It",
							meatStickerOption: 0,
							link: "/category/cat12960461/Name-It"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Baby Club Chic",
							link: "/category/cat13940499/Baby-Club-Chic"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat13060569/Nike",
							label: "Nike",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Adidas",
							link: "/category/cat13060568/Adidas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "https://www.falabella.com.pe/falabella-pe/collection/puma-kids",
							label: "Puma Kids",
							meatStickerOption: 0
						},
						{
							label: "Offcorss",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/collection/offcorss"
						},
						{
							link: "/category/cat11160488/Marcas-Destacadas",
							label: "Ver todo",
							isHighlightLink: true
						}
					],
					label: "Marcas",
					link: "/category/cat11160488/Marcas-Destacadas"
				}
			]
		},
		{
			label: "Juguetería y Mundo Bebé",
			link: "cat40628",
			subCategories: [
				{
					link: "/category/cat11810534/Juguetes",
					label: "Juguetes",
					leafCategories: [
						{
							link: "/category/cat11810536/Carros-y-Pistas",
							isHighlightLink: false,
							label: "Carros y Pistas"
						},
						{
							label: "Cocinitas y Juego de Roles",
							isHighlightLink: false,
							link: "/category/cat11810537/Cocinas-y-Juego-de-Roles"
						},
						{
							label: "Desarrollo y Aprendizaje",
							link: "/category/cat14630461/Desarrollo-y-Aprendizaje",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Dinosaurios y Animales",
							link: "/category/cat14630462/Dinosaurios-y-Animales"
						},
						{
							link: "/category/cat11810539/Figuras-de-Accion",
							label: "Figuras de Acción y Sets",
							isHighlightLink: false
						},
						{
							link: "/category/cat800492/Juguetes-Bebe",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Juguetes Bebé"
						},
						{
							isHighlightLink: false,
							link: "/category/cat11810552/Juguetes-a-Control-Remoto-y-Drones",
							label: "Juguetes a Control Remoto y Drones"
						},
						{
							link: "/category/cat11810541/Juegos-de-Mesa",
							isHighlightLink: false,
							label: "Juegos de Mesa"
						},
						{
							isHighlightLink: false,
							label: "Lego y Armables",
							link: "/category/cat11810546/Lego-y-Armables"
						},
						{
							link: "/category/cat11810547/Manualidades-y-Arte",
							isHighlightLink: false,
							label: "Manualidades y Arte"
						},
						{
							label: "Maquillaje Infantil",
							link: "/category/cat12710486/Maquillaje-para-Ninas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Muñecas y Accesorios",
							link: "/category/cat11810549/Munecas-y-Accesorios"
						},
						{
							isHighlightLink: false,
							label: "Peluches y Mascotas interactivas",
							link: "/category/cat1630478/Peluches-y-Mascotas-interactivas"
						},
						{
							label: "Pistolas de Juguete",
							isHighlightLink: false,
							link: "/category/cat11810545/Pistolas-de-Juguete"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat13940515/Rompecabezas",
							label: "Rompecabezas",
							isHighlightLink: false
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat11810534/Juguetes"
						}
					]
				},
				{
					verTodoActive: true,
					link: "/category/cat11850461/Juegos-de-Exterior",
					label: "Juegos de Exterior",
					leafCategories: [
						{
							link: "/category/cat11810535/Autos-a-Bateria-y-Exclusivos-com",
							label: "Autos a Batería",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Bicicletas Infantiles",
							link: "/category/cat50676/Bicicletas-Infantiles",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat6630583/Camas-Elasticas",
							label: "Camas Elásticas"
						},
						{
							isHighlightLink: false,
							label: "Casitas y Juegos de Jardín",
							link: "/category/cat11810543/Casitas-y-Juegos-de-Jardin",
							meatStickerOption: 0
						},
						{
							link: "/category/cat14460491/Juguetes-Deportivos",
							label: "Juguetes deportivos",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Patines y Skates",
							meatStickerOption: 0,
							link: "/category/cat11810550/Patines-y-Skates"
						},
						{
							isHighlightLink: false,
							link: "/category/cat6630596/Piscinas--inflables-y-juegos-de-agua",
							meatStickerOption: 0,
							label: "Piscinas, Inflables y Juegos de Agua"
						},
						{
							link: "/category/cat11810553/Scooters--Triciclos-y-Correpasillos",
							label: "Scooters, Triciclos y Correpasillos",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat11850461/Juegos-de-Exterior",
							isHighlightLink: true,
							label: "Ver todo"
						}
					]
				},
				{
					label: "Marcas Juguetería",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Barbie",
							link: "/category/cat2750488/Barbie",
							meatStickerOption: 0
						},
						{
							label: "Fisher Price",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat1860472/Fisher-Price"
						},
						{
							isHighlightLink: false,
							label: "Hot Wheels",
							link: "/category/cat2750494/Hot-Wheels",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat2340508/Lego",
							isHighlightLink: false,
							label: "Lego"
						},
						{
							label: "Little Tikes",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat2750472/Little-Tikes"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "LOL",
							link: "/category/cat12780493/LOL"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1860482/Play-Doh",
							label: "Play Doh",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "https://www.falabella.com.pe/falabella-pe/collection/scoop",
							label: "Scoop"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Winfun",
							link: "/category/cat4850491/Winfun"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat5210515/Marcas-Jugueteria"
						}
					],
					link: "/category/cat5210515/Marcas-Jugueteria",
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14630463/Alimentacion-Infantil",
							label: "Alimentacion Infantil"
						},
						{
							isHighlightLink: false,
							label: "Andadores y Caminadores",
							link: "/category/cat7350538/Andadores-y-Caminadores",
							meatStickerOption: 0
						},
						{
							link: "/category/cat7350606/Bano-bebe",
							isHighlightLink: false,
							label: "Baño bebé"
						},
						{
							link: "/category/cat7350616/Bolsos-y-Portabebes",
							label: "Bolsos y portabebes",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Biberones y Chupones",
							link: "/category/cat800470/Biberones-y-Chupones"
						},
						{
							meatStickerOption: 0,
							label: "Coches para Bebés",
							link: "/category/cat800474/Coches-para-Bebes",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat7350615/Corrales--Pack-and-Play-y-Colchones",
							meatStickerOption: 0,
							label: "Corrales, Pack and Play y Colchones"
						},
						{
							label: "Gimnasios y Centro de Actividad",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat800488/Gimnasios-y-Centro-de-Actividad"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat800492/Juguetes-Bebe",
							isHighlightLink: false,
							label: "Juguetes Bebé"
						},
						{
							isHighlightLink: false,
							label: "Lactancia",
							link: "/category/cat7350601/Lactancia"
						},
						{
							meatStickerOption: 0,
							label: "Móviles Infantiles",
							link: "/category/cat7350547/Moviles-Infantiles",
							isHighlightLink: false
						},
						{
							label: "Pañales y Toallitas",
							link: "/category/cat9630497/Panales-y-Toallitas",
							isHighlightLink: false
						},
						{
							link: "/category/cat7350607/Salud-y-Cuidado",
							isHighlightLink: false,
							label: "Salud y Cuidado"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Seguridad y Accesorios",
							link: "/category/cat800480/Seguridad-y-Accesorios"
						},
						{
							label: "Sillas de Comer",
							link: "/category/cat7350605/Sillas-de-Comer",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							link: "/category/cat800478/Sillas-Mecedoras-y-Columpios",
							label: "Sillas Mecedoras y Columpios",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Sillas de Auto",
							link: "/category/cat800476/Sillas-para-Auto",
							meatStickerOption: 0
						},
						{
							link: "/category/cat40497/Mundo-Bebe",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					label: "Mundo Bebé",
					link: "/category/cat40497/Mundo-Bebe"
				},
				{
					link: "/category/cat7350561/Ropa-para-bebe",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Accesorios",
							meatStickerOption: 0,
							link: "/category/cat14190544/Accesorios-Bebe"
						},
						{
							meatStickerOption: 0,
							label: "Bodys",
							link: "/category/cat14620473/Bodys-Bebe",
							isHighlightLink: false
						},
						{
							link: "/category/cat14190536/Casacas-Abrigos-y-Chalecos-Bebe",
							meatStickerOption: 0,
							label: "Casacas y Chalecos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Chompas y Poleras",
							link: "/category/cat14190538/Chompas-y-Polerones-Bebe"
						},
						{
							isHighlightLink: false,
							link: "/category/cat14620475/Enterizos-Bebe",
							meatStickerOption: 0,
							label: "Enterizos"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat14190543/Pijamas-y-Ropa-Interior-Bebe",
							isHighlightLink: false,
							label: "Pijamas y Ropa Interior"
						},
						{
							link: "/category/cat14190540/Polos-Blusas-y-Camisas-Bebe",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Polos, Blusas y Camisas"
						},
						{
							link: "/category/cat14190545/Trajes-de-bano-Bebe",
							isHighlightLink: false,
							label: "Ropas de Baño",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Shorts y Pantalones",
							link: "/category/cat14190539/Pantalones-Jeans-y-Leggings-Bebe"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat14190542/Vestidos-y-Faldas-Bebe",
							isHighlightLink: false,
							label: "Vestidos y Faldas"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat7350561/Ropa-para-bebe"
						}
					],
					label: "Ropa para bebé",
					verTodoActive: true
				},
				{
					label: "Marcas Mundo Bebés",
					verTodoActive: true,
					leafCategories: [
						{
							link: "/category/cat2750474/Avent",
							isHighlightLink: false,
							label: "Avent",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Infanti",
							link: "/category/cat9750485/Infanti"
						},
						{
							isHighlightLink: false,
							link: "/category/cat2750471/Graco",
							meatStickerOption: 0,
							label: "Graco"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat12530470/Maternelle",
							isHighlightLink: false,
							label: "Maternelle"
						},
						{
							label: "Yamp",
							meatStickerOption: 0,
							link: "/category/cat4120462/Yamp",
							isHighlightLink: false
						},
						{
							link: "/category/cat14640461/Marcas-Mundo-Bebes",
							label: "Ver todo",
							isHighlightLink: true
						}
					],
					link: "/category/cat14640461/Marcas-Mundo-Bebes"
				},
				{
					link: "/category/cat530473/Mochilas,-Loncheras-y-Utiles",
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Útiles Escolares",
							link: "/category/cat3940465/Utiles-Escolares",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Mochilas Infantiles",
							link: "/category/cat6140462/Mochilas-Infantiles"
						},
						{
							label: "Mochilas Juveniles",
							isHighlightLink: false,
							link: "/category/cat6140463/Mochilas-Juveniles"
						},
						{
							label: "Loncheras, Tapers y Tomatodos",
							isHighlightLink: false,
							link: "/category/cat11830509/Loncheras,-Tapers-y-Tomatodos"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Cartucheras",
							link: "/category/cat9530470/Cartucheras"
						},
						{
							link: "/category/cat12090500/Libros-Infantiles",
							label: "Libros Infantiles",
							isHighlightLink: false
						},
						{
							link: "/category/cat13130463/Agendas",
							label: "Agendas",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat530473/Mochilas,-Loncheras-y-Utiles"
						}
					],
					label: "Útiles, Mochilas y Loncheras"
				}
			]
		},
		{
			subCategories: [
				{
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat40727/Perfumes",
							meatStickerOption: 0,
							label: "Perfumes"
						},
						{
							meatStickerOption: 0,
							label: "Maquillaje",
							link: "/category/cat560663/Maquillaje",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Cuidado del Rostro",
							link: "/category/cat5130511/Cuidado-del-Rostro",
							isHighlightLink: false
						},
						{
							link: "/category/cat11140487/Dermocosmetica",
							isHighlightLink: false,
							label: "Dermocosmética",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat3950475/Cuidado-del-Cuerpo-y-Spa",
							label: "Cuidado del Cuerpo y Spa"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat5130510/Cuidado-Capilar",
							isHighlightLink: false,
							label: "Cuidado Capilar"
						},
						{
							label: "Cuidado Personal Hombre",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat6530467/Cuidado-Personal-Hombre"
						}
					],
					label: "Belleza",
					link: "/page/Mundo-Belleza?staticPageId=8900002"
				},
				{
					leafCategories: [
						{
							label: "Mujer",
							link: "/category/cat40703/Perfumes-de-Mujer",
							isHighlightLink: false
						},
						{
							link: "/category/cat560665/Perfumes-de-Hombre",
							label: "Hombre",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat9090469/Sets-de-perfumes",
							label: "Sets "
						},
						{
							isHighlightLink: false,
							label: "Buy & Try  ",
							link: "/page/Buy-and-try?staticPageId=25300003"
						},
						{
							label: "Ver todo",
							link: "/category/cat40727/Perfumes",
							isHighlightLink: true
						}
					],
					label: "Perfumes",
					link: "/category/cat40727/Perfumes"
				},
				{
					link: "/category/cat560663/Maquillaje",
					leafCategories: [
						{
							label: "Labios",
							link: "/category/cat560679/Maquillaje-de-labios",
							isHighlightLink: false
						},
						{
							link: "/category/cat560675/Maquillaje-de-rostro",
							label: "Rostro",
							isHighlightLink: false
						},
						{
							link: "/category/cat12000461/Maquillaje-de-cejas",
							label: "Cejas",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Ojos",
							link: "/category/cat560673/Maquillaje-de-ojos"
						},
						{
							label: "Minis",
							isHighlightLink: false,
							link: "/category/cat13460464/Minis"
						},
						{
							isHighlightLink: false,
							label: "Cuidado de uñas",
							link: "/category/cat560677/Esmalte-de-unas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7230486/Maquillaje-en-Oferta",
							label: "Maquillaje en Oferta"
						},
						{
							link: "/category/cat560663/Maquillaje",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					label: "Maquillaje"
				},
				{
					link: "/category/cat5130511/Cuidado-del-Rostro",
					leafCategories: [
						{
							link: "/category/cat5130512/Limpiadores-Faciales",
							isHighlightLink: false,
							label: "Limpiadores Faciales"
						},
						{
							label: "Hidratantes Faciales",
							isHighlightLink: false,
							link: "/category/cat5130515/Hidratantes-Faciales"
						},
						{
							isHighlightLink: false,
							link: "/category/cat5130516/Tratamiento-Facial",
							label: "Tratamiento Facial"
						},
						{
							label: "Mascarillas",
							link: "/category/cat13450463/Mascarillas",
							isHighlightLink: false
						},
						{
							link: "/category/cat5130517/Tratamiento-de-ojos",
							isHighlightLink: false,
							label: "Tratamiento de ojos"
						},
						{
							isHighlightLink: false,
							label: "Necesidades específicas",
							link: "/category/cat5130520/Necesidades-especificas"
						},
						{
							isHighlightLink: false,
							link: "/category/cat9550461/Sets-de-rostro",
							label: "Sets de rostro"
						},
						{
							link: "/category/cat5130511/Cuidado-del-Rostro",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					label: "Cuidado del Rostro"
				},
				{
					leafCategories: [
						{
							link: "/category/cat6520594/Manos-y-pies",
							isHighlightLink: false,
							label: "Manos y pies"
						},
						{
							label: "Tratamientos corporales",
							link: "/category/cat6520592/Tratamientos-corporales",
							isHighlightLink: false
						},
						{
							label: "Baño, Masajes y Aromaterapia",
							link: "/category/cat7230474/Bano,-Masajes-y-Aromaterapia",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Depilación",
							isHighlightLink: false,
							link: "/category/cat14130497/Depilacion"
						},
						{
							label: "Vitaminas y Suplementos",
							isHighlightLink: false,
							link: "/category/cat7230475/Vitaminas-y-Suplementos"
						},
						{
							label: "Bloqueadores y Bronceadores",
							isHighlightLink: false,
							link: "/category/cat3950477/Bloqueadores-y-Bronceadores"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat3950475/Cuidado-del-Cuerpo-y-Spa"
						}
					],
					link: "/category/cat3950475/Cuidado-del-Cuerpo-y-Spa",
					label: "Cuidado del Cuerpo y Spa"
				},
				{
					label: "Cuidado Capilar",
					link: "/category/cat5130510/Cuidado-Capilar",
					leafCategories: [
						{
							link: "/category/cat760682/Shampoo",
							label: "Shampoo",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat11390486/Acondicionador-y-Mascarilla",
							label: "Acondicionador"
						},
						{
							isHighlightLink: false,
							label: "Sets cuidado capilar",
							meatStickerOption: 0,
							link: "/category/cat13920494/Sets"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13920495/Tratamientos-capilares---Styling",
							meatStickerOption: 0,
							label: "Styling y tratamientos"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat13920507/Hombres-y-Barberia",
							isHighlightLink: false,
							label: "Barbería"
						},
						{
							meatStickerOption: 0,
							label: "Tintes",
							link: "/category/cat13920493/Tintes?isPLP=1",
							isHighlightLink: false
						},
						{
							link: "/category/cat40771/Secadoras-de-Cabello",
							isHighlightLink: false,
							label: "Secadoras de Cabello"
						},
						{
							isHighlightLink: false,
							link: "/category/cat40479/Alisadoras-y-Rizadores",
							label: "Alisadoras y Rizadores"
						},
						{
							label: "Ver todo",
							isHighlightLink: true,
							link: "/category/cat13920492/Por-tipo"
						}
					]
				},
				{
					link: "/category/cat6530467/Cuidado-Personal-Hombre",
					label: "Cuidado Personal Hombre",
					leafCategories: [
						{
							label: "Perfumes de Hombre",
							link: "/category/cat560665/Perfumes-de-Hombre",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Tratamientos Faciales Hombre",
							link: "/category/cat5130518/Tratamientos-Faciales-Hombre"
						},
						{
							isHighlightLink: false,
							label: "Cremas de afeitar",
							link: "/category/cat6530468/Cremas-de-afeitar"
						},
						{
							isHighlightLink: false,
							label: "Barbería y tratamiento capilar",
							link: "/category/cat13150464/Barberia-y-tratamiento-capilar"
						},
						{
							link: "/category/cat6530467/Cuidado-Personal-Hombre",
							isHighlightLink: true,
							label: "Ver todo"
						}
					]
				},
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Kerastase",
							isHighlightLink: false,
							link: "/category/cat8020468/Kerastase"
						},
						{
							meatStickerOption: 0,
							label: "Estée Lauder",
							link: "/category/cat2240481/Estee-Lauder?isPLP=1",
							isHighlightLink: false
						},
						{
							label: "Carolina Herrera",
							link: "/category/cat2730484/Carolina-Herrera",
							isHighlightLink: false
						},
						{
							label: "MAC",
							link: "/category/cat5810485/MAC",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat13940461/Shiseido",
							label: "Shiseido"
						},
						{
							link: "/page/Dior?staticPageId=22200006",
							label: "DIOR",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							label: "Paco Rabanne",
							link: "/category/cat2740463/Paco-Rabanne",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat11990507/Benefit?isLanding=true",
							label: "Benefit"
						},
						{
							link: "/category/cat2610467/Marcas-de-Belleza",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					label: "Marcas de Belleza",
					link: "/category/cat2610467/Marcas-de-Belleza"
				},
				{
					verTodoActive: true,
					link: "https://reservasbellezafalabella.simplybook.me/v2/",
					label: "Belleza Studio",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "https://reservasbellezafalabella.simplybook.me/v2/",
							meatStickerOption: 0,
							label: "Reserva tu clase virtual"
						}
					]
				},
				{
					label: "SALE!",
					link: "/category/cat14890464/Liquidacion-Belleza",
					verTodoActive: true,
					leafCategories: [
						{
							label: "Beauty Sale",
							link: "/category/cat15540465/Beauty-Days ",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							label: "Las mejores ofertas",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14890464/Liquidacion-Belleza"
						}
					]
				}
			],
			link: "cat40498",
			label: "Belleza"
		},
		{
			bannerLocation: "urlToImage",
			link: "cat11140487",
			subCategories: [
				{
					leafCategories: [
						{
							link: "/category/cat13810474/Rostro",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Rostro"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ojos",
							link: "/category/cat13810475/Ojos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13810476/Serum",
							label: "Sérum",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							label: "Cremas",
							isHighlightLink: false,
							link: "/category/cat13810477/Cremas"
						},
						{
							isHighlightLink: true,
							link: "/category/cat13810473/Antiedad",
							label: "Ver todo Antiedad"
						}
					],
					label: "Antiedad",
					link: "/category/cat13810473/Antiedad",
					verTodoActive: true
				},
				{
					label: "Hidratantes",
					leafCategories: [
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Agua termal",
							link: "/category/cat13810482/Agua-termal"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Manos",
							link: "/category/cat13810481/Manos"
						},
						{
							link: "/category/cat13810480/Corporales",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Corporales"
						},
						{
							label: "Faciales",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat13810479/Faciales"
						},
						{
							link: "/category/cat13810478/Hidratantes",
							label: "Ver todo Hidratantes",
							isHighlightLink: true
						}
					],
					link: "/category/cat13810478/Hidratantes",
					verTodoActive: true
				},
				{
					link: "/category/cat13810483/Limpieza-Facial",
					leafCategories: [
						{
							meatStickerOption: 0,
							label: "Exfoliantes",
							link: "/category/cat13810487/Exfoliantes",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Espumas limpiadoras",
							link: "/category/cat13810486/Espumas-limpiadoras"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13810485/Desmaquilladores",
							label: "Desmaquillantes",
							meatStickerOption: 0
						},
						{
							label: "Agua Micelar",
							isHighlightLink: false,
							link: "/category/cat13810484/Agua-Micelar",
							meatStickerOption: 0
						},
						{
							label: "Ver todo Limpieza Facial",
							link: "/category/cat13810483/Limpieza-Facial",
							isHighlightLink: true
						}
					],
					verTodoActive: true,
					label: "Limpieza Facial"
				},
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Antiestrías",
							link: "/category/cat13810492/Antiestrías"
						},
						{
							isHighlightLink: false,
							label: "Bloqueadores solares",
							link: "/category/cat11140481/Bloqueadores-solares",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat13810490/Hidratantes",
							isHighlightLink: false,
							label: "Hidratantes"
						},
						{
							link: "/category/cat13810491/Baño",
							label: "Baño",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat13810488/Mamas-y-Bebes",
							isHighlightLink: true,
							label: "Ver todo Mamás y Bebés"
						}
					],
					verTodoActive: true,
					link: "/category/cat13810488/Mamas-y-Bebes",
					label: "Mamás y Bebés"
				},
				{
					verTodoActive: true,
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat13820461/Rostro",
							label: "Rostro",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Cuerpo",
							link: "/category/cat13820462/Cuerpo",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							link: "/category/cat13820463/Bebes",
							meatStickerOption: 0,
							label: "Pediátricos"
						},
						{
							isHighlightLink: true,
							link: "/category/cat13810493/Bloqueadores-Solares",
							label: "Ver todo Bloqueadores solares"
						}
					],
					label: "Bloqueadores solares",
					link: "/category/cat13810493/Bloqueadores-Solares"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Anticaspa",
							link: "/category/cat13820467/Anticaspa",
							meatStickerOption: 0
						},
						{
							link: "/category/cat13820466/anticaída",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Anticaída"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Shampoo",
							link: "/category/cat13820465/shampoo"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Capilar",
							link: "/category/cat13820464/Capilar"
						}
					],
					verTodoActive: true,
					link: "/category/cat13820464/Capilar",
					label: "Capilar"
				},
				{
					link: "/category/cat13820468/Soluciones-Dermatologicas",
					label: "Soluciones dermatológicas",
					leafCategories: [
						{
							link: "/category/cat13820473/Piel-Sensible",
							isHighlightLink: false,
							label: "Piel sensible",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Piel seca",
							link: "/category/cat13820472/Piel-Seca"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Piel grasa",
							link: "/category/cat13820471/Piel-Grasa"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13820470/Cicatrizacion",
							label: "Cicatrización",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/category/cat13820469/Antimanchas",
							label: "Antimanchas",
							isHighlightLink: false
						},
						{
							label: "Acné",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat11280470/Acne"
						},
						{
							isHighlightLink: true,
							link: "/category/cat13820468/Soluciones-Dermatologicas",
							label: "Ver todo Soluciones Dermatológicas"
						}
					],
					verTodoActive: true
				},
				{
					link: "/category/cat13820474/Marcas",
					leafCategories: [
						{
							link: "/collection/eucerin\t",
							label: "Eucerin",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/category/cat14950466/Neutrogena",
							label: "Neutrogena"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Bioderma",
							link: "/category/cat11290462/Bioderma"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Uriage",
							link: "/category/cat13030519/Uriage"
						},
						{
							meatStickerOption: 0,
							label: "Isdin",
							isHighlightLink: false,
							link: "/category/cat10070461/Isdin"
						},
						{
							link: "/category/cat11240503/La-Roche-Posay",
							label: "La Roche Posay",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							link: "/category/cat13060470/Cellskinlab",
							meatStickerOption: 0,
							label: "Cellskinlab",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Endocare",
							link: "/category/cat13700494/"
						},
						{
							link: "/category/cat11990465/cerave",
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Cerave"
						},
						{
							label: "Skinlab",
							meatStickerOption: 0,
							link: "/category/cat13530464/Skinlab",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Urbio",
							link: "/category/cat13060475/Urbio",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Sesderma",
							link: "/category/cat13940500/Sesderma"
						},
						{
							isHighlightLink: true,
							label: "Ver todo Marcas",
							link: "/category/cat13820474/Marcas"
						}
					],
					verTodoActive: true,
					label: "Marcas"
				}
			],
			label: "Dermocosmética"
		},
		{
			subCategories: [
				{
					leafCategories: [
						{
							link: "/category/cat9090486/Relojes-Mujer",
							isHighlightLink: false,
							label: "Relojes Mujer"
						},
						{
							label: "Relojes Hombre",
							link: "/category/cat9090478/Relojes-Hombre",
							isHighlightLink: false
						},
						{
							label: "Relojes Deportivos",
							link: "/category/cat10920491/Relojes-Deportivos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Relojes Lujo",
							link: "/category/cat10920492/Relojes-Lujo"
						},
						{
							label: "Smartwatch",
							isHighlightLink: false,
							link: "/category/cat10920494/Smartwatch"
						},
						{
							link: "/category/cat40758/Relojes",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					label: "Relojes",
					link: "/category/cat40758/Relojes"
				},
				{
					label: "Carteras y Mochilas",
					leafCategories: [
						{
							link: "/category/cat4220604/Carteras",
							label: "Carteras",
							isHighlightLink: false
						},
						{
							label: "Mochilas",
							isHighlightLink: false,
							link: "/category/cat7230523/Mochilas"
						},
						{
							isHighlightLink: false,
							label: "Billeteras y Monederos",
							link: "/category/cat7230525/Billeteras-y-Monederos"
						},
						{
							isHighlightLink: false,
							label: "Carteras y accesorios SALE",
							link: "/category/cat12970482/Carteras-y-accesorios-SALE"
						},
						{
							label: "Ver todo",
							link: "/category/cat7230499/Carteras-y-Mochilas",
							isHighlightLink: true
						}
					],
					link: "/category/cat7230499/Carteras-y-Mochilas"
				},
				{
					link: "/category/cat510499/Lentes",
					label: "Lentes",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat7230541/Lentes-de-Sol-Mujer",
							label: "Lentes de Sol Mujer"
						},
						{
							link: "/category/cat7230500/Lentes-de-Sol",
							isHighlightLink: false,
							label: "Lentes de Sol de Hombre"
						},
						{
							meatStickerOption: 0,
							label: "Accesorios para Lentes",
							link: "/category/cat14120466/Accesorios-para-Lentes",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Lentes de Contacto",
							meatStickerOption: 0,
							link: "/category/cat14180471/Lentes-de-contacto"
						},
						{
							label: "Lentes Blue Blocking",
							link: "/category/cat15370461/Lentes-Blue-Blocking",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat510499/Lentes",
							label: "Ver todo",
							isHighlightLink: true
						}
					]
				},
				{
					link: "/category/cat4350568/Joyeria",
					label: "Joyería",
					leafCategories: [
						{
							label: "Collares",
							link: "/category/cat7230529/Collares",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Aretes",
							link: "/category/cat7230533/Aretes"
						},
						{
							label: "Pulseras",
							isHighlightLink: false,
							link: "/category/cat7230531/Pulseras"
						},
						{
							label: "Anillos",
							isHighlightLink: false,
							link: "/category/cat7230532/Anillos"
						},
						{
							link: "/category/cat7230534/Sets-de-Joyas",
							isHighlightLink: false,
							label: "Sets de Joyas"
						},
						{
							link: "/category/cat4350568/Joyeria",
							isHighlightLink: true,
							label: "Ver todo"
						}
					]
				},
				{
					link: "/category/cat11450461/Otros-Accesorios",
					label: "Otros Accesorios",
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "https://www.falabella.com.pe/falabella-pe/category/cat14060481/PONCHOS-Y-BUFANDAS",
							label: "Ponchos y Bufandas",
							isHighlightLink: false
						},
						{
							label: "Billeteras",
							link: "/category/cat560711/Billeteras",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat7230502/Corbatas",
							label: "Corbatas"
						},
						{
							link: "/category/cat760692/Bufandas-y-panuelos",
							label: "Bufandas y pañuelos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Correas",
							link: "/category/cat7230501/Correas"
						},
						{
							label: "Gorros y Sombreros",
							isHighlightLink: false,
							link: "/category/cat11660535/Gorros-y-Sombreros"
						},
						{
							label: "Mochilas",
							link: "/category/cat7230505/Mochilas",
							isHighlightLink: false
						},
						{
							label: "Otros Accesorios Mujer",
							link: "/category/cat7840476/Otros-Accesorios-Mujer",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat11450461/Otros-Accesorios"
						}
					]
				},
				{
					leafCategories: [
						{
							label: "Michael Kors",
							isHighlightLink: false,
							link: "/category/cat5200533/Michael-Kors"
						},
						{
							isHighlightLink: false,
							link: "/category/cat1900527/Fossil",
							label: "Fossil"
						},
						{
							link: "/category/cat1900521/Casio",
							isHighlightLink: false,
							label: "Casio"
						},
						{
							label: "Basement",
							isHighlightLink: false,
							link: "/category/cat2040470/Basement"
						},
						{
							link: "/category/cat2040474/Citizen",
							isHighlightLink: false,
							label: "Citizen"
						},
						{
							isHighlightLink: false,
							link: "/category/cat7110489/Bulova",
							label: "Bulova"
						},
						{
							link: "/category/cat1900535/Tommy-Hilfiger",
							isHighlightLink: false,
							label: "Tommy Hilfiger"
						},
						{
							label: "Ver todo",
							link: "/category/cat11410461/Marcas-Relojes",
							isHighlightLink: true
						}
					],
					link: "/category/cat11410461/Marcas-Relojes",
					label: "Marcas Relojes"
				},
				{
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/category/cat11430461/Michael-Kors",
							label: "Michael Kors"
						},
						{
							isHighlightLink: false,
							label: "Aldo",
							link: "/category/cat4400467/Aldo"
						},
						{
							isHighlightLink: false,
							label: "Tous",
							link: "/category/cat10960501/Tous"
						},
						{
							isHighlightLink: false,
							label: "Basement",
							link: "/category/cat11430462/Basement"
						},
						{
							label: "Guess",
							link: "/category/cat11430465/Guess",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat11430463/Sybilla",
							label: "Sybilla"
						},
						{
							label: "Crepier",
							isHighlightLink: false,
							link: "/category/cat2750522/Crepier"
						},
						{
							label: "Elle",
							isHighlightLink: false,
							link: "/category/cat2750520/Elle"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat10110464/Mango",
							label: "Mango"
						},
						{
							isHighlightLink: true,
							link: "/category/cat2090462/Marcas-Carteras-y-Accesorios",
							label: "Ver todo"
						}
					],
					label: "Marcas Carteras y Accesorios",
					link: "/category/cat2090462/Marcas-Carteras-y-Accesorios"
				}
			],
			label: "Accesorios",
			link: "cat1870494"
		},
		{
			subCategories: [
				{
					label: "Libros",
					link: "/category/cat12100468/Libros",
					leafCategories: [
						{
							link: "/category/cat13060565/Libros-Harry-Potter",
							label: "Libros Harry Potter",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat12300463/Autoayuda",
							label: "Autoayuda"
						},
						{
							isHighlightLink: false,
							label: "Biografías y Memorias",
							link: "/category/cat12090496/Biografias-y-Memorias"
						},
						{
							isHighlightLink: false,
							link: "/category/cat12300464/Comics-y-Manga",
							label: "Cómics y Manga"
						},
						{
							link: "/category/cat12090498/Diccionarios-y-Enciclopedias",
							label: "Diccionarios y Enciclopedias",
							isHighlightLink: false
						},
						{
							link: "/category/cat12090497/Ficcion",
							label: "Ficción",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Librería Gourmet",
							link: "/category/cat13130463/Libreria-Gourmet"
						},
						{
							link: "/category/cat12090500/Libros-Infantiles",
							label: "Libros Infantiles",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Libros Técnicos",
							link: "/category/cat12090499/Libros-Tecnicos"
						},
						{
							label: "Literatura Juvenil",
							isHighlightLink: false,
							link: "/category/cat14630475/Literatura-Juvenil",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Novelas",
							link: "/category/cat12300466/Novelas"
						},
						{
							link: "/category/cat12090501/Revistas-y-Agendas",
							isHighlightLink: false,
							label: "Revistas y Agendas"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat12100468/Libros"
						}
					]
				},
				{
					label: "Instrumentos Musicales",
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Guitarras y Cuerdas",
							link: "/category/cat13270487/Guitarras-y-Cuerdas"
						},
						{
							link: "/category/cat13270491/Teclados-y-pianos",
							label: "Teclados y pianos",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							label: "Baterías y Percusión",
							link: "/category/cat13270489/Baterias-y-Percusion",
							isHighlightLink: false
						},
						{
							label: "Instrumentos de Viento",
							link: "/category/cat13270492/Instrumentos-de-Viento",
							isHighlightLink: false
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "DJ",
							link: "/category/cat14000480/DJ"
						},
						{
							link: "/category/cat13270494/Amplificacion-y-Hi-Fi",
							isHighlightLink: false,
							label: "Amplificación y Hi-Fi"
						},
						{
							label: "Ver todo",
							link: "/category/cat40630/Instrumentos-Musicales",
							isHighlightLink: true
						}
					],
					link: "/category/cat40630/Instrumentos-Musicales?isPLP=1"
				},
				{
					leafCategories: [
						{
							link: "/category/cat12500461/Alimentos-y-Snacks",
							meatStickerOption: 0,
							label: "Alimentos y Snacks",
							isHighlightLink: false
						},
						{
							label: "Casas y Camas",
							isHighlightLink: false,
							link: "/category/cat12500463/Casas-y-Camas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14110481/Collares--Correas-y-Arneses",
							label: "Collares, Correas y Arneses"
						},
						{
							isHighlightLink: false,
							label: "Higiene y Cuidados",
							link: "/category/cat12500464/Higiene-y-Cuidados"
						},
						{
							isHighlightLink: false,
							label: "Juguetes y Entrenamiento",
							link: "/category/cat12500465/Juguetes-y-Entrenamiento"
						},
						{
							label: "Platos y Bebederos",
							meatStickerOption: 0,
							isHighlightLink: false,
							link: "/category/cat14110477/Platos-y-Bebederos"
						},
						{
							meatStickerOption: 0,
							label: "Ropa y Accesorios",
							isHighlightLink: false,
							link: "/category/cat12500466/Ropa-y-Accesorios"
						},
						{
							link: "/category/cat8050466/Mundo-Mascotas",
							isHighlightLink: true,
							label: "Ver todo"
						}
					],
					label: "Mundo Mascotas",
					link: "/page/Mascotas?staticPageId=23000003"
				},
				{
					label: "Especiales",
					leafCategories: [
						{
							label: "Arreglos Florales",
							isHighlightLink: false,
							link: "/category/cat11830481/Arreglos-Florales"
						},
						{
							isHighlightLink: false,
							label: "Limpieza",
							meatStickerOption: 0,
							link: "/category/cat13920465/Limpieza"
						},
						{
							link: "/category/cat13040465/Productos-Ecologicos",
							label: "Productos Ecológicos",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/category/cat13270462/Papeleria",
							meatStickerOption: 0,
							label: "Papelería"
						},
						{
							isHighlightLink: false,
							label: "Bolsas Reutilizables",
							link: "/category/cat12330462/Bolsas-Reutilizables"
						},
						{
							isHighlightLink: false,
							link: "/category/cat11610470/Jardineria",
							label: "Jardinería"
						},
						{
							link: "/category/cat13080476/Bigbox",
							isHighlightLink: false,
							label: "Bigbox"
						},
						{
							label: "Ver todo",
							link: "/category/cat12330461/Especiales",
							isHighlightLink: true
						}
					],
					link: "/category/cat12330461/Especiales"
				},
				{
					label: "Gourmet",
					link: "/category/cat7040473/Gourmet",
					leafCategories: [
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Johnnie Walker",
							link: "/category/cat12300465/Johnnie-Walker"
						},
						{
							link: "/category/cat13380480/Aceites-y-Especias",
							label: "Aceites y Especias",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							link: "/category/cat13380481/Cafés-y-Tés",
							isHighlightLink: false,
							label: "Cafés y Tés",
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Cerveza y Espumantes",
							link: "/category/cat13380484/Cerveza-y-Espumantes"
						},
						{
							link: "/category/cat13380485/Chocolates-y-Snacks",
							isHighlightLink: false,
							label: "Chocolates y Snacks"
						},
						{
							meatStickerOption: 0,
							label: "Destilados y Licores",
							link: "/category/cat13380483/Destilados-y-Licore",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Productos Organicos",
							link: "/category/cat14630476/Productos-Organicos"
						},
						{
							isHighlightLink: false,
							link: "/category/cat13380479/Vinos-y-Accesorios",
							label: "Vinos y Accesorios"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat13380486/Otras-Bebidas",
							isHighlightLink: false,
							label: "Otras Bebidas"
						},
						{
							label: "Otros Comestibles",
							link: "/category/cat13380487/Otros-Comestibles",
							isHighlightLink: false
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat7040473/Gourmet"
						}
					]
				},
				{
					leafCategories: [
						{
							meatStickerOption: 0,
							link: "/category/cat40501/Salud-y-Bienestar",
							isHighlightLink: false,
							label: "Salud y Bienestar"
						},
						{
							meatStickerOption: 0,
							link: "/category/cat14070464/Alcohol-en-Gel",
							isHighlightLink: false,
							label: "Alcohol en gel"
						},
						{
							meatStickerOption: 0,
							label: "Mascarillas y más",
							link: "/category/cat13940501/Mascarillas-Médicas",
							isHighlightLink: false
						},
						{
							label: "Vitaminas y Suplementos",
							isHighlightLink: false,
							link: "/category/cat7230475/Vitaminas-y-Suplementos"
						},
						{
							isHighlightLink: false,
							label: "Salud Bucal",
							meatStickerOption: 0,
							link: "/category/cat14130501/Salud-Bucal"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Masajeadores",
							link: "/category/cat12940567/Masajeadores"
						},
						{
							isHighlightLink: false,
							label: "Bloqueadores solares",
							link: "/category/cat11140481/Bloqueadores-solares"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat2600464/Salud"
						}
					],
					link: "/category/cat2600464/Salud",
					label: "Salud"
				},
				{
					leafCategories: [
						{
							link: "/category/cat2660495/Parrillas",
							isHighlightLink: false,
							label: "Parrillas"
						},
						{
							isHighlightLink: false,
							label: "Cajas Chinas",
							link: "/category/cat2660496/Cajas-Chinas"
						},
						{
							link: "/category/cat11510478/Kamados",
							label: "Kamados",
							isHighlightLink: false
						},
						{
							label: "Cilindros",
							link: "/category/cat2660497/Cilindros",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Paelleras",
							link: "/category/cat7110601/Paelleras"
						},
						{
							link: "/category/cat2660501/Accesorios-y-Utensilios",
							isHighlightLink: false,
							label: "Accesorios y Utensilios"
						},
						{
							label: "Rejillas y Asadores",
							isHighlightLink: false,
							link: "/category/cat2660500/Rejillas-y-Asadores"
						},
						{
							label: "Parrillas Empotrables",
							isHighlightLink: false,
							link: "/category/cat7000466/Parrillas-Empotrables"
						},
						{
							isHighlightLink: true,
							label: "Ver todo",
							link: "/category/cat2660494/Parrillas,-Cajas-Chinas-y-mas"
						}
					],
					label: "Parrillas, Cajas Chinas y más",
					link: "/category/cat2660494/Parrillas,-Cajas-Chinas-y-mas"
				},
				{
					link: "/category/cat950500/Maleteria-y-Viajes",
					leafCategories: [
						{
							link: "/category/cat950500/Maleteria-y-Viajes",
							isHighlightLink: true,
							label: "Ver todo"
						},
						{
							link: "/category/cat980618/Accesorios-de-Viaje",
							label: "Accesorios de viaje",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Bolsos de viaje",
							link: "/category/cat6880496/Bolsos-de-Viaje"
						},
						{
							label: "Maletas de cabina",
							isHighlightLink: false,
							link: "/category/cat5790462/Maletas-de-Cabina"
						},
						{
							link: "/category/cat6880492/Maletas-de-Viaje",
							label: "Maletas de viaje",
							isHighlightLink: false
						},
						{
							label: "Mochilas outdoors",
							isHighlightLink: false,
							link: "/category/cat6880494/Mochilas-Outdoors"
						},
						{
							label: "Mochilas para laptop",
							isHighlightLink: false,
							link: "/category/cat270485/Mochilas-para-Laptop"
						}
					],
					label: "Maletería y Viajes"
				},
				{
					label: "Automotriz",
					link: "/category/cat12950471/Automotriz",
					leafCategories: [
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Autoradios",
							link: "/category/cat6370523/Autoradios"
						},
						{
							label: "Baterías de autos",
							link: "/category/cat12950473/Baterías-de-autos",
							meatStickerOption: 0,
							isHighlightLink: false
						}
					],
					verTodoActive: true
				}
			],
			label: "Nuevas Categorías",
			link: "cat12100467"
		},
		{
			subCategories: [
				{
					leafCategories: [
						{
							isHighlightLink: false,
							label: "Moda Mujer",
							meatStickerOption: 0,
							link: "/collection/moda-mujer-liquidacion"
						},
						{
							label: "Ropa deportiva",
							isHighlightLink: false,
							link: "/collection/liquidacion-ropa-deportiva-mujer",
							meatStickerOption: 0
						},
						{
							label: "Ropas de baño",
							isHighlightLink: false,
							meatStickerOption: 0,
							link: "/collection/ropa-de-banos-liquidacion"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Ropa Interior y pijamas",
							link: "/collection/ropa-interior-y-pijamas"
						},
						{
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Calzado Mujer",
							link: "/collection/liquidacionv2021calzadomujer"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Belleza",
							link: "/category/cat14890464/Liquidacion-Belleza"
						},
						{
							label: "Ver todo Liquidación Mujer",
							link: "/collection/todo-liquidacion-mujer",
							isHighlightLink: true
						}
					],
					label: "Liquidación Mujer",
					link: "/collection/todo-liquidacion-mujer",
					verTodoActive: true
				},
				{
					leafCategories: [
						{
							link: "/collection/moda-hombre-liquidacion",
							meatStickerOption: 0,
							isHighlightLink: false,
							label: "Moda Hombre"
						},
						{
							label: "Ropa Deportiva",
							link: "/collection/liquidacion-ropa-deportiva-hombre",
							meatStickerOption: 0,
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							link: "/collection/liquidacion-v2021-calzado-hombre",
							meatStickerOption: 0,
							label: "Calzado"
						},
						{
							link: "/collection/todo-liquidacion-hombre",
							label: "Ver todo Liquidación Hombre",
							isHighlightLink: true
						}
					],
					label: "Liquidación Hombre",
					link: "/collection/todo-liquidacion-hombre",
					verTodoActive: true
				},
				{
					verTodoActive: true,
					link: "/collection/todo-liquidacion-ninos-y-bebes",
					label: "Liquidación Niños",
					leafCategories: [
						{
							isHighlightLink: false,
							link: "/collection/liquidacion-nina-2-a-8-anos",
							meatStickerOption: 0,
							label: "Ropa Niñas 2-8"
						},
						{
							isHighlightLink: false,
							meatStickerOption: 0,
							label: "Ropa Niños 2-8",
							link: "/collection/liquidacion-nino-2-a-8-anos"
						},
						{
							link: "/collection/liquidacion-nina-8-a-16-anos",
							label: "Ropa Niñas 8-16",
							isHighlightLink: false,
							meatStickerOption: 0
						},
						{
							isHighlightLink: false,
							label: "Ropa Niños 8-16",
							link: "/collection/liquidacion-nino-8-a-16-anos",
							meatStickerOption: 0
						},
						{
							meatStickerOption: 0,
							link: "/collection/liquidacion-bebe",
							label: "Ropa bebé",
							isHighlightLink: false
						},
						{
							isHighlightLink: false,
							label: "Calzado Infantil",
							link: "/collection/liquidacion-v2021-calzado-ninos",
							meatStickerOption: 0
						},
						{
							link: "/collection/todo-liquidacion-ninos-y-bebes",
							isHighlightLink: true,
							label: "Ver todo Liquidación Niños"
						}
					]
				}
			],
			label: "Liquidación",
			link: "liquidacion-verano",
			bannerLocation: "urlToImage"
		}
	]
};
var taxonomyV1PE = {
	state: state$3
};

var entry$4 = {
	cc_fallback: true,
	all_accesses: {
		categories: [
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					description: "",
					filename: "icdiadelamadre.png",
					tags: [
					],
					title: "icdiadelamadre.png",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc0eaed4acc8f0505/62584e827e7b344b2534f183/icdiadelamadre.png",
					permanent_url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc0eaed4acc8f0505/icdiadelamadre.png"
				},
				image_ios_app: {
					description: "",
					filename: "icdiadelamadre.png",
					tags: [
					],
					title: "icdiadelamadre.png",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc0eaed4acc8f0505/62584e827e7b344b2534f183/icdiadelamadre.png",
					permanent_url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc0eaed4acc8f0505/icdiadelamadre.png"
				},
				image_web: {
					description: "",
					filename: "icdiadelamadre.svg",
					tags: [
					],
					title: "icdiadelamadre.svg",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt44fc08ac0c08a2dd/62584ea901fc7752fb533aec/icdiadelamadre.svg",
					permanent_url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt44fc08ac0c08a2dd/icdiadelamadre.svg"
				},
				is_seasonal: true,
				item_name: "Día de la madre",
				item_url: "https://www.falabella.com/falabella-cl/collection/regalos-dia-de-la-madre",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Ropa y accesorios",
						item_url: "https://www.falabella.com/falabella-cl/collection/ddm-ropa-y-accesorios",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/ddm-ropa-y-accesorios",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Botas y botines",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?mkid=LA_VTB_VER_10446&facetSelected=true&f.product.attribute.Tipo=Botas%3A%3ABotines&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Carteras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7480104/Carteras-y-mochilas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jeans y pantalones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850040/Pantalones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Joyas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat590028/Joyas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lencería",
								item_url: "https://www.falabella.com/falabella-cl/collection/lenceria-sexy",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parkas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850036/Abrigos-y-Chaquetas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Relojes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12160001/Relojes-Mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa deportiva",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930168/Ropa-deportiva-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sweaters y polerones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850034/Sweaters-y-chalecos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850068/Zapatillas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Belleza",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7660002/Belleza--higiene-y-salud",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7660002/Belleza--higiene-y-salud",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cuidado capilar",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9440008/Cuidado-Capilar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cuidado de la piel",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3214/Cuidado-del-Rostro",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dermocosmética",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-dermocosmetica",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Maquillaje",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690199/Maquillaje?isPLP=1&sred=maquillaje",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perfumes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2069/Perfumes",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Electro",
						item_url: "https://www.falabella.com/falabella-cl/collection/dia-de-la-madre-tecno",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/dia-de-la-madre-tecno",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Celulares",
								item_url: "https://www.falabella.com/falabella-cl/category/cat720161/Smartphones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Computadores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70057/Notebooks",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Electrobelleza",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2025/Tecnologia-para-la-Belleza",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smartwatch",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4290063/SmartWatch",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tablets",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7230007/Tablets",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Más regalos",
						item_url: "",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/dia-de-la-madre-chocolates",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Chocolates",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12011175/Chocolates?mkid=PL_B2_CHO_63",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Flores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2037/Flores-y-plantas-artificiales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Libros",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11448/Libros?isPLP=1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Marcos de fotos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3146/Marcos-de-foto",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Rangos de regalos",
						item_url: "https://www.falabella.com/falabella-cl/collection/regalos-dia-de-la-madre",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/regalos-dia-de-la-madre",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Hasta $10.000",
								item_url: "https://www.falabella.com/falabella-cl/collection/regalos-dia-de-la-madre?facetSelected=true&f.range.derived.price.search=HASTA+%2410.000",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "$10.000 - $20.000",
								item_url: "https://www.falabella.com/falabella-cl/collection/regalos-dia-de-la-madre?facetSelected=true&f.range.derived.price.search=%2410.000+-+%2420.000",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "$20.000 - $40.000",
								item_url: "https://www.falabella.com/falabella-cl/collection/regalos-dia-de-la-madre?&facetSelected=true&f.range.derived.price.search=%2420.000+-+%2440.000",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "$40.000 o más",
								item_url: "https://www.falabella.com/falabella-cl/collection/regalos-dia-de-la-madre?facetSelected=true&f.range.derived.price.search=%24100.000+-+%24200.000%3A%3A%24200.000+-+%24350.000%3A%3A%24350.000+-+%24500.000%3A%3A%2440.000+-+%2460.000%3A%3A%24500.000+-+%241.000.000%3A%3A%2460.000+-+%24100.000%3A%3ADESDE+%241.000.000",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Día de la madre",
				ver_todo: {
					title: "Ver todo Día de la Madre",
					href: "https://www.falabella.com/falabella-cl/collection/regalos-dia-de-la-madre"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "ictelefonia3x.png",
					title: "ictelefonia3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03279a8a27dca634/61c1d7f88ae3ee7d4c155d2c/ictelefonia3x.png"
				},
				image_ios_app: {
					filename: "ictelefonia3x.png",
					title: "ictelefonia3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03279a8a27dca634/61c1d7f88ae3ee7d4c155d2c/ictelefonia3x.png"
				},
				image_web: {
					filename: "ictelefonia.svg",
					tags: [
					],
					title: "ictelefonia.svg",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltdf74a05ca641dd8e/61c1cebd8d6b4f214f46a81d/ictelefonia.svg"
				},
				is_seasonal: false,
				item_name: "Celulares y planes",
				item_url: "https://www.falabella.com/falabella-cl/category/cat16400010/Telefonia",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Celulares y teléfonos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2018/Celulares-y-Telefonos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2018/Celulares-y-Telefonos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Celulares básicos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1280018/Celulares-Basicos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Celulares con planes",
								item_url: "https://tienda.falabella.com/falabella-cl/page/planes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smartphones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat720161/Smartphones",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas destacadas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat720161/Smartphones",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Huawei",
								item_url: "https://www.falabella.com/falabella-cl/category/cat720161/Smartphones?facetSelected=true&f.product.brandName=huawei",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "iPhone",
								item_url: "https://www.falabella.com/falabella-cl/category/cat720161/Smartphones?facetSelected=true&f.product.brandName=apple",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Motorola",
								item_url: "https://www.falabella.com/falabella-cl/category/cat720161/Smartphones?facetSelected=true&f.product.brandName=motorola",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Oppo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2018/Celulares-y-Telefonos?facetSelected=true&f.product.brandName=oppo&isPLP=1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Samsung",
								item_url: "https://www.falabella.com/falabella-cl/category/cat720161/Smartphones?facetSelected=true&f.product.brandName=samsung",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vivo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat720161/Smartphones?facetSelected=true&f.product.brandName=vivo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Xiaomi",
								item_url: "https://www.falabella.com/falabella-cl/category/cat720161/Smartphones?facetSelected=true&f.product.brandName=xiaomi",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Accesorios celulares",
						item_url: "https://www.falabella.com/falabella-cl/category/cat70014/Accesorios-Celulares",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70014/Accesorios-Celulares",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Audífonos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1640002/Audifonos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Baterías externas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7230057/Baterias-Externas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Carcasas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1820030/Carcasas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cargadores y cables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat170030/Cargadores-y-cables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Otros accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13750040/Otros-Accesorios-Celulares",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Protector de pantalla",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1920016/Protector-de-Pantalla",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tarjetas de memoria",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70037/Tarjetas-de-Memoria",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Wearables",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7190053/Wearables",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190053/Wearables",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6240028/Accesorios-Wearables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smartband",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4290064/Smartband",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smartwaches",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4290063/SmartWatch",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smartwaches niños",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5550008/Smartwatch-Kids",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Celulares y planes",
				ver_todo: {
					title: "Ver todo Celulares y planes",
					href: "https://www.falabella.com/falabella-cl/category/cat16400010/Telefonia"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "ictecnologia3x.png",
					title: "ictecnologia3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt43a3a0967b17c282/61c1d7f8d628d527ff440f85/ictecnologia3x.png"
				},
				image_ios_app: {
					filename: "ictecnologia3x.png",
					title: "ictecnologia3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt43a3a0967b17c282/61c1d7f8d628d527ff440f85/ictecnologia3x.png"
				},
				image_web: {
					filename: "ictecnologia.svg",
					title: "ictecnologia.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt947c65477aaf6d9c/61bbaa0fe5a70e7d5276b690/ictecnologia.svg"
				},
				is_seasonal: false,
				item_name: "Tecnología",
				item_url: "https://www.falabella.com/falabella-cl/category/cat7090034/Tecnologia",
				monetization_banner: [
				],
				position_bottom: true,
				second_level_categories: [
					{
						item_name: "TV",
						item_url: "https://www.falabella.com/falabella-cl/category/cat1012/TV-y-Video",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1012/TV-y-Video",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70050/Accesorios-TV",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Proyectores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2070/Proyectores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smart tv",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190148/Televisores-LED",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smart tv menores a 50\"",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190148/Televisores?facetSelected=true&f.product.attribute.Tama%C3%B1o_de_la_pantalla=22+pulgadas%3A%3A24+pulgadas%3A%3A24%22%3A%3A32+%22%3A%3A32+pulgadas%3A%3A32%22%3A%3A32%27%27%3A%3A39+pulgadas%3A%3A40+%22%3A%3A40+pulgadas%3A%3A40%22%3A%3A42+%22%3A%3A42+pulgadas%3A%3A42%22%3A%3A43+%22%3A%3A43+pulgadas%3A%3A43%22%3A%3A48+pulgadas%3A%3A48%22%3A%3A49+pulgadas%3A%3A49%22%3A%3A49%27%27",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smart tv entre 50\" - 55\"",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190148/Televisores?facetSelected=true&f.product.attribute.Tama%C3%B1o_de_la_pantalla=50+%22%3A%3A50+pulgadas%3A%3A50%22%3A%3A55+%22%3A%3A55+pulgadas%3A%3A55%22",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smart tv sobre 55\"",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190148/Televisores?facetSelected=true&f.product.attribute.Tama%C3%B1o_de_la_pantalla=58+%22%3A%3A58+pulgadas%3A%3A58%27%27%3A%3A60+%22%3A%3A60+pulgadas%3A%3A60%27%27%3A%3A65+%22%3A%3A65+pulgadas%3A%3A65%22%3A%3A70+%22%3A%3A70+pulgadas%3A%3A70%22%3A%3A75+%22%3A%3A75+pulgadas%3A%3A77+pulgadas%3A%3A82+pulgadas%3A%3A83+pulgadas%3A%3A85+pulgadas%3A%3A86+pulgadas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Soportes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70052/Soportes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Streaming",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6260040/Streaming",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Audio",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2005/Audio",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2005/Audio",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Audífonos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1640002/Audifonos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Audífonos inalámbricos",
								item_url: "https://www.falabella.com/falabella-cl/collection/audifono-inalambrico",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Audio profesional y DJ",
								item_url: "https://www.falabella.com/falabella-cl/category/cat590091/Audio-profesional-y-DJ",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Equipos de música y karaoke",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3091/Equipos-de-musica-y-karaokes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hi-Fi",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3203/Hi-Fi",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Instrumentos musicales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3117/Instrumentos-Musicales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parlantes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3171/Parlantes-bluetooth",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Soundbar y home theater",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2045/Soundbar-y-Home-Theater",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Wearables",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7190053/Wearables",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190053/Wearables",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Smartband",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4290064/Smartband",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smartwatches",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4290063/SmartWatch",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Smartwatches niños",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4290063/SmartWatch?facetSelected=true&f.product.brandName=momo%3A%3Asoymomo",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Computación",
						item_url: "https://www.falabella.com/falabella-cl/category/cat40052/Computadores",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat40052/Computadores",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2001/Accesorios-Computacion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "All in one",
								item_url: "https://www.falabella.com/falabella-cl/category/cat40051/All-in-one",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Almacenamiento",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2003/Almacenamiento",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chromebooks",
								item_url: "https://www.falabella.com/falabella-cl/collection/chromebook",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Desktops",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350043/Desktops",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Impresoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2049/Impresoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Kindles & eReaders",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7230007/Tablets?facetSelected=true&f.product.attribute.Tipo=Ebooks",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Monitores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2062/Monitores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Notebooks",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70057/Notebooks",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Routers y repetidor wifi",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2082/Routers-y-Conectividad",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Softwares",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2076/Softwares",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tablets",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7230007/Tablets",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Webcams",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2380002/WebCams",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Computación gamer",
						item_url: "https://www.falabella.com/falabella-cl/category/cat4850013/Computacion-gamer",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4850013/Computacion-gamer",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Teclado gamer",
								item_url: "https://www.falabella.com/falabella-cl/collection/teclado-gamer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Silla gamer",
								item_url: "https://www.falabella.com/falabella-cl/collection/sillas-gamer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Monitor gamer",
								item_url: "https://www.falabella.com/falabella-cl/collection/monitor-gamer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Escritorio gamer",
								item_url: "https://www.falabella.com/falabella-cl/collection/escritorio-gamer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Accesorios gamer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13520029/Accesorios-Gamers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Audífonos gamer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4930009/Audifonos-Gamers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Desktop gamer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10700011/Desktops-Gamers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mouse gamer",
								item_url: "https://www.falabella.com/falabella-cl/collection/mouse-gamer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Notebook gamer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70057/Notebooks?facetSelected=true&f.product.attribute.Tipo=Gamers",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Videojuegos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2023/Videojuegos?isLanding=true",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2023/Videojuegos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3190/Accesorios-Videojuegos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Consolas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat202303/Consolas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juegos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2023/Videojuegos?facetSelected=true&f.product.attribute.Tipo=Videojuegos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Nintendo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70003/Nintendo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "PlayStation",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4440005/Playstation",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Suscripciones y tarjetas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12530007/Suscripiones-y-tarjetas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Xbox",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4440004/Xbox",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Fotografía",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2038/Fotografia?isLanding=true",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2038/Fotografia",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190259/Accesorios-de-fotografia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cámaras compactas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70028/Camaras-compactas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cámaras de video",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2014/Camaras-de-video",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cámaras deportivas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7230012/Camaras-deportivas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cámaras instantáneas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2038/Fotografia?facetSelected=true&f.product.attribute.Tipo=C%C3%A1maras+instant%C3%A1neas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cámaras profesionales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18230032/Camaras-Profesionales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cámaras semiprofesionales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7230011/Camaras-Semiprofesionales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Drones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7230062/Drones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lentes, filtros y flash",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70040/Lentes--Filtros-y-Flash",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tarjetas de memoria",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70037/Tarjetas-de-Memoria",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Smart home",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7190093/Smart-Home",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190093/Smart-Home",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Asistentes de voz",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13490034/Asistentes-por-Voz",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aspiradoras robot",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8600022/Aspiradoras-Robot",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Gadgets y novedades",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190100/Gadgets",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Iluminación inteligente",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190096/Iluminacion-inteligente",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Proyectores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14710001/Proyectores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Seguridad y vigilancia",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190094/Camaras-de-Seguridad-y-Vigilancia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Streaming",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6260040/Streaming",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Notebooks",
						item_url: "https://www.falabella.com/falabella-cl/category/cat70057/Notebooks",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70057/Notebooks",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Chromebooks",
								item_url: "https://www.falabella.com/falabella-cl/collection/chromebook",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Notebooks business",
								item_url: "https://www.falabella.com/falabella-cl/collection/business",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Notebooks gamer",
								item_url: "https://www.falabella.com/falabella-cl/collection/gamer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Notebooks multitarea",
								item_url: "https://www.falabella.com/falabella-cl/collection/multitarea",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Notebooks performance",
								item_url: "https://www.falabella.com/falabella-cl/collection/perfomance",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Tecnología",
				ver_todo: {
					title: "Ver todo Tecnología",
					href: "https://www.falabella.com/falabella-cl/category/cat7090034/Tecnologia"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icelectrohogar3x.png",
					title: "icelectrohogar3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7228651e9f01b80c/61c1d7e6c9ed2d27fb59f31f/icelectrohogar3x.png"
				},
				image_ios_app: {
					filename: "icelectrohogar3x.png",
					title: "icelectrohogar3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7228651e9f01b80c/61c1d7e6c9ed2d27fb59f31f/icelectrohogar3x.png"
				},
				image_web: {
					filename: "icelectrohogar.svg",
					title: "icelectrohogar.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt0fc0408794d97c18/61bbb3798d6b4f214f469ec5/icelectrohogar.svg"
				},
				is_seasonal: false,
				item_name: "Electrohogar",
				item_url: "https://www.falabella.com/falabella-cl/category/cat16510006/Electrohogar",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Electrodomésticos cocina",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2034/Electrodomesticos-Cocina",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2034/Electrodomesticos-Cocina",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Batidoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9890052/Batidoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cafeteras eléctricas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3045/Cafeteras-electricas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cocina entretenida",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6740089/Cocina-Entretenida",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Freidoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3099/Freidoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hervidores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3110/Hervidores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hornos eléctricos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3114/Hornos-Electricos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Licuadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3141/Licuadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Microondas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3151/Microondas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ollas multifuncionales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7230035/Ollas-multiuso-y-arroceras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Robot de cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8410002/Robot-de-Cocina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Wafleras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3219/Sandwicheras-y-Wafleras",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Aspirado y limpieza",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7190001/Aspirado-y-Limpieza",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190001/Aspirado-y-Limpieza",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Aspiradoras de arrastre",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8600021/Aspiradoras-de-Tambor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aspiradoras portátiles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8600026/Aspiradoras-Portatiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aspiradoras robot",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8600022/Aspiradoras-Robot",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aspiradoras verticales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8600024/Aspiradoras-Verticales",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Refrigeradores",
						item_url: "https://www.falabella.com/falabella-cl/category/cat3205/Refrigeradores",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3205/Refrigeradores",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cavas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1840004/Cavas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Freezers",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4048/Freezers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Frigobares",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4049/Frigobar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Refrigeradores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3205/Refrigeradores?f.product.attribute.Tipo=Bottom+freezer%3A%3AMonopuerta%3A%3ATop+mount&isPLP=1%2C1%2C1%2C1&isPLP=1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Side by side",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4091/Side-by-Side",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Cocina",
						item_url: "https://www.falabella.com/falabella-cl/category/cat3065/Cocina",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3065/Cocina",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Campanas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4026/Campanas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cocinas a gas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70012/Cocinas-a-gas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Encimeras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4045/Encimeras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hornos empotrables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4054/Hornos-Empotrables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Kits empotrados",
								item_url: "https://www.falabella.com/falabella-cl/collection/kit-empotrados",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Lavado y planchado",
						item_url: "https://www.falabella.com/falabella-cl/category/cat3136/Lavado",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3136/Lavado",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Lavadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4060/Lavadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lavadoras y secadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1700002/Lavadoras-Secadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lavavajillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4061/Lavavajillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Planchas convencionales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8530004/Planchas-Convencionales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Planchas verticales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8530006/Planchas-Verticales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Secadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4088/Secadoras",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Máquinas de coser",
						item_url: "https://www.falabella.com/falabella-cl/page/costuras",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/page/costuras",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios y complementos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8540013/Accesorios-y-Complementos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bordadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8540011/Bordadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cortadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14790018/Cortadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Máquinas de coser",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2024/Maquinas-de-Coser",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Overlock y quilting",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13620018/Overlock-y-Quilting",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Equipamiento industrial",
						item_url: "https://www.falabella.com/falabella-cl/category/cat19110021/Equipamiento-Industrial",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19110021/Equipamiento-Industrial",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios comerciales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10897314/Accesorios-Comerciales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Gastronomía",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10897842/Gastronomia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mueblería y grifería",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11264206/Muebleria-y-Griferia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Refrigeración industrial",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10896522/Refrigeracion-Industrial",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Cuidado personal",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2025/Tecnologia-para-la-Belleza",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2025/Tecnologia-para-la-Belleza",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Afeitadoras y cortapelos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11731/Afeitadoras-y-Cortapelos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Alisadores de pelo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3018/Alisadores-de-pelo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Depiladoras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11730/Depiladoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Onduladores de pelo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3170/Onduladores-de-pelo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Secadores de pelo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3223/Secadores-de-pelo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tecnología para la belleza",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2025/Tecnologia-para-la-Belleza",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Calefacción",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7170003/Calefaccion",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7170003/Calefaccion",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Calefont y termos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2013/Calefont-y-Termos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calefacción de patio",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11050001/Estufas-de-Patio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calientacamas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3046/Calientacamas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Estufas a gas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9910024/Estufas-Gas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Estufas a parafina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16250010/Estufas-Parafina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Estufas a pellet y leña",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9910027/Estufas-Pellet-y-Lena",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Estufas eléctricas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9910006/Estufas-Electricas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Aire acondicionado y ventilación",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG12097/Climatizacion",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12097/Climatizacion",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Aire acondicionado",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2019/Aire-Acondicionado",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aire acondicionado portátil",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7830015/Portatiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aire acondicionado split",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7830014/Split",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Enfriadores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat170042/Enfriadores-de-aire?mkid=PL_HU_VER_1000008583",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Purificadores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3197/Purificadores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ventiladores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3254/Ventiladores",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Electrohogar",
				ver_todo: {
					title: "Ver todo Electrohogar",
					href: "https://www.falabella.com/falabella-cl/category/cat16510006/Electrohogar"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icmuebles3x.png",
					title: "icmuebles3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blte42ff9cf282a902e/61c1d7f8e5a70e7d5276bf8b/icmuebles3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icmuebles.svg",
					title: "icmuebles.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt0b027c28b9bfc253/61bba9f79793463f93f420f8/icmuebles.svg"
				},
				is_seasonal: false,
				item_name: "Muebles y organización",
				item_url: "https://www.falabella.com/falabella-cl/category/cat1008/Muebles-y-Organizacion",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Muebles por tipo",
						item_url: "https://www.falabella.com/falabella-cl/category/cat1008/Muebles-y-Organizacion",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1008/Muebles-y-Organizacion",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Marcas premium",
								item_url: "https://www.falabella.com/falabella-cl/collection/marcas-premium-muebles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Banquetas y pouffs",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10600007/Banquetas-y-poufs",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Berger y reclinables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3036/Bergers-y-Reclinables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camas infantiles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3180021/Camas-infantiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Clóset",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3063/Closet",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cómodas y cajoneras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3074/Comodas-y-Cajoneras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cunas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10170015/Cunas-de-Madera",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Escritorios y sillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2046/Oficina-y-escritorio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Estantes y repisas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1810012/Estantes--repisas-y-soportes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juegos de comedor",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3123/Juegos-de-Comedor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mesas de centro y arrimos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2940012/Mesas-Centro--Laterales-y-Arrimos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mesas de comedor",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3149/Mesas-de-Comedor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muebles de bar",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3032/Bar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muebles de TV y racks",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5140014/Muebles-de-TV-y-Racks",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Respaldos y veladores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3212/Respaldos-y-Veladores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas de comedor",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3229/Sillas-de-Comedor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sofás y sillones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8960005/Sofas-y-Sillones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Terrazas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1180024/Muebles-de-terraza",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vitrinas y buffets",
								item_url: "https://www.falabella.com/falabella-cl/category/cat840027/Vitrinas-y-Buffet",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Living y sala de estar",
						item_url: "https://www.falabella.com/falabella-cl/category/cat16610015/Living---Sala-de-Estar",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16610015/Living---Sala-de-Estar",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Marcas premium",
								item_url: "https://www.falabella.com/falabella-cl/collection/living-y-sala-de-estar-premium",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Banquetas y pouffs",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10600007/Banquetas-y-poufs",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bergers y reclinables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3036/Bergers-y-Reclinables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Estantes y repisas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1810012/Estantes--repisas-y-soportes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mesas de centro y arrimos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2940012/Mesas-Centro--Laterales-y-Arrimos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muebles de TV y racks",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5140014/Muebles-de-TV-y-Racks",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sofás y sillones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8960005/Sofas-y-Sillones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sofás, camas y futones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3107/Sofas-cama-y-futones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sitiales y poltronas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3234/Sitiales-y-poltronas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Comedor",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2021/Muebles-de-comedor",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2021/Muebles-de-comedor",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Marcas premium",
								item_url: "https://www.falabella.com/falabella-cl/collection/muebles-comedor-premium",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juegos de comedor",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3123/Juegos-de-Comedor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mesas de comedor",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3149/Mesas-de-Comedor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muebles de bar",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3032/Bar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas de comedor",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3229/Sillas-de-Comedor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vitrinas y buffet",
								item_url: "https://www.falabella.com/falabella-cl/category/cat840027/Vitrinas-y-Buffet",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Muebles de niños",
						item_url: "https://www.falabella.com/falabella-cl/category/cat3180022/Muebles-Infantiles",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3180022/Muebles-Infantiles",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Camas infantiles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3180021/Camas-infantiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mesas y escritorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16080001/Escritorios-Infantiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas infantiles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12830003/Sillas--Sofas-y-Mesas-infantiles",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Dormitorio",
						item_url: "https://www.falabella.com/falabella-cl/category/cat5870049/Muebles-de-Dormitorio",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5870049/Muebles-de-Dormitorio",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Clóset",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3063/Closet",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cómodas y cajoneras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3074/Comodas-y-Cajoneras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dormitorio infantil",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3180022/Muebles-Infantiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Respaldos y veladores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3212/Respaldos-y-Veladores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapateros",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10137/Organizador-de-Zapatos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Oficina y escritorio",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2046/Oficina-y-escritorio",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2046/Oficina-y-escritorio",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Escritorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3158/Escritorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Escritorio gamer",
								item_url: "https://www.falabella.com/falabella-cl/collection/escritorio-gamer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lockers",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10143/Lockers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas de escritorio",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9130008/Sillas-de-Escritorio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas gamer",
								item_url: "https://www.falabella.com/falabella-cl/collection/sillas-gamer",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Organización y almacenamiento",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10139/Organizacion",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10139/Organizacion",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cajas y canastos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6210052/Cajas-organizadoras-y-canastos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mudanza",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10165/Mudanza",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Organización baño",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10169/Organizacion-de-Bano",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Organización cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8950026/Organizacion-de-Cocina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Organización dormitorio",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8950028/Organizacion-de-Dormitorio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Organización escritorio",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10159/Organizacion-de-Escritorio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Organización infantil",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16260008/Organizacion-Infantil",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perchas y ganchos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11640016/Perchas--percheros-y-ganchos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Soportes, rieles y escuadras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10142/Soportes--Rieles-y-Escuadras",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Crate&Barrel",
						item_url: "https://tienda.falabella.com/falabella-cl/page/crateandbarrel",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://tienda.falabella.com/falabella-cl/page/crateandbarrel",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Alfombras",
								item_url: "https://www.falabella.com/falabella-cl/collection/alfombras-crate--26-barrel?mkid=LP_C6_VER_832",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Comedor y cocina",
								item_url: "https://www.falabella.com/falabella-cl/collection/comedor-y-cocina-crate-barrel",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Decoración",
								item_url: "https://www.falabella.com/falabella-cl/collection/decoracion-crate--26-barrel?mkid=LP_C2_VER_828",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muebles",
								item_url: "https://www.falabella.com/falabella-cl/collection/muebles-crate--26-barrel?mkid=LP_HU_VER_820",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Textil hogar",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-ropa-de-cama-y-bano?mkid=LP_C_VER_777",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ofertas",
								item_url: "https://www.falabella.com/falabella-cl/collection/sale-crate--26-barrel?mkid=LP_SA_VER_384",
								tag: "SALE",
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Maletas y viajes",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2058/Maleteria-y-viajes",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2058/Maleteria-y-viajes",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios de viaje",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1870002/Accesorios-de-Viaje",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Maletas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3143/Maletas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Tienda virtual",
						item_url: "https://www.falabella.com/falabella-cl/collection/realidad-aumentada",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Realidad aumentada",
								item_url: "https://www.falabella.com/falabella-cl/collection/realidad-aumentada",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Muebles y organización",
				ver_todo: {
					title: "Ver todo Muebles y organización",
					href: "https://www.falabella.com/falabella-cl/category/cat1008/Muebles-y-Organizacion"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icdormitorio3x.png",
					title: "icdormitorio3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt1fbdd431cb627371/61c1d7e6d73c783f9a3d265a/icdormitorio3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icdormitorio.svg",
					title: "icdormitorio.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf7ebc5fb8ddbf851/61bba9f8d628d527ff44066a/icdormitorio.svg"
				},
				is_seasonal: false,
				item_name: "Dormitorio",
				item_url: "https://www.falabella.com/falabella-cl/category/cat1005/Dormitorio",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Camas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat13720010/Camas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13720010/Camas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Marcas premium",
								item_url: "https://www.falabella.com/falabella-cl/collection/marcas-premium-j14",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "1 plaza",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13720015/Camas-1-Plaza",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "1,5 plazas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13720017/Camas-1-5-Plazas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "2 plazas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13720016/Camas-2-Plazas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "King",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19370004/Camas-King",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Súper king",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19370016/Camas-Super-King",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Tipos de cama",
						item_url: "https://www.falabella.com/falabella-cl/category/cat670091/Tipos-de-Cama",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13720010/Camas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Box spring",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13720010/Camas?facetSelected=true&f.product.attribute.Tipo_de_cama=Box+springs",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camarotes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3049/Camarotes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camas americanas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13720010/Camas?facetSelected=true&f.product.attribute.Tipo_de_cama=Cama+americana%3A%3ACamas+americanas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camas europeas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13720010/Camas?facetSelected=true&f.product.attribute.Tipo_de_cama=Cama+europea%3A%3ACamas+Europeas%3A%3ACamas+europeas.product.attribute.Tipo=Cama+Europea%3A%3ACama+europea%3A%3ACamas+Europea%3A%3ACamas+Europeas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camas nido",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2029/Camas-Nido",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Marquesas y bases",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8690021/Marquesas-y-Bases-de-Cama",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Colchones",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2020/Colchones",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2020/Colchones",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "1 plaza",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90008/Colchon-1-Plaza",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "1,5 plazas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90013/Colchon-1-5-Plazas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "2 plazas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90010/Colchon-2-Plazas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Colchones de espuma",
								item_url: "https://www.falabella.com/falabella-cl/collection/colchones-de-espuma",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "King",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19370014/Colchon-King",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Súper king",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19370017/Colchon-Super-King",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Dormitorio de niños",
						item_url: "https://www.falabella.com/falabella-cl/category/cat3180019/Dormitorio-Infantil",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3180019/Dormitorio-Infantil",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Camas infantiles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3180021/Camas-infantiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cómodas y mudadores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4034/Comodas-y-mudadores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cunas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4038/Cunas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dormitorio bebé",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3180019/Dormitorio-Infantil",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa de cama infantil",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4210002/Ropa-de-cama-infantil",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa de cuna",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4086/Ropa-de-cuna",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa de cama",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2073/Ropa-de-Cama",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2073/Ropa-de-Cama",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Almohadas y fundas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13790009/Almohadas-y-fundas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cojines y pieceras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3067/Cojines-y-Pieceras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cubrecamas y quilts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3080/Cubrecamas-y-Quilts",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cubrecolchón y toppers",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3194/Cubrecolchon",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Faldones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2073/Ropa-de-Cama?facetSelected=true&f.product.attribute.Tipo=Faldones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Frazadas y mantas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3098/Frazadas-y-Mantas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fundas plumón",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3104/Funda-plumon",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juegos de cama",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3122/Juegos-de-Cama",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Plumones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3185/Plumones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa de cama infantil",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4210002/Ropa-de-cama-infantil",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sábanas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3215/Sabanas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Muebles de dormitorio",
						item_url: "https://www.falabella.com/falabella-cl/category/cat5870049/Muebles-de-Dormitorio",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5870049/Muebles-de-Dormitorio",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Clóset",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3063/Closet",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cómodas y cajoneras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3074/Comodas-y-Cajoneras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Organización y dormitorio",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8950028/Organizacion-de-Dormitorio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Respaldos y veladores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3212/Respaldos-y-Veladores",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Combos de dormitorio",
						item_url: "https://www.falabella.com/falabella-cl/collection/combos-dormitorio",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/combos-dormitorio",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "1 plaza",
								item_url: "https://www.falabella.com/falabella-cl/collection/combos-dormitorio?&f.product.L2_category_paths=cat1005%7C%7CDormitorio%2Fcat13720010%7C%7CCamas%2Fcat13720015%7C%7CCamas+1+Plaza",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "1,5 plazas",
								item_url: "https://www.falabella.com/falabella-cl/collection/combos-dormitorio?&f.product.L2_category_paths=cat1005%7C%7CDormitorio%2Fcat13720010%7C%7CCamas%2Fcat13720017%7C%7CCamas+1.5+Plazas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "2 plazas",
								item_url: "https://www.falabella.com/falabella-cl/collection/combos-dormitorio?&f.product.L2_category_paths=cat1005%7C%7CDormitorio%2Fcat13720010%7C%7CCamas%2Fcat13720016%7C%7CCamas+2+Plazas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "King",
								item_url: "https://www.falabella.com/falabella-cl/collection/combos-dormitorio?&f.product.L2_category_paths=cat1005%7C%7CDormitorio%2Fcat13720010%7C%7CCamas%2Fcat19370004%7C%7CCamas+King",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Súper king",
								item_url: "https://www.falabella.com/falabella-cl/collection/combos-dormitorio?&f.product.L2_category_paths=cat1005%7C%7CDormitorio%2Fcat13720010%7C%7CCamas%2Fcat19370016%7C%7CCamas+Super+King",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas destacadas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat1005/Dormitorio?facetSelected=true&f.product.brandName=cannon%3A%3Acelta%3A%3Acic%3A%3Adrimkip%3A%3Adr%C3%B6m%3A%3Aflex%3A%3Arosen%3A%3Atempur",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1005/Dormitorio?facetSelected=true&f.product.brandName=cannon%3A%3Acelta%3A%3Acic%3A%3Adrimkip%3A%3Adr%C3%B6m%3A%3Aflex%3A%3Arosen%3A%3Atempur",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cannon",
								item_url: "https://www.falabella.com/falabella-cl/collection/cannon-coleccion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Celta",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1005/Dormitorio?facetSelected=true&f.product.brandName=celta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "CIC",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1005/Dormitorio?facetSelected=true&f.product.brandName=cic",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Drimkip",
								item_url: "https://www.falabella.com/falabella-cl/search?Ntt=&f.product.brandName=DRIMKIP",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dröm",
								item_url: "https://tienda.falabella.com/falabella-cl/page/Drom",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Flex",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1005/Dormitorio?facetSelected=true&f.product.brandName=flex",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Rosen",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1005/Dormitorio?facetSelected=true&f.product.brandName=rosen",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Simmons",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1005/Dormitorio?facetSelected=true&f.product.brandName=simmons",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tempur",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1005/Dormitorio?facetSelected=true&f.product.brandName=tempur",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Dormitorio",
				ver_todo: {
					title: "Ver todo Dormitorio",
					href: "https://www.falabella.com/falabella-cl/category/cat1005/Dormitorio"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "iccocina3x.png",
					title: "iccocina3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blta0350d60988ebd6a/61c1d7e6c548b77c207dc5f3/iccocina3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "iccocina.svg",
					title: "iccocina.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc63fb2810a80ce61/61bbaba8c52c5b292ce23609/iccocina.svg"
				},
				is_seasonal: false,
				item_name: "Cocina y baño",
				item_url: "https://www.falabella.com/falabella-cl/category/cat01/Cocina-y-Bano",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Cocina",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10000/Cocina",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10000/Cocina",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Campanas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4026/Campanas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cocinas a gas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70012/Cocinas-a-gas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Encimeras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4045/Encimeras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Grifería cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10017/Griferia-de-Cocina-y-Lavadero?&f.product.L2_category_paths=cat01%7C%7CCocina+y+Ba%C3%B1o%2FCATG10002%7C%7CGrifer%C3%ADas%2FCATG10017%7C%7CGrifer%C3%ADa+de+Cocina+y+Lavadero",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hornos empotrables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4054/Hornos-Empotrables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lavaplatos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10013/Lavaplatos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lavavajillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4061/Lavavajillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muebles de cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10014/Muebles-de-Cocina",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Baño",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10001/Bano",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10001/Bano",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Duchas y cabinas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10023/Duchas-y-Cabinas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Grifería baño",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10018/Griferia-para-Bano",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lavamanos y vanitorios",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10022/Lavamanos-y-Vanitorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Seguridad y movilidad reducida",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10028/Seguridad-Bano-y-Movilidad-Reducida",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tinas e hidromasaje",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10024/Tinas-e-Hidromasajes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "WC - sanitarios",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10020/WC---Sanitarios",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Calefont y termos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2013/Calefont-y-Termos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2013/Calefont-y-Termos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10182/Accesorios-Calefont?sortBy=derived.price.search%2Casc&facetSelected=true&f.product.L3_category_paths=cat16510006%7C%7CElectrohogar%2Fcat7170003%7C%7CCalefacci%C3%B3n%2Fcat2013%7C%7CCalefont+y+Termos%2FCATG10182%7C%7CAccesorios+Calefont",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calefont tiro forzado",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10179/Calefont-tiro-forzado",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calefont tiro natural",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10180/Calefont-tiro-natural",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Termos y calderas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10181/Termos-y-Calderas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Electrodomésticos cocina",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2034/Electrodomesticos-Cocina?isLanding=true",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2034/Electrodomesticos-Cocina",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Batidoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9890052/Batidoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cafeteras eléctricas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3045/Cafeteras-electricas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cocina entretenida",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6740089/Cocina-Entretenida",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Freidoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3099/Freidoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hervidores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3110/Hervidores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hornos eléctricos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3114/Hornos-Electricos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Licuadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3141/Licuadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Microondas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3151/Microondas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ollas multifuncionales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7230035/Ollas-multiuso-y-arroceras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Robot de cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8410002/Robot-de-Cocina",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Menaje cocina",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2060/Menaje-Cocina",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2060/Menaje-Cocina",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Baterías de cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3034/Baterias-de-Cocina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Contenedores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5430047/Contenedores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cuchillos y tablas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280093/Cuchillos-y-tablas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Marcas premium",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2060/Menaje-Cocina?facetSelected=true&f.product.brandName=3+claveles%3A%3Acosta+nova%3A%3Acrate+%26+barrel%3A%3Acuisinart%3A%3Aemile+henry%3A%3Ajohn+lewis%3A%3Ajoseph%3A%3Ajoseph+joseph%3A%3Akanka%3A%3Akitchen-it%3A%3Akitchenaid%3A%3Akorkmaz%3A%3Ale+creuset%3A%3Aoxo%3A%3Apip+studio%3A%3Arachael+ray%3A%3Aspal%3A%3Avictorinox+chile%3A%3Awmf",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ollas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3169/Ollas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Organización",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8950026/Organizacion-de-Cocina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Repostería",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280016/Reposteria",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sartenes y wok",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3220/Sartenes-y-Wok",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Termos y picnic",
								item_url: "https://www.falabella.com/falabella-cl/category/cat970004/Termos-y-Picnic",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Textil cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14600003/Textil-Cocina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Utensilios de cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3024/Utensilios-de-cocina",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Refrigeradores",
						item_url: "https://www.falabella.com/falabella-cl/category/cat3205/Refrigeradores",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3205/Refrigeradores",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cavas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1840004/Cavas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Convencionales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3205/Refrigeradores?f.product.attribute.Tipo=Bottom+freezer%3A%3AMonopuerta%3A%3ATop+mount&isPLP=1%2C1%2C1%2C1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Freezers",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4048/Freezers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Frigobar",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4049/Frigobar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Side by side",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4091/Side-by-Side",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Menaje comedor",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2061/Menaje-Comedor",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2061/Menaje-Comedor",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios de mesa",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3012/Accesorios-de-mesa",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aperitivo y bar",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280098/Aperitivo-y-bar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cuchillería",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3081/Cuchilleria",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fuentes y bandejas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3100/Fuentes-y-Bandejas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mantelería",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280099/Manteleria",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Marcas premium",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2061/Menaje-Comedor?facetSelected=true&f.product.brandName=anthropologie+home%3A%3Abordallo%3A%3Acosta+nova%3A%3Acrate+%26+barrel%3A%3Adalper%3A%3Aemile+henry%3A%3Aidurgo%3A%3Ajohn+lewis%3A%3Ajoseph+joseph%3A%3Alaguiole%3A%3Aoxo%3A%3Apip+studio%3A%3Aportmeirion%3A%3Aqdigital%3A%3Aschott+zwiesel%3A%3Aspal%3A%3Awmf%3A%3Awrzesniak",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Té y café",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280097/Te-y-cafe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vajilla",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280100/Vajilla",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vasos y copas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6590032/Vasos-y-copas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Complementos de baño",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2006/Menaje-Bano",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2006/Menaje-Bano",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3010/Accesorios-de-Bano",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Basureros y papeleros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11390001/Basureros-y-Papeleros",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tapas y asientos WC",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10027/Tapas-y-asientos-para-WC",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Organización",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10169/Organizacion-de-Bano",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Textil baño",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10030/Textil-bano",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Toallas de baño",
								item_url: "https://www.falabella.com/falabella-cl/category/cat670073/Toallas-de-bano?sred=Toalla",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Cocina y baño",
				ver_todo: {
					title: "Ver todo Cocina y baño",
					href: "https://www.falabella.com/falabella-cl/category/cat01/Cocina-y-Bano"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icdecohogar3x.png",
					title: "icdecohogar3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltfffbf5cd8795880d/61c1d7e6d628d527ff440f7f/icdecohogar3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icdecohogar.svg",
					title: "icdecohogar.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3a3f8240ad1e0872/61bba9f7c52c5b292ce23603/icdecohogar.svg"
				},
				is_seasonal: false,
				item_name: "Decoración e iluminación",
				item_url: "https://www.falabella.com/falabella-cl/category/cat2026/Decoracion-e-iluminacion",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Decoración",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2026/Decoracion",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2026/Decoracion",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Adornos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280221/Adornos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Decoración de pared",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280225/Decoracion-de-muro",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Decoración infantil",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12740004/Decoracion-Infantil",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Espejos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3094/Espejos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fotomurales y autoadhesivos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10103/Fotomurales-y-autoadhesivos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Marcas Premium",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2026/Decoracion-e-iluminacion?facetSelected=true&f.product.brandName=ameritex%3A%3Abasement+home%3A%3Abenetton%3A%3Acrate+%26+barrel%3A%3Ajohn+lewis%3A%3Asur+dise%C3%B1o%3A%3Athe+popular+design",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Marcos de foto",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3146/Marcos-de-foto",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Papel mural y guardas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10833/Papel-Mural-y-guardas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Alfombras y cubrepisos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2002/Alfombras-y-cubrepisos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2002/Alfombras-y-cubrepisos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Alfombras decorativas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2002/Alfombras-y-cubrepisos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Alfombras infantiles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13140020/Alfombras-Infantiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cubrepisos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10091/Cubrepisos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Limpiapies",
								item_url: "https://www.falabella.com/falabella-cl/category/cat17930011/Limpiapies",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Marcas Premium",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2002/Alfombras-y-cubrepisos?facetSelected=true&f.product.brandName=basement+home%3A%3Acrate+%26+barrel%3A%3Ajohn+lewis%3A%3Akilimbrand%3A%3Asur+dise%C3%B1o",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pasto sintético",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10092/Pasto-Sintetico",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Cortinas y rollers",
						item_url: "https://www.falabella.com/falabella-cl/category/cat5540010/Cortinas-y-rollers",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5540010/Cortinas-y-rollers",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Barras y rieles",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10088/Barras-y-Rieles-para-Cortinas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cortinas de cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10083/Cortinas-de-Cocina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cortinas de tela",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10084/Cortinas-de-Tela",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cortinas roller",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10086/Cortinas-Roller",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Persianas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10085/Persianas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Velos y visillos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10087/Velos-y-Visillos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Iluminación interior",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10081/Iluminacion-Interior",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10081/Iluminacion-Interior",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Ampolletas y tubos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10093/Ampolletas-y-tubos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Apliqués, focos y plafones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12590001/Apliques--focos-y-plafones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cintas y luces led",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15480004/Cintas-y-luces-led",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Empotrados y paneles led",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10094/Focos-Empotrados-y-paneles-led",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Iluminación inteligente",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190096/Iluminacion-inteligente",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lámparas colgantes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6570004/Lamparas-colgantes-y-techo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lámparas de mesa",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6570005/Lamparas-de-mesa-y-escritorio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lámparas de pie",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6570006/Lamparas-de-pie",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lámparas infantiles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15790004/Iluminacion-Infantil",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Letreros y fiesta",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10096/Letreros-luminosos-y-fiesta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantallas para lámpara",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12590004/Pantallas-para-Lamparas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Iluminación exterior",
						item_url: "https://www.falabella.com/falabella-cl/category/cat14250003/Iluminacion-Exterior",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14250003/Iluminacion-Exterior",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Apliqués exterior",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15480005/Apliques-exterior-y-focos-tortuga",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cintas y luces led",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15480004/Cintas-y-luces-led",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Estacas para jardín",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10099/Estacas-para-jardin",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Faroles y antorchas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10098/Faroles-y-antorchas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Focos solares",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10100/Focos-solares",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muro y piso",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10101/Iluminacion-de-piso-y-muro",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Reflectores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10097/Focos-Reflectores",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Tendencias e inspiración",
						item_url: "https://tienda.falabella.com/falabella-cl/page/casa-f",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/espacio-diseno",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Deco kids",
								item_url: "https://www.falabella.com/falabella-cl/collection/deco-kids",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Decoración",
								item_url: "https://www.falabella.com/falabella-cl/collection/espacio-diseno-decoracion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dormitorio",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14010411/Dormitorio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Inspírate en casa F",
								item_url: "https://www.falabella.com/falabella-cl/page/casa-f?staticPageId=33400001",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Menaje",
								item_url: "https://www.falabella.com/falabella-cl/collection/espacio-diseno-menaje",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muebles",
								item_url: "https://www.falabella.com/falabella-cl/collection/espacio-diseno-muebles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa de cama",
								item_url: "https://www.falabella.com/falabella-cl/collection/espacio-diseno-ropa-de-cama",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Terraza",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1180024/Muebles-de-terraza",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Arte Falabella",
						item_url: "https://tienda.falabella.com/falabella-cl/page/arte-falabella",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280225/Decoracion-de-muro?facetSelected=true&f.product.brandName=alejandra+caro%3A%3Aalejandra+rivera%3A%3Aandrés+muñoz%3A%3Aandrés+parra+(nia+de+indias)%3A%3Abarbara+oettinger%3A%3Abernardita+bennet%3A%3Acarla+mc-kay%3A%3Acarla+yovane%3A%3Acarlos+silva%3A%3Acarola+sepulveda%3A%3Acarolina+agüero%3A%3Aconstanza+miranda%3A%3Acristian+ordoñez%3A%3Adiego+urbina%3A%3Afelipe+muñoz%3A%3Afrancisco+ibañez%3A%3Aisidora+correa%3A%3Ajorge+brantmayer%3A%3Ajorge+gronemeyer%3A%3Ajosefina+astorga%3A%3Aleonora+vicuña%3A%3Alucas+urenda%3A%3Amaite+zubizarreta%3A%3Amarize+parra%3A%3Amatthew+neary%3A%3Amauricio+soto%3A%3Amila+belén%3A%3Anicolás+piwonka%3A%3Apablo+izquierdo%3A%3Apía+vergara%3A%3Arosario+ateaga%3A%3Asebastián+leal%3A%3Asebastián+mejia%3A%3Atomás+verdejo%3A%3Atomás+westenenk%3A%3Avalentina+guerrero%3A%3Avalentina+osnovikoff%3A%3Averónica+garay&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Arte en blanco y negro",
								item_url: "https://www.falabella.com/falabella-cl/collection/fotografias-bn",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Artistas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280225/Decoracion-de-muro?facetSelected=true&f.product.brandName=alejandra+caro%3A%3Aalejandra+rivera%3A%3Aandr%C3%A9s+mu%C3%B1oz%3A%3Aandr%C3%A9s+parra+(nia+de+indias)%3A%3Abarbara+oettinger%3A%3Abernardita+bennet%3A%3Acarla+mc-kay%3A%3Acarla+yovane%3A%3Acarlos+silva%3A%3Acarola+sepulveda%3A%3Acarolina+ag%C3%BCero%3A%3Aconstanza+miranda%3A%3Acristian+ordo%C3%B1ez%3A%3Adiego+urbina%3A%3Afelipe+mu%C3%B1oz%3A%3Afrancisco+iba%C3%B1ez%3A%3Aisidora+correa%3A%3Ajorge+brantmayer%3A%3Ajorge+gronemeyer%3A%3Ajosefina+astorga%3A%3Aleonora+vicu%C3%B1a%3A%3Alucas+urenda%3A%3Amaite+zubizarreta%3A%3Amarize+parra%3A%3Amatthew+neary%3A%3Amauricio+soto%3A%3Amila+bel%C3%A9n%3A%3Anicol%C3%A1s+piwonka%3A%3Apablo+izquierdo%3A%3Ap%C3%ADa+vergara%3A%3Arosario+ateaga%3A%3Asebasti%C3%A1n+leal%3A%3Asebasti%C3%A1n+mejia%3A%3Atom%C3%A1s+verdejo%3A%3Atom%C3%A1s+westenenk%3A%3Avalentina+guerrero%3A%3Avalentina+osnovikoff%3A%3Aver%C3%B3nica+garay&facetSelected=true%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue%2Ctrue&isPLP=1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Impresión horizontal",
								item_url: "https://www.falabella.com/falabella-cl/collection/fotografias-horizontal",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Impresión vertical",
								item_url: "https://www.falabella.com/falabella-cl/collection/fotografias-vertical",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Paisaje natural",
								item_url: "https://www.falabella.com/falabella-cl/collection/paisaje-natural",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Paisaje urbano",
								item_url: "https://www.falabella.com/falabella-cl/collection/paisaje-urbano",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Retratos",
								item_url: "https://www.falabella.com/falabella-cl/collection/retrato",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Decoración e iluminación",
				ver_todo: {
					title: "Ver todo Decoración e iluminación",
					href: "https://www.falabella.com/falabella-cl/category/cat2026/Decoracion-e-iluminacion"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icjardin3x.png",
					title: "icjardin3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf4f9ef91b3143678/61c1d7e68f8a44201b511e68/icjardin3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icjardin.svg",
					title: "icjardin.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt6f17b646ccda86ba/61bbb0390beb6a7d689d1766/icjardin.svg"
				},
				is_seasonal: false,
				item_name: "Jardín y terraza",
				item_url: "https://www.falabella.com/falabella-cl/category/CATG10011/Jardin-y-terraza",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Terraza",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10503/Terrazas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10503/Terrazas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Coolers",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90104/Coolers-y-neveras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Decoración exterior",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14240003/Decoracion-de-exterior",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Menaje comedor",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2061/Menaje-Comedor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muebles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1180024/Muebles-de-terraza",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Toldos y pérgolas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10512/Toldos-y-Pergolas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Parrillas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2079/Parrillas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2079/Parrillas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2450145/Accesorios-de-Parrillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parrillas a carbón",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2450141/Parrillas-de-Carbon",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parrillas a gas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2450139/Parrillas-de-Gas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parrillas eléctricas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3174/Parrillas-Electricas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Mundo piscina",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7280050/Piscinas--spa-e-inflables",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280050/Piscinas--spa-e-inflables",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Flotadores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280050/Piscinas--spa-e-inflables?mkid=PL_HU_FLO_18&facetSelected=true&f.product.attribute.Tipo=Inflable%3A%3AInflables%3A%3ASalvavidas+y+flotaci%C3%B3n",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juegos de agua",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280050/Piscinas--spa-e-inflables?mkid=PL_HU_JUE_20&facetSelected=true&f.product.attribute.Tipo=Accesorio+Buceo%2FNataci%C3%B3n%3A%3AFuente+de+agua%3A%3AJuegos+de+agua%3A%3AJuegos+de+playa%3A%3AKit+de+buceo+y+nataci%C3%B3n%3A%3ALanzadores%3A%3ALanzadores+de+agua%3A%3ASnorkel+m%C3%A1scara+de+buceo%3A%3ATabla+body+board",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mantención de piscinas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280050/Piscinas--spa-e-inflables?mkid=PL_HU_MAN_22&facetSelected=true&f.product.attribute.Tipo=Accesorio+de+piscina%3A%3AAccesorio+piscina%3A%3AAccesorios+de+piscinas%3A%3AAlguicida%3A%3ABio+Free%3A%3ABomba%3A%3ABombas+de+piscina%3A%3ACalentadores+de+piscina%3A%3ACloro%3A%3ACobertor%3A%3AConector+piscina%3A%3ADecantador%3A%3ADosificador%3A%3AFiltros+de+piscinas%3A%3AFocos+para+piscina%3A%3AHerramientas+mec%C3%A1nicas%3A%3AHerramientas+multiprop%C3%B3sito%3A%3ALimpiafondo%3A%3AQuimico%3A%3ARegulador+PH%3A%3ASet+piscina%3A%3ASkimmer+piscina%3A%3ATerm%C3%B3metro+piscina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Piscinas estructurales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280050/Piscinas--spa-e-inflables?mkid=PL_HU_PIS_17&facetSelected=true&f.product.attribute.Tipo=Piscinas+estructurales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Piscinas inflables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280050/Piscinas--spa-e-inflables?mkid=PL_HU_PIS_19&facetSelected=true&f.product.attribute.Tipo=Centro+de+actividades%3A%3APiscina%3A%3APiscinas+inflables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Toallas de playa",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19300025/Toallas-de-Playa?sred=Toalla-de-playa",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Jardín",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10504/Jardin",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10504/Jardin",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Bodegas y organizadores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10515/Bodegas-de-jardin-y-organizadores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cercos y enrejados",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10521/Cercos-y-Enrejados",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Control de plagas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10517/Insecticidas-y-Repelentes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Eco jardín",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10522/Eco-Jardin",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Herramientas y máquinas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18320015/Herramientas-y-maquinaria-de-jardin",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Huerto urbano",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10561/Huerto-Urbano",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Maceteros y accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10520/Maceteros-y-Accesorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Plantas y pasto",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10518/Plantas-y-Pasto",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Piscinas y accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280050/Piscinas--spa-e-inflables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Riego de jardín",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10519/Riego-de-Jardin",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Siembra y cuidados",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10516/Tierras--Semillas-y-Fertilizantes",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Juegos de exterior",
						item_url: "https://www.falabella.com/falabella-cl/category/cat690277/Juegos-de-exterior",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690277/Juegos-de-exterior",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Autos a batería",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90084/Autos-a-bateria",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camas elásticas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90024/Camas-elasticas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Casas de juego y carpas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12270018/Casas-de-juego-y-carpas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Go karts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1100004/Go-kart",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Inflables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930380/Inflables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Piscinas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280050/Piscinas--spa-e-inflables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Scooter, skate y patines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280035/Scooter--Skate-y-Patines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Triciclos y correpasillos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3078/Triciclos-y-correpasillos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Iluminación exterior",
						item_url: "https://www.falabella.com/falabella-cl/category/cat14250003/Iluminacion-Exterior",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14250003/Iluminacion-Exterior",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Apliqués exterior",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15480005/Apliques-exterior-y-focos-tortuga",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Estacas para jardín",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10099/Estacas-para-jardin",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Faroles y antorchas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10098/Faroles-y-antorchas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muro y piso",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10101/Iluminacion-de-piso-y-muro",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Herramientas de jardín",
						item_url: "https://www.falabella.com/falabella-cl/category/cat18320015/Herramientas-y-maquinaria-de-jardin",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18320015/Herramientas-y-maquinaria-de-jardin",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios para maquinarias",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10902/Accesorios-para-maquinaria-de-jardin",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cortadoras de pasto",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14080024/Cortadoras-de-pasto",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cortasetos y podadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10897/Cortasetos-y-podadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Herramientas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10903/Herramientas-de-jardin",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Motosierras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18380033/Motosierras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Orilladoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18380043/Orilladoras-y-desbrozadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sopladores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10898/Sopladores",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Jardín y terraza",
				ver_todo: {
					title: "Ver todo Jardín y terraza",
					href: "https://www.falabella.com/falabella-cl/category/CATG10011/Jardin-y-terraza"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: false
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icdeportes3x.png",
					title: "icdeportes3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltd78ed66a7672777b/61c1d7e5f8d92f21558914a9/icdeportes3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icdeportes.svg",
					title: "icdeportes.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltbcc40a9b1eb9fdc7/61bba9f78ae3ee7d4c1553b3/icdeportes.svg"
				},
				is_seasonal: false,
				item_name: "Deportes y aire libre",
				item_url: "https://tienda.falabella.com/falabella-cl/page/deporte",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Ropa deportiva mujer",
						item_url: "https://www.falabella.com/falabella-cl/category/cat6930168/Ropa-deportiva-mujer",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930168/Ropa-deportiva-mujer",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Calzas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930190/Calzas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantalones y shorts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12650001/Pantalones-y-Shorts?f.product.attribute.Tipo=Buzos%3A%3AJogger%3A%3APantalones%3A%3APantalones+de+buzo%3A%3APantalones+de+ski%3A%3APantalones+deportivos%3A%3APantalones+outdoor%3A%3AShorts%3A%3AShorts+deportivo%3A%3ASweatpants&f.range.derived.variant.discount_upto=Hasta+60%25+dcto",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parkas y cortavientos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12650002/Parkas-y-cortavientos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Petos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930191/Petos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Poleras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930180/Poleras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Polerones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930181/Polerones-Mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850068/Zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas Outdoors",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.attribute.Disciplina=Outdoor%3A%3ATrail+runningZapatillas&f.product.attribute.G%C3%A9nero=Mujer",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa deportiva hombre",
						item_url: "https://www.falabella.com/falabella-cl/category/cat6930003/Ropa-Deportiva-Hombre",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930003/Ropa-Deportiva-Hombre",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Camisetas de fútbol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat190004/Camisetas-Oficiales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantalones y joggers",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930019/Pantalones-y-Joggers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parkas y cortavientos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12650004/Parkas-y-Cortavientos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Poleras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930011/Poleras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Polerones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930014/Polerones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Shorts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930018/Shorts",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850064/Zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas Outdoors",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.attribute.Disciplina=Outdoor%3A%3ATrail+runningZapatillas&f.product.attribute.G%C3%A9nero=Hombre",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Bicicletas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat70007/Bicicletas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70007/Bicicletas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930367/Accesorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bicicletas de aprendizaje",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70007/Bicicletas?facetSelected=true&f.product.attribute.Tipo=Bicicleta+de+aprendizaje&isPLP=1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cascos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930376/Cascos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Eléctricas y plegables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat530006/Bicicletas-Electricas-y-Plegables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Infantiles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90099/Bicicletas-Infantiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mountain bike",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70008/Bicicletas-Mountain-Bike",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa ciclismo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930366/Ropa-Ciclismo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ruta y pista",
								item_url: "https://www.falabella.com/falabella-cl/category/cat190018/Bicicletas-Ruta-Pista",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Urbanas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70010/Bicicletas-Urbanas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Fitness",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2036/Fitness",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2036/Fitness",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930440/Accesorios-Fitness",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bicicletas estáticas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4046/Bicicletas-Estaticas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Crossfit",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4910004/Crossfit-y-Entrenamiento-Funcional",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Elípticas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4044/Elipticas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Home gym",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4053/Home-Gym",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mancuernas y pesas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930442/Mancuernas-y-Pesas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Spinning",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4092/Spinning",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trotadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19170001/Trotadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vitaminas y suplementos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11342105/Vitaminas-y-suplementos?facetSelected=true&f.product.attribute.Tipo=Suplementos+deportivos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Camping",
						item_url: "https://www.falabella.com/falabella-cl/category/cat6930448/Camping",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930448/Camping",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90105/Accesorios-Outdoor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Carpas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90101/Carpas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14790011/Cocina-de-Camping",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Colchones y colchonetas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90102/Colchones-y-Colchonetas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Coolers",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90104/Coolers-y-neveras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hidratación",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930080/Hidratacion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Linternas y lámparas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14790015/Linternas-y-lamparas-outdoor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mochilas y bolsos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90121/Mochilas-y-Bolsos-Outdoor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sacos de dormir",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90103/Sacos-de-Dormir",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas y mesas plegables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190301/Sillas-y-Mesas-Plegables",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Electromovilidad",
						item_url: "https://www.falabella.com/falabella-cl/category/cat18260007/Electromovilidad",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18260007/Electromovilidad",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Bicicletas eléctricas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat530006/Bicicletas-Electricas-y-Plegables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cascos urbanos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930376/Cascos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hoverboard",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280160/Hoverboard",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Monorueda, patín y skate",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18260008/Monorueda--Patin-y-skate",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Scooters eléctricos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8910010/Scooter-Electricos-Adulto",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Accesorios deportivos",
						item_url: "https://www.falabella.com/falabella-cl/collection/Accesorios-Deportivos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12006/Accesorios-deportivos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Bolsos y mochilas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930147/Bolsos-y-mochilas-deportivas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botellas e hidratación",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930002/Deportes-y-aire-libre?facetSelected=true&f.product.attribute.Tipo=Botellas+deportivas%3A%3AProductos+de+hidrataci%C3%B3n",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calcetines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930002/Deportes-y-aire-libre?facetSelected=true&f.product.attribute.Tipo=Calcetines+deportivos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jockeys y gorros",
								item_url: "https://www.falabella.com/falabella-cl/collection/jockey-y-gorros-deportivos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pelotas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280239/Disciplinas?facetSelected=true&f.product.attribute.Tipo=Balones+de+entrenamiento%3A%3APelotas+de+b%C3%A1squet%3A%3APelotas+de+f%C3%BAtbol%3A%3APelotas+de+handball%3A%3APelotas+de+rugby%3A%3APelotas+de+voley",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Relojes y smartbands",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7480067/Relojes-deportivos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Disciplinas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7280239/Disciplinas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280239/Disciplinas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Básquetbol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90097/Basquetbol",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Boxeo y artes marciales",
								item_url: "https://www.falabella.com/falabella-cl/collection/box",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fútbol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90089/Futbol",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Motociclismo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190291/Motos-y-accesorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Náuticos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190285/Nauticos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Padel y tenis",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90090/Tenis--padel-y-squash",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ping pong y pool",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930454/Ping-pong--Taca-Taca-y-Pool",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vóleibol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5920003/Voleyball",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Yoga y pilates",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7450049/Yoga-y-pilates",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas destacadas",
						item_url: "https://www.falabella.com/falabella-cl/collection/deporte-marcas-destacadas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Adidas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=adidas%3A%3Aadidas+originals",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Diadora",
								item_url: "https://www.falabella.com/falabella-cl/collection/diadora",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ellesse",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930002/Deportes-y-aire-libre?facetSelected=true&f.product.brandName=ellesse",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jeep",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930002/Deportes-y-aire-libre?facetSelected=true&f.product.brandName=jeep",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lippi",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=lippi",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mossimo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=mossimo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mountain Gear",
								item_url: "https://www.falabella.com/falabella-cl/collection/mountain-gear",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Nike",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=nike",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Puma",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=puma",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Reebok",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=reebok",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "The North Face",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=north+face%3A%3Athe+north+face",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Under Armour",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=under+armour",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Deportes y aire libre",
				ver_todo: {
					title: "Ver todo Deportes",
					href: "https://tienda.falabella.com/falabella-cl/page/deporte"
				}
			},
			{
				canal: {
					adddesktop: false,
					addmobile: false,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icdeportes3x.png",
					title: "icdeportes3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltd78ed66a7672777b/61c1d7e5f8d92f21558914a9/icdeportes3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icdeportes.svg",
					title: "icdeportes.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltbcc40a9b1eb9fdc7/61bba9f78ae3ee7d4c1553b3/icdeportes.svg"
				},
				is_seasonal: false,
				item_name: "Deportes y aire libre",
				item_url: "https://tienda.falabella.com/falabella-cl/page/deporte",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Ver todo Deportes",
						item_url: "https://tienda.falabella.com/falabella-cl/page/deporte",
						gu_as_de_compra: [
						],
						third_level_categories: [
						]
					},
					{
						item_name: "Ropa deportiva mujer",
						item_url: "https://www.falabella.com/falabella-cl/category/cat6930168/Ropa-deportiva-mujer",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930168/Ropa-deportiva-mujer",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Calzas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930190/Calzas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantalones y shorts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12650001/Pantalones-y-Shorts?f.product.attribute.Tipo=Buzos%3A%3AJogger%3A%3APantalones%3A%3APantalones+de+buzo%3A%3APantalones+de+ski%3A%3APantalones+deportivos%3A%3APantalones+outdoor%3A%3AShorts%3A%3AShorts+deportivo%3A%3ASweatpants&f.range.derived.variant.discount_upto=Hasta+60%25+dcto",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parkas y cortavientos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12650002/Parkas-y-cortavientos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Petos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930191/Petos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Poleras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930180/Poleras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Polerones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930181/Polerones-Mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850068/Zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas Outdoors",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.attribute.Disciplina=Outdoor%3A%3ATrail+runningZapatillas&f.product.attribute.G%C3%A9nero=Mujer",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa deportiva hombre",
						item_url: "https://www.falabella.com/falabella-cl/category/cat6930003/Ropa-Deportiva-Hombre",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930003/Ropa-Deportiva-Hombre",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Camisetas de fútbol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat190004/Camisetas-Oficiales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantalones y joggers",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930019/Pantalones-y-Joggers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parkas y cortavientos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12650004/Parkas-y-Cortavientos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Poleras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930011/Poleras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Polerones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930014/Polerones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Shorts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930018/Shorts",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850064/Zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas Outdoors",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.attribute.Disciplina=Outdoor%3A%3ATrail+runningZapatillas&f.product.attribute.G%C3%A9nero=Hombre",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Bicicletas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat70007/Bicicletas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70007/Bicicletas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930367/Accesorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bicicletas de aprendizaje",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70007/Bicicletas?facetSelected=true&f.product.attribute.Tipo=Bicicleta+de+aprendizaje&isPLP=1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cascos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930376/Cascos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Eléctricas y plegables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat530006/Bicicletas-Electricas-y-Plegables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Infantiles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90099/Bicicletas-Infantiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mountain bike",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70008/Bicicletas-Mountain-Bike",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa ciclismo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930366/Ropa-Ciclismo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ruta y pista",
								item_url: "https://www.falabella.com/falabella-cl/category/cat190018/Bicicletas-Ruta-Pista",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Urbanas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70010/Bicicletas-Urbanas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Fitness",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2036/Fitness",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2036/Fitness",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930440/Accesorios-Fitness",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bicicletas estáticas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4046/Bicicletas-Estaticas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Crossfit",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4910004/Crossfit-y-Entrenamiento-Funcional",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Elípticas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4044/Elipticas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Home gym",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4053/Home-Gym",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mancuernas y pesas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930442/Mancuernas-y-Pesas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Spinning",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4092/Spinning",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trotadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19170001/Trotadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vitaminas y suplementos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11342105/Vitaminas-y-suplementos?facetSelected=true&f.product.attribute.Tipo=Suplementos+deportivos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Camping",
						item_url: "https://www.falabella.com/falabella-cl/category/cat6930448/Camping",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930448/Camping",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90105/Accesorios-Outdoor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Carpas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90101/Carpas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14790011/Cocina-de-Camping",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Colchones y colchonetas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90102/Colchones-y-Colchonetas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Coolers",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90104/Coolers-y-neveras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hidratación",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930080/Hidratacion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Linternas y lámparas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14790015/Linternas-y-lamparas-outdoor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mochilas y bolsos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90121/Mochilas-y-Bolsos-Outdoor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sacos de dormir",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90103/Sacos-de-Dormir",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas y mesas plegables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190301/Sillas-y-Mesas-Plegables",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Electromovilidad",
						item_url: "https://www.falabella.com/falabella-cl/category/cat18260007/Electromovilidad",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18260007/Electromovilidad",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Bicicletas eléctricas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat530006/Bicicletas-Electricas-y-Plegables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cascos urbanos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930376/Cascos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hoverboard",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280160/Hoverboard",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Monorueda, patín y skate",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18260008/Monorueda--Patin-y-skate",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Scooters eléctricos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8910010/Scooter-Electricos-Adulto",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Accesorios deportivos",
						item_url: "https://www.falabella.com/falabella-cl/collection/Accesorios-Deportivos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12006/Accesorios-deportivos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Bolsos y mochilas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930147/Bolsos-y-mochilas-deportivas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botellas e hidratación",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930002/Deportes-y-aire-libre?facetSelected=true&f.product.attribute.Tipo=Botellas+deportivas%3A%3AProductos+de+hidrataci%C3%B3n",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calcetines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930002/Deportes-y-aire-libre?facetSelected=true&f.product.attribute.Tipo=Calcetines+deportivos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jockeys y gorros",
								item_url: "https://www.falabella.com/falabella-cl/collection/jockey-y-gorros-deportivos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pelotas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280239/Disciplinas?facetSelected=true&f.product.attribute.Tipo=Balones+de+entrenamiento%3A%3APelotas+de+b%C3%A1squet%3A%3APelotas+de+f%C3%BAtbol%3A%3APelotas+de+handball%3A%3APelotas+de+rugby%3A%3APelotas+de+voley",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Relojes y smartbands",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7480067/Relojes-deportivos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Disciplinas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7280239/Disciplinas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280239/Disciplinas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Básquetbol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90097/Basquetbol",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Boxeo y artes marciales",
								item_url: "https://www.falabella.com/falabella-cl/collection/box",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fútbol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90089/Futbol",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Motociclismo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190291/Motos-y-accesorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Náuticos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190285/Nauticos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Padel y tenis",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90090/Tenis--padel-y-squash",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ping pong y pool",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930454/Ping-pong--Taca-Taca-y-Pool",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vóleibol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5920003/Voleyball",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Yoga y pilates",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7450049/Yoga-y-pilates",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas destacadas",
						item_url: "https://www.falabella.com/falabella-cl/collection/deporte-marcas-destacadas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Adidas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=adidas%3A%3Aadidas+originals",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Diadora",
								item_url: "https://www.falabella.com/falabella-cl/collection/diadora",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ellesse",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930002/Deportes-y-aire-libre?facetSelected=true&f.product.brandName=ellesse",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jeep",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930002/Deportes-y-aire-libre?facetSelected=true&f.product.brandName=jeep",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lippi",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=lippi",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mossimo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=mossimo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mountain Gear",
								item_url: "https://www.falabella.com/falabella-cl/collection/mountain-gear",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Nike",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=nike",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Puma",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=puma",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Reebok",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=reebok",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "The North Face",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=north+face%3A%3Athe+north+face",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Under Armour",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12010/Ropa-deportiva?facetSelected=true&f.product.brandName=under+armour",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Deportes y aire libre Solo APP",
				ver_todo: {
					title: "Ver todo Deportes",
					href: "https://tienda.falabella.com/falabella-cl/page/deporte"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icmascotas3x.png",
					title: "icmascotas3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt78bbe5383ed5f95f/61e02434ef206c6c5e494ed4/icmascotas3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icmascotas.svg",
					tags: [
					],
					title: "icmascotas.svg",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt6339dcc540f54187/61e0240a2e109d6c649d4891/icmascotas.svg"
				},
				is_seasonal: false,
				item_name: "Mascotas",
				item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Alimentos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.attribute.Tipo=Alimento+de+mascota%3A%3AAlimento+h%C3%BAmedo+para+gato%3A%3AAlimento+h%C3%BAmedo+para+perro%3A%3AAlimento+para+peces%3A%3AAlimento+para+tortuga%3A%3AAlimento+seco%3A%3AAlimento+seco+para+gato%3A%3AAlimento+seco+para+perro%3A%3ASnack+para+gato%3A%3ASnack+para+perro",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.attribute.Tipo=Alimento+de+mascota%3A%3AAlimento+h%C3%BAmedo+para+gato%3A%3AAlimento+h%C3%BAmedo+para+perro%3A%3AAlimento+para+peces%3A%3AAlimento+para+tortuga%3A%3AAlimento+seco%3A%3AAlimento+seco+para+gato%3A%3AAlimento+seco+para+perro%3A%3ASnack+para+gato%3A%3ASnack+para+perro",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Gatos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11631/Alimentacion-para-gatos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Otros animales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.attribute.Tipo=Alimento+de+mascota%3A%3AAlimento+para+peces%3A%3AAlimento+para+tortuga&f.product.attribute.Tipo_de_mascota=Ave%3A%3AAves%3A%3AConejo%3A%3AOtro%3A%3AOtros%3A%3ARoedor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perros",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11625/Alimentacion-para-perros",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Camas y casas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.attribute.Tipo=Cama+para+mascota%3A%3ACama+para+perro%3A%3ACasa+para+mascota%3A%3ACasa+para+perro%3A%3AGateras+y+rascadores",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.attribute.Tipo=Cama+para+mascota%3A%3ACama+para+perro%3A%3ACasa+para+mascota%3A%3ACasa+para+perro%3A%3AGateras+y+rascadores",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Gatos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11633/Camas-y-rascadores-para-gatos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360006/Casas--camas-y-transporte-para-perros",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Transporte y jaulas",
								item_url: "https://www.falabella.com/falabella-cl/search?Ntt=jaula&facetSelected=true&f.product.attribute.Tipo_de_producto=Casas+y+camas%3A%3AViajes",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Juguetes y entretención",
						item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.attribute.Tipo=Accesorios%3A%3AFiguras+de+animales%3A%3AGateras+y+rascadores%3A%3AHueso%3A%3AJuguete+para+gato%3A%3AJuguete+para+mascota%3A%3AJuguete+para+perro",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.attribute.Tipo=Accesorios%3A%3AFiguras+de+animales%3A%3AGateras+y+rascadores%3A%3AHueso%3A%3AJuguete+para+gato%3A%3AJuguete+para+mascota%3A%3AJuguete+para+perro",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Gatos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11632/Juguetes-y-entretencion-para-gatos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perros",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11626/Juguetes-y-entrenamiento-para-perro",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Pet lovers",
						item_url: "https://www.falabella.com/falabella-cl/category/cat13620011/Pet-Lovers",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13620011/Pet-Lovers",
								tag: {
								},
								is_ver_todo: true
							}
						]
					},
					{
						item_name: "Higiene y cuidados",
						item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.attribute.Tipo=Acondicionador%3A%3AAntiparasitario%3A%3AArena%3A%3AArena+sanitaria%3A%3AArena+sanitaria+para+gato%3A%3AHigiene+para+gato%3A%3AMedicamento+para+mascota%3A%3AOtros+accesorios+de+higiene%3A%3APeluqueria+canina%3A%3AShampoo",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.attribute.Tipo=Acondicionador%3A%3AAntiparasitario%3A%3AArena%3A%3AArena+sanitaria%3A%3AArena+sanitaria+para+gato%3A%3AHigiene+para+gato%3A%3AMedicamento+para+mascota%3A%3AOtros+accesorios+de+higiene%3A%3APeluqueria+canina%3A%3AShampoo",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Gatos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11629/Higiene-y-cuidados-para-gatos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perros",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11624/Higiene-y-cuidados-para-perros",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa y accesorios",
						item_url: "https://www.falabella.com/falabella-cl/category/cat9360004/Ropa-y-accesorios-para-perros?&f.product.L2_category_paths=cat9360001%7C%7CMascotas%2FCATG11619%7C%7CPerros%2Fcat9360004%7C%7CRopa+y+accesorios+para+perros",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360004/Ropa-y-accesorios-para-perros?&f.product.L2_category_paths=cat9360001%7C%7CMascotas%2FCATG11619%7C%7CPerros%2Fcat9360004%7C%7CRopa+y+accesorios+para+perros",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Gatos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11630/Ropa-y-accesorios-para-gatos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360004/Ropa-y-accesorios-para-perros",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Arnés, collares y correas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat12562928/Arnes--Collares-y-Correas?&f.product.L2_category_paths=cat9360001%7C%7CMascotas%2FCATG11619%7C%7CPerros%2Fcat12562928%7C%7CArnes%2C+Collares+y+Correas&mkid=PL_B1_PER_91",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12562928/Arnes--Collares-y-Correas?&f.product.L2_category_paths=cat9360001%7C%7CMascotas%2FCATG11619%7C%7CPerros%2Fcat12562928%7C%7CArnes%2C+Collares+y+Correas&mkid=PL_B1_PER_91",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Gatos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11628/Arneses-y-collares",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12562928/Arnes--Collares-y-Correas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas destacadas",
						item_url: "",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Cat Chow",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.brandName=cat+chow",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Champion Cat",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.brandName=champion+cat",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Champion Dog",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.brandName=champion+dog",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dog Chow",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.brandName=dog+chow",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dog Plus",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.brandName=dog+plus",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hills",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.brandName=hill%3Fs%3A%3Ahills+pet+nutrition",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Master Cat",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.brandName=master+cat%3A%3Amastercat",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Master Dog",
								item_url: "https://www.falabella.com/falabella-cl/search?Ntt=&f.product.brandName=MASTER%20DOG",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pedigree",
								item_url: "https://www.falabella.com/falabella-cl/search?Ntt=&f.product.brandName=PEDIGREE",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Petizoos",
								item_url: "https://www.falabella.com/falabella-cl/search?Ntt=&f.product.brandName=PETIZOOS",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vitalcan",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.product.brandName=vitalcan",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: "NUEVO",
				tags: [
				],
				title: "Mascotas",
				ver_todo: {
					title: "Ver todo Mascotas",
					href: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas"
				}
			},
			{
				canal: {
					adddesktop: false,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icmujer3x.png",
					title: "icmujer3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf7acc53dc814ef1f/61c1d7f8c455652925b79892/icmujer3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icmujer.svg",
					title: "icmujer.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt9f2eb45d4f0e2764/61bba9f73d2b1760404ecb8f/icmujer.svg"
				},
				is_seasonal: false,
				item_name: "Mujer",
				item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Tendencias e inspiración",
						item_url: "https://tienda.falabella.com/falabella-cl/page/moda-f",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Inspírate con Moda F",
								item_url: "https://tienda.falabella.com/falabella-cl/page/moda-f",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Marcas premium",
								item_url: "https://tienda.falabella.com/falabella-cl/page/marcas-premium",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mejores marcas zapatos",
								item_url: "https://tienda.falabella.com/falabella-cl/page/zapatos-mejores-marcas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sneaker corner",
								item_url: "https://tienda.falabella.com/falabella-cl/page/zapatillas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Segmentos y ocasiones",
						item_url: "https://www.falabella.com/falabella-cl/category/cat11670003/Especiales",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Diseño local",
								item_url: "https://www.falabella.com/falabella-cl/collection/diseno-local",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mundo señora",
								item_url: "https://www.falabella.com/falabella-cl/collection/mundo-senora",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mundo surf",
								item_url: "https://www.falabella.com/falabella-cl/collection/Mundo-Surf",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa de fiesta",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14330023/Vestidos-y-enteritos?&f.product.attribute.Estilo=Fiesta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa maternal",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350021/Ropa-Maternal",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa + sustentable",
								item_url: "https://www.falabella.com/falabella-cl/collection/mas-verde-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tallas grandes",
								item_url: "https://www.falabella.com/falabella-cl/collection/Tallas-Grandes-Mujer",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Zapatos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat12440001/Zapatos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12440001/Zapatos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Botines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690245/Botines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botas mujer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690241/Botas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850068/Zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat660024/Zapatos-mujer",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa",
						item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/Nueva-Temporada-Moda-Mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Blusas y poleras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850030/Blusas-y-Poleras-Mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Buzos y calzas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.attribute.Tipo=Buzos%3A%3ACalzas%3A%3ALeggins",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chaquetas y parkas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850036/Abrigos-y-Chaquetas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Faldas y shorts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.attribute.Tipo=Bermudas%3A%3AFaldas%3A%3AShorts",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jeans",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850040/Pantalones?facetSelected=true&f.product.attribute.Tipo=Jeans",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Kimonos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850036/Abrigos-y-Chaquetas?facetSelected=true&f.product.attribute.Tipo=Kimonos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Packs",
								item_url: "https://www.falabella.com/falabella-cl/collection/packs-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantalones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850040/Pantalones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Polerones y chiporros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350055/Polerones-Mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sweaters y chalecos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850034/Sweaters-y-chalecos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trajes de baño",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11610008/Trajes-de-bano-y-bikinis",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vestidos y enteritos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14330023/Vestidos-y-enteritos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas de lujo",
						item_url: "https://www.falabella.com/falabella-cl/collection/marcas-premium-accesorios",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "DKNY",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex&f.product.brandName=dkny",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Furla",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7480104/Carteras-y-mochilas?facetSelected=true&f.product.brandName=furla",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Longchamp",
								item_url: "https://tienda.falabella.com/falabella-cl/page/longchamp?sred=longchamp",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Michael Kors",
								item_url: "https://tienda.falabella.com/falabella-cl/page/michael-kors?sred=michael-kors",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ralph Lauren",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?&facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex&f.product.brandName=lauren+ralph+lauren",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tous",
								item_url: "https://www.falabella.com/falabella-cl/collection/tous?mkid=LA_BO_VER_687",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa interior y pijamas",
						item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-ropa-interior-mujer",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13140017/Ropa-Interior-y-Pijamas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/lo-nuevo-en-ropa-interior-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calzones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350018/Calzones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fajas y modeladores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350012/Fajas-y-Modeladores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pack ropa interior",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13140017/Ropa-Interior-y-Pijamas?&facetSelected=true&f.product.attribute.Contenido=Pack+de+2%3A%3APack+de+3",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantuflas y accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16630007/Pantuflas-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantys y calcetines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350013/Pantys-y-Calcetines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pijamas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350017/Pijamas-y-Camisas-de-dormir",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sostenes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350019/Sostenes",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Accesorios",
						item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2017/Accesorios",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/lo-nuevo-en-carteras-y-mochilas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Billeteras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3038/Billeteras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Carteras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7480104/Carteras-y-mochilas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cinturones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3062/Cinturones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jockeys y gorros",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer&f.product.attribute.Tipo=Gorros%3A%3AJockeys%3A%3ASombreros",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Joyas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat590028/Joyas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lentes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat570195/Lentes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lentes ópticos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11810/Lentes-opticos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mascarillas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12004/Mascarillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mochilas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5880085/Mochilas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pañuelos y bufandas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3088/Panuelos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Relojes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12160001/Relojes-Mujer",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas destacadas",
						item_url: "https://tienda.falabella.com/falabella-cl/page/marcas-destacadas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Marcas de la A a la Z",
								item_url: "https://tienda.falabella.com/falabella-cl/page/marcas-destacadas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aldo",
								item_url: "https://tienda.falabella.com/falabella-cl/page/aldo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Americanino",
								item_url: "https://tienda.falabella.com/falabella-cl/page/americanino",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Basement",
								item_url: "https://tienda.falabella.com/falabella-cl/page/basement",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calzedonia",
								item_url: "https://tienda.falabella.com/falabella-cl/page/calzedonia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dahla",
								item_url: "https://tienda.falabella.com/falabella-cl/page/dahla",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Desigual",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat7330051/Mujer?facetSelected=true&f.product.brandName=desigual",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Elle",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer?facetSelected=true&f.product.brandName=elle",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Esprit",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.brandName=esprit",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Etam",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer?facetSelected=true&f.product.brandName=etam",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "GAP",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer?facetSelected=true&f.product.brandName=gap",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lounge",
								item_url: "https://www.falabella.com/falabella-cl/collection/landing-lounge?sred=loungee",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mango",
								item_url: "https://tienda.falabella.com/falabella-cl/page/mango",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mossimo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer?facetSelected=true&f.product.brandName=mossimo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pandora",
								item_url: "https://tienda.falabella.com/falabella-cl/page/pandora",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Rapsodia",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.brandName=rapsodia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Superdry",
								item_url: "https://tienda.falabella.com/falabella-cl/page/superdry",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sybilla",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.brandName=sybilla",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "University Club",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer?f.product.brandName=university+club",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vero Moda",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.brandName=vero+moda",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Mujer Mobile y App",
				ver_todo: {
					title: "Ver todo Mujer",
					href: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: false,
					addapp: false
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icmujer3x.png",
					title: "icmujer3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf7acc53dc814ef1f/61c1d7f8c455652925b79892/icmujer3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icmujer.svg",
					title: "icmujer.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt9f2eb45d4f0e2764/61bba9f73d2b1760404ecb8f/icmujer.svg"
				},
				is_seasonal: false,
				item_name: "Mujer",
				item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Tendencias e inspiración",
						item_url: "https://tienda.falabella.com/falabella-cl/page/moda-f",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Inspírate con Moda F",
								item_url: "https://tienda.falabella.com/falabella-cl/page/moda-f",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Marcas premium",
								item_url: "https://tienda.falabella.com/falabella-cl/page/marcas-premium",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mejores marcas zapatos",
								item_url: "https://tienda.falabella.com/falabella-cl/page/zapatos-mejores-marcas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sneaker corner",
								item_url: "https://tienda.falabella.com/falabella-cl/page/zapatillas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Segmentos y ocasiones",
						item_url: "https://www.falabella.com/falabella-cl/category/cat11670003/Especiales",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Diseño local",
								item_url: "https://www.falabella.com/falabella-cl/collection/diseno-local",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mundo señora",
								item_url: "https://www.falabella.com/falabella-cl/collection/mundo-senora",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mundo surf",
								item_url: "https://www.falabella.com/falabella-cl/collection/Mundo-Surf",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa de fiesta",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14330023/Vestidos-y-enteritos?&f.product.attribute.Estilo=Fiesta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa maternal",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350021/Ropa-Maternal",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa + sustentable",
								item_url: "https://www.falabella.com/falabella-cl/collection/mas-verde-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tallas grandes",
								item_url: "https://www.falabella.com/falabella-cl/collection/Tallas-Grandes-Mujer",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Zapatos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat12440001/Zapatos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12440001/Zapatos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Botines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690245/Botines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botas mujer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690241/Botas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850068/Zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat660024/Zapatos-mujer",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa",
						item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/Nueva-Temporada-Moda-Mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Blusas y poleras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850030/Blusas-y-Poleras-Mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Buzos y calzas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.attribute.Tipo=Buzos%3A%3ACalzas%3A%3ALeggins",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chaquetas y parkas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850036/Abrigos-y-Chaquetas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Faldas y shorts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.attribute.Tipo=Bermudas%3A%3AFaldas%3A%3AShorts",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jeans",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850040/Pantalones?facetSelected=true&f.product.attribute.Tipo=Jeans",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Kimonos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850036/Abrigos-y-Chaquetas?facetSelected=true&f.product.attribute.Tipo=Kimonos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Packs",
								item_url: "https://www.falabella.com/falabella-cl/collection/packs-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantalones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850040/Pantalones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Polerones y chiporros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350055/Polerones-Mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sweaters y chalecos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850034/Sweaters-y-chalecos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trajes de baño",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11610008/Trajes-de-bano-y-bikinis",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vestidos y enteritos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14330023/Vestidos-y-enteritos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas de lujo",
						item_url: "https://www.falabella.com/falabella-cl/collection/marcas-premium-accesorios",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "DKNY",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex&f.product.brandName=dkny",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Furla",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7480104/Carteras-y-mochilas?facetSelected=true&f.product.brandName=furla",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Longchamp",
								item_url: "https://tienda.falabella.com/falabella-cl/page/longchamp?sred=longchamp",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Michael Kors",
								item_url: "https://tienda.falabella.com/falabella-cl/page/michael-kors?sred=michael-kors",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ralph Lauren",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?&facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex&f.product.brandName=lauren+ralph+lauren",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tous",
								item_url: "https://www.falabella.com/falabella-cl/collection/tous?mkid=LA_BO_VER_687roduct.attribute.G%C3%A9nero=Mujer%3A%3AUnisex&f.product.brandName=coach",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa interior y pijamas",
						item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-ropa-interior-mujer",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13140017/Ropa-Interior-y-Pijamas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/lo-nuevo-en-ropa-interior-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calzones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350018/Calzones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fajas y modeladores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350012/Fajas-y-Modeladores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pack ropa interior",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13140017/Ropa-Interior-y-Pijamas?&facetSelected=true&f.product.attribute.Contenido=Pack+de+2%3A%3APack+de+3",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantys y calcetines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350013/Pantys-y-Calcetines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pijamas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350017/Pijamas-y-Camisas-de-dormir",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sostenes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7350019/Sostenes",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Accesorios",
						item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2017/Accesorios",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/lo-nuevo-en-carteras-y-mochilas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Billeteras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3038/Billeteras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Carteras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7480104/Carteras-y-mochilas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cinturones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3062/Cinturones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jockeys y gorros",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer&f.product.attribute.Tipo=Gorros%3A%3AJockeys%3A%3ASombreros",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Joyas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat590028/Joyas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lentes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat570195/Lentes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mochilas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5880085/Mochilas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Relojes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12160001/Relojes-Mujer",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas destacadas",
						item_url: "https://tienda.falabella.com/falabella-cl/page/marcas-destacadas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Marcas de la A a la Z",
								item_url: "https://tienda.falabella.com/falabella-cl/page/marcas-destacadas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aldo",
								item_url: "https://tienda.falabella.com/falabella-cl/page/aldo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Americanino",
								item_url: "https://tienda.falabella.com/falabella-cl/page/americanino",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Basement",
								item_url: "https://tienda.falabella.com/falabella-cl/page/basement",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calzedonia",
								item_url: "https://tienda.falabella.com/falabella-cl/page/calzedonia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dahla",
								item_url: "https://tienda.falabella.com/falabella-cl/page/dahla",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Desigual",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat7330051/Mujer?facetSelected=true&f.product.brandName=desigual",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Elle",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer?facetSelected=true&f.product.brandName=elle",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Esprit",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.brandName=esprit",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Etam",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer?facetSelected=true&f.product.brandName=etam",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "GAP",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer?facetSelected=true&f.product.brandName=gap",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lounge",
								item_url: "https://www.falabella.com/falabella-cl/collection/landing-lounge?sred=lounge",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mango",
								item_url: "https://tienda.falabella.com/falabella-cl/page/mango",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mossimo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer?facetSelected=true&f.product.brandName=mossimo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pandora",
								item_url: "https://tienda.falabella.com/falabella-cl/page/pandora",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Rapsodia",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.brandName=rapsodia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Superdry",
								item_url: "https://tienda.falabella.com/falabella-cl/page/superdry",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sybilla",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.brandName=sybilla",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "University Club",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer?f.product.brandName=university+club",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vero Moda",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?facetSelected=true&f.product.brandName=vero+moda",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Mujer Desktop",
				ver_todo: {
					title: "Ver todo Mujer",
					href: "https://www.falabella.com/falabella-cl/category/cat7330051/Mujer"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icninos3x.png",
					title: "icninos3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt2399020a097356b7/61c1d7f89d4a976169b70ab4/icninos3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icninos.svg",
					title: "icninos.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltd2d44e532d12a746/61bba9f7c9ed2d27fb59ea4f/icninos.svg"
				},
				is_seasonal: false,
				item_name: "Niños y juguetería",
				item_url: "https://www.falabella.com/falabella-cl/category/cat13550007/Ninos-y-Jugueteria",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Ropa de niñas por edad",
						item_url: "https://www.falabella.com/falabella-cl/category/cat13680004/Ropa-de-bebe-nina",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "0 - 24 meses",
								item_url: "https://www.falabella.com/falabella-cl/collection/ropa-bebe-nina-0-a-24",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "2 - 8 años",
								item_url: "https://www.falabella.com/falabella-cl/collection/ropa-nina-2-a-8",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "8 - 16 años",
								item_url: "https://www.falabella.com/falabella-cl/collection/ropa-nina-8-a16",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa de niñas por tipo",
						item_url: "https://www.falabella.com/falabella-cl/category/cat12850003/Ropa-de-ninas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12850003/Ropa-de-ninas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Buzos y conjuntos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7660148/Buzos-y-Conjuntos-Ninas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calcetines y ropa interior",
								item_url: "https://www.falabella.com/falabella-cl/category/cat17180020/Ropa-Interior-y-Pijamas-Ninas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calzas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14370004/Calzas-Ninas?facetSelected=true&f.product.attribute.Tipo=Calzas%3A%3ALeggins%3A%3APantys",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chalecos y polerones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16400013/Sweaters-y-Polerones-Ninas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chaquetas y parkas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat17010032/Chaquetas--Parkas-y-Abrigos-Ninas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jeans y pantalones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16400014/Jeans-y-Pantalones-Ninas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pijamas y pantuflas",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-pijamas-nina?facetSelected=true&f.product.attribute.Tipo=Pantuflas%3A%3APijamas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Poleras y blusas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16400012/Poleras-y-Blusas-Ninas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa deportiva",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12270016/Ropa-Deportiva?f.product.attribute.G%C3%A9nero=Ni%C3%B1a%3A%3AUnisex",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Shorts y jardineras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19280007/Shorts-Ninas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trajes de baño y bikinis",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19290017/Trajes-de-Bano-y-Bikinis-Ninas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vestidos y enteritos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16400015/Faldas-y-Vestidos-Ninas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa de niños por edad",
						item_url: "https://www.falabella.com/falabella-cl/category/cat14730004/Ropa-de-bebe-nino",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "0 - 24 meses",
								item_url: "https://www.falabella.com/falabella-cl/collection/ropa-bebe-nino-0-a-24",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "2 - 8 años",
								item_url: "https://www.falabella.com/falabella-cl/collection/ropa-nino-2-a-8",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "8 - 16 años",
								item_url: "https://www.falabella.com/falabella-cl/collection/ropa-nino-8-a-16",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa de niños por tipo",
						item_url: "https://www.falabella.com/falabella-cl/category/cat12850002/Ropa-de-ninos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12850002/Ropa-de-ninos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Calcetines y ropa interior",
								item_url: "https://www.falabella.com/falabella-cl/category/cat17180021/Ropa-Interior-y-Pijamas-Ninos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Conjuntos y buzos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16400020/Buzos-y-Conjuntos-Ninos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chalecos y polerones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16400018/Sweaters-y-Polerones-Ninos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chaquetas y parkas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat17010033/Chaquetas--Parkas-y-Abrigos-Ninos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jeans y pantalones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16400019/Jeans-y-Pantalones-Ninos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pijamas y pantuflas",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-ropa-interior-y-pijamas-nino?facetSelected=true&f.product.attribute.Tipo=Pantuflas%3A%3APijamas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Poleras y camisas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16400016/Poleras-y-Camisas-Ninos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa deportiva",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12270016/Ropa-Deportiva?f.product.attribute.G%C3%A9nero=Ni%C3%B1o%3A%3AUnisex",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Shorts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19280010/Shorts-Ninos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trajes de baño",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19290018/Trajes-de-Bano-Ninos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Zapatos",
						item_url: "https://www.falabella.com/falabella-cl/collection/Ver-Todo-Zapatos-Ninos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/Ver-Todo-Zapatos-Ninos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/zapatos-ninos-nueva-coleccion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botas y botines",
								item_url: "https://www.falabella.com/falabella-cl/collection/Ver-Todo-Zapatos-Ninos?f.product.attribute.Tipo=Botas%3A%3ABotas+de+lluvia%3A%3ABotines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/collection/Ver-Todo-Zapatillas-Ninos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Juguetes",
						item_url: "https://www.falabella.com/falabella-cl/category/cat14680031/Juguetes",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14680031/Juguetes",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Autos y pistas de juguetes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11837/Autos-y-vehiculos-a-control-remoto",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Disfraces",
								item_url: "https://www.falabella.com/falabella-cl/category/cat210002/Disfraces",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Figuras de acción",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690299/Figuras-de-accion-y-coleccionables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juegos de mesa",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3127/Juegos-de-Mesa",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juegos de rol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6980031/Juegos-de-Rol",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juguetes de bebé",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4059/Juguetes-bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juguetes didácticos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90080/Juguetes-Didacticos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "LEGO y armables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat430005/Lego-y-Armables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muñecas y accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90074/Munecas-y-Accesorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Peluches",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90075/Peluches",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pistolas de juguete",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90083/Pistolas-de-Juguete",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Rompecabezas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8860003/Puzzles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Videojuegos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2023/Videojuegos?isLanding=true",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Juguetería por edad",
						item_url: "https://www.falabella.com/falabella-cl/category/cat14680031/Juguetes",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14680031/Juguetes",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "0 - 1 año",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14680031/Juguetes?facetSelected=true&f.product.attribute.Edad_m%C3%ADnima_recomendada=3+meses%3A%3A6+meses%3A%3A9+meses%3A%3AReci%C3%A9n+nacido",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "1 - 2 años",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14680031/Juguetes?f.product.attribute.Edad_m%C3%ADnima_recomendada=1+a%C3%B1o%3A%3A12+meses%3A%3A2+a%C3%B1os",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "3 - 5 años",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14680031/Juguetes?f.product.attribute.Edad_m%C3%ADnima_recomendada=3+a%C3%B1os%3A%3A4+a%C3%B1os%3A%3A5+a%C3%B1os&isPLP=1%2C1%2C1%2C1&isPLP=1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "6 - 8 años",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14680031/Juguetes?f.product.attribute.Edad_m%C3%ADnima_recomendada=6+a%C3%B1os%3A%3A7+a%C3%B1os%3A%3A8+a%C3%B1os&isPLP=1%2C1%2C1%2C1%2C1&isPLP=1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "9 años o más",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14680031/Juguetes?f.product.attribute.Edad_m%C3%ADnima_recomendada=10+a%C3%B1os%3A%3A11+a%C3%B1os%3A%3A12+a%C3%B1os%3A%3A13+a%C3%B1os%3A%3A14+a%C3%B1os%3A%3A15+a%C3%B1os%3A%3A9+a%C3%B1os&isPLP=1%2C1%2C1%2C1%2C1%2C1%2C1%2C1&isPLP=1",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Juegos de exterior",
						item_url: "https://www.falabella.com/falabella-cl/category/cat690277/Juegos-de-Exterior-e-Interior",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690277/Juegos-de-Exterior-e-Interior",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Autos a batería",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90084/Autos-a-bateria",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camas elásticas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90024/Camas-elasticas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Casas de juego y carpas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12270018/Casas-de-juego-y-carpas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Go karts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1100004/Go-kart",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Inflables",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930380/Inflables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Inflables para piscina",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10509/Inflables-y-juegos-para-piscina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ping pong, taca taca y pool",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930454/Ping-pong,-Taca-Taca-y-Pool",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Piscinas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280050/Piscinas--spa-e-inflables",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Resbalines y columpios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12270019/Resbalines--columpios-y-balancines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Scooter, skate y patines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280035/Scooter--Skate-y-Patines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Triciclos y correpasillos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3078/Triciclos-y-Correpasillos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Niños y juguetería",
				ver_todo: {
					title: "Ver todo Niños y juguetería",
					href: "https://www.falabella.com/falabella-cl/category/cat13550007/Ninos-y-Jugueteria"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "ichombre3x.png",
					title: "ichombre3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltccb04aa36c60085e/61c1d7e69793463f93f42abf/ichombre3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "ichombre.svg",
					title: "ichombre.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt04e87fa3dbb450ec/61bba9f79793463f93f420f4/ichombre.svg"
				},
				is_seasonal: false,
				item_name: "Hombre",
				item_url: "https://www.falabella.com/falabella-cl/category/cat7450065/Hombre",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Tendencias e inspiración",
						item_url: "https://tienda.falabella.com/falabella-cl/page/moda-hombre",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Inspírate con Moda F",
								item_url: "https://tienda.falabella.com/falabella-cl/page/moda-hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mundo surf",
								item_url: "https://www.falabella.com/falabella-cl/collection/marcas-surferas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa + sustentable",
								item_url: "https://www.falabella.com/falabella-cl/collection/-2bverde-hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sneaker corner",
								item_url: "https://tienda.falabella.com/falabella-cl/page/zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tallas grandes",
								item_url: "https://www.falabella.com/falabella-cl/collection/tallas-grande-hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Urban store",
								item_url: "https://tienda.falabella.com/falabella-cl/page/urbano-hombre",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Zapatos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/zapatos-hombre-nueva-coleccion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botas y botines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720008/Zapatos-hombre?f.product.attribute.Tipo=Botas%3A%3ABotines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantuflas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos?facetSelected=true&f.product.attribute.Tipo=Pantuflas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850064/Zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720008/Zapatos-hombre",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa interior y pijamas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat5260002/Ropa-interior",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5260002/Ropa-interior",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Boxers y calzoncillos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7450083/Boxers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calcetines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7450088/Calcetines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pijamas y camisetas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7450086/Pijamas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa",
						item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/Nueva-temporada-Moda-Hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camisas y guayaberas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18380042/Camisas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chalecos y sweaters",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320012/Chalecos-y-Sweaters",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chaquetas y parkas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16580002/Chaquetas-y-abrigos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jeans",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7450073/Jeans-Hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantalones y buzos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat17980009/Pantalones-Hombre?f.product.attribute.G%C3%A9nero=Hombre&facetSelected=true",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Poleras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320010/Poleras?f.product.attribute.G%C3%A9nero=Hombre&facetSelected=true",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Polerones y polar",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7500027/Polerones-y-Polar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Shorts y trajes de baño",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre?facetSelected=true&f.product.attribute.Tipo=Bermudas%3A%3ABermudas+denim%3A%3AShorts%3A%3AShorts+de+buzo%3A%3ATrajes+de+ba%C3%B1o",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trajes formales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1640033/Trajes-formales",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Cuidado personal",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7660002/Belleza?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7660002/Belleza?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Afeitadoras y cortapelos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11731/Afeitadoras-y-Cortapelos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cuidado capilar",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7660002/Belleza?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre&f.product.attribute.Tipo=Aceites+capilares%3A%3AAcondicionadores%3A%3AAftershave%3A%3AControl+ca%C3%ADda%3A%3ACremas+de+masaje+capilar%3A%3ACremas+para+peinar%3A%3AOtros+accesorios+de+belleza%3A%3APreparados+de+afeitar%3A%3ASet+de+tratamiento+capilar%3A%3AShampoos%3A%3ASprays+capilares%3A%3ATratamientos+capilares",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perfumes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3112/Perfumes-Hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tratamiento",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3214/Cuidado-del-Rostro?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vitaminas y suplementos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11342105/Vitaminas-y-suplementos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa deportiva",
						item_url: "https://www.falabella.com/falabella-cl/category/cat6930003/Ropa-deportiva-hombre",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930003/Ropa-deportiva-hombre",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12006/Accesorios-deportivos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bolsos deportivos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930147/Bolsos-deportivos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camisetas de fútbol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat190004/Camisetas-Oficiales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantalones y joggers",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930019/Pantalones-y-Joggers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parkas y cortavientos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12650004/Parkas-y-Cortavientos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Poleras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930011/Poleras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Polerones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930014/Polerones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Shorts",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930018/Shorts",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Accesorios",
						item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre%3A%3AUnisex",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6050003/Accesorios",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Billeteras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6050006/Billeteras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bufandas y pañuelos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6050009/Bufandas-y-Panuelos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cinturones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6050005/Cinturones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Corbatas y humitas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320018/Corbatas-y-Humitas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jockeys y gorros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6050008/Jockeys-y-Gorros",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lentes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6050011/Lentes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mochilas y bolsos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6050007/Bolsos-y-Mochilas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Relojes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3207/Relojes-hombre",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas destacadas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat5420004/Marcas--Destacadas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Adidas",
								item_url: "https://www.falabella.com/falabella-cl/collection/adidas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Americanino",
								item_url: "https://tienda.falabella.com/falabella-cl/page/americanino",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Basement",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre?f.product.brandName=basement",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calvin Klein",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre?f.product.brandName=calvin+klein",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cascais",
								item_url: "https://tienda.falabella.com/falabella-cl/page/cascais",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Casio",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3208/Relojes?mkid=PL_HU_VER_1000010543&f.product.brandName=casio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Festina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3208/Relojes?mkid=PL_HU_VER_1000010545&&f.product.brandName=festina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "G Schock",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3208/Relojes?facetSelected=true&f.product.brandName=g-shock",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Kaya Unite",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7450065/Hombre?facetSelected=true&f.product.brandName=kaya+unite",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lacoste",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre?f.product.brandName=lacoste",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "La Martina",
								item_url: "https://tienda.falabella.com/falabella-cl/page/la-martina?sred=la-martina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Levi´s",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre?f.product.brandName=levis%3A%3Alevis+negocio+especial",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lippi",
								item_url: "https://www.falabella.com/falabella-cl/collection/lippi",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mango Man",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre?facetSelected=true&f.product.brandName=mango+man",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Marmot",
								item_url: "https://www.falabella.com/falabella-cl/search?Ntt=&f.product.brandName=Marmot",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mossimo",
								item_url: "https://tienda.falabella.com/falabella-cl/page/vidal-mossimo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "NBA",
								item_url: "https://www.falabella.com/falabella-cl/collection/nba-hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Nike",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930003/Ropa-deportiva-hombre?facetSelected=true&f.product.brandName=nike",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tommy Hilfiger",
								item_url: "https://www.falabella.com/falabella-cl/collection/tommy-hilfiger-hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ray Ban",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7480074/Anteojos?facetSelected=true&f.product.brandName=ray+ban",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Superdry",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7450065/Hombre?facetSelected=true&f.product.brandName=superdry",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Wolf&Hank",
								item_url: "https://tienda.falabella.com/falabella-cl/page/wolf-hank",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Hombre",
				ver_todo: {
					title: "Ver todo Hombre",
					href: "https://www.falabella.com/falabella-cl/category/cat7450065/Hombre"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icbebes3x.png",
					title: "icbebes3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt19198c2478e49f47/61c1d7e63d2b1760404ed551/icbebes3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icbebes.svg",
					title: "icbebes.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt29f1d661f4d54701/61bba9f785b59c201581b31c/icbebes.svg"
				},
				is_seasonal: false,
				item_name: "Bebés",
				item_url: "https://www.falabella.com/falabella-cl/category/cat2008/Mundo-Bebe",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Ropa bebé niña por edad",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7280122/Ropa-de-bebe?f.product.attribute.Género=Niña%3A%3AUnisex",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "0 - 6 meses",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280122/Ropa-de-bebe?facetSelected=true&f.product.attribute.G%C3%A9nero=Beb%C3%A9+ni%C3%B1a%3A%3ANi%C3%B1a%3A%3AUnisex&f.variant.attribute.size=0+meses%3A%3A3+meses%3A%3A6+meses%3A%3Aprematuro%3A%3Atu",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "6 - 12 meses",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280122/Ropa-de-bebe?facetSelected=true&f.product.attribute.G%C3%A9nero=Beb%C3%A9+ni%C3%B1a%3A%3ANi%C3%B1a%3A%3AUnisex&f.variant.attribute.size=12+meses%3A%3A6+meses%3A%3A9+meses%3A%3Atu",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "12 - 24 meses",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280122/Ropa-de-bebe?facetSelected=true&f.product.attribute.G%C3%A9nero=Beb%C3%A9+ni%C3%B1a%3A%3ANi%C3%B1a%3A%3AUnisex&f.variant.attribute.size=12+meses%3A%3A18+meses%3A%3A24+meses%3A%3A36+meses",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa bebé niña por tipo",
						item_url: "https://www.falabella.com/falabella-cl/category/cat13680004/Vestuario-Bebe-Nina",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13680004/Vestuario-Bebe-Nina",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Bodies y piluchos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330009/Bodies-Ninas-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Buzos y sets",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330007/Buzos-y-Conjuntos-Ninas-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calcetines, baberos y gorros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330010/Ropa-Interior-Ninas-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calzas, jeans y pantalones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330005/Jeans-y-Pantalones-Ninas-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chaquetas y parkas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330030/Chaquetas,-Parkas-y-Abrigos-Ninas-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ositos y enteritos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330006/Ositos-y-Enteritos-Ninas-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Patitas y pantys",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13680004/Ropa-de-bebe-nina?f.product.attribute.Tipo=Pantys&isPLP=1%2C1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pijamas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330012/Pijamas-Ninas-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Poleras, blusas y camisetas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330001/Poleras-y-Blusas-Ninas-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Polerones y chalecos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330011/Sweaters-y-Polerones-Ninas-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trajes de baño",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330004/Trajes-de-Banos-y-Bikinis-Ninas-Bebe?&f.product.attribute.Género=Niña%3A%3AUnisex",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vestidos y jardineras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330003/Faldas-y-Vestidos-Ninas-Bebe",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa bebé niño por edad",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7280122/Ropa-de-bebe?&f.product.attribute.Género=Niño%3A%3AUnisex",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "0-6 meses",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280122/Ropa-de-bebe?facetSelected=true&f.product.attribute.G%C3%A9nero=Beb%C3%A9+ni%C3%B1o%3A%3ANi%C3%B1o%3A%3AUnisex&f.variant.attribute.size=0+meses%3A%3A3+meses%3A%3A6+meses%3A%3Aprematuro%3A%3Atu",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "6-12 meses",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280122/Ropa-de-bebe?facetSelected=true&f.product.attribute.G%C3%A9nero=Beb%C3%A9+ni%C3%B1o%3A%3ANi%C3%B1o%3A%3AUnisex&f.variant.attribute.size=12+meses%3A%3A6+meses%3A%3A9+meses%3A%3Atu",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "12-24 meses",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7280122/Ropa-de-bebe?facetSelected=true&f.product.attribute.G%C3%A9nero=Beb%C3%A9+ni%C3%B1o%3A%3ANi%C3%B1o%3A%3AUnisex&f.variant.attribute.size=12+meses%3A%3A18+meses%3A%3A24+meses%3A%3A36+meses",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa bebé niño por tipo",
						item_url: "https://www.falabella.com/falabella-cl/category/cat14730004/Vestuario-Bebe-Nino",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14730004/Vestuario-Bebe-Nino",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Bodies y piluchos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330025/Bodies-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Buzos y sets",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330022/Buzos-y-Conjuntos-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calcetines, baberos y gorros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330026/Ropa-Interior-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chaquetas y parkas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330017/Chaquetas,-Parkas-y-Abrigos-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jeans y pantalones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330021/Jeans-y-Pantalones-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ositos y enteritos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330023/Ositos-y-Enteritos-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pijamas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330029/Pijamas-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Poleras, camisas y camisetas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330018/Poleras-y-Camisas-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Polerones y chalecos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330027/Sweaters-y-Polerones-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Shorts y jardineras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330019/Shorts-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trajes de baño",
								item_url: "https://www.falabella.com/falabella-cl/category/cat15330020/Trajes-de-Bano-Ninos-Bebe",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Coches y sillas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat690191/Coches-y-Sillas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690191/Coches-y-Sillas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10400099/Accesorios-Coches",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Coches",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3064/Coches",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas de auto",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3228/Sillas-de-Auto",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas nido",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3233/Silllas-nido",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Lactancia y alimentación",
						item_url: "https://www.falabella.com/falabella-cl/category/cat4010/Lactancia-y-alimentacion",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4010/Lactancia-y-alimentacion",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9370010/Accesorios-de-Lactancia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Baberos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2450294/Baberos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Chupetes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2810082/Chupetes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Extractores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2670020/Extractores-de-Leche",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Leches y colados",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10010/Alimento-de-Bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mamaderas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2670018/Mamaderas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Platos y contenedores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10729/Menaje-bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas de comer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3230/Sillas-de-Comer",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Higiene y salud",
						item_url: "https://www.falabella.com/falabella-cl/category/cat4089/Higiene-y-salud",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4089/Higiene-y-salud",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Pañales y toallas húmedas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10540003/Panales-y-toallas-humedas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Termómetros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13650010/Termometros",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Seguridad y paseo",
						item_url: "https://www.falabella.com/falabella-cl/category/cat70065/Seguridad-y-paseo",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70065/Seguridad-y-paseo",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2670034/Accesorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Barandas y rejas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2670028/Barandas-y-rejas?page=1",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bolsos maternales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat550035/Bolsos-maternales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Monitores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4070/Monitores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Porta bebé",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4022/Porta-bebe",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Juguetes y entretención",
						item_url: "https://www.falabella.com/falabella-cl/category/cat10190017/Entretencion-bebe",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10190017/Entretencion-bebe",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Andadores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3020/Andadores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Gimnasio y actividad",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4051/Gimnasio-bebe",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juguetes",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4059/Juguetes-bebe",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Dormitorio bebé",
						item_url: "https://www.falabella.com/falabella-cl/category/cat3180019/Dormitorio-Infantil",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3180019/Dormitorio-Infantil",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cómodas y mudadores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4034/Comodas-y-mudadores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cunas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4038/Cunas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa de cuna",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4086/Ropa-de-cuna",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Bebés",
				ver_todo: {
					title: "Ver todo bebé",
					href: "https://www.falabella.com/falabella-cl/category/cat2008/Mundo-Bebe"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "iczapatos3x.png",
					title: "iczapatos3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt945202ec157fec32/61c1d7f8abe5293e65781714/iczapatos3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "iczapatos.svg",
					title: "iczapatos.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt043b23ad48000e7e/61bbaa0f130d606170802d45/iczapatos.svg"
				},
				is_seasonal: false,
				item_name: "Zapatos",
				item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-zapatos",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Tendencias e inspiración",
						item_url: "https://tienda.falabella.com/falabella-cl/page/zapatos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://tienda.falabella.com/falabella-cl/page/zapatos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Sneaker corner",
								item_url: "https://tienda.falabella.com/falabella-cl/page/zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Inspírate con Moda F",
								item_url: "https://tienda.falabella.com/falabella-cl/page/moda-f",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Diseño chileno",
								item_url: "https://www.falabella.com/falabella-cl/collection/zapatos-diseno-chileno",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Todo deporte",
								item_url: "https://tienda.falabella.com/falabella-cl/page/deporte",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos cómodos",
								item_url: "https://www.falabella.com/falabella-cl/collection/zapatos-comodos-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mejores marcas",
								item_url: "https://tienda.falabella.com/falabella-cl/page/zapatos-mejores-marcas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Mujer",
						item_url: "https://www.falabella.com/falabella-cl/category/cat12440001/Zapatos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12440001/Zapatos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/zapatos-mujer-nueva-temporada",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botines mujer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690245/Botines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690241/Botas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantuflas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16630007/Pantuflas-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos casuales",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?mkid=VE_HU_VER_10375&&f.product.attribute.Tipo=Mocasines%3A%3AZapatos+casuales&store=tienda&subdomain=tienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850068/Zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas outdoor",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7500146/Zapatillas-deportivas-mujer?facetSelected=true&f.product.attribute.Disciplina=Outdoor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas running",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7500146/Zapatillas-deportivas-mujer?f.product.attribute.Disciplina=Cross+training%3A%3ARunning&facetSelected=true",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas urbanas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690239/Zapatillas-urbanas-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat660024/Zapatos-mujer?facetSelected=true&f.product.attribute.Tipo=Alpargatas%3A%3ABallerinas%3A%3AMocasines%3A%3AZapatos+casuales%3A%3AZapatos+formales",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Hombre",
						item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/zapatos-hombre-nueva-coleccion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720008/Zapatos-hombre?f.product.attribute.Tipo=Botas%3A%3ABotines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mocasines",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos?facetSelected=true&f.product.attribute.Tipo=Mocasines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pantuflas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos?facetSelected=true&f.product.attribute.Tipo=Pantuflas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat850064/Zapatillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas de fútbol",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930355/Zapatillas-deportivas-hombre?f.product.attribute.Disciplina=Baby+f%C3%BAtbol%3A%3AF%C3%BAtbol&facetSelected=true",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas outdoor",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930355/Zapatillas-deportivas-hombre?facetSelected=true&f.product.attribute.Disciplina=Outdoor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas running",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930355/Zapatillas-deportivas-hombre?f.product.attribute.Disciplina=Cross+training%3A%3ARunning&facetSelected=true",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas urbanas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7500133/Zapatillas-urbanas-hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos casuales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos?f.product.attribute.Tipo=Mocasines%3A%3AZapatos+casuales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos de seguridad",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10787/Zapatos-de-Seguridad",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos formales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos?facetSelected=true&f.product.attribute.Tipo=Zapatos+formales",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Infantil",
						item_url: "https://www.falabella.com/falabella-cl/collection/Ver-Todo-Zapatos-Ninos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/Ver-Todo-Zapatos-Ninos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Nueva temporada",
								item_url: "https://www.falabella.com/falabella-cl/collection/zapatos-ninos-nueva-coleccion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botas y botines niña",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12547507/Zapatos-Nina?facetSelected=true&f.product.attribute.Tipo=Botas%3A%3ABotas+de+lluvia%3A%3ABotinesotines",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Botas y botines niño",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12547736/Zapatos-Nino?f.product.attribute.Tipo=Botas%3A%3ABotas+de+lluvia%3A%3ABotines&facetSelected=true",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas niñas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4740101/Zapatillas-nina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas niños",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4740100/Zapatillas-Ninos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos escolares",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1530008/Zapatos-Escolares",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos niñas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4100009/Zapatos-nina",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos niños",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4100007/Zapatos-nino",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Mejores marcas",
						item_url: "https://tienda.falabella.com/falabella-cl/page/zapatos-mejores-marcas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://tienda.falabella.com/falabella-cl/page/zapatos-mejores-marcas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Aldo",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=aldo&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Alma en Pena",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=alma+en+pena&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camper",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=camper&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Clarks",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=clarks&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cecilia Bolocco",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=cecilia+bolocco&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "DKNY",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=DKNY&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hispanitas",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=hispanitas&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "HOFF",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=hoff&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Michael Kors",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=michael+kors&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pikolinos",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=pikolinos&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sam Edelman",
								item_url: "https://tienda.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?&f.product.brandName=sam+edelman&store=tienda&subdomain=tienda%2Ctienda",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Más marcas",
						item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-zapatos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Adidas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.brandName=adidas%3A%3Aadidas+originals",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Asics",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.brandName=asics",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Americanino",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-zapatos?f.product.brandName=americanino",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Basement",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-zapatos?f.product.brandName=basement",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Call it Spring",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-zapatos?f.product.brandName=call+it+spring",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Champion",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?&facetSelected=true&f.product.brandName=champion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Converse",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.brandName=converse",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Diadora",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?&facetSelected=true&f.product.brandName=diadora",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fila",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.brandName=fila",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Gacel",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12440001/Zapatos-Mujer?facetSelected=true&f.product.brandName=gacel",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Guante",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos?facetSelected=true&f.product.brandName=guante",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lippi",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?f.product.brandName=lippi",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "New Balance",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.brandName=new+balance",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Nike",
								item_url: "https://tienda.falabella.com/falabella-cl/page/Nike",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "ON",
								item_url: "https://tienda.falabella.com/falabella-cl/page/on-running",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Puma",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.brandName=puma",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Skechers",
								item_url: "https://www.falabella.com/falabella-cl/collection/Ver-Todo-Zapatillas?&facetSelected=true&f.product.brandName=skechers",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Starter",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?&facetSelected=true&f.product.brandName=starter",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sybilla",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12440001/Zapatos?facetSelected=true&f.product.brandName=sybilla",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vans",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?facetSelected=true&f.product.brandName=vans",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Veja",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2083/Zapatillas?&facetSelected=true&f.product.brandName=veja",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Zapatos",
				ver_todo: {
					title: "Ver todo Zapatos",
					href: "https://www.falabella.com/falabella-cl/collection/ver-todo-zapatos"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icbelleza3x.png",
					title: "icbelleza3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt0e656c41122541fb/61c1d7e6c52c5b292ce23efc/icbelleza3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icbelleza.svg",
					title: "icbelleza.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt369adbbcad386704/61bba9f78d6b4f214f469eaf/icbelleza.svg"
				},
				is_seasonal: false,
				item_name: "Belleza y salud",
				item_url: "https://www.falabella.com/falabella-cl/category/cat7660002/Belleza--higiene-y-salud",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Perfumes",
						item_url: "https://www.falabella.com/falabella-cl/category/cat2069/Perfumes",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2069/Perfumes",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Hombre",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3112/Perfumes-Hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mujer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3160/Perfumes-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sets",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2069/Perfumes?facetSelected=true&f.product.attribute.Formato=Set",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Maquillaje",
						item_url: "https://www.falabella.com/falabella-cl/category/cat690199/Maquillaje",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690199/Maquillaje",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Brochas y accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690203/Brochas-y-accesorios-de-maquillaje",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Labios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4720024/Maquillaje-de-labios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ojos y cejas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4720025/Maquillaje-de-ojos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Rostro",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4720026/Maquillaje-de-rostro",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sets",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4720028/Sets-de-Maquillaje",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Manos y pies",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7660015/Cuidado-de-manos-y-pies",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7660015/Cuidado-de-manos-y-pies",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cremas y exfoliantes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11729/Cremas-y-exfoliantes-manos-y-pies",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Uñas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4720029/Cuidado-de-unas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Cuidado de la piel",
						item_url: "https://www.falabella.com/falabella-cl/category/cat3214/Cuidado-del-Rostro",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3214/Cuidado-del-Rostro",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Antiedad y serums",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13060003/Antiedad",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cuidado del cuerpo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4960009/Cuidado-del-Cuerpo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hidratantes faciales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90035/Hidratantes-faciales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Limpiadores faciales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90032/Limpiadores-faciales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Protección solar rostro",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13070030/Proteccion-solar-rostro",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sets de rostro",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5870078/Sets-de-Rostro",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tecnología para la belleza",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2025/Tecnologia-para-la-Belleza",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tratamientos hombre",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90036/Tratamientos-faciales?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Dermocosmética",
						item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-dermocosmetica",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-dermocosmetica",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Antiedad",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13060003/Antiedad",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cuerpo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13060006/Cuerpo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hidratación y limpieza",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13060007/Hidratacion-y-Limpieza",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Protección solar",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690213/Bloqueadores-solares",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sets",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-dermocosmetica?f.product.attribute.Formato=Set",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Cuidado capilar y barbería",
						item_url: "https://www.falabella.com/falabella-cl/category/cat9440008/Cuidado-Capilar",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9440008/Cuidado-Capilar",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Afeitadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11731/Afeitadoras-y-Cortapelos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Alisadores de pelo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3018/Alisadores-de-pelo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Barbería",
								item_url: "https://www.falabella.com/falabella-cl/collection/tratamiento-hombre-y-barberia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Onduladores de pelo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3170/Onduladores-de-pelo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Secadores de pelo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3223/Secadores-de-pelo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sets",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9440008/Cuidado-Capilar?facetSelected=true&f.product.attribute.Tipo=Set+de+tratamiento+capilar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Shampoo y acondicionador",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90039/Shampoo-y-acondicionador",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tratamientos y mascarillas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat4960011/Tratamientos-capilares",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Salud",
						item_url: "https://www.falabella.com/falabella-cl/category/cat14090015/Salud",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14090015/Salud",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios de salud",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11199/Accesorios-de-salud",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Equipos de movilidad",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19190043/Equipos-de-movilidad",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lentes ópticos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11739/Articulos-para-el-cuidado-de-los-ojos-y-lentes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mascarillas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12004/Mascarillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Monitores de salud",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11205/Monitores-de-salud",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ortopedia",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11868860/Equipos-ortopedicos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Marcas destacadas",
						item_url: "https://tienda.falabella.com/falabella-cl/page/belleza-f",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Acqua di Parma",
								item_url: "https://tienda.falabella.com/falabella-cl/page/aqcua-di-parma",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bath & Body Works",
								item_url: "https://tienda.falabella.com/falabella-cl/page/bath-body-works",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Benefit",
								item_url: "https://tienda.falabella.com/falabella-cl/page/mundo-benefit",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "CHANEL",
								item_url: "https://tienda.falabella.com/falabella-cl/page/chanel?sred=chanel",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "DIOR",
								item_url: "https://tienda.falabella.com/falabella-cl/page/dior?sred=dior",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dior Backstage",
								item_url: "https://tienda.falabella.com/falabella-cl/page/dior-backstage",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Kerastase",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7660002/Belleza--higiene-y-salud?facetSelected=true&f.product.brandName=kerastase",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Jo Malone London",
								item_url: "https://tienda.falabella.com/falabella-cl/page/jo-malone",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "La Mer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7660002/Belleza--higiene-y-salud?facetSelected=true&f.product.brandName=la+mer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "MAC",
								item_url: "https://www.falabella.com/falabella-cl/collection/mac",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sisley",
								item_url: "https://tienda.falabella.com/falabella-cl/page/sisley",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "The Body Shop",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7660002/Belleza--higiene-y-salud?facetSelected=true&f.product.brandName=the+body+shop",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Bienestar",
						item_url: "https://www.falabella.com/falabella-cl/category/cat14090015/Salud",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14090015/Salud",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Bienestar sexual",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11207/Bienestar-sexual",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Masajeadores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7660016/Masajeadores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pesas y balanzas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11764/Balanzas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tomador de presión",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11765/Tomador-de-presion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Termómetros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11868602/Termometros",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vitaminas y suplementos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11342105/Vitaminas-y-suplementos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Belleza y salud",
				ver_todo: {
					title: "Ver todo Belleza y salud",
					href: "https://www.falabella.com/falabella-cl/category/cat7660002/Belleza--higiene-y-salud"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icpisos3x.png",
					title: "icpisos3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3c54320b41f4dd0d/61c1d7f88d6b4f214f46a843/icpisos3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icpisos.svg",
					title: "icpisos.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltdd398e5883432f22/61bbaa0f191c5560467dc77a/icpisos.svg"
				},
				is_seasonal: false,
				item_name: "Pisos, pinturas y terminaciones",
				item_url: "",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Pisos y revestimientos",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10741/Pisos-y-revestimientos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10741/Pisos-y-revestimientos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cerámicas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10827/Ceramicas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Molduras y guardapolvos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10847/Molduras--Marcos-y-Guardapolvo-",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mosaicos y decorados",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10832/Mosaicos-y-Decorados",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Papel mural y guardas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10833/Papel-Mural-y-guardas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Piedras y enchapes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10831/Piedras-y-Enchapes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pisos de madera y deck",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10829/Pisos-de-Madera-y-Deck",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pisos flotantes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10826/Pisos-Flotantes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pisos vinílicos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10830/Pisos-Vinilicos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Porcelanatos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10828/Porcelanatos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Siding",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10834/Siding",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Adhesivos y fragües",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10742/Frag-es",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10742/Frag-es",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Adhesivos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10813/Adhesivos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fragües",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10742/Frag-es",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Siliconas y selladores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10814/Siliconas-y-Selladores",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Pinturas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat20792242/Pinturas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20792242/Pinturas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Barniz, protector y stains",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10838/Protectores-de-Madera--Barnices-y-Stains",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Diluyente, solvente y más",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10837/Diluyentes--Solventes-y-Limpiadores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Herramientas y complementos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10836/Herramientas-y-Complementos-Pintor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pinturas en spray",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10839/Pintura-en-Spray",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pinturas especiales",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10842/Pinturas-especiales-y-por-material",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pinturas para exterior",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10840/Pinturas-para-exterior",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pinturas para interior",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10841/Pintura-para-interior",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Preparación y reparación",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10843/Preparacion-y-reparacion-superficies",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Cerraduras y quincallería",
						item_url: "https://www.falabella.com/falabella-cl/category/cat20792436/Cerraduras-y-quincalleria",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20792436/Cerraduras-y-quincalleria",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cerraduras y chapas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10861/Cerraduras-y-Chapas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Manillas y perillas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10864/Manillas-y-perillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Para muebles y clóset",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10862/Quincalleria-para-Muebles-y-Closet",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Para puertas y ventanas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10863/Quincalleria-para-Puertas-y-Ventanas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perfiles para terminaciones",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10865/Perfiles-para-terminaciones",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Protecciones",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10745/Protecciones-para-Puertas-y-Ventanas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10745/Protecciones-para-Puertas-y-Ventanas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Persianas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10859/Persianas-de-Exterior-y-de-Seguridad",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Protecciones",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10860/Protecciones-para-Puertas-y-Ventanas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Puertas",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10743/Puertas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10743/Puertas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Control de acceso",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10850/Control-de-acceso",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mamparas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10848/Mamparas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Molduras y guardapolvos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10847/Molduras--Marcos-y-Guardapolvo-",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Portón de entrada",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10849/Porton-Entrada",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Puertas de clóset y otras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10846/Puertas-Closet-y-Otras-Puertas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Puertas de exterior",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10845/Puertas-de-Entrada-y-Exterior",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Puertas de interior",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10844/Puertas-de-Interior",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ventanas",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10744/Ventanas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10744/Ventanas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Aleros y toldos retráctiles",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10857/Aleros-y-Toldos-Retractiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ventanas de aluminio",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10853/Ventanas-de-aluminio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ventanas de techo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10856/Ventanas-y-Soluciones-de-techo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ventanas termopanel",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10852/Ventanas-Termopanel",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Pisos, pinturas y terminaciones",
				ver_todo: {
					title: "",
					href: ""
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "iconstruccion3x.png",
					title: "iconstruccion3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt18643e6dd0633ada/61c1d7f88c8e757c1a01306b/iconstruccion3x.png"
				},
				image_ios_app: {
					filename: "iconstruccion3x.png",
					title: "iconstruccion3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt18643e6dd0633ada/61c1d7f88c8e757c1a01306b/iconstruccion3x.png"
				},
				image_web: {
					filename: "iconstruccion.svg",
					title: "iconstruccion.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt00e3e410d91757b6/61c0fddbc9ed2d27fb59f144/iconstruccion.svg"
				},
				is_seasonal: false,
				item_name: "Construcción",
				item_url: "https://www.falabella.com/falabella-cl/category/CATG10005/Construccion-y-ferreteria",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Materiales de construcción",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10731/Materiales-de-Construccion",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10731/Materiales-de-Construccion",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Alambres, mallas y cercos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10757/Alambres--Mallas-y-Cercos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cemento y complementos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10753/Cemento-y-complementos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Escaleras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10751/Escaleras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ladrillos, bloques y pastelones",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10756/Ladrillos--bloques-y-pastelones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perfiles, acero y metalcón",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10755/Perfiles-acero-y-metalcon",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tabiquería",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10752/Tabiqueria",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Herramientas y máquinas",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10734/Maquinarias-y-Herramientas-Constructor",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10734/Maquinarias-y-Herramientas-Constructor",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Betoneras y trompos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10775/Betoneras-y-Trompos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Carretillas y ruedas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10778/Carretillas-y-Ruedas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tecles y huinches",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10779/Tecles-y-Huinches",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Platachos, llanas y planas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10781/Platachos--Llanas-y-Planas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Palas, picotas y rastrillos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10782/Palas--Picotas-y-Rastrillos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Puntos, cinceles y combos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10784/Puntos--Cinceles-y-Combos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Techos y aislantes",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10733/Techos-y-Aislantes",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10733/Techos-y-Aislantes",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Techumbre",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10772/Techumbre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aislantes térmicos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10773/Aislantes-Termicos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Barreras humedad y geotextiles",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10774/Barreras-Humedad-y-Geotextiles",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Maderas y tableros",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10732/Maderas-y-tableros",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10732/Maderas-y-tableros",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Escaleras y pasamanos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10767/Escaleras-y-Pasamanos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Madera impregnada",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10765/Madera-Impregnada",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Madera seca",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10763/Madera-Seca",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Madera verde",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10764/Madera-Verde",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "MDF y hardboard",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10762",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Melaminas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10761/Melaminas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Oregón y nativas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10766/Oregon-y-Nativas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "OSB",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10760",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tableros revestimiento",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10768/Tableros-Revestimiento",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tapacantos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10769/Tapacantos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Terciado",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10759/Terciado",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vigas y pilares laminados",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10770/Vigas-y-Pilares-Laminados",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Puertas",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10743/Puertas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10743/Puertas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Mamparas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10848/Mamparas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Control de acceso",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10850/Control-de-acceso",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Molduras y guardapolvos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10847/Molduras--Marcos-y-Guardapolvo-",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Portón de entrada",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10849/Porton-Entrada",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Puertas de clóset y otras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10846/Puertas-Closet-y-Otras-Puertas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Puertas de exterior",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10845/Puertas-de-Entrada-y-Exterior",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Puertas de interior",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10844/Puertas-de-Interior",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cerraduras y chapas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10861/Cerraduras-y-Chapas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ventanas",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10744/Ventanas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10744/Ventanas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Aleros y toldos retráctiles",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10857/Aleros-y-Toldos-Retractiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ventanas de aluminio",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10853/Ventanas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ventanas termopanel",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10852/Ventanas-Termopanel",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ventanas de techo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10856/Ventanas-y-Soluciones-de-techo",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Electricidad",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10737/Electricidad",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10737/Electricidad",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Alargadores y extensiones",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10801/Alargadores-y-Extensiones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Automáticos, tableros y medidores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10800/Automaticos--Tableros-y-Medidores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cableado y conexiones",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10797/Cables-y-alambres-Electricos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Canalización",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10798/Canalizacion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Enchufes, placas y volantes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10796/Enchufes--placas-y-volantes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Energía solar",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10803/Energia-Solar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Herramientas y complementos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10799/Herramientas-y-Complementos-Electricos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pilas y baterías",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10795/Pilas-y-Baterias",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Portalámparas y soquetes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10805/Portalamparas-y-Soquetes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Temporizadores y sensores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10802/Temporizadores--Timers-y-Sensores",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: "NUEVO",
				tags: [
				],
				title: "Construcción",
				ver_todo: {
					title: "Ver todo Construcción",
					href: "https://www.falabella.com/falabella-cl/category/CATG10005/Construccion-y-ferreteria"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icferreteria.png",
					title: "icferreteria.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blte61730bb0dc6a6f4/61e867a3581db15a1fe98647/icferreteria.png"
				},
				image_ios_app: {
					filename: "icferreteria.png",
					title: "icferreteria.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blte61730bb0dc6a6f4/61e867a3581db15a1fe98647/icferreteria.png"
				},
				image_web: {
					filename: "icferreteria.svg",
					tags: [
					],
					title: "icferreteria.svg",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt0ebed6c2caf586d5/61e867b178c11410d82de2d2/icferreteria.svg"
				},
				is_seasonal: false,
				item_name: "Ferretería",
				item_url: "https://www.falabella.com/falabella-cl/category/CATG10005/Construccion-y-ferreteria",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Cerraduras y quincallería",
						item_url: "https://www.falabella.com/falabella-cl/category/cat20792436/Cerraduras-y-quincalleria",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20792436/Cerraduras-y-quincalleria",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Automatización de portones",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10849/Porton-Entrada",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cerraduras y chapas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10861/Cerraduras-y-Chapas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Manillas y perillas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10864/Manillas-y-perillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Perfiles para terminaciones",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10865/Perfiles-para-terminaciones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Quincallería para muebles y clóset",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10862/Quincalleria-para-Muebles-y-Closet",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Quincallería para muebles y ventanas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10863/Quincalleria-para-Puertas-y-Ventanas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Seguridad",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10736/Seguridad",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10736/Seguridad",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cadenas, cuerdas y accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10791/Cadenas--Cuerdas-y-Accesorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cajas fuertes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10789/Cajas-Fuertes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Candados",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10790/Candados",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Extintores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10793/Extintores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Seguridad vial",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10792/Seguridad-Vial",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Tornillos, clavos y fijaciones",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10738/Tornillos--clavos-y-fijaciones",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10738/Tornillos--clavos-y-fijaciones",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Fijaciones adhesivas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10811/Fijaciones-Adhesivas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fijaciones para concreto",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10810/Fijaciones-para-Concreto",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fijaciones para madera",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10807/Fijaciones-para-Madera",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fijaciones para metal",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10806/Fijaciones-para-Metal",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fijaciones para tabique y yeso",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10808/Fijaciones-para-tabiqueria-y-yeso-carton",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fijaciones para techos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10809/Fijaciones-para-Techos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Otras fijaciones",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10812/Otras-Fijaciones",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Ropa y protección",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10735/Ropa-y-Proteccion",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10735/Ropa-y-Proteccion",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Protección personal",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10788/Elementos-de-Proteccion-Personal",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa de trabajo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10785/Ropa-de-Trabajo",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos de seguridad",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10787/Zapatos-de-Seguridad",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Gasfitería",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10740/Gasfiteria",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10740/Gasfiteria",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Alcantarillado",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10824/Articulos-de-Alcantarillado",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bombas y motobombas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10817/Bombas-y-motobombas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cañerías, tubos y fitting",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10821/Canerias--Tubos-y-Fitting",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Destapes y drenajes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10823/Destapes-y-Drenajes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Filtros y purificadores de agua",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10819/Filtros-y-Purificadores-de-agua",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fosas y estanques",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10818/Fosas-y-estanques",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Herramientas y complementos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10816/Herramientas-y-complementos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Llaves y válvulas",
								item_url: "",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Electricidad",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10737/Electricidad",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10737/Electricidad",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Alargadores y extensiones",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10801/Alargadores-y-Extensiones",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Automáticos, tableros y medidores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10800/Automaticos--Tableros-y-Medidores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cableado y conexiones",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10797/Cables-y-alambres-Electricos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Canalización",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10798/Canalizacion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Enchufes, placas y volantes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10796/Enchufes--placas-y-volantes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Energía solar",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10803/Energia-Solar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Herramientas y complementos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10799/Herramientas-y-Complementos-Electricos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Portalámparas y soquetes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10805/Portalamparas-y-Soquetes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Temporizadores y sensores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10802/Temporizadores--Timers-y-Sensores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pilas y baterías",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10795/Pilas-y-Baterias",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: "NUEVO",
				tags: [
				],
				title: "Ferretería",
				ver_todo: {
					title: "Ver todo Ferretería",
					href: "https://www.falabella.com/falabella-cl/category/CATG10005/Construccion-y-ferreteria"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icherramientas3x.png",
					tags: [
					],
					title: "icherramientas3x.png",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltd145b17da9776ff0/61c1dc158d6b4f214f46a863/icherramientas3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icherramientas.svg",
					tags: [
					],
					title: "icherramientas.svg",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt52d5c08b54d66c87/61c1dba1191c5560467dd0cb/icherramientas.svg"
				},
				is_seasonal: false,
				item_name: "Herramientas y maquinarias",
				item_url: "https://www.falabella.com/falabella-cl/category/cat8620074/Herramientas-y-maquinas",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Herramientas eléctricas",
						item_url: "https://www.falabella.com/falabella-cl/category/cat18320014/Herramientas-electricas-e-inalambricas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18320014/Herramientas-electricas-e-inalambricas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10875/Accesorios-de-Herramientas-electricas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Atornilladores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10876/Atornilladores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dremel y multipropósito",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14090002/Dremel-y-herramientas-multiproposito",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Esmeriles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18380029/Esmeriles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lijadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14080026/Lijadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Rotomartillos y demoledores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10880/Rotomartillos-y-demoledores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sierras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14090005/Sierras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Taladros",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14080023/Taladros",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Taladros inalámbricos",
								item_url: "https://www.falabella.com/falabella-cl/collection/taladro-inalambrico",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Máquinas y complementos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat18320016/Maquinarias-y-complementos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18320016/Maquinarias-y-complementos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Compresores y complementos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10748/Compresores-y-complementos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Generadores y accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat17370002/Generadores-y-complementos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hidrolavadoras y accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9560006/Hidrolavadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Soldadoras y complementos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10747/Soldadoras-y-complementos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Herramientas manuales",
						item_url: "https://www.falabella.com/falabella-cl/category/cat20791939/Herramientas-manuales",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20791939/Herramientas-manuales",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Alicates y llaves",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10882/Alicates--Caimanes-y-llaves",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cuchillos y repuestos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10883/Cuchillos-y-repuestos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dados y llaves",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10885/Dados-y-Llaves",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Destornilladores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10886/Destornilladores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Engrapadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10887/Engrapadoras-y-grapas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Limas, formones y escofinas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10891/Limas--formones-y-escofinas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Martillos y mazos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10888/Martillos-y-mazos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Serruchos y sierras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10893/Serruchos-y-sierras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Set de herramientas manuales",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10892/Set-de-herramientas-manuales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tornillos y prensas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10894/Tornillos--prensas-y-sargentos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Jardín",
						item_url: "https://www.falabella.com/falabella-cl/category/cat18320015/Herramientas-y-maquinaria-de-jardin",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18320015/Herramientas-y-maquinaria-de-jardin",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios máquinas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10902/Accesorios-para-maquinaria-de-jardin",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cortadoras de pasto",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14080024/Cortadoras-de-pasto",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cortasetos y podadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10897/Cortasetos-y-podadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Herramientas de jardín",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10903/Herramientas-de-jardin",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Orilladoras y desbrozadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18380043/Orilladoras-y-desbrozadoras",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Medición y trazado",
						item_url: "https://www.falabella.com/falabella-cl/category/cat18320017/Herramientas-de-medicion-y-trazado",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18320017/Herramientas-de-medicion-y-trazado",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Huinchas, reglas y escuadras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10870/Huinchas--reglas-y-escuadras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Medición y nivelación láser",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10871/Medicion-y-nivelacion-laser",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Plomadas, niveles y trazadores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10872/Plomadas--niveles-y-trazadores",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Organización",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10746/Cajas-de-herramientas-y-organizadores",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10746/Cajas-de-herramientas-y-organizadores",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cajas de herramientas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18040009/Cajas-y-maletas-de-herramientas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Carros y transporte",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10868/Carros-y-Transporte",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Equipamiento de taller",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10866/Equipamiento-de-taller",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Herramientas por especialidad",
						item_url: "",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Herramientas constructor",
								item_url: "https://sodimac.falabella.com/sodimac-cl/category/CATG10734/Maquinarias-y-Herramientas-Constructor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Herramientas electricistas",
								item_url: "https://sodimac.falabella.com/sodimac-cl/category/CATG10799/Herramientas-y-Complementos-Electricos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Herramientas pintor",
								item_url: "https://sodimac.falabella.com/sodimac-cl/category/CATG10836/Herramientas-y-Complementos-Pintor",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Herramientas y maquinarias",
				ver_todo: {
					title: "Ver todo Herramientas y maquinarias",
					href: "https://www.falabella.com/falabella-cl/category/cat8620074/Herramientas-y-maquinas"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icautomotriz3x.png",
					tags: [
					],
					title: "icautomotriz3x.png",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltd83b90563a7cae73/61c1e265c52c5b292ce23f20/icautomotriz3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icautomotriz.svg",
					tags: [
					],
					title: "icautomotriz.svg",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3e140d0929c723d2/61c1e288c455652925b798b0/icautomotriz.svg"
				},
				is_seasonal: false,
				item_name: "Automotriz",
				item_url: "https://www.falabella.com/falabella-cl/category/CATG10006/Automotriz",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Neumáticos y llantas",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10651/Neumaticos-y-Llantas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10651/Neumaticos-y-Llantas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Llantas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10657/Llantas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Neumáticos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10658/Neumaticos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pulidoras",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10683/Pulidoras",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Audio y video",
						item_url: "https://www.falabella.com/falabella-cl/category/cat670008/Audio-y-video-para-autos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat670008/Audio-y-video-para-autos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cables y accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10659/Cables-y-accesorios-para-autos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cámaras de retroceso y DVR",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10660/Camaras-de-retroceso-y-DVR",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Manos libres",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10661/Manos-libre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Parlantes y amplificación",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1870079/Parlantes-y-amplificadores-para-Autos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Radios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3202/Radios-para-Autos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Limpieza",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10655/Limpieza-para-Autos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10655/Limpieza-para-Autos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Aromatizantes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10687/Aromatizantes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Brillo y pulido",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10688",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hidrolavado y accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10689/Hidrolavado-y-accesorios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lavado de carrocería",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10690/Lavado-de-carroceria",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lavado de neumáticos y llantas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10691/Lavado-de-neumaticos-y-llantas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lavado de vidrios y espejos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10692/Lavado-de-vidrios-y-espejos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Limpieza y aspirado interior",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10693/Limpieza-y-aspirado-de-interior",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Paños y utensilios",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10694/Panos-y-utensilios",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Accesorios de interior",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10663/Accesorios-de-interior-para-autos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10663/Accesorios-de-interior-para-autos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cortinas y tapasoles",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10705/Cortinas-y-tapasoles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cubreasientos, pisos y más",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10706/Cubreasientos--cubrevolantes-y-pisos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Organizadores para autos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10707/Organizadores-para-autos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Otros accesorios de interior",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10708/Otros-accesorios-de-interior",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Accesorios de exterior",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10664/Accesorios-de-exterior-para-autos",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10664/Accesorios-de-exterior-para-autos",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Amarres y pulpos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10715/Amarres--Eslingas-y-Pulpos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Antirrobos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10695/Traba-Volantes-y-Traba-Ruedas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cadenas de nieve",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10714/Cadenas-de-nieve",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cubreautos y fundas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10709/Cubreautos-y-fundas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Neblineros y barras led",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10711/Neblineros-y-barras-led",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Otros accesorios de exterior",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10712/Otros-accesorios-exterior",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Portabicicleta, esquí y más",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10717/Portabicicletas--Portaesquies-y-Otros",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Portaequipajes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10716/Portaequipajes-y-Equipamiento-de-viaje",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Líquidos y lubricantes",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10653/Liquidos-y-lubricantes",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10653/Liquidos-y-lubricantes",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Aceites y lubricantes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10678/Aceites-y-lubricantes-para-autos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Aditivos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10676/Aditivos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Anticongelantes y aguas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10675",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Repuestos y autopartes",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10652/Repuestos-y-autopartes",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10652/Repuestos-y-autopartes",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Baterías",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10666/Baterias",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cargadores y partidores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18380030/Cargadores-y-partidores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Focos y ampolletas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10668/Focos-y-ampolletas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Plumillas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10672/Plumillas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Motos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat7190291/Motos-y-accesorios",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7190291/Motos-y-accesorios",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5810113/Accesorios-Motos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cascos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7500015/Cascos-Motos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Equipamiento",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10701",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Guantes",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10698",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: "NUEVO",
				tags: [
				],
				title: "Automotriz",
				ver_todo: {
					title: "Ver todo Automotriz",
					href: "https://www.falabella.com/falabella-cl/page/accesorios-para-autos"
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icmusicalibrospapeleria.png",
					tags: [
					],
					title: "icmusicalibrospapeleria.png",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4764beff5576cdcd/61f94abe847be764b351ba46/icmusicalibrospapeleria.png"
				},
				image_ios_app: {
					filename: "icmusicalibrospapeleria.png",
					tags: [
					],
					title: "icmusicalibrospapeleria.png",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4764beff5576cdcd/61f94abe847be764b351ba46/icmusicalibrospapeleria.png"
				},
				image_web: {
					filename: "icmusicalibrospapeleria.svg",
					tags: [
					],
					title: "icmusicalibrospapeleria.svg",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt23b8a5339be2bfcb/61f9493cc1f2271a3225dd90/icmusicalibrospapeleria.svg"
				},
				is_seasonal: false,
				item_name: "Música, libros y papelería",
				item_url: "",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Instrumentos musicales",
						item_url: "https://www.falabella.com/falabella-cl/category/cat3117/Instrumentos-Musicales?isPLP=1",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3117/Instrumentos-Musicales?isPLP=1",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios musicales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70025/Accesorios-Musicales",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Amplificación",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2860024/Amplificacion-y-HI-FI",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bajos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13900004/Bajos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Baterías y percusión",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70023/Baterias-y-Percusion",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "DJ",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18020005/DJ",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Guitarras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70021/Guitarras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Instrumentos de viento",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70022/Instrumentos-de-Viento",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Teclados y pianos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat70024/Teclados-y-Pianos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ukeleles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat18210004/Ukeleles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tornamesas y vinilos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10917725/Vinilos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Arte y manualidades",
						item_url: "https://www.falabella.com/falabella-cl/category/cat90073/Arte-y-manualidades",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat90073/Arte-y-manualidades",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Dibujos y colores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12450040/Dibujo-y-Colores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Manualidades y actividades",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12450042/Manualidades-y-actividades",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pinceles y rotuladores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11465/Pinceles-y-rotuladores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pinturas y acuarelas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11466/Pinturas-y-Acuarelas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Pizarras y atriles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12460023/Pizarras-y-atriles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Plasticinas y masas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12450041/Plasticinas--Masas-y-Arenas",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Libros",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG11448/Libros?isPLP=1",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11448/Libros?isPLP=1",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Ciencias naturales e ingeniería",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11453/Ciencias-Naturales--Tecnicas-e-Ingenieria",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ciencias sociales y humanidades",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11454/Ciencias-Sociales--Humanidades-y-Arte",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Economía y finanzas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11455/Economia-Finanzas-y-Negocios",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "eReaders",
								item_url: "https://www.falabella.com/falabella-cl/category/cat7230007/Tablets?facetSelected=true&f.product.attribute.Tipo=Ebooks",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Escolares y PSU",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11458/Escolares-y-PSU",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Libros infantiles",
								item_url: "https://www.falabella.com/falabella-cl/category/cat910002/Libros-Infantiles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Literatura y novelas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11452/Literatura-y-Novelas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Manga y comic",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10587490/Historietas-y-comics",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Novedades",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10967213/Novedades",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Recreación y estilo de vida",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11457/Actividades-Recreacion-y-Estilo-de-Vida",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Tejido, bordado y costura",
						item_url: "https://www.falabella.com/falabella-cl/category/cat19280006/Tejido--bordado-y-costura",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19280006/Tejido--bordado-y-costura",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Bordado",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11169968/Bordado",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Costura",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11170066/Costura",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Máquinas de coser",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2024/Maquinas-de-Coser",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Tejido",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11170275/Tejido",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Artículos de librería",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG11449/Articulos-de-escritorio-y-papeleria?isPLP=1",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11449/Articulos-de-escritorio-y-papeleria?isPLP=1",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Adhesivos y pegamento",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11459/Adhesivos-y-pegamento",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Calculadoras",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2012/Calculadoras",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Carpetas y organizadores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11462/Carpetas-y-organizadores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cuadernos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11740009/Cuadernos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Destacadores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11460/Destacadores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Estuches escolares",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12060005/Estuches-escolares",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lápices y útiles escolares",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11740010/Lapices-y-utiles-escolares",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Papeles",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11461/Papeles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Planner y agendas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat10981330/Planners-y-agendas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Suministros de oficina",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11463/Suministros-de-escritorio",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Fiestas y celebraciones",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG11451/Fiestas-y-celebraciones",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11451/Fiestas-y-celebraciones",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Cotillón adulto",
								item_url: "https://www.falabella.com/falabella-cl/category/cat16940049/Fiesta-y-cotillon-adulto",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cotillón infantil",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11467/Fiesta-y-cotillon-infantil",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: "NUEVO",
				tags: [
				],
				title: "Música, libros y papelería",
				ver_todo: {
					title: "",
					href: ""
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icotrascategorias3x.png",
					title: "icotrascategorias3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt5c7ece23044de394/61c1d7f895cb603e6b5ccd5a/icotrascategorias3x.png"
				},
				image_ios_app: {
				},
				image_web: {
					filename: "icotrascategorias.svg",
					tags: [
					],
					title: "icotrascategorias.svg",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltcd1d0f17ca6d5b50/61c1d2b3c52c5b292ce23eea/icotrascategorias.svg"
				},
				is_seasonal: false,
				item_name: "Otras categorías",
				item_url: "",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Alimentos y bebidas",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10012/Alimentos-y-bebidas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10012/Alimentos-y-bebidas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Aceites y condimentos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14090030/Aceites-y-aderezos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bebidas, aguas y jugos",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10206/Bebidas--aguas-y-jugos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Café y té",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10199/Desayunos-y-panaderia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Cervezas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10205/Cervezas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Despensa",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10194/Despensa",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Dulces y snacks",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10200/Dulces-y-snacks",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juan Valdez",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10012/Alimentos-y-bebidas?facetSelected=true&f.product.brandName=juan+valdez",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Leches",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10196/Lacteos-y-frescos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vinos, espumantes y licores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14090025/Vinos-y-licores",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Aseo y limpieza",
						item_url: "https://www.falabella.com/falabella-cl/category/CATG10598/Aseo-y-limpieza",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10598/Aseo-y-limpieza",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Basureros y contenedores",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11390001/Basureros-y-Papeleros",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lavado y planchado",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10275/Lavado-y-planchado",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Lavalozas y limpiadores",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10277/Lavalozas-y-Limpiadores",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Limpieza de pisos y superficies",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10278/Limpieza-de-pisos-y-superficies",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Utensilios de aseo",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10273/Utensilios-de-aseo",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Productos + sustentables",
						item_url: "https://www.falabella.com/falabella-cl/collection/productos-sustentables",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/productos-sustentables",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Belleza",
								item_url: "https://www.falabella.com/falabella-cl/collection/productos-sustentables?&f.product.L0_category_paths=cat7660002%7C%7CBelleza%2C+higiene+y+salud",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Decoración",
								item_url: "https://www.falabella.com/falabella-cl/collection/productos-sustentables?&f.product.L1_category_paths=cat8950017%7C%7CDecohogar%2Fcat2026%7C%7CDecoraci%C3%B3n+e+iluminaci%C3%B3n",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Emporio y hogar",
								item_url: "https://www.falabella.com/falabella-cl/collection/productos-sustentables?&f.product.L0_category_paths=CATG10012%7C%7CAlimentos+y+bebidas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Hombre",
								item_url: "https://www.falabella.com/falabella-cl/collection/-2bverde-hombre",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Menaje",
								item_url: "https://www.falabella.com/falabella-cl/collection/productos-sustentables?&f.product.L1_category_paths=cat8950017%7C%7CDecohogar%2Fcat2061%7C%7CMenaje+Comedor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Muebles",
								item_url: "https://www.falabella.com/falabella-cl/collection/productos-sustentables?&f.product.L0_category_paths=cat1005%7C%7CDormitorio",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mujer",
								item_url: "https://www.falabella.com/falabella-cl/collection/mas-verde-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Niños",
								item_url: "https://www.falabella.com/falabella-cl/collection/productos-sustentables?&f.product.L1_category_paths=cat13550007%7C%7CNi%C3%B1os+y+Jugueter%C3%ADa%2Fcat5620004%7C%7CModa+Infantil",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Salud e insumos médicos",
						item_url: "https://www.falabella.com/falabella-cl/category/cat14090015/Salud",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14090015/Salud",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios médicos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14090017/Accesorios-Medicos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Balanzas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11764/Balanzas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Bienestar sexual",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG11207/Bienestar-sexual",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Masajeadores/almohadas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat14090018/Masajeadores-y-almohadas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mascarillas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG12004/Mascarillas",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mobiliario médico",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19190046/Camillas-y-Catres",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Movilidad",
								item_url: "https://www.falabella.com/falabella-cl/category/cat19190043/Movilidad",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ortopedia/protecciones",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11868860/Ortopedia",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Vitaminas y suplementos",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11342105/Vitaminas-y-suplementos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Otras categorías",
				ver_todo: {
					title: "",
					href: ""
				}
			},
			{
				canal: {
					adddesktop: true,
					addmobile: true,
					addapp: true
				},
				gu_as_de_compra: [
				],
				image_android_app: {
					filename: "icliquidacion3x.png",
					title: "icliquidacion3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltcdb17ff7783c7eb5/61c1d7e6130d606170803655/icliquidacion3x.png"
				},
				image_ios_app: {
					filename: "icliquidacion3x.png",
					title: "icliquidacion3x.png",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltcdb17ff7783c7eb5/61c1d7e6130d606170803655/icliquidacion3x.png"
				},
				image_web: {
					filename: "icliquidacion.svg",
					title: "icliquidacion.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt520c77645b55f1b7/61c0fb668ae3ee7d4c155b14/icliquidacion.svg"
				},
				is_seasonal: true,
				item_name: "Liquidación",
				item_url: "",
				monetization_banner: [
				],
				position_bottom: false,
				second_level_categories: [
					{
						item_name: "Liquidación mujer",
						item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s&facetSelected=true",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat20002/Moda-Mujer?f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s&facetSelected=true",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios de moda",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?facetSelected=true&f.product.attribute.G%C3%A9nero=Mujer%3A%3AUnisex?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ofertas carteras y mochilas",
								item_url: "https://www.falabella.com/falabella-cl/collection/carteras-en-oferta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ofertas ropa mujer",
								item_url: "https://www.falabella.com/falabella-cl/collection/ropa-mujer",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Relojes en oferta",
								item_url: "https://www.falabella.com/falabella-cl/collection/ofertas-accesorios-relojes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa interior y pijamas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13140017/Ropa-Interior-y-Pijamas?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trajes de baño",
								item_url: "https://www.falabella.com/falabella-cl/category/cat11610008/Trajes-de-bano-y-bikinis?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas en oferta",
								item_url: "https://www.falabella.com/falabella-cl/collection/zapatillas-en-oferta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos y sandalias",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690247/Sandalias?&f.range.derived.variant.discount=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Liquidación hombre",
						item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre?f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s&facetSelected=true",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre?f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s&facetSelected=true",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-accesorios?facetSelected=true&f.product.attribute.G%C3%A9nero=Hombre%3A%3AUnisex?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ofertas ropa hombre",
								item_url: "https://www.falabella.com/falabella-cl/collection/ofertas-hombre-ropa",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa interior y pijamas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat5260002/Ropa-interior-y-pijamas?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Trajes de baño",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1320008/Moda-Hombre?facetSelected=true&f.product.attribute.Tipo=Trajes+de+ba%C3%B1o&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatillas en oferta",
								item_url: "https://www.falabella.com/falabella-cl/collection/zapatillas-en-oferta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos y sandalias",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1720006/Zapatos?facetSelected=true&f.range.derived.variant.discount=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Liquidación niños y bebés",
						item_url: "https://www.falabella.com/falabella-cl/collection/ofertas-juguetes",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/ofertas-juguetes",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Juegos de exterior",
								item_url: "https://www.falabella.com/falabella-cl/category/cat690277/Juegos-de-exterior?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mundo bebé",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-mundo-bebe?sid=HO_M4_MUN_41?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Oferta juguetes",
								item_url: "https://www.falabella.com/falabella-cl/collection/ofertas-juguetes",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa bebé",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-ropa-bebe?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa niñas oferta",
								item_url: "https://www.falabella.com/falabella-cl/category/cat12850003/Ropa-de-ninas?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa niños oferta",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquidacion-ropa-de-ninos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Zapatos niños en oferta",
								item_url: "https://www.falabella.com/falabella-cl/collection/Ver-Todo-Zapatos-Ninos?facetSelected=true&f.product.attribute.Tipo=Sandalias%3A%3AZapato+casual&f.range.derived.variant.discount=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Liquidación hogar y jardín",
						item_url: "https://www.falabella.com/falabella-cl/collection/ofertas-hogar",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/ofertas-hogar",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Alfombras en oferta",
								item_url: "https://www.falabella.com/falabella-cl/collection/alfombras-en-oferta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Camas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat13720010/Camas?f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s&facetSelected=true&page=3",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Iluminación",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10081/Iluminacion-Interior?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Menaje",
								item_url: "https://www.falabella.com/falabella-cl/collection/ver-todo-cocina-y-comedor",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ofertas hogar y decoración",
								item_url: "https://www.falabella.com/falabella-cl/collection/ofertas-hogar",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Piscinas en oferta",
								item_url: "https://www.falabella.com/falabella-cl/collection/piscinas-en-oferta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Terrazas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat1180024/Muebles-de-terraza?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Liquidación tecnología",
						item_url: "https://www.falabella.com/falabella-cl/collection/liquitecno?page=1",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquitecno?page=1",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Accesorios",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquitecno?facetSelected=true&f.product.attribute.Tipo=Adaptadores%3A%3AApple+Watch%3A%3ACargadores+inal%C3%A1mbricos%3A%3ACartuchos%3A%3ADiscos+duros+externos%3A%3AMemorias+Micro+SD%3A%3AMouses%3A%3ASeguridad%2F+Alarmas%3A%3ATeclados%3A%3ATouchpads%3A%3AVideojuegos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Audio e instrumentos",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquitecno?facetSelected=true&f.product.attribute.Tipo=Aud%C3%ADfonos+Hi-Fi%3A%3AAud%C3%ADfonos+headset%3A%3AAud%C3%ADfonos+vincha%3A%3AParlantes+port%C3%A1tiles%3A%3AUkeleles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Computación",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquitecno?facetSelected=true&f.product.attribute.Tipo=2+en+1%3A%3ACartuchos%3A%3AMonitores+LED%3A%3ANotebooks",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Electrodomésticos",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquitecno?facetSelected=true&f.product.attribute.Tipo=Air+Fryer%3A%3AAspiradoras+robots%3A%3ABatidoras+de+mano%3A%3ABatidoras+de+pie%3A%3ACafeteras+expresso%3A%3AEsmeriles%3A%3AHervidores%3A%3ALicuadoras%3A%3ASandwicheras%3A%3ATrapeadores+robots",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Línea blanca",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquitecno?&f.product.L1_category_paths=cat16510006%7C%7CElectrohogar%2Fcat7090035%7C%7CL%C3%ADnea+blanca",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Oferta refrigeradores",
								item_url: "https://www.falabella.com/falabella-cl/collection/refrigeradores-oferta",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Liquidación muebles",
						item_url: "https://www.falabella.com/falabella-cl/collection/liquidacion-muebles",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquidacion-muebles",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Closet baratos",
								item_url: "https://www.falabella.com/falabella-cl/collection/closets-baratos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Futones baratos",
								item_url: "https://www.falabella.com/falabella-cl/collection/futones-baratos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Juegos de living en oferta",
								item_url: "https://www.falabella.com/falabella-cl/collection/juegos-de-living-en-oferta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Liquidación de muebles",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquidacion-muebles",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Sillas y escritorios baratos",
								item_url: "https://www.falabella.com/falabella-cl/collection/escritorios-baratos",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Liquidación deporte",
						item_url: "https://www.falabella.com/falabella-cl/collection/liquidacion-deportes",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquidacion-deportes",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Bicicletas en oferta",
								item_url: "https://www.falabella.com/falabella-cl/collection/bicicletas-en-oferta",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Fitness",
								item_url: "https://www.falabella.com/falabella-cl/category/cat2036/Fitness?f.range.derived.variant.discount_from=30%25+dcto+y+m%C3%A1s&facetSelected=true",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa deportiva hombre",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930003/Ropa-deportiva-hombre?facetSelected=true&f.range.derived.variant.discount_from=30%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ropa deportiva mujer",
								item_url: "https://www.falabella.com/falabella-cl/category/cat6930168/Ropa-deportiva-mujer?facetSelected=true&f.range.derived.variant.discount_from=30%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Liquidación mejoramiento del hogar",
						item_url: "https://www.falabella.com/falabella-cl/collection/liquidacion-mejoramiento-hogar-y-auto",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquidacion-mejoramiento-hogar-y-auto",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Baños y cocina",
								item_url: "https://www.falabella.com/falabella-cl/category/cat01/Cocina-y-Bano?facetSelected=true&f.range.derived.variant.discount=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Construcción y ferretería",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10005/Construccion-y-ferreteria?facetSelected=true&f.range.derived.variant.discount=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Herramientas y maquinarias",
								item_url: "https://www.falabella.com/falabella-cl/category/cat8620074/Herramientas-y-maquinas?facetSelected=true&f.range.derived.variant.discount=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							}
						]
					},
					{
						item_name: "Liquidación otras categorías",
						item_url: "https://www.falabella.com/falabella-cl/collection/ofertas",
						gu_as_de_compra: [
						],
						third_level_categories: [
							{
								item_name: "Ver todo",
								item_url: "https://www.falabella.com/falabella-cl/collection/ofertas",
								tag: {
								},
								is_ver_todo: true
							},
							{
								item_name: "Alimentos y bebidas",
								item_url: "https://www.falabella.com/falabella-cl/category/CATG10012/Alimentos-y-bebidas?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Instrumentos musicales",
								item_url: "https://www.falabella.com/falabella-cl/category/cat3117/Instrumentos-Musicales?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Libros",
								item_url: "https://www.falabella.com/falabella-cl/collection/liquidacion-libros",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Mascotas",
								item_url: "https://www.falabella.com/falabella-cl/category/cat9360001/Mascotas?facetSelected=true&f.range.derived.variant.discount_from=20%25+dcto+y+m%C3%A1s",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ofertas maquillaje",
								item_url: "https://www.falabella.com/falabella-cl/collection/ofertas-belleza-maquillaje",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ofertas neumáticos",
								item_url: "https://www.falabella.com/falabella-cl/collection/oferta-neumaticos",
								tag: {
								},
								is_ver_todo: false
							},
							{
								item_name: "Ofertas perfumes",
								item_url: "https://www.falabella.com/falabella-cl/collection/oferta-perfumes",
								tag: {
								},
								is_ver_todo: false
							}
						]
					}
				],
				tag: {
				},
				tags: [
				],
				title: "Liquidación SEO",
				ver_todo: {
					title: "",
					href: ""
				}
			}
		],
		accesses: [
			{
				item_name: "Nuestras tiendas",
				items: [
					{
						item_name: "Falabella",
						icon: {
							filename: "hr-6-falabella.svg",
							title: "hr-6-falabella.svg",
							tags: [
							],
							url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltdd4febec3e84e871/60c9aca0eefdde56c1143c6e/hr-6-falabella.svg"
						},
						url: "https://tienda.falabella.com/falabella-cl",
						is_new_tab: false,
						second_level_access: [
						]
					},
					{
						item_name: "Sodimac",
						icon: {
							description: "",
							filename: "Sodimac.svg",
							tags: [
							],
							title: "hr-7-sodimac.svg",
							url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt6b84a079db062ffe/6127d0af4dd2c76eddbbf2b7/Sodimac.svg",
							permanent_url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt6b84a079db062ffe/hr-7-sodimac.svg"
						},
						url: "https://sodimac.falabella.com/sodimac-cl",
						is_new_tab: false,
						second_level_access: [
						]
					},
					{
						item_name: "Tottus",
						icon: {
							filename: "hr-9-tottus.svg",
							title: "hr-9-tottus.svg",
							tags: [
							],
							url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt92c9788003828968/60c9ad90bdf5ed4ae2de2ed7/hr-9-tottus.svg"
						},
						url: "https://tottus.falabella.com/tottus-cl",
						is_new_tab: false,
						second_level_access: [
						]
					},
					{
						item_name: "Linio",
						icon: {
							filename: "etiqueta_linio_circulo.svg",
							tags: [
							],
							title: "etiqueta_linio_circulo.svg",
							url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blta92c5979912f8a1e/611c4a6b25695f14a34d8552/etiqueta_linio_circulo.svg"
						},
						url: "https://linio.falabella.com/linio-cl",
						is_new_tab: false,
						second_level_access: [
						]
					}
				]
			},
			{
				item_name: "",
				items: [
					{
						item_name: "Vende con nosotros",
						icon: {
						},
						url: "https://www.falabella.com/falabella-cl/page/Vende-en-Falabella.com?mkid=LA_VI_VER_1000002626&staticPageId=42100010",
						is_new_tab: false,
						second_level_access: [
						]
					}
				]
			},
			{
				item_name: "",
				items: [
					{
						item_name: "Guías de compra",
						icon: {
							filename: "ic-guias-de-compra.svg",
							title: "ic-guias-de-compra.svg",
							tags: [
							],
							url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltfbdfc62f526c2399/6193c83c3b08dd14d79a8ecd/ic-guias-de-compra.svg"
						},
						url: "",
						is_new_tab: false,
						second_level_access: [
							{
								child_name: "Televisores",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-televisores",
								is_new_tab: false
							},
							{
								child_name: "Notebooks",
								url: "https://www.falabella.com/falabella-cl/page/Guia-de-compra-Notebooks",
								is_new_tab: false
							},
							{
								child_name: "Smartwach",
								url: "https://www.falabella.com/falabella-cl/page/guia-compra-smartwatch",
								is_new_tab: false
							},
							{
								child_name: "Refrigeradores",
								url: "https://www.falabella.com/falabella-cl/page/guia-compra-refrigeradores",
								is_new_tab: false
							},
							{
								child_name: "Lavadoras",
								url: "https://www.falabella.com/falabella-cl/page/guia-compra-lavadoras",
								is_new_tab: false
							},
							{
								child_name: "Calefacción",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-calefaccion",
								is_new_tab: false
							},
							{
								child_name: "Camas",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-camas",
								is_new_tab: false
							},
							{
								child_name: "Ropa de cama",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-ropa-de-cama",
								is_new_tab: false
							},
							{
								child_name: "Coches",
								url: "https://www.falabella.com/falabella-cl/page/Guia-de-compra-Coches",
								is_new_tab: false
							},
							{
								child_name: "Juguetería",
								url: "https://www.falabella.com/falabella-cl/page/guia-compra-jugueteria",
								is_new_tab: false
							},
							{
								child_name: "Bicicletas",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-bicicletas",
								is_new_tab: false
							},
							{
								child_name: "Aire acondicionado",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-aire-acondicionado",
								is_new_tab: false
							},
							{
								child_name: "Aspiradora robot",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-aspiradora-robot",
								is_new_tab: false
							},
							{
								child_name: "Sofás",
								url: "https://www.falabella.com/falabella-cl/page/guia-compra-sofa",
								is_new_tab: false
							},
							{
								child_name: "Cocina",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-cocinas",
								is_new_tab: false
							},
							{
								child_name: "Scooter eléctrico",
								url: "https://www.falabella.com/falabella-cl/page/Guia-Compra-Scooter-Electrico",
								is_new_tab: false
							},
							{
								child_name: "Máquinas de ejercicio",
								url: "https://www.falabella.com/falabella-cl/page/guia-compra-maquinas-de-ejercicio",
								is_new_tab: false
							},
							{
								child_name: "Cafeteras",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-cafeteras",
								is_new_tab: false
							},
							{
								child_name: "Zapatillas",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-zapatillas",
								is_new_tab: false
							},
							{
								child_name: "Celulares",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-celulares",
								is_new_tab: false
							},
							{
								child_name: "Sillas para auto",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-sillas-de-auto",
								is_new_tab: false
							},
							{
								child_name: "Tratamiento facial por edad",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-tratamiento-facial",
								is_new_tab: false
							},
							{
								child_name: "Tratamiento capilar",
								url: "https://www.falabella.com/falabella-cl/page/guia-compra-tratamiento-capilar",
								is_new_tab: false
							},
							{
								child_name: "Tratamiento facial por tipo de piel",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-compra-tratamiento-facial-piel",
								is_new_tab: false
							},
							{
								child_name: "Instrumentos musicales",
								url: "https://www.falabella.com/falabella-cl/page/guia-de-instrumentos-musicales",
								is_new_tab: false
							},
							{
								child_name: "Cámaras de seguridad",
								url: "https://www.falabella.com/falabella-cl/page/guia-compra-camaras-seguridad",
								is_new_tab: false
							}
						]
					},
					{
						item_name: "Garantía extendida",
						icon: {
							filename: "ic-garantia-extendida.svg",
							title: "ic-garantia-extendida.svg",
							tags: [
							],
							url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt0c469eced4e010e9/6193c84df71a3113890ea4fd/ic-garantia-extendida.svg"
						},
						url: "https://tienda.falabella.com/falabella-cl/page/garantia-extendida",
						is_new_tab: false,
						second_level_access: [
						]
					},
					{
						item_name: "Centro de ayuda",
						icon: {
							filename: "iccentrodeayuda.svg",
							tags: [
							],
							title: "iccentrodeayuda.svg",
							url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc2fd2ce4af6bcb5a/61e01aef14ef402247ceb8bc/iccentrodeayuda.svg"
						},
						url: "https://www.falabella.com/falabella-cl/page/contactanos",
						is_new_tab: false,
						second_level_access: [
						]
					},
					{
						item_name: "Horario de tiendas",
						icon: {
							filename: "ic-horario-tienda.svg",
							title: "ic-horario-tienda.svg",
							tags: [
							],
							url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt28fff7b2d03820a7/6193c8623b08dd14d79a8ed1/ic-horario-tienda.svg"
						},
						url: "https://www.falabella.com/falabella-cl/page/horarios-tiendas-retiro",
						is_new_tab: false,
						second_level_access: [
						]
					},
					{
						item_name: "Fpay",
						icon: {
							description: "",
							filename: "ic-fpay.svg",
							tags: [
							],
							title: "ic-fpay.svg",
							url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltae7d1c582be34be4/6197de319248f010ab794bfd/ic-fpay.svg",
							permanent_url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltae7d1c582be34be4/fpay.svg"
						},
						url: "https://fpay.cl/",
						is_new_tab: true,
						second_level_access: [
						]
					}
				]
			}
		],
		category_position: 1
	},
	app_item: {
		item_name: "¡Descarga la App!",
		icon: {
			filename: "Group_6863.svg",
			title: "Group_6863.svg",
			tags: [
			],
			url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blte4b8338fd0b115c4/6172e290f13b7e5c89d3f820/Group_6863.svg"
		},
		url_android: "https://play.google.com/store/apps/details?id=com.falabella.falabellaApp&hl=es_419&gl=US",
		url_ios: "https://apps.apple.com/cl/app/falabella/id947145705"
	},
	fast_accesses: {
		login_items: [
			{
				item_name: "tienes|Mis CMR Puntos",
				icon: {
					filename: "Group.svg",
					title: "Group.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blta22b5a7071a3edf8/6172dde0385f7a513f0ded6f/Group.svg"
				},
				cmr_puntos_icon: {
					filename: "cmr-puntos-isotipo.svg",
					title: "cmr_puntos.svg",
					tags: [
					],
					description: "",
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3e3d742e1bd8e2cd/61fbb5e319a2b06354d1104a/cmr-puntos-isotipo.svg"
				},
				cmr_points_check_box: true,
				url: "https://www.falabella.com/falabella-cl/page/Puntos-CMR",
				is_new_tab: false,
				child_items: [
				]
			},
			{
				item_name: "Mis compras",
				icon: {
					filename: "mis_compras.svg",
					title: "mis_compras.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7f6e0d00e53d6d99/6172dd2a4307ab590944c8f9/mis_compras.svg"
				},
				cmr_puntos_icon: {
				},
				cmr_points_check_box: false,
				url: "https://www.falabella.com/falabella-cl/myorders",
				is_new_tab: false,
				child_items: [
				]
			},
			{
				item_name: "Tarjeta CMR",
				icon: {
					filename: "tarjetacmr.svg",
					title: "tarjetacmr.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt04894b18de2231a8/61c9d887abe5293e6578202a/tarjetacmr.svg"
				},
				cmr_puntos_icon: {
				},
				cmr_points_check_box: false,
				url: "",
				is_new_tab: false,
				child_items: [
					{
						child_name: "Pedir CMR (regalo $10.000)",
						url: "https://www.falabella.com/falabella-cl/page/CMR-enlinea?sid=HO_EC_APE_824&&staticPageId=28700002&detalleClic=menu-mobile&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ",
						icon: {
						},
						is_new_tab: false
					},
					{
						child_name: "Paga cuota CMR",
						url: "https://www.falabella.com/falabella-cl/page/CMR-enlinea?sid=HO_EC_APE_824&&staticPageId=28700002&detalleClic=menu&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ",
						icon: {
						},
						is_new_tab: false
					}
				]
			},
			{
				item_name: "Centro de ayuda",
				icon: {
					filename: "centro_de_ayuda.svg",
					title: "centro_de_ayuda.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt1697b26a879245ff/6172de328331c0590beede35/centro_de_ayuda.svg"
				},
				cmr_puntos_icon: {
				},
				cmr_points_check_box: false,
				url: "https://www.falabella.com/falabella-cl/page/contactanos",
				is_new_tab: false,
				child_items: [
				]
			}
		],
		not_logged_items: [
			{
				item_name: "Mis compras",
				icon: {
					filename: "mis_compras.svg",
					title: "mis_compras.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7f6e0d00e53d6d99/6172dd2a4307ab590944c8f9/mis_compras.svg"
				},
				url: "https://www.falabella.com/falabella-cl/myorders",
				is_new_tab: false,
				child_items: [
				]
			},
			{
				item_name: "Tarjeta CMR",
				icon: {
					filename: "tarjetacmr.svg",
					title: "tarjetacmr.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt04894b18de2231a8/61c9d887abe5293e6578202a/tarjetacmr.svg"
				},
				url: "",
				is_new_tab: false,
				child_items: [
					{
						child_name: "Pedir CMR (regalo $10.000)",
						url: "https://www.falabella.com/falabella-cl/page/CMR-enlinea?sid=HO_EC_APE_824&&staticPageId=28700002&detalleClic=menu-mobile&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ",
						icon: {
						},
						is_new_tab: false
					},
					{
						child_name: "Paga cuota CMR",
						url: "https://pagorapido.bancofalabella.cl/?utm_source=falabella.com&utm_medium=header&utm_campaign=landing-datos-para-clientes",
						icon: {
						},
						is_new_tab: true
					},
					{
						child_name: "Descuentos CMR",
						url: "https://www.falabella.com/falabella-cl/collection/descuentos-cmr?sid=HO_ME_MOB_32",
						icon: {
						},
						is_new_tab: false
					}
				]
			},
			{
				item_name: "CMR Puntos",
				icon: {
					filename: "Group.svg",
					title: "Group.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blta22b5a7071a3edf8/6172dde0385f7a513f0ded6f/Group.svg"
				},
				url: "https://www.falabella.com/falabella-cl/page/Puntos-CMR",
				is_new_tab: false,
				child_items: [
				]
			},
			{
				item_name: "Centro de ayuda",
				icon: {
					filename: "centro_de_ayuda.svg",
					title: "centro_de_ayuda.svg",
					tags: [
					],
					url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt1697b26a879245ff/6172de328331c0590beede35/centro_de_ayuda.svg"
				},
				url: "https://www.falabella.com/falabella-cl/page/contactanos",
				is_new_tab: false,
				child_items: [
				]
			}
		]
	},
	logo: {
		url: "https://www.falabella.com/falabella-cl",
		imagedesktop: {
			filename: "logo-falabella-menu.svg",
			title: "logo-falabella-menu.svg",
			tags: [
			],
			url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7a1a0943d581e5c2/6193c80df71a3113890ea4f9/logo-falabella-menu.svg"
		},
		imagemobile: {
			filename: "logofalabella.svg",
			title: "logofalabella.svg",
			tags: [
			],
			url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc54319de484b6515/61c08b87c455652925b794c7/logofalabella.svg"
		}
	},
	monetization_banners: {
		banner: [
		],
		size: {
		}
	},
	tags: [
	],
	title: "[PRODUCTION] Navigation Menu",
	ventatelef_nica: {
		title: "VENTA TELEFÓNICA",
		icon: {
			filename: "callcenter.svg",
			title: "callcenter.svg",
			tags: [
			],
			url: "https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7ad77151fd33ab4c/618542e019df7c77cdb202c5/callcenter.svg"
		},
		number: 6003906500,
		link: "tel:6003906500"
	}
};
var taxonomyV2CL = {
	entry: entry$4
};

var taxonomyFallback = {
  v1: {
    ar: taxonomyV1AR,
    cl: taxonomyV1CL,
    co: taxonomyV1CO,
    pe: taxonomyV1PE
  },
  v2: {
    cl: taxonomyV2CL
  }
};

var A11Y_LOCATION_LABEL = 'location';
var Taxonomy = function Taxonomy(_ref) {
  var headerData = _ref.headerData,
    data = _ref.data,
    currentLocation = _ref.currentLocation,
    isInternetExplorer = _ref.isInternetExplorer,
    isGeoLocationEnabled = _ref.isGeoLocationEnabled,
    deviceType = _ref.deviceType,
    hideMenuBar = _ref.hideMenuBar,
    isCatalyst = _ref.isCatalyst,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    isMenuVisible = _ref.isMenuVisible,
    setMenuVisible = _ref.setMenuVisible;
  var _useContext = useContext(AppContext),
    tenant = _useContext.tenant,
    baseUrl = _useContext.baseUrl;
  var taxonomyData = data.entry;
  var onNavBtnClick = function onNavBtnClick() {
    setMenuVisible(!isMenuVisible);
  };
  var hideMenu = function hideMenu() {
    setMenuVisible(false);
  };
  useEffect(function () {
    if (hideMenuBar) {
      hideMenu();
    }
  }, [hideMenuBar]);
  return jsx("div", {
    className: styles$n.HamburgerBtnWrapper
  }, jsx(HamburgerBtn, {
    showTaxonomy: isMenuVisible,
    onNavBtnClick: onNavBtnClick,
    deviceType: deviceType
  }), jsx(MatchMedia$1, {
    content: {
      mobile: function mobile() {
        return jsx(TaxonomyMobile$1, {
          showTaxonomy: isMenuVisible,
          taxonomyData: taxonomyData,
          hideMenu: hideMenu,
          a11yLocationLabel: A11Y_LOCATION_LABEL,
          currentLocation: currentLocation,
          header: headerData,
          setMenuVisible: setMenuVisible,
          isGeoLocationEnabled: isGeoLocationEnabled,
          tenant: tenant,
          isCatalyst: isCatalyst
        });
      },
      tablet: function tablet() {
        return jsx(TaxonomyMobile$1, {
          showTaxonomy: isMenuVisible,
          taxonomyData: taxonomyData,
          hideMenu: hideMenu,
          a11yLocationLabel: A11Y_LOCATION_LABEL,
          currentLocation: currentLocation,
          header: headerData,
          setMenuVisible: setMenuVisible,
          isGeoLocationEnabled: isGeoLocationEnabled,
          tenant: tenant,
          isCatalyst: isCatalyst
        });
      },
      desktop: function desktop() {
        return jsx(TaxonomyDesktop$1, {
          showTaxonomy: isMenuVisible,
          taxonomyData: taxonomyData,
          setMenuVisible: setMenuVisible,
          hideMenu: hideMenu,
          isAgentLoggedIn: isAgentLoggedIn,
          isVendorLoggedIn: isVendorLoggedIn
        });
      }
    }
  }));
};
Taxonomy.propTypes = process.env.NODE_ENV !== "production" ? {
  headerData: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  firstName: PropTypes.string,
  currentLocation: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  isInternetExplorer: PropTypes.bool,
  isGeoLocationEnabled: PropTypes.bool,
  hideMenuBar: PropTypes.bool,
  isCatalyst: PropTypes.bool,
  isAgentLoggedIn: PropTypes.bool,
  isMenuVisible: PropTypes.bool,
  setMenuVisible: PropTypes.func
} : {};
Taxonomy.defaultProps = {
  firstName: '',
  isInternetExplorer: false,
  isGeoLocationEnabled: false,
  hideMenuBar: false,
  isCatalyst: false,
  isAgentLoggedIn: false,
  isMenuVisible: false,
  setMenuVisible: noop
};
var getTaxonomyData = function getTaxonomyData(_ref2) {
  var tenant = _ref2.tenant,
    baseUrl = _ref2.baseUrl;
  var validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
  return doFetch(buildContentUrl(baseUrl, 'taxonomy', validTenant, 'v2'), {}, {
    data: taxonomyFallback.v2[validTenant],
    triggerOnResponseError: true,
    triggerOnNetworkError: true
  });
};
Taxonomy.getTaxonomyData = getTaxonomyData;
var Taxonomy$1 = withUser(Taxonomy);

var styles$o = {"searchBar":"SearchBar-module_searchBar__MCR66","store_search_input_wrapper":"SearchBar-module_store_search_input_wrapper__xsfQV","store_search_input_wrapper--to_com":"SearchBar-module_store_search_input_wrapper--to_com__1NwKJ","showOverlay":"SearchBar-module_showOverlay__38sQn","flatSearchCorners":"SearchBar-module_flatSearchCorners__yGqZ8","searchBar--whitelabel":"SearchBar-module_searchBar--whitelabel__3lxuF","searchBar__Icon":"SearchBar-module_searchBar__Icon__3BPGE","searchBar__Input":"SearchBar-module_searchBar__Input__1kPKS","searchBar__Close":"SearchBar-module_searchBar__Close__2CD8z","hidden":"SearchBar-module_hidden__1KZ_s","sr-only":"SearchBar-module_sr-only__3UWD4","searchBtnIcon":"SearchBar-module_searchBtnIcon__2L2s0","searchIcon":"SearchBar-module_searchIcon__FS7b4","searchBtnIcon--so_com":"SearchBar-module_searchBtnIcon--so_com__180Pb","searchBtnIcon--to_com":"SearchBar-module_searchBtnIcon--to_com__3wI72","searchBtnIcon--whitelabel":"SearchBar-module_searchBtnIcon--whitelabel__3fImg","searchBtn":"SearchBar-module_searchBtn__SVnGE","searchBarActive":"SearchBar-module_searchBarActive__2PAUu","searchBarWrapper":"SearchBar-module_searchBarWrapper__FWM7Z","store_search":"SearchBar-module_store_search__3Foue","store_search--to_com":"SearchBar-module_store_search--to_com__11RRF","searchBarWrapper--to_com":"SearchBar-module_searchBarWrapper--to_com__3HRbu","searchBarWrapper--whitelabel":"SearchBar-module_searchBarWrapper--whitelabel__3tGCM","overlap":"SearchBar-module_overlap__26Avz","showFlatEdges":"SearchBar-module_showFlatEdges__I5E-G"};

var Searchbar = function Searchbar(_ref) {
  var deviceType = _ref.deviceType,
    handleEnter = _ref.handleEnter,
    isTypeAheadActive = _ref.isTypeAheadActive,
    minQueryLength = _ref.minQueryLength,
    onSearchBarChange = _ref.onSearchBarChange,
    searchbar = _ref.searchbar,
    searchQuery = _ref.searchQuery,
    setSearchInputRef = _ref.setSearchInputRef,
    setSearchQuery = _ref.setSearchQuery,
    setIsSearchBarTouched = _ref.setIsSearchBarTouched,
    searchInSis = _ref.searchInSis,
    store = _ref.store;
  var _getStandaloneSite = getStandaloneSite(store),
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSearchBarActive = _useState2[0],
    setSearchBarActive = _useState2[1];
  var searchInputRef = useRef();
  setSearchInputRef(searchInputRef);
  var makeTypeAheadCall = function makeTypeAheadCall(value) {
    if (value.length >= minQueryLength) {
      onSearchBarChange(value);
    } else {
      onSearchBarChange();
    }
  };
  var getPlaceholder = function getPlaceholder(_ref2) {
    var type = _ref2.type;
    if (!store || isSodimacStandalone || isWhitelabelSite) {
      return get(searchbar, "".concat(type, "_placeholder"), '');
    }
    return "Buscar en ".concat(get(SIS_STORE_MAP, store));
  };
  var searchPlaceholder = getPlaceholder({
    type: 'desktop'
  });
  var searchPlaceholderMobile = getPlaceholder({
    type: 'mobile'
  });
  var debouncedTypeAhead = useCallback(debounce(makeTypeAheadCall, 200), [searchInSis, store]);
  var handleChange = function handleChange(e) {
    var value = e.target.value;
    setSearchQuery(value);
    debouncedTypeAhead(value);
  };
  var clearSearch = function clearSearch() {
    setSearchQuery('');
    onSearchBarChange();
    if (searchInputRef && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };
  var rendeCrossIcon = function rendeCrossIcon() {
    return searchQuery.length ? jsx("i", {
      id: "testId-SearchBar-Close",
      className: styles$o.searchBar__Close,
      onClick: clearSearch
    }) : jsx(React.Fragment, null);
  };
  var isDesktop = deviceType === 'desktop';
  var handleOnBlur = function handleOnBlur(event) {
    if (!event.relatedTarget) {
      setIsSearchBarTouched(false);
      return;
    }
    if (event.relatedTarget && !event.relatedTarget.id.includes('searchCheckbox')) {
      setIsSearchBarTouched(false);
    }
  };
  return jsx("div", {
    className: classNames(styles$o.searchBarWrapper, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$o.searchBarActive, isSearchBarActive), styles$o.store_search, store), styles$o['store_search--to_com'], isTottusStandalone), styles$o['searchBarWrapper--to_com'], isTottusStandalone), styles$o['searchBarWrapper--whitelabel'], isWhitelabelSite)),
    onFocus: function onFocus() {
      return setIsSearchBarTouched(true);
    },
    onBlur: function onBlur(e) {
      return handleOnBlur(e);
    }
  }, jsx("div", {
    className: classNames(styles$o.searchBar, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$o.showOverlay, isTypeAheadActive), styles$o.flatSearchCorners, !isSodimacStandalone && isTypeAheadActive), styles$o.store_search_input_wrapper, store), styles$o['store_search_input_wrapper--to_com'], isTottusStandalone), styles$o['searchBar--whitelabel'], isWhitelabelSite)),
    onFocus: function onFocus() {
      return isDesktop && setSearchBarActive(true);
    },
    onBlur: function onBlur() {
      return isDesktop && setSearchBarActive(false);
    }
  }, jsx("label", {
    htmlFor: "testId-SearchBar-Input",
    className: styles$o['sr-only']
  }, "Search Bar"), jsx("input", {
    autoComplete: "off",
    className: styles$o.searchBar__Input,
    id: "testId-SearchBar-Input",
    onChange: handleChange,
    ref: searchInputRef,
    tabIndex: "-1",
    type: "text",
    value: searchQuery,
    placeholder: deviceType === 'desktop' ? searchPlaceholder : searchPlaceholderMobile,
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === 13 && searchInputRef.current) {
        searchInputRef.current.blur();
      }
    },
    onBlur: function onBlur() {
      return updateDigitalDataCookies({
        firstLevelItem: 'N1 - Search Typeahead',
        tag: HEADER
      });
    }
  }), rendeCrossIcon()), jsx("button", {
    onClick: handleEnter,
    className: classNames(styles$o.searchBtnIcon, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$o.showFlatEdges, !isSodimacStandalone && isTypeAheadActive), styles$o.overlap, isTypeAheadActive), styles$o['searchBtnIcon--so_com'], isSodimacStandalone && !isTypeAheadActive), styles$o['searchBtnIcon--to_com'], isTottusStandalone), styles$o['searchBtnIcon--whitelabel'], isWhitelabelSite))
  }, jsx("img", {
    className: styles$o.searchIcon,
    src: get(searchbar, 'search_icon.url', '')
  })));
};
Searchbar.propTypes = process.env.NODE_ENV !== "production" ? {
  deviceType: PropTypes.string.isRequired,
  handleEnter: PropTypes.func.isRequired,
  isSisSodimacPdpEnabled: PropTypes.bool,
  isTypeAheadActive: PropTypes.bool.isRequired,
  labels: PropTypes.object,
  minQueryLength: PropTypes.number.isRequired,
  onSearchBarChange: PropTypes.func.isRequired,
  searchbar: PropTypes.object.isRequired,
  searchQuery: PropTypes.string.isRequired,
  setSearchInputRef: PropTypes.func.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
  setIsSearchBarTouched: PropTypes.func,
  searchInSis: PropTypes.bool.isRequired,
  store: PropTypes.string
} : {};
Searchbar.defaultProps = {
  setIsSearchBarTouched: noop,
  labels: {},
  store: null
};

var sortSuggestions = function sortSuggestions(suggestions) {
  return suggestions.sort(function (a, b) {
    return a.order > b.order ? 1 : -1;
  });
};
var handleSuggestionsCount = function handleSuggestionsCount(suggestions, count) {
  if (!count) return suggestions;
  return suggestions.slice(0, count || suggestions.length);
};
var SearchHelper = function SearchHelper(results, deviceType) {
  var suggestions = results.suggestions,
    _results$relatedBrand = results.relatedBrands,
    relatedBrands = _results$relatedBrand === void 0 ? [] : _results$relatedBrand,
    _results$relatedCateg = results.relatedCategories,
    relatedCategories = _results$relatedCateg === void 0 ? [] : _results$relatedCateg;
  var isMobile = deviceType === 'mobile';
  if (suggestions.length === 0) {
    return {};
  }
  var fileteredSuggestions = handleSuggestionsCount(suggestions, isMobile ? 5 : null);
  var filteredRelatedBrands = handleSuggestionsCount(relatedBrands, isMobile ? 4 : null);
  var filteredRelatedCategories = handleSuggestionsCount(relatedCategories, isMobile ? 4 : null);
  if (isMobile) {
    fileteredSuggestions[0].categoryScope = [];
  }
  var categoryScopeLength = get(fileteredSuggestions, '[0].categoryScope.length', 0);
  var relatedBrandsIndex = fileteredSuggestions.length + categoryScopeLength;
  var relatedCategoriesIndex = fileteredSuggestions.length + categoryScopeLength + filteredRelatedBrands.length;
  var totalSuggestionsCount = fileteredSuggestions.length + categoryScopeLength + filteredRelatedBrands.length + filteredRelatedCategories.length;
  var categories = [{
    key: 'suggestions',
    listItems: fileteredSuggestions,
    listItemIndexStart: 0,
    order: 1
  }, {
    key: 'relatedBrands',
    listItems: filteredRelatedBrands,
    listItemIndexStart: relatedBrandsIndex,
    title: 'relatedBrands',
    order: isMobile ? 3 : 2
  }, {
    key: 'relatedCategories',
    listItems: filteredRelatedCategories,
    listItemIndexStart: relatedCategoriesIndex,
    title: 'relatedCategories',
    order: isMobile ? 2 : 3
  }];
  return {
    categories: sortSuggestions(categories),
    totalSuggestionsCount: totalSuggestionsCount + 1
  };
};
var getRecentSearchedStoredData = function getRecentSearchedStoredData(tenant) {
  return JSON.parse(WebStorage.getItem({
    name: "recent_searches_".concat(tenant),
    fromPersistence: true
  })) || {};
};
var setRecentSearchedValues = function setRecentSearchedValues(value, store, tenant) {
  var storedData = getRecentSearchedStoredData(tenant);
  var key = store || 'marketplace';
  var data = storedData[key] || [];
  if (data.find(function (val) {
    return value.url === val.url;
  })) {
    data = [value].concat(_toConsumableArray(data.filter(function (val) {
      return value.url !== val.url;
    })));
  } else {
    data = [value].concat(_toConsumableArray(data.slice(0, data.length - (data.length >= 15 ? 1 : 0))));
  }
  WebStorage.setItem({
    name: "recent_searches_".concat(tenant),
    value: JSON.stringify(_objectSpread2({}, storedData, _defineProperty({}, key, data))),
    shouldPersist: true
  });
};
var getRecentSearchedValues = function getRecentSearchedValues(store, tenant, deviceType) {
  var _data;
  var storedData = getRecentSearchedStoredData(tenant);
  var key = store || 'marketplace';
  var data = (storedData[key] || []).slice(0, deviceType === 'mobile' ? 15 : 10);
  data = (_data = data) === null || _data === void 0 ? void 0 : _data.filter(function (val) {
    var _val$url;
    return !(val !== null && val !== void 0 && (_val$url = val.url) !== null && _val$url !== void 0 && _val$url.includes('}'));
  });
  return data;
};
var clearRecentSearchedValues = function clearRecentSearchedValues(store, tenant) {
  var storedData = getRecentSearchedStoredData(tenant);
  var key = store || 'marketplace';
  WebStorage.setItem({
    name: "recent_searches_".concat(tenant),
    value: JSON.stringify(_objectSpread2({}, storedData, _defineProperty({}, key, []))),
    shouldPersist: true
  });
};
var destroyAllRecentSearchedValues = function destroyAllRecentSearchedValues(tenant) {
  WebStorage.removeItem({
    name: "recent_searches_".concat(tenant),
    fromPersistence: true
  });
};

var styles$p = {"searchResults":"SearchList-module_searchResults__3TIFk","recentSearchResults":"SearchList-module_recentSearchResults__3FnM_","agent-loggedin":"SearchList-module_agent-loggedin__6O6Dz","vendor-loggedin":"SearchList-module_vendor-loggedin__2d09b","searchResults__other_category":"SearchList-module_searchResults__other_category__1rEhZ","searchResults__title":"SearchList-module_searchResults__title__3ayRO","storeTitle":"SearchList-module_storeTitle__ZacCN","recentSearchResults__title__container":"SearchList-module_recentSearchResults__title__container__3BAlL","recentSearchResults__title":"SearchList-module_recentSearchResults__title__yLWsO","recentSearchResults__clear":"SearchList-module_recentSearchResults__clear__BUiLB","searchListItem":"SearchList-module_searchListItem__wFMs5","searchListItem__active":"SearchList-module_searchListItem__active__3cm_Y","storeAnchor":"SearchList-module_storeAnchor__3rIz-","recentSearchListItem":"SearchList-module_recentSearchListItem__3RCEf","recentSearchListItem__active":"SearchList-module_recentSearchListItem__active__1YQDF"};

var getURL = function getURL(url, tenant, store) {
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  if (isWhitelabelSite) {
    return "".concat(getWhitelabelSiteBaseUrl(tenant, store)).concat(url);
  }
  if (isStandaloneSite) {
    return "".concat(getStandaloneSiteBaseUrl(tenant, store)).concat(url);
  }
  var baseUrl = getStoreBaseUrl(tenant, store);
  return "".concat(baseUrl).concat(url);
};
var SearchListItem = function SearchListItem(_ref) {
  var text = _ref.text,
    routingUrl = _ref.routingUrl,
    url = _ref.url,
    index = _ref.index,
    children = _ref.children,
    isActive = _ref.isActive,
    onMouseOver = _ref.onMouseOver,
    isCategoryItem = _ref.isCategoryItem,
    setActiveAnchorRef = _ref.setActiveAnchorRef,
    onSelect = _ref.onSelect,
    tenant = _ref.tenant,
    store = _ref.store,
    rawStore = _ref.rawStore,
    searchQuery = _ref.searchQuery,
    section = _ref.section,
    sectionSize = _ref.sectionSize,
    listItemIndexStart = _ref.listItemIndexStart,
    deviceType = _ref.deviceType,
    title = _ref.title,
    setSearchQuery = _ref.setSearchQuery,
    isStore = _ref.isStore,
    categoryItemSearchQuery = _ref.categoryItemSearchQuery;
  var itemText = text;
  if (isCategoryItem) {
    itemText = "<span>en</span> ".concat(text);
  }
  var anchorRef = useRef();
  if (isActive) {
    setActiveAnchorRef(anchorRef);
  }
  var handleArrowClick = function handleArrowClick() {
    setSearchQuery(anchorRef.current.innerText);
  };
  var handleMouseOver = function handleMouseOver() {
    onMouseOver(index);
  };
  var clickItem = function clickItem() {
    var itemClickedText = text.replace(/(<([^>]+)>)/gi, '');
    window.dispatchEvent(new CustomEvent('DDM_onSearching', {
      bubbles: true,
      detail: {
        value: itemClickedText,
        prefix: 'TA'
      }
    }));
    if (isXLPPage()) {
      var sectionClicked =
      section === 'suggestions' ? 'keyword' : section === 'relatedBrands' ? 'brand' : 'category';
      var position = listItemIndexStart ? index - listItemIndexStart : index;
      var subSection = isCategoryItem ? 'category' : 'x';
      var metrics = "".concat(searchQuery, "|").concat(itemClickedText, "|").concat(position, "/").concat(sectionSize, "|").concat(sectionClicked, "|").concat(subSection);
      saveTypeaheadMetrics(metrics);
    }
    onSelect();
    var nonCategoryItemText = url.includes('Ntt') ? "<b>".concat(itemClickedText, "</b>") : itemClickedText;
    setRecentSearchedValues({
      text: isCategoryItem ? "<b>".concat(categoryItemSearchQuery.replace(/(<([^>]+)>)/gi, ''), "</b> en ").concat(itemClickedText) : nonCategoryItemText,
      url: url
    }, rawStore, tenant);
  };
  var anchorProps = {
    className: classNames(_defineProperty(_defineProperty({}, styles$p.searchListItem__active, isActive), styles$p.storeAnchor, isStore)),
    tabIndex: '-1',
    ref: anchorRef,
    onMouseOver: handleMouseOver,
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize("".concat(itemText))
    },
    onClick: clickItem
  };
  return jsx("li", {
    className: styles$p.searchListItem,
    key: "".concat(text, "-").concat(index)
  }, routingUrl ? jsx("a", {
    href: "".concat(routingUrl),
    onClick: clickItem
  }, jsx("a", anchorProps)) : jsx("a", _extends({}, anchorProps, {
    href: getURL(url, tenant, store)
  })), deviceType === 'mobile' && !title && jsx("i", {
    id: "suggestion-arrow",
    onClick: handleArrowClick
  }), children);
};
SearchListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  routingUrl: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isActive: PropTypes.bool.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  isCategoryItem: PropTypes.bool,
  setActiveAnchorRef: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  tenant: PropTypes.string.isRequired,
  store: PropTypes.string.isRequired,
  rawStore: PropTypes.string,
  deviceType: PropTypes.string.isRequired,
  title: PropTypes.string,
  searchQuery: PropTypes.string,
  section: PropTypes.string,
  sectionSize: PropTypes.number,
  listItemIndexStart: PropTypes.number,
  categoryItemSearchQuery: PropTypes.string
} : {};
SearchListItem.defaultProps = {
  children: null,
  isCategoryItem: false,
  rawStore: null
};

var minQueryLength = 2;
var minQueryLengthForSuggestion = 3;
var maxQueryLengthForSuggestion = 30;
var searchLabels = {
  relatedBrandsMobile: 'Marcas',
  relatedCategoriesMobile: 'Categorías',
  relatedBrands: 'Marcas relacionadas',
  relatedCategories: 'Categorías relacionadas',
  searchPlaceholder: '¿Qué buscas?',
  incorrectSearch: 'Busqueda Incorrecta',
  emptySearch: 'Busqueda Vacia',
  incorrectSearchBody: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
  emptySearchBody: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
  recentSearches: 'Buscaste recientemente',
  clear: 'Limpiar'
};

var SearchList = function SearchList(_ref) {
  var cursor = _ref.cursor,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    onMouseOver = _ref.onMouseOver,
    onSelect = _ref.onSelect,
    deviceType = _ref.deviceType,
    results = _ref.results,
    setActiveAnchorRef = _ref.setActiveAnchorRef,
    tenant = _ref.tenant,
    store = _ref.store,
    searchInSis = _ref.searchInSis,
    searchQuery = _ref.searchQuery,
    setSearchQuery = _ref.setSearchQuery;
  var counter = 0;
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var renderList = function renderList() {
    var isCategoryItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var list = arguments.length > 1 ? arguments[1] : undefined;
    var listItemIndexStart = arguments.length > 2 ? arguments[2] : undefined;
    var title = arguments.length > 3 ? arguments[3] : undefined;
    var section = arguments.length > 4 ? arguments[4] : undefined;
    var sectionSize = arguments.length > 5 ? arguments[5] : undefined;
    var categoryItemSearchQuery = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
    counter = listItemIndexStart || counter;
    var isCustomSite = isStandaloneSite || isWhitelabelSite;
    return list.map(function (_ref2) {
      var text = _ref2.text,
        url = _ref2.url,
        routingUrl = _ref2.routingUrl,
        categoryScope = _ref2.categoryScope;
      counter += 1;
      return jsx(SearchListItem, {
        key: "".concat(text, "-").concat(url),
        text: text,
        url: url,
        routingUrl: routingUrl,
        onFocus: onMouseOver,
        onMouseOver: onMouseOver,
        isActive: counter === cursor,
        index: counter,
        isCategoryItem: isCategoryItem,
        setActiveAnchorRef: setActiveAnchorRef,
        onSelect: onSelect,
        tenant: tenant,
        store: searchInSis && title !== 'relatedBrands' || isCustomSite ? store : 'falabella',
        rawStore: store,
        searchQuery: searchQuery,
        setSearchQuery: setSearchQuery,
        section: section,
        sectionSize: sectionSize,
        listItemIndexStart: listItemIndexStart,
        title: title,
        deviceType: deviceType,
        isStore: !!store,
        categoryItemSearchQuery: categoryItemSearchQuery
      }, categoryScope && jsx("ul", null, renderList(true, categoryScope, null, null, section, sectionSize, text)));
    });
  };
  var isMobile = deviceType === 'mobile';
  return jsx("div", {
    className: classNames(styles$p.searchResults, styles$p["".concat(isAgentLoggedIn ? 'agent-loggedin' : isVendorLoggedIn && 'vendor-loggedin')])
  }, results.categories.map(function (_ref3) {
    var key = _ref3.key,
      listItems = _ref3.listItems,
      listItemIndexStart = _ref3.listItemIndexStart,
      title = _ref3.title;
    var sectionSize = listItems.reduce(function (acc, next) {
      return next && next.categoryScope ? acc + next.categoryScope.length : acc;
    }, listItems.length);
    return jsx(Fragment, {
      key: key
    }, listItems.length !== 0 && jsx("section", {
      className: classNames(_defineProperty({}, styles$p.searchResults__other_category, title))
    }, title && jsx("h6", {
      className: classNames(styles$p.searchResults__title, _defineProperty({}, styles$p.storeTitle, store)),
      onClick: function onClick(e) {
        return e.preventDefault();
      }
    }, searchLabels[isMobile ? "".concat(title, "Mobile") : title] || title), jsx("ul", null, renderList(false, listItems, listItemIndexStart, title, key, sectionSize))));
  }));
};
SearchList.propTypes = process.env.NODE_ENV !== "production" ? {
  cursor: PropTypes.number.isRequired,
  isAgentLoggedIn: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  onMouseOver: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  results: PropTypes.object,
  setActiveAnchorRef: PropTypes.func,
  tenant: PropTypes.string.isRequired,
  deviceType: PropTypes.string,
  isSearchBarTouched: PropTypes.bool,
  store: PropTypes.string.isRequired,
  searchInSis: PropTypes.bool,
  searchQuery: PropTypes.string
} : {};
SearchList.defaultProps = {
  isAgentLoggedIn: false,
  isVendorLoggedIn: false,
  isSearchBarTouched: false,
  results: {},
  setActiveAnchorRef: noop,
  searchInSis: false
};

var CancelablePromise = function () {
  function CancelablePromise(promise) {
    _classCallCheck(this, CancelablePromise);
    this.promise = promise;
    this.isCanceled = false;
  }
  return _createClass(CancelablePromise, [{
    key: "cancel",
    value: function cancel() {
      this.isCanceled = true;
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.promise;
            case 2:
              result = _context.sent;
              if (!this.isCanceled) {
                _context.next = 5;
                break;
              }
              throw new Error('Promise is Cancelled');
            case 5:
              return _context.abrupt("return", result);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }]);
}();

var getTopScroll = function getTopScroll() {
  if (document.body.style.top) {
    return document.body.style.top;
  }
  var scrollY = window.scrollY || document.documentElement.scrollTop;
  return "-".concat(scrollY, "px");
};
var disableScroll = function disableScroll() {
  document.body.style.top = getTopScroll();
};
var enableScroll = function enableScroll() {
  var scrollY = document.body.style.top;
  document.body.style.position = '';
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
};

var styles$q = {"background-overlay":"BackgroundOverlay-module_background-overlay__1T4Cp","shade-lighter":"BackgroundOverlay-module_shade-lighter__21DMM"};

var BackgroundOverlay = function BackgroundOverlay(_ref) {
  var shade = _ref.shade,
    setOverlayEnabled = _ref.setOverlayEnabled;
  var overlayRef = useRef();
  React.useEffect(function () {
    setOverlayEnabled(true);
    return function () {
      setOverlayEnabled(false);
    };
  }, []);
  return createPortal(jsx("div", {
    ref: overlayRef,
    onKeyDown: noop,
    tabIndex: "0",
    role: "button",
    className: classNames(styles$q['background-overlay'], _defineProperty({}, styles$q["shade-".concat(shade)], shade && typeof shade === 'string'))
  }), document.body);
};
BackgroundOverlay.defaultProps = {
  shade: null,
  setOverlayEnabled: function setOverlayEnabled() {}
};
BackgroundOverlay.propTypes = process.env.NODE_ENV !== "production" ? {
  shade: PropTypes.oneOf(['lighter']),
  setOverlayEnabled: PropTypes.func.isRequired
} : {};
var BackgroundOverlay$1 = withUser(BackgroundOverlay);

var nameHOC = function nameHOC(Component) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "".concat(Component.originalName || Component.displayName || Component.name || 'Component').concat(suffix);
};
var hocUtils = {
  nameHOC: nameHOC
};

var nameHOC$1 = hocUtils.nameHOC;
var WithTogggle = function WithTogggle(WrappedComponent) {
  var ComponentWithToggle = function ComponentWithToggle(props) {
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      toggle = _useState2[0],
      setToggle = _useState2[1];
    var toggleState = {
      visible: toggle,
      setVisible: function setVisible(bool) {
        return setToggle(bool);
      }
    };
    return jsx(WrappedComponent, _extends({}, props, {
      toggleState: toggleState
    }));
  };
  ComponentWithToggle.originalName = nameHOC$1(WrappedComponent);
  ComponentWithToggle.displayName = nameHOC$1(WrappedComponent, 'WithToggle');
  return ComponentWithToggle;
};

var styles$r = {"modal-container":"Modal-module_modal-container__Zgie2","modal":"Modal-module_modal__2xwES","floatBottom":"Modal-module_floatBottom__2Iwlt","floatBottomTransition":"Modal-module_floatBottomTransition__2XKZC","frombottom":"Modal-module_frombottom___LdFR","floatBottomEndTransition":"Modal-module_floatBottomEndTransition__1dh1G","tobottom":"Modal-module_tobottom__1gqpW","floatBottomEndTransitionOnboarding":"Modal-module_floatBottomEndTransitionOnboarding__2hxVa","tobottomOnboarding":"Modal-module_tobottomOnboarding__2acza","floatBottomEnd":"Modal-module_floatBottomEnd__2UnXh","withPadding":"Modal-module_withPadding__3iM0M","modal-busy-overlay":"Modal-module_modal-busy-overlay__3c7OZ","modal-close":"Modal-module_modal-close__38WBS","marginRight5":"Modal-module_marginRight5__2Whu4","modal-header":"Modal-module_modal-header__UN68T","noBorder":"Modal-module_noBorder__3r5E6","modal-body":"Modal-module_modal-body__2MKK-","zone-modal-body-retail":"Modal-module_zone-modal-body-retail__1YYz6","zone-modal-body-marketplace":"Modal-module_zone-modal-body-marketplace__3IW46","no-result-modal-body":"Modal-module_no-result-modal-body__2PHql","full-screen":"Modal-module_full-screen__2SUPN","with-header":"Modal-module_with-header__3OI6H","flex":"Modal-module_flex__1DgYi","doc-click-overlay":"Modal-module_doc-click-overlay__3ItFi","click-element":"Modal-module_click-element__38vVQ","icon-danger":"Modal-module_icon-danger__1toyc","icon-big":"Modal-module_icon-big__NxfZD"};

var Modal = function Modal(_ref) {
  var children = _ref.children,
    toggleState = _ref.toggleState,
    content = _ref.content,
    options = _ref.options,
    header = _ref.header,
    visible = _ref.visible,
    withPadding = _ref.withPadding,
    showCloseButton = _ref.showCloseButton,
    fullScreen = _ref.fullScreen,
    appendClickElement = _ref.appendClickElement,
    deviceType = _ref.deviceType,
    showSpinner = _ref.showSpinner,
    resetHandler = _ref.resetHandler,
    closeOtherModals = _ref.closeOtherModals,
    fullWidth = _ref.fullWidth,
    customClass = _ref.customClass,
    customID = _ref.customID,
    customBodyClass = _ref.customBodyClass,
    customHeaderClass = _ref.customHeaderClass,
    isOverlayEnabled = _ref.isOverlayEnabled,
    modalTranslateStyle = _ref.modalTranslateStyle,
    customCloseIconClass = _ref.customCloseIconClass,
    modalAnimationClass = _ref.modalAnimationClass,
    zoneModalWrapStyles = _ref.zoneModalWrapStyles,
    buttonOpenModalID = _ref.buttonOpenModalID,
    modalContainerZIndex = _ref.modalContainerZIndex,
    keepNoScroll = _ref.keepNoScroll;
  if (visible) {
    toggleState.setVisible(true);
  }
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    customHeader = _useState2[0],
    setCustomHeader = _useState2[1];
  var config = _objectSpread2({
    width: undefined,
    height: undefined,
    disableOutsideClick: false
  }, options);
  var _useState3 = useState(showSpinner),
    _useState4 = _slicedToArray(_useState3, 2),
    modalBusy = _useState4[0],
    setModalBusy = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isModalVisible = _useState6[0],
    setModalVisible = _useState6[1];
  var removeClasses = function removeClasses() {
    if (!customBodyClass) {
      return;
    }
    if (!keepNoScroll) {
      toggleBodyClass(false, 'no-scroll');
    }
    if (deviceType !== 'desktop') {
      enableScroll();
    }
    setModalVisible(false);
  };
  useEffect(function () {
    if (toggleState.visible) {
      setModalVisible(true);
      toggleBodyClass(true, 'no-scroll');
      if (deviceType !== 'desktop') {
        disableScroll();
      }
    } else if (isModalVisible) {
      removeClasses();
    }
    if (!toggleState.visible) {
      resetHandler();
    }
    return removeClasses;
  }, [toggleState.visible]);
  var actions = {
    close: function close() {
      toggleState.setVisible(false);
    },
    setCustomHeader: setCustomHeader,
    setBusy: function setBusy(toggle) {
      return setModalBusy(toggle);
    }
  };
  var newChildren = Children.map(children, function (element) {
    return appendClickElement ? jsx("div", {
      onClick: function onClick() {
        toggleState.setVisible(true);
        closeOtherModals();
      },
      onKeyDown: noop,
      role: "button",
      tabIndex: 0,
      className: "click-element"
    }, children) : jsx(element.type, _extends({
      onClick: function onClick() {
        toggleState.setVisible(true);
        closeOtherModals();
      },
      id: buttonOpenModalID
    }, element.props));
  });
  var height = options.height,
    width = options.width,
    _options$overflow = options.overflow,
    overflow = _options$overflow === void 0 ? 'auto' : _options$overflow,
    borderRadius = options.borderRadius;
  var heightWithUnits = height ? height.toString().includes('vh', '%') ? height : "".concat(height, "px") : 'auto';
  var widthUnits = width ? "".concat(width, "px") : 'auto';
  var getModalContainerStyles = function getModalContainerStyles() {
    var modalContainerStyles = {};
    if (!_.isEmpty(modalTranslateStyle)) {
      modalContainerStyles = _objectSpread2({}, modalTranslateStyle);
    }
    if (modalContainerZIndex) {
      modalContainerStyles.zIndex = modalContainerZIndex;
    }
    return modalContainerStyles;
  };
  return jsx(Fragment, null, newChildren, toggleState.visible && jsx("div", {
    style: getModalContainerStyles(),
    className: classNames(styles$r['modal-container'], _defineProperty(_defineProperty({}, styles$r['full-screen'], fullScreen), modalAnimationClass, modalAnimationClass))
  }, jsx(WithOutsideClick, {
    id: 'zone_modal_wrap',
    onOutsideClick: function onOutsideClick(e) {
      if (!config.disableOutsideClick && toggleState.visible) {
        actions.close();
        e.stopPropagation();
      }
    },
    styles: {
      'doc-click-overlay': config.disableOutsideClick ? styles$r['doc-click-overlay'] : ''
    },
    style: zoneModalWrapStyles
  }, jsx("div", {
    style: _objectSpread2({}, options, {
      height: fullScreen ? '100vh' : heightWithUnits,
      width: fullScreen || fullWidth ? '100vw' : widthUnits,
      overflow: overflow
    }),
    className: classNames(styles$r.modal, _defineProperty({}, styles$r.withPadding, withPadding), styles$r["".concat(customClass)]),
    id: customID
  }, modalBusy && jsx("div", {
    className: styles$r['modal-busy-overlay']
  }, jsx(Spinner, null)), showCloseButton && jsx("button", {
    type: "button",
    className: classNames(styles$r['modal-close'], _defineProperty({}, styles$r["".concat(customCloseIconClass)], customCloseIconClass)),
    id: "testId-modal-close",
    onClick: actions.close
  }, jsx("i", {
    className: classNames(styles$r['icon-danger'], fullWidth ? styles$r['icon-big'] : '')
  })), header && jsx("div", {
    style: {
      borderBottom: borderRadius === 0 ? 'none' : null
    },
    className: classNames(styles$r['modal-header'], _defineProperty(_defineProperty({}, styles$r.withPadding, withPadding), styles$r["".concat(customHeaderClass)], customHeaderClass))
  }, jsx("i", {
    className: "csicon-".concat(header.icon)
  }), " ", header.title), !header && customHeader && jsx("div", {
    className: classNames(styles$r['modal-header'], _defineProperty(_defineProperty({}, styles$r.withPadding, withPadding), styles$r["".concat(customHeaderClass)], customHeaderClass))
  }, customHeader), jsx("div", {
    className: classNames(styles$r['modal-body'], _defineProperty(_defineProperty(_defineProperty({}, styles$r['with-header'], header || customHeader), styles$r['full-screen'], fullScreen), styles$r.withPadding, withPadding), styles$r["".concat(customBodyClass)])
  }, content(actions)))), isOverlayEnabled && jsx(BackgroundOverlay$1, null), jsx("style", null, "\n          .no-scroll {\n            overflow: hidden;\n            pointer-events: none;\n          }\n        ")));
};
Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  toggleState: PropTypes.object.isRequired,
  content: PropTypes.func.isRequired,
  options: PropTypes.object,
  header: PropTypes.objectOf({
    icon: PropTypes.string,
    title: PropTypes.string
  }),
  visible: PropTypes.bool,
  withPadding: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  fullScreen: PropTypes.bool,
  appendClickElement: PropTypes.bool,
  deviceType: PropTypes.string,
  showSpinner: PropTypes.bool,
  resetHandler: PropTypes.func,
  closeOtherModals: PropTypes.func,
  fullWidth: PropTypes.bool,
  isOverlayEnabled: PropTypes.bool,
  customClass: PropTypes.string,
  customID: PropTypes.string,
  modalTranslateStyle: PropTypes.object,
  customBodyClass: PropTypes.string,
  modalAnimationClass: PropTypes.string,
  customHeaderClass: PropTypes.string,
  customCloseIconClass: PropTypes.string,
  zoneModalWrapStyles: PropTypes.object,
  buttonOpenModalID: PropTypes.string,
  modalContainerZIndex: PropTypes.number,
  keepNoScroll: PropTypes.bool
} : {};
Modal.defaultProps = {
  children: [],
  options: {},
  header: null,
  visible: false,
  isOverlayEnabled: true,
  withPadding: true,
  showCloseButton: true,
  fullScreen: false,
  appendClickElement: false,
  deviceType: 'desktop',
  showSpinner: false,
  resetHandler: noop,
  closeOtherModals: noop,
  fullWidth: false,
  customClass: '',
  customID: '',
  customBodyClass: '',
  modalTranslateStyle: {},
  modalAnimationClass: '',
  customHeaderClass: '',
  customCloseIconClass: '',
  zoneModalWrapStyles: {},
  buttonOpenModalID: '',
  keepNoScroll: false
};
WithTogggle(Modal);

var styles$s = {"search":"Search-module_search__3pmGP","hasResults":"Search-module_hasResults__1jnH_","storeSearch":"Search-module_storeSearch__1UJBu","search--to_com":"Search-module_search--to_com__u5RJ0","overlay":"Search-module_overlay__3OGZk","header":"Search-module_header__1K8Ze","headerText":"Search-module_headerText__ablmD","modalBody":"Search-module_modalBody__3p6ha","horizontal-menu":"Search-module_horizontal-menu__a8nHq"};

function encodeNttParameter(url, baseUrl) {
  var nttParamIndex = url.indexOf('Ntt=');
  if (nttParamIndex === -1 || !url.split('Ntt=')[1]) return "".concat(baseUrl).concat(url);
  var _url$split = url.split('Ntt='),
    _url$split2 = _slicedToArray(_url$split, 2),
    path = _url$split2[0],
    value = _url$split2[1];
  return "".concat(baseUrl).concat(path, "Ntt=").concat(encodeURIComponent(value));
}
var getURL$1 = function getURL(url, tenant, store) {
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var baseUrl;
  if (isWhitelabelSite) {
    baseUrl = getWhitelabelSiteBaseUrl(tenant, store);
  } else if (isStandaloneSite) {
    baseUrl = getStandaloneSiteBaseUrl(tenant, store);
  } else {
    baseUrl = getStoreBaseUrl(tenant, store);
  }
  return encodeNttParameter(url, baseUrl);
};
var RecentSearchListItem = function RecentSearchListItem(_ref) {
  var text = _ref.text,
    url = _ref.url,
    index = _ref.index,
    tenant = _ref.tenant,
    store = _ref.store,
    rawStore = _ref.rawStore;
  var clickItem = function clickItem() {
    window.dispatchEvent(new CustomEvent('DDM_onSearching', {
      bubbles: true,
      detail: {
        value: text.replace(/(<([^>]+)>)/gi, ''),
        prefix: 'RS'
      }
    }));
    setRecentSearchedValues({
      text: text,
      url: url
    }, rawStore, tenant);
  };
  var anchorProps = {
    tabIndex: '-1',
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(text)
    },
    onClick: clickItem
  };
  return jsx("li", {
    className: styles$p.recentSearchListItem,
    key: "".concat(text, "-").concat(index)
  }, jsx("a", _extends({}, anchorProps, {
    href: getURL$1(url, tenant, store)
  })));
};
RecentSearchListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  tenant: PropTypes.string.isRequired,
  store: PropTypes.string.isRequired,
  rawStore: PropTypes.string
} : {};

var RecentSearchList = function RecentSearchList(_ref) {
  var isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    results = _ref.results,
    tenant = _ref.tenant,
    store = _ref.store,
    handleClearRecentSearchedData = _ref.handleClearRecentSearchedData;
  var counter = 0;
  var renderList = function renderList(list, title) {
    return list.map(function (_ref2) {
      var text = _ref2.text,
        url = _ref2.url;
      counter += 1;
      return jsx(RecentSearchListItem, {
        key: "".concat(text, "-").concat(url),
        text: text,
        url: url,
        index: counter,
        tenant: tenant,
        store: store && title !== 'relatedBrands' ? store : 'falabella',
        rawStore: store
      });
    });
  };
  return results.length && jsx("div", {
    className: classNames(styles$p.searchResults, styles$p.recentSearchResults, styles$p["".concat(isAgentLoggedIn ? 'agent-loggedin' : isVendorLoggedIn && 'vendor-loggedin')])
  }, jsx("section", {
    className: styles$p.recentSearchResults
  }, jsx("div", {
    className: styles$p.recentSearchResults__title__container
  }, jsx("h6", {
    className: styles$p.recentSearchResults__title,
    onClick: function onClick(e) {
      return e.preventDefault();
    }
  }, searchLabels.recentSearches), jsx("a", {
    className: styles$p.recentSearchResults__clear,
    onClick: handleClearRecentSearchedData
  }, searchLabels.clear)), jsx("ul", null, renderList(results, searchLabels.recentSearches))));
};
RecentSearchList.propTypes = process.env.NODE_ENV !== "production" ? {
  isAgentLoggedIn: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  results: PropTypes.array,
  tenant: PropTypes.string.isRequired,
  store: PropTypes.string,
  handleClearRecentSearchedData: PropTypes.func.isRequired
} : {};
RecentSearchList.defaultProps = {
  isAgentLoggedIn: false,
  isVendorLoggedIn: false,
  results: [],
  store: null
};

var storeMap = {
  cl: {
    sodimac: 'sodimac',
    so_com: 'sodimac',
    tottus: 'tottus',
    to_com: 'tottus',
    linio: 'linio',
    fa_america: 'americanino',
    fa_carters: 'carters',
    fa_aldo: 'aldo',
    fa_crabarr: 'crateandbarrel'
  },
  pe: {
    sodimac: 'sodimac',
    so_com: 'sodimac',
    tottus: 'tottus',
    to_com: 'tottus',
    linio: 'linio',
    fa_carters: 'carters',
    fa_aldo: 'aldo',
    fa_crabarr: 'crateandbarrel'
  },
  co: {
    sodimac: 'sodimac',
    so_com: 'sodimac',
    homecenter: 'homecenter',
    linio: 'linio',
    fa_crabarr: 'crateandbarrel'
  }
};

var Search = function Search(_ref) {
  var currentSearchTerm = _ref.currentSearchTerm,
    deviceType = _ref.deviceType,
    getTypeaheadUrl = _ref.getTypeaheadUrl,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isAndes = _ref.isAndes,
    isSisSodimacPdpEnabled = _ref.isSisSodimacPdpEnabled,
    isSearchBarTouched = _ref.isSearchBarTouched,
    setIsSearchBarTouched = _ref.setIsSearchBarTouched,
    isSvsSearch = _ref.isSvsSearch,
    isTypeAheadEnabled = _ref.isTypeAheadEnabled,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    onLoadingStateChange = _ref.onLoadingStateChange,
    onSearch = _ref.onSearch,
    searchbar = _ref.searchbar,
    setHideMenuBar = _ref.setHideMenuBar,
    setSearchInputRef = _ref.setSearchInputRef,
    store = _ref.store,
    searchInSis = _ref.searchInSis,
    isRecentSearchesEnabled = _ref.isRecentSearchesEnabled,
    isSearchSpecialCharactersEnabled = _ref.isSearchSpecialCharactersEnabled;
  var _useContext = useContext(AppContext),
    tenant = _useContext.tenant;
  var _getStandaloneSite = getStandaloneSite(store),
    isTottusStandAloneSite = _getStandaloneSite.isTottusStandAloneSite;
  var initialState = {
    cursor: 0,
    results: {}
  };
  var initialRender = useRef(true);
  var searchContainerRef = useRef();
  var overlayRef = useRef();
  var _useState = useState(isSvsSearch ? '' : currentSearchTerm),
    _useState2 = _slicedToArray(_useState, 2),
    searchQuery = _useState2[0],
    setSearchQuery = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    activeAnchorRef = _useState4[0],
    setActiveAnchorRef = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    searchValidationModal = _useState6[0],
    setSearchValidationModal = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isInvalidSearch = _useState8[0],
    setIsInvalidSearch = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    recentSearchedData = _useState10[0],
    setRecentSearchedData = _useState10[1];
  useEffect(function () {
    if (isRecentSearchesEnabled && isSearchBarTouched && !searchQuery) {
      setRecentSearchedData(getRecentSearchedValues(store, tenant, deviceType));
    }
    if (searchQuery) {
      setRecentSearchedData([]);
    }
    if (!isRecentSearchesEnabled) {
      destroyAllRecentSearchedValues(tenant);
    }
  }, [isSearchBarTouched, searchQuery]);
  var handleClearRecentSearchedData = function handleClearRecentSearchedData() {
    setRecentSearchedData([]);
    clearRecentSearchedValues(store, tenant);
  };
  useEffect(function () {
    setSearchQuery(isSvsSearch ? '' : currentSearchTerm);
  }, [currentSearchTerm]);
  var reducer = useReducer(function (state, action) {
    switch (action.type) {
      case 'RESULTS':
        return _objectSpread2({}, state, {
          cursor: 0,
          results: action.payload
        });
      case 'NEXT':
        return _objectSpread2({}, state, {
          cursor: (state.cursor + 1) % state.results.totalSuggestionsCount
        });
      case 'PREV':
        return _objectSpread2({}, state, {
          cursor: (state.cursor - 1 + state.results.totalSuggestionsCount) % state.results.totalSuggestionsCount
        });
      case 'SET_CURSOR':
        return _objectSpread2({}, state, {
          cursor: action.payload
        });
      default:
        throw new Error();
    }
  }, initialState);
  var _reducer = _slicedToArray(reducer, 2),
    state = _reducer[0],
    dispatch = _reducer[1];
  var lastPromise = useRef(null);
  var handleEnter = function handleEnter() {
    var newSearchTerm = processSearchQuery(searchQuery, isSearchSpecialCharactersEnabled);
    if (newSearchTerm.length === 0) {
      setSearchValidationModal(true);
      return;
    } else if (newSearchTerm.length < minQueryLength) {
      setIsInvalidSearch(true);
      setSearchValidationModal(true);
      return;
    }
    window.dispatchEvent(new CustomEvent('search_executed', {
      bubbles: true,
      detail: {}
    }));
    if (activeAnchorRef && activeAnchorRef.current) {
      activeAnchorRef.current.click();
    } else if (searchQuery) {
      onSearch(newSearchTerm);
      setSearchQuery(newSearchTerm);
      if (lastPromise.current) {
        lastPromise.current.cancel();
      }
      dispatch({
        type: 'RESULTS',
        payload: {}
      });
      setRecentSearchedValues({
        text: "<b>".concat(newSearchTerm, "</b>"),
        url: "/".concat(storeMap[tenant][store] || 'falabella', "-").concat(tenant, "/").concat(SEARCH_PATH[store] || 'search', "?Ntt=").concat(newSearchTerm)
      }, store, tenant);
    }
  };
  var handleOnKeyDown = function handleOnKeyDown(e) {
    switch (e.key) {
      case 'ArrowDown':
        dispatch({
          type: 'NEXT'
        });
        break;
      case 'ArrowUp':
        dispatch({
          type: 'PREV'
        });
        break;
      case 'Enter':
        handleEnter();
        break;
    }
  };
  var handleSearchBarChange = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(val) {
      var validate;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isTypeAheadEnabled) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", true);
          case 2:
            validate = function validate(v) {
              return v.trim && v.trim() && v.trim().length >= minQueryLengthForSuggestion && v.trim().length <= maxQueryLengthForSuggestion;
            };
            if (!(!val || !validate(val))) {
              _context.next = 6;
              break;
            }
            dispatch({
              type: 'RESULTS',
              payload: {}
            });
            return _context.abrupt("return", true);
          case 6:
            if (lastPromise.current) {
              lastPromise.current.cancel();
            }
            lastPromise.current = new CancelablePromise(doFetch(getTypeaheadUrl(val, tenant, isAndes, store)));
            lastPromise.current.start().then(function (data) {
              var results = val && data ? SearchHelper(data, deviceType) : {};
              dispatch({
                type: 'RESULTS',
                payload: results
              });
            }).catch(noop);
            return _context.abrupt("return", true);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSearchBarChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      handleSearchBarChange(searchQuery);
    }
  }, [searchInSis]);
  var handleOuterClick = function handleOuterClick(e) {
    function clearResults() {
      dispatch({
        type: 'RESULTS',
        payload: {}
      });
    }
    var overlayNode = get(overlayRef, 'current');
    var isOverlayClick = overlayNode && overlayNode.contains(e.target);
    var searchContainerNode = get(searchContainerRef, 'current');
    var isSearchContainerClick = searchContainerNode.contains(e.target);
    if (isSearchContainerClick) {
      if (isOverlayClick) {
        clearResults();
        setRecentSearchedData([]);
      }
    } else {
      clearResults();
      setRecentSearchedData([]);
    }
  };
  var onSelect = function onSelect() {
    onLoadingStateChange(true);
    dispatch({
      type: 'RESULTS',
      payload: {}
    });
  };
  useEffect(function () {
    document.addEventListener('mousedown', handleOuterClick);
    return function () {
      document.removeEventListener('mousedown', handleOuterClick);
    };
  }, []);
  var handleMouseOver = function handleMouseOver(cursor) {
    dispatch({
      type: 'SET_CURSOR',
      payload: cursor
    });
  };
  var hasSearchResults =  !!Object.keys(state.results).length;
  useEffect(function () {
    setHideMenuBar(hasSearchResults || !!recentSearchedData.length);
    toggleBodyClass(hasSearchResults || !!recentSearchedData.length, 'no-scroll-typeaheadOn');
  }, [hasSearchResults, recentSearchedData.length]);
  return jsx("div", {
    role: "button",
    tabIndex: "0",
    ref: searchContainerRef,
    className: classNames(styles$s.search, _defineProperty(_defineProperty({}, styles$s['search--to_com'], isTottusStandAloneSite), styles$s.storeSearch, store)),
    onKeyDown: handleOnKeyDown,
    id: "testId-search-wrapper"
  }, (hasSearchResults || recentSearchedData.length > 0) && !searchValidationModal && jsx("div", {
    className: styles$s.overlay,
    ref: overlayRef
  }), jsx(Searchbar, {
    deviceType: deviceType,
    handleEnter: handleEnter,
    isFocused: state.cursor === 0,
    isTypeAheadActive: !searchValidationModal && (hasSearchResults || recentSearchedData.length > 0),
    isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
    labels: searchLabels,
    minQueryLength: minQueryLengthForSuggestion,
    onSearch: onSearch,
    onSearchBarChange: handleSearchBarChange,
    searchbar: searchbar,
    searchQuery: searchQuery,
    setSearchInputRef: setSearchInputRef,
    setSearchQuery: setSearchQuery,
    setIsSearchBarTouched: setIsSearchBarTouched,
    searchInSis: searchInSis,
    store: store
  }), hasSearchResults && !searchValidationModal && jsx(SearchList, {
    cursor: state.cursor,
    isAgentLoggedIn: isAgentLoggedIn,
    isVendorLoggedIn: isVendorLoggedIn,
    onFocus: handleMouseOver,
    onMouseOver: handleMouseOver,
    onSelect: onSelect,
    results: state.results,
    deviceType: deviceType,
    setActiveAnchorRef: setActiveAnchorRef,
    tenant: tenant,
    store: store,
    searchInSis: searchInSis,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery
  }), !hasSearchResults && !searchValidationModal && recentSearchedData.length > 0 && jsx(RecentSearchList, {
    cursor: state.cursor,
    isAgentLoggedIn: isAgentLoggedIn,
    isVendorLoggedIn: isVendorLoggedIn,
    onMouseOver: handleMouseOver,
    results: recentSearchedData,
    tenant: tenant,
    store: store,
    handleClearRecentSearchedData: handleClearRecentSearchedData
  }), searchValidationModal ? jsx(Modal, {
    header: {
      title: jsx("div", {
        className: styles$s.header
      }, jsx("p", {
        className: styles$s.headerText
      }, isInvalidSearch ? searchLabels.incorrectSearch : searchLabels.emptySearch))
    },
    toggleState: {
      visible: searchValidationModal,
      setVisible: function setVisible(value) {
        setSearchValidationModal(value);
        setIsInvalidSearch(false);
      }
    },
    options: {
      borderRadius: 0
    },
    fullScreen: false,
    withPadding: false,
    deviceType: deviceType,
    content: function content() {
      return jsx("p", {
        className: styles$s.modalBody
      }, isInvalidSearch ? searchLabels.incorrectSearchBody : searchLabels.emptySearchBody);
    }
  }) : null, jsx("style", null, "\n          .no-scroll-typeaheadOn {\n            overflow: hidden;\n          }\n        "));
};
Search.propTypes = process.env.NODE_ENV !== "production" ? {
  currentSearchTerm: PropTypes.string,
  deviceType: PropTypes.string.isRequired,
  getTypeaheadUrl: PropTypes.func.isRequired,
  isAgentLoggedIn: PropTypes.bool,
  isAndes: PropTypes.bool,
  isSisSodimacPdpEnabled: PropTypes.bool,
  isSvsSearch: PropTypes.bool,
  isTypeAheadEnabled: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  onLoadingStateChange: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
  searchbar: PropTypes.object.isRequired,
  setHideMenuBar: PropTypes.func,
  setSearchInputRef: PropTypes.func.isRequired,
  store: PropTypes.string,
  searchInSis: PropTypes.bool,
  setIsSearchBarTouched: PropTypes.func,
  isSearchBarTouched: PropTypes.bool,
  isSISExperience: PropTypes.bool,
  isRecentSearchesEnabled: PropTypes.bool.isRequired,
  isSearchSpecialCharactersEnabled: PropTypes.bool
} : {};
Search.defaultProps = {
  currentSearchTerm: '',
  isAgentLoggedIn: false,
  isSisSodimacPdpEnabled: false,
  isSvsSearch: false,
  isTypeAheadEnabled: true,
  isVendorLoggedIn: false,
  onLoadingStateChange: noop,
  setHideMenuBar: noop,
  store: null,
  searchInSis: false,
  isSearchBarTouched: false,
  setIsSearchBarTouched: noop,
  isSISExperience: false,
  isSearchSpecialCharactersEnabled: false
};
Search.defaultProps = {};

var labels$2 = {
  WELCOME_LABEL: 'Bienvenid@,',
  LOGIN_LABEL: 'Inicia Sesión',
  A11Y_USER_LABEL: 'user info',
  MY_ACCOUNT_LABEL: 'Mi Cuenta',
  NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
  BAG: 'Bolsa',
  ORDER_BY_DESKTOP: 'Ordenar por',
  HELP: 'ayuda',
  HAVE_LABEL: 'Tienes'
};
var endpoints = {
  getATGLoginUrl: function getATGLoginUrl(baseUrl) {
    return "".concat(baseUrl, "/myaccount/includes/loginForm.jsp");
  }
};
var UserActionConfig = {
  labels: labels$2,
  endpoints: endpoints
};

var styles$t = {"options":"UserInfoPopup-module_options__3nRxg","options__item":"UserInfoPopup-module_options__item__36EQt","options__item--text":"UserInfoPopup-module_options__item--text__24pg8","register-container":"UserInfoPopup-module_register-container__39G7-","register--register":"UserInfoPopup-module_register--register__3WWvk","icon":"UserInfoPopup-module_icon__1Bkq3","display1":"UserInfoPopup-module_display1__267H3","link":"UserInfoPopup-module_link__1_QIl","register--no-account":"UserInfoPopup-module_register--no-account__3dhXm","last-item-style":"UserInfoPopup-module_last-item-style__tljDv","options-icon":"UserInfoPopup-module_options-icon__2YoYX","userinfo-list":"UserInfoPopup-module_userinfo-list__3Wbmd","cmr-title":"UserInfoPopup-module_cmr-title__3Hn80"};

var UserInfoPopup = function UserInfoPopup(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
    myAccountDesktop = _ref.myAccountDesktop,
    logoutHandler = _ref.logoutHandler,
    toggleLoginForm = _ref.toggleLoginForm,
    isCmrPointsEnabled = _ref.isCmrPointsEnabled,
    myAccountLabel = _ref.myAccountLabel,
    tenant = _ref.tenant,
    cmrPoints = _ref.cmrPoints,
    topPosition = _ref.topPosition;
  var loginOption = [];
  if (!isLoggedIn) {
    var items = get(myAccountDesktop, 'items_logged_out.items', []);
    items.forEach(function (item, i) {
      var _item$login = item.login,
        login = _item$login === void 0 ? false : _item$login;
      loginOption.push(_objectSpread2({}, item, {
        id: "testId-loggedout-item-".concat(i),
        handler: login ? toggleLoginForm : noop
      }));
    });
  } else {
    var _items = get(myAccountDesktop, 'items_logged_in.items.redirection_items', []);
    var actionItems = get(myAccountDesktop, 'items_logged_in.items.action_items', {});
    _items.forEach(function (item, i) {
      loginOption.push(_objectSpread2({}, item, {
        id: "testId-loggedin-item-".concat(i),
        handler: noop
      }));
    });
    Object.keys(actionItems).forEach(function (key, i) {
      if (key === 'cerrar_sesion') {
        loginOption.push(_objectSpread2({}, actionItems[key], {
          id: "testId-loggedin-action-item-".concat(i),
          handler: logoutHandler,
          type: 'actionLogOut'
        }));
      } else {
        loginOption.push(_objectSpread2({}, actionItems[key], {
          id: "testId-loggedin-action-item-".concat(i)
        }));
      }
    });
  }
  var initializeUrl = function initializeUrl(atgUrl, catalystUrl) {
    return CookieStorage.isCatalyst() ? catalystUrl : atgUrl;
  };
  var last_item_style_logged = get(myAccountDesktop, 'items_logged_in.last_item_style', false);
  var last_item_style_not_logged = get(myAccountDesktop, 'items_logged_out.last_item_style', false);
  var loggedlistClass = "".concat(styles$t['userinfo-list']);
  var unloggedlistClass = "".concat(styles$t['userinfo-list']);
  if (last_item_style_logged) {
    loggedlistClass = "".concat(styles$t['userinfo-list'], " ").concat(styles$t['last-item-style']);
  }
  if (last_item_style_not_logged) {
    unloggedlistClass = "".concat(styles$t['userinfo-list'], " ").concat(styles$t['last-item-style']);
  }
  var isMyAccount = function isMyAccount() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return title && title.toLowerCase() === myAccountLabel.toLowerCase();
  };
  var getLoggedInUserPopUp = function getLoggedInUserPopUp() {
    return jsx(React.Fragment, null, jsx("ul", {
      className: loggedlistClass
    }, loginOption.map(function (_ref2) {
      var title = _ref2.title,
        catalyst_url = _ref2.catalyst_url,
        atg_url = _ref2.atg_url,
        _ref2$is_new_tab = _ref2.is_new_tab,
        is_new_tab = _ref2$is_new_tab === void 0 ? false : _ref2$is_new_tab,
        _ref2$is_cmr = _ref2.is_cmr,
        is_cmr = _ref2$is_cmr === void 0 ? false : _ref2$is_cmr,
        _ref2$handler = _ref2.handler,
        handler = _ref2$handler === void 0 ? noop : _ref2$handler,
        type = _ref2.type,
        id = _ref2.id;
      var href = initializeUrl(catalyst_url, atg_url);
      if (is_cmr) {
        return jsx("li", {
          key: id,
          id: id,
          className: classNames(styles$t.display1, styles$t['options__item--text'])
        }, jsx("ul", null, jsx(CmrPuntosCategoryItem, {
          cmrPuntosURL: href,
          cmrText: jsx("p", {
            className: styles$t['cmr-title']
          }, title),
          isCmrPointsEnabled: isCmrPointsEnabled,
          isLoggedIn: isLoggedIn,
          isNewTab: is_new_tab,
          isRebrandingEnabled: true,
          tenantId: "falabella-".concat(tenant),
          cmrPoints: cmrPoints
        })));
      }
      return jsx("li", {
        key: title,
        className: styles$t.options__item
      }, type === 'actionLogOut' ? jsx("a", {
        id: id,
        className: classNames(styles$t.display1, styles$t['options__item--text']),
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          handler();
          updateDigitalDataCookies({
            firstLevelItem: "N1 - ".concat(title),
            tag: HEADER
          });
        }
      }, title) : jsx("a", {
        className: classNames(styles$t.display1, styles$t['options__item--text']),
        style: isMyAccount(title) ? {
          fontWeight: 'bold'
        } : {},
        id: id,
        target: is_new_tab ? '_blank' : '',
        href: href,
        rel: "noreferrer",
        onClick: function onClick() {
          return updateDigitalDataCookies({
            firstLevelItem: "N1 - ".concat(title),
            tag: HEADER
          });
        }
      }, title));
    })));
  };
  var getGuestUserPopup = function getGuestUserPopup() {
    return jsx(React.Fragment, null, jsx("ul", {
      className: unloggedlistClass
    }, loginOption.map(function (_ref3) {
      var title = _ref3.title,
        url = _ref3.url,
        _ref3$is_new_tab = _ref3.is_new_tab,
        is_new_tab = _ref3$is_new_tab === void 0 ? false : _ref3$is_new_tab,
        id = _ref3.id,
        login = _ref3.login,
        handler = _ref3.handler,
        icon = _ref3.icon;
      return jsx("li", {
        key: title,
        className: styles$t.options__item
      }, get(icon, 'url', false) && jsx("i", {
        className: styles$t['options-icon'],
        style: {
          backgroundImage: "url(".concat(icon.url, ")")
        }
      }), login ? jsx("a", {
        id: id,
        className: classNames(styles$t.display1, styles$t['options__item--text']),
        onClick: function onClick(e) {
          e.preventDefault();
          handler();
          updateDigitalDataCookies({
            firstLevelItem: "N1 - ".concat(title),
            tag: HEADER
          });
        }
      }, title) : jsx("a", {
        id: id,
        className: classNames(styles$t.display1, styles$t['options__item--text']),
        target: is_new_tab ? '_blank' : '',
        href: url,
        rel: "noreferrer",
        onClick: function onClick() {
          return updateDigitalDataCookies({
            firstLevelItem: "N1 - ".concat(title),
            tag: HEADER
          });
        }
      }, title));
    })));
  };
  return jsx("div", {
    id: isLoggedIn ? 'logged-in-options' : '',
    className: styles$t.options,
    "data-top-position": "".concat(topPosition, "px")
  }, isLoggedIn ? getLoggedInUserPopUp() : getGuestUserPopup());
};
UserInfoPopup.defaultProps = {
  cmrData: {},
  isCmrPointsEnabled: false,
  myAccountLabel: '',
  tenant: ''
};
UserInfoPopup.propTypes = process.env.NODE_ENV !== "production" ? {
  isLoggedIn: PropTypes.bool.isRequired,
  isCmrPointsEnabled: PropTypes.bool,
  noAccountLabel: PropTypes.string.isRequired,
  myAccountLabel: PropTypes.string.isRequired,
  myAccountDesktop: PropTypes.object.isRequired,
  cmrData: PropTypes.object,
  toggleLoginForm: PropTypes.func,
  logoutHandler: PropTypes.func.isRequired,
  tenant: PropTypes.string,
  cmrPoints: PropTypes.object,
  topPosition: PropTypes.number
} : {};

var styles$u = {"info":"UserInfo-module_info__2X_v-","account-content":"UserInfo-module_account-content__3NgXy","info__icon":"UserInfo-module_info__icon__2Khh1","info__name":"UserInfo-module_info__name__2L1i6","info__name--to_com":"UserInfo-module_info__name--to_com__35tMD","onboarding-login-text":"UserInfo-module_onboarding-login-text__gDaFT","label-secondary":"UserInfo-module_label-secondary__-tNsn","my-account-label":"UserInfo-module_my-account-label__1NQmc","my-account-label--to_com":"UserInfo-module_my-account-label--to_com__2qy26","my-account-label--whitelabel":"UserInfo-module_my-account-label--whitelabel__1E79c","label-primary":"UserInfo-module_label-primary__mmxd2","flex":"UserInfo-module_flex__o3jFP","flexBox":"UserInfo-module_flexBox__Vzu5n","flexBoxWithHeight":"UserInfo-module_flexBoxWithHeight__2jSYD","icon-cmr-icon":"UserInfo-module_icon-cmr-icon__2iD6s","grayCMR":"UserInfo-module_grayCMR__1SVDs","popover-wrapper":"UserInfo-module_popover-wrapper__3t5YR","downArrowicon":"UserInfo-module_downArrowicon__3jNOC","downArrowicon--to_com":"UserInfo-module_downArrowicon--to_com__292Au","downArrowicon1":"UserInfo-module_downArrowicon1__TycCb","grayDownArrow":"UserInfo-module_grayDownArrow__3vzF9","loggedin-modal":"UserInfo-module_loggedin-modal__RbQOQ","label-secondary-cmr":"UserInfo-module_label-secondary-cmr__1y6q0","cmrWrapper":"UserInfo-module_cmrWrapper__1z8IT","cmrFirstName":"UserInfo-module_cmrFirstName__2qzWq","haveLabel":"UserInfo-module_haveLabel__flyLJ","icon":"UserInfo-module_icon__27_bD","display1":"UserInfo-module_display1__1TD_E","display1--to_com":"UserInfo-module_display1--to_com__2ZXJz","display1--whitelabel":"UserInfo-module_display1--whitelabel__2ofZo","display2":"UserInfo-module_display2__2-oS8","sr-only":"UserInfo-module_sr-only__20bXd","icon-arrow_down_small":"UserInfo-module_icon-arrow_down_small__21wlI","icon-user1":"UserInfo-module_icon-user1__2zdWi","portal":"UserInfo-module_portal__MjKfg","backdrop":"UserInfo-module_backdrop__2Yy8v"};

var Portal = function Portal(_ref) {
  var id = _ref.id,
    children = _ref.children,
    classes = _ref.classes,
    top = _ref.top;
  var ref = useRef(null);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    dynamic = _useState2[0],
    setDynamic = _useState2[1];
  useEffect(function () {
    if (global.document) {
      if (!ref.current) {
        ref.current = document.getElementById(id) || document.createElement('div');
        setDynamic(ref);
      } else {
        ref.current.id = id;
        ref.current.classList.add(classes);
        ref.current.style.top = top;
        document.body.appendChild(ref.current);
      }
    }
    return function () {
      if (ref && ref.current.parentElement) {
        ref.current.parentElement.removeChild(ref.current);
      }
    };
  }, [dynamic]);
  return ref.current && createPortal(children, ref.current);
};

var UserInfo = function UserInfo(_ref) {
  var isLoggedIn = _ref.isLoggedIn,
    userFirstName = _ref.userFirstName,
    myAccountLabel = _ref.myAccountLabel,
    noAccountLabel = _ref.noAccountLabel,
    myAccountDesktop = _ref.myAccountDesktop,
    logoutHandler = _ref.logoutHandler,
    isATGLoginEnabled = _ref.isATGLoginEnabled,
    isOnboardingInProgress = _ref.isOnboardingInProgress,
    anchorStyle = _ref.anchorStyle,
    toggleLoginForm = _ref.toggleLoginForm,
    entry = _ref.entry,
    tenant = _ref.tenant,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isOrangeOrSISHeader = _ref.isOrangeOrSISHeader,
    store = _ref.store;
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var _useContext = useContext(AppContext),
    baseUrl = _useContext.baseUrl;
  var endpoints = UserActionConfig.endpoints;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDropdownVisible = _useState2[0],
    setIsDropdownVisible = _useState2[1];
  var isCmrPointsEnabled = get(entry, 'header_configs[0].toggles.iscmrenabled', false);
  var cmrPoints = useCmrPoints("falabella-".concat(tenant), true, isLoggedIn);
  var updatedBalancePoints = get(cmrPoints, 'balancePoints', -1);
  var isCMRUnavailable = !(updatedBalancePoints && updatedBalancePoints > 0) || !isCmrPointsEnabled;
  var showDropdownMenu = function showDropdownMenu() {
    return setIsDropdownVisible(true);
  };
  var hideDropdownMenu = function hideDropdownMenu() {
    return setIsDropdownVisible(false);
  };
  var getLoggedInUserComponent = function getLoggedInUserComponent() {
    if (updatedBalancePoints < 0) {
      return null;
    } else if (isCmrPointsEnabled) {
      return jsx("div", {
        className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles$u.flexBoxWithHeight, !isCMRUnavailable), styles$u.flexBox, isCMRUnavailable), styles$u.cmrWrapper, true))
      }, jsx("span", {
        className: classNames(styles$u['label-secondary-cmr'])
      }, formatPoints(updatedBalancePoints, tenant)), jsx("div", {
        className: classNames(styles$u['icon-cmr-icon'], _defineProperty({}, styles$u.grayCMR, !isOrangeOrSISHeader || isStandaloneSite))
      }));
    }
    return null;
  };
  var welcomeLabelComponent = function welcomeLabelComponent() {
    return jsx("div", {
      className: classNames(_defineProperty(_defineProperty({}, styles$u.flexBoxWithHeight, isLoggedIn && !isCMRUnavailable), styles$u.flexBox, !isLoggedIn || isCMRUnavailable))
    }, jsx("p", {
      className: classNames(styles$u.display1, _defineProperty(_defineProperty({}, styles$u['display1--to_com'], isTottusStandalone), styles$u['display1--whitelabel'], isWhitelabelSite))
    }, myAccountDesktop.hello_text, ", ", userFirstName), jsx("div", {
      className: classNames(styles$u.downArrowicon1, _defineProperty({}, styles$u.grayDownArrow, !isOrangeOrSISHeader))
    }));
  };
  var getGuestUserComponent = function getGuestUserComponent() {
    return jsx("div", {
      className: styles$u.flex
    }, jsx("p", {
      className: classNames(styles$u['my-account-label'], _defineProperty(_defineProperty({}, styles$u['my-account-label--to_com'], isTottusStandalone), styles$u['my-account-label--whitelabel'], isWhitelabelSite))
    }, "Inicia sesi\xF3n"), jsx("div", {
      className: classNames(styles$u.downArrowicon, _defineProperty(_defineProperty({}, styles$u.grayDownArrow, !isOrangeOrSISHeader), styles$u['downArrowicon--to_com'], isTottusStandalone))
    }));
  };
  var getContentContainer = function getContentContainer(children) {
    return isATGLoginEnabled ? jsx("a", {
      href: endpoints.getATGLoginUrl(baseUrl),
      style: {
        textDecoration: 'none'
      },
      className: anchorStyle
    }, children) : children;
  };
  var content = function content() {
    var children = jsx("div", {
      id: "user-info",
      className: styles$u.info
    }, jsx("div", {
      className: classNames(styles$u.info__name, _defineProperty(_defineProperty({}, styles$u['onboarding-login-text'], isOnboardingInProgress), styles$u['info__name--to_com'], isTottusStandalone))
    }, jsx("div", {
      className: classNames(_defineProperty({}, styles$u['account-content'], isLoggedIn && !isCMRUnavailable))
    }, isLoggedIn ? welcomeLabelComponent() : jsx("p", {
      className: classNames(styles$u.display1, styles$u['label-primary'], _defineProperty({}, styles$u['display1--to_com'], isTottusStandalone), _defineProperty({}, styles$u['display1--whitelabel'], isWhitelabelSite))
    }, myAccountDesktop.hello_text, ",")), isLoggedIn ? getLoggedInUserComponent() : getGuestUserComponent()));
    return getContentContainer(children);
  };
  var headerHeight = getHeaderHeight({
    isVendorLoggedIn: isVendorLoggedIn,
    isAgentLoggedIn: isAgentLoggedIn
  });
  return jsx("div", {
    id: "testId-UserAction-userinfo",
    className: classNames(_defineProperty({}, styles$u['account-content'], isLoggedIn && isCMRUnavailable)),
    onMouseEnter: showDropdownMenu,
    onMouseLeave: hideDropdownMenu
  }, content(), isDropdownVisible && jsx(Portal, {
    id: "mkp-popover-portal",
    classes: styles$u.portal,
    top: "".concat(headerHeight.totalVisibleHeight + window.scrollY, "px")
  }, jsx("span", {
    className: styles$u.backdrop,
    onMouseEnter: hideDropdownMenu
  })), isDropdownVisible && jsx(UserInfoPopup, {
    myAccountDesktop: myAccountDesktop,
    logoutHandler: logoutHandler,
    isLoggedIn: isLoggedIn,
    noAccountLabel: noAccountLabel,
    toggleLoginForm: !isLoggedIn && !isATGLoginEnabled ? toggleLoginForm : noop,
    isCmrPointsEnabled: isCmrPointsEnabled,
    myAccountLabel: myAccountLabel,
    tenant: tenant,
    cmrPoints: cmrPoints,
    topPosition: headerHeight.sisHeaderHeight + headerHeight.searchHeaderHeight
  }));
};
UserInfo.propTypes = process.env.NODE_ENV !== "production" ? {
  a11yUserLabel: PropTypes.string.isRequired,
  anchorStyle: PropTypes.string,
  deviceType: PropTypes.string,
  entry: PropTypes.object,
  isAgentLoggedIn: PropTypes.bool,
  isATGLoginEnabled: PropTypes.bool,
  isLoggedIn: PropTypes.bool.isRequired,
  isOnboardingInProgress: PropTypes.bool.isRequired,
  isVendorLoggedIn: PropTypes.bool,
  loginLabel: PropTypes.string.isRequired,
  logoutHandler: PropTypes.func.isRequired,
  myAccountDesktop: PropTypes.object.isRequired,
  myAccountLabel: PropTypes.string.isRequired,
  noAccountLabel: PropTypes.string.isRequired,
  onLoadingStateChange: PropTypes.func,
  setMenuVisible: PropTypes.func,
  tenant: PropTypes.string,
  toggleLoginForm: PropTypes.func.isRequired,
  userFirstName: PropTypes.string.isRequired,
  welcomeLabel: PropTypes.string.isRequired,
  isOrangeOrSISHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  store: PropTypes.string
} : {};
UserInfo.defaultProps = {
  isAgentLoggedIn: false,
  isVendorLoggedIn: false,
  tenant: ''
};

var styles$v = {"utils":"UserActions-module_utils__3VcVK","utils-ul":"UserActions-module_utils-ul__Feiqp","utils-list-mobile":"UserActions-module_utils-list-mobile__31rW6","utils-list-mobile--so_com":"UserActions-module_utils-list-mobile--so_com__3WWqR","utils-list-mobile--to_com":"UserActions-module_utils-list-mobile--to_com__3kaIb","utils-list":"UserActions-module_utils-list__fSm9Q","content-wrapper":"UserActions-module_content-wrapper__3Z4ot","go-to-basket":"UserActions-module_go-to-basket__2ZvQr","content-wrapper--to_com":"UserActions-module_content-wrapper--to_com__2GVUc","orders-content-wrapper":"UserActions-module_orders-content-wrapper__2_Dpz","orders-content-wrapper--to_com":"UserActions-module_orders-content-wrapper--to_com__1D82w","basket-icon":"UserActions-module_basket-icon__3wDtw","wishlist-icon--to_com":"UserActions-module_wishlist-icon--to_com__3gB4J","wishlist-icon":"UserActions-module_wishlist-icon__yW8-l","utils-list--to_com":"UserActions-module_utils-list--to_com__1DNQM","utils-search":"UserActions-module_utils-search__108xE","user-info":"UserActions-module_user-info__Bjp0o","onboarding-highlight":"UserActions-module_onboarding-highlight__2sdvH","loginTextFade":"UserActions-module_loginTextFade__3nsZH","utils-span":"UserActions-module_utils-span__39zW-","utils-span--to_com":"UserActions-module_utils-span--to_com__1YG_x","utils-span--whitelabel":"UserActions-module_utils-span--whitelabel__UHt76","utils-span-lower":"UserActions-module_utils-span-lower__1lYdm","utils-span-lower--to_com":"UserActions-module_utils-span-lower--to_com__1ivIW","utils-span-lower--whitelabel":"UserActions-module_utils-span-lower--whitelabel__2gSpj","utils-anchor":"UserActions-module_utils-anchor__2BBUL","searchIcon":"UserActions-module_searchIcon__2sjTj","closeIcon":"UserActions-module_closeIcon__2JcNh","active":"UserActions-module_active__3uf62","utilIcon":"UserActions-module_utilIcon__3hRCU","utilIcon--to_com":"UserActions-module_utilIcon--to_com__2wg8T","utilIcon--whitelabel":"UserActions-module_utilIcon--whitelabel__3wyrc","login-list":"UserActions-module_login-list__3MIAb","store_inicia":"UserActions-module_store_inicia__poBUe","login-list--so_com":"UserActions-module_login-list--so_com__3-r5q","login-list--to_com":"UserActions-module_login-list--to_com__1fFOF","login_list_store":"UserActions-module_login_list_store__20Bkq","utilMobileIcon":"UserActions-module_utilMobileIcon__1J3FZ","icon":"UserActions-module_icon__1lkUA","account":"UserActions-module_account__11d5y","orders":"UserActions-module_orders__H9i7Y","orders-title":"UserActions-module_orders-title__3XjLB","has-count":"UserActions-module_has-count__2EIrE","store-stroke":"UserActions-module_store-stroke__3CWLf","has-count--so_com":"UserActions-module_has-count--so_com__3B8J9","cart-container":"UserActions-module_cart-container__1wpyz","cart-icon":"UserActions-module_cart-icon__2Uhht","cart-count-container":"UserActions-module_cart-count-container__3f1Gc","cart-count-value":"UserActions-module_cart-count-value__n5cmO","cart-count-value--to_com":"UserActions-module_cart-count-value--to_com__2ExLN","cart-count-container--to_com":"UserActions-module_cart-count-container--to_com__24Xt-","has-count-desktop":"UserActions-module_has-count-desktop__202jS","title":"UserActions-module_title__163yx","link":"UserActions-module_link__2xG9T","icon-bag":"UserActions-module_icon-bag__2mzCg","icon-user1":"UserActions-module_icon-user1__1jP-X","icon-help":"UserActions-module_icon-help__1bWwW","icon-delivery":"UserActions-module_icon-delivery__3F-lI","icon-user1-mobile":"UserActions-module_icon-user1-mobile__1Cnz4","icon-bag-mobile":"UserActions-module_icon-bag-mobile__2i8zR","tracking-links-wrapper":"UserActions-module_tracking-links-wrapper__3bDR3","tracking":"UserActions-module_tracking__2Weph","tracking-item":"UserActions-module_tracking-item__3qyOY","tracking-icon":"UserActions-module_tracking-icon__3HJqf","tracking-item-text":"UserActions-module_tracking-item-text__2f-j6","tracking-btn":"UserActions-module_tracking-btn__1FzWu"};

var WHITELABEL_CONFIG = {
  logo: {
    brandLogo: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blte519222fb2afb54e/679c7958e729222d0f536c25/carterslogo.svg',
    url: 'https://staging-carters.falabella.com'
  },
  header: {
    iconBackgroundColor: '#111',
    borderRadius: '80px',
    textColor: '#111',
    backgroundColor: '#fff'
  },
  menu: {
    menu_type: 'Button Menu',
    desktop: {
      icon: {
        url: 'https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt90792027e39db4dc/679c849c31e91973afa599ae/menuhamburger.svg'
      },
      text: 'Menú',
      background_color: ''
    },
    mobile: {
      icon: {
        url: 'https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt90792027e39db4dc/679c849c31e91973afa599ae/menuhamburger.svg'
      },
      text: 'Menú',
      background_color: ''
    },
    text_color: '#333',
    close_icon: {
      url: 'https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/bltdeb40ae1b6cb0114/67adecb3d4104e90845da3e6/Group_1.svg'
    }
  },
  searchbar: {
    desktop_placeholder: '¿Qué buscas?',
    mobile_placeholder: '¿Qué buscas?',
    icon: {
      close_icon: {},
      search_icon: {
        url: 'https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt9fbaac40a4afddc1/679867a717131c0e22b207c8/Shape.svg'
      },
      search_icon_background_color: '#333333'
    },
    search_placeholder_text_color: '#333333'
  }
};

var extractHeaderConfig = function extractHeaderConfig(header, deviceType) {
  var _crossBannerConfigs$b, _crossBannerConfigs$b2, _searchConfigs$icon, _searchConfigs$icon2;
  var isOnboardingEnabled = get(header, 'entry.header_configs[0].toggles.isonboardingenabled', false);
  var isProgramaticallyGeofinderEnabled = get(header, 'entry.header_configs[0].toggles.isprogramaticallygeofinderenabled', false);
  var geofinderConfigs = get(header, 'entry.header_configs[0].property_configs.geofinder', {});
  var isRecentSearchesEnabled = get(header, 'entry.header_configs[0].toggles.isrecentsearchesenabled', false);
  var isMyAccountEnabled = get(header, 'entry.header_configs[0].toggles.ismyaccountenabled', false);
  var isMyOrdersEnabled = get(header, 'entry.header_configs[0].toggles.ismyordersenabled', false);
  var isWishListEnabled = get(header, 'entry.header_configs[0].toggles.iswishlistenabled', false);
  var crossBannerConfigs = get(header, 'entry.cross_banner', {});
  var crossBanner = {
    url: (crossBannerConfigs === null || crossBannerConfigs === void 0 ? void 0 : crossBannerConfigs.url) || '',
    openInNewTab: (crossBannerConfigs === null || crossBannerConfigs === void 0 ? void 0 : crossBannerConfigs.is_new_tab) || false,
    desktopImageUrl: (crossBannerConfigs === null || crossBannerConfigs === void 0 ? void 0 : (_crossBannerConfigs$b = crossBannerConfigs.banner_desktop_image) === null || _crossBannerConfigs$b === void 0 ? void 0 : _crossBannerConfigs$b.url) || '',
    mobileImageUrl: (crossBannerConfigs === null || crossBannerConfigs === void 0 ? void 0 : (_crossBannerConfigs$b2 = crossBannerConfigs.banner_mobile_image) === null || _crossBannerConfigs$b2 === void 0 ? void 0 : _crossBannerConfigs$b2.url) || '',
    position: (crossBannerConfigs === null || crossBannerConfigs === void 0 ? void 0 : crossBannerConfigs.banner_position) || 'top',
    isVisible: (crossBannerConfigs === null || crossBannerConfigs === void 0 ? void 0 : crossBannerConfigs.banner_visible) || false
  };
  var searchConfigs = get(header, 'entry.searchbar', {});
  var searchbar = {
    desktop_placeholder: searchConfigs.desktop_placeholder || WHITELABEL_CONFIG.searchbar.desktop_placeholder,
    mobile_placeholder: searchConfigs.mobile_placeholder || WHITELABEL_CONFIG.searchbar.mobile_placeholder,
    search_placeholder_text_color: searchConfigs.search_placeholder_text_color || WHITELABEL_CONFIG.searchbar.search_placeholder_text_color,
    search_icon: ((_searchConfigs$icon = searchConfigs.icon) === null || _searchConfigs$icon === void 0 ? void 0 : _searchConfigs$icon.search_icon) || WHITELABEL_CONFIG.searchbar.icon.search_icon,
    search_icon_background_color: ((_searchConfigs$icon2 = searchConfigs.icon) === null || _searchConfigs$icon2 === void 0 ? void 0 : _searchConfigs$icon2.search_icon_background_color) || WHITELABEL_CONFIG.searchbar.icon.search_icon_background_color,
    searchBarBorderRadius: searchConfigs.border_radius || '80px',
    searchBarBorderColor: searchConfigs.border_color || WHITELABEL_CONFIG.searchbar.icon.search_icon_background_color
  };
  var mainLogoIcon = get(header, "entry.brand_logo.".concat(deviceType, "_icon.url"), WHITELABEL_CONFIG.logo.brandLogo);
  var logoURL = get(header, 'entry.brand_logo.url', WHITELABEL_CONFIG.logo.url);
  var menuConfig = get(header, 'entry.menu', WHITELABEL_CONFIG.menu);
  var menuTextColor = get(header, 'entry.menu.text_color', WHITELABEL_CONFIG.header.textColor);
  var myOrdersTextColor = get(header, "entry.myorders_".concat(deviceType, ".text_color"), WHITELABEL_CONFIG.header.textColor);
  var myAccountTextColor = get(header, "entry.myaccount_".concat(deviceType, ".text_color"), WHITELABEL_CONFIG.header.textColor);
  var topHeaderTextColor = get(header, 'entry.header_themes.top_text_color', WHITELABEL_CONFIG.header.textColor);
  var topHeaderBackgroundColor = get(header, 'entry.header_themes.top_background_color', WHITELABEL_CONFIG.header.backgroundColor);
  var bottomHeaderBackgroundColor = get(header, 'entry.header_themes.bottom_background_color', WHITELABEL_CONFIG.header.backgroundColor);
  var fontLink = get(header, 'entry.header_themes.font.font_link', '');
  var fontFamily = get(header, 'entry.header_themes.font.font_family', '');
  return {
    isOnboardingEnabled: isOnboardingEnabled,
    isProgramaticallyGeofinderEnabled: isProgramaticallyGeofinderEnabled,
    geofinderConfigs: geofinderConfigs,
    isRecentSearchesEnabled: isRecentSearchesEnabled,
    isWishListEnabled: isWishListEnabled,
    isMyAccountEnabled: isMyAccountEnabled,
    isMyOrdersEnabled: isMyOrdersEnabled,
    crossBanner: crossBanner,
    searchbar: searchbar,
    mainLogoIcon: mainLogoIcon,
    logoURL: logoURL,
    menuConfig: menuConfig,
    menuTextColor: menuTextColor,
    myOrdersTextColor: myOrdersTextColor,
    myAccountTextColor: myAccountTextColor,
    topHeaderTextColor: topHeaderTextColor,
    topHeaderBackgroundColor: topHeaderBackgroundColor,
    bottomHeaderBackgroundColor: bottomHeaderBackgroundColor,
    fontLink: fontLink,
    fontFamily: fontFamily
  };
};
var onSearchTermChange = function onSearchTermChange(_ref) {
  var searchTerm = _ref.searchTerm,
    setErrorMessage = _ref.setErrorMessage,
    store = _ref.store,
    tenant = _ref.tenant;
  var lables = configs.lables,
    constants = configs.constants;
  if (searchTerm.length === 0) {
    setErrorMessage({
      title: lables.emptySearchErrorTitle,
      msg: lables.emptySearchErrorMessage
    });
    return false;
  }
  if (searchTerm.length < constants.MIN_SEARCH_TERM_LENGTH) {
    setErrorMessage({
      title: lables.incorrectSearchErrorTitle,
      msg: lables.incorrectSearchErrorMessage
    });
    return false;
  }
  var termo = encodeURIComponent(searchTerm).replace(/%20/g, '+');
  window.dispatchEvent(new CustomEvent('DDM_onSearching', {
    bubbles: true,
    detail: {
      value: termo,
      prefix: 'BCR'
    }
  }));
  var envBaseUrl = getWhitelabelSiteBaseUrl(tenant, store);
  var storeName = STORE_MAP[tenant][store];
  var searchPath = SEARCH_PATH[store];
  window.location.href = "".concat(envBaseUrl, "/").concat(storeName, "-").concat(tenant, "/").concat(searchPath, "?Ntt=").concat(termo);
  setErrorMessage(undefined);
  return true;
};

var UserActionDesktop = function UserActionDesktop(_ref2) {
  var isLoggedIn = _ref2.isLoggedIn,
    userFirstName = _ref2.userFirstName,
    welcomeLabel = _ref2.welcomeLabel,
    loginLabel = _ref2.loginLabel,
    a11yUserLabel = _ref2.a11yUserLabel,
    myAccountLabel = _ref2.myAccountLabel,
    noAccountLabel = _ref2.noAccountLabel,
    utilBarButtons = _ref2.utilBarButtons,
    logoutHandler = _ref2.logoutHandler,
    onLoadingStateChange = _ref2.onLoadingStateChange,
    isOnboardingInProgress = _ref2.isOnboardingInProgress,
    deviceType = _ref2.deviceType,
    listStyle = _ref2.listStyle,
    anchorStyle = _ref2.anchorStyle,
    toggleLoginForm = _ref2.toggleLoginForm,
    headerData = _ref2.headerData,
    tenant = _ref2.tenant,
    setMenuVisible = _ref2.setMenuVisible,
    isVendorLoggedIn = _ref2.isVendorLoggedIn,
    isAgentLoggedIn = _ref2.isAgentLoggedIn,
    isOrangeOrSISHeader = _ref2.isOrangeOrSISHeader,
    isSISLevel2Header = _ref2.isSISLevel2Header,
    store = _ref2.store;
  var myOrdersDesktop = utilBarButtons.myOrdersDesktop,
    myAccountDesktop = utilBarButtons.myAccountDesktop;
  var myOrderBtnText = get(myOrdersDesktop, 'button_text', 'Mis Compras');
  var myOrderBtnUrl = get(myOrdersDesktop, 'url', 'Mis Compras');
  var _getStandaloneSite = getStandaloneSite(store),
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var entry = headerData.entry;
  var _extractHeaderConfig = extractHeaderConfig(headerData, deviceType),
    isMyAccountEnabled = _extractHeaderConfig.isMyAccountEnabled,
    isMyOrdersEnabled = _extractHeaderConfig.isMyOrdersEnabled;
  return jsx(Fragment, null, myAccountDesktop && (isWhitelabelSite ? isMyAccountEnabled : true) && jsx("li", {
    className: "".concat(styles$v['user-info'], " ").concat(listStyle, " ").concat(isOnboardingInProgress ? styles$v['onboarding-highlight'] : null)
  }, jsx(UserInfo, {
    isLoggedIn: isLoggedIn,
    entry: entry,
    tenant: tenant,
    myAccountDesktop: myAccountDesktop,
    userFirstName: userFirstName,
    welcomeLabel: welcomeLabel,
    loginLabel: loginLabel,
    a11yUserLabel: a11yUserLabel,
    isOnboardingInProgress: isOnboardingInProgress,
    myAccountLabel: myAccountLabel,
    noAccountLabel: noAccountLabel,
    logoutHandler: logoutHandler,
    onLoadingStateChange: onLoadingStateChange,
    deviceType: deviceType,
    anchorStyle: anchorStyle,
    toggleLoginForm: toggleLoginForm,
    setMenuVisible: setMenuVisible,
    isVendorLoggedIn: isVendorLoggedIn,
    isAgentLoggedIn: isAgentLoggedIn,
    isOrangeOrSISHeader: isOrangeOrSISHeader,
    isSISLevel2Header: isSISLevel2Header,
    store: store
  })), myOrdersDesktop && (isWhitelabelSite ? isMyOrdersEnabled : true) && jsx("li", {
    className: classNames(styles$v.orders, styles$v.highlight, listStyle)
  }, jsx("a", {
    id: "testId-userAction-orders",
    className: classNames(styles$v['content-wrapper'], _defineProperty({}, styles$v['content-wrapper--to_com'], isTottusStandalone)),
    href: myOrderBtnUrl,
    onClick: function onClick() {
      return updateDigitalDataCookies({
        firstLevelItem: 'N1 - Mis compras',
        tag: HEADER
      });
    }
  }, jsx("span", {
    className: classNames(styles$v['utils-span'], _defineProperty(_defineProperty({}, styles$v['utils-span--to_com'], isTottusStandalone), styles$v['utils-span--whitelabel'], isWhitelabelSite))
  }, myOrderBtnText.split(' ')[0]), jsx("span", {
    className: classNames(styles$v['utils-span-lower'], _defineProperty(_defineProperty({}, styles$v['utils-span-lower--to_com'], isTottusStandalone), styles$v['utils-span-lower--whitelabel'], isWhitelabelSite))
  }, myOrderBtnText.split(' ')[1]))));
};
UserActionDesktop.propTypes = process.env.NODE_ENV !== "production" ? {
  utilBarButtons: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  userFirstName: PropTypes.string.isRequired,
  welcomeLabel: PropTypes.string.isRequired,
  loginLabel: PropTypes.string.isRequired,
  a11yUserLabel: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  myAccountLabel: PropTypes.string.isRequired,
  noAccountLabel: PropTypes.string.isRequired,
  isOnboardingInProgress: PropTypes.bool.isRequired,
  logoutHandler: PropTypes.func.isRequired,
  onLoadingStateChange: PropTypes.func.isRequired,
  listStyle: PropTypes.string.isRequired,
  headerData: PropTypes.object.isRequired,
  anchorStyle: PropTypes.string.isRequired,
  tenant: PropTypes.string.isRequired,
  toggleLoginForm: PropTypes.func.isRequired,
  setMenuVisible: PropTypes.func,
  isVendorLoggedIn: PropTypes.bool,
  isAgentLoggedIn: PropTypes.bool,
  isOrangeOrSISHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  store: PropTypes.string
} : {};
UserActionDesktop.defaultProps = {
  isVendorLoggedIn: false,
  isAgentLoggedIn: false
};

var styles$w = {"modal-wrapper":"LoggedinModal-module_modal-wrapper__3hY9l","modalHeader":"LoggedinModal-module_modalHeader__2uVO_","username":"LoggedinModal-module_username__2MhGF","closeIcon":"LoggedinModal-module_closeIcon__1I0Lc","icon-cmr-icon":"LoggedinModal-module_icon-cmr-icon__6BGN7","modalBody":"LoggedinModal-module_modalBody__2kw9w"};

var LoggedinModal = function LoggedinModal(_ref) {
  var deviceType = _ref.deviceType,
    modalVisible = _ref.modalVisible,
    loggedinItems = _ref.loggedinItems,
    helloUserText = _ref.helloUserText,
    logoutHandler = _ref.logoutHandler,
    isUserLoggedIn = _ref.isUserLoggedIn,
    isCmrPointsEnabled = _ref.isCmrPointsEnabled,
    myAccountLabel = _ref.myAccountLabel,
    toggleModal = _ref.toggleModal,
    mobileModalClass = _ref.mobileModalClass,
    tenant = _ref.tenant;
  var loginOptions = [];
  var items = get(loggedinItems, 'redirection_items', []);
  var actionItems = get(loggedinItems, 'action_items', {});
  items.forEach(function (item, i) {
    loginOptions.push(_objectSpread2({}, item, {
      id: "testId-redirection-item-mobile-".concat(i, "}"),
      handler: noop
    }));
  });
  Object.keys(actionItems).forEach(function (key, i) {
    if (key === 'cerrar_sesion') {
      loginOptions.push(_objectSpread2({}, actionItems[key], {
        handler: logoutHandler,
        id: "testId-action-item-mobile-".concat(i),
        type: 'actionLogOut'
      }));
    } else {
      loginOptions.push(_objectSpread2({
        id: "testId-action-item-mobile-".concat(i)
      }, actionItems[key]));
    }
  });
  var initializeUrl = function initializeUrl(atgUrl, catalystUrl) {
    return CookieStorage.isCatalyst() ? catalystUrl : atgUrl;
  };
  var isMyAccount = function isMyAccount() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return title && title.toLowerCase() === myAccountLabel.toLowerCase();
  };
  return jsx("div", null, jsx(Modal, {
    toggleState: {
      visible: modalVisible,
      setVisible: toggleModal
    },
    isOverlayEnabled: false,
    content: function content(_ref2) {
      var close = _ref2.close;
      return jsx("div", {
        className: styles$w['modal-wrapper']
      }, jsx("div", {
        className: styles$w.modalHeader
      }, jsx("p", {
        className: styles$w.username
      }, helloUserText), jsx("i", {
        onClick: close,
        className: styles$w.closeIcon
      })), jsx("div", {
        className: styles$w.modalBody
      }, jsx("ul", null, loginOptions.map(function (_ref3) {
        var atg_url = _ref3.atg_url,
          catalyst_url = _ref3.catalyst_url,
          _ref3$handler = _ref3.handler,
          handler = _ref3$handler === void 0 ? noop : _ref3$handler,
          icon = _ref3.icon,
          is_cmr = _ref3.is_cmr,
          is_new_tab = _ref3.is_new_tab,
          title = _ref3.title,
          type = _ref3.type,
          id = _ref3.id;
        if (is_cmr) {
          return jsx("li", {
            key: title
          }, jsx(CmrPuntosMenuMobile, {
            cmrPuntosURL: initializeUrl(atg_url, catalyst_url),
            cmrpuntosImageUrl: icon.url,
            cmrText: title,
            imageStyle: 'icon-cmr-icon',
            isCmrPointsEnabled: isCmrPointsEnabled,
            isLoggedIn: isUserLoggedIn,
            isRebrandingEnabled: true,
            tenantId: "falabella-".concat(tenant)
          }));
        }
        return jsx("li", {
          key: title
        }, type === 'actionLogOut' ? jsx("a", {
          id: id,
          href: "#",
          onClick: function onClick(e) {
            e.preventDefault();
            close();
            handler();
          }
        }, title) : jsx("a", {
          style: isMyAccount(title) ? {
            fontWeight: 'bold'
          } : {},
          id: id,
          target: is_new_tab ? '_blank' : '',
          href: initializeUrl(catalyst_url, atg_url),
          rel: "noreferrer"
        }, title));
      }))));
    },
    options: {
      width: 500,
      height: 331,
      disableOutsideClick: false,
      overflow: 'visible',
      borderRadius: '10px 10px 0px 0px',
      padding: '25px 27px 0 24px'
    },
    deviceType: deviceType,
    fullWidth: true,
    withPadding: false,
    customClass: mobileModalClass,
    showCloseButton: false
  }));
};
LoggedinModal.propTypes = process.env.NODE_ENV !== "production" ? {
  deviceType: PropTypes.string,
  tenant: PropTypes.string,
  modalVisible: PropTypes.bool.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  isCmrPointsEnabled: PropTypes.bool.isRequired,
  myAccountLabel: PropTypes.string,
  mobileModalClass: PropTypes.string,
  loggedinItems: PropTypes.object,
  helloUserText: PropTypes.any,
  logoutHandler: PropTypes.func,
  toggleModal: PropTypes.func.isRequired
} : {};
LoggedinModal.defaultProps = {
  loggedinItems: {},
  helloUserText: null,
  logoutHandler: noop,
  myAccountLabel: '',
  mobileModalClass: '',
  tenant: ''
};

var BRAND_CONFIG = {
  sodimac: {
    brand_color: '#0072CE',
    brand_logo: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt14d15984f6f1452f/64e7549caf6c4b79b52d16e5/sodimac.svg',
    url: '#'
  },
  linio: {
    brand_color: '#C300A2',
    brand_logo: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blta14044007f618d7c/64e8d88912188b3ba0712710/linio.svg',
    url: '#'
  },
  tottus: {
    brand_color: '#64a70b',
    brand_logo: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt70c4281f902c5f79/64e8d8ceb62c6f29b2c3b030/tottus.svg',
    url: '#'
  },
  homecenter: {
    brand_color: '#0072CE',
    brand_logo: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt74c5ad167ce7b7bc/64e8cefe1ab3c32dd103db0a/homecenter.svg',
    url: '#'
  }
};
var MARKETPLACE_LOGO_URL_DESKTOP = 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltd26bd771774314af/626b07662bec9b34ea68a177/falabella-com-desktop.svg';
var MARKETPLACE_LOGO_URL_MOBILE = 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltdb9822fdc4aa9da6/626b0766d2794936634f916f/falabella-com-mobile.svg';
var WISHLIST_ICON_URL = 'https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt07f3d77814036772/65b24dcc41400c07fd457368/heart_desktop_grey.svg';
var CART_ICON_URL = 'https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt930de827842bd280/65b24e36568d54f35735c426/carritodesk.svg';
var CART_ICON_URL_MOBILE = 'https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt20b73fbfd5cbd218/65b25b56568d54479835c453/Mobile_Cart_new.svg';
var ZONE_ICON_URL = 'https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt12bfc7a09b55ab55/6538d0cfd31953c6b30dbd57/gray_geofinder.svg';

var isSmallScreenWidth = isWindow$1() && window.innerWidth < 335;
var fetchElemWidth = function fetchElemWidth() {
  return isSmallScreenWidth ? {
    width: '60px'
  } : {
    width: '70px'
  };
};
var UserActions = function UserActions(_ref) {
  var _ref$isUserLoggedIn = _ref.isUserLoggedIn,
    isUserLoggedIn = _ref$isUserLoggedIn === void 0 ? false : _ref$isUserLoggedIn,
    setUserLoggedIn = _ref.setUserLoggedIn,
    firstName = _ref.firstName,
    cartCount = _ref.cartCount,
    setFirstName = _ref.setFirstName,
    setCartCount = _ref.setCartCount,
    atgBaseUrl = _ref.atgBaseUrl,
    catalystBaseUrl = _ref.catalystBaseUrl,
    onLoadingStateChange = _ref.onLoadingStateChange,
    onUserLogout = _ref.onUserLogout,
    deviceType = _ref.deviceType,
    headerData = _ref.headerData,
    isOnboardingInProgress = _ref.isOnboardingInProgress,
    onUserLogin = _ref.onUserLogin,
    onUserLoginComplete = _ref.onUserLoginComplete,
    onUserLoginConsentsUpdate = _ref.onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate = _ref.onUserLoginPasswordUpdate,
    unifiedLoginBaseUrl = _ref.unifiedLoginBaseUrl,
    userCartCount = _ref.userCartCount,
    setHideMenuBar = _ref.setHideMenuBar,
    modalVisible = _ref.modalVisible,
    mobileModalClass = _ref.mobileModalClass,
    toggleModal = _ref.toggleModal,
    setMenuVisible = _ref.setMenuVisible,
    forceATG = _ref.forceATG,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isStore = _ref.isStore,
    _ref$isOrangeOrSISHea = _ref.isOrangeOrSISHeader,
    isOrangeOrSISHeader = _ref$isOrangeOrSISHea === void 0 ? false : _ref$isOrangeOrSISHea,
    isSISLevel2Header = _ref.isSISLevel2Header,
    store = _ref.store,
    showLoginForm = _ref.showLoginForm,
    setShowLoginForm = _ref.setShowLoginForm,
    getUserSegments = _ref.getUserSegments;
  var _useContext = useContext(AppContext),
    tenant = _useContext.tenant;
  var labels = UserActionConfig.labels;
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var _useState = useState({
      enabled: false,
      cartId: '',
      siteName: '',
      ecommName: '',
      defaultColor: '',
      multiSite: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    whiteLabelProp = _useState2[0],
    setWhiteLabelProp = _useState2[1];
  var envBaseUrl = getEnvBaseUrl(tenant);
  var loginWizardBaseUrl = !unifiedLoginBaseUrl ? envBaseUrl : unifiedLoginBaseUrl;
  var toggleLoginForm = useCallback(function () {
    setShowLoginForm(function (v) {
      setHideMenuBar(!v);
      return !v;
    });
  });
  useEffect(function () {
    if (userCartCount) {
      setCartCount(userCartCount);
    }
  }, [userCartCount]);
  var onLogin = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(response) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!response.loginStatus) {
              _context.next = 4;
              break;
            }
            setUserLoggedIn(true);
            _context.next = 4;
            return onUserLogin(response);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onLogin(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onClose = function onClose() {
    toggleLoginForm();
  };
  var _ref3 = headerData.entry || {},
    _ref3$myaccount_deskt = _ref3.myaccount_desktop,
    myaccount_desktop = _ref3$myaccount_deskt === void 0 ? {} : _ref3$myaccount_deskt,
    _ref3$myorders_deskto = _ref3.myorders_desktop,
    myorders_desktop = _ref3$myorders_deskto === void 0 ? {} : _ref3$myorders_deskto,
    _ref3$myaccount_mobil = _ref3.myaccount_mobile,
    myaccount_mobile = _ref3$myaccount_mobil === void 0 ? {} : _ref3$myaccount_mobil,
    _ref3$cart = _ref3.cart,
    cart = _ref3$cart === void 0 ? {} : _ref3$cart,
    _ref3$wishlist = _ref3.wishlist,
    wishlist = _ref3$wishlist === void 0 ? {} : _ref3$wishlist;
  var _extractHeaderConfig = extractHeaderConfig(headerData, deviceType),
    isWishListEnabled = _extractHeaderConfig.isWishListEnabled,
    isMyAccountEnabled = _extractHeaderConfig.isMyAccountEnabled;
  var handleUserLogout = function () {
    var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2() {
      var data, errors, success;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            onLoadingStateChange(true);
            _context2.next = 3;
            return logout({
              tenantId: getEcommerceName(store, tenant),
              atgBaseUrl: atgBaseUrl,
              catalystBaseUrl: catalystBaseUrl,
              forceATG: forceATG,
              additionalInfo: isWhitelabelSite ? {
                whitelabel: whiteLabelProp
              } : {}
            });
          case 3:
            data = _context2.sent;
            errors = get(data, 'errors', []);
            success = get(data, 'success', false);
            if (!(success || errors[0] && errors[0].code === 'SESSION_CONFIRMATION_NUMBER_MISMATCH_ERROR')) {
              _context2.next = 12;
              break;
            }
            setUserLoggedIn(false);
            _context2.next = 10;
            return onUserLogout();
          case 10:
            onLoadingStateChange(false);
            window.location.reload(true);
          case 12:
            _context2.prev = 12;
            if (!(errors.length >= 0)) {
              _context2.next = 18;
              break;
            }
            setUserLoggedIn(false);
            throw new Error('Logout POST request failed');
          case 18:
            setUserLoggedIn(false);
            throw new Error('Received error response for logout');
          case 20:
            _context2.next = 25;
            break;
          case 22:
            _context2.prev = 22;
            _context2.t0 = _context2["catch"](12);
            return _context2.abrupt("return", undefined);
          case 25:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[12, 22]]);
    }));
    return function handleUserLogout() {
      return _ref4.apply(this, arguments);
    };
  }();
  var utilBarButtonsCopy = {
    myOrdersDesktop: _objectSpread2({}, myorders_desktop),
    myAccountDesktop: _objectSpread2({}, myaccount_desktop)
  };
  var loginText = get(myaccount_mobile, 'items_logged_out.login_text', 'Inicia sesión');
  var isCmrPointsEnabled = get(headerData, 'entry.header_configs[0].toggles.iscmrenabled', false);
  var helloText = get(myaccount_desktop, 'hello_text', 'Hola');
  var cartIconSrc = {
    desktop: isOrangeOrSISHeader ? get(cart, 'icon_desktop.url', '') : get(cart, 'gray_icon_desktop.url', CART_ICON_URL),
    mobile: isOrangeOrSISHeader ? get(cart, 'icon_mobile.url', '') : get(cart, 'gray_icon_mobile.url', CART_ICON_URL_MOBILE)
  };
  var shouldRenderWishlistItem = wishlist.is_enable || isWhitelabelSite && isWishListEnabled;
  useEffect(function () {
    var userCookie = CookieStorage.getUserDataCookieName();
    var userDetails = CookieStorage.unescapeATGCookies(CookieStorage.getCookie(userCookie) || '').split('*');
    setFirstName(isUserLoggedIn && decodeURIComponent(userDetails[0]));
    setCartCount(userDetails[1]);
    getUserSegments();
  }, [isUserLoggedIn]);
  var handlePageShow = function handlePageShow(event) {
    if (event.persisted) {
      var userCookie = CookieStorage.getUserDataCookieName();
      var userDetails = CookieStorage.unescapeATGCookies(CookieStorage.getCookie(userCookie) || '').split('*');
      setFirstName(isUserLoggedIn && decodeURIComponent(userDetails === null || userDetails === void 0 ? void 0 : userDetails[0]));
      setCartCount((userDetails === null || userDetails === void 0 ? void 0 : userDetails[1]) || 0);
    }
  };
  useEffect(function () {
    setWhiteLabelProp(generateWhiteLabelProps(store, tenant));
    window.addEventListener('pageshow', handlePageShow);
    return function () {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);
  return jsx(Fragment, null, jsx(LoginWizard, {
    atgBaseUrl: atgBaseUrl,
    catalystBaseUrl: catalystBaseUrl,
    onLogin: onLogin,
    onClose: onClose,
    show: showLoginForm,
    tenant: tenant,
    flowType: "header",
    doMergeCart: true,
    id: "testId-cc",
    isRebrandingEnabled: true,
    forceATG: forceATG,
    onComplete: onUserLoginComplete,
    onConsentsUpdate: onUserLoginConsentsUpdate,
    onPasswordUpdate: onUserLoginPasswordUpdate,
    baseUrl: loginWizardBaseUrl,
    whitelabel: whiteLabelProp
  }), jsx("div", {
    className: styles$v.utils
  }, jsx("ul", {
    className: styles$v['utils-ul']
  }, jsx(MatchMedia$1, {
    content: {
      desktop: function desktop() {
        return myaccount_desktop && jsx(Fragment, null, jsx(UserActionDesktop, {
          utilBarButtons: utilBarButtonsCopy,
          isLoggedIn: isUserLoggedIn,
          userFirstName: firstName,
          headerData: headerData,
          tenant: tenant,
          isOnboardingInProgress: isOnboardingInProgress,
          welcomeLabel: labels.WELCOME_LABEL,
          loginLabel: labels.LOGIN_LABEL,
          a11yUserLabel: labels.A11Y_USER_LABEL,
          myAccountLabel: labels.MY_ACCOUNT_LABEL,
          noAccountLabel: labels.NO_ACCOUNT_LABEL,
          logoutHandler: handleUserLogout,
          onLoadingStateChange: onLoadingStateChange,
          deviceType: deviceType,
          listStyle: styles$v['utils-list'],
          anchorStyle: styles$v['utils-anchor'],
          toggleLoginForm: toggleLoginForm,
          setMenuVisible: setMenuVisible,
          isVendorLoggedIn: isVendorLoggedIn,
          isAgentLoggedIn: isAgentLoggedIn,
          isOrangeOrSISHeader: isOrangeOrSISHeader,
          isSISLevel2Header: isSISLevel2Header,
          store: store
        }), shouldRenderWishlistItem && jsx("li", {
          className: classNames(styles$v['utils-list'], styles$v['wishlist-icon'], _defineProperty({}, styles$v['wishlist-icon--to_com'], isTottusStandalone))
        }, jsx("div", null, jsx("a", {
          id: "testId-UserAction-wishlist",
          className: classNames(styles$v['utils-anchor']),
          href: wishlist.url,
          onClick: function onClick() {
            return updateDigitalDataCookies({
              firstLevelItem: 'N1 - Mis listas',
              tag: HEADER
            });
          }
        }, jsx("i", {
          id: "wishlist-icon",
          "data-icontype": "wishlist",
          style: {
            backgroundImage: "url(".concat(isOrangeOrSISHeader ? get(wishlist, 'icon_desktop.url', '') : get(wishlist, 'gray_icon_desktop.url', WISHLIST_ICON_URL), ")")
          },
          className: classNames(styles$v.utilIcon, _defineProperty({}, styles$v['utilIcon--to_com'], isTottusStandalone))
        })))), jsx("li", {
          className: classNames(styles$v['utils-list'], styles$v['basket-icon'], _defineProperty({}, styles$v['utils-list--to_com'], isTottusStandalone))
        }, jsx("div", {
          className: classNames(styles$v['orders-content-wrapper'], _defineProperty({}, styles$v['orders-content-wrapper--to_com'], isTottusStandalone))
        }, jsx("a", {
          id: "testId-UserAction-basket",
          className: classNames(styles$v['utils-anchor']),
          href: cart.url,
          onClick: function onClick() {
            return updateDigitalDataCookies({
              firstLevelItem: 'N1 - Basket',
              tag: HEADER
            });
          }
        }, jsx("i", {
          style: {
            backgroundImage: "url(".concat(cartIconSrc.desktop, ")")
          },
          className: classNames(styles$v.utilIcon, _defineProperty({}, styles$v['utilIcon--whitelabel'], isWhitelabelSite))
        })), jsx("span", {
          className: classNames(styles$v['has-count-desktop'], isStore && styles$v['store-stroke'])
        }, cartCount))));
      }
    }
  }), deviceType !== 'desktop' && cart && cart.icon_mobile && cart.icon_mobile.url && jsx(MediaComponent, {
    from: "mobile",
    to: "tablet"
  }, jsx(React.Fragment, null, (isWhitelabelSite ? isMyAccountEnabled : true) && jsx("li", {
    className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles$v['login-list'], true), styles$v['login-list--so_com'], isSodimacStandalone), styles$v['login-list--to_com'], isTottusStandalone))
  }, isUserLoggedIn ? jsx("div", {
    id: "testId-loggedin-user",
    className: classNames(_defineProperty({}, styles$v.login_list_store, isStore)),
    onClick: function onClick() {
      return toggleModal(true);
    }
  }, jsx("span", null, helloText, ", "), jsx("p", {
    style: firstName && firstName.length >= 10 ? fetchElemWidth() : {
      width: 'auto'
    }
  }, firstName)) : jsx("p", {
    id: "testId-Inicia-sesi\xF3n",
    role: "button",
    onClick: toggleLoginForm,
    className: classNames(_defineProperty({}, styles$v.store_inicia, isStore))
  }, loginText)), jsx("li", {
    className: classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$v['utils-list-mobile'], true), styles$v['utils-list-mobile--so_com'], isSodimacStandalone), styles$v['utils-list-mobile--to_com'], isTottusStandalone), styles$v['basket-icon'], true))
  }, jsx("div", {
    className: styles$v['content-wrapper']
  }, jsx("a", {
    id: "testId-UserAction-basket",
    className: classNames(styles$v['utils-anchor']),
    href: cart.url
  }, isStandaloneSite ? jsx("div", {
    className: styles$v['cart-container']
  }, jsx("img", {
    src: cartIconSrc.mobile,
    alt: "cart-icon",
    className: classNames(_defineProperty({}, styles$v['cart-icon'], true))
  }), jsx("div", {
    className: classNames(styles$v['cart-count-container'], _defineProperty({}, styles$v['cart-count-container--to_com'], isTottusStandalone))
  }, jsx("span", {
    className: classNames(styles$v['cart-count-value'], _defineProperty({}, styles$v['cart-count-value--to_com'], isTottusStandalone))
  }, cartCount))) : jsx("i", {
    style: {
      backgroundImage: "url(".concat(cartIconSrc.mobile, ")")
    },
    className: classNames(styles$v.utilIcon, styles$v['has-count'], isStore && styles$v['store-stroke']),
    "data-count": cartCount
  }))))))), deviceType !== 'desktop' && jsx(LoggedinModal, {
    modalVisible: modalVisible,
    toggleModal: toggleModal,
    mobileModalClass: mobileModalClass,
    loggedinItems: get(myaccount_mobile, 'items_logged_in', {}),
    helloUserText: "".concat(helloText, ", ").concat(firstName),
    logoutHandler: handleUserLogout,
    isUserLoggedIn: isUserLoggedIn,
    isCmrPointsEnabled: isCmrPointsEnabled,
    myAccountLabel: labels.MY_ACCOUNT_LABEL,
    tenant: tenant,
    deviceType: deviceType
  })));
};
UserActions.propTypes = process.env.NODE_ENV !== "production" ? {
  showSearchBar: PropTypes.bool.isRequired,
  setShowSearchBar: PropTypes.func.isRequired,
  cartCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  firstName: PropTypes.string.isRequired,
  labels: PropTypes.object,
  appCtx: PropTypes.object,
  isUserLoggedIn: PropTypes.bool.isRequired,
  isOnboardingInProgress: PropTypes.bool.isRequired,
  setUserLoggedIn: PropTypes.func.isRequired,
  setFirstName: PropTypes.func,
  setCartCount: PropTypes.func,
  isATGLoginEnabled: PropTypes.bool,
  isInternetExplorer: PropTypes.bool,
  atgBaseUrl: PropTypes.string.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  onLoadingStateChange: PropTypes.func,
  onUserLogout: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired,
  headerData: PropTypes.object.isRequired,
  onUserLogin: PropTypes.func,
  onUserLoginComplete: PropTypes.func,
  onUserLoginConsentsUpdate: PropTypes.func,
  onUserLoginPasswordUpdate: PropTypes.func,
  unifiedLoginBaseUrl: PropTypes.string,
  userCartCount: PropTypes.number,
  setHideMenuBar: PropTypes.func,
  modalVisible: PropTypes.bool,
  mobileModalClass: PropTypes.string,
  toggleModal: PropTypes.func,
  setMenuVisible: PropTypes.func,
  forceATG: PropTypes.bool.isRequired,
  isAgentLoggedIn: PropTypes.bool.isRequired,
  isVendorLoggedIn: PropTypes.bool.isRequired,
  isStore: PropTypes.bool,
  isOrangeOrSISHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  store: PropTypes.string,
  getUserSegments: PropTypes.func.isRequired
} : {};
UserActions.defaultProps = {
  cartCount: 0,
  setFirstName: noop,
  setCartCount: noop,
  isATGLoginEnabled: false,
  isInternetExplorer: false,
  onLoadingStateChange: noop,
  onUserLogout: noop,
  onUserLogin: noop,
  onUserLoginComplete: noop,
  onUserLoginConsentsUpdate: noop,
  onUserLoginPasswordUpdate: noop,
  unifiedLoginBaseUrl: undefined,
  setHideMenuBar: noop,
  toggleModal: noop,
  modalVisible: false,
  isAgentLoggedIn: false,
  isVendorLoggedIn: false,
  mobileModalClass: '',
  isStore: false
};
var UserActions$1 = withUser(UserActions);

var styles$x = {"agentHeader":"AgentHeader-module_agentHeader__39nzj","strong":"AgentHeader-module_strong__2x94v","labelsContainer":"AgentHeader-module_labelsContainer__Lfv26","vendorLogin":"AgentHeader-module_vendorLogin__2IVsp","vendorText":"AgentHeader-module_vendorText__24OpU","vendorHomeContainer":"AgentHeader-module_vendorHomeContainer__2sZ4S","store":"AgentHeader-module_store__2-Y7a","newCustomer":"AgentHeader-module_newCustomer__28py6","icon":"AgentHeader-module_icon__pIgsF","vendorHome":"AgentHeader-module_vendorHome__10ZgQ","csicon-ham":"AgentHeader-module_csicon-ham__2aW6C","csicon-icon-scan":"AgentHeader-module_csicon-icon-scan__24MgL","agent-button-link":"AgentHeader-module_agent-button-link__1uW61","agent-button-container":"AgentHeader-module_agent-button-container__tHoOt","agent-button":"AgentHeader-module_agent-button__pX6f2","agent-logout1":"AgentHeader-module_agent-logout1__1Htwp","clientName":"AgentHeader-module_clientName__3JI7a","agent-link":"AgentHeader-module_agent-link__1tIUm"};

var agentLinks = function agentLinks(tenant) {
  var region = tenant === 'cl' ? '' : ".".concat(tenant);
  return [{
    text: 'Cambios y devoluciones',
    link: "https://www.falabella.com".concat(region, "/falabella-").concat(tenant, "/mi-cuenta/ordenes/solicitud-de-cambio/1")
  }, {
    text: 'Recepción de productos',
    link: "https://www.falabella.com".concat(region, "/falabella-").concat(tenant, "/CroConfirmation")
  }];
};
var endPoints = function endPoints(tenantId) {
  return {
    AGENT_LOGOUT_URL: "/".concat(tenantId, "/includes/agentLogout.jsp"),
    NEW_AGENT_URL: "/".concat(tenantId, "/includes/agentCustomerLogout.jsp"),
    USER_LOGOUT_URL: '/includes/agentCustomerLogout.jsp'
  };
};
var catalystEndpoints = function catalystEndpoints(tenantId) {
  return {
    NEW_AGENT_URL: "/".concat(tenantId, "/agent/search"),
    POST_LOGOUT_REDIRECTION: "/".concat(tenantId, "/agent/login?isLogout=true ")
  };
};
var labels$3 = {
  NEW_CUSTOMER_TEXT: 'Buscar nuevo cliente',
  CLOSE_SESSION: 'Cerrar Sesión',
  VENDOR_LABEL: 'Vendedor',
  CLIENT_LABEL: 'Cliente'
};
var AgentHeaderConfig = {
  agentLinks: agentLinks,
  labels: labels$3,
  endPoints: endPoints,
  catalystEndpoints: catalystEndpoints
};

var AgentLinkButton = function AgentLinkButton(_ref) {
  var text = _ref.text,
    link = _ref.link;
  return jsx("a", {
    "data-cta": "true",
    rel: "noreferrer",
    target: "_blank",
    className: styles$x['agent-link'],
    href: link
  }, jsx("button", {
    type: "button",
    className: styles$x['agent-button']
  }, text.toUpperCase()));
};
var renderAgentButtons = function renderAgentButtons(agentLinks) {
  return jsx("div", {
    className: styles$x['agent-button-container']
  }, agentLinks.map(function (agentLink, i) {
    return jsx(AgentLinkButton, _extends({}, agentLink, {
      key: "agentLink_".concat(i)
    }));
  }));
};
var AgentHeader = function AgentHeader(_ref2) {
  var agentCookie = _ref2.agentCookie,
    userName = _ref2.userName,
    onUserLogout = _ref2.onUserLogout,
    isCatalyst = _ref2.isCatalyst,
    tenant = _ref2.tenant,
    setIsAgentLoggedIn = _ref2.setIsAgentLoggedIn,
    agentBaseUrl = _ref2.agentBaseUrl,
    atgBaseUrl = _ref2.atgBaseUrl,
    catalystBaseUrl = _ref2.catalystBaseUrl,
    forceATG = _ref2.forceATG,
    store = _ref2.store;
  var labels = AgentHeaderConfig.labels,
    agentLinks = AgentHeaderConfig.agentLinks,
    endPoints = AgentHeaderConfig.endPoints,
    catalystEndpoints = AgentHeaderConfig.catalystEndpoints;
  var agentCookieParts = agentCookie.split('*');
  var agentId = agentCookieParts[0];
  var tenantId = store !== 'so_com' ? "falabella-".concat(tenant) : "sodimac-".concat(tenant);
  var catalystEndpointsObj = catalystEndpoints(tenantId);
  var endPointsObj = endPoints(tenantId);
  var agentLinksObj = agentLinks(tenant);
  var onAgentLogout = function () {
    var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isCatalyst) {
              _context.next = 13;
              break;
            }
            _context.prev = 1;
            e.preventDefault();
            _context.next = 5;
            return agentLogout({
              tenantId: tenantId,
              agentBaseUrl: agentBaseUrl
            });
          case 5:
            setIsAgentLoggedIn(false);
            CookieStorage.removeCookie({
              name: CookieStorage.getAgentDataCookie()
            });
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            console.log('AGENT_LOGOUT_ERROR', _context.t0);
          case 12:
            window.location.href = catalystEndpointsObj.POST_LOGOUT_REDIRECTION;
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function onAgentLogout(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var userLogout = function () {
    var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(e) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            _context2.next = 3;
            return logout({
              tenantId: "falabella-".concat(tenant),
              atgBaseUrl: atgBaseUrl,
              catalystBaseUrl: catalystBaseUrl,
              forceATG: forceATG
            });
          case 3:
            _context2.next = 5;
            return onUserLogout();
          case 5:
            window.location.href = catalystEndpointsObj.NEW_AGENT_URL;
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function userLogout(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var goToNewUrl = function () {
    var _ref5 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3(e) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!userName) {
              _context3.next = 3;
              break;
            }
            _context3.next = 3;
            return userLogout(e);
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function goToNewUrl(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
  return jsx("div", {
    className: styles$x.agentHeader,
    id: "guided-selling-header-agent",
    "data-testid": "guided-selling-header"
  }, jsx("div", {
    className: styles$x.labelsContainer
  }, jsx("div", {
    className: styles$x.vendorLogin
  }, jsx("div", {
    className: styles$x.vendorText
  }, jsx("span", null, jsx("strong", {
    className: styles$x.strong
  }, labels.VENDOR_LABEL), "\xA0", agentId, ":\xA0"), jsx("a", {
    onClick: onAgentLogout,
    href: endPointsObj.AGENT_LOGOUT_URL
  }, labels.CLOSE_SESSION)), jsx("div", {
    className: styles$x.newCustomer
  }, jsx("a", {
    onClick: goToNewUrl,
    className: styles$x['agent-logout1'],
    href: isCatalyst ? catalystEndpointsObj.NEW_AGENT_URL : endPointsObj.NEW_AGENT_URL,
    rel: "noreferrer noopener"
  }, labels.NEW_CUSTOMER_TEXT))), userName && jsx("div", {
    className: styles$x.clientName
  }, jsx("div", {
    className: styles$x.clientText
  }, jsx("span", {
    className: styles$x.strong
  }, labels.CLIENT_LABEL, "\xA0"), jsx("span", null, userName, ":")), jsx("a", {
    className: styles$x['agent-logout2'],
    onClick: userLogout,
    href: endPointsObj.USER_LOGOUT_URL
  }, labels.CLOSE_SESSION))), renderAgentButtons(agentLinksObj));
};
AgentHeader.defaultProps = {
  tenant: 'cl',
  isCatalyst: false
};
AgentHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  agentCookie: PropTypes.string.isRequired,
  userName: PropTypes.string,
  onUserLogout: PropTypes.func,
  isCatalyst: PropTypes.bool,
  tenant: PropTypes.string,
  setIsAgentLoggedIn: PropTypes.func,
  agentBaseUrl: PropTypes.string,
  atgBaseUrl: PropTypes.string,
  catalystBaseUrl: PropTypes.string,
  forceATG: PropTypes.bool.isRequired
} : {};

var liveStreamConfig = {
  inputStream: {
    type: 'LiveStream',
    constraints: {
      width: {
        min: 640
      },
      height: {
        min: 480
      },
      aspectRatio: {
        min: 1,
        max: 100
      },
      facingMode: 'environment'
    }
  },
  locator: {
    patchSize: 'medium',
    halfSample: true
  },
  numOfWorkers: 2,
  frequency: 10,
  decoder: {
    readers: [{
      format: 'ean_reader',
      config: {}
    }, {
      format: 'code_128_reader',
      config: {}
    }]
  },
  locate: true
};
function startQuaggaLivestream(detectedCallback) {
  Quagga.init(liveStreamConfig, function (err) {
    if (err) {
      return;
    }
    Quagga.start();
  });
  Quagga.onProcessed(function (result) {
    var drawingCtx = Quagga.canvas.ctx.overlay;
    var drawingCanvas = Quagga.canvas.dom.overlay;
    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute('width'), 10), parseInt(drawingCanvas.getAttribute('height'), 10));
        result.boxes.filter(function (box) {
          return box !== result.box;
        }).forEach(function (box) {
          Quagga.ImageDebug.drawPath(box, {
            x: 0,
            y: 1
          }, drawingCtx, {
            color: 'green',
            lineWidth: 2
          });
        });
      }
      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, {
          x: 0,
          y: 1
        }, drawingCtx, {
          color: '#00F',
          lineWidth: 2
        });
      }
      if (result.codeResult && result.codeResult.code) {
        Quagga.ImageDebug.drawPath(result.line, {
          x: 'x',
          y: 'y'
        }, drawingCtx, {
          color: 'red',
          lineWidth: 3
        });
      }
    }
  });
  Quagga.onDetected(detectedCallback);
}
function stopQuaggaLivestream() {
  Quagga.stop();
}

var generateInput = function generateInput() {
  var input = document.querySelector('.scanner-input');
  var inputContainer = document.querySelector('#interactive.viewport');
  if (inputContainer && !input) {
    input = document.createElement('input');
    input.classList.add('scanner-input');
    input.setAttribute('type', 'file');
    input.setAttribute('style', 'display:none;');
    inputContainer.appendChild(input);
  }
  return {
    input: input
  };
};
var removeInput = function removeInput() {
  var input = document.querySelector('.scanner-input');
  if (input) {
    input.parentElement.removeChild(input);
  }
};
var startQuaggaPicture = function startQuaggaPicture(detectedCallback) {
  var _generateInput = generateInput(),
    input = _generateInput.input;
  if (!input) {
    return;
  }
  input.addEventListener('change', function (e) {
    if (e.target && e.target.files) {
      Quagga.decodeSingle({
        inputStream: {
          singleChannel: false,
          size: 800
        },
        locator: {
          patchSize: 'medium',
          halfSample: true
        },
        decoder: {
          readers: ['upc_reader', 'code_128_reader', 'code_39_reader', 'code_39_vin_reader', 'ean_8_reader', 'ean_reader', 'upc_e_reader', 'codabar_reader']
        },
        locate: true,
        src: URL.createObjectURL(e.target.files[0])
      }, function (result) {
        detectedCallback(result);
      });
    }
  });
  input.click();
};
var stopQuaggaPicture = function stopQuaggaPicture() {
  removeInput();
};

var styles$y = {"video_overlays":"ProductScanner-module_video_overlays__273Nn","topText__overlay":"ProductScanner-module_topText__overlay__2SJsO","centerSquare":"ProductScanner-module_centerSquare__18iZj","maskTop":"ProductScanner-module_maskTop__3oa96","maskBottom":"ProductScanner-module_maskBottom__ml44i","interactive":"ProductScanner-module_interactive__27CMw","guided-scan-container":"ProductScanner-module_guided-scan-container__1n2eO","portrait":"ProductScanner-module_portrait__3IHBm","landscape":"ProductScanner-module_landscape__3OnAW","bottomText__overlay":"ProductScanner-module_bottomText__overlay__b17m5","cancelButton":"ProductScanner-module_cancelButton__mgZ2n"};

var styles$z = {"scannerModalOverlay":"ScanModalOverlay-module_scannerModalOverlay__3kLEm","modal-title":"ScanModalOverlay-module_modal-title__2vp7n","modal-option":"ScanModalOverlay-module_modal-option__29Oet"};

var ScanModalOverlay = function ScanModalOverlay(_ref) {
  var scanOtherProduct = _ref.scanOtherProduct,
    modalInformation = _ref.modalInformation,
    vendorProductAvailableLabel = _ref.vendorProductAvailableLabel,
    vendorPriceLabel = _ref.vendorPriceLabel,
    vendorStockLabel = _ref.vendorStockLabel,
    vendorScanAnotherProductLabel = _ref.vendorScanAnotherProductLabel,
    vendorInformationNotAvailableLabel = _ref.vendorInformationNotAvailableLabel;
  var _ref2 = modalInformation || {},
    displayName = _ref2.displayName,
    price = _ref2.price,
    message = _ref2.message;
  return jsx("div", {
    className: styles$z.scannerModalOverlay
  }, displayName || price ? jsx(Fragment, null, jsx("div", {
    className: styles$z['modal-title']
  }, "".concat(vendorProductAvailableLabel, ": ").concat(displayName)), jsx("div", {
    className: styles$z['modal-title']
  }, "".concat(vendorPriceLabel, ": ").concat(price)), jsx("div", {
    className: styles$z['modal-title']
  }, "".concat(vendorStockLabel, ": disponible"))) : jsx("div", {
    className: styles$z['modal-title']
  }, message || vendorInformationNotAvailableLabel), jsx("button", {
    className: styles$z['modal-option'],
    type: "button",
    onClick: function onClick() {
      scanOtherProduct();
    }
  }, vendorScanAnotherProductLabel));
};
ScanModalOverlay.propTypes = process.env.NODE_ENV !== "production" ? {
  scanOtherProduct: PropTypes.func.isRequired,
  modalInformation: PropTypes.object.isRequired,
  vendorProductAvailableLabel: PropTypes.string,
  vendorPriceLabel: PropTypes.string,
  vendorStockLabel: PropTypes.string,
  vendorScanAnotherProductLabel: PropTypes.string,
  vendorInformationNotAvailableLabel: PropTypes.string
} : {};
ScanModalOverlay.defaultProps = {
  vendorProductAvailableLabel: '',
  vendorPriceLabel: '',
  vendorStockLabel: '',
  vendorScanAnotherProductLabel: '',
  vendorInformationNotAvailableLabel: ''
};

var ScanLoadingOverlay = function ScanLoadingOverlay(_ref) {
  var loadingLabel = _ref.loadingLabel;
  return jsx("div", {
    className: styles$z.scannerModalOverlay
  }, jsx("div", {
    className: styles$z['modal-title']
  }, loadingLabel));
};
ScanLoadingOverlay.defaultProps = {
  loadingLabel: ''
};
ScanLoadingOverlay.propTypes = process.env.NODE_ENV !== "production" ? {
  loadingLabel: PropTypes.string
} : {};

var apiConfig = {
  getScanSkuDetailsUrl: function getScanSkuDetailsUrl(regionCode, productCode) {
    return "/s/browse/v1/scanSkuDetails/".concat(regionCode, "?{\"productCode\":").concat(productCode, ",\"flagScanner\":true,\"codeType\":\"EAN\"}");
  }
};

var ProductScanner = function ProductScanner(_ref) {
  var _ref$regionCode = _ref.regionCode,
    regionCode = _ref$regionCode === void 0 ? 'cl' : _ref$regionCode,
    deviceType = _ref.deviceType,
    onScannerClose = _ref.onScannerClose;
  if (!global.window && !global.document) {
    return null;
  }
  var vendorInvalidCodeLabel = 'Lo sentimos, no hemos podido encontrar el producto escaneado.';
  var vendorBarcodeCenterLabel = 'Centra tu código de barras y evita mover tu teléfono.';
  var vendorScanInfoLabel = 'El escaneo es automático, evita brillos y reflejos.';
  var vendorCancelButtonLabel = 'CANCELAR';
  var vendorProductAvailableLabel = 'Producto disponible en tienda';
  var vendorPriceLabel = 'Precio';
  var vendorStockLabel = 'Stock';
  var vendorScanAnotherProductLabel = 'ESCANEAR OTRO PRODUCTO';
  var vendorInformationNotAvailableLabel = 'Informacion no disponible';
  var vendorLoadingLabel = 'Buscando..';
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    modalData = _useState6[0],
    setModalData = _useState6[1];
  var clearInternalCanvas = function clearInternalCanvas() {
    var video = document.querySelector('#interactive video');
    var canvas = document.querySelector('#interactive canvas');
    if (video) {
      video.outerHTML = '';
    }
    if (canvas) {
      canvas.outerHTML = '';
    }
  };
  var _useState7 = useState('portrait'),
    _useState8 = _slicedToArray(_useState7, 2),
    deviceOrientation = _useState8[0],
    setDeviceOrientation = _useState8[1];
  useEffect(function () {
    if (process.browser) {
      if (global.window.innerHeight > global.window.innerWidth) {
        setDeviceOrientation('portrait');
      } else {
        setDeviceOrientation('landscape');
      }
    }
  }, [deviceType]);
  var getProductDetails = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(code) {
      var scanSkuDetailsUrl, response, _response$products$0$, url, id, displayName, prices, price;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            scanSkuDetailsUrl = apiConfig.getScanSkuDetailsUrl(regionCode, code);
            _context.prev = 1;
            _context.next = 4;
            return doFetch(scanSkuDetailsUrl);
          case 4:
            response = _context.sent;
            if (!(response && response.products && response.products.length > 0)) {
              _context.next = 16;
              break;
            }
            _response$products$0$ = response.products[0].product, url = _response$products$0$.url, id = _response$products$0$.id, displayName = _response$products$0$.displayName, prices = _response$products$0$.prices;
            setLoading(false);
            if (!(url && id)) {
              _context.next = 13;
              break;
            }
            global.window.location.assign(url.startsWith('/') ? url : "/".concat(url));
            return _context.abrupt("return");
          case 13:
            price = prices[0].originalPrice;
            setModalData({
              displayName: displayName,
              price: price
            });
            return _context.abrupt("return");
          case 16:
            setLoading(false);
            setModalData({
              message: vendorInvalidCodeLabel
            });
            _context.next = 24;
            break;
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](1);
            setLoading(false);
            setModalData({
              message: vendorInformationNotAvailableLabel
            });
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 20]]);
    }));
    return function getProductDetails(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var pictureCallback = function () {
    var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(result) {
      var code;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (result && result.codeResult && result.codeResult.code) {
              stopQuagga();
              clearInternalCanvas();
              setLoading(true);
              code = result.codeResult.code;
              getProductDetails(code);
            } else {
              setModalData(undefined);
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function pictureCallback(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var codeValues = {};
  var livestreamCallback = function () {
    var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3(result) {
      var _result$codeResult$co, code;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (result && result.codeResult) {
              _result$codeResult$co = result.codeResult.code, code = _result$codeResult$co === void 0 ? 0 : _result$codeResult$co;
              if (codeValues[code] > 3) {
                stopQuagga();
                clearInternalCanvas();
                setLoading(true);
                getProductDetails(code);
              } else {
                codeValues[code] = codeValues[code] ? codeValues[code] + 1 : 1;
              }
            }
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function livestreamCallback(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var mediaDevicesAvailable = navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function';
  var startQuagga = mediaDevicesAvailable ? function () {
    return startQuaggaLivestream(livestreamCallback);
  } : function () {
    return startQuaggaPicture(pictureCallback);
  };
  var stopQuagga = mediaDevicesAvailable ? stopQuaggaLivestream : stopQuaggaPicture;
  var scanOtherProduct = function scanOtherProduct() {
    setModalData(undefined);
    startQuagga();
  };
  var stopScanner = function stopScanner() {
    stopQuagga();
    setActive(false);
    clearInternalCanvas();
    setModalData(undefined);
    onScannerClose();
  };
  useEffect(function () {
    startQuagga();
  }, []);
  return jsx("div", {
    className: "".concat(styles$y['guided-scan-container'], " ").concat(styles$y[deviceOrientation])
  }, jsx("div", {
    id: "interactive",
    className: "".concat(styles$y.interactive, " viewport ").concat(styles$y['gs-scan'])
  }, jsx("div", {
    className: styles$y.videoOverlay,
    id: styles$y.video_overlays
  }, jsx("div", {
    id: styles$y.centerSquare
  }, jsx("div", {
    id: styles$y.maskTop
  }), jsx("div", {
    id: styles$y.maskBottom
  })), jsx("div", {
    id: styles$y.bottomText__overlay
  }, vendorBarcodeCenterLabel, jsx("br", null), vendorScanInfoLabel))), jsx("button", {
    className: styles$y.cancelButton,
    type: "button",
    onClick: stopScanner
  }, vendorCancelButtonLabel), modalData && jsx(ScanModalOverlay, {
    vendorProductAvailableLabel: vendorProductAvailableLabel,
    vendorPriceLabel: vendorPriceLabel,
    vendorStockLabel: vendorStockLabel,
    vendorScanAnotherProductLabel: vendorScanAnotherProductLabel,
    vendorInformationNotAvailableLabel: vendorInformationNotAvailableLabel,
    scanOtherProduct: scanOtherProduct,
    modalInformation: modalData
  }), loading && jsx(ScanLoadingOverlay, {
    loadingLabel: vendorLoadingLabel
  }));
};
ProductScanner.defaultProps = {
  onScannerClose: function onScannerClose() {},
  regionCode: '',
  deviceType: 'desktop'
};
ProductScanner.propTypes = process.env.NODE_ENV !== "production" ? {
  onScannerClose: PropTypes.func,
  regionCode: PropTypes.string,
  deviceType: PropTypes.string
} : {};

var styles$A = {"vendorHeader":"VendorHeader-module_vendorHeader__Rvhf9","strong":"VendorHeader-module_strong__137Gw","vendorLogin":"VendorHeader-module_vendorLogin__28-MY","vendor_logout":"VendorHeader-module_vendor_logout__2KHWm","vendorHomeContainer":"VendorHeader-module_vendorHomeContainer__1wyIQ","store":"VendorHeader-module_store__1eyIF","newCustomer":"VendorHeader-module_newCustomer__1Jc3i","search_customer":"VendorHeader-module_search_customer__RZ6wB","customer_logout":"VendorHeader-module_customer_logout__q-Fte","icon":"VendorHeader-module_icon__2CUS3","vendorHome":"VendorHeader-module_vendorHome__3Q99E","vendor_home":"VendorHeader-module_vendor_home__3uP6t","csicon-icon-scan":"VendorHeader-module_csicon-icon-scan__1r3h4"};

var endPoints$1 = {
  VENDOR_LOGOUT_URL: function VENDOR_LOGOUT_URL(tenant) {
    return "/".concat(tenant, "/includes/vendorLogout.jsp");
  },
  SEARCH_CUSTOMER_URL: '/agentLocal/search.jsp',
  CUSTOMER_LOGOUT_URL: function CUSTOMER_LOGOUT_URL(tenant, storeId, modulo) {
    return "/".concat(tenant, "/includes/vendorCustomerLogout.jsp").concat(storeId && modulo ? "?storeId=".concat(storeId, "&modulo=").concat(modulo) : '');
  },
  VENDOR_HOME_URL: function VENDOR_HOME_URL(tenant, pageId) {
    return "/".concat(tenant, "/page/Venta-Guiada?staticPageId=").concat(pageId);
  }
};
var catalystEndpoints$1 = {
  VENDOR_LOGOUT_URL: '/s/auth/v1/agent/logout',
  SEARCH_CUSTOMER_URL: function SEARCH_CUSTOMER_URL(tenant) {
    return "/".concat(tenant, "/agent/search");
  },
  CUSTOMER_LOGOUT_URL: function CUSTOMER_LOGOUT_URL(tenant, storeId, modulo) {
    return "/".concat(tenant, "/agent/search?isLogout=true").concat(storeId && modulo ? "&storeId=".concat(storeId, "&modulo=").concat(modulo) : '');
  },
  POST_LOGOUT_URL: function POST_LOGOUT_URL(tenant, storeId, modulo) {
    return "/".concat(tenant, "/agentlocal/login?isLogout=true").concat(storeId && modulo ? "&storeId=".concat(storeId, "&modulo=").concat(modulo) : '');
  },
  POST_LOGIN_URL: function POST_LOGIN_URL(tenant, storeId, modulo) {
    return "/".concat(tenant, "/agentlocal/login").concat(storeId && modulo ? "?storeId=".concat(storeId, "&modulo=").concat(modulo) : '');
  }
};
var VendorHeaderConfig = {
  endPoints: endPoints$1,
  catalystEndpoints: catalystEndpoints$1
};

var VendorHeader = function VendorHeader(_ref) {
  var isCatalyst = _ref.isCatalyst,
    tenant = _ref.tenant,
    setIsVendorLoggedIn = _ref.setIsVendorLoggedIn,
    vendorBaseUrl = _ref.vendorBaseUrl,
    atgBaseUrl = _ref.atgBaseUrl,
    catalystBaseUrl = _ref.catalystBaseUrl,
    onUserLogout = _ref.onUserLogout,
    forceATG = _ref.forceATG,
    store = _ref.store,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    whitelabel = _ref.whitelabel;
  var endPoints = VendorHeaderConfig.endPoints,
    catalystEndpoints = VendorHeaderConfig.catalystEndpoints;
  var tenantId = store !== 'so_com' ? "falabella-".concat(tenant) : "sodimac-".concat(tenant);
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showScanner = _useState4[0],
    setShowScanner = _useState4[1];
  var vendorcookie = CookieStorage.getCookie(CookieStorage.getVendorDataCookie());
  var clientCookie = CookieStorage.getCookie(CookieStorage.getUserDataCookieName());
  var pageId = {
    cl: 26000001,
    co: 12600002,
    pe: 12200002
  };
  useEffect(function () {
    var vendorValues = vendorcookie.split('*');
    var vendorId = decodeURIComponent(decodeURIComponent(get(vendorValues, '[0]', '')));
    var storeName = get(vendorValues, '[1]', '');
    var channel = 'kiosk';
    var module = CookieStorage.getCookie(CookieStorage.getKioskoModuleCookieName());
    var storeId = CookieStorage.getCookie(CookieStorage.getKioskoStoreCookieName());
    if (storeId) {
      storeName = storeId;
    }
    var digitalData = global.window.digitalData ? global.window.digitalData : {
      login: {},
      page: {}
    };
    if (!digitalData.login) {
      digitalData.login = {};
    }
    if (!digitalData.page) {
      digitalData.page = {};
    }
    digitalData.login.vendorCode = vendorId;
    if (storeName) digitalData.login.localStoreName = storeName;
    digitalData.page.canal = channel;
    global.window.digitalData = digitalData;
    setState({
      vendorId: vendorId,
      usersName: decodeURIComponent(decodeURIComponent(clientCookie.split('*')[0])),
      module: module,
      storeName: storeName
    });
  }, [vendorcookie]);
  var onScanButtonClicked = function onScanButtonClicked() {
    toggleNotificationsPopUpVisibilty();
    setShowScanner(true);
  };
  var onVendorLogout = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isCatalyst) {
              _context.next = 22;
              break;
            }
            if (!isVendorLoggedIn) {
              _context.next = 18;
              break;
            }
            _context.prev = 2;
            e.preventDefault();
            _context.next = 6;
            return agentLogout({
              tenantId: tenantId,
              vendorBaseUrl: vendorBaseUrl,
              additionalInfo: {
                whitelabel: whitelabel
              }
            });
          case 6:
            setIsVendorLoggedIn(false);
            CookieStorage.removeCookie({
              name: CookieStorage.getVendorDataCookie()
            });
            CookieStorage.removeCookie({
              name: CookieStorage.getKioskoStoreCookieName()
            });
            CookieStorage.removeCookie({
              name: CookieStorage.getKioskoModuleCookieName()
            });
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            console.log('KIOSKO_LOGOUT_ERROR', _context.t0);
          case 15:
            window.location.href = VendorHeaderConfig.catalystEndpoints.POST_LOGOUT_URL(tenantId, state.storeName, state.module);
            _context.next = 22;
            break;
          case 18:
            CookieStorage.removeCookie({
              name: CookieStorage.getVendorDataCookie()
            });
            CookieStorage.removeCookie({
              name: CookieStorage.getKioskoStoreCookieName()
            });
            CookieStorage.removeCookie({
              name: CookieStorage.getKioskoModuleCookieName()
            });
            window.location.href = VendorHeaderConfig.catalystEndpoints.POST_LOGIN_URL(tenantId, state.storeName, state.module);
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 12]]);
    }));
    return function onVendorLogout(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onClientLogout = function () {
    var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(e) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!isCatalyst) {
              _context2.next = 13;
              break;
            }
            e.preventDefault();
            _context2.prev = 2;
            _context2.next = 5;
            return logout({
              tenantId: tenantId,
              catalystBaseUrl: catalystBaseUrl,
              additionalInfo: {
                whitelabel: whitelabel
              }
            });
          case 5:
            _context2.next = 7;
            return onUserLogout();
          case 7:
            _context2.next = 12;
            break;
          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](2);
            console.log('CLIENT_LOGOUT_ERROR', _context2.t0);
          case 12:
            window.location.href = VendorHeaderConfig.catalystEndpoints.SEARCH_CUSTOMER_URL(tenantId);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 9]]);
    }));
    return function onClientLogout(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getCatalystLink = function getCatalystLink(loggedInUrl, notLoggedVendorUrl) {
    var url = isVendorLoggedIn ? loggedInUrl : notLoggedVendorUrl;
    if (state.storeName && state.module) {
      url = "".concat(url).concat(state.storeName && state.module ? "?storeId=".concat(state.storeName, "&modulo=").concat(state.module) : '');
    }
    return url;
  };
  var redirectLinks = function redirectLinks() {
    if (isCatalyst) {
      return getCatalystLink(catalystEndpoints.VENDOR_LOGOUT_URL, catalystEndpoints.POST_LOGIN_URL(tenantId));
    } else {
      return getCatalystLink(endPoints.VENDOR_LOGOUT_URL(tenantId), null);
    }
  };
  var redirectLinksSearch = function redirectLinksSearch() {
    if (isCatalyst) {
      return getCatalystLink(catalystEndpoints.SEARCH_CUSTOMER_URL(tenantId), catalystEndpoints.POST_LOGIN_URL(tenantId));
    } else {
      return getCatalystLink(endPoints.SEARCH_CUSTOMER_URL, null);
    }
  };
  return jsx("div", {
    className: styles$A.vendorHeader,
    id: "guided-selling-header-vendor",
    "data-testid": "guided-selling-header"
  }, showScanner && jsx(ProductScanner, {
    onScannerClose: function onScannerClose() {
      toggleNotificationsPopUpVisibilty();
      setShowScanner(false);
    },
    regionCode: tenant,
    deviceType: 'desktop'
  }), jsx("div", {
    className: styles$A.vendorLogin
  }, jsx("b", {
    className: styles$A.strong
  }, "Vendedor:"), " ".concat(state.vendorId, " "), jsx("a", {
    className: styles$A.vendor_logout,
    onClick: onVendorLogout,
    href: redirectLinks()
  }, isVendorLoggedIn ? '(Cerrar Sesión)' : '(Iniciar Sesión)')), jsx("div", {
    className: styles$A.newCustomer
  }, jsx("a", {
    className: styles$A.search_customer,
    onClick: state.usersName ? onClientLogout : undefined,
    href: redirectLinksSearch(),
    rel: "noreferrer noopener"
  }, 'Buscar nuevo cliente'), jsx("br", null), jsx("b", {
    className: styles$A.strong
  }, "Cliente:"), state.usersName && jsx("span", null, " ".concat(state.usersName, " "), jsx("a", {
    className: styles$A.customer_logout,
    onClick: onClientLogout,
    href: isCatalyst ? catalystEndpoints.CUSTOMER_LOGOUT_URL(tenantId, state.storeName, state.module) : endPoints.CUSTOMER_LOGOUT_URL(tenantId, state.storeName, state.module),
    rel: "noreferrer noopener"
  }, '(Cerrar Sesión)'))), jsx("div", {
    className: styles$A.store
  }, jsx("b", {
    className: styles$A.strong
  }, "Tienda:"), " (", state.storeName, ")", jsx("br", null), jsx("b", {
    className: styles$A.strong
  }, "Modulo:"), " (", state.module, ")"), jsx("div", {
    className: styles$A.vendorHomeContainer
  }, jsx("div", {
    "data-testid": "scanButton",
    className: classNames(styles$A.vendorHome, 'scanButton'),
    onClick: onScanButtonClicked
  }, jsx("div", {
    className: styles$A['csicon-icon-scan']
  }), jsx("span", null, 'Scan')), endPoints.VENDOR_HOME_URL(tenantId) && jsx("a", {
    className: styles$A.vendor_home,
    href: endPoints.VENDOR_HOME_URL(tenantId, pageId[tenant])
  }, 'VENDOR HOME')));
};
VendorHeader.defaultProps = {
  isCatalyst: false,
  tenant: 'cl',
  isVendorLoggedIn: false,
  whitelabel: {}
};
VendorHeader.propTypes = process.env.NODE_ENV !== "production" ? {
  isCatalyst: PropTypes.bool,
  tenant: PropTypes.string,
  setIsVendorLoggedIn: PropTypes.func,
  atgBaseUrl: PropTypes.string,
  catalystBaseUrl: PropTypes.string,
  onUserLogout: PropTypes.func,
  vendorBaseUrl: PropTypes.string,
  forceATG: PropTypes.bool.isRequired,
  isVendorLoggedIn: PropTypes.bool,
  whitelabel: PropTypes.object
} : {};

var transversalFallback = {
  v2: {
    cl: '<div></div>',
    co: '<div></div>',
    pe: '<div></div>',
    ar: '<div></div>'
  },
  v3: {
    cl: '<div></div>',
    co: '<div></div>',
    pe: '<div></div>',
    ar: '<div></div>'
  }
};

var styles$B = {"container":"TernaryNavBar-module_container__1dqro","promotionalSection":"TernaryNavBar-module_promotionalSection__RL7_0","ternary-nav-bar":"TernaryNavBar-module_ternary-nav-bar__1SGyK","searchCheckBox":"TernaryNavBar-module_searchCheckBox__Hk8Y_","ternary-nav-bar-sis-level-header":"TernaryNavBar-module_ternary-nav-bar-sis-level-header__2kgEz","ternary-nav-bar--so_com":"TernaryNavBar-module_ternary-nav-bar--so_com__2VL8D","ternary-nav-bar--to_com":"TernaryNavBar-module_ternary-nav-bar--to_com__3U6aw","overshadow":"TernaryNavBar-module_overshadow__uh8Z0","zone-container":"TernaryNavBar-module_zone-container__3qifB","activity-lists":"TernaryNavBar-module_activity-lists__1iP5W","activity-link":"TernaryNavBar-module_activity-link__31MdM","activity-link-link":"TernaryNavBar-module_activity-link-link__2hxDb"};

var styles$C = {"modal-wrapper":"Zone-module_modal-wrapper__1GrTK","retail":"Zone-module_retail__2i2a1","marketplace":"Zone-module_marketplace__2q8h5","store":"Zone-module_store__2uUGS","zone-modal-container":"Zone-module_zone-modal-container__3YgO0","zone-select-wrapper":"Zone-module_zone-select-wrapper__2NKEc","mr-4":"Zone-module_mr-4__13SYq","modal-zone-name":"Zone-module_modal-zone-name__38YZx","icon-location":"Zone-module_icon-location__2PUFT","remove-icon":"Zone-module_remove-icon__2w9rc","icon-header":"Zone-module_icon-header__3HOBP","icon":"Zone-module_icon__3YMi0","storeIcon":"Zone-module_storeIcon__1uPnw","sr-only":"Zone-module_sr-only__3o5vB","zone-modal-body":"Zone-module_zone-modal-body__1DCsW","modal-btn-close":"Zone-module_modal-btn-close__3mj5V","icon-close":"Zone-module_icon-close__2ujn9","modal-header":"Zone-module_modal-header__2SZqI","modal-heading":"Zone-module_modal-heading__3KqrM","modal-content":"Zone-module_modal-content__2uQ2U","banner-text":"Zone-module_banner-text__1fGt7","input-wrapper":"Zone-module_input-wrapper__3QLvJ","provincia-wrapper":"Zone-module_provincia-wrapper__3VaO-","comuna-wrapper":"Zone-module_comuna-wrapper__DJY5H","btn-zone-select-retail":"Zone-module_btn-zone-select-retail__2IlTj","btn-zone-select-marketplace":"Zone-module_btn-zone-select-marketplace__3FkYW","btn-zone-select-stock-en-tienda":"Zone-module_btn-zone-select-stock-en-tienda__QcGgi","storeButton":"Zone-module_storeButton__15BoF","so_com":"Zone-module_so_com__3NeGg","tottus-comuna":"Zone-module_tottus-comuna__GbEVl","comuna":"Zone-module_comuna__3N_ti","tottus-span":"Zone-module_tottus-span__2VyVj","bold":"Zone-module_bold__3nCWu","zone-lable":"Zone-module_zone-lable__25mlT","new-zone-modal":"Zone-module_new-zone-modal__2dWau","flex-align-center":"Zone-module_flex-align-center__1xkn9","success-message-parent":"Zone-module_success-message-parent__2GZ39","justify-from-start":"Zone-module_justify-from-start__RUW7l","justify-space-around":"Zone-module_justify-space-around__1ANb2","flex-column":"Zone-module_flex-column__2SYAi","flex-row":"Zone-module_flex-row__2gmfT","zone-popover":"Zone-module_zone-popover__N4_bx","large":"Zone-module_large__1jKvr","medium":"Zone-module_medium__2Zc7u","small":"Zone-module_small__2aQU4","success-modal":"Zone-module_success-modal__SSrPS","warning-modal":"Zone-module_warning-modal__1EIwf","pressure-modal":"Zone-module_pressure-modal__1Xh3t","reminder-modal":"Zone-module_reminder-modal__2kI67","text-label":"Zone-module_text-label__jtLgS","highlighted":"Zone-module_highlighted__3IvCC","banner":"Zone-module_banner__3DCtR","modal-close":"Zone-module_modal-close__32xk3","icon-danger":"Zone-module_icon-danger__qCh8k","icon-success":"Zone-module_icon-success__3HJ6M","sucess-icon-wrapper":"Zone-module_sucess-icon-wrapper__QGivp","sucess-message-wrapper":"Zone-module_sucess-message-wrapper__kcxwx","message-wrapper":"Zone-module_message-wrapper__lCVSA","btn-wrapper":"Zone-module_btn-wrapper__1gr81","btn-underline":"Zone-module_btn-underline__1HR-t","btn-outline":"Zone-module_btn-outline__2Ud7P","stockEnTiendaWrapper":"Zone-module_stockEnTiendaWrapper__v81x3","stockEnTienda":"Zone-module_stockEnTienda__1VQA_","deliveryOptions":"Zone-module_deliveryOptions__36wJH","checkboxRebranding":"Zone-module_checkboxRebranding__3OKgz","save-location-checkbox":"Zone-module_save-location-checkbox__2YGoz","rebrandIcon":"Zone-module_rebrandIcon__3EBIG","hideIcon":"Zone-module_hideIcon__1bzi5","save-current-location":"Zone-module_save-current-location__2w02Q","btn-zone-select-cancel":"Zone-module_btn-zone-select-cancel__3HwMH","pickupInStore":"Zone-module_pickupInStore__t1zIK","scroll":"Zone-module_scroll__KpDvn","deliveryOptionsError":"Zone-module_deliveryOptionsError__28QZt","homeDelivery":"Zone-module_homeDelivery__1KtbH","stock-en-tienda-footer":"Zone-module_stock-en-tienda-footer__2L7Ki","display-none":"Zone-module_display-none__8-YO6","pickup-in-store-container":"Zone-module_pickup-in-store-container__1QUUk","pickup-in-store-data-header":"Zone-module_pickup-in-store-data-header__38_Zz","pickup-in-store-list":"Zone-module_pickup-in-store-list__6SGAk","selected":"Zone-module_selected__1BtHl","store-logo":"Zone-module_store-logo__2lwqF","pickup-in-store-falabella":"Zone-module_pickup-in-store-falabella__3q1My","pickup-in-store-sodimac":"Zone-module_pickup-in-store-sodimac__1oeKS","pickup-in-store-tottus":"Zone-module_pickup-in-store-tottus__Hku5-","pickup-in-store-default":"Zone-module_pickup-in-store-default__3JMQy","pickup-in-store-list-content":"Zone-module_pickup-in-store-list-content__3tsZz","store-name":"Zone-module_store-name__V81zp","store-addressline":"Zone-module_store-addressline__NAaIQ","store-available-slot":"Zone-module_store-available-slot__21x6P","delivery-options-error-container":"Zone-module_delivery-options-error-container__1zKQ_","delivery-options-error":"Zone-module_delivery-options-error__3cUn-","delivery-options-location-icon":"Zone-module_delivery-options-location-icon__NnxBy","delivery-options-error-heading":"Zone-module_delivery-options-error-heading__2dn4p","normal":"Zone-module_normal__2PhWI","capitalise":"Zone-module_capitalise__2YMca","delivery-options-error-subheading-container":"Zone-module_delivery-options-error-subheading-container__ewgSt","delivery-options-error-subheading":"Zone-module_delivery-options-error-subheading__2EuCi","zone-select-wrapper-sis-level-header":"Zone-module_zone-select-wrapper-sis-level-header__3vh-s","storeIconWhite":"Zone-module_storeIconWhite__c3y9Z","new-zone-modal-container":"Zone-module_new-zone-modal-container__2NN4x","draggable-bar":"Zone-module_draggable-bar__2lrsX","gap":"Zone-module_gap__eAIfy","no-padding":"Zone-module_no-padding__1YPMi","modal-header-text":"Zone-module_modal-header-text__2QGQW","warning-section":"Zone-module_warning-section__2mUU4","warning-icon":"Zone-module_warning-icon__2xVAH","input-section":"Zone-module_input-section__2q6PN","save-location":"Zone-module_save-location__6cXvv","edit-icon":"Zone-module_edit-icon__2jfHi","zone-selection-body":"Zone-module_zone-selection-body__24HgK","modal-label":"Zone-module_modal-label__2sbpt","btn-zone-select":"Zone-module_btn-zone-select__371GK","no-coverage-body":"Zone-module_no-coverage-body__q5swK","no-address":"Zone-module_no-address__3W00J","modal-body":"Zone-module_modal-body__gYooq","selected-address":"Zone-module_selected-address__2tCse","close-nocoverage":"Zone-module_close-nocoverage__3nJ1f","see-coverage":"Zone-module_see-coverage__3xjAC","new-address":"Zone-module_new-address__1xxGq","savezone-container":"Zone-module_savezone-container__3uIuU","address-container":"Zone-module_address-container__1klTs","address-selection":"Zone-module_address-selection__3JCq1","lwrapper":"Zone-module_lwrapper__dfNzb","active":"Zone-module_active__2LBYD","radio-icon":"Zone-module_radio-icon__1v_tJ","remove-button":"Zone-module_remove-button__1lQJe","button-container":"Zone-module_button-container__1pnKP","directions-link":"Zone-module_directions-link__Fs7qD","save-button":"Zone-module_save-button__ltYAh","delete-address-container":"Zone-module_delete-address-container__1pIbP","modal-buttons":"Zone-module_modal-buttons__1qrRs","cancel-link":"Zone-module_cancel-link__3PseL","delete-button":"Zone-module_delete-button__3qdBd"};

var styles$D = {"autocomplete-input-wrapper":"Autocomplete-module_autocomplete-input-wrapper__3WjSy","autocomplete-input":"Autocomplete-module_autocomplete-input__WTcGr","autocomplete-input-2":"Autocomplete-module_autocomplete-input-2__2_xRh","type2":"Autocomplete-module_type2__3SweY","suggestions-list":"Autocomplete-module_suggestions-list__2aU4G","arrow-icon":"Autocomplete-module_arrow-icon__LVI0T","scroll":"Autocomplete-module_scroll__2lAOm","suggestion":"Autocomplete-module_suggestion__3t35l","selected":"Autocomplete-module_selected__f6MIC","retail":"Autocomplete-module_retail__H00MC","marketplace":"Autocomplete-module_marketplace__2aSi7","storeBorder":"Autocomplete-module_storeBorder__25dh0","enableSisThemedBorder":"Autocomplete-module_enableSisThemedBorder__2bZvO","floating-label":"Autocomplete-module_floating-label__3EVZi","floating-icon":"Autocomplete-module_floating-icon__2AMUx","icon-search":"Autocomplete-module_icon-search__16OPC","icon-close":"Autocomplete-module_icon-close__3mfYW","error-notification":"Autocomplete-module_error-notification__KMgwa","error-notification-text":"Autocomplete-module_error-notification-text__2Jn8D","error-notification-container":"Autocomplete-module_error-notification-container__3AQcP","warning-icon":"Autocomplete-module_warning-icon__3zeBJ","bold-text":"Autocomplete-module_bold-text__1SmEk"};

var LABELS = {
  WRONG_SELECTION_TEXT: 'No se encontraron resultados para',
  RECOMMEND_TEXT: '. Te recomendamos ',
  PLEASE_SELECT_TEXT: 'seleccionar una opción de la lista',
  OR_TEXT: 'o',
  REENTER_TEXT: 'volver a ingresarla.'
};
var config = {
  LABELS: LABELS
};

var ErrorNotification = function ErrorNotification(_ref) {
  var message = _ref.message;
  var LABELS = config.LABELS;
  var WRONG_SELECTION_TEXT = LABELS.WRONG_SELECTION_TEXT,
    RECOMMEND_TEXT = LABELS.RECOMMEND_TEXT,
    PLEASE_SELECT_TEXT = LABELS.PLEASE_SELECT_TEXT,
    OR_TEXT = LABELS.OR_TEXT,
    REENTER_TEXT = LABELS.REENTER_TEXT;
  return jsx("div", {
    className: styles$D['error-notification']
  }, jsx("div", {
    className: styles$D['warning-icon']
  }, "!"), jsx("div", {
    className: styles$D['error-notification-text']
  }, jsx("span", null, WRONG_SELECTION_TEXT), "\xA0", jsx("span", {
    className: styles$D['bold-text']
  }, message), jsx("span", null, RECOMMEND_TEXT), "\xA0", jsx("span", {
    className: styles$D['bold-text']
  }, PLEASE_SELECT_TEXT), "\xA0", jsx("span", null, OR_TEXT), "\xA0", jsx("span", {
    className: styles$D['bold-text']
  }, REENTER_TEXT)));
};
ErrorNotification.propTypes = process.env.NODE_ENV !== "production" ? {
  message: PropTypes.string
} : {};

var SuggestionsList = function SuggestionsList(_ref) {
  var suggestions = _ref.suggestions,
    onSelectSuggestion = _ref.onSelectSuggestion,
    displaySuggestions = _ref.displaySuggestions,
    selectedSuggestion = _ref.selectedSuggestion,
    inputValue = _ref.inputValue,
    showEmptyResult = _ref.showEmptyResult,
    suggestionContainerRef = _ref.suggestionContainerRef,
    currState = _ref.currState,
    onHover = _ref.onHover,
    branding = _ref.branding,
    isStore = _ref.isStore,
    enableSisThemedBorder = _ref.enableSisThemedBorder;
  if (displaySuggestions && suggestions.length > 0) {
    var currSelectionRef = useRef(null);
    useEffect(function () {
      if (currSelectionRef.current !== null && !currState.hovering) {
        if (currState.direction === 1 && currState.cursor % 3 === 2) {
          suggestionContainerRef.current.scroll(0, currSelectionRef.current.offsetHeight * currState.cursor);
        }
        if (currState.direction === -1 && (suggestions.length - currState.cursor) % 3 === 0) {
          suggestionContainerRef.current.scroll(0, currSelectionRef.current.offsetHeight * (currState.cursor - 2));
        }
      }
    });
    var isSelected = function isSelected(i) {
      return selectedSuggestion === inputValue || currState.cursor === i;
    };
    return jsx("ul", {
      className: classNames(styles$D['suggestions-list'], styles$D["".concat(suggestions.length > 3 ? 'scroll' : '')]),
      ref: suggestionContainerRef
    }, suggestions.map(function (suggestion, i) {
      return jsx("li", {
        key: suggestion,
        className: classNames(styles$D.suggestion, styles$D[branding], styles$D["".concat(isSelected(i) ? 'selected' : '')], _defineProperty(_defineProperty({}, styles$D.storeBorder, isStore), styles$D.enableSisThemedBorder, isStore && enableSisThemedBorder)),
        onMouseDown: function onMouseDown() {
          return onSelectSuggestion(suggestion);
        },
        onMouseOver: function onMouseOver() {
          onHover(i);
        },
        ref: i === currState.cursor ? currSelectionRef : null
      }, suggestion);
    }));
  } else if (showEmptyResult && displaySuggestions) {
    return jsx("ul", {
      className: classNames(styles$D['error-notification-container'], styles$D['suggestions-list'])
    }, jsx("li", null, jsx(ErrorNotification, {
      message: "\"".concat(inputValue, "\"")
    })));
  }
  return jsx(React.Fragment, null);
};
SuggestionsList.propTypes = process.env.NODE_ENV !== "production" ? {
  suggestions: PropTypes.array.isRequired,
  onSelectSuggestion: PropTypes.func.isRequired,
  displaySuggestions: PropTypes.bool.isRequired,
  selectedSuggestion: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  showEmptyResult: PropTypes.bool,
  suggestionContainerRef: PropTypes.object,
  currState: PropTypes.object.isRequired,
  onHover: PropTypes.func.isRequired,
  branding: PropTypes.oneOf(['retail', 'marketplace']).isRequired,
  enableSisThemedBorder: PropTypes.bool
} : {};

var Autocomplete = function Autocomplete(_ref) {
  var inputLabel = _ref.inputLabel,
    placeholder = _ref.placeholder,
    suggestions = _ref.suggestions,
    onChangeHandler = _ref.onChangeHandler,
    disabled = _ref.disabled,
    selectedOption = _ref.selectedOption,
    InputValue = _ref.InputValue,
    setInputValue = _ref.setInputValue,
    showEmptyResult = _ref.showEmptyResult,
    onFocus = _ref.onFocus,
    resetOnFocus = _ref.resetOnFocus,
    branding = _ref.branding,
    inputId = _ref.inputId,
    isStore = _ref.isStore,
    enableSisThemedBorder = _ref.enableSisThemedBorder,
    type = _ref.type;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    filteredSuggestions = _useState2[0],
    setFilteredSuggestions = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedSuggestion = _useState4[0],
    setSelectedSuggestion = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    displaySuggestions = _useState6[0],
    setDisplaySuggestions = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showLabel = _useState8[0],
    setLabel = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isFocused = _useState10[0],
    setFocus = _useState10[1];
  var suggestionContainerRef = useRef(null);
  var inputRef = useRef(null);
  var _useReducer = useReducer(function (currState, action) {
      var cursor = currState.cursor,
        direction = currState.direction,
        hovering = currState.hovering;
      switch (action.type) {
        case 'NEXT':
          direction = 1;
          if (cursor < suggestions.length - 1) {
            cursor += 1;
          }
          hovering = false;
          return {
            cursor: cursor,
            direction: direction,
            hovering: hovering
          };
        case 'PREV':
          direction = -1;
          if (cursor > 0) {
            cursor -= 1;
          }
          hovering = false;
          return {
            cursor: cursor,
            direction: direction,
            hovering: hovering
          };
        case 'SET_CURR':
          hovering = true;
          return {
            cursor: action.payload,
            direction: direction,
            hovering: hovering
          };
        case 'RESET':
          return {
            cursor: -1,
            direction: 1,
            hovering: false
          };
        default:
          return currState;
      }
    }, {
      cursor: -1,
      direction: 1,
      hovering: false
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  useEffect(function () {
    if (selectedOption) {
      setSelectedSuggestion(selectedOption.name);
    }
  }, [selectedOption]);
  var resetInput = function resetInput() {
    setSelectedSuggestion(undefined);
    onChangeHandler(undefined);
    setFilteredSuggestions(suggestions);
    setInputValue('');
    dispatch({
      type: 'RESET'
    });
  };
  var onChange = function onChange(event) {
    var value = event.target.value;
    setInputValue(value);
    var filteredSuggestion = suggestions.filter(function (suggestion) {
      return suggestion.toLowerCase().includes(value.toLowerCase());
    });
    setFilteredSuggestions(filteredSuggestion);
    setDisplaySuggestions(true);
    if (!value) {
      resetInput();
    }
  };
  var discardSuggestions = function discardSuggestions() {
    setFilteredSuggestions([]);
    setDisplaySuggestions(false);
    setLabel(false);
    setFocus(false);
  };
  var onSelectSuggestion = function onSelectSuggestion(suggestion) {
    setSelectedSuggestion(suggestion);
    onChangeHandler(suggestion);
    discardSuggestions();
  };
  var setSuggestions = function setSuggestions() {
    if (!resetOnFocus && InputValue) {
      var filteredSuggestion = suggestions.filter(function (suggestion) {
        return suggestion.toLowerCase().includes(InputValue.toLowerCase());
      });
      setFilteredSuggestions(filteredSuggestion);
    } else {
      if (resetOnFocus) {
        resetInput();
      }
      setFilteredSuggestions(suggestions);
    }
    setDisplaySuggestions(true);
    setLabel(true);
    setFocus(true);
    if (onFocus) {
      onFocus();
    }
  };
  var CrossIcon = function CrossIcon() {
    return isFocused && jsx("i", {
      onClick: resetInput,
      className: styles$D['icon-close']
    });
  };
  var SearchIcon = function SearchIcon() {
    return jsx("i", {
      className: styles$D['icon-search']
    });
  };
  var handleKeyDown = function handleKeyDown(e) {
    var selectedIndex = state.cursor === -1 ? 0 : state.cursor;
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        dispatch({
          type: 'NEXT'
        });
        break;
      case 'ArrowUp':
        e.preventDefault();
        dispatch({
          type: 'PREV'
        });
        break;
      case 'Enter':
        e.preventDefault();
        if (InputValue) {
          if (filteredSuggestions.length > 0) {
            onSelectSuggestion(filteredSuggestions[selectedIndex]);
          }
        } else {
          onSelectSuggestion(suggestions[selectedIndex]);
        }
        break;
    }
  };
  var handleIconClick = function handleIconClick() {
    inputRef.current.focus();
    inputRef.current.click();
  };
  var showInputLabel = type === 1 ? showLabel || InputValue : true;
  return jsx(WithOutsideClick, {
    onOutsideClick: discardSuggestions,
    styles: {
      'doc-click-overlay': styles$D['doc-click-overlay']
    }
  }, jsx("div", {
    className: classNames(styles$D['autocomplete-input-wrapper'], styles$D["type".concat(type)])
  }, showInputLabel && jsx("label", {
    className: classNames(styles$D[branding], styles$D['floating-label'])
  }, ' ', inputLabel, ' '), jsx("input", {
    className: classNames(styles$D['autocomplete-input'], styles$D[branding], _defineProperty({}, styles$D['autocomplete-input-2'], type === 2)),
    type: "text",
    ref: inputRef,
    onChange: onChange,
    onFocus: setSuggestions,
    value: InputValue,
    placeholder: placeholder,
    disabled: disabled,
    autoComplete: "off",
    maxLength: 33,
    onKeyDown: handleKeyDown,
    id: inputId
  }), type === 1 ? jsx("span", {
    className: styles$D['floating-icon']
  }, InputValue ? jsx(CrossIcon, null) : jsx(SearchIcon, null)) : jsx("span", {
    onClick: handleIconClick,
    className: styles$D['arrow-icon']
  }), jsx(SuggestionsList, {
    inputValue: InputValue,
    selectedSuggestion: selectedSuggestion,
    onSelectSuggestion: onSelectSuggestion,
    displaySuggestions: displaySuggestions,
    suggestions: filteredSuggestions,
    showEmptyResult: showEmptyResult,
    suggestionContainerRef: suggestionContainerRef,
    currState: state,
    onHover: function onHover(i) {
      dispatch({
        type: 'SET_CURR',
        payload: i
      });
    },
    branding: branding,
    isStore: isStore,
    enableSisThemedBorder: enableSisThemedBorder
  })));
};
Autocomplete.defaultProps = {
  disabled: false,
  defaultOption: undefined,
  showEmptyResult: false,
  resetOnFocus: false,
  inputId: '',
  type: 1
};
Autocomplete.propTypes = process.env.NODE_ENV !== "production" ? {
  placeholder: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  suggestions: PropTypes.array.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  selectedOption: PropTypes.object.isRequired,
  defaultOption: PropTypes.object,
  InputValue: PropTypes.string.isRequired,
  setInputValue: PropTypes.func.isRequired,
  showEmptyResult: PropTypes.bool,
  onFocus: PropTypes.func,
  resetOnFocus: PropTypes.bool,
  branding: PropTypes.oneOf(['retail', 'marketplace']).isRequired,
  inputId: PropTypes.string,
  enableSisThemedBorder: PropTypes.bool,
  type: PropTypes.number
} : {};

var constants$2 = {
  REG_ID: 'regionData',
  COM_ID: 'comunaData',
  PROV_ID: 'provinceData',
  IS_ZONE_SELECTED: 'IS_ZONE_SELECTED',
  IS_PRESSURE_MODAL_INTERACTED: 'IS_PRESSURE_MODAL_INTERACTED',
  PRICE_GROUP_ID: 'priceGroupId',
  ZONES: 'zones',
  ZONE_DATA: 'zoneData',
  POLITICAL_ID: 'politicalId',
  POLITICAL_ID_EXISTS: 'isPoliticalIdExists',
  ADDRESS_LINES: 'addressLines',
  ADDRESS_IDS: 'addressId',
  MODAL_CLOSE_TIME: 350,
  USER_ZONE: 'userSelectedZone',
  PICKUP_IN_STORE: 'PickupInStore',
  HOME_DELIVERY: 'HomeDelivery',
  REMINDER_MODAL_TYPE: {
    USER_LOGGED_IN: 'USER_LOGGED_IN',
    INACTIVE: 'INACTIVE'
  },
  USER_LAST_SESSION: 'USER_LAST_SESSION',
  REACT_APP_GOOGLE_MAPS_API_KEY: 'AIzaSyDQcjKFGIhNTPtmcWyxCl_EcFvGbM3d7KM',
  ERROR_CODES: {
    INVALID_SESSION: 'INVALID_SESSION'
  }
};
var labels$4 = {
  PRESSURE_DESKTOP_LABLE: 'Ingresa tu ubicación',
  PRESSURE_MOBILE_LABLE: 'Ingresa tu ubicación',
  SELECTED_REGION_LABLE: 'Entrega en',
  SELECTED_REGION_LABLE_TOTTUS: 'Envío a:',
  MODAL_BANNER_TEXT: {
    cl: 'Ingresa tu ubicación y te mostraremos los productos disponibles con tiempos y costos de entrega precisos.',
    pe: 'Ingresa tu ubicación y te mostraremos los productos disponibles con tiempos y costos de entrega precisos.',
    co: 'Ingresa tu ubicación y te mostraremos los productos disponibles con tiempos y costos de entrega precisos.'
  },
  SELECT_BUTTON_MARKETPLACE: 'Guardar',
  SELECT_BUTTON_RETAIL: {
    desktop: 'GUARDAR UBICACIÓN',
    mobile: 'GUARDAR',
    tablet: 'GUARDAR'
  },
  MODAL_DESKTOP_HEADER: {
    cl: '¿Dónde quieres recibir tu compra?',
    pe: 'Ingresa tu ubicación',
    co: 'Ingresa tu ubicación'
  },
  MODAL_MOBILE_HEADER: {
    cl: '¿Dónde quieres recibir tu compra?',
    pe: 'Ingresa tu ubicación',
    co: 'Ingresa tu ubicación'
  },
  NEW_ZONE_MODAL_LABELS: {
    VIEW2: {
      HEADER: 'Confirma la dirección',
      WARNING_LABEL: 'Fija la ubicación exacta en el mapa',
      SAVE: 'Confirmar y guardar'
    },
    VIEW1: {
      HEADER: '¿Dónde quieres recibir tu compra?',
      BODY: 'Ingresa tu dirección y te mostraremos los productos disponibles para envío',
      SAVE: 'Continuar',
      GET_LAT_LONG_API_URL: "https://maps.googleapis.com/maps/api/geocode/json?key=".concat(constants$2.REACT_APP_GOOGLE_MAPS_API_KEY, "&address="),
      VALID_LOCALTION_TYPES: ['street_number', 'route']
    },
    VIEW3: {
      HEADER: '',
      BODY: 'Lo sentimos, aún no tenemos cobertura para esta dirección',
      URL: {
        cl: 'https://www.tottus.cl/tottus-cl/content/zonas-de-cobertura',
        pe: 'https://firebasestorage.googleapis.com/v0/b/tottus-orion-prod.appspot.com/o/helpline_peru%2Fhtmls%2Ffaq.html?alt=media&token=bd82f2f4-bb39-450b-8018-e02a601fc562'
      },
      LINK_TEXT1: 'Ver zonas de cobertura',
      LINK_TEXT2: 'Intentar con otra dirección',
      BUTTON: 'Seguir navegando'
    },
    VIEW4: {
      HEADER: '¿Dónde quieres recibir tu compra?',
      BODY: 'Ingresa tu dirección y te mostraremos los productos disponibles, para envío a tu dirección.',
      ACTION: 'Guardar',
      URL: {
        cl: 'https://www.tottus.cl/tottus-cl/content/zonas-de-cobertura',
        pe: 'https://firebasestorage.googleapis.com/v0/b/tottus-orion-prod.appspot.com/o/helpline_peru%2Fhtmls%2Ffaq.html?alt=media&token=bd82f2f4-bb39-450b-8018-e02a601fc562'
      },
      LINK_TEXT: 'Agregar otra dirección'
    },
    VIEW5: {
      HEADER: 'Eliminar dirección',
      BODY: '¿Estás seguro que quieres eliminar esta dirección? Al eliminarla, dejará de aparecer en tu lista de direcciones.',
      SAVE: 'Eliminar',
      CANCEL: 'Cancelar',
      LINK_TEXT: 'Agregar otra dirección'
    }
  },
  CANCEL: 'Cancelar',
  REVISAR_STOCK: 'Revisar stock',
  SEE_AVAILABILITY: 'Ver disponibilidad',
  KEEP_IT_TEXT: 'Mantener',
  SAVE_AS_PRIMARY_ADDRESS: 'Guardar como dirección principal.',
  USE_CURRENT_LOCATION: 'O <p>usa tu ubicación actual</p>',
  CHANGE_IT_TEXT: 'Cambiar',
  LOCATION_DETECTED_TEXT_PART_1: 'En tu última visita te mostramos productos para recibir en',
  LOCATION_DETECTED_TEXT_PART_2: 'Elige si quieres mantener la ubicación o cambiarla.',
  SUCCESS_LABEL_1: 'Ubicación guardada',
  SUCCESS_LABEL_2: 'Puedes cambiarla cuando quieras.',
  PRESSURE_LABEL_1: 'Elige dónde recibir tus productos',
  PRESSURE_LABEL_2: 'Podrás ver la disponibilidad y tiempos de entrega para tu despacho o retiro en tienda.',
  REMINDER_USER_LOGGED_IN: '¡Esta es tu ubicación favorita! La puedes cambiar para revisar productos disponibles en otros lugares.',
  REMINDER_USER_INACTIVE: '¡Está es tu última ubicación! La puedes cambiar para revisar productos disponibles en otros lugares.',
  DE_ERROR_LABEL: {
    co: 'Intenta con otro barrio',
    pe: 'Intenta con otro distrito',
    cl: 'Intenta con otra comuna'
  },
  ERROR_LOADING_MAPS: 'Error al cargar mapas'
};
var DEFAULT_ZONES_VALUE = {
  staging: {
    cl: {
      politicalId: '4856187d-c035-45ac-9f4e-9290b9e9f85f',
      priceGroupId: 96,
      zones: 'FAHD,PCL1169,CHILEXPRESS_8,PCL1310,BX_R13_BASE,PCL388,PCL1340,3045,PCL1339,IMKP,PCL1209,PCL63,13,PCL1207,PCL1493,ZL_CERRILLOS,PCL1103,PLUGINS1,PCL1294,ALHU,PCL268,STGZ,PCL2581,TOTTUS_001,PCL161,PCL1234,PCL2579,130617,PCL645,123,PCL67,LOSC,PCL138,PCL1208,ZONA_STARKEN,PCL1393,PCL1362,PCL1184,PCL773,PCL37,PCL1233,PCL2588'
    },
    pe: {
      politicalId: 'c6b7a50c-60f3-4687-91d0-9461d538812a',
      priceGroupId: 49,
      zones: 'IBIS_21,PPE2671,PPE4410,INTERNACIONAL,PPE4273,912_LIMA_2,PPE2526,912_LIMA_1,PPE2525,100,PPE4400,PPE46,SCADFBD_DIRECTO,PPE3883,PPE4023,PLUGINSPE1,PPE3884,PPE48,OLVAA_81,PPE4105,PPE49,150000,PPE14,IBIS_3PL_83,PPE4357,150101,PPE320,PPE47,ZONA1,PPE3882,09876,PPE44,URBANO_83,PPE3967'
    },
    co: {
      politicalId: '59a6aec4-fc51-4f3b-ab5e-62fd7a1076c0',
      priceGroupId: '19',
      zones: 'SERVIENTREGA_35,TCC_35,IBIS_02,DEPRISA_26,14,SERVI_CO,PLUGINS1CO,TEST_1'
    }
  },
  beta: {
    cl: {
      politicalId: '15c37b0b-a392-41a9-8b3b-978376c700d5',
      priceGroupId: 96,
      zones: 'FALABELLA_FBY_BT_SDD,PCL2829,REVERSE_RM_REDPROPIA,PCL2998,PCL3128,PCL2808,1234,PCL1223,PCL2802,PCL2826,PCL3019,PCL2281,PCL3009,HUB_SALIDA_DIRECTA_RM,PCL2120,PCL3043,PCL3025,BLUE_RM_URBANO,PCL115,3045,PCL1486,PCL2980,PCL1736,PCL1923,PCL2981,PCL2792,PCL3006,BX_R13_BASE,PCL226,PCL2847,PCL2901,PCL2827,PCL2979,PCL1389,PCL2843,ZL_CERRILLOS,PCL1135,PCL2977,SCD9039_FLEX,PCL105,FBY_RM_M,PCL2380,PCL2442,2020,PCL1186,PCL2864,FALABELLA_FBY_SDD,PCL2269,PCL2846,13,PCL861,PCL3015,FEDEX_RM_URB,PCL2520,LOSC,PCL540,CHILEXPRESS_8,PCL1839,FBY_BT_SALIDA_DIRECTA,PCL2288,PCL2978,PCL2862,PCL2803,PCL2890,PCL2838,RM,PCL108,PCL94,CHILE_INTERNATIONAL,PCL1364,PCL2801,PCL3011,PCL3017,13_MAIPU,PCL2830,PCL3026,PCL2845,PCL2982,PCL109,PCL3136,130617,PCL25,PCL2441,PCL184,PCL3012,PCL1336,STARKEN_R13,PCL3041,PCL2825,PCL2511,PCL3042'
    },
    pe: {
      politicalId: '799c102f-9b4c-44be-a421-23e366a63b82',
      priceGroupId: 2,
      zones: 'IBIS_51,PPE3342,PPE3361,PPE1112,PPE3384,912_LIMA_2,PPE1280,150000,PPE4,912_LIMA_1,PPE1279,150101,PPE344,PPE3059,PPE2492,IMP_2,PPE3331,PPE3357,PPE1091,PERF_TEST,PPE1653,PPE2486,OLVAA_81,PPE2815,IMP_1,PPE3164,PPE2918,URBANO_83,PPE2429,PPE3152,PPE3479,PPE3483,PPE3394,LIMA_URB1_DIRECTO,PPE2511,IBIS_19,PPE1382,IBIS_3PL_83,PPE3248'
    },
    co: {
      politicalId: 'bbea9a06-99b1-44de-bc6e-d314bca4fad3',
      priceGroupId: 10,
      zones: 'SERVIENTREGA_6,PCO137,SERVIENTREGA_83,PCO214,ENVIA_9,PCO618,DEPRISA_55,PCO96,DEPRISA_52,PCO93,PCO739,DEPRISA_46,PCO87,TCC_9,PCO234,DEPRISA_39,PCO80,PCO516,PCO522,SERVIENTREGA_76,PCO207,SERVIENTREGA_0,PCO31,COORDINADORA_87,PCO609,ENVIA_1,PCO610,ENVIA_71,PCO680,TCC_86,PCO311,ENVIA_65,PCO674,14,PCO14,SERVIENTREGA_15,PCO146,PCO726,99,PCO326,ENVIA_59,PCO668,TCC_66,PCO291,PCO746,SERVIENTREGA_61,PCO192,ENVIA_46,PCO655,TCC_73,PCO298,PCO745,DEPRISA_24,PCO65,TCC_78,PCO303,PCO710,TCC_19,PCO244,ENVIA_74,PCO683,PCO703,IBIS_DIRECTO_BO,PCO704,IBIS_6,PCO38,SERVIENTREGA_80,PCO211,DEPRISA_3,PCO44,DEPRISA_34,PCO75,TCC_3,PCO228,TCC_24,PCO249,SERVIENTREGA_21,PCO152,PCO32,ENVIA_54,PCO663,PCO714'
    }
  },
  production: {
    cl: {
      politicalId: '15c37b0b-a392-41a9-8b3b-978376c700d5',
      priceGroupId: 96,
      zones: 'FALABELLA_FBY_BT_SDD,PCL2829,REVERSE_RM_REDPROPIA,PCL2998,PCL3128,PCL2808,1234,PCL1223,PCL2802,PCL2826,PCL3019,PCL2281,PCL3009,HUB_SALIDA_DIRECTA_RM,PCL2120,PCL3043,PCL3025,BLUE_RM_URBANO,PCL115,3045,PCL1486,PCL2980,PCL1736,PCL1923,PCL2981,PCL2792,PCL3006,BX_R13_BASE,PCL226,PCL2847,PCL2901,PCL2827,PCL2979,PCL1389,PCL2843,ZL_CERRILLOS,PCL1135,PCL2977,SCD9039_FLEX,PCL105,FBY_RM_M,PCL2380,PCL2442,2020,PCL1186,PCL2864,FALABELLA_FBY_SDD,PCL2269,PCL2846,13,PCL861,PCL3015,FEDEX_RM_URB,PCL2520,LOSC,PCL540,CHILEXPRESS_8,PCL1839,FBY_BT_SALIDA_DIRECTA,PCL2288,PCL2978,PCL2862,PCL2803,PCL2890,PCL2838,RM,PCL108,PCL94,CHILE_INTERNATIONAL,PCL1364,PCL2801,PCL3011,PCL3017,13_MAIPU,PCL2830,PCL3026,PCL2845,PCL2982,PCL109,PCL3136,130617,PCL25,PCL2441,PCL184,PCL3012,PCL1336,STARKEN_R13,PCL3041,PCL2825,PCL2511,PCL3042'
    },
    pe: {
      politicalId: '799c102f-9b4c-44be-a421-23e366a63b82',
      priceGroupId: 2,
      zones: 'IBIS_51,PPE3342,PPE3361,PPE1112,PPE3384,912_LIMA_2,PPE1280,150000,PPE4,912_LIMA_1,PPE1279,150101,PPE344,PPE3059,PPE2492,IMP_2,PPE3331,PPE3357,PPE1091,PERF_TEST,PPE1653,PPE2486,OLVAA_81,PPE2815,IMP_1,PPE3164,PPE2918,URBANO_83,PPE2429,PPE3152,PPE3479,PPE3483,PPE3394,LIMA_URB1_DIRECTO,PPE2511,IBIS_19,PPE1382,IBIS_3PL_83,PPE3248'
    },
    co: {
      politicalId: 'bbea9a06-99b1-44de-bc6e-d314bca4fad3',
      priceGroupId: 10,
      zones: 'SERVIENTREGA_6,PCO137,SERVIENTREGA_83,PCO214,ENVIA_9,PCO618,DEPRISA_55,PCO96,DEPRISA_52,PCO93,PCO739,DEPRISA_46,PCO87,TCC_9,PCO234,DEPRISA_39,PCO80,PCO516,PCO522,SERVIENTREGA_76,PCO207,SERVIENTREGA_0,PCO31,COORDINADORA_87,PCO609,ENVIA_1,PCO610,ENVIA_71,PCO680,TCC_86,PCO311,ENVIA_65,PCO674,14,PCO14,SERVIENTREGA_15,PCO146,PCO726,99,PCO326,ENVIA_59,PCO668,TCC_66,PCO291,PCO746,SERVIENTREGA_61,PCO192,ENVIA_46,PCO655,TCC_73,PCO298,PCO745,DEPRISA_24,PCO65,TCC_78,PCO303,PCO710,TCC_19,PCO244,ENVIA_74,PCO683,PCO703,IBIS_DIRECTO_BO,PCO704,IBIS_6,PCO38,SERVIENTREGA_80,PCO211,DEPRISA_3,PCO44,DEPRISA_34,PCO75,TCC_3,PCO228,TCC_24,PCO249,SERVIENTREGA_21,PCO152,PCO32,ENVIA_54,PCO663,PCO714'
    }
  }
};
var configs$1 = {
  labels: labels$4,
  constants: constants$2,
  DEFAULT_ZONES_VALUE: DEFAULT_ZONES_VALUE
};

var styles$E = {"input-wrapper":"Select-module_input-wrapper__1_4N7","select-input":"Select-module_select-input__17wm1","retail":"Select-module_retail__2NiJT","blur":"Select-module_blur__20Vbj","select-input-2":"Select-module_select-input-2__1ZyzO","type2":"Select-module_type2__MAn3D","suggestions-list":"Select-module_suggestions-list__1SGda","arrow-icon":"Select-module_arrow-icon__2NZsD","suggestion":"Select-module_suggestion__1kpis","selected":"Select-module_selected__1UzF5","floating-label":"Select-module_floating-label__1Dq8C","marketplace":"Select-module_marketplace__LHHjY"};

var Select = function Select(_ref) {
  var onSelectChange = _ref.onSelectChange,
    fieldName = _ref.fieldName,
    defaultValue = _ref.defaultValue,
    fieldOptions = _ref.fieldOptions,
    disabled = _ref.disabled,
    placeholder = _ref.placeholder,
    branding = _ref.branding,
    selectId = _ref.selectId,
    type = _ref.type;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setFocus = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    selected = _useState4[0],
    setSelected = _useState4[1];
  var inputRef = useRef(null);
  var onChangeHandler = function onChangeHandler(e) {
    var selctedOption = fieldOptions.find(function (item) {
      return item.toString() === e.target.value.toString();
    });
    onSelectChange(selctedOption);
    setSelected(selctedOption);
  };
  var handleLabels = function handleLabels() {
    setFocus(false);
  };
  var showLabel = function showLabel() {
    if (type === 1) {
      setFocus(true);
    }
  };
  var handleIconClick = function handleIconClick(e) {
    inputRef.current.focus();
    inputRef.current.click();
  };
  var isLabelVisible = isFocused || defaultValue && defaultValue !== 'default' || selected;
  return jsx(WithOutsideClick, {
    onOutsideClick: handleLabels,
    styles: {
      'doc-click-overlay': styles$E['doc-click-overlay']
    }
  }, jsx("div", {
    className: classNames(styles$E['input-wrapper'], _defineProperty({}, styles$E["type".concat(2)], type === 2))
  }, isLabelVisible && jsx("label", {
    className: classNames(styles$E['floating-label'], styles$E[branding])
  }, fieldName), jsx("select", {
    name: fieldName,
    value: defaultValue,
    ref: inputRef,
    tabIndex: "0",
    onChange: onChangeHandler,
    onFocus: showLabel,
    disabled: disabled,
    className: classNames(styles$E['select-input'], styles$E[branding], styles$E[defaultValue ? '' : 'blur'], _defineProperty({}, styles$E['select-input-2'], type === 2)),
    key: "".concat(fieldName, "-select-box"),
    id: selectId
  }, jsx("option", {
    className: styles$E.suggestion,
    value: "",
    disabled: true,
    hidden: true
  }, placeholder), fieldOptions.map(function (field) {
    return jsx("option", {
      className: styles$E.suggestion,
      key: field,
      value: field
    }, field);
  })), type === 2 && jsx("span", {
    onTouchStart: handleIconClick,
    className: styles$E['arrow-icon']
  })));
};
Select.defaultProps = {
  fieldName: '',
  fieldOptions: [],
  defaultValue: '',
  onSelectChange: noop,
  disabled: false,
  placeholder: '',
  selectId: '',
  type: 1
};
Select.propTypes = process.env.NODE_ENV !== "production" ? {
  fieldName: PropTypes.string,
  fieldOptions: PropTypes.array,
  defaultValue: PropTypes.string,
  onSelectChange: PropTypes.func,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  branding: PropTypes.oneOf(['retail', 'marketplace']).isRequired,
  type: PropTypes.number,
  selectId: PropTypes.string
} : {};

function DeliveryOptionsError(_ref) {
  var deliveryOptions = _ref.deliveryOptions,
    tenant = _ref.tenant;
  var labels = configs$1.labels;
  return jsx("div", {
    className: styles$C['delivery-options-error-container']
  }, jsx("div", {
    className: classNames(styles$C['delivery-options-error'], _defineProperty({}, styles$C.homeDelivery, get(deliveryOptions, 'type', '') === 'HomeDelivery'))
  }, jsx("i", {
    className: styles$C['delivery-options-location-icon']
  }), jsx("p", {
    className: classNames(styles$C['delivery-options-error-heading'], _defineProperty({}, styles$C.homeDelivery, get(deliveryOptions, 'type', '') === 'HomeDelivery'))
  }, 'No disponible', jsx("span", {
    className: styles$C.normal
  }, " ".concat(get(deliveryOptions, 'type', '') === 'HomeDelivery' ? 'en' : 'en puntos de retiro en', " ")), jsx("span", {
    className: styles$C.capitalise
  }, "".concat(get(deliveryOptions, 'comunaName', '').toLowerCase())))), jsx("div", {
    className: styles$C['delivery-options-error-subheading-container']
  }, jsx("p", {
    className: styles$C['delivery-options-error-subheading']
  }, 'Lo sentimos.', " ", jsx("span", {
    className: styles$C.bold
  }, labels.DE_ERROR_LABEL[tenant]), " o revisa la disponibilidad del ".concat(get(deliveryOptions, 'type', '') === 'HomeDelivery' ? 'retiro en un punto.' : 'envío a domicilio.'))));
}
DeliveryOptionsError.propTypes = process.env.NODE_ENV !== "production" ? {
  deliveryOptions: PropTypes.object.isRequired,
  tenant: PropTypes.string.isRequired
} : {};

var inputLabel = {
  states: {
    desktop: {
      cl: 'Región',
      pe: 'Departamento',
      co: 'Departamento'
    },
    mobile: {
      cl: 'Región',
      pe: 'Departamento',
      co: 'Departamento'
    }
  },
  communa: {
    desktop: {
      cl: '',
      pe: 'Provincia',
      co: 'Ciudad'
    },
    mobile: {
      cl: '',
      pe: 'Provincia',
      co: 'Ciudad'
    }
  },
  districts: {
    desktop: {
      cl: 'Comuna',
      pe: 'Distrito',
      co: 'Barrio'
    },
    mobile: {
      cl: 'Comuna',
      pe: 'Distrito',
      co: 'Barrio'
    }
  }
};
var placeholder = {
  states: {
    desktop: {
      cl: 'Ingresa una Región',
      pe: 'Ingresa una departamento',
      co: 'Ingresa un departamento'
    },
    mobile: {
      cl: 'Selecciona una Región',
      pe: 'Selecciona una departamento',
      co: 'Selecciona un departamento'
    }
  },
  communa: {
    desktop: {
      cl: '',
      pe: 'Ingresa una provincia',
      co: 'Ingresa una ciudad'
    },
    mobile: {
      cl: '',
      pe: 'Selecciona una provincia',
      co: 'Selecciona una ciudad'
    }
  },
  districts: {
    desktop: {
      cl: 'Ingresa una Comuna',
      pe: 'Ingresa un distrito',
      co: 'Ingresa un barrio'
    },
    mobile: {
      cl: 'Selecciona una Comuna',
      pe: 'Selecciona un distrito',
      co: 'Selecciona un barrio'
    }
  }
};

var ModalContent = function ModalContent(_ref) {
  var regionsSuggestion = _ref.regionsSuggestion,
    comunaSuggestion = _ref.comunaSuggestion,
    regionChangeHandler = _ref.regionChangeHandler,
    selectedRegion = _ref.selectedRegion,
    comunaChangeHandler = _ref.comunaChangeHandler,
    selectedComuna = _ref.selectedComuna,
    deviceType = _ref.deviceType,
    saveZone = _ref.saveZone,
    getSavedZone = _ref.getSavedZone,
    regionInputValue = _ref.regionInputValue,
    setRegionInputValue = _ref.setRegionInputValue,
    comunaInputValue = _ref.comunaInputValue,
    setComunaInputValue = _ref.setComunaInputValue,
    setModalVisible = _ref.setModalVisible,
    enableEnter = _ref.enableEnter,
    onFocus = _ref.onFocus,
    branding = _ref.branding,
    tenant = _ref.tenant,
    provinceSuggestion = _ref.provinceSuggestion,
    provinceChangeHandler = _ref.provinceChangeHandler,
    selectedProvince = _ref.selectedProvince,
    provinceInputValue = _ref.provinceInputValue,
    setProvinceInputValue = _ref.setProvinceInputValue,
    stockEnTienda = _ref.stockEnTienda,
    setSaveLocation = _ref.setSaveLocation,
    saveLocation = _ref.saveLocation,
    deliveryOptions = _ref.deliveryOptions,
    isDefaultComuna = _ref.isDefaultComuna,
    isStore = _ref.isStore,
    enableSisThemedBorder = _ref.enableSisThemedBorder,
    isSodimacStandAlone = _ref.isSodimacStandAlone,
    selectedZone = _ref.selectedZone;
  var labels = configs$1.labels,
    constants = configs$1.constants;
  var isStockEnTiendaModal = !!Object.keys(stockEnTienda).length;
  var isDeliveryOptionsModal = !isEmpty(deliveryOptions);
  var pickupInStoreData = get(deliveryOptions, 'pickupInStoreData', []);
  var selectedPickupInStoreId = get(deliveryOptions, 'selectedPickupInStoreId', null);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    regions = _useState2[0],
    setRegions = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    comunas = _useState4[0],
    setComunas = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    provinces = _useState6[0],
    setProvinces = _useState6[1];
  var geofinderLevel3Id = tenant === 'cl' ? 'geofinder-input-level2' : 'geofinder-input-level3';
  var onPressEnter = function onPressEnter(e) {
    var shouldSaveZone = tenant !== 'cl' ? selectedRegion && selectedProvince && selectedComuna : selectedRegion && selectedComuna;
    if (e.key === 'Enter' && shouldSaveZone && enableEnter) {
      saveZone();
    }
  };
  var getModalHeader = function getModalHeader() {
    if (isStockEnTiendaModal) {
      return jsx("p", {
        className: classNames(styles$C['modal-heading'], styles$C.bold)
      }, stockEnTienda.title);
    }
    if (isDeliveryOptionsModal) {
      return jsx("p", {
        className: classNames(styles$C['modal-heading'], styles$C.bold, _defineProperty({}, styles$C.pickupInStore, isDeliveryOptionsModal && get(deliveryOptions, 'type', '') === constants.PICKUP_IN_STORE))
      }, deliveryOptions.title);
    }
    if (selectedComuna && regionInputValue) {
      return jsx("p", {
        className: styles$C['modal-heading']
      }, jsx("span", {
        className: styles$C['mr-4']
      }, labels.SELECTED_REGION_LABLE), jsx("span", {
        className: styles$C['modal-zone-name']
      }, " ".concat(selectedComuna.name, " ")));
    }
    return jsx("p", {
      className: classNames(styles$C['modal-heading'], styles$C.bold)
    }, deviceType === 'desktop' ? labels.MODAL_DESKTOP_HEADER[tenant] : labels.MODAL_MOBILE_HEADER[tenant]);
  };
  useEffect(function () {
    if (isDeliveryOptionsModal) {
      if (deliveryOptions.type && deliveryOptions.type === constants.HOME_DELIVERY) {
        var getHomeDeliveryData = get(deliveryOptions, 'getHomeDeliveryData', undefined);
        if (getHomeDeliveryData && getHomeDeliveryData instanceof Function) {
          getHomeDeliveryData(selectedComuna, true);
        }
      }
    }
  }, []);
  useEffect(function () {
    getSavedZone();
    setRegions(regionsSuggestion.map(function (item) {
      return item.name;
    }));
  }, [regionsSuggestion]);
  useEffect(function () {
    setProvinces(provinceSuggestion.map(function (item) {
      return item.name;
    }));
  }, [provinceSuggestion]);
  useEffect(function () {
    setComunas(comunaSuggestion.map(function (item) {
      return item.name;
    }));
  }, [comunaSuggestion]);
  useEffect(function () {
    window.addEventListener('keydown', onPressEnter);
    return function () {
      window.removeEventListener('keydown', onPressEnter);
    };
  }, [enableEnter]);
  useEffect(function () {
    if (isDeliveryOptionsModal && (deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.type) === constants.PICKUP_IN_STORE && deliveryOptions !== null && deliveryOptions !== void 0 && deliveryOptions.getPickupInStoreData && !isEmpty(selectedZone)) {
      deliveryOptions.getPickupInStoreData(selectedZone, true);
    }
  }, []);
  var shouldButtonDisable = function shouldButtonDisable() {
    if (tenant !== 'cl') {
      return !(selectedRegion && selectedComuna && selectedProvince && regionInputValue && provinceInputValue && comunaInputValue);
    }
    return !(selectedRegion && selectedComuna && regionInputValue && comunaInputValue);
  };
  var getDeliveryOptionsButtonLabel = function getDeliveryOptionsButtonLabel() {
    if (isDefaultComuna && deliveryOptions.error) {
      return "".concat(labels.SELECT_BUTTON_MARKETPLACE, " comuna");
    }
    return labels.SEE_AVAILABILITY;
  };
  var shouldDeliveryButtonBeDisabled = function shouldDeliveryButtonBeDisabled() {
    if (isStockEnTiendaModal) {
      return !(selectedRegion && selectedComuna && regionInputValue && comunaInputValue);
    }
    return !(selectedRegion && selectedComuna && regionInputValue && comunaInputValue && !deliveryOptions.error && !deliveryOptions.disableButton);
  };
  return jsx("div", {
    className: classNames(styles$C['zone-modal-body'], styles$C[branding], _defineProperty(_defineProperty({}, styles$C.stockEnTienda, !!isStockEnTiendaModal || !!isDeliveryOptionsModal), styles$C.deliveryOptions, !!isDeliveryOptionsModal))
  }, jsx("div", {
    className: "".concat(styles$C['modal-header'], " ").concat(styles$C[branding])
  }, jsx("i", {
    className: classNames(styles$C['icon-location'], styles$C['icon-header'], styles$C[branding], _defineProperty(_defineProperty({}, styles$C.homeDelivery, isDeliveryOptionsModal && get(deliveryOptions, 'type', '') === constants.HOME_DELIVERY), styles$C.pickupInStore, isDeliveryOptionsModal && get(deliveryOptions, 'type', '') === constants.PICKUP_IN_STORE))
  }, jsx("span", {
    className: styles$C['sr-only']
  }, "location-icon")), getModalHeader()), jsx("button", {
    type: "button",
    className: "".concat(styles$C['modal-btn-close'], "\n         ").concat(styles$C[branding]),
    id: "testId-zone-modal-close",
    onClick: function onClick() {
      return setModalVisible(false);
    }
  }, jsx("div", {
    className: "".concat(styles$C['icon-close'])
  })), jsx("div", {
    className: styles$C['modal-content']
  }, !isDeliveryOptionsModal && jsx("p", {
    className: styles$C['banner-text']
  }, isStockEnTiendaModal ? stockEnTienda.bannerText[deviceType] : labels.MODAL_BANNER_TEXT[tenant]), jsx("div", {
    className: styles$C['input-wrapper'],
    key: "wrapper-region"
  }, deviceType === 'desktop' ? jsx(Autocomplete, {
    inputLabel: inputLabel.states.desktop[tenant],
    placeholder: placeholder.states.desktop[tenant],
    key: "Ingresa una Regi\xF3n",
    suggestions: regions,
    onChangeHandler: regionChangeHandler,
    disabled: !(regions.length > 0),
    selectedOption: selectedRegion,
    InputValue: regionInputValue,
    setInputValue: setRegionInputValue,
    showEmptyResult: true,
    onFocus: onFocus,
    resetOnFocus: true,
    branding: branding,
    inputId: "geofinder-input-level1",
    isStore: isStore,
    enableSisThemedBorder: enableSisThemedBorder,
    isSodimacStandAlone: isSodimacStandAlone
  }) : jsx(Select, {
    fieldName: inputLabel.states.mobile[tenant],
    placeholder: placeholder.states.mobile[tenant],
    key: "Selecciona una regi\xF3n",
    onSelectChange: regionChangeHandler,
    fieldOptions: regions,
    disabled: !(regions.length > 0),
    defaultValue: selectedRegion ? selectedRegion.name : '',
    branding: branding,
    selectId: "geofinder-input-level1"
  })), tenant !== 'cl' && jsx("div", {
    className: styles$C['provincia-wrapper'],
    key: "wrapper-provincia"
  }, deviceType === 'desktop' ? jsx(Autocomplete, {
    inputLabel: inputLabel.communa.desktop[tenant],
    placeholder: placeholder.communa.desktop[tenant],
    key: "Ingresa una provincia",
    suggestions: provinces,
    onChangeHandler: provinceChangeHandler,
    disabled: !(selectedRegion && provinces.length > 0),
    selectedOption: selectedProvince,
    InputValue: provinceInputValue,
    setInputValue: setProvinceInputValue,
    showEmptyResult: true,
    onFocus: onFocus,
    resetOnFocus: true,
    branding: branding,
    inputId: "geofinder-input-level2",
    isStore: isStore,
    enableSisThemedBorder: enableSisThemedBorder
  }) : jsx(Select, {
    fieldName: inputLabel.communa.mobile[tenant],
    placeholder: placeholder.communa.mobile[tenant],
    key: "Selecciona una provincia",
    onSelectChange: provinceChangeHandler,
    fieldOptions: provinces,
    disabled: !(selectedRegion && provinces.length > 0),
    defaultValue: selectedProvince ? selectedProvince.name : '',
    branding: branding,
    selectId: "geofinder-input-level2"
  })), jsx("div", {
    className: classNames(styles$C['comuna-wrapper'], _defineProperty({}, styles$C.deliveryOptionsError, deliveryOptions.error)),
    key: "wrapper-comuna"
  }, deviceType === 'desktop' ? jsx(Autocomplete, {
    inputLabel: inputLabel.districts.desktop[tenant],
    placeholder: placeholder.districts.desktop[tenant],
    key: "Ingresa una Comuna",
    suggestions: comunas,
    onChangeHandler: comunaChangeHandler,
    disabled: tenant !== 'cl' ? !(selectedRegion && selectedProvince && comunas.length > 0) : !(selectedRegion && comunas.length > 0),
    selectedOption: selectedComuna,
    InputValue: comunaInputValue,
    setInputValue: setComunaInputValue,
    onFocus: onFocus,
    showEmptyResult: true,
    resetOnFocus: true,
    branding: branding,
    inputId: geofinderLevel3Id,
    isStore: isStore,
    enableSisThemedBorder: enableSisThemedBorder
  }) : jsx(Select, {
    fieldName: inputLabel.districts.mobile[tenant],
    placeholder: placeholder.districts.mobile[tenant],
    key: "Selecciona una comuna",
    onSelectChange: comunaChangeHandler,
    fieldOptions: comunas,
    disabled: tenant !== 'cl' ? !(selectedRegion && selectedProvince && comunas.length > 0) : !(selectedRegion && comunas.length > 0),
    defaultValue: selectedComuna ? selectedComuna.name : '',
    branding: branding,
    selectId: geofinderLevel3Id
  })), jsx(React.Fragment, null, isDeliveryOptionsModal && deliveryOptions.error && deliveryOptions.comunaName && jsx(DeliveryOptionsError, {
    deliveryOptions: deliveryOptions,
    tenant: tenant
  }))), isStockEnTiendaModal || isDeliveryOptionsModal ? jsx("div", {
    className: styles$C['stock-en-tienda-footer']
  }, jsx("button", {
    type: "button",
    className: styles$C['btn-zone-select-cancel'],
    onClick: function onClick() {
      return setModalVisible(false);
    }
  }, labels.CANCEL), jsx("button", {
    id: "testId-select-stock",
    type: "button",
    className: classNames(styles$C['btn-zone-select-stock-en-tienda'], _defineProperty(_defineProperty({}, styles$C.deliveryOptions, isDeliveryOptionsModal), styles$C.so_com, isSodimacStandAlone)),
    disabled: shouldDeliveryButtonBeDisabled(),
    onClick: saveZone
  }, isDeliveryOptionsModal ? getDeliveryOptionsButtonLabel() : labels.REVISAR_STOCK)) : jsx("button", {
    type: "button",
    className: classNames(styles$C["btn-zone-select-".concat(branding)], _defineProperty(_defineProperty({}, styles$C.storeButton, isStore), styles$C.so_com, isSodimacStandAlone)),
    disabled: shouldButtonDisable(),
    onClick: saveZone,
    id: "geofinder-button-save"
  }, branding === 'marketplace' ? labels.SELECT_BUTTON_MARKETPLACE : labels.SELECT_BUTTON_RETAIL[deviceType]));
};
ModalContent.propTypes = process.env.NODE_ENV !== "production" ? {
  regionsSuggestion: PropTypes.array.isRequired,
  regionChangeHandler: PropTypes.func.isRequired,
  selectedRegion: PropTypes.object.isRequired,
  comunaSuggestion: PropTypes.array.isRequired,
  comunaChangeHandler: PropTypes.func.isRequired,
  selectedComuna: PropTypes.object.isRequired,
  deviceType: PropTypes.string.isRequired,
  saveZone: PropTypes.func.isRequired,
  getSavedZone: PropTypes.func.isRequired,
  regionInputValue: PropTypes.string.isRequired,
  setRegionInputValue: PropTypes.func.isRequired,
  comunaInputValue: PropTypes.string.isRequired,
  setComunaInputValue: PropTypes.func.isRequired,
  setModalVisible: PropTypes.func.isRequired,
  enableEnter: PropTypes.bool,
  onFocus: PropTypes.func,
  branding: PropTypes.oneOf(['retail', 'marketplace']).isRequired,
  tenant: PropTypes.string.isRequired,
  provinceSuggestion: PropTypes.array.isRequired,
  provinceChangeHandler: PropTypes.func.isRequired,
  selectedProvince: PropTypes.object.isRequired,
  provinceInputValue: PropTypes.string.isRequired,
  setProvinceInputValue: PropTypes.func.isRequired,
  stockEnTienda: PropTypes.object,
  selectedZone: PropTypes.object,
  deliveryOptions: PropTypes.object,
  isDefaultComuna: PropTypes.bool,
  enableSisThemedBorder: PropTypes.bool,
  isSodimacStandAlone: PropTypes.bool
} : {};
ModalContent.defaultProps = {
  stockEnTienda: {},
  deliveryOptions: {},
  selectedZone: {},
  isDefaultComuna: false,
  enableSisThemedBorder: false,
  isSodimacStandAlone: false
};

var mapMarker = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M7.09637 14.7234L11.5964 20.2234L14.0964 17.7234L16.0964 15.2234C16.5964 14.0567 17.5964 11.6234 17.5964 11.2234V8.72339L16.5964 5.72339L15.5964 4.22339L10.5964 3.22339L8.59637 3.72339L7.09637 5.22339L5.59637 7.22339L5.09637 9.72339L7.09637 14.7234Z\" fill=\"white\" stroke=\"white\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.5964 3.4468C8.19992 3.4468 5.4468 6.19992 5.4468 9.5964V9.7684C5.4468 10.493 5.67953 11.363 6.09882 12.3249C6.51467 13.2789 7.09358 14.2775 7.73759 15.2463C9.02572 17.1841 10.5363 18.9468 11.4088 19.9152C11.5105 20.0281 11.6822 20.0282 11.7838 19.9153C12.6564 18.947 14.1671 17.1841 15.4552 15.2463C16.0992 14.2775 16.6781 13.2789 17.094 12.3249C17.5133 11.363 17.746 10.493 17.746 9.7684V9.5964C17.746 6.19992 14.9929 3.4468 11.5964 3.4468ZM4 9.5964C4 5.40088 7.40088 2 11.5964 2C15.7919 2 19.1928 5.40088 19.1928 9.5964V9.7684C19.1928 10.7743 18.8778 11.8534 18.4203 12.903C17.9593 13.9605 17.3323 15.0359 16.6601 16.0472C15.3157 18.0697 13.7523 19.892 12.8588 20.8836V20.8836C12.1825 21.6345 11.0103 21.6345 10.334 20.8836V20.8836C9.4405 19.892 7.87708 18.0697 6.53271 16.0472C5.86047 15.0359 5.2335 13.9605 4.77254 12.903C4.31502 11.8534 4 10.7743 4 9.7684V9.5964Z\" fill=\"#333333\"/>\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.873 9.6414C8.873 8.13688 10.0919 6.918 11.5964 6.918C13.1009 6.918 14.3198 8.13688 14.3198 9.6414V9.6784C14.3198 11.1829 13.1009 12.4018 11.5964 12.4018C10.0919 12.4018 8.873 11.1829 8.873 9.6784C8.873 9.67221 8.87308 9.66605 8.87323 9.6599C8.87308 9.65375 8.873 9.64759 8.873 9.6414ZM10.3196 9.6599C10.3197 9.66605 10.3198 9.67221 10.3198 9.6784C10.3198 10.3839 10.8909 10.955 11.5964 10.955C12.3019 10.955 12.873 10.3839 12.873 9.6784V9.6414C12.873 8.93592 12.3019 8.3648 11.5964 8.3648C10.8909 8.3648 10.3198 8.93592 10.3198 9.6414C10.3198 9.64759 10.3197 9.65375 10.3196 9.6599Z\" fill=\"#333333\"/>\n<circle cx=\"11.6464\" cy=\"9.67336\" r=\"1.35\" fill=\"white\"/>\n</svg>\n";

var styles$F = {"map-container":"GoogleMaps-module_map-container__27afb","skeleton-placeholder":"GoogleMaps-module_skeleton-placeholder__1KqU6","skeleton-box":"GoogleMaps-module_skeleton-box__2delG","shimmer":"GoogleMaps-module_shimmer__3oJA0","skeleton-map":"GoogleMaps-module_skeleton-map__1id4Z"};

var entry$5 = {
	cmr_puntos_button: {
		desktop: {
			href: "",
			icon: {
			},
			order: {
			},
			title: ""
		},
		enabled: false,
		is_new_tab: false,
		mobile: {
			href: "",
			icon: {
			},
			order: {
			},
			title: ""
		}
	},
	country_selector: [
		{
			items: [
				{
					tenant_name: "Argentina",
					tenant_name_short: "ar",
					url: "https://www.falabella.com.ar/falabella-ar",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagAr.svg"
				},
				{
					tenant_name: "Colombia",
					tenant_name_short: "co",
					url: "https://www.falabella.com.co/falabella-co",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagCo.svg"
				},
				{
					tenant_name: "Chile",
					tenant_name_short: "cl",
					url: "https://www.falabella.com/falabella-cl",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagCl.svg"
				},
				{
					tenant_name: "Perú",
					tenant_name_short: "pe",
					url: "https://www.falabella.com.pe/falabella-pe",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagPe.svg"
				},
				{
					tenant_name: "Home Corporativo",
					tenant_name_short: "corp",
					url: "https://www.falabella.com/static/staticContent/common/COR/homeCorporativo.html?p=1",
					flag_url: "https://www.falabella.com/apple-touch-icon.png"
				}
			],
			tags: [
			],
			title: "HEADER - COUNTRY SELECTOR"
		}
	],
	desktop_util_buttons: {
		bolsa: [
			{
				title: "HEADER - DESKTOP UTIL - 3 Bolsa",
				link: {
					title: "Bolsa",
					href: "https://www.falabella.com.ar/falabella-ar/basket"
				},
				image: {
					is_dir: false,
					filename: "header-stage-desktop-bag.svg",
					tags: [
					],
					title: "header-stage-desktop-bag.svg",
					url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blte1d682668107b307/60834f6ee0753d466aa6d273/header-stage-desktop-bag.svg"
				},
				is_new_tab: false,
				must_be_logged_in: false,
				tags: [
				]
			}
		],
		inicia_sesion: [
			{
				image: {
					filename: "header-account.svg",
					title: "header-account.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/bltd9f8f0fc9073d770/60072ae17957730fa57a8ada/header-account.svg"
				},
				is_new_tab: false,
				link: {
					title: "Inicia sesión",
					href: "https://www.falabella.com.ar/falabella-ar/myaccount/homeZP.jsp"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - DESKTOP UTIL - 1 Sesión"
			}
		],
		inicia_sesion_dropdown: {
			menu_items_with_url: [
				{
					title: "Mi Cuenta",
					href: "/falabella-ar/myaccount/homeZP.jsp"
				},
				{
					title: "Mis órdenes",
					href: "/falabella-ar/mi-cuenta/ordenes"
				}
			],
			menu_items_without_url: {
				cerrar_sesion: "Cerrar sesión"
			},
			cmr_puntos_button: {
				enabled: false,
				href: "",
				is_new_tab: false,
				title: ""
			},
			menu_items_with_atg_url: [
				{
					title: "Mi Cuenta",
					href: "/falabella-ar/myaccount/homeZP.jsp"
				},
				{
					title: "Mis órdenes",
					href: "/falabella-ar/mi-cuenta/ordenes"
				}
			]
		},
		mis_compras: [
			{
				title: "HEADER - DESKTOP UTIL - 2 Órdenes",
				link: {
					title: "Mis órdenes",
					href: "https://www.falabella.com.ar/falabella-ar/mi-cuenta/ordenes"
				},
				image: {
					is_dir: false,
					filename: "header-stage-desktop-orders.svg",
					tags: [
					],
					title: "header-stage-desktop-orders.svg",
					url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt09bd453534a3661f/60834762b35a7a3c69a38622/header-stage-desktop-orders.svg"
				},
				is_new_tab: false,
				must_be_logged_in: true,
				tags: [
				]
			}
		]
	},
	headerconfig: {
		links: {
			atgbaseurl: "https://www.falabella.com.ar",
			catalystbaseurl: "https://www.falabella.com.ar"
		},
		toggles: {
			isatgloginenabled: true,
			isgeolocationenabled: false,
			istypeaheadenabled: true,
			iszonemodalenabled: false
		}
	},
	links: {
		bottom_left: [
		],
		bottom_right: [
			{
				items: [
					{
						title: "Nuestras tiendas",
						url: "https://www.falabella.com.ar/falabella-ar/page/Nuestras-tiendas?staticPageId=10200005&uxref=tiendas",
						is_new_tab: false
					},
					{
						title: "Servicio al cliente",
						url: "https://www.falabella.com.ar/falabella-ar/page/Servicio-al-cliente?staticPageId=10200044&uxref=sac",
						is_new_tab: false
					},
					{
						title: "CMR",
						url: "https://www.cmrfalabella.com.ar/",
						is_new_tab: true
					},
					{
						title: "Botón de arrepentimiento",
						url: "https://www.falabella.com.ar/falabella-ar/page/Cancelar-mi-compra?staticPageId=13000007",
						is_new_tab: false
					}
				],
				tags: [
				],
				title: "HEADER - BOTTOM RIGHT",
				vertical_bars: false
			}
		],
		top_left: [
			{
				items: [
					{
						title: "Venta telefónica 0810 666 6685",
						url: "https://www.falabella.com.ar/falabella-ar/category/cat60018/Venta-telefonica",
						is_new_tab: false
					}
				],
				tags: [
				],
				title: "HEADER - TOP LEFT",
				vertical_bars: false
			}
		],
		top_right: [
			{
				items: [
					{
						title: "Venta Corporativa",
						url: "https://www.falabella.com.ar/falabella-ar/page/Gift-cards?staticPageId=13300001",
						is_new_tab: true
					},
					{
						title: "Viajes",
						url: "http://www.viajesfalabella.com.ar/",
						is_new_tab: true
					},
					{
						title: "Seguros",
						url: "https://web.segurosfalabella.com/ar/",
						is_new_tab: true
					},
					{
						title: "Sodimac",
						url: "http://www.sodimac.com.ar/",
						is_new_tab: true
					}
				],
				tags: [
				],
				title: "HEADER - TOP RIGHT",
				vertical_bars: true
			}
		]
	},
	logo_icon: {
		filename: "falabella-logo.svg",
		title: "falabella-logo.svg",
		is_dir: false,
		tags: [
		],
		url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt07072e69e68f1133/5ffebc0d7c627d662d7fdc1a/falabella-logo.svg"
	},
	mis_compras_dropdown: {
		button: [
			{
				image: {
					filename: "icon-bag_ma.svg",
					title: "icon-bag_ma.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt461d3ba8ff03060f/60833df5e650b13fbe213c64/icon-bag_ma.svg"
				},
				is_new_tab: false,
				link: {
					title: "IR A MIS COMPRAS",
					href: "https://www.falabella.com.ar/falabella-ar/mi-cuenta/ordenes"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - TRACKING - Boton"
			}
		],
		description: "",
		menu_items: [
			{
				icon_image: {
					filename: "tracking.svg",
					title: "tracking.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/bltfb839f95638356ba/60072aa30a80720ff10f1318/tracking.svg"
				},
				icon_link: {
					title: "Trackea el estado de tu orden",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - 1 Trackea"
			},
			{
				icon_image: {
					filename: "change.svg",
					title: "change.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt192647d7b36c40d4/60072ab14485e50f8f208eaa/change.svg"
				},
				icon_link: {
					title: "Realiza cambios o devoluciones",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - 2 Cambios"
			},
			{
				icon_image: {
					filename: "boleta.svg",
					title: "boleta.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/bltbb086ae23655ed4a/60072ac70069f70f7771dc81/boleta.svg"
				},
				icon_link: {
					title: "Imprime tu boleta o ticket de cambio",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - 3 Boleta"
			}
		],
		title: "¡Conoce los detalles de tu compra en un solo lugar!",
		help: [
			{
				title: "HEADER - HELP BUTTON",
				link: {
					title: "¿Necesitas ayuda?",
					href: ""
				},
				image: {
				},
				is_new_tab: false,
				must_be_logged_in: false,
				tags: [
				]
			}
		]
	},
	mobile_menu_buttons: [
		{
			image: {
				parent_uid: "blt0bb18aa096bef9de",
				filename: "icon-web-my-account_(1).svg",
				title: "icon-web-my-account_(1).svg",
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt4454368caa6f9db1/5f3dbf3da2d0da1276202ae4/icon-web-my-account_(1).svg"
			},
			is_new_tab: false,
			link: {
				title: "Mi Cuenta",
				href: "https://www.falabella.com.ar/falabella-ar/myaccount/homeZP.jsp"
			},
			must_be_logged_in: true,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 1 Cuenta"
		},
		{
			image: {
				parent_uid: "blt0bb18aa096bef9de",
				filename: "icon-web-my-orders_(1).svg",
				title: "icon-web-my-orders_(1).svg",
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt4e8d4c8317471de1/5f3dbf3dd2d0bd0ea12f0cb6/icon-web-my-orders_(1).svg"
			},
			is_new_tab: false,
			link: {
				title: "Mis órdenes",
				href: "https://www.falabella.com.ar/falabella-ar/mi-cuenta/ordenes"
			},
			must_be_logged_in: true,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 2 Ordenes"
		},
		{
			image: {
				parent_uid: "blt0bb18aa096bef9de",
				filename: "icon-web-time_(1).svg",
				title: "icon-web-time_(1).svg",
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/bltae878515f1a4900e/5f3dbf3d004c131277a52afc/icon-web-time_(1).svg"
			},
			is_new_tab: false,
			link: {
				title: "Horarios de tiendas",
				href: "https://www.falabella.com.ar/falabella-ar/page/Nuestras-tiendas?staticPageId=10200005&uxref=tiendas"
			},
			must_be_logged_in: false,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 3 Horarios Tiendas"
		}
	],
	mobile_promotional_links: [
		{
			title: "VENTA TELEFÓNICA 0810 666 6685",
			url: "https://www.falabella.com.ar/falabella-ar/category/cat60018/Venta-telef%C3%B3nica",
			is_new_tab: false
		},
		{
			title: "TIENDAS",
			url: "https://www.falabella.com.ar/falabella-ar/page/Nuestras-tiendas?staticPageId=10200005",
			is_new_tab: false
		},
		{
			title: "SERVICIO AL CLIENTE",
			url: "https://www.falabella.com.ar/falabella-ar/page/Servicio-al-cliente?staticPageId=10200044",
			is_new_tab: false
		},
		{
			title: "VENTA CORPORATIVA",
			url: "http://falabellacorporativa.com.ar/",
			is_new_tab: false
		},
		{
			title: "CMR",
			url: "https://www.cmrfalabella.com.ar/home?utm_source=falabella&utm_medium=sitio&utm_campaign=head",
			is_new_tab: false
		},
		{
			title: "VIAJES",
			url: "http://www.viajesfalabella.com.ar/",
			is_new_tab: false
		},
		{
			title: "SEGUROS",
			url: "https://web.segurosfalabella.com/ar/?utm_source=Header&utm_medium=Falabella",
			is_new_tab: false
		},
		{
			title: "SODIMAC",
			url: "https://www.sodimac.com.ar/sodimac-ar/",
			is_new_tab: false
		},
		{
			title: "LINIO",
			url: "https://www.linio.com.ar/",
			is_new_tab: false
		}
	],
	mobile_util_buttons: {
		bolsa: [
			{
				title: "HEADER - MOBILE UTIL - 3 Bolsa",
				link: {
					title: "",
					href: "https://www.falabella.com.ar/falabella-ar/basket"
				},
				image: {
					filename: "header-bag-mobile.svg",
					title: "header-bag-mobile.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/bltb625a4bb0a59d4c9/6037eb3c664b723dc415a24d/header-bag-mobile.svg"
				},
				is_new_tab: false,
				must_be_logged_in: false,
				tags: [
				]
			}
		],
		cuenta: [
			{
				image: {
					filename: "header-account-mobile.svg",
					title: "header-account-mobile.svg",
					parent_uid: {
					},
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt9974fa971b702175/6037eb0c4ea5666c4e568ef0/header-account-mobile.svg"
				},
				is_new_tab: false,
				link: {
					title: "",
					href: "https://www.falabella.com.ar/falabella-ar/myaccount/homeZP.jsp"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - MOBILE UTIL - 2 Cuenta"
			}
		],
		buscar: [
			{
				image: {
					filename: "header-search.svg",
					title: "header-search.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt57fedbc5869947a7/6008431b4485e50f8f2094a1/header-search.svg"
				},
				is_new_tab: false,
				link: {
					title: "",
					href: "https://www.falabella.com.ar/falabella-ar/"
				},
				must_be_logged_in: false,
				tags: [
				],
				title: "HEADER - MOBILE UTIL - 1 Search"
			}
		]
	},
	searchbar: {
		search_icon: {
			filename: "searcher-glass.svg",
			title: "searcher-glass.svg",
			is_dir: false,
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/bltb1843819341ea078/60376c6a7737ce7794e65a37/searcher-glass.svg"
		},
		placeholder_search: "¿Qué buscas?",
		close_icon: {
			filename: "cancel.svg",
			title: "cancel.svg",
			parent_uid: {
			},
			is_dir: false,
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt7fad59c3e9a35bdc/602e35b30d10887006031a0c/cancel.svg"
		}
	},
	tags: [
	],
	title: "Header FAAR - PROD ONLY",
	transversal_banner_url: "https://www.falabella.com.ar/static/RDF/site/home/promohuincha/html/ph_home.html",
	huincha: {
		url: "https://www.falabella.com.ar/static/RDF/site/home/promohuincha/html/ph_home.html",
		data: {
			content: "<div class=\"container_huincha_cyber_faar huincha-gpt\" data-wrapper=\"H-Bancos\">\n\t<style>.container_huincha_cyber_faar {width: 100%;text-align: center;margin: 0;background-color: #efefef; border-bottom: 2px solid #90c827;padding: 0px 0;}</style>\t\n\t<a href=\"https://www.falabella.com.ar/falabella-ar/category/cat5630001/Electro-y-tecnologia?sid=home_BTH_Ahora12-18_170521\" data-cta=\"true\">\n\t\t<picture>\n\t\t\t<source srcset=\"https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/bltc8ebfc6803c1fc5a/609abcc5ce885c5a4f2827a2/BTH_Ahora12-18_110521.jpg?auto=webp&quality=70&width=90p\" media=\"(min-width: 740px)\">\n\t\t\t\n    <img\n      data-src=\"https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/bltad335de5bb437ca8/609abcc56f0758480561fbc8/BTH_Ahora12-18_110521_mobile.jpg?auto=webp&quality=70&width=90p\"\n      alt=\"\"\n      class=\" lazyload\"\n    />\n\t\t</picture>\t\t\n\t</a>\n</div>"
		}
	}
};
var headerV2AR = {
	entry: entry$5
};

var entry$6 = {
	cmr_puntos_button: {
		desktop: {
			href: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
			order: 2,
			title: "Mis CMR puntos",
			icon: {
			}
		},
		enabled: true,
		is_new_tab: true,
		mobile: {
			href: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_mobile",
			order: 3,
			title: "Mis CMR puntos",
			icon: {
				filename: "logo-bn.svg",
				title: "logo-bn.svg",
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltd52ba695345f8ea6/5f1863d03d0b7137bd73662e/logo-bn.svg"
			}
		}
	},
	country_selector: [
		{
			title: "HEADER - COUNTRY SELECTOR",
			items: [
				{
					tenant_name: "Argentina",
					tenant_name_short: "ar",
					url: "https://www.falabella.com.ar/falabella-ar",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagAr.svg"
				},
				{
					tenant_name: "Colombia",
					tenant_name_short: "co",
					url: "https://www.falabella.com.co/falabella-co",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagCo.svg"
				},
				{
					tenant_name: "Chile",
					tenant_name_short: "cl",
					url: "https://www.falabella.com/falabella-cl",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagCl.svg"
				},
				{
					tenant_name: "Perú",
					tenant_name_short: "pe",
					url: "https://www.falabella.com.pe/falabella-pe",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagPe.svg"
				},
				{
					tenant_name: "Home Corporativo",
					tenant_name_short: "corp",
					url: "https://www.falabella.com/static/staticContent/common/COR/homeCorporativo.html?p=1",
					flag_url: "https://www.falabella.com/apple-touch-icon.png"
				}
			],
			tags: [
			]
		}
	],
	desktop_util_buttons: {
		bolsa: [
			{
				image: {
					filename: "header-stage1-desktop-bag.svg",
					title: "header-stage1-desktop-bag.svg",
					parent_uid: {
					},
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt519e8cdcf2f5dd4e/6099159dc1ac134bc5d3a5cd/header-stage1-desktop-bag.svg"
				},
				is_new_tab: false,
				link: {
					title: "Bolsa",
					href: "/falabella-cl/basket"
				},
				must_be_logged_in: false,
				tags: [
				],
				title: "HEADER - DESKTOP UTIL - 3 Carro"
			}
		],
		inicia_sesion: [
			{
				image: {
					filename: "header-account.svg",
					title: "header-account.svg",
					is_dir: false,
					tags: [
					],
					parent_uid: "blt95d90815fa569596",
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt68b62861f458aaac/600729a527b1080f8436e55d/header-account.svg"
				},
				is_new_tab: false,
				link: {
					title: "Inicia sesión",
					href: "https://www.falabella.com/falabella-cl/"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - DESKTOP UTIL - 1 Sesión"
			}
		],
		mis_compras: [
			{
				title: "HEADER - DESKTOP UTIL - 2 Compras",
				link: {
					title: "Mis compras",
					href: "/falabella-cl/myorders"
				},
				image: {
					filename: "header-stage1-desktop-orders.svg",
					title: "header-stage1-desktop-orders.svg",
					is_dir: false,
					tags: [
					],
					parent_uid: "blt95d90815fa569596",
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt939c220774de101a/60365f047737ce7794e65445/header-stage1-desktop-orders.svg"
				},
				is_new_tab: false,
				must_be_logged_in: true,
				tags: [
				]
			}
		],
		inicia_sesion_dropdown: {
			menu_items_with_url: [
				{
					title: "Mi Cuenta",
					href: "/falabella-cl/myaccount"
				},
				{
					title: "Mis compras",
					href: "/falabella-cl/myorders"
				}
			],
			menu_items_without_url: {
				cerrar_sesion: "Cerrar sesión"
			},
			menu_items_with_atg_url: [
				{
					title: "Mi Cuenta",
					href: "/falabella-cl/myaccount/homeZP.jsp"
				},
				{
					title: "Mis compras",
					href: "/falabella-cl/mi-cuenta/ordenes"
				}
			]
		}
	},
	headerconfig: {
		links: {
			atgbaseurl: "https://www.falabella.com",
			catalystbaseurl: "https://www.falabella.com"
		},
		toggles: {
			isatgloginenabled: true,
			isgeolocationenabled: true,
			istypeaheadenabled: true,
			iszonemodalenabled: true
		}
	},
	links: {
		bottom_right: [
			{
				title: "HEADER - BOTTOM RIGHT",
				items: [
					{
						title: "Horario de tiendas",
						url: "https://www.falabella.com/falabella-cl/page/Horarios-especiales?sid=HO_HH_APE_27&staticPageId=38100001&uxref=horarios",
						is_new_tab: false
					},
					{
						title: "Marketplace",
						url: "https://www.falabella.com/falabella-cl/page/Market-Place?staticPageId=42100009&uxref=marketplace",
						is_new_tab: false
					},
					{
						title: "Falabella sostenible",
						url: "https://www.falabella.com/falabella-cl/page/Falabella-Sostenible?staticPageId=22500003&uxref=sostenible",
						is_new_tab: false
					},
					{
						title: "Club bebé",
						url: "https://www.celebracionesfalabella.com/bebe/?uxref=bebe",
						is_new_tab: true
					},
					{
						title: "Novios",
						url: "https://www.noviosfalabella.com/noviosclpr/public/inicio.do?uxref=novios",
						is_new_tab: true
					},
					{
						title: "CMR puntos",
						url: "https://www.falabella.com/falabella-cl/page/Puntos-CMR?staticPageId=40200001&uxref=cmrpuntos",
						is_new_tab: false
					},
					{
						title: "![enter image description here][1]  Paga tu CMR\n\n\n  [1]: https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltb9ed7af9d0558e57/5f0f2af0600d867e81bcb005/cmr.svg",
						url: "https://pagorapido.bancofalabella.cl/?utm_source=falabella.com&utm_medium=header&utm_campaign=landing-datos-para-clientes",
						is_new_tab: true
					}
				],
				vertical_bars: false,
				tags: [
				]
			}
		],
		top_left: [
			{
				title: "HEADER - TOP LEFT",
				items: [
					{
						title: "Venta telefónica **600 390 6500**",
						url: "https://www.falabella.com/falabella-cl/page/contactanos?staticPageId=37900002&menu=contactanos&&sac",
						is_new_tab: false
					}
				],
				vertical_bars: false,
				tags: [
				]
			}
		],
		top_right: [
			{
				items: [
					{
						title: "Banco-CMR",
						url: "https://www.bancofalabella.cl/home",
						is_new_tab: true
					},
					{
						title: "Viajes",
						url: "http://www.viajesfalabella.cl/",
						is_new_tab: true
					},
					{
						title: "Seguros",
						url: "https://web.segurosfalabella.com/cl/?utm_source=falabella.com&utm_medium=header",
						is_new_tab: true
					},
					{
						title: "Sodimac",
						url: "http://www.sodimac.cl/sodimac-cl/",
						is_new_tab: true
					},
					{
						title: "Fazil",
						url: "https://fazil-app.com/",
						is_new_tab: true
					},
					{
						title: "Tottus",
						url: "http://www.tottus.cl/tottus/",
						is_new_tab: true
					},
					{
						title: "Linio",
						url: "https://www.linio.cl/",
						is_new_tab: true
					},
					{
						title: "Mallplaza",
						url: "https://www.mallplaza.cl/",
						is_new_tab: true
					}
				],
				tags: [
				],
				title: "HEADER - TOP RIGHT",
				vertical_bars: true
			}
		],
		bottom_left: [
		]
	},
	logo_icon: {
		filename: "falabella-logo.svg",
		title: "falabella-logo.svg",
		is_dir: false,
		tags: [
		],
		url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt0d4f7fe05a57d9e2/5ffe843ec4800352b1e502aa/falabella-logo.svg"
	},
	mis_compras_dropdown: {
		button: [
			{
				title: "HEADER - TRACKING - Boton",
				link: {
					title: "IR A MIS COMPRAS",
					href: "/falabella-cl/myorders"
				},
				image: {
				},
				is_new_tab: false,
				must_be_logged_in: false,
				tags: [
				]
			}
		],
		description: "",
		menu_items: [
			{
				icon_image: {
					filename: "icon-web-my-orders.svg",
					title: "icon-web-my-orders.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltdbdccfe00b44edcf/5f11bfe25bbd1b7f3aca86b5/icon-web-my-orders.svg"
				},
				icon_link: {
					title: "Trackea el estado de tu compra",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - Trackea"
			},
			{
				icon_image: {
					filename: "change.svg",
					title: "change.svg",
					is_dir: false,
					tags: [
					],
					parent_uid: "blt95d90815fa569596",
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltd821a1eead073bc7/600729743e567f1011da0f57/change.svg"
				},
				icon_link: {
					title: "Realiza cambios o devoluciones",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - Cambios y Dev"
			},
			{
				icon_image: {
					filename: "boleta.svg",
					title: "boleta.svg",
					is_dir: false,
					tags: [
					],
					parent_uid: "blt95d90815fa569596",
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blta015ac1f7a9796db/6007298b0069f70f7771dc63/boleta.svg"
				},
				icon_link: {
					title: "Imprime tu boleta o ticket de cambio",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - Imprime boleta"
			}
		],
		title: "¡Conoce los detalles de tu compra en un solo lugar!",
		help: [
		]
	},
	mobile_menu_buttons: [
		{
			title: "HEADER - MOBILE MENU - 1 Cuenta",
			link: {
				title: "Mi Cuenta",
				href: "https://www.falabella.com/falabella-cl/myaccount/homeZP.jsp"
			},
			image: {
				filename: "icon-web-my-account_(1).svg",
				title: "icon-web-my-account_(1).svg",
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltd9e7b442351e7773/5f15b4d14c943d560770a4f5/icon-web-my-account_(1).svg"
			},
			is_new_tab: false,
			must_be_logged_in: true,
			tags: [
			]
		},
		{
			title: "HEADER - MOBILE MENU - 2 Compras",
			link: {
				title: "Mis compras",
				href: "https://www.falabella.com/falabella-cl/mi-cuenta/ordenes"
			},
			image: {
				filename: "icon-web-my-orders_(1).svg",
				title: "icon-web-my-orders_(1).svg",
				parent_uid: {
				},
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt0c8cb2232e45930b/5f15d238e910ca5d87ee635b/icon-web-my-orders_(1).svg"
			},
			is_new_tab: false,
			must_be_logged_in: true,
			tags: [
			]
		},
		{
			title: "HEADER - MOBILE MENU - 4 Horario Tienda",
			link: {
				title: "Horarios de tiendas",
				href: "https://www.falabella.com/falabella-cl/page/Horarios-especiales?sid=HO_HH_APE_27&staticPageId=38100001&uxref=mobilehorarios"
			},
			image: {
				filename: "icon-web-time_(1).svg",
				title: "icon-web-time_(1).svg",
				parent_uid: {
				},
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt885e5dd9767bcfaa/5f15d20f08a8cc582aeb7014/icon-web-time_(1).svg"
			},
			is_new_tab: false,
			must_be_logged_in: false,
			tags: [
			]
		},
		{
			title: "HEADER - MOBILE MENU - 6 Paga CMR",
			link: {
				title: "Paga tu CMR",
				href: "https://pagorapido.bancofalabella.cl/?utm_source=falabella.com&utm_medium=header&utm_campaign=landing-datos-para-clientes"
			},
			image: {
				is_dir: false,
				filename: "CMR.png",
				parent_uid: "blt95d90815fa569596",
				tags: [
				],
				title: "CMR.png",
				url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt11afd40388d29abc/5f1f4d10e573ea0784b6cda9/CMR.png"
			},
			is_new_tab: true,
			must_be_logged_in: false,
			tags: [
			]
		}
	],
	mobile_promotional_links: [
		{
			title: "Servicio al cliente",
			url: "https://www.falabella.com/falabella-cl/page/contactanos?staticPageId=37900002&menu=contactanos&&sac",
			is_new_tab: false
		},
		{
			title: "Venta telefónica 600 390 6500",
			url: "tel:6003906500",
			is_new_tab: false
		},
		{
			title: "Marketplace",
			url: "https://www.falabella.com/falabella-cl/page/Market-Place?staticPageId=42100009&uxref=mobilemarketplace",
			is_new_tab: false
		},
		{
			title: "Falabella sostenible",
			url: "https://www.falabella.com/falabella-cl/page/Falabella-Sostenible?staticPageId=22500003",
			is_new_tab: false
		},
		{
			title: "Club bebé",
			url: "https://www.celebracionesfalabella.com/bebe/",
			is_new_tab: false
		},
		{
			title: "Novios",
			url: "https://www.noviosfalabella.com/novios-cl/public/inicio.do",
			is_new_tab: false
		},
		{
			title: "Banco-CMR",
			url: "https://www.bancofalabella.cl/",
			is_new_tab: false
		},
		{
			title: "Viajes",
			url: "http://www.viajesfalabella.cl/",
			is_new_tab: false
		},
		{
			title: "Seguros",
			url: "https://web.segurosfalabella.com/cl/?utm_source=falabella.com&amp;utm_medium=header",
			is_new_tab: false
		},
		{
			title: "Sodimac",
			url: "http://www.sodimac.cl/sodimac-cl/",
			is_new_tab: false
		},
		{
			title: "Fazil",
			url: "https://fazil-app.com/",
			is_new_tab: false
		},
		{
			title: "Tottus",
			url: "http://www.tottus.cl/tottus/",
			is_new_tab: false
		},
		{
			title: "Linio",
			url: "https://www.linio.cl/",
			is_new_tab: false
		},
		{
			title: "Mallplaza",
			url: "https://www.mallplaza.cl/",
			is_new_tab: false
		}
	],
	mobile_util_buttons: {
		bolsa: [
			{
				image: {
					filename: "header-bag-mobile.svg",
					title: "header-bag-mobile.svg",
					parent_uid: "blt95d90815fa569596",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltba4029654d4397df/6036669e11a708101ad342f9/header-bag-mobile.svg"
				},
				is_new_tab: false,
				link: {
					title: "",
					href: "/falabella-cl/basket"
				},
				must_be_logged_in: false,
				tags: [
				],
				title: "HEADER - MOBILE UTIL - 3 Carro"
			}
		],
		cuenta: [
			{
				image: {
					filename: "header-account-mobile.svg",
					title: "header-account-mobile.svg",
					parent_uid: {
					},
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blte2c54567d179240e/6036975f0efbd9779b0279ad/header-account-mobile.svg"
				},
				is_new_tab: false,
				link: {
					title: "",
					href: "https://www.falabella.com/falabella-cl/myaccount/homeZP.jsp"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - MOBILE UTIL - 2 Cuenta"
			}
		],
		buscar: [
			{
				image: {
					filename: "header-search.svg",
					title: "header-search.svg",
					parent_uid: {
					},
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt27e70f57c0f24499/603768f94ea5666c4e568b13/header-search.svg"
				},
				is_new_tab: false,
				link: {
					title: "¿Qué buscas?",
					href: "https://www.falabella.com/falabella-cl/"
				},
				must_be_logged_in: false,
				tags: [
				],
				title: "HEADER - MOBILE UTIL - 1 Buscador"
			}
		]
	},
	searchbar: {
		search_icon: {
			filename: "searcher-glass.svg",
			title: "searcher-glass.svg",
			is_dir: false,
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt132cdc967ce98bc7/6007289d82548c0f8284a042/searcher-glass.svg"
		},
		placeholder_search: "¿Qué buscas?",
		close_icon: {
			filename: "cancel.svg",
			title: "cancel.svg",
			parent_uid: {
			},
			is_dir: false,
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt560f003a29bc2ec7/602e356c0d10887006031a08/cancel.svg"
		}
	},
	tags: [
	],
	title: "Header FACL - PROD ONLY",
	transversal_banner_url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
	huincha: {
		url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
		data: {
			content: ""
		}
	}
};
var headerV2CL = {
	entry: entry$6
};

var entry$7 = {
	cmr_puntos_button: {
		desktop: {
			href: "",
			icon: {
			},
			order: {
			},
			title: ""
		},
		enabled: false,
		is_new_tab: false,
		mobile: {
			href: "",
			icon: {
			},
			order: {
			},
			title: ""
		}
	},
	country_selector: [
		{
			items: [
				{
					tenant_name: "Argentina",
					tenant_name_short: "ar",
					url: "https://www.falabella.com.ar/falabella-ar",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagAr.svg"
				},
				{
					tenant_name: "Colombia",
					tenant_name_short: "co",
					url: "https://www.falabella.com.co/falabella-co",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagCo.svg"
				},
				{
					tenant_name: "Chile",
					tenant_name_short: "cl",
					url: "https://www.falabella.com/falabella-cl",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagCl.svg"
				},
				{
					tenant_name: "Perú",
					tenant_name_short: "pe",
					url: "https://www.falabella.com.pe/falabella-pe",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagPe.svg"
				},
				{
					tenant_name: "Home Corporativo",
					tenant_name_short: "corp",
					url: "https://www.falabella.com/static/staticContent/common/COR/homeCorporativo.html?p=1",
					flag_url: "https://www.falabella.com/apple-touch-icon.png"
				}
			],
			tags: [
			],
			title: "HEADER - COUNTRY SELECTOR"
		}
	],
	desktop_util_buttons: {
		bolsa: [
			{
				image: {
					filename: "header-stage-desktop-bag.svg",
					title: "header-stage-desktop-bag.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/blt0a3ffe8ad6df640b/60834f0903ce953dac75763a/header-stage-desktop-bag.svg"
				},
				is_new_tab: false,
				link: {
					title: "Bolsa",
					href: "https://www.falabella.com.co/falabella-co/basket"
				},
				must_be_logged_in: false,
				tags: [
				],
				title: "HEADER - DESKTOP UTIL - 3 Bolsa"
			}
		],
		inicia_sesion: [
			{
				image: {
					filename: "header-account.svg",
					title: "header-account.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/bltd11d8295acdae180/60072b873c38be10329e17c3/header-account.svg"
				},
				is_new_tab: false,
				link: {
					title: "Inicia sesión",
					href: "https://www.falabella.com.co/falabella-co/"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - DESKTOP UTIL - 1 Sesión"
			}
		],
		inicia_sesion_dropdown: {
			menu_items_with_url: [
				{
					title: "Mi Cuenta",
					href: "/falabella-co/myaccount/homeZP.jsp"
				},
				{
					title: "Mis pedidos",
					href: "/falabella-co/mi-cuenta/ordenes"
				}
			],
			menu_items_without_url: {
				cerrar_sesion: "Cerrar sesión"
			},
			menu_items_with_atg_url: [
				{
					title: "Mi Cuenta",
					href: "/falabella-co/myaccount/homeZP.jsp"
				},
				{
					title: "Mis pedidos",
					href: "/falabella-co/mi-cuenta/ordenes"
				}
			]
		},
		mis_compras: [
			{
				image: {
					filename: "header-stage-desktop-orders.svg",
					title: "header-stage-desktop-orders.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/bltd4f8a52b074eec24/608347d075873e466bcc6805/header-stage-desktop-orders.svg"
				},
				is_new_tab: false,
				link: {
					title: "Mis pedidos",
					href: "https://www.falabella.com.co/falabella-co/mi-cuenta/ordenes"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - DESKTOP UTIL - 2 Pedidos"
			}
		]
	},
	headerconfig: {
		links: {
			atgbaseurl: "https://www.falabella.com.co",
			catalystbaseurl: "https://www.falabella.com.co"
		},
		toggles: {
			isatgloginenabled: true,
			isgeolocationenabled: false,
			istypeaheadenabled: true,
			iszonemodalenabled: false
		}
	},
	links: {
		bottom_left: [
		],
		bottom_right: [
			{
				items: [
					{
						title: "Horario de tiendas",
						url: "https://www.falabella.com.co/falabella-co/page/Tiendas?staticPageId=22600001",
						is_new_tab: false
					},
					{
						title: "Club novios",
						url: "https://www.noviosfalabella.com.co/novios-co/public/inicio.do",
						is_new_tab: true
					},
					{
						title: "CMR puntos",
						url: "https://www.cmrpuntos.com.co/home?utm_source=web_falabella&utm_medium=banner_web&utm_campaign=inscripcion_cmrpuntos&utm_content=banner_web_fb--banner/&sid=BNXLHH1601064596",
						is_new_tab: true
					},
					{
						title: "Solicita aquí tu CMR",
						url: "https://www.falabella.com.co/falabella-co/page/CMR-enlinea-?staticPageId=22200001&from=kOip6l6uDoIrqeFrSDvBpYeOTqnoISOnT9wJkaoSi0XymtGTDJjK05L3Y3eCwCHhYfezum5jldV86T6/7T5KZXsNkJ5pDqXRGoI2XPsMk1jbS/47wc6AeUTX5bNd4teprAwxHURP0/e6e/L6OX9i1dB50GNauwtA9A9Po0u3k8mSVJAsvDWoVF/ohkwuS3U2yy3ClGYQLGotNQ5q2m/zwPgSUoI3pQC6T8QSW4rBwoD4bRWkvlJpCLHUsfbhT/OdYKI0c/7h04nJYDGKNWPXClIfDrL8vfowh3ReRukIF1bdRsVr+iXTInu2dQJXsKKyAnwyCug8u1+2KutZwOw36A=&utm_source=page&utm_medium=falabellaco&utm_campaign=BannerXL_BancoFalabella_Bono40&utm_content=central&cs=home-falabellaco-BannerXL_BancoFalabella_Bono40-central/&sid=BNXLHH1600297932",
						is_new_tab: false
					}
				],
				tags: [
				],
				title: "HEADER - BOTTOM RIGHT",
				vertical_bars: false
			}
		],
		top_left: [
			{
				items: [
					{
						title: "Venta telefónica  **587 8008 O 018000 958787**",
						url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002",
						is_new_tab: false
					},
					{
						title: "Teléfonos servicio al cliente",
						url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002",
						is_new_tab: false
					}
				],
				tags: [
				],
				title: "HEADER - TOP LEFT",
				vertical_bars: false
			}
		],
		top_right: [
			{
				items: [
					{
						title: "Banco",
						url: "https://www.bancofalabella.com.co/",
						is_new_tab: true
					},
					{
						title: "Seguros",
						url: "https://web.segurosfalabella.com/co/?utm_source=Referral&utm_medium=Falabella&utm_campaign=Home_Falabella",
						is_new_tab: true
					},
					{
						title: "Sodimac",
						url: "http://www.homecenter.com.co/homecenter-co",
						is_new_tab: true
					},
					{
						title: "Linio",
						url: "https://www.linio.com.co/",
						is_new_tab: true
					}
				],
				tags: [
				],
				title: "HEADER - TOP RIGHT",
				vertical_bars: true
			}
		]
	},
	logo_icon: {
		filename: "falabella-logo.svg",
		title: "falabella-logo.svg",
		is_dir: false,
		tags: [
		],
		url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/blta8ffc95229597844/5ffebb1d22252d41f72869c0/falabella-logo.svg"
	},
	mis_compras_dropdown: {
		button: [
			{
				title: "HEADER - TRACKING - BTN",
				link: {
					title: "IR A MIS PEDIDOS",
					href: "/falabella-co/mi-cuenta/ordenes"
				},
				image: {
				},
				is_new_tab: false,
				must_be_logged_in: true,
				tags: [
				]
			}
		],
		description: "",
		menu_items: [
			{
				icon_image: {
					filename: "icon-web-my-orders.svg",
					title: "icon-web-my-orders.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/blt1ac1b3bda3c0f4cc/6037ed3e427f5d75042c4144/icon-web-my-orders.svg"
				},
				icon_link: {
					title: "Trackea el estado de tu pedido",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - 1 Trackea"
			},
			{
				icon_image: {
					parent_uid: "bltf30c86d89bde0447",
					filename: "change.svg",
					title: "change.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/blt12811750cbca7aed/6007248d82548c0f8284a014/change.svg"
				},
				icon_link: {
					title: "Realiza cambios o devoluciones",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - 2 Cambios"
			},
			{
				icon_image: {
					parent_uid: "bltf30c86d89bde0447",
					filename: "boleta.svg",
					title: "boleta.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/blt4a25113b5baf3205/6007248d3c38be10329e1794/boleta.svg"
				},
				icon_link: {
					title: "Imprime tu boleta o ticket de cambio",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - 3 Boleta"
			}
		],
		title: "¡Conoce los detalles de tu pedido en un solo lugar!",
		help: [
			{
				title: "HEADER - HELP BUTTON",
				link: {
					title: "¿Necesitas ayuda?",
					href: ""
				},
				image: {
				},
				is_new_tab: false,
				must_be_logged_in: false,
				tags: [
				]
			}
		]
	},
	mobile_menu_buttons: [
		{
			image: {
				is_dir: false,
				filename: "icon-web-my-account_(1).svg",
				tags: [
				],
				title: "icon-web-my-account_(1).svg",
				parent_uid: "bltf30c86d89bde0447",
				url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/bltb46223aace3e8063/5f3168e17f3b7908db0320e8/icon-web-my-account_(1).svg"
			},
			is_new_tab: false,
			link: {
				title: "Mi Cuenta",
				href: "https://www.falabella.com.co/falabella-co/myaccount/homeZP.jsp"
			},
			must_be_logged_in: true,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 1 Cuenta"
		},
		{
			image: {
				is_dir: false,
				filename: "icon-web-my-orders_(1).svg",
				tags: [
				],
				title: "icon-web-my-orders_(1).svg",
				parent_uid: "bltf30c86d89bde0447",
				url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/blte125040a7a38ffa8/5f31692ad9a24d7c67e5033c/icon-web-my-orders_(1).svg"
			},
			is_new_tab: false,
			link: {
				title: "Mis pedidos",
				href: "https://www.falabella.com.co/falabella-co/mi-cuenta/ordenes"
			},
			must_be_logged_in: true,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 2 Pedidos"
		},
		{
			image: {
				filename: "logo-bn.svg",
				title: "logo-bn.svg",
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/blt4ffd890c249d7dd4/5f7b2992be6df80f0910bc6a/logo-bn.svg"
			},
			is_new_tab: true,
			link: {
				title: "Mis CMR puntos",
				href: "https://www.cmrpuntos.com.co/home?utm_source=mobile_falabella&utm_medium=menulateral_mobile&utm_campaign=inscripcion_cmrpuntos&utm_content=--"
			},
			must_be_logged_in: false,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 3 CMR puntos"
		},
		{
			image: {
				is_dir: false,
				filename: "icon-web-time_(1).svg",
				tags: [
				],
				title: "icon-web-time_(1).svg",
				parent_uid: "bltf30c86d89bde0447",
				url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/bltb52a3af038a4c5be/5f31698e327a6201d7eba89a/icon-web-time_(1).svg"
			},
			is_new_tab: false,
			link: {
				title: "Horarios de tiendas",
				href: "https://www.falabella.com.co/falabella-co/page/Tiendas?staticPageId=22600001"
			},
			must_be_logged_in: false,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 4 Tiendas"
		},
		{
			image: {
				is_dir: false,
				filename: "CMR_(1).png",
				tags: [
				],
				title: "CMR_(1).png",
				parent_uid: "bltf30c86d89bde0447",
				url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/blt7dafae2c0f069a60/5f3169618e1e8d4046e9ed04/CMR_(1).png"
			},
			is_new_tab: true,
			link: {
				title: "Paga tu CMR",
				href: "https://banco-co-gateway-pagos.fif.tech/payment/Index.html#!/login/?utm_source=falabella&utm_medium=nuevaspiezas&utm_campaign=canalesdigitales&utm_campaign_term=canalesdepago"
			},
			must_be_logged_in: false,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 5 Paga CMR"
		}
	],
	mobile_promotional_links: [
		{
			title: "VENTA TELEFÓNICA 587 8006 O 018000 958787",
			url: "tel:0315878006",
			is_new_tab: false
		},
		{
			title: "TIENDAS",
			url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002#nuestras-tiendas",
			is_new_tab: false
		},
		{
			title: "TELÉFONOS SERVICIO AL CLIENTE",
			url: "https://www.falabella.com.co/falabella-co/page/servicio-al-cliente?staticPageId=13000002",
			is_new_tab: false
		},
		{
			title: "NOVIOS",
			url: "https://www.noviosfalabella.com.co/novios-co/public/inicio.do",
			is_new_tab: false
		},
		{
			title: "BANCO",
			url: "https://www.bancofalabella.com.co/home",
			is_new_tab: false
		},
		{
			title: "VIAJES",
			url: "https://www.viajesfalabella.com.co/",
			is_new_tab: false
		},
		{
			title: "SEGUROS",
			url: "https://web.segurosfalabella.com/co/?_ga=2.191816106.160009833.1553270107-1981813348.1553270107",
			is_new_tab: false
		},
		{
			title: "SODIMAC",
			url: "https://www.homecenter.com.co/homecenter-co/",
			is_new_tab: false
		},
		{
			title: "LINIO",
			url: "https://www.linio.com.co/",
			is_new_tab: false
		}
	],
	mobile_util_buttons: {
		bolsa: [
			{
				image: {
					filename: "header-bag-mobile.svg",
					title: "header-bag-mobile.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/blt4d98b55635ecb2ca/6037ec9ef54af27503f2ddff/header-bag-mobile.svg"
				},
				is_new_tab: false,
				link: {
					title: "",
					href: "https://www.falabella.com.co/falabella-co/basket"
				},
				must_be_logged_in: false,
				tags: [
				],
				title: "HEADER - MOBILE UTIL - 3 Bolsa"
			}
		],
		cuenta: [
			{
				image: {
					filename: "header-account-mobile.svg",
					title: "header-account-mobile.svg",
					parent_uid: {
					},
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/bltc5d26655372aec9a/6037ec38ce4a0d12c3ec23c9/header-account-mobile.svg"
				},
				is_new_tab: false,
				link: {
					title: "",
					href: "https://www.falabella.com.co/falabella-co/myaccount/homeZP.jsp"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - MOBILE UTIL - 2 Cuenta"
			}
		],
		buscar: [
			{
				image: {
					filename: "header-search.svg",
					title: "header-search.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/bltfe1667cc9f76f96b/6008446e82548c0f8284a5cf/header-search.svg"
				},
				is_new_tab: false,
				link: {
					title: "",
					href: "https://www.falabella.com.co/falabella-co/"
				},
				must_be_logged_in: false,
				tags: [
				],
				title: "HEADER - MOBILE UTIL - 1 Searh"
			}
		]
	},
	searchbar: {
		search_icon: {
			filename: "searcher-glass.svg",
			title: "searcher-glass.svg",
			is_dir: false,
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/blte9c20b98d24f1a25/60376c9a4a75a66ee92262d6/searcher-glass.svg"
		},
		placeholder_search: "¿Qué buscas?",
		close_icon: {
			filename: "cancel.svg",
			title: "cancel.svg",
			is_dir: false,
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt088e6fffbba20f16/bltfee5d9abf0549955/602e35caf16aa8400f83ba3e/cancel.svg"
		}
	},
	tags: [
	],
	title: "Header FACO - PROD ONLY",
	transversal_banner_url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
	huincha: {
		url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
		data: {
			content: ""
		}
	}
};
var headerV2CO = {
	entry: entry$7
};

var entry$8 = {
	cmr_puntos_button: {
		desktop: {
			href: "",
			icon: {
			},
			order: {
			},
			title: ""
		},
		enabled: false,
		is_new_tab: false,
		mobile: {
			href: "",
			icon: {
			},
			order: 3,
			title: ""
		}
	},
	country_selector: [
		{
			items: [
				{
					tenant_name: "Argentina",
					tenant_name_short: "ar",
					url: "https://www.falabella.com.ar/falabella-ar",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagAr.svg"
				},
				{
					tenant_name: "Colombia",
					tenant_name_short: "co",
					url: "https://www.falabella.com.co/falabella-co",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagCo.svg"
				},
				{
					tenant_name: "Chile",
					tenant_name_short: "cl",
					url: "https://www.falabella.com/falabella-cl",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagCl.svg"
				},
				{
					tenant_name: "Perú",
					tenant_name_short: "pe",
					url: "https://www.falabella.com.pe/falabella-pe",
					flag_url: "https://www.falabella.com/a/fa/static/styles/svg/flagPe.svg"
				},
				{
					tenant_name: "Home Corporativo",
					tenant_name_short: "corp",
					url: "https://www.falabella.com/static/staticContent/common/COR/homeCorporativo.html?p=1",
					flag_url: "https://www.falabella.com/apple-touch-icon.png"
				}
			],
			tags: [
			],
			title: "HEADER - COUNTRY SELECTOR"
		}
	],
	desktop_util_buttons: {
		bolsa: [
			{
				title: "HEADER - DESKTOP UTIL - 3 bolsa",
				link: {
					title: "Bolsa",
					href: "https://www.falabella.com.pe/falabella-pe/basket"
				},
				image: {
					filename: "icon-bag.svg",
					title: "icon-bag.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt13c044e65bf22e5b/6007514c96de49101cfb2c8e/icon-bag.svg"
				},
				is_new_tab: false,
				must_be_logged_in: false,
				tags: [
				]
			}
		],
		inicia_sesion: [
			{
				image: {
					filename: "header-account.svg",
					title: "header-account.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt771b305100a43c7b/60074cf982548c0f8284a15e/header-account.svg"
				},
				is_new_tab: false,
				link: {
					title: "Inicia sesión",
					href: "https://www.falabella.com.pe/falabella-pe/myaccount/homeZP.jsp"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - DESKTOP UTIL - 1 cuenta"
			}
		],
		inicia_sesion_dropdown: {
			menu_items_with_url: [
				{
					title: "Mi cuenta",
					href: "/falabella-pe/myaccount/homeZP.jsp"
				},
				{
					title: "Mis órdenes",
					href: "/falabella-pe/mi-cuenta/ordenes"
				}
			],
			menu_items_without_url: {
				cerrar_sesion: "Cerrar sesión"
			},
			menu_items_with_atg_url: [
				{
					title: "Mi cuenta",
					href: "/falabella-pe/myaccount/homeZP.jsp"
				},
				{
					title: "Mis órdenes",
					href: "/falabella-pe/mi-cuenta/ordenes"
				}
			]
		},
		mis_compras: [
			{
				image: {
					filename: "icon-my-orders.svg",
					title: "icon-my-orders.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/bltc27cae0404990367/600751300839e910126d5057/icon-my-orders.svg"
				},
				is_new_tab: false,
				link: {
					title: "Mis órdenes",
					href: "https://www.falabella.com.pe/falabella-pe/mi-cuenta/ordenes"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - DESKTOP UTIL - 2 ordenes"
			}
		]
	},
	headerconfig: {
		links: {
			atgbaseurl: "https://www.falabella.com.pe",
			catalystbaseurl: "https://www.falabella.com.pe"
		},
		toggles: {
			isatgloginenabled: true,
			isgeolocationenabled: false,
			istypeaheadenabled: true,
			iszonemodalenabled: false
		}
	},
	links: {
		bottom_left: [
		],
		bottom_right: [
			{
				items: [
					{
						title: "FONOCOMPRAS 203-7050",
						url: "https://www.falabella.com.pe/falabella-pe/",
						is_new_tab: false
					},
					{
						title: "Nuestras tiendas",
						url: "https://www.falabella.com.pe/falabella-pe/page/YoMeQuedoEnCasa?staticPageId=21300001#horarios",
						is_new_tab: false
					},
					{
						title: "Novios",
						url: "https://www.noviosfalabella.com.pe/novios-pe/public/inicio.do",
						is_new_tab: true
					},
					{
						title: "CMR puntos",
						url: "https://www.falabella.com.pe/falabella-pe/page/CMR-Puntos?staticPageId=20500001?utm_source=web_falabella&utm_medium=banner_desktop&utm_campaign=",
						is_new_tab: false
					},
					{
						title: "![enter image description here][1]  Pide tu CMR\n\n\n  [1]: https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltb9ed7af9d0558e57/5f0f2af0600d867e81bcb005/cmr.svg",
						url: "https://www.falabella.com.pe/falabella-pe/page/Tu-CMR-Online?staticPageId=24600001&detalleClic=headermodulehome",
						is_new_tab: true
					}
				],
				tags: [
				],
				title: "HEADER - BOTTOM RIGHT",
				vertical_bars: false
			}
		],
		top_left: [
			{
				items: [
					{
						title: "Whatsapp y atención al cliente 512-3333",
						url: "https://api.whatsapp.com/send?phone=5115123333",
						is_new_tab: true
					}
				],
				tags: [
				],
				title: "HEADER - TOP LEFT",
				vertical_bars: false
			}
		],
		top_right: [
			{
				items: [
					{
						title: "Linio",
						url: "https://www.linio.com.pe/",
						is_new_tab: true
					},
					{
						title: "Tottus",
						url: "https://www.tottus.com.pe/tottus/",
						is_new_tab: true
					},
					{
						title: "Sodimac",
						url: "https://www.sodimac.com.pe/sodimac-pe/",
						is_new_tab: true
					},
					{
						title: "Seguros",
						url: "https://web.segurosfalabella.com/pe/",
						is_new_tab: true
					},
					{
						title: "Viajes",
						url: "https://www.viajesfalabella.com.pe/",
						is_new_tab: true
					},
					{
						title: "Banco",
						url: "https://www.bancofalabella.pe/home/",
						is_new_tab: true
					}
				],
				tags: [
				],
				title: "HEADER - TOP RIGHT",
				vertical_bars: true
			}
		]
	},
	logo_icon: {
		filename: "falabella-logo.svg",
		title: "falabella-logo.svg",
		is_dir: false,
		tags: [
		],
		url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt55577d5d52ecddaf/5ffebbd0092adc41f184be78/falabella-logo.svg"
	},
	mis_compras_dropdown: {
		button: [
			{
				image: {
				},
				is_new_tab: false,
				link: {
					title: "IR A MIS COMPRAS",
					href: "https://www.falabella.com.pe/falabella-pe/mi-cuenta/ordenes"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - TRACKING - BTN"
			}
		],
		description: "",
		menu_items: [
			{
				icon_image: {
					filename: "tracking.svg",
					title: "tracking.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt80a2a979b9e8fcae/60074c7727b1080f8436e665/tracking.svg"
				},
				icon_link: {
					title: "Trackea el estado de tu orden",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - 1 Trackea"
			},
			{
				icon_image: {
					filename: "change.svg",
					title: "change.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blta7168d0ba2c39976/60074c990839e910126d5025/change.svg"
				},
				icon_link: {
					title: "Realiza cambios o devoluciones",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - Cambios Trackea"
			},
			{
				icon_image: {
					filename: "boleta.svg",
					title: "boleta.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/bltafdb55eb546c1993/60074cc296de49101cfb2c7e/boleta.svg"
				},
				icon_link: {
					title: "Imprime tu boleta o ticket de cambio",
					href: ""
				},
				tags: [
				],
				title: "HEADER - TRACKING - 3 Boleta"
			}
		],
		title: "¡Conoce los detalles de tu compra en un solo lugar!",
		help: [
			{
				title: "HEADER - HELP BUTTON",
				link: {
					title: "¿Necesitas ayuda?",
					href: ""
				},
				image: {
				},
				is_new_tab: false,
				must_be_logged_in: false,
				tags: [
				]
			}
		]
	},
	mobile_menu_buttons: [
		{
			image: {
				parent_uid: "bltde2c542bc5be2fca",
				filename: "icon-web-my-account_(1).svg",
				title: "icon-web-my-account_(1).svg",
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/bltdb2d51ab2891c430/5f3c46245f7d2953ae821710/icon-web-my-account_(1).svg"
			},
			is_new_tab: false,
			link: {
				title: "Mi cuenta",
				href: "https://www.falabella.com.pe/falabella-pe/myaccount/homeZP.jsp"
			},
			must_be_logged_in: true,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 1 Cuenta"
		},
		{
			image: {
				parent_uid: "bltde2c542bc5be2fca",
				filename: "icon-web-my-orders_(1).svg",
				title: "icon-web-my-orders_(1).svg",
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/bltfc84f6a21fb874c3/5f3c462460261e2e581f20e5/icon-web-my-orders_(1).svg"
			},
			is_new_tab: false,
			link: {
				title: "Mis órdenes",
				href: "https://www.falabella.com.pe/falabella-pe/mi-cuenta/ordenes"
			},
			must_be_logged_in: true,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 2 Mis Órdenes"
		},
		{
			image: {
				filename: "logo-bn.svg",
				title: "logo-bn.svg",
				parent_uid: {
				},
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt0bf48310d5e2a16c/5f3c81fd3ebefc321efdce18/logo-bn.svg"
			},
			is_new_tab: false,
			link: {
				title: "Mis CMR puntos",
				href: "https://www.falabella.com.pe/falabella-pe/page/CMR-Puntos?staticPageId=20500001?utm_source=web_falabella&utm_medium=menu_mobile&utm_campaign=%20inscripcion_cmrpuntos%20&utm_content"
			},
			must_be_logged_in: false,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 3 Cuenta"
		},
		{
			image: {
				parent_uid: "bltde2c542bc5be2fca",
				filename: "icon-web-time_(1).svg",
				title: "icon-web-time_(1).svg",
				is_dir: false,
				tags: [
				],
				url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt53519faf422679c9/5f3c45fe62013530f82eb415/icon-web-time_(1).svg"
			},
			is_new_tab: false,
			link: {
				title: "Horarios de tiendas",
				href: "https://www.falabella.com.pe/falabella-pe/static/staticContent1.jsp?active=0&id=cat50487"
			},
			must_be_logged_in: false,
			tags: [
			],
			title: "HEADER - MOBILE MENU - 4 Cuenta"
		}
	],
	mobile_promotional_links: [
		{
			title: "FONOCOMPRAS 203-7050",
			url: "https://www.falabella.com.pe/falabella-pe/#",
			is_new_tab: false
		},
		{
			title: "NUESTRAS TIENDAS",
			url: "https://www.falabella.com.pe/falabella-pe/category/cat50668/Hoy-en-tiendas",
			is_new_tab: false
		},
		{
			title: "SERVICIO AL CLIENTE",
			url: "https://www.falabella.com.pe/falabella-pe/category/cat50608/Servicio-al-cliente",
			is_new_tab: false
		},
		{
			title: "CMR",
			url: "https://cmr-points-pe.azurewebsites.net/",
			is_new_tab: false
		},
		{
			title: "BANCO",
			url: "http://www.bancofalabella.pe/",
			is_new_tab: false
		},
		{
			title: "VIAJES",
			url: "http://www.viajesfalabella.com.pe/",
			is_new_tab: false
		},
		{
			title: "SEGUROS",
			url: "http://www.segurosfalabellacorredores.com.pe/web/agenciadeseguros/home",
			is_new_tab: false
		},
		{
			title: "SODIMAC",
			url: "http://www.sodimac.com.pe/",
			is_new_tab: false
		},
		{
			title: "TOTTUS",
			url: "http://www.tottus.com.pe/",
			is_new_tab: false
		}
	],
	mobile_util_buttons: {
		bolsa: [
			{
				title: "HEADER - MOBILE UTIL - 3  Bolsa",
				link: {
					title: "",
					href: "https://www.falabella.com.pe/falabella-pe/basket"
				},
				image: {
					filename: "header-bag-mobile.svg",
					title: "header-bag-mobile.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blta1be175c9f9ce563/6037ee6a1f3c9a3b23d6db15/header-bag-mobile.svg"
				},
				is_new_tab: false,
				must_be_logged_in: false,
				tags: [
				]
			}
		],
		cuenta: [
			{
				image: {
					filename: "header-account-mobile.svg",
					title: "header-account-mobile.svg",
					parent_uid: {
					},
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt8d16d0cbe81d944d/6037ee3e2eee966ee2e3cb38/header-account-mobile.svg"
				},
				is_new_tab: false,
				link: {
					title: "",
					href: "https://www.falabella.com.pe/falabella-pe/myaccount/homeZP.jsp"
				},
				must_be_logged_in: true,
				tags: [
				],
				title: "HEADER - MOBILE UTIL - 2 Cuenta"
			}
		],
		buscar: [
			{
				image: {
					filename: "header-search.svg",
					title: "header-search.svg",
					is_dir: false,
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/bltaa2fa1eff6163b01/600844fd82548c0f8284a5d5/header-search.svg"
				},
				is_new_tab: false,
				link: {
					title: "",
					href: "https://www.falabella.com.pe/falabella-pe/"
				},
				must_be_logged_in: false,
				tags: [
				],
				title: "HEADER - MOBILE UTIL - 1 Search"
			}
		]
	},
	searchbar: {
		search_icon: {
			filename: "searcher-glass.svg",
			title: "searcher-glass.svg",
			is_dir: false,
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blta1697e55322960f8/60376cbf664b723dc4159ede/searcher-glass.svg"
		},
		placeholder_search: "¿Qué buscas?",
		close_icon: {
			filename: "cancel.svg",
			title: "cancel.svg",
			is_dir: false,
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt0a0ec337667e9031/602e35e42568577267da5cb7/cancel.svg"
		}
	},
	tags: [
	],
	title: "Header FAPE - PROD ONLY",
	transversal_banner_url: "https://www.falabella.com.pe/static/RDF/site/home-new/huincha-transversal/bh_comprahoy.html",
	huincha: {
		url: "https://www.falabella.com.pe/static/RDF/site/home-new/huincha-transversal/bh_comprahoy.html",
		data: {
			content: "<div class=\"container_huincha_cyber_faar huincha-gpt\" data-wrapper=\"H-Comprahoy\">\n    <style>.container_huincha_cyber_faar {width: 100%;text-align: center;margin: 0;background-color: #efefef; border-bottom: 2px solid #90c827;padding: 0px 0;}\n    .container_huincha_cyber_faar img{width: 100%;}  .container_huincha_cyber_faar picture{width: 100%;}\n    </style>   \n    <a href=\"https://www.falabella.com.pe/falabella-pe/collection/compra-hoy-recibe-hoy\" data-cta=\"true\">\n        <picture>\n            <source srcset=\"https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/bltb705fb2fa7da3822/608c2c3e1022211019ccc1b5/010521-huincha-compra-recibe.jpg\" media=\"(min-width: 740px)\">\n            \n    <img\n      data-src=\"https://images.contentstack.io/v3/assets/bltf4ed0b9a176c126e/blt67ba8921db6070d5/608c2c3f49c1fd103f4ac3c0/010521-m-huincha-compra-recibe.jpg\"\n      alt=\"\"\n      class=\" lazyload\"\n    />\n        </picture>       \n    </a>\n</div>"
		}
	}
};
var headerV2PE = {
	entry: entry$8
};

var entry$9 = {
	bottom_right_links: [
		{
			title: "Vende con nosotros",
			url: "https://www.falabella.com/falabella-cl/page/Vende-en-Falabella.com?mkid=LA_VI_VER_1000002626&staticPageId=42100010",
			is_new_tab: false,
			dropdown_items: [
			],
			last_item_style: false
		},
		{
			title: "Fpay",
			url: "https://fpay.cl/",
			is_new_tab: false,
			dropdown_items: [
			],
			last_item_style: false
		},
		{
			title: "Tarjeta CMR",
			url: "",
			is_new_tab: false,
			dropdown_items: [
				{
					title: "Pide tu CMR",
					url: "https://www.bancofalabella.cl/pide-tu-cmr-online",
					is_new_tab: false
				},
				{
					title: "Paga tu CMR",
					url: "https://pagorapido.bancofalabella.cl/?utm_source=falabella.com&utm_medium=header&utm_campaign=landing-datos-para-clientes",
					is_new_tab: false
				}
			],
			last_item_style: false
		},
		{
			title: "Ayuda",
			url: "",
			is_new_tab: false,
			dropdown_items: [
				{
					title: "Centro de Ayuda",
					url: "https://www.falabella.com/falabella-cl/page/contactanos",
					is_new_tab: false
				},
				{
					title: "Horario de tiendas",
					url: "https://www.falabella.com/falabella-cl/page/Horarios-especiales?sid=HO_HH_APE_27&staticPageId=38100001&uxref=horarios",
					is_new_tab: false
				},
				{
					title: "Venta telefónica 600 390 6500",
					url: "https://www.falabella.com/falabella-cl/page/contactanos?staticPageId=37900002&menu=contactanos&&sac",
					is_new_tab: false
				}
			],
			last_item_style: true
		}
	],
	cart: {
		icon_desktop: {
			filename: "hr-4-cart-desktop.svg",
			title: "hr-4-cart-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbbfae160b3e081f6/60c9ac28eefdde56c1143c66/hr-4-cart-desktop.svg"
		},
		icon_mobile: {
			filename: "hr-14-cart-mobile.svg",
			title: "hr-14-cart-mobile.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltb68b665c67cd07b4/60c9ac76eefdde56c1143c6a/hr-14-cart-mobile.svg"
		},
		url: "/falabella-cl/basket"
	},
	geofinder: {
		icon_desktop: {
			filename: "hr-5-geo-desktop.svg",
			title: "hr-5-geo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbb63b168b9d5e404/60c9ac81bdf5ed4ae2de2ed3/hr-5-geo-desktop.svg"
		},
		icon_mobile: {
			filename: "hr-5-geo-desktop.svg",
			title: "hr-5-geo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbb63b168b9d5e404/60c9ac81bdf5ed4ae2de2ed3/hr-5-geo-desktop.svg"
		}
	},
	header_configs: [
		{
			links: {
				catalystbaseurl: "https://staging.falabella.com",
				atgbaseurl: "https://cl-testcloud.falabella.com"
			},
			tags: [
			],
			title: "Rebranded Header FACL Staging",
			toggles: {
				isatgloginenabled: true,
				isgeolocationenabled: false,
				istypeaheadenabled: true,
				iszonemodalenabled: true,
				iscmrenabled: true
			}
		}
	],
	is_sticky_desktop: true,
	is_sticky_mobile: true,
	line_between_accesses: true,
	logo: {
		desktop_icon: {
			filename: "hr-1-logo-desktop.svg",
			title: "hr-1-logo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt4cc88d1c198f9ef1/60c9928f0ece0255888d7968/hr-1-logo-desktop.svg"
		},
		mobile_icon: {
			filename: "hr-12-logo-mobile.svg",
			title: "hr-12-logo-mobile.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt529baed8dca866c1/60c9929ee1b3f7481347c560/hr-12-logo-mobile.svg"
		},
		url: "/falabella-cl",
		tablet_icon: {
			filename: "logo_160px.svg",
			title: "logo_160px.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt37d90a09b211d04b/60cc2f0bd78f9d375f081766/logo_160px.svg"
		}
	},
	menu: {
		desktop_icon: {
			filename: "hr-2-menu-desktop.svg",
			title: "hr-2-menu-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltd6d940bad112ae36/60c992a9b085be4819b86f09/hr-2-menu-desktop.svg"
		},
		mobile_icon: {
		},
		desktop_text: "Menu",
		mobile_text: "Menu"
	},
	myaccount_desktop: {
		hello_text: "Hola",
		items_logged_out: {
			last_item_style: true,
			items: [
				{
					title: "Inicia sesión",
					url: "",
					is_new_tab: true,
					icon: {
					},
					login: true,
					login_and_redirect: false
				},
				{
					title: "Regístrate",
					url: "/falabella-cl/myaccount/registration",
					is_new_tab: true,
					icon: {
					},
					login: false,
					login_and_redirect: false
				},
				{
					title: "Mi cuenta",
					url: "/falabella-cl/myaccount/userPersonalInformation",
					is_new_tab: true,
					icon: {
					},
					login: false,
					login_and_redirect: true
				},
				{
					title: "CMR Puntos",
					url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
					is_new_tab: true,
					icon: {
						filename: "hr-10-cmr-round.svg",
						title: "hr-10-cmr-round.svg",
						tags: [
						],
						url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltdf8c6970f686ace9/60c9a1bd5a50fc37590b1beb/hr-10-cmr-round.svg"
					},
					login: false,
					login_and_redirect: false
				}
			],
			login_text: "Inicia sesión"
		},
		items_logged_in: {
			last_item_style: false,
			items: {
				redirection_items: [
					{
						title: "Mi cuenta",
						catalyst_url: "/falabella-cl/myaccount/userPersonalInformation",
						atg_url: "/falabella-cl/myaccount/userPersonalInformation",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					},
					{
						title: "Mis CMR Puntos",
						catalyst_url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
						atg_url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
						is_new_tab: true,
						icon: {
						},
						is_cmr: true
					},
					{
						title: "Mis compras",
						catalyst_url: "/falabella-cl/myorders",
						atg_url: "/falabella-cl/myorders",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					},
					{
						title: "Mis Gift Cards",
						catalyst_url: "/falabella-cl/mi-cuenta/giftcards",
						atg_url: "/falabella-cl/mi-cuenta/giftcards",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					}
				],
				action_items: {
					cerrar_sesion: {
						title: "Cerrar Sesion"
					}
				}
			}
		}
	},
	myaccount_mobile: {
		hello_text: "Hola",
		close_icon: {
		},
		items_logged_out: {
			login_text: "Inicia sesión"
		},
		items_logged_in: {
			redirection_items: [
				{
					title: "Tienes",
					catalyst_url: "",
					atg_url: "",
					is_new_tab: true,
					icon: {
					},
					is_cmr: true
				},
				{
					title: "Mi cuenta",
					catalyst_url: "/falabella-cl/myaccount",
					atg_url: "/falabella-cl/myaccount",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				},
				{
					title: "Mis compras",
					catalyst_url: "/falabella-cl/myorders",
					atg_url: "/falabella-cl/myorders",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				},
				{
					title: "Mis Gift Cards",
					catalyst_url: "/falabella-cl/mi-cuenta/giftcards",
					atg_url: "/falabella-cl/mi-cuenta/giftcards",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				}
			],
			action_items: {
				cerrar_sesion: {
					title: "Cerrar sesión"
				}
			}
		}
	},
	myorders_desktop: {
		button_text: "Mis compras",
		url: "/falabella-cl/myorders"
	},
	our_stores: {
		items: [
			{
				icon: {
					filename: "hr-6-falabella.svg",
					title: "hr-6-falabella.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltdd4febec3e84e871/60c9aca0eefdde56c1143c6e/hr-6-falabella.svg"
				},
				url: "",
				is_new_tab: false,
				dropdown_items: [
					{
						title: "Moda F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/moda-cl"
					},
					{
						title: "Belleza F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/belleza-cl"
					},
					{
						title: "Casa F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/casa-cl"
					},
					{
						title: "Electro F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/electro-cl"
					}
				]
			},
			{
				icon: {
					filename: "hr-7-sodimac.svg",
					title: "hr-7-sodimac.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6b84a079db062ffe/60c9ad794e87de56c8122ac6/hr-7-sodimac.svg"
				},
				url: "https://sodimac.falabella.com/sodimac-cl/",
				is_new_tab: false,
				dropdown_items: [
				]
			},
			{
				icon: {
					filename: "hr-8-linio.svg",
					title: "hr-8-linio.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt61f2028271cd868e/60c9ad84610188558e3b3214/hr-8-linio.svg"
				},
				url: "https://linio.falabella.com/linio-cl",
				is_new_tab: false,
				dropdown_items: [
				]
			},
			{
				icon: {
					filename: "hr-9-tottus.svg",
					title: "hr-9-tottus.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt92c9788003828968/60c9ad90bdf5ed4ae2de2ed7/hr-9-tottus.svg"
				},
				url: "https://tottus.falabella.com/tottus-cl",
				is_new_tab: false,
				dropdown_items: [
				]
			}
		],
		title: "Nuestras tiendas:"
	},
	searchbar: {
		search_icon: {
			filename: "hr-3-search-desktop.svg",
			title: "hr-3-search-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt019384dffb744bb5/60c992b60504174955a9729b/hr-3-search-desktop.svg"
		},
		close_icon: {
		},
		desktop_placeholder: "¿Qué buscas?",
		mobile_placeholder: "¿Qué buscas?"
	},
	tags: [
	],
	title: "Staging",
	transversal_banner_url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
	huincha: {
		url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
		data: {
			content: ""
		}
	}
};
var headerV3CO = {
	entry: entry$9
};

var entry$a = {
	bottom_right_links: [
		{
			title: "Vende con nosotros",
			url: "https://www.falabella.com/falabella-cl/page/Vende-en-Falabella.com?mkid=LA_VI_VER_1000002626&staticPageId=42100010",
			is_new_tab: false,
			dropdown_items: [
			],
			last_item_style: false
		},
		{
			title: "Fpay",
			url: "https://fpay.cl/",
			is_new_tab: false,
			dropdown_items: [
			],
			last_item_style: false
		},
		{
			title: "Tarjeta CMR",
			url: "",
			is_new_tab: false,
			dropdown_items: [
				{
					title: "Pide tu CMR",
					url: "https://www.bancofalabella.cl/pide-tu-cmr-online",
					is_new_tab: false
				},
				{
					title: "Paga tu CMR",
					url: "https://pagorapido.bancofalabella.cl/?utm_source=falabella.com&utm_medium=header&utm_campaign=landing-datos-para-clientes",
					is_new_tab: false
				}
			],
			last_item_style: false
		},
		{
			title: "Ayuda",
			url: "",
			is_new_tab: false,
			dropdown_items: [
				{
					title: "Centro de Ayuda",
					url: "https://www.falabella.com/falabella-cl/page/contactanos",
					is_new_tab: false
				},
				{
					title: "Horario de tiendas",
					url: "https://www.falabella.com/falabella-cl/page/Horarios-especiales?sid=HO_HH_APE_27&staticPageId=38100001&uxref=horarios",
					is_new_tab: false
				},
				{
					title: "Venta telefónica 600 390 6500",
					url: "https://www.falabella.com/falabella-cl/page/contactanos?staticPageId=37900002&menu=contactanos&&sac",
					is_new_tab: false
				}
			],
			last_item_style: true
		}
	],
	cart: {
		icon_desktop: {
			filename: "hr-4-cart-desktop.svg",
			title: "hr-4-cart-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbbfae160b3e081f6/60c9ac28eefdde56c1143c66/hr-4-cart-desktop.svg"
		},
		icon_mobile: {
			filename: "hr-14-cart-mobile.svg",
			title: "hr-14-cart-mobile.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltb68b665c67cd07b4/60c9ac76eefdde56c1143c6a/hr-14-cart-mobile.svg"
		},
		url: "/falabella-cl/basket"
	},
	geofinder: {
		icon_desktop: {
			filename: "hr-5-geo-desktop.svg",
			title: "hr-5-geo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbb63b168b9d5e404/60c9ac81bdf5ed4ae2de2ed3/hr-5-geo-desktop.svg"
		},
		icon_mobile: {
			filename: "hr-5-geo-desktop.svg",
			title: "hr-5-geo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbb63b168b9d5e404/60c9ac81bdf5ed4ae2de2ed3/hr-5-geo-desktop.svg"
		}
	},
	header_configs: [
		{
			links: {
				catalystbaseurl: "https://staging.falabella.com",
				atgbaseurl: "https://cl-testcloud.falabella.com"
			},
			tags: [
			],
			title: "Rebranded Header FACL Staging",
			toggles: {
				isatgloginenabled: true,
				isgeolocationenabled: false,
				istypeaheadenabled: true,
				iszonemodalenabled: true,
				iscmrenabled: true
			}
		}
	],
	is_sticky_desktop: true,
	is_sticky_mobile: true,
	line_between_accesses: true,
	logo: {
		desktop_icon: {
			filename: "hr-1-logo-desktop.svg",
			title: "hr-1-logo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt4cc88d1c198f9ef1/60c9928f0ece0255888d7968/hr-1-logo-desktop.svg"
		},
		mobile_icon: {
			filename: "hr-12-logo-mobile.svg",
			title: "hr-12-logo-mobile.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt529baed8dca866c1/60c9929ee1b3f7481347c560/hr-12-logo-mobile.svg"
		},
		url: "/falabella-cl",
		tablet_icon: {
			filename: "logo_160px.svg",
			title: "logo_160px.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt37d90a09b211d04b/60cc2f0bd78f9d375f081766/logo_160px.svg"
		}
	},
	menu: {
		desktop_icon: {
			filename: "hr-2-menu-desktop.svg",
			title: "hr-2-menu-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltd6d940bad112ae36/60c992a9b085be4819b86f09/hr-2-menu-desktop.svg"
		},
		mobile_icon: {
		},
		desktop_text: "Menu",
		mobile_text: "Menu"
	},
	myaccount_desktop: {
		hello_text: "Hola",
		items_logged_out: {
			last_item_style: true,
			items: [
				{
					title: "Inicia sesión",
					url: "",
					is_new_tab: true,
					icon: {
					},
					login: true,
					login_and_redirect: false
				},
				{
					title: "Regístrate",
					url: "/falabella-cl/myaccount/registration",
					is_new_tab: true,
					icon: {
					},
					login: false,
					login_and_redirect: false
				},
				{
					title: "Mi cuenta",
					url: "/falabella-cl/myaccount/userPersonalInformation",
					is_new_tab: true,
					icon: {
					},
					login: false,
					login_and_redirect: true
				},
				{
					title: "CMR Puntos",
					url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
					is_new_tab: true,
					icon: {
						filename: "hr-10-cmr-round.svg",
						title: "hr-10-cmr-round.svg",
						tags: [
						],
						url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltdf8c6970f686ace9/60c9a1bd5a50fc37590b1beb/hr-10-cmr-round.svg"
					},
					login: false,
					login_and_redirect: false
				}
			],
			login_text: "Inicia sesión"
		},
		items_logged_in: {
			last_item_style: false,
			items: {
				redirection_items: [
					{
						title: "Mi cuenta",
						catalyst_url: "/falabella-cl/myaccount/userPersonalInformation",
						atg_url: "/falabella-cl/myaccount/userPersonalInformation",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					},
					{
						title: "Mis CMR Puntos",
						catalyst_url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
						atg_url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
						is_new_tab: true,
						icon: {
						},
						is_cmr: true
					},
					{
						title: "Mis compras",
						catalyst_url: "/falabella-cl/myorders",
						atg_url: "/falabella-cl/myorders",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					},
					{
						title: "Mis Gift Cards",
						catalyst_url: "/falabella-cl/mi-cuenta/giftcards",
						atg_url: "/falabella-cl/mi-cuenta/giftcards",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					}
				],
				action_items: {
					cerrar_sesion: {
						title: "Cerrar Sesion"
					}
				}
			}
		}
	},
	myaccount_mobile: {
		hello_text: "Hola",
		close_icon: {
		},
		items_logged_out: {
			login_text: "Inicia sesión"
		},
		items_logged_in: {
			redirection_items: [
				{
					title: "Tienes",
					catalyst_url: "",
					atg_url: "",
					is_new_tab: true,
					icon: {
					},
					is_cmr: true
				},
				{
					title: "Mi cuenta",
					catalyst_url: "/falabella-cl/myaccount",
					atg_url: "/falabella-cl/myaccount",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				},
				{
					title: "Mis compras",
					catalyst_url: "/falabella-cl/myorders",
					atg_url: "/falabella-cl/myorders",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				},
				{
					title: "Mis Gift Cards",
					catalyst_url: "/falabella-cl/mi-cuenta/giftcards",
					atg_url: "/falabella-cl/mi-cuenta/giftcards",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				}
			],
			action_items: {
				cerrar_sesion: {
					title: "Cerrar sesión"
				}
			}
		}
	},
	myorders_desktop: {
		button_text: "Mis compras",
		url: "/falabella-cl/myorders"
	},
	our_stores: {
		items: [
			{
				icon: {
					filename: "hr-6-falabella.svg",
					title: "hr-6-falabella.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltdd4febec3e84e871/60c9aca0eefdde56c1143c6e/hr-6-falabella.svg"
				},
				url: "",
				is_new_tab: false,
				dropdown_items: [
					{
						title: "Moda F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/moda-cl"
					},
					{
						title: "Belleza F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/belleza-cl"
					},
					{
						title: "Casa F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/casa-cl"
					},
					{
						title: "Electro F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/electro-cl"
					}
				]
			},
			{
				icon: {
					filename: "hr-7-sodimac.svg",
					title: "hr-7-sodimac.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6b84a079db062ffe/60c9ad794e87de56c8122ac6/hr-7-sodimac.svg"
				},
				url: "https://sodimac.falabella.com/sodimac-cl/",
				is_new_tab: false,
				dropdown_items: [
				]
			},
			{
				icon: {
					filename: "hr-8-linio.svg",
					title: "hr-8-linio.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt61f2028271cd868e/60c9ad84610188558e3b3214/hr-8-linio.svg"
				},
				url: "https://linio.falabella.com/linio-cl",
				is_new_tab: false,
				dropdown_items: [
				]
			},
			{
				icon: {
					filename: "hr-9-tottus.svg",
					title: "hr-9-tottus.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt92c9788003828968/60c9ad90bdf5ed4ae2de2ed7/hr-9-tottus.svg"
				},
				url: "https://tottus.falabella.com/tottus-cl",
				is_new_tab: false,
				dropdown_items: [
				]
			}
		],
		title: "Nuestras tiendas:"
	},
	searchbar: {
		search_icon: {
			filename: "hr-3-search-desktop.svg",
			title: "hr-3-search-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt019384dffb744bb5/60c992b60504174955a9729b/hr-3-search-desktop.svg"
		},
		close_icon: {
		},
		desktop_placeholder: "¿Qué buscas?",
		mobile_placeholder: "¿Qué buscas?"
	},
	tags: [
	],
	title: "Staging",
	transversal_banner_url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
	huincha: {
		url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
		data: {
			content: ""
		}
	}
};
var headerV3CL = {
	entry: entry$a
};

var entry$b = {
	bottom_right_links: [
		{
			title: "Vende con nosotros",
			url: "https://www.falabella.com/falabella-cl/page/Vende-en-Falabella.com?mkid=LA_VI_VER_1000002626&staticPageId=42100010",
			is_new_tab: false,
			dropdown_items: [
			],
			last_item_style: false
		},
		{
			title: "Fpay",
			url: "https://fpay.cl/",
			is_new_tab: false,
			dropdown_items: [
			],
			last_item_style: false
		},
		{
			title: "Tarjeta CMR",
			url: "",
			is_new_tab: false,
			dropdown_items: [
				{
					title: "Pide tu CMR",
					url: "https://www.bancofalabella.cl/pide-tu-cmr-online",
					is_new_tab: false
				},
				{
					title: "Paga tu CMR",
					url: "https://pagorapido.bancofalabella.cl/?utm_source=falabella.com&utm_medium=header&utm_campaign=landing-datos-para-clientes",
					is_new_tab: false
				}
			],
			last_item_style: false
		},
		{
			title: "Ayuda",
			url: "",
			is_new_tab: false,
			dropdown_items: [
				{
					title: "Centro de Ayuda",
					url: "https://www.falabella.com/falabella-cl/page/contactanos",
					is_new_tab: false
				},
				{
					title: "Horario de tiendas",
					url: "https://www.falabella.com/falabella-cl/page/Horarios-especiales?sid=HO_HH_APE_27&staticPageId=38100001&uxref=horarios",
					is_new_tab: false
				},
				{
					title: "Venta telefónica 600 390 6500",
					url: "https://www.falabella.com/falabella-cl/page/contactanos?staticPageId=37900002&menu=contactanos&&sac",
					is_new_tab: false
				}
			],
			last_item_style: true
		}
	],
	cart: {
		icon_desktop: {
			filename: "hr-4-cart-desktop.svg",
			title: "hr-4-cart-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbbfae160b3e081f6/60c9ac28eefdde56c1143c66/hr-4-cart-desktop.svg"
		},
		icon_mobile: {
			filename: "hr-14-cart-mobile.svg",
			title: "hr-14-cart-mobile.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltb68b665c67cd07b4/60c9ac76eefdde56c1143c6a/hr-14-cart-mobile.svg"
		},
		url: "/falabella-cl/basket"
	},
	geofinder: {
		icon_desktop: {
			filename: "hr-5-geo-desktop.svg",
			title: "hr-5-geo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbb63b168b9d5e404/60c9ac81bdf5ed4ae2de2ed3/hr-5-geo-desktop.svg"
		},
		icon_mobile: {
			filename: "hr-5-geo-desktop.svg",
			title: "hr-5-geo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbb63b168b9d5e404/60c9ac81bdf5ed4ae2de2ed3/hr-5-geo-desktop.svg"
		}
	},
	header_configs: [
		{
			links: {
				catalystbaseurl: "https://staging.falabella.com",
				atgbaseurl: "https://cl-testcloud.falabella.com"
			},
			tags: [
			],
			title: "Rebranded Header FACL Staging",
			toggles: {
				isatgloginenabled: true,
				isgeolocationenabled: false,
				istypeaheadenabled: true,
				iszonemodalenabled: true,
				iscmrenabled: true
			}
		}
	],
	is_sticky_desktop: true,
	is_sticky_mobile: true,
	line_between_accesses: true,
	logo: {
		desktop_icon: {
			filename: "hr-1-logo-desktop.svg",
			title: "hr-1-logo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt4cc88d1c198f9ef1/60c9928f0ece0255888d7968/hr-1-logo-desktop.svg"
		},
		mobile_icon: {
			filename: "hr-12-logo-mobile.svg",
			title: "hr-12-logo-mobile.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt529baed8dca866c1/60c9929ee1b3f7481347c560/hr-12-logo-mobile.svg"
		},
		url: "/falabella-cl",
		tablet_icon: {
			filename: "logo_160px.svg",
			title: "logo_160px.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt37d90a09b211d04b/60cc2f0bd78f9d375f081766/logo_160px.svg"
		}
	},
	menu: {
		desktop_icon: {
			filename: "hr-2-menu-desktop.svg",
			title: "hr-2-menu-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltd6d940bad112ae36/60c992a9b085be4819b86f09/hr-2-menu-desktop.svg"
		},
		mobile_icon: {
		},
		desktop_text: "Menu",
		mobile_text: "Menu"
	},
	myaccount_desktop: {
		hello_text: "Hola",
		items_logged_out: {
			last_item_style: true,
			items: [
				{
					title: "Inicia sesión",
					url: "",
					is_new_tab: true,
					icon: {
					},
					login: true,
					login_and_redirect: false
				},
				{
					title: "Regístrate",
					url: "/falabella-cl/myaccount/registration",
					is_new_tab: true,
					icon: {
					},
					login: false,
					login_and_redirect: false
				},
				{
					title: "Mi cuenta",
					url: "/falabella-cl/myaccount/userPersonalInformation",
					is_new_tab: true,
					icon: {
					},
					login: false,
					login_and_redirect: true
				},
				{
					title: "CMR Puntos",
					url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
					is_new_tab: true,
					icon: {
						filename: "hr-10-cmr-round.svg",
						title: "hr-10-cmr-round.svg",
						tags: [
						],
						url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltdf8c6970f686ace9/60c9a1bd5a50fc37590b1beb/hr-10-cmr-round.svg"
					},
					login: false,
					login_and_redirect: false
				}
			],
			login_text: "Inicia sesión"
		},
		items_logged_in: {
			last_item_style: false,
			items: {
				redirection_items: [
					{
						title: "Mi cuenta",
						catalyst_url: "/falabella-cl/myaccount/userPersonalInformation",
						atg_url: "/falabella-cl/myaccount/userPersonalInformation",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					},
					{
						title: "Mis CMR Puntos",
						catalyst_url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
						atg_url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
						is_new_tab: true,
						icon: {
						},
						is_cmr: true
					},
					{
						title: "Mis compras",
						catalyst_url: "/falabella-cl/myorders",
						atg_url: "/falabella-cl/myorders",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					},
					{
						title: "Mis Gift Cards",
						catalyst_url: "/falabella-cl/mi-cuenta/giftcards",
						atg_url: "/falabella-cl/mi-cuenta/giftcards",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					}
				],
				action_items: {
					cerrar_sesion: {
						title: "Cerrar Sesion"
					}
				}
			}
		}
	},
	myaccount_mobile: {
		hello_text: "Hola",
		close_icon: {
		},
		items_logged_out: {
			login_text: "Inicia sesión"
		},
		items_logged_in: {
			redirection_items: [
				{
					title: "Tienes",
					catalyst_url: "",
					atg_url: "",
					is_new_tab: true,
					icon: {
					},
					is_cmr: true
				},
				{
					title: "Mi cuenta",
					catalyst_url: "/falabella-cl/myaccount",
					atg_url: "/falabella-cl/myaccount",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				},
				{
					title: "Mis compras",
					catalyst_url: "/falabella-cl/myorders",
					atg_url: "/falabella-cl/myorders",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				},
				{
					title: "Mis Gift Cards",
					catalyst_url: "/falabella-cl/mi-cuenta/giftcards",
					atg_url: "/falabella-cl/mi-cuenta/giftcards",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				}
			],
			action_items: {
				cerrar_sesion: {
					title: "Cerrar sesión"
				}
			}
		}
	},
	myorders_desktop: {
		button_text: "Mis compras",
		url: "/falabella-cl/myorders"
	},
	our_stores: {
		items: [
			{
				icon: {
					filename: "hr-6-falabella.svg",
					title: "hr-6-falabella.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltdd4febec3e84e871/60c9aca0eefdde56c1143c6e/hr-6-falabella.svg"
				},
				url: "",
				is_new_tab: false,
				dropdown_items: [
					{
						title: "Moda F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/moda-cl"
					},
					{
						title: "Belleza F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/belleza-cl"
					},
					{
						title: "Casa F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/casa-cl"
					},
					{
						title: "Electro F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/electro-cl"
					}
				]
			},
			{
				icon: {
					filename: "hr-7-sodimac.svg",
					title: "hr-7-sodimac.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6b84a079db062ffe/60c9ad794e87de56c8122ac6/hr-7-sodimac.svg"
				},
				url: "https://sodimac.falabella.com/sodimac-cl/",
				is_new_tab: false,
				dropdown_items: [
				]
			},
			{
				icon: {
					filename: "hr-8-linio.svg",
					title: "hr-8-linio.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt61f2028271cd868e/60c9ad84610188558e3b3214/hr-8-linio.svg"
				},
				url: "https://linio.falabella.com/linio-cl",
				is_new_tab: false,
				dropdown_items: [
				]
			},
			{
				icon: {
					filename: "hr-9-tottus.svg",
					title: "hr-9-tottus.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt92c9788003828968/60c9ad90bdf5ed4ae2de2ed7/hr-9-tottus.svg"
				},
				url: "https://tottus.falabella.com/tottus-cl",
				is_new_tab: false,
				dropdown_items: [
				]
			}
		],
		title: "Nuestras tiendas:"
	},
	searchbar: {
		search_icon: {
			filename: "hr-3-search-desktop.svg",
			title: "hr-3-search-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt019384dffb744bb5/60c992b60504174955a9729b/hr-3-search-desktop.svg"
		},
		close_icon: {
		},
		desktop_placeholder: "¿Qué buscas?",
		mobile_placeholder: "¿Qué buscas?"
	},
	tags: [
	],
	title: "Staging",
	transversal_banner_url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
	huincha: {
		url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
		data: {
			content: ""
		}
	}
};
var headerV3AR = {
	entry: entry$b
};

var entry$c = {
	bottom_right_links: [
		{
			title: "Vende con nosotros",
			url: "https://www.falabella.com/falabella-cl/page/Vende-en-Falabella.com?mkid=LA_VI_VER_1000002626&staticPageId=42100010",
			is_new_tab: false,
			dropdown_items: [
			],
			last_item_style: false
		},
		{
			title: "Fpay",
			url: "https://fpay.cl/",
			is_new_tab: false,
			dropdown_items: [
			],
			last_item_style: false
		},
		{
			title: "Tarjeta CMR",
			url: "",
			is_new_tab: false,
			dropdown_items: [
				{
					title: "Pide tu CMR",
					url: "https://www.bancofalabella.cl/pide-tu-cmr-online",
					is_new_tab: false
				},
				{
					title: "Paga tu CMR",
					url: "https://pagorapido.bancofalabella.cl/?utm_source=falabella.com&utm_medium=header&utm_campaign=landing-datos-para-clientes",
					is_new_tab: false
				}
			],
			last_item_style: false
		},
		{
			title: "Ayuda",
			url: "",
			is_new_tab: false,
			dropdown_items: [
				{
					title: "Centro de Ayuda",
					url: "https://www.falabella.com/falabella-cl/page/contactanos",
					is_new_tab: false
				},
				{
					title: "Horario de tiendas",
					url: "https://www.falabella.com/falabella-cl/page/Horarios-especiales?sid=HO_HH_APE_27&staticPageId=38100001&uxref=horarios",
					is_new_tab: false
				},
				{
					title: "Venta telefónica 600 390 6500",
					url: "https://www.falabella.com/falabella-cl/page/contactanos?staticPageId=37900002&menu=contactanos&&sac",
					is_new_tab: false
				}
			],
			last_item_style: true
		}
	],
	cart: {
		icon_desktop: {
			filename: "hr-4-cart-desktop.svg",
			title: "hr-4-cart-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbbfae160b3e081f6/60c9ac28eefdde56c1143c66/hr-4-cart-desktop.svg"
		},
		icon_mobile: {
			filename: "hr-14-cart-mobile.svg",
			title: "hr-14-cart-mobile.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltb68b665c67cd07b4/60c9ac76eefdde56c1143c6a/hr-14-cart-mobile.svg"
		},
		url: "/falabella-cl/basket"
	},
	geofinder: {
		icon_desktop: {
			filename: "hr-5-geo-desktop.svg",
			title: "hr-5-geo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbb63b168b9d5e404/60c9ac81bdf5ed4ae2de2ed3/hr-5-geo-desktop.svg"
		},
		icon_mobile: {
			filename: "hr-5-geo-desktop.svg",
			title: "hr-5-geo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltbb63b168b9d5e404/60c9ac81bdf5ed4ae2de2ed3/hr-5-geo-desktop.svg"
		}
	},
	header_configs: [
		{
			links: {
				catalystbaseurl: "https://staging.falabella.com",
				atgbaseurl: "https://cl-testcloud.falabella.com"
			},
			tags: [
			],
			title: "Rebranded Header FACL Staging",
			toggles: {
				isatgloginenabled: true,
				isgeolocationenabled: false,
				istypeaheadenabled: true,
				iszonemodalenabled: true,
				iscmrenabled: true
			}
		}
	],
	is_sticky_desktop: true,
	is_sticky_mobile: true,
	line_between_accesses: true,
	logo: {
		desktop_icon: {
			filename: "hr-1-logo-desktop.svg",
			title: "hr-1-logo-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt4cc88d1c198f9ef1/60c9928f0ece0255888d7968/hr-1-logo-desktop.svg"
		},
		mobile_icon: {
			filename: "hr-12-logo-mobile.svg",
			title: "hr-12-logo-mobile.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt529baed8dca866c1/60c9929ee1b3f7481347c560/hr-12-logo-mobile.svg"
		},
		url: "/falabella-cl",
		tablet_icon: {
			filename: "logo_160px.svg",
			title: "logo_160px.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt37d90a09b211d04b/60cc2f0bd78f9d375f081766/logo_160px.svg"
		}
	},
	menu: {
		desktop_icon: {
			filename: "hr-2-menu-desktop.svg",
			title: "hr-2-menu-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltd6d940bad112ae36/60c992a9b085be4819b86f09/hr-2-menu-desktop.svg"
		},
		mobile_icon: {
		},
		desktop_text: "Menu",
		mobile_text: "Menu"
	},
	myaccount_desktop: {
		hello_text: "Hola",
		items_logged_out: {
			last_item_style: true,
			items: [
				{
					title: "Inicia sesión",
					url: "",
					is_new_tab: true,
					icon: {
					},
					login: true,
					login_and_redirect: false
				},
				{
					title: "Regístrate",
					url: "/falabella-cl/myaccount/registration",
					is_new_tab: true,
					icon: {
					},
					login: false,
					login_and_redirect: false
				},
				{
					title: "Mi cuenta",
					url: "/falabella-cl/myaccount/userPersonalInformation",
					is_new_tab: true,
					icon: {
					},
					login: false,
					login_and_redirect: true
				},
				{
					title: "CMR Puntos",
					url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
					is_new_tab: true,
					icon: {
						filename: "hr-10-cmr-round.svg",
						title: "hr-10-cmr-round.svg",
						tags: [
						],
						url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltdf8c6970f686ace9/60c9a1bd5a50fc37590b1beb/hr-10-cmr-round.svg"
					},
					login: false,
					login_and_redirect: false
				}
			],
			login_text: "Inicia sesión"
		},
		items_logged_in: {
			last_item_style: false,
			items: {
				redirection_items: [
					{
						title: "Mi cuenta",
						catalyst_url: "/falabella-cl/myaccount/userPersonalInformation",
						atg_url: "/falabella-cl/myaccount/userPersonalInformation",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					},
					{
						title: "Mis CMR Puntos",
						catalyst_url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
						atg_url: "https://www.cmrpuntos.cl/home?utm_source=Falabella&utm_medium=web_desktop",
						is_new_tab: true,
						icon: {
						},
						is_cmr: true
					},
					{
						title: "Mis compras",
						catalyst_url: "/falabella-cl/myorders",
						atg_url: "/falabella-cl/myorders",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					},
					{
						title: "Mis Gift Cards",
						catalyst_url: "/falabella-cl/mi-cuenta/giftcards",
						atg_url: "/falabella-cl/mi-cuenta/giftcards",
						is_new_tab: true,
						icon: {
						},
						is_cmr: false
					}
				],
				action_items: {
					cerrar_sesion: {
						title: "Cerrar Sesion"
					}
				}
			}
		}
	},
	myaccount_mobile: {
		hello_text: "Hola",
		close_icon: {
		},
		items_logged_out: {
			login_text: "Inicia sesión"
		},
		items_logged_in: {
			redirection_items: [
				{
					title: "Tienes",
					catalyst_url: "",
					atg_url: "",
					is_new_tab: true,
					icon: {
					},
					is_cmr: true
				},
				{
					title: "Mi cuenta",
					catalyst_url: "/falabella-cl/myaccount",
					atg_url: "/falabella-cl/myaccount",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				},
				{
					title: "Mis compras",
					catalyst_url: "/falabella-cl/myorders",
					atg_url: "/falabella-cl/myorders",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				},
				{
					title: "Mis Gift Cards",
					catalyst_url: "/falabella-cl/mi-cuenta/giftcards",
					atg_url: "/falabella-cl/mi-cuenta/giftcards",
					is_new_tab: true,
					icon: {
					},
					is_cmr: false
				}
			],
			action_items: {
				cerrar_sesion: {
					title: "Cerrar sesión"
				}
			}
		}
	},
	myorders_desktop: {
		button_text: "Mis compras",
		url: "/falabella-cl/myorders"
	},
	our_stores: {
		items: [
			{
				icon: {
					filename: "hr-6-falabella.svg",
					title: "hr-6-falabella.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltdd4febec3e84e871/60c9aca0eefdde56c1143c6e/hr-6-falabella.svg"
				},
				url: "",
				is_new_tab: false,
				dropdown_items: [
					{
						title: "Moda F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/moda-cl"
					},
					{
						title: "Belleza F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/belleza-cl"
					},
					{
						title: "Casa F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/casa-cl"
					},
					{
						title: "Electro F",
						is_new_tab: false,
						url: "https://tienda.falabella.com/electro-cl"
					}
				]
			},
			{
				icon: {
					filename: "hr-7-sodimac.svg",
					title: "hr-7-sodimac.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6b84a079db062ffe/60c9ad794e87de56c8122ac6/hr-7-sodimac.svg"
				},
				url: "https://sodimac.falabella.com/sodimac-cl/",
				is_new_tab: false,
				dropdown_items: [
				]
			},
			{
				icon: {
					filename: "hr-8-linio.svg",
					title: "hr-8-linio.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt61f2028271cd868e/60c9ad84610188558e3b3214/hr-8-linio.svg"
				},
				url: "https://linio.falabella.com/linio-cl",
				is_new_tab: false,
				dropdown_items: [
				]
			},
			{
				icon: {
					filename: "hr-9-tottus.svg",
					title: "hr-9-tottus.svg",
					tags: [
					],
					url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt92c9788003828968/60c9ad90bdf5ed4ae2de2ed7/hr-9-tottus.svg"
				},
				url: "https://tottus.falabella.com/tottus-cl",
				is_new_tab: false,
				dropdown_items: [
				]
			}
		],
		title: "Nuestras tiendas:"
	},
	searchbar: {
		search_icon: {
			filename: "hr-3-search-desktop.svg",
			title: "hr-3-search-desktop.svg",
			tags: [
			],
			url: "https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt019384dffb744bb5/60c992b60504174955a9729b/hr-3-search-desktop.svg"
		},
		close_icon: {
		},
		desktop_placeholder: "¿Qué buscas?",
		mobile_placeholder: "¿Qué buscas?"
	},
	tags: [
	],
	title: "Staging",
	transversal_banner_url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
	huincha: {
		url: "https://www.falabella.com/static/RDF/site/home/promohuincha/html/ph_home.html",
		data: {
			content: ""
		}
	}
};
var headerV3PE = {
	entry: entry$c
};

var availableZones = {
	"2": true,
	"4": true,
	"5": true,
	"6": true,
	"7": true,
	"8": true,
	"9": true,
	"10": true,
	"11": true,
	"13": true,
	"14": true,
	"17": true,
	"18": true,
	"19": true,
	"20": true,
	"21": true,
	"22": true,
	"23": true,
	"24": true,
	"25": true,
	"27": true,
	"28": true,
	"29": true,
	"30": true,
	AFZone: true
};
var data = [
	{
		id: "2",
		name: "ANTIOQUIA"
	},
	{
		id: "4",
		name: "ATLANTICO"
	},
	{
		id: "5",
		name: "BOLIVAR"
	},
	{
		id: "6",
		name: "BOYACA"
	},
	{
		id: "7",
		name: "CALDAS"
	},
	{
		id: "8",
		name: "CAQUETA"
	},
	{
		id: "9",
		name: "CASANARE"
	},
	{
		id: "10",
		name: "CAUCA"
	},
	{
		id: "11",
		name: "CESAR"
	},
	{
		id: "13",
		name: "CORDOBA"
	},
	{
		id: "14",
		name: "CUNDINAMARCA"
	},
	{
		id: "17",
		name: "HUILA"
	},
	{
		id: "18",
		name: "LA GUAJIRA"
	},
	{
		id: "19",
		name: "MAGDALENA"
	},
	{
		id: "20",
		name: "META"
	},
	{
		id: "21",
		name: "NARIÑO"
	},
	{
		id: "22",
		name: "NORTE DE SANTANDER"
	},
	{
		id: "23",
		name: "PUTUMAYO"
	},
	{
		id: "24",
		name: "QUINDIO"
	},
	{
		id: "25",
		name: "RISARALDA"
	},
	{
		id: "27",
		name: "SANTANDER"
	},
	{
		id: "AFZone",
		name: "Seleccionar ubicación"
	},
	{
		id: "28",
		name: "SUCRE"
	},
	{
		id: "29",
		name: "TOLIMA"
	},
	{
		id: "30",
		name: "VALLE DEL CAUCA"
	}
];
var defaultZone = "AFZone";
var zonesV1CO = {
	availableZones: availableZones,
	data: data,
	defaultZone: defaultZone
};

var availableZones$1 = {
	"1": true,
	"2": true,
	"3": true,
	"4": true,
	"5": true,
	"6": true,
	"7": true,
	"8": true,
	"9": true,
	"10": true,
	"11": true,
	"12": true,
	"13": true,
	"14": true,
	"15": true,
	AFZone: true
};
var data$1 = [
	{
		id: "AFZone",
		name: "Seleccionar ubicación"
	},
	{
		id: "13",
		name: "Región Metropolitana (XIII)"
	},
	{
		id: "1",
		name: "Región de Tarapacá (I)"
	},
	{
		id: "2",
		name: "Región de Antofagasta (II)"
	},
	{
		id: "3",
		name: "Región de Atacama (III)"
	},
	{
		id: "4",
		name: "Región de Coquimbo (IV)"
	},
	{
		id: "5",
		name: "Región de Valparaíso (V)"
	},
	{
		id: "6",
		name: "Región del Libertador Gral. Bdo. O Higgins (VI)"
	},
	{
		id: "7",
		name: "Región del Maule (VII)"
	},
	{
		id: "8",
		name: "Región del Biobío (VIII)"
	},
	{
		id: "9",
		name: "Región de la Araucanía (IX)"
	},
	{
		id: "10",
		name: "Región de los Lagos (X)"
	},
	{
		id: "11",
		name: "Región de Aysén (XI)"
	},
	{
		id: "12",
		name: "Región de Magallanes y la Antártica Chilena (XII)"
	},
	{
		id: "14",
		name: "Región de los Ríos (XIV)"
	},
	{
		id: "15",
		name: "Región Arica y Parinacota (XV)"
	}
];
var defaultZone$1 = "AFZone";
var zonesV1CL = {
	availableZones: availableZones$1,
	data: data$1,
	defaultZone: defaultZone$1
};

var availableZones$2 = {
	"1000": true,
	"1100": true,
	"1200": true,
	"1300": true,
	"1400": true,
	"1500": true,
	"1600": true,
	"1700": true,
	"1800": true,
	"1900": true,
	"2000": true,
	"2100": true,
	"2200": true,
	"2300": true,
	"2400": true,
	"2500": true,
	"2600": true,
	"2700": true,
	"2800": true,
	"2900": true,
	"3000": true,
	"3100": true,
	"3200": true,
	AFZone: true
};
var data$2 = [
	{
		id: "AFZone",
		name: " Seleccionar ubicación"
	},
	{
		id: "2700",
		name: "BUENOS AIRES"
	},
	{
		id: "1900",
		name: "CATAMARCA"
	},
	{
		id: "1400",
		name: "CHACO"
	},
	{
		id: "3100",
		name: "CHUBUT"
	},
	{
		id: "1000",
		name: "CIUDAD AUTONOMA DE BS.AS."
	},
	{
		id: "2000",
		name: "CORDOBA"
	},
	{
		id: "1800",
		name: "CORRIENTES"
	},
	{
		id: "2300",
		name: "ENTRE RIOS"
	},
	{
		id: "1300",
		name: "FORMOSA"
	},
	{
		id: "1100",
		name: "JUJUY"
	},
	{
		id: "2800",
		name: "LA PAMPA"
	},
	{
		id: "2400",
		name: "LA RIOJA"
	},
	{
		id: "2200",
		name: "MENDOZA"
	},
	{
		id: "1500",
		name: "MISIONES"
	},
	{
		id: "2900",
		name: "NEUQUEN"
	},
	{
		id: "3000",
		name: "RIO NEGRO"
	},
	{
		id: "1200",
		name: "SALTA"
	},
	{
		id: "2500",
		name: "SAN JUAN"
	},
	{
		id: "2600",
		name: "SAN LUIS"
	},
	{
		id: "3200",
		name: "SANTA CRUZ"
	},
	{
		id: "2100",
		name: "SANTA FE"
	},
	{
		id: "1700",
		name: "STAGO. DEL ESTERO"
	},
	{
		id: "1600",
		name: "TUCUMAN"
	}
];
var defaultZone$2 = "AFZone";
var zonesV1AR = {
	availableZones: availableZones$2,
	data: data$2,
	defaultZone: defaultZone$2
};

var availableZones$3 = {
	"10000": true,
	"20000": true,
	"30000": true,
	"40000": true,
	"50000": true,
	"60000": true,
	"70000": true,
	"80000": true,
	"90000": true,
	"100000": true,
	"110000": true,
	"120000": true,
	"130000": true,
	"140000": true,
	"150000": true,
	"160000": true,
	"180000": true,
	"190000": true,
	"200000": true,
	"210000": true,
	"220000": true,
	"230000": true,
	"240000": true,
	"250000": true,
	AFZone: true
};
var data$3 = [
	{
		id: "10000",
		name: "AMAZONAS"
	},
	{
		id: "20000",
		name: "ANCASH"
	},
	{
		id: "30000",
		name: "APURIMAC"
	},
	{
		id: "40000",
		name: "AREQUIPA"
	},
	{
		id: "50000",
		name: "AYACUCHO"
	},
	{
		id: "60000",
		name: "CAJAMARCA"
	},
	{
		id: "70000",
		name: "CALLAO"
	},
	{
		id: "80000",
		name: "CUZCO"
	},
	{
		id: "90000",
		name: "HUANCAVELICA"
	},
	{
		id: "100000",
		name: "HUANUCO"
	},
	{
		id: "110000",
		name: "ICA"
	},
	{
		id: "120000",
		name: "JUNIN"
	},
	{
		id: "130000",
		name: "LA LIBERTAD"
	},
	{
		id: "140000",
		name: "LAMBAYEQUE"
	},
	{
		id: "150000",
		name: "LIMA"
	},
	{
		id: "160000",
		name: "LORETO"
	},
	{
		id: "180000",
		name: "MOQUEGUA"
	},
	{
		id: "190000",
		name: "PASCO"
	},
	{
		id: "200000",
		name: "PIURA"
	},
	{
		id: "210000",
		name: "PUNO"
	},
	{
		id: "220000",
		name: "SAN MARTIN"
	},
	{
		id: "AFZone",
		name: "Seleccionar ubicación"
	},
	{
		id: "230000",
		name: "TACNA"
	},
	{
		id: "240000",
		name: "TUMBES"
	},
	{
		id: "250000",
		name: "UCAYALI"
	}
];
var defaultZone$3 = "AFZone";
var zonesV1PE = {
	availableZones: availableZones$3,
	data: data$3,
	defaultZone: defaultZone$3
};

var entry$d = {
	_version: 9,
	bottom_right_links: [
	],
	brand_logo: {
		desktop_icon: {
			_version: 1,
			title: "carterslogo.svg",
			filename: "carterslogo.svg",
			tags: [
			],
			url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blte519222fb2afb54e/679c7958e729222d0f536c25/carterslogo.svg"
		},
		tablet_icon: {
			_version: 1,
			title: "carterslogo.svg",
			filename: "carterslogo.svg",
			tags: [
			],
			url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blte519222fb2afb54e/679c7958e729222d0f536c25/carterslogo.svg"
		},
		mobile_icon: {
			_version: 1,
			title: "carterslogo.svg",
			filename: "carterslogo.svg",
			tags: [
			],
			url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blte519222fb2afb54e/679c7958e729222d0f536c25/carterslogo.svg"
		},
		url: "/"
	},
	cart: {
		icon_desktop: {
			_version: 1,
			title: "header-cart.svg",
			filename: "header-cart.svg",
			tags: [
			],
			url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt30b9f0658ce8c7d6/67aded68890f91dd6d51c5c5/header-cart.svg"
		},
		icon_mobile: {
			_version: 1,
			title: "header-cart.svg",
			filename: "header-cart.svg",
			tags: [
			],
			url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt30b9f0658ce8c7d6/67aded68890f91dd6d51c5c5/header-cart.svg"
		},
		url: "/cart",
		number_color: "",
		product_counter_bg_color: ""
	},
	cross_banner: {
		banner_desktop_image: {
		},
		banner_mobile_image: {
		},
		banner_position: {
		},
		banner_visible: false,
		is_new_tab: false,
		url: ""
	},
	geofinder: {
		text_color: "#495867",
		icon_desktop: {
			_version: 1,
			title: "location-geofinder 1.svg",
			filename: "location-geofinder_1.svg",
			tags: [
			],
			url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt429e1e008b47cd51/67adef11a76cfcc065f76c87/location-geofinder_1.svg"
		},
		icon_mobile: {
			_version: 1,
			title: "location-geofinder 1.svg",
			filename: "location-geofinder_1.svg",
			tags: [
			],
			url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt429e1e008b47cd51/67adef11a76cfcc065f76c87/location-geofinder_1.svg"
		},
		geo_finder_chosen_address_text: "",
		geo_finder_select_address_text: ""
	},
	header_configs: [
		{
			_version: 3,
			links: {
				catalystbaseurl: "https://staging.falabella.com"
			},
			property_configs: {
				geofinder: {
					notification_inactive_session: "",
					notification_life: ""
				},
				web_push_notifications: {
					ask_again_delay: 1209600
				}
			},
			tags: [
			],
			title: "[Staging] - Carters Header Config",
			toggles: {
				is_sticky_header_desktop: false,
				is_sticky_header_mobile: false,
				iswishlistenabled: false,
				ismyordersenabled: true,
				isgeolocationenabled: false,
				istypeaheadenabled: false,
				iszonemodalenabled: true,
				isonboardingenabled: true,
				issearchexperiencecheckbox: false,
				iswebpushnotificationenabled: true,
				isanalyticsinfov2enabled: false,
				isprogramaticallygeofinderenabled: false,
				isrecentsearchesenabled: false,
				ispopovervisible: false,
				ismyaccountenabled: true
			}
		}
	],
	header_themes: {
		top_background_color: "#fff",
		top_text_color: "#343E49",
		bottom_background_color: "#fff",
		bottom_text_color: "#495867",
		font: {
			font_family: "",
			font_link: ""
		}
	},
	menu: {
		menu_type: "Button Menu",
		desktop: {
			icon: {
				_version: 1,
				title: "menuhamburger.svg",
				filename: "menuhamburger.svg",
				tags: [
				],
				url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt90792027e39db4dc/679c849c31e91973afa599ae/menuhamburger.svg"
			},
			text: "Menú",
			background_color: ""
		},
		mobile: {
			icon: {
				_version: 1,
				title: "menuhamburger.svg",
				filename: "menuhamburger.svg",
				tags: [
				],
				url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/blt90792027e39db4dc/679c849c31e91973afa599ae/menuhamburger.svg"
			},
			text: "Menú",
			background_color: ""
		},
		text_color: "#333",
		close_icon: {
			_version: 1,
			title: "Group 1.svg",
			filename: "Group_1.svg",
			tags: [
			],
			url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/bltdeb40ae1b6cb0114/67adecb3d4104e90845da3e6/Group_1.svg"
		}
	},
	myaccount_desktop: {
		hello_text: "Hola",
		text_color: "#333",
		items_logged_out: {
			login_text: "Inicia sesión",
			last_item_style: false,
			items: [
				{
					title: "Inicia sesión",
					url: "",
					is_new_tab: true,
					icon: {
					},
					login: true,
					login_and_redirect: false
				}
			]
		},
		items_logged_in: {
			last_item_style: false,
			items: {
				action_items: {
					cerrar_sesion: {
						title: "Cerrar sesion"
					}
				},
				redirection_items: [
				]
			}
		}
	},
	myaccount_mobile: {
		hello_text: "Hola",
		text_color: "#333",
		close_icon: {
		},
		items_logged_out: {
			login_text: "Inicia sesión"
		},
		items_logged_in: {
			redirection_items: [
			],
			action_items: {
				cerrar_sesion: {
					title: "Cerrar sesión"
				}
			}
		}
	},
	myorders_desktop: {
		button_text: "Mis compras",
		text_color: "#333",
		url: "https://staging.falabella.com/falabella-cl/myorders"
	},
	onboarding: {
		desktop: [
		],
		mobile: [
		]
	},
	pdp_themes: {
		styles: {
			border_radius: "0px",
			color: "#00a9e0",
			secondary_color: "#096588"
		}
	},
	searchbar: {
		icon: {
			search_icon: {
				_version: 1,
				title: "top-bar-search.svg",
				filename: "top-bar-search.svg",
				tags: [
				],
				url: "https://images-staging.falabella.com/v3/assets/bltb9d14061af10d563/bltd406f855f58a5006/67aded004808983bf5cb782c/top-bar-search.svg"
			},
			close_icon: {
			},
			search_icon_background_color: "#179DCA"
		},
		desktop_placeholder: "¿Qué buscas?",
		mobile_placeholder: "¿Qué buscas?",
		search_placeholder_text_color: "",
		border_color: "#343E49",
		border_radius: "80px"
	},
	tags: [
	],
	title: "[Staging] - Carters Header",
	wishlist: {
		icon_desktop: {
		},
		icon_mobile: {
		},
		url: ""
	},
	xlp_themes: {
		styles: {
			border_radius: "0px",
			color: "#00a9e0",
			secondary_color: "#096588"
		}
	},
	huincha: {
		data: {
			content: ""
		}
	}
};
var whitelabelHeaderV3 = {
	entry: entry$d
};

var headerFallback = {
  v2: {
    ar: headerV2AR,
    cl: headerV2CL,
    co: headerV2CO,
    pe: headerV2PE
  },
  v3: {
    ar: headerV3AR,
    cl: headerV3CL,
    co: headerV3CO,
    pe: headerV3PE
  },
  zones_v1: {
    ar: zonesV1AR,
    cl: zonesV1CL,
    co: zonesV1CO,
    pe: zonesV1PE
  }
};
var whitelabelHeaderFallback = {
  v3: whitelabelHeaderV3
};

var entry$e = {
	title: "[Staging] - Carters Menu",
	browse_main_text: "Menú",
	hightlight_color: "rgba(0, 169, 224, 0.05)",
	hightlight_text_color: "#111",
	color_line: "#00A9E0",
	data_wrapper: "",
	default_category_colors: {
		level_one_category_color: "#111",
		level_two_category_color: "#111",
		level_three_category_color: "#111",
		highlight_level_category_color: "#111"
	},
	categories: [
		{
			title: "test carters",
			item_name: "test carters",
			item_color: "",
			item_url: {
				title: "/",
				href: "/"
			},
			new_tab: false,
			channel: {
				desktop: true,
				mobile: true
			},
			highlight_level_categories: [
			],
			second_level_categories: [
				{
					item_name: "test level 2",
					item_color: "",
					item_url: "",
					new_tab: false,
					tag: {
						show: false,
						text: "",
						background_color: ""
					},
					third_level_categories: [
					],
					_metadata: {
						uid: "cs94c3c5957c7c7078"
					}
				}
			],
			banners: [
			],
			_metadata: {
				uid: "cs85c2b649854faaa6"
			}
		}
	],
	tags: [
	],
	locale: "fa-carters-cl",
	uid: "blta75870c3ba8bf89d",
	created_by: "blt516974f8f995a2ce",
	updated_by: "blt516974f8f995a2ce",
	created_at: "2025-02-17T11:40:28.389Z",
	updated_at: "2025-02-21T06:43:12.528Z",
	ACL: {
	},
	_version: 2,
	_in_progress: false
};
var whitelabelMenuV2CL = {
	entry: entry$e
};

var whitelabelMenuFallback = {
  v2: whitelabelMenuV2CL
};

var getSisNavigationMenu = function () {
  var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(_ref) {
    var tenant, baseUrl, store, menuFallbackData, validTenant, sisMenu;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          tenant = _ref.tenant, baseUrl = _ref.baseUrl, store = _ref.store;
          if (store) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", null);
        case 3:
          menuFallbackData = isWhitelabel(store) ? whitelabelMenuFallback.v2 : null;
          validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
          _context.next = 7;
          return doFetch(buildContentUrl(baseUrl, 'sisMenu', validTenant, 'v2', store), {}, {
            data: menuFallbackData,
            triggerOnResponseError: true,
            triggerOnNetworkError: true
          });
        case 7:
          sisMenu = _context.sent;
          return _context.abrupt("return", sisMenu);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getSisNavigationMenu(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getHeaderData = function () {
  var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(_ref3) {
    var tenant, baseUrl, store, validTenant, headerFallbackData, _yield$Promise$all, _yield$Promise$all2, header, transversalBannerHtml;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          tenant = _ref3.tenant, baseUrl = _ref3.baseUrl, store = _ref3.store;
          validTenant = isValidTenant(tenant) ? tenant : countriesCode.FACL;
          headerFallbackData = isWhitelabel(store) ? whitelabelHeaderFallback.v3 : headerFallback.v3[validTenant];
          _context2.next = 5;
          return Promise.all([doFetch(buildContentUrl(baseUrl, 'header', validTenant, 'v3', store), {}, {
            data: headerFallbackData,
            triggerOnResponseError: true,
            triggerOnNetworkError: true
          }), doFetch(buildContentUrl(baseUrl, 'transversal', validTenant, 'v3', store), {}, {
            data: transversalFallback.v3[validTenant],
            triggerOnResponseError: true,
            triggerOnNetworkError: true
          })]);
        case 5:
          _yield$Promise$all = _context2.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          header = _yield$Promise$all2[0];
          transversalBannerHtml = _yield$Promise$all2[1];
          return _context2.abrupt("return", _objectSpread2({}, header, {
            transversalBannerHtml: transversalBannerHtml
          }));
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getHeaderData(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var checkMobileApp = function checkMobileApp() {
  var urlSearchParams = new URLSearchParams(window.location.search);
  var _Object$fromEntries = Object.fromEntries(urlSearchParams.entries()),
    externalSiteName = _Object$fromEntries.externalSiteName,
    sid = _Object$fromEntries.sid;
  return externalSiteName === 'MobileApp' && sid === 'APPMOBILE';
};
var siteValue = function siteValue(store) {
  var subDomain = getSubdomain();
  var expParam = getEXPParam();
  var isValidExpParam = function isValidExpParam() {
    return (isPdpPage() || !subDomain && isLandingPage()) && expParam;
  };
  var currentSiteValue = isPdpPage() ? null : subDomain;
  return store || (isValidExpParam() ? expParam : currentSiteValue);
};
var shouldStickyActivate = function shouldStickyActivate(currScroll) {
  var worldsMenuBar = document.querySelector('[data-wrapper="EM-Worldsapp"]');
  var filterSection = document.getElementById('testId-facets-mobile-container');
  return !!worldsMenuBar && currScroll + 70 > get(worldsMenuBar, 'offsetTop', null) || !!filterSection && currScroll + 70 > get(filterSection, 'offsetTop', null);
};
var toggleHeader = function toggleHeader(currDirection, currScroll, threshold, styles) {
  var toggledValue = true;
  var headerElement = document.getElementById('scrollable-content');
  var bottomHeaderElement = document.getElementById('bottom-header');
  headerElement.classList.remove("".concat(styles['header-scroll-styles']));
  bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
  if (currDirection === 2) {
    headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
  }
  if (currDirection === 2 && currScroll > threshold && !shouldStickyActivate(currScroll)) {
    headerElement.classList.add("".concat(styles.hide));
  } else if (currDirection === 1 && currScroll > threshold && !shouldStickyActivate(currScroll)
  ) {
    headerElement.classList.remove("".concat(styles.hide));
    headerElement.classList.add("".concat(styles['header-scroll-styles']));
    bottomHeaderElement.classList.add("".concat(styles['bottom-header']));
  } else {
    toggledValue = false;
    if (headerElement.classList.contains("".concat(styles.hide))) {
      headerElement.classList.remove("".concat(styles.hide));
    }
  }
  return toggledValue;
};
var getMapCentroid = function getMapCentroid(data, selectedId) {
  if (data.length) {
    if (selectedId) {
      var selectedItem = data.find(function (_ref5) {
        var id = _ref5.id;
        return id === selectedId;
      });
      return {
        lat: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.latitude,
        lng: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.longitude
      };
    } else {
      var _data$, _data$2;
      return {
        lat: data === null || data === void 0 ? void 0 : (_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.latitude,
        lng: data === null || data === void 0 ? void 0 : (_data$2 = data[0]) === null || _data$2 === void 0 ? void 0 : _data$2.longitude
      };
    }
  } else {
    return {
      lat: 0,
      lng: 0
    };
  }
};

var GoogleMaps = function GoogleMaps(_ref) {
  var markersData = _ref.markersData,
    containerStyle = _ref.containerStyle,
    handleDragEnd = _ref.handleDragEnd,
    zoom = _ref.zoom,
    handleMarkerClick = _ref.handleMarkerClick,
    isMarkerInteractive = _ref.isMarkerInteractive,
    selectedPinId = _ref.selectedPinId,
    externalMapRef = _ref.mapRef,
    zoomControl = _ref.zoomControl,
    isSingleFingerScrollEnabled = _ref.isSingleFingerScrollEnabled;
  var internalMapRef = React.useRef(null);
  var mapRef = externalMapRef || internalMapRef;
  var labels = configs$1.labels,
    constants = configs$1.constants;
  var _useLoadScript = useLoadScript({
      googleMapsApiKey: constants.REACT_APP_GOOGLE_MAPS_API_KEY
    }),
    isLoaded = _useLoadScript.isLoaded,
    loadError = _useLoadScript.loadError;
  var _React$useState = React.useState(function () {
      return getMapCentroid(markersData, selectedPinId);
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mapCenter = _React$useState2[0],
    setMapCenter = _React$useState2[1];
  React.useEffect(function () {
    var _getMapCentroid = getMapCentroid(markersData, selectedPinId),
      lat = _getMapCentroid.lat,
      lng = _getMapCentroid.lng;
    setMapCenter({
      lat: lat,
      lng: lng
    });
  }, [selectedPinId, markersData]);
  var handleMarkerClickState = function handleMarkerClickState(index) {
    if (!isMarkerInteractive) return;
    handleMarkerClick(index);
  };
  if (loadError) return jsx("div", null, labels.ERROR_LOADING_MAPS);
  if (!isLoaded) {
    return jsx("div", {
      style: {
        height: containerStyle.height
      },
      className: styles$F['map-container']
    }, jsx("div", {
      className: styles$F['skeleton-placeholder']
    }, jsx("div", {
      className: classNames(styles$F['skeleton-box'], styles$F['skeleton-map'])
    })));
  }
  var onMapDragEnd = function onMapDragEnd() {
    if (mapRef.current) {
      var newCenter = mapRef.current.getCenter();
      setMapCenter({
        lat: newCenter.lat(),
        lng: newCenter.lng()
      });
      if (handleDragEnd) {
        handleDragEnd({
          lat: newCenter.lat(),
          lng: newCenter.lng()
        });
      }
    }
  };
  return jsx(GoogleMap, {
    mapContainerStyle: containerStyle,
    center: mapCenter,
    zoom: zoom,
    onLoad: function onLoad(map) {
      mapRef.current = map;
    },
    onDragEnd: onMapDragEnd,
    options: {
      disableDefaultUI: true,
      zoomControl: zoomControl,
      gestureHandling: isSingleFingerScrollEnabled ? 'greedy' : ''
    }
  }, markersData.map(function (marker, index) {
    return jsx(Marker, {
      key: index,
      onClick: function onClick() {
        return handleMarkerClickState(marker === null || marker === void 0 ? void 0 : marker.id);
      },
      position: {
        lat: Number(marker.latitude),
        lng: Number(marker.longitude)
      },
      draggable: marker.draggable || false,
      icon: {
        url: marker.icon || svgToDataUri(mapMarker),
        scaledSize: new window.google.maps.Size(marker !== null && marker !== void 0 && marker.selected ? 70 : 50,
        marker !== null && marker !== void 0 && marker.selected ? 70 : 50),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point((marker !== null && marker !== void 0 && marker.selected ? 70 : 50) / 2,
        marker !== null && marker !== void 0 && marker.selected ? 70 : 50)
      }
    });
  }));
};
GoogleMaps.defaultProps = {
  markersData: [],
  zoom: 15,
  containerStyle: {
    width: '100%',
    height: '400px'
  },
  handleDragEnd: function handleDragEnd() {},
  handleMarkerClick: noop,
  isMarkerInteractive: false,
  selectedPinId: '',
  zoomControl: true,
  isSingleFingerScrollEnabled: false
};
GoogleMaps.propTypes = process.env.NODE_ENV !== "production" ? {
  mapRef: PropTypes.shape({
    current: PropTypes.object
  }),
  markersData: PropTypes.arrayOf(PropTypes.shape({
    latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    draggable: PropTypes.bool,
    icon: PropTypes.string
  })),
  containerStyle: PropTypes.object,
  handleDragEnd: PropTypes.func,
  handleMarkerClick: PropTypes.func,
  isMarkerInteractive: PropTypes.bool,
  zoomControl: PropTypes.bool,
  zoom: PropTypes.number,
  selectedPinId: PropTypes.string,
  isSingleFingerScrollEnabled: PropTypes.bool
} : {};

var styles$G = {"input-container":"InputBox-module_input-container__wpOod","inputBox":"InputBox-module_inputBox__1MyA2","icon":"InputBox-module_icon__TGb6v","ellipsis":"InputBox-module_ellipsis__3VoVD"};

var InputBox = function InputBox(props) {
  var label = props.label,
    hideLabel = props.hideLabel,
    type = props.type,
    id = props.id,
    placeholder = props.placeholder,
    icon = props.icon,
    handleChange = props.handleChange,
    name = props.name,
    value = props.value,
    hasEllipsis = props.hasEllipsis,
    readOnly = props.readOnly,
    onClick = props.onClick,
    maxLength = props.maxLength;
  return jsx("div", {
    className: styles$G['input-container']
  }, !hideLabel && jsx("label", {
    htmlFor: id
  }, label), jsx("input", {
    className: classNames(styles$G.inputBox, _defineProperty({}, styles$G.ellipsis, hasEllipsis)),
    type: type,
    readOnly: readOnly,
    name: name,
    maxLength: maxLength,
    onClick: onClick,
    placeholder: placeholder,
    onChange: handleChange,
    id: id,
    value: value
  }), !!icon && jsx("div", {
    className: styles$G.icon
  }, icon));
};
InputBox.defaultProps = {
  placeholder: '',
  type: 'text',
  hideLabel: false,
  hasEllipsis: false,
  readOnly: false,
  onClick: function onClick() {},
  maxLength: 50
};
InputBox.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string.isRequired,
  hideLabel: PropTypes.bool,
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  maxLength: PropTypes.number
} : {};

var getBaseUrl = function getBaseUrl(tenant) {
  var _window, _window$location;
  var envPrefix = 'www';
  var baseUrl = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin;
  if (baseUrl && (baseUrl.includes(ENVIRONMENT.DEVELOPMEMT) || baseUrl.includes(ENVIRONMENT.STAGING))) {
    envPrefix = 'staging';
  }
  return "https://".concat(envPrefix, ".fazil-app.com/").concat(tenant, "/s/delivery-tottusya-service/v3/available-delivery-services");
};
var getTottusZones = function () {
  var _ref = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(latitude, longitude, tenant) {
    var _response;
    var response, baseUrl;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          response = {};
          _context.prev = 1;
          baseUrl = getBaseUrl(tenant);
          _context.next = 5;
          return doFetch("".concat(baseUrl, "?coordinates=").concat(latitude, ",").concat(longitude), {
            headers: {
              source: 'tottusya'
            }
          });
        case 5:
          response = _context.sent;
          _context.next = 11;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](1);
          console.error('Zone validation failed', _context.t0.message);
        case 11:
          return _context.abrupt("return", ((_response = response) === null || _response === void 0 ? void 0 : _response.tottusYaZones) || []);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function getTottusZones(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var MapSelection = function MapSelection(_ref) {
  var setCurrentView = _ref.setCurrentView,
    saveZone = _ref.saveZone,
    selectedComuna = _ref.selectedComuna,
    handleChange = _ref.handleChange,
    addressLinesData = _ref.addressLinesData,
    setBusy = _ref.setBusy,
    setAddressLinesData = _ref.setAddressLinesData,
    isUserLoggedIn = _ref.isUserLoggedIn,
    tenant = _ref.tenant,
    store = _ref.store,
    selectedRegion = _ref.selectedRegion,
    saveAdressData = _ref.saveAdressData,
    setShowLoginForm = _ref.setShowLoginForm,
    setModalVisible = _ref.setModalVisible;
  var labels = configs$1.labels,
    constants = configs$1.constants;
  var mapLabels = labels.NEW_ZONE_MODAL_LABELS.VIEW2;
  var onMarkerDragEnd = React.useCallback(function (event) {
    var newLat = event.latLng.lat();
    var newLng = event.latLng.lng();
    setAddressLinesData(_objectSpread2({}, addressLinesData, {
      latitude: newLat,
      longitude: newLng
    }));
  }, []);
  var validateZones = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
      var response, response2, unescapeATGCookies, getCookie, cookieSID, data, error, domain;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setBusy(true);
            _context.next = 3;
            return getTottusZones(addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.latitude, addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.longitude, tenant);
          case 3:
            response = _context.sent;
            setBusy(false);
            if (!(response !== null && response !== void 0 && response.length)) {
              _context.next = 34;
              break;
            }
            if (isUserLoggedIn) {
              _context.next = 9;
              break;
            }
            saveAdressData(_objectSpread2({}, addressLinesData), response, selectedComuna);
            return _context.abrupt("return");
          case 9:
            _context.prev = 9;
            unescapeATGCookies = CookieStorage.unescapeATGCookies, getCookie = CookieStorage.getCookie;
            cookieSID = process.env.ENVIRONMENT === 'dev' ? process.env.TEST_COOKIE_SID : unescapeATGCookies(getCookie('sid'));
            data = {
              state: selectedComuna.parentStateName,
              customInfo: [{
                name: 'stateCode',
                value: selectedRegion.code
              }, {
                name: 'statePoliticalAreaId',
                value: selectedComuna.parentStateId
              }, {
                name: 'municipalCode',
                value: selectedComuna.code
              }, {
                name: 'municipalPoliticalAreaId',
                value: selectedComuna.politicalId
              }, {
                name: 'department',
                value: addressLinesData.landmark
              }],
              municipal: selectedComuna.name,
              addressLine1: addressLinesData.addressLine1,
              addressLine2: addressLinesData.addressLine2,
              latitude: addressLinesData.latitude,
              longitude: addressLinesData.longitude
            };
            if (tenant === 'pe') {
              data.city = selectedComuna.parentCountyName;
              data.customInfo.push({
                name: 'cityCode',
                value: selectedComuna.parentPoliticalId
              });
            }
            _context.next = 16;
            return saveUserAddresses(cookieSID, tenant, store, data);
          case 16:
            response2 = _context.sent;
            if (!(response2.errors && response2.errors.length > 0)) {
              _context.next = 21;
              break;
            }
            error = new Error("".concat(response2.errors[0].message, " (").concat(response2.errors[0].code, ")"));
            error.code = response2.errors[0].code;
            throw error;
          case 21:
            _context.next = 31;
            break;
          case 23:
            _context.prev = 23;
            _context.t0 = _context["catch"](9);
            if (!(_context.t0.code === constants.ERROR_CODES.INVALID_SESSION)) {
              _context.next = 29;
              break;
            }
            setModalVisible(false);
            setShowLoginForm(true);
            return _context.abrupt("return");
          case 29:
            console.log(_context.t0);
            saveZone(response === null || response === void 0 ? void 0 : response.tottusYaZones);
          case 31:
            if (response2) {
              setCurrentView('view4');
              domain = CookieStorage.getHost(tenant);
              CookieStorage.removeCookieByDomain({
                name: constants.ADDRESS_IDS,
                domain: domain
              });
            }
            _context.next = 35;
            break;
          case 34:
            setCurrentView('view3');
          case 35:
            setBusy(false);
          case 36:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[9, 23]]);
    }));
    return function validateZones() {
      return _ref2.apply(this, arguments);
    };
  }();
  return jsx("div", null, jsx("div", {
    className: styles$C['warning-section']
  }, jsx("span", {
    className: styles$C['warning-icon']
  }), jsx("p", null, mapLabels.WARNING_LABEL)), jsx(GoogleMaps, {
    markersData: [{
      latitude: addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.latitude,
      longitude: addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.longitude,
      draggable: true,
      icon: svgToDataUri(mapMarker)
    }],
    containerStyle: {
      width: '100%',
      height: '45vh'
    },
    onMarkerDragEnd: onMarkerDragEnd,
    zoom: 15
  }), jsx("div", {
    className: styles$C['input-section']
  }, jsx(InputBox, {
    label: "Direcci\xF3n",
    hasEllipsis: true,
    readOnly: true,
    onClick: function onClick() {
      return setCurrentView('view1');
    },
    value: getTottusAddress(_objectSpread2({}, addressLinesData, {
      comuna: selectedComuna.name,
      region: selectedComuna.parentStateName
    })),
    icon: jsx("span", {
      onClick: function onClick() {
        return setCurrentView('view1');
      },
      className: styles$C['edit-icon']
    })
  }), jsx(InputBox, {
    placeholder: 'Ej; Casa 10',
    value: addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.landmark,
    handleChange: handleChange,
    name: "landmark",
    label: "Dpto./Casa/Oficina/Condominio (opcional)"
  }), jsx("button", {
    onClick: _asyncToGenerator( _regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return validateZones();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })),
    className: styles$C['save-location']
  }, mapLabels.SAVE)));
};

var ZoneSelection = function ZoneSelection(_ref) {
  var regionsSuggestion = _ref.regionsSuggestion,
    comunaSuggestion = _ref.comunaSuggestion,
    regionChangeHandler = _ref.regionChangeHandler,
    selectedRegion = _ref.selectedRegion,
    comunaChangeHandler = _ref.comunaChangeHandler,
    selectedComuna = _ref.selectedComuna,
    deviceType = _ref.deviceType,
    saveZone = _ref.saveZone,
    getSavedZone = _ref.getSavedZone,
    regionInputValue = _ref.regionInputValue,
    setRegionInputValue = _ref.setRegionInputValue,
    comunaInputValue = _ref.comunaInputValue,
    setComunaInputValue = _ref.setComunaInputValue,
    enableEnter = _ref.enableEnter,
    onFocus = _ref.onFocus,
    branding = _ref.branding,
    tenant = _ref.tenant,
    provinceSuggestion = _ref.provinceSuggestion,
    provinceChangeHandler = _ref.provinceChangeHandler,
    selectedProvince = _ref.selectedProvince,
    provinceInputValue = _ref.provinceInputValue,
    setProvinceInputValue = _ref.setProvinceInputValue,
    isStore = _ref.isStore,
    enableSisThemedBorder = _ref.enableSisThemedBorder,
    isSodimacStandAlone = _ref.isSodimacStandAlone,
    addressLinesData = _ref.addressLinesData,
    setCurrentView = _ref.setCurrentView,
    handleChange = _ref.handleChange,
    isClearForm = _ref.isClearForm,
    setIsClearForm = _ref.setIsClearForm,
    setAddressLinesData = _ref.setAddressLinesData,
    setBusy = _ref.actions.setBusy,
    resetHandler = _ref.resetHandler;
  var labels = configs$1.labels;
  var zoneLabel = labels.NEW_ZONE_MODAL_LABELS.VIEW1;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    regions = _useState2[0],
    setRegions = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    comunas = _useState4[0],
    setComunas = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    provinces = _useState6[0],
    setProvinces = _useState6[1];
  var _addressLinesData$add = addressLinesData.addressLine1,
    addressLine1 = _addressLinesData$add === void 0 ? '' : _addressLinesData$add,
    _addressLinesData$add2 = addressLinesData.addressLine2,
    addressLine2 = _addressLinesData$add2 === void 0 ? '' : _addressLinesData$add2;
  var geofinderLevel3Id = tenant === 'cl' ? 'geofinder-input-level2' : 'geofinder-input-level3';
  useEffect(function () {
    setRegions(regionsSuggestion.map(function (item) {
      return item.name;
    }));
  }, [regionsSuggestion]);
  useEffect(function () {
    setProvinces(provinceSuggestion.map(function (item) {
      return item.name;
    }));
  }, [provinceSuggestion]);
  useEffect(function () {
    setComunas(comunaSuggestion.map(function (item) {
      return item.name;
    }));
  }, [comunaSuggestion]);
  var shouldButtonDisable = function shouldButtonDisable() {
    if (tenant !== 'cl') {
      return !(selectedRegion && selectedComuna && selectedProvince && regionInputValue && provinceInputValue && comunaInputValue && addressLine1 && addressLine2);
    }
    return !(selectedRegion && selectedComuna && regionInputValue && comunaInputValue && addressLine1 && addressLine2);
  };
  var goToNextScreen = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
      var _response$results, _response$results$, _response$results2, _response$results2$, response, geometry, addressComponents, hasStreetNumber, hasRoute, _geometry$location, _geometry$location2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(selectedRegion && selectedComuna && regionInputValue && comunaInputValue && addressLine1 && addressLine2)) {
              _context.next = 18;
              break;
            }
            setBusy(true);
            _context.prev = 2;
            _context.next = 5;
            return doFetch("".concat(zoneLabel.GET_LAT_LONG_API_URL).concat(addressLine1, "+").concat(addressLine2, "+").concat(selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.name, "&components=country:").concat(tenant));
          case 5:
            response = _context.sent;
            geometry = response === null || response === void 0 ? void 0 : (_response$results = response.results) === null || _response$results === void 0 ? void 0 : (_response$results$ = _response$results[0]) === null || _response$results$ === void 0 ? void 0 : _response$results$.geometry;
            addressComponents = response === null || response === void 0 ? void 0 : (_response$results2 = response.results) === null || _response$results2 === void 0 ? void 0 : (_response$results2$ = _response$results2[0]) === null || _response$results2$ === void 0 ? void 0 : _response$results2$.address_components;
            hasStreetNumber = addressComponents.some(function (item) {
              var _item$types;
              return zoneLabel.VALID_LOCALTION_TYPES[0] === (item === null || item === void 0 ? void 0 : (_item$types = item.types) === null || _item$types === void 0 ? void 0 : _item$types[0]);
            });
            hasRoute = addressComponents.some(function (item) {
              var _item$types2;
              return zoneLabel.VALID_LOCALTION_TYPES[1] === (item === null || item === void 0 ? void 0 : (_item$types2 = item.types) === null || _item$types2 === void 0 ? void 0 : _item$types2[0]);
            });
            if (hasStreetNumber && hasRoute) {
              setAddressLinesData(_objectSpread2({}, addressLinesData, {
                latitude: geometry === null || geometry === void 0 ? void 0 : (_geometry$location = geometry.location) === null || _geometry$location === void 0 ? void 0 : _geometry$location.lat,
                longitude: geometry === null || geometry === void 0 ? void 0 : (_geometry$location2 = geometry.location) === null || _geometry$location2 === void 0 ? void 0 : _geometry$location2.lng
              }));
            } else {
              setAddressLinesData(_objectSpread2({}, addressLinesData, {
                latitude: selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.latitude,
                longitude: selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.longitude
              }));
            }
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);
            console.error(_context.t0);
          case 16:
            setBusy(false);
            setCurrentView('view2');
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 13]]);
    }));
    return function goToNextScreen() {
      return _ref2.apply(this, arguments);
    };
  }();
  var setInputValue = function setInputValue(inputValue, customReturn) {
    if (isClearForm) {
      setRegionInputValue('');
      setComunaInputValue('');
      return customReturn || '';
    }
    return inputValue;
  };
  useEffect(function () {
    if (isClearForm) {
      resetHandler();
      setIsClearForm(false);
    }
  }, [isClearForm]);
  return jsx("div", {
    className: classNames(styles$C['zone-selection-body'], styles$C[branding])
  }, jsx("p", {
    className: styles$C['modal-label']
  }, zoneLabel.BODY), jsx("div", {
    className: classNames(styles$C['modal-content'])
  }, jsx("div", {
    className: styles$C['input-wrapper'],
    key: "wrapper-region"
  }, deviceType === 'desktop' ? jsx(Autocomplete, {
    inputLabel: inputLabel.states.desktop[tenant],
    placeholder: placeholder.states.desktop[tenant],
    key: "Ingresa una Regi\xF3n",
    type: 2,
    suggestions: regions,
    onChangeHandler: regionChangeHandler,
    disabled: !(regions.length > 0),
    selectedOption: selectedRegion,
    InputValue: setInputValue(regionInputValue),
    setInputValue: setRegionInputValue,
    showEmptyResult: true,
    onFocus: onFocus,
    resetOnFocus: true,
    branding: branding,
    inputId: "geofinder-input-level1",
    isStore: isStore,
    enableSisThemedBorder: enableSisThemedBorder,
    isSodimacStandAlone: isSodimacStandAlone
  }) : jsx(Select, {
    fieldName: inputLabel.states.mobile[tenant],
    placeholder: placeholder.states.mobile[tenant],
    key: "Selecciona una regi\xF3n",
    onSelectChange: regionChangeHandler,
    fieldOptions: regions,
    disabled: !(regions.length > 0),
    defaultValue: setInputValue((selectedRegion === null || selectedRegion === void 0 ? void 0 : selectedRegion.name) || ''),
    branding: branding,
    selectId: "geofinder-input-level1",
    type: 2
  })), tenant !== 'cl' && jsx("div", {
    className: styles$C['provincia-wrapper'],
    key: "wrapper-provincia"
  }, deviceType === 'desktop' ? jsx(Autocomplete, {
    inputLabel: inputLabel.communa.desktop[tenant],
    placeholder: placeholder.communa.desktop[tenant],
    key: "Ingresa una provincia",
    suggestions: provinces,
    type: 2,
    onChangeHandler: provinceChangeHandler,
    disabled: !(selectedRegion && provinces.length > 0),
    selectedOption: selectedProvince,
    InputValue: provinceInputValue,
    setInputValue: setProvinceInputValue,
    showEmptyResult: true,
    onFocus: onFocus,
    resetOnFocus: true,
    branding: branding,
    inputId: "geofinder-input-level2",
    isStore: isStore,
    enableSisThemedBorder: enableSisThemedBorder
  }) : jsx(Select, {
    fieldName: inputLabel.communa.mobile[tenant],
    placeholder: placeholder.communa.mobile[tenant],
    key: "Selecciona una provincia",
    onSelectChange: provinceChangeHandler,
    fieldOptions: provinces,
    disabled: !(selectedRegion && provinces.length > 0),
    defaultValue: selectedProvince ? selectedProvince.name : '',
    branding: branding,
    selectId: "geofinder-input-level2",
    type: 2
  })), jsx("div", {
    className: classNames(styles$C['comuna-wrapper']),
    key: "wrapper-comuna"
  }, deviceType === 'desktop' ? jsx(Autocomplete, {
    inputLabel: inputLabel.districts.desktop[tenant],
    placeholder: placeholder.districts.desktop[tenant],
    key: "Ingresa una Comuna",
    suggestions: comunas,
    type: 2,
    onChangeHandler: comunaChangeHandler,
    disabled: tenant !== 'cl' ? !(selectedRegion && selectedProvince && comunas.length > 0) : !(selectedRegion && comunas.length > 0),
    selectedOption: selectedComuna,
    InputValue: setInputValue(comunaInputValue),
    setInputValue: setComunaInputValue,
    onFocus: onFocus,
    showEmptyResult: true,
    resetOnFocus: true,
    branding: branding,
    inputId: geofinderLevel3Id,
    isStore: isStore,
    enableSisThemedBorder: enableSisThemedBorder
  }) : jsx(Select, {
    fieldName: inputLabel.districts.mobile[tenant],
    placeholder: placeholder.districts.mobile[tenant],
    key: "Selecciona una comuna",
    onSelectChange: comunaChangeHandler,
    fieldOptions: comunas,
    disabled: tenant !== 'cl' ? !(selectedRegion && selectedProvince && comunas.length > 0) : !(selectedRegion && comunas.length > 0),
    defaultValue: setInputValue((selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.name) || ''),
    branding: branding,
    selectId: geofinderLevel3Id,
    type: 2
  })), jsx(InputBox, {
    placeholder: '2 de Mayo',
    label: "Calle",
    name: "addressLine2",
    value: setInputValue(addressLinesData.addressLine2, undefined),
    handleChange: handleChange
  }), jsx(InputBox, {
    placeholder: '123',
    label: "N\xFAmero",
    maxLength: 8,
    type: "number",
    name: "addressLine1",
    value: setInputValue(addressLinesData.addressLine1, undefined),
    handleChange: handleChange
  }), jsx(InputBox, {
    placeholder: 'Ej: Casa 10',
    name: "landmark",
    value: setInputValue(addressLinesData.landmark, undefined),
    label: "Dpto./Casa/Oficina/Condominio (opcional)",
    handleChange: handleChange
  })), jsx("button", {
    type: "button",
    className: classNames(styles$C['btn-zone-select'], _defineProperty(_defineProperty({}, styles$C.storeButton, isStore), styles$C.so_com, isSodimacStandAlone)),
    disabled: shouldButtonDisable(),
    onClick: goToNextScreen,
    id: "geofinder-button-save"
  }, zoneLabel.SAVE));
};
ZoneSelection.propTypes = process.env.NODE_ENV !== "production" ? {
  regionsSuggestion: PropTypes.array.isRequired,
  regionChangeHandler: PropTypes.func.isRequired,
  selectedRegion: PropTypes.object.isRequired,
  comunaSuggestion: PropTypes.array.isRequired,
  comunaChangeHandler: PropTypes.func.isRequired,
  selectedComuna: PropTypes.object.isRequired,
  deviceType: PropTypes.string.isRequired,
  saveZone: PropTypes.func.isRequired,
  getSavedZone: PropTypes.func.isRequired,
  regionInputValue: PropTypes.string.isRequired,
  setRegionInputValue: PropTypes.func.isRequired,
  comunaInputValue: PropTypes.string.isRequired,
  setComunaInputValue: PropTypes.func.isRequired,
  setModalVisible: PropTypes.func.isRequired,
  enableEnter: PropTypes.bool,
  onFocus: PropTypes.func,
  branding: PropTypes.oneOf(['retail', 'marketplace']).isRequired,
  tenant: PropTypes.string.isRequired,
  provinceSuggestion: PropTypes.array.isRequired,
  provinceChangeHandler: PropTypes.func.isRequired,
  selectedProvince: PropTypes.object.isRequired,
  provinceInputValue: PropTypes.string.isRequired,
  setProvinceInputValue: PropTypes.func.isRequired,
  stockEnTienda: PropTypes.object,
  deliveryOptions: PropTypes.object,
  isDefaultComuna: PropTypes.bool,
  enableSisThemedBorder: PropTypes.bool,
  isSodimacStandAlone: PropTypes.bool,
  setAddressLinesData: PropTypes.func.isRequired,
  addressLinesData: PropTypes.object.isRequired
} : {};
ZoneSelection.defaultProps = {
  stockEnTienda: {},
  deliveryOptions: {},
  isDefaultComuna: false,
  enableSisThemedBorder: false,
  isSodimacStandAlone: false
};

var SaveAddress = function SaveAddress(_ref) {
  var setCurrentView = _ref.setCurrentView,
    tenant = _ref.tenant,
    store = _ref.store,
    resetHandler = _ref.resetHandler,
    setGeofinderProgramatically = _ref.setGeofinderProgramatically,
    setModalVisible = _ref.setModalVisible,
    setBusy = _ref.setBusy,
    setDeleteAddressID = _ref.setDeleteAddressID,
    saveAdressData = _ref.saveAdressData,
    setIsClearForm = _ref.setIsClearForm,
    addressLinesData = _ref.addressLinesData,
    setSelectedComuna = _ref.setSelectedComuna,
    setAddressLinesData = _ref.setAddressLinesData,
    selectedComuna = _ref.selectedComuna,
    fetchComunaDefault = _ref.fetchComunaDefault,
    setShowLoginForm = _ref.setShowLoginForm;
  var labels = configs$1.labels,
    constants = configs$1.constants;
  var screenLabels = labels.NEW_ZONE_MODAL_LABELS.VIEW4;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    addressList = _useState2[0],
    setAddressList = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedAddressId = _useState4[0],
    setSelectedAddressId = _useState4[1];
  var addNewAddress = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsClearForm(true);
            resetHandler();
            setCurrentView('view1');
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function addNewAddress() {
      return _ref2.apply(this, arguments);
    };
  }();
  var saveAddress = function () {
    var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2() {
      var _addressLinesData$zon;
      var addr, _addr$addressLine, addressLine1, _addr$addressLine2, addressLine2, _addr$departmentNumbe, departmentNumber, _addr$latitude, latitude, _addr$longitude, longitude, addData, response, _response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setBusy(true);
            addr = addressList.find(function (item) {
              return item.id === selectedAddressId;
            });
            if (addr) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            _addr$addressLine = addr.addressLine1, addressLine1 = _addr$addressLine === void 0 ? '' : _addr$addressLine, _addr$addressLine2 = addr.addressLine2, addressLine2 = _addr$addressLine2 === void 0 ? '' : _addr$addressLine2, _addr$departmentNumbe = addr.departmentNumber, departmentNumber = _addr$departmentNumbe === void 0 ? '' : _addr$departmentNumbe, _addr$latitude = addr.latitude, latitude = _addr$latitude === void 0 ? '' : _addr$latitude, _addr$longitude = addr.longitude, longitude = _addr$longitude === void 0 ? '' : _addr$longitude;
            addData = {
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              landmark: departmentNumber,
              latitude: latitude,
              longitude: longitude,
              id: selectedAddressId
            };
            response = addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.zones;
            if (!(addressLinesData !== null && addressLinesData !== void 0 && (_addressLinesData$zon = addressLinesData.zones) !== null && _addressLinesData$zon !== void 0 && _addressLinesData$zon.length)) {
              _context2.next = 11;
              break;
            }
            saveAdressData(addData, addressLinesData === null || addressLinesData === void 0 ? void 0 : addressLinesData.zones, selectedComuna);
            _context2.next = 23;
            break;
          case 11:
            _context2.next = 13;
            return getTottusZones(latitude, longitude, tenant);
          case 13:
            response = _context2.sent;
            if (!((_response = response) !== null && _response !== void 0 && _response.length)) {
              _context2.next = 20;
              break;
            }
            _context2.next = 17;
            return setGeofinderProgramatically(_objectSpread2({}, addr));
          case 17:
            setModalVisible(false);
            _context2.next = 23;
            break;
          case 20:
            setSelectedComuna({
              name: addr === null || addr === void 0 ? void 0 : addr.municipal,
              parentStateName: addr === null || addr === void 0 ? void 0 : addr.state
            });
            setAddressLinesData(_objectSpread2({}, addData));
            setCurrentView('view3');
          case 23:
            setBusy(false);
          case 24:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function saveAddress() {
      return _ref3.apply(this, arguments);
    };
  }();
  var selectAddress = function selectAddress(id) {
    setSelectedAddressId(id);
  };
  var fetchAddresses = function () {
    var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3() {
      var unescapeATGCookies, getCookie, cookieSID, cookieSIDStatus, _addresses$, response, _response2, addresses, isUserZone, shouldForceDefault, selectedAddress;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            unescapeATGCookies = CookieStorage.unescapeATGCookies, getCookie = CookieStorage.getCookie;
            cookieSID = process.env.ENVIRONMENT === 'dev' ? process.env.TEST_COOKIE_SID : unescapeATGCookies(getCookie('sid'));
            cookieSIDStatus = getCookie('sidStatus');
            _context3.prev = 3;
            setBusy(true);
            if (!(cookieSIDStatus === SID_STATUS.SOFTLOGIN)) {
              _context3.next = 11;
              break;
            }
            _context3.next = 8;
            return getUserAddressesCheckout(cookieSID, tenant, store);
          case 8:
            response = _context3.sent;
            _context3.next = 14;
            break;
          case 11:
            _context3.next = 13;
            return getUserAddresses(cookieSID, tenant, store);
          case 13:
            response = _context3.sent;
          case 14:
            if (!(response.errors && response.errors.length > 0)) {
              _context3.next = 16;
              break;
            }
            throw new Error("".concat(response.errors[0].message, " (").concat(response.errors[0].code, ")"));
          case 16:
            _response2 = response, addresses = _response2.addresses;
            if (!(addresses && addresses.length === 0)) {
              _context3.next = 24;
              break;
            }
            isUserZone = CookieStorage.getCookie(constants.USER_ZONE) === 'userselected';
            if (!isUserZone) {
              _context3.next = 23;
              break;
            }
            shouldForceDefault = true;
            _context3.next = 23;
            return fetchComunaDefault(shouldForceDefault);
          case 23:
            addNewAddress();
          case 24:
            setAddressList(addresses);
            selectedAddress = CookieStorage.getCookie(constants.ADDRESS_IDS);
            setSelectedAddressId(selectedAddress || ((_addresses$ = addresses[0]) === null || _addresses$ === void 0 ? void 0 : _addresses$.id) || '');
            setBusy(false);
            _context3.next = 34;
            break;
          case 30:
            _context3.prev = 30;
            _context3.t0 = _context3["catch"](3);
            console.log(_context3.t0);
            setBusy(false);
          case 34:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[3, 30]]);
    }));
    return function fetchAddresses() {
      return _ref4.apply(this, arguments);
    };
  }();
  useEffect(function () {
    fetchAddresses();
  }, [tenant]);
  var deleteUserAddress = function () {
    var _ref5 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee4(addressID) {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            setDeleteAddressID(addressID);
            setCurrentView('view5');
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function deleteUserAddress(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  return jsx("div", {
    className: styles$C['savezone-container']
  }, jsx("p", {
    className: styles$C['modal-content']
  }, screenLabels.BODY), jsx("div", {
    className: styles$C['address-container']
  }, addressList.map(function (addr, index) {
    return jsx("div", {
      key: addr.id,
      onClick: function onClick() {
        return selectAddress(addr.id);
      },
      className: classNames(styles$C['address-selection'], _defineProperty({}, styles$C.active, selectedAddressId ? selectedAddressId === addr.id : index === 0))
    }, jsx("div", {
      className: styles$C.lwrapper
    }, jsx("div", {
      className: styles$C['radio-icon']
    }), jsx("div", {
      className: styles$C.address
    }, getTottusAddress({
      addressLine1: addr.addressLine1,
      addressLine2: addr.addressLine2,
      landmark: addr.landmark,
      latitude: addr.latitude,
      longitude: addr.longitude,
      comuna: addr.municipal,
      region: addr.state
    }))), jsx("span", {
      className: styles$C['remove-button'],
      onClick: function onClick() {
        return deleteUserAddress(addr.id);
      }
    }, "Eliminar"));
  })), jsx("div", {
    className: styles$C['button-container']
  }, jsx("div", {
    onClick: addNewAddress,
    className: styles$C['directions-link']
  }, screenLabels.LINK_TEXT), jsx("button", {
    onClick: saveAddress,
    className: styles$C['save-button']
  }, screenLabels.ACTION)));
};

var NoCoverage = function NoCoverage(_ref) {
  var setCurrentView = _ref.setCurrentView,
    addressLinesData = _ref.addressLinesData,
    selectedComuna = _ref.selectedComuna,
    close = _ref.close,
    setIsClearForm = _ref.setIsClearForm,
    tenant = _ref.tenant;
  var redirectToScreen1 = function redirectToScreen1() {
    setIsClearForm(true);
    setCurrentView('view1');
  };
  var labels = configs$1.labels;
  var screenLabels = labels.NEW_ZONE_MODAL_LABELS.VIEW3;
  return jsx("div", {
    className: styles$C['no-coverage-body']
  }, jsx("span", {
    className: styles$C['no-address']
  }), jsx("p", {
    className: styles$C['modal-body']
  }, screenLabels.BODY), jsx("p", {
    className: styles$C['selected-address']
  }, getTottusAddress(_objectSpread2({}, addressLinesData, {
    comuna: selectedComuna.name,
    region: selectedComuna.parentStateName
  }))), jsx("button", {
    onClick: redirectToScreen1,
    className: styles$C['new-address']
  }, screenLabels.LINK_TEXT2), jsx("a", {
    target: "blank",
    href: screenLabels.URL[tenant],
    className: styles$C['see-coverage']
  }, screenLabels.LINK_TEXT1), jsx("button", {
    onClick: close,
    className: styles$C['close-nocoverage']
  }, screenLabels.BUTTON));
};

var DeleteAddress = function DeleteAddress(_ref) {
  var setCurrentView = _ref.setCurrentView,
    tenant = _ref.tenant,
    store = _ref.store,
    setBusy = _ref.setBusy,
    deleteAddressID = _ref.deleteAddressID,
    setShowLoginForm = _ref.setShowLoginForm,
    setModalVisible = _ref.setModalVisible;
  var setCancel = function setCancel() {
    return setCurrentView('view4');
  };
  var constants = configs$1.constants,
    labels = configs$1.labels;
  var deleteAddresse = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
      var _response$errors, _response$errors$, unescapeATGCookies, getCookie, cookieSID, response, savedAddressId, domain;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setBusy(true);
            _context.prev = 1;
            unescapeATGCookies = CookieStorage.unescapeATGCookies, getCookie = CookieStorage.getCookie;
            cookieSID = process.env.ENVIRONMENT === 'dev' ? process.env.TEST_COOKIE_SID : unescapeATGCookies(getCookie('sid'));
            _context.next = 6;
            return deleteUserAddresses(cookieSID, tenant, store, deleteAddressID);
          case 6:
            response = _context.sent;
            if (!((response === null || response === void 0 ? void 0 : (_response$errors = response.errors) === null || _response$errors === void 0 ? void 0 : (_response$errors$ = _response$errors[0]) === null || _response$errors$ === void 0 ? void 0 : _response$errors$.code) === constants.ERROR_CODES.INVALID_SESSION)) {
              _context.next = 11;
              break;
            }
            setModalVisible(false);
            setShowLoginForm(true);
            return _context.abrupt("return");
          case 11:
            setCurrentView('view4');
            savedAddressId = CookieStorage.getCookie(constants.ADDRESS_IDS);
            if (savedAddressId === deleteAddressID) {
              domain = CookieStorage.getHost(tenant);
              CookieStorage.removeCookieByDomain({
                name: constants.ADDRESS_IDS,
                domain: domain
              });
              CookieStorage.removeCookieByDomain({
                name: constants.ADDRESS_LINES,
                domain: domain
              });
            }
            setBusy(false);
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](1);
            console.error('Error deleting address:', _context.t0);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 17]]);
    }));
    return function deleteAddresse() {
      return _ref2.apply(this, arguments);
    };
  }();
  var screenLabels = labels.NEW_ZONE_MODAL_LABELS.VIEW5;
  return jsx("div", {
    className: styles$C['delete-address-container']
  }, jsx("p", {
    className: styles$C['modal-content']
  }, screenLabels.BODY), jsx("div", {
    className: styles$C['modal-buttons']
  }, jsx("div", {
    onClick: setCancel,
    className: styles$C['cancel-link']
  }, screenLabels.CANCEL), jsx("button", {
    onClick: deleteAddresse,
    className: styles$C['delete-button']
  }, screenLabels.SAVE)));
};

var ModelContentWithMaps = function ModelContentWithMaps(props) {
  var view = props.isUserLoggedIn ? 'view4' : 'view1';
  var _React$useState = React.useState(view),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    currentView = _React$useState2[0],
    setCurrentView = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isDragging = _React$useState4[0],
    setIsDragging = _React$useState4[1];
  var _React$useState5 = React.useState({
      x: 0,
      y: 0
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    offset = _React$useState6[0],
    setOffset = _React$useState6[1];
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    startY = _React$useState8[0],
    setStartY = _React$useState8[1];
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    deleteAddressID = _useState2[0],
    setDeleteAddressID = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isClearForm = _useState4[0],
    setIsClearForm = _useState4[1];
  var modalRef = React.useRef(null);
  var saveZone = props.saveZone,
    actions = props.actions,
    addressLinesData = props.addressLinesData,
    setAddressLinesData = props.setAddressLinesData,
    selectedComuna = props.selectedComuna,
    isUserLoggedIn = props.isUserLoggedIn,
    tenant = props.tenant,
    store = props.store,
    selectedRegion = props.selectedRegion,
    addNewAddress = props.addNewAddress,
    resetHandler = props.resetHandler,
    setGeofinderProgramatically = props.setGeofinderProgramatically,
    setModalVisible = props.setModalVisible,
    setSavedAddressLinesData = props.setSavedAddressLinesData,
    saveAdressData = props.saveAdressData,
    setSelectedComuna = props.setSelectedComuna,
    getSavedZone = props.getSavedZone,
    fetchComunaDefault = props.fetchComunaDefault,
    setShowLoginForm = props.setShowLoginForm;
  var labels = configs$1.labels;
  var handleChange = function handleChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    props.setAddressLinesData(function (prevData) {
      return _objectSpread2({}, prevData, _defineProperty({}, name, value));
    });
  };
  React.useEffect(function () {
    if (!(addressLinesData !== null && addressLinesData !== void 0 && addressLinesData.addressLine1)) {
      getSavedZone();
    }
  }, []);
  var getScreenView = function getScreenView() {
    switch (currentView) {
      case 'view1':
        return jsx(ZoneSelection, _extends({}, props, {
          branding: '',
          handleChange: handleChange,
          setCurrentView: setCurrentView,
          isClearForm: isClearForm,
          setIsClearForm: setIsClearForm
        }));
      case 'view2':
        return jsx(MapSelection, {
          setCurrentView: setCurrentView,
          saveZone: saveZone,
          addressLinesData: addressLinesData,
          setAddressLinesData: setAddressLinesData,
          selectedComuna: selectedComuna,
          handleChange: handleChange,
          setBusy: actions.setBusy,
          isUserLoggedIn: isUserLoggedIn,
          tenant: tenant,
          selectedRegion: selectedRegion,
          saveAdressData: saveAdressData,
          setModalVisible: setModalVisible,
          setShowLoginForm: setShowLoginForm
        });
      case 'view3':
        return jsx(NoCoverage, {
          setCurrentView: setCurrentView,
          addressLinesData: addressLinesData,
          selectedComuna: selectedComuna,
          close: actions.close,
          tenant: tenant,
          setIsClearForm: setIsClearForm
        });
      case 'view4':
        return jsx(SaveAddress, {
          setCurrentView: setCurrentView,
          addressLinesData: addressLinesData,
          selectedComuna: selectedComuna,
          addNewAddress: addNewAddress,
          tenant: tenant,
          store: store,
          resetHandler: resetHandler,
          setGeofinderProgramatically: setGeofinderProgramatically,
          setModalVisible: setModalVisible,
          setAddressLinesData: setAddressLinesData,
          setSavedAddressLinesData: setSavedAddressLinesData,
          saveZone: saveZone,
          setBusy: actions.setBusy,
          setDeleteAddressID: setDeleteAddressID,
          saveAdressData: saveAdressData,
          setIsClearForm: setIsClearForm,
          setSelectedComuna: setSelectedComuna,
          fetchComunaDefault: fetchComunaDefault,
          setShowLoginForm: setShowLoginForm
        });
      case 'view5':
        return jsx(DeleteAddress, {
          setCurrentView: setCurrentView,
          tenant: props.tenant,
          store: store,
          setBusy: actions.setBusy,
          deleteAddressID: deleteAddressID,
          setShowLoginForm: setShowLoginForm,
          setModalVisible: setModalVisible
        });
      default:
        return null;
    }
  };
  var handleTouchStart = function handleTouchStart(e) {
    setIsDragging(true);
    var touch = e.touches[0];
    var rect = modalRef.current.getBoundingClientRect();
    setOffset({
      x: touch.clientX - rect.left,
      y: touch.clientY - rect.top
    });
    setStartY(touch.clientY);
  };
  var handleTouchMove = function handleTouchMove(e) {
    if (!isDragging) return;
    var touch = e.touches[0];
    var newLeft = touch.clientX - offset.x;
    var newTop = touch.clientY - offset.y;
    modalRef.current.style.left = "".concat(newLeft, "px");
    modalRef.current.style.top = "".concat(newTop, "px");
  };
  var handleTouchEnd = function handleTouchEnd(e) {
    setIsDragging(false);
    var touch = e.changedTouches[0];
    var dragDistance = touch.clientY - startY;
    if (dragDistance > 10) {
      actions.close();
    }
  };
  return jsx("div", {
    ref: modalRef,
    className: styles$C['new-zone-modal-container']
  }, jsx("div", {
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
    className: styles$C['draggable-bar']
  }), jsx("div", {
    className: classNames(styles$C['modal-header'], styles$C.marketplace, styles$C.gap, _defineProperty({}, styles$C['no-padding'], currentView === 'view3'))
  }, currentView !== 'view3' && jsx(Fragment, null, jsx("i", {
    className: classNames(styles$C['icon-location'], styles$C['icon-header'], styles$C.marketplace, _defineProperty({}, styles$C['remove-icon'], currentView === 'view5'))
  }, jsx("span", {
    className: styles$C['sr-only']
  }, "location-icon")), jsx("span", {
    className: styles$C['modal-header-text']
  }, labels.NEW_ZONE_MODAL_LABELS[currentView.toUpperCase()].HEADER)), jsx("button", {
    type: "button",
    className: "".concat(styles$C['modal-btn-close']),
    id: "testId-zone-modal-close",
    onClick: function onClick() {
      return actions.close();
    }
  }, jsx("div", {
    className: "".concat(styles$C['icon-close'])
  }))), getScreenView());
};
ModelContentWithMaps.defaultProps = {};
ModelContentWithMaps.propTypes = process.env.NODE_ENV !== "production" ? {
  tenant: PropTypes.string.isRequired
} : {};

var ModalContent$1 = function ModalContent$1(props) {
  var store = props.store;
  if (store === 'to_com') {
    return jsx(ModelContentWithMaps, props);
  }
  return jsx(ModalContent, props);
};

var notificationTimeOut = function notificationTimeOut(dismissHandler, notificationLife) {
  var time = Number(notificationLife);
  setTimeout(function () {
    dismissHandler(false);
  }, time);
};
var PopOverWrapper = function PopOverWrapper(_ref) {
  var children = _ref.children,
    dismissHandler = _ref.dismissHandler,
    hideCrossButton = _ref.hideCrossButton,
    size = _ref.size,
    customClass = _ref.customClass,
    isBrandingMarketplace = _ref.isBrandingMarketplace;
  return jsx("div", {
    className: classNames(styles$C['zone-popover'], styles$C["".concat(size)], styles$C["".concat(customClass)], _defineProperty({}, styles$C.marketplace, isBrandingMarketplace))
  }, children, !hideCrossButton && jsx("button", {
    type: "button",
    className: styles$C['modal-close'],
    id: "testId-modal-close",
    onClick: function onClick() {
      dismissHandler(true);
    }
  }, "\u2715"));
};
PopOverWrapper.defaultProps = {
  hideCrossButton: false,
  size: 'large',
  customClass: ''
};
PopOverWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  dismissHandler: PropTypes.func.isRequired,
  hideCrossButton: PropTypes.bool,
  size: PropTypes.oneOf(['large', 'medium']),
  customClass: PropTypes.oneOf(['', 'success-modal', 'warning-modal', 'pressure-modal', 'reminder-modal']),
  isBrandingMarketplace: PropTypes.bool.isRequired
} : {};
var PressureModal = function PressureModal(_ref2) {
  var dismissHandler = _ref2.dismissHandler,
    isBrandingMarketplace = _ref2.isBrandingMarketplace,
    notificationLife = _ref2.notificationLife;
  var labels = configs$1.labels;
  notificationTimeOut(dismissHandler, notificationLife);
  return jsx(PopOverWrapper, {
    dismissHandler: dismissHandler,
    isBrandingMarketplace: isBrandingMarketplace,
    customClass: "pressure-modal"
  }, jsx("span", {
    className: classNames(styles$C['text-label'], styles$C.highlighted)
  }, labels.PRESSURE_LABEL_1), jsx("span", {
    className: classNames(styles$C['text-label'], styles$C.banner)
  }, labels.PRESSURE_LABEL_2));
};
PressureModal.propTypes = process.env.NODE_ENV !== "production" ? {
  dismissHandler: PropTypes.func.isRequired,
  isBrandingMarketplace: PropTypes.bool.isRequired,
  notificationLife: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
var SuccessModal = function SuccessModal(_ref3) {
  var dismissHandler = _ref3.dismissHandler,
    isBrandingMarketplace = _ref3.isBrandingMarketplace,
    notificationLife = _ref3.notificationLife;
  var labels = configs$1.labels;
  notificationTimeOut(dismissHandler, notificationLife);
  return jsx(PopOverWrapper, {
    dismissHandler: dismissHandler,
    customClass: "success-modal",
    isBrandingMarketplace: isBrandingMarketplace
  }, jsx("div", {
    className: classNames(styles$C['success-message-parent'], styles$C['justify-from-start'])
  }, jsx("div", {
    className: styles$C['sucess-icon-wrapper']
  }, jsx("i", {
    className: classNames(styles$C['icon-success'], _defineProperty({}, styles$C.marketplace, isBrandingMarketplace))
  })), jsx("div", {
    className: styles$C['sucess-message-wrapper']
  }, jsx("span", {
    className: classNames(styles$C['text-label'], styles$C.highlighted)
  }, labels.SUCCESS_LABEL_1), jsx("span", {
    className: classNames(styles$C['text-label'], styles$C.banner)
  }, labels.SUCCESS_LABEL_2))));
};
SuccessModal.propTypes = process.env.NODE_ENV !== "production" ? {
  dismissHandler: PropTypes.func.isRequired,
  isBrandingMarketplace: PropTypes.bool.isRequired,
  notificationLife: PropTypes.number.isRequired
} : {};
var SelectionWarningModal = function SelectionWarningModal(_ref4) {
  var dismissHandler = _ref4.dismissHandler,
    selectedLocation = _ref4.selectedLocation,
    handleZoneChangeClick = _ref4.handleZoneChangeClick,
    keepTheLocation = _ref4.keepTheLocation,
    isBrandingMarketplace = _ref4.isBrandingMarketplace;
  var labels = configs$1.labels;
  notificationTimeOut(dismissHandler, 0);
  return jsx(PopOverWrapper, {
    dismissHandler: dismissHandler,
    hideCrossButton: true,
    customClass: "warning-modal",
    isBrandingMarketplace: isBrandingMarketplace
  }, jsx("div", {
    className: classNames(styles$C['flex-align-center'], styles$C['justify-from-start'], styles$C['flex-column'])
  }, jsx("div", {
    className: styles$C['message-wrapper']
  }, jsx("span", {
    className: classNames(styles$C['text-label'], styles$C.banner)
  }, labels.LOCATION_DETECTED_TEXT_PART_1, jsx("span", {
    className: styles$C['modal-zone-name']
  }, " \u201C".concat(selectedLocation.toLowerCase(), "\u201D. ")), labels.LOCATION_DETECTED_TEXT_PART_2)), jsx("div", {
    className: classNames(styles$C['flex-align-center'], styles$C['justify-space-around'], styles$C['flex-row'], styles$C['btn-wrapper'])
  }, jsx("button", {
    className: styles$C['btn-underline'],
    onClick: handleZoneChangeClick
  }, jsx("span", null, labels.CHANGE_IT_TEXT)), jsx("button", {
    className: styles$C['btn-outline'],
    onClick: keepTheLocation
  }, labels.KEEP_IT_TEXT))));
};
SelectionWarningModal.propTypes = process.env.NODE_ENV !== "production" ? {
  dismissHandler: PropTypes.func.isRequired,
  selectedLocation: PropTypes.string.isRequired,
  handleZoneChangeClick: PropTypes.func.isRequired,
  keepTheLocation: PropTypes.func.isRequired,
  isBrandingMarketplace: PropTypes.bool.isRequired
} : {};
var ReminderModal = function ReminderModal(_ref5) {
  var dismissHandler = _ref5.dismissHandler,
    type = _ref5.type,
    isBrandingMarketplace = _ref5.isBrandingMarketplace,
    notificationLife = _ref5.notificationLife;
  var labels = configs$1.labels,
    constants = configs$1.constants;
  notificationTimeOut(dismissHandler, notificationLife);
  var label = '';
  switch (type) {
    case constants.REMINDER_MODAL_TYPE.USER_LOGGED_IN:
      label = labels.REMINDER_USER_LOGGED_IN;
      break;
    case constants.REMINDER_MODAL_TYPE.INACTIVE:
      label = labels.REMINDER_USER_INACTIVE;
      break;
    default:
      label = 'No se encontro el tipo de notificacion';
      break;
  }
  return jsx(PopOverWrapper, {
    dismissHandler: dismissHandler,
    isBrandingMarketplace: isBrandingMarketplace,
    customClass: "reminder-modal"
  }, jsx("span", {
    className: classNames(styles$C['text-label'], styles$C.banner)
  }, label));
};
ReminderModal.propTypes = process.env.NODE_ENV !== "production" ? {
  dismissHandler: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  isBrandingMarketplace: PropTypes.bool.isRequired,
  notificationLife: PropTypes.number.isRequired
} : {};

var data$4 = [
	{
		type: "STATE",
		id: "2",
		code: "2",
		politicalId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		name: "ANTOFAGASTA"
	},
	{
		type: "STATE",
		id: "15",
		code: "15",
		politicalId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		name: "ARICA Y PARINACOTA"
	},
	{
		type: "STATE",
		id: "3",
		code: "3",
		politicalId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		name: "ATACAMA"
	},
	{
		type: "STATE",
		id: "11",
		code: "11",
		politicalId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		name: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO"
	},
	{
		type: "STATE",
		id: "8",
		code: "8",
		politicalId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		name: "BIOBÍO"
	},
	{
		type: "STATE",
		id: "4",
		code: "4",
		politicalId: "73c626ec-e662-4777-83a2-576f60963d87",
		name: "COQUIMBO"
	},
	{
		type: "STATE",
		id: "9",
		code: "9",
		politicalId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		name: "LA ARAUCANÍA"
	},
	{
		type: "STATE",
		id: "6",
		code: "6",
		politicalId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		name: "LIBERTADOR GENERAL BERNARDO O'HIGGINS"
	},
	{
		type: "STATE",
		id: "10",
		code: "10",
		politicalId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		name: "LOS LAGOS"
	},
	{
		type: "STATE",
		id: "14",
		code: "14",
		politicalId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		name: "LOS RÍOS"
	},
	{
		type: "STATE",
		id: "12",
		code: "12",
		politicalId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		name: "MAGALLANES Y DE LA ANTÁRTICA CHILENA"
	},
	{
		type: "STATE",
		id: "7",
		code: "7",
		politicalId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		name: "MAULE"
	},
	{
		type: "STATE",
		id: "13",
		code: "13",
		politicalId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		name: "METROPOLITANA DE SANTIAGO"
	},
	{
		type: "STATE",
		id: "8",
		code: "8",
		politicalId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		name: "ÑUBLE"
	},
	{
		type: "STATE",
		id: "1",
		code: "1",
		politicalId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		name: "TARAPACÁ"
	},
	{
		type: "STATE",
		id: "5",
		code: "5",
		politicalId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		name: "VALPARAÍSO"
	}
];
var statesCL = {
	data: data$4,
	"default": {
	name: "Seleccion ubicacion",
	politicalId: "15c37b0b-a392-41a9-8b3b-978376c700d5",
	priceGroupId: "96",
	zones: [
		"ZL_CERRILLOS",
		"LOSC",
		"130617",
		"13"
	]
}
};

var data$5 = [
	{
		politicalId: "e3bc0ac5-4aab-4980-a3c8-c83078bc9f2a",
		name: "ANTOFAGASTA",
		parentPoliticalId: "7d2e20f4-43e2-484b-b3e9-09e5d6f04c3d",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20105",
			"ANTO",
			"2"
		],
		type: "TOWN",
		priceGroupId: "5",
		latitude: -23.651,
		longitude: -70.38444444444445,
		code: "10"
	},
	{
		politicalId: "9163ba94-cf41-420f-acf7-d2a696694c59",
		name: "AYQUINA",
		parentPoliticalId: "13f92d76-03a9-45cf-89ab-17493b65ca16",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20202",
			"CALA",
			"2"
		],
		type: "TOWN",
		priceGroupId: "27",
		latitude: -22.278527,
		longitude: -68.323382,
		code: "11"
	},
	{
		politicalId: "b4365925-2966-42c7-9798-3a48e4196cb6",
		name: "CALAMA",
		parentPoliticalId: "13f92d76-03a9-45cf-89ab-17493b65ca16",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"CALA",
			"20203",
			"2"
		],
		type: "TOWN",
		priceGroupId: "27",
		latitude: -22.474,
		longitude: -68.9238888888889,
		code: "11"
	},
	{
		politicalId: "465c6406-3577-4d1a-b64a-ba5861699653",
		name: "CALETA COLOSO",
		parentPoliticalId: "7d2e20f4-43e2-484b-b3e9-09e5d6f04c3d",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20106",
			"ANTO",
			"2"
		],
		type: "TOWN",
		priceGroupId: "5",
		latitude: -23.760438,
		longitude: -70.462039,
		code: "461"
	},
	{
		politicalId: "8a9ed4a7-d67c-464a-89a4-375aa39e7c37",
		name: "CATARPE",
		parentPoliticalId: "259f3884-3603-4ed5-ab4d-bad491a3e7f3",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20204",
			"SPAT",
			"2"
		],
		type: "TOWN",
		priceGroupId: "27",
		latitude: -22.847394,
		longitude: -68.206964,
		code: "16"
	},
	{
		politicalId: "58e6332b-15c5-4cd3-b4ba-c42d4f938c2a",
		name: "CERRO MORENO",
		parentPoliticalId: "7d2e20f4-43e2-484b-b3e9-09e5d6f04c3d",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"MEJI",
			"20105",
			"2"
		],
		type: "TOWN",
		priceGroupId: "5",
		latitude: -23.465617,
		longitude: -70.549554,
		code: "483"
	},
	{
		politicalId: "b0602fc9-83bb-470d-9a0c-061de84eeead",
		name: "CHUQUICAMATA",
		parentPoliticalId: "13f92d76-03a9-45cf-89ab-17493b65ca16",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20205",
			"CALA",
			"2"
		],
		type: "TOWN",
		priceGroupId: "27",
		latitude: -22.315523,
		longitude: -68.925709,
		code: "11"
	},
	{
		politicalId: "b8974d0a-546f-4158-85c6-a95809f5ff46",
		name: "COBIJA",
		parentPoliticalId: "f5f595d1-b805-4bd8-ad10-eda90c45ad45",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20303",
			"TOCO",
			"2"
		],
		type: "TOWN",
		priceGroupId: "5",
		latitude: -22.553073,
		longitude: -70.261881,
		code: "19"
	},
	{
		politicalId: "5cd2cc6c-9959-4d6b-a4ec-803cbeec7479",
		name: "MARÍA ELENA",
		parentPoliticalId: "38ad930a-8534-428c-aa31-ce50f976059a",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20302",
			"MARI",
			"2"
		],
		type: "TOWN",
		priceGroupId: "5",
		latitude: -22.317,
		longitude: -69.67694444444444,
		code: "13"
	},
	{
		politicalId: "a293a530-0715-4603-babe-e4716f37ce4e",
		name: "MEJILLONES",
		parentPoliticalId: "05380d97-e8df-4620-9e4b-685e282d53ef",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"MEJI",
			"20107",
			"2"
		],
		type: "DISTRICT",
		priceGroupId: "5",
		latitude: -23.11,
		longitude: -70.45583333333333,
		code: "14"
	},
	{
		politicalId: "529ef6ee-9b5c-4fdd-9ccb-44a51d685ddf",
		name: "OLLAGÜE",
		parentPoliticalId: "109d4c25-3803-41b5-a2be-057c99583360",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"OLLA",
			"20206",
			"2"
		],
		type: "DISTRICT",
		priceGroupId: "27",
		latitude: -21.233,
		longitude: -68.26694444444445,
		code: "15"
	},
	{
		politicalId: "464506e4-d8b1-4d2c-8f46-4ee8676a5e16",
		name: "PAPOSO",
		parentPoliticalId: "bee77297-ec48-46e9-b847-2c3a6e1d86eb",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20101",
			"TALT",
			"2"
		],
		type: "TOWN",
		priceGroupId: "5",
		latitude: -25.009559,
		longitude: -70.464623,
		code: "18"
	},
	{
		politicalId: "23d288a9-ea20-4784-b0a4-0823414f75a6",
		name: "QUILAGUA",
		parentPoliticalId: "38ad930a-8534-428c-aa31-ce50f976059a",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20305",
			"MARI",
			"2"
		],
		type: "TOWN",
		priceGroupId: "5",
		latitude: -21.660848,
		longitude: -69.536011,
		code: "13"
	},
	{
		politicalId: "a5c1c59a-a370-4200-ab8a-141c393defed",
		name: "SAN FRANCISCO DE CHIU CHIU",
		parentPoliticalId: "13f92d76-03a9-45cf-89ab-17493b65ca16",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20207",
			"CALA",
			"2"
		],
		type: "TOWN",
		priceGroupId: "27",
		latitude: -22.342734,
		longitude: -68.650172,
		code: "11"
	},
	{
		politicalId: "0e6fbead-4ebb-4224-b3ee-3b1c0e829bda",
		name: "SAN PEDRO DE ATACAMA",
		parentPoliticalId: "259f3884-3603-4ed5-ab4d-bad491a3e7f3",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"SPAT",
			"20201",
			"2"
		],
		type: "TOWN",
		priceGroupId: "27",
		latitude: -22.92,
		longitude: -68.20083333333334,
		code: "16"
	},
	{
		politicalId: "229fca8c-1c93-4db8-8e6b-5d3e9a9b3078",
		name: "SIERRA GORDA",
		parentPoliticalId: "05380d97-e8df-4620-9e4b-685e282d53ef",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"SGOR",
			"20102",
			"2"
		],
		type: "DISTRICT",
		priceGroupId: "5",
		latitude: -22.898,
		longitude: -69.32277777777777,
		code: "17"
	},
	{
		politicalId: "36019db5-b785-49d5-af0e-1dcd0a56af1f",
		name: "TALTAL",
		parentPoliticalId: "bee77297-ec48-46e9-b847-2c3a6e1d86eb",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"TALT",
			"20103",
			"2"
		],
		type: "TOWN",
		priceGroupId: "5",
		latitude: -25.41,
		longitude: -70.4888888888889,
		code: "18"
	},
	{
		politicalId: "338d189f-4f59-47b5-a2e6-6770b7bf5f88",
		name: "TOCONAO",
		parentPoliticalId: "259f3884-3603-4ed5-ab4d-bad491a3e7f3",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"20104",
			"SPAT",
			"2"
		],
		type: "TOWN",
		priceGroupId: "27",
		latitude: -23.190498,
		longitude: -68.00506,
		code: "16"
	},
	{
		politicalId: "e9250701-b0f2-4ada-a515-faf62331c0e5",
		name: "TOCOPILLA",
		parentPoliticalId: "f5f595d1-b805-4bd8-ad10-eda90c45ad45",
		parentStateId: "70b1febe-fd2c-4ae7-bdb6-167976826b1a",
		parentStateName: "ANTOFAGASTA",
		zones: [
			"TOCO",
			"20304",
			"2"
		],
		type: "TOWN",
		priceGroupId: "5",
		latitude: -22.082,
		longitude: -70.1888888888889,
		code: "19"
	}
];
var antofagasta = {
	data: data$5
};

var data$6 = [
	{
		politicalId: "acfa312f-7586-4cf7-bbeb-1514c9580a9f",
		name: "ANGOL",
		parentPoliticalId: "9b0321de-40d3-4690-8c30-2a4d7c9a850d",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"ANGO",
			"90111",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "58",
		latitude: -37.803,
		longitude: -72.70194444,
		code: "216"
	},
	{
		politicalId: "2aeb8e0d-0bfa-49b5-8c3f-1bb33b5d4cf9",
		name: "BARROS ARANA",
		parentPoliticalId: "e1eb2003-6c37-4969-8a27-a5cd985e4b32",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90218",
			"TSCH",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.986691,
		longitude: -72.921548,
		code: "388"
	},
	{
		politicalId: "747b2d16-0a11-443a-83b7-d81d16b0133a",
		name: "CABURGA",
		parentPoliticalId: "7a36b61f-a717-4bac-b3c6-568c9296e719",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"PUCO",
			"90214",
			"9"
		],
		type: "TOWN",
		priceGroupId: "59",
		latitude: -39.201273,
		longitude: -71.809342,
		code: "413"
	},
	{
		politicalId: "dd215ade-1b0c-4883-b7b0-99db38257944",
		name: "CAJÓN",
		parentPoliticalId: "abb1b393-5d5e-4925-896f-5c3a954e4acc",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"VILC",
			"90211",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.680398,
		longitude: -72.506521,
		code: "391"
	},
	{
		politicalId: "8410853a-76b6-4c3d-ae78-3864638302c7",
		name: "CAPITÁN PASTENE",
		parentPoliticalId: "5764dd2b-7ef9-4f4d-a1dc-59e8252d76aa",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90110",
			"LUMA",
			"9"
		],
		type: "TOWN",
		priceGroupId: "58",
		latitude: -38.194761,
		longitude: -72.992441,
		code: "379"
	},
	{
		politicalId: "e61b2df9-7d34-47ab-9273-5c94c11a9b33",
		name: "CARAHUE",
		parentPoliticalId: "9a816360-ae5f-4196-8678-daebb3691ae2",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"CARA",
			"90225",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.707,
		longitude: -73.15083333,
		code: "217"
	},
	{
		politicalId: "de218fea-18d8-47cb-9784-5d3e59b2797a",
		name: "CHEQUENCO",
		parentPoliticalId: "4c2a7315-9e16-42df-b659-781b57274681",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"VILC",
			"90220",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.683591,
		longitude: -72.00636,
		code: "380"
	},
	{
		politicalId: "27d8cc51-ddb7-4d70-ac46-8b2333690e07",
		name: "CHOLCHOL",
		parentPoliticalId: "796b84ba-6b7f-442c-a33b-d51f73910f52",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"CHLC",
			"90216",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "44",
		latitude: -38.6,
		longitude: -72.835,
		code: "392"
	},
	{
		politicalId: "42cedaf7-47d0-428d-b334-9c654c97d154",
		name: "COLLIPULLI",
		parentPoliticalId: "ac5805bc-7423-41b2-9d61-640793236ee8",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"COLL",
			"90114",
			"9"
		],
		type: "TOWN",
		priceGroupId: "58",
		latitude: -37.953,
		longitude: -72.43194444,
		code: "218"
	},
	{
		politicalId: "48ccf8c3-5d9d-4866-9052-353c37a8b6a1",
		name: "CUNCO",
		parentPoliticalId: "796b84ba-6b7f-442c-a33b-d51f73910f52",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90208",
			"CUNC",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "44",
		latitude: -38.93,
		longitude: -72.02694444,
		code: "219"
	},
	{
		politicalId: "7c57c0cf-be14-42b4-b080-ecda03d4ab2c",
		name: "CURACAUTÍN",
		parentPoliticalId: "9b0321de-40d3-4690-8c30-2a4d7c9a850d",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90104",
			"CURC",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "58",
		latitude: -38.432,
		longitude: -71.88388889,
		code: "220"
	},
	{
		politicalId: "5af3b55c-46b4-4704-9860-07289efa2f9b",
		name: "CURACO",
		parentPoliticalId: "ac5805bc-7423-41b2-9d61-640793236ee8",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90103",
			"COLL",
			"9"
		],
		type: "TOWN",
		priceGroupId: "58",
		latitude: -38.021384,
		longitude: -72.354544,
		code: "218"
	},
	{
		politicalId: "78ff5389-3d49-4b81-aa0d-b72febe7c550",
		name: "CURARREHUE",
		parentPoliticalId: "796b84ba-6b7f-442c-a33b-d51f73910f52",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90207",
			"CRHU",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "44",
		latitude: -39.359,
		longitude: -71.58777778,
		code: "221"
	},
	{
		politicalId: "e32d0b57-bac0-4621-b6ca-20f9b393d608",
		name: "ERCILLA",
		parentPoliticalId: "87ab9de2-e1a8-4d7f-9190-70b1980a6859",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"ERCI",
			"90120",
			"9"
		],
		type: "TOWN",
		priceGroupId: "58",
		latitude: -38.05,
		longitude: -72.38277778,
		code: "222"
	},
	{
		politicalId: "4a16264b-5dc2-42f9-a051-eba40896854a",
		name: "FAJA MAISAN",
		parentPoliticalId: "98a22203-c00c-48a9-a71f-90878d8e47bb",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90206",
			"PITR",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -39.044431,
		longitude: -72.913374,
		code: "235"
	},
	{
		politicalId: "ee40f2ef-38c3-4784-b93e-8089585af4d0",
		name: "FREIRE",
		parentPoliticalId: "2c8f2a55-cf8e-4808-97f0-7ef6a32286c5",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90205",
			"FRER",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.954,
		longitude: -72.62194444,
		code: "223"
	},
	{
		politicalId: "53311d1b-fceb-411b-9660-a6ede5e1de56",
		name: "GALVARINO",
		parentPoliticalId: "796b84ba-6b7f-442c-a33b-d51f73910f52",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"GALV",
			"90204",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "44",
		latitude: -38.4,
		longitude: -72.78277778,
		code: "224"
	},
	{
		politicalId: "2b1fb649-c68c-4cfc-a584-6d50dcd0b7ce",
		name: "GORBEA",
		parentPoliticalId: "2da2fea2-e5bb-42a8-9460-d9cb7ddd4231",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90203",
			"GORB",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -39.095,
		longitude: -72.67194444,
		code: "225"
	},
	{
		politicalId: "a7e920d3-ef91-40ce-bf60-79ce1f1efe16",
		name: "HUALPIN",
		parentPoliticalId: "e1eb2003-6c37-4969-8a27-a5cd985e4b32",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90210",
			"TSCH",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -39.089639,
		longitude: -73.179588,
		code: "388"
	},
	{
		politicalId: "18429ae9-77d3-4d23-adce-589a4c61b9db",
		name: "LABRANZA",
		parentPoliticalId: "abb1b393-5d5e-4925-896f-5c3a954e4acc",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"TEMU",
			"90211",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.766279,
		longitude: -72.751585,
		code: "390"
	},
	{
		politicalId: "4225f2c8-fcde-42a2-af9a-6c3df337e2b6",
		name: "LASTARRIA",
		parentPoliticalId: "2da2fea2-e5bb-42a8-9460-d9cb7ddd4231",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90203",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -39.235705,
		longitude: -72.675888,
		code: "443"
	},
	{
		politicalId: "de0fa78a-67f4-4b08-8c5d-622da9c20005",
		name: "LAUTARO",
		parentPoliticalId: "d1ae03c9-6ede-4de8-bf6b-e8d74461932f",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"LAUT",
			"90202",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.529,
		longitude: -72.42694444,
		code: "227"
	},
	{
		politicalId: "fa1dc8ee-2041-4600-bc18-ea2aa5865a2e",
		name: "LICAN RAY",
		parentPoliticalId: "1e141087-e64f-4556-9489-0b2204144da0",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90201",
			"VILL",
			"9"
		],
		type: "TOWN",
		priceGroupId: "59",
		latitude: -39.485483,
		longitude: -72.162101,
		code: "383"
	},
	{
		politicalId: "82c6a10f-5314-4a9e-b55e-1dbbe737291b",
		name: "LONCOCHE",
		parentPoliticalId: "796b84ba-6b7f-442c-a33b-d51f73910f52",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90224",
			"LONC",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "44",
		latitude: -39.354,
		longitude: -72.62777778,
		code: "228"
	},
	{
		politicalId: "7a9fd499-710b-4931-a0d2-753fee95da90",
		name: "LONQUIMAY",
		parentPoliticalId: "9b0321de-40d3-4690-8c30-2a4d7c9a850d",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90116",
			"LNQY",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "58",
		latitude: -38.433,
		longitude: -71.23277778,
		code: "229"
	},
	{
		politicalId: "4bea5186-21db-4f19-b3f0-3d6ca6f38d25",
		name: "LOS SAUCES",
		parentPoliticalId: "9b0321de-40d3-4690-8c30-2a4d7c9a850d",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"SAUC",
			"90112",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "58",
		latitude: -37.967,
		longitude: -72.83277778,
		code: "230"
	},
	{
		politicalId: "6a9c0fee-65d4-436c-ba44-0a64dd306249",
		name: "LUMACO",
		parentPoliticalId: "5764dd2b-7ef9-4f4d-a1dc-59e8252d76aa",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"LUMA",
			"90102",
			"9"
		],
		type: "TOWN",
		priceGroupId: "58",
		latitude: -38.163,
		longitude: -72.90388889,
		code: "231"
	},
	{
		politicalId: "c9b6b086-921d-4670-ab13-ab11bc5697ca",
		name: "MELIPEUCO",
		parentPoliticalId: "796b84ba-6b7f-442c-a33b-d51f73910f52",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90223",
			"MLPC",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "44",
		latitude: -38.843,
		longitude: -71.68694444,
		code: "232"
	},
	{
		politicalId: "f4919713-6d97-4855-90bf-7bb52e0dfa24",
		name: "MININCO",
		parentPoliticalId: "d3e75ec3-45b0-4352-b573-7cec942bfe45",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90101",
			"MINI",
			"9"
		],
		type: "TOWN",
		priceGroupId: "58",
		latitude: -37.79142,
		longitude: -72.477429,
		code: "447"
	},
	{
		politicalId: "b5cf8a31-d83f-4ae7-b8f6-a9312843c8eb",
		name: "MOLCO",
		parentPoliticalId: "1e141087-e64f-4556-9489-0b2204144da0",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90108",
			"VILL",
			"9"
		],
		type: "TOWN",
		priceGroupId: "59",
		latitude: -39.302821,
		longitude: -72.09096,
		code: "383"
	},
	{
		politicalId: "779a24a8-1d25-4d1a-8d09-8c7d66756bff",
		name: "NUEVA IMPERIAL",
		parentPoliticalId: "796b84ba-6b7f-442c-a33b-d51f73910f52",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90222",
			"NVAI",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "44",
		latitude: -38.745,
		longitude: -72.95,
		code: "226"
	},
	{
		politicalId: "ac47b97d-3580-4c06-8329-a0d36aa39be5",
		name: "PADRE LAS CASAS",
		parentPoliticalId: "796b84ba-6b7f-442c-a33b-d51f73910f52",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90221",
			"PLCA",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "44",
		latitude: -38.766,
		longitude: -72.59277778,
		code: "378"
	},
	{
		politicalId: "b3a1f35c-9c44-43f6-b822-38f0764e7e50",
		name: "PAILAHUEQUE",
		parentPoliticalId: "87ab9de2-e1a8-4d7f-9190-70b1980a6859",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90119",
			"ERCI",
			"9"
		],
		type: "TOWN",
		priceGroupId: "58",
		latitude: -38.132297,
		longitude: -72.322834,
		code: "222"
	},
	{
		politicalId: "2904452e-7929-44f5-82b4-196b5f274ecf",
		name: "PERQUENCO",
		parentPoliticalId: "796b84ba-6b7f-442c-a33b-d51f73910f52",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"PERQ",
			"90219",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "44",
		latitude: -38.417,
		longitude: -72.38277778,
		code: "234"
	},
	{
		politicalId: "dba34e8d-b6b3-419f-9517-259a079c4746",
		name: "PIDIMA",
		parentPoliticalId: "87ab9de2-e1a8-4d7f-9190-70b1980a6859",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90117",
			"ERCI",
			"9"
		],
		type: "TOWN",
		priceGroupId: "58",
		latitude: -38.01404,
		longitude: -72.426278,
		code: "222"
	},
	{
		politicalId: "bad99ed9-826c-47d5-810e-dd2b9a2802cd",
		name: "PILLANLELBUN",
		parentPoliticalId: "d1ae03c9-6ede-4de8-bf6b-e8d74461932f",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"LAUT",
			"90202",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.636178,
		longitude: -72.452775,
		code: "381"
	},
	{
		politicalId: "8291beba-62d0-4160-9779-cd2ae9e6cd03",
		name: "PITRUFQUÉN",
		parentPoliticalId: "98a22203-c00c-48a9-a71f-90878d8e47bb",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90215",
			"PITR",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.983,
		longitude: -72.64277778,
		code: "235"
	},
	{
		politicalId: "4e356135-2690-4b1f-8956-fe22b6218c53",
		name: "PUCÓN",
		parentPoliticalId: "7a36b61f-a717-4bac-b3c6-568c9296e719",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"PUCO",
			"90214",
			"9"
		],
		type: "TOWN",
		priceGroupId: "59",
		latitude: -39.282,
		longitude: -71.95388889,
		code: "237"
	},
	{
		politicalId: "404e1550-9dd3-45e2-be95-62e3e4f60cca",
		name: "PURÉN",
		parentPoliticalId: "9b0321de-40d3-4690-8c30-2a4d7c9a850d",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"PURE",
			"90113",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "58",
		latitude: -38.022,
		longitude: -73.06694444,
		code: "238"
	},
	{
		politicalId: "fdf15274-8251-41e2-b41a-7773d39290d3",
		name: "QUEPE",
		parentPoliticalId: "2c8f2a55-cf8e-4808-97f0-7ef6a32286c5",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"QUEP",
			"90205",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.868865,
		longitude: -72.613013,
		code: "239"
	},
	{
		politicalId: "e20c793f-fd9e-4bcb-8bc0-56b71dab3a44",
		name: "QUEULE",
		parentPoliticalId: "1296864f-48fd-45ec-aa6f-1064adda8099",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90213",
			"TOLT",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -39.39973,
		longitude: -73.209786,
		code: "242"
	},
	{
		politicalId: "7fb69a81-a19c-4257-95c7-e82903c1061c",
		name: "RENAICO",
		parentPoliticalId: "d3e75ec3-45b0-4352-b573-7cec942bfe45",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90106",
			"RNCO",
			"9"
		],
		type: "TOWN",
		priceGroupId: "58",
		latitude: -37.667,
		longitude: -72.58277778,
		code: "200"
	},
	{
		politicalId: "2a49a82e-ce55-431a-bc89-1730ec556d2c",
		name: "SAAVEDRA",
		parentPoliticalId: "796b84ba-6b7f-442c-a33b-d51f73910f52",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"SVDR",
			"90212",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "44",
		latitude: -38.783,
		longitude: -73.4,
		code: "236"
	},
	{
		politicalId: "5359dd50-0ed9-465f-b984-b3feeccb7c19",
		name: "TEMUCO",
		parentPoliticalId: "abb1b393-5d5e-4925-896f-5c3a954e4acc",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"TEMU",
			"90211",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.727,
		longitude: -72.59888889,
		code: "241"
	},
	{
		politicalId: "303acdf0-e895-4465-9983-b72fe5dd4bde",
		name: "TEMUCUICUI",
		parentPoliticalId: "87ab9de2-e1a8-4d7f-9190-70b1980a6859",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90107",
			"ERCI",
			"9"
		],
		type: "TOWN",
		priceGroupId: "58",
		latitude: -38.093511,
		longitude: -72.433859,
		code: "222"
	},
	{
		politicalId: "cd55c631-10d1-413e-bf34-674182f04d3b",
		name: "TEODORO SCHMIDT",
		parentPoliticalId: "e1eb2003-6c37-4969-8a27-a5cd985e4b32",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90210",
			"TSCH",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.967,
		longitude: -73.035,
		code: "240"
	},
	{
		politicalId: "a9d7aecc-15fa-4983-883a-f5ae722e5816",
		name: "TOLTÉN",
		parentPoliticalId: "1296864f-48fd-45ec-aa6f-1064adda8099",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90209",
			"TOLT",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -39.217,
		longitude: -73.21694444,
		code: "242"
	},
	{
		politicalId: "a98f1d6e-209e-428f-a1d5-316c0069c43d",
		name: "TRAIGUÉN",
		parentPoliticalId: "9b0321de-40d3-4690-8c30-2a4d7c9a850d",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"90115",
			"TRAI",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "58",
		latitude: -38.248,
		longitude: -72.6675,
		code: "243"
	},
	{
		politicalId: "a2e5d0fd-8aa4-41a8-a6f2-2e19136e90ee",
		name: "TROVOLHUE",
		parentPoliticalId: "9a816360-ae5f-4196-8678-daebb3691ae2",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"CARA",
			"90225",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.632404,
		longitude: -73.32043,
		code: "385"
	},
	{
		politicalId: "eb1bf85e-803d-44da-9fcc-e8824854c7c8",
		name: "VICTORIA",
		parentPoliticalId: "9b0321de-40d3-4690-8c30-2a4d7c9a850d",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"VICT",
			"90105",
			"9"
		],
		type: "DISTRICT",
		priceGroupId: "58",
		latitude: -38.23,
		longitude: -72.34277778,
		code: "244"
	},
	{
		politicalId: "2f1ba56e-27c9-4997-aafa-1d2da19a9291",
		name: "VILCÚN",
		parentPoliticalId: "4c2a7315-9e16-42df-b659-781b57274681",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"VILC",
			"90220",
			"9"
		],
		type: "TOWN",
		priceGroupId: "44",
		latitude: -38.65,
		longitude: -72.23277778,
		code: "245"
	},
	{
		politicalId: "6983df76-ed39-4005-9ab6-6f3bb8e65bef",
		name: "VILLARRICA",
		parentPoliticalId: "1e141087-e64f-4556-9489-0b2204144da0",
		parentStateId: "d86e5095-af2e-4da3-b3ee-27ef2bad8772",
		parentStateName: "LA ARAUCANÍA",
		zones: [
			"VILL",
			"90301",
			"9"
		],
		type: "TOWN",
		priceGroupId: "59",
		latitude: -39.28,
		longitude: -72.21777778,
		code: "246"
	}
];
var araucania = {
	data: data$6
};

var data$7 = [
	{
		politicalId: "32f0a1a3-57a8-4196-9b0b-899ecf3f57a4",
		name: "ANCUTA",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150203",
			"PUTR",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.44994,
		longitude: -69.201063,
		code: "9"
	},
	{
		politicalId: "76469839-53e3-40e7-ad4b-2d55b9e96474",
		name: "ARICA",
		parentPoliticalId: "b6198d85-11ca-4c05-9698-703a212504bc",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150112",
			"ARIC",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.455,
		longitude: -70.28388888888888,
		code: "1"
	},
	{
		politicalId: "9f84dabb-ac7e-465f-a6c2-309e16101c15",
		name: "BELÉN",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150204",
			"PUTR",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.468119,
		longitude: -69.515102,
		code: "9"
	},
	{
		politicalId: "ceb08132-ef10-4f1b-83eb-3ffc771adfa5",
		name: "CALETA CAMARONES",
		parentPoliticalId: "a16b19e4-dbf3-43e1-b6e0-17abc02ea23d",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150113",
			"CAMA",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -19.196604,
		longitude: -70.266255,
		code: "2"
	},
	{
		politicalId: "deff309f-8543-460f-9f19-ed369588e1c5",
		name: "CALETA VITOR",
		parentPoliticalId: "b6198d85-11ca-4c05-9698-703a212504bc",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150114",
			"ARIC",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.74849,
		longitude: -70.337601,
		code: "1"
	},
	{
		politicalId: "a2973a6c-2322-4c8f-a2e5-f4e5c0e934d0",
		name: "CAMARONES",
		parentPoliticalId: "a16b19e4-dbf3-43e1-b6e0-17abc02ea23d",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150115",
			"CAMA",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -19.017,
		longitude: -69.86694444444444,
		code: "2"
	},
	{
		politicalId: "942b3678-00e2-454f-b17e-97621683f515",
		name: "CAQUENA",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150205",
			"PUTR",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.054733,
		longitude: -69.200663,
		code: "9"
	},
	{
		politicalId: "347abf89-8d64-4b0e-8789-39837ad654c9",
		name: "CHAPIQUIÑA",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150211",
			"PUTR",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.395136,
		longitude: -69.536844,
		code: "9"
	},
	{
		politicalId: "6f49dfd9-7f60-4631-b3f8-ba043d38ca55",
		name: "CHITITA",
		parentPoliticalId: "a16b19e4-dbf3-43e1-b6e0-17abc02ea23d",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150101",
			"CAMA",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.827481,
		longitude: -69.682956,
		code: "2"
	},
	{
		politicalId: "f4c05f60-c3f6-4855-a29d-5b07e8dc97e3",
		name: "CHUCUYO",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150212",
			"PUTR",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.218698,
		longitude: -69.321817,
		code: "9"
	},
	{
		politicalId: "db03568d-ce18-442b-90f6-972461571a55",
		name: "CODPA",
		parentPoliticalId: "a16b19e4-dbf3-43e1-b6e0-17abc02ea23d",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150102",
			"CAMA",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.833315,
		longitude: -69.74499,
		code: "2"
	},
	{
		politicalId: "9ebdf920-9bcc-4654-a78f-868e870f2990",
		name: "COSAPILLA",
		parentPoliticalId: "9f62b7eb-45f0-4c21-b327-2891e8f9e53f",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150213",
			"GLAG",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -17.767877,
		longitude: -69.411899,
		code: "5"
	},
	{
		politicalId: "31256c83-2a66-42bb-88ae-4f85c01a4c06",
		name: "CUYA",
		parentPoliticalId: "a16b19e4-dbf3-43e1-b6e0-17abc02ea23d",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150103",
			"CAMA",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -19.160557,
		longitude: -70.179574,
		code: "2"
	},
	{
		politicalId: "e4296584-e3e1-4efe-8d6d-e0d498d67bc9",
		name: "ESQUINA",
		parentPoliticalId: "a16b19e4-dbf3-43e1-b6e0-17abc02ea23d",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150111",
			"CAMA",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.936328,
		longitude: -69.530392,
		code: "2"
	},
	{
		politicalId: "9f62b7eb-45f0-4c21-b327-2891e8f9e53f",
		name: "GENERAL LAGOS",
		parentPoliticalId: "52459d02-7f37-471d-8d47-8f27c85c5f69",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150202",
			"GLAG",
			"15"
		],
		type: "DISTRICT",
		priceGroupId: "32",
		latitude: -17.653,
		longitude: -69.635,
		code: "5"
	},
	{
		politicalId: "b87815e6-4d6c-4b42-93bc-ab911afd980c",
		name: "GUALLATIRE",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150214",
			"PUTR",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.49824,
		longitude: -69.154185,
		code: "9"
	},
	{
		politicalId: "430b1637-b627-4b9e-9433-013f981f9652",
		name: "GUANACAGUA",
		parentPoliticalId: "a16b19e4-dbf3-43e1-b6e0-17abc02ea23d",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150110",
			"CAMA",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.819075,
		longitude: -69.709313,
		code: "2"
	},
	{
		politicalId: "416b4719-436d-4081-ac5a-f5dbe334b68b",
		name: "LAS MAITAS",
		parentPoliticalId: "b6198d85-11ca-4c05-9698-703a212504bc",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150109",
			"ARIC",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.516731,
		longitude: -70.217507,
		code: "1"
	},
	{
		politicalId: "1fee8667-2b8a-444d-96c6-6071ec44a5c0",
		name: "MOLINOS",
		parentPoliticalId: "b6198d85-11ca-4c05-9698-703a212504bc",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150108",
			"ARIC",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.38231,
		longitude: -69.946039,
		code: "1"
	},
	{
		politicalId: "34980a06-e7ea-41d1-8cb9-d1b5f0475c39",
		name: "PACHAMA",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150201",
			"PUTR",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.429517,
		longitude: -69.528825,
		code: "9"
	},
	{
		politicalId: "08097169-ab1b-4790-8823-6b08af173099",
		name: "PARINACOTA",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150206",
			"PUTR",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.202164,
		longitude: -69.26767,
		code: "9"
	},
	{
		politicalId: "b8cf7eb8-c265-4f8c-bb11-55f48a7b43b7",
		name: "POCONCHILE",
		parentPoliticalId: "b6198d85-11ca-4c05-9698-703a212504bc",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150107",
			"ARIC",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.450431,
		longitude: -70.06837,
		code: "1"
	},
	{
		politicalId: "5a313f9d-2254-4710-8411-0843d3ad67ba",
		name: "PUTRE",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"PUTR",
			"150207",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.2,
		longitude: -69.58277777777778,
		code: "9"
	},
	{
		politicalId: "19436657-18d2-408a-a2d2-e51e30cf11e0",
		name: "SAN MIGUEL DE AZAPA",
		parentPoliticalId: "b6198d85-11ca-4c05-9698-703a212504bc",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150106",
			"ARIC",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.519954,
		longitude: -70.180199,
		code: "1"
	},
	{
		politicalId: "13f7d9f4-d59b-4c64-9520-179776e143e7",
		name: "SOCOROMA",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150208",
			"PUTR",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.263873,
		longitude: -69.602289,
		code: "9"
	},
	{
		politicalId: "a7c8f582-fe52-466d-a335-bee2489b3e23",
		name: "SORA",
		parentPoliticalId: "b6198d85-11ca-4c05-9698-703a212504bc",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150105",
			"ARIC",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.349795,
		longitude: -69.874376,
		code: "1"
	},
	{
		politicalId: "e8fa8eda-66cb-45f9-b7d7-dcaa08a4da3a",
		name: "TIGNAMAR",
		parentPoliticalId: "ab7aa766-b718-4f90-ac15-281423d80459",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150209",
			"PUTR",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.581071,
		longitude: -69.494284,
		code: "9"
	},
	{
		politicalId: "4a7760e9-3450-445e-bf0b-95f971bdebb4",
		name: "VILLA FRONTERA",
		parentPoliticalId: "b6198d85-11ca-4c05-9698-703a212504bc",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150104",
			"ARIC",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -18.397305,
		longitude: -70.314892,
		code: "1"
	},
	{
		politicalId: "497666b7-7451-44ff-95d5-c483a907068b",
		name: "VISVIRI",
		parentPoliticalId: "9f62b7eb-45f0-4c21-b327-2891e8f9e53f",
		parentStateId: "6d6996df-6428-4a38-91e8-735b8fe727ad",
		parentStateName: "ARICA Y PARINACOTA",
		zones: [
			"150210",
			"GLAG",
			"15"
		],
		type: "TOWN",
		priceGroupId: "32",
		latitude: -17.594943,
		longitude: -69.481573,
		code: "5"
	}
];
var arica = {
	data: data$7
};

var data$8 = [
	{
		politicalId: "ab0104fe-4951-44ca-8ced-9db245f4a847",
		name: "ALTO DEL CARMEN",
		parentPoliticalId: "41178152-2db1-47a7-999e-465774f5974e",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30303",
			"ACAR",
			"3"
		],
		type: "DISTRICT",
		priceGroupId: "60",
		latitude: -28.749,
		longitude: -70.49083333333333,
		code: "20"
	},
	{
		politicalId: "5ad56138-380b-4f82-8149-a7687846e979",
		name: "BAHÍA INGLESA",
		parentPoliticalId: "f2081aa0-9822-46af-86f4-5e28fc8af038",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"CALD",
			"30201",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -27.101791,
		longitude: -70.857242,
		code: "411"
	},
	{
		politicalId: "fee43a22-1d55-4c38-96c1-3646e97dabf0",
		name: "CACHIYUYO",
		parentPoliticalId: "a5c174eb-d238-421c-92aa-aae3f085006f",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30304",
			"VALL",
			"3"
		],
		type: "TOWN",
		priceGroupId: "60",
		latitude: -29.036827,
		longitude: -70.898494,
		code: "30"
	},
	{
		politicalId: "61f03e37-7336-4d9e-bdce-8aee1e0d5262",
		name: "CALDERA",
		parentPoliticalId: "f2081aa0-9822-46af-86f4-5e28fc8af038",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"CALD",
			"30201",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -27.066,
		longitude: -70.82583333333334,
		code: "21"
	},
	{
		politicalId: "fb43b913-6748-49d4-bcbb-2cf284389e41",
		name: "CARRIZAL BAJO",
		parentPoliticalId: "38133ad3-600a-4cbc-84b4-c7c1b4a01cef",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30305",
			"HUAS",
			"3"
		],
		type: "TOWN",
		priceGroupId: "60",
		latitude: -28.083985,
		longitude: -71.14719,
		code: "27"
	},
	{
		politicalId: "637ac3f9-b49d-4b23-8fdd-a156c67ddd64",
		name: "CHANAR BLANCO",
		parentPoliticalId: "a5c174eb-d238-421c-92aa-aae3f085006f",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30306",
			"VALL",
			"3"
		],
		type: "TOWN",
		priceGroupId: "60",
		latitude: -28.646068,
		longitude: -70.696384,
		code: "30"
	},
	{
		politicalId: "9b233621-3161-452b-b33a-48d305054bc8",
		name: "CHAÑARAL",
		parentPoliticalId: "914ec09d-df83-4f14-826a-57e89d01192f",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"CHAN",
			"30105",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -26.346,
		longitude: -70.62388888888889,
		code: "22"
	},
	{
		politicalId: "95931bcc-c6c6-4897-b32e-7667a8e593a5",
		name: "COPIAPÓ",
		parentPoliticalId: "229aa671-24ce-4ef9-993d-c892d4e370a9",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30202",
			"COPI",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -27.375,
		longitude: -70.32888888888888,
		code: "23"
	},
	{
		politicalId: "003699ca-df4b-4a1b-b5db-ab2ea92c63cb",
		name: "DIEGO DE ALMAGRO",
		parentPoliticalId: "d93ef5a3-67e8-4412-a700-2de1db4b68a4",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30101",
			"DIEG",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -26.39,
		longitude: -70.05194444444444,
		code: "24"
	},
	{
		politicalId: "a934ed21-b186-4b1b-ab87-2200cda0de69",
		name: "EL SALADO",
		parentPoliticalId: "914ec09d-df83-4f14-826a-57e89d01192f",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30102",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -26.421259,
		longitude: -70.319409,
		code: "454"
	},
	{
		politicalId: "681fa30d-606d-47e8-85f7-fbeefe78793e",
		name: "EL SALVADOR",
		parentPoliticalId: "d93ef5a3-67e8-4412-a700-2de1db4b68a4",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"ELSA",
			"30104",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -26.246818,
		longitude: -69.627427,
		code: "25"
	},
	{
		politicalId: "63ac9dfb-5e02-4a8f-8e3d-a243145a0ba4",
		name: "FREIRINA",
		parentPoliticalId: "41178152-2db1-47a7-999e-465774f5974e",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"FREI",
			"30307",
			"3"
		],
		type: "DISTRICT",
		priceGroupId: "60",
		latitude: -28.506,
		longitude: -71.07583333333334,
		code: "26"
	},
	{
		politicalId: "26f9628b-a39a-4902-b7c2-293890d52cdd",
		name: "HUASCO",
		parentPoliticalId: "38133ad3-600a-4cbc-84b4-c7c1b4a01cef",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"HUAS",
			"30308",
			"3"
		],
		type: "TOWN",
		priceGroupId: "60",
		latitude: -28.456,
		longitude: -71.18583333333333,
		code: "27"
	},
	{
		politicalId: "b4aabc27-7e08-447d-97af-d4525a7723e1",
		name: "HUASCO BAJO",
		parentPoliticalId: "38133ad3-600a-4cbc-84b4-c7c1b4a01cef",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30301",
			"HUAS",
			"3"
		],
		type: "TOWN",
		priceGroupId: "60",
		latitude: -28.475341,
		longitude: -71.176656,
		code: "27"
	},
	{
		politicalId: "665e0e2a-e05f-4afc-9f36-c37f0af97146",
		name: "INCA DEL ORO",
		parentPoliticalId: "d93ef5a3-67e8-4412-a700-2de1db4b68a4",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30101",
			"DIEG",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -26.75466,
		longitude: -69.904701,
		code: "434"
	},
	{
		politicalId: "cb263a4c-949a-45c7-b371-eb095bf3e3a6",
		name: "PAIPOTE",
		parentPoliticalId: "229aa671-24ce-4ef9-993d-c892d4e370a9",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"PAIP",
			"30202",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -27.415199,
		longitude: -70.277086,
		code: "453"
	},
	{
		politicalId: "338edecf-1880-4a62-8736-aae444d4cb83",
		name: "PAN DE AZUCAR",
		parentPoliticalId: "914ec09d-df83-4f14-826a-57e89d01192f",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30102",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -26.195901,
		longitude: -70.511691,
		code: "454"
	},
	{
		politicalId: "6eac78ac-d653-4f8c-a89f-135e0e6cc581",
		name: "POTRERILLOS",
		parentPoliticalId: "d93ef5a3-67e8-4412-a700-2de1db4b68a4",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"ELSA",
			"30103",
			"3"
		],
		type: "TOWN",
		priceGroupId: "57",
		latitude: -26.436022,
		longitude: -69.483814,
		code: "25"
	},
	{
		politicalId: "8bf8bc47-c8c0-425d-bcda-d0e346e6d654",
		name: "TIERRA AMARILLA",
		parentPoliticalId: "a86d4cfd-0ac3-43c8-ae44-fb49536beb2a",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"30203",
			"TAMA",
			"3"
		],
		type: "DISTRICT",
		priceGroupId: "57",
		latitude: -27.473,
		longitude: -70.28277777777778,
		code: "29"
	},
	{
		politicalId: "d327f864-a95a-4ffb-990e-3a2910b8d1ca",
		name: "VALLENAR",
		parentPoliticalId: "a5c174eb-d238-421c-92aa-aae3f085006f",
		parentStateId: "b83e9641-cc4e-48c0-8638-42f1a4c9d3db",
		parentStateName: "ATACAMA",
		zones: [
			"VALL",
			"30302",
			"3"
		],
		type: "TOWN",
		priceGroupId: "60",
		latitude: -28.577,
		longitude: -70.76694444444445,
		code: "30"
	}
];
var atacama = {
	data: data$8
};

var data$9 = [
	{
		politicalId: "d592cc43-e4bc-49b8-bca6-7aedf62699f2",
		name: "AYSÉN",
		parentPoliticalId: "64eeb8e2-92ae-4aa5-b8aa-3357940e2125",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"AISE",
			"110404",
			"11"
		],
		type: "DISTRICT",
		priceGroupId: "37",
		latitude: -45.412,
		longitude: -72.69777778,
		code: "533"
	},
	{
		politicalId: "e505ca2b-44dd-418c-85a8-7051aececc1b",
		name: "BALMACEDA",
		parentPoliticalId: "d65221fc-5915-410c-b4e4-4e264c595309",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110302",
			"COYH",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -45.909382,
		longitude: -71.699507,
		code: "295"
	},
	{
		politicalId: "70ea40b6-aef0-46a3-b858-4cf1cb4d37ce",
		name: "CHILE CHICO",
		parentPoliticalId: "5b9af64a-7ca5-4a7e-a591-e4b5b3147ef9",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110103",
			"CHCH",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -46.55,
		longitude: -71.73277778,
		code: "293"
	},
	{
		politicalId: "1541efa1-e599-457c-be91-3b9c474eadca",
		name: "CISNES",
		parentPoliticalId: "64eeb8e2-92ae-4aa5-b8aa-3357940e2125",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"CISN",
			"110405",
			"11"
		],
		type: "DISTRICT",
		priceGroupId: "37",
		latitude: -44.751,
		longitude: -72.69694444,
		code: "300"
	},
	{
		politicalId: "1177f806-45f9-4bc9-b130-31a9e814dfe2",
		name: "COCHRANE",
		parentPoliticalId: "ef448559-667f-452b-9cd0-c0ebbb2aa02b",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110202",
			"COCH",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -47.267,
		longitude: -72.535,
		code: "294"
	},
	{
		politicalId: "9fda5c18-c5fa-4458-9318-1f250a2fe5e8",
		name: "COYHAIQUE",
		parentPoliticalId: "d65221fc-5915-410c-b4e4-4e264c595309",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110311",
			"COYH",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -45.57167,
		longitude: -72.071087,
		code: "295"
	},
	{
		politicalId: "5d4204f9-0273-4bd8-bde7-a40f247a2ba1",
		name: "GUAITECAS",
		parentPoliticalId: "64eeb8e2-92ae-4aa5-b8aa-3357940e2125",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"GUAI",
			"110406",
			"11"
		],
		type: "DISTRICT",
		priceGroupId: "37",
		latitude: -43.884,
		longitude: -73.95,
		code: "296"
	},
	{
		politicalId: "14096373-b867-4840-97ae-8811daf5010d",
		name: "LA JUNTA",
		parentPoliticalId: "ef448559-667f-452b-9cd0-c0ebbb2aa02b",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110407",
			"COCH",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -43.976074,
		longitude: -72.407085,
		code: "294"
	},
	{
		politicalId: "1da495d7-b596-4da1-b58f-ad8b29c0a9e3",
		name: "LA TAPERA",
		parentPoliticalId: "8c1f74ca-d536-414e-8702-01f370d748ec",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110303",
			"LAVE",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -44.240275,
		longitude: -71.851376,
		code: "297"
	},
	{
		politicalId: "5cac400c-cabe-48d4-bd0c-0fcf8bb7d949",
		name: "LAGO VERDE",
		parentPoliticalId: "8c1f74ca-d536-414e-8702-01f370d748ec",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110304",
			"LAVE",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -44.219,
		longitude: -71.83888889,
		code: "297"
	},
	{
		politicalId: "abba1dd5-5735-4f4a-b13e-0293067b7f91",
		name: "O'HIGGINS",
		parentPoliticalId: "10a857fa-3ee6-4631-86ec-ef888d074a58",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"OHIG",
			"110204",
			"11"
		],
		type: "DISTRICT",
		priceGroupId: "37",
		latitude: -48.8,
		longitude: -73.18277778,
		code: "298"
	},
	{
		politicalId: "e6368042-ed24-4b1b-aaff-fb0b7fa02c3c",
		name: "PUERTO AYSÉN",
		parentPoliticalId: "d592cc43-e4bc-49b8-bca6-7aedf62699f2",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110409",
			"AISE",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -45.403074,
		longitude: -72.690087,
		code: "533"
	},
	{
		politicalId: "67fb0c06-b92b-4b3a-b292-501d789a625f",
		name: "PUERTO BERTRAND",
		parentPoliticalId: "5b9af64a-7ca5-4a7e-a591-e4b5b3147ef9",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110102",
			"CHCH",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -47.016128,
		longitude: -72.828996,
		code: "293"
	},
	{
		politicalId: "4d235d6b-414f-40d5-87a3-dd0f1ce80ccf",
		name: "PUERTO CHACABUCO",
		parentPoliticalId: "d592cc43-e4bc-49b8-bca6-7aedf62699f2",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110410",
			"AISE",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -45.462856,
		longitude: -72.820227,
		code: "533"
	},
	{
		politicalId: "5ac73824-4b25-4e77-a59e-c0f83fa339ef",
		name: "PUERTO CISNES",
		parentPoliticalId: "1541efa1-e599-457c-be91-3b9c474eadca",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110401",
			"CISN",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -44.728949,
		longitude: -72.680354,
		code: "300"
	},
	{
		politicalId: "a5ac59ff-dde2-41a0-8f64-6048546caad1",
		name: "PUERTO INGENIERO IBAÑEZ",
		parentPoliticalId: "d65221fc-5915-410c-b4e4-4e264c595309",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110305",
			"COYH",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -46.292418,
		longitude: -71.939339,
		code: "295"
	},
	{
		politicalId: "00661d83-651b-47d8-8c4d-a6b48a775456",
		name: "PUERTO RAUL MARIN BALMACEDAS",
		parentPoliticalId: "1541efa1-e599-457c-be91-3b9c474eadca",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110402",
			"CISN",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -43.776208,
		longitude: -72.953987,
		code: "300"
	},
	{
		politicalId: "7be0db54-9a45-45ea-b190-99c8cfa78f15",
		name: "PUYUHUAPI",
		parentPoliticalId: "1541efa1-e599-457c-be91-3b9c474eadca",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110403",
			"CISN",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -44.324529,
		longitude: -72.559077,
		code: "300"
	},
	{
		politicalId: "d9a61054-14b2-4eb2-bb03-36fe1a183211",
		name: "RÍO IBÁÑEZ",
		parentPoliticalId: "d692a369-18db-46c7-b4d6-30a04d2daeb8",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110101",
			"RIBA",
			"11"
		],
		type: "DISTRICT",
		priceGroupId: "37",
		latitude: -46.255,
		longitude: -71.95,
		code: "301"
	},
	{
		politicalId: "4ba2b77c-05f6-4ad2-b27a-70d26541eabb",
		name: "TORTEL",
		parentPoliticalId: "10a857fa-3ee6-4631-86ec-ef888d074a58",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110203",
			"TRTL",
			"11"
		],
		type: "DISTRICT",
		priceGroupId: "37",
		latitude: -47.781,
		longitude: -73.51194444,
		code: "302"
	},
	{
		politicalId: "655c8c25-49d2-4b75-adf7-dbb9c5ce946e",
		name: "VILLA O'HIGGINS",
		parentPoliticalId: "abba1dd5-5735-4f4a-b13e-0293067b7f91",
		parentStateId: "21999b34-d273-4b67-9ae1-ad5880644ea4",
		parentStateName: "AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO",
		zones: [
			"110201",
			"OHIG",
			"11"
		],
		type: "TOWN",
		priceGroupId: "37",
		latitude: -48.481788,
		longitude: -72.587345,
		code: "298"
	}
];
var aysen = {
	data: data$9
};

var data$a = [
	{
		politicalId: "981f60d6-04da-42c5-822d-55fb94a5ebb0",
		name: "ALTO BIOBÍO",
		parentPoliticalId: "bce0a9b9-6bfa-4392-948f-480b78196906",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"ALBB",
			"80422",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "9",
		latitude: -38.619,
		longitude: -71.32416667,
		code: "565"
	},
	{
		politicalId: "2d97db09-c2c1-4def-872c-86625ac5ad21",
		name: "ANTIGUALA",
		parentPoliticalId: "7e65198a-d18c-4409-99b7-2b7a9c9fac2d",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80302",
			"ALAM",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.673804,
		longitude: -73.394817,
		code: "182"
	},
	{
		politicalId: "669345dd-f494-42d3-8d77-5b9ec33124ae",
		name: "ANTUCO",
		parentPoliticalId: "bce0a9b9-6bfa-4392-948f-480b78196906",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80421",
			"ANTU",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "9",
		latitude: -37.327,
		longitude: -71.67777778,
		code: "160"
	},
	{
		politicalId: "36f5ccf3-57bd-44a6-ab55-727250e8706b",
		name: "ARAUCO",
		parentPoliticalId: "1d08d7d6-cb7c-482d-a7f3-151112e1a0fc",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"ZL_ARAUCO",
			"ARAU",
			"80303",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.257,
		longitude: -73.28388888888888,
		code: "161"
	},
	{
		politicalId: "eb81f287-22d5-49f6-b6a6-cc82e8c53193",
		name: "CABRERO",
		parentPoliticalId: "984bce9c-9c17-43a9-8f37-54eb7ff16007",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80420",
			"CABR",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.039,
		longitude: -72.39888889,
		code: "164"
	},
	{
		politicalId: "4d9cf333-b107-47fe-a2d2-391e698e95ad",
		name: "CALETA EL REFUGIO",
		parentPoliticalId: "67ed2a9d-cb50-4ea9-bffb-0cf34f3fbc07",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80210",
			"ZL_PENCO",
			"PENC",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.721574,
		longitude: -72.986027,
		code: "181"
	},
	{
		politicalId: "10a8d2d0-5b69-40b3-a0d9-4e5f92a8c6b3",
		name: "CALETA LENGA",
		parentPoliticalId: "77f6d75a-9f6d-46ea-87f0-0a3d3cf063ea",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80227",
			"HPEN",
			"ZL_HUALPEN",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.766743,
		longitude: -73.172441,
		code: "637"
	},
	{
		politicalId: "7150e3e3-62bd-4bd4-af8d-5a51efbc1571",
		name: "CALETA TUMBES",
		parentPoliticalId: "5bdb6aca-4078-47fb-bdd2-ef1dea886b5b",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80226",
			"ZL_TALCAHUANO",
			"THNO",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.640525,
		longitude: -73.093951,
		code: "209"
	},
	{
		politicalId: "97ed3250-4d70-42e7-bab3-6c3635921388",
		name: "CAÑETE",
		parentPoliticalId: "6480906d-db10-490e-80af-f358830b36bc",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"CANE",
			"80304",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.80127778,
		longitude: -73.40894444,
		code: "163"
	},
	{
		politicalId: "74510169-8fef-4c5c-bb34-98409f972977",
		name: "CANIHUAL",
		parentPoliticalId: "45b5e9de-097d-44e9-9964-892a3284c4a6",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80305",
			"TIRU",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -38.33815,
		longitude: -73.488092,
		code: "210"
	},
	{
		politicalId: "76c7cb12-806b-4922-b32a-19704292109d",
		name: "CARAMPANGUE",
		parentPoliticalId: "1d08d7d6-cb7c-482d-a7f3-151112e1a0fc",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"ZL_ARAUCO",
			"ARAU",
			"80303",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.255547,
		longitude: -73.236069,
		code: "165"
	},
	{
		politicalId: "dd67aa47-3552-49cb-9993-5f313affd347",
		name: "CAYUCUPIL",
		parentPoliticalId: "6480906d-db10-490e-80af-f358830b36bc",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80306",
			"CANE",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.811119,
		longitude: -73.269107,
		code: "163"
	},
	{
		politicalId: "e478e53b-310a-4e1f-ae4b-c4b0a46ba12d",
		name: "CERRO ALTO",
		parentPoliticalId: "cbb2c394-436f-47c2-88ab-c598d9c3a7fd",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"FLOR",
			"80307",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.928162,
		longitude: -72.851737,
		code: "177"
	},
	{
		politicalId: "6f6e2a2b-44f0-47e8-b253-f641b7ec8946",
		name: "CHIGUAYANTE",
		parentPoliticalId: "73735409-0fae-49f2-a11c-27e2af34f74f",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"ZL_CHIGUAYANTE",
			"80225",
			"CHIG",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "93",
		latitude: -36.909,
		longitude: -73.02777777777777,
		code: "371"
	},
	{
		politicalId: "df50b5cf-13e2-4ece-95d6-ce792b700435",
		name: "CHIVILINGO",
		parentPoliticalId: "4616cc72-1103-4b7f-930c-d77cacda358e",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80224",
			"ZL_LOTA",
			"LOTA",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.147522,
		longitude: -73.174315,
		code: "184"
	},
	{
		politicalId: "d29c9892-b1cc-4a47-85bf-753b720058b3",
		name: "COCHOLQUE",
		parentPoliticalId: "a856d8a9-bb6c-4ba7-8401-5bd80a59696d",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80223",
			"TOME",
			"ZL_TOME",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.593329,
		longitude: -72.977431,
		code: "211"
	},
	{
		politicalId: "21ef2f6a-2980-4057-bcfb-7a6ba9149add",
		name: "COLCURA",
		parentPoliticalId: "4616cc72-1103-4b7f-930c-d77cacda358e",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80222",
			"ZL_LOTA",
			"LOTA",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.11226,
		longitude: -73.14985,
		code: "184"
	},
	{
		politicalId: "fc4bd475-3f43-483e-aee9-3cb28a83ff73",
		name: "COLIUMO",
		parentPoliticalId: "a856d8a9-bb6c-4ba7-8401-5bd80a59696d",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80221",
			"TOME",
			"ZL_TOME",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.55259,
		longitude: -72.957517,
		code: "211"
	},
	{
		politicalId: "519d94aa-0592-4d3c-b4e3-0f23fec6a88b",
		name: "CONCEPCIÓN",
		parentPoliticalId: "73735409-0fae-49f2-a11c-27e2af34f74f",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"CONC",
			"ZL_CONCEPCION",
			"80220",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "93",
		latitude: -36.815,
		longitude: -73.02888888888889,
		code: "171"
	},
	{
		politicalId: "fb88f7cb-856c-4f72-870d-0eaa3d68e89f",
		name: "CONTULMO",
		parentPoliticalId: "ce607f31-13e2-444e-b214-2016b12cf1ac",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80308",
			"CONT",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "93",
		latitude: -38.005,
		longitude: -73.2175,
		code: "172"
	},
	{
		politicalId: "24e628d4-4cbf-4cf1-a573-ff1ed87d4d52",
		name: "CORONEL",
		parentPoliticalId: "73735409-0fae-49f2-a11c-27e2af34f74f",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"ZL_CORONEL",
			"CORO",
			"80205",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "93",
		latitude: -36.982,
		longitude: -73.15694444444445,
		code: "173"
	},
	{
		politicalId: "571a13df-d4e7-4709-a1bd-29ce28b68d65",
		name: "CURANILAHUE",
		parentPoliticalId: "ce607f31-13e2-444e-b214-2016b12cf1ac",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"CURA",
			"80309",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "93",
		latitude: -37.472,
		longitude: -73.34777778,
		code: "174"
	},
	{
		politicalId: "aff0da34-e134-4ecc-8929-89d02d10d610",
		name: "DICHATO",
		parentPoliticalId: "a856d8a9-bb6c-4ba7-8401-5bd80a59696d",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80203",
			"TOME",
			"ZL_TOME",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.548082,
		longitude: -72.935481,
		code: "175"
	},
	{
		politicalId: "840d82fb-d1a0-4a4b-9c31-e7e64a9d0b34",
		name: "FLORIDA",
		parentPoliticalId: "73735409-0fae-49f2-a11c-27e2af34f74f",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"FLOR",
			"80204",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "93",
		latitude: -36.821,
		longitude: -72.66194444,
		code: "177"
	},
	{
		politicalId: "abbae62f-c494-4194-8bdd-21beb95265a6",
		name: "HUALPÉN",
		parentPoliticalId: "77f6d75a-9f6d-46ea-87f0-0a3d3cf063ea",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"HPEN",
			"80219",
			"ZL_HUALPEN",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.789,
		longitude: -73.10083333333333,
		code: "637"
	},
	{
		politicalId: "f910b427-78e1-42ff-9c21-d37f0df22dfb",
		name: "HUALPENCILLO",
		parentPoliticalId: "77f6d75a-9f6d-46ea-87f0-0a3d3cf063ea",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"HPEN",
			"80219",
			"ZL_HUALPEN",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.776004,
		longitude: -73.15866,
		code: "612"
	},
	{
		politicalId: "b9fb5821-71bf-4866-8933-414a3694f327",
		name: "HUALQUI",
		parentPoliticalId: "cbb2c394-436f-47c2-88ab-c598d9c3a7fd",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"HAQI",
			"80209",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.967,
		longitude: -72.93277778,
		code: "178"
	},
	{
		politicalId: "466002a8-8077-4c9f-ab8a-896dd3d7c09b",
		name: "HUÉPIL",
		parentPoliticalId: "7a814684-f91b-4e39-8be4-5972cd474d43",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"HUEP",
			"80418",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.241155,
		longitude: -71.944483,
		code: "563"
	},
	{
		politicalId: "7688c3c1-d892-4883-954c-65f87e9d9c70",
		name: "LAJA",
		parentPoliticalId: "bce0a9b9-6bfa-4392-948f-480b78196906",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"LAJA",
			"80402",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "9",
		latitude: -37.267,
		longitude: -72.7,
		code: "179"
	},
	{
		politicalId: "462a220b-84e4-41de-a755-440c3db3e2dd",
		name: "LARAQUETE",
		parentPoliticalId: "1d08d7d6-cb7c-482d-a7f3-151112e1a0fc",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80310",
			"ZL_ARAUCO",
			"ARAU",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.165807,
		longitude: -73.183134,
		code: "441"
	},
	{
		politicalId: "dc08cdb5-f185-4bef-9e0d-9608e4c21426",
		name: "LEBU",
		parentPoliticalId: "ce607f31-13e2-444e-b214-2016b12cf1ac",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80311",
			"LEBU",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "93",
		latitude: -37.606,
		longitude: -73.64277778,
		code: "180"
	},
	{
		politicalId: "5667f0f3-6d93-4bbf-878e-d6d943256708",
		name: "LIRQUEN",
		parentPoliticalId: "67ed2a9d-cb50-4ea9-bffb-0cf34f3fbc07",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80208",
			"ZL_PENCO",
			"PENC",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.713934,
		longitude: -72.975474,
		code: "181"
	},
	{
		politicalId: "b44bfa69-5bdb-4e10-8c30-f2fad1375572",
		name: "LLOICURA",
		parentPoliticalId: "a856d8a9-bb6c-4ba7-8401-5bd80a59696d",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80207",
			"TOME",
			"ZL_TOME",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.677673,
		longitude: -72.774941,
		code: "211"
	},
	{
		politicalId: "1e570a8b-1ec5-4d7c-b764-71803929d0ea",
		name: "LOS ÁLAMOS",
		parentPoliticalId: "7e65198a-d18c-4409-99b7-2b7a9c9fac2d",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80301",
			"ALAM",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.621,
		longitude: -73.45583333,
		code: "182"
	},
	{
		politicalId: "be322d71-e939-4f50-8d57-3872cff138fb",
		name: "LOS ÁNGELES",
		parentPoliticalId: "19b66ef5-1b9e-4e00-82b1-388aad30f9d2",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80403",
			"ZL_LOS_ANGELES",
			"LANG",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -36.944,
		longitude: -72.35083333333333,
		code: "183"
	},
	{
		politicalId: "b0430380-4887-4ffe-a248-ba3db1df61ea",
		name: "LOTA",
		parentPoliticalId: "4616cc72-1103-4b7f-930c-d77cacda358e",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"ZL_LOTA",
			"LOTA",
			"80206",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.08900000000001,
		longitude: -73.15027777777779,
		code: "184"
	},
	{
		politicalId: "179fe506-5d82-4ac7-bd3d-91b1fe32d98c",
		name: "LOTA ALTO",
		parentPoliticalId: "4616cc72-1103-4b7f-930c-d77cacda358e",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"ZL_LOTA",
			"LOTA",
			"80206",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.080208,
		longitude: -73.158137,
		code: "185"
	},
	{
		politicalId: "d2ab30fb-ac24-4f52-a4f7-6d257df24262",
		name: "LOTA BAJO",
		parentPoliticalId: "4616cc72-1103-4b7f-930c-d77cacda358e",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"ZL_LOTA",
			"LOTA",
			"80206",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.088824,
		longitude: -73.161429,
		code: "186"
	},
	{
		politicalId: "cb8d7c90-ad37-4e17-ae17-044681ea5403",
		name: "MONTE AGUILA",
		parentPoliticalId: "984bce9c-9c17-43a9-8f37-54eb7ff16007",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80404",
			"CABR",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.083293,
		longitude: -72.438758,
		code: "187"
	},
	{
		politicalId: "bae30b23-260f-43ab-9490-f64d621d309b",
		name: "MULCHÉN",
		parentPoliticalId: "e52b7be4-2265-40e3-bbe7-ad7a3e6cf7f0",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"MULC",
			"80405",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.715,
		longitude: -72.23888889,
		code: "188"
	},
	{
		politicalId: "9a41ea60-a299-4e17-ba49-61ee7c4ca5d9",
		name: "NACIMIENTO",
		parentPoliticalId: "bce0a9b9-6bfa-4392-948f-480b78196906",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"NACI",
			"80407",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "9",
		latitude: -37.501,
		longitude: -72.67583333,
		code: "189"
	},
	{
		politicalId: "21068e27-9c7d-4e2c-babe-1572be296c00",
		name: "NEGRETE",
		parentPoliticalId: "4c607de8-a364-4524-8394-ad9f389fdb69",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"NEGR",
			"80401",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.583,
		longitude: -72.51694444,
		code: "190"
	},
	{
		politicalId: "d05a7bea-1f16-485b-8750-a5d777d0df40",
		name: "PEMEHUE",
		parentPoliticalId: "e52b7be4-2265-40e3-bbe7-ad7a3e6cf7f0",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"90118",
			"MULC",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -38.067659,
		longitude: -71.710752,
		code: "188"
	},
	{
		politicalId: "d8e880b5-1a66-4bcc-884f-a86a97f19613",
		name: "PENCO",
		parentPoliticalId: "67ed2a9d-cb50-4ea9-bffb-0cf34f3fbc07",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80202",
			"ZL_PENCO",
			"PENC",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.742,
		longitude: -72.99777777777778,
		code: "193"
	},
	{
		politicalId: "a2f0b53a-bd8f-412f-b72b-a96ef007fca1",
		name: "PINGUERAL",
		parentPoliticalId: "a856d8a9-bb6c-4ba7-8401-5bd80a59696d",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80211",
			"TOME",
			"ZL_TOME",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.531654,
		longitude: -72.930255,
		code: "175"
	},
	{
		politicalId: "52f0a694-a6e0-4879-90b2-b388b7c4c4bc",
		name: "POLCURA",
		parentPoliticalId: "7a814684-f91b-4e39-8be4-5972cd474d43",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80409",
			"TUCA",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.285174,
		longitude: -71.718763,
		code: "213"
	},
	{
		politicalId: "d1970263-dc5f-4213-bdbb-1c397024b895",
		name: "PUNTA DE PARRA",
		parentPoliticalId: "a856d8a9-bb6c-4ba7-8401-5bd80a59696d",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80213",
			"TOME",
			"ZL_TOME",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.673086,
		longitude: -72.962261,
		code: "211"
	},
	{
		politicalId: "7ee1de93-495c-4323-a67f-38d9d90c1231",
		name: "QUIAPO",
		parentPoliticalId: "1d08d7d6-cb7c-482d-a7f3-151112e1a0fc",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80312",
			"ZL_ARAUCO",
			"ARAU",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.405198,
		longitude: -73.562134,
		code: "161"
	},
	{
		politicalId: "ae13f46b-445b-4ad1-8091-20150a302e71",
		name: "QUIDICO",
		parentPoliticalId: "45b5e9de-097d-44e9-9964-892a3284c4a6",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80313",
			"TIRU",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -38.248042,
		longitude: -73.484397,
		code: "210"
	},
	{
		politicalId: "426c9431-bef1-4648-b6b8-c5dd18951c56",
		name: "QUILACO",
		parentPoliticalId: "bce0a9b9-6bfa-4392-948f-480b78196906",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80410",
			"QLAC",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "9",
		latitude: -37.68,
		longitude: -72.00694444,
		code: "196"
	},
	{
		politicalId: "a9eac17d-5c66-4f15-9abe-1dba25290e09",
		name: "QUILLECO",
		parentPoliticalId: "bce0a9b9-6bfa-4392-948f-480b78196906",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80411",
			"QLLC",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "9",
		latitude: -37.467,
		longitude: -71.96694444,
		code: "197"
	},
	{
		politicalId: "50ab3792-53ad-4c5b-b192-2b5548f38660",
		name: "RAFAEL",
		parentPoliticalId: "a856d8a9-bb6c-4ba7-8401-5bd80a59696d",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80214",
			"TOME",
			"ZL_TOME",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.632697,
		longitude: -72.79222,
		code: "211"
	},
	{
		politicalId: "fbbc0574-fdeb-455e-a5a2-ac35d51991ed",
		name: "RERE",
		parentPoliticalId: "27d8545e-543a-4a68-90a5-723a1a26049b",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80406",
			"YUMB",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.133219,
		longitude: -72.72711,
		code: "214"
	},
	{
		politicalId: "5cb292bc-ac0d-49cf-8575-bf97d12dfa96",
		name: "RIHUE",
		parentPoliticalId: "4c607de8-a364-4524-8394-ad9f389fdb69",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80412",
			"NEGR",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.6222,
		longitude: -72.59149,
		code: "190"
	},
	{
		politicalId: "baca101e-4519-49af-b4d7-68c72f6b290d",
		name: "SAN PEDRO DE LA PAZ",
		parentPoliticalId: "73735409-0fae-49f2-a11c-27e2af34f74f",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80216",
			"ZL_SAN_PEDRO_DE_LA_PAZ",
			"SPED",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "93",
		latitude: -36.864,
		longitude: -73.10777777777777,
		code: "393"
	},
	{
		politicalId: "efc38b61-6d14-4882-92bb-6d5aa430b9fb",
		name: "SAN ROSENDO",
		parentPoliticalId: "bce0a9b9-6bfa-4392-948f-480b78196906",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80413",
			"SANR",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "9",
		latitude: -37.258,
		longitude: -72.71583333,
		code: "206"
	},
	{
		politicalId: "737d0178-8733-48a4-9f3e-3bde13b823ec",
		name: "SANTA BÁRBARA",
		parentPoliticalId: "bce0a9b9-6bfa-4392-948f-480b78196906",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80414",
			"SBAR",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "9",
		latitude: -37.663,
		longitude: -72.01777778,
		code: "207"
	},
	{
		politicalId: "3ac16a05-2624-472a-a669-80fe0d465c28",
		name: "SANTA FE",
		parentPoliticalId: "19b66ef5-1b9e-4e00-82b1-388aad30f9d2",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80403",
			"ZL_LOS_ANGELES",
			"LANG",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.466891,
		longitude: -72.583383,
		code: "473"
	},
	{
		politicalId: "c21c6b8f-34b1-4bc9-b589-4fa3a8158a9e",
		name: "SANTA JUANA",
		parentPoliticalId: "73735409-0fae-49f2-a11c-27e2af34f74f",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80217",
			"SJUN",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "93",
		latitude: -37.17933333,
		longitude: -72.93527778,
		code: "208"
	},
	{
		politicalId: "383ecaac-e88e-44d3-94ff-1d1056aa927c",
		name: "TALCAHUANO",
		parentPoliticalId: "5bdb6aca-4078-47fb-bdd2-ef1dea886b5b",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80218",
			"ZL_TALCAHUANO",
			"THNO",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.736,
		longitude: -73.10027777777778,
		code: "209"
	},
	{
		politicalId: "e26f583e-84ca-478d-9a50-dd3847a4087a",
		name: "TALCAMÁVIDA",
		parentPoliticalId: "cbb2c394-436f-47c2-88ab-c598d9c3a7fd",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"ECAR",
			"80215",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -37.160924,
		longitude: -72.910933,
		code: "176"
	},
	{
		politicalId: "9ef95a8b-a81a-4059-969e-c69ea6654917",
		name: "TIRÚA",
		parentPoliticalId: "45b5e9de-097d-44e9-9964-892a3284c4a6",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"TIRU",
			"80314",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -38.339,
		longitude: -73.48388889,
		code: "210"
	},
	{
		politicalId: "15abb0e3-70c7-4cbd-aa70-74b6ad31ba32",
		name: "TOMÉ",
		parentPoliticalId: "a856d8a9-bb6c-4ba7-8401-5bd80a59696d",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"TOME",
			"80201",
			"ZL_TOME",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.624,
		longitude: -72.95,
		code: "211"
	},
	{
		politicalId: "8e06dbea-4a24-4a19-a04f-0941fbb18d93",
		name: "TRANAQUEPE",
		parentPoliticalId: "45b5e9de-097d-44e9-9964-892a3284c4a6",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80315",
			"TIRU",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -38.191249,
		longitude: -73.423514,
		code: "210"
	},
	{
		politicalId: "54ddccc4-c126-46ee-99cb-46055c343cf2",
		name: "TRUPAN",
		parentPoliticalId: "7a814684-f91b-4e39-8be4-5972cd474d43",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"80415",
			"TUCA",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.278821,
		longitude: -71.827637,
		code: "213"
	},
	{
		politicalId: "64e7d55b-1c2c-475a-9d56-65d59ed97422",
		name: "TUCAPEL",
		parentPoliticalId: "7a814684-f91b-4e39-8be4-5972cd474d43",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"TUCA",
			"80416",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.633,
		longitude: -73.33277778,
		code: "213"
	},
	{
		politicalId: "41735228-1d65-498a-b80f-f88eb86f2a64",
		name: "YUMBEL",
		parentPoliticalId: "27d8545e-543a-4a68-90a5-723a1a26049b",
		parentStateId: "9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b",
		parentStateName: "BIOBÍO",
		zones: [
			"YUMB",
			"80408",
			"8"
		],
		type: "TOWN",
		priceGroupId: "9",
		latitude: -37.096,
		longitude: -72.55583333,
		code: "214"
	}
];
var biobio = {
	data: data$a
};

var data$b = [
	{
		politicalId: "71bd0ea7-237c-4128-9276-f71d8e44de1f",
		name: "ANDACOLLO",
		parentPoliticalId: "49d50870-0220-4127-b78f-8697504f53d5",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40108",
			"ANDA",
			"4"
		],
		type: "DISTRICT",
		priceGroupId: "39",
		latitude: -30.23,
		longitude: -71.08583333333333,
		code: "31"
	},
	{
		politicalId: "b7410ac7-13b5-4183-9403-8f005ff02bce",
		name: "BARRAZA",
		parentPoliticalId: "5b7d0d68-80c4-4531-a9bc-3c796bd76687",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40203",
			"ZL_OVALLE",
			"OVAL",
			"4"
		],
		type: "TOWN",
		priceGroupId: "729",
		latitude: -30.657398,
		longitude: -71.483855,
		code: "40"
	},
	{
		politicalId: "e98a51ed-777c-4935-8053-ddfb85f62e4b",
		name: "CANELA",
		parentPoliticalId: "d9ee4279-a4aa-4dce-8ac0-3f57c941ccb5",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40204",
			"CANL",
			"4"
		],
		type: "DISTRICT",
		priceGroupId: "39",
		latitude: -31.396,
		longitude: -71.41888888888889,
		code: "32"
	},
	{
		politicalId: "6a381af0-d936-410e-9182-40928be0eb5a",
		name: "CANELA ALTA",
		parentPoliticalId: "e98a51ed-777c-4935-8053-ddfb85f62e4b",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40204",
			"CANL",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -31.390234,
		longitude: -71.383979,
		code: "32"
	},
	{
		politicalId: "410b5aa1-e49e-4d7b-b149-2f785fec9444",
		name: "CANELA BAJA",
		parentPoliticalId: "e98a51ed-777c-4935-8053-ddfb85f62e4b",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40205",
			"CANL",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -31.400031,
		longitude: -71.457883,
		code: "32"
	},
	{
		politicalId: "75a4f22d-b3be-41ba-81f4-9177e6db727f",
		name: "COMBARBALÁ",
		parentPoliticalId: "3136e967-97a3-4224-8327-a01c7bb264c2",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40404",
			"COMB",
			"4"
		],
		type: "DISTRICT",
		priceGroupId: "729",
		latitude: -31.18,
		longitude: -71.0038888888889,
		code: "33"
	},
	{
		politicalId: "50a1891b-4a90-4616-9600-6ea0604665f3",
		name: "COQUIMBO",
		parentPoliticalId: "865ac130-a12f-44e6-9a17-0baebd61d676",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40107",
			"COQU",
			"ZL_COQUIMBO",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -29.971,
		longitude: -71.30694444444444,
		code: "34"
	},
	{
		politicalId: "ab8f4a32-4b5e-48a7-86dc-82a9354294f5",
		name: "EL MOLLE",
		parentPoliticalId: "756db29a-abc1-4308-aa12-434dd94c88ac",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40302",
			"VICU",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -29.979439,
		longitude: -70.956213,
		code: "45"
	},
	{
		politicalId: "576b5a30-28cb-487d-a06e-985fd2b9aa64",
		name: "GUANAQUEROS",
		parentPoliticalId: "865ac130-a12f-44e6-9a17-0baebd61d676",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40106",
			"OVAL",
			"ZL_COQUIMBO",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -30.19882,
		longitude: -71.421245,
		code: "431"
	},
	{
		politicalId: "9d2a9d5d-ddfc-4d03-8203-896b25638ea7",
		name: "HUINTIL",
		parentPoliticalId: "72bcd0a6-c3bd-4cd5-91b9-b1b343c5036f",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40206",
			"ILLA",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -31.567939,
		longitude: -70.981472,
		code: "35"
	},
	{
		politicalId: "727f71ea-a57b-4245-a3d3-973860412beb",
		name: "ILLAPEL",
		parentPoliticalId: "72bcd0a6-c3bd-4cd5-91b9-b1b343c5036f",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40208",
			"ILLA",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -31.639,
		longitude: -71.17888888888889,
		code: "35"
	},
	{
		politicalId: "f837d3cc-9935-4a61-8de1-d1bf0cef27e0",
		name: "LA CEBADA",
		parentPoliticalId: "5b7d0d68-80c4-4531-a9bc-3c796bd76687",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40405",
			"ZL_OVALLE",
			"OVAL",
			"4"
		],
		type: "TOWN",
		priceGroupId: "729",
		latitude: -30.968889,
		longitude: -71.640556,
		code: "40"
	},
	{
		politicalId: "2d18584b-9fc3-4ead-ace1-0708c7c89d0f",
		name: "LA CHIMBA",
		parentPoliticalId: "5b7d0d68-80c4-4531-a9bc-3c796bd76687",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40401",
			"ZL_OVALLE",
			"4"
		],
		type: "TOWN",
		priceGroupId: "729",
		latitude: -30.641458,
		longitude: -71.234651,
		code: "435"
	},
	{
		politicalId: "fb1f528f-9805-483f-ac07-f75bb3a098b4",
		name: "LA HERRADURA",
		parentPoliticalId: "865ac130-a12f-44e6-9a17-0baebd61d676",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40107",
			"COQU",
			"ZL_COQUIMBO",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -29.983083,
		longitude: -71.366896,
		code: "437"
	},
	{
		politicalId: "74e7558f-c7e6-4124-84c4-7ca5374dc202",
		name: "LA HIGUERA",
		parentPoliticalId: "49d50870-0220-4127-b78f-8697504f53d5",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"LAHI",
			"40105",
			"4"
		],
		type: "DISTRICT",
		priceGroupId: "39",
		latitude: -29.5,
		longitude: -71.28277777777778,
		code: "36"
	},
	{
		politicalId: "20621884-5d4e-4c7d-9937-da4709bc90a6",
		name: "LA SERENA",
		parentPoliticalId: "49d50870-0220-4127-b78f-8697504f53d5",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"ZL_LA_SERENA",
			"40301",
			"LASE",
			"4"
		],
		type: "DISTRICT",
		priceGroupId: "39",
		latitude: -29.907,
		longitude: -71.24694444444445,
		code: "37"
	},
	{
		politicalId: "54b679bb-9eb1-4eca-8e8e-7498abeb85e8",
		name: "LAS TACAS",
		parentPoliticalId: "865ac130-a12f-44e6-9a17-0baebd61d676",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40104",
			"COQU",
			"ZL_COQUIMBO",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -30.088935,
		longitude: -71.3664,
		code: "442"
	},
	{
		politicalId: "aded357c-0a40-42ab-bbf8-35b1adf35870",
		name: "LOS VILOS",
		parentPoliticalId: "43e7251b-dc53-4eba-93ef-3a51e6e39485",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40201",
			"LVIL",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -31.915,
		longitude: -71.50583333333333,
		code: "38"
	},
	{
		politicalId: "26dce005-6ec1-4b98-9184-c9271ea3e10d",
		name: "MONTE GRANDE",
		parentPoliticalId: "c7de24c1-56bb-49c1-9dc9-d6518a698f02",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40304",
			"PAIG",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -30.094314,
		longitude: -70.494837,
		code: "41"
	},
	{
		politicalId: "84319cd8-c4e9-480b-99f2-273c60a4e26f",
		name: "MONTE PATRIA",
		parentPoliticalId: "3136e967-97a3-4224-8327-a01c7bb264c2",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"MOPA",
			"40408",
			"4"
		],
		type: "DISTRICT",
		priceGroupId: "729",
		latitude: -30.775,
		longitude: -70.94277777777778,
		code: "39"
	},
	{
		politicalId: "ad04e4cc-2403-4f4d-b5f2-3e2062f0d878",
		name: "OVALLE",
		parentPoliticalId: "5b7d0d68-80c4-4531-a9bc-3c796bd76687",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40401",
			"ZL_OVALLE",
			"OVAL",
			"4"
		],
		type: "TOWN",
		priceGroupId: "729",
		latitude: -30.599,
		longitude: -71.1888888888889,
		code: "40"
	},
	{
		politicalId: "13f7f09e-059d-452e-9df9-5f09c3afd970",
		name: "PAIHUANO",
		parentPoliticalId: "c7de24c1-56bb-49c1-9dc9-d6518a698f02",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"PAIG",
			"40103",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -30.038,
		longitude: -70.50694444444444,
		code: "41"
	},
	{
		politicalId: "b6aa5bf9-353e-4838-98ee-e070a7f7a303",
		name: "PICHIDANGUI",
		parentPoliticalId: "43e7251b-dc53-4eba-93ef-3a51e6e39485",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40202",
			"LVIL",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -32.140559,
		longitude: -71.52969,
		code: "38"
	},
	{
		politicalId: "86148c2a-74dd-4f4b-90d6-8a34cf4e3e7a",
		name: "PIQUE DE TAMAYA",
		parentPoliticalId: "5b7d0d68-80c4-4531-a9bc-3c796bd76687",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40402",
			"ZL_OVALLE",
			"OVAL",
			"4"
		],
		type: "TOWN",
		priceGroupId: "729",
		latitude: -30.579341,
		longitude: -71.407946,
		code: "40"
	},
	{
		politicalId: "0c4868c1-8bbd-41a8-9898-2582a84d9592",
		name: "PISCO ELQUI",
		parentPoliticalId: "c7de24c1-56bb-49c1-9dc9-d6518a698f02",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40303",
			"PAIG",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -30.125391,
		longitude: -70.493943,
		code: "41"
	},
	{
		politicalId: "c9c76e17-7f17-4ee3-8f5a-15a9ef3547f0",
		name: "PUERTO ALDEA",
		parentPoliticalId: "865ac130-a12f-44e6-9a17-0baebd61d676",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40102",
			"COQU",
			"ZL_COQUIMBO",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -30.293881,
		longitude: -71.609877,
		code: "462"
	},
	{
		politicalId: "87edcae8-7e85-420e-9f1f-05917a6c8100",
		name: "PUERTO VELERO",
		parentPoliticalId: "865ac130-a12f-44e6-9a17-0baebd61d676",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40102",
			"COQU",
			"ZL_COQUIMBO",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -30.243178,
		longitude: -71.474212,
		code: "462"
	},
	{
		politicalId: "c0715546-8398-49ce-86d4-8eb1973b2d8c",
		name: "PUNITAQUI",
		parentPoliticalId: "3136e967-97a3-4224-8327-a01c7bb264c2",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"PUNI",
			"40403",
			"4"
		],
		type: "DISTRICT",
		priceGroupId: "729",
		latitude: -30.833,
		longitude: -71.25083333333333,
		code: "42"
	},
	{
		politicalId: "7d264d66-842e-4965-a765-34856ea95163",
		name: "RÍO HURTADO",
		parentPoliticalId: "3136e967-97a3-4224-8327-a01c7bb264c2",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40407",
			"RHUR",
			"4"
		],
		type: "DISTRICT",
		priceGroupId: "729",
		latitude: -30.273,
		longitude: -70.66694444444445,
		code: "43"
	},
	{
		politicalId: "ab347d06-ca0d-4ce5-aa11-5bd9faf4715d",
		name: "SALAMANCA",
		parentPoliticalId: "d9ee4279-a4aa-4dce-8ac0-3f57c941ccb5",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"SALA",
			"40207",
			"4"
		],
		type: "DISTRICT",
		priceGroupId: "39",
		latitude: -31.78,
		longitude: -70.96694444444445,
		code: "44"
	},
	{
		politicalId: "be9e60ae-ba45-4ae8-9481-ef7f7af0498d",
		name: "SAN JULIÁN",
		parentPoliticalId: "5b7d0d68-80c4-4531-a9bc-3c796bd76687",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40406",
			"ZL_OVALLE",
			"OVAL",
			"4"
		],
		type: "TOWN",
		priceGroupId: "729",
		latitude: -30.645444,
		longitude: -71.34168,
		code: "40"
	},
	{
		politicalId: "3436965c-621a-447d-bb6b-4aada065bf0b",
		name: "SOTAQUI",
		parentPoliticalId: "5b7d0d68-80c4-4531-a9bc-3c796bd76687",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40409",
			"ZL_OVALLE",
			"OVAL",
			"4"
		],
		type: "TOWN",
		priceGroupId: "729",
		latitude: -30.637012,
		longitude: -71.117916,
		code: "475"
	},
	{
		politicalId: "88c07a9f-ad7b-4cfb-8cf9-5d3d1de3f6ff",
		name: "TONGOY",
		parentPoliticalId: "865ac130-a12f-44e6-9a17-0baebd61d676",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40101",
			"TONG",
			"ZL_COQUIMBO",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -30.258878,
		longitude: -71.493212,
		code: "477"
	},
	{
		politicalId: "4e6234a0-f9af-420a-bcc2-71041451a3fb",
		name: "TOTORALILLO",
		parentPoliticalId: "865ac130-a12f-44e6-9a17-0baebd61d676",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"40109",
			"COQU",
			"ZL_COQUIMBO",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -30.062776,
		longitude: -71.366529,
		code: "442"
	},
	{
		politicalId: "987c2184-dde6-448a-bda9-40f0efeb904e",
		name: "VICUÑA",
		parentPoliticalId: "756db29a-abc1-4308-aa12-434dd94c88ac",
		parentStateId: "73c626ec-e662-4777-83a2-576f60963d87",
		parentStateName: "COQUIMBO",
		zones: [
			"VICU",
			"40110",
			"4"
		],
		type: "TOWN",
		priceGroupId: "39",
		latitude: -30.019,
		longitude: -70.70138888888889,
		code: "45"
	}
];
var coquimbo = {
	data: data$b
};

var data$c = [
	{
		politicalId: "50ff8e7e-c5e4-4d1c-bd85-63a901b0c118",
		name: "BUCALEMU",
		parentPoliticalId: "9105b826-5ffc-4143-bb6b-711f4607c844",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60106",
			"PARE",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.64418,
		longitude: -72.036995,
		code: "112"
	},
	{
		politicalId: "f4cb0f29-dc4b-4346-a365-b05807290e9f",
		name: "CAHUIL",
		parentPoliticalId: "24960e6b-b6c9-4a92-b58d-47e8c0825084",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60107",
			"PICH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.479975,
		longitude: -72.015045,
		code: "117"
	},
	{
		politicalId: "505f22d2-9f54-4a0a-8c33-a8ae31f97ab2",
		name: "CALETONES",
		parentPoliticalId: "07b9b295-5122-428a-a6c3-3bb0b8429cad",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60241",
			"ZL_MACHALI",
			"MACH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.106588,
		longitude: -70.452123,
		code: "106"
	},
	{
		politicalId: "b8d561b0-79e6-48fb-b14e-6ae80015bdfa",
		name: "CALLEUQUE",
		parentPoliticalId: "3fbd69a4-da9d-452e-bde0-47953311f1ce",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60304",
			"PERA",
			"6"
		],
		type: "TOWN",
		priceGroupId: "716",
		latitude: -34.403641,
		longitude: -71.437949,
		code: "114"
	},
	{
		politicalId: "816368ec-cc75-4815-9e68-b6ecec5d1bbb",
		name: "CHAPA VERDE",
		parentPoliticalId: "07b9b295-5122-428a-a6c3-3bb0b8429cad",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60233",
			"ZL_MACHALI",
			"MACH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.052008,
		longitude: -70.43321,
		code: "106"
	},
	{
		politicalId: "b0d33f69-8c2c-4dea-a2dc-3513844247e5",
		name: "CHÉPICA",
		parentPoliticalId: "2fb16880-73ff-4a1e-a196-323ad2fc3617",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60303",
			"CHEP",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "716",
		latitude: -34.733,
		longitude: -71.28277777777778,
		code: "91"
	},
	{
		politicalId: "53aa2c3f-8114-445b-8f2a-4685a5b17888",
		name: "CHIMBARONGO",
		parentPoliticalId: "713e04ac-f4d5-4d15-b75a-714c57a19d90",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"ZL_CHIMBARONGO",
			"60302",
			"CHIM",
			"6"
		],
		type: "TOWN",
		priceGroupId: "731",
		latitude: -34.70800000000001,
		longitude: -71.04194444444444,
		code: "92"
	},
	{
		politicalId: "05d8d063-075c-4118-92e0-7ab45a8caec0",
		name: "CODEGUA",
		parentPoliticalId: "989d021a-9c74-4f86-951b-eb6329fa8c28",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"CODE",
			"60232",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "83",
		latitude: -34.033,
		longitude: -70.66694444444445,
		code: "93"
	},
	{
		politicalId: "14920929-81bd-4330-bdba-f97653738c1e",
		name: "COINCO",
		parentPoliticalId: "7869fbe4-027d-4fd1-a5c0-b7ced086ed5d",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"COIN",
			"60231",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.273,
		longitude: -70.95277777777778,
		code: "94"
	},
	{
		politicalId: "645058f6-0f37-4e98-b69c-68439985994a",
		name: "COLTAUCO",
		parentPoliticalId: "989d021a-9c74-4f86-951b-eb6329fa8c28",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"COLT",
			"60230",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "83",
		latitude: -34.297,
		longitude: -71.09194444444444,
		code: "95"
	},
	{
		politicalId: "5b78e41f-5c06-4375-93e2-6a24ac7fa6f3",
		name: "COPEQUÉN",
		parentPoliticalId: "7869fbe4-027d-4fd1-a5c0-b7ced086ed5d",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60229",
			"COIN",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.250317,
		longitude: -70.926755,
		code: "94"
	},
	{
		politicalId: "e89cde65-76e6-41fa-a391-d8b390ebc206",
		name: "COYA",
		parentPoliticalId: "07b9b295-5122-428a-a6c3-3bb0b8429cad",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60228",
			"ZL_MACHALI",
			"MACH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.203354,
		longitude: -70.529278,
		code: "96"
	},
	{
		politicalId: "f80a5b01-cc22-4b7c-8561-601041e50924",
		name: "CUNACO",
		parentPoliticalId: "55e8d856-b48b-4d48-a2d4-98a003dbcfec",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"NANC",
			"60301",
			"ZL_SANTA_CRUZ",
			"6"
		],
		type: "TOWN",
		priceGroupId: "716",
		latitude: -34.651869,
		longitude: -71.287708,
		code: "423"
	},
	{
		politicalId: "12f3ac79-ac44-4ced-aacb-1940d660b8c7",
		name: "DOÑIHUE",
		parentPoliticalId: "77399761-9ef5-47f0-8947-5b7b5194e4f5",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60234",
			"DONI",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.185,
		longitude: -70.88388888888889,
		code: "97"
	},
	{
		politicalId: "cb604205-5c49-4433-ace0-9187267b0e33",
		name: "EL ESTERO",
		parentPoliticalId: "221db8f9-0f89-4eb8-b63b-945efd0a3100",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60226",
			"LCAB",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.152498,
		longitude: -71.452298,
		code: "101"
	},
	{
		politicalId: "d1f84e01-e1c1-4e43-9a16-39e55f75dade",
		name: "EL MANZANO",
		parentPoliticalId: "221db8f9-0f89-4eb8-b63b-945efd0a3100",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60225",
			"LCAB",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.179868,
		longitude: -71.398954,
		code: "101"
	},
	{
		politicalId: "0f4fcd01-2251-4358-9922-85a09727c555",
		name: "EL RULO",
		parentPoliticalId: "7869fbe4-027d-4fd1-a5c0-b7ced086ed5d",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60224",
			"COIN",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.307612,
		longitude: -71.020909,
		code: "94"
	},
	{
		politicalId: "3a0bcd60-783f-40fa-8468-148766d7fd08",
		name: "EL TENIENTE",
		parentPoliticalId: "07b9b295-5122-428a-a6c3-3bb0b8429cad",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60223",
			"ZL_MACHALI",
			"MACH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.087796,
		longitude: -70.458397,
		code: "96"
	},
	{
		politicalId: "610c9f31-b179-477c-822c-8efc19d75ea4",
		name: "GRANEROS",
		parentPoliticalId: "989d021a-9c74-4f86-951b-eb6329fa8c28",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"ZL_GRANEROS",
			"GRAN",
			"60222",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "83",
		latitude: -34.063,
		longitude: -70.72083333333333,
		code: "99"
	},
	{
		politicalId: "88af022c-e8ea-49da-901b-42482ab9618e",
		name: "GUACARHUE",
		parentPoliticalId: "56bc89bb-3a45-4f95-a810-9f749c725540",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60221",
			"QTIL",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.354781,
		longitude: -71.020825,
		code: "120"
	},
	{
		politicalId: "4b818f3f-c0c2-46da-983c-5ecff36be256",
		name: "GULTRO",
		parentPoliticalId: "40faab1b-2385-4532-9dd0-bc516fb2a2a1",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60215",
			"OLIV",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.205431,
		longitude: -70.758009,
		code: "98"
	},
	{
		politicalId: "33953af2-3cc5-4673-ab76-d84c6188ae53",
		name: "LA BOCA",
		parentPoliticalId: "b8c84bdb-bf12-4c82-85b3-ead676018d32",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60101",
			"NAVI",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -33.92554,
		longitude: -71.845998,
		code: "110"
	},
	{
		politicalId: "a7b1b23f-de96-45a4-af95-6e5a5471f654",
		name: "LA ESTRELLA",
		parentPoliticalId: "dd1ac98d-4c63-40bd-988a-7a2ea51ffeb8",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60109",
			"LAES",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "83",
		latitude: -34.2,
		longitude: -71.66694444,
		code: "100"
	},
	{
		politicalId: "efbc04ca-d974-4630-a81d-62d32e1cd09a",
		name: "LA RUFINA",
		parentPoliticalId: "5c10434d-bb18-4567-8df0-b33fd6ffcf8a",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60317",
			"SFER",
			"ZL_SAN_FERNANDO",
			"6"
		],
		type: "TOWN",
		priceGroupId: "731",
		latitude: -34.744694,
		longitude: -70.750426,
		code: "126"
	},
	{
		politicalId: "c62fafbc-e5ba-4b8b-b756-e1a1b9061e4e",
		name: "LA VINILLA",
		parentPoliticalId: "07b9b295-5122-428a-a6c3-3bb0b8429cad",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60216",
			"ZL_MACHALI",
			"MACH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.167076,
		longitude: -70.650215,
		code: "106"
	},
	{
		politicalId: "0d49683a-dc6f-4493-a296-e370c5c6d6a4",
		name: "LARMAHUE",
		parentPoliticalId: "3e25728a-dfad-4952-8fb4-9a4fa0dd16c6",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60227",
			"PICD",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.410807,
		longitude: -71.214473,
		code: "116"
	},
	{
		politicalId: "be267d6b-fbd4-4bbb-9179-c38f63d962b1",
		name: "LAS CABRAS",
		parentPoliticalId: "221db8f9-0f89-4eb8-b63b-945efd0a3100",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"LCAB",
			"60202",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.285,
		longitude: -71.30083333,
		code: "101"
	},
	{
		politicalId: "610427ae-8c8d-4864-8f09-ba1c0ee82090",
		name: "LAS NIEVES",
		parentPoliticalId: "c86ce4e0-52d8-4927-826f-6adb48c6803b",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60203",
			"RENG",
			"ZL_RENGO",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.479249,
		longitude: -70.743183,
		code: "122"
	},
	{
		politicalId: "86cda2d0-bf8e-40a1-9986-ddd58ad7c447",
		name: "LITUECHE",
		parentPoliticalId: "3285f74f-51f4-47ea-a73a-3cc5898b5427",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"LCHE",
			"60110",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.119,
		longitude: -71.72777778,
		code: "102"
	},
	{
		politicalId: "ccb532ad-340f-4fac-85fa-89725a68fa6e",
		name: "LO MIRANDA",
		parentPoliticalId: "77399761-9ef5-47f0-8947-5b7b5194e4f5",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60204",
			"LOMI",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.191344,
		longitude: -70.892122,
		code: "103"
	},
	{
		politicalId: "90dba7ea-1c5a-4b38-a9e5-8127d7de385d",
		name: "LOLOL",
		parentPoliticalId: "2fb16880-73ff-4a1e-a196-323ad2fc3617",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"LOLO",
			"60316",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "731",
		latitude: -34.731,
		longitude: -71.63583333,
		code: "104"
	},
	{
		politicalId: "f8e562f6-fc32-4c79-9833-e6fb8dfbe717",
		name: "MACHALÍ",
		parentPoliticalId: "07b9b295-5122-428a-a6c3-3bb0b8429cad",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"ZL_MACHALI",
			"60205",
			"MACH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.185,
		longitude: -70.66194444444444,
		code: "106"
	},
	{
		politicalId: "8fa80443-9f7b-47a3-9a09-144fcccc8a90",
		name: "MALLOA",
		parentPoliticalId: "4bcd8a5d-6a2f-4e1e-b32d-225d9eaf0cc7",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"MALO",
			"60206",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.445,
		longitude: -70.93444444,
		code: "107"
	},
	{
		politicalId: "a6c63d17-680f-4503-b905-000ae2d19738",
		name: "MARCHIHUE",
		parentPoliticalId: "dd1ac98d-4c63-40bd-988a-7a2ea51ffeb8",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"MARC",
			"60111",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "716",
		latitude: -34.4,
		longitude: -71.63277778,
		code: "108"
	},
	{
		politicalId: "332bdc68-7847-424f-b01d-cd1be7d6a44b",
		name: "MATANZAS",
		parentPoliticalId: "b8c84bdb-bf12-4c82-85b3-ead676018d32",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60115",
			"NAVI",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -33.962629,
		longitude: -71.876193,
		code: "110"
	},
	{
		politicalId: "aeed9a05-6f3a-4606-a810-ece0c9b23c67",
		name: "MOSTAZAL",
		parentPoliticalId: "1e104796-12a2-461b-bb33-761ada63262b",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60207",
			"ZL_MOSTAZAL",
			"SFRA",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -33.977,
		longitude: -70.7088888888889,
		code: "124"
	},
	{
		politicalId: "c0c370ac-8470-418f-8482-628530bd29ad",
		name: "NANCAGUA",
		parentPoliticalId: "2fb16880-73ff-4a1e-a196-323ad2fc3617",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"NANC",
			"60315",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "716",
		latitude: -34.649,
		longitude: -71.20277778,
		code: "109"
	},
	{
		politicalId: "e8816ec3-5d67-4419-9cfd-d7010b29a0c2",
		name: "NAVIDAD",
		parentPoliticalId: "b8c84bdb-bf12-4c82-85b3-ead676018d32",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60116",
			"NAVI",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -33.95,
		longitude: -71.83277778,
		code: "110"
	},
	{
		politicalId: "c0863822-d4cd-46cd-8932-902538649337",
		name: "OLIVAR",
		parentPoliticalId: "40faab1b-2385-4532-9dd0-bc516fb2a2a1",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60208",
			"OLIV",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.21400000000001,
		longitude: -70.81888888888888,
		code: "98"
	},
	{
		politicalId: "64561ae1-4cf9-41e8-9a11-45009ddc23a8",
		name: "PALMILLA",
		parentPoliticalId: "3e265ff3-0085-4030-9e71-d59a93074905",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60309",
			"PALM",
			"6"
		],
		type: "TOWN",
		priceGroupId: "716",
		latitude: -34.604,
		longitude: -71.35777778,
		code: "111"
	},
	{
		politicalId: "ad81bbda-b14a-4478-b140-505db6956985",
		name: "PANGAL",
		parentPoliticalId: "07b9b295-5122-428a-a6c3-3bb0b8429cad",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60209",
			"ZL_MACHALI",
			"MACH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.239512,
		longitude: -70.44292,
		code: "106"
	},
	{
		politicalId: "6f833023-3788-49aa-8015-9425d87da90b",
		name: "PAREDONES",
		parentPoliticalId: "9105b826-5ffc-4143-bb6b-711f4607c844",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"PARE",
			"60114",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.661,
		longitude: -71.89388889,
		code: "112"
	},
	{
		politicalId: "e245910d-d697-41ee-ad68-4329b1f83ed1",
		name: "PELEQUÉN",
		parentPoliticalId: "4bcd8a5d-6a2f-4e1e-b32d-225d9eaf0cc7",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"PELE",
			"60210",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.466648,
		longitude: -70.896415,
		code: "113"
	},
	{
		politicalId: "a93a86ca-15ac-48fd-9d6f-de0c98208622",
		name: "PEOR ES NADA",
		parentPoliticalId: "713e04ac-f4d5-4d15-b75a-714c57a19d90",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60314",
			"ZL_CHIMBARONGO",
			"CHIM",
			"6"
		],
		type: "TOWN",
		priceGroupId: "731",
		latitude: -34.788159,
		longitude: -71.043696,
		code: "92"
	},
	{
		politicalId: "5e5446c7-082a-41ab-bafe-995ed6e8ad62",
		name: "PERALILLO",
		parentPoliticalId: "3fbd69a4-da9d-452e-bde0-47953311f1ce",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60313",
			"PERA",
			"6"
		],
		type: "TOWN",
		priceGroupId: "716",
		latitude: -34.483,
		longitude: -71.48277778,
		code: "114"
	},
	{
		politicalId: "50ac0b9b-2213-456f-ae1f-c30b53ce78d1",
		name: "PEUMO",
		parentPoliticalId: "989d021a-9c74-4f86-951b-eb6329fa8c28",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"PEUM",
			"60211",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "83",
		latitude: -34.389,
		longitude: -71.17083333,
		code: "115"
	},
	{
		politicalId: "fe0b039b-c59c-450d-a66e-1d8765aee3cf",
		name: "PICARQUIN",
		parentPoliticalId: "1e104796-12a2-461b-bb33-761ada63262b",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60212",
			"ZL_MOSTAZAL",
			"SFRA",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -33.959778,
		longitude: -70.628424,
		code: "124"
	},
	{
		politicalId: "b0b6def1-91c1-4130-a445-7299370e5e2e",
		name: "PICHIDEGUA",
		parentPoliticalId: "3e25728a-dfad-4952-8fb4-9a4fa0dd16c6",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"PICD",
			"60213",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.357,
		longitude: -71.28694444,
		code: "116"
	},
	{
		politicalId: "97c7f347-8af2-47fa-a398-05f86e5f3bb7",
		name: "PICHILEMU",
		parentPoliticalId: "24960e6b-b6c9-4a92-b58d-47e8c0825084",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"PICH",
			"60104",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.402,
		longitude: -72.00888889,
		code: "117"
	},
	{
		politicalId: "a95df315-2fb6-4303-a3b4-d3080af74cda",
		name: "PLACILLA",
		parentPoliticalId: "2fb16880-73ff-4a1e-a196-323ad2fc3617",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60312",
			"PLAC",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "731",
		latitude: -34.633,
		longitude: -71.11694444,
		code: "118"
	},
	{
		politicalId: "739db5d1-0f52-4c38-9542-395818e3f7c6",
		name: "PLAYA PUNTA DE LOBOS",
		parentPoliticalId: "24960e6b-b6c9-4a92-b58d-47e8c0825084",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60103",
			"PICH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.385202,
		longitude: -72.018225,
		code: "117"
	},
	{
		politicalId: "ff2c87f4-fcfb-4244-bec0-a1b8b82b5840",
		name: "POPETA",
		parentPoliticalId: "c86ce4e0-52d8-4927-826f-6adb48c6803b",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60217",
			"RENG",
			"ZL_RENGO",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.437559,
		longitude: -70.788587,
		code: "122"
	},
	{
		politicalId: "37ebf421-620e-4108-ae51-f43916dc0942",
		name: "PUENTE NEGRO",
		parentPoliticalId: "5c10434d-bb18-4567-8df0-b33fd6ffcf8a",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60311",
			"SFER",
			"ZL_SAN_FERNANDO",
			"6"
		],
		type: "TOWN",
		priceGroupId: "731",
		latitude: -34.686724,
		longitude: -70.873719,
		code: "126"
	},
	{
		politicalId: "990f0787-c6d6-422b-9afe-26312409e3e1",
		name: "PUERTECILLO",
		parentPoliticalId: "3285f74f-51f4-47ea-a73a-3cc5898b5427",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60113",
			"LCHE",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.088705,
		longitude: -71.960905,
		code: "102"
	},
	{
		politicalId: "e68b9a42-f401-45b9-a1d4-afec72806db0",
		name: "PUMANQUE",
		parentPoliticalId: "2fb16880-73ff-4a1e-a196-323ad2fc3617",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"PUMA",
			"60305",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "731",
		latitude: -34.605,
		longitude: -71.64388889,
		code: "119"
	},
	{
		politicalId: "e2c5de43-a343-4ed2-99ec-b18b88dfc875",
		name: "PUPUYA",
		parentPoliticalId: "b8c84bdb-bf12-4c82-85b3-ead676018d32",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60112",
			"NAVI",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.014703,
		longitude: -71.844974,
		code: "110"
	},
	{
		politicalId: "afc0f263-49a9-4cfd-8db9-826e3b0a1d4c",
		name: "QUILTA DE TILCOCO",
		parentPoliticalId: "56bc89bb-3a45-4f95-a810-9f749c725540",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60218",
			"QTIL",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.357,
		longitude: -70.96888889,
		code: "120"
	},
	{
		politicalId: "56bc89bb-3a45-4f95-a810-9f749c725540",
		name: "QUINTA DE TILCOCO",
		parentPoliticalId: "989d021a-9c74-4f86-951b-eb6329fa8c28",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60218",
			"QTIL",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "83",
		latitude: -34.357,
		longitude: -70.96888889,
		code: "120"
	},
	{
		politicalId: "22be493b-c102-42d9-aff5-74ca25c11a73",
		name: "RANCAGUA",
		parentPoliticalId: "989d021a-9c74-4f86-951b-eb6329fa8c28",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"RANC",
			"60219",
			"ZL_RANCAGUA",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "83",
		latitude: -34.162,
		longitude: -70.74083333333333,
		code: "121"
	},
	{
		politicalId: "035d9bbf-3309-48b4-b841-81cbb9076f93",
		name: "RAPEL",
		parentPoliticalId: "b8c84bdb-bf12-4c82-85b3-ead676018d32",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60108",
			"NAVI",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -33.944182,
		longitude: -71.739708,
		code: "110"
	},
	{
		politicalId: "cb33f506-1986-4952-abf5-b8a3f8a74569",
		name: "RENGO",
		parentPoliticalId: "c86ce4e0-52d8-4927-826f-6adb48c6803b",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"RENG",
			"ZL_RENGO",
			"60220",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.402,
		longitude: -70.85583333333332,
		code: "122"
	},
	{
		politicalId: "c0cb8406-2789-4e78-9ab3-600878201d04",
		name: "REQUEGUA",
		parentPoliticalId: "38215070-65a0-4938-83de-825ed83e730a",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60239",
			"SVIC",
			"ZL_SAN_VICENTE",
			"6"
		],
		type: "TOWN",
		priceGroupId: "26",
		latitude: -34.45122,
		longitude: -71.004184,
		code: "467"
	},
	{
		politicalId: "aaa297c4-da24-4408-bf3a-baa24df53d6e",
		name: "REQUÍNOA",
		parentPoliticalId: "989d021a-9c74-4f86-951b-eb6329fa8c28",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"REQU",
			"ZL_REQUINOA",
			"60236",
			"6"
		],
		type: "DISTRICT",
		priceGroupId: "83",
		latitude: -34.283,
		longitude: -70.80583333333333,
		code: "123"
	},
	{
		politicalId: "a16b4944-1d1c-4416-8faf-49f12c2cd9e5",
		name: "ROSARIO",
		parentPoliticalId: "c86ce4e0-52d8-4927-826f-6adb48c6803b",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"ROSA",
			"60237",
			"ZL_RENGO",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.350316,
		longitude: -70.842618,
		code: "545"
	},
	{
		politicalId: "1d183cbc-4b6e-4abb-931f-48673828d410",
		name: "SALSIPUEDES",
		parentPoliticalId: "4bcd8a5d-6a2f-4e1e-b32d-225d9eaf0cc7",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60238",
			"MALO",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.399713,
		longitude: -70.961717,
		code: "107"
	},
	{
		politicalId: "b71b2c48-4e10-4978-8928-19a98ce3963b",
		name: "SAN FERNANDO",
		parentPoliticalId: "5c10434d-bb18-4567-8df0-b33fd6ffcf8a",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"SFER",
			"60310",
			"ZL_SAN_FERNANDO",
			"6"
		],
		type: "TOWN",
		priceGroupId: "731",
		latitude: -34.584,
		longitude: -70.98694444444445,
		code: "126"
	},
	{
		politicalId: "9cb2a4c3-ca14-4407-bc46-dfd327e19761",
		name: "SAN PEDRO DE ALCÁNTARA",
		parentPoliticalId: "9105b826-5ffc-4143-bb6b-711f4607c844",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60105",
			"PARE",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.767518,
		longitude: -71.836755,
		code: "112"
	},
	{
		politicalId: "d4608f1e-5d7f-4481-b86a-06bddb2d877f",
		name: "SAN RAFAEL",
		parentPoliticalId: "3e265ff3-0085-4030-9e71-d59a93074905",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60102",
			"PALM",
			"6"
		],
		type: "TOWN",
		priceGroupId: "716",
		latitude: -34.561982,
		longitude: -71.389674,
		code: "111"
	},
	{
		politicalId: "519bf5c1-5a4b-4a09-9f78-a156e1583b55",
		name: "SAN VICENTE",
		parentPoliticalId: "38215070-65a0-4938-83de-825ed83e730a",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60239",
			"SVIC",
			"ZL_SAN_VICENTE",
			"6"
		],
		type: "TOWN",
		priceGroupId: "26",
		latitude: -34.08300000000001,
		longitude: -71.75,
		code: "125"
	},
	{
		politicalId: "5c00cdd8-b417-4e65-993f-d2e126930308",
		name: "SANTA CRUZ",
		parentPoliticalId: "55e8d856-b48b-4d48-a2d4-98a003dbcfec",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"SCRU",
			"ZL_SANTA_CRUZ",
			"60306",
			"6"
		],
		type: "TOWN",
		priceGroupId: "716",
		latitude: -34.631,
		longitude: -71.35888888888888,
		code: "128"
	},
	{
		politicalId: "e102a9b3-ca0a-416a-9fab-25e8a699670e",
		name: "SEWELL",
		parentPoliticalId: "07b9b295-5122-428a-a6c3-3bb0b8429cad",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60240",
			"ZL_MACHALI",
			"MACH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.085431,
		longitude: -70.383756,
		code: "106"
	},
	{
		politicalId: "543a38fb-549e-404b-afd1-43853a1f22c2",
		name: "SIERRAS DE BELLAVISTA",
		parentPoliticalId: "5c10434d-bb18-4567-8df0-b33fd6ffcf8a",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60307",
			"SFER",
			"ZL_SAN_FERNANDO",
			"6"
		],
		type: "TOWN",
		priceGroupId: "731",
		latitude: -34.804361,
		longitude: -70.753726,
		code: "126"
	},
	{
		politicalId: "1dc9ea15-dbc9-40ae-9d36-f98c08998181",
		name: "TERMAS DE CAUQUENES",
		parentPoliticalId: "07b9b295-5122-428a-a6c3-3bb0b8429cad",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60201",
			"ZL_MACHALI",
			"MACH",
			"6"
		],
		type: "TOWN",
		priceGroupId: "83",
		latitude: -34.248859,
		longitude: -70.556117,
		code: "106"
	},
	{
		politicalId: "6b708f98-215b-4b16-b7dc-c8dc057b31d7",
		name: "TERMAS DEL FLACO",
		parentPoliticalId: "5c10434d-bb18-4567-8df0-b33fd6ffcf8a",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60308",
			"SFER",
			"ZL_SAN_FERNANDO",
			"6"
		],
		type: "TOWN",
		priceGroupId: "731",
		latitude: -34.958445,
		longitude: -70.436326,
		code: "126"
	},
	{
		politicalId: "3947c099-e8de-40c2-a453-4027dd9359fd",
		name: "TINGUIRIRICA",
		parentPoliticalId: "713e04ac-f4d5-4d15-b75a-714c57a19d90",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"ZL_CHIMBARONGO",
			"60302",
			"CHIM",
			"6"
		],
		type: "TOWN",
		priceGroupId: "731",
		latitude: -34.651993,
		longitude: -70.971039,
		code: "129"
	},
	{
		politicalId: "47bc4001-21ea-40bc-af0d-c52cf3373f10",
		name: "ZÚÑIGA",
		parentPoliticalId: "38215070-65a0-4938-83de-825ed83e730a",
		parentStateId: "1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70",
		parentStateName: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
		zones: [
			"60214",
			"SVIC",
			"ZL_SAN_VICENTE",
			"6"
		],
		type: "TOWN",
		priceGroupId: "26",
		latitude: -34.355577,
		longitude: -71.104852,
		code: "125"
	}
];
var libertador = {
	data: data$c
};

var data$d = [
	{
		politicalId: "ed156c60-e651-4334-beea-d9ffc80befeb",
		name: "ACHAO",
		parentPoliticalId: "0d23ae0d-dfd0-4bcf-869d-6da6dfb71271",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100110",
			"ACHA",
			"10"
		],
		type: "TOWN",
		priceGroupId: "13",
		latitude: -42.470447,
		longitude: -73.490225,
		code: "502"
	},
	{
		politicalId: "57466a2d-db4e-4569-ae66-67da75fb76e3",
		name: "ALERCE",
		parentPoliticalId: "c6a286f2-26d0-4042-96aa-3b00410783da",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100404",
			"PMON",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -41.398637,
		longitude: -72.916721,
		code: "507"
	},
	{
		politicalId: "9ef2339a-c0bb-47dd-b8e5-74ea7e09c4d0",
		name: "ANCUD",
		parentPoliticalId: "076685a6-d76b-4a79-a333-46265d358c2f",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"ANCU",
			"100109",
			"10"
		],
		type: "TOWN",
		priceGroupId: "13",
		latitude: -41.877,
		longitude: -73.81388889,
		code: "247"
	},
	{
		politicalId: "abbff24a-5a7e-43e6-9963-e7847c1bb9d2",
		name: "BAHÍA MANSA",
		parentPoliticalId: "4ccda78c-b057-46eb-9483-f69e358ad0e6",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100310",
			"SJCO",
			"10"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -40.584556,
		longitude: -73.731455,
		code: "288"
	},
	{
		politicalId: "f773b2ec-dc0f-499f-b35e-317fd078e098",
		name: "CALBUCO",
		parentPoliticalId: "5618c09e-3d26-4bed-8388-2c594a82d3a5",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100411",
			"CALB",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -41.758,
		longitude: -73.15083333,
		code: "248"
	},
	{
		politicalId: "350b4e5a-96df-4cbe-b260-8762608e640c",
		name: "CALETA CONDOR",
		parentPoliticalId: "4bef75c2-cdb5-401d-aa89-7545433b4add",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100313",
			"RNEG",
			"10"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -40.707999,
		longitude: -73.7913,
		code: "287"
	},
	{
		politicalId: "20a08f5c-1774-44ec-99e0-0526fb4affdb",
		name: "CALETA HULLELHUE",
		parentPoliticalId: "4bef75c2-cdb5-401d-aa89-7545433b4add",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100312",
			"RNEG",
			"10"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -40.693012,
		longitude: -73.793781,
		code: "287"
	},
	{
		politicalId: "3089853d-68de-4093-8fb4-3cbe830d96f3",
		name: "CASTRO",
		parentPoliticalId: "ff1c73e1-4953-491b-818b-e3558cabcfc7",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"CAST",
			"100111",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "13",
		latitude: -42.478,
		longitude: -73.77888889,
		code: "249"
	},
	{
		politicalId: "4a88a1cc-8112-43b7-bebe-2db0bc4fa445",
		name: "CHACAO",
		parentPoliticalId: "076685a6-d76b-4a79-a333-46265d358c2f",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100108",
			"ANCU",
			"10"
		],
		type: "TOWN",
		priceGroupId: "13",
		latitude: -41.827978,
		longitude: -73.526127,
		code: "501"
	},
	{
		politicalId: "b2b9ad80-b723-4a59-838e-31fe79a513fa",
		name: "CHAITÉN",
		parentPoliticalId: "5ddc5e57-2b54-45a9-9ae4-2e0afe7b724b",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"CHAI",
			"100205",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -42.899,
		longitude: -72.66694444,
		code: "250"
	},
	{
		politicalId: "681d5673-f5c3-4f35-8157-784e923d1c09",
		name: "CHAMIZA",
		parentPoliticalId: "c6a286f2-26d0-4042-96aa-3b00410783da",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100404",
			"PMON",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -41.483218,
		longitude: -72.843645,
		code: "508"
	},
	{
		politicalId: "b3b45559-5917-4e6e-a57d-03dee8a77a73",
		name: "CHONCHI",
		parentPoliticalId: "568de970-b807-4ed8-9812-1c86887bd602",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"CHON",
			"100107",
			"10"
		],
		type: "TOWN",
		priceGroupId: "13",
		latitude: -42.626,
		longitude: -73.78083333,
		code: "251"
	},
	{
		politicalId: "8ba8b810-463a-4fdf-ab1f-566de2f82e1f",
		name: "COCHAMÓ",
		parentPoliticalId: "8fecf7ec-d6c9-4171-9384-d9cf6cc88e42",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"CCHM",
			"100410",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "41",
		latitude: -41.5,
		longitude: -72.31694444,
		code: "252"
	},
	{
		politicalId: "b396ca2d-d87b-458e-bce1-c9741c302a9a",
		name: "CUCAO",
		parentPoliticalId: "568de970-b807-4ed8-9812-1c86887bd602",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"CHON",
			"100107",
			"10"
		],
		type: "TOWN",
		priceGroupId: "13",
		latitude: -42.637522,
		longitude: -74.110222,
		code: "504"
	},
	{
		politicalId: "d7cfb1c1-ef4e-41ef-92c6-218724428239",
		name: "CURACO DE VÉLEZ",
		parentPoliticalId: "ff1c73e1-4953-491b-818b-e3558cabcfc7",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"CUVE",
			"100106",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "13",
		latitude: -42.434,
		longitude: -73.58194444,
		code: "254"
	},
	{
		politicalId: "e7c4ebb2-3a3f-4b69-9629-047d15d261a8",
		name: "DALCAHUE",
		parentPoliticalId: "0aee0cae-fd70-4001-8a55-2818a321c69c",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100105",
			"DALC",
			"10"
		],
		type: "TOWN",
		priceGroupId: "13",
		latitude: -42.374,
		longitude: -73.65083333,
		code: "255"
	},
	{
		politicalId: "03eb69b2-ba63-4332-97cb-ac18fa267c3f",
		name: "ENSENADA",
		parentPoliticalId: "369ae6f9-018d-489c-9e6d-4c4f4eb0bfd5",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100409",
			"PVAR",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -41.212001,
		longitude: -72.545665,
		code: "506"
	},
	{
		politicalId: "6e5d1060-c7df-4ec1-a183-fafe20d2523e",
		name: "ENTRE LAGOS",
		parentPoliticalId: "ce22a10c-d25b-4b21-b8f0-31b19d11be53",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100302",
			"PUYG",
			"10"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -40.685852,
		longitude: -72.600454,
		code: "256"
	},
	{
		politicalId: "cabd51df-1370-46db-9d01-81b935dfbc51",
		name: "FRESIA",
		parentPoliticalId: "8fecf7ec-d6c9-4171-9384-d9cf6cc88e42",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"FRES",
			"100408",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "41",
		latitude: -41.153,
		longitude: -73.41694444,
		code: "257"
	},
	{
		politicalId: "19adacdb-8774-4d83-bcb7-7d080399fb43",
		name: "FRUTILLAR",
		parentPoliticalId: "8fecf7ec-d6c9-4171-9384-d9cf6cc88e42",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"FRUT",
			"100407",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "41",
		latitude: -41.117,
		longitude: -73.085,
		code: "258"
	},
	{
		politicalId: "d3a2ff90-80f5-4582-b96f-76a361778af3",
		name: "FUTALEUFÚ",
		parentPoliticalId: "6dc00dbd-9864-4ff7-80ad-eb65571ae4d8",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100204",
			"FUTA",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "41",
		latitude: -43.168,
		longitude: -71.84777778,
		code: "260"
	},
	{
		politicalId: "e5740bf3-be43-4704-825f-8af1311fecbd",
		name: "HORNOPIRÉN",
		parentPoliticalId: "079fb8cf-ff36-4f77-875b-32132e280195",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100203",
			"HULA",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -41.966107,
		longitude: -72.47122,
		code: "262"
	},
	{
		politicalId: "a34d2764-e6a3-4327-8998-edd6b73cfb42",
		name: "HUALAIHUÉ",
		parentPoliticalId: "079fb8cf-ff36-4f77-875b-32132e280195",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"HULA",
			"100202",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -41.992,
		longitude: -72.66694444,
		code: "262"
	},
	{
		politicalId: "96f45153-614e-4de0-b516-7b27b1811142",
		name: "LLANQUIHUE",
		parentPoliticalId: "8fecf7ec-d6c9-4171-9384-d9cf6cc88e42",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100406",
			"LLAN",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "41",
		latitude: -41.266,
		longitude: -73.01194444,
		code: "266"
	},
	{
		politicalId: "f58c1d5a-02be-46ba-aaae-91cc0c72e2b2",
		name: "LOS MUERMOS",
		parentPoliticalId: "8fecf7ec-d6c9-4171-9384-d9cf6cc88e42",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"LMUE",
			"100405",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "41",
		latitude: -41.391,
		longitude: -73.45138889,
		code: "268"
	},
	{
		politicalId: "6895ccda-ab4b-4213-8483-57cca8d85e94",
		name: "MAICOLPUE",
		parentPoliticalId: "4ccda78c-b057-46eb-9483-f69e358ad0e6",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100307",
			"SJCO",
			"10"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -40.819908,
		longitude: -73.339111,
		code: "288"
	},
	{
		politicalId: "21703ede-8382-4c1b-ac02-7761c7692ede",
		name: "MAULLÍN",
		parentPoliticalId: "8fecf7ec-d6c9-4171-9384-d9cf6cc88e42",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"MAUL",
			"100401",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "41",
		latitude: -41.618,
		longitude: -73.59777778,
		code: "271"
	},
	{
		politicalId: "3a010c5c-c203-4a0c-88c9-6fd70d78d389",
		name: "NUEVA BRAUNAU",
		parentPoliticalId: "369ae6f9-018d-489c-9e6d-4c4f4eb0bfd5",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"PVAR",
			"100403",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -41.32564,
		longitude: -73.081787,
		code: "503"
	},
	{
		politicalId: "f98fcb41-cf4e-40f6-8421-632901ba1448",
		name: "OSORNO",
		parentPoliticalId: "5f2808e6-c494-4465-ab81-61f0bea77daf",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"OSOR",
			"100308",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "7",
		latitude: -40.574,
		longitude: -73.12583333,
		code: "272"
	},
	{
		politicalId: "6d99e895-61c2-4f51-97a1-6be3f57acd1b",
		name: "PALENA",
		parentPoliticalId: "6dc00dbd-9864-4ff7-80ad-eb65571ae4d8",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100206",
			"PALE",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "41",
		latitude: -43.623,
		longitude: -71.80388889,
		code: "274"
	},
	{
		politicalId: "79107918-8c18-428f-b21b-e3621d453bdd",
		name: "PARGUA",
		parentPoliticalId: "5618c09e-3d26-4bed-8388-2c594a82d3a5",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"PARG",
			"100411",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -41.792123,
		longitude: -73.464233,
		code: "505"
	},
	{
		politicalId: "74a507a3-95f7-46a7-83f7-c44010b7d264",
		name: "PUAUCHO",
		parentPoliticalId: "4ccda78c-b057-46eb-9483-f69e358ad0e6",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"SJCO",
			"100305",
			"10"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -40.501,
		longitude: -73.39194444,
		code: "288"
	},
	{
		politicalId: "1eeb6d0c-000d-48f4-b274-c1a25bad8bd6",
		name: "PUCATRIHUE",
		parentPoliticalId: "4ccda78c-b057-46eb-9483-f69e358ad0e6",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100311",
			"SJCO",
			"10"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -40.535985,
		longitude: -73.708862,
		code: "288"
	},
	{
		politicalId: "d115c92a-d7c2-4020-8663-449021b3a7ad",
		name: "PUERTO MONTT",
		parentPoliticalId: "c6a286f2-26d0-4042-96aa-3b00410783da",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100404",
			"PMON",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -41.454,
		longitude: -72.99277778,
		code: "276"
	},
	{
		politicalId: "51674a17-2457-48cf-9ee0-63a023b0751a",
		name: "PUERTO OCTAY",
		parentPoliticalId: "5f2808e6-c494-4465-ab81-61f0bea77daf",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100501",
			"POCT",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "7",
		latitude: -40.967,
		longitude: -72.9,
		code: "277"
	},
	{
		politicalId: "51c1bbea-bc5e-41be-bc6d-a446f7609f05",
		name: "PUERTO VARAS",
		parentPoliticalId: "369ae6f9-018d-489c-9e6d-4c4f4eb0bfd5",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"PVAR",
			"100403",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -41.323,
		longitude: -72.96694444,
		code: "278"
	},
	{
		politicalId: "d0879f81-3c1a-4cb3-a9c2-5c89f701b390",
		name: "PUQUELDÓN",
		parentPoliticalId: "ff1c73e1-4953-491b-818b-e3558cabcfc7",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"PUQU",
			"100104",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "13",
		latitude: -42.604,
		longitude: -73.68388889,
		code: "400"
	},
	{
		politicalId: "edb221da-187d-4205-aaa6-73bc229263f7",
		name: "PURRANQUE",
		parentPoliticalId: "5f2808e6-c494-4465-ab81-61f0bea77daf",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100301",
			"PURR",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "7",
		latitude: -40.909,
		longitude: -73.1675,
		code: "279"
	},
	{
		politicalId: "ce22a10c-d25b-4b21-b8f0-31b19d11be53",
		name: "PUYEHUE",
		parentPoliticalId: "5f2808e6-c494-4465-ab81-61f0bea77daf",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100302",
			"PUYG",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "7",
		latitude: -40.717,
		longitude: -72.32083333,
		code: "280"
	},
	{
		politicalId: "27e5c5fa-9e43-4c2b-a16d-5da453e82641",
		name: "QUEILÉN",
		parentPoliticalId: "ff1c73e1-4953-491b-818b-e3558cabcfc7",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100103",
			"QUEI",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "13",
		latitude: -42.874,
		longitude: -73.46694444,
		code: "281"
	},
	{
		politicalId: "c1f9c1c3-6e0b-414a-9bb9-d5a79a5a0132",
		name: "QUELLÓN",
		parentPoliticalId: "ff1c73e1-4953-491b-818b-e3558cabcfc7",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100102",
			"QUEL",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "13",
		latitude: -43.121,
		longitude: -73.60777778,
		code: "283"
	},
	{
		politicalId: "e79c16b7-ba2e-4e31-9707-1d4b1f7c8336",
		name: "QUEMCHI",
		parentPoliticalId: "ff1c73e1-4953-491b-818b-e3558cabcfc7",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100101",
			"QUEM",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "13",
		latitude: -42.142,
		longitude: -73.47777778,
		code: "284"
	},
	{
		politicalId: "83e6cf08-8fb0-44f5-a2b7-bed7ffc963c3",
		name: "QUINCHAO",
		parentPoliticalId: "0d23ae0d-dfd0-4bcf-869d-6da6dfb71271",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100113",
			"ACHA",
			"10"
		],
		type: "TOWN",
		priceGroupId: "13",
		latitude: -42.479,
		longitude: -73.49694444,
		code: "285"
	},
	{
		politicalId: "206b7399-117e-4645-bd13-f3949ab2fbbe",
		name: "QUIQUEL",
		parentPoliticalId: "0aee0cae-fd70-4001-8a55-2818a321c69c",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100112",
			"DALC",
			"10"
		],
		type: "TOWN",
		priceGroupId: "13",
		latitude: -42.355069,
		longitude: -73.579694,
		code: "255"
	},
	{
		politicalId: "4d314567-570f-455b-9ec9-454da535fc7c",
		name: "RIACHUELO",
		parentPoliticalId: "4bef75c2-cdb5-401d-aa89-7545433b4add",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100304",
			"RNEG",
			"10"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -40.819908,
		longitude: -73.339111,
		code: "287"
	},
	{
		politicalId: "c75dd2c4-ce6d-44f8-a27a-7cb6719284ef",
		name: "RÍO NEGRO",
		parentPoliticalId: "4bef75c2-cdb5-401d-aa89-7545433b4add",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"RNEG",
			"100309",
			"10"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -41.967,
		longitude: -72.45,
		code: "287"
	},
	{
		politicalId: "4ccda78c-b057-46eb-9483-f69e358ad0e6",
		name: "SAN JUAN DE LA COSTA",
		parentPoliticalId: "5f2808e6-c494-4465-ab81-61f0bea77daf",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"SJCO",
			"100305",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "7",
		latitude: -40.501,
		longitude: -73.39194444,
		code: "288"
	},
	{
		politicalId: "74cdacc3-bfb4-4d6a-b1c2-c77c4f833acb",
		name: "SAN PABLO",
		parentPoliticalId: "5f2808e6-c494-4465-ab81-61f0bea77daf",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"SPAB",
			"100306",
			"10"
		],
		type: "DISTRICT",
		priceGroupId: "7",
		latitude: -40.4,
		longitude: -73.01694444,
		code: "290"
	},
	{
		politicalId: "5d9d6be2-a303-416b-89c9-bb3ad3626861",
		name: "VILLA SANTA LUCIA",
		parentPoliticalId: "5ddc5e57-2b54-45a9-9ae4-2e0afe7b724b",
		parentStateId: "5e89ced2-fde6-465e-8d25-527d83acb41d",
		parentStateName: "LOS LAGOS",
		zones: [
			"100201",
			"CHAI",
			"10"
		],
		type: "TOWN",
		priceGroupId: "41",
		latitude: -43.4135,
		longitude: -72.367226,
		code: "250"
	}
];
var losLagos = {
	data: data$d
};

var data$e = [
	{
		politicalId: "698d64fe-908b-4fa8-a3e8-6b9f892dbe3f",
		name: "ANTILHUE",
		parentPoliticalId: "c4bd0600-fd1f-4254-9f44-cd6b1fdf6df3",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"LLAG",
			"140217",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.806467,
		longitude: -72.958524,
		code: "528"
	},
	{
		politicalId: "a84fd752-758a-49b1-b820-073c936f972d",
		name: "CALETA HUELLELHUE",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"RNEG",
			"140209",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.791093,
		longitude: -73.12306,
		code: "509"
	},
	{
		politicalId: "8d2f3e3b-253f-40c0-957e-139b88fcb1a7",
		name: "CAYUMAPU",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140209",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.722679,
		longitude: -73.107962,
		code: "529"
	},
	{
		politicalId: "95ea21ee-edd1-428a-8ce1-b26aee96cea9",
		name: "CHAIHUIN",
		parentPoliticalId: "147665cf-5704-4a8f-8627-f28914ebf4f4",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140211",
			"CORR",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.953753,
		longitude: -73.581031,
		code: "253"
	},
	{
		politicalId: "71c8f81a-e594-42dd-9038-800ffc103bdb",
		name: "CHOSHUENCO",
		parentPoliticalId: "09b35935-cfa9-4f63-ac65-0f1d99a7cbf9",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140215",
			"PANG",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.836189,
		longitude: -72.081116,
		code: "526"
	},
	{
		politicalId: "ec54c6f5-b352-4d12-bced-b5bca908eeed",
		name: "CIRUELOS",
		parentPoliticalId: "c4bd0600-fd1f-4254-9f44-cd6b1fdf6df3",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"PICH",
			"140217",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.802329,
		longitude: -72.729554,
		code: "516"
	},
	{
		politicalId: "ba563c2e-a867-4968-bdc7-ea9754cec340",
		name: "COÑARIPE",
		parentPoliticalId: "09b35935-cfa9-4f63-ac65-0f1d99a7cbf9",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140212",
			"PANG",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.571634,
		longitude: -72.004502,
		code: "525"
	},
	{
		politicalId: "448ee1e1-762d-46ea-85d1-751bd7c2a6e5",
		name: "CORRAL",
		parentPoliticalId: "147665cf-5704-4a8f-8627-f28914ebf4f4",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"CORR",
			"140213",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.867,
		longitude: -73.43277778,
		code: "253"
	},
	{
		politicalId: "55f77bbd-bfc6-4559-81a3-15d0f0a3422d",
		name: "CURIÑANCO",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140209",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.735922,
		longitude: -73.393482,
		code: "517"
	},
	{
		politicalId: "a97a7000-cfcf-4870-8d0a-41e9ac3bd1de",
		name: "FUTRONO",
		parentPoliticalId: "f51255cf-1c2e-48d7-9e8d-61467106ee24",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"FUTR",
			"140102",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -40.131,
		longitude: -72.39583333,
		code: "261"
	},
	{
		politicalId: "e41b4a6a-534d-49c5-83c4-4de4fb53216c",
		name: "LA UNIÓN",
		parentPoliticalId: "25d2e7f6-8d02-4105-a08c-0c2e63be335c",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140103",
			"LAUN",
			"14"
		],
		type: "DISTRICT",
		priceGroupId: "7",
		latitude: -40.292,
		longitude: -73.08777778,
		code: "263"
	},
	{
		politicalId: "a342caaa-ba61-45aa-a13c-bd7f9467b50c",
		name: "LAGO RANCO",
		parentPoliticalId: "84efa050-afbb-43fa-ad1e-9c5f625872ec",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"LRAN",
			"140104",
			"14"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -40.317,
		longitude: -72.5,
		code: "264"
	},
	{
		politicalId: "09944c0c-0653-44e8-844a-638f47a4d0da",
		name: "LANCO",
		parentPoliticalId: "fe6f7012-badc-48a3-a897-7b913a828542",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"LANC",
			"140214",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.447,
		longitude: -72.77194444,
		code: "265"
	},
	{
		politicalId: "7126bed8-afb1-4d81-992a-f4f1c6c3743f",
		name: "LIQUIÑE",
		parentPoliticalId: "09b35935-cfa9-4f63-ac65-0f1d99a7cbf9",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140215",
			"PANG",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.743664,
		longitude: -71.85436,
		code: "275"
	},
	{
		politicalId: "ecb3c5d0-ada8-4974-b9f5-59c4892ae47d",
		name: "LLIFEN",
		parentPoliticalId: "f51255cf-1c2e-48d7-9e8d-61467106ee24",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"FUTR",
			"140102",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -40.199467,
		longitude: -72.260317,
		code: "519"
	},
	{
		politicalId: "7d82fb69-518e-4daa-afa9-3dd67bc99e78",
		name: "LOS LAGOS",
		parentPoliticalId: "c4bd0600-fd1f-4254-9f44-cd6b1fdf6df3",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"LLAG",
			"140217",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -41.92,
		longitude: -72.14194444,
		code: "267"
	},
	{
		politicalId: "9c996e00-eaf8-4c47-be15-e4fa28fdb4c5",
		name: "LOS MOLINOS",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140209",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.846918,
		longitude: -73.392703,
		code: "510"
	},
	{
		politicalId: "a28d878e-7b90-4af5-8e57-5c3f73873bda",
		name: "MÁFIL",
		parentPoliticalId: "2eb4ecfe-0aef-4b55-8048-3ded666f9503",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140216",
			"MAFI",
			"14"
		],
		type: "DISTRICT",
		priceGroupId: "19",
		latitude: -39.65,
		longitude: -72.95,
		code: "269"
	},
	{
		politicalId: "c8a832f4-c14c-4aa6-a331-4c20c40370fa",
		name: "MALALHUE",
		parentPoliticalId: "fe6f7012-badc-48a3-a897-7b913a828542",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"LANC",
			"140214",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.541455,
		longitude: -72.506476,
		code: "523"
	},
	{
		politicalId: "85702426-019c-4af7-a86e-2365c544ee0c",
		name: "MARIQUINA",
		parentPoliticalId: "b7a3e2de-add7-445c-bc77-59a984af6cf8",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"MRQN",
			"140201",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.538943,
		longitude: -72.962937,
		code: "270"
	},
	{
		politicalId: "7497e953-7aa5-49b5-ac32-436c2806ebed",
		name: "MELEFQUEN",
		parentPoliticalId: "09b35935-cfa9-4f63-ac65-0f1d99a7cbf9",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140204",
			"PANG",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.58181,
		longitude: -72.442467,
		code: "524"
	},
	{
		politicalId: "f9bdfec6-255b-4a61-b92a-c7c0694d8448",
		name: "NELTUME",
		parentPoliticalId: "09b35935-cfa9-4f63-ac65-0f1d99a7cbf9",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140215",
			"PANG",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.848667,
		longitude: -71.93929,
		code: "527"
	},
	{
		politicalId: "8e8f7558-4e5d-4a0b-aa65-e9b1396cf324",
		name: "NIEBLA",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140202",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.868707,
		longitude: -73.397552,
		code: "450"
	},
	{
		politicalId: "5e376e09-d781-453d-86cd-0b8cceccc9b3",
		name: "PAILLACO",
		parentPoliticalId: "a5479910-7273-42b2-83cd-11ced1c1d386",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140203",
			"PAIL",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -40.068,
		longitude: -72.88277778,
		code: "273"
	},
	{
		politicalId: "dcb9e0df-a6a8-4fa4-a1b0-f8695021bc03",
		name: "PANGUIPULLI",
		parentPoliticalId: "09b35935-cfa9-4f63-ac65-0f1d99a7cbf9",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140204",
			"PANG",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.642,
		longitude: -72.33388889,
		code: "275"
	},
	{
		politicalId: "209aaf9c-aa36-4506-93b6-3b712afbeac0",
		name: "PELCHUQUIN",
		parentPoliticalId: "b7a3e2de-add7-445c-bc77-59a984af6cf8",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140205",
			"MRQN",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.62462,
		longitude: -73.077591,
		code: "270"
	},
	{
		politicalId: "66af20ef-7e45-43d8-a4fe-b01dbcdabfaf",
		name: "PICHIRROPULLI",
		parentPoliticalId: "a5479910-7273-42b2-83cd-11ced1c1d386",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140203",
			"PAIL",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -40.150458,
		longitude: -72.897897,
		code: "518"
	},
	{
		politicalId: "61df2f7b-b5d6-4e88-af47-64ee0f1b871b",
		name: "PICHOY",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140209",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.707586,
		longitude: -73.13667,
		code: "511"
	},
	{
		politicalId: "a016d7f4-2291-4910-a48e-569cb8133d09",
		name: "PILOLCURA",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140210",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.673064,
		longitude: -73.350013,
		code: "291"
	},
	{
		politicalId: "948fd780-a8a9-4b4b-a51a-3ddf400fd4f7",
		name: "PISHUINCO",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140209",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.80657,
		longitude: -73.055881,
		code: "512"
	},
	{
		politicalId: "6983ac58-f4d9-4bad-bf74-1a30dba0798f",
		name: "PLAYA ROSADA",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140202",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.870223,
		longitude: -73.394848,
		code: "515"
	},
	{
		politicalId: "22bd7bc0-49a5-49c2-9a13-78819de641d2",
		name: "PULLINQUE",
		parentPoliticalId: "09b35935-cfa9-4f63-ac65-0f1d99a7cbf9",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140204",
			"PANG",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.596099,
		longitude: -72.223825,
		code: "525"
	},
	{
		politicalId: "5414fa42-777a-460a-b3a3-27c2e52eda6e",
		name: "PUNUCAPA",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140206",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.756582,
		longitude: -73.265776,
		code: "291"
	},
	{
		politicalId: "deb4e535-d186-4bf0-9eac-a90c4d2dca13",
		name: "RIÑIHUE",
		parentPoliticalId: "c4bd0600-fd1f-4254-9f44-cd6b1fdf6df3",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"LLAG",
			"140217",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.821408,
		longitude: -72.44233,
		code: "522"
	},
	{
		politicalId: "b27b154d-f152-4969-b86d-a77ceea09f4c",
		name: "RIÑINAHUE",
		parentPoliticalId: "84efa050-afbb-43fa-ad1e-9c5f625872ec",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140101",
			"LRAN",
			"14"
		],
		type: "TOWN",
		priceGroupId: "7",
		latitude: -40.320488,
		longitude: -72.210787,
		code: "264"
	},
	{
		politicalId: "870da9d9-3bec-4694-b9af-1e56464a64d4",
		name: "RÍO BUENO",
		parentPoliticalId: "25d2e7f6-8d02-4105-a08c-0c2e63be335c",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"RIOB",
			"140207",
			"14"
		],
		type: "DISTRICT",
		priceGroupId: "7",
		latitude: -40.338,
		longitude: -72.95694444,
		code: "286"
	},
	{
		politicalId: "0d0479b8-e21b-40c9-8643-0462acb0baac",
		name: "TOROBAYO",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140208",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.834113,
		longitude: -73.268759,
		code: "291"
	},
	{
		politicalId: "8daf6c8c-e9e0-463b-8734-ca803522652f",
		name: "VALDIVIA",
		parentPoliticalId: "655ecadd-2284-4bea-9ef1-5550cbc7f4f0",
		parentStateId: "f8351488-0741-4c3f-a455-5008a7f81e57",
		parentStateName: "LOS RÍOS",
		zones: [
			"140209",
			"VALD",
			"14"
		],
		type: "TOWN",
		priceGroupId: "19",
		latitude: -39.8,
		longitude: -73.23277778,
		code: "291"
	}
];
var losRios = {
	data: data$e
};

var data$f = [
	{
		politicalId: "9849aa1f-fc54-4e5c-80a2-32c967f6726f",
		name: "ANTÁRTICA",
		parentPoliticalId: "1913d956-99f2-452a-b57c-14f35fded20c",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"ANTA",
			"120305",
			"12"
		],
		type: "DISTRICT",
		priceGroupId: "24",
		latitude: -75,
		longitude: -71.5,
		code: "303"
	},
	{
		politicalId: "2f8c0f18-51a6-41df-96f2-105e5104a2b3",
		name: "CABO DE HORNOS",
		parentPoliticalId: "1913d956-99f2-452a-b57c-14f35fded20c",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120304",
			"CAHO",
			"12"
		],
		type: "DISTRICT",
		priceGroupId: "24",
		latitude: -54.947,
		longitude: -67.60694444,
		code: "309"
	},
	{
		politicalId: "73506737-368c-4d7b-88c1-3c6a906f0ee2",
		name: "CERRO SOMBRERO",
		parentPoliticalId: "cece74d3-25b9-4c94-85c8-2bbd7c874ad1",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120102",
			"PRIM",
			"12"
		],
		type: "TOWN",
		priceGroupId: "24",
		latitude: -52.772685,
		longitude: -69.288322,
		code: "307"
	},
	{
		politicalId: "e5007789-5248-4cb7-865b-ad206ba36acb",
		name: "LAGUNA BLANCA",
		parentPoliticalId: "c47a4824-87f1-4e70-8e70-6c43166def1c",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120404",
			"LABL",
			"12"
		],
		type: "DISTRICT",
		priceGroupId: "24",
		latitude: -52.267,
		longitude: -71.18277778,
		code: "304"
	},
	{
		politicalId: "8d33d034-d5bb-4b95-b7ac-ba9cb8169621",
		name: "NATALES",
		parentPoliticalId: "dfd0d284-9dcf-45dd-8043-7fab668f2ca7",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"PNAT",
			"120205",
			"12"
		],
		type: "DISTRICT",
		priceGroupId: "24",
		latitude: -51.733,
		longitude: -72.51694444,
		code: "308"
	},
	{
		politicalId: "a0039aa2-3e4e-49cf-b424-a955aae2f556",
		name: "PORVENIR",
		parentPoliticalId: "d9481daa-244a-49bf-ace8-25ecc9070a63",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"PORV",
			"120105",
			"12"
		],
		type: "DISTRICT",
		priceGroupId: "24",
		latitude: -53.298,
		longitude: -70.385,
		code: "306"
	},
	{
		politicalId: "cece74d3-25b9-4c94-85c8-2bbd7c874ad1",
		name: "PRIMAVERA",
		parentPoliticalId: "d9481daa-244a-49bf-ace8-25ecc9070a63",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120104",
			"PRIM",
			"12"
		],
		type: "DISTRICT",
		priceGroupId: "24",
		latitude: -52.886,
		longitude: -69.35277778,
		code: "307"
	},
	{
		politicalId: "f5074cd2-ac03-4901-9518-bba2d8f8f29e",
		name: "PUERTO EDEN",
		parentPoliticalId: "8d33d034-d5bb-4b95-b7ac-ba9cb8169621",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120204",
			"PNAT",
			"12"
		],
		type: "TOWN",
		priceGroupId: "24",
		latitude: -49.126222,
		longitude: -74.414245,
		code: "308"
	},
	{
		politicalId: "872f5278-c42c-4829-b43d-3afaec470fb6",
		name: "PUERTO NATALES",
		parentPoliticalId: "8d33d034-d5bb-4b95-b7ac-ba9cb8169621",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120203",
			"PNAT",
			"12"
		],
		type: "TOWN",
		priceGroupId: "24",
		latitude: -51.727758,
		longitude: -72.502395,
		code: "308"
	},
	{
		politicalId: "15dee7e3-425a-41e6-b7b1-eec354d562ae",
		name: "PUERTO NAVARINO",
		parentPoliticalId: "2f8c0f18-51a6-41df-96f2-105e5104a2b3",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120405",
			"CAHO",
			"12"
		],
		type: "TOWN",
		priceGroupId: "24",
		latitude: -54.925849,
		longitude: -68.322646,
		code: "309"
	},
	{
		politicalId: "83f155c9-0f86-49b9-be84-c44929ee8ec1",
		name: "PUERTO TORO",
		parentPoliticalId: "2f8c0f18-51a6-41df-96f2-105e5104a2b3",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120303",
			"CAHO",
			"12"
		],
		type: "TOWN",
		priceGroupId: "24",
		latitude: -55.083093,
		longitude: -67.075816,
		code: "309"
	},
	{
		politicalId: "8d95f61e-eaee-4363-88a9-65eb68b9f74f",
		name: "PUERTO WILLIAMS",
		parentPoliticalId: "2f8c0f18-51a6-41df-96f2-105e5104a2b3",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120302",
			"CAHO",
			"12"
		],
		type: "TOWN",
		priceGroupId: "24",
		latitude: -54.935634,
		longitude: -67.610606,
		code: "309"
	},
	{
		politicalId: "e2bb2856-bcea-4961-898d-5eb4ad1466d1",
		name: "PUNTA ARENAS",
		parentPoliticalId: "c47a4824-87f1-4e70-8e70-6c43166def1c",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"PUNT",
			"120403",
			"12"
		],
		type: "DISTRICT",
		priceGroupId: "24",
		latitude: -53.148,
		longitude: -70.90694444,
		code: "310"
	},
	{
		politicalId: "60a65610-813d-4a98-abae-f4bd338cfa8c",
		name: "RÍO VERDE",
		parentPoliticalId: "c47a4824-87f1-4e70-8e70-6c43166def1c",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120402",
			"RVER",
			"12"
		],
		type: "DISTRICT",
		priceGroupId: "24",
		latitude: -52.628,
		longitude: -71.47694444,
		code: "311"
	},
	{
		politicalId: "c4e7ba29-a0d1-425b-979e-04996ef4a318",
		name: "TIMAUKEL",
		parentPoliticalId: "d9481daa-244a-49bf-ace8-25ecc9070a63",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120103",
			"TMKL",
			"12"
		],
		type: "DISTRICT",
		priceGroupId: "24",
		latitude: -53.672,
		longitude: -69.70083333,
		code: "313"
	},
	{
		politicalId: "6c9a701c-2f42-49a9-b2a2-e16a0953eab6",
		name: "TORRES DEL PAINE",
		parentPoliticalId: "dfd0d284-9dcf-45dd-8043-7fab668f2ca7",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"TPAI",
			"120202",
			"12"
		],
		type: "DISTRICT",
		priceGroupId: "24",
		latitude: -50.982,
		longitude: -72.49888889,
		code: "312"
	},
	{
		politicalId: "51573984-8f1e-4dff-bcb4-5d8cde352314",
		name: "VILLA CAMERON",
		parentPoliticalId: "c4e7ba29-a0d1-425b-979e-04996ef4a318",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120101",
			"TMKL",
			"12"
		],
		type: "TOWN",
		priceGroupId: "24",
		latitude: -53.639943,
		longitude: -69.646654,
		code: "313"
	},
	{
		politicalId: "4803bdcf-f7de-4af9-bbf9-b95dc4d378ad",
		name: "VILLA CERRO CASTILLO",
		parentPoliticalId: "6c9a701c-2f42-49a9-b2a2-e16a0953eab6",
		parentStateId: "26a00517-eb4e-46ea-bf0d-438d7f075863",
		parentStateName: "MAGALLANES Y DE LA ANTÁRTICA CHILENA",
		zones: [
			"120201",
			"TPAI",
			"12"
		],
		type: "TOWN",
		priceGroupId: "24",
		latitude: -51.256875,
		longitude: -72.344119,
		code: "312"
	}
];
var magallanes = {
	data: data$f
};

var data$g = [
	{
		politicalId: "a1e82da7-770a-49e4-bf8d-d652e46610c3",
		name: "BOBADILLA",
		parentPoliticalId: "99c219e0-db22-45ee-930f-48bc372c6c5a",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70308",
			"ZL_SAN_JAVIER",
			"SJAV",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.567958,
		longitude: -71.697915,
		code: "152"
	},
	{
		politicalId: "3c027b14-96ae-4153-b57c-3dbd63f3cf40",
		name: "CALIBORO",
		parentPoliticalId: "99c219e0-db22-45ee-930f-48bc372c6c5a",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70311",
			"ZL_SAN_JAVIER",
			"SJAV",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.824884,
		longitude: -71.900152,
		code: "152"
	},
	{
		politicalId: "200d0e81-d6dc-4446-8aed-d74a15acbb57",
		name: "CAUQUENES",
		parentPoliticalId: "957b0028-2409-41cc-a034-7149b14a639b",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"CAUQ",
			"ZL_CAUQUENES",
			"70109",
			"7"
		],
		type: "TOWN",
		priceGroupId: "68",
		latitude: -35.96400000000001,
		longitude: -72.31694444444445,
		code: "130"
	},
	{
		politicalId: "785f66a8-549a-4cd1-b522-b63879c14bae",
		name: "CHANCO",
		parentPoliticalId: "996863bb-60d2-4679-9d5d-23cb34f67466",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"CHNC",
			"70108",
			"7"
		],
		type: "TOWN",
		priceGroupId: "68",
		latitude: -35.729,
		longitude: -72.51777778,
		code: "131"
	},
	{
		politicalId: "e34d450a-c55a-495d-8a20-2a49f4949754",
		name: "CHOVELLEN",
		parentPoliticalId: "3cc032a8-624d-47ef-9fd0-f064a40b385b",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70107",
			"PELL",
			"7"
		],
		type: "TOWN",
		priceGroupId: "68",
		latitude: -35.907539,
		longitude: -72.660133,
		code: "145"
	},
	{
		politicalId: "8337df22-9af5-464d-a1bf-d777109b011e",
		name: "COLBÚN",
		parentPoliticalId: "234a2ca5-bc8b-4ea3-b9de-e281a11c7058",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70312",
			"COLB",
			"7"
		],
		type: "TOWN",
		priceGroupId: "55",
		latitude: -35.7,
		longitude: -71.41694444,
		code: "132"
	},
	{
		politicalId: "e121b7f3-05f0-422b-98ca-3ed934c9e197",
		name: "CONSTITUCIÓN",
		parentPoliticalId: "d0f75c64-b162-433c-b970-e0d803ab7535",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"ZL_CONSTITUCION",
			"70411",
			"CONS",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.33900000000001,
		longitude: -72.41388888888889,
		code: "133"
	},
	{
		politicalId: "56514ee2-f950-406b-803b-6a4f3e6042ab",
		name: "CUMPEO",
		parentPoliticalId: "8fbbfcb7-43ec-484c-8264-3fa98b52e5bb",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"CUMP",
			"RCLA",
			"70405",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.279476,
		longitude: -71.257286,
		code: "422"
	},
	{
		politicalId: "caf803b9-c249-478e-91bf-ea19d2821996",
		name: "CURANIPE",
		parentPoliticalId: "3cc032a8-624d-47ef-9fd0-f064a40b385b",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70106",
			"PELL",
			"7"
		],
		type: "TOWN",
		priceGroupId: "68",
		latitude: -35.846964,
		longitude: -72.6372,
		code: "539"
	},
	{
		politicalId: "26616945-570c-44d6-a5e5-048d80bcbf71",
		name: "CUREPTO",
		parentPoliticalId: "7c657f5b-c29b-4648-88ef-8735a9f7eb1e",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70412",
			"CURE",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.083,
		longitude: -72.01694444,
		code: "134"
	},
	{
		politicalId: "1854532a-0600-4220-9ffb-b6026f458b07",
		name: "CURICÓ",
		parentPoliticalId: "85ede188-6ab3-4603-90c4-f8e6e905844c",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70203",
			"ZL_CURICO",
			"CURI",
			"7"
		],
		type: "TOWN",
		priceGroupId: "35",
		latitude: -34.976,
		longitude: -71.2238888888889,
		code: "135"
	},
	{
		politicalId: "1a4bae7b-1ca7-427a-b42f-eb85cb7aa9f6",
		name: "EMPEDRADO",
		parentPoliticalId: "8d30eea5-2176-4c5a-a836-2c54497c6c46",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"EMPE",
			"70413",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "43",
		latitude: -35.591,
		longitude: -72.27277778,
		code: "136"
	},
	{
		politicalId: "3ab3516c-27b2-402e-bf92-359d7d46ca6b",
		name: "GUALLECO",
		parentPoliticalId: "7c657f5b-c29b-4648-88ef-8735a9f7eb1e",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70410",
			"CURE",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.246847,
		longitude: -71.984218,
		code: "134"
	},
	{
		politicalId: "6c33f373-6d65-4307-8366-0d55a02eea76",
		name: "HUALAÑÉ",
		parentPoliticalId: "cebb4bb8-ac2e-4913-9ed6-b7fb7a9649eb",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70202",
			"HUAL",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "35",
		latitude: -34.983,
		longitude: -71.81694444,
		code: "137"
	},
	{
		politicalId: "531b291d-221f-4f51-a5b7-9d13fddba630",
		name: "HUERTA DE MAULE",
		parentPoliticalId: "99c219e0-db22-45ee-930f-48bc372c6c5a",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70316",
			"ZL_SAN_JAVIER",
			"SJAV",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.662099,
		longitude: -71.945717,
		code: "152"
	},
	{
		politicalId: "c38cef45-4fe7-4cf4-8aba-817ef1118f51",
		name: "LICANTÉN",
		parentPoliticalId: "27b5d288-d738-4172-b1cb-1066847b9360",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70201",
			"LICA",
			"7"
		],
		type: "TOWN",
		priceGroupId: "35",
		latitude: -34.983,
		longitude: -72,
		code: "138"
	},
	{
		politicalId: "13d20da1-f0a7-4860-979b-c0fee8033c71",
		name: "LINARES",
		parentPoliticalId: "c6f27aa1-07b9-4099-a665-12deb6d2cc79",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"ZL_LINARES",
			"70314",
			"LINA",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "55",
		latitude: -35.85,
		longitude: -71.585,
		code: "139"
	},
	{
		politicalId: "c47f6d18-2d3a-4f12-a84a-e7a2a7fbd4cb",
		name: "LONGAVÍ",
		parentPoliticalId: "c6f27aa1-07b9-4099-a665-12deb6d2cc79",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"LONG",
			"70315",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "55",
		latitude: -35.966,
		longitude: -71.68194444,
		code: "105"
	},
	{
		politicalId: "57d07f0b-d2b7-4258-b44d-bf445b8e8ff7",
		name: "LONTUE",
		parentPoliticalId: "56f552ad-1dbf-4276-b3c0-5e86cf10797f",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"LONT",
			"70212",
			"ZL_MOLINA",
			"7"
		],
		type: "TOWN",
		priceGroupId: "35",
		latitude: -35.056567,
		longitude: -71.269913,
		code: "140"
	},
	{
		politicalId: "23d88488-2bd5-489d-845b-a19829028d81",
		name: "LORA",
		parentPoliticalId: "27b5d288-d738-4172-b1cb-1066847b9360",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70211",
			"LICA",
			"7"
		],
		type: "TOWN",
		priceGroupId: "35",
		latitude: -35.027755,
		longitude: -72.073205,
		code: "138"
	},
	{
		politicalId: "a6014dac-a50a-4c69-8f18-59119335c9c8",
		name: "LOS NICHES",
		parentPoliticalId: "85ede188-6ab3-4603-90c4-f8e6e905844c",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70203",
			"ZL_CURICO",
			"CURI",
			"7"
		],
		type: "TOWN",
		priceGroupId: "35",
		latitude: -35.102103,
		longitude: -71.136464,
		code: "595"
	},
	{
		politicalId: "c941e1a9-42cf-4823-af6d-b1d2c226b23f",
		name: "MARISCADERO",
		parentPoliticalId: "3cc032a8-624d-47ef-9fd0-f064a40b385b",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70105",
			"PELL",
			"7"
		],
		type: "TOWN",
		priceGroupId: "68",
		latitude: -35.817006,
		longitude: -72.585795,
		code: "145"
	},
	{
		politicalId: "df089c20-e08a-4ac9-a3a0-4dcffc77c1dc",
		name: "MAULE",
		parentPoliticalId: "8d30eea5-2176-4c5a-a836-2c54497c6c46",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70401",
			"MULE",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "43",
		latitude: -35.516,
		longitude: -71.57194444,
		code: "141"
	},
	{
		politicalId: "b2af002c-50ef-4def-8e7d-c0f22b6f096e",
		name: "MOLINA",
		parentPoliticalId: "56f552ad-1dbf-4276-b3c0-5e86cf10797f",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"ZL_MOLINA",
			"70210",
			"MOLI",
			"7"
		],
		type: "TOWN",
		priceGroupId: "35",
		latitude: -35.09,
		longitude: -71.27888888888889,
		code: "142"
	},
	{
		politicalId: "fa9cad69-6f18-4111-80c0-4104297ca461",
		name: "NIRIVILO",
		parentPoliticalId: "99c219e0-db22-45ee-930f-48bc372c6c5a",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70301",
			"ZL_SAN_JAVIER",
			"SJAV",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.543777,
		longitude: -72.091625,
		code: "152"
	},
	{
		politicalId: "9ecfa483-76e5-4c53-a32f-d2641665c8ed",
		name: "PANIMAVIDA",
		parentPoliticalId: "234a2ca5-bc8b-4ea3-b9de-e281a11c7058",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70302",
			"COLB",
			"7"
		],
		type: "TOWN",
		priceGroupId: "55",
		latitude: -35.75883,
		longitude: -71.417567,
		code: "456"
	},
	{
		politicalId: "74ff8a56-f841-4f65-a22a-efba4b656dcc",
		name: "PARRAL",
		parentPoliticalId: "d0c4d8fa-c94d-49be-8742-b2ea50916165",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"ZL_PARRAL",
			"70303",
			"PARR",
			"7"
		],
		type: "TOWN",
		priceGroupId: "55",
		latitude: -36.147,
		longitude: -71.82194444444444,
		code: "143"
	},
	{
		politicalId: "cac735f7-7704-4880-ac98-7d2f90afc427",
		name: "PELARCO",
		parentPoliticalId: "8d30eea5-2176-4c5a-a836-2c54497c6c46",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70402",
			"PELA",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "43",
		latitude: -35.378,
		longitude: -71.43444444,
		code: "144"
	},
	{
		politicalId: "890f0140-5a98-4e9a-9e10-e65f060d0306",
		name: "PELLUHUE",
		parentPoliticalId: "3cc032a8-624d-47ef-9fd0-f064a40b385b",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"PELL",
			"70104",
			"7"
		],
		type: "TOWN",
		priceGroupId: "68",
		latitude: -35.814,
		longitude: -72.57388889,
		code: "145"
	},
	{
		politicalId: "56d6835e-0e52-4bc2-8aed-8191c813cda7",
		name: "PENCAHUE",
		parentPoliticalId: "8d30eea5-2176-4c5a-a836-2c54497c6c46",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70403",
			"PNCH",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "43",
		latitude: -35.391,
		longitude: -71.785,
		code: "146"
	},
	{
		politicalId: "dbd1e8ed-a70d-463c-b888-b0af720e723a",
		name: "PETEROA",
		parentPoliticalId: "116b21bf-eb43-44a6-a5ef-8d69c6000a0b",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70209",
			"SAFA",
			"7"
		],
		type: "TOWN",
		priceGroupId: "35",
		latitude: -35.022399,
		longitude: -71.430407,
		code: "150"
	},
	{
		politicalId: "a11e9c19-f0a6-4445-86e4-b3de24282ab6",
		name: "PUTAGÁN",
		parentPoliticalId: "9513496b-427e-4eac-87bc-cc658a8a4896",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70304",
			"VALG",
			"7"
		],
		type: "TOWN",
		priceGroupId: "55",
		latitude: -35.764432,
		longitude: -71.667777,
		code: "156"
	},
	{
		politicalId: "07f1862d-7d08-49e8-8c4e-172b0f4e9934",
		name: "PUTU",
		parentPoliticalId: "d0f75c64-b162-433c-b970-e0d803ab7535",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70404",
			"ZL_CONSTITUCION",
			"CONS",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.214202,
		longitude: -72.283402,
		code: "133"
	},
	{
		politicalId: "23ae9a5a-e10d-429e-b84c-1503d76b0f36",
		name: "QUILHUINE",
		parentPoliticalId: "996863bb-60d2-4679-9d5d-23cb34f67466",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70103",
			"CHNC",
			"7"
		],
		type: "TOWN",
		priceGroupId: "68",
		latitude: -35.593054,
		longitude: -72.523286,
		code: "131"
	},
	{
		politicalId: "de82304e-2fb6-4cbb-91d4-88edd76894d4",
		name: "RARI",
		parentPoliticalId: "234a2ca5-bc8b-4ea3-b9de-e281a11c7058",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70305",
			"COLB",
			"7"
		],
		type: "TOWN",
		priceGroupId: "55",
		latitude: -35.76697,
		longitude: -71.414639,
		code: "132"
	},
	{
		politicalId: "cbbf3da5-ef32-4bf4-9b1f-6d08433eb78f",
		name: "RAUCO",
		parentPoliticalId: "cebb4bb8-ac2e-4913-9ed6-b7fb7a9649eb",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70208",
			"RAUC",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "35",
		latitude: -34.929,
		longitude: -71.31083333,
		code: "402"
	},
	{
		politicalId: "ec747746-6eae-44f5-bacf-f14f1a55461e",
		name: "RETIRO",
		parentPoliticalId: "c6f27aa1-07b9-4099-a665-12deb6d2cc79",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70306",
			"RETI",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "55",
		latitude: -36.046,
		longitude: -71.75888889,
		code: "147"
	},
	{
		politicalId: "346136c2-811f-419b-874f-31dc29dab89e",
		name: "RÍO CLARO",
		parentPoliticalId: "8fbbfcb7-43ec-484c-8264-3fa98b52e5bb",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"RCLA",
			"70405",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.217,
		longitude: -71.25,
		code: "148"
	},
	{
		politicalId: "efe8e177-05e8-4699-a146-11f30971ce52",
		name: "ROMERAL",
		parentPoliticalId: "cebb4bb8-ac2e-4913-9ed6-b7fb7a9649eb",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70207",
			"ROME",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "35",
		latitude: -34.967,
		longitude: -71.13277778,
		code: "149"
	},
	{
		politicalId: "b16397ee-d76d-46e5-88be-ea60bbe4b675",
		name: "SAGRADA FAMILIA",
		parentPoliticalId: "116b21bf-eb43-44a6-a5ef-8d69c6000a0b",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"SAFA",
			"70206",
			"7"
		],
		type: "TOWN",
		priceGroupId: "35",
		latitude: -35,
		longitude: -71.38277778,
		code: "150"
	},
	{
		politicalId: "97e0ddba-e26c-407c-be97-231c76bfefaf",
		name: "SAN CLEMENTE",
		parentPoliticalId: "e8e150b3-ddc7-40f8-bc7d-1e3da2a45aa1",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70406",
			"ZL_SAN_CLEMENTE",
			"SCLE",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.534,
		longitude: -71.48583333333333,
		code: "151"
	},
	{
		politicalId: "bcc1db68-438a-481e-a208-5a7c981580be",
		name: "SAN JAVIER",
		parentPoliticalId: "99c219e0-db22-45ee-930f-48bc372c6c5a",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70307",
			"ZL_SAN_JAVIER",
			"SJAV",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.05,
		longitude: -71.46694444444445,
		code: "152"
	},
	{
		politicalId: "e7f69f66-7840-4910-98ca-c3b494933c98",
		name: "SAUZAL",
		parentPoliticalId: "957b0028-2409-41cc-a034-7149b14a639b",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70102",
			"CAUQ",
			"ZL_CAUQUENES",
			"7"
		],
		type: "TOWN",
		priceGroupId: "68",
		latitude: -35.72095,
		longitude: -72.126029,
		code: "130"
	},
	{
		politicalId: "1a2b8fa9-eb9a-4479-b29b-ca1e9dae9c42",
		name: "TALCA",
		parentPoliticalId: "8d30eea5-2176-4c5a-a836-2c54497c6c46",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"ZL_TALCA",
			"70408",
			"TALC",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "43",
		latitude: -35.42299999999999,
		longitude: -71.65694444444445,
		code: "153"
	},
	{
		politicalId: "2e0724f7-07dc-4f41-a386-45bf4b03c16a",
		name: "TENO",
		parentPoliticalId: "cebb4bb8-ac2e-4913-9ed6-b7fb7a9649eb",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"TENO",
			"70205",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "35",
		latitude: -34.873,
		longitude: -71.16194444,
		code: "154"
	},
	{
		politicalId: "da0e4ce6-7c2f-4d57-900e-8c4eb22ab993",
		name: "TREGUALEMU",
		parentPoliticalId: "3cc032a8-624d-47ef-9fd0-f064a40b385b",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70101",
			"PELL",
			"7"
		],
		type: "TOWN",
		priceGroupId: "68",
		latitude: -36.004395,
		longitude: -72.77232,
		code: "145"
	},
	{
		politicalId: "f22ed2d4-8fa5-4059-86de-fb72ea1852ae",
		name: "VICHUQUÉN",
		parentPoliticalId: "cebb4bb8-ac2e-4913-9ed6-b7fb7a9649eb",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"VICH",
			"70204",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "35",
		latitude: -34.823,
		longitude: -72.035,
		code: "155"
	},
	{
		politicalId: "c472dd9c-c330-4d74-993f-d95a258b6d0b",
		name: "VILCHES",
		parentPoliticalId: "e8e150b3-ddc7-40f8-bc7d-1e3da2a45aa1",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70409",
			"ZL_SAN_CLEMENTE",
			"SCLE",
			"7"
		],
		type: "TOWN",
		priceGroupId: "43",
		latitude: -35.598664,
		longitude: -71.205476,
		code: "151"
	},
	{
		politicalId: "91671b72-c280-44c8-a33c-431a340a135d",
		name: "VILLA ALEGRE",
		parentPoliticalId: "9513496b-427e-4eac-87bc-cc658a8a4896",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70313",
			"VALG",
			"7"
		],
		type: "TOWN",
		priceGroupId: "55",
		latitude: -35.665,
		longitude: -71.74194444,
		code: "156"
	},
	{
		politicalId: "956fc10b-6c1f-4225-a90f-69bbc8881a2c",
		name: "VILLA BAVIERA",
		parentPoliticalId: "d0c4d8fa-c94d-49be-8742-b2ea50916165",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"70309",
			"ZL_PARRAL",
			"PARR",
			"7"
		],
		type: "TOWN",
		priceGroupId: "55",
		latitude: -36.387357,
		longitude: -71.588292,
		code: "143"
	},
	{
		politicalId: "c094cc12-d89f-4dd0-a922-7a7543a2a62f",
		name: "VILLA PRAT",
		parentPoliticalId: "116b21bf-eb43-44a6-a5ef-8d69c6000a0b",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"SAFA",
			"70206",
			"7"
		],
		type: "TOWN",
		priceGroupId: "35",
		latitude: -35.099746,
		longitude: -71.617919,
		code: "541"
	},
	{
		politicalId: "c84b6024-5b86-47ef-8356-07b68b42da42",
		name: "YERBAS BUENAS",
		parentPoliticalId: "c6f27aa1-07b9-4099-a665-12deb6d2cc79",
		parentStateId: "77d9e536-ce23-436f-aa4f-5799edccd004",
		parentStateName: "MAULE",
		zones: [
			"YBNS",
			"70310",
			"7"
		],
		type: "DISTRICT",
		priceGroupId: "55",
		latitude: -35.75,
		longitude: -71.58277778,
		code: "157"
	}
];
var maule = {
	data: data$g
};

var data$h = [
	{
		politicalId: "b48448a2-7072-46fb-b35b-928c8c0bcf10",
		name: "ALHUÉ",
		parentPoliticalId: "7167e784-9750-473d-984f-652fc4cb11dc",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ALHU",
			"130305",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -34.033,
		longitude: -71.085,
		code: "315"
	},
	{
		politicalId: "7c571dd7-7a8b-4ac5-a53c-16950478e98e",
		name: "ALTO JAHUEL",
		parentPoliticalId: "b3dc6891-ea17-4dba-ac1b-a17f75f15523",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130502",
			"ZL_BUIN",
			"BUIN",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.733858,
		longitude: -70.684805,
		code: "316"
	},
	{
		politicalId: "b7c1bf1d-252a-4be4-94d9-1b593b1785f9",
		name: "ANGOSTURA",
		parentPoliticalId: "d5353aea-7aef-40a2-a7c3-964efd72e004",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"60235",
			"PAIN",
			"ZL_PAINE",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.90001,
		longitude: -70.734053,
		code: "626"
	},
	{
		politicalId: "93373817-6760-432f-be84-3d35ff661bb9",
		name: "BATUCO",
		parentPoliticalId: "b402f9c7-9639-490b-8f0c-6251d23e9e3d",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"BATU",
			"130206",
			"ZL_LAMPA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "63",
		latitude: -33.24294,
		longitude: -70.774871,
		code: "377"
	},
	{
		politicalId: "24ec9401-232e-402b-bafb-004d90af0e0b",
		name: "BUIN",
		parentPoliticalId: "b3dc6891-ea17-4dba-ac1b-a17f75f15523",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_BUIN",
			"BUIN",
			"130102",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.728,
		longitude: -70.7388888888889,
		code: "316"
	},
	{
		politicalId: "ed51d70f-cf39-4205-85b1-c7db65492341",
		name: "CAJÓN DEL MAIPO",
		parentPoliticalId: "b7e558b2-a2cc-4d3b-9aa8-bf0e4c28b9ae",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130401",
			"SJOS",
			"13"
		],
		type: "TOWN",
		priceGroupId: "75",
		latitude: -33.641,
		longitude: -70.355,
		code: "318"
	},
	{
		politicalId: "9e44381f-b5f1-4ae4-b8bd-5e4288a93aba",
		name: "CALERA DE TANGO",
		parentPoliticalId: "c1a9d82f-225a-4114-aeea-b9bc4e93c4d0",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130503",
			"CTAN",
			"ZL_CALERA DE TANGO",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "23",
		latitude: -33.628,
		longitude: -70.785,
		code: "372"
	},
	{
		politicalId: "0149c2b2-c163-482a-b621-486371cbb763",
		name: "CALEU",
		parentPoliticalId: "609ea683-85c2-40e8-acad-80c962655be6",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130205",
			"TILT",
			"13"
		],
		type: "TOWN",
		priceGroupId: "63",
		latitude: -33.001341,
		longitude: -70.951911,
		code: "368"
	},
	{
		politicalId: "15c37b0b-a392-41a9-8b3b-978376c700d5",
		name: "CERRILLOS",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_CERRILLOS",
			"LOSC",
			"130617",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -33.5,
		longitude: -70.71666666666667,
		code: "319"
	},
	{
		politicalId: "46b4967d-ff36-4b32-ab28-670dc74bbe47",
		name: "CERRO NAVIA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130616",
			"ZL_CERRO_NAVIA",
			"CNAV",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "723",
		latitude: -33.422,
		longitude: -70.735,
		code: "320"
	},
	{
		politicalId: "f5e4254b-3066-4b18-be01-bba2eb9ad128",
		name: "CHAMPA",
		parentPoliticalId: "d5353aea-7aef-40a2-a7c3-964efd72e004",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"PAIN",
			"ZL_PAINE",
			"130505",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.852924,
		longitude: -70.764944,
		code: "625"
	},
	{
		politicalId: "2d462b48-1e73-4cce-a5a0-1755ae25377e",
		name: "CHICUREO",
		parentPoliticalId: "9b1318e1-0551-4129-8295-d267574dafd7",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"CHIC",
			"130204",
			"ZL_COLINA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "723",
		latitude: -33.272334,
		longitude: -70.679306,
		code: "643"
	},
	{
		politicalId: "eb536f24-37b7-457a-a4a6-a7374f6967f3",
		name: "COLINA",
		parentPoliticalId: "9b1318e1-0551-4129-8295-d267574dafd7",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130207",
			"COLI",
			"ZL_COLINA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "723",
		latitude: -33.194,
		longitude: -70.66777777777779,
		code: "321"
	},
	{
		politicalId: "925736ca-d1c2-4e08-84e3-4c2c947da062",
		name: "CONCHALÍ",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130608",
			"CCHA",
			"ZL_CONCHALI",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "63",
		latitude: -33.38,
		longitude: -70.6675,
		code: "322"
	},
	{
		politicalId: "7ac4e933-b99e-4efd-a973-cb2817577c6c",
		name: "CURACAVÍ",
		parentPoliticalId: "7167e784-9750-473d-984f-652fc4cb11dc",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_CURACAVI",
			"130306",
			"CRCV",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "63",
		latitude: -33.399,
		longitude: -71.13694444444445,
		code: "323"
	},
	{
		politicalId: "65e114fe-9be1-478b-9032-67a45b058e04",
		name: "EL BOSQUE",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130614",
			"ZL_EL_BOSQUE",
			"ELBO",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "74",
		latitude: -33.567,
		longitude: -70.6675,
		code: "324"
	},
	{
		politicalId: "b704e45d-bf34-4563-81d4-76feacd25916",
		name: "EL COLORADO",
		parentPoliticalId: "9af8f062-cd1c-463c-8a3d-dab624ddaa2e",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130613",
			"ZL_LO_BARNECHEA",
			"LOBA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "34",
		latitude: -33.348893,
		longitude: -70.292088,
		code: "648"
	},
	{
		politicalId: "f8b5e997-2624-4edf-96df-fa01ebde4db7",
		name: "EL MONTE",
		parentPoliticalId: "dc3feaae-0533-4118-b594-9f08e8e47eac",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_EL_MONTE",
			"130704",
			"ELMO",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -33.684,
		longitude: -71.01694444444445,
		code: "325"
	},
	{
		politicalId: "5291e455-3816-4cb7-9f8c-d57386b88475",
		name: "ESTACIÓN CENTRAL",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ECEN",
			"130615",
			"ZL_ESTACION_CENTRAL",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "70",
		latitude: -33.459,
		longitude: -70.69888888888889,
		code: "326"
	},
	{
		politicalId: "dd203c94-0cdd-4065-bc9b-c9b40102feab",
		name: "FARELLONES",
		parentPoliticalId: "9af8f062-cd1c-463c-8a3d-dab624ddaa2e",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130613",
			"ZL_LO_BARNECHEA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "34",
		latitude: -33.351497,
		longitude: -70.311856,
		code: "535"
	},
	{
		politicalId: "917a6f4e-c085-4b0f-bdfe-099483e62596",
		name: "HOSPITAL",
		parentPoliticalId: "d5353aea-7aef-40a2-a7c3-964efd72e004",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"PAIN",
			"ZL_PAINE",
			"130505",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.863686,
		longitude: -70.74969,
		code: "626"
	},
	{
		politicalId: "18df0069-20bf-4368-a8f3-5445563791c3",
		name: "HUECHURABA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_HUECHURABA",
			"HUEC",
			"130612",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "63",
		latitude: -33.368,
		longitude: -70.63388888888889,
		code: "327"
	},
	{
		politicalId: "dd29cce6-37d1-4063-b3e6-988d2527ccce",
		name: "HUELQUÉN",
		parentPoliticalId: "d5353aea-7aef-40a2-a7c3-964efd72e004",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130504",
			"PAIN",
			"ZL_PAINE",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.831942,
		longitude: -70.642083,
		code: "349"
	},
	{
		politicalId: "8d096a9a-540a-449e-aeaf-a7ca1853823a",
		name: "INDEPENDENCIA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130611",
			"ZL_INDEPENDENCIA",
			"INDE",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "745",
		latitude: -33.413,
		longitude: -70.66583333333334,
		code: "328"
	},
	{
		politicalId: "937e4f51-63ad-4ba5-9d84-ba61fa103855",
		name: "ISLA DE MAIPO",
		parentPoliticalId: "4a1e2f62-f4e2-4eae-92d9-c0c4a2c6f0c9",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"IMAI",
			"130701",
			"ZL_ISLA_DE_MAIPO",
			"13"
		],
		type: "TOWN",
		priceGroupId: "96",
		latitude: -33.754,
		longitude: -70.88583333333334,
		code: "329"
	},
	{
		politicalId: "d83bd30c-804e-438a-a097-8bbc915b7a9d",
		name: "LA CISTERNA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_LA_CISTERNA",
			"130610",
			"LACI",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -33.529,
		longitude: -70.66277777777778,
		code: "330"
	},
	{
		politicalId: "17335c47-dfbb-4e97-a3ab-30c802e45af4",
		name: "LA DEHESA",
		parentPoliticalId: "9af8f062-cd1c-463c-8a3d-dab624ddaa2e",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_LO_BARNECHEA",
			"130631",
			"13"
		],
		type: "TOWN",
		priceGroupId: "34",
		latitude: -33.339533,
		longitude: -70.527535,
		code: "331"
	},
	{
		politicalId: "4107aaf9-b3f4-4666-b8d5-bea868c34751",
		name: "LA FLORIDA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_LA_FLORIDA",
			"LAFL",
			"130609",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "95",
		latitude: -33.525,
		longitude: -70.53777777777778,
		code: "332"
	},
	{
		politicalId: "fdb26226-5140-43a2-a2d1-6300311df26d",
		name: "LA GRANJA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_LA_GRANJA",
			"130627",
			"LAGR",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "12",
		latitude: -33.53333333333333,
		longitude: -70.61749999999999,
		code: "333"
	},
	{
		politicalId: "54595723-3399-4375-aae8-6532487a2cb1",
		name: "LA PARVA",
		parentPoliticalId: "9af8f062-cd1c-463c-8a3d-dab624ddaa2e",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130613",
			"ZL_LO_BARNECHEA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "34",
		latitude: -33.336472,
		longitude: -70.290174,
		code: "622"
	},
	{
		politicalId: "bccd53fe-6ecf-46b0-a4f0-03f20acbbc68",
		name: "LA PINTANA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130628",
			"LAPI",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "75",
		latitude: -33.583,
		longitude: -70.63388889,
		code: "334"
	},
	{
		politicalId: "4eb6ccde-7e2e-4bc4-8572-723f83c2017d",
		name: "LA REINA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_LA_REINA",
			"130629",
			"LARE",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "67",
		latitude: -33.443,
		longitude: -70.53194444444445,
		code: "335"
	},
	{
		politicalId: "6688dd1c-efba-4fed-9d8c-c26ff8f8d501",
		name: "LAMPA",
		parentPoliticalId: "b402f9c7-9639-490b-8f0c-6251d23e9e3d",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130203",
			"LAMP",
			"ZL_LAMPA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "63",
		latitude: -33.286,
		longitude: -70.87777777777777,
		code: "336"
	},
	{
		politicalId: "9e635d19-b626-4171-8beb-d92e58c2a417",
		name: "LAS CONDES",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130630",
			"ZL_LAS_CONDES",
			"LCON",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "34",
		latitude: -33.41666666666666,
		longitude: -70.58333333333333,
		code: "337"
	},
	{
		politicalId: "ccf3dfdd-abac-4067-9ab7-11dfbf8d1ccd",
		name: "LINDEROS",
		parentPoliticalId: "b3dc6891-ea17-4dba-ac1b-a17f75f15523",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130101",
			"ZL_BUIN",
			"BUIN",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.763133,
		longitude: -70.73943,
		code: "636"
	},
	{
		politicalId: "7d29c008-f6f8-4753-8d14-db09dcb903cd",
		name: "LO BARNECHEA",
		parentPoliticalId: "9af8f062-cd1c-463c-8a3d-dab624ddaa2e",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_LO_BARNECHEA",
			"130631",
			"LOBA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "34",
		latitude: -33.35,
		longitude: -70.51666666666667,
		code: "338"
	},
	{
		politicalId: "6ab07f63-54b2-472d-9b04-737daa092576",
		name: "LO ESPEJO",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130633",
			"ZL_LO_ESPEJO",
			"LOES",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -33.522,
		longitude: -70.68694444444445,
		code: "339"
	},
	{
		politicalId: "c08e2544-5079-4aa6-8e1a-7f375349dbc8",
		name: "LO PRADO",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130618",
			"ZL_LO_PRADO",
			"LOPR",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "70",
		latitude: -33.44499999999999,
		longitude: -70.72583333333334,
		code: "340"
	},
	{
		politicalId: "36926ecb-1b63-4b0a-8623-5c80db5c1c8e",
		name: "LONQUEN",
		parentPoliticalId: "4a1e2f62-f4e2-4eae-92d9-c0c4a2c6f0c9",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130707",
			"LONQ",
			"ZL_ISLA_DE_MAIPO",
			"13"
		],
		type: "TOWN",
		priceGroupId: "96",
		latitude: -33.713505,
		longitude: -70.855155,
		code: "341"
	},
	{
		politicalId: "2a94ac82-c4c4-48bb-8087-a3c5a41bfcd7",
		name: "MACUL",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130619",
			"MACU",
			"ZL_MACUL",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "54",
		latitude: -33.487,
		longitude: -70.60388888888889,
		code: "342"
	},
	{
		politicalId: "0d2f65f0-e1d6-40c1-b968-4397b4264fed",
		name: "MAIPO",
		parentPoliticalId: "b3dc6891-ea17-4dba-ac1b-a17f75f15523",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_BUIN",
			"BUIN",
			"130102",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.729583,
		longitude: -70.778037,
		code: "343"
	},
	{
		politicalId: "461c6daa-5bd9-4532-9447-16a2c334d85b",
		name: "MAIPÚ",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130620",
			"ZL_MAIPU",
			"MIPU",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "88",
		latitude: -33.51666666666667,
		longitude: -70.76666666666667,
		code: "344"
	},
	{
		politicalId: "cb624df2-8efc-409f-84ae-c9479379e5e2",
		name: "MALLARAUCO",
		parentPoliticalId: "b1a04505-c035-41b4-aba1-bf016bf8840f",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130307",
			"MELI",
			"ZL_MELIPILLA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "96",
		latitude: -33.568636,
		longitude: -71.176643,
		code: "347"
	},
	{
		politicalId: "c31142ad-61aa-40a5-9de9-35285691b926",
		name: "MALLOCO",
		parentPoliticalId: "834b17bb-4edd-4897-8dc9-4d0ce77ee324",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130706",
			"MALL",
			"ZL_PENAFLOR",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.60565,
		longitude: -70.863771,
		code: "345"
	},
	{
		politicalId: "c6ab0f1d-2968-4b45-865b-6ebc3d5c0d1b",
		name: "MARÍA PINTO",
		parentPoliticalId: "7167e784-9750-473d-984f-652fc4cb11dc",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130301",
			"MAPI",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -33.515,
		longitude: -71.11888889,
		code: "346"
	},
	{
		politicalId: "9b9b9671-a555-434e-b8d1-3f728b1a286a",
		name: "MELIPILLA",
		parentPoliticalId: "b1a04505-c035-41b4-aba1-bf016bf8840f",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"MELI",
			"ZL_MELIPILLA",
			"130308",
			"13"
		],
		type: "TOWN",
		priceGroupId: "96",
		latitude: -33.689,
		longitude: -71.20777777777778,
		code: "347"
	},
	{
		politicalId: "def974d3-c79d-4717-a44f-14c6503ec82c",
		name: "NOS",
		parentPoliticalId: "d6249a1b-c5ad-4235-b1eb-750d76255cad",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"NOSO",
			"ZL_SAN_BERNARDO",
			"130501",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.647475,
		longitude: -70.711846,
		code: "373"
	},
	{
		politicalId: "44a4c81d-fbd7-4b0f-b57b-0f3ea8462088",
		name: "ÑUÑOA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"NUNO",
			"ZL_NUNOA",
			"130621",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "67",
		latitude: -33.454,
		longitude: -70.60388888888889,
		code: "314"
	},
	{
		politicalId: "8d8ee998-6abb-4d55-9e50-53c08c8f64da",
		name: "PADRE HURTADO",
		parentPoliticalId: "a2a58bbd-c0a6-4f82-b150-248bf8ff352f",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130705",
			"PHUR",
			"ZL_PADRE_HURTADO",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.576,
		longitude: -70.785,
		code: "348"
	},
	{
		politicalId: "c9efb793-4825-46c7-90f3-d52b7bd4bbe9",
		name: "PAINE",
		parentPoliticalId: "d5353aea-7aef-40a2-a7c3-964efd72e004",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"PAIN",
			"ZL_PAINE",
			"130505",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.812,
		longitude: -70.72277777777778,
		code: "349"
	},
	{
		politicalId: "8c147b79-81b5-4ad7-917b-d7a1c3200ff2",
		name: "PEDRO AGUIRRE CERDA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"PEDR",
			"ZL_PEDRO_AGUIRRE_CERDA",
			"130622",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -33.46633333333334,
		longitude: -70.63361111111112,
		code: "352"
	},
	{
		politicalId: "abc6f970-8314-4088-ae40-24b6d59385cf",
		name: "PELDEHUE",
		parentPoliticalId: "9b1318e1-0551-4129-8295-d267574dafd7",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130202",
			"COLI",
			"ZL_COLINA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "723",
		latitude: -33.172333,
		longitude: -70.633631,
		code: "321"
	},
	{
		politicalId: "43a57312-4838-486a-a5bd-85c5aed4107c",
		name: "PEÑAFLOR",
		parentPoliticalId: "834b17bb-4edd-4897-8dc9-4d0ce77ee324",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"PENA",
			"ZL_PENAFLOR",
			"130702",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.60627777777778,
		longitude: -70.87652222222222,
		code: "350"
	},
	{
		politicalId: "7495a248-017d-4e70-b753-9c0ebfe6667c",
		name: "PEÑALOLÉN",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"PLOL",
			"130623",
			"ZL_PENALOLEN",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "54",
		latitude: -33.48618888888889,
		longitude: -70.53333333333333,
		code: "351"
	},
	{
		politicalId: "891809c9-1ce7-4954-9c37-e1debc62ecfc",
		name: "PIRQUE",
		parentPoliticalId: "33bd4061-4f8a-4f65-8553-efc6a430fe71",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130403",
			"ZL_PIRQUE",
			"PIRQ",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "75",
		latitude: -33.65,
		longitude: -70.56388888888888,
		code: "353"
	},
	{
		politicalId: "3d8e0c6e-3221-4091-87b6-6228be8bf6e6",
		name: "POMAIRE",
		parentPoliticalId: "b1a04505-c035-41b4-aba1-bf016bf8840f",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130302",
			"MELI",
			"ZL_MELIPILLA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "96",
		latitude: -33.65048,
		longitude: -71.151635,
		code: "347"
	},
	{
		politicalId: "74164632-e9b3-4ba1-b0cb-d253d380b767",
		name: "PROVIDENCIA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"PROV",
			"130624",
			"ZL_PROVIDENCIA",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "67",
		latitude: -33.435,
		longitude: -70.61583333333333,
		code: "354"
	},
	{
		politicalId: "4173aea4-ec07-4dae-88d3-11b43e86a643",
		name: "PUDAHUEL",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130625",
			"ZL_PUDAHUEL",
			"PUDA",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "88",
		latitude: -33.43333333333333,
		longitude: -70.71666666666667,
		code: "355"
	},
	{
		politicalId: "ae62b0e0-4630-4229-aef1-32d355a77a5c",
		name: "PUENTE ALTO",
		parentPoliticalId: "33bd4061-4f8a-4f65-8553-efc6a430fe71",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130402",
			"ZL_PUENTE_ALTO",
			"PALT",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "75",
		latitude: -33.616,
		longitude: -70.56694444444445,
		code: "356"
	},
	{
		politicalId: "96a7b847-2fe5-43cb-9011-f921b965e9cf",
		name: "QUILICURA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130626",
			"ZL_QUILICURA",
			"QILI",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "723",
		latitude: -33.361,
		longitude: -70.72888888888889,
		code: "358"
	},
	{
		politicalId: "0bb43655-790c-4abb-af0e-75230f5eca93",
		name: "QUINTA NORMAL",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130632",
			"ZL_QUINTA_NORMAL",
			"QNOR",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "70",
		latitude: -33.427,
		longitude: -70.69888888888889,
		code: "357"
	},
	{
		politicalId: "9724cf52-40c5-41d9-9753-bb868b169e3a",
		name: "RECOLETA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_RECOLETA",
			"130601",
			"RECO",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "63",
		latitude: -33.406,
		longitude: -70.63388888888889,
		code: "359"
	},
	{
		politicalId: "26899fb9-ad18-474d-be56-86b90a1a9a04",
		name: "RENCA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130602",
			"RENC",
			"ZL_RENCA",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "723",
		latitude: -33.398,
		longitude: -70.72277777777778,
		code: "360"
	},
	{
		politicalId: "16cc3a30-e312-4a3f-af0c-eed392c48565",
		name: "SAN BERNARDO",
		parentPoliticalId: "d6249a1b-c5ad-4235-b1eb-750d76255cad",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_SAN_BERNARDO",
			"SBER",
			"130501",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.582,
		longitude: -70.68694444444445,
		code: "362"
	},
	{
		politicalId: "1ef539e3-2a4b-4743-8150-87f9c10c595e",
		name: "SAN JOAQUÍN",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"SJOA",
			"130603",
			"ZL_SAN_JOAQUIN",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "12",
		latitude: -33.491,
		longitude: -70.62777777777777,
		code: "363"
	},
	{
		politicalId: "b7e558b2-a2cc-4d3b-9aa8-bf0e4c28b9ae",
		name: "SAN JOSÉ DE MAIPO",
		parentPoliticalId: "33bd4061-4f8a-4f65-8553-efc6a430fe71",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130401",
			"SJOS",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "75",
		latitude: -33.644,
		longitude: -70.35277778,
		code: "376"
	},
	{
		politicalId: "2f454d43-c0a5-4019-964a-1c3779107ad7",
		name: "SAN MIGUEL",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_SAN_MIGUEL",
			"130604",
			"SMIG",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "12",
		latitude: -33.48583333333333,
		longitude: -70.63472222222222,
		code: "364"
	},
	{
		politicalId: "6d5ebe99-50b0-4c27-b6ad-e869583c8453",
		name: "SAN PEDRO",
		parentPoliticalId: "7167e784-9750-473d-984f-652fc4cb11dc",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130303",
			"SNPD",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -33.9,
		longitude: -71.46694444444445,
		code: "84"
	},
	{
		politicalId: "ca788b90-2d10-48b5-8d5a-2a1f8fce1416",
		name: "SAN RAMÓN",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_SAN_RAMON",
			"130605",
			"SRAM",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "12",
		latitude: -33.53333333333333,
		longitude: -70.63416666666667,
		code: "365"
	},
	{
		politicalId: "754af0b0-44a7-46a3-b7c2-353378b7db51",
		name: "SANTA ROSA DE CHENA",
		parentPoliticalId: "a2a58bbd-c0a6-4f82-b150-248bf8ff352f",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130705",
			"PHUR",
			"ZL_PADRE_HURTADO",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.56518,
		longitude: -70.785151,
		code: "375"
	},
	{
		politicalId: "119de5d1-59f1-44f5-80b9-69485472e4e3",
		name: "SANTIAGO",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_SANTIAGO",
			"130606",
			"STGO",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "70",
		latitude: -33.43722222222222,
		longitude: -70.65055555555556,
		code: "366"
	},
	{
		politicalId: "66697773-4684-4d7c-892a-d334da8e55eb",
		name: "TALAGANTE",
		parentPoliticalId: "dc3feaae-0533-4118-b594-9f08e8e47eac",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"TALA",
			"ZL_TALAGANTE",
			"130703",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -33.66699999999999,
		longitude: -70.93083333333334,
		code: "367"
	},
	{
		politicalId: "8354424f-9790-4833-8eb9-f7533af89a39",
		name: "TILTIL",
		parentPoliticalId: "609ea683-85c2-40e8-acad-80c962655be6",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"TILT",
			"130201",
			"13"
		],
		type: "TOWN",
		priceGroupId: "63",
		latitude: -33.085,
		longitude: -70.9175,
		code: "368"
	},
	{
		politicalId: "71c1915a-a9bd-4d02-8fb4-65f8afb7cf3e",
		name: "VALDIVIA",
		parentPoliticalId: "d5353aea-7aef-40a2-a7c3-964efd72e004",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"PAIN",
			"ZL_PAINE",
			"130505",
			"13"
		],
		type: "TOWN",
		priceGroupId: "23",
		latitude: -33.811465,
		longitude: -70.860036,
		code: "374"
	},
	{
		politicalId: "78775ee4-0bea-4344-89cd-6b9e433e80a3",
		name: "VALLE NEVADO",
		parentPoliticalId: "9af8f062-cd1c-463c-8a3d-dab624ddaa2e",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"130613",
			"ZL_LO_BARNECHEA",
			"13"
		],
		type: "TOWN",
		priceGroupId: "34",
		latitude: -33.354048,
		longitude: -70.249119,
		code: "621"
	},
	{
		politicalId: "2010ac8b-eb1c-4ef2-b469-29e4a07f2cba",
		name: "VITACURA",
		parentPoliticalId: "e40136c4-ccbe-449d-81b2-770d76a0cb12",
		parentStateId: "a768f0a2-bb5d-4d51-8cad-03b48b25c4a4",
		parentStateName: "METROPOLITANA DE SANTIAGO",
		zones: [
			"ZL_VITACURA",
			"VITA",
			"130607",
			"13"
		],
		type: "DISTRICT",
		priceGroupId: "34",
		latitude: -33.4,
		longitude: -70.6,
		code: "369"
	}
];
var metropolitana = {
	data: data$h
};

var data$i = [
	{
		politicalId: "9b63bc22-bbce-4652-9524-a5ec3a8735bb",
		name: "ALMARZA",
		parentPoliticalId: "ed90fd44-2f02-445c-ae8b-b3595e2437ca",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80127",
			"CHVJ",
			"ZL_CHILLAN_VIEJO",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.625706,
		longitude: -72.163037,
		code: "532"
	},
	{
		politicalId: "fdb5735e-e518-4958-8928-2fb9c5138af3",
		name: "BUCHUPUREO",
		parentPoliticalId: "667377fa-c5db-4bda-985b-e0a9f17fdda0",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80128",
			"COBQ",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.072754,
		longitude: -72.780506,
		code: "168"
	},
	{
		politicalId: "7c7e4439-6a26-474c-bd22-06473f2b2386",
		name: "BULNES",
		parentPoliticalId: "b2fbd49c-1287-40bb-afe1-7f7c2b55164a",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"BULN",
			"80122",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.739,
		longitude: -72.29194444,
		code: "162"
	},
	{
		politicalId: "268c7b73-96d1-429c-8414-202551e88334",
		name: "CAMPANARIO",
		parentPoliticalId: "5861cf3e-5e7e-4a07-8ecc-1872e093a364",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80126",
			"YUNG",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -37.130467,
		longitude: -72.186945,
		code: "610"
	},
	{
		politicalId: "8c584b53-34cf-46c0-99e1-3932411faf3d",
		name: "CHACHAPOAL",
		parentPoliticalId: "e9568e00-b58f-4106-8314-b06a391abbe6",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80121",
			"ZL_SAN_CARLOS",
			"SCAR",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.460543,
		longitude: -71.731572,
		code: "201"
	},
	{
		politicalId: "21a1af4b-e993-4cd6-9858-cea3ffe8b367",
		name: "CHILLÁN",
		parentPoliticalId: "d81419b8-fd6f-4c29-a6aa-4854070c1e41",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"ZL_CHILLAN",
			"CHIL",
			"80120",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.601,
		longitude: -72.10888888888888,
		code: "167"
	},
	{
		politicalId: "bc987669-8e60-44c2-9497-c706210e4c89",
		name: "CHILLÁN VIEJO",
		parentPoliticalId: "ed90fd44-2f02-445c-ae8b-b3595e2437ca",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"CHVJ",
			"80119",
			"ZL_CHILLAN_VIEJO",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.633,
		longitude: -72.13388888888889,
		code: "532"
	},
	{
		politicalId: "9eb54777-280b-40f5-838b-d88294b13b8f",
		name: "CHOLGUAN",
		parentPoliticalId: "5861cf3e-5e7e-4a07-8ecc-1872e093a364",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"CHOL",
			"80118",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -37.164058,
		longitude: -72.068679,
		code: "611"
	},
	{
		politicalId: "67c264ba-7509-41d4-b4f8-7613a6c7da5a",
		name: "COBQUECURA",
		parentPoliticalId: "667377fa-c5db-4bda-985b-e0a9f17fdda0",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80117",
			"COBQ",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.133,
		longitude: -72.78277778,
		code: "168"
	},
	{
		politicalId: "72723af6-6b6a-4c3b-8df0-767495cd9c55",
		name: "COELEMU",
		parentPoliticalId: "c644ce2a-3034-443c-a7fb-64491d0a861c",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"COEL",
			"80116",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.485,
		longitude: -72.69388889,
		code: "169"
	},
	{
		politicalId: "1a43e278-ddb4-4db4-8c53-738f6e7a2635",
		name: "COIHUECO",
		parentPoliticalId: "0622d04c-fb98-43e5-bfdb-4c4d3accc70f",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"COIC",
			"80419",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -35.783,
		longitude: -72.43277778,
		code: "170"
	},
	{
		politicalId: "e9f4b910-805d-479c-a951-2714392b1d8f",
		name: "EL CARMEN",
		parentPoliticalId: "80269e8c-06fb-41a2-b297-3f278ec5da93",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"ECAR",
			"80115",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "51",
		latitude: -36.9,
		longitude: -72.03277778,
		code: "176"
	},
	{
		politicalId: "a043a06f-0312-4e03-a348-7a9622d31595",
		name: "LOS LLEUQUES",
		parentPoliticalId: "56af496f-7843-42d8-b1e1-458502b04d97",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80112",
			"PINT",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.85759,
		longitude: -71.642118,
		code: "194"
	},
	{
		politicalId: "daf10c81-840b-43d6-9fed-5ba5f4207a8e",
		name: "MINAS DEL PRADO",
		parentPoliticalId: "0622d04c-fb98-43e5-bfdb-4c4d3accc70f",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80111",
			"COIC",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.664763,
		longitude: -71.704035,
		code: "170"
	},
	{
		politicalId: "16295641-ec9e-42a2-8623-bc514ab5c8c1",
		name: "NAHUELTORO",
		parentPoliticalId: "e9568e00-b58f-4106-8314-b06a391abbe6",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80110",
			"ZL_SAN_CARLOS",
			"SCAR",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.493991,
		longitude: -71.758438,
		code: "201"
	},
	{
		politicalId: "50a1bcb5-d336-470d-bc07-4cb263973056",
		name: "NEBUCO",
		parentPoliticalId: "ed90fd44-2f02-445c-ae8b-b3595e2437ca",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80109",
			"CHVJ",
			"ZL_CHILLAN_VIEJO",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.645432,
		longitude: -72.211434,
		code: "532"
	},
	{
		politicalId: "c8e8f282-88d3-47b9-8086-e85b6f5788ad",
		name: "NINHUE",
		parentPoliticalId: "a4c673dc-78be-4ec7-a293-9b4836377638",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80108",
			"NINH",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "51",
		latitude: -36.401,
		longitude: -72.39694444,
		code: "191"
	},
	{
		politicalId: "83f35299-81d2-4f0e-b033-6f12fca8f504",
		name: "ÑIPAS",
		parentPoliticalId: "3de23d23-b3c0-43e3-8639-1b8cfd92b5a9",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80107",
			"RANQ",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.603622,
		longitude: -72.537225,
		code: "158"
	},
	{
		politicalId: "1a873fa2-2416-40ae-8ae3-162d055458fc",
		name: "ÑIQUÉN",
		parentPoliticalId: "0998a06f-a125-4c1f-a14b-ff30c43965c9",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"NIQU",
			"80106",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "51",
		latitude: -36.287,
		longitude: -71.89888889,
		code: "159"
	},
	{
		politicalId: "9dd08060-2d9f-43f3-ac72-bad50efa528f",
		name: "PEMUCO",
		parentPoliticalId: "80269e8c-06fb-41a2-b297-3f278ec5da93",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80104",
			"PEMU",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "51",
		latitude: -36.978,
		longitude: -72.09083333,
		code: "192"
	},
	{
		politicalId: "57358261-f1b6-44f2-83ce-f2f2d4930d3d",
		name: "PINTO",
		parentPoliticalId: "56af496f-7843-42d8-b1e1-458502b04d97",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80103",
			"PINT",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.7,
		longitude: -71.9,
		code: "194"
	},
	{
		politicalId: "92b6eda9-3638-4353-8cd8-f2612df7a5e1",
		name: "PORTEZUELO",
		parentPoliticalId: "a4c673dc-78be-4ec7-a293-9b4836377638",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80102",
			"PORT",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "51",
		latitude: -36.533,
		longitude: -72.43277778,
		code: "195"
	},
	{
		politicalId: "221d1486-a3f8-4c52-b48e-226d654dcbbf",
		name: "QUILLÓN",
		parentPoliticalId: "80269e8c-06fb-41a2-b297-3f278ec5da93",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"QULL",
			"80101",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "51",
		latitude: -36.738,
		longitude: -72.46888889,
		code: "198"
	},
	{
		politicalId: "75cae1fe-9013-4e1e-b413-7a375066bcea",
		name: "QUILMO",
		parentPoliticalId: "ed90fd44-2f02-445c-ae8b-b3595e2437ca",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80138",
			"CHVJ",
			"ZL_CHILLAN_VIEJO",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.674933,
		longitude: -72.12415,
		code: "532"
	},
	{
		politicalId: "bd1b32bd-12bc-486e-b0a3-e3da52f673a9",
		name: "QUINCHAMALÍ",
		parentPoliticalId: "d81419b8-fd6f-4c29-a6aa-4854070c1e41",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80133",
			"ZL_CHILLAN",
			"CHIL",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.648354,
		longitude: -72.403003,
		code: "167"
	},
	{
		politicalId: "6314f8ad-38db-4396-89e9-295b37de1a14",
		name: "QUIRIHUE",
		parentPoliticalId: "a4c673dc-78be-4ec7-a293-9b4836377638",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"QUIR",
			"80132",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "51",
		latitude: -36.281,
		longitude: -72.53444444,
		code: "199"
	},
	{
		politicalId: "8cee4204-0745-4c30-8605-79312f946e98",
		name: "RÁNQUIL",
		parentPoliticalId: "3de23d23-b3c0-43e3-8639-1b8cfd92b5a9",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"RANQ",
			"80131",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.65,
		longitude: -72.535,
		code: "401"
	},
	{
		politicalId: "2d22a587-d564-49c2-8d6d-52eabdecf109",
		name: "RUCAPEQUÉN",
		parentPoliticalId: "ed90fd44-2f02-445c-ae8b-b3595e2437ca",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80130",
			"CHVJ",
			"ZL_CHILLAN_VIEJO",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.672031,
		longitude: -72.281449,
		code: "532"
	},
	{
		politicalId: "d5fb4cea-8fef-4f5b-a4a2-318299174123",
		name: "SAN CARLOS",
		parentPoliticalId: "e9568e00-b58f-4106-8314-b06a391abbe6",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80129",
			"ZL_SAN_CARLOS",
			"SCAR",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.422,
		longitude: -71.9588888888889,
		code: "201"
	},
	{
		politicalId: "ba226dc5-dc17-4081-b144-0959f11fca27",
		name: "SAN FABIÁN",
		parentPoliticalId: "36b007c8-2c6a-44cc-a338-fea1df4373dc",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"SFAB",
			"80125",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.554,
		longitude: -71.54888889,
		code: "202"
	},
	{
		politicalId: "3da86a22-47a0-44ba-b299-13341789a248",
		name: "SAN GABRIEL",
		parentPoliticalId: "36b007c8-2c6a-44cc-a338-fea1df4373dc",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80124",
			"SFAB",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.650252,
		longitude: -71.394883,
		code: "202"
	},
	{
		politicalId: "08e0d2c6-4929-4b4c-963d-cf9009a59133",
		name: "SAN GREGORIO",
		parentPoliticalId: "1a873fa2-2416-40ae-8ae3-162d055458fc",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80135",
			"NIQU",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.281339,
		longitude: -71.815165,
		code: "203"
	},
	{
		politicalId: "ae55fce5-1690-472c-814f-369e67084058",
		name: "SAN IGNACIO",
		parentPoliticalId: "80269e8c-06fb-41a2-b297-3f278ec5da93",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"SIGN",
			"80123",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "51",
		latitude: -36.8,
		longitude: -72.03277778,
		code: "204"
	},
	{
		politicalId: "0fc2c84d-4fc1-456c-98d0-ad56e624e0ed",
		name: "SAN NICOLÁS",
		parentPoliticalId: "0998a06f-a125-4c1f-a14b-ff30c43965c9",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80141",
			"SNIC",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "51",
		latitude: -36.883,
		longitude: -72.48277778,
		code: "205"
	},
	{
		politicalId: "2d98d763-750b-49c1-93be-ba3a8c4b95b7",
		name: "SANTA CLARO",
		parentPoliticalId: "b2fbd49c-1287-40bb-afe1-7f7c2b55164a",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"BULN",
			"80122",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.826156,
		longitude: -72.329044,
		code: "616"
	},
	{
		politicalId: "b014a8e8-1798-45d4-a39d-499587b3e60c",
		name: "TREGUACO",
		parentPoliticalId: "a4c673dc-78be-4ec7-a293-9b4836377638",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"TREG",
			"80140",
			"8"
		],
		type: "DISTRICT",
		priceGroupId: "93",
		latitude: -36.429,
		longitude: -72.65138889,
		code: "212"
	},
	{
		politicalId: "0249c81b-b9e8-43d8-b16e-70adb049186b",
		name: "TRES ESQUINAS",
		parentPoliticalId: "b2fbd49c-1287-40bb-afe1-7f7c2b55164a",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80139",
			"BULN",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.790155,
		longitude: -72.208001,
		code: "162"
	},
	{
		politicalId: "cefcf136-dcac-4912-99eb-bbdc9a722454",
		name: "TRES ESQUINAS DE CATO",
		parentPoliticalId: "0622d04c-fb98-43e5-bfdb-4c4d3accc70f",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80134",
			"COIC",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.5437,
		longitude: -71.780035,
		code: "170"
	},
	{
		politicalId: "585e843e-5dc6-4bd0-b9d2-b921c9b48317",
		name: "VEGAS DE ITATA",
		parentPoliticalId: "c644ce2a-3034-443c-a7fb-64491d0a861c",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80137",
			"COEL",
			"8"
		],
		type: "TOWN",
		priceGroupId: "93",
		latitude: -36.401496,
		longitude: -72.851273,
		code: "169"
	},
	{
		politicalId: "cd8d85a6-af25-4ead-853c-eba580040594",
		name: "VILLA EL COPIHUE",
		parentPoliticalId: "d81419b8-fd6f-4c29-a6aa-4854070c1e41",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80136",
			"ZL_CHILLAN",
			"CHIL",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -36.626163,
		longitude: -72.115259,
		code: "167"
	},
	{
		politicalId: "c55aceea-ae7e-466b-a29f-d697782a398c",
		name: "YUNGAY",
		parentPoliticalId: "5861cf3e-5e7e-4a07-8ecc-1872e093a364",
		parentStateId: "3b7c88cb-8cd4-4510-972a-1b625479b7f4",
		parentStateName: "ÑUBLE",
		zones: [
			"80126",
			"YUNG",
			"8"
		],
		type: "TOWN",
		priceGroupId: "51",
		latitude: -37.10445,
		longitude: -71.93080556,
		code: "215"
	}
];
var nuble = {
	data: data$i
};

var data$j = [
	{
		politicalId: "f35cae58-b2b9-460a-91fe-061b2047d770",
		name: "ALTO HOSPICIO",
		parentPoliticalId: "3c1dcf1c-b235-49d3-a78e-c7e8727bd384",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10103",
			"AHOS",
			"1"
		],
		type: "DISTRICT",
		priceGroupId: "728",
		latitude: -20.257,
		longitude: -70.02194444,
		code: "407"
	},
	{
		politicalId: "0ef815cb-39ae-4d5e-a553-734d8919dc0a",
		name: "CAMIÑA",
		parentPoliticalId: "ba14ba77-8769-4766-b1c9-bfb35c30ec52",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10210",
			"CAMI",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -20.483,
		longitude: -69.36694444444444,
		code: "3"
	},
	{
		politicalId: "fd691690-0a02-490c-9acd-331c576579db",
		name: "CARIQUIMA",
		parentPoliticalId: "2edb745c-198e-42fb-8c3b-9ee75cdcbf59",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10209",
			"COLC",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.467818,
		longitude: -68.644229,
		code: "4"
	},
	{
		politicalId: "216ea9d2-2d1d-4809-b36b-fb02ce5c51be",
		name: "CHAPIQUILTA",
		parentPoliticalId: "ba14ba77-8769-4766-b1c9-bfb35c30ec52",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10208",
			"CAMI",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.317536,
		longitude: -69.410641,
		code: "3"
	},
	{
		politicalId: "d4cf21f8-0ab7-40c6-b856-8a4d292a6cb2",
		name: "CHIJO",
		parentPoliticalId: "2edb745c-198e-42fb-8c3b-9ee75cdcbf59",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10207",
			"COLC",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.443135,
		longitude: -68.580616,
		code: "4"
	},
	{
		politicalId: "f438ebd4-df1a-4ff8-9abb-3713dda8d23b",
		name: "COLCHANE",
		parentPoliticalId: "2edb745c-198e-42fb-8c3b-9ee75cdcbf59",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"COLC",
			"10201",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.284,
		longitude: -68.6675,
		code: "4"
	},
	{
		politicalId: "7f577e00-17aa-4f9c-853d-a26a5e4a04d0",
		name: "ENQUELGA",
		parentPoliticalId: "2edb745c-198e-42fb-8c3b-9ee75cdcbf59",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10205",
			"COLC",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.228899,
		longitude: -68.80482,
		code: "4"
	},
	{
		politicalId: "49887296-28dd-43e0-9958-53aca47a051a",
		name: "HUARA",
		parentPoliticalId: "6f337665-8cbd-4d87-8a27-b6298d964d01",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"HUAR",
			"10206",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.809,
		longitude: -69.97194444,
		code: "398"
	},
	{
		politicalId: "bf4f2cfe-c687-4ddc-b5fe-d6b1fceb563f",
		name: "HUATACONDO",
		parentPoliticalId: "fa892745-9c2e-4ced-a64b-dc997dd59f89",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10218",
			"POZO",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -20.927339,
		longitude: -69.055173,
		code: "8"
	},
	{
		politicalId: "f44f08c1-4f46-4e17-854a-5abe724236bf",
		name: "IQUIQUE",
		parentPoliticalId: "3c1dcf1c-b235-49d3-a78e-c7e8727bd384",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10101",
			"IQUI",
			"1"
		],
		type: "DISTRICT",
		priceGroupId: "11",
		latitude: -20.244,
		longitude: -70.1388888888889,
		code: "6"
	},
	{
		politicalId: "727ae37e-9e54-4eed-9837-e6bb59ab8b3a",
		name: "ISLUGA",
		parentPoliticalId: "2edb745c-198e-42fb-8c3b-9ee75cdcbf59",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10219",
			"COLC",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.250935,
		longitude: -68.723022,
		code: "4"
	},
	{
		politicalId: "59d953c0-a6f8-4b21-8418-bbebe2ff99a9",
		name: "LA HUAYCA",
		parentPoliticalId: "fa892745-9c2e-4ced-a64b-dc997dd59f89",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10220",
			"POZO",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -20.430878,
		longitude: -69.561094,
		code: "8"
	},
	{
		politicalId: "e7ec06cf-ac56-4988-8d31-1e6b329b815d",
		name: "LA TIRANA",
		parentPoliticalId: "fa892745-9c2e-4ced-a64b-dc997dd59f89",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10221",
			"POZO",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -20.337622,
		longitude: -69.65626,
		code: "8"
	},
	{
		politicalId: "835caf47-02fe-4f69-b4c5-9457263187e9",
		name: "LIRIMA",
		parentPoliticalId: "31ef98a6-7a25-44df-af3d-a6552e02e76e",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10203",
			"PICA",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.846662,
		longitude: -68.856312,
		code: "7"
	},
	{
		politicalId: "b0f420fb-35b7-4bb2-9312-bf1f577a31e3",
		name: "MAMINA",
		parentPoliticalId: "fa892745-9c2e-4ced-a64b-dc997dd59f89",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10204",
			"POZO",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -20.074528,
		longitude: -69.21517,
		code: "8"
	},
	{
		politicalId: "d7af6ff4-8acd-4670-8ce6-b3e37118c814",
		name: "MOCHA",
		parentPoliticalId: "6f337665-8cbd-4d87-8a27-b6298d964d01",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10217",
			"HUAR",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.812885,
		longitude: -69.275602,
		code: "398"
	},
	{
		politicalId: "d2f37ea9-2de4-4693-b9fb-44a1a53090a3",
		name: "MOQUELLA",
		parentPoliticalId: "ba14ba77-8769-4766-b1c9-bfb35c30ec52",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10215",
			"CAMI",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.352673,
		longitude: -69.5203,
		code: "3"
	},
	{
		politicalId: "dd665b41-bae3-47c0-bea8-1d0cdc9153f8",
		name: "PICA",
		parentPoliticalId: "31ef98a6-7a25-44df-af3d-a6552e02e76e",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10211",
			"PICA",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -20.483,
		longitude: -69.37777777777777,
		code: "7"
	},
	{
		politicalId: "d5853965-e9ce-4185-9516-0f834eec95c4",
		name: "PINTADOS",
		parentPoliticalId: "fa892745-9c2e-4ced-a64b-dc997dd59f89",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10102",
			"POZO",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -20.622204,
		longitude: -69.63691,
		code: "8"
	},
	{
		politicalId: "4fe11668-e176-4f4e-8370-07489878f2cd",
		name: "PISAGUA",
		parentPoliticalId: "6f337665-8cbd-4d87-8a27-b6298d964d01",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10202",
			"HUAR",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.597287,
		longitude: -70.213165,
		code: "398"
	},
	{
		politicalId: "88737a47-9990-48c0-924a-def162851ba8",
		name: "POZO ALMONTE",
		parentPoliticalId: "fa892745-9c2e-4ced-a64b-dc997dd59f89",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10216",
			"POZO",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -20.291,
		longitude: -69.69583333333334,
		code: "8"
	},
	{
		politicalId: "17e8bcfc-93a9-4c2a-9b03-c6f10510c001",
		name: "SAN ANTONIO DE ZAPIGA",
		parentPoliticalId: "6f337665-8cbd-4d87-8a27-b6298d964d01",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10214",
			"HUAR",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.638745,
		longitude: -69.964031,
		code: "398"
	},
	{
		politicalId: "825a0e68-bd12-496c-8af0-ce2435d89610",
		name: "SAN LORENZO DE TARAPACÁ",
		parentPoliticalId: "6f337665-8cbd-4d87-8a27-b6298d964d01",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10213",
			"HUAR",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.927166,
		longitude: -69.511936,
		code: "398"
	},
	{
		politicalId: "3efa7296-1e8f-477a-82e7-0f362ab49714",
		name: "SOTOCA",
		parentPoliticalId: "6f337665-8cbd-4d87-8a27-b6298d964d01",
		parentStateId: "38798c03-241c-44f4-bbfa-8c1264ab3fff",
		parentStateName: "TARAPACÁ",
		zones: [
			"10212",
			"HUAR",
			"1"
		],
		type: "TOWN",
		priceGroupId: "11",
		latitude: -19.595956,
		longitude: -69.232794,
		code: "398"
	}
];
var tarapaca = {
	data: data$j
};

var data$k = [
	{
		politicalId: "cb8d092c-9259-4079-8e50-0bb4da6c16fa",
		name: "ALGARROBO",
		parentPoliticalId: "7f66ef09-00ec-47a7-a89d-3b0951a4236c",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50802",
			"ALGA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.36916666666666,
		longitude: -71.66666666666667,
		code: "46"
	},
	{
		politicalId: "c01917cd-9122-405c-9e47-35d43e7d847c",
		name: "ALICAHUE",
		parentPoliticalId: "02b3471a-fcbc-409e-bee6-e594a0f303a5",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50301",
			"CABI",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.351538,
		longitude: -70.783289,
		code: "48"
	},
	{
		politicalId: "1837b594-72b2-43e2-9ce1-394754bbf2bb",
		name: "ARTIFICIO",
		parentPoliticalId: "6463a932-7c63-4a04-b907-019cd9df7800",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"ARTI",
			"50508",
			"ZL_CALERA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "4",
		latitude: -32.777965,
		longitude: -71.191314,
		code: "409"
	},
	{
		politicalId: "c2c70380-005a-4ca1-8a4a-511b4d694267",
		name: "BARRANCAS",
		parentPoliticalId: "edc47fe3-f4fb-4c9c-8d7b-d29bb963af96",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"BARR",
			"SANT",
			"50811",
			"ZL_SAN_ANTONIO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.598455,
		longitude: -71.593595,
		code: "544"
	},
	{
		politicalId: "d9b329ba-3e5c-49c3-8350-95255135507a",
		name: "CABILDO",
		parentPoliticalId: "02b3471a-fcbc-409e-bee6-e594a0f303a5",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"CABI",
			"50306",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.409,
		longitude: -71.06777777777778,
		code: "48"
	},
	{
		politicalId: "b4061430-6248-4232-b7d0-e4288c4db376",
		name: "CACHAGUA",
		parentPoliticalId: "ddaff0a9-0c97-44f1-8705-5745a476f098",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50302",
			"ZL_ZAPALLAR",
			"ZAPA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.579281,
		longitude: -71.452523,
		code: "396"
	},
	{
		politicalId: "6463a932-7c63-4a04-b907-019cd9df7800",
		name: "CALERA",
		parentPoliticalId: "eeb387cc-0f28-4d74-b317-792618c4eb53",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50508",
			"ZL_CALERA",
			"LACA",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "4",
		latitude: -32.784,
		longitude: -71.2038888888889,
		code: "61"
	},
	{
		politicalId: "3685a918-5b9f-4ed4-bc83-220ce5506e71",
		name: "CALETA EL MEMBRILLO",
		parentPoliticalId: "d3c49b0c-106e-4788-8905-75815dea5403",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51002",
			"VALP",
			"ZL_VALPARAISO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.022242,
		longitude: -71.633501,
		code: "87"
	},
	{
		politicalId: "045c173d-04a9-4f89-906e-ac3d3a838165",
		name: "CALLE LARGA",
		parentPoliticalId: "fef90e27-bf73-4bb7-8a04-5688330b2aec",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"CALL",
			"50405",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.88305555555556,
		longitude: -70.46805555555555,
		code: "50"
	},
	{
		politicalId: "c35e46b8-49c6-41e4-a470-ecfbeff31c5d",
		name: "CANAL BEAGLE",
		parentPoliticalId: "4066f409-908b-420a-8625-12661840b633",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51003",
			"VINA",
			"ZL_VINA_DEL_MAR",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.039026,
		longitude: -71.510107,
		code: "88"
	},
	{
		politicalId: "acc4e596-9f0b-4146-88af-4c187ae5844d",
		name: "CARTAGENA",
		parentPoliticalId: "2058875e-e5ea-4c19-a7c3-5a30115a14d8",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"CART",
			"50803",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "713",
		latitude: -33.55383333333333,
		longitude: -71.60749999999999,
		code: "51"
	},
	{
		politicalId: "cb14b9e6-f3b5-4125-8717-c8294624757f",
		name: "CASABLANCA",
		parentPoliticalId: "b5715f5f-5124-4ce5-8c1c-40f2ad569e48",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51004",
			"CASA",
			"ZL_CASABLANCA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.325,
		longitude: -71.40083333333334,
		code: "52"
	},
	{
		politicalId: "1d92935a-35bc-4a20-b933-48c4fb04ae19",
		name: "CATAPILCO",
		parentPoliticalId: "ddaff0a9-0c97-44f1-8705-5745a476f098",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"ZL_ZAPALLAR",
			"ZAPA",
			"50307",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.570188,
		longitude: -71.278057,
		code: "419"
	},
	{
		politicalId: "c5fd4ecd-6b7e-4cbc-87f8-1e98a9af9aad",
		name: "CATEMU",
		parentPoliticalId: "ba5392da-2404-4da8-9621-2851336e60fa",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50904",
			"CATE",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "16",
		latitude: -32.781,
		longitude: -70.96888888888888,
		code: "53"
	},
	{
		politicalId: "bfc97218-b69c-49a6-a477-7c3015038a40",
		name: "CONCÓN",
		parentPoliticalId: "bd121181-92ad-42e6-87bf-ee2c0304c6b4",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"ZL_CON_CON",
			"CCON",
			"51005",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "90",
		latitude: -32.96,
		longitude: -71.46888888888888,
		code: "54"
	},
	{
		politicalId: "d53d4351-7cf6-42ee-a3a0-75e4a8ab35fd",
		name: "CURAUMA",
		parentPoliticalId: "d3c49b0c-106e-4788-8905-75815dea5403",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51103",
			"VALP",
			"ZL_VALPARAISO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.12274,
		longitude: -71.575656,
		code: "649"
	},
	{
		politicalId: "a94351a6-31cc-4714-b5f8-25d03a5d93e3",
		name: "EL BELLOTO",
		parentPoliticalId: "d4beebdd-482e-4001-8846-26bdba3526ac",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"ELBE",
			"50101",
			"ZL_QUILPUE",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.046754,
		longitude: -71.417055,
		code: "47"
	},
	{
		politicalId: "c3682a9e-6580-4b1a-b9b4-18e5cbe3e31c",
		name: "EL MELÓN",
		parentPoliticalId: "baa5d32a-f0ef-446a-aa3d-7faaf7cc67b0",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"EMEL",
			"ZL_NOGALES",
			"50505",
			"5"
		],
		type: "TOWN",
		priceGroupId: "4",
		latitude: -32.688057,
		longitude: -71.210994,
		code: "55"
	},
	{
		politicalId: "fba89bbc-8edc-4d31-a59b-37f66a35e732",
		name: "EL QUISCO",
		parentPoliticalId: "c83e778e-9867-4071-aee4-d11ba5d67bd6",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50804",
			"QSCO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.39138888888889,
		longitude: -71.68416666666667,
		code: "56"
	},
	{
		politicalId: "4ab67fff-4797-4057-9bc3-3e6730f35c42",
		name: "EL TABO",
		parentPoliticalId: "a7ca157c-e230-4842-a935-77f42558ef98",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"TABO",
			"50805",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.48,
		longitude: -71.62083333333332,
		code: "57"
	},
	{
		politicalId: "08ff9719-49c4-4e55-9c0c-0883d7dc0138",
		name: "EL TOTORAL",
		parentPoliticalId: "c83e778e-9867-4071-aee4-d11ba5d67bd6",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50801",
			"QSCO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.421313,
		longitude: -71.635893,
		code: "56"
	},
	{
		politicalId: "8e1c151c-1d63-4c60-893a-730a0e656c32",
		name: "HIJUELAS",
		parentPoliticalId: "eeb387cc-0f28-4d74-b317-792618c4eb53",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"HIJU",
			"50509",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "4",
		latitude: -32.855,
		longitude: -71.09388888888888,
		code: "58"
	},
	{
		politicalId: "93b31d41-ca99-48d6-ae04-859dcca5a0aa",
		name: "HORCÓN",
		parentPoliticalId: "89a153ba-8cf7-4960-b4e0-73b56ff302e2",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51006",
			"PUCH",
			"ZL_PUCHUNCAVI",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -32.709384,
		longitude: -71.49001,
		code: "74"
	},
	{
		politicalId: "a278c84a-494d-4e40-b7da-1e1c5c477a39",
		name: "ISLA DE PASCUA",
		parentPoliticalId: "a1ae1e47-8b04-4050-8559-1833dc0fb781",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"PASC",
			"50201",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -27.12881111111111,
		longitude: -109.3599444444444,
		code: "59"
	},
	{
		politicalId: "009288b1-f81b-450c-814e-63daf8384c46",
		name: "ISLA NEGRA",
		parentPoliticalId: "c83e778e-9867-4071-aee4-d11ba5d67bd6",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50806",
			"QSCO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.443086,
		longitude: -71.681852,
		code: "56"
	},
	{
		politicalId: "23e1d4e5-bf0f-4dd9-a44e-431cefa74fee",
		name: "JUAN FERNÁNDEZ",
		parentPoliticalId: "bd121181-92ad-42e6-87bf-ee2c0304c6b4",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"JFER",
			"51007",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "96",
		latitude: -33.633,
		longitude: -78.86694444444444,
		code: "60"
	},
	{
		politicalId: "9f30c0da-fa86-4451-bebe-fc6fbd4bb09b",
		name: "LA CALERA",
		parentPoliticalId: "6463a932-7c63-4a04-b907-019cd9df7800",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50508",
			"ZL_CALERA",
			"LACA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "4",
		latitude: -32.784,
		longitude: -71.2038888888889,
		code: "61"
	},
	{
		politicalId: "1fb7c686-b057-4f01-8b54-883977c0785d",
		name: "LA CRUZ",
		parentPoliticalId: "eeb387cc-0f28-4d74-b317-792618c4eb53",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"LACR",
			"50510",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "4",
		latitude: -32.82400000000001,
		longitude: -71.24388888888889,
		code: "62"
	},
	{
		politicalId: "2350be9d-b725-4942-a6e9-bb3d11cd80ce",
		name: "LA LIGUA",
		parentPoliticalId: "77b7e1c3-978f-4944-b1c8-f0f5d361e99e",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"LALI",
			"50305",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.35368888888889,
		longitude: -71.27211111111112,
		code: "63"
	},
	{
		politicalId: "30f759c3-d0ef-41c2-a108-1dd56604dfec",
		name: "LAS CRUCES",
		parentPoliticalId: "a7ca157c-e230-4842-a935-77f42558ef98",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"LCRU",
			"50807",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.49841,
		longitude: -71.622997,
		code: "590"
	},
	{
		politicalId: "069c36fc-caef-49f1-a925-b1e36b074b35",
		name: "LAS DICHAS",
		parentPoliticalId: "b5715f5f-5124-4ce5-8c1c-40f2ad569e48",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50813",
			"CASA",
			"ZL_CASABLANCA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.287419,
		longitude: -71.506409,
		code: "52"
	},
	{
		politicalId: "05233254-8274-4134-945a-b374047090fe",
		name: "LIMACHE",
		parentPoliticalId: "271074c7-054f-4791-851d-574067a2cbc1",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"ZL_LIMACHE",
			"LIMA",
			"50501",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.003,
		longitude: -71.26083333333334,
		code: "64"
	},
	{
		politicalId: "00319e95-411d-42e0-8917-4988b770c74c",
		name: "LIMACHITO",
		parentPoliticalId: "271074c7-054f-4791-851d-574067a2cbc1",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50503",
			"ZL_LIMACHE",
			"LIMA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.001743,
		longitude: -71.278549,
		code: "64"
	},
	{
		politicalId: "61ea4c92-33f6-4ddd-b6b3-a694f08145e8",
		name: "LLAILLAY",
		parentPoliticalId: "ba5392da-2404-4da8-9621-2851336e60fa",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"LLAY",
			"50905",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "16",
		latitude: -32.844,
		longitude: -70.95694444444445,
		code: "65"
	},
	{
		politicalId: "258de86b-794e-4e18-9f40-8a2d768e532e",
		name: "LLOLLEO",
		parentPoliticalId: "edc47fe3-f4fb-4c9c-8d7b-d29bb963af96",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50808",
			"LLOL",
			"SANT",
			"ZL_SAN_ANTONIO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.615644,
		longitude: -71.61407,
		code: "66"
	},
	{
		politicalId: "a2a205b6-ea0d-4029-9aec-017cbee2bedd",
		name: "LO CHAPARRO",
		parentPoliticalId: "271074c7-054f-4791-851d-574067a2cbc1",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50502",
			"ZL_LIMACHE",
			"LIMA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -32.99868,
		longitude: -71.234324,
		code: "64"
	},
	{
		politicalId: "c8e7b766-ace7-401a-94ab-e4e0826b171a",
		name: "LO GAMBOA",
		parentPoliticalId: "271074c7-054f-4791-851d-574067a2cbc1",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50507",
			"ZL_LIMACHE",
			"LIMA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -32.993982,
		longitude: -71.244475,
		code: "64"
	},
	{
		politicalId: "417257f8-4d72-4035-bd1c-84ddd4ae5e21",
		name: "LOS ANDES",
		parentPoliticalId: "efdd8a79-12e5-4fc1-b7c4-f309e243e8cd",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50402",
			"LAND",
			"ZL_LOS_ANDES",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.837,
		longitude: -70.59694444444445,
		code: "67"
	},
	{
		politicalId: "d5b86c64-3f79-44d6-a581-21eee860f3d7",
		name: "LOS MAITENES",
		parentPoliticalId: "271074c7-054f-4791-851d-574067a2cbc1",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50506",
			"ZL_LIMACHE",
			"LIMA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -32.990085,
		longitude: -71.255125,
		code: "64"
	},
	{
		politicalId: "f55fea37-a747-46f1-a610-bae59d44be37",
		name: "MAITENCILLO",
		parentPoliticalId: "89a153ba-8cf7-4960-b4e0-73b56ff302e2",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51008",
			"PUCH",
			"ZL_PUCHUNCAVI",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -32.648761,
		longitude: -71.438241,
		code: "445"
	},
	{
		politicalId: "03a68299-c303-40af-ba44-fac001524fbd",
		name: "MIRASOL",
		parentPoliticalId: "7f66ef09-00ec-47a7-a89d-3b0951a4236c",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51104",
			"ALGA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.328667,
		longitude: -71.645254,
		code: "46"
	},
	{
		politicalId: "ec81de12-dd16-45b5-bba2-fd20b607c0d2",
		name: "NEGRETE",
		parentPoliticalId: "baa5d32a-f0ef-446a-aa3d-7faaf7cc67b0",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"ZL_NOGALES",
			"50505",
			"NOGA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "4",
		latitude: -32.736,
		longitude: -71.20777777777778,
		code: "68"
	},
	{
		politicalId: "baa5d32a-f0ef-446a-aa3d-7faaf7cc67b0",
		name: "NOGALES",
		parentPoliticalId: "eeb387cc-0f28-4d74-b317-792618c4eb53",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"ZL_NOGALES",
			"50505",
			"NOGA",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "4",
		latitude: -32.736,
		longitude: -71.20777777777778,
		code: "68"
	},
	{
		politicalId: "77ae869f-3921-41a5-9c9a-96ccb4e09998",
		name: "OLMUÉ",
		parentPoliticalId: "0443c690-a7ec-4ee0-9ceb-83206b5e4b67",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"OLMU",
			"50511",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "90",
		latitude: -33.009,
		longitude: -71.16694444444445,
		code: "69"
	},
	{
		politicalId: "711ccd7d-78e1-4485-bfa7-3010ea92205f",
		name: "PANQUEHUE",
		parentPoliticalId: "ba5392da-2404-4da8-9621-2851336e60fa",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"PANQ",
			"50906",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "16",
		latitude: -32.784,
		longitude: -70.83694444444444,
		code: "70"
	},
	{
		politicalId: "f25126ba-1a7f-455a-8eb3-bb682c0328f8",
		name: "PAPUDO",
		parentPoliticalId: "0211a107-6de7-4fb3-8b78-28e11bf23699",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50303",
			"PAPU",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.47,
		longitude: -71.38083333333333,
		code: "71"
	},
	{
		politicalId: "80ebdff7-23fd-43f1-90c0-0136682145a6",
		name: "PEDEGUA",
		parentPoliticalId: "891c795a-0326-4c53-ae36-a92f102f7160",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50304",
			"PETO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.357206,
		longitude: -71.069533,
		code: "457"
	},
	{
		politicalId: "eb2e194d-9c9d-42b4-9830-931b80bab4de",
		name: "PEÑABLANCA",
		parentPoliticalId: "dd3b3d51-424e-4fb8-9ddf-f8b81a258c78",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"VALE",
			"51001",
			"ZL_VILLA_ALEMANA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.037156,
		longitude: -71.351834,
		code: "72"
	},
	{
		politicalId: "e4e16de4-3039-4f00-a4e3-df73f2cdcaec",
		name: "PETORCA",
		parentPoliticalId: "891c795a-0326-4c53-ae36-a92f102f7160",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50304",
			"PETO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.29,
		longitude: -70.95,
		code: "73"
	},
	{
		politicalId: "07d0c660-13e6-4e82-b5c6-dd52192b6d64",
		name: "PICHICUY",
		parentPoliticalId: "77b7e1c3-978f-4944-b1c8-f0f5d361e99e",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50308",
			"LALI",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.341047,
		longitude: -71.454448,
		code: "63"
	},
	{
		politicalId: "faa8b5a3-5a08-4b88-a541-a39334abc2c5",
		name: "PLAZA VIEJA",
		parentPoliticalId: "efdd8a79-12e5-4fc1-b7c4-f309e243e8cd",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50401",
			"LAND",
			"ZL_LOS_ANDES",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.827762,
		longitude: -70.650364,
		code: "67"
	},
	{
		politicalId: "6d91281d-caee-46e5-8acc-dd3e0d8ee8a2",
		name: "POCURO",
		parentPoliticalId: "fef90e27-bf73-4bb7-8a04-5688330b2aec",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50406",
			"CALL",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.868938,
		longitude: -70.62299,
		code: "50"
	},
	{
		politicalId: "9f031eef-ba1c-4d1d-92f3-22004a5c1f1f",
		name: "PUCHUNCAVÍ",
		parentPoliticalId: "89a153ba-8cf7-4960-b4e0-73b56ff302e2",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"PUCH",
			"51009",
			"ZL_PUCHUNCAVI",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -32.748,
		longitude: -71.39777777777779,
		code: "74"
	},
	{
		politicalId: "6e458ced-f3ec-4ab9-9fb5-f5dfc8c759d2",
		name: "PUNTA DE TRALCA",
		parentPoliticalId: "c83e778e-9867-4071-aee4-d11ba5d67bd6",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50809",
			"QSCO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.416622,
		longitude: -71.701072,
		code: "56"
	},
	{
		politicalId: "7ba31e7e-3c0d-49fd-8aa5-6f176f4661fb",
		name: "PUTAENDO",
		parentPoliticalId: "ba5392da-2404-4da8-9621-2851336e60fa",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50901",
			"PUTA",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "16",
		latitude: -32.628,
		longitude: -70.71583333333334,
		code: "75"
	},
	{
		politicalId: "94236975-219a-43eb-8f55-60ae71179ef5",
		name: "QUILLOTA",
		parentPoliticalId: "d9ef328d-68b2-45bb-b8da-d1a3f964857c",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"QLTA",
			"ZL_QUILLOTA",
			"50504",
			"5"
		],
		type: "TOWN",
		priceGroupId: "734",
		latitude: -32.915,
		longitude: -71.26388888888889,
		code: "76"
	},
	{
		politicalId: "f172d766-9a08-43c0-9165-2f485f30b2e2",
		name: "QUILPUÉ",
		parentPoliticalId: "d4beebdd-482e-4001-8846-26bdba3526ac",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50601",
			"QUIL",
			"ZL_QUILPUE",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.04751944444444,
		longitude: -71.44247222222222,
		code: "77"
	},
	{
		politicalId: "4a36d154-1e0e-4475-9cce-7c9ff0c6fbb3",
		name: "QUINQUIMO",
		parentPoliticalId: "0211a107-6de7-4fb3-8b78-28e11bf23699",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"LALI",
			"50303",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.443772,
		longitude: -71.315207,
		code: "464"
	},
	{
		politicalId: "2af673e0-38de-41b6-8d18-5b4e63cd197f",
		name: "QUINTAY",
		parentPoliticalId: "b5715f5f-5124-4ce5-8c1c-40f2ad569e48",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51004",
			"CASA",
			"ZL_CASABLANCA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.186477,
		longitude: -71.684891,
		code: "394"
	},
	{
		politicalId: "248c5e56-fd92-4752-ba32-f30dec51810a",
		name: "QUINTERO",
		parentPoliticalId: "bd121181-92ad-42e6-87bf-ee2c0304c6b4",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51010",
			"ZL_QUINTERO",
			"QUIN",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "90",
		latitude: -32.845,
		longitude: -71.46694444444445,
		code: "78"
	},
	{
		politicalId: "3bfc04c4-0102-4c8b-b1f9-ded653243d2b",
		name: "REÑACA",
		parentPoliticalId: "4066f409-908b-420a-8625-12661840b633",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50701",
			"VINA",
			"ZL_VINA_DEL_MAR",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -32.970082,
		longitude: -71.544825,
		code: "79"
	},
	{
		politicalId: "28baf60e-f507-4d4c-984a-7e7e6907d480",
		name: "RINCONADA",
		parentPoliticalId: "3f7f6ae5-5924-4c16-9262-088b838370a5",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"RINC",
			"50403",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "16",
		latitude: -32.83316111111112,
		longitude: -70.6883888888889,
		code: "80"
	},
	{
		politicalId: "33019291-2afb-4301-b037-5064b2bf264f",
		name: "RODELILLO",
		parentPoliticalId: "d3c49b0c-106e-4788-8905-75815dea5403",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51012",
			"VALP",
			"ZL_VALPARAISO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.066019,
		longitude: -71.558321,
		code: "542"
	},
	{
		politicalId: "e851d500-eeed-4363-861f-b013404c286b",
		name: "SAN ALFONSO DEL MAR",
		parentPoliticalId: "7f66ef09-00ec-47a7-a89d-3b0951a4236c",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50810",
			"ALGA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.35022,
		longitude: -71.652463,
		code: "46"
	},
	{
		politicalId: "9fd13a84-b620-42d1-9925-0fa6102be5b1",
		name: "SAN ANTONIO",
		parentPoliticalId: "edc47fe3-f4fb-4c9c-8d7b-d29bb963af96",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"SANT",
			"50811",
			"ZL_SAN_ANTONIO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "713",
		latitude: -33.59472222222222,
		longitude: -71.60722222222222,
		code: "81"
	},
	{
		politicalId: "414cc47b-0952-4807-a880-15bb96d4eb65",
		name: "SAN ESTEBAN",
		parentPoliticalId: "3f7f6ae5-5924-4c16-9262-088b838370a5",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50404",
			"SEST",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "16",
		latitude: -32.805,
		longitude: -70.58083333333333,
		code: "82"
	},
	{
		politicalId: "c5a8890c-7e19-4faa-9619-8bf3ad97f23f",
		name: "SAN FELIPE",
		parentPoliticalId: "ba5392da-2404-4da8-9621-2851336e60fa",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"ZL_SAN_FELIPE",
			"50902",
			"SFEL",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "16",
		latitude: -32.75,
		longitude: -70.71277777777777,
		code: "83"
	},
	{
		politicalId: "f6c84bac-7ef1-426e-bdb8-f52b9b5a9147",
		name: "SAN PEDRO DE LIMACHE",
		parentPoliticalId: "d9ef328d-68b2-45bb-b8da-d1a3f964857c",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"QLTA",
			"ZL_QUILLOTA",
			"50504",
			"5"
		],
		type: "TOWN",
		priceGroupId: "734",
		latitude: -32.939727,
		longitude: -71.277052,
		code: "543"
	},
	{
		politicalId: "edfaff84-bbfd-4a33-be14-a1391f9cdf58",
		name: "SANTA MARÍA",
		parentPoliticalId: "ba5392da-2404-4da8-9621-2851336e60fa",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"SMAR",
			"50903",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "16",
		latitude: -32.75033333333333,
		longitude: -70.66694444444445,
		code: "85"
	},
	{
		politicalId: "db4582b1-4b29-4057-ae5b-23e26c90096e",
		name: "SANTO DOMINGO",
		parentPoliticalId: "2058875e-e5ea-4c19-a7c3-5a30115a14d8",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"50812",
			"SDGO",
			"5"
		],
		type: "DISTRICT",
		priceGroupId: "713",
		latitude: -33.70800000000001,
		longitude: -71.61777777777777,
		code: "86"
	},
	{
		politicalId: "9435d7a0-cc11-47c0-8908-58b5d56ac54d",
		name: "VALPARAÍSO",
		parentPoliticalId: "d3c49b0c-106e-4788-8905-75815dea5403",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51012",
			"VALP",
			"ZL_VALPARAISO",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.05,
		longitude: -71.61583333333333,
		code: "87"
	},
	{
		politicalId: "379ab3d4-dae9-4817-997f-4d74287f17aa",
		name: "VENTANAS",
		parentPoliticalId: "89a153ba-8cf7-4960-b4e0-73b56ff302e2",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"PUCH",
			"51009",
			"ZL_PUCHUNCAVI",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -32.74202,
		longitude: -71.488071,
		code: "536"
	},
	{
		politicalId: "cfd555c7-efd2-4d4b-94e7-847d2e41fdf1",
		name: "VILLA ALEMANA",
		parentPoliticalId: "dd3b3d51-424e-4fb8-9ddf-f8b81a258c78",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"VALE",
			"51001",
			"ZL_VILLA_ALEMANA",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.066,
		longitude: -71.32888888888888,
		code: "89"
	},
	{
		politicalId: "9d9c140d-f490-49c7-81b2-c7662f624421",
		name: "VIÑA DEL MAR",
		parentPoliticalId: "4066f409-908b-420a-8625-12661840b633",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"51101",
			"VINA",
			"ZL_VINA_DEL_MAR",
			"5"
		],
		type: "TOWN",
		priceGroupId: "90",
		latitude: -33.025,
		longitude: -71.50138888888888,
		code: "88"
	},
	{
		politicalId: "8e63a851-5890-4995-a123-4508d2509896",
		name: "ZAPALLAR",
		parentPoliticalId: "ddaff0a9-0c97-44f1-8705-5745a476f098",
		parentStateId: "48b4a271-8bc0-465b-bb6f-381b943ae624",
		parentStateName: "VALPARAÍSO",
		zones: [
			"ZL_ZAPALLAR",
			"ZAPA",
			"50307",
			"5"
		],
		type: "TOWN",
		priceGroupId: "16",
		latitude: -32.568,
		longitude: -71.43777777777778,
		code: "90"
	}
];
var valparaiso = {
	data: data$k
};

var districtsCL = {
  '70b1febe-fd2c-4ae7-bdb6-167976826b1a': antofagasta,
  'd86e5095-af2e-4da3-b3ee-27ef2bad8772': araucania,
  '6d6996df-6428-4a38-91e8-735b8fe727ad': arica,
  'b83e9641-cc4e-48c0-8638-42f1a4c9d3db': atacama,
  '21999b34-d273-4b67-9ae1-ad5880644ea4': aysen,
  '9573e7f4-77d7-4c1b-8d75-e9dc2bdcc91b': biobio,
  '73c626ec-e662-4777-83a2-576f60963d87': coquimbo,
  '1bf237ff-3120-4fd6-b6ac-7c74e4cb9b70': libertador,
  '5e89ced2-fde6-465e-8d25-527d83acb41d': losLagos,
  'f8351488-0741-4c3f-a455-5008a7f81e57': losRios,
  '26a00517-eb4e-46ea-bf0d-438d7f075863': magallanes,
  '77d9e536-ce23-436f-aa4f-5799edccd004': maule,
  'a768f0a2-bb5d-4d51-8cad-03b48b25c4a4': metropolitana,
  '3b7c88cb-8cd4-4510-972a-1b625479b7f4': nuble,
  '38798c03-241c-44f4-bbfa-8c1264ab3fff': tarapaca,
  '48b4a271-8bc0-465b-bb6f-381b943ae624': valparaiso
};

var data$l = [
	{
		type: "STATE",
		id: "10000",
		code: "10000",
		politicalId: "d194932b-c762-4015-bfce-f33abb721722",
		name: "AMAZONAS"
	},
	{
		type: "STATE",
		id: "20000",
		code: "20000",
		politicalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		name: "ÁNCASH"
	},
	{
		type: "STATE",
		id: "30000",
		code: "30000",
		politicalId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		name: "APURÍMAC"
	},
	{
		type: "STATE",
		id: "40000",
		code: "40000",
		politicalId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		name: "AREQUIPA"
	},
	{
		type: "STATE",
		id: "50000",
		code: "50000",
		politicalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		name: "AYACUCHO"
	},
	{
		type: "STATE",
		id: "60000",
		code: "60000",
		politicalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		name: "CAJAMARCA"
	},
	{
		type: "STATE",
		id: "150000",
		code: "150000",
		politicalId: "0645d9b2-b706-4047-8615-721aff7cc891",
		name: "CALLAO"
	},
	{
		type: "STATE",
		id: "80000",
		code: "80000",
		politicalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		name: "CUSCO"
	},
	{
		type: "STATE",
		id: "90000",
		code: "90000",
		politicalId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		name: "HUANCAVELICA"
	},
	{
		type: "STATE",
		id: "100000",
		code: "100000",
		politicalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		name: "HUÁNUCO"
	},
	{
		type: "STATE",
		id: "110000",
		code: "110000",
		politicalId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		name: "ICA"
	},
	{
		type: "STATE",
		id: "120000",
		code: "120000",
		politicalId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		name: "JUNÍN"
	},
	{
		type: "STATE",
		id: "130000",
		code: "130000",
		politicalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		name: "LA LIBERTAD"
	},
	{
		type: "STATE",
		id: "140000",
		code: "140000",
		politicalId: "58b2133e-d2a1-4878-99f2-caf0357cc6fe",
		name: "LAMBAYEQUE"
	},
	{
		type: "STATE",
		id: "150000",
		code: "150000",
		politicalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		name: "LIMA"
	},
	{
		type: "STATE",
		id: "",
		code: "",
		politicalId: "418cca57-a8ca-4b83-a92c-cda22bab52d4",
		name: "LORETO"
	},
	{
		type: "STATE",
		id: "",
		code: "",
		politicalId: "1eca5d7d-367a-4a3b-91dc-ad86a2bbe85c",
		name: "MADRE DE DIOS"
	},
	{
		type: "STATE",
		id: "180000",
		code: "180000",
		politicalId: "0d31cbc1-501f-4713-bef8-e1fabd88981d",
		name: "MOQUEGUA"
	},
	{
		type: "STATE",
		id: "190000",
		code: "190000",
		politicalId: "60a17fa3-efef-4262-a82c-b00e429c9bbb",
		name: "PASCO"
	},
	{
		type: "STATE",
		id: "200000",
		code: "200000",
		politicalId: "d2f08b0b-0b99-4aea-8bcf-4bcfc06e8fc6",
		name: "PIURA"
	},
	{
		type: "STATE",
		id: "210000",
		code: "210000",
		politicalId: "34827cc4-9e86-499c-920f-8c253b0dbc81",
		name: "PUNO"
	},
	{
		type: "STATE",
		id: "220000",
		code: "220000",
		politicalId: "5e2d5236-b4b4-4970-a849-512cbad6cf33",
		name: "SAN MARTÍN"
	},
	{
		type: "STATE",
		id: "230000",
		code: "230000",
		politicalId: "c202c4db-847d-442f-85a0-a0b392672b52",
		name: "TACNA"
	},
	{
		type: "STATE",
		id: "240000",
		code: "240000",
		politicalId: "46d124d2-60ba-469a-bea6-45c8712283e1",
		name: "TUMBES"
	},
	{
		type: "STATE",
		id: "250000",
		code: "250000",
		politicalId: "486639bd-ae9c-41e8-958c-6af5cbcf6432",
		name: "UCAYALI"
	}
];
var statesPE = {
	data: data$l,
	"default": {
	name: "Seleccion ubicacion",
	politicalId: "799c102f-9b4c-44be-a421-23e366a63b82",
	priceGroupId: "2",
	zones: [
		"150000",
		"180000"
	]
}
};

var data$m = [
	{
		politicalId: "3af630ed-6385-452e-936f-4bf97d01cff3",
		name: "BARRANCA",
		parentPoliticalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		type: "COUNTY",
		latitude: -10.752952839157075,
		longitude: -77.75756336147847,
		code: ""
	},
	{
		politicalId: "15c412f1-92c7-4689-8f33-87a486df12e2",
		name: "CAJATAMBO",
		parentPoliticalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		type: "COUNTY",
		latitude: -10.475174910738868,
		longitude: -76.99512937835928,
		code: ""
	},
	{
		politicalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		name: "CAÑETE",
		parentPoliticalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		type: "COUNTY",
		latitude: -13.080639727938953,
		longitude: -76.38573489721276,
		code: "150400"
	},
	{
		politicalId: "c84741dd-b81c-4672-9cfc-eb652ca6859b",
		name: "CANTA",
		parentPoliticalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		type: "COUNTY",
		latitude: -11.469599607147385,
		longitude: -76.62959698848637,
		code: ""
	},
	{
		politicalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		name: "HUARAL",
		parentPoliticalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		type: "COUNTY",
		latitude: -11.501182629664411,
		longitude: -77.20455190009093,
		code: "150800"
	},
	{
		politicalId: "6076c229-7d22-458f-912d-0957d552e37f",
		name: "HUAROCHIRÍ",
		parentPoliticalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		type: "COUNTY",
		latitude: -11.7534192567894,
		longitude: -76.30146973091436,
		code: ""
	},
	{
		politicalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		name: "HUAURA",
		parentPoliticalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		type: "COUNTY",
		latitude: -11.067860051649598,
		longitude: -77.6004715139915,
		code: ""
	},
	{
		politicalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		name: "LIMA",
		parentPoliticalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		type: "COUNTY",
		latitude: -12.043027415547202,
		longitude: -77.04365450940945,
		code: "150100"
	},
	{
		politicalId: "493ad5fd-2f33-443d-b790-0736d85e029d",
		name: "OYÓN",
		parentPoliticalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		type: "COUNTY",
		latitude: -10.66136783762911,
		longitude: -76.77452336390728,
		code: ""
	},
	{
		politicalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		name: "YAUYOS",
		parentPoliticalId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		type: "COUNTY",
		latitude: -12.455466575820685,
		longitude: -75.92346483932835,
		code: "150700"
	}
];
var lima = {
	data: data$m
};

var data$n = [
	{
		politicalId: "869fd2a7-4b1e-4c32-9cbd-e73fb767754c",
		name: "BAGUA",
		parentPoliticalId: "d194932b-c762-4015-bfce-f33abb721722",
		parentStateId: "d194932b-c762-4015-bfce-f33abb721722",
		type: "COUNTY",
		latitude: -5.638534683423873,
		longitude: -78.52927787037521,
		code: "10200"
	},
	{
		politicalId: "f233bdf0-5ba2-40f4-82e4-dfb711e3ba5b",
		name: "BONGARÁ",
		parentPoliticalId: "d194932b-c762-4015-bfce-f33abb721722",
		parentStateId: "d194932b-c762-4015-bfce-f33abb721722",
		type: "COUNTY",
		latitude: -5.942726712485535,
		longitude: -77.975116058171,
		code: ""
	},
	{
		politicalId: "8be7f8f4-33d1-49f2-8021-fe6ae9fc5845",
		name: "CHACHAPOYAS",
		parentPoliticalId: "d194932b-c762-4015-bfce-f33abb721722",
		parentStateId: "d194932b-c762-4015-bfce-f33abb721722",
		type: "COUNTY",
		latitude: -6.233297476811688,
		longitude: -77.86720876916651,
		code: "10100"
	},
	{
		politicalId: "cae86c51-cfe1-4124-a93c-734800082e1c",
		name: "CONDORCANQUI",
		parentPoliticalId: "d194932b-c762-4015-bfce-f33abb721722",
		parentStateId: "d194932b-c762-4015-bfce-f33abb721722",
		type: "COUNTY",
		latitude: -4.5709246854298495,
		longitude: -77.85500223123577,
		code: ""
	},
	{
		politicalId: "56b24cbe-6395-45e6-826e-f8dd7d2ab4ea",
		name: "LUYA",
		parentPoliticalId: "d194932b-c762-4015-bfce-f33abb721722",
		parentStateId: "d194932b-c762-4015-bfce-f33abb721722",
		type: "COUNTY",
		latitude: -6.1410020300119355,
		longitude: -77.97416742932874,
		code: "10400"
	},
	{
		politicalId: "02a2fd6f-de6b-44c3-b952-82af08e8ebc2",
		name: "RODRÍGUEZ DE MENDOZA",
		parentPoliticalId: "d194932b-c762-4015-bfce-f33abb721722",
		parentStateId: "d194932b-c762-4015-bfce-f33abb721722",
		type: "COUNTY",
		latitude: -6.395699388838293,
		longitude: -77.46444157631313,
		code: ""
	},
	{
		politicalId: "29f33450-4a9f-48be-87bc-95fb6668d48a",
		name: "UTCUBAMBA",
		parentPoliticalId: "d194932b-c762-4015-bfce-f33abb721722",
		parentStateId: "d194932b-c762-4015-bfce-f33abb721722",
		type: "COUNTY",
		latitude: -5.735715763565752,
		longitude: -78.45388071932275,
		code: ""
	}
];
var amazonas = {
	data: data$n
};

var data$o = [
	{
		politicalId: "a516fced-6623-4d31-9de3-c582a6ec7f4c",
		name: "AIJA",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.788751524150323,
		longitude: -77.61309574996802,
		code: ""
	},
	{
		politicalId: "ab86164c-fdf0-493a-b411-33a4519024ae",
		name: "ANTONIO RAIMONDI",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.121966520490604,
		longitude: -76.99822187593044,
		code: ""
	},
	{
		politicalId: "54d7e1fe-add3-44ad-81c6-688b53a73315",
		name: "ASUNCIÓN",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.168648117197344,
		longitude: -77.37724504322514,
		code: ""
	},
	{
		politicalId: "e91d0ddd-2b94-4c3f-956c-9a37d70663b4",
		name: "BOLOGNESI",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -10.107164770658782,
		longitude: -77.18276127261038,
		code: ""
	},
	{
		politicalId: "1ff4b409-b641-4226-ae68-ff16411842b8",
		name: "CARHUAZ",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.29673650797583,
		longitude: -77.65471591688274,
		code: ""
	},
	{
		politicalId: "844b98a1-6355-404f-9717-e37144818d7b",
		name: "CARLOS FERMÍN FITZCARRALD",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.091270803808433,
		longitude: -77.31669898153346,
		code: ""
	},
	{
		politicalId: "0161ac9d-cbea-452f-882f-839032f3f750",
		name: "CASMA",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.478759222981234,
		longitude: -78.28810922405992,
		code: ""
	},
	{
		politicalId: "da680c35-0e9a-44fa-b3be-18a0ad5d6eb4",
		name: "CORONGO",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -8.578986363292431,
		longitude: -77.90760607325319,
		code: ""
	},
	{
		politicalId: "5dc8e713-4742-4c15-93af-ec0718a692bc",
		name: "HUARAZ",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.513390218963062,
		longitude: -77.50246406464738,
		code: "20100"
	},
	{
		politicalId: "29a695bf-e07c-44d4-b7d8-dac3e29556b0",
		name: "HUARI",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.349871023970456,
		longitude: -77.16766319309805,
		code: ""
	},
	{
		politicalId: "b9ba9ea0-8617-4bd9-bc7a-23293833504c",
		name: "HUARMEY",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -10.040410221190891,
		longitude: -78.15600289125136,
		code: ""
	},
	{
		politicalId: "bf6e5d78-a2b6-488c-876d-592f2924df11",
		name: "HUAYLAS",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -8.879251862272378,
		longitude: -77.88465722343334,
		code: ""
	},
	{
		politicalId: "117e7e55-b7c7-42ae-a119-174a617f05bf",
		name: "MARISCAL LUZURIAGA",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -8.867881591078062,
		longitude: -77.35772608778841,
		code: "21400"
	},
	{
		politicalId: "300ddf51-7e1e-4631-9e15-e89cc26182f1",
		name: "OCROS",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -10.639132995810096,
		longitude: -77.55442561823112,
		code: ""
	},
	{
		politicalId: "b5bddace-91ef-43bd-9fb4-f32d2b65addd",
		name: "PALLASCA",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -8.251078827294277,
		longitude: -78.01545728514121,
		code: ""
	},
	{
		politicalId: "f464682b-0ef9-4cc9-b517-78356e9056b5",
		name: "POMABAMBA",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -8.81802955574102,
		longitude: -77.46681911429044,
		code: "21000"
	},
	{
		politicalId: "b34e1684-1c71-41ad-8f76-966e55158d10",
		name: "RECUAY",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.725930330416306,
		longitude: -77.45192259007116,
		code: "21100"
	},
	{
		politicalId: "18a8db5c-c487-4e72-b246-e88ea7b02030",
		name: "SANTA",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.072399695431617,
		longitude: -78.56839696650715,
		code: "21200"
	},
	{
		politicalId: "336a3c53-204a-4768-8daf-279ee7b93ed9",
		name: "SIHUAS",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -8.552688688308923,
		longitude: -77.63278423909458,
		code: ""
	},
	{
		politicalId: "f2d4bb1a-7010-4d8a-8d94-a8f1d3fab2c9",
		name: "YUNGAY",
		parentPoliticalId: "6f47ba65-b917-4053-af63-770210c80ff9",
		parentStateId: "6f47ba65-b917-4053-af63-770210c80ff9",
		type: "COUNTY",
		latitude: -9.146587878262233,
		longitude: -77.74558906223567,
		code: ""
	}
];
var ancash = {
	data: data$o
};

var data$p = [
	{
		politicalId: "f5af0031-ae87-4edd-a546-26478bb00daf",
		name: "ABANCAY",
		parentPoliticalId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		parentStateId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		type: "COUNTY",
		latitude: -13.638347723484253,
		longitude: -72.8936320065582,
		code: "30100"
	},
	{
		politicalId: "d6602a1e-893f-4562-bf2b-417634cfca3d",
		name: "ANDAHUAYLAS",
		parentPoliticalId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		parentStateId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		type: "COUNTY",
		latitude: -13.634035571257625,
		longitude: -73.35250206948128,
		code: "30200"
	},
	{
		politicalId: "60bfbe5a-d29b-4d8b-af33-de131e376919",
		name: "ANTABAMBA",
		parentPoliticalId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		parentStateId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		type: "COUNTY",
		latitude: -14.35810645422097,
		longitude: -72.87779245634734,
		code: ""
	},
	{
		politicalId: "c8786337-eda8-48df-ac43-4d43cd2d015d",
		name: "AYMARAES",
		parentPoliticalId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		parentStateId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		type: "COUNTY",
		latitude: -14.274222359539765,
		longitude: -73.26368864302837,
		code: ""
	},
	{
		politicalId: "1e7bde82-14d2-4839-a548-5f020183daf0",
		name: "CHINCHEROS",
		parentPoliticalId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		parentStateId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		type: "COUNTY",
		latitude: -13.538507345527673,
		longitude: -73.67955793286752,
		code: ""
	},
	{
		politicalId: "5b96c4b6-1c2e-471f-8f04-58792ed4347e",
		name: "COTABAMBAS",
		parentPoliticalId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		parentStateId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		type: "COUNTY",
		latitude: -14.100608397158522,
		longitude: -72.25505545756796,
		code: ""
	},
	{
		politicalId: "dd358b19-941c-445a-8cdd-974e39179ac6",
		name: "GRAU",
		parentPoliticalId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		parentStateId: "699fe048-0283-4a1f-b3f1-536ed91559ec",
		type: "COUNTY",
		latitude: -14.106470268563188,
		longitude: -72.71150703233194,
		code: ""
	}
];
var apurimac = {
	data: data$p
};

var data$q = [
	{
		politicalId: "1803bbce-bec1-44ac-a1a0-97964e94059f",
		name: "AREQUIPA",
		parentPoliticalId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		parentStateId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		type: "COUNTY",
		latitude: -16.39100699521703,
		longitude: -71.50304449217496,
		code: "40100"
	},
	{
		politicalId: "d1de0420-48ef-4012-8d66-62f416a70b33",
		name: "CAMANÁ",
		parentPoliticalId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		parentStateId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		type: "COUNTY",
		latitude: -16.58700464823727,
		longitude: -72.7377006636363,
		code: "40200"
	},
	{
		politicalId: "687a64f4-196c-4162-844e-7d046ab677aa",
		name: "CARAVELÍ",
		parentPoliticalId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		parentStateId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		type: "COUNTY",
		latitude: -15.814137934632907,
		longitude: -74.2916965061464,
		code: "40300"
	},
	{
		politicalId: "61a3096b-91bf-467f-9ec5-0df890566cc1",
		name: "CASTILLA",
		parentPoliticalId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		parentStateId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		type: "COUNTY",
		latitude: -16.043443412055154,
		longitude: -72.51573091308232,
		code: "40400"
	},
	{
		politicalId: "610eee89-c96b-441a-8e65-496cb1ccad3f",
		name: "CAYLLOMA",
		parentPoliticalId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		parentStateId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		type: "COUNTY",
		latitude: -15.647923249446348,
		longitude: -71.5355828525225,
		code: "40500"
	},
	{
		politicalId: "1ab18408-b5c8-4698-9c21-d7facb49311b",
		name: "CONDESUYOS",
		parentPoliticalId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		parentStateId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		type: "COUNTY",
		latitude: -15.821934642139407,
		longitude: -72.65062171381251,
		code: ""
	},
	{
		politicalId: "9dc59433-bbcf-40f1-b2a1-d677160f315c",
		name: "ISLAY",
		parentPoliticalId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		parentStateId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		type: "COUNTY",
		latitude: -17.16981793734841,
		longitude: -71.79406060611211,
		code: "40700"
	},
	{
		politicalId: "b44806c0-46dd-4c00-9fa0-37b720271fe3",
		name: "LA UNIÓN",
		parentPoliticalId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		parentStateId: "019adee1-9a4f-46c4-9e20-32f650e2dd29",
		type: "COUNTY",
		latitude: -15.20063871861058,
		longitude: -72.87412957577017,
		code: ""
	}
];
var arequipa = {
	data: data$q
};

var data$r = [
	{
		politicalId: "92117962-eec4-41ed-b697-1a0c5a4b4685",
		name: "CANGALLO",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -13.558813270351482,
		longitude: -74.1954370979236,
		code: "50200"
	},
	{
		politicalId: "ff6f78d4-18d5-4f62-8bb8-c191e0ee6b08",
		name: "HUAMANGA",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -13.165410906451203,
		longitude: -74.22495178304493,
		code: "50100"
	},
	{
		politicalId: "2fe79b78-e1b2-4660-bb2e-afed838a87b5",
		name: "HUANCA SANCOS",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -13.932280103909338,
		longitude: -74.31783433281001,
		code: ""
	},
	{
		politicalId: "4e91be14-7322-42fa-b085-ccc33602300d",
		name: "HUANTA",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -12.939779695160059,
		longitude: -74.25507642477413,
		code: "50300"
	},
	{
		politicalId: "23822616-c04a-4ad1-9717-3509d0987c36",
		name: "LA MAR",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -12.947086390430123,
		longitude: -74.02030203339227,
		code: ""
	},
	{
		politicalId: "e0f77e62-3148-41c6-aa9c-d0a66e97b2f0",
		name: "LUCANAS",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -14.66230757365075,
		longitude: -74.15516398050816,
		code: "50500"
	},
	{
		politicalId: "0f5d75ba-2843-4cb7-a162-87c47b7627c2",
		name: "PARINACOCHAS",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -15.047231738729165,
		longitude: -73.76996369355624,
		code: "50600"
	},
	{
		politicalId: "6f6a0efc-433a-4932-a97d-12c91b42117b",
		name: "PÁUCAR DEL SARA SARA",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -15.179091647513165,
		longitude: -73.28743727788107,
		code: ""
	},
	{
		politicalId: "25ccc29f-cd4c-4bb4-9bd9-27a7f1d69fff",
		name: "SUCRE",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -14.035905478187791,
		longitude: -73.8347313322165,
		code: ""
	},
	{
		politicalId: "81725b56-3491-42c2-a45a-0941ff074e24",
		name: "VÍCTOR FAJARDO",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -13.718704157014418,
		longitude: -74.09239008794648,
		code: ""
	},
	{
		politicalId: "5912bff6-0a24-4f2d-a055-1a544f408f55",
		name: "VILCAS HUAMÁN",
		parentPoliticalId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		parentStateId: "6f58c0d0-ecec-4108-a162-5c0a9ee0194e",
		type: "COUNTY",
		latitude: -13.656948741309547,
		longitude: -73.9359082440107,
		code: ""
	}
];
var ayacucho = {
	data: data$r
};

var data$s = [
	{
		politicalId: "d33357e6-e94a-4698-bcb6-b01480df6a78",
		name: "CAJABAMBA",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -7.610310876589497,
		longitude: -78.05916707987485,
		code: ""
	},
	{
		politicalId: "6d02c2f3-c551-4985-a4ed-1d676e06b465",
		name: "CAJAMARCA",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -7.155670597624078,
		longitude: -78.52270760168699,
		code: "60100"
	},
	{
		politicalId: "ae46e01d-47d0-4677-8fc3-1a789a452a70",
		name: "CELENDÍN",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -6.874215010926279,
		longitude: -78.1399058509166,
		code: ""
	},
	{
		politicalId: "e3c64b44-1c81-41fb-bfb6-cd5a8a25883d",
		name: "CHOTA",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -6.559010169403877,
		longitude: -78.64059783420028,
		code: ""
	},
	{
		politicalId: "0dfaf029-b048-42ef-9cef-5956f8420fa4",
		name: "CONTUMAZÁ",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -7.364806214566245,
		longitude: -78.81405135682029,
		code: ""
	},
	{
		politicalId: "78618586-4334-4e02-96ea-d39147776243",
		name: "CUTERVO",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -6.33911296056825,
		longitude: -78.8046993301193,
		code: "60500"
	},
	{
		politicalId: "c89cedd3-218b-456a-b3cc-d296448f6e61",
		name: "HUALGAYOC",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -6.746216983926167,
		longitude: -78.59897226482637,
		code: ""
	},
	{
		politicalId: "b4f45748-1960-4fed-aeb3-9596ae7eb5b7",
		name: "JAÉN",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -5.668287710458843,
		longitude: -78.80737315334933,
		code: "60800"
	},
	{
		politicalId: "7939bd9b-1139-4371-a7ae-28ad8c3d2d7e",
		name: "SAN IGNACIO",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -5.122435270029509,
		longitude: -79.02334273542944,
		code: ""
	},
	{
		politicalId: "c29a5bf2-ecb0-4d68-91b6-d99b804f35c4",
		name: "SAN MARCOS",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -7.3294362536276445,
		longitude: -78.1625709218107,
		code: ""
	},
	{
		politicalId: "cc23e183-9392-4329-a2ac-b0ac933945d7",
		name: "SAN MIGUEL",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -6.9942814447185695,
		longitude: -78.8885931648765,
		code: ""
	},
	{
		politicalId: "2ab5d813-f253-49e3-96f0-c89b7a691ad1",
		name: "SAN PABLO",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -7.112834081841626,
		longitude: -78.81960610411488,
		code: ""
	},
	{
		politicalId: "7b55f057-17ff-48d4-8eb8-ac19dd5ad3be",
		name: "SANTA CRUZ",
		parentPoliticalId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		parentStateId: "fbeea2fc-e10b-4860-a548-a6c8ad87b463",
		type: "COUNTY",
		latitude: -6.622819036705698,
		longitude: -78.9501606082467,
		code: "60900"
	}
];
var cajamarca = {
	data: data$s
};

var data$t = [
	{
		politicalId: "b2c2da13-8a47-4786-8529-93935366172b",
		name: "CALLAO",
		parentPoliticalId: "0645d9b2-b706-4047-8615-721aff7cc891",
		parentStateId: "0645d9b2-b706-4047-8615-721aff7cc891",
		type: "COUNTY",
		latitude: -12.051707021722612,
		longitude: -77.12743609841627,
		code: "70100"
	}
];
var callao = {
	data: data$t
};

var data$u = [
	{
		politicalId: "f3b858a1-d803-426c-adaa-b9b77764757f",
		name: "ACOMAYO",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -13.920153355061215,
		longitude: -71.67970973464625,
		code: ""
	},
	{
		politicalId: "d1b11af0-3c00-490c-8919-31d5ec4bebc0",
		name: "ANTA",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -13.469950382293089,
		longitude: -72.15641381148993,
		code: "80300"
	},
	{
		politicalId: "0605bb33-4283-4113-aac4-809fcd0d2070",
		name: "CALCA",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -13.326066917939265,
		longitude: -71.97287324476697,
		code: "80400"
	},
	{
		politicalId: "5f51211a-83ce-4633-a69d-5852b245729f",
		name: "CANAS",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -14.53163083833416,
		longitude: -71.31214122289212,
		code: "80500"
	},
	{
		politicalId: "2aeb1fb0-2d51-4cbc-aaf1-5d087471c24c",
		name: "CANCHIS",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -14.248865767788477,
		longitude: -71.21087527339029,
		code: ""
	},
	{
		politicalId: "ca9c6046-b872-40e0-a5cd-f52078fc7886",
		name: "CHUMBIVILCAS",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -14.449093004256312,
		longitude: -72.08406912713941,
		code: ""
	},
	{
		politicalId: "974097ef-3bec-40b2-9ec9-26d24ab37ca3",
		name: "CUZCO",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -13.522694842708447,
		longitude: -71.96726869756583,
		code: "80100"
	},
	{
		politicalId: "aa81ad2e-54f1-4560-9296-f20843ba8ff1",
		name: "ESPINAR",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -14.75749867603363,
		longitude: -71.38302558102544,
		code: ""
	},
	{
		politicalId: "86bccab6-5508-4674-a677-4d03b5704134",
		name: "LA CONVENCIÓN",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -12.837035111049802,
		longitude: -72.71642163232234,
		code: ""
	},
	{
		politicalId: "3cbe0855-8138-4be9-8424-345e9f0a013b",
		name: "PARURO",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -13.757766036936042,
		longitude: -71.86131403157947,
		code: "81000"
	},
	{
		politicalId: "25f49a4e-4081-4fa0-82f6-9ba6bed6e762",
		name: "PAUCARTAMBO",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -13.31422615672017,
		longitude: -71.5868261330918,
		code: ""
	},
	{
		politicalId: "e745580b-938e-4433-b4c0-8d5a16222956",
		name: "QUISPICANCHI",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -13.683287277921382,
		longitude: -71.62952541844825,
		code: "81200"
	},
	{
		politicalId: "0f5886a1-eab2-440f-9dee-8ea634ad0c50",
		name: "URUBAMBA",
		parentPoliticalId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		parentStateId: "9fd2a8dd-6a13-4ac3-b018-c63d643359c8",
		type: "COUNTY",
		latitude: -13.297295258016293,
		longitude: -72.12310616026288,
		code: "81300"
	}
];
var cusco = {
	data: data$u
};

var data$v = [
	{
		politicalId: "ad10f1b3-cee3-443b-a2ab-0658b11c258f",
		name: "ACOBAMBA",
		parentPoliticalId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		parentStateId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		type: "COUNTY",
		latitude: -12.864274468246444,
		longitude: -74.5853375245678,
		code: ""
	},
	{
		politicalId: "ba2c3f04-2461-4fe0-8b42-74fe9a800ec2",
		name: "ANGARAES",
		parentPoliticalId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		parentStateId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		type: "COUNTY",
		latitude: -12.995917978085746,
		longitude: -74.73685667358451,
		code: ""
	},
	{
		politicalId: "fc82ee14-65a0-4623-a675-146f32205161",
		name: "CASTROVIRREYNA",
		parentPoliticalId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		parentStateId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		type: "COUNTY",
		latitude: -13.276485582261584,
		longitude: -75.32112516495626,
		code: ""
	},
	{
		politicalId: "e4c62477-fa8f-46e7-b497-65b25079e918",
		name: "CHURCAMPA",
		parentPoliticalId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		parentStateId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		type: "COUNTY",
		latitude: -12.747890400325385,
		longitude: -74.4095310585867,
		code: ""
	},
	{
		politicalId: "b36a40bc-b552-4e16-b18b-5a31a75cd190",
		name: "HUANCAVELICA",
		parentPoliticalId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		parentStateId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		type: "COUNTY",
		latitude: -12.767693442084907,
		longitude: -74.99194181205579,
		code: "90100"
	},
	{
		politicalId: "149134a9-133d-493a-a2eb-ad8deae997c4",
		name: "HUAYTARÁ",
		parentPoliticalId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		parentStateId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		type: "COUNTY",
		latitude: -13.608519675434273,
		longitude: -75.36252828130864,
		code: ""
	},
	{
		politicalId: "a9bf156d-8d3b-47ac-b46c-011f56383954",
		name: "TAYACAJA",
		parentPoliticalId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		parentStateId: "f63f7140-f4ab-4e7c-ae76-4e6b7537cf52",
		type: "COUNTY",
		latitude: -12.407277965442097,
		longitude: -74.87475796693016,
		code: ""
	}
];
var huancavalica = {
	data: data$v
};

var data$w = [
	{
		politicalId: "bafa452b-3145-4034-86ca-2d42a71e4c26",
		name: "AMBO",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -10.136493504131854,
		longitude: -76.2012588124644,
		code: "100200"
	},
	{
		politicalId: "ce5f72a0-eec0-4344-a1ad-698e6726414c",
		name: "DOS DE MAYO",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -9.82386055875334,
		longitude: -76.80454359144689,
		code: ""
	},
	{
		politicalId: "9c927770-c5bc-4266-9fd1-d175f89d0d9a",
		name: "HUACAYBAMBA",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -8.99942183317098,
		longitude: -76.95916491155293,
		code: ""
	},
	{
		politicalId: "948ea29c-6897-481e-aa05-90b39c6dde3f",
		name: "HUAMALÍES",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -9.28356678368404,
		longitude: -76.37976435139069,
		code: ""
	},
	{
		politicalId: "e7633bb3-47e5-46af-8058-cd25a1b0c017",
		name: "HUÁNUCO",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -9.87130022507966,
		longitude: -76.20628044409074,
		code: "100100"
	},
	{
		politicalId: "8778a0a3-383b-42bd-92ea-b71dad496eb1",
		name: "LAURICOCHA",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -9.982726822843775,
		longitude: -76.68204709886469,
		code: ""
	},
	{
		politicalId: "fa73fc9a-b2b3-4fc2-9234-3860c72cb395",
		name: "LEONCIO PRADO",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -9.295666030068285,
		longitude: -76.00025492040159,
		code: "100700"
	},
	{
		politicalId: "4e9c1885-69f0-4b12-b4ae-56eb60d6eb34",
		name: "MARAÑÓN",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -8.626425196500785,
		longitude: -77.11761613326777,
		code: ""
	},
	{
		politicalId: "f522f56a-e935-4a8f-890e-aa3f1b1cad4b",
		name: "PACHITEA",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -9.90768415138057,
		longitude: -76.01730342627053,
		code: ""
	},
	{
		politicalId: "1740067a-d4fa-4ceb-ba48-9583c9c065c0",
		name: "PUERTO INCA",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -9.355265627344826,
		longitude: -75.02331149843477,
		code: ""
	},
	{
		politicalId: "2ffdba6f-fbdb-498b-ae90-d198659950f2",
		name: "YAROWILCA",
		parentPoliticalId: "f5abf936-faac-43fd-8370-bf48c7070463",
		parentStateId: "f5abf936-faac-43fd-8370-bf48c7070463",
		type: "COUNTY",
		latitude: -9.866422099999141,
		longitude: -76.5913790791425,
		code: ""
	}
];
var huanuco = {
	data: data$w
};

var data$x = [
	{
		politicalId: "96a17b7f-aba2-42a0-82a0-1b9690170ed2",
		name: "CHINCHA",
		parentPoliticalId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		parentStateId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		type: "COUNTY",
		latitude: -13.381253198088418,
		longitude: -76.13841635704375,
		code: "110200"
	},
	{
		politicalId: "2407d98a-2a8e-45ac-b945-f8dfdcba49a6",
		name: "ICA",
		parentPoliticalId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		parentStateId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		type: "COUNTY",
		latitude: -14.061380539336913,
		longitude: -75.7355754108483,
		code: "110100"
	},
	{
		politicalId: "dde9ce71-bc73-41b3-9b9b-08de016f3995",
		name: "NAZCA",
		parentPoliticalId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		parentStateId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		type: "COUNTY",
		latitude: -14.779119779527145,
		longitude: -74.94436896049339,
		code: "110300"
	},
	{
		politicalId: "f201fadb-ad3d-4eea-85f8-63f594591dce",
		name: "PALPA",
		parentPoliticalId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		parentStateId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		type: "COUNTY",
		latitude: -14.533462375881296,
		longitude: -75.19108092614992,
		code: "110500"
	},
	{
		politicalId: "bebdf24d-c7df-4377-a077-1d399fd1f8bb",
		name: "PISCO",
		parentPoliticalId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		parentStateId: "913f7c00-bc1a-4840-b769-91c29cd93b54",
		type: "COUNTY",
		latitude: -13.716651584242667,
		longitude: -76.18422703779906,
		code: "110400"
	}
];
var ica = {
	data: data$x
};

var data$y = [
	{
		politicalId: "22410504-7e24-4e1b-b2c8-3996e0b4a95b",
		name: "CHANCHAMAYO",
		parentPoliticalId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		parentStateId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		type: "COUNTY",
		latitude: -10.942110905230725,
		longitude: -75.24905924166444,
		code: "120800"
	},
	{
		politicalId: "7644e40c-24bf-4b00-ae6f-797bd233e0cd",
		name: "CHUPACA",
		parentPoliticalId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		parentStateId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		type: "COUNTY",
		latitude: -12.059325415727699,
		longitude: -75.28957215697598,
		code: ""
	},
	{
		politicalId: "7705bbea-8666-4f64-9204-7000f3075524",
		name: "CONCEPCIÓN",
		parentPoliticalId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		parentStateId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		type: "COUNTY",
		latitude: -11.919908198748818,
		longitude: -75.31860478610325,
		code: "120600"
	},
	{
		politicalId: "8db2edb7-cacd-4862-83a0-0708f6d3e19d",
		name: "HUANCAYO",
		parentPoliticalId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		parentStateId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		type: "COUNTY",
		latitude: -12.068352818507806,
		longitude: -75.21603299444568,
		code: "120100"
	},
	{
		politicalId: "c740d943-a6dc-411b-882f-c176d705be86",
		name: "JAUJA",
		parentPoliticalId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		parentStateId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		type: "COUNTY",
		latitude: -11.783372768616857,
		longitude: -75.49076607534512,
		code: "120200"
	},
	{
		politicalId: "85837f26-fb73-428c-9977-0cd214374d19",
		name: "JUNÍN",
		parentPoliticalId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		parentStateId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		type: "COUNTY",
		latitude: -11.156176589736743,
		longitude: -75.99110654047557,
		code: ""
	},
	{
		politicalId: "4ebbfbc8-ac1c-4a25-bec5-cd558ccb3790",
		name: "SATIPO",
		parentPoliticalId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		parentStateId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		type: "COUNTY",
		latitude: -11.25870683205324,
		longitude: -74.64711803408957,
		code: "120700"
	},
	{
		politicalId: "16f9a40a-1b67-403b-9826-36f2aa55b07d",
		name: "TARMA",
		parentPoliticalId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		parentStateId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		type: "COUNTY",
		latitude: -11.42792893306153,
		longitude: -75.69269056338948,
		code: "120400"
	},
	{
		politicalId: "48dbece0-ff76-48a7-99a8-39cfe5712336",
		name: "YAULI",
		parentPoliticalId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		parentStateId: "09054d1c-09bb-401d-804b-b73eb4e6df95",
		type: "COUNTY",
		latitude: -11.684345548094432,
		longitude: -76.10687535907437,
		code: "120500"
	}
];
var junin = {
	data: data$y
};

var data$z = [
	{
		politicalId: "06ae71e1-ac1f-4d2f-ae8b-b3222042e9f5",
		name: "ASCOPE",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -7.7103731719085005,
		longitude: -79.10869720139415,
		code: ""
	},
	{
		politicalId: "89b12b51-2529-4a61-8031-76af2a23c221",
		name: "BOLÍVAR",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -7.1357569903736495,
		longitude: -77.7326809896305,
		code: ""
	},
	{
		politicalId: "5cb41d29-a19a-4fb4-b2f8-616dae3a20ea",
		name: "CHEPÉN",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -7.228641484905577,
		longitude: -79.4321350840858,
		code: ""
	},
	{
		politicalId: "7e6325a2-8ed1-4dff-88c5-09432338c896",
		name: "GRAN CHIMÚ",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -7.579827526878338,
		longitude: -78.68040487524625,
		code: ""
	},
	{
		politicalId: "e8f68799-b88e-47b8-a7bb-03c41d5cdc3e",
		name: "JULCÁN",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -8.046343917324196,
		longitude: -78.48646546101794,
		code: ""
	},
	{
		politicalId: "e568d98b-2b9f-4c74-a2ee-d3df11c864f4",
		name: "OTUZCO",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -7.905037898021929,
		longitude: -78.56744754516346,
		code: ""
	},
	{
		politicalId: "98e79e71-00cb-45b1-acfe-9660701be63b",
		name: "PACASMAYO",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -7.404117223173381,
		longitude: -79.56395132802837,
		code: "130500"
	},
	{
		politicalId: "052b602e-fcce-4854-8632-e6b2ae1ca7c4",
		name: "PATAZ",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -8.204010500435283,
		longitude: -77.38617433371336,
		code: ""
	},
	{
		politicalId: "f5530459-0774-432c-9094-5956031f74f8",
		name: "SÁNCHEZ CARRIÓN",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -7.816401541596915,
		longitude: -78.05097981707807,
		code: ""
	},
	{
		politicalId: "45eb8a1b-5795-47ad-94a8-cdce39530cb3",
		name: "SANTIAGO DE CHUCO",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -8.162077614567126,
		longitude: -78.17632194216387,
		code: ""
	},
	{
		politicalId: "45781c9f-7d5f-4deb-b2ca-8286505ed6f9",
		name: "TRUJILLO",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -8.110911762547495,
		longitude: -79.03236209463687,
		code: "130100"
	},
	{
		politicalId: "20eec9f2-f167-4270-af20-579eb89a804a",
		name: "VIRÚ",
		parentPoliticalId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		parentStateId: "58a33dc7-1a06-4e76-ae28-0f4dea1c3175",
		type: "COUNTY",
		latitude: -8.409292802985542,
		longitude: -78.74747397845249,
		code: ""
	}
];
var laLibertad = {
	data: data$z
};

var data$A = [
	{
		politicalId: "5da76988-049c-40b0-89f2-bfd5f471e6aa",
		name: "CHICLAYO",
		parentPoliticalId: "58b2133e-d2a1-4878-99f2-caf0357cc6fe",
		parentStateId: "58b2133e-d2a1-4878-99f2-caf0357cc6fe",
		type: "COUNTY",
		latitude: -6.7459812680206985,
		longitude: -79.8784727630911,
		code: "140100"
	},
	{
		politicalId: "f9143bd4-9e21-4a45-b291-87d0b288d18c",
		name: "FERREÑAFE",
		parentPoliticalId: "58b2133e-d2a1-4878-99f2-caf0357cc6fe",
		parentStateId: "58b2133e-d2a1-4878-99f2-caf0357cc6fe",
		type: "COUNTY",
		latitude: -6.634638113283852,
		longitude: -79.78436913729115,
		code: "140300"
	},
	{
		politicalId: "95135a04-a24f-45fc-8288-9175a904c9fb",
		name: "LAMBAYEQUE",
		parentPoliticalId: "58b2133e-d2a1-4878-99f2-caf0357cc6fe",
		parentStateId: "58b2133e-d2a1-4878-99f2-caf0357cc6fe",
		type: "COUNTY",
		latitude: -6.701217375362747,
		longitude: -79.9069713555705,
		code: "140200"
	}
];
var lambayeque = {
	data: data$A
};

var countiesPE = {
  'd194932b-c762-4015-bfce-f33abb721722': amazonas,
  '6f47ba65-b917-4053-af63-770210c80ff9': ancash,
  '699fe048-0283-4a1f-b3f1-536ed91559ec': apurimac,
  '019adee1-9a4f-46c4-9e20-32f650e2dd29': arequipa,
  '6f58c0d0-ecec-4108-a162-5c0a9ee0194e': ayacucho,
  'fbeea2fc-e10b-4860-a548-a6c8ad87b463': cajamarca,
  '0645d9b2-b706-4047-8615-721aff7cc891': callao,
  '9fd2a8dd-6a13-4ac3-b018-c63d643359c8': cusco,
  'f63f7140-f4ab-4e7c-ae76-4e6b7537cf52': huancavalica,
  'f5abf936-faac-43fd-8370-bf48c7070463': huanuco,
  '913f7c00-bc1a-4840-b769-91c29cd93b54': ica,
  '09054d1c-09bb-401d-804b-b73eb4e6df95': junin,
  '58a33dc7-1a06-4e76-ae28-0f4dea1c3175': laLibertad,
  '58b2133e-d2a1-4878-99f2-caf0357cc6fe': lambayeque,
  '282e07f8-3727-4a4d-81d8-fc6184886000': lima
};

var data$B = [
	{
		politicalId: "5b48851e-8c50-499b-b1a7-699a9d3cef15",
		name: "ANCON",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.250394,
		longitude: -78.4524591,
		code: "150102"
	},
	{
		politicalId: "bc839a28-43b9-425b-800f-5a7e06ecfff8",
		name: "ATE",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.1040898,
		longitude: -72.0436091,
		code: "150103"
	},
	{
		politicalId: "1f7b1d2b-6b4f-403a-a434-9a196509d43f",
		name: "ATE - A",
		parentPoliticalId: "bc839a28-43b9-425b-800f-5a7e06ecfff8",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "TOWN",
		priceGroupId: "2",
		latitude: -12.0369379652552,
		longitude: -76.9233739696242,
		code: "150103"
	},
	{
		politicalId: "8e382ef3-96a4-45f1-834c-964174b48b42",
		name: "ATE - B",
		parentPoliticalId: "bc839a28-43b9-425b-800f-5a7e06ecfff8",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "TOWN",
		priceGroupId: "2",
		latitude: -12.0111473056907,
		longitude: -76.8282850628643,
		code: "150144"
	},
	{
		politicalId: "d45e4ac8-5eea-4c24-b3ca-b926185d0da9",
		name: "BARRANCO",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -5.411732,
		longitude: -80.68054550000001,
		code: "150104"
	},
	{
		politicalId: "b13c0ecc-5bbb-4e64-9e02-a7c6612c9b07",
		name: "BREÑA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.929933,
		longitude: -74.70590589999999,
		code: "150105"
	},
	{
		politicalId: "c9b7e549-14fe-4f49-a821-28c9172a33bd",
		name: "CARABAYLLO",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -17.4204023,
		longitude: -70.5127345,
		code: "150106"
	},
	{
		politicalId: "9a915916-474c-4854-b6c9-c37dd712e2c6",
		name: "CHACLACAYO",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -9.712464599999999,
		longitude: -76.8490328,
		code: "150108"
	},
	{
		politicalId: "88e465b3-b0c2-4ddc-aaf1-c30a09dd513e",
		name: "CHORRILLOS",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.9634202,
		longitude: -77.4587239,
		code: "150109"
	},
	{
		politicalId: "d07c18d2-abfa-41a4-a6a1-7b36021951d7",
		name: "CIENEGUILLA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -7.1961329,
		longitude: -75.29564049999999,
		code: "150140"
	},
	{
		politicalId: "b3cc4c08-a102-4f34-951f-9b56b95d90af",
		name: "COMAS",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -7.2949584,
		longitude: -76.7718838,
		code: "150107"
	},
	{
		politicalId: "8961cdcb-c0f0-475f-b4bb-27f0062e4830",
		name: "EL AGUSTINO",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -9.6073986,
		longitude: -76.7033471,
		code: "150110"
	},
	{
		politicalId: "5f0454d5-fe83-4bd1-88b8-08c78678fa8c",
		name: "INDEPENDENCIA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -5.7413646,
		longitude: -77.9063156,
		code: "150128"
	},
	{
		politicalId: "9c79f439-4ba6-47fe-92b5-0bf877825939",
		name: "JESUS MARIA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.4733198,
		longitude: -76.18706809999999,
		code: "150111"
	},
	{
		politicalId: "8982af45-4943-4ac4-8dc0-76c0f0783a45",
		name: "LA MOLINA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.8920309,
		longitude: -75.3477767,
		code: "150112"
	},
	{
		politicalId: "321e8ec1-e2e5-495a-958c-d8a91442ff7e",
		name: "LA VICTORIA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.4750115,
		longitude: -78.8856773,
		code: "150113"
	},
	{
		politicalId: "799c102f-9b4c-44be-a421-23e366a63b82",
		name: "LIMA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -4.8649135,
		longitude: -81.07009939999999,
		code: "150101"
	},
	{
		politicalId: "4701a6a7-7dfa-47a1-9343-115eeb51a77d",
		name: "LINCE",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0859946,
		longitude: -75.5367845,
		code: "150114"
	},
	{
		politicalId: "69d5632f-334d-49d9-aabf-9cba9924a46f",
		name: "LOS OLIVOS",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -7.193833,
		longitude: -78.426165,
		code: "150139"
	},
	{
		politicalId: "5815e7a5-b28c-4fe3-8fd1-a5fc3ca89dee",
		name: "LURIGANCHO CHOSICA",
		parentPoliticalId: "cf4bb22d-b43c-4861-89a3-8f9412a8a45d",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "TOWN",
		priceGroupId: "2",
		latitude: -11.9760193211596,
		longitude: -76.8057795998893,
		code: "150115"
	},
	{
		politicalId: "dc9acd96-db10-4077-89d7-b26c6f0a3731",
		name: "LURIN",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.5279385,
		longitude: -73.3659226,
		code: "150116"
	},
	{
		politicalId: "b62e3850-19dc-424c-98e8-b4fd1120b375",
		name: "MAGDALENA DEL MAR",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.7232514,
		longitude: -75.88741089999999,
		code: "150117"
	},
	{
		politicalId: "16501f55-5411-4554-8ccc-79e9c14d600f",
		name: "MIRAFLORES",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.8994627,
		longitude: -74.2751517,
		code: "150118"
	},
	{
		politicalId: "929cd968-ee78-4968-985a-ccd4f3cbbc8c",
		name: "PACHACAMAC",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.3379818,
		longitude: -72.06457759999999,
		code: "150119"
	},
	{
		politicalId: "9ee0a67a-14d3-4b70-b23b-cc85df85b215",
		name: "PUCUSANA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.6900569,
		longitude: -76.7336521,
		code: "150120"
	},
	{
		politicalId: "8308a64b-7af3-40ef-9107-53535987279e",
		name: "PUEBLO LIBRE",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.069014,
		longitude: -71.7552565,
		code: "150121"
	},
	{
		politicalId: "9afb86c8-b2d2-4f78-a633-235f11b5f719",
		name: "PUENTE PIEDRA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.853611,
		longitude: -70.0204962,
		code: "150122"
	},
	{
		politicalId: "4a8b7372-e21b-44b5-a358-f18b166bddaa",
		name: "PUNTA HERMOSA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.4118969,
		longitude: -73.9124674,
		code: "150124"
	},
	{
		politicalId: "08392a2f-fc01-42e8-bff8-7889bb217100",
		name: "PUNTA NEGRA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.6479481,
		longitude: -74.5697617,
		code: "150123"
	},
	{
		politicalId: "72dd5489-b7f1-41dd-be3f-3001fb7e8cb0",
		name: "RIMAC",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -18.1795976,
		longitude: -70.4550922,
		code: "150125"
	},
	{
		politicalId: "398e3d3c-9d03-4914-aaba-746ec09041ab",
		name: "SAN BARTOLO",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.5506489,
		longitude: -71.82748459999999,
		code: "150126"
	},
	{
		politicalId: "9568ca6c-5448-4a0b-9d20-0109604d6e48",
		name: "SAN BORJA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.9595235,
		longitude: -75.258844,
		code: "150141"
	},
	{
		politicalId: "25a46912-b7cd-483c-8257-d365c63071d6",
		name: "SAN ISIDRO",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.5547681,
		longitude: -77.6292697,
		code: "150127"
	},
	{
		politicalId: "9c085f3b-746d-47b1-b874-98cc0d47bab2",
		name: "SAN JUAN DE LURIGANCHO",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.6388455,
		longitude: -71.60204379999999,
		code: "150136"
	},
	{
		politicalId: "14eb7ce0-c05c-4562-bcfb-f7b24f178cd9",
		name: "SAN JUAN DE MIRAFLORES",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.3822487,
		longitude: -74.1474846,
		code: "150129"
	},
	{
		politicalId: "70827673-28c0-445e-aec9-d0be2774676d",
		name: "SAN LUIS",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -7.0459234,
		longitude: -78.04236829999999,
		code: "150130"
	},
	{
		politicalId: "8fa9f7d5-b5bb-4253-9bf9-f31ec1683ce5",
		name: "SAN MARTIN DE PORRES",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -9.6277897,
		longitude: -74.9749415,
		code: "150131"
	},
	{
		politicalId: "bf31f86f-0521-4b6b-b1a4-ee46561aac70",
		name: "SAN MIGUEL",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.3442564,
		longitude: -75.56551470000001,
		code: "150132"
	},
	{
		politicalId: "a0875567-4dd8-4b52-b8aa-708cea6c040c",
		name: "SANTA ANITA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.008651299999999,
		longitude: -75.8533954,
		code: "150143"
	},
	{
		politicalId: "67a86cfe-8995-4c3d-aaa7-0d8f7c5a38d6",
		name: "SANTA MARÍA DE HUACHIPA",
		parentPoliticalId: "cf4bb22d-b43c-4861-89a3-8f9412a8a45d",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "TOWN",
		priceGroupId: "2",
		latitude: -12.0129735503472,
		longitude: -76.91795593779,
		code: "150145"
	},
	{
		politicalId: "dda29b49-0942-4233-867a-3ded608be754",
		name: "SANTA MARÍA DEL MAR",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.4942029,
		longitude: -70.34481869999999,
		code: "150137"
	},
	{
		politicalId: "77a431ca-6e12-49e4-9314-814e46bd4a90",
		name: "SANTA ROSA",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.722374,
		longitude: -75.0826507,
		code: "150138"
	},
	{
		politicalId: "b57d6999-0f3a-41e2-9828-ef706d47852d",
		name: "SANTIAGO DE SURCO",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.4437428,
		longitude: -78.6559664,
		code: "150133"
	},
	{
		politicalId: "7807f107-62bb-4fa7-92e6-f5f51e621012",
		name: "SURQUILLO",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.6291421,
		longitude: -74.1438375,
		code: "150134"
	},
	{
		politicalId: "cfeba0cb-e04c-4559-b49b-4c7a48f56887",
		name: "VILLA EL SALVADOR",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.6684084,
		longitude: -76.789553,
		code: "150142"
	},
	{
		politicalId: "1db381f7-611c-4df4-81cb-2bcc6ad6a4be",
		name: "VILLA MARIA DEL TRIUNFO",
		parentPoliticalId: "49d4498e-e89b-4a7c-9736-c9f6d5869f6b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -4.7969384,
		longitude: -79.8520818,
		code: "150135"
	}
];
var lima$1 = {
	data: data$B
};

var data$C = [
	{
		politicalId: "307fe2c4-327a-4892-a947-e329efd6b11d",
		name: "BARRANCA",
		parentPoliticalId: "3af630ed-6385-452e-936f-4bf97d01cff3",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.7739623,
		longitude: -75.3587075,
		code: ""
	},
	{
		politicalId: "2105a64c-1411-48df-8fea-6a841c2689a9",
		name: "PARAMONGA",
		parentPoliticalId: "3af630ed-6385-452e-936f-4bf97d01cff3",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.683314,
		longitude: -75.1895576,
		code: ""
	},
	{
		politicalId: "336112fe-51d3-467f-a048-a6eba1eb761e",
		name: "PATIVILCA",
		parentPoliticalId: "3af630ed-6385-452e-936f-4bf97d01cff3",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.4073137,
		longitude: -76.8194767,
		code: ""
	},
	{
		politicalId: "31a21333-7a53-461f-b7c0-47fc667f764e",
		name: "SUPE",
		parentPoliticalId: "3af630ed-6385-452e-936f-4bf97d01cff3",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0800159,
		longitude: -74.7571147,
		code: ""
	},
	{
		politicalId: "69072233-d2bb-47b0-ae0d-b2e90731a362",
		name: "SUPE PUERTO",
		parentPoliticalId: "3af630ed-6385-452e-936f-4bf97d01cff3",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -17.3321649,
		longitude: -70.2527379,
		code: ""
	}
];
var barranca = {
	data: data$C
};

var data$D = [
	{
		politicalId: "ab0a48c3-fcd3-4e65-a00f-b27d6affb46a",
		name: "CAJATAMBO",
		parentPoliticalId: "15c412f1-92c7-4689-8f33-87a486df12e2",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.1928391,
		longitude: -74.8507131,
		code: ""
	},
	{
		politicalId: "0c9d6475-6069-418f-af91-ff98ae1ac8d1",
		name: "COPA",
		parentPoliticalId: "15c412f1-92c7-4689-8f33-87a486df12e2",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.9298168,
		longitude: -71.10588469999999,
		code: ""
	},
	{
		politicalId: "d22e741b-bfaf-4420-bce2-358496d60ef7",
		name: "GORGOR",
		parentPoliticalId: "15c412f1-92c7-4689-8f33-87a486df12e2",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.7126152,
		longitude: -75.5131117,
		code: ""
	},
	{
		politicalId: "5978771a-f929-41e0-8610-64d9e3ca35f7",
		name: "HUANCAPON",
		parentPoliticalId: "15c412f1-92c7-4689-8f33-87a486df12e2",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.1252002,
		longitude: -76.4208755,
		code: ""
	},
	{
		politicalId: "6483fd5f-f58e-4201-92b5-f8b028309f10",
		name: "MANAS",
		parentPoliticalId: "15c412f1-92c7-4689-8f33-87a486df12e2",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.8833338,
		longitude: -75.55096019999999,
		code: ""
	}
];
var cajatambo = {
	data: data$D
};

var data$E = [
	{
		politicalId: "5de9e555-3248-4e1c-bf3f-46a3246a1621",
		name: "ASIA",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.4985936,
		longitude: -72.3562713,
		code: "150418"
	},
	{
		politicalId: "6838a9e6-3f4d-4249-85bc-f7cb5291cf2b",
		name: "ASIA - A",
		parentPoliticalId: "5de9e555-3248-4e1c-bf3f-46a3246a1621",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "TOWN",
		priceGroupId: "2",
		latitude: -12.7508179192171,
		longitude: -76.6083030465808,
		code: "150418"
	},
	{
		politicalId: "b063e854-80a3-4bc8-831a-4befbb47a635",
		name: "ASIA - B",
		parentPoliticalId: "5de9e555-3248-4e1c-bf3f-46a3246a1621",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "TOWN",
		priceGroupId: "2",
		latitude: -12.8388041301557,
		longitude: -76.5272753784902,
		code: "150419"
	},
	{
		politicalId: "8a03fdba-b5f3-42cb-b5bf-7374e6e3cefb",
		name: "CALANGO",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.6608331,
		longitude: -77.9007264,
		code: ""
	},
	{
		politicalId: "b9e762f1-4dc6-4a3d-81d6-37bc10bb9875",
		name: "CERRO AZUL",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.7028298,
		longitude: -73.7360175,
		code: "150403"
	},
	{
		politicalId: "95e23f2b-8f23-4456-992b-ac7ba9736c49",
		name: "CHILCA",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.9797342,
		longitude: -75.2362381,
		code: "150405"
	},
	{
		politicalId: "fd22a945-b7e7-4424-af97-6f4a28dfedc0",
		name: "COAYLLO",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.116973,
		longitude: -73.6044294,
		code: ""
	},
	{
		politicalId: "cdc9d7f2-4028-4438-b5b1-07e8dddab9d9",
		name: "IMPERIAL",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -16.227869,
		longitude: -68.9599205,
		code: "150406"
	},
	{
		politicalId: "488085c2-e246-48be-8652-70d153a87345",
		name: "LUNAHUANA",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.7194156,
		longitude: -75.5917092,
		code: ""
	},
	{
		politicalId: "561c37fd-2759-4f16-bb0c-af873a1625e0",
		name: "MALA",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.8391299,
		longitude: -77.9510209,
		code: "150408"
	},
	{
		politicalId: "8fc840a4-d502-482c-8e72-945bd356cc93",
		name: "NUEVO IMPERIAL",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.2238172,
		longitude: -73.015602,
		code: "150417"
	},
	{
		politicalId: "f7c9c2c9-0618-440f-aeda-5a24ed3c76ab",
		name: "PACARAN",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.5422684,
		longitude: -77.7741569,
		code: ""
	},
	{
		politicalId: "6bb3d921-051f-44bc-abdd-94d95d3e3c3a",
		name: "QUILMANA",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.8773075,
		longitude: -78.04236829999999,
		code: ""
	},
	{
		politicalId: "9f7e1413-ace3-4f08-b2ab-28df36234f5c",
		name: "SAN ANTONIO",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.979538,
		longitude: -74.9766203,
		code: "150412"
	},
	{
		politicalId: "123dba8b-208a-4e21-b80b-a2cc1797c5a4",
		name: "SAN LUIS",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.7271657,
		longitude: -76.4598019,
		code: "150414"
	},
	{
		politicalId: "da987f99-e787-403b-886a-1f6405a7de2c",
		name: "SAN VICENTE DE CAÑETE",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.7995188,
		longitude: -75.891902,
		code: "150401"
	},
	{
		politicalId: "08945024-0271-48d0-94ab-527f5856b0f1",
		name: "SANTA CRUZ DE FLORES",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.1863289,
		longitude: -76.6481299,
		code: ""
	},
	{
		politicalId: "e2189be7-dff9-49f8-8aba-f0726ff7d419",
		name: "ZUÑIGA",
		parentPoliticalId: "5e074b4c-533b-433f-a9ba-e89e4d80e422",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.9639505,
		longitude: -71.7741103,
		code: ""
	}
];
var canete = {
	data: data$E
};

var data$F = [
	{
		politicalId: "5bfcb89c-6523-4250-93bc-92e9f265812f",
		name: "ARAHUAY",
		parentPoliticalId: "c84741dd-b81c-4672-9cfc-eb652ca6859b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.83294,
		longitude: -75.42997,
		code: ""
	},
	{
		politicalId: "9eb747c4-6866-4910-8bb3-eb3bb7639c0b",
		name: "CANTA",
		parentPoliticalId: "c84741dd-b81c-4672-9cfc-eb652ca6859b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.9146292,
		longitude: -77.2979782,
		code: ""
	},
	{
		politicalId: "59eb5a10-19f2-4d2b-97d4-b08f309d363c",
		name: "HUAMANTANGA",
		parentPoliticalId: "c84741dd-b81c-4672-9cfc-eb652ca6859b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.3174672,
		longitude: -75.22298630000002,
		code: ""
	},
	{
		politicalId: "32aae42b-35c2-4fa5-a85f-df663947404c",
		name: "HUAROS",
		parentPoliticalId: "c84741dd-b81c-4672-9cfc-eb652ca6859b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.0841756,
		longitude: -71.121085,
		code: ""
	},
	{
		politicalId: "87ad28af-8920-4d10-93a1-97aac10a58dc",
		name: "LACHAQUI",
		parentPoliticalId: "c84741dd-b81c-4672-9cfc-eb652ca6859b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.3810593,
		longitude: -73.435808,
		code: ""
	},
	{
		politicalId: "6848f754-ef2d-479e-8953-abb04e15cbc7",
		name: "SAN BUENAVENTURA",
		parentPoliticalId: "c84741dd-b81c-4672-9cfc-eb652ca6859b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.712389,
		longitude: -74.0331078,
		code: ""
	},
	{
		politicalId: "3db4e624-a5bf-41c1-8a5f-d71eeb9bf74d",
		name: "SANTA ROSA DE QUIVES",
		parentPoliticalId: "c84741dd-b81c-4672-9cfc-eb652ca6859b",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.2190728,
		longitude: -73.0884214,
		code: ""
	}
];
var canta = {
	data: data$F
};

var data$G = [
	{
		politicalId: "6870581c-fc80-4a68-bffc-aeb45da9f7f5",
		name: "ATAVILLOS ALTO",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.6452313,
		longitude: -75.0597997,
		code: ""
	},
	{
		politicalId: "6cea956c-dcdc-4c56-b25b-6ad83890bb83",
		name: "ATAVILLOS BAJO",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -16.6735115,
		longitude: -70.97176929999999,
		code: ""
	},
	{
		politicalId: "d448d40b-e1c4-4cdb-89d2-44f359360482",
		name: "AUCALLAMA",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.3603292,
		longitude: -79.3127543,
		code: ""
	},
	{
		politicalId: "19f51a6d-38bc-48f1-b823-f279f9dcd8b0",
		name: "CHANCAY",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.7615069,
		longitude: -71.84898,
		code: "150805"
	},
	{
		politicalId: "6d7b09cd-63a0-4b50-bc9e-2fd3c4403a0c",
		name: "HUARAL",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.3418778,
		longitude: -78.6051147,
		code: "150801"
	},
	{
		politicalId: "f99243c1-f34a-4c73-a2cb-c5bed661f05e",
		name: "IHUARI",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.0150596,
		longitude: -74.54632819999999,
		code: ""
	},
	{
		politicalId: "45e2d060-7bfc-43e2-81e5-8341a2589072",
		name: "LAMPIAN",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -9.382213799999999,
		longitude: -76.7577201,
		code: ""
	},
	{
		politicalId: "60e874c4-1e92-4e39-b47b-cf4b27893da1",
		name: "PACARAOS",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.4529463,
		longitude: -74.6620003,
		code: ""
	},
	{
		politicalId: "4ae7d328-9404-4c83-9e77-c785705c0823",
		name: "SAN MIGUEL DE ACOS",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.97776,
		longitude: -77.1894934,
		code: ""
	},
	{
		politicalId: "8b784ac0-1ca5-4db8-a949-b4c49824d7b8",
		name: "SANTA CRUZ DE ANDAMARCA",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.6202431,
		longitude: -69.9907655,
		code: ""
	},
	{
		politicalId: "0cf310e2-2d7e-42d2-805c-e70e5697ddd1",
		name: "SUMBILCA",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.4601506,
		longitude: -69.4355341,
		code: ""
	},
	{
		politicalId: "4a2b724e-64c6-4a95-bb8c-3abe3ea61d20",
		name: "VEINTISIETE DE NOVIEMBRE",
		parentPoliticalId: "315bcbb3-f758-473f-975b-76fb7df10309",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -9.3643091,
		longitude: -76.8490328,
		code: ""
	}
];
var huaral = {
	data: data$G
};

var data$H = [
	{
		politicalId: "492b7c63-2364-41d8-819c-5d19fde4e15d",
		name: "ANTIOQUIA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.852605,
		longitude: -70.7540166,
		code: ""
	},
	{
		politicalId: "33ac93c3-246c-4d07-b348-078c53fe70e3",
		name: "CALLAHUANCA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.2826649,
		longitude: -74.02487119999999,
		code: ""
	},
	{
		politicalId: "fd51405b-5bc8-4711-a5a2-e156bd40adb5",
		name: "CARAMPOMA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -9.870406899999999,
		longitude: -76.4331698,
		code: ""
	},
	{
		politicalId: "87929e65-1ffd-4879-a074-96234bd4bbc6",
		name: "CHICLA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.785431,
		longitude: -73.4738455,
		code: ""
	},
	{
		politicalId: "672f0982-700e-42ef-8e14-89534ccb2b09",
		name: "CUENCA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -9.113688999999999,
		longitude: -75.84683199999999,
		code: ""
	},
	{
		politicalId: "364ce829-65d8-4ced-9747-49750562d1fd",
		name: "HUACHUPAMPA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.0100454,
		longitude: -77.4979275,
		code: ""
	},
	{
		politicalId: "9c364cde-45df-483f-b7c8-8d54a1f66da6",
		name: "HUANZA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.4029474,
		longitude: -74.9121083,
		code: ""
	},
	{
		politicalId: "49d199aa-0d77-4186-bbf9-3eefcd1f051b",
		name: "HUAROCHIRI",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.0445184,
		longitude: -78.77028949999999,
		code: ""
	},
	{
		politicalId: "04e19704-e104-4fe9-9dd8-02013fb679eb",
		name: "LAHUAYTAMBO",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.73691,
		longitude: -74.825752,
		code: ""
	},
	{
		politicalId: "dfbfda4c-03ed-4404-abce-36b2b19be7fc",
		name: "LANGA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.8269682,
		longitude: -74.1111494,
		code: ""
	},
	{
		politicalId: "17399b9c-f072-454b-a1de-8ea03e09d720",
		name: "LARAOS",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.3484088,
		longitude: -75.8185314,
		code: ""
	},
	{
		politicalId: "27bb60ef-2f8f-48f9-b2e1-206c4f319e20",
		name: "MARIATANA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -16.5363938,
		longitude: -71.9994067,
		code: ""
	},
	{
		politicalId: "cac967cd-1785-4ffd-8781-de3bd909c99e",
		name: "MATUCANA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -5.1356014,
		longitude: -79.8856824,
		code: ""
	},
	{
		politicalId: "1bc13043-9743-4c3d-988c-232746d8a5fd",
		name: "RICARDO PALMA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.2291587,
		longitude: -78.5547283,
		code: ""
	},
	{
		politicalId: "fd46c4a6-8cc5-4e6b-af5c-9b1199412ab2",
		name: "SAN ANDRES DE TUPICOCHA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -9.9831641,
		longitude: -76.68891359999999,
		code: ""
	},
	{
		politicalId: "d488a748-f633-4078-8075-8ba5c18cb1c4",
		name: "SAN ANTONIO",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -16.7407664,
		longitude: -69.715289,
		code: ""
	},
	{
		politicalId: "200bb960-f9f3-4706-ace3-e77f7d406649",
		name: "SAN BARTOLOME",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -7.3523479,
		longitude: -78.0309542,
		code: ""
	},
	{
		politicalId: "4edc4622-0ead-4bc3-b81c-085c334d6d6c",
		name: "SAN DAMIAN",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.2493815,
		longitude: -75.8577528,
		code: ""
	},
	{
		politicalId: "1622b0f0-4647-4804-802f-1e7ae7ee6624",
		name: "SAN JUAN DE IRIS",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.523588499999999,
		longitude: -77.53901270000001,
		code: ""
	},
	{
		politicalId: "a7f1983c-ecb8-4255-8460-ecdce4ae651d",
		name: "SAN JUAN DE TANTARANCHE",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.448031299999999,
		longitude: -76.47221429999999,
		code: ""
	},
	{
		politicalId: "5c7630c4-3617-400f-9b12-35aa501a45fd",
		name: "SAN LORENZO DE QUINTI",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.2352032,
		longitude: -78.2682596,
		code: ""
	},
	{
		politicalId: "22f181fc-ce4f-4fbe-87cd-22e30afa8d31",
		name: "SAN MATEO",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.925936200000001,
		longitude: -78.7362845,
		code: ""
	},
	{
		politicalId: "88de4cab-3f59-4653-a519-855a0e10ab28",
		name: "SAN MATEO DE OTAO",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.460483699999999,
		longitude: -76.4519704,
		code: ""
	},
	{
		politicalId: "db22844f-2fa4-4175-bf6e-0d4ad52c5e43",
		name: "SAN PEDRO DE CASTA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.9601749,
		longitude: -74.4921261,
		code: ""
	},
	{
		politicalId: "f8303e77-5f47-48df-83c3-aa76f416b1e0",
		name: "SAN PEDRO DE HUANCAYRE",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.6662082,
		longitude: -69.710821,
		code: ""
	},
	{
		politicalId: "7d4f11a0-bb5f-4003-bdc2-26cb0b09a017",
		name: "SANGALLAYA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.4648789,
		longitude: -72.2482225,
		code: ""
	},
	{
		politicalId: "e0025736-4dd6-4485-803f-7e856e0961a7",
		name: "SANTA CRUZ DE COCACHACRA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.4301048,
		longitude: -78.72069499999999,
		code: ""
	},
	{
		politicalId: "c2ea3526-0ef1-4e6c-bd5e-0668f52ce3eb",
		name: "SANTA EULALIA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -7.142815799999999,
		longitude: -78.6512767,
		code: ""
	},
	{
		politicalId: "a9bb0311-9027-47c6-be0b-596535c2b081",
		name: "SANTIAGO DE ANCHUCAYA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.5371338,
		longitude: -73.111356,
		code: ""
	},
	{
		politicalId: "e1a3a9ab-8670-4401-b966-bd40a88549c7",
		name: "SANTIAGO DE TUNA",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -7.2557429,
		longitude: -78.2597173,
		code: ""
	},
	{
		politicalId: "fe71c70b-03fa-4dd2-a0ae-8c7f66c860b7",
		name: "SANTO DOMINGO DE LOS OLLEROS",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -17.4776078,
		longitude: -70.0339387,
		code: ""
	},
	{
		politicalId: "dc7603e3-24ea-4d86-a84b-2a2ad9fec1a9",
		name: "SURCO",
		parentPoliticalId: "6076c229-7d22-458f-912d-0957d552e37f",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.707574399999999,
		longitude: -77.8035929,
		code: ""
	}
];
var huarochiri = {
	data: data$H
};

var data$I = [
	{
		politicalId: "4c1cc049-5ee4-467c-91e7-15728fc30427",
		name: "AMBAR",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -7.899606599999998,
		longitude: -74.92087719999999,
		code: ""
	},
	{
		politicalId: "7a3c2a2f-1842-487d-be75-71b29c3ea4ba",
		name: "CALETA DE CARQUIN",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.1895112,
		longitude: -71.7707989,
		code: ""
	},
	{
		politicalId: "572f43b2-d786-4e6b-ae25-206be8d76690",
		name: "CHECRAS",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.831325999999999,
		longitude: -77.3898602,
		code: ""
	},
	{
		politicalId: "49063635-0957-450f-aea0-917ca8313bd3",
		name: "HUACHO",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.0139992,
		longitude: -69.3667194,
		code: "150501"
	},
	{
		politicalId: "b149f8d8-4ca2-4107-bbf9-a435cfd13c9a",
		name: "HUALMAY",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.589688,
		longitude: -73.9962255,
		code: ""
	},
	{
		politicalId: "d78cfe17-0d03-4ab7-a032-91388b3aa5bf",
		name: "HUAURA",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.2206209,
		longitude: -69.154315,
		code: ""
	},
	{
		politicalId: "36ef693c-99a0-494d-911e-2ee0129b2b70",
		name: "LEONCIO PRADO",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.4417838,
		longitude: -74.8273184,
		code: ""
	},
	{
		politicalId: "f785025e-3f25-45df-8f53-9bfb43e351c1",
		name: "PACCHO",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.7395127,
		longitude: -73.8631845,
		code: ""
	},
	{
		politicalId: "7b3b150a-a87e-468a-8e15-2627023611e4",
		name: "SANTA LEONOR",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -2.5779366,
		longitude: -72.8042797,
		code: ""
	},
	{
		politicalId: "f17fc83a-b1e6-48f1-99e9-ffbdd7b3fd3a",
		name: "SANTA MARÍA",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.7577876,
		longitude: -73.5270333,
		code: ""
	},
	{
		politicalId: "ba64aa8f-ea91-49ea-9f97-63ef56811984",
		name: "SAYAN",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -17.6223246,
		longitude: -71.2710875,
		code: ""
	},
	{
		politicalId: "64424b05-d77e-4e0f-873e-fd8aff7126ed",
		name: "VEGUETA",
		parentPoliticalId: "5b26d112-8520-4fae-baae-6455771c38e9",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.928324,
		longitude: -76.1116997,
		code: ""
	}
];
var huaura = {
	data: data$I
};

var data$J = [
	{
		politicalId: "49413968-1fa5-4212-856f-359117fc9c64",
		name: "ANDAJES",
		parentPoliticalId: "493ad5fd-2f33-443d-b790-0736d85e029d",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.3601736,
		longitude: -71.6730848,
		code: ""
	},
	{
		politicalId: "bd324fd8-e18c-476a-9a86-07ee935b6a81",
		name: "CAUJUL",
		parentPoliticalId: "493ad5fd-2f33-443d-b790-0736d85e029d",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.267332,
		longitude: -72.3399927,
		code: ""
	},
	{
		politicalId: "8e6e27ae-55ae-4c20-93a0-a2e347d5c9c2",
		name: "COCHAMARCA",
		parentPoliticalId: "493ad5fd-2f33-443d-b790-0736d85e029d",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -16.9083726,
		longitude: -69.3701186,
		code: ""
	},
	{
		politicalId: "e7f59ba9-3ca9-48a5-b6c1-3106e8355553",
		name: "NAVAN",
		parentPoliticalId: "493ad5fd-2f33-443d-b790-0736d85e029d",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.851955,
		longitude: -79.3043021,
		code: ""
	},
	{
		politicalId: "5a437d47-ddce-44ef-8479-0e803a244d48",
		name: "OYÓN",
		parentPoliticalId: "493ad5fd-2f33-443d-b790-0736d85e029d",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -7.250700200000001,
		longitude: -78.6583124,
		code: ""
	},
	{
		politicalId: "b2728c8a-5c83-415a-b1b3-6577495a57d4",
		name: "PACHANGARA",
		parentPoliticalId: "493ad5fd-2f33-443d-b790-0736d85e029d",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -10.0263988,
		longitude: -73.65362089999999,
		code: ""
	}
];
var oyon = {
	data: data$J
};

var data$K = [
	{
		politicalId: "7ad08076-ccaf-4a97-8ca3-5c25655e2396",
		name: "ALIS",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -11.9929208,
		longitude: -77.05181689999999,
		code: ""
	},
	{
		politicalId: "f29b31f3-befe-4dc2-8396-d242060cac24",
		name: "ALLAUCA",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0325966,
		longitude: -76.99117199999999,
		code: ""
	},
	{
		politicalId: "0c8f6027-8a92-4e4c-929d-bcc66d69be79",
		name: "AYAVIRI",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -5.1875288,
		longitude: -80.6651779,
		code: ""
	},
	{
		politicalId: "446baeb6-59e9-4795-9d53-fc6f23fb915d",
		name: "AZÁNGARO",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -15.8402218,
		longitude: -70.0218805,
		code: "150725"
	},
	{
		politicalId: "e6855f09-55d8-4a18-8238-27aa5d709771",
		name: "CACRA",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0774344,
		longitude: -77.0934137,
		code: ""
	},
	{
		politicalId: "938d4641-1bef-4be9-be18-c64e7899d8d5",
		name: "CARANIA",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -5.189729100000001,
		longitude: -80.63827760000001,
		code: ""
	},
	{
		politicalId: "eaa829fd-c0f6-4247-8bf3-3437dfa12b24",
		name: "CATAHUASI",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0433031,
		longitude: -76.97036729999999,
		code: ""
	},
	{
		politicalId: "97eb7731-2414-47f5-b5c4-65fee37d7112",
		name: "CHOCOS",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.0629482,
		longitude: -79.0532061,
		code: ""
	},
	{
		politicalId: "515f8912-c65b-4296-96f1-4cc85de6674f",
		name: "COCHAS",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -18.1090725,
		longitude: -70.2170209,
		code: ""
	},
	{
		politicalId: "358d8541-bdea-4467-bd86-3638649d58ae",
		name: "COLONIA",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -16.342715,
		longitude: -71.5814137,
		code: ""
	},
	{
		politicalId: "7ae317e0-7bf5-4132-9b4a-b0038d0f451b",
		name: "HONGOS",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0686357,
		longitude: -75.21029759999999,
		code: ""
	},
	{
		politicalId: "c890671f-37c5-4a14-88e5-2e883369af4d",
		name: "HUAMPARA",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.2499159,
		longitude: -74.66346399999999,
		code: ""
	},
	{
		politicalId: "2d9b8c93-c595-4d8c-96de-ebb3c45c8c18",
		name: "HUANCAYA",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -4.903638,
		longitude: -80.68643229999999,
		code: ""
	},
	{
		politicalId: "da6ae7cc-1a4b-4769-8181-ac57e2936a89",
		name: "HUAÑEC",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -16.4056088,
		longitude: -71.52608959999999,
		code: ""
	},
	{
		politicalId: "dc53f9fa-2f51-42a2-8057-5745dfc41ac7",
		name: "HUANGASCAR",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.025239,
		longitude: -77.0332342,
		code: ""
	},
	{
		politicalId: "613f8aa0-f085-4885-858b-b0f82f6c453c",
		name: "HUANTAN",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.0559028,
		longitude: -78.9910352,
		code: ""
	},
	{
		politicalId: "77566e50-5fae-46d3-9d88-60addcba713e",
		name: "LARAOS",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -9.105264799999999,
		longitude: -78.445126,
		code: ""
	},
	{
		politicalId: "420230c0-9166-4992-9b89-463f835130fa",
		name: "LINCHA",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0820196,
		longitude: -76.928234,
		code: ""
	},
	{
		politicalId: "61d2c127-db36-4b8f-9ce2-b094b49ba792",
		name: "MADEAN",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -5.179372,
		longitude: -80.67811309999999,
		code: ""
	},
	{
		politicalId: "31d52ccf-4c64-42d6-a5aa-f8afa70215ef",
		name: "MIRAFLORES",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.53195,
		longitude: -71.96746259999999,
		code: ""
	},
	{
		politicalId: "3ca8ec8a-ce4b-458e-a0a8-3cd2ed1778ab",
		name: "OMAS",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0579479,
		longitude: -75.2158171,
		code: ""
	},
	{
		politicalId: "4c161263-05b9-421d-a939-3c1b361e8a81",
		name: "PUTINZA",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -3.7436735,
		longitude: -73.25163260000001,
		code: ""
	},
	{
		politicalId: "314cdd7d-242f-453a-ab91-76218c32c3e6",
		name: "QUINCHES",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0734497,
		longitude: -77.01628989999999,
		code: ""
	},
	{
		politicalId: "7005e728-a752-4ada-b279-97ccb05c3aae",
		name: "QUINOCAY",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -4.1396069,
		longitude: -73.55941279999999,
		code: ""
	},
	{
		politicalId: "6a7efa4c-eeec-45e6-8411-cf3105dd6542",
		name: "SAN JOAQUÍN",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0289625,
		longitude: -77.0097152,
		code: ""
	},
	{
		politicalId: "9584166d-934e-445b-be95-8bb7883c3154",
		name: "SAN PEDRO DE PILAS",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -12.0954443,
		longitude: -76.9947088,
		code: ""
	},
	{
		politicalId: "b5f9615b-40ec-4251-a91b-c56a530df429",
		name: "TANTA",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -14.07546,
		longitude: -75.7341811,
		code: "150726"
	},
	{
		politicalId: "11b8abfc-51cc-4564-8a53-c2cb029c3b5f",
		name: "TAURIPAMPA",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -8.3792869,
		longitude: -74.54486349999999,
		code: ""
	},
	{
		politicalId: "4229f1ac-321d-45fe-9e88-0351e5c1a6d5",
		name: "TOMAS",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -6.7448809,
		longitude: -79.84648039999999,
		code: ""
	},
	{
		politicalId: "026b4d39-40a4-422c-9cc5-cfb137c54c15",
		name: "TUPE",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -5.1782884,
		longitude: -80.6548882,
		code: ""
	},
	{
		politicalId: "041e5135-c4bd-47a4-9608-618ada8ae93b",
		name: "VIÑAC",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -7.1617465,
		longitude: -78.51278549999999,
		code: ""
	},
	{
		politicalId: "501b5582-1595-438c-97dd-3341c2732b8a",
		name: "VITIS",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -13.53195,
		longitude: -71.96746259999999,
		code: ""
	},
	{
		politicalId: "f174719f-a9d2-453d-a9dd-ea9fb63e2d71",
		name: "YAUYOS",
		parentPoliticalId: "a6920b4e-e061-4ff2-ba78-eca7664803cf",
		parentStateId: "282e07f8-3727-4a4d-81d8-fc6184886000",
		parentStateName: "LIMA",
		zones: [
			"150000",
			"180000"
		],
		type: "DISTRICT",
		priceGroupId: "2",
		latitude: -9.063336399999999,
		longitude: -78.589011,
		code: ""
	}
];
var yauyos = {
	data: data$K
};

var lima$2 = {
  '49d4498e-e89b-4a7c-9736-c9f6d5869f6b': lima$1,
  '3af630ed-6385-452e-936f-4bf97d01cff3': barranca,
  '15c412f1-92c7-4689-8f33-87a486df12e2': cajatambo,
  '5e074b4c-533b-433f-a9ba-e89e4d80e422': canete,
  'c84741dd-b81c-4672-9cfc-eb652ca6859b': canta,
  '315bcbb3-f758-473f-975b-76fb7df10309': huaral,
  '6076c229-7d22-458f-912d-0957d552e37f': huarochiri,
  '5b26d112-8520-4fae-baae-6455771c38e9': huaura,
  '493ad5fd-2f33-443d-b790-0736d85e029d': oyon,
  'a6920b4e-e061-4ff2-ba78-eca7664803cf': yauyos
};

var districtsPE = {
  '282e07f8-3727-4a4d-81d8-fc6184886000': lima$2
};

var geoFallbacks = {
  states: {
    ar: {},
    cl: statesCL,
    co: {},
    pe: statesPE
  },
  counties: {
    ar: {},
    cl: {},
    co: {},
    pe: countiesPE
  },
  districts: {
    ar: {},
    cl: districtsCL,
    co: {},
    pe: districtsPE
  }
};

var ZoneModal = function ZoneModal(_ref) {
  var deviceType = _ref.deviceType,
    tenant = _ref.tenant,
    handleRouteChange = _ref.handleRouteChange,
    isBrandingMarketplace = _ref.isBrandingMarketplace,
    entry = _ref.entry,
    isModalVisible = _ref.modalVisible,
    setIsModalVisible = _ref.setModalVisible,
    isOnboardingInProgress = _ref.isOnboardingInProgress,
    isDefaultComuna = _ref.isDefaultComuna,
    selectedZone = _ref.selectedZone,
    isPopOverVisible = _ref.isPopOverVisible,
    stockEnTienda = _ref.stockEnTienda,
    deliveryOptions = _ref.deliveryOptions,
    isUserLoggedIn = _ref.isUserLoggedIn,
    isProgramaticallyGeofinderEnabled = _ref.isProgramaticallyGeofinderEnabled,
    _ref$geofinderConfigs = _ref.geofinderConfigs,
    geofinderConfigs = _ref$geofinderConfigs === void 0 ? {} : _ref$geofinderConfigs,
    isStore = _ref.isStore,
    enableSisThemedBorder = _ref.enableSisThemedBorder,
    _ref$isSodimacStandAl = _ref.isSodimacStandAlone,
    isSodimacStandAlone = _ref$isSodimacStandAl === void 0 ? false : _ref$isSodimacStandAl,
    _ref$isOrangeOrSISHea = _ref.isOrangeOrSISHeader,
    isOrangeOrSISHeader = _ref$isOrangeOrSISHea === void 0 ? false : _ref$isOrangeOrSISHea,
    _ref$isSISLevel2Heade = _ref.isSISLevel2Header,
    isSISLevel2Header = _ref$isSISLevel2Heade === void 0 ? true : _ref$isSISLevel2Heade,
    store = _ref.store,
    isTottusStandAlone = _ref.isTottusStandAlone,
    baseUrl = _ref.baseUrl,
    setShowLoginForm = _ref.setShowLoginForm;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    regions = _useState2[0],
    setRegions = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    comunas = _useState4[0],
    setComunas = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    provinces = _useState6[0],
    setProvinces = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedRegion = _useState8[0],
    setSelectedRegion = _useState8[1];
  var _useState9 = useState(undefined),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedComuna = _useState10[0],
    setSelectedComuna = _useState10[1];
  var _useState11 = useState(undefined),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedProvince = _useState12[0],
    setSelectedProvince = _useState12[1];
  var _useState13 = useState(undefined),
    _useState14 = _slicedToArray(_useState13, 2),
    savedRegion = _useState14[0],
    setSavedRegion = _useState14[1];
  var _useState15 = useState(undefined),
    _useState16 = _slicedToArray(_useState15, 2),
    savedComuna = _useState16[0],
    setSavedComuna = _useState16[1];
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    savedProvince = _useState18[0],
    setSavedProvince = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    popOvervisible = _useState20[0],
    setPopOverVisible = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    modalVisible = _useState22[0],
    setModalVisible = _useState22[1];
  var _useState23 = useState(''),
    _useState24 = _slicedToArray(_useState23, 2),
    regionInputValue = _useState24[0],
    setRegionInputValue = _useState24[1];
  var _useState25 = useState(''),
    _useState26 = _slicedToArray(_useState25, 2),
    comunaInputValue = _useState26[0],
    setComunaInputValue = _useState26[1];
  var _useState27 = useState(''),
    _useState28 = _slicedToArray(_useState27, 2),
    provinceInputValue = _useState28[0],
    setProvinceInputValue = _useState28[1];
  var _useState29 = useState(''),
    _useState30 = _slicedToArray(_useState29, 2),
    popModalType = _useState30[0],
    setPopModal = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    zoneSession = _useState32[0],
    setZoneSession = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    showSuccessModal = _useState34[0],
    setSuccessModal = _useState34[1];
  var _useState35 = useState(false),
    _useState36 = _slicedToArray(_useState35, 2),
    showReminderModal = _useState36[0],
    setShowReminderModal = _useState36[1];
  var _useState37 = useState(null),
    _useState38 = _slicedToArray(_useState37, 2),
    reminderModalType = _useState38[0],
    setReminderModalType = _useState38[1];
  var _useState39 = useState('floatBottomTransition'),
    _useState40 = _slicedToArray(_useState39, 2),
    mobileModalClass = _useState40[0],
    setMobileModalClass = _useState40[1];
  var _useState41 = useState({
      addressLine1: '',
      addressLine2: '',
      landmark: '',
      latitude: '',
      longitude: '',
      zones: []
    }),
    _useState42 = _slicedToArray(_useState41, 2),
    addressLinesData = _useState42[0],
    setAddressLinesData = _useState42[1];
  var _useState43 = useState(undefined),
    _useState44 = _slicedToArray(_useState43, 2),
    savedAddressLinesData = _useState44[0],
    setSavedAddressLinesData = _useState44[1];
  var labels = configs$1.labels,
    constants = configs$1.constants,
    DEFAULT_ZONES_VALUE = configs$1.DEFAULT_ZONES_VALUE;
  var isStockEnTiendaModal = !!Object.keys(stockEnTienda).length;
  var isDeliveryOptionsModal = !isEmpty(deliveryOptions);
  var isPickupInStore = get(deliveryOptions, 'type', '') === constants.PICKUP_IN_STORE;
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    enableEnter = _useState46[0],
    setEnableEnter = _useState46[1];
  var _useState47 = useState(false),
    _useState48 = _slicedToArray(_useState47, 2),
    pressureModalInteractionSession = _useState48[0],
    setPressureModalInteractionSession = _useState48[1];
  var notificationInactiveSession = get(geofinderConfigs, 'notification_inactive_session', 12);
  var notificationLife = get(geofinderConfigs, 'notification_life', 10000);
  var timer;
  var geoFinderIconMap = {
    desktop: 'icon_desktop',
    mobile: 'icon_mobile',
    tablet: 'icon_mobile'
  };
  var geoFinderIconURL = get(entry, "geofinder.".concat(geoFinderIconMap[deviceType], ".url"), '');
  var grayHeadergeoFinderIconURL = get(entry, "geofinder.gray_".concat(geoFinderIconMap[deviceType], ".url"), ZONE_ICON_URL);
  var cookieSetHelper = function cookieSetHelper(name, value) {
    CookieStorage.setCookie({
      name: name,
      value: value,
      regionCode: tenant
    });
  };
  var getSelectedOption = function getSelectedOption(list, key, opt) {
    var selectedOption = list.find(function (item) {
      return item[key].toLowerCase() === opt.toLowerCase();
    });
    selectedOption = capitalizeSelectedOption(selectedOption);
    return selectedOption;
  };
  var resetComuna = function resetComuna() {
    setComunas([]);
    setComunaInputValue('');
    setSelectedComuna('');
    setAddressLinesData({
      addressLine1: '',
      addressLine2: '',
      landmark: '',
      latitude: '',
      longitude: ''
    });
  };
  var resetProvince = function resetProvince() {
    setProvinces([]);
    setProvinceInputValue('');
    setSelectedProvince('');
  };
  var updateProvince = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(politicalId, provId) {
      var keyProvince,
        response,
        list,
        mutatedList,
        selectedProv,
        _args = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            keyProvince = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'id';
            _context.next = 3;
            return doFetch(apiEndpoints.getProvinceList(politicalId, tenant, baseUrl), {}, {
              data: geoFallbacks.counties[tenant][politicalId],
              triggerOnResponseError: true,
              triggerOnNetworkError: true
            });
          case 3:
            response = _context.sent;
            list = response && response.data ? response.data : [];
            try {
              mutatedList = capitalizeList(list);
              setProvinces(mutatedList);
            } catch (e) {
              setProvinces(list);
            }
            if (provId) {
              selectedProv = getSelectedOption(list, keyProvince, provId);
              setProvinceInputValue(selectedProv.name);
              setSavedProvince(selectedProv);
            }
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function updateProvince(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var updateComuna = function () {
    var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(politicalId, comId) {
      var keyComuna,
        list,
        response,
        mutatedList,
        selectedCom,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            keyComuna = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 'id';
            list = [];
            if (!politicalId) {
              _context2.next = 8;
              break;
            }
            _context2.next = 5;
            return doFetch(apiEndpoints.getCitylist(politicalId, tenant, baseUrl), {}, {
              data: geoFallbacks.districts[tenant][politicalId],
              triggerOnResponseError: true,
              triggerOnNetworkError: true
            });
          case 5:
            response = _context2.sent;
            list = response && response.data ? response.data : [];
            try {
              mutatedList = capitalizeList(list);
              setComunas(mutatedList);
            } catch (e) {
              setComunas(list);
            }
          case 8:
            if (!comId) {
              _context2.next = 13;
              break;
            }
            selectedCom = getSelectedOption(list, keyComuna, comId);
            setComunaInputValue(selectedCom.name);
            setSavedComuna(selectedCom);
            return _context2.abrupt("return", selectedCom);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function updateComuna(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var getFromLocalStorage = function getFromLocalStorage(keyName) {
    var keyValue = WebStorage.getItem({
      name: keyName,
      fromPersistence: true
    });
    return keyValue && JSON.parse(keyValue) ? JSON.parse(keyValue) : undefined;
  };
  var updateDistrict = function () {
    var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3(politicalId, countyPoliticalId, disId) {
      var keyDistrict,
        response,
        list,
        mutatedList,
        selectedCom,
        _args3 = arguments;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            keyDistrict = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : 'id';
            _context3.next = 3;
            return doFetch(apiEndpoints.getDistrictList(politicalId, countyPoliticalId, tenant, baseUrl), {}, {
              data: get(geoFallbacks, "districts.".concat(tenant, ".").concat(politicalId, ".").concat(countyPoliticalId), undefined),
              triggerOnResponseError: true,
              triggerOnNetworkError: true
            });
          case 3:
            response = _context3.sent;
            list = response && response.data ? response.data : [];
            try {
              mutatedList = capitalizeList(list);
              setComunas(mutatedList);
            } catch (e) {
              setComunas(list);
            }
            if (!disId) {
              _context3.next = 11;
              break;
            }
            selectedCom = getSelectedOption(list, keyDistrict, disId);
            setComunaInputValue(selectedCom.name);
            setSavedComuna(selectedCom);
            return _context3.abrupt("return", selectedCom);
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function updateDistrict(_x5, _x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();
  var setToLocalStorage = function setToLocalStorage(name, value) {
    var isString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (value) {
      var data = isString ? value : JSON.stringify(value);
      WebStorage.setItem({
        name: name,
        value: data,
        shouldPersist: true
      });
    }
  };
  var fetchSavedZoneDetails = function () {
    var _ref5 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee4() {
      var region, comuna, province, addressLines, addressLine1, addressLine2, landmark, longitude, latitude, USER_ZONE, POLITICAL_ID, REG_ID, COM_ID, PROV_ID, ADDRESS_LINES, isUserZone, politicalIdCookie, addressLineCookie, _addressLineCookie$sp, _addressLineCookie$sp2, getRegionDetailsFromComuna, getProvinceDetailsFromComuna, saveDistrictAPIresponse, _addressLines, _addressLines2, _addressLines3, _addressLines4, _addressLines5, notValidZones, response, savedZoneInfo;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            USER_ZONE = constants.USER_ZONE, POLITICAL_ID = constants.POLITICAL_ID, REG_ID = constants.REG_ID, COM_ID = constants.COM_ID, PROV_ID = constants.PROV_ID, ADDRESS_LINES = constants.ADDRESS_LINES;
            isUserZone = CookieStorage.getCookie(USER_ZONE) === 'userselected';
            politicalIdCookie = CookieStorage.getCookie(POLITICAL_ID);
            addressLineCookie = decodeURIComponent(CookieStorage.getCookie(ADDRESS_LINES)) || '';
            if (isTottusStandAlone) {
              _addressLineCookie$sp = addressLineCookie.split('*');
              _addressLineCookie$sp2 = _slicedToArray(_addressLineCookie$sp, 5);
              addressLine1 = _addressLineCookie$sp2[0];
              addressLine2 = _addressLineCookie$sp2[1];
              landmark = _addressLineCookie$sp2[2];
              latitude = _addressLineCookie$sp2[3];
              longitude = _addressLineCookie$sp2[4];
            }
            getRegionDetailsFromComuna = function getRegionDetailsFromComuna(cmna) {
              return {
                politicalId: cmna.parentStateId,
                name: cmna.parentStateName
              };
            };
            getProvinceDetailsFromComuna = function getProvinceDetailsFromComuna(cmna) {
              return {
                politicalId: cmna.parentPoliticalId,
                name: cmna.parentCountyName
              };
            };
            saveDistrictAPIresponse = function saveDistrictAPIresponse(apiData) {
              region = getRegionDetailsFromComuna(apiData);
              comuna = _objectSpread2({}, apiData);
              if (!isPickupInStore && !isStockEnTiendaModal) {
                setToLocalStorage(REG_ID, region);
                setToLocalStorage(COM_ID, comuna);
                if (isTottusStandAlone) {
                  setToLocalStorage(ADDRESS_LINES, addressLinesData);
                }
              }
              if (tenant !== 'cl') {
                province = getProvinceDetailsFromComuna(apiData);
                if (!isPickupInStore && !isStockEnTiendaModal) {
                  setToLocalStorage(PROV_ID, province);
                }
              }
            };
            if (selectedZone) {
              saveDistrictAPIresponse(selectedZone);
            } else {
              region = getFromLocalStorage(REG_ID);
              comuna = getFromLocalStorage(COM_ID);
              province = getFromLocalStorage(PROV_ID);
              addressLines = getFromLocalStorage(ADDRESS_LINES);
            }
            if (!addressLineCookie && isTottusStandAlone) {
              addressLines = getFromLocalStorage(ADDRESS_LINES);
              addressLine1 = (_addressLines = addressLines) === null || _addressLines === void 0 ? void 0 : _addressLines.addressLine1;
              addressLine2 = (_addressLines2 = addressLines) === null || _addressLines2 === void 0 ? void 0 : _addressLines2.addressLine2;
              landmark = (_addressLines3 = addressLines) === null || _addressLines3 === void 0 ? void 0 : _addressLines3.landmark;
              latitude = (_addressLines4 = addressLines) === null || _addressLines4 === void 0 ? void 0 : _addressLines4.latitude;
              longitude = (_addressLines5 = addressLines) === null || _addressLines5 === void 0 ? void 0 : _addressLines5.longitude;
            }
            if (!(isPickupInStore || isStockEnTiendaModal)) {
              _context4.next = 12;
              break;
            }
            return _context4.abrupt("return", {
              region: region,
              comuna: comuna,
              province: province
            });
          case 12:
            notValidZones = tenant !== 'cl' ? !region && !province && !comuna : !region && !comuna;
            if (!(notValidZones && isUserZone && politicalIdCookie || comuna && comuna.politicalId !== politicalIdCookie)) {
              _context4.next = 19;
              break;
            }
            _context4.next = 16;
            return doFetch("".concat(apiEndpoints.getComunaDetails(politicalIdCookie, tenant, baseUrl, store)));
          case 16:
            response = _context4.sent;
            savedZoneInfo = get(response, 'data', undefined);
            if (savedZoneInfo && !response.default) {
              saveDistrictAPIresponse(savedZoneInfo);
            }
          case 19:
            return _context4.abrupt("return", {
              region: region,
              comuna: comuna,
              province: province,
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              landmark: landmark,
              latitude: latitude,
              longitude: longitude
            });
          case 20:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function fetchSavedZoneDetails() {
      return _ref5.apply(this, arguments);
    };
  }();
  var registerUserLastSession = function registerUserLastSession() {
    setToLocalStorage(constants.USER_LAST_SESSION, new Date());
  };
  var geoFinderLastSession = function geoFinderLastSession(isZoneSelected) {
    var lastSessionString = getFromLocalStorage(constants.USER_LAST_SESSION);
    var lastSession = new Date(lastSessionString).getTime();
    var now = new Date().getTime();
    var inactiveSessionTime = Number(notificationInactiveSession);
    var showAgain = inactiveSessionTime * 60 * 60 * 1000;
    var userInactivity = now - lastSession;
    if (userInactivity > showAgain && isZoneSelected) {
      setReminderModalType(constants.REMINDER_MODAL_TYPE.INACTIVE);
      setShowReminderModal(true);
    }
    registerUserLastSession();
  };
  var getSavedZone = function () {
    var _ref6 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee5() {
      var initLoad,
        IS_PRESSURE_MODAL_INTERACTED,
        USER_ZONE,
        isDefaultZone,
        _yield$fetchSavedZone,
        region,
        comuna,
        province,
        addressLine1,
        addressLine2,
        landmark,
        latitude,
        longitude,
        IS_ZONE_SELECTED,
        _args5 = arguments;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            initLoad = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : false;
            IS_PRESSURE_MODAL_INTERACTED = CookieStorage.getCookie(constants.IS_PRESSURE_MODAL_INTERACTED);
            setPressureModalInteractionSession(IS_PRESSURE_MODAL_INTERACTED === 'true');
            if (initLoad) {
              setPopModal('pressure');
              setPopOverVisible(true);
            }
            USER_ZONE = constants.USER_ZONE;
            isDefaultZone = CookieStorage.getCookie(USER_ZONE) === 'defaultZone';
            if (!(isDefaultComuna || isDefaultZone && !selectedZone)) {
              _context5.next = 8;
              break;
            }
            return _context5.abrupt("return");
          case 8:
            _context5.next = 10;
            return fetchSavedZoneDetails();
          case 10:
            _yield$fetchSavedZone = _context5.sent;
            region = _yield$fetchSavedZone.region;
            comuna = _yield$fetchSavedZone.comuna;
            province = _yield$fetchSavedZone.province;
            addressLine1 = _yield$fetchSavedZone.addressLine1;
            addressLine2 = _yield$fetchSavedZone.addressLine2;
            landmark = _yield$fetchSavedZone.landmark;
            latitude = _yield$fetchSavedZone.latitude;
            longitude = _yield$fetchSavedZone.longitude;
            IS_ZONE_SELECTED = CookieStorage.getCookie(constants.IS_ZONE_SELECTED);
            setZoneSession(IS_ZONE_SELECTED === 'true');
            if (region && !isEmpty(region) && typeof region !== 'string') {
              region = capitalizeSelectedOption(region);
              setRegionInputValue(region.name);
              setSavedRegion(region);
              if (tenant !== 'cl') {
                updateProvince(region.politicalId);
              } else {
                updateComuna(region.politicalId);
              }
            }
            setSavedAddressLinesData({
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              landmark: landmark,
              latitude: latitude || (selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.latitude) || (savedComuna === null || savedComuna === void 0 ? void 0 : savedComuna.latitude) || '',
              longitude: longitude || (selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.latitude) || (savedComuna === null || savedComuna === void 0 ? void 0 : savedComuna.longitude) || ''
            });
            setAddressLinesData({
              addressLine1: addressLine1,
              addressLine2: addressLine2,
              landmark: landmark,
              latitude: latitude || (selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.latitude) || (savedComuna === null || savedComuna === void 0 ? void 0 : savedComuna.latitude) || '',
              longitude: longitude || (selectedComuna === null || selectedComuna === void 0 ? void 0 : selectedComuna.latitude) || (savedComuna === null || savedComuna === void 0 ? void 0 : savedComuna.longitude) || ''
            });
            if (tenant !== 'cl' && province && !isEmpty(province) && typeof province !== 'string') {
              province = capitalizeSelectedOption(province);
              setProvinceInputValue(province.name);
              setSavedProvince(province);
              updateDistrict(region.politicalId, province.politicalId);
            }
            if (comuna && !isEmpty(comuna) && typeof comuna !== 'string') {
              comuna = capitalizeSelectedOption(comuna);
              setComunaInputValue(comuna.name);
              setSavedComuna(comuna);
            }
            if (initLoad) {
              geoFinderLastSession(IS_ZONE_SELECTED === 'true');
            }
          case 27:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getSavedZone() {
      return _ref6.apply(this, arguments);
    };
  }();
  var resetOnModalClose = function resetOnModalClose() {
    setRegionInputValue('');
    setSelectedRegion(undefined);
    resetComuna();
    resetProvince();
  };
  var resetSavedDetails = function resetSavedDetails() {
    setSavedRegion(undefined);
    setSavedComuna(undefined);
    setSavedProvince(undefined);
    setSavedAddressLinesData(undefined);
  };
  var getRegionList = function () {
    var _ref7 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee6() {
      var response, list, mutatedList;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return doFetch(apiEndpoints.getRegion(tenant, baseUrl), {}, {
              data: geoFallbacks.states[tenant],
              triggerOnResponseError: true,
              triggerOnNetworkError: true
            });
          case 2:
            response = _context6.sent;
            list = response && response.data ? response.data : [];
            try {
              mutatedList = capitalizeList(list);
              setRegions(mutatedList);
            } catch (e) {
              setRegions(list);
            }
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function getRegionList() {
      return _ref7.apply(this, arguments);
    };
  }();
  var regionChangeHandler = function () {
    var _ref8 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee7(opt) {
      var selectedReg;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (opt) {
              _context7.next = 3;
              break;
            }
            resetOnModalClose();
            return _context7.abrupt("return");
          case 3:
            selectedReg = getSelectedOption(regions, 'name', opt);
            setSelectedRegion(selectedReg);
            setRegionInputValue(opt);
            setEnableEnter(false);
          case 7:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function regionChangeHandler(_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
  var provinceChangeHandler = function () {
    var _ref9 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee8(opt) {
      var selectedProv;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (opt) {
              _context8.next = 5;
              break;
            }
            setProvinceInputValue('');
            setSelectedProvince(undefined);
            resetComuna();
            return _context8.abrupt("return");
          case 5:
            selectedProv = getSelectedOption(provinces, 'name', opt);
            setSelectedProvince(selectedProv);
            setProvinceInputValue(opt);
            setEnableEnter(false);
          case 9:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function provinceChangeHandler(_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
  var getZoneIDAndName = function getZoneIDAndName(zones, currentZoneName) {
    var zonesV1 = headerFallback.zones_v1[tenant];
    var zoneID;
    var zoneName;
    try {
      zoneID = zones.find(function (z) {
        return _.get(zonesV1, 'availableZones', {})[z];
      });
      zoneName = _.get(zonesV1, 'data', []).find(function (z) {
        return z.id === zoneID;
      }).name;
    } catch (error) {
      zoneID = zones.slice(-1)[0];
      zoneName = currentZoneName;
    }
    if (!zoneID) {
      zoneID = zones.slice(-1)[0];
      zoneName = currentZoneName;
    }
    return {
      zoneID: zoneID,
      zoneName: zoneName
    };
  };
  var getInitialZonesDetailsForEvent = function getInitialZonesDetailsForEvent() {
    var zonesInfo = CookieStorage.getCookie(constants.ZONES);
    var politicalIdInfo = CookieStorage.getCookie(constants.POLITICAL_ID);
    var priceGroupIdInfo = CookieStorage.getCookie(constants.PRICE_GROUP_ID);
    var envirnoment = getEnvironment();
    if (!envirnoment) {
      envirnoment = 'production';
    }
    if (zonesInfo && politicalIdInfo && priceGroupIdInfo) {
      try {
        return new Promise(function (resolve) {
          resolve(_defineProperty(_defineProperty(_defineProperty({}, constants.ZONES, JSON.parse(zonesInfo).join(',')), constants.POLITICAL_ID, politicalIdInfo), constants.PRICE_GROUP_ID, priceGroupIdInfo));
        });
      } catch (error) {
        return new Promise(function (resolve) {
          resolve(_.get(DEFAULT_ZONES_VALUE, "".concat(envirnoment, ".").concat(tenant), DEFAULT_ZONES_VALUE.production.cl));
        });
      }
    }
    return new Promise(function (resolve) {
      resolve(_.get(DEFAULT_ZONES_VALUE, "".concat(envirnoment, ".").concat(tenant), DEFAULT_ZONES_VALUE.production.cl));
    });
  };
  var triggerComunaEvent = function () {
    var _ref10 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee9() {
      var zones,
        politicalId,
        priceGroupId,
        comunaDetails,
        comunaEvent,
        _args9 = arguments;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            zones = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : '';
            politicalId = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : '';
            priceGroupId = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : '';
            comunaDetails = {};
            if (!(zones && politicalId && priceGroupId)) {
              _context9.next = 8;
              break;
            }
            comunaDetails = _defineProperty(_defineProperty(_defineProperty({}, constants.ZONES, JSON.parse(JSON.stringify(zones)).join(',')), constants.POLITICAL_ID, politicalId), constants.PRICE_GROUP_ID, priceGroupId);
            _context9.next = 11;
            break;
          case 8:
            _context9.next = 10;
            return getInitialZonesDetailsForEvent();
          case 10:
            comunaDetails = _context9.sent;
          case 11:
            comunaEvent = new CustomEvent('COMUNAHASPOPULATED', {
              detail: comunaDetails
            });
            window.dispatchEvent(comunaEvent);
          case 13:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function triggerComunaEvent() {
      return _ref10.apply(this, arguments);
    };
  }();
  var saveComunaDetails = function saveComunaDetails(cmna) {
    var zones = cmna.zones,
      currentZoneName = cmna.name,
      priceGroupId = cmna.priceGroupId,
      politicalId = cmna.politicalId;
    var _getZoneIDAndName = getZoneIDAndName(zones, currentZoneName),
      zoneID = _getZoneIDAndName.zoneID,
      zoneName = _getZoneIDAndName.zoneName;
    cookieSetHelper(constants.POLITICAL_ID, politicalId);
    cookieSetHelper(constants.PRICE_GROUP_ID, priceGroupId);
    cookieSetHelper(constants.ZONE_DATA, {
      zoneID: zoneID,
      zoneName: zoneName
    });
    cookieSetHelper(constants.USER_ZONE, 'userselected');
    if (!isTottusStandAlone) {
      cookieSetHelper(constants.ZONES, JSON.stringify(zones));
    }
    triggerComunaEvent(zones, politicalId, priceGroupId);
  };
  var saveZone = function saveZone(tottusComuna) {
    var setZoneConfigForPDPModal = get(stockEnTienda, 'setZoneConfig', null);
    if (isStockEnTiendaModal && setZoneConfigForPDPModal) {
      setZoneConfigForPDPModal({
        region: selectedRegion || savedRegion,
        comuna: selectedComuna || savedComuna
      });
      if (deviceType !== 'desktop') {
        setIsModalVisible(false);
      }
    }
    var setZoneConfigForDeliveryOptions = get(deliveryOptions, 'setZoneConfig', null);
    if (isDeliveryOptionsModal) {
      if (setZoneConfigForDeliveryOptions && setZoneConfigForDeliveryOptions instanceof Function) {
        setZoneConfigForDeliveryOptions({
          region: selectedRegion || savedRegion,
          comuna: selectedComuna || savedComuna
        });
      }
      if (isPickupInStore) {
        return;
      }
    }
    if (isStockEnTiendaModal) {
      return;
    }
    setToLocalStorage(constants.REG_ID, selectedRegion || savedRegion);
    setToLocalStorage(constants.COM_ID, selectedComuna || savedComuna);
    if (tenant !== 'cl') {
      setToLocalStorage(constants.PROV_ID, selectedProvince || savedProvince);
    }
    cookieSetHelper(constants.IS_ZONE_SELECTED, 'true');
    if (!isStockEnTiendaModal && !isDeliveryOptionsModal) {
      if (deviceType === 'desktop') {
        if (isBrandingMarketplace) {
          setIsModalVisible(false);
        } else {
          setModalVisible(false);
        }
      } else {
        setMobileModalClass('floatBottomEndTransition');
        var animationTimer = setTimeout(function () {
          if (isBrandingMarketplace) {
            setIsModalVisible(false);
          } else {
            setModalVisible(false);
          }
          clearTimeout(animationTimer);
        }, constants.MODAL_CLOSE_TIME);
      }
    }
    if (selectedRegion) {
      setSavedRegion(selectedRegion);
    }
    if (tenant !== 'cl' && selectedProvince) {
      setSavedProvince(selectedProvince);
    }
    if (selectedComuna) {
      setSavedComuna(selectedComuna);
      saveComunaDetails(selectedComuna);
    }
    var selectedZoneValidation = tenant !== 'cl' ? selectedComuna || selectedProvince || selectedRegion : selectedComuna || selectedRegion;
    if (isTottusStandAlone && tottusComuna) {
      setSavedComuna(tottusComuna);
      saveComunaDetails(tottusComuna);
      handleRouteChange(tottusComuna);
    } else if (selectedZoneValidation) {
      handleRouteChange(selectedComuna);
    }
    setSuccessModal(true);
  };
  var saveAdressData = function saveAdressData(address, customZones, comuna) {
    if (!customZones.length) {
      return;
    }
    var latitude = address.latitude,
      longitude = address.longitude,
      addressLine1 = address.addressLine1,
      addressLine2 = address.addressLine2;
    var landmark = (address === null || address === void 0 ? void 0 : address.landmark) || (address === null || address === void 0 ? void 0 : address.departmentNumber) || '';
    setSavedAddressLinesData(address);
    setAddressLinesData(address);
    setToLocalStorage(constants.ADDRESS_LINES, address);
    var addressCookieValue = "".concat(addressLine1.replaceAll('*', '#'), "*").concat(addressLine2.replaceAll('*', '#'), "*").concat(landmark.replaceAll('*', '#'), "*").concat(latitude, "*").concat(longitude);
    cookieSetHelper(constants.ADDRESS_LINES, encodeURIComponent(addressCookieValue));
    cookieSetHelper(constants.ZONES, JSON.stringify(customZones));
    if (address !== null && address !== void 0 && address.id) {
      cookieSetHelper(constants.ADDRESS_IDS, address === null || address === void 0 ? void 0 : address.id);
    }
    saveZone(comuna);
  };
  var setGeofinderProgramatically = function () {
    var _ref11 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee10(address) {
      var customInfo, stateCode, state, municipal, latitude, longitude, statePoliticalId, municipalPoliticalAreaId, comuna, customZones, regionData;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (!isEmpty(address)) {
              _context10.next = 2;
              break;
            }
            return _context10.abrupt("return");
          case 2:
            customInfo = address.customInfo, stateCode = address.stateCode, state = address.state, municipal = address.municipal, latitude = address.latitude, longitude = address.longitude;
            statePoliticalId = customInfo.find(function (info) {
              return info.name === 'statePoliticalAreaId';
            });
            municipalPoliticalAreaId = customInfo.find(function (info) {
              return info.name === 'municipalPoliticalAreaId';
            });
            _context10.next = 7;
            return updateComuna(statePoliticalId.value, municipalPoliticalAreaId.value, 'politicalId');
          case 7:
            comuna = _context10.sent;
            if (!isTottusStandAlone) {
              _context10.next = 15;
              break;
            }
            _context10.next = 11;
            return getTottusZones(latitude, longitude, tenant);
          case 11:
            customZones = _context10.sent;
            if (customZones.length) {
              _context10.next = 14;
              break;
            }
            return _context10.abrupt("return");
          case 14:
            saveAdressData(address, customZones, comuna);
          case 15:
            regionData = {
              code: stateCode,
              id: stateCode,
              name: state,
              politicalId: statePoliticalId.value,
              type: 'STATE'
            };
            cookieSetHelper(constants.IS_ZONE_SELECTED, 'true');
            cookieSetHelper(constants.ADDRESS_IDS, address === null || address === void 0 ? void 0 : address.id);
            setSelectedRegion(regionData);
            setSavedRegion(regionData);
            setRegionInputValue(state);
            setComunaInputValue(municipal);
            cookieSetHelper(constants.POLITICAL_ID, municipalPoliticalAreaId.value);
            cookieSetHelper(constants.USER_ZONE, 'userselected');
          case 24:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function setGeofinderProgramatically(_x10) {
      return _ref11.apply(this, arguments);
    };
  }();
  var setGeofinderProgramaticallyFAPE = function () {
    var _ref12 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee11(address) {
      var customInfo, stateCode, state, city, municipal, latitude, longitude, statePoliticalId, cityPoliticalAreaId, municipalPoliticalAreaId, district, regionData, customZones;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            customInfo = address.customInfo, stateCode = address.stateCode, state = address.state, city = address.city, municipal = address.municipal, latitude = address.latitude, longitude = address.longitude;
            statePoliticalId = customInfo.find(function (info) {
              return info.name === 'statePoliticalAreaId';
            });
            cityPoliticalAreaId = customInfo.find(function (info) {
              return info.name === 'cityPoliticalAreaId';
            });
            municipalPoliticalAreaId = customInfo.find(function (info) {
              return info.name === 'municipalPoliticalAreaId';
            });
            _context11.next = 6;
            return updateProvince(statePoliticalId.value, cityPoliticalAreaId.value, 'politicalId');
          case 6:
            _context11.next = 8;
            return updateDistrict(statePoliticalId.value, cityPoliticalAreaId.value, municipalPoliticalAreaId.value, 'politicalId');
          case 8:
            district = _context11.sent;
            regionData = {
              code: stateCode,
              id: stateCode,
              name: state,
              politicalId: statePoliticalId.value,
              type: 'STATE'
            };
            if (!isTottusStandAlone) {
              _context11.next = 18;
              break;
            }
            _context11.next = 13;
            return getTottusZones(latitude, longitude, tenant);
          case 13:
            customZones = _context11.sent;
            if (customZones.length) {
              _context11.next = 17;
              break;
            }
            setSavedAddressLinesData(undefined);
            return _context11.abrupt("return");
          case 17:
            saveAdressData(address, customZones, district);
          case 18:
            cookieSetHelper(constants.IS_ZONE_SELECTED, 'true');
            cookieSetHelper(constants.ADDRESS_IDS, address === null || address === void 0 ? void 0 : address.id);
            setSelectedRegion(regionData);
            setSavedRegion(regionData);
            setRegionInputValue(state);
            setProvinceInputValue(city);
            setComunaInputValue(municipal);
            cookieSetHelper(constants.POLITICAL_ID, municipalPoliticalAreaId.value);
            cookieSetHelper(constants.USER_ZONE, 'userselected');
          case 27:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }));
    return function setGeofinderProgramaticallyFAPE(_x11) {
      return _ref12.apply(this, arguments);
    };
  }();
  var getFavoriteAddress = function getFavoriteAddress(addresses) {
    var favorite = addresses.find(function (a) {
      return a.isDefaultAddress === true;
    });
    return favorite || addresses[0];
  };
  useEffect(function () {
    _asyncToGenerator( _regeneratorRuntime().mark(function _callee12() {
      var response, IS_ZONE_SELECTED_COOKIE, IS_ZONE_SELECTED, unescapeATGCookies, getCookie, cookieSID, cookieSIDStatus, _response, addresses, favoriteAddress, addressLine1, addressLine2, latitude, longitude, landmark;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            if (isProgramaticallyGeofinderEnabled) {
              _context12.next = 3;
              break;
            }
            console.log('programatically geofinder disabled');
            return _context12.abrupt("return");
          case 3:
            IS_ZONE_SELECTED_COOKIE = CookieStorage.getCookie(constants.IS_ZONE_SELECTED);
            IS_ZONE_SELECTED = IS_ZONE_SELECTED_COOKIE === 'true';
            if (!(isUserLoggedIn && !IS_ZONE_SELECTED)) {
              _context12.next = 40;
              break;
            }
            unescapeATGCookies = CookieStorage.unescapeATGCookies, getCookie = CookieStorage.getCookie;
            cookieSID = process.env.ENVIRONMENT === 'dev' ? process.env.TEST_COOKIE_SID : unescapeATGCookies(getCookie('sid'));
            cookieSIDStatus = getCookie('sidStatus');
            _context12.prev = 9;
            if (!(cookieSIDStatus === SID_STATUS.SOFTLOGIN)) {
              _context12.next = 16;
              break;
            }
            _context12.next = 13;
            return getUserAddressesCheckout(cookieSID, tenant, store);
          case 13:
            response = _context12.sent;
            _context12.next = 19;
            break;
          case 16:
            _context12.next = 18;
            return getUserAddresses(cookieSID, tenant, store);
          case 18:
            response = _context12.sent;
          case 19:
            if (!(response.errors && response.errors.length > 0)) {
              _context12.next = 21;
              break;
            }
            throw new Error("".concat(response.errors[0].message, " (").concat(response.errors[0].code, ")"));
          case 21:
            _response = response, addresses = _response.addresses;
            favoriteAddress = getFavoriteAddress(addresses);
            if (!isEmpty(favoriteAddress)) {
              _context12.next = 25;
              break;
            }
            return _context12.abrupt("return");
          case 25:
            if (!(tenant === 'cl')) {
              _context12.next = 30;
              break;
            }
            _context12.next = 28;
            return setGeofinderProgramatically(favoriteAddress);
          case 28:
            _context12.next = 32;
            break;
          case 30:
            _context12.next = 32;
            return setGeofinderProgramaticallyFAPE(favoriteAddress);
          case 32:
            if (isTottusStandAlone) {
              addressLine1 = favoriteAddress.addressLine1, addressLine2 = favoriteAddress.addressLine2, latitude = favoriteAddress.latitude, longitude = favoriteAddress.longitude, landmark = favoriteAddress.landmark;
              setAddressLinesData({
                addressLine1: addressLine1,
                addressLine2: addressLine2,
                landmark: landmark,
                latitude: latitude,
                longitude: longitude
              });
            }
            setReminderModalType(constants.REMINDER_MODAL_TYPE.USER_LOGGED_IN);
            setShowReminderModal(true);
            _context12.next = 40;
            break;
          case 37:
            _context12.prev = 37;
            _context12.t0 = _context12["catch"](9);
            console.log(_context12.t0);
          case 40:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[9, 37]]);
    }))();
  }, [isUserLoggedIn]);
  useEffect(function () {
    if (selectedRegion) {
      if (tenant !== 'cl') {
        resetProvince();
        updateProvince(selectedRegion.politicalId);
      } else {
        resetComuna();
        updateComuna(selectedRegion.politicalId);
      }
    }
  }, [selectedRegion]);
  useEffect(function () {
    if (selectedProvince) {
      resetComuna();
      var _ref14 = selectedRegion || savedRegion,
        politicalId = _ref14.politicalId;
      updateDistrict(politicalId, selectedProvince.politicalId);
    }
  }, [selectedProvince]);
  function fetchComunaDefault() {
    return _fetchComunaDefault.apply(this, arguments);
  }
  function _fetchComunaDefault() {
    _fetchComunaDefault = _asyncToGenerator( _regeneratorRuntime().mark(function _callee15() {
      var forceDefault,
        comunaDefault,
        _comunaDefault$data,
        zones,
        currentZoneName,
        priceGroupId,
        politicalId,
        latitude,
        longitude,
        _getZoneIDAndName2,
        zoneID,
        zoneName,
        _args15 = arguments;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            forceDefault = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : false;
            if (!(CookieStorage.getCookie(constants.POLITICAL_ID).length === 0 || forceDefault)) {
              _context15.next = 8;
              break;
            }
            _context15.next = 4;
            return doFetch("".concat(baseUrl).concat(apiEndpoints.getComunaDetails('default', tenant, '', store)), {});
          case 4:
            comunaDefault = _context15.sent;
            if (comunaDefault && comunaDefault.default) {
              _comunaDefault$data = comunaDefault.data, zones = _comunaDefault$data.zones, currentZoneName = _comunaDefault$data.name, priceGroupId = _comunaDefault$data.priceGroupId, politicalId = _comunaDefault$data.politicalId, latitude = _comunaDefault$data.latitude, longitude = _comunaDefault$data.longitude;
              _getZoneIDAndName2 = getZoneIDAndName(zones, currentZoneName), zoneID = _getZoneIDAndName2.zoneID, zoneName = _getZoneIDAndName2.zoneName;
              cookieSetHelper(constants.POLITICAL_ID, politicalId);
              cookieSetHelper(constants.PRICE_GROUP_ID, priceGroupId);
              cookieSetHelper(constants.POLITICAL_ID_EXISTS, true);
              cookieSetHelper(constants.IS_ZONE_SELECTED, false);
              cookieSetHelper(constants.USER_ZONE, 'defaultZone');
              cookieSetHelper(constants.ZONES, JSON.stringify(zones));
              cookieSetHelper(constants.ZONE_DATA, {
                zoneID: zoneID,
                zoneName: zoneName
              });
              if (isTottusStandAlone) {
                cookieSetHelper(constants.ADDRESS_LINES, "***".concat(latitude, "*").concat(longitude));
              }
              if (forceDefault) {
                handleRouteChange(comunaDefault.data);
                resetSavedDetails();
                resetOnModalClose();
              }
              triggerComunaEvent(zones, politicalId, priceGroupId);
            }
            _context15.next = 9;
            break;
          case 8:
            triggerComunaEvent();
          case 9:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return _fetchComunaDefault.apply(this, arguments);
  }
  useEffect(function () {
    var fetchComunaData = function () {
      var _ref15 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return fetchComunaDefault();
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return function fetchComunaData() {
        return _ref15.apply(this, arguments);
      };
    }();
    fetchComunaData();
  }, []);
  var comunaChangeHandler = function () {
    var _ref16 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee14(opt) {
      var selectedCom, getPickupInStoreData, getHomeDeliveryData;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            if (opt) {
              _context14.next = 2;
              break;
            }
            return _context14.abrupt("return", setSelectedComuna(''));
          case 2:
            selectedCom = getSelectedOption(comunas, 'name', opt);
            setSelectedComuna(selectedCom);
            setComunaInputValue(opt);
            setEnableEnter(true);
            setAddressLinesData({
              addressLine1: '',
              addressLine2: '',
              landmark: '',
              latitude: '',
              longitude: ''
            });
            if (isDeliveryOptionsModal) {
              if (deliveryOptions.type && deliveryOptions.type === constants.PICKUP_IN_STORE) {
                getPickupInStoreData = get(deliveryOptions, 'getPickupInStoreData', undefined);
                if (getPickupInStoreData && getPickupInStoreData instanceof Function) {
                  getPickupInStoreData(selectedCom);
                }
              } else if (deliveryOptions.type && deliveryOptions.type === constants.HOME_DELIVERY) {
                getHomeDeliveryData = get(deliveryOptions, 'getHomeDeliveryData', undefined);
                if (getHomeDeliveryData && getHomeDeliveryData instanceof Function) {
                  getHomeDeliveryData(selectedCom);
                }
              }
            }
          case 8:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    return function comunaChangeHandler(_x12) {
      return _ref16.apply(this, arguments);
    };
  }();
  useEffect(function () {
    return function () {
      clearTimeout(timer);
    };
  }, [popModalType]);
  useEffect(function () {
    if ((modalVisible || isModalVisible) && regions.length === 0) {
      getRegionList();
    }
  }, [modalVisible, isModalVisible]);
  useEffect(function () {
    var initLoad = true;
    getSavedZone(initLoad);
    return function () {
      setPopOverVisible(false);
      setSuccessModal(false);
    };
  }, []);
  useEffect(function () {
    var USER_ZONE = constants.USER_ZONE;
    var isDefaultZone = CookieStorage.getCookie(USER_ZONE) === 'defaultZone';
    if (isDefaultComuna || isDefaultZone && !selectedZone) {
      setSavedRegion(undefined);
      setSavedComuna(undefined);
      setSavedAddressLinesData(undefined);
      if (!isPickupInStore) {
        WebStorage.removeItem({
          name: constants.REG_ID,
          fromPersistence: true
        });
        WebStorage.removeItem({
          name: constants.COM_ID,
          fromPersistence: true
        });
      }
      setSelectedRegion(undefined);
      setSelectedComuna(undefined);
      if (tenant !== 'cl') {
        setSavedProvince(undefined);
        if (!isPickupInStore) {
          WebStorage.removeItem({
            name: constants.PROV_ID,
            fromPersistence: true
          });
        }
        setSelectedProvince(undefined);
      }
    }
  }, [isDefaultComuna]);
  useEffect(function () {
    if (selectedZone && selectedZone.name) {
      getSavedZone(false);
    }
  }, [selectedZone]);
  var ModalLabelContent = function ModalLabelContent() {
    var pressureLabel = deviceType === 'desktop' ? labels.PRESSURE_DESKTOP_LABLE : labels.PRESSURE_MOBILE_LABLE;
    var selectedRegionLabel = !isTottusStandAlone ? labels.SELECTED_REGION_LABLE : labels.SELECTED_REGION_LABLE_TOTTUS;
    var isDefaultZone = isWindow$1() && CookieStorage.getCookie(constants.USER_ZONE) === 'defaultZone';
    var savedGeoValidation = tenant !== 'cl' ? savedRegion && savedProvince && savedComuna : savedRegion && savedComuna;
    if (savedGeoValidation && !isDefaultZone) {
      return jsx("p", {
        className: classNames(styles$C['zone-lable'], _defineProperty(_defineProperty(_defineProperty({}, styles$C.marketplace, isBrandingMarketplace), styles$C.store, isStore), styles$C['new-zone-modal'], isTottusStandAlone))
      }, selectedRegionLabel, "\xA0", jsx("span", {
        className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles$C.marketplace, isBrandingMarketplace), styles$C.comuna, !isTottusStandAlone), styles$C['tottus-comuna'], isTottusStandAlone))
      }, getTottusAddress(_objectSpread2({}, savedAddressLinesData, {
        comuna: savedComuna.name
      }), isTottusStandAlone)));
    }
    return jsx("p", {
      className: classNames(styles$C['zone-lable'], styles$C.bold, _defineProperty(_defineProperty({}, styles$C.marketplace, isBrandingMarketplace), styles$C.store, isStore))
    }, pressureLabel);
  };
  useEffect(function () {
    if (!isStockEnTiendaModal) {
      setToLocalStorage(constants.REG_ID, selectedRegion || savedRegion);
      setToLocalStorage(constants.COM_ID, selectedComuna || savedComuna);
    }
    if (tenant !== 'cl' && !isStockEnTiendaModal) {
      setToLocalStorage(constants.PROV_ID, selectedProvince || savedProvince);
    }
  }, [savedComuna, savedRegion, savedProvince]);
  var pressureModalDismissHandler = function pressureModalDismissHandler(interacted) {
    setPopOverVisible(false);
    if (interacted) {
      CookieStorage.setCookie({
        name: constants.IS_PRESSURE_MODAL_INTERACTED,
        value: 'true',
        regionCode: tenant
      });
    }
  };
  var PopOverContent = function PopOverContent() {
    if (!isPopOverVisible) {
      return jsx(React.Fragment, null);
    }
    if (zoneSession) {
      return jsx(React.Fragment, null);
    }
    if (!pressureModalInteractionSession && !zoneSession && popModalType === 'pressure') {
      return jsx(PressureModal, {
        dismissHandler: pressureModalDismissHandler,
        isBrandingMarketplace: isBrandingMarketplace,
        notificationLife: notificationLife
      });
    }
    return jsx(React.Fragment, null);
  };
  var closeOtherModals = function closeOtherModals() {
    setPopOverVisible(false);
    setSuccessModal(false);
  };
  var toggleModal = function toggleModal(visibility) {
    if (deviceType !== 'desktop') {
      if (!visibility) {
        setMobileModalClass('floatBottomEndTransition');
        var animationTimer = setTimeout(function () {
          if (isBrandingMarketplace) {
            setIsModalVisible(visibility);
          } else {
            setModalVisible(visibility);
          }
          clearTimeout(animationTimer);
        }, constants.MODAL_CLOSE_TIME);
      } else {
        setMobileModalClass('floatBottomTransition');
        if (isBrandingMarketplace) {
          setIsModalVisible(visibility);
        } else {
          setModalVisible(visibility);
        }
      }
    } else if (isBrandingMarketplace) {
      setIsModalVisible(visibility);
    } else {
      setModalVisible(visibility);
    }
  };
  var getModalHeight = function getModalHeight() {
    if (isTottusStandAlone) {
      return;
    }
    if (tenant !== 'cl' && !isDeliveryOptionsModal && !isStockEnTiendaModal) {
      return deviceType === 'desktop' ? 491 : 410;
    }
    if (isDeliveryOptionsModal || isStockEnTiendaModal) {
      return deviceType === 'desktop' ? 531 : 330;
    }
    return deviceType === 'desktop' ? 403 : 330;
  };
  var getModalWidth = function getModalWidth() {
    if (isTottusStandAlone) {
      return deviceType === 'desktop' ? 400 : '100%';
    }
    return 500;
  };
  var customBodyClass = function customBodyClass() {
    return isBrandingMarketplace ? 'zone-modal-body-marketplace' : 'zone-modal-body-retail';
  };
  return jsx("div", {
    className: classNames(styles$C['modal-wrapper'], _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$C.marketplace, isBrandingMarketplace), styles$C.retail, !isBrandingMarketplace), styles$C.stockEnTiendaWrapper, !!isStockEnTiendaModal || !!isDeliveryOptionsModal), styles$C.store, isStore)),
    id: "modal-wrapper"
  }, jsx(Modal, {
    toggleState: {
      visible: isBrandingMarketplace ? isModalVisible : modalVisible,
      setVisible: toggleModal
    },
    keepNoScroll: (deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.type) === constants.PICKUP_IN_STORE,
    content: function content(actions) {
      return jsx(ModalContent$1, {
        actions: actions,
        regionsSuggestion: regions,
        regionChangeHandler: regionChangeHandler,
        selectedRegion: selectedRegion || savedRegion,
        comunaSuggestion: comunas,
        selectedZone: selectedZone,
        comunaChangeHandler: comunaChangeHandler,
        addressLinesData: addressLinesData,
        setAddressLinesData: setAddressLinesData,
        setSavedAddressLinesData: setSavedAddressLinesData,
        store: store,
        selectedComuna: selectedRegion || selectedProvince || selectedComuna ? selectedComuna : savedComuna,
        setSelectedComuna: setSelectedComuna,
        provinceSuggestion: provinces,
        provinceChangeHandler: provinceChangeHandler,
        selectedProvince: selectedRegion || selectedProvince ? selectedProvince : savedProvince,
        deviceType: deviceType,
        tenant: tenant,
        saveZone: saveZone,
        setSelectedRegion: setSelectedRegion,
        getSavedZone: getSavedZone,
        regionInputValue: regionInputValue,
        setRegionInputValue: setRegionInputValue,
        provinceInputValue: provinceInputValue,
        setProvinceInputValue: setProvinceInputValue,
        comunaInputValue: comunaInputValue,
        setComunaInputValue: setComunaInputValue,
        setModalVisible: toggleModal,
        enableEnter: enableEnter,
        onFocus: function onFocus() {
          setEnableEnter(false);
        },
        branding: isBrandingMarketplace ? 'marketplace' : 'retail',
        stockEnTienda: isStockEnTiendaModal ? stockEnTienda : {},
        deliveryOptions: isDeliveryOptionsModal ? deliveryOptions : {},
        isDefaultComuna: isDefaultComuna,
        isStore: isStore,
        enableSisThemedBorder: enableSisThemedBorder,
        isSodimacStandAlone: isSodimacStandAlone,
        setGeofinderProgramatically: tenant === 'cl' ? setGeofinderProgramatically : setGeofinderProgramaticallyFAPE,
        isUserLoggedIn: isUserLoggedIn,
        resetHandler: resetOnModalClose,
        saveAdressData: saveAdressData,
        fetchComunaDefault: fetchComunaDefault,
        setShowLoginForm: setShowLoginForm
      });
    },
    isOverlayEnabled: !isStockEnTiendaModal && !isDeliveryOptionsModal,
    options: {
      width: getModalWidth(),
      height: getModalHeight(),
      disableOutsideClick: false,
      overflow: 'visible',
      borderRadius: deviceType === 'desktop' ? '3px' : '10px 10px 0px 0px',
      padding: deviceType === 'desktop' ? '' : !isStockEnTiendaModal && !isDeliveryOptionsModal && '10px 0px 0px 0px'
    },
    deviceType: deviceType,
    resetHandler: resetOnModalClose,
    withPadding: !isStockEnTiendaModal && !isDeliveryOptionsModal && !isTottusStandAlone,
    closeOtherModals: closeOtherModals,
    fullWidth: deviceType !== 'desktop',
    customClass: deviceType !== 'desktop' && !isStockEnTiendaModal && !isDeliveryOptionsModal ? mobileModalClass : '',
    showCloseButton: false,
    fullScreen: (!!isStockEnTiendaModal || !!isDeliveryOptionsModal) && deviceType !== 'desktop',
    customBodyClass: !!isStockEnTiendaModal || !!isDeliveryOptionsModal || !!isTottusStandAlone ? 'no-custom-class' : customBodyClass(),
    buttonOpenModalID: "geofinder-button-open"
  }, isStockEnTiendaModal || isDeliveryOptionsModal ? jsx("div", null) : jsx("div", {
    className: styles$C['zone-modal-container']
  }, jsx("div", {
    className: "".concat(styles$C['zone-select-wrapper'], "  ").concat(!isSISLevel2Header && styles$C['zone-select-wrapper-sis-level-header'])
  }, jsx("i", {
    style: isBrandingMarketplace ? {
      backgroundImage: "url(".concat(isOrangeOrSISHeader ? geoFinderIconURL : grayHeadergeoFinderIconURL, ")")
    } : {},
    className: classNames(styles$C['icon-location'], styles$C.icon, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$C.marketplace, isBrandingMarketplace), styles$C.retail, !isBrandingMarketplace), styles$C.storeIcon, isStore), styles$C.storeIconWhite, !isSISLevel2Header))
  }, jsx("span", {
    className: styles$C['sr-only']
  }, "location-icon")), jsx(ModalLabelContent, null)))), popOvervisible && !isOnboardingInProgress && jsx(PopOverContent, null), showSuccessModal && jsx(SuccessModal, {
    dismissHandler: function dismissHandler() {
      return setSuccessModal(false);
    },
    isBrandingMarketplace: isBrandingMarketplace,
    notificationLife: notificationLife
  }), showReminderModal && jsx(ReminderModal, {
    dismissHandler: function dismissHandler() {
      return setShowReminderModal(false);
    },
    type: reminderModalType,
    isBrandingMarketplace: isBrandingMarketplace,
    notificationLife: notificationLife
  }));
};
ZoneModal.defaultProps = {
  deviceType: 'desktop',
  isDefaultComuna: false,
  selectedZone: undefined,
  isPopOverVisible: false,
  stockEnTienda: {},
  deliveryOptions: {},
  isUserLoggedIn: false,
  isProgramaticallyGeofinderEnabled: false,
  geofinderConfigs: {},
  isStore: false,
  isTottusStandAloneSite: false
};
ZoneModal.propTypes = process.env.NODE_ENV !== "production" ? {
  deviceType: PropTypes.string,
  tenant: PropTypes.string.isRequired,
  handleRouteChange: PropTypes.func.isRequired,
  isBrandingMarketplace: PropTypes.bool.isRequired,
  entry: PropTypes.object.isRequired,
  modalVisible: PropTypes.bool.isRequired,
  setModalVisible: PropTypes.func.isRequired,
  isOnboardingInProgress: PropTypes.bool.isRequired,
  isDefaultComuna: PropTypes.bool,
  selectedZone: PropTypes.object,
  isPopOverVisible: PropTypes.bool,
  stockEnTienda: PropTypes.object,
  deliveryOptions: PropTypes.object,
  isUserLoggedIn: PropTypes.bool,
  isProgramaticallyGeofinderEnabled: PropTypes.bool,
  geofinderConfigs: PropTypes.object,
  isStore: PropTypes.bool,
  enableSisThemedBorder: PropTypes.bool,
  isTottusStandAloneSite: PropTypes.bool,
  setShowLoginForm: PropTypes.func.isRequired
} : {};

var styles$H = {"container":"NavbarLinks-module_container__1OqNW","content-wrapper":"NavbarLinks-module_content-wrapper__1X23k","content-wrapper-stores":"NavbarLinks-module_content-wrapper-stores__1GaJt","last-dropdown":"NavbarLinks-module_last-dropdown__1v9dT","nav-link--so_com":"NavbarLinks-module_nav-link--so_com__2D2zp","last-nav-link":"NavbarLinks-module_last-nav-link__2Cd0D","onboarding-highlight":"NavbarLinks-module_onboarding-highlight__1Z3nV","stores-wrapper":"NavbarLinks-module_stores-wrapper__V6pHd","stores-list-container":"NavbarLinks-module_stores-list-container__1F5-X","display-none":"NavbarLinks-module_display-none__1s-4e","ours-stores-label":"NavbarLinks-module_ours-stores-label__1n5Ut","store-icon-wrapper":"NavbarLinks-module_store-icon-wrapper__3Pvd3","last-store-icon":"NavbarLinks-module_last-store-icon__9XeAm","stores-icon":"NavbarLinks-module_stores-icon__1tW6w","down-arrow":"NavbarLinks-module_down-arrow__3aTxs","has-dropdown":"NavbarLinks-module_has-dropdown__1iw6X","links-list-container":"NavbarLinks-module_links-list-container__1gewo","links-dropdown":"NavbarLinks-module_links-dropdown__1tlIs","links-style":"NavbarLinks-module_links-style__3Bx2O","popover-on-hover":"NavbarLinks-module_popover-on-hover__1IdBY","width-store-4":"NavbarLinks-module_width-store-4__H3RpE","width-store-3":"NavbarLinks-module_width-store-3__E0aJI","stores-list-container-sis-new":"NavbarLinks-module_stores-list-container-sis-new__2oqFq","storeHighlightAnimation":"NavbarLinks-module_storeHighlightAnimation__3y74D"};

var styles$I = {"popover-container":"Popover-module_popover-container__3qpkj","bottom":"Popover-module_bottom__2rsDO","popover":"Popover-module_popover__2BK5J","bottom-caret-center":"Popover-module_bottom-caret-center__Chzin","bottom-caret-login":"Popover-module_bottom-caret-login__1WGhj","bottom-caret-login-cmr":"Popover-module_bottom-caret-login-cmr__2pSi_","bottom-caret-notlogin":"Popover-module_bottom-caret-notlogin__19OPO","left":"Popover-module_left__2ISqD","compact":"Popover-module_compact__1_wKy","bottom-caret-stores-links":"Popover-module_bottom-caret-stores-links__17eZ3","bottom-caret-links":"Popover-module_bottom-caret-links__CzWAV","medium":"Popover-module_medium__1dZLr","wide":"Popover-module_wide__DFk6y","minimal":"Popover-module_minimal__1vz-a","doc-click-overlay":"Popover-module_doc-click-overlay__2XQNe","doc-click-overlay-relative":"Popover-module_doc-click-overlay-relative__peuMa"};

var WithToggle = function WithToggle(WrappedComponent) {
  var ComponentWithToggle = function ComponentWithToggle(props) {
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      toggle = _useState2[0],
      setToggle = _useState2[1];
    var toggleState = {
      visible: toggle,
      setVisible: function setVisible(bool) {
        return setToggle(bool);
      }
    };
    return jsx(WrappedComponent, _extends({}, props, {
      toggleState: toggleState
    }));
  };
  ComponentWithToggle.originalName = 'WrappedComponent';
  ComponentWithToggle.displayName = 'WithToggle';
  return ComponentWithToggle;
};

var MarketplaceOverlay = function MarketplaceOverlay(_ref) {
  var handlers = _ref.handlers,
    backdropPosition = _ref.backdropPosition,
    setOverlayEnabled = _ref.setOverlayEnabled;
  React.useEffect(function () {
    setOverlayEnabled(true);
    toggleBodyClass(true, 'no-overlay-scroll');
    return function () {
      setOverlayEnabled(false);
      toggleBodyClass(false, 'no-overlay-scroll');
    };
  }, []);
  return jsx(React.Fragment, null, jsx("div", {
    style: backdropPosition,
    className: "overlay",
    onClick: handlers
  }), jsx("style", null, "\n          .overlay {\n            background: rgba(0, 0, 0, 0.7);\n            height: 100vh;\n            position: fixed;\n            left: 0;\n            top: 0;\n            width: 100%;\n            z-index: 100;\n            transition: background-color 0.5s;\n          }\n          .no-overlay-scroll {\n            position: fixed;\n            overflow-y: scroll;\n            inline-size: 100%;\n          }\n        "));
};
MarketplaceOverlay.propTypes = process.env.NODE_ENV !== "production" ? {
  handlers: PropTypes.func,
  backdropPosition: PropTypes.object,
  setOverlayEnabled: PropTypes.func.isRequired
} : {};
MarketplaceOverlay.defaultProps = {
  handlers: noop$1,
  backdropPosition: {}
};
var MarketplaceOverlay$1 = withUser(MarketplaceOverlay);

var Popover = function Popover(_ref) {
  var children = _ref.children,
    content = _ref.content,
    trigger = _ref.trigger,
    toggleState = _ref.toggleState,
    timer = _ref.timer,
    type = _ref.type,
    position = _ref.position,
    dismissOnOutsideClick = _ref.dismissOnOutsideClick,
    enableParentClick = _ref.enableParentClick,
    customClassForPopup = _ref.customClassForPopup,
    hasRelativePosition = _ref.hasRelativePosition,
    backdropPosition = _ref.backdropPosition,
    onHoverStyle = _ref.onHoverStyle,
    setMenuVisible = _ref.setMenuVisible;
  var visible = toggleState.visible,
    setVisible = toggleState.setVisible;
  var triggerPopoverHandler = function triggerPopoverHandler(eventType) {
    if (eventType === trigger) {
      setVisible(true);
      if (setMenuVisible && typeof setMenuVisible === 'function') {
        setMenuVisible(false);
      }
      timer.setToggle(true);
    }
  };
  var dismissHandler = function dismissHandler() {
    setVisible(false);
    timer.setToggle(false);
  };
  var popoverContent = function popoverContent(dismiss) {
    if (typeof content === 'function') {
      return content(dismiss);
    }
    return content;
  };
  var renderChildren = function renderChildren() {
    return React.Children.map(children, function (child) {
      return React.cloneElement(child);
    });
  };
  return jsx(WithOutsideClick, {
    onOutsideClick: function onOutsideClick() {
      if (dismissOnOutsideClick) {
        dismissHandler();
      }
    },
    styles: {
      'doc-click-overlay': styles$I['doc-click-overlay'],
      'doc-click-overlay-relative': styles$I['doc-click-overlay-relative']
    },
    className: hasRelativePosition ? 'doc-click-overlay-relative' : ''
  }, !enableParentClick && jsx("div", {
    className: classNames(_defineProperty({}, onHoverStyle, visible && timer.toggle))
  }, children), jsx("div", {
    className: classNames(styles$I['popover-container'], styles$I["".concat(position)]),
    onKeyPress: noop,
    onClick: function onClick() {
      return triggerPopoverHandler('click');
    },
    onMouseEnter: function onMouseEnter() {
      return triggerPopoverHandler('hover');
    },
    onMouseLeave: function onMouseLeave() {
      return trigger === 'hover' && dismissHandler();
    },
    role: "menuitem",
    tabIndex: "0"
  }, enableParentClick && renderChildren(), visible && timer.toggle && jsx("div", {
    className: classNames(styles$I.popover, styles$I["".concat(type)], customClassForPopup)
  }, popoverContent(dismissHandler))), visible && timer.toggle && backdropPosition && jsx(MarketplaceOverlay$1, {
    backdropPosition: backdropPosition
  }));
};
Popover.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  trigger: PropTypes.oneOf(['click', 'hover']),
  toggleState: PropTypes.object,
  timer: PropTypes.object,
  customClassForPopup: PropTypes.string,
  backdropPosition: PropTypes.object,
  type: PropTypes.oneOf(['default', 'compact', 'wide', 'medium']),
  position: PropTypes.oneOf(['bottom', 'right', 'bottom-caret-center', 'bottom-caret-login', 'bottom-caret-login-cmr', 'bottom-caret-notlogin', 'bottom-caret-stores-links', 'bottom-caret-links']),
  dismissOnOutsideClick: PropTypes.bool,
  enableParentClick: PropTypes.bool,
  onHoverStyle: PropTypes.string,
  hasRelativePosition: PropTypes.bool,
  setMenuVisible: PropTypes.func
} : {};
Popover.defaultProps = {
  trigger: 'click',
  position: 'bottom',
  toggleState: null,
  timer: {
    setToggle: noop,
    toggle: true
  },
  type: 'default',
  customClassForPopup: '',
  backdropPosition: null,
  onHoverStyle: null,
  dismissOnOutsideClick: false,
  enableParentClick: false,
  hasRelativePosition: false
};
var PopoverWithToggle = WithToggle(Popover);

var sisLinksIconData = {
  sodimac: {
    icons: {
      desktop: {
        enabled: '',
        disabled: 'https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltc77ca5e020314ff2/sodimac-disabled.svg'
      },
      mobile: {
        enabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4c09611b59cb4ab4/sodimac_enabled.svg',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt1bcf6f9731bb8aa5/sodimac_disabled.svg'
      },
      tablet: {
        enabled: '',
        disabled: 'https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/bltc77ca5e020314ff2/sodimac-disabled.svg'
      }
    }
  },
  linio: {
    icons: {
      desktop: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7ade53c9276480f9/linio-disabled.svg'
      },
      mobile: {
        enabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt94ad9b607e6962c1/linio_enabled.svg',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt65a907f9e974c0ca/linio_disabled.svg'
      },
      tablet: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7ade53c9276480f9/linio-disabled.svg'
      }
    }
  },
  tottus: {
    icons: {
      desktop: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf096c948d3597c60/tottus-disabled.svg'
      },
      mobile: {
        enabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt80cbc2d0aedde9ba/tottus_enabled.svg',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4006f183a66e4b6e/tottus_disabled.svg'
      },
      tablet: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltf096c948d3597c60/tottus-disabled.svg'
      }
    }
  },
  homecenter: {
    icons: {
      desktop: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt55f993da75fa018d/homecenter-disabled.svg'
      },
      mobile: {
        enabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4c09611b59cb4ab4/sodimac_enabled.svg',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt1bcf6f9731bb8aa5/sodimac_disabled.svg'
      },
      tablet: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt55f993da75fa018d/homecenter-disabled.svg'
      }
    }
  },
  marketplace: {
    icons: {
      desktop: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt422ee1291fbab2a2/marketplace-disabled.svg'
      },
      mobile: {
        enabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt0ec8e7392f212ae9/main_enabled.svg',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3d85d8338375406b/65562af1647c280cbd4e9275/main_disabled.svg'
      },
      tablet: {
        enabled: '',
        disabled: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt422ee1291fbab2a2/marketplace-disabled.svg'
      }
    }
  }
};

var contentMaker = function contentMaker(_ref) {
  var _ref$dropdownItem = _ref.dropdownItem,
    dropdownItem = _ref$dropdownItem === void 0 ? [] : _ref$dropdownItem,
    _ref$isStoresContent = _ref.isStoresContent,
    isStoresContent = _ref$isStoresContent === void 0 ? false : _ref$isStoresContent,
    _ref$lastItemStyle = _ref.lastItemStyle,
    lastItemStyle = _ref$lastItemStyle === void 0 ? false : _ref$lastItemStyle,
    index = _ref.index;
  return jsx("div", {
    className: isStoresContent ? styles$H['content-wrapper-stores'] : styles$H['content-wrapper']
  }, dropdownItem.map(function (_ref2, i) {
    var _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? '' : _ref2$title,
      is_new_tab = _ref2.is_new_tab,
      url = _ref2.url;
    return jsx("a", {
      id: "testId-bottom-header-links-".concat(index, "-").concat(i),
      className: lastItemStyle ? styles$H['last-dropdown'] : '',
      key: title,
      href: url,
      target: is_new_tab ? '_blank' : '',
      rel: "noreferrer",
      onClick: function onClick() {
        return updateDigitalDataCookies({
          firstLevelItem: "N2 - ".concat(title),
          tag: HEADER
        });
      }
    }, title);
  }));
};
var Stores = function Stores(_ref3) {
  var storeList = _ref3.storeList,
    title = _ref3.title,
    isOnboardingInProgress = _ref3.isOnboardingInProgress,
    isNewNavigation = _ref3.isNewNavigation,
    deviceType = _ref3.deviceType,
    _ref3$currentPage = _ref3.currentPage,
    currentPage = _ref3$currentPage === void 0 ? '' : _ref3$currentPage;
  return jsx("div", {
    className: "".concat(styles$H['stores-list-container'], " ").concat(isNewNavigation ? styles$H['stores-list-container-sis-new'] : null)
  }, !isNewNavigation && title && jsx("p", {
    className: styles$H['ours-stores-label']
  }, title), jsx("div", {
    className: "".concat(styles$H['stores-wrapper'], " ").concat(isOnboardingInProgress ? styles$H['onboarding-highlight'] : null)
  }, storeList.map(function (store, i) {
    var dropdownItem = get(store, 'dropdown_items', []);
    var isNotAllStores = storeList.length <= 4;
    if (dropdownItem.length) {
      return jsx(PopoverWithToggle, {
        trigger: "hover",
        position: "bottom-caret-stores-links",
        hasRelativePosition: true,
        backdropPosition: {
          top: "".concat(120 - (isWindow$1() ? window.pageYOffset || document.documentElement.scrollTop : {}), "px")
        },
        content: contentMaker({
          dropdownItem: dropdownItem,
          isStoresContent: true,
          index: i
        })
      }, jsx("div", {
        className: "".concat(styles$H['store-icon-wrapper'], " ").concat(i === storeList.stores.length - 1 && styles$H['last-store-icon'], " "),
        key: "stores-list-".concat(i)
      }, jsx("div", {
        style: {
          backgroundImage: "url(".concat(get(store, 'icon.url', ''), ")")
        },
        className: "".concat(styles$H['stores-icon'], " ").concat(styles$H['has-dropdown'])
      }), jsx("div", {
        className: styles$H['down-arrow']
      })));
    }
    var getStoreName = function getStoreName() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var storeMatch = matchStoreName(text);
      if (storeMatch) {
        return SIS_STORE_MAP[storeMatch];
      }
      return 'marketplace';
    };
    var isActivePage = function isActivePage(url) {
      return getStoreName(url).toLowerCase() === currentPage.toLocaleLowerCase();
    };
    var addDataStoreAttr = function addDataStoreAttr() {
      return isNewNavigation && {
        'data-page-active': isActivePage(store.url.href)
      };
    };
    var setBackgroundImageUrl = function setBackgroundImageUrl() {
      if (!isNewNavigation) return get(store, 'icon.url', '');
      var storeUrl = get(store, 'url.href', '');
      var isActive = isActivePage(storeUrl);
      var storeName = getStoreName(storeUrl).toLocaleLowerCase();
      var _ref4 = sisLinksIconData[storeName] && isActive ? sisLinksIconData[storeName].icons[deviceType] : sisLinksIconData[storeName].icons[deviceType],
        enabled = _ref4.enabled,
        disabled = _ref4.disabled;
      if ((isActive || !isActive) && currentPage === 'marketplace') {
        return deviceType !== 'mobile' ? get(store, 'icon.url', '') : enabled;
      }
      if (isActive) {
        return isActive && deviceType !== 'mobile' ? get(store, 'icon.url', '') : enabled;
      }
      return disabled;
    };
    var getBackgroundImage = function getBackgroundImage() {
      return isNewNavigation ? "url(".concat(setBackgroundImageUrl(), ")") : "url(".concat(get(store, 'icon.url', ''), ")");
    };
    return jsx("div", _extends({
      className: "".concat(styles$H['store-icon-wrapper'], " ").concat(i === storeList.length - 1 && styles$H['last-store-icon'], " ").concat(isNotAllStores && isNewNavigation && styles$H["width-store-".concat(storeList.length)], " "),
      key: "stores-list-".concat(i)
    }, addDataStoreAttr()), jsx("a", {
      id: "testId-store-links-".concat(i),
      href: store.url.href,
      target: store.is_new_tab ? '_blank' : '',
      rel: "noreferrer",
      onClick: function onClick() {
        return updateDigitalDataCookies({
          firstLevelItem: "N".concat(isNewNavigation ? '0' : '2', " - Store ").concat(getStoreName(store.url.href)),
          tag: HEADER
        });
      }
    }, jsx("div", {
      style: {
        backgroundImage: getBackgroundImage(),
        width: "".concat(!isNewNavigation && getWidthForStoreIcon(get(store, 'icon.title', '')), "px")
      },
      className: "".concat(styles$H['stores-icon'])
    })));
  })));
};
Stores.propTypes = process.env.NODE_ENV !== "production" ? {
  storeList: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  isOnboardingInProgress: PropTypes.bool.isRequired,
  isNewNavigation: PropTypes.bool
} : {};
var AdditonalLinks = function AdditonalLinks(_ref5) {
  var links = _ref5.links,
    topPosition = _ref5.topPosition,
    store = _ref5.store;
  return jsx("div", {
    className: styles$H['links-list-container']
  }, links.map(function (_ref6, i) {
    var _ref6$title = _ref6.title,
      title = _ref6$title === void 0 ? '' : _ref6$title,
      _ref6$url = _ref6.url,
      url = _ref6$url === void 0 ? '' : _ref6$url,
      _ref6$is_new_tab = _ref6.is_new_tab,
      is_new_tab = _ref6$is_new_tab === void 0 ? false : _ref6$is_new_tab,
      _ref6$last_item_style = _ref6.last_item_style,
      last_item_style = _ref6$last_item_style === void 0 ? false : _ref6$last_item_style,
      _ref6$dropdown_items = _ref6.dropdown_items,
      dropdown_items = _ref6$dropdown_items === void 0 ? [] : _ref6$dropdown_items;
    if (dropdown_items.length) {
      return jsx(PopoverWithToggle, {
        key: title,
        trigger: "hover",
        position: "bottom-caret-links",
        hasRelativePosition: true,
        onHoverStyle: styles$H['popover-on-hover'],
        customClassForPopup: classNames(_defineProperty(_defineProperty({}, styles$H['nav-link--so_com'], getStandaloneSite(store).isSodimacStandalone), styles$H['last-nav-link'], i === links.length - 1)),
        backdropPosition: {
          top: "".concat(topPosition - (isWindow$1() ? window.pageYOffset || document.documentElement.scrollTop : {}), "px")
        },
        content: contentMaker({
          dropdownItem: dropdown_items,
          lastItemStyle: last_item_style,
          index: i
        })
      }, jsx("div", {
        id: "testId-extra-links-dropdown-".concat(i),
        className: styles$H['links-dropdown'],
        key: "links-list-".concat(i)
      }, jsx("div", null, title), jsx("div", {
        className: styles$H['down-arrow']
      })));
    }
    return jsx("a", {
      id: "testId-extra-links-".concat(i),
      className: styles$H['links-style'],
      key: title,
      href: url,
      target: is_new_tab ? '_blank' : '',
      rel: "noreferrer",
      onClick: function onClick() {
        return updateDigitalDataCookies({
          firstLevelItem: "N2 - ".concat(title),
          tag: HEADER
        });
      }
    }, title);
  }));
};
AdditonalLinks.propTypes = process.env.NODE_ENV !== "production" ? {
  links: PropTypes.arrayOf(PropTypes.object),
  topPosition: PropTypes.number.isRequired,
  store: PropTypes.string
} : {};
var StoresAndLinks = function StoresAndLinks(_ref7) {
  var ourStores = _ref7.ourStores,
    additonalLinks = _ref7.additonalLinks,
    isOnboardingInProgress = _ref7.isOnboardingInProgress,
    isVendorLoggedIn = _ref7.isVendorLoggedIn,
    isAgentLoggedIn = _ref7.isAgentLoggedIn,
    isNewNavigation = _ref7.isNewNavigation,
    currentPage = _ref7.currentPage,
    deviceType = _ref7.deviceType,
    isStoreVisible = _ref7.isStoreVisible,
    store = _ref7.store;
  var headerHeight = getHeaderHeight({
    isVendorLoggedIn: isVendorLoggedIn,
    isAgentLoggedIn: isAgentLoggedIn
  });
  return jsx("div", {
    className: styles$H.container
  }, ourStores.length >= 1 && isStoreVisible ? jsx(Stores, {
    isOnboardingInProgress: isOnboardingInProgress,
    storeList: ourStores,
    title: ourStores.title,
    isNewNavigation: isNewNavigation,
    deviceType: deviceType,
    currentPage: currentPage
  }) : null, additonalLinks.length ? jsx(AdditonalLinks, {
    topPosition: headerHeight.totalVisibleHeight,
    links: additonalLinks,
    store: store
  }) : null);
};
StoresAndLinks.propTypes = process.env.NODE_ENV !== "production" ? {
  ourStores: PropTypes.arrayOf(PropTypes.object),
  additonalLinks: PropTypes.arrayOf(PropTypes.object),
  isOnboardingInProgress: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  isAgentLoggedIn: PropTypes.bool,
  isNewNavigation: PropTypes.bool,
  currentPage: PropTypes.string,
  deviceType: PropTypes.string,
  isStoreVisible: PropTypes.bool,
  store: PropTypes.string
} : {};
StoresAndLinks.defaultProps = {
  ourStores: [],
  additonalLinks: [],
  isOnboardingInProgress: false,
  isVendorLoggedIn: false,
  isAgentLoggedIn: false,
  isNewNavigation: false,
  currentPage: '',
  isStoreVisible: true
};

var TernaryNavBar = function TernaryNavBar(_ref) {
  var currentStep = _ref.currentStep,
    deviceType = _ref.deviceType,
    handleRouteChange = _ref.handleRouteChange,
    header = _ref.header,
    hideNavbar = _ref.hideNavbar,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isBrandingMarketplace = _ref.isBrandingMarketplace,
    isDefaultComuna = _ref.isDefaultComuna,
    isOnboardingDisabledCookie = _ref.isOnboardingDisabledCookie,
    isOnboardingEnabled = _ref.isOnboardingEnabled,
    isOverlayEnabled = _ref.isOverlayEnabled,
    isPopOverVisible = _ref.isPopOverVisible,
    isVendorLoggedIn = _ref.isVendorLoggedIn,
    isZoneModalEnabled = _ref.isZoneModalEnabled,
    modalVisible = _ref.modalVisible,
    selectedZone = _ref.selectedZone,
    setModalVisible = _ref.setModalVisible,
    tenant = _ref.tenant,
    storeName = _ref.storeName,
    isUserLoggedIn = _ref.isUserLoggedIn,
    isProgramaticallyGeofinderEnabled = _ref.isProgramaticallyGeofinderEnabled,
    geofinderConfigs = _ref.geofinderConfigs,
    isOrangeOrSISHeader = _ref.isOrangeOrSISHeader,
    isSISLevel2Header = _ref.isSISLevel2Header,
    store = _ref.store,
    baseUrl = _ref.baseUrl,
    setShowLoginForm = _ref.setShowLoginForm;
  if (!isZoneModalEnabled && deviceType === 'mobile' || hideNavbar) {
    return jsx(React.Fragment, null);
  }
  var _header$entry = header.entry,
    entry = _header$entry === void 0 ? {} : _header$entry;
  var ourStores = get(entry, 'sis_configs.0.stores', []).filter(function (st) {
    return st.is_enable;
  }).sort(function (a, b) {
    return a.order - b.order;
  });
  var additonalLinks = get(entry, 'bottom_right_links', []);
  var sisfilteredStores = getStoreNameFromSisPage(ourStores, storeName.toLowerCase());
  var _getStandaloneSite = getStandaloneSite(store),
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone;
  var isNewNavigation = !isSISLevel2Header;
  var showStore = !!(!isNewNavigation && true);
  return jsx("nav", {
    className: classNames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles$B['ternary-nav-bar'], true), styles$B.overshadow, !(modalVisible || isOverlayEnabled)), styles$B['ternary-nav-bar-sis-level-header'], !isSISLevel2Header), styles$B['ternary-nav-bar--so_com'], isSodimacStandalone), styles$B['ternary-nav-bar--to_com'], isTottusStandalone))
  }, isZoneModalEnabled && jsx("div", {
    className: classNames(styles$B.container, styles$B['zone-container'])
  }, jsx(React.Fragment, null, jsx(ZoneModal, {
    deviceType: deviceType,
    tenant: tenant,
    isDefaultComuna: isDefaultComuna,
    selectedZone: selectedZone,
    handleRouteChange: handleRouteChange,
    isOnboardingInProgress: isOnboardingEnabled && currentStep <= 1 && !isOnboardingDisabledCookie,
    entry: entry,
    baseUrl: baseUrl,
    modalVisible: modalVisible,
    setModalVisible: setModalVisible,
    isBrandingMarketplace: isBrandingMarketplace,
    isPopOverVisible: isPopOverVisible,
    isUserLoggedIn: isUserLoggedIn,
    isProgramaticallyGeofinderEnabled: isProgramaticallyGeofinderEnabled,
    geofinderConfigs: geofinderConfigs,
    isStore: !!storeName,
    store: store,
    isOrangeOrSISHeader: isOrangeOrSISHeader,
    isSISLevel2Header: isSISLevel2Header,
    enableSisThemedBorder: !!isSodimacStandalone,
    isSodimacStandAlone: isSodimacStandalone,
    isTottusStandAlone: isTottusStandalone,
    setShowLoginForm: setShowLoginForm
  }))), jsx(MatchMedia$1, {
    key: "search-bar-desktop",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(StoresAndLinks, {
          ourStores: sisfilteredStores.stores,
          isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 0,
          additonalLinks: additonalLinks,
          isAgentLoggedIn: isAgentLoggedIn,
          isVendorLoggedIn: isVendorLoggedIn,
          isNewNavigation: isNewNavigation,
          isStoreVisible: showStore,
          store: store
        });
      },
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      }
    }
  }));
};
TernaryNavBar.propTypes = process.env.NODE_ENV !== "production" ? {
  currentStep: PropTypes.number.isRequired,
  deviceType: PropTypes.string.isRequired,
  handleRouteChange: PropTypes.func.isRequired,
  header: PropTypes.object,
  hideNavbar: PropTypes.bool,
  isAgentLoggedIn: PropTypes.bool,
  isBrandingMarketplace: PropTypes.bool.isRequired,
  isDefaultComuna: PropTypes.bool,
  isOnboardingDisabledCookie: PropTypes.bool,
  isOnboardingEnabled: PropTypes.bool.isRequired,
  isOverlayEnabled: PropTypes.bool,
  isPopOverVisible: PropTypes.bool,
  searchInSis: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool,
  isZoneModalEnabled: PropTypes.bool,
  modalVisible: PropTypes.bool.isRequired,
  selectedZone: PropTypes.object,
  setModalVisible: PropTypes.func.isRequired,
  tenant: PropTypes.string.isRequired,
  isSearchBarTouched: PropTypes.bool,
  storeName: PropTypes.string,
  isUserLoggedIn: PropTypes.bool,
  isProgramaticallyGeofinderEnabled: PropTypes.bool,
  geofinderConfigs: PropTypes.object,
  isOrangeOrSISHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  store: PropTypes.string
} : {};
TernaryNavBar.defaultProps = {
  header: {},
  hideNavbar: false,
  isAgentLoggedIn: false,
  isDefaultComuna: false,
  isOnboardingDisabledCookie: false,
  isOverlayEnabled: false,
  isPopOverVisible: false,
  searchInSis: false,
  isVendorLoggedIn: false,
  isZoneModalEnabled: false,
  selectedZone: undefined,
  isSearchBarTouched: false,
  isUserLoggedIn: false,
  isProgramaticallyGeofinderEnabled: false,
  geofinderConfigs: {},
  isSISLevel2Header: true
};
var TernaryNavBar$1 = withUser(TernaryNavBar);

var trackMapping = {
  search: 'tag_new_slp',
  noResult: 'tag_new_slp_no_result',
  category: 'tag_new_plp',
  product: 'tag_new_pdp',
  error: 'error'
};
var track = function track(eventName) {
  var eventValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (window && window._satellite) {
    if (eventValue) {
      window._satellite.track(eventName, eventValue);
      return;
    }
    window._satellite.track(eventName);
  }
};
var pageBottom = function pageBottom() {
  if (window && window._satellite && window._satellite.pageBottom) {
    console.log('satellite is present');
    var eventToDigitalData = new CustomEvent('DDCCSatelliteIsPresent');
    window.dispatchEvent(eventToDigitalData);
    window._satellite.pageBottom();
  } else {
    console.log('satellite is not present');
  }
};
var updateData = function updateData() {
  updateDigitalData();
  var page = getPage(window.location.href);
  var event = trackMapping[page];
  track(event);
};
var initAnalitycs = function initAnalitycs(parentRouter) {
  return function () {
    if (parentRouter && parentRouter.events) {
      parentRouter.events.on('routeChangeComplete', function () {
        updateData();
      });
      parentRouter.events.on('routeChangeStart', function () {
        window.previousUrl = window.location.href;
      });
      pageBottom();
    }
  };
};
var loadAnalytics = function () {
  var _ref = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(parentRouter) {
    var country, env, isSodimacStandAloneSite, isTottusStandAloneSite, url, script;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return initDigitalData();
        case 2:
          country = getCountry();
          env = getEnvironment();
          isSodimacStandAloneSite = isCurrentUrlSodimacStandAlone();
          isTottusStandAloneSite = isCurrentUrlTottusStandAlone();
          if (isSodimacStandAloneSite) {
            url = analyticsInfo.tagManager[country].sodimac[env];
          } else if (isTottusStandAloneSite) {
            url = analyticsInfo.tagManager[country].tottus[env];
          } else {
            url = analyticsInfo.tagManager[country][env];
          }
          script = createScriptTag({
            src: url,
            onLoad: initAnalitycs(parentRouter)
          });
          appendNodeToHead(script);
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadAnalytics(_x) {
    return _ref.apply(this, arguments);
  };
}();

var styles$J = {"onboarding-modal-wrapper":"onboarding-module_onboarding-modal-wrapper__2bbZ8","onboarding-mobile-container":"onboarding-module_onboarding-mobile-container__Qj4dv","onboarding-animation-in":"onboarding-module_onboarding-animation-in__2L3Vz","fadeIn":"onboarding-module_fadeIn__1BOed","onboarding-animation-out":"onboarding-module_onboarding-animation-out__1qolr","fadeOut":"onboarding-module_fadeOut__Z-Otl","hide":"onboarding-module_hide__3psRY","opacity-1":"onboarding-module_opacity-1__2ORer","opacity-0":"onboarding-module_opacity-0__1HUUS","title":"onboarding-module_title__BZKam","cl":"onboarding-module_cl__O7r3i","step-0":"onboarding-module_step-0__2BCIQ","step-1":"onboarding-module_step-1__2T94G","pe":"onboarding-module_pe__1fzat","description-container":"onboarding-module_description-container__i0i0a","button-next":"onboarding-module_button-next__25xb4","actions-container":"onboarding-module_actions-container__2z5W_","pagination":"onboarding-module_pagination__3qEPG","current":"onboarding-module_current__2LJxY"};

var OnboardingMobile = function OnboardingMobile(_ref) {
  var data = _ref.data,
    currentStep = _ref.currentStep,
    nextStep = _ref.nextStep,
    skip = _ref.skip,
    deviceType = _ref.deviceType,
    hasNextStep = _ref.hasNextStep,
    tenant = _ref.tenant;
  var _useState = useState('floatBottomTransition'),
    _useState2 = _slicedToArray(_useState, 2),
    animationClass = _useState2[0],
    setAnimationClass = _useState2[1];
  var hideModal = function hideModal(callback) {
    setAnimationClass('floatBottomEndTransitionOnboarding');
    var animationTimer = setTimeout(function () {
      callback();
      clearTimeout(animationTimer);
    }, 350);
  };
  var onSkip = function onSkip() {
    hideModal(skip);
  };
  var onNext = function onNext() {
    if (!hasNextStep) {
      hideModal(nextStep);
    } else {
      document.getElementsByClassName(styles$J['onboarding-mobile-container'])[0].classList.add(styles$J['onboarding-animation-out']);
      var animationTimer = setTimeout(function () {
        nextStep();
        document.getElementsByClassName(styles$J['onboarding-mobile-container'])[0].classList.add(styles$J['onboarding-animation-in']);
        clearTimeout(animationTimer);
      }, 10);
    }
  };
  var heightMap = {
    cl: window.innerWidth > 367 ? 389 : 412,
    pe: ''
  };
  return jsx("div", {
    className: styles$J['onboarding-modal-wrapper'],
    id: "onboarding-mobile-modal-wrapper"
  }, jsx(Modal, {
    toggleState: {
      visible: true,
      setVisible: function setVisible() {}
    },
    content: function content() {
      return jsx("div", {
        className: "".concat(styles$J['onboarding-mobile-container'], " ").concat(currentStep === 1 ? styles$J['onboarding-animation'] : '')
      }, jsx("div", {
        className: "".concat(styles$J['title'], " ").concat(styles$J["".concat(tenant)], " ").concat(currentStep === 1 && styles$J['hide']),
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(data[currentStep].title)
        }
      }), jsx("img", {
        src: data[0].image.url,
        alt: data[0].image.title,
        className: "\n                  ".concat(tenant, "\n                  ").concat(styles$J['step-0'], "\n                  ").concat(currentStep === 0 && styles$J['opacity-1'], "\n                "),
        style: {
          position: currentStep === 0 && 'relative'
        }
      }), data.length === 2 && jsx("img", {
        src: data[1].image.url,
        alt: data[1].image.title,
        className: "\n                              ".concat(styles$J['step-1'], "\n                              ").concat(currentStep === 1 && styles$J['opacity-1'], "\n                            "),
        style: {
          position: currentStep === 1 && 'relative'
        }
      }), jsx("div", {
        className: styles$J['description-container'],
        "data-step": currentStep,
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(data[currentStep].description)
        }
      }), jsx("button", {
        id: "testId-onboarding-mobile-step-".concat(currentStep),
        className: styles$J['button-next'],
        onClick: onNext
      }, jsx("span", null, data[currentStep].buttonText)), data.length > 1 && jsx("div", {
        className: styles$J['actions-container']
      }, jsx("button", {
        id: "testId-onboarding-mobile-skip",
        onClick: onSkip
      }, data[currentStep].jumpButtonText), jsx("div", {
        className: styles$J['pagination']
      }, jsx("div", {
        className: currentStep === 0 && styles$J['current']
      }), jsx("div", {
        className: currentStep === 1 && styles$J['current']
      }))));
    },
    options: {
      height: heightMap[tenant],
      disableOutsideClick: false,
      overflow: 'visible',
      borderRadius: '12px 12px 0px 0px',
      padding: '32px 16px 0',
      marginTop: deviceType === 'tablet' ? 'auto' : '0px',
      minWidth: 'auto'
    },
    deviceType: deviceType,
    resetHandler: function resetHandler() {},
    closeOtherModals: function closeOtherModals() {},
    customClass: animationClass,
    showCloseButton: false,
    customBodyClass: 'onboarding-mobile-modal-body',
    withPadding: false,
    zoneModalWrapStyles: {
      marginTop: 'auto'
    },
    modalContainerZIndex: 9001
  }));
};
OnboardingMobile.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
  nextStep: PropTypes.func.isRequired,
  skip: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired,
  hasNextStep: PropTypes.bool.isRequired,
  tenant: PropTypes.string.isRequired
} : {};

var styles$K = {"onboarding-modal-wrapper":"onboarding-module_onboarding-modal-wrapper__1AGU9","modal-animation":"onboarding-module_modal-animation__25x10","onboarding-desktop-container":"onboarding-module_onboarding-desktop-container__1TY2H","onboarding-title":"onboarding-module_onboarding-title__2FmTe","pe":"onboarding-module_pe__2Q5qa","description-container":"onboarding-module_description-container__3GVer","button-next":"onboarding-module_button-next__c4kQ0","actions-container":"onboarding-module_actions-container__1AIjc","action-step-1":"onboarding-module_action-step-1__FfKuK","pagination":"onboarding-module_pagination__3Nw8u","current":"onboarding-module_current__3zzpr"};

var OnboardingDesktop = function OnboardingDesktop(_ref) {
  var data = _ref.data,
    currentStep = _ref.currentStep,
    nextStep = _ref.nextStep,
    skip = _ref.skip,
    hasNextStep = _ref.hasNextStep,
    tenant = _ref.tenant;
  var onNext = function onNext() {
    nextStep();
  };
  var calculateTranslateProp = function calculateTranslateProp() {
    if (isWindow$1()) {
      var width = window.innerWidth / 2 - 289;
      var height = -window.innerHeight / 2 + 212;
      return {
        transform: "translate(".concat(width, "px, ").concat(height, "px)")
      };
    }
    return undefined;
  };
  return jsx("div", {
    className: styles$K['onboarding-modal-wrapper'],
    id: "onboarding-desktop-modal-wrapper"
  }, jsx(Modal, {
    toggleState: {
      visible: true,
      setVisible: function setVisible() {}
    },
    content: function content() {
      return jsx("div", {
        className: styles$K['onboarding-desktop-container']
      }, currentStep === 0 && jsx("div", {
        className: "".concat(styles$K['onboarding-title'], " ").concat(styles$K[tenant]),
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(data[currentStep].title)
        }
      }), jsx("div", {
        className: styles$K['description-container'],
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(data[currentStep].description)
        }
      }), jsx("button", {
        id: "testId-onboarding-desktop-step-".concat(currentStep),
        className: styles$K['button-next'],
        onClick: onNext
      }, data[currentStep].buttonText), data.length > 1 && jsx("div", {
        className: "".concat(styles$K['actions-container'], " ").concat(currentStep === 1 ? styles$K['action-step-1'] : '')
      }, jsx("button", {
        id: "testId-onboarding-desktop-skip",
        onClick: skip
      }, data[currentStep].jumpButtonText), jsx("div", {
        className: styles$K['pagination']
      }, jsx("div", {
        className: currentStep === 0 && styles$K['current']
      }), jsx("div", {
        className: currentStep === 1 && styles$K['current']
      }))));
    },
    options: {
      width: 500,
      disableOutsideClick: false,
      overflow: 'visible',
      borderRadius: '12px',
      padding: '32px 24px 36px 24px',
      minWidth: 'auto',
      minHeight: 'auto'
    },
    customBodyClass: "onboarding-desktop-modal-body",
    deviceType: "desktop",
    resetHandler: function resetHandler() {},
    closeOtherModals: function closeOtherModals() {},
    customClass: 'floatBottomTransition',
    showCloseButton: false,
    modalAnimationClass: currentStep === 1 && styles$K['modal-animation'],
    modalTranslateStyle: currentStep === 1 && calculateTranslateProp(),
    withPadding: false,
    modalContainerZIndex: 9001
  }));
};
OnboardingDesktop.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
  nextStep: PropTypes.func.isRequired,
  skip: PropTypes.func.isRequired,
  tenant: PropTypes.string.isRequired
} : {};

var buildOnboardingData = function buildOnboardingData(data) {
  var mobile = get(data, 'mobile', []).map(function (d) {
    return {
      title: get(d, 'title', ''),
      enabled: get(d, 'enabled', false),
      description: get(d, 'description', ''),
      image: {
        filename: get(d, 'image.filename', ''),
        title: get(d, 'image.title', ''),
        tags: get(d, 'image.tags', []),
        url: get(d, 'image.url', '')
      },
      buttonText: get(d, 'button_text', ''),
      jumpButtonText: get(d, 'jump_button_text', '')
    };
  });
  var desktop = get(data, 'desktop', []).map(function (d) {
    return {
      title: get(d, 'title', ''),
      enabled: get(d, 'enabled', false),
      description: get(d, 'description', ''),
      buttonText: get(d, 'button_text', ''),
      jumpButtonText: get(d, 'jump_button_text', '')
    };
  });
  return {
    desktop: desktop,
    mobile: mobile,
    tablet: mobile
  };
};
var onboardingCookieName = 'on_boarding';
var onboardingCookieValues = {
  SKIPPED: 'skipped',
  DONE: 'done'
};
var Onboarding = function Onboarding(_ref) {
  var deviceType = _ref.deviceType,
    onboardingData = _ref.onboardingData,
    currentStep = _ref.currentStep,
    setCurrentStep = _ref.setCurrentStep,
    tenant = _ref.tenant;
  if (!onboardingData || deviceType === 'mobile' && isEmpty$1(get(onboardingData, 'mobile')) || deviceType === 'tablet' && isEmpty$1(get(onboardingData, 'mobile')) || deviceType === 'desktop' && isEmpty$1(get(onboardingData, 'desktop')) || isWindow$1() && CookieStorage.getCookie(onboardingCookieName) === onboardingCookieValues.DONE || currentStep > 1) {
    return null;
  }
  var data = buildOnboardingData(onboardingData);
  var isCurrentStepEnabled = get(data, "".concat(deviceType, "[").concat(currentStep, "].enabled"));
  var hasNextStep = get(data, "".concat(deviceType, "[").concat(currentStep + 1, "].enabled"));
  if (!isCurrentStepEnabled && currentStep === 0) {
    if (!get(data, "".concat(deviceType, "[1].enabled"))) {
      return null;
    }
    setCurrentStep(1);
  } else if (!isCurrentStepEnabled && currentStep === 1) {
    return null;
  }
  var disableOnboarding = function disableOnboarding() {
    var skipped = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var ended = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (isWindow$1()) {
      var onboardingCookieValue = CookieStorage.getCookie(onboardingCookieName);
      if (onboardingCookieValue === onboardingCookieValues.SKIPPED || ended) {
        CookieStorage.setCookie({
          name: onboardingCookieName,
          value: onboardingCookieValues.DONE,
          regionCode: tenant
        });
      } else if (!onboardingCookieValue && skipped) {
        CookieStorage.setCookie({
          name: onboardingCookieName,
          value: onboardingCookieValues.SKIPPED,
          regionCode: tenant
        });
      }
    }
  };
  var nextStep = function nextStep() {
    if (currentStep === 0 && !hasNextStep || currentStep === 1) {
      disableOnboarding(false, true);
    }
    setCurrentStep(function (state) {
      return state + 1;
    });
  };
  var skip = function skip() {
    disableOnboarding(true, false);
    setCurrentStep(2);
  };
  return jsx(MatchMedia$1, {
    key: "onboarding-flow",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(OnboardingDesktop, {
          data: data.desktop,
          currentStep: currentStep,
          nextStep: nextStep,
          skip: skip,
          hasNextStep: hasNextStep,
          tenant: tenant
        });
      },
      tablet: function tablet() {
        return jsx(OnboardingMobile, {
          data: data.mobile,
          currentStep: currentStep,
          nextStep: nextStep,
          skip: skip,
          deviceType: "tablet",
          hasNextStep: hasNextStep,
          tenant: tenant
        });
      },
      mobile: function mobile() {
        return jsx(OnboardingMobile, {
          data: data.mobile,
          currentStep: currentStep,
          nextStep: nextStep,
          skip: skip,
          deviceType: "mobile",
          hasNextStep: hasNextStep,
          tenant: tenant
        });
      }
    }
  });
};
Onboarding.propTypes = process.env.NODE_ENV !== "production" ? {
  onboardingData: PropTypes.object.isRequired,
  deviceType: PropTypes.string.isRequired,
  tenant: PropTypes.string.isRequired,
  currentStep: PropTypes.number.isRequired,
  setCurrentStep: PropTypes.func.isRequired
} : {};

var nameHOC$2 = function nameHOC(Component) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "".concat(Component.originalName || Component.displayName || Component.name || 'Component').concat(suffix);
};
var SkipSSR = function SkipSSR(WrappedComponent) {
  var ComponentWithoutSSR = function ComponentWithoutSSR(props) {
    var _ref = props || {},
      _ref$forceSSR = _ref.forceSSR,
      forceSSR = _ref$forceSSR === void 0 ? false : _ref$forceSSR,
      rest = _objectWithoutProperties(_ref, ["forceSSR"]);
    var _useState = useState(forceSSR),
      _useState2 = _slicedToArray(_useState, 2),
      render = _useState2[0],
      setRender = _useState2[1];
    useEffect(function () {
      setRender(true);
    }, []);
    return render ? jsx(WrappedComponent, rest) : jsx(Fragment, null);
  };
  ComponentWithoutSSR.originalName = nameHOC$2(WrappedComponent);
  ComponentWithoutSSR.displayName = nameHOC$2(WrappedComponent, 'WithoutSSR');
  return ComponentWithoutSSR;
};

var styles$L = {"container":"SiSNavigationMenu-module_container__1t9Q_","item-name-with-double-lines":"SiSNavigationMenu-module_item-name-with-double-lines__1s9p7"};

var styles$M = {"container-top-menu":"CategoryButton-module_container-top-menu__3Aj-w","top-menu-line":"CategoryButton-module_top-menu-line__3TOWq","top-menu":"CategoryButton-module_top-menu__1HTfC","categoryWrapper":"CategoryButton-module_categoryWrapper__xpc56","categoryWrapper--to_com":"CategoryButton-module_categoryWrapper--to_com__3kVkS","chevron-container":"CategoryButton-module_chevron-container__3uSEj","chevron-down":"CategoryButton-module_chevron-down__1IF4v","chevron-down--to_com":"CategoryButton-module_chevron-down--to_com__dgUBX","active":"CategoryButton-module_active__1u65s","name":"CategoryButton-module_name__I26aI"};

var CategoryButton = function CategoryButton(_ref) {
  var onItemWithSubCategoriesSelected = _ref.onItemWithSubCategoriesSelected,
    isOpen = _ref.isOpen,
    classes = _ref.classes,
    style = _ref.style,
    id = _ref.id,
    store = _ref.store;
  var _getStandaloneSite = getStandaloneSite(store),
    isTottusStandalone = _getStandaloneSite.isTottusStandalone;
  return jsx("div", {
    className: styles$M['container-top-menu'],
    "data-testid": "CategoryButton"
  }, jsx("div", {
    className: classNames(styles$M['top-menu'], classes.join(' ')),
    style: _objectSpread2({}, style),
    id: id
  }, jsx("div", {
    className: classNames(styles$M.categoryWrapper, _defineProperty({}, styles$M['categoryWrapper--to_com'], isTottusStandalone)),
    onClick: function onClick() {
      return onItemWithSubCategoriesSelected(!isOpen);
    }
  }, "Categor\xEDas", jsx("div", {
    className: styles$M['chevron-container']
  }, jsx("i", {
    "aria-hidden": "true",
    className: classNames(styles$M['chevron-down'], _defineProperty(_defineProperty({}, styles$M['chevron-down--to_com'], isTottusStandalone), styles$M.active, isOpen))
  })))));
};
CategoryButton.propTypes = process.env.NODE_ENV !== "production" ? {
  brandLogo: PropTypes.shape({
    url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      })
    })
  }),
  categories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    channel: PropTypes.shape({
      desktop: PropTypes.bool,
      mobile: PropTypes.bool,
      app: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      item_image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        }),
        app: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })),
    second_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      }),
      third_level_categories: PropTypes.arrayOf(PropTypes.shape({
        item_name: PropTypes.string,
        item_url: PropTypes.string,
        new_tab: PropTypes.bool,
        tag: PropTypes.shape({
          show: PropTypes.bool,
          text: PropTypes.string,
          background_color: PropTypes.string
        })
      }))
    })),
    banners: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.shape({
        href: PropTypes.string
      }),
      new_tab: PropTypes.bool,
      image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        })
      })
    }))
  })).isRequired,
  onItemWithSubCategoriesSelected: PropTypes.func,
  isOpen: PropTypes.bool,
  store: PropTypes.string,
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string
} : {};
CategoryButton.defaultProps = {
  categories: [],
  isOpen: false,
  classes: [],
  style: {},
  id: undefined
};

var styles$N = {"container":"SiSCategoryMenuDesktop-module_container__3jYP-","portal":"SiSCategoryMenuDesktop-module_portal__3a2Ms","backdrop":"SiSCategoryMenuDesktop-module_backdrop__2aQxN"};

var styles$O = {"body-wrapper":"Body-module_body-wrapper__nzQEh","body":"Body-module_body__273Dq","divider":"Body-module_divider__2xEkM","footer":"Body-module_footer__1YyGf","banners-without-second-level-categories":"Body-module_banners-without-second-level-categories__18SDg","center-banners":"Body-module_center-banners__2-e3D","extra-padding-top":"Body-module_extra-padding-top__7oTM-","padding-height-default":"Body-module_padding-height-default__3BOKQ","padding-height-with-only-banners":"Body-module_padding-height-with-only-banners__3NO9w","padding-height-with-only-hightlights":"Body-module_padding-height-with-only-hightlights__3dfGZ","border":"Body-module_border__2HVZN","isVisible":"Body-module_isVisible__1Z0pc"};

var styles$P = {"navigation":"SideMenu-module_navigation__3UtEc","itemWrapper":"SideMenu-module_itemWrapper__3IXOl","chevron-right":"SideMenu-module_chevron-right__2aH8I"};

var SideMenu = function SideMenu(_ref) {
  var categories = _ref.categories,
    isOpen = _ref.isOpen,
    onItemWithSubCategoriesSelected = _ref.onItemWithSubCategoriesSelected,
    currentCategoryIndex = _ref.currentCategoryIndex,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor,
    dataWrapper = _ref.dataWrapper,
    levelOneCategoryColor = _ref.levelOneCategoryColor;
  var itHasChildrenItems = function itHasChildrenItems(category) {
    var hasItems = false;
    hasItems = category.highlight_level_categories && category.highlight_level_categories.length > 0 || category.second_level_categories && category.second_level_categories.length > 0 || category.banners && category.banners.length > 0;
    return hasItems;
  };
  var hightLightStyle = {
    backgroundColor: hightlightColor,
    color: hightlightTextColor
  };
  useEffect(function () {
    onItemWithSubCategoriesSelected(isOpen, 0, categories[0].item_name);
  }, [isOpen]);
  return jsx("div", {
    className: classNames(styles$P.navigation)
  }, categories.map(function (category, index) {
    return jsx("a", _extends({
      key: "L1_".concat(category.item_name),
      "data-cta": "true",
      target: category.new_tab && !itHasChildrenItems(category) ? '_blank' : '_self',
      rel: "noreferrer"
    }, category.item_url && category.item_url.href ? {
      href: itHasChildrenItems(category) ? '#' : category.item_url.href
    } : {
      href: itHasChildrenItems(category) ? '#' : null
    }, {
      onMouseEnter: function onMouseEnter() {
        return onItemWithSubCategoriesSelected(undefined, index, category.item_name);
      },
      className: classNames(styles$P.itemWrapper),
      style: isOpen && index === currentCategoryIndex ? hightLightStyle : {
        color: getCategoryColor(levelOneCategoryColor, category.item_color)
      },
      onClick: function onClick() {
        return !itHasChildrenItems(category) && updateDigitalDataCookies({
          firstLevelItem: category.item_name,
          secondLevelItem: category.item_name,
          thirdLevelItem: category.item_name,
          postionOne: index,
          postionTwo: 0,
          postionThree: 0,
          tag: SIS_NAVIGATION,
          dataWrapper: dataWrapper
        });
      }
    }), jsx("span", {
      className: styles$P['item-name']
    }, category.item_name), itHasChildrenItems(category) && jsx("i", {
      "aria-hidden": "true",
      className: styles$P['chevron-right']
    }));
  }));
};
SideMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  categories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    item_color: PropTypes.string,
    new_tab: PropTypes.bool,
    channel: PropTypes.shape({
      desktop: PropTypes.bool,
      mobile: PropTypes.bool,
      app: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      item_image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        }),
        app: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })),
    second_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      }),
      third_level_categories: PropTypes.arrayOf(PropTypes.shape({
        item_name: PropTypes.string,
        item_url: PropTypes.string,
        new_tab: PropTypes.bool,
        tag: PropTypes.shape({
          show: PropTypes.bool,
          text: PropTypes.string,
          background_color: PropTypes.string
        })
      }))
    })),
    banners: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.shape({
        href: PropTypes.string
      }),
      new_tab: PropTypes.bool,
      image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        })
      })
    }))
  })).isRequired,
  colorLine: PropTypes.string,
  hightlightColor: PropTypes.string,
  hightlightTextColor: PropTypes.string,
  onItemWithSubCategoriesSelected: PropTypes.func,
  isOpen: PropTypes.bool,
  currentCategoryIndex: PropTypes.number,
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string,
  dataWrapper: PropTypes.string
} : {};
SideMenu.defaultProps = {
  categories: [],
  hightlightColor: '',
  hightlightTextColor: '',
  isOpen: false,
  classes: [],
  style: {},
  id: undefined
};

var isTest = "production" === 'test';
var CSImageWrapper = function CSImageWrapper(_ref) {
  var lazyLoad = _ref.lazyLoad,
    children = _ref.children;
  return lazyLoad && !isTest ? jsx(LazyLoad, {
    once: true,
    offset: 300
  }, children) : jsx(Fragment, null, children);
};
CSImageWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  lazyLoad: PropTypes.bool
} : {};
CSImageWrapper.defaultProps = {
  lazyLoad: true
};

var breakpoints = {
  xs: '0',
  sm: '640px',
  md: '720px',
  lg: '1024px',
  xl: '1280px'
};
var CSImage = function CSImage(_ref) {
  var id = _ref.id,
    src = _ref.src,
    resolution = _ref.resolution,
    breakpoint = _ref.breakpoint,
    alt = _ref.alt,
    height = _ref.height,
    width = _ref.width,
    format = _ref.format,
    auto = _ref.auto,
    quality = _ref.quality,
    disable = _ref.disable,
    crop = _ref.crop,
    fit = _ref.fit,
    trim = _ref.trim,
    dpr = _ref.dpr,
    lazyLoad = _ref.lazyLoad,
    autoMaxWidth = _ref.autoMaxWidth,
    callbackHeight = _ref.callbackHeight,
    restProps = _objectWithoutProperties(_ref, ["id", "src", "resolution", "breakpoint", "alt", "height", "width", "format", "auto", "quality", "disable", "crop", "fit", "trim", "dpr", "lazyLoad", "autoMaxWidth", "callbackHeight"]);
  var url;
  try {
    url = new URL(src);
  } catch (error) {
    return null;
  }
  var imageHeight = useRef(null);
  var customWidth = null;
  var customDisable = null;
  if (autoMaxWidth && !width) {
    var maxWidth = resolution === 'mobile' && breakpoint ? breakpoints[breakpoint] : breakpoints.xl || null;
    if (maxWidth) {
      maxWidth = maxWidth.replace('px', '');
      customWidth = +maxWidth > 0 ? maxWidth : null;
      customDisable = customWidth && !disable ? 'upscale' : disable;
    }
  } else {
    customWidth = width;
    customDisable = disable;
  }
  var searchParams = _objectSpread2({
    width: customWidth,
    disable: customDisable,
    height: height,
    format: format,
    auto: auto,
    quality: quality,
    crop: crop,
    fit: fit,
    trim: trim,
    dpr: dpr
  }, url.searchParams);
  var search = stringify(searchParams, {
    skipNull: true
  });
  var uri;
  if (search) {
    uri = "".concat(url.origin).concat(url.pathname, "?").concat(search);
  } else {
    uri = "".concat(url.origin).concat(url.pathname);
  }
  var mediaSize = resolution === 'mobile' ? 'max' : 'min';
  return jsx(CSImageWrapper, {
    lazyLoad: lazyLoad
  }, jsx("picture", null, jsx("source", {
    "data-testid": "source-image",
    srcSet: uri,
    media: resolution && breakpoint ? "(".concat(mediaSize, "-width: ").concat(breakpoints[breakpoint], ")") : null
  }), !callbackHeight && jsx("img", _extends({
    id: id,
    "data-testid": "cs-image",
    alt: alt
  }, restProps)), callbackHeight && jsx("img", _extends({
    id: id,
    "data-testid": "cs-image",
    alt: alt
  }, restProps, {
    onLoad: function onLoad() {
      callbackHeight(imageHeight);
    },
    ref: imageHeight
  }))));
};
CSImage.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.string,
  src: PropTypes.string.isRequired,
  resolution: PropTypes.oneOf(['mobile', 'desktop']),
  breakpoint: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  alt: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  format: PropTypes.string,
  auto: PropTypes.string,
  quality: PropTypes.number,
  disable: PropTypes.string,
  crop: PropTypes.string,
  fit: PropTypes.string,
  trim: PropTypes.string,
  dpr: PropTypes.number,
  lazyLoad: PropTypes.bool,
  autoMaxWidth: PropTypes.bool
} : {};
CSImage.defaultProps = {
  id: null,
  resolution: null,
  breakpoint: null,
  alt: null,
  height: null,
  width: null,
  format: null,
  auto: null,
  quality: null,
  disable: null,
  crop: null,
  fit: null,
  trim: null,
  dpr: null,
  lazyLoad: true,
  autoMaxWidth: true,
  callbackHeight: false
};

var styles$Q = {"hlc-container":"HighlightLevelCategories-module_hlc-container__QFgAB","container":"HighlightLevelCategories-module_container__1Ti30","item":"HighlightLevelCategories-module_item__g9v49","mobile-container":"HighlightLevelCategories-module_mobile-container__2sPQZ"};

var styles$R = {"carousel-indicators-container":"CarouselIndicators-module_carousel-indicators-container__1uLVj","active-indicator":"CarouselIndicators-module_active-indicator__3GP3X","indicator":"CarouselIndicators-module_indicator__3_DoD","carousel-indicators":"CarouselIndicators-module_carousel-indicators__ClN-W"};

var CarouselIndicators = function CarouselIndicators(_ref) {
  var pagesCount = _ref.pagesCount,
    activeIndex = _ref.activeIndex,
    onIndicatorClick = _ref.onIndicatorClick;
  var indicators = [];
  var _loop = function _loop(indicatorIndex) {
    indicators.push(jsx("li", {
      "data-testid": "carousel-indicator-".concat(indicatorIndex),
      key: indicatorIndex,
      onClick: function onClick() {
        return onIndicatorClick(indicatorIndex);
      },
      className: classNames(activeIndex === indicatorIndex ? styles$R['active-indicator'] : styles$R.indicator)
    }));
  };
  for (var indicatorIndex = 0; indicatorIndex < pagesCount; indicatorIndex += 1) {
    _loop(indicatorIndex);
  }
  return jsx("div", {
    className: classNames('carousel-indicators', 'w-100', 'd-flex', 'justify-content-center', 'mx-0', styles$R['carousel-indicators-container'])
  }, jsx("ol", {
    className: classNames(styles$R['carousel-indicators'], {
      'd-none': indicators.length < 2
    }, 'm-0 p-0')
  }, indicators));
};
CarouselIndicators.displayName = 'CarouselIndicators';
CarouselIndicators.propTypes = process.env.NODE_ENV !== "production" ? {
  pagesCount: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
  onIndicatorClick: PropTypes.func
} : {};
CarouselIndicators.defaultProps = {
  onIndicatorClick: function onIndicatorClick() {}
};

var setSlideWidthToCards = (function (page, slideCenterWidth) {
  var children = page.props.children;
  var childrenToRender = children || page;
  return React.Children.map(childrenToRender, function (item) {
    var props = {
      screencenterx: slideCenterWidth
    };
    return React.cloneElement(item, props);
  });
});

var styles$S = {"carousel-wrapper":"MobileCarousel-module_carousel-wrapper__1Afu4","mobile-carousel":"MobileCarousel-module_mobile-carousel__1ocF6","slide-height-reference":"MobileCarousel-module_slide-height-reference__3pRdQ","carousel-row":"MobileCarousel-module_carousel-row__3gFFs"};

var MobileCarousel = function MobileCarousel(_ref) {
  var titleText = _ref.titleText,
    pages = _ref.pages,
    titleClassName = _ref.titleClassName,
    hideIndicators = _ref.hideIndicators,
    marginStyleIndicators = _ref.marginStyleIndicators;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeIndex = _useState2[0],
    setActiveIndex = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    pagesCount = _useState4[0],
    setPagesCount = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    visibleWidth = _useState6[0],
    setVisibleWidth = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    centerPos = _useState8[0],
    setcenterPos = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    scrolledX = _useState10[0],
    setScrolledX = _useState10[1];
  var sliderRef = useRef(null);
  var visibleRef = useRef(null);
  useEffect(function () {
    if (sliderRef.current && visibleRef.current && pagesCount === 0) {
      var sliderW = sliderRef.current.scrollWidth;
      var visibleW = visibleRef.current.clientWidth;
      setPagesCount(Math.ceil(sliderW / visibleW));
      setVisibleWidth(visibleW);
      setcenterPos(visibleW * 0.5);
    }
  }, [visibleRef, sliderRef]);
  var handleScroll = function handleScroll(e) {
    var page = (e.target.scrollLeft + centerPos) / visibleWidth;
    var roundedPage = page < 1 ? 0 : Math.round(page);
    setActiveIndex(roundedPage === pagesCount ? pagesCount - 1 : roundedPage);
    setScrolledX(e.target.scrollLeft);
  };
  var referenceItem;
  if (pages[0]) {
    referenceItem = jsx("div", {
      className: styles$S['slide-height-reference']
    }, pages[0]);
  }
  if (pages.length === 0) return jsx(Fragment, null);
  return jsx("div", {
    ref: visibleRef,
    "data-testid": "mobile-carousel",
    className: classNames('mobile-carousel', styles$S['carousel-wrapper']),
    onScroll: handleScroll
  }, titleText && jsx("div", {
    className: titleClassName
  }, titleText), jsx("div", {
    className: styles$S['mobile-carousel']
  }, referenceItem, jsx("div", {
    ref: sliderRef,
    "data-testid": "mobile-carousel-row",
    className: "".concat(styles$S['carousel-row'], " mobile-carousel-row")
  }, React.Children.map(pages, function (item) {
    return setSlideWidthToCards(item, centerPos);
  }))), !hideIndicators && jsx(CarouselIndicators, {
    pagesCount: pagesCount,
    activeIndex: activeIndex,
    marginStyle: marginStyleIndicators
  }));
};
MobileCarousel.propTypes = process.env.NODE_ENV !== "production" ? {
  titleText: PropTypes.string,
  titleClassName: PropTypes.string,
  pages: PropTypes.array.isRequired,
  hideIndicators: PropTypes.bool,
  marginStyleIndicators: PropTypes.string
} : {};
MobileCarousel.defaultProps = {
  titleClassName: '',
  pages: [],
  hideIndicators: false,
  marginStyleIndicators: ''
};

var MIN_HIGHLIGHT_LEVEL_CATEGORIES = 6;
var MAX_CHARACTERES_BANNER_CAPTION = 50;
var MAX_CHARACTERES_TAG = 15;
var MAX_BANNERS = 6;
var NUMBER_OF_COLUMNS_FOR_CATEGORIES_AND_BANNERS = 6;
var MAX_HIGHLIGHTS = 8;
var PADDING_LEFT_AND_RIGHT_PERCENTAGE_FOR_PANEL = 0.0234375;
var MARGIN_RIGHT_FOR_ITEMS_INSIDE_PANEL = 0.09775390625;

var MobileCard = function MobileCard(_ref) {
  var isNewTab = _ref.isNewTab,
    itemName = _ref.itemName,
    itemUrl = _ref.itemUrl,
    itemImage = _ref.itemImage,
    dataWrapper = _ref.dataWrapper,
    firstLevelItem = _ref.firstLevelItem,
    currentCategoryIndex = _ref.currentCategoryIndex,
    index = _ref.index,
    itemColor = _ref.itemColor;
  return jsx("a", _extends({
    className: styles$Q.item,
    "data-cta": "true",
    target: isNewTab ? '_blank' : '_self',
    rel: "noreferrer"
  }, itemUrl ? {
    href: itemUrl
  } : {}, {
    onClick: function onClick() {
      return updateDigitalDataCookies({
        firstLevelItem: firstLevelItem,
        secondLevelItem: "H ".concat(itemName),
        thirdLevelItem: "H ".concat(itemName),
        postionOne: currentCategoryIndex + 1,
        postionTwo: index + 1,
        postionThree: 0,
        tag: SIS_NAVIGATION,
        dataWrapper: dataWrapper
      });
    }
  }), ' ', jsx(CSImage, {
    src: _.get(itemImage, 'mobile.url', ''),
    quality: 70,
    auto: "webp",
    alt: ''
  }), jsx("span", {
    style: itemColor ? {
      color: itemColor
    } : {}
  }, itemName));
};
var HighlightLevelCategories = function HighlightLevelCategories(_ref2) {
  var highlightLevelCategories = _ref2.highlightLevelCategories,
    dataWrapper = _ref2.dataWrapper,
    currentCategoryIndex = _ref2.currentCategoryIndex,
    highLightedCategoryIndex = _ref2.highLightedCategoryIndex,
    firstLevelItem = _ref2.firstLevelItem,
    isOpen = _ref2.isOpen,
    highlightLevelCategoryColor = _ref2.highlightLevelCategoryColor;
  var filteredHighlightLevelCategories = highlightLevelCategories.slice(0, MAX_HIGHLIGHTS);
  var getMobilePages = function getMobilePages() {
    return filteredHighlightLevelCategories.map(function (data, index) {
      return jsx(MobileCard, {
        key: "HLC_".concat(index, "_").concat(data.item_name),
        className: styles$Q['product-item'],
        index: index,
        isNewTab: data.new_tab,
        itemName: data.item_name,
        itemUrl: data.item_url,
        itemImage: data.item_image,
        dataWrapper: dataWrapper,
        firstLevelItem: firstLevelItem,
        itemColor: data.item_color,
        currentCategoryIndex: currentCategoryIndex
      });
    });
  };
  return jsx("div", {
    className: styles$Q['hlc-container'],
    "data-testid": "HighlightLevelCategories"
  }, isIpadPotrait() ? jsx("div", {
    className: styles$Q['mobile-container']
  }, jsx(MobileCarousel, {
    pages: getMobilePages(),
    hideIndicators: false
  })) : jsx("div", {
    className: styles$Q.container
  }, filteredHighlightLevelCategories.map(function (_ref3, index) {
    var new_tab = _ref3.new_tab,
      item_name = _ref3.item_name,
      item_url = _ref3.item_url,
      item_image = _ref3.item_image,
      item_color = _ref3.item_color;
    return jsx("a", _extends({
      key: "HLC_".concat(index, "_").concat(item_name),
      className: styles$Q.item,
      "data-cta": "true",
      target: new_tab ? '_blank' : '_self',
      rel: "noreferrer"
    }, item_url ? {
      href: item_url
    } : {}, {
      onClick: function onClick() {
        return updateDigitalDataCookies({
          firstLevelItem: firstLevelItem,
          secondLevelItem: "H ".concat(item_name),
          thirdLevelItem: "H ".concat(item_name),
          postionOne: currentCategoryIndex + 1,
          postionTwo: index + 1,
          postionThree: 0,
          tag: SIS_NAVIGATION,
          dataWrapper: dataWrapper
        });
      }
    }), ' ', isOpen && currentCategoryIndex === highLightedCategoryIndex && jsx(CSImage, {
      "data-testid": "CSImageDesktop",
      src: _.get(item_image, 'desktop.url', ''),
      quality: 70,
      width: "80p",
      auto: "webp",
      alt: '',
      lazyLoad: false
    }), jsx("span", {
      style: {
        color: getCategoryColor(highlightLevelCategoryColor, item_color)
      }
    }, item_name));
  })));
};
HighlightLevelCategories.propTypes = process.env.NODE_ENV !== "production" ? {
  highlightLevelCategories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string,
    item_url: PropTypes.string,
    new_tab: PropTypes.bool,
    item_image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      }),
      app: PropTypes.shape({
        url: PropTypes.string
      })
    })
  })),
  isOpen: PropTypes.bool,
  highlightLevelCategoryColor: PropTypes.string
} : {};
HighlightLevelCategories.defaultProps = {
  isOpen: false
};

var styles$T = {"fill-full-height":"SubCategories-module_fill-full-height__3BHwC","small-height":"SubCategories-module_small-height__DomAt","container":"SubCategories-module_container__3a9eN","subcategories":"SubCategories-module_subcategories__3biEf","second-level-category-without-banners":"SubCategories-module_second-level-category-without-banners__3WUd3","second-level-category-with-banners":"SubCategories-module_second-level-category-with-banners__3nUAR","list-item":"SubCategories-module_list-item__6XLMU","list-title":"SubCategories-module_list-title__3bskI","content":"SubCategories-module_content__3X-Ff","text":"SubCategories-module_text__25stj","hover-effect":"SubCategories-module_hover-effect__1E3TD"};

var styles$U = {"tag":"Tag-module_tag__3Xt3-","mobile":"Tag-module_mobile__3FvaO","desktop":"Tag-module_desktop__13BEQ"};

var isVisibleColorLine = function isVisibleColorLine() {
  var highlightLevelCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var banners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var secondLevelCategories = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return highlightLevelCategories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES && (banners.length > 0 || secondLevelCategories.length > 0);
};
var showBannerDivider = function showBannerDivider() {
  var banners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var secondLevelCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return banners.length > 0 && secondLevelCategories.length > 0;
};
var formatTextWithShowMore = function formatTextWithShowMore(text, maxCharacters) {
  if (text.length > maxCharacters) {
    return "".concat(text.substring(0, maxCharacters), "...", ' ');
  }
  return text;
};
var cutText = function cutText(text, maxCharacters) {
  if (text.length > maxCharacters) {
    return text.substring(0, maxCharacters);
  }
  return text;
};

var Tag = function Tag(_ref) {
  var text = _ref.text,
    background_color = _ref.background_color,
    device = _ref.device;
  return jsx("div", {
    className: classNames(styles$U.tag, styles$U["".concat(device)]),
    style: {
      background: background_color
    }
  }, cutText(text, MAX_CHARACTERES_TAG));
};
Tag.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string.isRequired,
  background_color: PropTypes.string,
  device: PropTypes.string
} : {};
Tag.defaultProps = {
  background_color: ''
};

var styles$V = {"tooltipParent":"Tooltip-module_tooltipParent__2vNFe","default":"Tooltip-module_default__VxMM7","static":"Tooltip-module_static__MLMa_","pointer":"Tooltip-module_pointer__39WeT","tooltipContainer":"Tooltip-module_tooltipContainer__3ch-v","bottom-static":"Tooltip-module_bottom-static__NfOf4","bottom":"Tooltip-module_bottom__17wWJ","bottom-left":"Tooltip-module_bottom-left__1qZDg","right":"Tooltip-module_right__2TCdn","left":"Tooltip-module_left__go_1c","top":"Tooltip-module_top__cphzC","top-left":"Tooltip-module_top-left__3BqKs","top-middle":"Tooltip-module_top-middle__3D4_s","top-caret-left":"Tooltip-module_top-caret-left__3_WuY","bottom-right":"Tooltip-module_bottom-right__1N7fZ","bottom-right-mobile":"Tooltip-module_bottom-right-mobile__2Rq9l","caret":"Tooltip-module_caret__A8gYD","fullWidth":"Tooltip-module_fullWidth__3zm7G","tooltipText":"Tooltip-module_tooltipText__3rzuw","medium":"Tooltip-module_medium__2qoeq","small":"Tooltip-module_small__1Qds8","verysmall":"Tooltip-module_verysmall__3b8bW","verysmall-2":"Tooltip-module_verysmall-2__3h0kR"};

var TooltipText = function TooltipText(_ref) {
  var text = _ref.text,
    viewType = _ref.viewType,
    color = _ref.color;
  return jsx("p", {
    style: {
      color: color
    },
    className: classNames(styles$V.tooltipText, styles$V["".concat(viewType)])
  }, text);
};
TooltipText.defaultProps = {
  viewType: 'default',
  color: ''
};
TooltipText.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  viewType: PropTypes.oneOf(['fullWidth', 'default', 'medium', 'verysmall', 'verysmall-2'])
} : {};
var Tooltip = function Tooltip(_ref2) {
  var tooltipContent = _ref2.tooltipContent,
    children = _ref2.children,
    hasCaret = _ref2.hasCaret,
    position = _ref2.position,
    viewType = _ref2.viewType,
    showArrow = _ref2.showArrow,
    containerStyle = _ref2.containerStyle;
  return jsx(Fragment, null, jsx("div", {
    className: classNames(styles$V.tooltipParent, styles$V["".concat(viewType)])
  }, children, jsx("div", {
    style: containerStyle,
    className: classNames(styles$V.tooltipContainer, styles$V["".concat(position)])
  }, hasCaret && jsx("div", {
    id: "caret",
    className: classNames(styles$V.caret, styles$V["".concat(position)])
  }), jsx("div", {
    className: styles$V.tooltipContent
  }, tooltipContent)), showArrow && jsx("div", {
    className: styles$V.pointer
  })));
};
Tooltip.defaultProps = {
  hasCaret: false,
  viewType: 'default',
  showArrow: false
};
Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.object.isRequired,
  tooltipContent: PropTypes.object.isRequired,
  hasCaret: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'right', 'bottom', 'top', 'top-left', 'top-middle', 'bottom-left', 'bottom-static']).isRequired,
  viewType: PropTypes.oneOf(['fullWidth', 'default', 'medium', 'small', 'verysmall', 'static']),
  showArrow: PropTypes.bool,
  containerStyle: PropTypes.object
} : {};

var SubCategories = function SubCategories(_ref) {
  var fillFullHeight = _ref.fillFullHeight,
    secondLevelCategories = _ref.secondLevelCategories,
    hasBanner = _ref.hasBanner,
    currentCategoryIndex = _ref.currentCategoryIndex,
    dataWrapper = _ref.dataWrapper,
    firstLevelItem = _ref.firstLevelItem,
    levelTwoCategoryColor = _ref.levelTwoCategoryColor,
    levelThreeCategoryColor = _ref.levelThreeCategoryColor;
  var getChildContentForCategory = function getChildContentForCategory(category, isSecondLevelCategories) {
    var charactersRepresentedByStyles = 20 / 7.984;
    var charactersToDisplayTooltip = isSecondLevelCategories ? 21 : 27;
    var relativeTagSize = isSecondLevelCategories ? 0.95 : 1.22;
    var tooltipMarginTop = '28px';
    var categoryLength = (category.item_name && category.item_name.length) + (category.tag && category.tag.show && category.tag.text && category.tag.text.length * relativeTagSize - 1 + charactersRepresentedByStyles);
    return jsx("div", {
      className: styles$T.content
    }, categoryLength <= charactersToDisplayTooltip ? jsx("span", {
      className: styles$T.text
    }, category.item_name) : jsx(Tooltip, {
      viewType: "static",
      position: "bottom-static",
      containerStyle: {
        marginTop: tooltipMarginTop
      },
      tooltipContent: jsx(TooltipText, {
        color: "#495867",
        text: category.item_name,
        viewType: "verysmall-2"
      })
    }, jsx("span", {
      className: styles$T.text
    }, category.item_name)), category.tag && category.tag.show && jsx(Tag, _extends({}, category.tag, {
      device: "desktop"
    })));
  };
  var wrapWithLink = function wrapWithLink(category, body) {
    var isForThirdLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var categoryColor = arguments.length > 3 ? arguments[3] : undefined;
    return jsx("a", {
      "data-cta": "true",
      href: category.item_url,
      target: category.new_tab ? '_blank' : '_self',
      className: classNames(styles$T['hover-effect'], _defineProperty(_defineProperty({}, styles$T['list-title'], !isForThirdLevel), styles$T['list-item'], isForThirdLevel)),
      rel: "noreferrer",
      style: {
        color: categoryColor
      }
    }, body);
  };
  return jsx("div", {
    className: classNames(styles$T.container, _defineProperty(_defineProperty({}, styles$T['fill-full-height'], fillFullHeight), styles$T['small-height'], !fillFullHeight))
  }, jsx("div", {
    className: styles$T.subcategories
  }, secondLevelCategories.map(function (subCategory, index) {
    return jsx("ul", {
      key: "second-level-category-".concat(index),
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      className: classNames(styles$T['second-level-category-without-banners'], _defineProperty({}, styles$T['second-level-category-with-banners'], hasBanner))
    }, jsx("li", {
      onClick: function onClick() {
        return updateDigitalDataCookies({
          firstLevelItem: firstLevelItem,
          secondLevelItem: subCategory.item_name,
          thirdLevelItem: subCategory.item_name,
          postionOne: currentCategoryIndex + 1,
          postionTwo: index,
          postionThree: 0,
          tag: SIS_NAVIGATION,
          dataWrapper: dataWrapper
        });
      }
    }, subCategory.item_url ? wrapWithLink(subCategory, getChildContentForCategory(subCategory, true), false, getCategoryColor(levelTwoCategoryColor, subCategory.item_color)) : jsx("div", {
      className: styles$T['list-title']
    }, getChildContentForCategory(subCategory, true))), subCategory.third_level_categories && subCategory.third_level_categories.map(function (thirdLevelCategory, subindex) {
      return jsx("li", {
        key: "third-level-category-".concat(subindex),
        onClick: function onClick() {
          return updateDigitalDataCookies({
            firstLevelItem: firstLevelItem,
            secondLevelItem: subCategory.item_name,
            thirdLevelItem: thirdLevelCategory.item_name,
            postionOne: currentCategoryIndex + 1,
            postionTwo: index + 1,
            postionThree: subindex + 1,
            tag: SIS_NAVIGATION,
            dataWrapper: dataWrapper
          });
        }
      }, thirdLevelCategory.item_url ? wrapWithLink(thirdLevelCategory, getChildContentForCategory(thirdLevelCategory), true, getCategoryColor(levelThreeCategoryColor, thirdLevelCategory.item_color)) : jsx("div", {
        className: styles$T['list-item']
      }, getChildContentForCategory(thirdLevelCategory)));
    }));
  })));
};
SubCategories.propTypes = process.env.NODE_ENV !== "production" ? {
  fillFullHeight: PropTypes.bool,
  secondLevelCategories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string,
    item_url: PropTypes.string,
    new_tab: PropTypes.bool,
    tag: PropTypes.shape({
      show: PropTypes.bool,
      text: PropTypes.string,
      background_color: PropTypes.string
    }),
    third_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      })
    }))
  })),
  hasBanner: PropTypes.bool,
  currentCategoryIndex: PropTypes.number,
  dataWrapper: PropTypes.string,
  firstLevelItem: PropTypes.string,
  levelTwoCategoryColor: PropTypes.string,
  levelThreeCategoryColor: PropTypes.string
} : {};
SubCategories.defaultProps = {
  fillFullHeight: false
};

var styles$W = {"container":"Banners-module_container__15D5g","banner-item":"Banners-module_banner-item__3PxHq","item-link":"Banners-module_item-link__xetfR","hover-effect":"Banners-module_hover-effect__1pXee","title":"Banners-module_title__tDzoO"};

var useSiSMenuHook = function useSiSMenuHook() {
  var _useState = useState(190),
    _useState2 = _slicedToArray(_useState, 2),
    widthPerElment = _useState2[0],
    setWidthPerElment = _useState2[1];
  var handleResize = function handleResize() {
    if (global.window && global.window.outerWidth) {
      var currentWidth = global.window.outerWidth;
      if (currentWidth > 720 && currentWidth <= 1279) {
        var paddingLeftAndRight = currentWidth * PADDING_LEFT_AND_RIGHT_PERCENTAGE_FOR_PANEL;
        var marginRightPerElement = currentWidth * MARGIN_RIGHT_FOR_ITEMS_INSIDE_PANEL;
        var calWidthPerElement = (currentWidth - paddingLeftAndRight - marginRightPerElement) / NUMBER_OF_COLUMNS_FOR_CATEGORIES_AND_BANNERS;
        setWidthPerElment(calWidthPerElement);
      } else if (currentWidth > 1024 && currentWidth <= 1280) {
        setWidthPerElment(142);
      } else {
        setWidthPerElment(190);
      }
    }
  };
  useEffect(function () {
    handleResize();
    if (global.window) {
      global.window.addEventListener('resize', handleResize);
    }
    return function () {
      if (global.window) {
        global.window.removeEventListener('resize', handleResize);
      }
    };
  }, []);
  return {
    widthPerElment: widthPerElment
  };
};

var Banners = function Banners(_ref) {
  var banners = _ref.banners,
    classes = _ref.classes,
    style = _ref.style,
    id = _ref.id,
    dataWrapper = _ref.dataWrapper,
    firstLevelItem = _ref.firstLevelItem,
    currentCategoryIndex = _ref.currentCategoryIndex;
  var filteredBanners = banners.slice(0, MAX_BANNERS);
  var _useSiSMenuHook = useSiSMenuHook(),
    widthPerElment = _useSiSMenuHook.widthPerElment;
  var getContentForBanenr = function getContentForBanenr(banner) {
    return jsx(React.Fragment, null, jsx("div", {
      className: styles$W.title,
      style: {
        width: !isIpadPotrait() ? "".concat(widthPerElment, "px") : '100%'
      }
    }, !isIpadPotrait() ? formatTextWithShowMore(banner.item_name, MAX_CHARACTERES_BANNER_CAPTION) : banner.item_name), isIpadPotrait() ? jsx(CSImage, {
      src: banner.image.mobile.url,
      quality: 70,
      lazyLoad: false,
      auto: "webp",
      alt: banner.item_name
    }) : jsx(CSImage, {
      src: banner.image.desktop.url,
      quality: 70,
      auto: "webp",
      lazyLoad: false,
      alt: banner.item_name
    }));
  };
  var wrapWithLink = function wrapWithLink(banner, body) {
    return jsx("a", {
      "data-cta": "true",
      href: banner.item_url.href,
      target: banner.new_tab ? '_blank' : '_self',
      className: classNames(styles$W['hover-effect'], styles$W['item-link']),
      rel: "noreferrer"
    }, body);
  };
  return jsx("div", {
    className: classNames(styles$W.container, classes.join(' ')),
    style: style,
    id: id
  }, filteredBanners.map(function (banner, index) {
    return jsx("div", {
      className: styles$W['banner-item'],
      key: index,
      style: {
        width: !isIpadPotrait() ? "".concat(widthPerElment, "px") : '100%'
      },
      onClick: function onClick() {
        return updateDigitalDataCookies({
          firstLevelItem: firstLevelItem,
          secondLevelItem: "B ".concat(banner.item_name),
          thirdLevelItem: "B ".concat(banner.item_name),
          postionOne: currentCategoryIndex + 1,
          positionTwo: index + 1,
          postionThree: 0,
          tag: SIS_NAVIGATION,
          dataWrapper: dataWrapper
        });
      }
    }, banner.item_url && banner.item_url.href ? wrapWithLink(banner, getContentForBanenr(banner)) : jsx("div", {
      className: styles$W['item-link']
    }, getContentForBanenr(banner)));
  }));
};
Banners.propTypes = process.env.NODE_ENV !== "production" ? {
  banners: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string,
    item_url: PropTypes.shape({
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      })
    })
  })),
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string
} : {};
Banners.defaultProps = {
  classes: [],
  style: {},
  id: undefined
};

var Body = function Body(_ref) {
  var categories = _ref.categories,
    currentCategoryIndex = _ref.currentCategoryIndex,
    onItemWithSubCategoriesSelected = _ref.onItemWithSubCategoriesSelected,
    isOpen = _ref.isOpen,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor,
    dataWrapper = _ref.dataWrapper,
    firstLevelItemName = _ref.firstLevelItemName,
    colorLine = _ref.colorLine,
    defaultCategoryColors = _ref.defaultCategoryColors;
  if (_.isEmpty(categories)) {
    return jsx(React.Fragment, null);
  }
  var _ref2 = defaultCategoryColors || {},
    level_one_category_color = _ref2.level_one_category_color,
    level_two_category_color = _ref2.level_two_category_color,
    level_three_category_color = _ref2.level_three_category_color,
    highlight_level_category_color = _ref2.highlight_level_category_color;
  var getStyleForPanelWithPadding = function getStyleForPanelWithPadding(_ref3) {
    var banners = _ref3.banners,
      second_level_categories = _ref3.second_level_categories,
      highlight_level_categories = _ref3.highlight_level_categories;
    var panelClassList = [styles$O['padding-height-default']];
    if (banners.length > 0 && second_level_categories.length === 0 && highlight_level_categories.length < MIN_HIGHLIGHT_LEVEL_CATEGORIES) {
      panelClassList = [styles$O['padding-height-with-only-banners']];
    }
    if (banners.length === 6 && second_level_categories.length > 0 && highlight_level_categories.length < MIN_HIGHLIGHT_LEVEL_CATEGORIES) {
      panelClassList = [styles$O['padding-height-with-only-banners']];
    }
    if (banners.length === 0 && second_level_categories.length === 0 && highlight_level_categories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES) {
      panelClassList = [styles$O['padding-height-with-only-hightlights']];
    } else if (highlight_level_categories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES) {
      panelClassList.push(styles$O['padding-height-with-only-hightlights']);
    }
    return panelClassList;
  };
  return jsx("div", {
    className: classNames(styles$O['body-wrapper'], _defineProperty({}, styles$O.isVisible, isOpen))
  }, jsx(SideMenu, {
    categories: categories,
    onItemWithSubCategoriesSelected: onItemWithSubCategoriesSelected,
    currentCategoryIndex: currentCategoryIndex,
    isOpen: isOpen,
    hightlightColor: hightlightColor,
    hightlightTextColor: hightlightTextColor,
    dataWrapper: dataWrapper,
    levelOneCategoryColor: level_one_category_color
  }), categories.map(function (category, index) {
    var _category$highlight_l = category.highlight_level_categories,
      highlight_level_categories = _category$highlight_l === void 0 ? [] : _category$highlight_l,
      _category$second_leve = category.second_level_categories,
      second_level_categories = _category$second_leve === void 0 ? [] : _category$second_leve,
      _category$banners = category.banners,
      banners = _category$banners === void 0 ? [] : _category$banners;
    var showSubCategoryClass = currentCategoryIndex === index ? styles$O.isVisible : '';
    return jsx("div", {
      key: category === null || category === void 0 ? void 0 : category.item_name,
      className: classNames(styles$O.body, getStyleForPanelWithPadding(category), showSubCategoryClass)
    }, highlight_level_categories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES && jsx(HighlightLevelCategories, {
      highlightLevelCategories: highlight_level_categories,
      dataWrapper: dataWrapper,
      currentCategoryIndex: currentCategoryIndex,
      highLightedCategoryIndex: index,
      firstLevelItem: firstLevelItemName,
      isOpen: isOpen,
      highlightLevelCategoryColor: highlight_level_category_color
    }), isVisibleColorLine(highlight_level_categories, banners, second_level_categories) && jsx("hr", {
      className: styles$O.divider,
      style: {
        borderColor: colorLine || 'white'
      }
    }), jsx("div", {
      className: classNames(styles$O.footer, _defineProperty(_defineProperty({}, styles$O['extra-padding-top'], !highlight_level_categories), styles$O['banners-without-second-level-categories'], !(second_level_categories.length > 0 && banners.length < MAX_BANNERS) && banners.length === MAX_BANNERS))
    }, second_level_categories.length > 0 && banners.length < 6 && jsx(SubCategories, {
      secondLevelCategories: second_level_categories,
      fillFullHeight: highlight_level_categories.length < MIN_HIGHLIGHT_LEVEL_CATEGORIES,
      hasBanner: banners.length > 0,
      currentCategoryIndex: currentCategoryIndex,
      dataWrapper: dataWrapper,
      firstLevelItem: firstLevelItemName,
      levelTwoCategoryColor: level_two_category_color,
      levelThreeCategoryColor: level_three_category_color
    }), isOpen && banners.length > 0 && currentCategoryIndex === index && jsx(Banners, {
      banners: banners,
      dataWrapper: dataWrapper,
      firstLevelItem: firstLevelItemName,
      currentCategoryIndex: currentCategoryIndex
    })));
  }), jsx("div", {
    className: classNames(styles$O.border),
    style: {
      backgroundColor: "".concat(colorLine)
    }
  }));
};
Body.propTypes = process.env.NODE_ENV !== "production" ? {
  categories: PropTypes.arrayOf(PropTypes.object),
  category: PropTypes.object,
  onItemWithSubCategoriesSelected: PropTypes.func,
  currentCategoryIndex: PropTypes.number,
  isOpen: PropTypes.bool,
  hightlightColor: PropTypes.string,
  hightlightTextColor: PropTypes.string,
  dataWrapper: PropTypes.string,
  firstLevelItemName: PropTypes.string,
  colorLine: PropTypes.string
} : {};
Body.defaultProps = {};

var styles$X = {"menu-button-container":"HamburgerButton-module_menu-button-container__1rmhU","menuWrapper":"HamburgerButton-module_menuWrapper__3dvcA","hamburger-icon-container":"HamburgerButton-module_hamburger-icon-container__1gu28","hamburger-icon":"HamburgerButton-module_hamburger-icon__2180W","name":"HamburgerButton-module_name__4K1AR"};

var HamburgerButton = function HamburgerButton(_ref) {
  var _menuConfig$deviceTyp, _menuConfig$deviceTyp2;
  var onButtonClick = _ref.onButtonClick,
    isOpen = _ref.isOpen,
    menuConfig = _ref.menuConfig,
    deviceType = _ref.deviceType;
  var menuLabel = "".concat((_menuConfig$deviceTyp = menuConfig[deviceType]) === null || _menuConfig$deviceTyp === void 0 ? void 0 : _menuConfig$deviceTyp.text);
  var hamburgerIcon = "".concat((_menuConfig$deviceTyp2 = menuConfig[deviceType]) === null || _menuConfig$deviceTyp2 === void 0 ? void 0 : _menuConfig$deviceTyp2.icon.url);
  var closeIcon = 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt47578a26a96c1f3f/67a067a1f6f9a688750cf724/close.svg';
  return jsx("div", {
    className: styles$X['menu-button-container'],
    "data-testid": "CategoryButton"
  }, jsx("div", {
    className: classNames(styles$X['menu-button-container'])
  }, jsx("div", {
    className: classNames(styles$X.menuWrapper),
    onClick: function onClick() {
      return onButtonClick(!isOpen);
    }
  }, jsx("div", {
    className: styles$X['hamburger-icon-container']
  }, jsx("i", {
    "aria-hidden": "true",
    className: classNames(styles$X['hamburger-icon']),
    style: {
      maskImage: "url(".concat(isOpen ? closeIcon : hamburgerIcon, ")")
    }
  })), menuLabel && menuLabel)));
};
HamburgerButton.propTypes = process.env.NODE_ENV !== "production" ? {
  onButtonClick: PropTypes.func,
  isOpen: PropTypes.bool,
  menuConfig: PropTypes.shape({
    desktop: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    }),
    mobile: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    })
  }),
  deviceType: PropTypes.string
} : {};
HamburgerButton.defaultProps = {
  isOpen: false,
  deviceType: 'desktop'
};

var SiSNavigationMenuDesktop = function SiSNavigationMenuDesktop(_ref) {
  var categories = _ref.categories,
    colorLine = _ref.colorLine,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor,
    store = _ref.store,
    dataWrapper = _ref.dataWrapper,
    isSISLevel2Header = _ref.isSISLevel2Header,
    classes = _ref.classes,
    style = _ref.style,
    id = _ref.id,
    isVendorOrAgentLoggedIn = _ref.isVendorOrAgentLoggedIn,
    menuConfig = _ref.menuConfig,
    defaultCategoryColors = _ref.defaultCategoryColors;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    currentCategoryIndex = _useState4[0],
    setCurrentCategoryIndex = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    firstLevelItem = _useState6[0],
    setFirstLevelItem = _useState6[1];
  var desktopCategories = categories.filter(function (c) {
    return c.channel.desktop;
  });
  var closeNavigationMenu = function closeNavigationMenu() {
    setOpen(false);
  };
  var onItemWithSubCategoriesSelected = function onItemWithSubCategoriesSelected(hasItems) {
    var categoryIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var firstLevelItemName = arguments.length > 2 ? arguments[2] : undefined;
    setFirstLevelItem(firstLevelItemName);
    setCurrentCategoryIndex(categoryIndex);
    if (typeof hasItems === 'boolean') {
      setOpen(hasItems);
    }
  };
  var getRelativeHeight = function getRelativeHeight() {
    if (isWhitelabel(store)) {
      return '145px';
    }
    if (!isSISLevel2Header) {
      if (isVendorOrAgentLoggedIn) {
        return '145px';
      }
      return '106px';
    } else {
      return '70px';
    }
  };
  return jsx("div", {
    className: classNames(styles$N.container, classes.join(' ')),
    style: style,
    id: id,
    "data-testid": "SiSNavigationMenuDesktop",
    onMouseLeave: closeNavigationMenu
  }, isWhitelabel(store) ? jsx(HamburgerButton, {
    onButtonClick: onItemWithSubCategoriesSelected,
    isOpen: isOpen,
    menuConfig: menuConfig,
    deviceType: "desktop"
  }) : jsx(CategoryButton, {
    onItemWithSubCategoriesSelected: onItemWithSubCategoriesSelected,
    isOpen: isOpen,
    store: store
  }), isOpen && jsx(Portal, {
    id: "submen-backdrop",
    classes: styles$N.portal,
    top: getRelativeHeight()
  }, jsx("span", {
    className: styles$N.backdrop,
    onClick: closeNavigationMenu,
    onMouseEnter: closeNavigationMenu
  })), jsx(Body, {
    categories: desktopCategories,
    currentCategoryIndex: currentCategoryIndex,
    onItemWithSubCategoriesSelected: onItemWithSubCategoriesSelected,
    isOpen: isOpen,
    hightlightColor: hightlightColor,
    hightlightTextColor: hightlightTextColor,
    dataWrapper: dataWrapper,
    firstLevelItemName: firstLevelItem,
    colorLine: colorLine,
    defaultCategoryColors: defaultCategoryColors
  }));
};
SiSNavigationMenuDesktop.propTypes = process.env.NODE_ENV !== "production" ? {
  categories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    channel: PropTypes.shape({
      desktop: PropTypes.bool,
      mobile: PropTypes.bool,
      app: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      item_image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        }),
        app: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })),
    second_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      }),
      third_level_categories: PropTypes.arrayOf(PropTypes.shape({
        item_name: PropTypes.string,
        item_url: PropTypes.string,
        new_tab: PropTypes.bool,
        tag: PropTypes.shape({
          show: PropTypes.bool,
          text: PropTypes.string,
          background_color: PropTypes.string
        })
      }))
    })),
    banners: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.object,
      new_tab: PropTypes.bool,
      image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        })
      })
    }))
  })).isRequired,
  colorLine: PropTypes.string,
  categoryColor: PropTypes.string,
  store: PropTypes.string,
  hightlightColor: PropTypes.string,
  hightlightTextColor: PropTypes.string,
  browseMainText: PropTypes.string.isRequired,
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string,
  dataWrapper: PropTypes.string,
  isSISLevel2Header: PropTypes.bool,
  defaultCategoryColors: PropTypes.shape({})
} : {};
SiSNavigationMenuDesktop.defaultProps = {
  colorLine: '',
  categoryColor: '',
  banners: [],
  classes: [],
  id: undefined,
  isVendorOrAgentLoggedIn: false
};

var styles$Y = {"container":"SiSCategoryMenuMobile-module_container__3lRgp","top-menu-line":"SiSCategoryMenuMobile-module_top-menu-line___Bo4v","categoryWrapper":"SiSCategoryMenuMobile-module_categoryWrapper__3wc-p","categoryWrapper-text":"SiSCategoryMenuMobile-module_categoryWrapper-text__3CyNU","homecenter":"SiSCategoryMenuMobile-module_homecenter__3Iki-","chevron-container":"SiSCategoryMenuMobile-module_chevron-container__zY2xW","chevron-down":"SiSCategoryMenuMobile-module_chevron-down__3VfMk","chevron-down--to_com":"SiSCategoryMenuMobile-module_chevron-down--to_com__1YeDi","active":"SiSCategoryMenuMobile-module_active__3R6up","categoryWrapper--to_com":"SiSCategoryMenuMobile-module_categoryWrapper--to_com__2k-lj","wrapper-modal":"SiSCategoryMenuMobile-module_wrapper-modal__1uSq4","nav-body":"SiSCategoryMenuMobile-module_nav-body__1na7n","menu":"SiSCategoryMenuMobile-module_menu__1b9XQ","nav-sub-head":"SiSCategoryMenuMobile-module_nav-sub-head__2t_g2","nav-title":"SiSCategoryMenuMobile-module_nav-title__pl1Xz","modal-close":"SiSCategoryMenuMobile-module_modal-close__3qJqC","sis-modal-close-button":"SiSCategoryMenuMobile-module_sis-modal-close-button__19CoO","nav-sub-title":"SiSCategoryMenuMobile-module_nav-sub-title__3ODsw","sub-title":"SiSCategoryMenuMobile-module_sub-title__2ZpW3","arrow-left":"SiSCategoryMenuMobile-module_arrow-left__3n5GW","parent-category-title":"SiSCategoryMenuMobile-module_parent-category-title__3bPQO","nav-sub-content":"SiSCategoryMenuMobile-module_nav-sub-content__xN0kB","divider":"SiSCategoryMenuMobile-module_divider__5h2Nc","divider-gray":"SiSCategoryMenuMobile-module_divider-gray__bqUkT","menu-item-wrapper":"SiSCategoryMenuMobile-module_menu-item-wrapper__1vYkx","menu-item":"SiSCategoryMenuMobile-module_menu-item__deZ6g","arrow-right":"SiSCategoryMenuMobile-module_arrow-right__3jM3h","menu-item-second-wrapper":"SiSCategoryMenuMobile-module_menu-item-second-wrapper__1LSMt","menu-item-third-wrapper":"SiSCategoryMenuMobile-module_menu-item-third-wrapper__2g4ta","menu-primary-enter":"SiSCategoryMenuMobile-module_menu-primary-enter__3XnFj","menu-primary-enter-active":"SiSCategoryMenuMobile-module_menu-primary-enter-active__23S-x","menu-primary-exit":"SiSCategoryMenuMobile-module_menu-primary-exit__3Y6rA","menu-primary-exit-active":"SiSCategoryMenuMobile-module_menu-primary-exit-active__1AKz0","menu-secondary-enter":"SiSCategoryMenuMobile-module_menu-secondary-enter__2my63","menu-secondary-enter-active":"SiSCategoryMenuMobile-module_menu-secondary-enter-active__2EGzs","menu-secondary-exit-active":"SiSCategoryMenuMobile-module_menu-secondary-exit-active__13SzN","menu-tertiary-enter":"SiSCategoryMenuMobile-module_menu-tertiary-enter__1eZMe","menu-tertiary-enter-active":"SiSCategoryMenuMobile-module_menu-tertiary-enter-active__12IA_","menu-tertiary-exit-active":"SiSCategoryMenuMobile-module_menu-tertiary-exit-active__3gffA"};

var SiSNavigationMenuMobile = function SiSNavigationMenuMobile(_ref) {
  var categories = _ref.categories,
    browseMainText = _ref.browseMainText,
    colorLine = _ref.colorLine,
    store = _ref.store,
    dataWrapper = _ref.dataWrapper,
    classes = _ref.classes,
    style = _ref.style,
    id = _ref.id,
    menuConfig = _ref.menuConfig,
    defaultCategoryColors = _ref.defaultCategoryColors;
  var MAIN_MENU = 'main';
  var SECONDARY_MENU = 'secondary_menu';
  var THIRD_MENU = 'third_menu';
  var deviceType = 'mobile';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalVisible = _useState2[0],
    setIsModalVisible = _useState2[1];
  var _useState3 = useState(MAIN_MENU),
    _useState4 = _slicedToArray(_useState3, 2),
    activeMenu = _useState4[0],
    setActiveMenu = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    menuHeight = _useState6[0],
    setMenuHeight = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    menuMaxHeight = _useState8[0],
    setMenuMaxHeight = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedSecondaryCategory = _useState10[0],
    setSelectedSecondaryCategory = _useState10[1];
  var _useState11 = useState({}),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedTertiaryCategory = _useState12[0],
    setSelectedTertiaryCategory = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    firstLevelCategoryIndex = _useState14[0],
    setFirstLevelCategoryIndex = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    secondLevelCategoryIndex = _useState16[0],
    setSecondLevelCategoryIndex = _useState16[1];
  var mobileModalClass = 'floatBottomTransition';
  var mobileBodyModalClass = 'flex';
  var mobileModalID = 'modal-sub-menu';
  var isMobileDevice = isMobile();
  var _getStandaloneSite = getStandaloneSite(store),
    isTottusStandalone = _getStandaloneSite.isTottusStandalone,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var _ref2 = defaultCategoryColors || {},
    level_one_category_color = _ref2.level_one_category_color,
    level_two_category_color = _ref2.level_two_category_color,
    level_three_category_color = _ref2.level_three_category_color,
    highlight_level_category_color = _ref2.highlight_level_category_color;
  var filteredCategories = categories.filter(function (x) {
    return x.channel.mobile;
  });
  useEffect(function () {
    var height = window.innerHeight;
    setMenuMaxHeight(height * 0.7);
  }, []);
  var getCategoryStyle = function getCategoryStyle(defaultCategoryColor, category) {
    return category.item_color ? {
      color: category.item_color
    } : {
      color: defaultCategoryColor
    };
  };
  var calcHeight = function calcHeight() {
    var subCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var banners = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var highlightLevelCategories = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var BASE_NAV_HEIGHT = 80;
    var categoriesSize = subCategories.length;
    var bannersSize = banners.length;
    var highlightLevelCategoriesSize = highlightLevelCategories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES ? 1 : 0;
    var dh = categoriesSize * 52 + bannersSize * 80 + highlightLevelCategoriesSize * 230 + BASE_NAV_HEIGHT;
    setMenuHeight(dh > menuMaxHeight ? menuMaxHeight : dh);
  };
  var itHasChildrenItems = function itHasChildrenItems(category, goToMenu) {
    var hasItems = false;
    switch (goToMenu) {
      case SECONDARY_MENU:
        hasItems = category.highlight_level_categories && category.highlight_level_categories.length > 0 || category.second_level_categories && category.second_level_categories.length > 0 || category.banners && category.banners.length > 0;
        break;
      case THIRD_MENU:
        hasItems = category.third_level_categories && category.third_level_categories.length > 0;
        break;
    }
    return hasItems;
  };
  var onMenuItemWithChildClick = function onMenuItemWithChildClick(_ref3) {
    var goToMenu = _ref3.goToMenu,
      category = _ref3.category,
      categoryIndex = _ref3.categoryIndex;
    if (goToMenu) {
      if (goToMenu === SECONDARY_MENU) {
        setFirstLevelCategoryIndex(categoryIndex);
        setSelectedSecondaryCategory(category);
        calcHeight(category.second_level_categories, category.banners, category.highlight_level_categories);
      }
      if (goToMenu === THIRD_MENU) {
        setSecondLevelCategoryIndex(categoryIndex);
        setSelectedTertiaryCategory(category);
        calcHeight(category.third_level_categories);
      }
      document.getElementById(mobileModalID).scrollTo(0, 0);
      setActiveMenu(goToMenu);
    }
  };
  var onMenuItemClick = function onMenuItemClick(_ref4) {
    var categoryIndex = _ref4.categoryIndex;
    if (activeMenu) {
      if (activeMenu === SECONDARY_MENU) {
        updateDigitalDataCookies({
          firstLevelItem: filteredCategories[firstLevelCategoryIndex].item_name,
          secondLevelItem: filteredCategories[firstLevelCategoryIndex].second_level_categories[categoryIndex].item_name,
          thirdLevelItem: filteredCategories[firstLevelCategoryIndex].second_level_categories[categoryIndex].item_name,
          postionOne: firstLevelCategoryIndex + 1,
          postionTwo: categoryIndex + 1,
          postionThree: 0,
          tag: SIS_NAVIGATION,
          dataWrapper: dataWrapper
        });
      }
      if (activeMenu === THIRD_MENU) {
        updateDigitalDataCookies({
          firstLevelItem: filteredCategories[firstLevelCategoryIndex].item_name,
          secondLevelItem: filteredCategories[firstLevelCategoryIndex].second_level_categories[secondLevelCategoryIndex].item_name,
          thirdLevelItem: filteredCategories[firstLevelCategoryIndex].second_level_categories[secondLevelCategoryIndex].third_level_categories[categoryIndex].item_name,
          postionOne: firstLevelCategoryIndex + 1,
          postionTwo: secondLevelCategoryIndex + 1,
          postionThree: categoryIndex + 1,
          tag: SIS_NAVIGATION,
          dataWrapper: dataWrapper
        });
      }
    }
  };
  var goBack = function goBack(goToMenu) {
    setActiveMenu(goToMenu);
    if (goToMenu === MAIN_MENU) {
      calcHeight(filteredCategories);
    }
    if (goToMenu === SECONDARY_MENU) {
      calcHeight(selectedSecondaryCategory.second_level_categories, selectedSecondaryCategory.banners, selectedSecondaryCategory.highlight_level_categories);
    }
  };
  var MenuItem = function MenuItem(props) {
    var _props$category = props.category,
      item_url = _props$category.item_url,
      new_tab = _props$category.new_tab;
    var url = props.goToMenu === SECONDARY_MENU ? item_url.href : item_url;
    return url ? jsx("a", {
      href: props.itHasChildren ? '#' : url,
      target: new_tab && !props.itHasChildren ? '_blank' : '_self',
      className: styles$Y['menu-item-wrapper'],
      onClick: function onClick() {
        return props.itHasChildren ? onMenuItemWithChildClick(props) : onMenuItemClick(props);
      },
      rel: "noreferrer"
    }, props.children) : jsx("div", {
      className: styles$Y['menu-item-wrapper'],
      onClick: function onClick() {
        return props.itHasChildren ? onMenuItemWithChildClick(props) : onMenuItemClick(props);
      }
    }, props.children);
  };
  var NavBody = function NavBody(_ref5) {
    var actions = _ref5.actions;
    var visibleBannerDivider = showBannerDivider(selectedSecondaryCategory.banners, selectedSecondaryCategory.second_level_categories);
    var visibleCarouselDivider = isVisibleColorLine(selectedSecondaryCategory.highlight_level_categories, selectedSecondaryCategory.banners, selectedSecondaryCategory.second_level_categories);
    return jsx("div", {
      className: styles$Y['nav-body'],
      "data-testid": "SisCategoryMenuMobile-nav-body"
    }, jsx(CSSTransition, {
      in: activeMenu === MAIN_MENU,
      timeout: 500,
      classNames: "menu-primary",
      unmountOnExit: true
    }, jsx("div", {
      className: styles$Y.menu
    }, jsx("div", {
      className: styles$Y['nav-sub-head']
    }, jsx("div", {
      className: styles$Y['nav-title']
    }, jsx("span", null, browseMainText), jsx("button", {
      type: "button",
      className: classNames(styles$Y['modal-close'], styles$Y['sis-modal-close-button']),
      id: "testId-modal-close",
      onClick: actions.close
    }, jsx("i", {
      className: classNames(styles$Y['icon-danger'], styles$Y['icon-big'])
    })))), jsx("div", {
      className: styles$Y['nav-sub-content']
    }, filteredCategories.map(function (category, index) {
      return jsx(MenuItem, {
        goToMenu: SECONDARY_MENU,
        category: category,
        key: index,
        categoryIndex: index,
        itHasChildren: itHasChildrenItems(category, SECONDARY_MENU)
      }, jsx("div", {
        className: styles$Y['menu-item'],
        style: getCategoryStyle(level_one_category_color, category)
      }, category.item_name), itHasChildrenItems(category, SECONDARY_MENU) && jsx("div", {
        className: styles$Y['arrow-right']
      }, jsx("i", {
        "aria-hidden": "true"
      })));
    })))), jsx(CSSTransition, {
      in: activeMenu === SECONDARY_MENU,
      timeout: 500,
      classNames: "menu-secondary",
      unmountOnExit: true
    }, jsx("div", {
      className: styles$Y.menu
    }, jsx("div", {
      className: styles$Y['nav-sub-head']
    }, jsx("div", {
      className: styles$Y['nav-sub-title'],
      onClick: function onClick() {
        goBack(MAIN_MENU);
      }
    }, jsx("div", {
      className: styles$Y['sub-title']
    }, jsx("div", {
      className: styles$Y['arrow-left']
    }, jsx("i", {
      "aria-hidden": "true"
    })), jsx("span", null, "".concat(browseMainText))), jsx("button", {
      type: "button",
      className: classNames(styles$Y['modal-close'], styles$Y['sis-modal-close-button']),
      id: "testId-modal-close",
      onClick: actions.close
    }, jsx("i", {
      className: classNames(styles$Y['icon-danger'], styles$Y['icon-big'])
    }))), jsx("div", {
      className: styles$Y['parent-category-title'],
      style: getCategoryStyle(level_one_category_color, selectedSecondaryCategory)
    }, selectedSecondaryCategory.item_name)), jsx("div", {
      className: styles$Y['nav-sub-content']
    }, selectedSecondaryCategory && selectedSecondaryCategory.highlight_level_categories && selectedSecondaryCategory.highlight_level_categories.length >= MIN_HIGHLIGHT_LEVEL_CATEGORIES && jsx(HighlightLevelCategories, {
      highlightLevelCategories: selectedSecondaryCategory.highlight_level_categories,
      dataWrapper: dataWrapper,
      currentCategoryIndex: firstLevelCategoryIndex,
      firstLevelItem: filteredCategories[firstLevelCategoryIndex].item_name,
      highlightLevelCategoryColor: highlight_level_category_color
    }), colorLine && visibleCarouselDivider && jsx("hr", {
      className: styles$Y.divider,
      style: {
        borderTopColor: colorLine
      }
    }), selectedSecondaryCategory && selectedSecondaryCategory.second_level_categories && selectedSecondaryCategory.second_level_categories.map(function (category, index) {
      return jsx(MenuItem, {
        goToMenu: THIRD_MENU,
        category: category,
        key: index,
        categoryIndex: index,
        itHasChildren: itHasChildrenItems(category, THIRD_MENU)
      }, jsx("div", {
        className: styles$Y['menu-item-second-wrapper']
      }, jsx("div", {
        className: styles$Y['menu-item'],
        style: getCategoryStyle(level_two_category_color, category)
      }, category.item_name), category.tag && category.tag.show && jsx(Tag, _extends({}, category.tag, {
        device: "mobile"
      }))), itHasChildrenItems(category, THIRD_MENU) && jsx("div", {
        className: styles$Y['arrow-right']
      }, jsx("i", {
        "aria-hidden": "true"
      })));
    }), visibleBannerDivider && jsx("hr", {
      className: classNames(styles$Y.divider, styles$Y['divider-gray'])
    }), selectedSecondaryCategory && selectedSecondaryCategory.banners && jsx(Banners, {
      banners: selectedSecondaryCategory.banners,
      style: {
        marginTop: visibleBannerDivider || visibleCarouselDivider ? '20px' : ''
      },
      dataWrapper: dataWrapper,
      currentCategoryIndex: firstLevelCategoryIndex,
      firstLevelItem: filteredCategories[firstLevelCategoryIndex].item_name
    })))), jsx(CSSTransition, {
      in: activeMenu === THIRD_MENU,
      timeout: 500,
      classNames: "menu-tertiary",
      unmountOnExit: true
    }, jsx("div", {
      className: styles$Y.menu
    }, jsx("div", {
      className: styles$Y['nav-sub-head']
    }, jsx("div", {
      className: styles$Y['nav-sub-title'],
      onClick: function onClick() {
        goBack(SECONDARY_MENU);
      }
    }, jsx("div", {
      className: styles$Y['sub-title']
    }, jsx("div", {
      className: styles$Y['arrow-left']
    }, jsx("i", {
      "aria-hidden": "true"
    })), jsx("span", {
      style: getCategoryStyle(level_one_category_color, selectedSecondaryCategory)
    }, "".concat(selectedSecondaryCategory.item_name))), jsx("button", {
      type: "button",
      className: classNames(styles$Y['modal-close'], styles$Y['sis-modal-close-button']),
      id: "testId-modal-close",
      onClick: actions.close
    }, jsx("i", {
      className: classNames(styles$Y['icon-danger'], styles$Y['icon-big'])
    }))), jsx("div", {
      className: styles$Y['parent-category-title']
    }, jsx("a", {
      href: selectedTertiaryCategory.item_url ? selectedTertiaryCategory.item_url : '#',
      target: selectedTertiaryCategory.new_tab ? '_blank' : '_self',
      rel: "noreferrer",
      style: getCategoryStyle(level_two_category_color, selectedTertiaryCategory)
    }, selectedTertiaryCategory.item_name))), jsx("div", {
      className: styles$Y['nav-sub-content']
    }, selectedTertiaryCategory && selectedTertiaryCategory.third_level_categories && selectedTertiaryCategory.third_level_categories.map(function (category, index) {
      return jsx(MenuItem, {
        key: index,
        itHasChildren: false,
        category: category,
        categoryIndex: index
      }, jsx("div", {
        className: styles$Y['menu-item-third-wrapper']
      }, jsx("div", {
        className: styles$Y['menu-item'],
        style: getCategoryStyle(level_three_category_color, category)
      }, category.item_name), category.tag && category.tag.show && jsx(Tag, _extends({}, category.tag, {
        device: "mobile"
      }))));
    })))));
  };
  var toggleModal = function toggleModal() {
    setIsModalVisible(!isModalVisible);
    if (isModalVisible) {
      goBack(MAIN_MENU);
    }
  };
  return jsx("div", {
    className: classNames(styles$Y.container, classes.join(' ')),
    style: style,
    id: id
  }, isWhitelabelSite ? jsx(HamburgerButton, {
    onButtonClick: toggleModal,
    menuConfig: menuConfig,
    deviceType: deviceType,
    isOpen: isModalVisible
  }) : jsx("div", {
    className: classNames(styles$Y.categoryWrapper, styles$Y[store], _defineProperty(_defineProperty({}, styles$Y.active, !isMobileDevice && isModalVisible), styles$Y['categoryWrapper--to_com'], isTottusStandalone)),
    onClick: function onClick() {
      toggleModal();
    },
    "data-testid": "SiSNavigationMenuMobile-toggleId"
  }, jsx("div", {
    "data-testid": "category-text",
    className: classNames(styles$Y['categoryWrapper-text'], styles$Y[store])
  }, "Categor\xEDas"), jsx("div", {
    className: styles$Y['chevron-container']
  }, jsx("i", {
    "aria-hidden": "true",
    className: classNames(styles$Y['chevron-down'], _defineProperty(_defineProperty({}, styles$Y['chevron-down--to_com'], isTottusStandalone), styles$Y.active, isModalVisible))
  }))), jsx("div", {
    className: styles$Y['wrapper-modal']
  }, jsx(Modal, {
    toggleState: {
      visible: isModalVisible,
      setVisible: toggleModal
    },
    content: function content(actions) {
      return jsx(NavBody, {
        actions: actions
      });
    },
    options: {
      width: 'auto',
      height: null,
      minHeight: '279px',
      maxHeight: '70vh',
      disableOutsideClick: false,
      borderRadius: '10px 10px 0 0',
      padding: '0',
      display: 'flex',
      bottom: '0',
      left: '0',
      position: 'absolute'
    },
    deviceType: deviceType,
    fullWidth: deviceType !== 'desktop',
    customClass: mobileModalClass,
    customID: mobileModalID,
    customBodyClass: mobileBodyModalClass,
    showCloseButton: false,
    withPadding: false
  })));
};
SiSNavigationMenuMobile.propTypes = process.env.NODE_ENV !== "production" ? {
  brandLogo: PropTypes.shape({
    url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      })
    })
  }),
  categories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    channel: PropTypes.shape({
      desktop: PropTypes.bool,
      mobile: PropTypes.bool,
      app: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      item_image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        }),
        app: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })),
    second_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      }),
      third_level_categories: PropTypes.arrayOf(PropTypes.shape({
        item_name: PropTypes.string,
        item_url: PropTypes.string,
        new_tab: PropTypes.bool,
        tag: PropTypes.shape({
          show: PropTypes.bool,
          text: PropTypes.string,
          background_color: PropTypes.string
        })
      }))
    })),
    banners: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.object,
      new_tab: PropTypes.bool,
      image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        })
      })
    }))
  })).isRequired,
  colorLine: PropTypes.string,
  categoryColor: PropTypes.string,
  browseMainText: PropTypes.string.isRequired,
  store: PropTypes.oneOf(['sodimac', 'tottus', 'linio', 'homecenter']),
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string,
  menuConfig: PropTypes.shape({
    desktop: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    }),
    mobile: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    })
  }),
  defaultCategoryColors: PropTypes.shape({})
} : {};
SiSNavigationMenuMobile.defaultProps = {
  colorLine: '',
  categoryColor: '',
  classes: [],
  id: undefined
};

var SiSNavigationMenu = function SiSNavigationMenu(_ref) {
  var menuConfig = _ref.menuConfig,
    categories = _ref.categories,
    colorLine = _ref.colorLine,
    categoryColor = _ref.categoryColor,
    hightlightColor = _ref.hightlightColor,
    hightlightTextColor = _ref.hightlightTextColor,
    browseMainText = _ref.browseMainText,
    isSISLevel2Header = _ref.isSISLevel2Header,
    dataWrapper = _ref.dataWrapper,
    store = _ref.store,
    style = _ref.style,
    classes = _ref.classes,
    id = _ref.id,
    isVendorOrAgentLoggedIn = _ref.isVendorOrAgentLoggedIn,
    defaultCategoryColors = _ref.defaultCategoryColors;
  if (!store) {
    return jsx(React.Fragment, null);
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobileVisible = _useState2[0],
    setIsMobileVisible = _useState2[1];
  useEffect(function () {
    setIsMobileVisible(isIpadPotrait());
  }, [isMobileVisible]);
  return jsx("div", {
    "data-wrapper": "MS-MenuSis_".concat(dataWrapper),
    className: classNames(styles$L.container, classes.join(' ')),
    style: style,
    id: id,
    "data-testid": "SiSNavigationMenuId"
  }, isMobileVisible ? jsx(SiSNavigationMenuMobile, {
    categories: categories,
    colorLine: colorLine,
    browseMainText: browseMainText,
    categoryColor: categoryColor,
    store: store,
    dataWrapper: dataWrapper,
    menuConfig: menuConfig,
    defaultCategoryColors: defaultCategoryColors
  }) : jsx(SiSNavigationMenuDesktop, {
    categories: categories,
    browseMainText: browseMainText,
    colorLine: colorLine,
    categoryColor: categoryColor,
    hightlightColor: hightlightColor,
    hightlightTextColor: hightlightTextColor,
    store: store,
    dataWrapper: dataWrapper,
    isSISLevel2Header: isSISLevel2Header,
    isVendorOrAgentLoggedIn: isVendorOrAgentLoggedIn,
    menuConfig: menuConfig,
    defaultCategoryColors: defaultCategoryColors
  }));
};
SiSNavigationMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  brandLogo: PropTypes.shape({
    url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    image: PropTypes.shape({
      desktop: PropTypes.shape({
        url: PropTypes.string
      }),
      mobile: PropTypes.shape({
        url: PropTypes.string
      })
    })
  }),
  menuConfig: PropTypes.shape({
    desktop: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    }),
    mobile: PropTypes.shape({
      icon: PropTypes.shape({
        url: PropTypes.string
      }),
      text: PropTypes.string
    })
  }),
  categories: PropTypes.arrayOf(PropTypes.shape({
    item_name: PropTypes.string.isRequired,
    item_url: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string
    }),
    new_tab: PropTypes.bool,
    channel: PropTypes.shape({
      desktop: PropTypes.bool,
      mobile: PropTypes.bool,
      app: PropTypes.bool
    }),
    highlight_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      item_image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        }),
        app: PropTypes.shape({
          url: PropTypes.string
        })
      })
    })),
    second_level_categories: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.string,
      new_tab: PropTypes.bool,
      tag: PropTypes.shape({
        show: PropTypes.bool,
        text: PropTypes.string,
        background_color: PropTypes.string
      }),
      third_level_categories: PropTypes.arrayOf(PropTypes.shape({
        item_name: PropTypes.string,
        item_url: PropTypes.string,
        new_tab: PropTypes.bool,
        tag: PropTypes.shape({
          show: PropTypes.bool,
          text: PropTypes.string,
          background_color: PropTypes.string
        })
      }))
    })),
    banners: PropTypes.arrayOf(PropTypes.shape({
      item_name: PropTypes.string,
      item_url: PropTypes.object,
      new_tab: PropTypes.bool,
      image: PropTypes.shape({
        desktop: PropTypes.shape({
          url: PropTypes.string
        }),
        mobile: PropTypes.shape({
          url: PropTypes.string
        })
      })
    }))
  })),
  colorLine: PropTypes.string,
  categoryColor: PropTypes.string,
  hightlightColor: PropTypes.string,
  hightlightTextColor: PropTypes.string,
  isSISLevel2Header: PropTypes.bool,
  browseMainText: PropTypes.string.isRequired,
  dataWrapper: PropTypes.string,
  store: PropTypes.string,
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string
} : {};
SiSNavigationMenu.defaultProps = {
  classes: [],
  categories: [],
  id: undefined,
  isVendorOrAgentLoggedIn: false,
  style: {},
  dataWrapper: 'MS-MenuSis_'
};

var styles$Z = {"container":"Notification-module_container__1q1cZ","close-btn-container":"Notification-module_close-btn-container__sEP5M","main":"Notification-module_main__3_2fE","logo-container":"Notification-module_logo-container__28yca","content-container":"Notification-module_content-container__ID6EK","title":"Notification-module_title__3JDcm","body":"Notification-module_body__1ZkeQ"};

var Notification = function Notification(_ref) {
  var isVisible = _ref.isVisible,
    isWelcomeMessage = _ref.isWelcomeMessage,
    requireInteraction = _ref.requireInteraction,
    redirectUrl = _ref.redirectUrl,
    icon = _ref.icon,
    title = _ref.title,
    body = _ref.body,
    closeNotification = _ref.closeNotification;
  useEffect(function () {
    var timeoutId;
    if (isVisible && !requireInteraction) {
      timeoutId = setTimeout(function () {
        closeNotification();
      }, 10000);
    }
    return function () {
      clearTimeout(timeoutId);
    };
  }, [isVisible]);
  var onContainerClick = function onContainerClick() {
    if (redirectUrl) {
      window.location.assign(redirectUrl);
    }
  };
  var renderElement = function renderElement(value, Element) {
    if (value) {
      return Element;
    }
  };
  var iconSrc = function () {
    if (isWelcomeMessage) {
      return ICONS.F_LOGO;
    } else if (typeof icon === 'string') {
      return icon;
    } else {
      return '';
    }
  }();
  return jsx("div", {
    id: "testId-notification",
    "data-testid": "testId-notification",
    className: styles$Z.container,
    style: {
      visibility: isVisible ? 'visible' : 'hidden'
    }
  }, jsx("div", {
    className: styles$Z.main,
    onClick: onContainerClick
  }, renderElement(iconSrc, jsx("div", {
    className: styles$Z['logo-container']
  }, jsx("img", {
    src: iconSrc
  }))), jsx("div", {
    className: styles$Z['content-container']
  }, renderElement(title, jsx("div", {
    className: styles$Z.title
  }, title)), renderElement(body, jsx("div", {
    className: styles$Z.body
  }, body)))), jsx("div", {
    className: styles$Z['close-btn-container']
  }, jsx("button", {
    id: "testId-notification-close-btn",
    "data-testid": "testId-notification-close-btn",
    onClick: closeNotification
  }, "\u2573")));
};
Notification.defaultProps = {
  isVisible: false
};
Notification.propTypes = process.env.NODE_ENV !== "production" ? {
  isMarketplace: PropTypes.bool,
  isVisible: PropTypes.bool.isRequired,
  closeNotification: PropTypes.func.isRequired,
  isWelcomeMessage: PropTypes.bool,
  requireInteraction: PropTypes.bool,
  redirectUrl: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string
} : {};

var optIn = function optIn() {
  return {
    i18n: {
      es: {
        title: '¿Quieres conocer las mejores ofertas?',
        message: 'Que nadie te lo cuente. Suscríbete y activa las notificaciones.',
        accept: 'Sí, amo las ofertas',
        deny: 'No, gracias'
      },
      en: {
        title: '¿Quieres conocer las mejores ofertas?',
        message: 'Que nadie te lo cuente. Suscríbete y activa las notificaciones.',
        accept: 'Sí, amo las ofertas',
        deny: 'No, gracias'
      }
    },
    logo: ICONS.F_LOGO
  };
};
var airshipHelpers = {
  optIn: optIn
};

var openOptInModal = function () {
  var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(_ref) {
    var sdk, subdomain, tld, setPushNotificationData, config, optInOptions, optInStylesheetUrl, optInPlugin, isOptedIn;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          sdk = _ref.sdk, subdomain = _ref.subdomain, tld = _ref.tld, setPushNotificationData = _ref.setPushNotificationData, config = _ref.config;
          optInOptions = airshipHelpers.optIn();
          optInStylesheetUrl = function () {
            if (isLocalhost()) {
              return 'airship-mkp.styles.css';
            }
            return "https://".concat(subdomain, ".falabella.com").concat(tld, "/airship-styles-mkp.css");
          }();
          _context.prev = 3;
          _context.next = 6;
          return sdk.plugins.load('html-prompt', 'https://aswpsdkus.com/notify/v1/ua-html-prompt.min.js', {
            UA: window.UA,
            stylesheet: optInStylesheetUrl,
            askAgainDelay: get(config, 'ask_again_delay', 1209600),
            i18n: optInOptions.i18n,
            logo: optInOptions.logo
          });
        case 6:
          optInPlugin = _context.sent;
          _context.next = 9;
          return optInPlugin.prompt();
        case 9:
          isOptedIn = _context.sent;
          if (isOptedIn) {
            setTimeout(function () {
              document.querySelector('.airship-html-prompt-shadow').shadowRoot.querySelector('.airship-btn-accept').addEventListener('click', function () {
                setPushNotificationData({
                  isVisible: true,
                  body: '¡Listo! Recibirás notificaciones con las mejores ofertas y novedades 😀',
                  isWelcomeMessage: true
                });
              });
            }, 300);
          }
          _context.next = 16;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](3);
          console.log('Airship error at loading html-prompt plugin', _context.t0);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 13]]);
  }));
  return function openOptInModal(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var onServiceWokerLoaded = function () {
  var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(_ref3) {
    var subdomain, tld, setPushNotificationData, config, sdk, channel;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          subdomain = _ref3.subdomain, tld = _ref3.tld, setPushNotificationData = _ref3.setPushNotificationData, config = _ref3.config;
          if (!(typeof window !== 'undefined' && _typeof(window.UA) === 'object')) {
            _context2.next = 23;
            break;
          }
          _context2.prev = 2;
          _context2.next = 5;
          return window.UA;
        case 5:
          sdk = _context2.sent;
          sdk.localeOverride.setLanguage('es');
          if (!sdk.channel) {
            _context2.next = 13;
            break;
          }
          _context2.next = 10;
          return sdk.getChannel();
        case 10:
          _context2.t0 = _context2.sent;
          _context2.next = 14;
          break;
        case 13:
          _context2.t0 = Promise.resolve({});
        case 14:
          channel = _context2.t0;
          if (!((!sdk.channel || channel && !channel.opt_in) && sdk.canRegister)) {
            _context2.next = 18;
            break;
          }
          _context2.next = 18;
          return openOptInModal({
            sdk: sdk,
            subdomain: subdomain,
            tld: tld,
            setPushNotificationData: setPushNotificationData,
            config: config
          });
        case 18:
          _context2.next = 23;
          break;
        case 20:
          _context2.prev = 20;
          _context2.t1 = _context2["catch"](2);
          console.log('Airship global object error:', _context2.t1);
        case 23:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[2, 20]]);
  }));
  return function onServiceWokerLoaded(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var loadServiceWorker = function () {
  var _ref6 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3(_ref5) {
    var environment, subdomain, tld, setPushNotificationData, config, isLoggingEnabled, registration;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          environment = _ref5.environment, subdomain = _ref5.subdomain, tld = _ref5.tld, setPushNotificationData = _ref5.setPushNotificationData, config = _ref5.config;
          isLoggingEnabled = environment !== 'production';
          if (!('serviceWorker' in global.navigator)) {
            _context3.next = 15;
            break;
          }
          _context3.prev = 3;
          _context3.next = 6;
          return global.navigator.serviceWorker.register('/acc_sw.js');
        case 6:
          registration = _context3.sent;
          if (isLoggingEnabled) {
            console.log('Airship notification service worker registration successful with scope: ', registration.scope);
          }
          _context3.next = 10;
          return onServiceWokerLoaded({
            subdomain: subdomain,
            tld: tld,
            setPushNotificationData: setPushNotificationData,
            config: config
          });
        case 10:
          _context3.next = 15;
          break;
        case 12:
          _context3.prev = 12;
          _context3.t0 = _context3["catch"](3);
          if (isLoggingEnabled) {
            console.log('Airship notification service worker registration failed: ', _context3.t0);
          }
        case 15:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[3, 12]]);
  }));
  return function loadServiceWorker(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
var createAirshipScriptTag = function createAirshipScriptTag(_ref7) {
  var tenant = _ref7.tenant,
    environment = _ref7.environment,
    setPushNotificationData = _ref7.setPushNotificationData,
    config = _ref7.config;
  var allowedTenants = ['cl', 'co', 'pe'];
  var allowedEnvironments = ['dev', 'staging', 'beta', 'production'];
  if (!allowedTenants.includes(tenant) || !allowedEnvironments.includes(environment)) {
    return;
  }
  var subdomain = environment === 'production' ? 'www' : environment;
  var tld = tenant.toLowerCase() === 'cl' ? '' : ".".concat(tenant.toLowerCase());
  var headerScriptUrl = function () {
    return "https://".concat(subdomain, ".falabella.com").concat(tld, "/airship-header.js");
  }();
  var onLoad = function () {
    var _ref8 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return loadServiceWorker({
              environment: environment,
              subdomain: subdomain,
              tld: tld,
              setPushNotificationData: setPushNotificationData,
              config: config
            });
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function onLoad() {
      return _ref8.apply(this, arguments);
    };
  }();
  var script = createScriptTag({
    src: headerScriptUrl,
    type: 'text/javascript',
    id: 'airship-script',
    onLoad: onLoad,
    async: true
  });
  return script;
};
var loadAirshipScript = function loadAirshipScript(_ref9) {
  var tenant = _ref9.tenant,
    environment = _ref9.environment,
    setPushNotificationData = _ref9.setPushNotificationData,
    config = _ref9.config;
  if (getSISPageName()) {
    return;
  }
  var script = createAirshipScriptTag({
    tenant: tenant,
    environment: environment,
    setPushNotificationData: setPushNotificationData,
    config: config
  });
  var appendScript = function appendScript() {
    return appendNodeToHead(script);
  };
  appendScript();
};

var loadExternalDependencies = function loadExternalDependencies(_ref) {
  var toggles = _ref.toggles,
    tenant = _ref.tenant,
    environment = _ref.environment,
    functions = _ref.functions,
    configs = _ref.configs;
  if (toggles.isWebPushNotificationEnabled) {
    loadAirshipScript({
      tenant: tenant,
      environment: environment,
      setPushNotificationData: functions.setPushNotificationData,
      config: configs.webPushNotificationConfigs
    });
  }
};

var styles$_ = {"mobileBar":"MobileBar-module_mobileBar__3cRLY","brand_logo":"MobileBar-module_brand_logo__2ziP8"};

var MobileBar = function MobileBar(_ref) {
  var url = _ref.url;
  return jsx("a", {
    href: url,
    className: classNames(styles$_.mobileBar)
  }, "Ir a", jsx("div", {
    className: classNames(styles$_.brand_logo)
  }));
};
MobileBar.propTypes = process.env.NODE_ENV !== "production" ? {
  url: PropTypes.string.isRequired
} : {};
MobileBar.defaultProps = {
  url: '#'
};

var styles$$ = {"container":"SISLinks-module_container__3HR5h"};

var SISLinks = function SISLinks(_ref) {
  var stores = _ref.stores,
    storeName = _ref.storeName,
    deviceType = _ref.deviceType,
    isOnboardingEnabled = _ref.isOnboardingEnabled,
    currentStep = _ref.currentStep,
    isOnboardingDisabledCookie = _ref.isOnboardingDisabledCookie,
    isAgentLoggedIn = _ref.isAgentLoggedIn,
    isVendorLoggedIn = _ref.isVendorLoggedIn;
  return jsx("div", {
    id: "header-sis-links",
    className: classNames(styles$$.container)
  }, jsx(MatchMedia$1, {
    key: "sis-links-desktop",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(StoresAndLinks, {
          ourStores: stores,
          isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 0,
          additonalLinks: [],
          isAgentLoggedIn: isAgentLoggedIn,
          isVendorLoggedIn: isVendorLoggedIn,
          isNewNavigation: true,
          currentPage: storeName === '' ? 'marketplace' : storeName,
          deviceType: deviceType
        });
      },
      mobile: function mobile() {
        return jsx(StoresAndLinks, {
          ourStores: stores,
          isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 0,
          additonalLinks: [],
          isAgentLoggedIn: isAgentLoggedIn,
          isVendorLoggedIn: isVendorLoggedIn,
          isNewNavigation: true,
          currentPage: storeName === '' ? 'marketplace' : storeName,
          deviceType: deviceType
        });
      },
      tablet: function tablet() {
        return jsx(StoresAndLinks, {
          ourStores: stores,
          isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 0,
          additonalLinks: [],
          isAgentLoggedIn: isAgentLoggedIn,
          isVendorLoggedIn: isVendorLoggedIn,
          isNewNavigation: true,
          currentPage: storeName === '' ? 'marketplace' : storeName,
          deviceType: deviceType
        });
      }
    }
  }));
};
SISLinks.propTypes = process.env.NODE_ENV !== "production" ? {
  stores: PropTypes.arrayOf(PropTypes.object),
  storeName: PropTypes.string,
  deviceType: PropTypes.string,
  isOnboardingEnabled: PropTypes.bool,
  currentStep: PropTypes.number,
  isOnboardingDisabledCookie: PropTypes.bool,
  isAgentLoggedIn: PropTypes.bool,
  isVendorLoggedIn: PropTypes.bool
} : {};

var apiConfig$1 = {
  getSisHomeUrl: function getSisHomeUrl(_ref) {
    var tenant = _ref.tenant,
      store = _ref.store,
      env = _ref.env;
    var host = getHost$1(tenant, store, env);
    var storeName = STORE_MAP[tenant][store.toLowerCase()];
    var BU = storeName || 'falabella';
    return "".concat(host, "/").concat(BU, "-").concat(tenant);
  },
  getHomeUrl: function getHomeUrl(_ref2) {
    var tenant = _ref2.tenant,
      store = _ref2.store,
      env = _ref2.env;
    var _getStandaloneSite = getStandaloneSite(store),
      isStandaloneSite = _getStandaloneSite.isStandaloneSite,
      isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
    var isCustomSite = isStandaloneSite || isWhitelabelSite;
    var host = getHost$1(tenant, isCustomSite ? store : undefined, env);
    return "".concat(host, "/").concat(isCustomSite ? STORE_MAP[tenant][store] : 'falabella', "-").concat(tenant);
  },
  getTypeaheadUrl: function getTypeaheadUrl(term, tenant, isAndes, store) {
    var env = getEnvironment();
    if (!env) {
      env = 'production';
    }
    var subdomain = env === 'production' ? 'www' : env;
    var searchParams = new URLSearchParams({
      source: 'web'
    });
    if (isAndes) {
      searchParams.append('isAndes', 'true');
    }
    if (store) {
      searchParams.append('site', store);
    }
    return "https://".concat(subdomain, ".falabella.com/s/browse/v1/typeahead/").concat(tenant, "/").concat(term, "?").concat(searchParams.toString());
  }
};

var handleOnRouteChange = function handleOnRouteChange() {
  return '';
};
var OnboardingWithoutSSR = SkipSSR(Onboarding);
var Header = function Header(_ref) {
  var styles = _ref.styles,
    atgBaseUrl = _ref.atgBaseUrl,
    attachResizeListener = _ref.attachResizeListener,
    catalystBaseUrl = _ref.catalystBaseUrl,
    currentLocation = _ref.currentLocation,
    currentSearchTerm = _ref.currentSearchTerm,
    data = _ref.data,
    deviceType = _ref.deviceType,
    enableAnalyticsInfoCall = _ref.enableAnalyticsInfoCall,
    forceATG = _ref.forceATG,
    getTypeaheadUrl = _ref.getTypeaheadUrl,
    handleRouteChange = _ref.handleRouteChange,
    handleSoftRefresh = _ref.handleSoftRefresh,
    isATGLoginEnabled = _ref.isATGLoginEnabled,
    isDefaultComuna = _ref.isDefaultComuna,
    isGeoLocationEnabled = _ref.isGeoLocationEnabled,
    isPopOverVisible = _ref.isPopOverVisible,
    isTypeAheadEnabled = _ref.isTypeAheadEnabled,
    isZoneModalEnabled = _ref.isZoneModalEnabled,
    isWebPushNotificationEnabled = _ref.isWebPushNotificationEnabled,
    isSisSodimacPdpEnabled = _ref.isSisSodimacPdpEnabled,
    onUserLogin = _ref.onUserLogin,
    onUserLoginComplete = _ref.onUserLoginComplete,
    onUserLoginConsentsUpdate = _ref.onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate = _ref.onUserLoginPasswordUpdate,
    onUserLogout = _ref.onUserLogout,
    parentRouter = _ref.parentRouter,
    selectedZone = _ref.selectedZone,
    setAnalyticsInfo = _ref.setAnalyticsInfo,
    setBusy = _ref.setBusy,
    store = _ref.store,
    unifiedLoginBaseUrl = _ref.unifiedLoginBaseUrl,
    userCartCount = _ref.userCartCount,
    transversalBannerConfig = _ref.transversalBannerConfig,
    locationPathname = _ref.locationPathname,
    isOrangeHeader = _ref.isOrangeHeader,
    isSISLevel2Header = _ref.isSISLevel2Header,
    MobileAppWebView = _ref.MobileAppWebView;
  var _useState = useState(get(data, 'header', false)),
    _useState2 = _slicedToArray(_useState, 2),
    header = _useState2[0],
    setHeader = _useState2[1];
  var _useState3 = useState(get(data, 'taxonomy', false)),
    _useState4 = _slicedToArray(_useState3, 2),
    taxonomyData = _useState4[0],
    setTaxonomyData = _useState4[1];
  var _useState5 = useState(get(data, 'sisNavigationMenu', null)),
    _useState6 = _slicedToArray(_useState5, 2),
    sisNavigationMenu = _useState6[0],
    setSisNavigationMenu = _useState6[1];
  var labels = configs.labels,
    constants = configs.constants;
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showSearchBar = _useState8[0],
    setShowSearchBar = _useState8[1];
  var _useState9 = useState(store),
    _useState10 = _slicedToArray(_useState9, 2),
    site = _useState10[0],
    setSite = _useState10[1];
  var _useState11 = useState(undefined),
    _useState12 = _slicedToArray(_useState11, 2),
    errorMessage = _useState12[0],
    setErrorMessage = _useState12[1];
  var _useState13 = useState(currentLocation),
    _useState14 = _slicedToArray(_useState13, 2),
    location = _useState14[0],
    setLocation = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isMenuVisible = _useState16[0],
    setMenuVisible = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isMobileApp = _useState18[0],
    setMobileApp = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    modalVisible = _useState20[0],
    setModalVisible = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isSearchBarTouched = _useState22[0],
    setIsSearchBarTouched = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    zoneModalVisible = _useState24[0],
    setZoneModalVisible = _useState24[1];
  var _useState25 = useState(undefined),
    _useState26 = _slicedToArray(_useState25, 2),
    searchInputRef = _useState26[0],
    setSearchInputRef = _useState26[1];
  var _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    currentStep = _useState28[0],
    setCurrentStep = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    isOnboardingDisabledCookie = _useState30[0],
    setIsOnboardingDisabledCookie = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    isVendorLoggedIn = _useState32[0],
    setIsVendorLoggedIn = _useState32[1];
  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    isAgentLoggedIn = _useState34[0],
    setIsAgentLoggedIn = _useState34[1];
  var _useState35 = useState({
      isVisible: false
    }),
    _useState36 = _slicedToArray(_useState35, 2),
    pushNotificationData = _useState36[0],
    setPushNotificationData = _useState36[1];
  var _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    showLoginForm = _useState38[0],
    setShowLoginForm = _useState38[1];
  var emptySearchErrorTitle = labels.EMPTY_SEARCH_ERROR_TITLE;
  var emptySearchErrorMessage = labels.EMPTY_SEARCH_ERROR_MESSAGE;
  var incorrectSearchErrorTitle = labels.INCORRECT_SEARCH_ERROR_TITLE;
  var incorrectSearchErrorMessage = labels.INCORRECT_SEARCH_ERROR_MESSAGE;
  var _useContext = useContext(AppContext),
    tenant = _useContext.tenant,
    baseUrl = _useContext.baseUrl;
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    isIE = _useState40[0],
    setIsIe = _useState40[1];
  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    areCookiesPresent = _useState42[0],
    setAreCookiesPresent = _useState42[1];
  var isOrangeOrSISHeader = isOrangeHeader || site;
  var searchbar = get(header, 'entry.searchbar', {});
  var isStickyEnabled = {
    desktop: get(header, 'entry.is_sticky_desktop', false),
    mobile: get(header, 'entry.is_sticky_mobile', false),
    tablet: get(header, 'entry.is_sticky_mobile', false)
  };
  var isOnboardingEnabled = get(header, 'entry.header_configs[0].toggles.isonboardingenabled', false);
  var isProgramaticallyGeofinderEnabled = get(header, 'entry.header_configs[0].toggles.isprogramaticallygeofinderenabled', false);
  var _useState43 = useState(true),
    _useState44 = _slicedToArray(_useState43, 2),
    searchInSis = _useState44[0],
    setSearchInSis = _useState44[1];
  var geofinderConfigs = get(header, 'entry.header_configs[0].property_configs.geofinder', {});
  var isRecentSearchesEnabled = get(header, 'entry.header_configs[0].toggles.isrecentsearchesenabled', false);
  var isSearchSpecialCharactersEnabled = get(header, 'entry.header_configs[0].toggles.is_search_special_characters_enabled', false);
  var closeNotification = function closeNotification() {
    setPushNotificationData({
      isVisible: false
    });
  };
  useEffect(function () {
    var onboardingCookie = CookieStorage.getCookie(constants.ON_BOARDING_COOKIE) === 'done';
    setIsOnboardingDisabledCookie(onboardingCookie);
  }, [currentStep]);
  useEffect(function () {
    function loadInitialData() {
      return _loadInitialData.apply(this, arguments);
    }
    function _loadInitialData() {
      _loadInitialData = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
        var onboardingCookie, sisMenu, ieRegex;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              onboardingCookie = CookieStorage.getCookie(constants.ON_BOARDING_COOKIE) === 'done';
              setIsOnboardingDisabledCookie(onboardingCookie);
              if (data) {
                _context.next = 6;
                break;
              }
              Promise.all([getHeaderData({
                tenant: tenant,
                baseUrl: baseUrl
              }), getTaxonomyData({
                tenant: tenant,
                baseUrl: baseUrl
              }), getSisNavigationMenu({
                tenant: tenant,
                baseUrl: baseUrl,
                store: store
              })]).then(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 3),
                  headerRes = _ref3[0],
                  taxonomyRes = _ref3[1],
                  sisMenuRes = _ref3[2];
                setHeader(headerRes);
                setTaxonomyData(taxonomyRes);
                setSisNavigationMenu(sisMenuRes);
              }).catch(function (e) {
                console.log('getHeader error', e);
              });
              _context.next = 11;
              break;
            case 6:
              if (!(data && !data.sisNavigationMenu)) {
                _context.next = 11;
                break;
              }
              _context.next = 9;
              return getSisNavigationMenu({
                tenant: tenant,
                baseUrl: baseUrl,
                store: store
              });
            case 9:
              sisMenu = _context.sent;
              setSisNavigationMenu(sisMenu);
            case 11:
              ieRegex = new RegExp(/MSIE|Trident.*rv/i);
              setIsIe(ieRegex.test(window.navigator.userAgent));
              if (!location) {
                setLocation(getCurrentLocation());
              }
              attachResizeListener();
              loadExternalDependencies({
                tenant: tenant,
                environment: getEnvironment(),
                toggles: {
                  isWebPushNotificationEnabled: isWebPushNotificationEnabled
                },
                functions: {
                  setPushNotificationData: setPushNotificationData
                },
                configs: {
                  webPushNotificationConfigs: get(header, 'entry.header_configs[0].property_configs.web_push_notifications', {})
                }
              });
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _loadInitialData.apply(this, arguments);
    }
    try {
      loadInitialData();
    } catch (error) {
      console.error(error);
    }
  }, []);
  useEffect(function () {
    var urlSearchParams = new URLSearchParams(window.location.search);
    var _Object$fromEntries = Object.fromEntries(urlSearchParams.entries()),
      externalSiteName = _Object$fromEntries.externalSiteName,
      sid = _Object$fromEntries.sid;
    if (externalSiteName === 'MobileApp' && sid === 'APPMOBILE') {
      setMobileApp(true);
    }
    var subDomain = getSubdomain();
    var expParam = getEXPParam();
    var isValidExpParam = function isValidExpParam() {
      return (isPdpPage() || !subDomain && isLandingPage()) && expParam;
    };
    var siteValue = isPdpPage() ? null : subDomain;
    setSite(store || (isValidExpParam() ? expParam : siteValue));
  }, []);
  useEffect(function () {
    if (isStickyEnabled[deviceType]) {
      var currScroll = 0;
      var prevScroll = 0;
      var currDirection = 0;
      var prevDirection = 0;
      var threshold = deviceType === 'desktop' ? 2000 : 1000;
      var toggled = false;
      var shouldStickyActivate = function shouldStickyActivate() {
        var worldsMenuBar = document.querySelector('[data-wrapper="EM-Worldsapp"]');
        var filterSection = document.getElementById('testId-facets-mobile-container');
        return !!worldsMenuBar && currScroll + 70 > get(worldsMenuBar, 'offsetTop', null) || !!filterSection && currScroll + 70 > get(filterSection, 'offsetTop', null);
      };
      var toggleHeader = function toggleHeader() {
        toggled = true;
        var headerElement = document.getElementById('scrollable-content');
        var bottomHeaderElement = document.getElementById('bottom-header');
        headerElement.classList.remove("".concat(styles['header-scroll-styles']));
        bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
        if (currDirection === 2) {
          headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
        }
        if (currDirection === 2 && currScroll > threshold && !shouldStickyActivate()) {
          headerElement.classList.add("".concat(styles.hide));
        } else if (currDirection === 1 && currScroll > threshold && !shouldStickyActivate()
        ) {
          headerElement.classList.remove("".concat(styles.hide));
          headerElement.classList.add("".concat(styles['header-scroll-styles']));
          bottomHeaderElement.classList.add("".concat(styles['bottom-header']));
        } else {
          toggled = false;
          if (headerElement.classList.contains("".concat(styles.hide))) {
            headerElement.classList.remove("".concat(styles.hide));
          }
        }
        return toggled;
      };
      var checkScroll = function checkScroll(e) {
        var headerElement = document.getElementById('scrollable-content');
        var bottomHeaderElement = document.getElementById('bottom-header');
        currScroll = window.scrollY || document.documentElement.scrollTop;
        if (currScroll > prevScroll) {
          currDirection = 2;
        } else {
          currDirection = 1;
          if (currScroll <= 10) {
            if (isVendorLoggedIn || isAgentLoggedIn || areCookiesPresent) {
              headerElement.classList.add("".concat(styles['header-scroll-styles2']));
            }
            headerElement.classList.remove("".concat(styles['header-scroll-styles']));
            bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
          }
          if (prevScroll < 5 && currScroll < prevScroll) {
            headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
            headerElement.classList.remove("".concat(styles['header-scroll-styles']));
            bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
          }
          if (prevScroll - currScroll >= 5) {
            headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
          }
        }
        if (currDirection !== prevDirection) {
          toggled = toggleHeader();
        }
        if (toggled) {
          prevDirection = currDirection;
        }
        prevScroll = currScroll;
      };
      window.onscroll = checkScroll;
    }
  }, [header]);
  useEffect(function () {
    if (currentLocation) {
      setLocation(currentLocation);
    }
  }, [currentLocation]);
  var onSearchTermChange = function onSearchTermChange(searchTerm) {
    if (searchTerm.length === 0) {
      setErrorMessage({
        title: emptySearchErrorTitle,
        msg: emptySearchErrorMessage
      });
      return false;
    }
    if (searchTerm.length < constants.MIN_SEARCH_TERM_LENGTH) {
      setErrorMessage({
        title: incorrectSearchErrorTitle,
        msg: incorrectSearchErrorMessage
      });
      return false;
    }
    var termo = encodeURIComponent(searchTerm).replace(/%20/g, '+');
    window.dispatchEvent(new CustomEvent('DDM_onSearching', {
      bubbles: true,
      detail: {
        value: termo,
        prefix: 'BCR'
      }
    }));
    if (handleRouteChange) {
      handleRouteChange(termo, store && searchInSis);
    } else {
      var searchingInSis = searchInSis && site;
      var envBaseUrl = searchingInSis ? getStoreBaseUrl(tenant, site) : getStoreBaseUrl(tenant);
      var expName = searchingInSis ? STORES[site.toUpperCase()] : 'falabella';
      console.log('Redirecting to ', "".concat(envBaseUrl, "/").concat(expName, "-").concat(tenant, "/search?Ntt=").concat(termo));
      window.location.href = "".concat(envBaseUrl, "/").concat(expName, "-").concat(tenant, "/search?Ntt=").concat(termo);
    }
    setErrorMessage(undefined);
    return true;
  };
  var onSearchDomainChange = function onSearchDomainChange() {
    setSearchInSis(!searchInSis);
  };
  var _useState45 = useState(''),
    _useState46 = _slicedToArray(_useState45, 2),
    agentCookieData = _useState46[0],
    setAgentCookieData = _useState46[1];
  var _useState47 = useState(''),
    _useState48 = _slicedToArray(_useState47, 2),
    userInformation = _useState48[0],
    setUserInformation = _useState48[1];
  var _useState49 = useState(false),
    _useState50 = _slicedToArray(_useState49, 2),
    hideMenuBar = _useState50[0],
    setHideMenuBar = _useState50[1];
  var _useState51 = useState(false),
    _useState52 = _slicedToArray(_useState51, 2),
    isCatalyst = _useState52[0],
    setCatalyst = _useState52[1];
  var getCookie = CookieStorage.getCookie,
    setCookie = CookieStorage.setCookie,
    unescapeATGCookies = CookieStorage.unescapeATGCookies;
  var _useState53 = useState(''),
    _useState54 = _slicedToArray(_useState53, 2),
    mobileModalClass = _useState54[0],
    setMobileModalClass = _useState54[1];
  var toggleModal = function toggleModal(visibility) {
    if (deviceType !== 'desktop') {
      if (!visibility) {
        setMobileModalClass('floatBottomEndTransition');
        var animationTimer = setTimeout(function () {
          setModalVisible(visibility);
          clearTimeout(animationTimer);
        }, 350);
      } else {
        setMobileModalClass('floatBottomTransition');
        setModalVisible(visibility);
      }
    } else {
      setModalVisible(visibility);
    }
  };
  useEffect(function () {
    var params = new URLSearchParams(window.location.search);
    var storeIdQuery = params.get('storeId');
    var moduleQuery = params.get('modulo');
    var storeCookie = CookieStorage.getKioskoStoreCookieName();
    var moduleCookie = CookieStorage.getKioskoModuleCookieName();
    var storeId = getCookie(storeCookie);
    var module = getCookie(moduleCookie);
    if (storeIdQuery && storeId !== storeIdQuery) {
      setCookie({
        name: storeCookie,
        value: storeIdQuery
      });
      storeId = storeIdQuery;
    }
    if (moduleQuery && module !== moduleQuery) {
      setCookie({
        name: moduleCookie,
        value: moduleQuery
      });
      module = moduleQuery;
    }
    var vendorDataCookie = unescapeATGCookies(getCookie(CookieStorage.getVendorDataCookie()));
    var agentDataCookie = unescapeATGCookies(getCookie(CookieStorage.getAgentDataCookie()));
    var userCookie = CookieStorage.getUserDataCookieName();
    var userInformationCookie = unescapeATGCookies(getCookie(userCookie));
    if (vendorDataCookie) {
      setIsVendorLoggedIn(true);
    }
    if (storeId && module) {
      setAreCookiesPresent(true);
    }
    if (agentDataCookie) {
      setIsAgentLoggedIn(true);
      setAgentCookieData(agentDataCookie);
    }
    if (userInformationCookie) {
      setUserInformation(userInformationCookie);
    }
    setCatalyst(CookieStorage.isCatalyst());
  }, []);
  if (!header || !taxonomyData) {
    return jsx(React.Fragment, null);
  }
  var isSvsSearch = getParameterByName('f.svs') === 'true';
  var handleUserLogout = function () {
    var _ref4 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2() {
      var userCookie;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            userCookie = CookieStorage.getUserDataCookieName();
            CookieStorage.removeCookie({
              name: userCookie
            });
            _context2.next = 4;
            return onUserLogout();
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleUserLogout() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleUserLogin = function () {
    var _ref5 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3(userData) {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return onUserLogin(userData);
          case 2:
            if (enableAnalyticsInfoCall) {
              initDigitalData();
            }
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleUserLogin(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var marketPlaceLogoDesktop = isOrangeOrSISHeader ? MARKETPLACE_LOGO_URL_DESKTOP : get(header, 'entry.logo.desktop_icon.url', '');
  var marketPlaceLogoMobile = isOrangeOrSISHeader ? MARKETPLACE_LOGO_URL_MOBILE : get(header, 'entry.logo.mobile_icon.url', '');
  var logoIconDesktop = !site ? marketPlaceLogoDesktop : get(header, "entry.themes.".concat(site, ".logos.desktop.url"), BRAND_CONFIG["".concat(site)].brand_logo);
  var logoIconMobile = !site ? marketPlaceLogoMobile : get(header, "entry.themes.".concat(site, ".logos.mobile.url"), BRAND_CONFIG["".concat(site)].brand_logo);
  var mainLogoURL = get(header, 'entry.logo.url', "".concat(isCatalyst ? catalystBaseUrl : atgBaseUrl, "/falabella-").concat(tenant));
  var logoURL = !site ? mainLogoURL : fallbackForEmpty(header, "entry.themes.".concat(site, ".url"), BRAND_CONFIG["".concat(site)].url);
  var primaryThemeColor = fallbackForEmpty(header, "entry.themes.".concat(site, ".color"), site ? BRAND_CONFIG[site].brand_color : '#AAD500');
  var secondaryThemeColor = fallbackForEmpty(header, "entry.themes.".concat(site, ".secondary_color"), '#495867');
  var primaryColor = fallbackForEmpty(header, "entry.themes.".concat(site, ".color"), site ? BRAND_CONFIG[site].brand_color : '#343E49');
  var secondaryColor = fallbackForEmpty(header, "entry.themes.".concat(site, ".secondary_color"), '#343E49');
  var stores = get(header, 'entry.sis_configs.0.stores', []).filter(function (st) {
    return st.is_enable;
  }).sort(function (a, b) {
    return a.order - b.order;
  });
  var mobileBarRender = function mobileBarRender() {
    return isSISLevel2Header ? jsx(MobileBar, {
      url: mainLogoURL
    }) : jsx(React.Fragment, null);
  };
  return jsx(React.Fragment, null, site && jsx(MatchMedia$1, {
    key: "testId-taxonomy-mobile",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return mobileBarRender();
      },
      mobile: function mobile() {
        return mobileBarRender();
      }
    }
  }), jsx("header", {
    className: classNames(styles["".concat(isVendorLoggedIn || isAgentLoggedIn || areCookiesPresent ? 'no-border' : '')], styles["".concat(MobileAppWebView ? 'hide-component' : '')])
  }, !isSISLevel2Header && stores.length > 0 && jsx(SISLinks, {
    stores: stores,
    storeName: !isEmpty$1(sisNavigationMenu) ? get(sisNavigationMenu, 'entry.data_wrapper', '') : '',
    deviceType: deviceType,
    isOnboardingEnabled: isOnboardingEnabled,
    isOnboardingDisabledCookie: isOnboardingDisabledCookie,
    currentStep: currentStep,
    isAgentLoggedIn: isAgentLoggedIn,
    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent
  }), errorMessage && jsx(ErrorDialog, {
    title: errorMessage.title,
    message: errorMessage.msg,
    onClose: function onClose() {
      setErrorMessage(undefined);
    }
  }), isAgentLoggedIn && jsx(AgentHeader, {
    agentCookie: agentCookieData,
    userName: userInformation.split('*')[0],
    agentBaseUrl: baseUrl,
    atgBaseUrl: atgBaseUrl,
    catalystBaseUrl: catalystBaseUrl,
    onUserLogout: handleUserLogout,
    isCatalyst: CookieStorage.isCatalyst(),
    tenant: tenant,
    isAgentLoggedIn: isAgentLoggedIn,
    setIsAgentLoggedIn: setIsAgentLoggedIn,
    forceATG: forceATG,
    store: store
  }), (isVendorLoggedIn || areCookiesPresent) && jsx(VendorHeader, {
    isCatalyst: CookieStorage.isCatalyst(),
    tenant: tenant,
    setIsVendorLoggedIn: setIsVendorLoggedIn,
    isVendorLoggedIn: isVendorLoggedIn,
    vendorBaseUrl: baseUrl,
    atgBaseUrl: atgBaseUrl,
    catalystBaseUrl: catalystBaseUrl,
    onUserLogout: handleUserLogout,
    forceATG: forceATG,
    store: store
  }), isOnboardingEnabled && !isMobileApp && jsx(OnboardingWithoutSSR, {
    deviceType: deviceType,
    currentStep: currentStep,
    setCurrentStep: setCurrentStep,
    onboardingData: get(header, 'entry.onboarding', null),
    tenant: tenant
  }), jsx("div", {
    id: "scrollable-content",
    style: {
      background: site && fallbackForEmpty(header, "entry.themes.".concat(site, ".color"), BRAND_CONFIG[site].brand_color)
    },
    "data-testid": "header-util-bar",
    className: classNames("".concat(styles['header-util-bar']))
  }, jsx("div", {
    className: classNames(styles.container, styles['header-container'])
  }, !site && jsx(React.Fragment, null, jsx(MatchMedia$1, {
    key: "testId-taxonomy-mobile",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      },
      mobile: function mobile() {
        return jsx(Taxonomy$1, {
          headerData: header,
          data: taxonomyData,
          currentLocation: location,
          isInternetExplorer: isIE,
          isMenuVisible: isMenuVisible,
          setMenuVisible: setMenuVisible,
          isGeoLocationEnabled: isGeoLocationEnabled,
          deviceType: deviceType,
          hideMenuBar: hideMenuBar,
          isCatalyst: isCatalyst,
          isAgentLoggedIn: isAgentLoggedIn,
          isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent
        });
      }
    }
  }), jsx(MatchMedia$1, {
    key: "testId-taxonomy-tablet",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(React.Fragment, null);
      },
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(Taxonomy$1, {
          headerData: header,
          data: taxonomyData,
          currentLocation: location,
          isInternetExplorer: isIE,
          isMenuVisible: isMenuVisible,
          setMenuVisible: setMenuVisible,
          isGeoLocationEnabled: isGeoLocationEnabled,
          deviceType: deviceType,
          hideMenuBar: hideMenuBar,
          isCatalyst: isCatalyst,
          isAgentLoggedIn: isAgentLoggedIn,
          isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent
        });
      }
    }
  })), jsx(MatchMedia$1, {
    key: "testId-logo-link",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(Logo, {
          path: logoURL,
          logoIcon: logoIconDesktop,
          store: site
        });
      },
      mobile: function mobile() {
        return jsx(Logo, {
          path: logoURL,
          logoIcon: logoIconMobile,
          isMobile: true,
          store: site
        });
      },
      tablet: function tablet() {
        return jsx(Logo, {
          path: logoURL,
          logoIcon: logoIconMobile,
          isMobile: true,
          store: site
        });
      }
    }
  }), jsx(MatchMedia$1, {
    key: "testId-store-menu",
    deviceType: deviceType,
    content: {
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      },
      desktop: function desktop() {
        return jsx(SiSNavigationMenu, {
          brandLogo: get(sisNavigationMenu, 'entry.brand_logo', {}),
          categories: get(sisNavigationMenu, 'entry.categories', []),
          browseMainText: get(sisNavigationMenu, 'entry.browse_main_text', ''),
          colorLine: get(sisNavigationMenu, 'entry.color_line', ''),
          categoryColor: get(sisNavigationMenu, 'entry.category_color', ''),
          hightlightColor: get(sisNavigationMenu, 'entry.hightlight_color', ''),
          hightlightTextColor: get(sisNavigationMenu, 'entry.hightlight_text_color', ''),
          dataWrapper: get(sisNavigationMenu, 'entry.data_wrapper', ''),
          store: site,
          isSISLevel2Header: isSISLevel2Header
        });
      }
    }
  }), !site && jsx(MatchMedia$1, {
    key: "testId-taxonomy-desktop",
    deviceType: deviceType,
    content: {
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      },
      desktop: function desktop() {
        return jsx(Taxonomy$1, {
          currentLocation: location,
          data: taxonomyData,
          deviceType: deviceType,
          headerData: header,
          hideMenuBar: hideMenuBar,
          isAgentLoggedIn: isAgentLoggedIn,
          isCatalyst: isCatalyst,
          isGeoLocationEnabled: isGeoLocationEnabled,
          isInternetExplorer: isIE,
          isMenuVisible: isMenuVisible,
          isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
          setMenuVisible: setMenuVisible
        });
      }
    }
  }), jsx(MatchMedia$1, {
    key: "search-bar-desktop",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(Search, {
          deviceType: deviceType,
          getTypeaheadUrl: getTypeaheadUrl,
          isAndes: isZoneModalEnabled,
          searchInSis: searchInSis,
          isSvsSearch: isSvsSearch,
          isTypeAheadEnabled: isTypeAheadEnabled,
          isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
          onLoadingStateChange: setBusy,
          onSearch: onSearchTermChange,
          searchbar: searchbar,
          setHideMenuBar: setHideMenuBar,
          setSearchInputRef: setSearchInputRef,
          isSearchBarTouched: isSearchBarTouched,
          setIsSearchBarTouched: setIsSearchBarTouched,
          showSearchBar: showSearchBar,
          currentSearchTerm: currentSearchTerm || getParameterByName('Ntt'),
          store: site,
          onSearchDomainChange: onSearchDomainChange,
          isRecentSearchesEnabled: isRecentSearchesEnabled,
          isSearchSpecialCharactersEnabled: isSearchSpecialCharactersEnabled
        });
      },
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      }
    }
  }), jsx(UserActions$1, {
    showSearchBar: showSearchBar,
    setShowSearchBar: setShowSearchBar,
    isATGLoginEnabled: isATGLoginEnabled,
    isInternetExplorer: isIE,
    atgBaseUrl: atgBaseUrl,
    showLoginForm: showLoginForm,
    setShowLoginForm: setShowLoginForm,
    modalVisible: modalVisible,
    mobileModalClass: mobileModalClass,
    toggleModal: toggleModal,
    catalystBaseUrl: catalystBaseUrl,
    onLoadingStateChange: setBusy,
    onUserLogout: handleUserLogout,
    deviceType: deviceType,
    headerData: header,
    onUserLogin: handleUserLogin,
    onUserLoginComplete: onUserLoginComplete,
    onUserLoginConsentsUpdate: onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate: onUserLoginPasswordUpdate,
    unifiedLoginBaseUrl: unifiedLoginBaseUrl,
    userCartCount: userCartCount,
    isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 1,
    setHideMenuBar: setHideMenuBar,
    setMenuVisible: setMenuVisible,
    forceATG: forceATG,
    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
    isAgentLoggedIn: isAgentLoggedIn,
    isStore: !!site,
    isOrangeOrSISHeader: isOrangeOrSISHeader,
    isSISLevel2Header: isSISLevel2Header
  })), deviceType !== 'desktop' && jsx("div", {
    className: classNames(_defineProperty({}, styles.mobile_middle_wrapper, site))
  }, jsx(SiSNavigationMenu, {
    brandLogo: get(sisNavigationMenu, 'entry.brand_logo', {}),
    categories: get(sisNavigationMenu, 'entry.categories', []),
    browseMainText: get(sisNavigationMenu, 'entry.browse_main_text', ''),
    colorLine: get(sisNavigationMenu, 'entry.color_line', ''),
    categoryColor: get(sisNavigationMenu, 'entry.category_color', ''),
    hightlightColor: get(sisNavigationMenu, 'entry.hightlight_color', ''),
    hightlightTextColor: get(sisNavigationMenu, 'entry.hightlight_text_color', ''),
    dataWrapper: get(sisNavigationMenu, 'entry.data_wrapper', ''),
    store: site
  }), jsx(Search, {
    deviceType: deviceType,
    onSearch: onSearchTermChange,
    currentSearchTerm: currentSearchTerm || getParameterByName('Ntt'),
    isSvsSearch: isSvsSearch,
    isTypeAheadEnabled: isTypeAheadEnabled,
    isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
    getTypeaheadUrl: getTypeaheadUrl,
    onLoadingStateChange: setBusy,
    searchbar: searchbar,
    setHideMenuBar: setHideMenuBar,
    isAndes: isZoneModalEnabled,
    isAgentLoggedIn: isAgentLoggedIn,
    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
    setSearchInputRef: setSearchInputRef,
    isSearchBarTouched: isSearchBarTouched,
    setIsSearchBarTouched: setIsSearchBarTouched,
    store: site,
    searchInSis: searchInSis,
    onSearchDomainChange: onSearchDomainChange,
    isRecentSearchesEnabled: isRecentSearchesEnabled,
    isSearchSpecialCharactersEnabled: isSearchSpecialCharactersEnabled
  }))), jsx("div", {
    id: "bottom-header",
    className: classNames(_defineProperty({}, styles.hasBorder, !isOrangeOrSISHeader))
  }, jsx(TransversalBanner, {
    key: "transversalBanner",
    transversalBanner: header.transversalBannerHtml,
    transversalBannerConfig: transversalBannerConfig,
    locationPathname: locationPathname
  }), jsx(TernaryNavBar$1, {
    currentStep: currentStep,
    deviceType: deviceType,
    handleRouteChange: handleSoftRefresh,
    header: header,
    isAgentLoggedIn: isAgentLoggedIn,
    baseUrl: catalystBaseUrl,
    isBrandingMarketplace: true,
    isDefaultComuna: isDefaultComuna,
    selectedZone: selectedZone,
    isPopOverVisible: isPopOverVisible,
    isOnboardingDisabledCookie: isOnboardingDisabledCookie,
    isOnboardingEnabled: isOnboardingEnabled,
    searchInSis: searchInSis,
    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
    isZoneModalEnabled: isZoneModalEnabled,
    isSearchBarTouched: isSearchBarTouched,
    modalVisible: zoneModalVisible,
    setModalVisible: setZoneModalVisible,
    tenant: tenant,
    onSearchDomainChange: onSearchDomainChange,
    storeName: !isEmpty$1(sisNavigationMenu) ? get(sisNavigationMenu, 'entry.data_wrapper', '') : '',
    isProgramaticallyGeofinderEnabled: isProgramaticallyGeofinderEnabled,
    geofinderConfigs: geofinderConfigs,
    isOrangeOrSISHeader: isOrangeOrSISHeader,
    isSISLevel2Header: isSISLevel2Header,
    setShowLoginForm: setShowLoginForm
  })), modalVisible && deviceType !== 'desktop' && jsx(MarketplaceOverlay$1, {
    handlers: function handlers(e) {
      e.preventDefault();
      toggleModal(false);
      setModalVisible(false);
    }
  }), pushNotificationData.isVisible && jsx(Notification, {
    requireInteraction: pushNotificationData.require_interaction,
    isVisible: pushNotificationData.isVisible,
    isWelcomeMessage: pushNotificationData.isWelcomeMessage,
    action: pushNotificationData.action,
    icon: pushNotificationData.icon,
    title: pushNotificationData.title,
    body: pushNotificationData.body,
    closeNotification: closeNotification
  }), pushNotificationData.isVisible && jsx(Notification, {
    requireInteraction: pushNotificationData.require_interaction,
    isVisible: pushNotificationData.isVisible,
    isWelcomeMessage: pushNotificationData.isWelcomeMessage,
    action: pushNotificationData.action,
    icon: pushNotificationData.icon,
    title: pushNotificationData.title,
    body: pushNotificationData.body,
    closeNotification: closeNotification
  })), site && jsx("style", null, ' ', "\n          :root {\n            --primary-color: ".concat(primaryColor, ";\n            --secondary-color: ").concat(secondaryColor, ";\n            --primary-theme-color: ").concat(primaryThemeColor, ";\n            --secondary-theme-color: ").concat(secondaryThemeColor, ";\n          }\n        ")), isOrangeOrSISHeader ? jsx("style", null, "\n        :root {\n          --header-logo-background: linear-gradient(270.96deg, #ff6200 0%, #ff861b 95.09%);\n          --header-background: #ee5601;\n          --mobile-header-background: linear-gradient(17.56deg,#ff9401 63.22%,#ff7b01 105.58%,#ff6c01 144.92%);\n          --text-color: #fff;\n          --icon-background: #495867;\n          --hover-color: #FF6200;\n          --searchbar-box-shadow: 0px 0px 4px rgba(158, 160, 150, 0.5);\n          --cart-border-color: #ff9502;\n          --border-color: 255, 255, 255;\n          --header-primary-color: ".concat(primaryColor, ";\n          --header-zone-primary-color:#fff;\n          --sis-link-header-zone-whithe-icon: url(https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blte2bf633680a745d6/location_pin_white_sis.svg) !important;    \n          --header-border-top:;\n          --search-bar-border-radius:35px;\n          --category-button-wrapper-border-radius:32px;\n          --search-bar-button-icon-border-radius:35px;\n          --category-button-wrapper-font-size:16px;\n          --category-button-wrapper-border-color: #fff;\n          --category-button-chevron-down-color:#fff;\n        }\n        ")) : jsx("style", null, "\n          :root {\n            --header-logo-background: transparent;\n            --header-background: #FAFAFA;\n            --mobile-header-background: #FAFAFA;\n            --text-color: #343E49;\n            --icon-background: #343E49;\n            --hover-color: transparent;\n            --searchbar-box-shadow: none;\n            --cart-border-color: #343E49;\n            --border-color: 73, 88, 103;\n            --border-top-desktop: #CAD1D9;\n            --border-top-mobile: #FAFAFA;\n            --primary-color: ".concat(primaryColor, ";\n            --secondary-color: ").concat(primaryColor, ";\n            --primary-theme-color: ").concat(primaryThemeColor, ";\n            --secondary-theme-color: ").concat(secondaryThemeColor, ";\n            --linear-gradient-1: linear-gradient(90deg, #668F00 0%, #8FCA00 100%);\n            --linear-gradient-2: #AAD500;\n            --navigation-title: #68717D;\n            --color-shade-1: #495867;\n            --header-primary-color:#FAFAFA;\n            --sis-link-header-zone-whithe-icon:url(https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt12bfc7a09b55ab55/6538d0cfd31953c6b30dbd57/gray_geofinder.svg) !important;    \n            --header-border-top:").concat(!isSISLevel2Header ? '1px solid #EEEEEE;' : '', "  \n            --search-bar-border-radius:35px;\n            --search-bar-button-icon-border-radius:35px;\n            --category-button-wrapper-border-radius:32px;\n            --category-button-wrapper-font-size:16px;\n          }\n        ")));
};
Header.defaultProps = {
  atgBaseUrl: '',
  catalystBaseUrl: '',
  currentLocation: '',
  currentSearchTerm: '',
  enableAnalyticsInfoCall: false,
  forceATG: false,
  handleSoftRefresh: noop,
  isATGLoginEnabled: false,
  isDefaultComuna: false,
  isGeoLocationEnabled: true,
  isPopOverVisible: false,
  isTypeAheadEnabled: true,
  isZoneModalEnabled: true,
  isWebPushNotificationEnabled: false,
  isSisSodimacPdpEnabled: false,
  onRouteChange: handleOnRouteChange,
  onUserLogin: noop,
  onUserLoginComplete: noop,
  onUserLoginConsentsUpdate: noop,
  onUserLoginPasswordUpdate: noop,
  onUserLogout: noop,
  parentRouter: null,
  selectedZone: undefined,
  store: null,
  unifiedLoginBaseUrl: undefined,
  userCartCount: undefined,
  locationPathname: undefined,
  getTypeaheadUrl: apiConfig$1.getTypeaheadUrl,
  isOrangeHeader: false,
  isSISLevel2Header: false,
  MobileAppWebView: false
};
Header.propTypes = process.env.NODE_ENV !== "production" ? {
  styles: PropTypes.object.isRequired,
  atgBaseUrl: PropTypes.string.isRequired,
  attachResizeListener: PropTypes.func.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  currentLocation: PropTypes.string,
  currentSearchTerm: PropTypes.string,
  data: PropTypes.any,
  deviceType: PropTypes.string.isRequired,
  enableAnalyticsInfoCall: PropTypes.bool,
  forceATG: PropTypes.bool,
  getTypeaheadUrl: PropTypes.func,
  handleRouteChange: PropTypes.any,
  handleSoftRefresh: PropTypes.func,
  isATGLoginEnabled: PropTypes.bool,
  isDefaultComuna: PropTypes.bool,
  isGeoLocationEnabled: PropTypes.bool,
  isPopOverVisible: PropTypes.bool,
  isTypeAheadEnabled: PropTypes.bool,
  isZoneModalEnabled: PropTypes.bool,
  isWebPushNotificationEnabled: PropTypes.bool,
  isSisSodimacPdpEnabled: PropTypes.bool,
  onRouteChange: PropTypes.func,
  onUserLogin: PropTypes.func,
  onUserLoginComplete: PropTypes.func,
  onUserLoginConsentsUpdate: PropTypes.func,
  onUserLoginPasswordUpdate: PropTypes.func,
  onUserLogout: PropTypes.func,
  parentRouter: PropTypes.any,
  refreshUserData: PropTypes.func.isRequired,
  selectedZone: PropTypes.object,
  setAnalyticsInfo: PropTypes.func.isRequired,
  setBusy: PropTypes.func.isRequired,
  locationPathname: PropTypes.string,
  store: PropTypes.oneOf(['linio', 'sodimac', 'tottus', 'homecenter']),
  unifiedLoginBaseUrl: PropTypes.string,
  userCartCount: PropTypes.string,
  transversalBannerConfig: PropTypes.shape({
    home: PropTypes.bool,
    pdp: PropTypes.bool,
    xlp: PropTypes.bool,
    basket: PropTypes.bool
  }),
  isOrangeHeader: PropTypes.bool,
  isSISLevel2Header: PropTypes.bool,
  MobileAppWebView: PropTypes.bool
} : {};
var MarketplaceHeader = withUser(withLoader(withDevice(Header)));

var styles$10 = {"hide":"Header-module_hide__3fSYb","bottom-header":"Header-module_bottom-header__3FEwo","hasBorder":"Header-module_hasBorder__10kzF","header-scroll-styles":"Header-module_header-scroll-styles__110UC","header-scroll-vendor":"Header-module_header-scroll-vendor__1PvE9","no-border":"Header-module_no-border__1Nl6h","header-util-bar":"Header-module_header-util-bar__3c_pb","container":"Header-module_container__1pIp7","header-container":"Header-module_header-container__37tGL","header-container--so_com":"Header-module_header-container--so_com__1CkPi","header-container--to_com":"Header-module_header-container--to_com__-A9bJ","mobile_middle_wrapper":"Header-module_mobile_middle_wrapper__1_Ib1","mobile_middle_wrapper--to_com":"Header-module_mobile_middle_wrapper--to_com__-SRMm","hide-component":"Header-module_hide-component__KHMOm"};

var whitelabelStyles = {"hide":"WhitelabelHeader-module_hide__2LSBu","hasBorder":"WhitelabelHeader-module_hasBorder__tT8iL","header-scroll-styles":"WhitelabelHeader-module_header-scroll-styles__2Ljjy","header-scroll-vendor":"WhitelabelHeader-module_header-scroll-vendor__efkuk","no-border":"WhitelabelHeader-module_no-border__cRB-l","header-util-bar":"WhitelabelHeader-module_header-util-bar__2WeYL","container":"WhitelabelHeader-module_container__3TL4k","header-container":"WhitelabelHeader-module_header-container__1z92p","mobile_middle_wrapper":"WhitelabelHeader-module_mobile_middle_wrapper__kDq66","mobile_middle_wrapper--to_com":"WhitelabelHeader-module_mobile_middle_wrapper--to_com__31IKp","parent-container":"WhitelabelHeader-module_parent-container__1TzOb","cross-banner-top":"WhitelabelHeader-module_cross-banner-top__3aoPk","cross-banner-center":"WhitelabelHeader-module_cross-banner-center__11gVw","cross-banner-bottom":"WhitelabelHeader-module_cross-banner-bottom__2iz8e","top-header":"WhitelabelHeader-module_top-header__VXIgl","cross-banner":"WhitelabelHeader-module_cross-banner__2ong-","bottom-header":"WhitelabelHeader-module_bottom-header__sE-Na","hide-component":"WhitelabelHeader-module_hide-component__16nt3"};

function loadDigitalDataManager(args) {
  if (!args.isDDMInitializationEnabled) {
    return;
  }
  var env = getEnvironment();
  var digitalDataUrl = DIGITALDATA_CMS_URL[env];
  var script = createScriptTag({
    id: 'digital-data-manager-cc-script',
    src: digitalDataUrl,
    onLoad: function onLoad() {
      if (args.enableAnalyticsInfoCall) {
        loadAnalytics(args.parentRouter);
        if (typeof args.setAnalyticsInfo === 'function') {
          args.setAnalyticsInfo(true);
        }
      }
    }
  });
  appendNodeToHead(script);
  return script;
}

function loadVwoScript(args) {
  if (!args.isVwoEnabled) {
    return;
  }
  var bu = getBusinessUnit(args.isSodimacStandAloneSite, args.isTottusStandAloneSite);
  var scriptUrl = _.get(SCRIPT_URL, "".concat(bu, ".").concat(args.tenant), SCRIPT_URL.falabella[args.tenant]);
  if (!scriptUrl) {
    return;
  }
  var link = createLinkTag({
    linkOptions: {
      href: 'https://dev.visualwebsiteoptimizer.com',
      rel: 'preconnect'
    }
  });
  var script = createScriptTag({
    id: 'vwo',
    src: scriptUrl,
    async: true
  });
  appendNodeToHead(link);
  appendNodeToHead(script);
}

var SCRIPT_URL$1 = {
  dev: '',
  staging: 'https://assets-staging.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltb129496042c1a0f9/fingerprint-tracking.iife.js',
  beta: 'https://assets-uat.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt595922f660aed8d3/fingerprint-tracking.iife.js',
  production: 'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt810d8b9cff827359/fingerprint-tracking.iife.js'
};
function loadFingerprintTracking(args) {
  if (!args.isFingerprintTrackingEnabled) {
    return;
  }
  var env = getEnvironment();
  var fingerprintTrackingUrl = SCRIPT_URL$1[env];
  if (!fingerprintTrackingUrl) {
    return;
  }
  var script = createScriptTag({
    id: 'fp-t',
    src: fingerprintTrackingUrl,
    onLoad: function onLoad() {
      var initialize = get(window, 'fingerprintTracking.methods.init', noop);
      initialize();
    },
    onError: function onError() {
      var EventContextIDError = new CustomEvent('CONTEXTIDHASERROR');
      window.dispatchEvent(EventContextIDError);
      console.error('Failed loading fingerprintTracking script:');
    }
  });
  appendNodeToHead(script);
  return script;
}

var loadGoogleTagManager = function loadGoogleTagManager(args) {
  if (!args.isGoogleTagManagerEnabled) {
    return;
  }
  var env = getEnvironment();
  var country = getCountry();
  var businessUnit = 'FALABELLA';
  if (args.isSodimacStandAloneSite) {
    businessUnit = 'SODIMAC';
  } else if (args.isTottusStandAloneSite) {
    businessUnit = 'TOTTUS';
  } else if (args.isWhitelabelSite) {
    businessUnit = 'WHITELABEL';
  }
  var gtmID = gtmInfo[businessUnit][country][env];
  if (!gtmID) {
    console.error('GTM ID not found for the given BU, country, and environment.');
    return;
  }
  var scriptGTM = createScriptTag({
    async: true,
    src: "https://www.googletagmanager.com/gtm.js?id=".concat(gtmID),
    id: 'googletagmanager-script'
  });
  appendNodeToHead(scriptGTM);
  var scriptContent = "\n    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n    })(window,document,'script','dataLayer','".concat(gtmID, "');\n  ");
  var scriptTag = createScriptTag({
    id: 'gtm-script'
  });
  scriptTag.innerHTML = scriptContent;
  appendNodeToHead(scriptTag);
  var noscript = document.createElement('noscript');
  noscript.innerHTML = "<iframe src=\"https://www.googletagmanager.com/ns.html?id=".concat(gtmID, "\"\n  height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>");
  document.body.appendChild(noscript);
};

var loadMedallia = function loadMedallia(args) {
  if (!args.isTottusStandAloneSite) {
    return;
  }
  var country = getCountry();
  var businessUnit = args.isTottusStandAloneSite ? 'tottus' : 'falabella';
  var medalliaURL = analyticsInfo.medallia[businessUnit][country];
  if (!medalliaURL) {
    console.error('Madallia not found for the given BU and country.');
    return;
  }
  var scriptMedallia = createScriptTag({
    async: true,
    src: "".concat(medalliaURL)
  });
  appendNodeToHead(scriptMedallia);
};

var HEX_COLORS = {
  '#343E49': '#343E49'
};
var cssVariables = {
  hexColors: HEX_COLORS,
  so_com: {
    'search-bar-border-radius': '4px',
    'search-bar-button-icon-border-radius': '0px',
    'category-button-wrapper-border-radius': '4px'
  },
  to_com: {
    'search-bar-border-radius': '80px',
    'search-bar-button-icon-border-radius': '80px',
    'category-button-wrapper-border-radius': '80px'
  }
};

var useHeader = function useHeader(_ref) {
  var styles = _ref.styles,
    tenant = _ref.tenant,
    baseUrl = _ref.baseUrl,
    store = _ref.store,
    data = _ref.data,
    isWebPushNotificationEnabled = _ref.isWebPushNotificationEnabled,
    setPushNotificationData = _ref.setPushNotificationData,
    currentStepValue = _ref.currentStepValue,
    attachResizeListener = _ref.attachResizeListener,
    deviceType = _ref.deviceType,
    currentLocation = _ref.currentLocation;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOnboardingDisabledCookie = _useState2[0],
    setIsOnboardingDisabledCookie = _useState2[1];
  var _useState3 = useState(get(data, 'header', false)),
    _useState4 = _slicedToArray(_useState3, 2),
    header = _useState4[0],
    setHeader = _useState4[1];
  var _useState5 = useState(get(data, 'taxonomy', false)),
    _useState6 = _slicedToArray(_useState5, 2),
    taxonomyData = _useState6[0],
    setTaxonomyData = _useState6[1];
  var _useState7 = useState(get(data, 'sisNavigationMenu', null)),
    _useState8 = _slicedToArray(_useState7, 2),
    sisNavigationMenu = _useState8[0],
    setSisNavigationMenu = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isIE = _useState10[0],
    setIsIe = _useState10[1];
  var _useState11 = useState(currentLocation),
    _useState12 = _slicedToArray(_useState11, 2),
    location = _useState12[0],
    setLocation = _useState12[1];
  var _useState13 = useState(currentStepValue),
    _useState14 = _slicedToArray(_useState13, 2),
    currentStep = _useState14[0],
    setCurrentStep = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isMobileApp = _useState16[0],
    setMobileApp = _useState16[1];
  var _useState17 = useState(store),
    _useState18 = _slicedToArray(_useState17, 2),
    site = _useState18[0],
    setSite = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    isVendorLoggedIn = _useState20[0],
    setIsVendorLoggedIn = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isAgentLoggedIn = _useState22[0],
    setIsAgentLoggedIn = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    areCookiesPresent = _useState24[0],
    setAreCookiesPresent = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    isCatalyst = _useState26[0],
    setCatalyst = _useState26[1];
  var _useState27 = useState(''),
    _useState28 = _slicedToArray(_useState27, 2),
    userInformation = _useState28[0],
    setUserInformation = _useState28[1];
  var _useState29 = useState(''),
    _useState30 = _slicedToArray(_useState29, 2),
    agentCookieData = _useState30[0],
    setAgentCookieData = _useState30[1];
  var _useState31 = useState({
      enabled: false,
      cartId: '',
      siteName: '',
      ecommName: '',
      defaultColor: '',
      multiSite: false
    }),
    _useState32 = _slicedToArray(_useState31, 2),
    whiteLabelProp = _useState32[0],
    setWhiteLabelProp = _useState32[1];
  var constants = configs.constants;
  var getCookie = CookieStorage.getCookie,
    unescapeATGCookies = CookieStorage.unescapeATGCookies;
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isSodimacStandalone = _getStandaloneSite.isSodimacStandalone,
    isTottusStandalone = _getStandaloneSite.isTottusStandalone;
  var isMarketplace = !store;
  var isSis = store && !isStandaloneSite;
  var isStickyEnabled = {
    desktop: get(header, 'entry.is_sticky_desktop', false),
    mobile: get(header, 'entry.is_sticky_mobile', false),
    tablet: get(header, 'entry.is_sticky_mobile', false)
  };
  var setOnboardingCookie = function setOnboardingCookie() {
    var onboardingCookie = CookieStorage.getCookie(constants.ON_BOARDING_COOKIE) === 'done';
    setIsOnboardingDisabledCookie(onboardingCookie);
  };
  var fetchWhitelabelContentData = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
      var noHeaderData, noMenuData, _yield$Promise$all, _yield$Promise$all2, headerRes, sisMenuRes, sisMenu, _headerRes;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            noHeaderData = !(data !== null && data !== void 0 && data.header) || isEmpty(data.header.entry);
            noMenuData = !(data !== null && data !== void 0 && data.sisNavigationMenu) || isEmpty(data.sisNavigationMenu);
            if (!(!data || noHeaderData && noMenuData)) {
              _context.next = 19;
              break;
            }
            _context.prev = 3;
            _context.next = 6;
            return Promise.all([getHeaderData({
              tenant: tenant,
              baseUrl: baseUrl,
              store: store
            }), getSisNavigationMenu({
              tenant: tenant,
              baseUrl: baseUrl,
              store: store
            })]);
          case 6:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            headerRes = _yield$Promise$all2[0];
            sisMenuRes = _yield$Promise$all2[1];
            setHeader(headerRes);
            setSisNavigationMenu(sisMenuRes);
            _context.next = 17;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](3);
            console.log('get whitelabel content error', _context.t0);
          case 17:
            _context.next = 43;
            break;
          case 19:
            if (!noMenuData) {
              _context.next = 32;
              break;
            }
            _context.prev = 20;
            _context.next = 23;
            return getSisNavigationMenu({
              tenant: tenant,
              baseUrl: baseUrl,
              store: store
            });
          case 23:
            sisMenu = _context.sent;
            setSisNavigationMenu(sisMenu);
            _context.next = 30;
            break;
          case 27:
            _context.prev = 27;
            _context.t1 = _context["catch"](20);
            console.log('getSisNavigationMenu error', _context.t1);
          case 30:
            _context.next = 43;
            break;
          case 32:
            if (!noHeaderData) {
              _context.next = 43;
              break;
            }
            _context.prev = 33;
            _context.next = 36;
            return getHeaderData({
              tenant: tenant,
              baseUrl: baseUrl,
              store: store
            });
          case 36:
            _headerRes = _context.sent;
            setHeader(_headerRes);
            _context.next = 43;
            break;
          case 40:
            _context.prev = 40;
            _context.t2 = _context["catch"](33);
            console.log('getHeaderData error', _context.t2);
          case 43:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 14], [20, 27], [33, 40]]);
    }));
    return function fetchWhitelabelContentData() {
      return _ref2.apply(this, arguments);
    };
  }();
  var fetchData = function () {
    var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2() {
      var headerDataRequest, taxonomyDataRequest, sisDataRequest, sisMenu;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (data) {
              _context2.next = 8;
              break;
            }
            headerDataRequest = getHeaderData({
              tenant: tenant,
              baseUrl: baseUrl,
              store: store
            });
            taxonomyDataRequest = Promise.resolve(null);
            if (!getStandaloneSite(store).isStandaloneSite) {
              taxonomyDataRequest = getTaxonomyData({
                tenant: tenant,
                baseUrl: baseUrl
              });
            }
            sisDataRequest = getSisNavigationMenu({
              tenant: tenant,
              baseUrl: baseUrl,
              store: store
            });
            Promise.all([headerDataRequest, taxonomyDataRequest, sisDataRequest]).then(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 3),
                headerRes = _ref5[0],
                taxonomyRes = _ref5[1],
                sisMenuRes = _ref5[2];
              setHeader(headerRes);
              setTaxonomyData(taxonomyRes);
              setSisNavigationMenu(sisMenuRes);
            }).catch(function (e) {
              console.log('getHeader error', e);
            });
            _context2.next = 13;
            break;
          case 8:
            if (!(data && !data.sisNavigationMenu)) {
              _context2.next = 13;
              break;
            }
            _context2.next = 11;
            return getSisNavigationMenu({
              tenant: tenant,
              baseUrl: baseUrl,
              store: store
            });
          case 11:
            sisMenu = _context2.sent;
            setSisNavigationMenu(sisMenu);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function fetchData() {
      return _ref3.apply(this, arguments);
    };
  }();
  var setCurrentLocation = function setCurrentLocation() {
    if (!location) {
      setLocation(getCurrentLocation());
    }
  };
  var setIEUserAgent = function setIEUserAgent() {
    var ieRegex = new RegExp(/MSIE|Trident.*rv/i);
    setIsIe(ieRegex.test(window.navigator.userAgent));
  };
  var getExternalDependencies = function getExternalDependencies() {
    loadExternalDependencies({
      tenant: tenant,
      environment: getEnvironment(),
      isMarketplace: true,
      toggles: {
        isWebPushNotificationEnabled: isWebPushNotificationEnabled
      },
      functions: {
        setPushNotificationData: setPushNotificationData
      },
      configs: {
        webPushNotificationConfigs: get(header, 'entry.header_configs[0].property_configs.web_push_notifications', {})
      }
    });
  };
  var setSticky = function setSticky() {
    if (isStickyEnabled[deviceType]) {
      var currScroll = 0;
      var prevScroll = 0;
      var currDirection = 0;
      var prevDirection = 0;
      var threshold = deviceType === 'desktop' ? 2000 : 1000;
      var toggled = false;
      var checkScroll = function checkScroll(e) {
        var headerElement = document.getElementById('scrollable-content');
        var bottomHeaderElement = document.getElementById('bottom-header');
        if (!headerElement || !bottomHeaderElement) {
          return;
        }
        currScroll = window.scrollY || document.documentElement.scrollTop;
        if (currScroll > prevScroll) {
          currDirection = 2;
        } else {
          currDirection = 1;
          if (currScroll <= 10) {
            if (isVendorLoggedIn || isAgentLoggedIn || areCookiesPresent) {
              headerElement.classList.add("".concat(styles['header-scroll-styles2']));
            }
            headerElement.classList.remove("".concat(styles['header-scroll-styles']));
            bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
          }
          if (prevScroll < 5 && currScroll < prevScroll) {
            headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
            headerElement.classList.remove("".concat(styles['header-scroll-styles']));
            bottomHeaderElement.classList.remove("".concat(styles['bottom-header']));
          }
          if (prevScroll - currScroll >= 5) {
            headerElement.classList.remove("".concat(styles['header-scroll-styles2']));
          }
        }
        if (currDirection !== prevDirection) {
          toggled = toggleHeader(currDirection, currScroll, threshold, styles);
        }
        if (toggled) {
          prevDirection = currDirection;
        }
        prevScroll = currScroll;
      };
      window.onscroll = checkScroll;
    }
  };
  var setCookies = function setCookies() {
    var params = new URLSearchParams(window.location.search);
    var storeIdQuery = params.get('storeId');
    var moduleQuery = params.get('modulo');
    var storeCookie = CookieStorage.getKioskoStoreCookieName();
    var moduleCookie = CookieStorage.getKioskoModuleCookieName();
    var storeId = getCookie(storeCookie);
    var module = getCookie(moduleCookie);
    if (storeIdQuery && storeId !== storeIdQuery) {
      CookieStorage.setCookie({
        name: storeCookie,
        value: storeIdQuery,
        regionCode: tenant
      });
      storeId = storeIdQuery;
    }
    if (moduleQuery && module !== moduleQuery) {
      CookieStorage.setCookie({
        name: moduleCookie,
        value: moduleQuery,
        regionCode: tenant
      });
      module = moduleQuery;
    }
    var vendorDataCookie = unescapeATGCookies(getCookie(CookieStorage.getVendorDataCookie()));
    var agentDataCookie = unescapeATGCookies(getCookie(CookieStorage.getAgentDataCookie()));
    var userCookie = CookieStorage.getUserDataCookieName();
    var userInformationCookie = unescapeATGCookies(getCookie(userCookie));
    if (vendorDataCookie) {
      setIsVendorLoggedIn(true);
    }
    if (storeId && module) {
      setAreCookiesPresent(true);
    }
    if (agentDataCookie) {
      setIsAgentLoggedIn(true);
      setAgentCookieData(agentDataCookie);
    }
    if (userInformationCookie) {
      setUserInformation(userInformationCookie);
    }
    setCatalyst(CookieStorage.isCatalyst());
  };
  useEffect(function () {
    var initData = function () {
      var _ref6 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              setOnboardingCookie();
              if (!isWhitelabel(store)) {
                _context3.next = 6;
                break;
              }
              _context3.next = 4;
              return fetchWhitelabelContentData();
            case 4:
              _context3.next = 8;
              break;
            case 6:
              _context3.next = 8;
              return fetchData();
            case 8:
              setCurrentLocation();
              attachResizeListener();
              getExternalDependencies();
              setIEUserAgent();
              setSite(siteValue(store));
              setCookies();
              setWhiteLabelProp(generateWhiteLabelProps(store, tenant));
              if (checkMobileApp()) {
                setMobileApp(true);
              }
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function initData() {
        return _ref6.apply(this, arguments);
      };
    }();
    initData();
  }, []);
  useEffect(function () {
    var initData = function initData() {
      setOnboardingCookie();
      setSticky();
      if (currentLocation) {
        setLocation(currentLocation);
      }
    };
    initData();
  }, [currentStep, header, currentLocation]);
  return {
    isIE: isIE,
    location: location,
    isOnboardingDisabledCookie: isOnboardingDisabledCookie,
    header: header,
    currentStep: currentStep,
    setCurrentStep: setCurrentStep,
    taxonomyData: taxonomyData,
    sisNavigationMenu: sisNavigationMenu,
    setTaxonomyData: setTaxonomyData,
    setSisNavigationMenu: setSisNavigationMenu,
    isMobileApp: isMobileApp,
    site: site,
    isVendorLoggedIn: isVendorLoggedIn,
    setIsVendorLoggedIn: setIsVendorLoggedIn,
    isAgentLoggedIn: isAgentLoggedIn,
    setIsAgentLoggedIn: setIsAgentLoggedIn,
    currentLocation: currentLocation,
    isCatalyst: isCatalyst,
    userInformation: userInformation,
    agentCookieData: agentCookieData,
    areCookiesPresent: areCookiesPresent,
    whiteLabelProp: whiteLabelProp,
    isMarketplace: isMarketplace,
    isSis: isSis,
    isStandaloneSite: isStandaloneSite,
    isSodimacStandalone: isSodimacStandalone,
    isTottusStandalone: isTottusStandalone
  };
};

var BRAND_CONFIG$1 = {
  so_com: {
    brand_color: '#0072CE',
    primary_color: '#ffffff',
    scrollable_header_background_color: '#ffffff',
    bottom_header_background_color: '#ffffff',
    brand_logo: 'https://images.contentstack.io/v3/assets/blt6a203fe6c6a9b6dd/blt998f8642701056cb/664bb38e941bc88cfc9df692/logo-sodimac-header.svg',
    url: '#'
  },
  to_com: {
    brand_color: '#0072CE',
    primary_color: '#F1F1F1',
    scrollable_header_background_color: '#F1F1F1',
    bottom_header_background_color: '#F1F1F1',
    brand_logo: 'https://images.contentstack.io/v3/assets/blt72431f7a08fe765a/bltff6f6b29157f3e3c/66bf709c77be39465aea7982/tottus-standalone-logo.svg',
    url: '#'
  }
};

var OnboardingWithoutSSR$1 = SkipSSR(Onboarding);
var Header$1 = function Header(_ref) {
  var styles = _ref.styles,
    atgBaseUrl = _ref.atgBaseUrl,
    attachResizeListener = _ref.attachResizeListener,
    catalystBaseUrl = _ref.catalystBaseUrl,
    currentLocation = _ref.currentLocation,
    currentSearchTerm = _ref.currentSearchTerm,
    data = _ref.data,
    deviceType = _ref.deviceType,
    enableAnalyticsInfoCall = _ref.enableAnalyticsInfoCall,
    forceATG = _ref.forceATG,
    getTypeaheadUrl = _ref.getTypeaheadUrl,
    handleRouteChange = _ref.handleRouteChange,
    handleSoftRefresh = _ref.handleSoftRefresh,
    isATGLoginEnabled = _ref.isATGLoginEnabled,
    isDefaultComuna = _ref.isDefaultComuna,
    isGeoLocationEnabled = _ref.isGeoLocationEnabled,
    isPopOverVisible = _ref.isPopOverVisible,
    isTypeAheadEnabled = _ref.isTypeAheadEnabled,
    isZoneModalEnabled = _ref.isZoneModalEnabled,
    isWebPushNotificationEnabled = _ref.isWebPushNotificationEnabled,
    isSisSodimacPdpEnabled = _ref.isSisSodimacPdpEnabled,
    onUserLogin = _ref.onUserLogin,
    onUserLoginComplete = _ref.onUserLoginComplete,
    onUserLoginConsentsUpdate = _ref.onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate = _ref.onUserLoginPasswordUpdate,
    onUserLogout = _ref.onUserLogout,
    selectedZone = _ref.selectedZone,
    setBusy = _ref.setBusy,
    store = _ref.store,
    unifiedLoginBaseUrl = _ref.unifiedLoginBaseUrl,
    userCartCount = _ref.userCartCount,
    transversalBannerConfig = _ref.transversalBannerConfig,
    locationPathname = _ref.locationPathname,
    MobileAppWebView = _ref.MobileAppWebView;
  var _useContext = useContext(AppContext),
    tenant = _useContext.tenant,
    baseUrl = _useContext.baseUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSearchBar = _useState2[0],
    setShowSearchBar = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMenuVisible = _useState6[0],
    setMenuVisible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    modalVisible = _useState8[0],
    setModalVisible = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isSearchBarTouched = _useState10[0],
    setIsSearchBarTouched = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    zoneModalVisible = _useState12[0],
    setZoneModalVisible = _useState12[1];
  var _useState13 = useState(undefined),
    _useState14 = _slicedToArray(_useState13, 2),
    searchInputRef = _useState14[0],
    setSearchInputRef = _useState14[1];
  var _useState15 = useState({
      isVisible: false
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    pushNotificationData = _useState16[0],
    setPushNotificationData = _useState16[1];
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    searchInSis = _useState18[0],
    setSearchInSis = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    hideMenuBar = _useState20[0],
    setHideMenuBar = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    mobileModalClass = _useState22[0],
    setMobileModalClass = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    showLoginForm = _useState24[0],
    setShowLoginForm = _useState24[1];
  var labels = configs.labels,
    constants = configs.constants;
  var currentStepValue = 0;
  var isSvsSearch = getParameterByName('f.svs') === 'true';
  var emptySearchErrorTitle = labels.EMPTY_SEARCH_ERROR_TITLE;
  var emptySearchErrorMessage = labels.EMPTY_SEARCH_ERROR_MESSAGE;
  var incorrectSearchErrorTitle = labels.INCORRECT_SEARCH_ERROR_TITLE;
  var incorrectSearchErrorMessage = labels.INCORRECT_SEARCH_ERROR_MESSAGE;
  var _useHeader = useHeader({
      styles: styles,
      tenant: tenant,
      baseUrl: baseUrl,
      store: store,
      data: data,
      isWebPushNotificationEnabled: isWebPushNotificationEnabled,
      setPushNotificationData: setPushNotificationData,
      currentStepValue: currentStepValue,
      attachResizeListener: attachResizeListener,
      deviceType: deviceType,
      currentLocation: currentLocation
    }),
    isIE = _useHeader.isIE,
    location = _useHeader.location,
    isOnboardingDisabledCookie = _useHeader.isOnboardingDisabledCookie,
    header = _useHeader.header,
    currentStep = _useHeader.currentStep,
    setCurrentStep = _useHeader.setCurrentStep,
    taxonomyData = _useHeader.taxonomyData,
    sisNavigationMenu = _useHeader.sisNavigationMenu,
    isMobileApp = _useHeader.isMobileApp,
    site = _useHeader.site,
    isVendorLoggedIn = _useHeader.isVendorLoggedIn,
    setIsVendorLoggedIn = _useHeader.setIsVendorLoggedIn,
    isAgentLoggedIn = _useHeader.isAgentLoggedIn,
    setIsAgentLoggedIn = _useHeader.setIsAgentLoggedIn,
    isCatalyst = _useHeader.isCatalyst,
    userInformation = _useHeader.userInformation,
    agentCookieData = _useHeader.agentCookieData,
    areCookiesPresent = _useHeader.areCookiesPresent,
    whiteLabelProp = _useHeader.whiteLabelProp,
    isMarketplace = _useHeader.isMarketplace,
    isStandaloneSite = _useHeader.isStandaloneSite,
    isSodimacStandalone = _useHeader.isSodimacStandalone,
    isTottusStandalone = _useHeader.isTottusStandalone;
  var isOnboardingEnabled = get(header, 'entry.header_configs[0].toggles.isonboardingenabled', false);
  var isProgramaticallyGeofinderEnabled = get(header, 'entry.header_configs[0].toggles.isprogramaticallygeofinderenabled', false);
  var geofinderConfigs = get(header, 'entry.header_configs[0].property_configs.geofinder', {});
  var isRecentSearchesEnabled = get(header, 'entry.header_configs[0].toggles.isrecentsearchesenabled', false);
  var isSearchSpecialCharactersEnabled = get(header, 'entry.header_configs[0].toggles.is_search_special_characters_enabled', false);
  var searchbar = get(header, 'entry.searchbar', {});
  var mainLogoIcon = get(header, "entry.logo.".concat(deviceType, "_icon.url"), BRAND_CONFIG$1[site].brand_logo);
  var mainLogoURL = get(header, 'entry.logo.url', "".concat(HOME_URL["".concat(tenant, "__").concat(site)]));
  var logoURL = isMarketplace || isStandaloneSite ? mainLogoURL : get(header, "entry.themes.".concat(site, ".url"), BRAND_CONFIG$1[site].url);
  var primaryThemeColor = get(header, "entry.themes.".concat(site, ".color"), BRAND_CONFIG$1[site].brand_color);
  var secondaryThemeColor = get(header, "entry.themes.".concat(site, ".secondary_color"), '#495867');
  var primaryColor = get(header, "entry.themes.".concat(site, ".color"), BRAND_CONFIG$1[site].brand_color);
  var secondaryColor = get(header, "entry.themes.".concat(site, ".secondary_color"), cssVariables.hexColors['#343E49']);
  var closeNotification = function closeNotification() {
    setPushNotificationData({
      isVisible: false
    });
  };
  var onSearchTermChange = function onSearchTermChange(searchTerm) {
    if (searchTerm.length === 0) {
      setErrorMessage({
        title: emptySearchErrorTitle,
        msg: emptySearchErrorMessage
      });
      return false;
    }
    if (searchTerm.length < constants.MIN_SEARCH_TERM_LENGTH) {
      setErrorMessage({
        title: incorrectSearchErrorTitle,
        msg: incorrectSearchErrorMessage
      });
      return false;
    }
    var termo = encodeURIComponent(searchTerm).replace(/%20/g, '+');
    window.dispatchEvent(new CustomEvent('DDM_onSearching', {
      bubbles: true,
      detail: {
        value: termo,
        prefix: 'BCR'
      }
    }));
    if (handleRouteChange) {
      handleRouteChange(termo, store && searchInSis);
    } else {
      var envBaseUrl = getStandaloneSiteBaseUrl(tenant, store);
      var storeName = STORE_MAP[tenant][store];
      var searchPath = SEARCH_PATH[store];
      window.location.href = "".concat(envBaseUrl, "/").concat(storeName, "-").concat(tenant, "/").concat(searchPath, "?Ntt=").concat(termo);
    }
    setErrorMessage(undefined);
    return true;
  };
  var onSearchDomainChange = function onSearchDomainChange() {
    setSearchInSis(!searchInSis);
  };
  var toggleModal = function toggleModal(visibility) {
    if (deviceType !== 'desktop') {
      if (!visibility) {
        setMobileModalClass('floatBottomEndTransition');
        var animationTimer = setTimeout(function () {
          setModalVisible(visibility);
          clearTimeout(animationTimer);
        }, 350);
      } else {
        setMobileModalClass('floatBottomTransition');
        setModalVisible(visibility);
      }
    } else {
      setModalVisible(visibility);
    }
  };
  var handleUserLogout = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
      var userCookie;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            userCookie = CookieStorage.getUserDataCookieName();
            CookieStorage.removeCookie({
              name: userCookie
            });
            _context.next = 4;
            return onUserLogout();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleUserLogout() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleUserLogin = function () {
    var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(userData) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return onUserLogin(userData);
          case 2:
            if (enableAnalyticsInfoCall) {
              initDigitalData();
            }
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleUserLogin(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  if (!header) {
    return jsx(React.Fragment, null);
  }
  var isVendorOrAgentLoggedIn = isVendorLoggedIn || isAgentLoggedIn || areCookiesPresent;
  return jsx(React.Fragment, null, jsx("header", {
    className: classNames(_defineProperty(_defineProperty({}, styles['no-border'], isVendorOrAgentLoggedIn), styles['hide-component'], MobileAppWebView))
  }, errorMessage && jsx(ErrorDialog, {
    title: errorMessage.title,
    message: errorMessage.msg,
    onClose: function onClose() {
      setErrorMessage(undefined);
    }
  }), isAgentLoggedIn && jsx(AgentHeader, {
    agentCookie: agentCookieData,
    userName: userInformation.split('*')[0],
    agentBaseUrl: baseUrl,
    atgBaseUrl: atgBaseUrl,
    catalystBaseUrl: catalystBaseUrl,
    onUserLogout: handleUserLogout,
    isCatalyst: CookieStorage.isCatalyst(),
    tenant: tenant,
    setIsAgentLoggedIn: setIsAgentLoggedIn,
    forceATG: forceATG,
    store: store
  }), (isVendorLoggedIn || areCookiesPresent) && jsx(VendorHeader, {
    isCatalyst: CookieStorage.isCatalyst(),
    tenant: tenant,
    setIsVendorLoggedIn: setIsVendorLoggedIn,
    vendorBaseUrl: baseUrl,
    isVendorLoggedIn: isVendorLoggedIn,
    atgBaseUrl: atgBaseUrl,
    catalystBaseUrl: catalystBaseUrl,
    onUserLogout: handleUserLogout,
    forceATG: forceATG,
    store: store,
    whitelabel: whiteLabelProp
  }), isOnboardingEnabled && !isMobileApp && jsx(OnboardingWithoutSSR$1, {
    deviceType: deviceType,
    currentStep: currentStep,
    setCurrentStep: setCurrentStep,
    onboardingData: get(header, 'entry.onboarding', null),
    tenant: tenant
  }), jsx("div", {
    id: "scrollable-content",
    style: {
      background: site && get(header, "entry.themes.".concat(site, ".scrollable_header_background_color"), BRAND_CONFIG$1[site].scrollable_header_background_color)
    },
    "data-testid": "header-util-bar",
    className: classNames("".concat(styles['header-util-bar']))
  }, jsx("div", {
    className: classNames(styles.container, styles['header-container'], _defineProperty(_defineProperty({}, styles['header-container--so_com'], isSodimacStandalone), styles['header-container--to_com'], isTottusStandalone))
  }, !site && jsx(React.Fragment, null, jsx(MatchMedia$1, {
    key: "testId-taxonomy-mobile",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      },
      mobile: function mobile() {
        return jsx(Taxonomy$1, {
          headerData: header,
          data: taxonomyData,
          currentLocation: location,
          isInternetExplorer: isIE,
          isMenuVisible: isMenuVisible,
          setMenuVisible: setMenuVisible,
          isGeoLocationEnabled: isGeoLocationEnabled,
          deviceType: deviceType,
          hideMenuBar: hideMenuBar,
          isCatalyst: isCatalyst,
          isAgentLoggedIn: isAgentLoggedIn,
          isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent
        });
      }
    }
  }), jsx(MatchMedia$1, {
    key: "testId-taxonomy-tablet",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(React.Fragment, null);
      },
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(Taxonomy$1, {
          headerData: header,
          data: taxonomyData,
          currentLocation: location,
          isInternetExplorer: isIE,
          isMenuVisible: isMenuVisible,
          setMenuVisible: setMenuVisible,
          isGeoLocationEnabled: isGeoLocationEnabled,
          deviceType: deviceType,
          hideMenuBar: hideMenuBar,
          isCatalyst: isCatalyst,
          isAgentLoggedIn: isAgentLoggedIn,
          isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent
        });
      }
    }
  })), jsx(MatchMedia$1, {
    key: "testId-logo-link",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(Logo, {
          path: logoURL,
          logoIcon: mainLogoIcon,
          store: site
        });
      },
      mobile: function mobile() {
        return jsx(Logo, {
          path: logoURL,
          logoIcon: mainLogoIcon,
          isMobile: true,
          store: site
        });
      },
      tablet: function tablet() {
        return jsx(Logo, {
          path: logoURL,
          logoIcon: mainLogoIcon,
          isMobile: true,
          store: site
        });
      }
    }
  }), jsx(MatchMedia$1, {
    key: "testId-store-menu",
    deviceType: deviceType,
    content: {
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      },
      desktop: function desktop() {
        return jsx(SiSNavigationMenu, {
          isVendorOrAgentLoggedIn: isVendorOrAgentLoggedIn,
          brandLogo: get(sisNavigationMenu, 'entry.brand_logo', {}),
          categories: get(sisNavigationMenu, 'entry.categories', []),
          browseMainText: get(sisNavigationMenu, 'entry.browse_main_text', ''),
          colorLine: get(sisNavigationMenu, 'entry.color_line', ''),
          categoryColor: get(sisNavigationMenu, 'entry.category_color', ''),
          hightlightColor: get(sisNavigationMenu, 'entry.hightlight_color', ''),
          hightlightTextColor: get(sisNavigationMenu, 'entry.hightlight_text_color', ''),
          dataWrapper: get(sisNavigationMenu, 'entry.data_wrapper', ''),
          store: site,
          isSISLevel2Header: false
        });
      }
    }
  }), !site && jsx(MatchMedia$1, {
    key: "testId-taxonomy-desktop",
    deviceType: deviceType,
    content: {
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      },
      desktop: function desktop() {
        return jsx(Taxonomy$1, {
          currentLocation: location,
          data: taxonomyData,
          deviceType: deviceType,
          headerData: header,
          hideMenuBar: hideMenuBar,
          isAgentLoggedIn: isAgentLoggedIn,
          isCatalyst: isCatalyst,
          isGeoLocationEnabled: isGeoLocationEnabled,
          isInternetExplorer: isIE,
          isMenuVisible: isMenuVisible,
          isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
          setMenuVisible: setMenuVisible
        });
      }
    }
  }), jsx(MatchMedia$1, {
    key: "search-bar-desktop",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(Search, {
          deviceType: deviceType,
          getTypeaheadUrl: getTypeaheadUrl,
          isAndes: isZoneModalEnabled,
          searchInSis: searchInSis,
          isSvsSearch: isSvsSearch,
          isTypeAheadEnabled: isTypeAheadEnabled,
          isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
          onLoadingStateChange: setBusy,
          onSearch: onSearchTermChange,
          searchbar: searchbar,
          setHideMenuBar: setHideMenuBar,
          setSearchInputRef: setSearchInputRef,
          isSearchBarTouched: isSearchBarTouched,
          setIsSearchBarTouched: setIsSearchBarTouched,
          showSearchBar: showSearchBar,
          currentSearchTerm: currentSearchTerm || getParameterByName('Ntt'),
          store: site,
          onSearchDomainChange: onSearchDomainChange,
          isRecentSearchesEnabled: isRecentSearchesEnabled,
          isSearchSpecialCharactersEnabled: isSearchSpecialCharactersEnabled
        });
      },
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      }
    }
  }), jsx(UserActions$1, {
    showSearchBar: showSearchBar,
    setShowSearchBar: setShowSearchBar,
    isATGLoginEnabled: isATGLoginEnabled,
    isInternetExplorer: isIE,
    showLoginForm: showLoginForm,
    setShowLoginForm: setShowLoginForm,
    atgBaseUrl: atgBaseUrl,
    modalVisible: modalVisible,
    mobileModalClass: mobileModalClass,
    toggleModal: toggleModal,
    catalystBaseUrl: catalystBaseUrl,
    onLoadingStateChange: setBusy,
    onUserLogout: handleUserLogout,
    deviceType: deviceType,
    headerData: header,
    onUserLogin: handleUserLogin,
    onUserLoginComplete: onUserLoginComplete,
    onUserLoginConsentsUpdate: onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate: onUserLoginPasswordUpdate,
    unifiedLoginBaseUrl: unifiedLoginBaseUrl,
    userCartCount: userCartCount,
    isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 1,
    setHideMenuBar: setHideMenuBar,
    setMenuVisible: setMenuVisible,
    forceATG: forceATG,
    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
    isAgentLoggedIn: isAgentLoggedIn,
    isStore: true,
    isOrangeOrSISHeader: true,
    isSISLevel2Header: false,
    store: store
  })), deviceType !== 'desktop' && jsx("div", {
    className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles.mobile_middle_wrapper, site), styles['mobile_middle_wrapper--so_com'], isSodimacStandalone), styles['mobile_middle_wrapper--to_com'], isTottusStandalone))
  }, jsx(SiSNavigationMenu, {
    brandLogo: get(sisNavigationMenu, 'entry.brand_logo', {}),
    categories: get(sisNavigationMenu, 'entry.categories', []),
    browseMainText: get(sisNavigationMenu, 'entry.browse_main_text', ''),
    colorLine: get(sisNavigationMenu, 'entry.color_line', ''),
    categoryColor: get(sisNavigationMenu, 'entry.category_color', ''),
    hightlightColor: get(sisNavigationMenu, 'entry.hightlight_color', ''),
    hightlightTextColor: get(sisNavigationMenu, 'entry.hightlight_text_color', ''),
    dataWrapper: get(sisNavigationMenu, 'entry.data_wrapper', ''),
    store: site
  }), jsx(Search, {
    deviceType: deviceType,
    onSearch: onSearchTermChange,
    currentSearchTerm: currentSearchTerm || getParameterByName('Ntt'),
    isSvsSearch: isSvsSearch,
    isTypeAheadEnabled: isTypeAheadEnabled,
    isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
    getTypeaheadUrl: getTypeaheadUrl,
    onLoadingStateChange: setBusy,
    searchbar: searchbar,
    setHideMenuBar: setHideMenuBar,
    isAndes: isZoneModalEnabled,
    isAgentLoggedIn: isAgentLoggedIn,
    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
    setSearchInputRef: setSearchInputRef,
    isSearchBarTouched: isSearchBarTouched,
    setIsSearchBarTouched: setIsSearchBarTouched,
    store: site,
    searchInSis: searchInSis,
    onSearchDomainChange: onSearchDomainChange,
    isRecentSearchesEnabled: isRecentSearchesEnabled,
    isSearchSpecialCharactersEnabled: isSearchSpecialCharactersEnabled
  }))), jsx("div", {
    id: "bottom-header",
    style: {
      background: site && get(header, "entry.themes.".concat(site, ".bottom_header_background_color"), BRAND_CONFIG$1[site].bottom_header_background_color)
    }
  }, jsx(TransversalBanner, {
    key: "transversalBanner",
    transversalBanner: header.transversalBannerHtml,
    transversalBannerConfig: transversalBannerConfig,
    locationPathname: locationPathname
  }), jsx(TernaryNavBar$1, {
    currentStep: currentStep,
    deviceType: deviceType,
    handleRouteChange: handleSoftRefresh,
    header: header,
    isAgentLoggedIn: isAgentLoggedIn,
    baseUrl: catalystBaseUrl,
    isBrandingMarketplace: true,
    isDefaultComuna: isDefaultComuna,
    selectedZone: selectedZone,
    isPopOverVisible: isPopOverVisible,
    isOnboardingDisabledCookie: isOnboardingDisabledCookie,
    isOnboardingEnabled: isOnboardingEnabled,
    searchInSis: searchInSis,
    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
    isZoneModalEnabled: isZoneModalEnabled,
    isSearchBarTouched: isSearchBarTouched,
    modalVisible: zoneModalVisible,
    setModalVisible: setZoneModalVisible,
    tenant: tenant,
    onSearchDomainChange: onSearchDomainChange,
    storeName: !isEmpty$1(sisNavigationMenu) ? get(sisNavigationMenu, 'entry.data_wrapper', '') : '',
    isProgramaticallyGeofinderEnabled: isProgramaticallyGeofinderEnabled,
    geofinderConfigs: geofinderConfigs,
    isOrangeOrSISHeader: true,
    isSISLevel2Header: false,
    store: store,
    setShowLoginForm: setShowLoginForm
  })), modalVisible && deviceType !== 'desktop' && jsx(MarketplaceOverlay$1, {
    handlers: function handlers(e) {
      e.preventDefault();
      toggleModal(false);
      setModalVisible(false);
    }
  }), pushNotificationData.isVisible && jsx(Notification, {
    isMarketplace: true,
    requireInteraction: pushNotificationData.require_interaction,
    isVisible: pushNotificationData.isVisible,
    isWelcomeMessage: pushNotificationData.isWelcomeMessage,
    action: pushNotificationData.action,
    icon: pushNotificationData.icon,
    title: pushNotificationData.title,
    body: pushNotificationData.body,
    closeNotification: closeNotification
  })), jsx("style", null, "\n          :root {\n            --primary-color: ".concat(primaryColor, ";\n            --secondary-color: ").concat(secondaryColor, ";\n            --primary-theme-color: ").concat(primaryThemeColor, ";\n            --secondary-theme-color: ").concat(secondaryThemeColor, ";\n            --header-primary-color: ").concat(primaryColor, ";\n            --header-logo-background: linear-gradient(270.96deg, #ff6200 0%, #ff861b 95.09%);\n            --header-background: #FFF;\n            --mobile-header-background: linear-gradient(17.56deg,#ff9401 63.22%,#ff7b01 105.58%,#ff6c01 144.92%);\n            --text-color: ").concat(cssVariables.hexColors['#343E49'], ";\n            --icon-background: ").concat(cssVariables.hexColors['#343E49'], ";\n            --searchbar-box-shadow: 0px 0px 4px rgba(158, 160, 150, 0.5);\n            --cart-border-color: #ff9502;\n            --border-color: 52, 62, 73;\n            --header-zone-primary-color: ").concat(cssVariables.hexColors['#343E49'], ";\n            --sis-link-header-zone-whithe-icon: url(https://images.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt81992037b3a68062/64e8cbd72ca0795c4a0752e1/location_pin.svg) !important;\n            --search-bar-border-radius: ").concat(cssVariables[site]['search-bar-border-radius'], ";\n            --search-bar-button-icon-border-radius: ").concat(cssVariables[site]['search-bar-button-icon-border-radius'], ";\n            --category-button-wrapper-border-radius: ").concat(cssVariables[site]['category-button-wrapper-border-radius'], ";\n            --category-button-wrapper-font-size:14px;\n            --category-button-wrapper-border-color: ").concat(cssVariables.hexColors['#343E49'], ";\n            --category-button-chevron-down-color: ").concat(cssVariables.hexColors['#343E49'], ";\n          }\n        ")));
};
Header$1.propTypes = process.env.NODE_ENV !== "production" ? {
  styles: PropTypes.object.isRequired,
  atgBaseUrl: PropTypes.string.isRequired,
  attachResizeListener: PropTypes.func.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  currentLocation: PropTypes.string,
  currentSearchTerm: PropTypes.string,
  data: PropTypes.any,
  deviceType: PropTypes.string.isRequired,
  enableAnalyticsInfoCall: PropTypes.bool,
  forceATG: PropTypes.bool,
  getTypeaheadUrl: PropTypes.func,
  handleRouteChange: PropTypes.any,
  handleSoftRefresh: PropTypes.func,
  isATGLoginEnabled: PropTypes.bool,
  isDefaultComuna: PropTypes.bool,
  isGeoLocationEnabled: PropTypes.bool,
  isPopOverVisible: PropTypes.bool,
  isTypeAheadEnabled: PropTypes.bool,
  isZoneModalEnabled: PropTypes.bool,
  isWebPushNotificationEnabled: PropTypes.bool,
  isSisSodimacPdpEnabled: PropTypes.bool,
  onRouteChange: PropTypes.func,
  onUserLogin: PropTypes.func,
  onUserLoginComplete: PropTypes.func,
  onUserLoginConsentsUpdate: PropTypes.func,
  onUserLoginPasswordUpdate: PropTypes.func,
  onUserLogout: PropTypes.func,
  refreshUserData: PropTypes.func.isRequired,
  selectedZone: PropTypes.object,
  setBusy: PropTypes.func.isRequired,
  locationPathname: PropTypes.string,
  store: PropTypes.string,
  unifiedLoginBaseUrl: PropTypes.string,
  userCartCount: PropTypes.string,
  transversalBannerConfig: PropTypes.shape({
    home: PropTypes.bool,
    pdp: PropTypes.bool,
    xlp: PropTypes.bool,
    basket: PropTypes.bool
  }),
  MobileAppWebView: PropTypes.bool
} : {};
Header$1.defaultProps = {
  atgBaseUrl: '',
  catalystBaseUrl: '',
  currentLocation: '',
  currentSearchTerm: '',
  enableAnalyticsInfoCall: false,
  forceATG: false,
  handleSoftRefresh: noop$1,
  isATGLoginEnabled: false,
  isDefaultComuna: false,
  isGeoLocationEnabled: true,
  isPopOverVisible: false,
  isTypeAheadEnabled: true,
  isZoneModalEnabled: true,
  isWebPushNotificationEnabled: false,
  isSisSodimacPdpEnabled: false,
  onRouteChange: noop$1,
  onUserLogin: noop$1,
  onUserLoginComplete: noop$1,
  onUserLoginConsentsUpdate: noop$1,
  onUserLoginPasswordUpdate: noop$1,
  onUserLogout: noop$1,
  parentRouter: null,
  selectedZone: undefined,
  unifiedLoginBaseUrl: undefined,
  userCartCount: undefined,
  locationPathname: undefined,
  getTypeaheadUrl: apiConfig$1.getTypeaheadUrl,
  MobileAppWebView: false
};
var StandaloneHeader = withUser(withLoader(withDevice(Header$1)));

var styles$11 = {"cross-banner":"CrossBanner-module_cross-banner__2boPU","banner-image":"CrossBanner-module_banner-image__3mUqY"};

function CrossBanner(_ref) {
  var crossBanner = _ref.crossBanner,
    deviceType = _ref.deviceType;
  if (!(crossBanner !== null && crossBanner !== void 0 && crossBanner.isVisible)) return null;
  var url = crossBanner.url,
    openInNewTab = crossBanner.openInNewTab,
    desktopImageUrl = crossBanner.desktopImageUrl,
    mobileImageUrl = crossBanner.mobileImageUrl;
  var imageUrl = deviceType === 'desktop' ? desktopImageUrl : mobileImageUrl || desktopImageUrl;
  return jsx("div", {
    className: styles$11['cross-banner'],
    id: "cross-banner"
  }, jsx("a", {
    href: url,
    target: openInNewTab ? '_blank' : '_self',
    rel: "noopener noreferrer"
  }, jsx("img", {
    src: imageUrl,
    alt: "Cross Banner",
    className: styles$11['banner-image']
  })));
}
CrossBanner.defaultProps = {
  crossBanner: {
    isVisible: false,
    url: '',
    openInNewTab: false,
    desktopImageUrl: '',
    mobileImageUrl: ''
  },
  deviceType: 'desktop'
};
CrossBanner.propTypes = process.env.NODE_ENV !== "production" ? {
  crossBanner: PropTypes.shape({
    isVisible: PropTypes.bool,
    url: PropTypes.string,
    openInNewTab: PropTypes.bool,
    desktopImageUrl: PropTypes.string.isRequired,
    mobileImageUrl: PropTypes.string
  }).isRequired,
  deviceType: PropTypes.string.isRequired
} : {};

var OnboardingWithoutSSR$2 = SkipSSR(Onboarding);
var Header$2 = function Header(_ref) {
  var styles = _ref.styles,
    atgBaseUrl = _ref.atgBaseUrl,
    attachResizeListener = _ref.attachResizeListener,
    catalystBaseUrl = _ref.catalystBaseUrl,
    currentLocation = _ref.currentLocation,
    currentSearchTerm = _ref.currentSearchTerm,
    data = _ref.data,
    deviceType = _ref.deviceType,
    enableAnalyticsInfoCall = _ref.enableAnalyticsInfoCall,
    forceATG = _ref.forceATG,
    getTypeaheadUrl = _ref.getTypeaheadUrl,
    handleSoftRefresh = _ref.handleSoftRefresh,
    isATGLoginEnabled = _ref.isATGLoginEnabled,
    isDefaultComuna = _ref.isDefaultComuna,
    isPopOverVisible = _ref.isPopOverVisible,
    isTypeAheadEnabled = _ref.isTypeAheadEnabled,
    isZoneModalEnabled = _ref.isZoneModalEnabled,
    isWebPushNotificationEnabled = _ref.isWebPushNotificationEnabled,
    isSisSodimacPdpEnabled = _ref.isSisSodimacPdpEnabled,
    onUserLogin = _ref.onUserLogin,
    onUserLoginComplete = _ref.onUserLoginComplete,
    onUserLoginConsentsUpdate = _ref.onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate = _ref.onUserLoginPasswordUpdate,
    onUserLogout = _ref.onUserLogout,
    selectedZone = _ref.selectedZone,
    setBusy = _ref.setBusy,
    store = _ref.store,
    unifiedLoginBaseUrl = _ref.unifiedLoginBaseUrl,
    userCartCount = _ref.userCartCount,
    MobileAppWebView = _ref.MobileAppWebView;
  var _useContext = useContext(AppContext),
    tenant = _useContext.tenant,
    baseUrl = _useContext.baseUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSearchBar = _useState2[0],
    setShowSearchBar = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    modalVisible = _useState6[0],
    setModalVisible = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isSearchBarTouched = _useState8[0],
    setIsSearchBarTouched = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    zoneModalVisible = _useState10[0],
    setZoneModalVisible = _useState10[1];
  var _useState11 = useState(undefined),
    _useState12 = _slicedToArray(_useState11, 2),
    searchInputRef = _useState12[0],
    setSearchInputRef = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    hideMenuBar = _useState14[0],
    setHideMenuBar = _useState14[1];
  var _useState15 = useState({
      isVisible: false
    }),
    _useState16 = _slicedToArray(_useState15, 2),
    pushNotificationData = _useState16[0],
    setPushNotificationData = _useState16[1];
  var _useState17 = useState(''),
    _useState18 = _slicedToArray(_useState17, 2),
    mobileModalClass = _useState18[0],
    setMobileModalClass = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showLoginForm = _useState20[0],
    setShowLoginForm = _useState20[1];
  var currentStepValue = 0;
  var _useHeader = useHeader({
      styles: styles,
      tenant: tenant,
      baseUrl: baseUrl,
      store: store,
      data: data,
      isWebPushNotificationEnabled: isWebPushNotificationEnabled,
      setPushNotificationData: setPushNotificationData,
      currentStepValue: currentStepValue,
      attachResizeListener: attachResizeListener,
      deviceType: deviceType,
      currentLocation: currentLocation
    }),
    isIE = _useHeader.isIE,
    isOnboardingDisabledCookie = _useHeader.isOnboardingDisabledCookie,
    currentStep = _useHeader.currentStep,
    header = _useHeader.header,
    setCurrentStep = _useHeader.setCurrentStep,
    sisNavigationMenu = _useHeader.sisNavigationMenu,
    isMobileApp = _useHeader.isMobileApp,
    site = _useHeader.site,
    isVendorLoggedIn = _useHeader.isVendorLoggedIn,
    setIsVendorLoggedIn = _useHeader.setIsVendorLoggedIn,
    isAgentLoggedIn = _useHeader.isAgentLoggedIn,
    areCookiesPresent = _useHeader.areCookiesPresent,
    whiteLabelProp = _useHeader.whiteLabelProp;
  var _extractHeaderConfig = extractHeaderConfig(header, deviceType),
    isOnboardingEnabled = _extractHeaderConfig.isOnboardingEnabled,
    isProgramaticallyGeofinderEnabled = _extractHeaderConfig.isProgramaticallyGeofinderEnabled,
    geofinderConfigs = _extractHeaderConfig.geofinderConfigs,
    isRecentSearchesEnabled = _extractHeaderConfig.isRecentSearchesEnabled,
    searchbar = _extractHeaderConfig.searchbar,
    mainLogoIcon = _extractHeaderConfig.mainLogoIcon,
    logoURL = _extractHeaderConfig.logoURL,
    menuConfig = _extractHeaderConfig.menuConfig,
    menuTextColor = _extractHeaderConfig.menuTextColor,
    myAccountTextColor = _extractHeaderConfig.myAccountTextColor,
    myOrdersTextColor = _extractHeaderConfig.myOrdersTextColor,
    topHeaderTextColor = _extractHeaderConfig.topHeaderTextColor,
    topHeaderBackgroundColor = _extractHeaderConfig.topHeaderBackgroundColor,
    bottomHeaderBackgroundColor = _extractHeaderConfig.bottomHeaderBackgroundColor,
    fontLink = _extractHeaderConfig.fontLink,
    fontFamily = _extractHeaderConfig.fontFamily,
    crossBanner = _extractHeaderConfig.crossBanner;
  var closeNotification = function closeNotification() {
    setPushNotificationData({
      isVisible: false
    });
  };
  var handleSearchTermChange = function handleSearchTermChange(searchTerm) {
    onSearchTermChange({
      searchTerm: searchTerm,
      setErrorMessage: setErrorMessage,
      store: site,
      tenant: tenant
    });
  };
  var toggleModal = function toggleModal(visibility) {
    if (deviceType !== 'desktop') {
      if (!visibility) {
        setMobileModalClass('floatBottomEndTransition');
        var animationTimer = setTimeout(function () {
          setModalVisible(visibility);
          clearTimeout(animationTimer);
        }, 350);
      } else {
        setMobileModalClass('floatBottomTransition');
        setModalVisible(visibility);
      }
    } else {
      setModalVisible(visibility);
    }
  };
  var handleUserLogout = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee() {
      var userCookie;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            userCookie = CookieStorage.getUserDataCookieName();
            CookieStorage.removeCookie({
              name: userCookie
            });
            _context.next = 4;
            return onUserLogout();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleUserLogout() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleUserLogin = function () {
    var _ref3 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee2(userData) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return onUserLogin(userData);
          case 2:
            if (enableAnalyticsInfoCall) {
              initDigitalData();
            }
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleUserLogin(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var renderLogo = function renderLogo() {
    return jsx(MatchMedia$1, {
      key: "testId-logo-link",
      deviceType: deviceType,
      content: {
        desktop: function desktop() {
          return jsx(Logo, {
            path: logoURL,
            logoIcon: mainLogoIcon,
            store: site
          });
        },
        mobile: function mobile() {
          return jsx(Logo, {
            path: logoURL,
            logoIcon: mainLogoIcon,
            isMobile: true,
            store: site
          });
        },
        tablet: function tablet() {
          return jsx(Logo, {
            path: logoURL,
            logoIcon: mainLogoIcon,
            isMobile: true,
            store: site
          });
        }
      }
    });
  };
  var renderNavigationMenu = function renderNavigationMenu() {
    return jsx(SiSNavigationMenu, {
      menuConfig: get(header, 'entry.menu', menuConfig),
      categories: get(sisNavigationMenu, 'entry.categories', []),
      browseMainText: get(sisNavigationMenu, 'entry.browse_main_text', ''),
      colorLine: get(sisNavigationMenu, 'entry.color_line', ''),
      categoryColor: get(sisNavigationMenu, 'entry.category_color', ''),
      hightlightColor: get(sisNavigationMenu, 'entry.hightlight_color', ''),
      hightlightTextColor: get(sisNavigationMenu, 'entry.hightlight_text_color', ''),
      dataWrapper: get(sisNavigationMenu, 'entry.data_wrapper', ''),
      defaultCategoryColors: get(sisNavigationMenu, 'entry.default_category_colors', {}),
      store: site
    });
  };
  var renderSearch = function renderSearch() {
    return jsx(Search, {
      deviceType: deviceType,
      onSearch: handleSearchTermChange,
      currentSearchTerm: currentSearchTerm || getParameterByName('Ntt'),
      isTypeAheadEnabled: isTypeAheadEnabled,
      isSisSodimacPdpEnabled: isSisSodimacPdpEnabled,
      getTypeaheadUrl: getTypeaheadUrl,
      onLoadingStateChange: setBusy,
      searchbar: searchbar,
      setHideMenuBar: setHideMenuBar,
      isAndes: isZoneModalEnabled,
      isAgentLoggedIn: isAgentLoggedIn,
      isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
      setSearchInputRef: setSearchInputRef,
      isSearchBarTouched: isSearchBarTouched,
      setIsSearchBarTouched: setIsSearchBarTouched,
      searchInSis: false,
      store: site,
      isRecentSearchesEnabled: isRecentSearchesEnabled
    });
  };
  useEffect(function () {
    if (!fontLink) return;
    var existingLink = document.querySelector('link[data-font]');
    if (existingLink) {
      existingLink.href = fontLink;
    } else {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = fontLink;
      link.setAttribute('data-font', 'true');
      document.head.appendChild(link);
    }
  }, [fontLink]);
  if (!header) {
    return jsx(React.Fragment, null);
  }
  return jsx(React.Fragment, null, jsx("header", {
    className: classNames(styles['parent-container'], styles["cross-banner-".concat(crossBanner.position)], _defineProperty(_defineProperty({}, styles['no-border'], isVendorLoggedIn || isAgentLoggedIn || areCookiesPresent), styles['hide-component'], MobileAppWebView))
  }, errorMessage && jsx(ErrorDialog, {
    title: errorMessage.title,
    message: errorMessage.msg,
    onClose: function onClose() {
      setErrorMessage(undefined);
    }
  }), (isVendorLoggedIn || areCookiesPresent) && jsx(VendorHeader, {
    isCatalyst: CookieStorage.isCatalyst(),
    tenant: tenant,
    setIsVendorLoggedIn: setIsVendorLoggedIn,
    vendorBaseUrl: baseUrl,
    isVendorLoggedIn: isVendorLoggedIn,
    atgBaseUrl: atgBaseUrl,
    catalystBaseUrl: catalystBaseUrl,
    onUserLogout: handleUserLogout,
    forceATG: forceATG,
    store: store,
    whitelabel: whiteLabelProp
  }), isOnboardingEnabled && !isMobileApp && jsx(OnboardingWithoutSSR$2, {
    deviceType: deviceType,
    currentStep: currentStep,
    setCurrentStep: setCurrentStep,
    onboardingData: get(header, 'entry.onboarding', null),
    tenant: tenant
  }), jsx(CrossBanner, {
    crossBanner: crossBanner,
    deviceType: deviceType,
    className: styles['cross-banner']
  }), jsx("div", {
    id: "scrollable-content",
    style: {
      background: topHeaderBackgroundColor
    },
    "data-testid": "header-util-bar",
    className: classNames(styles['header-util-bar'], styles['top-header'])
  }, jsx("div", {
    className: classNames(styles.container, styles['header-container'])
  }, jsx(React.Fragment, null, jsx(MatchMedia$1, {
    key: "testId-store-menu",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return jsx(React.Fragment, null);
      },
      mobile: function mobile() {
        return renderNavigationMenu();
      },
      tablet: function tablet() {
        return renderNavigationMenu();
      }
    }
  }), renderLogo(), jsx(MatchMedia$1, {
    key: "testId-store-menu",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return renderNavigationMenu();
      },
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      }
    }
  }), jsx(MatchMedia$1, {
    key: "search-bar-desktop",
    deviceType: deviceType,
    content: {
      desktop: function desktop() {
        return renderSearch();
      },
      mobile: function mobile() {
        return jsx(React.Fragment, null);
      },
      tablet: function tablet() {
        return jsx(React.Fragment, null);
      }
    }
  })), jsx(UserActions$1, {
    showSearchBar: showSearchBar,
    setShowSearchBar: setShowSearchBar,
    isATGLoginEnabled: isATGLoginEnabled,
    isInternetExplorer: isIE,
    showLoginForm: showLoginForm,
    setShowLoginForm: setShowLoginForm,
    atgBaseUrl: atgBaseUrl,
    modalVisible: modalVisible,
    mobileModalClass: mobileModalClass,
    toggleModal: toggleModal,
    catalystBaseUrl: catalystBaseUrl,
    onLoadingStateChange: setBusy,
    onUserLogout: handleUserLogout,
    deviceType: deviceType,
    headerData: header,
    onUserLogin: handleUserLogin,
    onUserLoginComplete: onUserLoginComplete,
    onUserLoginConsentsUpdate: onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate: onUserLoginPasswordUpdate,
    unifiedLoginBaseUrl: unifiedLoginBaseUrl,
    userCartCount: userCartCount,
    isOnboardingInProgress: isOnboardingEnabled && !isOnboardingDisabledCookie && currentStep === 1,
    forceATG: forceATG,
    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
    isAgentLoggedIn: isAgentLoggedIn,
    isStore: true,
    isOrangeOrSISHeader: true,
    isSISLevel2Header: false,
    store: store
  })), deviceType !== 'desktop' && jsx("div", {
    className: classNames(_defineProperty({}, styles.mobile_middle_wrapper, site))
  }, renderSearch())), jsx("div", {
    id: "bottom-header",
    style: {
      background: site && bottomHeaderBackgroundColor,
      borderTop: '1px solid #CAD1D9'
    },
    className: styles['bottom-header']
  }, jsx(TernaryNavBar$1, {
    currentStep: currentStep,
    deviceType: deviceType,
    handleRouteChange: handleSoftRefresh,
    header: header,
    isAgentLoggedIn: isAgentLoggedIn,
    baseUrl: catalystBaseUrl,
    isBrandingMarketplace: true,
    isDefaultComuna: isDefaultComuna,
    selectedZone: selectedZone,
    isPopOverVisible: isPopOverVisible,
    isOnboardingDisabledCookie: isOnboardingDisabledCookie,
    isOnboardingEnabled: isOnboardingEnabled,
    isVendorLoggedIn: isVendorLoggedIn || areCookiesPresent,
    isZoneModalEnabled: isZoneModalEnabled,
    isSearchBarTouched: isSearchBarTouched,
    modalVisible: zoneModalVisible,
    setModalVisible: setZoneModalVisible,
    tenant: tenant,
    storeName: !isEmpty$1(sisNavigationMenu) ? get(sisNavigationMenu, 'entry.data_wrapper', '') : '',
    isProgramaticallyGeofinderEnabled: isProgramaticallyGeofinderEnabled,
    geofinderConfigs: geofinderConfigs,
    isOrangeOrSISHeader: true,
    isSISLevel2Header: false,
    store: store,
    setShowLoginForm: setShowLoginForm
  })), modalVisible && deviceType !== 'desktop' && jsx(MarketplaceOverlay$1, {
    handlers: function handlers(e) {
      e.preventDefault();
      toggleModal(false);
      setModalVisible(false);
    }
  }), pushNotificationData.isVisible && jsx(Notification, {
    isMarketplace: true,
    requireInteraction: pushNotificationData.require_interaction,
    isVisible: pushNotificationData.isVisible,
    isWelcomeMessage: pushNotificationData.isWelcomeMessage,
    action: pushNotificationData.action,
    icon: pushNotificationData.icon,
    title: pushNotificationData.title,
    body: pushNotificationData.body,
    closeNotification: closeNotification
  })), jsx("style", null, "\n          :root {\n            --text-color: ".concat(topHeaderTextColor, ";\n            --search-icon-background: ").concat(searchbar.search_icon_background_color, ";\n            --icon-background: #333;\n            --border-color: 52, 62, 73;\n            --search-bar-border-radius: ").concat(searchbar.searchBarBorderRadius, ";\n            --search-bar-button-icon-border-radius: ").concat(searchbar.searchBarBorderRadius, ";\n            --search-bar-border-color: ").concat(searchbar.searchBarBorderColor, ";\n            --menu-text-color: ").concat(menuTextColor, ";\n            --hamburger-menu-icon-color: ").concat(menuTextColor, ";\n            --my-orders-text-color: ").concat(myOrdersTextColor, ";\n            --my-account-text-color: ").concat(myAccountTextColor, ";\n            --whitelabel-font-family: ").concat(fontFamily, "\n          }\n        ")));
};
Header$2.propTypes = process.env.NODE_ENV !== "production" ? {
  styles: PropTypes.object.isRequired,
  atgBaseUrl: PropTypes.string.isRequired,
  attachResizeListener: PropTypes.func.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  currentLocation: PropTypes.string,
  currentSearchTerm: PropTypes.string,
  data: PropTypes.any,
  deviceType: PropTypes.string.isRequired,
  enableAnalyticsInfoCall: PropTypes.bool,
  forceATG: PropTypes.bool,
  getTypeaheadUrl: PropTypes.func,
  handleRouteChange: PropTypes.any,
  handleSoftRefresh: PropTypes.func,
  isATGLoginEnabled: PropTypes.bool,
  isDefaultComuna: PropTypes.bool,
  isGeoLocationEnabled: PropTypes.bool,
  isPopOverVisible: PropTypes.bool,
  isTypeAheadEnabled: PropTypes.bool,
  isZoneModalEnabled: PropTypes.bool,
  isWebPushNotificationEnabled: PropTypes.bool,
  isSisSodimacPdpEnabled: PropTypes.bool,
  onRouteChange: PropTypes.func,
  onUserLogin: PropTypes.func,
  onUserLoginComplete: PropTypes.func,
  onUserLoginConsentsUpdate: PropTypes.func,
  onUserLoginPasswordUpdate: PropTypes.func,
  onUserLogout: PropTypes.func,
  refreshUserData: PropTypes.func.isRequired,
  selectedZone: PropTypes.object,
  setBusy: PropTypes.func.isRequired,
  locationPathname: PropTypes.string,
  store: PropTypes.string,
  unifiedLoginBaseUrl: PropTypes.string,
  userCartCount: PropTypes.string,
  transversalBannerConfig: PropTypes.shape({
    home: PropTypes.bool,
    pdp: PropTypes.bool,
    xlp: PropTypes.bool,
    basket: PropTypes.bool
  }),
  MobileAppWebView: PropTypes.bool
} : {};
Header$2.defaultProps = {
  atgBaseUrl: '',
  catalystBaseUrl: '',
  currentLocation: '',
  currentSearchTerm: '',
  enableAnalyticsInfoCall: false,
  forceATG: false,
  handleSoftRefresh: noop$1,
  isATGLoginEnabled: false,
  isDefaultComuna: false,
  isGeoLocationEnabled: true,
  isPopOverVisible: false,
  isTypeAheadEnabled: true,
  isZoneModalEnabled: true,
  isWebPushNotificationEnabled: false,
  isSisSodimacPdpEnabled: false,
  onRouteChange: noop$1,
  onUserLogin: noop$1,
  onUserLoginComplete: noop$1,
  onUserLoginConsentsUpdate: noop$1,
  onUserLoginPasswordUpdate: noop$1,
  onUserLogout: noop$1,
  parentRouter: null,
  selectedZone: undefined,
  unifiedLoginBaseUrl: undefined,
  userCartCount: undefined,
  locationPathname: undefined,
  getTypeaheadUrl: apiConfig$1.getTypeaheadUrl,
  MobileAppWebView: false
};
var WhitelabelHeader = withUser(withLoader(withDevice(Header$2)));

var Header$3 = function Header(props) {
  var appCtx = useContext(AppContext);
  var _appCtx$MobileAppWebV = appCtx.MobileAppWebView,
    MobileAppWebView = _appCtx$MobileAppWebV === void 0 ? false : _appCtx$MobileAppWebV;
  var _useState = useState(appCtx.isSodimacStandAloneSite || props.isSodimacStandAloneSite),
    _useState2 = _slicedToArray(_useState, 2),
    isSodimacStandAloneSite = _useState2[0],
    setIsSodimacStandAloneSite = _useState2[1];
  var _useState3 = useState(appCtx.isTottusStandAloneSite || props.isTottusStandAloneSite),
    _useState4 = _slicedToArray(_useState3, 2),
    isTottusStandAloneSite = _useState4[0],
    setIsTottusStandAloneSite = _useState4[1];
  var _getStandaloneSite = getStandaloneSite(props.store),
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var checkIsSodimacStandalone = function checkIsSodimacStandalone() {
    if (isSodimacStandAloneSite) {
      return;
    }
    setIsSodimacStandAloneSite(isCurrentUrlSodimacStandAlone());
  };
  var checkIsTottusStandalone = function checkIsTottusStandalone() {
    if (isTottusStandAloneSite) {
      return;
    }
    setIsTottusStandAloneSite(isCurrentUrlTottusStandAlone());
  };
  useEffect(function () {
    checkIsSodimacStandalone();
    checkIsTottusStandalone();
    loadDigitalDataManager(props);
    loadVwoScript({
      isVwoEnabled: props.isVwoEnabled,
      tenant: appCtx.tenant || '',
      isSodimacStandAloneSite: isSodimacStandAloneSite,
      isTottusStandAloneSite: isTottusStandAloneSite
    });
    loadGoogleTagManager(_objectSpread2({}, props, {
      isWhitelabelSite: isWhitelabelSite
    }));
    loadFingerprintTracking(props);
    loadMedallia(props);
    saveDigitalDataCookies();
    generateMetaTagsAPP(isSodimacStandAloneSite, isTottusStandAloneSite);
  }, []);
  var headerProps = _objectSpread2({}, props, {
    styles: isWhitelabelSite ? whitelabelStyles : styles$10,
    MobileAppWebView: MobileAppWebView
  });
  if (isWhitelabelSite) {
    return jsx(WhitelabelHeader, headerProps);
  }
  if (isSodimacStandAloneSite || isTottusStandAloneSite) {
    return jsx(StandaloneHeader, headerProps);
  }
  return jsx(MarketplaceHeader, headerProps);
};
Header$3.propTypes = process.env.NODE_ENV !== "production" ? {
  isRebrandingEnabled: PropTypes.bool,
  isDDMInitializationEnabled: PropTypes.bool,
  isVwoEnabled: PropTypes.bool,
  isFingerprintTrackingEnabled: PropTypes.bool,
  isGoogleTagManagerEnabled: PropTypes.bool,
  isSodimacStandAloneSite: PropTypes.bool,
  isTottusStandAloneSite: PropTypes.bool,
  MobileAppWebView: PropTypes.bool,
  store: PropTypes.string
} : {};
Header$3.defaultProps = {
  isRebrandingEnabled: true,
  isDDMInitializationEnabled: true,
  isVwoEnabled: true,
  isFingerprintTrackingEnabled: true,
  isGoogleTagManagerEnabled: false,
  isSodimacStandAloneSite: false,
  isTottusStandAloneSite: false,
  MobileAppWebView: false
};

var UnifiedLoginModal = function UnifiedLoginModal(_ref) {
  var atgBaseUrl = _ref.atgBaseUrl,
    catalystBaseUrl = _ref.catalystBaseUrl,
    onUserLogin = _ref.onUserLogin,
    setUserLoggedIn = _ref.setUserLoggedIn,
    showLoginForm = _ref.showLoginForm,
    onClose = _ref.onClose,
    tenant = _ref.tenant,
    initDigitalData = _ref.initDigitalData,
    enableAnalytics = _ref.enableAnalytics,
    isRebrandingEnabled = _ref.isRebrandingEnabled,
    onComplete = _ref.onComplete,
    onConsentsUpdate = _ref.onConsentsUpdate,
    onPasswordUpdate = _ref.onPasswordUpdate,
    baseUrl = _ref.baseUrl;
  var _useState = useState({
      enabled: false,
      cartId: '',
      siteName: '',
      ecommName: '',
      defaultColor: '',
      multiSite: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    whiteLabelProp = _useState2[0],
    setWhiteLabelProp = _useState2[1];
  var onLogin = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(response) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!response.loginStatus) {
              _context.next = 5;
              break;
            }
            setUserLoggedIn(true);
            _context.next = 4;
            return onUserLogin(response);
          case 4:
            if (enableAnalytics) {
              initDigitalData();
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onLogin(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var setInitialWhiteLabelProps = function setInitialWhiteLabelProps() {
    if (!isClientSide()) return;
    var _URL = new URL(window.location.href),
      host = _URL.host;
    var sodimacStandaloneRegExp = /(sodimac)\.(cl|com(\.pe)?)$/;
    var tottusStandaloneRegExp = /(tottus)\.(cl|com(\.pe)?)$/;
    var isSodimacStandalone = sodimacStandaloneRegExp.test(host);
    var isTottusStandalone = tottusStandaloneRegExp.test(host);
    var store;
    if (isSodimacStandalone) store = STORES.SO_COM;
    if (isTottusStandalone) store = STORES.TO_COM;
    if (STANDALONE_STORES.includes(store)) {
      var whiteLabelProps = generateWhiteLabelProps(store, tenant.toLowerCase());
      setWhiteLabelProp(whiteLabelProps);
    }
  };
  useEffect(function () {
    setInitialWhiteLabelProps();
  }, []);
  return jsx(Fragment, null, jsx(LoginWizard, {
    atgBaseUrl: atgBaseUrl,
    catalystBaseUrl: catalystBaseUrl,
    onLogin: onLogin,
    onClose: onClose,
    show: showLoginForm,
    tenant: tenant,
    flowType: "header",
    doMergeCart: true,
    id: "testId-cc",
    isRebrandingEnabled: isRebrandingEnabled,
    onComplete: onComplete,
    onConsentsUpdate: onConsentsUpdate,
    onPasswordUpdate: onPasswordUpdate,
    baseUrl: baseUrl,
    whitelabel: whiteLabelProp
  }));
};
UnifiedLoginModal.propTypes = process.env.NODE_ENV !== "production" ? {
  atgBaseUrl: PropTypes.string.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  onUserLogin: PropTypes.func.isRequired,
  initDigitalData: PropTypes.func,
  setUserLoggedIn: PropTypes.func.isRequired,
  showLoginForm: PropTypes.bool.isRequired,
  enableAnalytics: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  tenant: PropTypes.string.isRequired,
  isRebrandingEnabled: PropTypes.bool,
  onComplete: PropTypes.func,
  onConsentsUpdate: PropTypes.func,
  onPasswordUpdate: PropTypes.func,
  baseUrl: PropTypes.string
} : {};
UnifiedLoginModal.defaultProps = {
  onUserLogin: noop,
  initDigitalData: noop,
  tenant: countriesCode.FACL,
  enableAnalytics: false,
  isRebrandingEnabled: false,
  onComplete: noop,
  onConsentsUpdate: noop,
  onPasswordUpdate: noop,
  baseUrl: undefined
};
var LoginModal = withUser(UnifiedLoginModal);

var styles$12 = {"container":"Breadcrumbs-module_container__2zdYj","dark-link":"Breadcrumbs-module_dark-link__2pNLh","breadcrumb-container":"Breadcrumbs-module_breadcrumb-container__2ae8-","landing-page-container":"Breadcrumbs-module_landing-page-container__19PLm","breadcrumb":"Breadcrumbs-module_breadcrumb__3lLwJ","selected-bread-crumb":"Breadcrumbs-module_selected-bread-crumb__1v4yG"};

var formatBreadcrumb = function formatBreadcrumb(items, productName) {
  var breadCrumbItems = items.slice();
  breadCrumbItems.reverse();
  var MAX_CATEGORY_LEVEL = 2;
  if (productName) {
    breadCrumbItems = breadCrumbItems.slice(0, MAX_CATEGORY_LEVEL);
  }
  return breadCrumbItems;
};
var getParams = function getParams(path) {
  var url = new URL("https://www.falabella.com".concat(path));
  return Object.fromEntries(url.searchParams.entries());
};
var getStore = function getStore(_ref) {
  var isPdpPage = _ref.isPdpPage,
    expParam = _ref.expParam,
    isLanding = _ref.isLanding,
    params = _ref.params,
    page = _ref.page;
  var store = STORE_MAP.MARKETPLACE;
  if (isPdpPage && expParam !== STORE_MAP.MARKETPLACE) {
    store = expParam;
  } else if (isLanding) {
    var pageStore = typeof page.store === 'string' ? page.store.toLowerCase() : '';
    store = getStoreName(pageStore === 'fa_com' ? '' : pageStore);
  } else {
    store = getStoreName(params.store);
  }
  return store;
};
var getEnvironmentName = function getEnvironmentName(text) {
  var envMatch = text.match(/(localhost|dev|staging|beta)/);
  switch (envMatch && envMatch[0] || '') {
    case 'dev':
      return ENVIRONMENT.DEVELOPMEMT;
    case 'staging':
      return ENVIRONMENT.STAGING;
    case 'beta':
      return ENVIRONMENT.UAT;
    default:
      return ENVIRONMENT.PRODUCTION;
  }
};
var Breadcrumbs = function Breadcrumbs(_ref2) {
  var items = _ref2.items,
    tenant = _ref2.tenant,
    host = _ref2.host,
    path = _ref2.path,
    productName = _ref2.productName,
    isPdpPage = _ref2.isPdpPage,
    isLanding = _ref2.isLanding,
    page = _ref2.page;
  if (!host || !path) {
    return jsx(Fragment, null);
  }
  var breadCrumbsData = !isLanding ? formatBreadcrumb(items, productName) : [];
  var params = getParams(path);
  var expParam = isPdpPage ? getStoreName(params.store) : '';
  var store = getStore({
    isPdpPage: isPdpPage,
    isLanding: isLanding,
    expParam: expParam,
    params: params,
    page: page
  });
  var _getStandaloneSite = getStandaloneSite(store),
    isStandaloneSite = _getStandaloneSite.isStandaloneSite,
    isWhitelabelSite = _getStandaloneSite.isWhitelabelSite;
  var isSisExperience = isPdpPage && expParam !== STORE_MAP.MARKETPLACE || !isPdpPage && store !== STORE_MAP.MARKETPLACE;
  var env = getEnvironmentName(host);
  var homeUrl = apiConfig$1.getHomeUrl({
    tenant: tenant,
    store: store,
    env: env
  });
  var sisHomeUrl = apiConfig$1.getSisHomeUrl({
    tenant: tenant,
    store: store,
    env: env
  });
  var backHandler = function backHandler() {
    if (isLanding) {
      window.location.replace(sisHomeUrl);
    } else {
      var len = breadCrumbsData.length;
      var parent = breadCrumbsData[len - 2];
      var backUrl = "/".concat(isStandaloneSite || isWhitelabelSite ? STORE_MAP[tenant][store] : 'falabella', "-").concat(tenant).concat(parent.link);
      window.location.replace(backUrl);
    }
  };
  var parsePageName = function parsePageName(title) {
    var t = title.includes('|') ? title.split('|')[0] : title;
    return t.replace('-', ' ').trim();
  };
  return jsx("div", {
    id: "breadcrumb",
    className: classNames(_defineProperty(_defineProperty(_defineProperty({}, styles$12.container, true), styles$12['breadcrumb-container'], true), styles$12['landing-page-container'], isLanding)),
    "data-testid": "breadcrumbs"
  }, jsx(MediaComponent, {
    from: "mobile",
    to: "desktop"
  }, (breadCrumbsData.length > 1 || isLanding) && jsx("button", {
    type: "button",
    onClick: backHandler
  }, jsx("i", {
    className: "csicon-arrow-left2"
  }))), jsx("ol", {
    className: classNames(styles$12.breadcrumb)
  }, jsx("li", {
    key: "breadcrumb-home"
  }, jsx("a", {
    href: homeUrl
  }, "Home")), (isSisExperience || isLanding) && ![STORE_MAP.MARKETPLACE, 'so_com', 'to_com'].includes(store) ? jsx("li", {
    key: "breadcrumb-".concat(store)
  }, jsx("a", {
    href: sisHomeUrl,
    style: {
      textTransform: 'capitalize'
    }
  }, STORE_MAP[tenant][store])) : null, isLanding ? jsx("li", {
    key: "breadcrumb-".concat(store, "-landing-page"),
    style: {
      textTransform: 'capitalize'
    }
  }, parsePageName(page.title)) : null, !isLanding && breadCrumbsData.map(function (item, index) {
    var isLastItem = index === breadCrumbsData.length - 1;
    var link = "".concat(sisHomeUrl).concat(item.link || '');
    var itemLabel = item.label || '';
    if (isLastItem && isPdpPage) {
      return jsx("li", {
        key: "breadcrumb-".concat(itemLabel)
      }, jsx("a", {
        href: link,
        className: classNames(styles$12['selected-bread-crumb'])
      }, itemLabel));
    }
    return jsx("li", {
      key: "breadcrumb-".concat(itemLabel)
    }, isLastItem ? jsx(Fragment, null, itemLabel) : jsx("a", {
      href: link
    }, itemLabel));
  })));
};
Breadcrumbs.defaultProps = {
  tenant: 'cl',
  items: [],
  productName: undefined,
  isPdpPage: false,
  isLanding: false
};
Breadcrumbs.propTypes = process.env.NODE_ENV !== "production" ? {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string
  })),
  tenant: PropTypes.oneOf(['cl', 'ar', 'pe', 'co']),
  host: PropTypes.string,
  path: PropTypes.string,
  productName: PropTypes.string,
  isPdpPage: PropTypes.bool,
  isLanding: PropTypes.bool,
  page: PropTypes.object
} : {};

var styles$13 = {"font-button":"MiniAccountWithLogin-module_font-button__2OdBb","container":"MiniAccountWithLogin-module_container__1vJF5","buttons-container":"MiniAccountWithLogin-module_buttons-container__2DvyN","signin-button":"MiniAccountWithLogin-module_signin-button__3PE_C","loggin-button-mobile":"MiniAccountWithLogin-module_loggin-button-mobile__DOFOa","signin-button-mobile":"MiniAccountWithLogin-module_signin-button-mobile__H90m7","wrapper":"MiniAccountWithLogin-module_wrapper__2xlSX","icon-container":"MiniAccountWithLogin-module_icon-container__hfaS6","text-container":"MiniAccountWithLogin-module_text-container__3RSTL","button-base":"MiniAccountWithLogin-module_button-base__NthAx","loggin-button":"MiniAccountWithLogin-module_loggin-button__1v9QI","mobile-image-container":"MiniAccountWithLogin-module_mobile-image-container__2eR7c","mobile-icon":"MiniAccountWithLogin-module_mobile-icon__3aMtc","mobile-text":"MiniAccountWithLogin-module_mobile-text__1-fUY","mobile-second":"MiniAccountWithLogin-module_mobile-second__3jG2W"};

var MiniAccountWithLogin = function MiniAccountWithLogin(_ref) {
  var cmrPuntosUrl = _ref.cmrPuntosUrl,
    isCmrPointsEnabled = _ref.isCmrPointsEnabled,
    style = _ref.style,
    classes = _ref.classes,
    isUserLoggedIn = _ref.isUserLoggedIn,
    setUserLoggedIn = _ref.setUserLoggedIn,
    onUserLoginComplete = _ref.onUserLoginComplete,
    onUserLoginConsentsUpdate = _ref.onUserLoginConsentsUpdate,
    onUserLoginPasswordUpdate = _ref.onUserLoginPasswordUpdate,
    onUserLogin = _ref.onUserLogin,
    atgBaseUrl = _ref.atgBaseUrl,
    catalystBaseUrl = _ref.catalystBaseUrl,
    unifiedLoginBaseUrl = _ref.unifiedLoginBaseUrl,
    setFirstName = _ref.setFirstName,
    setCartCount = _ref.setCartCount,
    enableAnalytics = _ref.enableAnalytics,
    initDigitalData = _ref.initDigitalData,
    forceATG = _ref.forceATG,
    tenant = _ref.tenant,
    id = _ref.id,
    store = _ref.store,
    baseHostUrl = _ref.baseHostUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showLoginForm = _useState2[0],
    setShowLoginForm = _useState2[1];
  var _useState3 = useState(isMobile()),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobileView = _useState4[0],
    setIsMobileView = _useState4[1];
  var _useContext = useContext(AppContext),
    _useContext$isRebrand = _useContext.isRebrandingEnabled,
    baseUrl = _useContext.baseUrl;
  var _useState5 = useState({
      enabled: false,
      cartId: '',
      siteName: '',
      ecommName: '',
      defaultColor: '',
      multiSite: false
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    whiteLabelProp = _useState6[0],
    setWhiteLabelProp = _useState6[1];
  var envBaseUrl = baseHostUrl ? buildBaseUrlBetaEnv(baseHostUrl) : getEnvBaseUrl(tenant);
  var loginWizardBaseUrl = !unifiedLoginBaseUrl ? envBaseUrl : unifiedLoginBaseUrl;
  var toggleLoginForm = function toggleLoginForm() {
    setShowLoginForm(function (v) {
      return !v;
    });
  };
  var onLogin = function () {
    var _ref2 = _asyncToGenerator( _regeneratorRuntime().mark(function _callee(response) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (response.loginStatus) {
              setUserLoggedIn(true);
              sendSatelliteTrackEvent('iniciarsesion_success');
            }
            initDigitalData();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onLogin(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var onClose = function onClose() {
    toggleLoginForm();
  };
  useEffect(function () {
    var handleResize = function handleResize() {
      setIsMobileView(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(function () {
    var userCookie = CookieStorage.getUserDataCookieName();
    var userDetails = CookieStorage.unescapeATGCookies(CookieStorage.getCookie(userCookie) || '').split('*');
    setFirstName(isUserLoggedIn && decodeURIComponent(userDetails[0]));
    setCartCount(userDetails[1]);
    if (isUserLoggedIn) document.body.style.overflow = 'visible';
  }, [isUserLoggedIn]);
  var LoginButtons = function LoginButtons(_ref3) {
    var mobile = _ref3.mobile;
    var mobileClass = mobile === true ? '-mobile' : '';
    var singinUrl = "".concat(baseUrl, "/falabella-").concat(tenant, "/myaccount/registration");
    if (baseHostUrl && store && store.toLowerCase() === 'so_com') {
      singinUrl = "".concat(envBaseUrl, "/sodimac-").concat(tenant, "/myaccount/registration");
    }
    return jsx(Fragment, null, jsx("a", {
      className: styles$13["loggin-button".concat(mobileClass)],
      id: "mini-account-login",
      onClick: function onClick() {
        toggleLoginForm();
        sendSatelliteTrackEvent('iniciarsesion_click');
      },
      role: "button",
      title: "Iniciar sesi\xF3n"
    }, "Iniciar sesi\xF3n"), jsx("a", {
      className: styles$13["signin-button".concat(mobileClass)],
      id: "mini-account-singin",
      role: "button",
      href: singinUrl,
      title: "Crear Cuenta"
    }, "Crear Cuenta"));
  };
  var DesktopView = function DesktopView() {
    return jsx(Fragment, null, jsx("div", {
      className: styles$13.wrapper
    }, jsx("div", {
      className: styles$13['icon-container']
    }), jsx("div", {
      className: styles$13['text-container']
    }, jsx("span", null, "Inicia sesi\xF3n para mejorar tu experiencia de compra"))), jsx("div", {
      className: styles$13['buttons-container']
    }, jsx(LoginButtons, {
      mobile: isMobileView
    })));
  };
  var MobileView = function MobileView() {
    return jsx(Fragment, null, jsx("div", {
      className: styles$13['mobile-image-container']
    }, jsx("div", {
      className: styles$13['mobile-icon']
    }), jsx("div", {
      className: styles$13['mobile-text']
    }, "Inicia sesi\xF3n para mejorar tu experiencia de compra")), jsx("div", {
      className: styles$13['buttons-container']
    }, jsx(LoginButtons, {
      mobile: isMobileView
    })));
  };
  var showComponent = function showComponent() {
    return isMobileView ? jsx(MobileView, null) : jsx(DesktopView, null);
  };
  useEffect(function () {
    setWhiteLabelProp(generateWhiteLabelProps(store, tenant));
  }, []);
  return isUserLoggedIn ? null : jsx("div", {
    className: classNames(classes.join(' ')),
    style: style,
    id: id,
    "data-wrapper": "MA-MiniAccount"
  }, jsx("div", {
    className: classNames(styles$13.container)
  }, jsx(LoginWizard, {
    atgBaseUrl: atgBaseUrl,
    catalystBaseUrl: catalystBaseUrl,
    onLogin: onLogin,
    onClose: onClose,
    show: showLoginForm,
    tenant: tenant,
    flowType: "header",
    doMergeCart: true,
    id: "testId-cc",
    isRebrandingEnabled: true,
    forceATG: forceATG,
    onComplete: onUserLoginComplete,
    onConsentsUpdate: onUserLoginConsentsUpdate,
    onPasswordUpdate: onUserLoginPasswordUpdate,
    baseUrl: loginWizardBaseUrl,
    whitelabel: whiteLabelProp
  }), showComponent()));
};
MiniAccountWithLogin.propTypes = process.env.NODE_ENV !== "production" ? {
  cmrPuntosUrl: PropTypes.string,
  isCmrPointsEnabled: PropTypes.bool,
  classes: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.object,
  id: PropTypes.string,
  deviceType: PropTypes.string,
  isUserLoggedIn: PropTypes.bool,
  onUserLogin: PropTypes.func,
  onUserLoginComplete: PropTypes.func,
  onUserLoginConsentsUpdate: PropTypes.func,
  onUserLoginPasswordUpdate: PropTypes.func,
  atgBaseUrl: PropTypes.string.isRequired,
  catalystBaseUrl: PropTypes.string.isRequired,
  initDigitalData: PropTypes.func,
  setUserLoggedIn: PropTypes.func.isRequired,
  enableAnalytics: PropTypes.bool,
  tenant: PropTypes.string.isRequired,
  baseUrl: PropTypes.string,
  store: PropTypes.string,
  baseHostUrl: PropTypes.string
} : {};
MiniAccountWithLogin.defaultProps = {
  classes: [],
  id: undefined,
  style: {},
  tenant: 'cl'
};
var MiniAccountWithLogin$1 = withUser(MiniAccountWithLogin);

var nameHOC$3 = hocUtils.nameHOC;
var getDefaultTheme = function getDefaultTheme() {
  return {
    color: '#343E49',
    secondary_color: '#343E49'
  };
};
var useThemeContext = function useThemeContext(_ref) {
  var themes = _ref.themes,
    store = _ref.store;
  if (themes && store && themes[store] !== undefined && themes[store].color !== undefined) {
    return {
      theme: themes[store]
    };
  }
  if (themes && store && isWhitelabel(store) && themes.styles !== undefined) {
    return {
      theme: themes.styles
    };
  }
  return {
    theme: getDefaultTheme()
  };
};
var ThemeContext$1 = createContainer(useThemeContext);
var withTheme = function withTheme(WrappedComponent) {
  var getInitialProps = WrappedComponent.getInitialProps;
  var ComponentWithTheme = function ComponentWithTheme(props) {
    var _useContext = useContext(ThemeContext$1.Context),
      theme = _useContext.theme;
    return jsx(WrappedComponent, _extends({}, props, {
      theme: theme
    }));
  };
  if (typeof getInitialProps === 'function') {
    ComponentWithTheme.getInitialProps = getInitialProps;
  }
  ComponentWithTheme.originalName = nameHOC$3(WrappedComponent);
  ComponentWithTheme.displayName = nameHOC$3(WrappedComponent, 'WithTheme');
  return ComponentWithTheme;
};

var TENANT = {
  CL: 'cl',
  PE: 'pe',
  CO: 'co'
};
var STORE = {
  FA_COM: 'fa_com',
  SO_COM: 'so_com',
  TO_COM: 'to_com',
  SODIMAC: 'sodimac',
  HOMECENTER: 'homecenter',
  TOTTUS: 'tottus',
  LINIO: 'linio',
  FA_CARTERS: 'fa_carters',
  FA_CRABARR: 'fa_crabarr',
  FA_ALDO: 'fa_aldo',
  FA_AMERICA: 'fa_america'
};
var FALABELLA_ICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3433851e0d3bd3d0/falabella.com@16px.png',
  type: 'image/png+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt719edd3f49967431/falabella.com@32px.png',
  type: 'image/png+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3c73742662b1d299/falabella.com@180x.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt87f76ca2d50fe2da/falabella.com@192px.png',
  type: 'image/png+xml'
}, {
  sizes: '256x256',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4c8eb5b1a3fcf71e/falabella.com@256px.png',
  type: 'image/png+xml'
}];
var SODIMAC_FAVICONS = [{
  sizes: '48x48',
  rel: 'icon',
  href: 'https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blta6bf10a4c1cac4da/Sodimac48.png',
  type: 'image/png+xml'
}, {
  sizes: '96x96',
  rel: 'icon',
  href: 'https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt2208fa5442c384b3/Sodimac96.png',
  type: 'image/png+xml'
}, {
  sizes: '144x144',
  rel: 'icon',
  href: 'https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/blt49a6f6934ded3134/Sodimac144.png',
  type: 'image/png+xml'
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.sodimac.com/v3/assets/blt6a203fe6c6a9b6dd/bltcf215412183f0b18/Sodimac192.png',
  type: 'image/png+xml'
}];
var TOTTUS_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc717242d6e3cb40e/Tottus@16px.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt7cea2811922a2fb8/Tottus@32px.png',
  type: 'image/svg+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt12137dde9c3944ce/Tottus@180x.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt731539d15505e022/Tottus@192px.png',
  type: 'image/svg+xml'
}];
var LINIO_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt5895e6819aea46b4/Linio@16px.png',
  type: 'image/svg+xml'
}, {
  sizes: '16x16',
  rel: 'alternate icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt5895e6819aea46b4/Linio@16px.png',
  type: 'image/png'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc00cf0d95916e89f/Linio@32px.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'alternate icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/bltc00cf0d95916e89f/Linio@32px.png',
  type: 'image/png'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt4995fbc240a6d726/Linio@180x.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt74633fecc79cb482/Linio@192px.png',
  type: 'image/svg+xml'
}, {
  sizes: '192x192',
  rel: 'alternate icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt74633fecc79cb482/Linio@192px.png',
  type: 'image/png'
}, {
  sizes: '256x256',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt953944608a731c85/Linio@256px.png',
  type: 'image/svg+xml'
}, {
  sizes: '256x256',
  rel: 'alternate icon',
  href: 'https://images.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt953944608a731c85/Linio@256px.png',
  type: 'image/png'
}];
var CARTERS_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/bltda651110224c91f1/67bc17d8eca79088e329ed9f/carters-16x16.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt0f8e3b763c746a6e/67bc17d85aed499388f7ddc5/carters-32x32.png',
  type: 'image/svg+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt95eaa90cb8f61c25/67bc17d99570312b5690453d/carters-180x180.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blta7dee384d54a9c47/67bc17d8c8662648d2c73bc9/carters-192x192.png',
  type: 'image/svg+xml'
}];
var CRABARR_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt69f450d615472b82/67bc1acb9570316f1c904556/crabarr-16x16.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt910ad5153952b8ab/67bc1acbaff4753a5beed630/crabarr-32x32.png',
  type: 'image/svg+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt641c17ca50dad7cd/67bc1acbe1c143da5796b73d/crabarr-180x180.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/bltd53e161eac4fa476/67bc1acbeca79047a929edac/crabarr-192x192.png',
  type: 'image/svg+xml'
}];
var ALDO_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/bltd79378f2c328e071/67bc19b0d4f68bf0c59cae28/aldo-16x16.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt3e62b694abe458e3/67bc19b01ce4bd0bb64b7455/aldo-32x32.png',
  type: 'image/svg+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt93e47b7073eb0525/67bc19b17259055779b7a0bc/aldo-180x180.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt09308f714f4e6a4e/67bc19b03cf087d41c85febe/aldo-192x192.png',
  type: 'image/svg+xml'
}];
var AMERICANINO_FAVICONS = [{
  sizes: '16x16',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt7e4f7a76a8c42b56/67bc1b5dc86626df8bc73bdb/americanino-16x16.png',
  type: 'image/svg+xml'
}, {
  sizes: '32x32',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt8e3e3ae5a574043f/67bc1b5dd4f68b814a9cae2f/americanino-32x32.png',
  type: 'image/svg+xml'
}, {
  sizes: '180x180',
  rel: 'apple-touch-icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blt755cb88f10a88184/67bc1b5d55356963914ff074/americanino-180x180.png',
  type: null
}, {
  sizes: '192x192',
  rel: 'icon',
  href: 'https://images.falabella.com/v3/assets/bltb9d14061af10d563/blte5f5d9bfadadb5c4/67bc1b5e4c7ca4154bcb2046/americanino-192x192.png',
  type: 'image/svg+xml'
}];
var FAVICONS = _defineProperty(_defineProperty(_defineProperty({}, TENANT.CL, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, STORE.FA_COM, FALABELLA_ICONS), STORE.SODIMAC, SODIMAC_FAVICONS), STORE.TOTTUS, TOTTUS_FAVICONS), STORE.LINIO, LINIO_FAVICONS), STORE.SO_COM, SODIMAC_FAVICONS), STORE.TO_COM, TOTTUS_FAVICONS), STORE.FA_CARTERS, CARTERS_FAVICONS), STORE.FA_CRABARR, CRABARR_FAVICONS), STORE.FA_ALDO, ALDO_FAVICONS), STORE.FA_AMERICA, AMERICANINO_FAVICONS)), TENANT.PE, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, STORE.FA_COM, FALABELLA_ICONS), STORE.SODIMAC, SODIMAC_FAVICONS), STORE.TOTTUS, TOTTUS_FAVICONS), STORE.LINIO, LINIO_FAVICONS), STORE.SO_COM, SODIMAC_FAVICONS), STORE.TO_COM, TOTTUS_FAVICONS), STORE.FA_CARTERS, CARTERS_FAVICONS), STORE.FA_CRABARR, CRABARR_FAVICONS), STORE.FA_ALDO, ALDO_FAVICONS), STORE.FA_AMERICA, AMERICANINO_FAVICONS)), TENANT.CO, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, STORE.FA_COM, FALABELLA_ICONS), STORE.HOMECENTER, FALABELLA_ICONS), STORE.LINIO, LINIO_FAVICONS), STORE.FA_CARTERS, CARTERS_FAVICONS), STORE.FA_CRABARR, CRABARR_FAVICONS), STORE.FA_ALDO, ALDO_FAVICONS), STORE.FA_AMERICA, AMERICANINO_FAVICONS));

var DEFAULT_STORE = STORE.FA_COM;
function isValid(value, validValuesMap) {
  return Object.values(validValuesMap).includes(value);
}
function getRawData(args) {
  if (!args || !args.tenant || !isValid(args.tenant, TENANT)) {
    return [];
  }
  var selectedStore = !isValid(args.store, STORE) ? DEFAULT_STORE : args.store;
  return _.get(FAVICONS, "".concat(args.tenant, ".").concat(selectedStore), []);
}
function render$1(props) {
  if (!props) {
    return null;
  }
  var favicons = getRawData(props);
  var renderFavicon = function renderFavicon(attrs, index) {
    return createElement('link', _objectSpread2({
      key: "".concat(attrs.href, "-").concat(index)
    }, attrs));
  };
  var renderFavicons = function renderFavicons(faviconList) {
    return faviconList.map(renderFavicon);
  };
  if (!favicons.length) {
    return null;
  }
  return renderFavicons(favicons);
}
var Favicons = {
  get: getRawData,
  render: render$1
};

var styles$14 = {"modalContainer":"RestrictedVariantModal-module_modalContainer__2SflB","modalHeader":"RestrictedVariantModal-module_modalHeader__3nq6R","containerTop":"RestrictedVariantModal-module_containerTop__1VpCI","dragHandleIcon":"RestrictedVariantModal-module_dragHandleIcon__1CMW8","warningIconContainer":"RestrictedVariantModal-module_warningIconContainer__29wcR","warningIcon":"RestrictedVariantModal-module_warningIcon__118wD","modal-btn-close":"RestrictedVariantModal-module_modal-btn-close__1T3w_","icon-danger":"RestrictedVariantModal-module_icon-danger__N2Xow","title":"RestrictedVariantModal-module_title__LkLdH","modalContent":"RestrictedVariantModal-module_modalContent__3zUft","contentText":"RestrictedVariantModal-module_contentText__3XOd0","modalFooter":"RestrictedVariantModal-module_modalFooter__3PUTl","btn-continue":"RestrictedVariantModal-module_btn-continue__3m78H"};

var ModalContent$2 = function ModalContent(_ref) {
  var addVariantToCart = _ref.addVariantToCart,
    onCloseModal = _ref.onCloseModal,
    deviceType = _ref.deviceType,
    modalText = _ref.modalText;
  return jsx("div", {
    className: styles$14.modalContainer,
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, deviceType === 'mobile' && jsx("div", {
    className: styles$14.containerTop
  }, jsx("i", {
    className: styles$14.dragHandleIcon
  })), jsx("div", {
    className: styles$14.modalHeader
  }, jsx("div", {
    className: styles$14.warningIconContainer
  }, jsx("i", {
    className: styles$14.warningIcon
  })), jsx("p", {
    className: styles$14.title
  }, "Importante"), jsx("button", {
    type: "button",
    className: styles$14['modal-btn-close'],
    onClick: onCloseModal
  }, jsx("i", {
    className: styles$14['icon-danger']
  }))), jsx("div", {
    className: styles$14.modalContent
  }, jsx("p", {
    className: styles$14.contentText,
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(modalText)
    }
  })), jsx("div", {
    className: styles$14.modalFooter
  }, jsx("button", {
    className: styles$14['btn-continue'],
    onClick: addVariantToCart
  }, "Entendido")));
};
ModalContent$2.propTypes = process.env.NODE_ENV !== "production" ? {
  addVariantToCart: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired,
  modalText: PropTypes.string.isRequired
} : {};
ModalContent$2.defaultProps = {
  modalText: ''
};

var RestrictedVariantModal = function RestrictedVariantModal(_ref) {
  var show18PlusModal = _ref.show18PlusModal,
    deviceType = _ref.deviceType,
    handleAddToCart = _ref.handleAddToCart,
    modalText = _ref.modalText,
    onCloseModal = _ref.onCloseModal;
  var _useContext = useContext(AppContext),
    tenant = _useContext.tenant;
  var _useState = useState(show18PlusModal),
    _useState2 = _slicedToArray(_useState, 2),
    modalVisible = _useState2[0],
    setModalVisible = _useState2[1];
  var IS_USER_OVER_18 = 'isUserOver18';
  var DESKTOP = 'desktop';
  var addVariantToCart = function addVariantToCart() {
    CookieStorage.setCookie({
      name: IS_USER_OVER_18,
      value: 'true',
      expiryDays: 30,
      regionCode: tenant
    });
    handleAddToCart();
  };
  useEffect(function () {
    return setModalVisible(show18PlusModal);
  }, [show18PlusModal]);
  useEffect(function () {
    if (!modalVisible) {
      onCloseModal();
    }
  }, [modalVisible]);
  return jsx(Modal, {
    toggleState: {
      visible: modalVisible,
      setVisible: setModalVisible
    },
    content: function content() {
      return jsx(ModalContent$2, {
        addVariantToCart: addVariantToCart,
        onCloseModal: onCloseModal,
        deviceType: deviceType,
        modalText: modalText
      });
    },
    options: {
      width: 400,
      overflow: 'hidden',
      borderRadius: deviceType === DESKTOP ? '12px' : '20px 20px 0 0'
    },
    fullWidth: deviceType !== DESKTOP,
    withPadding: false,
    showCloseButton: false,
    deviceType: deviceType,
    customClass: deviceType !== DESKTOP ? 'floatBottomTransition' : ''
  });
};
RestrictedVariantModal.propTypes = process.env.NODE_ENV !== "production" ? {
  deviceType: PropTypes.string.isRequired,
  show18PlusModal: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  handleAddToCart: PropTypes.func.isRequired,
  modalText: PropTypes.string
} : {};
RestrictedVariantModal.defaultProps = {
  modalText: ''
};

export { Breadcrumbs, Favicons, Footer$1 as Footer, GoogleMaps, Header$3 as Header, LoginModal, LoginWizard, MiniAccountWithLogin$1 as MiniAccountWithLogin, ContainerProvider as Provider, RestrictedVariantModal, SiSNavigationMenu, ThemeContext$1 as ThemeContext, UserContext, ZoneModal, withTheme, withUser };
